
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2hEyf", function(module, exports) {

$parcel$export(module.exports, "fontFallback", () => $24ffa0794f8d0bc4$export$2a99220fb32ec798);
/**
 * Font token fallbacks are verbose.
 * This object exists purely to make using fallbacks less cumbersome while we still need to use them.
 * Will be removed once fallbacks are no longer needed.
 *
 * This is referenced by the use-tokens-typography ESLint rule.
 */ const $24ffa0794f8d0bc4$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif'
    }
};

});

parcelRegister("M3hWz", function(module, exports) {

$parcel$export(module.exports, "ProductSearchInputSkeletonInteractiveSSR", () => $3b55a543569211e8$export$fa4a5af93371d2d1);
/*
 * An interactive version of the search input skeleton which allows users to
 * type into the skeleton's input. The state of the skeleton input is saved in
 * the browser's storage (specifically within window.inputSkeletonState).
 *
 * This component is intended to be used for server side rendering only as
 * the event listeners for the input are attached via a HTML script tag.
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $aDlrJ = parcelRequire("aDlrJ");
var $eSS4z = parcelRequire("eSS4z");
const $3b55a543569211e8$export$fa4a5af93371d2d1 = (props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eSS4z.ThemeProvider), {
        partialSearchCSS: props.theme,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aDlrJ.SearchInputSkeletonInteractiveSSR), {
            ...props
        })
    });
};

});
parcelRegister("aDlrJ", function(module, exports) {

$parcel$export(module.exports, "SearchInputSkeletonInteractiveSSR", () => $a560394ad49f84af$export$ed08cb5579938462);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $fwSxy = parcelRequire("fwSxy");

var $iSHbD = parcelRequire("iSHbD");

var $2wQTl = parcelRequire("2wQTl");

var $eSS4z = parcelRequire("eSS4z");
const $a560394ad49f84af$export$ed08cb5579938462 = ({ advancedSearchUrl: advancedSearchUrl, placeholder: placeholder, customScriptDataAttributes: customScriptDataAttributes, shouldFillContainer: shouldFillContainer })=>{
    const theme = (0, $eSS4z.useTheme)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRsearchInputWrapper), {
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            id: "ssr-search-input-popout-container",
            "data-ssr-placeholder": "search-input",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRformContainer), {
                id: "ssr-form-container",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("form", {
                    method: "get",
                    action: advancedSearchUrl,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fwSxy.SSRsearchInputContainer), {
                            shouldFillContainer: shouldFillContainer,
                            id: "ssr-input-container",
                            role: "search",
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRmobileSearchIconWrapper), {
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iSHbD.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false,
                                        size: "medium"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRdesktopSearchIconWrapper), {
                                    id: "ssr-search-icon-wrapper",
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iSHbD.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRsearchInputField), {
                                    id: "ssr-search-input",
                                    name: "text",
                                    placeholder: placeholder,
                                    autoComplete: "off",
                                    "aria-label": placeholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("script", {
                            "data-test-id": "ssr-scripts-init",
                            dangerouslySetInnerHTML: {
                                __html: (0, $2wQTl.script)
                            },
                            ...customScriptDataAttributes
                        })
                    ]
                })
            })
        })
    });
};

});
parcelRegister("2wQTl", function(module, exports) {

$parcel$export(module.exports, "script", () => $da2d6e1979a6c520$export$bc237d627614fc48);
/* eslint-disable */ // @ts-ignore
const $da2d6e1979a6c520$export$bc237d627614fc48 = `(function(document,window){var _a;var getWeakRef=function(queryId){var element=document.getElementById(queryId);if(!element){return null}return new WeakRef(element)};var currentInput=getWeakRef("ssr-search-input");var container=getWeakRef("ssr-input-container");var topContainer=getWeakRef("ssr-search-input-popout-container");var iconWrapper=getWeakRef("ssr-search-icon-wrapper");var formContainer=getWeakRef("ssr-form-container");var pageWidth=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;if(window["inputSkeletonState"]){for(var _i=0,_b=window["inputSkeletonState"].listeners;_i<_b.length;_i++){var listener=_b[_i];var target=listener[0],event_1=listener[1],handler=listener[2];target.removeEventListener(event_1,handler)}window["inputSkeletonState"].listeners=[]}function setExpandedStyles(){var _a,_b,_c,_d,_e,_f;(_a=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_a===void 0?void 0:_a.setAttribute("style","color: rgb(9, 30, 66);");if(pageWidth<=1130){(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_c=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_d=container===null||container===void 0?void 0:container.deref())===null||_d===void 0?void 0:_d.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}else{(_e=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_e===void 0?void 0:_e.setAttribute("style","position: absolute; right:0px; z-index:300;");(_f=container===null||container===void 0?void 0:container.deref())===null||_f===void 0?void 0:_f.setAttribute("style","width: 780px;")}}function resetInputSkeleton(){window["inputSkeletonState"]={query:"",placeholder:"",isFocused:false,selectionStart:0,selectionEnd:0,selectionDirection:"none",listeners:[]}}if(window["inputSkeletonState"]){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(window.inputSkeletonState.isFocused&&inputRef){inputRef.value=window.inputSkeletonState.query;inputRef.placeholder=window.inputSkeletonState.placeholder;inputRef.focus();inputRef.setSelectionRange(window.inputSkeletonState.selectionStart,window.inputSkeletonState.selectionEnd,window.inputSkeletonState.selectionDirection);setExpandedStyles()}}else{resetInputSkeleton()}var queryValue=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!queryValue){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){inputRef.value=queryValue}}var mediaQuery=window.matchMedia("(max-width: 1130px)");function handleSmallScreen(){var _a,_b,_c;if(window["inputSkeletonState"]){if(window.inputSkeletonState.isFocused){(_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_b=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}}}(_a=mediaQuery===null||mediaQuery===void 0?void 0:mediaQuery.addEventListener)===null||_a===void 0?void 0:_a.call(mediaQuery,"change",function(){return handleSmallScreen()});function changeHandler(e){var input=e.target;if(window.inputSkeletonState){window.inputSkeletonState.query=input===null||input===void 0?void 0:input.value;if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"){window.sessionStorage.setItem("atlassian.search-dialog-query",input.value)}var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none"}}}function focusHandler(e){if(window.inputSkeletonState){window.inputSkeletonState.isFocused=true;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.placeholder=inputRef.placeholder}}setExpandedStyles()}function blurClickHandler(e){var _a,_b,_c,_d,_e;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(!inputRef){return}if(currentInput&&e.target===inputRef&&window.inputSkeletonState){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none";if(!((_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.hasAttribute("style"))){window.inputSkeletonState.isFocused=true;setExpandedStyles()}}if(currentInput&&e.target!==inputRef){resetInputSkeleton();var sessionQuery=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!sessionQuery){inputRef.value=sessionQuery}else{inputRef.value=""}(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.removeAttribute("style");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.removeAttribute("style");(_d=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_d===void 0?void 0:_d.removeAttribute("style");inputRef.removeAttribute("style");(_e=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_e===void 0?void 0:_e.removeAttribute("style")}}function addListener(target,event,handler){var _a;target.addEventListener(event,handler);(_a=window===null||window===void 0?void 0:window.inputSkeletonState)===null||_a===void 0?void 0:_a.listeners.push([target,event,handler])}{var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){addListener(inputRef,"input",changeHandler);addListener(inputRef,"select",changeHandler);addListener(inputRef,"keydown",changeHandler);addListener(inputRef,"focus",focusHandler)}}addListener(document,"click",blurClickHandler)})(document,window);`;

});



parcelRegister("fsMoS", function(module, exports) {

$parcel$export(module.exports, "NavigationSearchDialog", () => $350bb53b739c1971$export$8d31f534ef9d9122);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $iPfZG = parcelRequire("iPfZG");

var $5izcQ = parcelRequire("5izcQ");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");

var $eO2QR = parcelRequire("eO2QR");

var $dIouf = parcelRequire("dIouf");

var $1YXTQ = parcelRequire("1YXTQ");

var $ge2sX = parcelRequire("ge2sX");

var $ljm2R = parcelRequire("ljm2R");

var $ep3mz = parcelRequire("ep3mz");

var $dPJCf = parcelRequire("dPJCf");

var $gz8ZY = parcelRequire("gz8ZY");

var $efvKr = parcelRequire("efvKr");

var $de2j9 = parcelRequire("de2j9");

var $lqqdh = parcelRequire("lqqdh");

var $cuRlJ = parcelRequire("cuRlJ");

var $2Fqwa = parcelRequire("2Fqwa");

var $f4L2T = parcelRequire("f4L2T");

var $escKD = parcelRequire("escKD");

var $kPjLK = parcelRequire("kPjLK");

var $7Fvok = parcelRequire("7Fvok");

var $lI5WA = parcelRequire("lI5WA");

var $5bPOK = parcelRequire("5bPOK");
const $350bb53b739c1971$export$c0d6ac131d4391b9 = 'search-spotlight';
const $350bb53b739c1971$export$3ae94a2503e890a1 = (date)=>{
    const timeAgo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1YXTQ.TimeAgo), {
        date: date,
        dateFormatOptions: {
            month: 'short'
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...(0, $lI5WA.i18n).lastUpdatedDate,
        values: {
            datetime: timeAgo
        }
    });
};
const $350bb53b739c1971$var$analyticsContainerStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
const $350bb53b739c1971$var$NavigationSearchDialogWithRouter = ({ theme: theme, shouldFillContainer: shouldFillContainer, intl: intl, clearStickySearchRef: clearStickySearchRef })=>{
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const searchInputRef = (0, $gwFzn.useRef)(null);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const openDialog = (e)=>{
        if (e) {
            e.preventDefault(); //prevent shortcut key from being added to search input
            searchInputRef.current?.focus();
        }
        setIsOpen(true);
    };
    const closeDialog = ()=>{
        setIsOpen(false);
    };
    const onResultLinkClick = ()=>{
        closeDialog();
    };
    const onNavigate = (url)=>{
        closeDialog();
        push(url);
    };
    const onInteractiveSkeletonEnter = (0, $kPjLK.generateInteractiveSkeletonOnEnter)(push);
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'search',
                source: 'globalNavigation',
                attributes: {
                    navigationLayer: 'global',
                    navigationContainer: 'top',
                    navVersion: isNav4Enabled ? '4' : '3'
                }
            }
        }).fire();
    };
    const getRootSearchDialog = ({ ref: ref, ...rest }, clientProviderConfig)=>{
        const { cloudId: cloudId, aggregatorUrl: aggregatorUrl } = clientProviderConfig;
        const interactiveSkeleton = {
            onEnter: onInteractiveSkeletonEnter,
            placeholder: intl.formatMessage((0, $lI5WA.i18n).placeholder)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
            name: $350bb53b739c1971$export$c0d6ac131d4391b9
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $350bb53b739c1971$var$analyticsContainerStyles,
            onClick: fireClickAnalytics,
            "data-vc": "app-navigation-search-dialog",
            "data-ssr-placeholder-replace": "search-input"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eO2QR.AddActivationIdWrapper), {
            channel: "fabric-elements",
            targetActionSubjects: [
                'postQuerySearchResults',
                'cachedResults'
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7Fvok.ExtensibleCrossProductSearchDialog), {
            jiraFeatures: {
                hasSoftwareAccess: true
            },
            forwardRef: ref,
            setIsExpanded: (value)=>value ? openDialog(null) : closeDialog(),
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl,
            onNavigateSecondary: (href)=>{
                // eslint-disable-next-line no-restricted-syntax
                window.location.assign(href);
            },
            features: {
                jiraFeatures: rest.jiraFeatures,
                confluenceFeatures: rest.confluenceFeatures,
                interactiveSkeleton: interactiveSkeleton
            },
            clearStickySearchRef: clearStickySearchRef,
            ...rest
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iPfZG.default), {
            engagementId: $350bb53b739c1971$export$c0d6ac131d4391b9
        }));
    };
    const getSearchDialog = (searchDialogProps, clientProviderConfig)=>{
        const autoAddCurrentSpaceIsEnabled = false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ep3mz.PageSubscriber), null, ({ spaceKey: spaceKey })=>{
            return !!spaceKey && autoAddCurrentSpaceIsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f4L2T.CurrentSpaceContext), {
                spaceKey: spaceKey
            }, ({ currentSpace: currentSpace, loading: loading })=>{
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kPjLK.InteractiveSearchInputSkeleton), {
                    theme: searchDialogProps.theme,
                    shouldFillContainer: searchDialogProps.shouldFillContainer
                });
                else {
                    const currentSpaceValid = currentSpace && Object.values(currentSpace).every((v)=>v !== undefined);
                    return getRootSearchDialog({
                        ...searchDialogProps,
                        confluenceFeatures: {
                            currentSpace: currentSpaceValid ? currentSpace : undefined
                        }
                    }, clientProviderConfig);
                }
            }) : getRootSearchDialog({
                ...searchDialogProps
            }, clientProviderConfig);
        });
    };
    const universalNavigationShortcut = (0, $ljm2R.isMac)() ? (0, $ljm2R.UNIVERSAL_NAVIGATION_SHORTCUT_MAC) : (0, $ljm2R.UNIVERSAL_NAVIGATION_SHORTCUT_WIN);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ge2sX.SessionData), null, ({ cloudId: cloudId, userId: userId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lqqdh.ClientProvider), {
            cloudId: cloudId,
            userId: userId,
            useUrsForPeopleSearch: false
        }, ({ clientProviderConfig: clientProviderConfig })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
                attribution: (0, $dIouf.Attribution).DISCO,
                modal: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Fqwa.UserContext), null, ({ data: data, isLoading: isLoading })=>{
                return isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kPjLK.InteractiveSearchInputSkeleton), {
                    theme: theme,
                    shouldFillContainer: shouldFillContainer
                }) : getSearchDialog({
                    isExpanded: isOpen,
                    onOpen: openDialog,
                    onClose: closeDialog,
                    linkComponent: (0, $cuRlJ.getResultLinkComponent)(onResultLinkClick),
                    formatDate: $350bb53b739c1971$export$3ae94a2503e890a1,
                    ref: searchInputRef,
                    theme: theme,
                    user: {
                        name: data && data.name,
                        email: data && data.email,
                        id: data && data.id
                    },
                    onNavigate: onNavigate,
                    shouldFillContainer: shouldFillContainer
                }, clientProviderConfig);
            })));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $ljm2R.NAVIGATION_SHORTCUT) : undefined,
        accelerator: isLiveEditMode || isOnEditRoute ? universalNavigationShortcut : [
            universalNavigationShortcut,
            (0, $ljm2R.NAVIGATION_SLASH_SHORTCUT)
        ],
        listener: openDialog,
        isAppNavigationShortcut: true
    }));
};
const $350bb53b739c1971$var$NavigationSearchDialogInternal = (0, $js7oX.default)($350bb53b739c1971$var$NavigationSearchDialogWithRouter);
const $350bb53b739c1971$export$8d31f534ef9d9122 = (props)=>{
    const [isQuickFindEnabled] = (0, $5bPOK.useQuickFindEnabled)();
    return isQuickFindEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $escKD.QuickFindNav3), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($350bb53b739c1971$var$NavigationSearchDialogInternal, props);
};

});
parcelRegister("eO2QR", function(module, exports) {

$parcel$export(module.exports, "AddActivationIdWrapper", () => $236feafa6fe3ed5c$export$80d66f5e04b5ca9e);

var $gwFzn = parcelRequire("gwFzn");

var $bQm3c = parcelRequire("bQm3c");

var $iSamx = parcelRequire("iSamx");
const $236feafa6fe3ed5c$export$80d66f5e04b5ca9e = ({ channel: channel, targetActionSubjects: targetActionSubjects, children: children })=>{
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const eventUpdater = (payload)=>{
        let data = payload.data || payload;
        if (!targetActionSubjects || targetActionSubjects.includes(data.actionSubjectId) || targetActionSubjects.includes(data.actionSubject)) data = {
            ...data,
            attributes: {
                ...data.attributes,
                activationId: activationId
            }
        };
        if (payload.data) {
            if (payload.data !== data) return {
                ...payload,
                data: data
            };
            return payload;
        }
        return data;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iSamx.AddAttributesWrapper), {
        eventUpdater: eventUpdater,
        channel: channel || '*'
    }, children);
};

});

parcelRegister("lqqdh", function(module, exports) {

$parcel$export(module.exports, "ClientProvider", () => $ed5c1b85ee8abc07$export$5d91bb6ce8e0f47);

var $gwFzn = parcelRequire("gwFzn");

var $15B7D = parcelRequire("15B7D");
var $91yhh = parcelRequire("91yhh");
var $6clwF = parcelRequire("6clwF");

var $jlIaF = parcelRequire("jlIaF");

var $5bPOK = parcelRequire("5bPOK");
const $ed5c1b85ee8abc07$export$5d91bb6ce8e0f47 = ({ userId: userId, cloudId: cloudId, children: children, useUrsForPeopleSearch: useUrsForPeopleSearch })=>{
    const clientProviderConfig = {
        isUserAnonymous: !userId,
        aggregatorUrl: '/gateway/api/xpsearch-aggregator',
        collaborationGraphUrl: '/gateway/api/collaboration',
        cloudId: cloudId,
        accountId: userId,
        useUrsForPeopleSearch: useUrsForPeopleSearch
    };
    const [quickFindEnabled] = (0, $5bPOK.useQuickFindEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $91yhh.ExperimentProvider), {
        quickFindEnabled: quickFindEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $15B7D.ConfluenceClientsProvider), {
        config: {
            ...clientProviderConfig,
            baseUrl: (0, $jlIaF.CONTEXT_PATH),
            scopes: undefined
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6clwF.JiraSearchClientProvider), {
        ...clientProviderConfig,
        baseUrl: `${window.location.protocol}//${window.location.hostname}`
    }, children({
        clientProviderConfig: clientProviderConfig
    }))));
};

});
parcelRegister("15B7D", function(module, exports) {

$parcel$export(module.exports, "ConfluenceClientsProvider", () => $06b7bb550af38e43$export$43e8a9214cb124ba);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $5wJ53 = parcelRequire("5wJ53");

var $csnse = parcelRequire("csnse");

var $aAuSn = parcelRequire("aAuSn");

var $heWLv = parcelRequire("heWLv");

var $cfEFl = parcelRequire("cfEFl");
var $kfImN = parcelRequire("kfImN");

var $9HkI0 = parcelRequire("9HkI0");
const $06b7bb550af38e43$var$defaultCollaborationGraphConfig = {
    collaborationGraphUrl: 'gateway/api/collaboration',
    useCollaborationGraphForRecents: false
};
const $06b7bb550af38e43$var$getSearchClientWithConfig = (0, $csnse.default)((config, collabGraphClient)=>new (0, $5wJ53.ConfluenceSearchClient)(config, collabGraphClient), (0, (/*@__PURE__*/$parcel$interopDefault($aAuSn))));
const $06b7bb550af38e43$var$getRecentsClientWithConfig = (0, $csnse.default)((config, collabGraphClient)=>new (0, $heWLv.ConfluenceRecentsClient)(config, collabGraphClient), (0, (/*@__PURE__*/$parcel$interopDefault($aAuSn))));
const $06b7bb550af38e43$var$getCollabGraphClientWithConfig = (0, $csnse.default)((config)=>new (0, $cfEFl.CollaborationGraphClient)({
        collaborationGraphUrl: config.collaborationGraphUrl,
        cloudId: config.cloudId,
        isMultiSite: config.isMultiSite,
        collabGraphSessionId: config.collabGraphSessionId,
        sites: config.sites
    }), (0, (/*@__PURE__*/$parcel$interopDefault($aAuSn))));
const $06b7bb550af38e43$export$5a44dbd630fde657 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({});
const $06b7bb550af38e43$var$MISSING_PROVIDER_ERROR = new Error(`Could not find all required Clients, make sure ConfluenceClientsProvider is created further up the tree`);
//Will generate a session id to be sent to the CG endpoint as well as the frontend analytics
//This is created here as CG results are cached inside search dialog and is not invoked for subsequent use actions
const $06b7bb550af38e43$var$COLLABORATION_GRAPH_SESSION_ID = (0, $9HkI0.v4)();
const $06b7bb550af38e43$export$413dca1b70dbb4a7 = (Component)=>{
    return (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)($06b7bb550af38e43$export$5a44dbd630fde657.Consumer, {
            children: ({ searchClient: searchClient, recentClient: recentClient, cloudId: cloudId, siteUrl: siteUrl = '', sites: sites, collabGraphSessionId: collabGraphSessionId })=>{
                if (!searchClient || !recentClient) throw $06b7bb550af38e43$var$MISSING_PROVIDER_ERROR;
                const { ...rest } = props;
                return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                    ...rest,
                    searchClient: searchClient,
                    recentClient: recentClient,
                    cloudId: cloudId,
                    collabGraphSessionId: collabGraphSessionId,
                    siteUrl: siteUrl,
                    sites: sites
                });
            }
        });
};
const $06b7bb550af38e43$export$43e8a9214cb124ba = ({ children: children, config: config })=>{
    const { baseUrl: baseUrl, cloudId: cloudId, collaborationGraphUrl: collaborationGraphUrl, aggregatorUrl: aggregatorUrl, isUserAnonymous: isUserAnonymous, useCollaborationGraphForRecents: useCollaborationGraphForRecents, recentItemsSupplier: recentItemsSupplier, sites: sites = [], collabGraphSessionId: collabGraphSessionId, scopes: scopes, useGraphQLClient: useGraphQLClient, useRecentWork: useRecentWork, recentWorkAPIUrl: recentWorkAPIUrl } = {
        ...$06b7bb550af38e43$var$defaultCollaborationGraphConfig,
        ...config
    };
    const siteUrl = (0, $kfImN.extractSiteUrl)(config);
    const collabGraphClient = $06b7bb550af38e43$var$getCollabGraphClientWithConfig({
        collaborationGraphUrl: collaborationGraphUrl,
        cloudId: cloudId,
        isMultiSite: sites.length > 1,
        sites: sites,
        collabGraphSessionId: collabGraphSessionId
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)($06b7bb550af38e43$export$5a44dbd630fde657.Provider, {
        value: {
            searchClient: $06b7bb550af38e43$var$getSearchClientWithConfig({
                isUserAnonymous: isUserAnonymous,
                url: aggregatorUrl,
                cloudId: cloudId,
                isCollaborationGraphEnabled: useCollaborationGraphForRecents,
                siteMasterList: sites,
                scopes: scopes,
                useGraphQLClient: useGraphQLClient
            }, collabGraphClient),
            recentClient: $06b7bb550af38e43$var$getRecentsClientWithConfig({
                url: baseUrl,
                isCollaborationGraphEnabled: useCollaborationGraphForRecents,
                recentItemsSupplier: recentItemsSupplier,
                useRecentWork: useRecentWork,
                recentWorkAPIUrl: recentWorkAPIUrl
            }, collabGraphClient),
            collabGraphClient: collabGraphClient,
            siteUrl: siteUrl,
            cloudId: cloudId,
            sites: sites,
            collabGraphSessionId: $06b7bb550af38e43$var$COLLABORATION_GRAPH_SESSION_ID
        },
        children: children
    });
};
const $06b7bb550af38e43$export$4823a6cc022cca16 = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext($06b7bb550af38e43$export$5a44dbd630fde657);
    if (!context.searchClient || !context.recentClient) throw $06b7bb550af38e43$var$MISSING_PROVIDER_ERROR;
    return context;
};
const $06b7bb550af38e43$export$376c08f4921c6b8d = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext($06b7bb550af38e43$export$5a44dbd630fde657);
    return context.recentClient;
};

});
parcelRegister("5wJ53", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSearchClient", () => $da2db4559cce8604$export$2bdc82bf1cf036b4);

var $czt8s = parcelRequire("czt8s");

var $jV49M = parcelRequire("jV49M");

var $12cJV = parcelRequire("12cJV");
var $c3kEC = parcelRequire("c3kEC");

var $jXnBe = parcelRequire("jXnBe");

var $3NyIw = parcelRequire("3NyIw");

var $kfImN = parcelRequire("kfImN");

var $6TCTf = parcelRequire("6TCTf");
var $cMXX8 = parcelRequire("cMXX8");
const $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE = 'confluence.nav-v3';
const $da2db4559cce8604$var$EMPTY_RESULT_PROMISE = Promise.resolve({
    items: [],
    timings: 0
});
class $da2db4559cce8604$export$2bdc82bf1cf036b4 {
    /**
   * Makes a search across all relevant scopes.
   */ search(query, filters, context, queryVersion, sites) {
        const modelParams = [
            {
                '@type': 'queryParams',
                queryVersion: queryVersion
            }
        ];
        if (filters.length > 0) return this.searchWithFilters(query, filters, context, modelParams, sites);
        if (this.useGraphQLClient) // TODO: convert this response to expected confluence search response
        this.graphQLClient.search({
            query: query,
            context: context,
            entities: (0, $6TCTf.CONFLUENCE_ITEM_ENTITIES),
            modelParams: modelParams,
            resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT,
            experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
            sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
        });
        const scopes = [
            this.scopes.itemScope,
            this.scopes.spaceScope,
            this.scopes.ursUserScope
        ];
        const responseAndTiming = this.aggregatorClient.search({
            query: query,
            context: context,
            scopes: scopes,
            modelParams: modelParams,
            resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT,
            filters: [],
            experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
            sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
        });
        const allResults = {
            [(0, $jXnBe.Scope).ConfluencePageBlogAttachment]: (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfItem(response.retrieveScope(this.scopes.itemScope), requestDurationMs))),
            [(0, $jXnBe.Scope).ConfluenceSpace]: (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfSpace(response.retrieveScope(this.scopes.spaceScope), requestDurationMs))),
            [(0, $jXnBe.Scope).UserConfluence]: (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapUrsPeople(response.retrieveScope(this.scopes.ursUserScope), requestDurationMs, sites.length > 0)))
        };
        return allResults;
    }
    searchSpaces(query, context, sites) {
        const scopes = [
            (0, $jXnBe.Scope).ConfluenceSpace
        ];
        const responseAndTiming = this.aggregatorClient.search({
            query: query,
            context: context,
            scopes: scopes,
            modelParams: [],
            resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.SPACE_RESULT_LIMIT,
            filters: [],
            experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
            sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
        });
        return (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfSpace(response.retrieveScope((0, $jXnBe.Scope).ConfluenceSpace), requestDurationMs)));
    }
    searchUsers(query, context, sites) {
        const scopes = [
            (0, $jXnBe.Scope).UserConfluence
        ];
        const responseAndTiming = this.aggregatorClient.search({
            query: query,
            context: context,
            scopes: scopes,
            modelParams: [],
            resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.PEOPLE_RESULT_LIMIT,
            filters: [],
            experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
            sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
        });
        return (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapUrsPeople(response.retrieveScope((0, $jXnBe.Scope).UserConfluence), requestDurationMs, sites.length > 0)));
    }
    getRecentPeople(context, sites) {
        const { fromCache: fromCache, value: value } = this.bootstrapPeopleCache.get(context, sites);
        return new (0, $czt8s.CancellablePromise)(value.then((results)=>({
                ...results,
                isCached: fromCache
            })));
    }
    /**
   * Check the user permissions for the given list of products.
   */ async getProductPermissions(products) {
        if (!this.permissionsDataCache) this.permissionsDataCache = await this.aggregatorClient.getProductPermissions(products, $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE);
        return this.permissionsDataCache;
    }
    async getAbTestData() {
        if (this.abTestDataCache) return this.abTestDataCache;
        const abTest = await this.aggregatorClient.getAbTestData((0, $jXnBe.Scope).ConfluencePageBlogAttachment, $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE);
        this.abTestDataCache = abTest;
        return abTest;
    }
    mapConfItem(response, timings) {
        if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, $jXnBe.Scope).ConfluencePageBlogAttachment}`);
        if (response.error) throw (0, $c3kEC.responseErrorToError)(response.error);
        function removeHighlightTags(text) {
            return text.replace(/@@@hl@@@|@@@endhl@@@/g, '');
        }
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ const items = response.results.map((item)=>({
                resultId: item.content.id,
                // content always available for pages/blogs/attachments // TODO
                name: removeHighlightTags(item.title),
                href: `${item.baseUrl}${item.url}`,
                containerName: item.container.title,
                analyticsType: (0, $jXnBe.ResultConfluence),
                contentType: `confluence-${item.content.type}`,
                resultType: (0, $jXnBe.ConfluenceObjectResult),
                containerId: item.content.space && item.content.space.id ? item.content.space.id : 'UNAVAILABLE',
                spaceId: item.container.id,
                iconClass: item.iconCssClass,
                lastModified: item.lastModified,
                isRecentResult: false
            }));
        /* eslint-enable */ return {
            items: items,
            totalSize: response.size !== undefined ? response.size : response.results.length,
            timings: timings
        };
    }
    mapConfSpace(response, timings) {
        if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, $jXnBe.Scope).ConfluenceSpace}`);
        if (response.error) throw (0, $c3kEC.responseErrorToError)(response.error);
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ const items = response.results.map((item)=>({
                resultId: item.id,
                avatarUrl: `${item.baseUrl}${item.space.icon.path}`,
                name: item.container.title,
                href: `${item.baseUrl || ''}${item.container.displayUrl}`,
                analyticsType: (0, $jXnBe.ResultConfluence),
                resultType: (0, $jXnBe.GenericContainerResult),
                contentType: (0, $jXnBe.ConfluenceSpace),
                key: item.space.key,
                // TODO
                id: item.id
            }));
        /* eslint-enable */ return {
            items: items,
            timings: timings
        };
    }
    constructor(config, collabGraphClient){
        this.aggregatorClient = void 0;
        this.graphQLClient = void 0;
        this.siteMasterList = void 0;
        this.collaborationGraphClient = void 0;
        this.isCollabGraphEnabled = void 0;
        this.isUserAnonymous = void 0;
        this.useGraphQLClient = void 0;
        this.scopes = void 0;
        this.bootstrapPeopleCache = void 0;
        this.abTestDataCache = null;
        this.permissionsDataCache = null;
        this.searchWithFilters = (query, filters, context, modelParams, sites)=>{
            const scopes = [
                (0, $jXnBe.Scope).ConfluencePageBlogAttachment
            ];
            const allFilters = [];
            let baseSpaceFilters = null;
            let baseUserFilters = null;
            let baseTimeFilters = null;
            // TODO: GraphQL queries with filters
            filters.forEach((filter)=>{
                switch(filter.type){
                    case 'space':
                        if (!baseSpaceFilters) {
                            baseSpaceFilters = {
                                '@type': 'spaces',
                                spaceKeys: []
                            };
                            allFilters.push(baseSpaceFilters);
                        }
                        baseSpaceFilters.spaceKeys.push(filter.id);
                        break;
                    case 'contributor':
                        if (!baseUserFilters) {
                            baseUserFilters = {
                                '@type': 'contributors',
                                accountIds: []
                            };
                            allFilters.push(baseUserFilters);
                        }
                        baseUserFilters.accountIds.push(filter.id);
                        break;
                    case 'lastModified':
                        if (!baseTimeFilters) {
                            baseTimeFilters = {
                                '@type': 'lastModified',
                                from: filter.id
                            };
                            allFilters.push(baseTimeFilters);
                        }
                        break;
                    default:
                        break;
                }
            });
            const responseAndTiming = this.aggregatorClient.search({
                query: query,
                context: context,
                scopes: scopes,
                modelParams: modelParams,
                resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT,
                filters: allFilters,
                experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
                sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
            });
            const results = {
                [(0, $jXnBe.Scope).ConfluencePageBlogAttachment]: (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfItem(response.retrieveScope((0, $jXnBe.Scope).ConfluencePageBlogAttachment), requestDurationMs))),
                [(0, $jXnBe.Scope).ConfluenceSpace]: (0, $czt8s.CancellablePromise).from($da2db4559cce8604$var$EMPTY_RESULT_PROMISE),
                [(0, $jXnBe.Scope).UserConfluence]: (0, $czt8s.CancellablePromise).from($da2db4559cce8604$var$EMPTY_RESULT_PROMISE)
            };
            return results;
        };
        this.recentPeopleSupplier = (context, sites)=>{
            if (this.isUserAnonymous) return Promise.resolve({
                items: [],
                timings: 0
            });
            if (this.isCollabGraphEnabled) return this.collaborationGraphClient.getUsers().then((response)=>this.mapCollabGraphPeople(response));
            return this.aggregatorClient.search({
                query: '',
                context: context,
                scopes: [
                    (0, $jXnBe.Scope).UserConfluence
                ],
                modelParams: [],
                resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.PEOPLE_RESULT_LIMIT,
                experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
                sites: sites?.map((s)=>s.cloudId)
            }).then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapUrsPeople(response.retrieveScope((0, $jXnBe.Scope).UserConfluence), requestDurationMs, sites.length > 0));
        };
        this.mapUrsPeople = (response, timings, isMultiSite)=>{
            if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, $jXnBe.Scope).UserConfluence}`);
            if (response.error) throw (0, $c3kEC.responseErrorToError)(response.error);
            const items = response.results.map((item)=>({
                    resultType: (0, $jXnBe.PersonResult),
                    resultId: `people-${item.id}`,
                    userId: item.id,
                    name: item.name,
                    href: (0, $kfImN.generatePeopleProfileUrl)(isMultiSite, item.absoluteUrl, item.id),
                    avatarUrl: item.avatarUrl,
                    contentType: (0, $jXnBe.Person),
                    analyticsType: (0, $jXnBe.ResultPerson),
                    mentionName: item.nickname || '',
                    presenceMessage: ''
                }));
            return {
                items: (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))(items, (item)=>item.resultId),
                timings: timings
            };
        };
        this.mapCollabGraphPeople = (response)=>{
            const items = response.collaborationGraphEntities.map((item)=>({
                    resultId: item.userProfile.account_id,
                    userId: item.userProfile.account_id,
                    name: item.userProfile.name,
                    href: `${(0, $kfImN.mapTenantIdToSiteUrl)(item.siteId, this.siteMasterList)}/people/${item.userProfile.account_id}`,
                    analyticsType: (0, $jXnBe.RecentPerson),
                    mentionName: item.userProfile.name,
                    presenceMessage: item.userProfile.name,
                    resultType: (0, $jXnBe.PersonResult),
                    avatarUrl: item.userProfile.picture,
                    contentType: (0, $jXnBe.Person)
                }));
            return {
                items: items,
                timings: response.timings
            };
        };
        const { siteMasterList: siteMasterList, scopes: _scopes } = config;
        this.aggregatorClient = new (0, $12cJV.AggregatorClient)(config);
        this.graphQLClient = new (0, $cMXX8.GraphQLClient)(config);
        this.isUserAnonymous = config.isUserAnonymous;
        this.useGraphQLClient = config.useGraphQLClient || false;
        this.bootstrapPeopleCache = new (0, $3NyIw.SimpleCache)(this.recentPeopleSupplier);
        this.siteMasterList = siteMasterList;
        this.collaborationGraphClient = collabGraphClient;
        this.isCollabGraphEnabled = config.isCollaborationGraphEnabled;
        this.scopes = {
            itemScope: _scopes?.itemScope ? _scopes.itemScope : (0, $jXnBe.Scope).ConfluencePageBlogAttachment,
            spaceScope: _scopes?.spaceScope ? _scopes.spaceScope : (0, $jXnBe.Scope).ConfluenceSpace,
            ursUserScope: _scopes?.ursUserScope ? _scopes.ursUserScope : (0, $jXnBe.Scope).UserConfluence
        };
    }
}
$da2db4559cce8604$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT = 30;
$da2db4559cce8604$export$2bdc82bf1cf036b4.SPACE_RESULT_LIMIT = 10;
$da2db4559cce8604$export$2bdc82bf1cf036b4.PEOPLE_RESULT_LIMIT = 10;

});
parcelRegister("czt8s", function(module, exports) {

$parcel$export(module.exports, "CancelError", () => $2bc9549dae34d364$export$d7f5e52d091a66db);
$parcel$export(module.exports, "CancellablePromise", () => $2bc9549dae34d364$export$5782acf08706f13d);
class $2bc9549dae34d364$export$d7f5e52d091a66db extends Error {
    constructor(...args){
        super(...args);
        this.isCancelled = true;
    }
}
const $2bc9549dae34d364$var$CANCEL_ERROR = new $2bc9549dae34d364$export$d7f5e52d091a66db('Promise is cancelled');
class $2bc9549dae34d364$export$5782acf08706f13d {
    static from(promise) {
        return new $2bc9549dae34d364$export$5782acf08706f13d(promise);
    }
    constructor(promise){
        this.cancellablePromiseInternal = void 0;
        this.cancelInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.promise = ()=>this.cancellablePromiseInternal;
        this.cancel = ()=>this.cancelInternal();
        this.cancellablePromiseInternal = Promise.race([
            promise,
            new Promise((_, reject)=>{
                this.cancelInternal = ()=>reject($2bc9549dae34d364$var$CANCEL_ERROR);
            })
        ]);
    }
}

});

parcelRegister("12cJV", function(module, exports) {

$parcel$export(module.exports, "AggregatorClient", () => $160b24ddcdce5168$export$842695bca69eca86);

var $dwp40 = parcelRequire("dwp40");

var $9Nzn7 = parcelRequire("9Nzn7");

var $kfImN = parcelRequire("kfImN");

var $dxrRk = parcelRequire("dxrRk");

var $bKLey = parcelRequire("bKLey");
class $160b24ddcdce5168$export$842695bca69eca86 {
    async getAbTestData(scope, experience, product) {
        const body = {
            cloudId: this.cloudId,
            scopes: [
                scope
            ],
            experience: experience,
            product: product
        };
        const response = await this.makePostRequest($160b24ddcdce5168$export$842695bca69eca86.EXPERIMENT_URL_PATH, body);
        const scopeWithAbTest = response.scopes.find((s)=>s.id === scope);
        const abTestPromise = scopeWithAbTest ? Promise.resolve(scopeWithAbTest.abTest) : Promise.resolve(null);
        return abTestPromise;
    }
    /**
   * Get a list of permitted scopes for the supplied product.
   *
   * Consumers should favour {@link batchedGetExtensibleProductPermission}, to batch
   * multiple scopes calls into one. {@link getProductScopes} may be used when a caller
   * explicitly wants a separate REST call to fetch scopes. One example may be if a product
   * has different scopes caching rules to other products.
   *
   * @param productId the product id to lookup scopes for
   * @param experience the experience this UI represents
   * @returns a promise of a list of scopes for the supplied product
   */ async getProductScopes(productId, experience) {
        const productScopeMap = await this.getGenericProductPermissions({
            productIds: [
                productId
            ],
            experience: experience
        });
        return productScopeMap.get(productId) || [];
    }
    /**
   * Returns a list of {@link Products} which the user should see in the dialog
   *
   * @deprecated consumers should use {@link batchedGetExtensibleProductPermission} to fetch product scopes, or
   * {@link getProductScopes} to force a separate call to fetch a single product's scopes.
   *
   */ async getProductPermissions(products, experience) {
        const lowercaseProductIds = products.map((p)=>p.toLowerCase());
        const productScopeMap = await this.getGenericProductPermissions({
            productIds: lowercaseProductIds,
            experience: experience
        });
        return lowercaseProductIds.filter((product)=>productScopeMap.get(product)?.length).map((product)=>product.toUpperCase());
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [], sourceProduct: sourceProduct }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : (0, $kfImN.limitToMaxSiteUsage)(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn,
            experimentId: this.backendExperiment?.experimentId,
            shadowExperimentId: this.backendExperiment?.shadowExperimentId,
            ...sourceProduct ? {
                sourceProduct: sourceProduct
            } : {}
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $9Nzn7.timed)(this.makePostRequest($160b24ddcdce5168$export$842695bca69eca86.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList, backendExperiment: backendExperiment }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.backendExperiment = void 0;
        this.getAggregatorConfig = ()=>{
            return {
                url: this.serviceConfig.url,
                cloudId: this.cloudId,
                siteMasterList: this.siteMasterList
            };
        };
        this.getGenericProductPermissions = async (args)=>{
            return (0, $bKLey.getFetchProductPermissions)(this.makeGetRequest)(args.productIds, this.cloudId, args.experience);
        };
        this.batchedGetExtensibleProductPermission = (0, $dxrRk.batchMethod)((args)=>{
            const emptyProductPermissions = {
                productIds: [],
                experience: ''
            };
            if (args.length === 0) return emptyProductPermissions;
            return args.reduce((acc, arg)=>{
                return {
                    productIds: [
                        ...acc.productIds,
                        ...arg.productIds
                    ],
                    experience: arg.experience
                };
            }, emptyProductPermissions);
        }, this.getGenericProductPermissions, (response, id)=>response.get(id) || []);
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.makeGetRequest = (path)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
        this.backendExperiment = backendExperiment;
    }
}
// Static URLs
$160b24ddcdce5168$export$842695bca69eca86.EXPERIMENT_URL_PATH = 'experiment/v1';
$160b24ddcdce5168$export$842695bca69eca86.QUICKSEARCH_API_URL = 'quicksearch/v1';

});
parcelRegister("9Nzn7", function(module, exports) {

$parcel$export(module.exports, "timed", () => $f0a7768b8895b419$export$d35186a762cd39c8);
const $f0a7768b8895b419$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};

});

parcelRegister("kfImN", function(module, exports) {

$parcel$export(module.exports, "extractSiteUrl", () => $1e46ba23978c04a9$export$c9a345fa92182d1c);
$parcel$export(module.exports, "mapTenantIdToSiteUrl", () => $1e46ba23978c04a9$export$fdb149c8c29e67a2);
$parcel$export(module.exports, "extractSiteIdBySiteUrl", () => $1e46ba23978c04a9$export$4be99cb40bcf5aef);
$parcel$export(module.exports, "generatePeopleProfileUrl", () => $1e46ba23978c04a9$export$ca98b3a6d1ea77f3);
$parcel$export(module.exports, "limitToMaxSiteUsage", () => $1e46ba23978c04a9$export$ba81234f3ab84a86);
const $1e46ba23978c04a9$export$c9a345fa92182d1c = ({ siteUrl: siteUrl, sites: sites })=>{
    if (siteUrl) return siteUrl;
    if (sites && sites.length > 0) return sites[0].siteUrl;
    return '';
};
const $1e46ba23978c04a9$export$fdb149c8c29e67a2 = (siteId, sites)=>{
    const matchingSite = sites.find((site)=>site.cloudId === siteId);
    return matchingSite ? matchingSite.siteUrl : '';
};
const $1e46ba23978c04a9$export$4be99cb40bcf5aef = (absSiteUrl, sites = [])=>{
    const baseUrlRegex = /^(http(s)?:\/\/[^\/]+)/;
    const urlRegexMatches = absSiteUrl.match(baseUrlRegex);
    if (!urlRegexMatches) return '';
    const baseUrl = urlRegexMatches[0];
    const matchingSite = sites.find((site)=>site.siteUrl === baseUrl);
    return matchingSite ? matchingSite.cloudId : '';
};
const $1e46ba23978c04a9$export$ca98b3a6d1ea77f3 = (isMultiSite, absoluteUrl = '', accountId, contextPath = '')=>{
    if (isMultiSite && absoluteUrl) return absoluteUrl;
    return contextPath ? `/${contextPath}/people/${accountId}` : `/people/${accountId}`;
};
const $1e46ba23978c04a9$var$MAX_SITES_INITIAL_QUERY = 3;
const $1e46ba23978c04a9$export$ba81234f3ab84a86 = (sites = [])=>{
    return sites.slice(0, $1e46ba23978c04a9$var$MAX_SITES_INITIAL_QUERY);
};

});

parcelRegister("dxrRk", function(module, exports) {

$parcel$export(module.exports, "batchMethod", () => $0d4ef05ab28cb343$export$198da76335167312);

var $2jjxD = parcelRequire("2jjxD");
const $0d4ef05ab28cb343$export$198da76335167312 = (argumentResolver, finalFn, successfulResponseMapper, debounceTime = 100)=>{
    const batchMap = {};
    const timedFn = (0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(()=>{
        const inFlightRequestsMap = {
            ...batchMap
        };
        const keys = Object.keys(inFlightRequestsMap);
        const args = keys.map((key)=>inFlightRequestsMap[key].arg);
        finalFn(argumentResolver(args)).then((response)=>{
            keys.forEach((key)=>{
                inFlightRequestsMap[key].resolve(successfulResponseMapper(response, key));
            });
        }).catch(()=>{
            keys.forEach((product)=>{
                inFlightRequestsMap[product].reject();
            });
        }).finally(()=>keys.forEach((key)=>delete batchMap[key]));
    }, debounceTime);
    return (id, arg)=>{
        const promise = new Promise((resolve, reject)=>{
            batchMap[id] = {
                resolve: resolve,
                reject: reject,
                arg: arg
            };
        });
        timedFn();
        return promise;
    };
};

});

parcelRegister("bKLey", function(module, exports) {

$parcel$export(module.exports, "getFetchProductPermissions", () => $73ef07e649cb3d00$export$b756f4e692ecc8f);
const $73ef07e649cb3d00$var$SCOPES_API_URL = 'scopes/v1';
const $73ef07e649cb3d00$export$b756f4e692ecc8f = (makeRequest)=>async (productIds, cloudId, experience)=>{
        if (productIds.length === 0) return Promise.resolve(new Map());
        try {
            const productParams = productIds.map((productId)=>[
                    'productId',
                    productId
                ]);
            const params = new URLSearchParams([
                [
                    'experience',
                    experience
                ],
                ...productParams
            ]);
            const path = `${$73ef07e649cb3d00$var$SCOPES_API_URL}/${cloudId}?${params.toString()}`;
            const response = await makeRequest(path);
            return new Map(Object.keys(response.products).map((product)=>[
                    product,
                    response.products[product]
                ]));
        } catch (e) {
            return new Map();
        }
    };

});


parcelRegister("c3kEC", function(module, exports) {

$parcel$export(module.exports, "responseErrorToError", () => $62cd9cdd84f4378e$export$59a963eec12b52ed);
function $62cd9cdd84f4378e$export$59a963eec12b52ed(responseError) {
    let stringRepresentation = 'undefined';
    // Check if error response has a nested 'message' object, if so we use that instead.
    const error = responseError.message ? responseError.message : responseError;
    if (error) {
        // Convert it to string directly by default
        stringRepresentation = String(error);
        // If the error is an object we will try to JSON parse it
        if (typeof error === 'object') try {
            // Try to parse it as JSON
            stringRepresentation = JSON.stringify(responseError);
        } catch  {
        // Swallow all stringify errors
        }
    }
    return new Error(stringRepresentation);
}

});

parcelRegister("jXnBe", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $42a3e378fee7fe01$export$775b6bb06e53a214);
$parcel$export(module.exports, "GenericContainerResult", () => $42a3e378fee7fe01$export$6ec00f56b27cdc1d);
$parcel$export(module.exports, "PersonResult", () => $42a3e378fee7fe01$export$ca1a50bc869949e);
$parcel$export(module.exports, "ConfluenceObjectResult", () => $42a3e378fee7fe01$export$a99961038e9d5471);
$parcel$export(module.exports, "RecentConfluence", () => $42a3e378fee7fe01$export$18c69de2b4aa679c);
$parcel$export(module.exports, "ResultConfluence", () => $42a3e378fee7fe01$export$dc31f0db54ab1a30);
$parcel$export(module.exports, "RecentPerson", () => $42a3e378fee7fe01$export$cb8b6c470492bee8);
$parcel$export(module.exports, "ResultPerson", () => $42a3e378fee7fe01$export$ebb42dafe7a39a20);
$parcel$export(module.exports, "ConfluenceSpace", () => $42a3e378fee7fe01$export$8ee8726ca4e2f8bd);
$parcel$export(module.exports, "Person", () => $42a3e378fee7fe01$export$d0e824889e01c751);
var $42a3e378fee7fe01$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    return Scope;
}({});
const $42a3e378fee7fe01$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $42a3e378fee7fe01$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $42a3e378fee7fe01$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $42a3e378fee7fe01$export$80a5be864676016b = 'confluence.space';
const $42a3e378fee7fe01$export$70542451ad6057d2 = 'urs.user-confluence';
const $42a3e378fee7fe01$export$6ec00f56b27cdc1d = 'generic-container-result';
const $42a3e378fee7fe01$export$ca1a50bc869949e = 'person-result';
const $42a3e378fee7fe01$export$a99961038e9d5471 = 'confluence-object-result';
const $42a3e378fee7fe01$export$18c69de2b4aa679c = 'recent-confluence';
const $42a3e378fee7fe01$export$dc31f0db54ab1a30 = 'result-confluence';
const $42a3e378fee7fe01$export$cb8b6c470492bee8 = 'recent-person';
const $42a3e378fee7fe01$export$ebb42dafe7a39a20 = 'result-person';
const $42a3e378fee7fe01$export$602b44a55c824e30 = 'advanced-search-confluence';
const $42a3e378fee7fe01$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $42a3e378fee7fe01$export$bbd1709e62826142 = 'confluence-page';
const $42a3e378fee7fe01$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $42a3e378fee7fe01$export$b441f0c13fd510b9 = 'confluence-attachment';
const $42a3e378fee7fe01$export$8ee8726ca4e2f8bd = 'confluence-space';
const $42a3e378fee7fe01$export$d0e824889e01c751 = 'person';

});

parcelRegister("3NyIw", function(module, exports) {

$parcel$export(module.exports, "SimpleCache", () => $d9c68f16ddda70b9$export$de40364712978bcb);
// A imperfect workaround to represent variadic parameters (varargs) in typescript
class $d9c68f16ddda70b9$export$de40364712978bcb {
    get(...args) {
        if (!this.currentValue || Date.now() >= this.nextCacheRefreshTime) {
            this.updateNextRefreshTime();
            let exception = new Error('');
            try {
                const result = this.supplier(...args);
                this.currentValue = result;
                if (this.currentValue) return {
                    fromCache: false,
                    value: this.currentValue
                };
            } catch (e) {
                // If there's an error we will return the last good value but will attempt again on the next get()
                this.invalidate();
                exception = e;
            }
            if (!this.currentValue) throw new Error(`Failed to initialise a value for the cache: ${exception?.stack}`);
        }
        return {
            fromCache: true,
            value: this.currentValue
        };
    }
    /**
   * Calls the given supplier and caches the value. If the value is a promise
   * which rejects, the cache will be invalidated and a subsequent call to
   * this function will call the supplier again.
   * @param args
   * @returns
   */ getAsync(...args) {
        const { fromCache: fromCache, value: value } = this.get(...args);
        // When the cached value is a promise which rejects, invalidate the cache
        Promise.resolve(value).catch(()=>this.invalidate());
        return {
            fromCache: fromCache,
            value: value
        };
    }
    invalidate() {
        this.nextCacheRefreshTime = Date.now();
    }
    updateNextRefreshTime() {
        this.nextCacheRefreshTime = Date.now() + this.timeoutMs;
    }
    /**
   * @param initialValue The initial value, if undefined then the first get() call when initiate the cache value
   *
   * @param supplier The callback that will be called if the cache times out or if no existing value exists for the cache.
   *                 In the case that the supplier throws an exception the error will not be cached. If there's an error
   *                    we will instead return the last known good value but will attempt to refresh the cache again the next time
   *                    get() is called.
   *                 Any parameters passed into get() will be passed through to supplier. Unlike memoize the cache does not
   *                    care about the parameters and will not be invalidated if these parameters change.
   *
   * @param timeoutMs The time to wait before allowing the cache to refresh, this defaults to 15 mins.
   */ constructor(supplier, initialValue = null, timeoutMs = $d9c68f16ddda70b9$export$de40364712978bcb.DEFAULT_TIMEOUT_IN_MS){
        this.timeoutMs = void 0;
        this.nextCacheRefreshTime = Date.now();
        this.currentValue = void 0;
        this.supplier = void 0;
        this.timeoutMs = timeoutMs;
        this.supplier = supplier;
        this.currentValue = null;
        if (initialValue) {
            this.currentValue = initialValue;
            this.updateNextRefreshTime();
        }
    }
}
$d9c68f16ddda70b9$export$de40364712978bcb.DEFAULT_TIMEOUT_IN_MS = 900000;

});

parcelRegister("6TCTf", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_ITEM_ENTITIES", () => $8a95e0dcc4ebe080$export$8c5e9a2b7d8e96fa);
$parcel$export(module.exports, "SEARCH_QUERY", () => $8a95e0dcc4ebe080$export$f8e8a5f34f6ea725);
$parcel$export(module.exports, "sitesToLocations", () => $8a95e0dcc4ebe080$export$13404986e7746e72);
const $8a95e0dcc4ebe080$export$8c5e9a2b7d8e96fa = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:blogpost'
];
const $8a95e0dcc4ebe080$export$f8e8a5f34f6ea725 = `
query($query: String, $entities:[String!]!, $locations: [String!]!, $confluenceFilters: SearchConfluenceFilter, $experience: String!){
  search{
    search(
      query: $query
      filters: {entities: $entities, locations: $locations, confluenceFilters: $confluenceFilters}
      analytics: {searchSessionId: "graphql"}
      experience: $experience
    ) {
      edges {
        node {
          id
          title
          url
          description
          type
          lastModifiedDate
          __typename
          ... on SearchConfluencePageBlogAttachment {
            type
            space {
              key
              iconUrl
            }
          }
        }
      }
    }
  }
}`;
const $8a95e0dcc4ebe080$export$13404986e7746e72 = (sites, cloudId)=>{
    const cloudIds = sites.length > 0 ? sites : [
        cloudId
    ];
    const locations = cloudIds.map((cloudId)=>`ari:cloud:confluence::site/${cloudId}`);
    return locations;
};
const $8a95e0dcc4ebe080$export$2351037d7dbc8a11 = (filters)=>{
    return {
        spaceFilter: filters.filter((filter)=>filter.type === 'space').map((filter)=>filter.id),
        contributorsFilter: filters.filter((filter)=>filter.type === 'contributor').map((filter)=>filter.id)
    };
};

});

parcelRegister("cMXX8", function(module, exports) {

$parcel$export(module.exports, "GraphQLClient", () => $f42a017b762dc955$export$b0f268a6eae2cdf1);

var $dwp40 = parcelRequire("dwp40");

var $9Nzn7 = parcelRequire("9Nzn7");

var $kfImN = parcelRequire("kfImN");

var $6TCTf = parcelRequire("6TCTf");
class $f42a017b762dc955$export$b0f268a6eae2cdf1 {
    async search({ query: query, context: // todo
    context, entities: entities, modelParams: // todo
    modelParams, resultLimit: // todo
    resultLimit, filters: filters, experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : (0, $kfImN.limitToMaxSiteUsage)(this.siteMasterList).map((site)=>site.cloudId);
        const locations = (0, $6TCTf.sitesToLocations)(cloudIdsToFilterOn, cloudId);
        const body = {
            query: (0, $6TCTf.SEARCH_QUERY),
            variables: {
                locations: locations,
                entities: entities,
                query: query,
                confluenceFilters: filters,
                experience: experience
            }
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $9Nzn7.timed)(this.makePostRequest($f42a017b762dc955$export$b0f268a6eae2cdf1.GRAPHQL_API_URL, body));
        return {
            response: {
                rawData: response
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
// Static URLs
$f42a017b762dc955$export$b0f268a6eae2cdf1.GRAPHQL_API_URL = 'graphql';

});


parcelRegister("heWLv", function(module, exports) {

$parcel$export(module.exports, "ConfluenceRecentsClient", () => $effb6ad10ca37aba$export$2c04424b0b9ef0ac);

var $dwp40 = parcelRequire("dwp40");

var $czt8s = parcelRequire("czt8s");

var $1TPG8 = parcelRequire("1TPG8");

var $9Nzn7 = parcelRequire("9Nzn7");

var $3NyIw = parcelRequire("3NyIw");

var $jXnBe = parcelRequire("jXnBe");
const $effb6ad10ca37aba$export$be774cfa50234d6d = 'rest/recentlyviewed/1.0/recent';
const $effb6ad10ca37aba$export$d8751bf2ebec9fba = 'rest/recentlyviewed/1.0/recent/spaces';
const $effb6ad10ca37aba$var$RECENT_PAGES_LIMIT = 200;
const $effb6ad10ca37aba$var$RECENT_SPACE_LIMIT = 5;

class $effb6ad10ca37aba$export$2c04424b0b9ef0ac {
    getRecent(cache) {
        const { fromCache: fromCache, value: value } = cache.get();
        return (0, $czt8s.CancellablePromise).from(value.then((results)=>({
                ...results,
                isCached: fromCache
            })));
    }
    getRecentItems() {
        return this.getRecent(this.recentItemCache);
    }
    getRecentSpaces() {
        return this.getRecent(this.recentSpaceCache);
    }
    createRecentRequestPromise(path, queryParams) {
        const options = {
            path: path,
            queryParams: queryParams
        };
        const requestPromise = (0, $dwp40.utils).requestService(this.serviceConfig, options);
        return (0, $9Nzn7.timed)(requestPromise);
    }
    constructor({ url: url, isCollaborationGraphEnabled: isCollaborationGraphEnabled, recentItemsSupplier: recentItemsSupplier, useRecentWork: useRecentWork, recentWorkAPIUrl: recentWorkAPIUrl }, collabGraphClient){
        this.baseUrl = void 0;
        this.serviceConfig = void 0;
        this.recentItemCache = void 0;
        this.recentSpaceCache = void 0;
        this.isCollabGraphEnabled = void 0;
        this.collaborationGraphClient = void 0;
        this.useRecentWork = void 0;
        this.recentWorkAPIUrl = void 0;
        this.recentItemsSupplier = async ()=>{
            if (this.useRecentWork) {
                const { createActivityClient: createActivityClient } = await (parcelRequire("lVwKT"));
                const activityClient = createActivityClient('v3', 'confluence', undefined, this.recentWorkAPIUrl);
                const { viewed: viewed } = await activityClient.fetchActivities([
                    250
                ], {
                    products: [
                        'confluence'
                    ]
                }, [
                    'viewed'
                ]);
                const items = viewed.filter((item)=>item.object.product === 'confluence').map((item)=>$effb6ad10ca37aba$var$recentWorkItemToResult(item));
                return {
                    items: items,
                    totalSize: items.length,
                    timings: 0
                };
            } else {
                const baseUrl = this.serviceConfig.url;
                const recentPagesPromiseWithTimings = this.createRecentRequestPromise($effb6ad10ca37aba$export$be774cfa50234d6d, {
                    limit: $effb6ad10ca37aba$var$RECENT_PAGES_LIMIT
                });
                const { result: result, durationMs: durationMs } = await recentPagesPromiseWithTimings;
                const items = result.filter((page)=>!!page.title).map((recentPage)=>$effb6ad10ca37aba$var$recentPageToResult(recentPage, baseUrl));
                return {
                    items: items,
                    totalSize: items.length,
                    timings: durationMs
                };
            }
        };
        this.recentSpacesSupplier = ()=>{
            if (this.isCollabGraphEnabled) return this.collaborationGraphClient.getContainers([
                (0, $1TPG8.SpaceContainerType)
            ]).then((response)=>$effb6ad10ca37aba$var$mapCollabGraphContainer(response));
            else {
                const recentSpacesPromise = this.createRecentRequestPromise($effb6ad10ca37aba$export$d8751bf2ebec9fba, {
                    limit: $effb6ad10ca37aba$var$RECENT_SPACE_LIMIT
                });
                return recentSpacesPromise.then(({ result: result, durationMs: durationMs })=>({
                        items: result.map((recentSpace)=>$effb6ad10ca37aba$var$recentSpaceToResult(recentSpace, `${this.baseUrl}/spaces/${recentSpace.key}`)),
                        timings: durationMs
                    }));
            }
        };
        this.serviceConfig = {
            url: url
        };
        this.baseUrl = url;
        this.recentItemCache = new (0, $3NyIw.SimpleCache)(recentItemsSupplier || this.recentItemsSupplier);
        this.recentSpaceCache = new (0, $3NyIw.SimpleCache)(this.recentSpacesSupplier);
        this.collaborationGraphClient = collabGraphClient;
        this.isCollabGraphEnabled = isCollaborationGraphEnabled;
        this.useRecentWork = useRecentWork || false;
        this.recentWorkAPIUrl = recentWorkAPIUrl;
    }
}
function $effb6ad10ca37aba$var$recentWorkItemToResult(recentItem) {
    const { object: object, containers: containers } = recentItem;
    return {
        resultId: object.id,
        containerName: containers[0].name,
        containerId: '',
        resultType: (0, $jXnBe.ConfluenceObjectResult),
        isRecentResult: true,
        name: object.name || '',
        // Failsafe. All items should have a name.
        href: object.url,
        contentType: `confluence-${object.type}`,
        lastModified: undefined,
        // not available
        analyticsType: (0, $jXnBe.RecentConfluence)
    };
}
function $effb6ad10ca37aba$var$recentPageToResult(recentPage, baseUrl) {
    return {
        resultId: String(recentPage.id),
        name: recentPage.title || '',
        // This is a failsafe, there should be a filter to drop pages with no titles
        href: `${baseUrl}${recentPage.url}`,
        containerName: recentPage.space,
        analyticsType: (0, $jXnBe.RecentConfluence),
        resultType: (0, $jXnBe.ConfluenceObjectResult),
        contentType: `confluence-${recentPage.contentType}`,
        iconClass: recentPage.iconClass,
        containerId: recentPage.spaceId.toString(),
        isRecentResult: true,
        lastModified: undefined,
        // not available for recent results
        spaceId: recentPage.spaceId?.toString()
    };
}
function $effb6ad10ca37aba$var$recentSpaceToResult(recentSpace, href) {
    return {
        resultId: recentSpace.id,
        name: recentSpace.name,
        key: recentSpace.key,
        href: href,
        avatarUrl: recentSpace.icon,
        analyticsType: (0, $jXnBe.RecentConfluence),
        resultType: (0, $jXnBe.GenericContainerResult),
        contentType: (0, $jXnBe.ConfluenceSpace),
        id: recentSpace.id
    };
}
function $effb6ad10ca37aba$var$mapCollabGraphContainer(response) {
    const items = response.collaborationGraphEntities.map((item)=>({
            id: item.containerDetails?.id,
            key: item.containerDetails?.key,
            icon: item.containerDetails?.iconUrl,
            name: item.containerDetails?.name,
            url: item.containerDetails?.url,
            siteId: item.siteId
        })).filter((space)=>space.id !== undefined).map((space)=>$effb6ad10ca37aba$var$recentSpaceToResult(space, space.url));
    return {
        items: items,
        timings: response.timings
    };
}

});
parcelRegister("1TPG8", function(module, exports) {

$parcel$export(module.exports, "SpaceContainerType", () => $efe8e1453cb04fa5$export$e28d152a38023114);
const $efe8e1453cb04fa5$export$e28d152a38023114 = 'confluenceSpace';
const $efe8e1453cb04fa5$export$b9a68081b849a9ab = 'jiraProject';

});

parcelRegister("lVwKT", function(module, exports) {

let $ff68545e13f3c187$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ff68545e13f3c187$var$load("jCu7l"),
    $ff68545e13f3c187$var$load("c6MKV"),
    $ff68545e13f3c187$var$load("efZH2")
]).then(()=>parcelRequire('mS2VM'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});




parcelRegister("cfEFl", function(module, exports) {

$parcel$export(module.exports, "MAX_CG_RESULTS", () => $6e4dcee96054a2d9$export$8b133b5f27893e80);
$parcel$export(module.exports, "CONTEXT_USER_ID", () => $6e4dcee96054a2d9$export$886facd7f1fb825b);
$parcel$export(module.exports, "QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT", () => $6e4dcee96054a2d9$export$c4871241365cf270);
$parcel$export(module.exports, "CollaborationGraphClient", () => $6e4dcee96054a2d9$export$cd5b4a06db0ea4e2);

var $1Qx68 = parcelRequire("1Qx68");

var $45ZOs = parcelRequire("45ZOs");
const $6e4dcee96054a2d9$export$8b133b5f27893e80 = 10;
const $6e4dcee96054a2d9$export$886facd7f1fb825b = 'context';
const $6e4dcee96054a2d9$export$c4871241365cf270 = 'quickSearch';
class $6e4dcee96054a2d9$export$cd5b4a06db0ea4e2 {
    constructor(config){
        this.isMultiSite = void 0;
        this.cloudId = void 0;
        this.sites = void 0;
        this.collabGraphSingleSite = void 0;
        this.collabGraphMultiSite = void 0;
        this.getContainers = (containerTypes, sites = [])=>{
            if (this.isMultiSite) return this.collabGraphMultiSite.getContainers({
                selectedSites: sites,
                containerTypes: containerTypes,
                allSites: this.sites.length > 0 ? this.sites : [
                    {
                        cloudId: this.cloudId
                    }
                ]
            });
            else return this.collabGraphSingleSite.getContainers({
                containerTypes: containerTypes,
                cloudId: this.cloudId
            });
        };
        this.getUsers = (sites = [])=>{
            if (this.isMultiSite) return this.collabGraphMultiSite.getUsers({
                allSites: this.sites.length > 0 ? this.sites : [
                    {
                        cloudId: this.cloudId
                    }
                ],
                selectedSites: sites
            });
            else return this.collabGraphSingleSite.getUsers({
                cloudId: this.cloudId
            });
        };
        this.collabGraphSingleSite = new (0, $1Qx68.CollaborationGraphSingleSite)(config);
        this.collabGraphMultiSite = new (0, $45ZOs.CollaborationGraphMultiSite)(config);
        this.isMultiSite = config.isMultiSite;
        this.cloudId = config.cloudId;
        this.sites = config.sites;
    }
}

});
parcelRegister("1Qx68", function(module, exports) {

$parcel$export(module.exports, "CollaborationGraphSingleSite", () => $a937e9fff7ff80c1$export$75acaca275e7d34b);

var $4M3aT = parcelRequire("4M3aT");

var $cfEFl = parcelRequire("cfEFl");
class $a937e9fff7ff80c1$export$75acaca275e7d34b extends (0, $4M3aT.CollaborationGraph) {
    getUsers(arg) {
        return this.usersCache.get(arg).value;
    }
    getContainers({ containerTypes: containerTypes, cloudId: cloudId }) {
        return this.containersCache.get({
            containerTypes: containerTypes,
            cloudId: cloudId
        }).value;
    }
    async getContainersSupplier({ containerTypes: containerTypes, cloudId: cloudId }) {
        const body = {
            containerTypes: containerTypes,
            context: {
                principalId: (0, $cfEFl.CONTEXT_USER_ID),
                siteId: cloudId,
                contextType: (0, $cfEFl.QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT)
            },
            maxNumberOfResults: (0, $cfEFl.MAX_CG_RESULTS),
            userId: (0, $cfEFl.CONTEXT_USER_ID),
            expanded: true
        };
        const { result: result, durationMs: durationMs } = await this.makeRequest(this.CONTAINER_URL_PATH, body);
        result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>{
            return {
                ...cgEntity,
                siteId: cloudId
            };
        });
        return {
            ...result,
            timings: durationMs
        };
    }
    async getUsersSupplier({ cloudId: cloudId = '', collabGraphSessionId: collabGraphSessionId = '' }) {
        const body = {
            context: {
                principalId: (0, $cfEFl.CONTEXT_USER_ID),
                siteId: cloudId,
                sessionId: collabGraphSessionId,
                contextType: (0, $cfEFl.QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT)
            },
            maxNumberOfResults: (0, $cfEFl.MAX_CG_RESULTS),
            userId: (0, $cfEFl.CONTEXT_USER_ID),
            expanded: true
        };
        const { result: result, durationMs: durationMs } = await this.makeRequest(this.USER_URL_PATH, body);
        result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>{
            return {
                ...cgEntity,
                siteId: cloudId
            };
        });
        return {
            ...result,
            timings: durationMs
        };
    }
    constructor({ collaborationGraphUrl: url }){
        super({
            url: url
        });
        this.CONTAINER_URL_PATH = 'v1/collaborationgraph/user/container';
        this.USER_URL_PATH = 'v1/collaborationgraph/user/user';
    }
}

});
parcelRegister("4M3aT", function(module, exports) {

$parcel$export(module.exports, "CollaborationGraph", () => $2d835650f472091b$export$d4989257696242c9);

var $dwp40 = parcelRequire("dwp40");

var $3NyIw = parcelRequire("3NyIw");

var $9Nzn7 = parcelRequire("9Nzn7");
class $2d835650f472091b$export$d4989257696242c9 {
    async makeRequest(path, body) {
        const options = {
            path: path,
            requestInit: {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify(body)
            }
        };
        return (0, $9Nzn7.timed)((0, $dwp40.utils).requestService(this.serviceConfig, options));
    }
    constructor({ url: url }){
        this.CONTAINER_URL_PATH = void 0;
        this.USER_URL_PATH = void 0;
        this.containersCache = void 0;
        this.usersCache = void 0;
        this.serviceConfig = void 0;
        this.serviceConfig = {
            url: url
        };
        this.getContainersSupplier = this.getContainersSupplier.bind(this);
        this.getUsersSupplier = this.getUsersSupplier.bind(this);
        this.containersCache = new (0, $3NyIw.SimpleCache)(this.getContainersSupplier);
        this.usersCache = new (0, $3NyIw.SimpleCache)(this.getUsersSupplier);
    }
}

});


parcelRegister("45ZOs", function(module, exports) {

$parcel$export(module.exports, "CollaborationGraphMultiSite", () => $5787685b349c0701$export$6150ad6d7e95f129);

var $jV49M = parcelRequire("jV49M");

var $4M3aT = parcelRequire("4M3aT");

var $cfEFl = parcelRequire("cfEFl");

var $kfImN = parcelRequire("kfImN");
const $5787685b349c0701$var$mergeUsers = (prevResult, nextResult)=>({
        timings: Math.max(prevResult.timings, nextResult.timings),
        collaborationGraphEntities: (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))(prevResult.collaborationGraphEntities.concat(nextResult.collaborationGraphEntities), (user)=>user.id)
    });
const $5787685b349c0701$var$emptyUserResponse = {
    timings: 0,
    collaborationGraphEntities: []
};
class $5787685b349c0701$export$6150ad6d7e95f129 extends (0, $4M3aT.CollaborationGraph) {
    async getContainersSupplier(arg) {
        const body = {
            containerTypes: arg.containerTypes,
            context: {
                principalId: (0, $cfEFl.CONTEXT_USER_ID),
                siteIds: arg.cloudIds,
                contextType: (0, $cfEFl.QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT)
            },
            maxNumberOfResults: (0, $cfEFl.MAX_CG_RESULTS),
            userId: (0, $cfEFl.CONTEXT_USER_ID),
            expanded: true
        };
        const { result: result, durationMs: durationMs } = await this.makeRequest(this.CONTAINER_URL_PATH, body);
        result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>{
            return {
                ...cgEntity,
                siteId: (0, $kfImN.extractSiteIdBySiteUrl)(cgEntity.containerDetails.url, arg.allSites)
            };
        });
        return {
            ...result,
            timings: durationMs
        };
    }
    async getUsersSupplier(arg) {
        const results = arg.cloudIds.map(async (cloudId)=>{
            const body = {
                context: {
                    principalId: (0, $cfEFl.CONTEXT_USER_ID),
                    siteId: cloudId,
                    contextType: (0, $cfEFl.QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT)
                },
                maxNumberOfResults: (0, $cfEFl.MAX_CG_RESULTS),
                userId: (0, $cfEFl.CONTEXT_USER_ID),
                expanded: true
            };
            const { result: result, durationMs: durationMs } = await this.makeRequest(this.USER_URL_PATH, body);
            result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>({
                    ...cgEntity,
                    siteId: cloudId
                }));
            return {
                ...result,
                timings: durationMs
            };
        });
        return Promise.all(results).then((values)=>values.reduce($5787685b349c0701$var$mergeUsers, $5787685b349c0701$var$emptyUserResponse));
    }
    getUsers({ allSites: allSites, selectedSites: selectedSites }) {
        if (selectedSites.length === 0) return this.usersCache.get({
            cloudIds: (0, $kfImN.limitToMaxSiteUsage)(allSites).map((site)=>site.cloudId)
        }).value;
        else return this.getUsersSupplier({
            cloudIds: selectedSites.map((site)=>site.cloudId)
        });
    }
    getContainers({ allSites: allSites, selectedSites: selectedSites, containerTypes: containerTypes }) {
        if (selectedSites.length === 0) return this.containersCache.get({
            cloudIds: (0, $kfImN.limitToMaxSiteUsage)(allSites).map((site)=>site.cloudId),
            containerTypes: containerTypes
        }).value;
        else return this.getContainersSupplier({
            cloudIds: selectedSites.map((site)=>site.cloudId),
            containerTypes: containerTypes,
            allSites: allSites
        });
    }
    constructor(config){
        super({
            url: config.collaborationGraphUrl
        });
        this.CONTAINER_URL_PATH = 'v1/collaborationgraph/multitenant/user/container';
        this.USER_URL_PATH = 'v1/collaborationgraph/user/user';
    }
}

});



parcelRegister("91yhh", function(module, exports) {

$parcel$export(module.exports, "ExperimentProvider", () => $c9b4bbfb0318c1b1$export$ce7a53bcef5d6aee);
$parcel$export(module.exports, "useExperiments", () => $c9b4bbfb0318c1b1$export$d98589668c6e11a9);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $iA4lt = parcelRequire("iA4lt");
var $gkXKl = parcelRequire("gkXKl");
var $4OGlb = parcelRequire("4OGlb");
const $c9b4bbfb0318c1b1$export$ce7a53bcef5d6aee = ({ quickFindEnabled: quickFindEnabled, children: children })=>{
    const layerName = quickFindEnabled ? (0, $4OGlb.STATSIG_QUICK_FIND_LAYER) : undefined;
    const { backendExperiment: backendExperiment, frontendExperiment: frontendExperiment } = (0, $gwFzn.useMemo)(()=>(0, $gkXKl.getMutuallyExclusiveExperiment)(layerName), [
        layerName
    ]);
    let frontendExperiments;
    if (quickFindEnabled) {
        const exampleFrontendExperiment = (0, $iA4lt.getFrontendExperiment)({
            abTestId: 'fe_search_experiment'
        });
        frontendExperiments = {
            // the mutually exclusive frontend experiment
            ...frontendExperiment?.abTestId && {
                [frontendExperiment.abTestId]: frontendExperiment
            },
            // add other frontend experiments that can be run alongside backend experiments here
            [exampleFrontendExperiment.abTestId]: exampleFrontendExperiment
        };
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)($c9b4bbfb0318c1b1$var$ExperimentContext.Provider, {
        value: {
            backendExperiment: backendExperiment,
            frontendExperiments: frontendExperiments
        },
        children: children
    });
};
const $c9b4bbfb0318c1b1$var$ExperimentContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    backendExperiment: undefined,
    frontendExperiments: undefined
});
const $c9b4bbfb0318c1b1$export$d98589668c6e11a9 = ()=>{
    return (0, $gwFzn.useContext)($c9b4bbfb0318c1b1$var$ExperimentContext);
};

});
parcelRegister("gkXKl", function(module, exports) {

$parcel$export(module.exports, "getMutuallyExclusiveExperiment", () => $ddee69ce44809421$export$fd4704975f80304e);
$parcel$export(module.exports, "getBackendExperimentsWithOverrides", () => $ddee69ce44809421$export$42e21c9a86f72c4f);

var $c6GJD = parcelRequire("c6GJD");

var $4OGlb = parcelRequire("4OGlb");

var $hm6w9 = parcelRequire("hm6w9");

var $iA4lt = parcelRequire("iA4lt");
const $ddee69ce44809421$export$fd4704975f80304e = (layerName, onErrorFn, shouldNotGetBackendExperiment = false)=>{
    try {
        if (!layerName) return {
            frontendExperiment: undefined,
            backendExperiment: (0, $hm6w9.getBackendExperimentConfig)(onErrorFn, shouldNotGetBackendExperiment),
            isMutuallyExclusive: false
        };
        const layer = (0, $c6GJD.default).getLayer(layerName, {
            fireLayerExposure: false
        });
        const frontendExperimentName = layer.get('frontendExperimentName', '');
        if (frontendExperimentName) return {
            frontendExperiment: (0, $iA4lt.getFrontendExperiment)({
                abTestId: frontendExperimentName
            }),
            backendExperiment: (0, $4OGlb.DEFAULT_STATSIG_EXPERIMENT_CONFIG),
            isMutuallyExclusive: true
        };
        return {
            frontendExperiment: undefined,
            backendExperiment: (0, $hm6w9.getBackendExperimentConfig)(onErrorFn, shouldNotGetBackendExperiment),
            isMutuallyExclusive: false
        };
    } catch (error) {
        onErrorFn?.(error);
    }
    return {
        frontendExperiment: undefined,
        backendExperiment: (0, $4OGlb.DEFAULT_STATSIG_EXPERIMENT_CONFIG),
        isMutuallyExclusive: false
    };
};
const $ddee69ce44809421$export$42e21c9a86f72c4f = (overrides, layerName, onErrorFn, shouldNotGetBackendExperiment = false)=>{
    // We should only evaluate the backend experiment here if we are using search experiment overrides functionality
    // backend experiments outside of rovo v rovo are evaluated at request time instead
    const shouldUseSearchExperimentOverrides = (0, $c6GJD.default).checkGate('search-experiment-overrides-backend');
    const shouldNotGetBackendExperimentsForOverrides = shouldUseSearchExperimentOverrides ? false : shouldNotGetBackendExperiment;
    // If the feature gate is enabled or no overrides are provided, return the default experiment.
    if (!shouldUseSearchExperimentOverrides || !overrides || overrides.length === 0) return $ddee69ce44809421$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides);
    // Filter for backend experiment from the overrides. only allowing them for now
    const backendOverrideExperiments = overrides.filter((override)=>override.location === 'backend' && override.type === 'experiment');
    if (!backendOverrideExperiments.length) return $ddee69ce44809421$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides);
    // Get the base user's experiments from layers.
    const { backendExperiment: backendExperiment, frontendExperiment: frontendExperiment, isMutuallyExclusive: isMutuallyExclusive } = $ddee69ce44809421$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides);
    if (backendExperiment && 'experimentLayers' in backendExperiment) backendExperiment.experimentLayers = backendExperiment?.experimentLayers.map((layer)=>{
        const layerToOverride = backendOverrideExperiments.find((exp)=>{
            return exp.layer && layer.name?.includes(exp.layer === 'qr' ? 'query_expansion' : exp.layer);
        });
        if (!layerToOverride) {
            const { testId: _, ...rest } = layer;
            return rest;
        }
        const statsigOverrideExperiment = (0, $c6GJD.default).getExperiment(layerToOverride?.name);
        // handle case where experiment didnt add testId - for older experiments should be on new ones
        if (!statsigOverrideExperiment.get('testId', null)) {
            const { testId: _, ...rest } = layer;
            return rest;
        }
        return {
            name: layer.name,
            layerId: statsigOverrideExperiment.get('testId', null),
            shadowId: statsigOverrideExperiment.get('shadowId', null),
            // The below values might not be sent to the backend, but we can still track them in the frontend.
            controlId: statsigOverrideExperiment.get('controlId', null),
            abTestId: statsigOverrideExperiment.get('abTestId', null)
        };
    });
    return {
        backendExperiment: backendExperiment,
        frontendExperiment: frontendExperiment,
        isMutuallyExclusive: isMutuallyExclusive
    };
};

});
parcelRegister("4OGlb", function(module, exports) {

$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM", () => $8c848bb8ca35d190$export$71a8b319599e57dc);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD", () => $8c848bb8ca35d190$export$c076c4dd9e9d1e6e);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM", () => $8c848bb8ca35d190$export$23877616cb34cf0c);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM", () => $8c848bb8ca35d190$export$68be56e20dba0ed5);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD", () => $8c848bb8ca35d190$export$f39fa5cd744578ae);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM", () => $8c848bb8ca35d190$export$a36d8c2d9981ec2b);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER", () => $8c848bb8ca35d190$export$fe025e19388affcf);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L3_LAYER", () => $8c848bb8ca35d190$export$11e2cd4e8edc5e82);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER", () => $8c848bb8ca35d190$export$9b30fb0a29b39382);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED", () => $8c848bb8ca35d190$export$a62089c95934ccf8);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED", () => $8c848bb8ca35d190$export$4e36729d15b3db9e);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN", () => $8c848bb8ca35d190$export$87f92c12fc8bb620);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L1_LAYER_NAME", () => $8c848bb8ca35d190$export$86bb6d2503529310);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L2_LAYER_NAME", () => $8c848bb8ca35d190$export$722a4624bef605fa);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_L3_LAYER_NAME", () => $8c848bb8ca35d190$export$1963cf4be1b2cd5e);
$parcel$export(module.exports, "STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER_NAME", () => $8c848bb8ca35d190$export$a18b3b3caa760214);
$parcel$export(module.exports, "STATSIG_FULL_PAGE_SEARCH_LAYER", () => $8c848bb8ca35d190$export$39bbb550e0341d58);
$parcel$export(module.exports, "STATSIG_QUICK_FIND_LAYER", () => $8c848bb8ca35d190$export$b669e8e4ed2b4c67);
$parcel$export(module.exports, "DEFAULT_STATSIG_EXPERIMENT_CONFIG", () => $8c848bb8ca35d190$export$afc3cbf9db978004);
$parcel$export(module.exports, "DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG", () => $8c848bb8ca35d190$export$fca208e1e43c6fac);
const $8c848bb8ca35d190$export$71a8b319599e57dc = 'l1_premium_vs_standard';
const $8c848bb8ca35d190$export$c076c4dd9e9d1e6e = 'search_platform_layer_l1_standard';
const $8c848bb8ca35d190$export$23877616cb34cf0c = 'search_platform_layer_l1_premium';
const $8c848bb8ca35d190$export$68be56e20dba0ed5 = 'l2_premium_vs_standard';
const $8c848bb8ca35d190$export$f39fa5cd744578ae = 'search_platform_layer_l2_standard';
const $8c848bb8ca35d190$export$a36d8c2d9981ec2b = 'search_platform_layer_l2_premium';
const $8c848bb8ca35d190$export$fe025e19388affcf = 'search_platform_layer_l2_blending';
const $8c848bb8ca35d190$export$11e2cd4e8edc5e82 = 'search_platform_layer_l3';
const $8c848bb8ca35d190$export$9b30fb0a29b39382 = 'search_platform_layer_query_expansion';
const $8c848bb8ca35d190$export$a62089c95934ccf8 = 'enable_l3';
const $8c848bb8ca35d190$export$4e36729d15b3db9e = 'enable_query_rewrite';
const $8c848bb8ca35d190$export$87f92c12fc8bb620 = 'search_platform_non_overlapping_domain';
const $8c848bb8ca35d190$export$86bb6d2503529310 = 'search_platform_layer_l1';
const $8c848bb8ca35d190$export$722a4624bef605fa = 'search_platform_layer_l2';
const $8c848bb8ca35d190$export$1963cf4be1b2cd5e = 'search_platform_layer_l3';
const $8c848bb8ca35d190$export$a18b3b3caa760214 = 'search_platform_layer_query_expansion';
const $8c848bb8ca35d190$export$39bbb550e0341d58 = 'full_page_search_layer';
const $8c848bb8ca35d190$export$b669e8e4ed2b4c67 = 'quick_find_layer';
const $8c848bb8ca35d190$export$afc3cbf9db978004 = {
    experimentId: 'default',
    shadowExperimentId: 'default',
    controlId: 'default',
    abTestId: 'default'
};
const $8c848bb8ca35d190$export$fca208e1e43c6fac = {
    experimentId: 'default',
    shadowExperimentId: 'default',
    experimentLayers: []
};

});

parcelRegister("hm6w9", function(module, exports) {

$parcel$export(module.exports, "getBackendExperimentConfig", () => $f62b6f09dac42d3d$export$2f6c9ab85be44d1a);
$parcel$export(module.exports, "getLayerValues", () => $f62b6f09dac42d3d$export$3178593b0bf95121);
$parcel$export(module.exports, "getBackendNonOverlappingDomainLayerValues", () => $f62b6f09dac42d3d$export$1e659fcd208b8aec);

var $c6GJD = parcelRequire("c6GJD");

var $4OGlb = parcelRequire("4OGlb");
const $f62b6f09dac42d3d$export$2f6c9ab85be44d1a = (onErrorFn, shouldNotGetBackendExperiment = false)=>{
    const isRequestDrivenExperimentationEnabled = (0, $c6GJD.default).checkGate('request_driven_experimentation_enabled');
    if (!isRequestDrivenExperimentationEnabled || shouldNotGetBackendExperiment) return;
    return $f62b6f09dac42d3d$var$getParallelBackendExperimentsConfig(onErrorFn);
};
const $f62b6f09dac42d3d$export$3178593b0bf95121 = (layerName)=>{
    const layer = (0, $c6GJD.default).getLayer(layerName);
    const layerNameWithoutSuffix = layerName.replace('_standard', '').replace('_premium', '');
    return {
        name: layerNameWithoutSuffix,
        layerId: layer.get('layerId', 'default'),
        shadowId: layer.get('shadowId', null),
        // The below values might not be sent to the backend but we can still track them in the frontend
        controlId: layer.get('controlId', null),
        abTestId: layer.get('abTestId', 'no_ab_test_id'),
        ...(0, $c6GJD.default).checkGate('search-experiment-overrides-backend') && {
            testId: layer.get('testId', null)
        }
    };
};
const $f62b6f09dac42d3d$export$1e659fcd208b8aec = ()=>{
    const layer = (0, $c6GJD.default).getLayer((0, $4OGlb.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN));
    return {
        l1Id: layer.get('l1Id', 'default'),
        l2Id: layer.get('l2Id', 'default'),
        l3Id: layer.get('l3Id', 'default'),
        qrId: layer.get('qrId', 'default'),
        abTestId: layer.get('abTestId', 'no_ab_test_id'),
        mutualExclusion: layer.get('mutualExclusion', false),
        controlId: layer.get('controlId', 'default')
    };
};
const $f62b6f09dac42d3d$var$getStandardOrPremiumLayerValues = (featureGateName, standardLayerName, premiumLayerName)=>{
    const isPremium = (0, $c6GJD.default).checkGate(featureGateName);
    if (isPremium) return $f62b6f09dac42d3d$export$3178593b0bf95121(premiumLayerName);
    return $f62b6f09dac42d3d$export$3178593b0bf95121(standardLayerName);
};
const $f62b6f09dac42d3d$var$getParallelBackendExperimentsConfig = (onErrorFn)=>{
    const isRequestDrivenExperimentationEnabled = (0, $c6GJD.default).checkGate('request_driven_experimentation_enabled');
    if (!isRequestDrivenExperimentationEnabled) return;
    try {
        const allLayers = [];
        const layer1 = $f62b6f09dac42d3d$var$getStandardOrPremiumLayerValues((0, $4OGlb.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM), (0, $4OGlb.STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD), (0, $4OGlb.STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM));
        allLayers.push(layer1);
        const layer2 = $f62b6f09dac42d3d$var$getStandardOrPremiumLayerValues((0, $4OGlb.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM), (0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD), (0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM));
        allLayers.push(layer2);
        const layer2Blending = $f62b6f09dac42d3d$export$3178593b0bf95121((0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER));
        allLayers.push(layer2Blending);
        const isLayer3Enabled = (0, $c6GJD.default).checkGate((0, $4OGlb.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED));
        if (isLayer3Enabled) {
            const layer3 = $f62b6f09dac42d3d$export$3178593b0bf95121((0, $4OGlb.STATSIG_SEARCH_BACKEND_L3_LAYER));
            allLayers.push(layer3);
        }
        const isQueryExpansionLayerEnabled = (0, $c6GJD.default).checkGate((0, $4OGlb.STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED));
        if (isQueryExpansionLayerEnabled) {
            const layerQueryExpansion = $f62b6f09dac42d3d$export$3178593b0bf95121((0, $4OGlb.STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER));
            allLayers.push(layerQueryExpansion);
        }
        const concatenatedExperimentId = allLayers.map((l)=>l?.layerId).join('_');
        const concatenatedShadowExperimentId = allLayers.map((l)=>l?.shadowId).join('_');
        return {
            experimentId: concatenatedExperimentId,
            shadowExperimentId: concatenatedShadowExperimentId,
            experimentLayers: allLayers
        };
    } catch (error) {
        onErrorFn?.(error);
    }
    return 0, $4OGlb.DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG;
};

});



parcelRegister("6clwF", function(module, exports) {

$parcel$export(module.exports, "JiraSearchClientProvider", () => $fe7e2b06857d7b1f$export$f8102de5af58503c);
$parcel$export(module.exports, "useJiraSearchClientContext", () => $fe7e2b06857d7b1f$export$71e1e199804dfd5e);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aAuSn = parcelRequire("aAuSn");

var $csnse = parcelRequire("csnse");

var $dGwqS = parcelRequire("dGwqS");

var $lP9EZ = parcelRequire("lP9EZ");

var $cfEFl = parcelRequire("cfEFl");
var $kfImN = parcelRequire("kfImN");

var $91yhh = parcelRequire("91yhh");
const $fe7e2b06857d7b1f$var$ERROR_MESSAGE = 'Jira search client has not been instantiated. This is most likely because you are missing a JiraSearchClientProvider.';
const $fe7e2b06857d7b1f$var$defaultCollaborationGraphConfig = {
    collaborationGraphUrl: 'gateway/api/collaboration',
    useCollaborationGraphForRecents: false
};
const $fe7e2b06857d7b1f$var$getCollabGraphClientWithConfig = (0, $csnse.default)((config)=>new (0, $cfEFl.CollaborationGraphClient)({
        collaborationGraphUrl: config.collaborationGraphUrl,
        cloudId: config.cloudId,
        isMultiSite: config.isMultiSite,
        sites: config.sites
    }), (0, (/*@__PURE__*/$parcel$interopDefault($aAuSn))));
const $fe7e2b06857d7b1f$export$5b76b773dfc5ee6a = /*#__PURE__*/ (0, $gwFzn.createContext)({});
const $fe7e2b06857d7b1f$var$DEFAULT_SITES = [];
const $fe7e2b06857d7b1f$export$f8102de5af58503c = ({ aggregatorUrl: aggregatorUrl, cloudId: cloudId, isUserAnonymous: isUserAnonymous, collaborationGraphUrl: collaborationGraphUrl, children: children, baseUrl: baseUrl, accountId: accountId, siteUrl: siteUrl = '', recentIssuesSupplier: recentIssuesSupplier, currentUserSupplier: currentUserSupplier, sites: sites = $fe7e2b06857d7b1f$var$DEFAULT_SITES })=>{
    siteUrl = (0, $gwFzn.useMemo)(()=>(0, $kfImN.extractSiteUrl)({
            siteUrl: siteUrl,
            sites: sites
        }), [
        siteUrl,
        sites
    ]);
    const { backendExperiment: backendExperiment } = (0, $91yhh.useExperiments)();
    const searchClient = (0, $gwFzn.useMemo)(()=>new (0, $lP9EZ.JiraSearchClient)({
            siteMasterList: sites,
            url: aggregatorUrl,
            cloudId: cloudId,
            isUserAnonymous: isUserAnonymous,
            recentIssuesSupplier: recentIssuesSupplier,
            siteUrl: siteUrl,
            backendExperiment: backendExperiment
        }), [
        aggregatorUrl,
        cloudId,
        isUserAnonymous,
        recentIssuesSupplier,
        siteUrl,
        sites,
        backendExperiment
    ]);
    const collabGraphClient = $fe7e2b06857d7b1f$var$getCollabGraphClientWithConfig({
        // If no collaborationGraphUrl is passed as a prop, use the fallback (default) URL
        collaborationGraphUrl: collaborationGraphUrl || $fe7e2b06857d7b1f$var$defaultCollaborationGraphConfig.collaborationGraphUrl,
        cloudId: cloudId,
        isMultiSite: sites.length > 1,
        sites: sites
    });
    const currentUserClient = (0, $gwFzn.useMemo)(()=>accountId ? new (0, $dGwqS.JiraCurrentUserClient)({
            accountId: accountId,
            baseUrl: baseUrl,
            currentUserSupplier: currentUserSupplier
        }) : undefined, [
        accountId,
        baseUrl,
        currentUserSupplier
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($fe7e2b06857d7b1f$export$5b76b773dfc5ee6a.Provider, {
        value: {
            searchClient: searchClient,
            collabGraphClient: collabGraphClient,
            currentUserClient: currentUserClient,
            siteUrl: siteUrl,
            cloudId: cloudId,
            sites: sites
        },
        children: children
    });
};
const $fe7e2b06857d7b1f$export$413dca1b70dbb4a7 = (Component)=>{
    return (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)($fe7e2b06857d7b1f$export$5b76b773dfc5ee6a.Consumer, {
            children: ({ searchClient: searchClient, collabGraphClient: collabGraphClient, currentUserClient: currentUserClient, cloudId: cloudId, sites: sites })=>{
                if (!searchClient) throw new Error($fe7e2b06857d7b1f$var$ERROR_MESSAGE);
                const { ...rest } = props;
                return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                    ...rest,
                    searchClient: searchClient,
                    collabGraphClient: collabGraphClient,
                    currentUserClient: currentUserClient,
                    cloudId: cloudId,
                    sites: sites
                });
            }
        });
};
function $fe7e2b06857d7b1f$export$71e1e199804dfd5e() {
    const { searchClient: searchClient, collabGraphClient: collabGraphClient, currentUserClient: currentUserClient, siteUrl: siteUrl, sites: sites, cloudId: cloudId } = (0, $gwFzn.useContext)($fe7e2b06857d7b1f$export$5b76b773dfc5ee6a);
    if (!searchClient) throw new Error($fe7e2b06857d7b1f$var$ERROR_MESSAGE);
    return {
        searchClient: searchClient,
        collabGraphClient: collabGraphClient,
        currentUserClient: currentUserClient,
        siteUrl: siteUrl,
        cloudId: cloudId,
        sites: sites
    };
}

});
parcelRegister("dGwqS", function(module, exports) {

$parcel$export(module.exports, "JiraCurrentUserClient", () => $d81dca87d92d32f6$export$bbcfcc9f52275229);

var $gwFzn = parcelRequire("gwFzn");

var $dwp40 = parcelRequire("dwp40");

var $9Nzn7 = parcelRequire("9Nzn7");

var $3NyIw = parcelRequire("3NyIw");

var $6clwF = parcelRequire("6clwF");
const $d81dca87d92d32f6$var$USER_DATA_URL = '/rest/api/3/user';
class $d81dca87d92d32f6$export$bbcfcc9f52275229 {
    async makeRequest(path) {
        const options = {
            path: path,
            queryParams: {
                accountId: this.accountId,
                expand: 'applicationRoles'
            }
        };
        return (0, $9Nzn7.timed)((0, $dwp40.utils).requestService(this.serviceConfig, options));
    }
    constructor({ accountId: accountId, baseUrl: baseUrl, currentUserSupplier: currentUserSupplier }){
        this.serviceConfig = void 0;
        this.currentUserCache = void 0;
        this.accountId = void 0;
        this.getCurrentUser = ()=>this.currentUserCache.get().value;
        this.getUserSupplier = async ()=>{
            const { result: result, durationMs: durationMs } = await this.makeRequest($d81dca87d92d32f6$var$USER_DATA_URL);
            return {
                ...result,
                timings: durationMs
            };
        };
        this.serviceConfig = {
            url: baseUrl
        };
        this.accountId = accountId;
        this.currentUserCache = new (0, $3NyIw.SimpleCache)(currentUserSupplier || this.getUserSupplier);
    }
}
const $d81dca87d92d32f6$export$2393d475b44b8a57 = (user = {})=>{
    const [loadingComplete, setLoadingComplete] = (0, $gwFzn.useState)(false);
    const [currentUser, setCurrentUser] = (0, $gwFzn.useState)(user);
    const { currentUserClient: currentUserClient } = (0, $6clwF.useJiraSearchClientContext)();
    (0, $gwFzn.useEffect)(()=>{
        if (!loadingComplete) {
            let shouldUpdate = true;
            currentUserClient?.getCurrentUser().then((result)=>{
                if (shouldUpdate && !loadingComplete) {
                    setCurrentUser({
                        id: result.accountId,
                        name: result.displayName,
                        avatarUrl: result.avatarUrls['24x24'],
                        email: result.emailAddress,
                        hasSoftwareAccess: result.applicationRoles.items.some((item)=>item.key === 'jira-software')
                    });
                    setLoadingComplete(true);
                }
            }).catch(()=>{}); // swallow any errors
            return ()=>{
                shouldUpdate = false;
            };
        }
    }, [
        currentUserClient,
        loadingComplete
    ]);
    return currentUser;
};

});

parcelRegister("lP9EZ", function(module, exports) {

$parcel$export(module.exports, "JiraSearchClient", () => $4194cf53882a191e$export$824e4d5b28750c3f);
$parcel$export(module.exports, "attributeTypeToContentType", () => $4194cf53882a191e$export$1436a8642ffb43cf);

var $czt8s = parcelRequire("czt8s");

var $12cJV = parcelRequire("12cJV");
var $c3kEC = parcelRequire("c3kEC");

var $8WxPE = parcelRequire("8WxPE");

var $3NyIw = parcelRequire("3NyIw");

var $8hr1g = parcelRequire("8hr1g");

var $fC7SC = parcelRequire("fC7SC");

var $kfImN = parcelRequire("kfImN");
const $4194cf53882a191e$var$RECENT_PLANS_SOFT_LIMIT = 2;
const $4194cf53882a191e$var$NAVIGATION_V3_EXPERIENCE = 'jira.nav-v3';
class $4194cf53882a191e$export$824e4d5b28750c3f {
    getRecent(cache, context, sites) {
        const { fromCache: fromCache, value: value } = cache.get(context, (0, $kfImN.limitToMaxSiteUsage)(sites));
        return (0, $czt8s.CancellablePromise).from(value.then((results)=>({
                ...results,
                isCached: fromCache
            })));
    }
    getRecentBoardsProjectsFiltersPlansInterleaved(context, sites) {
        const { fromCache: boardsProjectsFiltersFromCache, value: boardsProjectsFiltersValue } = this.recentBoardsProjectsFiltersCache.get(context, sites);
        const { fromCache: plansFromCache, value: plansValue } = this.recentPlansCache.get(context, sites);
        return (0, $czt8s.CancellablePromise).from(Promise.all([
            boardsProjectsFiltersValue,
            plansValue
        ]).then((results)=>({
                ...this.interleaveRecentBoardsProjectsFiltersPlans(results[0], results[1]),
                isCached: plansFromCache && boardsProjectsFiltersFromCache
            })));
    }
    getRecentIssues(context, sites) {
        return this.getRecent(this.recentIssuesCache, context, sites);
    }
    getRecentPlans(context, sites) {
        return this.getRecent(this.recentPlansCache, context, sites);
    }
    getRecentProjects(context, sites) {
        return this.getRecent(this.recentProjectsCache, context, sites);
    }
    getRecentBoardsProjectsFilters(context, sites) {
        return this.getRecent(this.recentBoardsProjectsFiltersCache, context, sites);
    }
    getRecentBoardsProjectsFiltersPlans(context, sites) {
        return this.getRecentBoardsProjectsFiltersPlansInterleaved(context, sites);
    }
    /**
   * Check the user permissions for the given list of products.
   */ async getProductPermissions(products) {
        if (!this.permissionsDataCache) this.permissionsDataCache = await this.aggregatorClient.getProductPermissions(products, $4194cf53882a191e$var$NAVIGATION_V3_EXPERIENCE);
        return this.permissionsDataCache;
    }
    async getAbTestData() {
        if (this.abTestDataCache) return this.abTestDataCache;
        const abTest = await this.aggregatorClient.getAbTestData((0, $8WxPE.Scope).JiraIssue, $4194cf53882a191e$var$NAVIGATION_V3_EXPERIENCE);
        this.abTestDataCache = abTest;
        return abTest;
    }
    getRecentPeople(context, sites) {
        return this.getRecent(this.recentPeopleCache, context, sites);
    }
    searchPeople(query, context, sites) {
        return (0, $czt8s.CancellablePromise).from(this.searchForPeopleScope(query, context, false, sites));
    }
    searchForPeopleScope(query, context, isForRecentResults, sites, queryVersion) {
        if (this.isUserAnonymous) return Promise.resolve({
            items: [],
            timings: 0,
            totalSize: 0
        });
        const results = this.searchForScope(query, [], context, [
            (0, $8WxPE.Scope).People
        ], $4194cf53882a191e$export$824e4d5b28750c3f.PEOPLE_RESULT_LIMIT, isForRecentResults, sites, queryVersion)[(0, $8WxPE.Scope).People];
        if (!results) throw new Error(`Failed to retrieve results for scope ${(0, $8WxPE.Scope).People}`);
        return results.promise();
    }
    searchProjects(query, context, sites) {
        const results = this.searchForScope(query, [], context, [
            (0, $8WxPE.Scope).JiraProject
        ], $4194cf53882a191e$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT, false, sites)[(0, $8WxPE.Scope).JiraProject];
        if (!results) throw new Error(`Failed to retrieve results for scope ${(0, $8WxPE.Scope).JiraProject}`);
        return results;
    }
    constructor(config){
        this.abTestDataCache = null;
        this.permissionsDataCache = null;
        this.aggregatorClient = void 0;
        this.recentIssuesCache = void 0;
        this.recentPeopleCache = void 0;
        this.recentBoardsProjectsFiltersCache = void 0;
        this.recentPlansCache = void 0;
        this.recentProjectsCache = void 0;
        this.isUserAnonymous = void 0;
        this.recentIssuesSupplier = async (context, sites)=>{
            const results = this.searchForScope('', [], context, [
                (0, $8WxPE.Scope).JiraIssue
            ], $4194cf53882a191e$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT, true, sites)[(0, $8WxPE.Scope).JiraIssue];
            if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, $8WxPE.Scope).JiraIssue}`);
            return results.promise();
        };
        // For recent results, we only want to show up to 2 recent plans as the last 2 results
        // as we cannot accurately interleave  recent plans with recent boards, projects, filter results.
        // However, it is valid to show more than 2 plans in the case where other entity types have been exhausted.
        this.interleaveRecentBoardsProjectsFiltersPlans = (boardProjectFilterResults, planResults)=>{
            const timings = planResults.timings > boardProjectFilterResults.timings ? planResults.timings : boardProjectFilterResults.timings;
            const { items: items } = boardProjectFilterResults;
            if (planResults.items.length >= $4194cf53882a191e$var$RECENT_PLANS_SOFT_LIMIT) while(items.length > $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT - $4194cf53882a191e$var$RECENT_PLANS_SOFT_LIMIT)items.pop();
            else while(items.length > $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT - planResults.items.length)items.pop();
            for(let planCount = 0; items.length < $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT && planResults.items.length > planCount; planCount++)items.push(planResults.items[planCount]);
            return {
                timings: timings,
                items: items,
                totalSize: items.length
            };
        };
        this.search = (query, filters, context, queryVersion, hasAdvancedRoadmapsAccess, sites)=>{
            const issueSearch = this.searchForScope(query, filters, context, [
                (0, $8WxPE.Scope).JiraIssue
            ], $4194cf53882a191e$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT, false, sites, queryVersion);
            const onlyDateFilterEnabled = filters.length === 1 && filters[0]?.type === 'dateFromLastModified';
            const scopes = hasAdvancedRoadmapsAccess ? [
                (0, $8WxPE.Scope).JiraBoardProjectFilterPlan
            ] : [
                (0, $8WxPE.Scope).JiraBoardProjectFilter
            ];
            const limit = hasAdvancedRoadmapsAccess ? $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT : $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_LIMIT;
            const jiraBoardProjectFilterSearch = filters.length === 0 || onlyDateFilterEnabled ? this.searchForScope(query, filters, context, scopes, limit, false, sites, queryVersion) : {};
            return {
                ...issueSearch,
                ...jiraBoardProjectFilterSearch
            };
        };
        this.searchForScope = (query, filters, context, scopes, resultLimit, isForRecentResults, sites = [], queryVersion)=>{
            const modelParams = queryVersion || queryVersion === 0 ? [
                {
                    '@type': 'queryParams',
                    queryVersion: queryVersion
                }
            ] : [];
            const allFilters = [];
            let baseProjectFilters = null;
            let baseAssigneeFilters = null;
            let baseBinaryStatusCategoryFilters = null;
            let lastModifiedFilter = {
                '@type': 'lastModified'
            };
            let lastViewedFilter = {
                '@type': 'lastViewed'
            };
            filters.forEach((filter)=>{
                switch(filter.type){
                    case 'project':
                        if (!baseProjectFilters) {
                            baseProjectFilters = {
                                '@type': 'projects',
                                projectIds: []
                            };
                            allFilters.push(baseProjectFilters);
                        }
                        baseProjectFilters.projectIds.push(filter.id);
                        break;
                    case 'assignee':
                        if (!baseAssigneeFilters) {
                            baseAssigneeFilters = {
                                '@type': 'assignees',
                                accountIds: []
                            };
                            allFilters.push(baseAssigneeFilters);
                        }
                        baseAssigneeFilters.accountIds.push(filter.id);
                        break;
                    case 'binary_status_category':
                        if (!baseBinaryStatusCategoryFilters) {
                            baseBinaryStatusCategoryFilters = {
                                '@type': 'binary_status_categories',
                                binaryStatusCategories: []
                            };
                            allFilters.push(baseBinaryStatusCategoryFilters);
                        }
                        baseBinaryStatusCategoryFilters.binaryStatusCategories.push(filter.id);
                        break;
                    case 'dateFromLastModified':
                        filter.id && (lastModifiedFilter.from = filter.id);
                        break;
                    case 'dateFromLastViewed':
                        filter.id && (lastViewedFilter.from = filter.id);
                        break;
                    case 'dateToLastModified':
                        filter.id && (lastModifiedFilter.to = filter.id);
                        break;
                    default:
                        break;
                }
            });
            if (lastModifiedFilter.from || lastModifiedFilter.to) allFilters.push(lastModifiedFilter);
            if (lastViewedFilter.from) allFilters.push(lastViewedFilter);
            const responses = this.aggregatorClient.search({
                query: query,
                context: context,
                scopes: scopes,
                modelParams: modelParams,
                resultLimit: resultLimit,
                filters: allFilters,
                experience: $4194cf53882a191e$var$NAVIGATION_V3_EXPERIENCE,
                sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
            });
            return scopes.reduce((results, currentScope)=>({
                    ...results,
                    [currentScope]: (0, $czt8s.CancellablePromise).from(responses.then(({ response: response, requestDurationMs: requestDurationMs })=>{
                        const scopedResponse = response.retrieveScope(currentScope);
                        if (!scopedResponse) throw new Error(`Expected a response but did not get any for scope: ${currentScope}`);
                        if (scopedResponse.error) throw (0, $c3kEC.responseErrorToError)(scopedResponse.error);
                        if (currentScope === (0, $8WxPE.Scope).JiraIssue) return (0, $fC7SC.transformJiraIssueScope)(scopedResponse, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $8WxPE.Scope).JiraPlan) return (0, $fC7SC.transformJiraPlanScope)(scopedResponse.results, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $8WxPE.Scope).JiraBoardProjectFilter) return (0, $fC7SC.transformJiraBoardProjectFilterScope)(scopedResponse.results, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $8WxPE.Scope).JiraBoardProjectFilterPlan) return (0, $fC7SC.transformJiraBoardProjectFilterScope)(scopedResponse.results, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $8WxPE.Scope).JiraProject) return (0, $fC7SC.transformJiraProjectScope)(scopedResponse.results, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $8WxPE.Scope).People) return (0, $fC7SC.transformUrsPeople)(scopedResponse.results, isForRecentResults, requestDurationMs, sites.length > 0);
                    }))
                }), {});
        };
        const { recentIssuesSupplier: recentIssuesSupplier = null } = config;
        this.aggregatorClient = new (0, $12cJV.AggregatorClient)(config);
        this.recentPeopleCache = new (0, $3NyIw.SimpleCache)((context, sites)=>this.searchForPeopleScope('', context, true, sites));
        this.recentIssuesCache = recentIssuesSupplier ? new (0, $3NyIw.SimpleCache)((ignored)=>recentIssuesSupplier()) : new (0, $3NyIw.SimpleCache)(this.recentIssuesSupplier);
        this.recentBoardsProjectsFiltersCache = new (0, $3NyIw.SimpleCache)(async (context, sites)=>{
            const results = this.searchForScope('', [], context, [
                (0, $8WxPE.Scope).JiraBoardProjectFilter
            ], $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT, true, sites)[(0, $8WxPE.Scope).JiraBoardProjectFilter];
            if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, $8WxPE.Scope).JiraBoardProjectFilter}`);
            return results.promise();
        });
        this.recentPlansCache = new (0, $3NyIw.SimpleCache)(async (context, sites)=>{
            const results = this.searchForScope('', [], context, [
                (0, $8WxPE.Scope).JiraPlan
            ], $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT, true, sites)[(0, $8WxPE.Scope).JiraPlan];
            if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, $8WxPE.Scope).JiraPlan}`);
            return results.promise();
        });
        this.recentProjectsCache = new (0, $3NyIw.SimpleCache)(async (context, sites)=>{
            const results = this.searchForScope('', [], context, [
                (0, $8WxPE.Scope).JiraProject
            ], $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_RESULT_LIMIT, true, sites)[(0, $8WxPE.Scope).JiraProject];
            if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, $8WxPE.Scope).JiraProject}`);
            return results.promise();
        });
        this.isUserAnonymous = config.isUserAnonymous;
    }
}
$4194cf53882a191e$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT = 50;
$4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_LIMIT = 6;
$4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT = 8;
$4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_RESULT_LIMIT = 10;
$4194cf53882a191e$export$824e4d5b28750c3f.PEOPLE_RESULT_LIMIT = 10;
function $4194cf53882a191e$export$1436a8642ffb43cf(attributeType) {
    switch(attributeType){
        case (0, $8WxPE.AttributeType).issue:
            return (0, $8WxPE.ContentType).JiraIssue;
        case (0, $8WxPE.AttributeType).project:
            return (0, $8WxPE.ContentType).JiraProject;
        case (0, $8WxPE.AttributeType).board:
            return (0, $8WxPE.ContentType).JiraBoard;
        case (0, $8WxPE.AttributeType).filter:
            return (0, $8WxPE.ContentType).JiraFilter;
        case (0, $8WxPE.AttributeType).plan:
            return (0, $8WxPE.ContentType).JiraPlan;
        case (0, $8WxPE.AttributeType).people:
            return (0, $8WxPE.ContentType).JiraPeople;
        default:
            throw new (0, $8hr1g.UnreachableError)(attributeType);
    }
}

});
parcelRegister("8WxPE", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $068ba82a94015a1a$export$775b6bb06e53a214);
$parcel$export(module.exports, "ContentType", () => $068ba82a94015a1a$export$e2e108cbe2e4f865);
$parcel$export(module.exports, "AttributeType", () => $068ba82a94015a1a$export$d31c6c64cddbeeac);
var $068ba82a94015a1a$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $068ba82a94015a1a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $068ba82a94015a1a$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $068ba82a94015a1a$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $068ba82a94015a1a$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});

});

parcelRegister("8hr1g", function(module, exports) {

$parcel$export(module.exports, "UnreachableError", () => $abe2b3690446e017$export$676c8946b241bf4b);
class $abe2b3690446e017$export$676c8946b241bf4b extends Error {
    constructor(v){
        super(`Unreachable code was reachable, value: ${v}`);
    }
}

});

parcelRegister("fC7SC", function(module, exports) {

$parcel$export(module.exports, "transformJiraIssueScope", () => $074c4d4296761b1e$export$ed218c5a500295c6);
$parcel$export(module.exports, "transformJiraPlanScope", () => $074c4d4296761b1e$export$3327c57623badb76);
$parcel$export(module.exports, "transformJiraBoardProjectFilterScope", () => $074c4d4296761b1e$export$313c00d1fd0198a9);
$parcel$export(module.exports, "transformJiraProjectScope", () => $074c4d4296761b1e$export$61106bcfd557994b);
$parcel$export(module.exports, "transformUrsPeople", () => $074c4d4296761b1e$export$ca9c7208f3fa3596);

var $8WxPE = parcelRequire("8WxPE");

var $lP9EZ = parcelRequire("lP9EZ");

var $jV49M = parcelRequire("jV49M");

var $kfImN = parcelRequire("kfImN");
function $074c4d4296761b1e$export$ed218c5a500295c6(response, isCached, timings) {
    const { results: results, size: size } = response;
    return {
        items: results.filter((item)=>item.attributes['@type'] === (0, $8WxPE.AttributeType).issue).map((item)=>{
            return {
                resultId: item.id,
                name: item.name,
                href: item.url,
                contentType: (0, $8WxPE.ContentType).JiraIssue,
                attributes: {
                    ...item.attributes,
                    isRecentResult: isCached
                },
                isCached: isCached
            };
        }),
        timings: timings,
        totalSize: size || results.length
    };
}
function $074c4d4296761b1e$export$3327c57623badb76(results, isCached, timings) {
    return {
        items: results.map((item)=>{
            return {
                resultId: item.id,
                name: item.name,
                href: item.url,
                contentType: (0, $8WxPE.ContentType).JiraPlan,
                attributes: item.attributes,
                isCached: isCached
            };
        }),
        timings: timings,
        totalSize: results.length
    };
}
function $074c4d4296761b1e$export$313c00d1fd0198a9(results, isCached, timings) {
    return {
        items: results.filter((item)=>[
                (0, $8WxPE.AttributeType).board,
                (0, $8WxPE.AttributeType).project,
                (0, $8WxPE.AttributeType).filter,
                (0, $8WxPE.AttributeType).plan
            ].includes(item.attributes['@type'])).map((item)=>{
            const contentType = (0, $lP9EZ.attributeTypeToContentType)(item.attributes['@type']);
            return {
                resultId: item.id,
                name: item.name,
                href: item.url,
                contentType: contentType,
                attributes: item.attributes,
                isCached: isCached
            };
        }),
        timings: timings,
        totalSize: results.length
    };
}
function $074c4d4296761b1e$export$61106bcfd557994b(results, isCached, timings) {
    return {
        items: results.map((item)=>{
            return {
                resultId: item.id,
                name: item.name,
                href: item.url,
                contentType: (0, $8WxPE.ContentType).JiraProject,
                attributes: item.attributes,
                isCached: isCached
            };
        }),
        timings: timings,
        totalSize: results.length
    };
}
function $074c4d4296761b1e$export$ca9c7208f3fa3596(results, isCached, timings, isMultiSite) {
    return {
        items: (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))(results, (item)=>item.id).map((item)=>({
                resultId: item.id,
                name: item.name,
                href: (0, $kfImN.generatePeopleProfileUrl)(isMultiSite, item.absoluteUrl, item.id, 'jira'),
                contentType: (0, $8WxPE.ContentType).JiraPeople,
                attributes: {
                    '@type': (0, $8WxPE.AttributeType).people,
                    avatarUrl: item.avatarUrl,
                    userId: item.id
                },
                isCached: isCached
            })),
        timings: timings,
        totalSize: results.length
    };
}

});




parcelRegister("cuRlJ", function(module, exports) {

$parcel$export(module.exports, "getResultLinkComponent", () => $42ea84ce17f63a94$export$7298e35d46e5a43);

var $gwFzn = parcelRequire("gwFzn");

var $cPER9 = parcelRequire("cPER9");

var $8lYIw = parcelRequire("8lYIw");
const $42ea84ce17f63a94$var$isNewTabClick = (e)=>e && (e.metaKey || e.shiftKey || e.ctrlKey);
const $42ea84ce17f63a94$export$7298e35d46e5a43 = (closeDrawer)=>{
    class ResultLinkComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
        render() {
            const { children: children, href: href, target: target, className: className } = this.props;
            const LinkComponent = this.getLinkComponent(href);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(LinkComponent, {
                href: href,
                onClick: this.handleClick,
                target: target,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className
            }, children);
        }
        constructor(...args){
            super(...args);
            this.handleClick = (event)=>{
                if (closeDrawer && !$42ea84ce17f63a94$var$isNewTabClick(event)) closeDrawer();
            };
            this.getLinkComponent = (href)=>href && href.startsWith('/people/') ? (0, $cPER9.PeopleLink) : (0, $8lYIw.Link);
        }
    }
    return ResultLinkComponent;
};

});

parcelRegister("2Fqwa", function(module, exports) {

$parcel$export(module.exports, "UserContext", () => $8294bb1f8dce0d1c$export$38ee920e59704589);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $gHANe = parcelRequire("gHANe");
const $8294bb1f8dce0d1c$export$38ee920e59704589 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.Query), {
        query: (0, $gHANe.UserContextQuery)
    }, ({ data: rawData, loading: loading })=>{
        const displayName = (rawData && rawData.user && rawData.user.displayName) ?? undefined;
        const id = (rawData && rawData.user && rawData.user.id) ?? undefined;
        const emails = rawData && rawData.user && rawData.user.emails || [];
        const email = emails.filter((email)=>email?.isPrimary).map((email)=>email?.value).find(Boolean) ?? undefined;
        return children({
            isLoading: loading,
            data: {
                email: email,
                id: id,
                name: displayName
            }
        });
    });

});

parcelRegister("f4L2T", function(module, exports) {

$parcel$export(module.exports, "CurrentSpaceContext", () => $844c79f4d45e1a83$export$109846573338f1b2);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $dqunX = parcelRequire("dqunX");
const $844c79f4d45e1a83$export$109846573338f1b2 = ({ children: children, spaceKey: spaceKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.Query), {
        query: (0, $dqunX.CurrentSpaceQuery),
        variables: {
            spaceKey: spaceKey
        }
    }, ({ data: data, loading: loading })=>{
        const id = data?.space?.id;
        const spaceName = data?.space?.name;
        const iconUrl = data?.space?.icon?.path;
        const currentSpace = id && spaceName && iconUrl ? {
            id: id,
            spaceName: spaceName,
            spaceKey: spaceKey,
            iconUrl: iconUrl
        } : undefined;
        return children({
            loading: loading,
            currentSpace: currentSpace
        });
    });

});
parcelRegister("dqunX", function(module, exports) {

$parcel$export(module.exports, "CurrentSpaceQuery", () => $f677b35d623dd038$export$6cba1f4a018a0482);

var $d2LG0 = parcelRequire("d2LG0");
const $f677b35d623dd038$export$6cba1f4a018a0482 = (0, $d2LG0.default)`query CurrentSpaceQuery($spaceKey:String){space(key:$spaceKey){id name icon{path(type:ABSOLUTE)}}}`;

});


parcelRegister("escKD", function(module, exports) {

$parcel$export(module.exports, "QuickFindNav3", () => $9d71cfad51bcb6ee$export$d916d15625b46dc9);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $4jplB = parcelRequire("4jplB");
const $9d71cfad51bcb6ee$export$d916d15625b46dc9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        testId: "quick-find-container",
        xcss: $9d71cfad51bcb6ee$var$searchBarWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $9d71cfad51bcb6ee$var$searchBarContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jplB.QuickFind), null)));
const $9d71cfad51bcb6ee$var$searchBarWrapper = (0, $ecnYn.xcss)({
    position: 'relative',
    width: '200px',
    height: "var(--ds-space-500, 40px)"
});
const $9d71cfad51bcb6ee$var$searchBarContainer = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    bottom: 'space.0',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    zIndex: 'dialog'
});

});
parcelRegister("4jplB", function(module, exports) {

$parcel$export(module.exports, "generateSearchUrl", () => $5235a3f27f080bad$export$8233bb098a93ad26);
$parcel$export(module.exports, "QuickFind", () => $5235a3f27f080bad$export$7d842d92e2721710);

var $gwFzn = parcelRequire("gwFzn");

var $hKLPv = parcelRequire("hKLPv");

var $dEBDF = parcelRequire("dEBDF");

var $bQm3c = parcelRequire("bQm3c");

var $gz8ZY = parcelRequire("gz8ZY");

var $dPJCf = parcelRequire("dPJCf");

var $9wGTI = parcelRequire("9wGTI");

var $ljm2R = parcelRequire("ljm2R");

var $efvKr = parcelRequire("efvKr");

var $de2j9 = parcelRequire("de2j9");

var $e4o8D = parcelRequire("e4o8D");

var $4VJDS = parcelRequire("4VJDS");
const $5235a3f27f080bad$var$generateUserUrl = (userId)=>`/wiki/people/${userId}`;
const $5235a3f27f080bad$var$generateTeamUrl = (teamId)=>`/wiki/people/team/${teamId}`;
const $5235a3f27f080bad$var$useTextParameter = (0, $dPJCf.createSingleQueryParamHook)('text');
const $5235a3f27f080bad$export$8233bb098a93ad26 = (urlQueryParams)=>{
    const url = new URL('/wiki/search', window.location.origin);
    const searchParams = new URLSearchParams(window.location.search);
    if (window.location.pathname !== '/wiki/search' && (0, $9wGTI.fg)('rovo_search_qf_to_product_filtered_fps')) searchParams.set('product', 'confluence');
    Object.entries(urlQueryParams).forEach(([key, value])=>{
        if (value !== undefined && value !== null) searchParams.set(key, String(value));
    });
    url.search = searchParams.toString();
    return url.href;
};
const $5235a3f27f080bad$export$7d842d92e2721710 = ()=>{
    const [open, setOpen] = (0, $gwFzn.useState)(false);
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { cloudId: cloudId, orgId: orgId, activationId: activationId, isAdminHubAIEnabled: isAdminHubAIEnabled, userId: userId, displayName: displayName, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const textParameter = $5235a3f27f080bad$var$useTextParameter();
    const queryParams = (0, $gwFzn.useMemo)(()=>({
            text: textParameter
        }), [
        textParameter
    ]);
    const analyticsAttributes = (0, $gwFzn.useMemo)(()=>({
            activationId: activationId,
            navdexPointType: (0, $dEBDF.TOUCH)
        }), [
        activationId
    ]);
    const user = (0, $gwFzn.useMemo)(()=>({
            id: userId,
            name: displayName
        }), [
        userId,
        displayName
    ]);
    const experimentLayers = (0, $4VJDS.default).getStringList('search_platform_layer_functions', []);
    const onNavigate = (0, $gwFzn.useCallback)((url)=>push(url), [
        push
    ]);
    const universalNavigationShortcut = (0, $ljm2R.isMac)() ? (0, $ljm2R.UNIVERSAL_NAVIGATION_SHORTCUT_MAC) : (0, $ljm2R.UNIVERSAL_NAVIGATION_SHORTCUT_WIN);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hKLPv.QuickFind), {
        cloudId: cloudId,
        orgId: orgId,
        primaryProduct: "confluence",
        analyticsAttributes: analyticsAttributes,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        isNav4Enabled: isNav4Enabled,
        onNavigate: onNavigate,
        queryParams: queryParams,
        open: open,
        setOpen: setOpen,
        user: user,
        generateSearchUrl: $5235a3f27f080bad$export$8233bb098a93ad26,
        generateUserUrl: $5235a3f27f080bad$var$generateUserUrl,
        generateTeamUrl: $5235a3f27f080bad$var$generateTeamUrl,
        experimentLayers: experimentLayers,
        isRovoLLMEnabled: isRovoLLMEnabled,
        isSSR: renderServerPlaceholder
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $ljm2R.NAVIGATION_SHORTCUT) : undefined,
        accelerator: isLiveEditMode || isOnEditRoute ? universalNavigationShortcut : [
            universalNavigationShortcut,
            (0, $ljm2R.NAVIGATION_SLASH_SHORTCUT)
        ],
        listener: ()=>setOpen(true),
        isAppNavigationShortcut: true
    }));
};

});
parcelRegister("hKLPv", function(module, exports) {

$parcel$export(module.exports, "QuickFind", () => $c8b08557d75a416b$export$7d842d92e2721710);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dpPtd = parcelRequire("dpPtd");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $hnvzE = parcelRequire("hnvzE");

var $icqFF = parcelRequire("icqFF");

var $4OGlb = parcelRequire("4OGlb");

var $7WbA8 = parcelRequire("7WbA8");

var $2ok43 = parcelRequire("2ok43");

var $86ob4 = parcelRequire("86ob4");

var $1XDdH = parcelRequire("1XDdH");

var $l1k3Q = parcelRequire("l1k3Q");

var $2tzUc = parcelRequire("2tzUc");

var $4VmlX = parcelRequire("4VmlX");

var $is3gE = parcelRequire("is3gE");

var $bHLTK = parcelRequire("bHLTK");

var $h9lDJ = parcelRequire("h9lDJ");

var $f8Fnp = parcelRequire("f8Fnp");

var $jQSTy = parcelRequire("jQSTy");
var $j5QtW = parcelRequire("j5QtW");
var $57tKZ = parcelRequire("57tKZ");
const $c8b08557d75a416b$var$textFieldBoxStyles = (0, $ecnYn.xcss)({
    width: '100%',
    position: 'relative'
});
const $c8b08557d75a416b$var$QuickFindComponent = ({ open: open, setOpen: setOpen, postQueryDisabled: postQueryDisabled, textfieldComponent: textfieldComponent, isSSR: isSSR })=>{
    const inputBoxRef = (0, $gwFzn.useRef)(null);
    const dialogRef = (0, $gwFzn.useRef)(null);
    const inputRef = (0, $gwFzn.useRef)(null);
    const [localQuery, setLocalQuery] = (0, $gwFzn.useState)((0, $2ok43.getInitialQuery));
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const dialogId = (0, $gwFzn.useId)();
    (0, $57tKZ.useSyncStates)(quickFindOpen, setQuickFindOpen, open, setOpen);
    (0, $jQSTy.useCloseManager)({
        dialogRef: dialogRef,
        inputBoxRef: inputBoxRef
    });
    (0, $j5QtW.usePreQueryDwellTimeAnalytics)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $l1k3Q.QuickFindResults), {}),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $c8b08557d75a416b$var$textFieldBoxStyles,
                ref: inputBoxRef,
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $icqFF.KeyboardHighlightProvider), {
                    listenerNode: inputRef?.current,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f8Fnp.SearchTextField), {
                            dialogId: dialogId,
                            inputRef: inputRef,
                            localQuery: localQuery,
                            setLocalQuery: setLocalQuery,
                            textfieldComponent: textfieldComponent,
                            postQueryDisabled: postQueryDisabled
                        }),
                        !isSSR && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dpPtd.FlagsProvider), {
                            children: quickFindOpen && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $86ob4.WidthObserverProvider), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h9lDJ.SearchDialog), {
                                    dialogId: dialogId,
                                    dialogRef: dialogRef,
                                    inputRef: inputRef,
                                    localQuery: localQuery,
                                    setLocalQuery: setLocalQuery
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $c8b08557d75a416b$export$68bbc91d7879f9e4 = ({ children: children, queryParams: actualQueryParams, ...props })=>{
    /**
	 * Quick Find does not need to set queryParams, hence using an object
	 * in a state variable as the queryParams object. Any interactions with
	 * the url should be done through onNavigate in the AppContext.
	 */ const [queryParams, setQueryParams] = (0, $gwFzn.useState)({
        text: actualQueryParams?.text
    });
    /**
	 * Quick Find only reacts to changes in the text query parameter when the
	 * user is on the search page.
	 */ const previousTextQueryParam = (0, $gwFzn.useRef)(actualQueryParams?.text);
    (0, $gwFzn.useEffect)(()=>{
        if (actualQueryParams?.text === previousTextQueryParam.current) return;
        let onSearchRoute = true; // Default to true in case URL parsing fails
        try {
            const generateSearchUrl = props.generateSearchUrl || (0, $1XDdH.defaultGenerateSearchUrl);
            const searchUrl = new URL(generateSearchUrl({}));
            const searchPath = searchUrl.pathname;
            const currentUrl = new URL(window.location.href);
            const currentPath = currentUrl.pathname;
            onSearchRoute = searchPath === currentPath;
        } catch (e) {
        // ignore error
        }
        if (onSearchRoute) setQueryParams((previousQueryParams)=>({
                ...previousQueryParams,
                text: actualQueryParams?.text
            }));
        previousTextQueryParam.current = actualQueryParams?.text;
    }, [
        actualQueryParams?.text,
        props.generateSearchUrl
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2tzUc.BootstrapStoreProvider), {
        ...props,
        queryParams: queryParams,
        callbacks: {
            updateQueryParameters: setQueryParams
        },
        statsigLayer: (0, $4OGlb.STATSIG_QUICK_FIND_LAYER),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bHLTK.SearchStoreProvider), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $is3gE.QuickFindStoreProvider), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7WbA8.AppContextProvider), {
                    ...props,
                    queryParams: queryParams,
                    children: children
                })
            })
        })
    });
};
const $c8b08557d75a416b$export$7d842d92e2721710 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hnvzE.default), {
        name: "quick-find",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($c8b08557d75a416b$export$68bbc91d7879f9e4, {
            ...props,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($c8b08557d75a416b$var$QuickFindComponent, {
                ...props
            })
        })
    });
};

});
parcelRegister("icqFF", function(module, exports) {

$parcel$export(module.exports, "useKeyboardNavigation", () => $ae3c6a4bb713dccb$export$4da28cf324280418);
$parcel$export(module.exports, "KeyboardHighlightProvider", () => $ae3c6a4bb713dccb$export$c8551b32665b42b);
$parcel$export(module.exports, "useKeyboardHighlightProvider", () => $ae3c6a4bb713dccb$export$cbeda0f7f7a8026c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $ae3c6a4bb713dccb$export$ef7af5d8bc5d5ac1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    registerKeyboardEnabled: undefined,
    unregisterKeyboardEnabled: undefined,
    getSelectedIndex: undefined,
    highlightComponentAt: undefined,
    unhighlightComponentAt: undefined,
    unhighlightAll: undefined,
    keyboardNavComponents: []
});
const $ae3c6a4bb713dccb$export$4da28cf324280418 = (options)=>{
    const [ref, setRef] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(null);
    const registrationId = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(null);
    const navigationTrackingId = options?.navigationTrackingId ?? null;
    const { registerKeyboardEnabled: registerKeyboardEnabled, unregisterKeyboardEnabled: unregisterKeyboardEnabled } = (0, $gwFzn.useContext)($ae3c6a4bb713dccb$export$ef7af5d8bc5d5ac1);
    const [isHighlighted, setIsHighlighted] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(false);
    const onKeydownCallback = options?.onKeydownCallback;
    const onHighlightedCallback = options?.onHighlightedCallback;
    const unregister = (0, $gwFzn.useCallback)(()=>{
        if (registrationId.current && unregisterKeyboardEnabled) // If the ref got removed or changed we unregister the current ref
        unregisterKeyboardEnabled(registrationId.current);
    }, [
        unregisterKeyboardEnabled
    ]);
    // Will unmount effect
    (0, $gwFzn.useEffect)(()=>()=>unregister(), [
        unregister
    ]);
    // Ref change to null
    (0, $gwFzn.useEffect)(()=>{
        !ref && unregister();
    }, [
        ref,
        unregister
    ]);
    // Everything else
    (0, $gwFzn.useEffect)(()=>{
        if (!registerKeyboardEnabled || !unregisterKeyboardEnabled) return;
        if (!ref) return;
        // Then we register the new ref
        if (ref) {
            // Another check here to ensure that the ref we get is actually a DOM node, there's probably better
            // ways to make this check but it doesn't matter too much.
            // If what we get is NOT a DOM node we will log a warning and default back to use React.findDOMNode
            if (!ref.compareDocumentPosition || !ref.addEventListener || !ref.removeEventListener) {
                // eslint-disable-next-line
                console.error('It is expected that any keyboard highlighting enabled component also passes the ref all the way to the DOM node.', 'It appears that the `ref` is not fowarded all the way to the DOM node, please use `React.forwardRef to ensure this is so`', 'Falling back to using ReactDOM.findDOMNode, this is not recommended and this fallback may be removed in the future');
                return;
            }
            registrationId.current = registerKeyboardEnabled(registrationId.current, ref, setIsHighlighted, onKeydownCallback, navigationTrackingId, onHighlightedCallback);
        }
    }, [
        ref,
        setIsHighlighted,
        onKeydownCallback,
        registerKeyboardEnabled,
        unregisterKeyboardEnabled,
        navigationTrackingId,
        onHighlightedCallback
    ]);
    return [
        isHighlighted,
        setRef
    ];
};
class $ae3c6a4bb713dccb$export$c8551b32665b42b extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidMount() {
        this.attach(this.props.listenerNode);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.listenerNode !== this.props.listenerNode) {
            this.detach(prevProps.listenerNode);
            this.attach(this.props.listenerNode);
        }
    }
    componentWillUnmount() {
        this.detach(this.props.listenerNode);
    }
    render() {
        return /*#__PURE__*/ (0, $7UHDa.jsx)($ae3c6a4bb713dccb$export$ef7af5d8bc5d5ac1.Provider, {
            value: {
                registerKeyboardEnabled: this.registerKeyboardEnabled,
                unregisterKeyboardEnabled: this.unregisterKeyboardEnabled,
                getSelectedIndex: this.getSelectedIndex,
                highlightComponentAt: this.highlightComponentAt,
                unhighlightComponentAt: this.unhighlightComponentAt,
                unhighlightAll: this.unhighlightAll,
                keyboardNavComponents: this.keyboardNavComponents
            },
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args);
        this.currentlySelected = undefined;
        this.currentSelectedTrackingId = null;
        this.keyboardNavComponents = [];
        this.registerKeyboardEnabled = (currentId, domRef, onHighlightChanged, onKeyDownWhenHighlighted, navigationTrackingId, onHighlightedCallback)=>{
            const indexAt = this.keyboardNavComponents.findIndex(({ id: id })=>id === currentId);
            // If the currentId is null or we can't find any records of the id we will create a new entry
            const isNew = currentId === null || currentId === undefined || indexAt === -1;
            const id = isNew ? Math.max(...this.keyboardNavComponents.map((component)=>component.id), 0) + 1 : this.keyboardNavComponents[indexAt].id;
            if (isNew) this.keyboardNavComponents.push({
                id: id,
                domRef: domRef,
                onHighlightChanged: onHighlightChanged,
                onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
                navigationTrackingId: navigationTrackingId,
                onHighlightedCallback: onHighlightedCallback
            });
            else // Otherwise we will update the current entry
            this.keyboardNavComponents[indexAt] = {
                id: id,
                domRef: domRef,
                onHighlightChanged: onHighlightChanged,
                onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
                navigationTrackingId: navigationTrackingId,
                onHighlightedCallback: onHighlightedCallback
            };
            this.keyboardNavComponents = this.keyboardNavComponents.sort((c1, c2)=>{
                const result = c1.domRef.compareDocumentPosition(c2.domRef);
                if (result & Node.DOCUMENT_POSITION_FOLLOWING || result & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
                else if (result & Node.DOCUMENT_POSITION_PRECEDING || result & Node.DOCUMENT_POSITION_CONTAINS) return 1;
                return 0;
            });
            const indexToHighlight = this.getSearchIdIndex(this.currentSelectedTrackingId);
            if (indexToHighlight !== undefined && indexToHighlight >= 0) {
                this.unhighlightAll();
                this.highlightComponentAt(indexToHighlight);
            }
            this.keyboardNavComponents = [
                ...this.keyboardNavComponents
            ];
            return id;
        };
        this.unregisterKeyboardEnabled = (unregisterRef)=>{
            if (this.currentlySelected === unregisterRef) this.currentlySelected = undefined;
            this.keyboardNavComponents = this.keyboardNavComponents.filter(({ id: ref })=>ref !== unregisterRef);
        };
        this.onKeyDownCallbackAt = (index, e)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) {
                const onKeyDown = this.keyboardNavComponents[index].onKeyDownWhenHighlighted;
                onKeyDown && onKeyDown(e, this.keyboardNavComponents[index].domRef);
            }
        };
        this.onHighlightedCallback = (index)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) {
                const callback = this.keyboardNavComponents[index].onHighlightedCallback;
                callback && callback(index);
            }
        };
        this.unhighlightComponentAt = (index)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) this.keyboardNavComponents[index].onHighlightChanged(false);
        };
        this.highlightComponentAt = (index)=>{
            if (index >= 0 && index < this.keyboardNavComponents.length) {
                const { id: id, navigationTrackingId: navigationTrackingId } = this.keyboardNavComponents[index];
                this.currentlySelected = id;
                this.currentSelectedTrackingId = navigationTrackingId;
                this.keyboardNavComponents[index].onHighlightChanged(true);
            }
        };
        this.unhighlightAll = ()=>{
            this.currentSelectedTrackingId = null;
            this.currentlySelected = undefined;
            this.keyboardNavComponents.forEach((component)=>component.onHighlightChanged(false));
        };
        this.getSelectedIndex = ()=>{
            if (!this.currentlySelected) return undefined;
            return this.keyboardNavComponents.findIndex(({ id: id })=>id === this.currentlySelected);
        };
        this.getSearchIdIndex = (searchId)=>searchId === null ? undefined : this.keyboardNavComponents.findIndex(({ navigationTrackingId: navigationTrackingId })=>navigationTrackingId === searchId);
        this.onKeyDown = (e)=>{
            if (this.keyboardNavComponents.length === 0) return;
            if (e.isComposing || e.keyCode === 229) return;
            let currentIndex = this.getSelectedIndex();
            const prevIndex = currentIndex;
            if (e.code === 'ArrowDown' || e.keyCode === 40) {
                if (!e.shiftKey) {
                    if (typeof currentIndex === 'undefined') currentIndex = 0;
                    else currentIndex = (currentIndex + 1) % this.keyboardNavComponents.length;
                    e.preventDefault();
                }
            } else if (e.code === 'ArrowUp' || e.keyCode === 38) {
                if (!e.shiftKey) {
                    if (typeof currentIndex === 'undefined') currentIndex = this.keyboardNavComponents.length - 1;
                    else {
                        currentIndex -= 1;
                        if (currentIndex < 0) currentIndex = this.keyboardNavComponents.length - Math.abs(currentIndex);
                    }
                    e.preventDefault();
                }
            } else {
                if (typeof currentIndex !== 'undefined') this.onKeyDownCallbackAt(currentIndex, e);
                return;
            }
            if (prevIndex !== currentIndex && currentIndex !== undefined) {
                this.unhighlightComponentAt(prevIndex);
                this.highlightComponentAt(currentIndex);
                this.onHighlightedCallback(currentIndex);
            }
        };
        this.attach = (listenerNode)=>{
            if (listenerNode) listenerNode.addEventListener('keydown', this.onKeyDown);
        };
        this.detach = (listenerNode)=>{
            if (listenerNode) listenerNode.removeEventListener('keydown', this.onKeyDown);
        };
    }
}
const $ae3c6a4bb713dccb$export$cbeda0f7f7a8026c = ()=>{
    return (0, $gwFzn.useContext)($ae3c6a4bb713dccb$export$ef7af5d8bc5d5ac1);
};

});

parcelRegister("7WbA8", function(module, exports) {

$parcel$export(module.exports, "useAppContext", () => $801eb453cbafb488$export$fdc397e486fa83e7);
$parcel$export(module.exports, "AppContextProvider", () => $801eb453cbafb488$export$20d2b7652facc723);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $3Ez6w = parcelRequire("3Ez6w");

var $1XDdH = parcelRequire("1XDdH");

var $jAenQ = parcelRequire("jAenQ");
const $801eb453cbafb488$var$DefaultLinkComponent = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $jAenQ.Link), {
        ref: ref,
        ...props
    }));
const $801eb453cbafb488$export$554c849e7e3a0f1 = {
    linkComponent: $801eb453cbafb488$var$DefaultLinkComponent,
    mapUserIdToProfileUrl: ()=>null,
    generateSearchUrl: (0, $1XDdH.defaultGenerateSearchUrl),
    getFeatureGate: ()=>false,
    getFrontendExperiment: ()=>({
            abTestId: '',
            cohort: '',
            serveExperiment: false
        }),
    queryParams: {},
    onNavigate: (0, $1XDdH.defaultOnNavigate),
    isNav4Enabled: false,
    isAdminHubAIEnabled: false,
    isRovoLLMEnabled: false
};
/**
 * Provides information about the host application that can't be stored in a state store,
 * e.g. a function.
 */ const $801eb453cbafb488$var$AppContext = /*#__PURE__*/ (0, $gwFzn.createContext)($801eb453cbafb488$export$554c849e7e3a0f1);
const $801eb453cbafb488$export$fdc397e486fa83e7 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext($801eb453cbafb488$var$AppContext);
const $801eb453cbafb488$export$20d2b7652facc723 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)($801eb453cbafb488$var$AppContext.Provider, {
        value: (0, $3Ez6w.extend)($801eb453cbafb488$export$554c849e7e3a0f1, props),
        children: children
    });

});
parcelRegister("3Ez6w", function(module, exports) {

$parcel$export(module.exports, "extend", () => $0776efa54b822e10$export$8b58be045bf06082);
// This function is used to override the values of an object with the values of another object.
// Unless the value is null or undefined, the value from the source object will be used.
function $0776efa54b822e10$export$8b58be045bf06082(target, source) {
    const result = {
        ...target
    };
    for(const key in source)if (source[key] !== null && source[key] !== undefined) result[key] = source[key];
    return result;
}

});

parcelRegister("1XDdH", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $0cd41d31d45cf5ea$export$f654b28f82155665);
$parcel$export(module.exports, "defaultGenerateSearchUrl", () => $0cd41d31d45cf5ea$export$3c0cdf0037f37eca);
$parcel$export(module.exports, "defaultOnNavigate", () => $0cd41d31d45cf5ea$export$bd386de500a3324b);
function $0cd41d31d45cf5ea$export$f654b28f82155665(url) {
    return url ? new URL(url).origin : window.location.origin;
}
function $0cd41d31d45cf5ea$export$3c0cdf0037f37eca(queryParams) {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value])=>{
        if (value !== undefined && value !== null) searchParams.set(key, String(value));
    });
    url.search = searchParams.toString();
    return url.href;
}
const $0cd41d31d45cf5ea$export$bd386de500a3324b = {
    callback: (url)=>{
        window.location.href = url;
    },
    options: {
        alwaysUseOnLinkClick: false
    }
};

});

parcelRegister("jAenQ", function(module, exports) {

$parcel$export(module.exports, "Link", () => $5c2811b97c7b9fe1$export$a6c7ac8248d6e38a);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fpGTa = parcelRequire("fpGTa");

var $7WbA8 = parcelRequire("7WbA8");
const $5c2811b97c7b9fe1$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { onNavigate: onNavigate } = (0, $7WbA8.useAppContext)();
    const { href: href, onClick: originalOnClick } = props;
    const onClick = (0, $gwFzn.useCallback)((event, analyticsEvent)=>{
        originalOnClick?.(event, analyticsEvent);
        // Use onNavigate if
        // - alwaysUseOnLinkClick is true
        // - navigating to the same site and not new tab/window
        const metaPressed = event.ctrlKey || event.metaKey || event.shiftKey;
        const sameOrigin = window.location.origin === new URL(href).origin;
        const onNavigateOverride = typeof onNavigate === 'object' ? onNavigate.options.alwaysUseOnLinkClick : false;
        const useOnNavigate = onNavigateOverride || sameOrigin && !metaPressed;
        if (useOnNavigate) {
            event.preventDefault();
            // Handles SPA navigation if consumer provides their own onNavigate
            const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
            onNavigateCallback(href, 'push');
        }
    }, [
        href,
        onNavigate,
        originalOnClick
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fpGTa.default), {
        ref: ref,
        ...props,
        onClick: onClick
    });
});

});


parcelRegister("2ok43", function(module, exports) {

$parcel$export(module.exports, "getInitialQuery", () => $e39928e964cca707$export$ed7270bd966434af);
$parcel$export(module.exports, "useInputSkeleton", () => $e39928e964cca707$export$67de3a75cbe82e14);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $fG2rA = parcelRequire("fG2rA");
var $epS7s = parcelRequire("epS7s");
const $e39928e964cca707$export$ed7270bd966434af = ()=>{
    const stickySearch = (0, $dh538.fg)('quick_find_remove_sticky_search') ? undefined : (0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_QUERY_KEY));
    return stickySearch || (0, $fG2rA.getInputSkeletonQuery)() || '';
};
const $e39928e964cca707$export$67de3a75cbe82e14 = ({ localQuery: localQuery, inputRef: inputRef })=>{
    // Focus input if skeleton is focused
    (0, $gwFzn.useEffect)(()=>{
        const skeletonFocused = (0, $fG2rA.getInputSkeletonFocus)();
        if (skeletonFocused) {
            const input = inputRef?.current;
            if (input) {
                input.focus();
                const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $fG2rA.getInputSkeletonSelection)();
                input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
            }
        }
        (0, $fG2rA.removeInputSkeletonState)();
    }, [
        inputRef
    ]);
    // Push local query to session storage
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $dh538.fg)('quick_find_remove_sticky_search')) return;
        (0, $epS7s.setSessionItem)((0, $epS7s.SEARCH_QUERY_KEY), localQuery);
    }, [
        localQuery
    ]);
};

});

parcelRegister("86ob4", function(module, exports) {

$parcel$export(module.exports, "WidthObserverProvider", () => $c34df63e628fa432$export$75f7910544138d14);
$parcel$export(module.exports, "useWidthObserverRegistration", () => $c34df63e628fa432$export$ad8c32a8eb05ab3d);
$parcel$export(module.exports, "WidthObserverElement", () => $c34df63e628fa432$export$f8586f54f6b8f867);
$parcel$export(module.exports, "useElementWidth", () => $c34df63e628fa432$export$1217913212f99c7);
$parcel$export(module.exports, "isBreakpointActive", () => $c34df63e628fa432$export$c44b7f69e7aa026);
$parcel$export(module.exports, "Hide", () => $c34df63e628fa432$export$bed28288a051538);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $c34df63e628fa432$var$WidthObserverContext = /*#__PURE__*/ (0, $gwFzn.createContext)(undefined);
const $c34df63e628fa432$export$75f7910544138d14 = ({ children: children })=>{
    const [elements, setElements] = (0, $gwFzn.useState)({});
    const [callbacks, setCallbacks] = (0, $gwFzn.useState)({});
    (0, $gwFzn.useEffect)(()=>{
        const handleResize = (entries)=>{
            entries.forEach((entry)=>{
                const id = entry.target.getAttribute('data-width-observer-id');
                if (id && callbacks[id]) {
                    const width = entry.contentRect.width;
                    callbacks[id].forEach((callback)=>callback(width));
                }
            });
        };
        const observer = new ResizeObserver(handleResize);
        Object.values(elements).forEach((element)=>observer.observe(element));
        return ()=>{
            observer.disconnect();
        };
    }, [
        elements,
        callbacks
    ]);
    const registerElement = (0, $gwFzn.useCallback)((id, element)=>{
        setElements((prev)=>({
                ...prev,
                [id]: element
            }));
    }, [
        setElements
    ]);
    const unregisterElement = (0, $gwFzn.useCallback)((id)=>{
        setElements((prev)=>{
            const newElements = {
                ...prev
            };
            delete newElements[id];
            return newElements;
        });
    }, [
        setElements
    ]);
    const subscribe = (0, $gwFzn.useCallback)((id, callback)=>{
        setCallbacks((prev)=>({
                ...prev,
                [id]: [
                    ...prev[id] || [],
                    callback
                ]
            }));
        return ()=>{
            setCallbacks((prev)=>({
                    ...prev,
                    [id]: (prev[id] || []).filter((cb)=>cb !== callback)
                }));
        };
    }, [
        setCallbacks
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($c34df63e628fa432$var$WidthObserverContext.Provider, {
        value: {
            registerElement: registerElement,
            unregisterElement: unregisterElement,
            subscribe: subscribe
        },
        children: children
    });
};
const $c34df63e628fa432$export$b78842cb7cd02769 = ()=>{
    const context = (0, $gwFzn.useContext)($c34df63e628fa432$var$WidthObserverContext);
    if (!context) throw new Error('useWidthObserver must be used within a WidthObserverProvider');
    return context;
};
const $c34df63e628fa432$export$ad8c32a8eb05ab3d = (id, ref)=>{
    const { registerElement: registerElement, unregisterElement: unregisterElement } = $c34df63e628fa432$export$b78842cb7cd02769();
    (0, $gwFzn.useEffect)(()=>{
        const element = ref.current;
        if (element) {
            element.setAttribute('data-width-observer-id', id);
            registerElement(id, element);
        }
        return ()=>{
            unregisterElement(id);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id,
        ref,
        ref.current,
        registerElement,
        unregisterElement
    ]);
};
const $c34df63e628fa432$export$f8586f54f6b8f867 = ({ id: id, children: children })=>{
    const elementRef = (0, $gwFzn.useRef)(null);
    $c34df63e628fa432$export$ad8c32a8eb05ab3d(id, elementRef);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).cloneElement(children, {
            ref: elementRef
        })
    });
};
const $c34df63e628fa432$export$1217913212f99c7 = (id)=>{
    const { subscribe: subscribe } = $c34df63e628fa432$export$b78842cb7cd02769();
    const [width, setWidth] = (0, $gwFzn.useState)(0);
    (0, $gwFzn.useEffect)(()=>{
        const unsubscribe = subscribe(id, setWidth);
        return ()=>{
            unsubscribe();
        };
    }, [
        id,
        subscribe
    ]);
    return width;
};
const $c34df63e628fa432$export$f29cb180c1a7eb72 = ({ target: id, children: children })=>{
    const width = $c34df63e628fa432$export$1217913212f99c7(id);
    if (width === 0) return null;
    return children(width);
};
const $c34df63e628fa432$var$breakpoints = {
    xxs: 0,
    xs: 480,
    sm: 768,
    md: 1024,
    lg: 1440,
    xl: 1768
};
const $c34df63e628fa432$export$c44b7f69e7aa026 = ({ width: width, above: above, below: below })=>{
    return above && width > $c34df63e628fa432$var$breakpoints[above] || below && width < $c34df63e628fa432$var$breakpoints[below] || false;
};
const $c34df63e628fa432$export$f6a3d19be20f5819 = ({ target: target, above: above, below: below, children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($c34df63e628fa432$export$f29cb180c1a7eb72, {
        target: target,
        children: (width)=>{
            if ($c34df63e628fa432$export$c44b7f69e7aa026({
                width: width,
                above: above,
                below: below
            })) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                children: children
            });
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
        }
    });
};
const $c34df63e628fa432$export$bed28288a051538 = ({ target: target, above: above, below: below, children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($c34df63e628fa432$export$f29cb180c1a7eb72, {
        target: target,
        children: (width)=>{
            if ($c34df63e628fa432$export$c44b7f69e7aa026({
                width: width,
                above: above,
                below: below
            })) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                children: children
            });
        }
    });
};

});

parcelRegister("l1k3Q", function(module, exports) {

$parcel$export(module.exports, "QuickFindResults", () => $0c35e478cf8dbc82$export$da9d0159e5272189);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $czt8s = parcelRequire("czt8s");
var $8LSUr = parcelRequire("8LSUr");

var $1yEFx = parcelRequire("1yEFx");

var $jjjIy = parcelRequire("jjjIy");

var $8WnGI = parcelRequire("8WnGI");

var $9wmQG = parcelRequire("9wmQG");

var $ebR6f = parcelRequire("ebR6f");

var $aE5mL = parcelRequire("aE5mL");

var $JQd0k = parcelRequire("JQd0k");

var $9ubz9 = parcelRequire("9ubz9");
parcelRequire("1nJM3");
var $f8oYd = parcelRequire("f8oYd");

var $4VkIo = parcelRequire("4VkIo");

var $8N0Nm = parcelRequire("8N0Nm");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $j4ply = parcelRequire("j4ply");

var $4VmlX = parcelRequire("4VmlX");

var $inrbX = parcelRequire("inrbX");

var $c74az = parcelRequire("c74az");

var $fqqqA = parcelRequire("fqqqA");

var $3zpmm = parcelRequire("3zpmm");

var $eK6Pl = parcelRequire("eK6Pl");

var $cA4A0 = parcelRequire("cA4A0");

var $6CCNp = parcelRequire("6CCNp");
const $0c35e478cf8dbc82$var$DEBOUNCE_TIMEOUT = 250;
const $0c35e478cf8dbc82$var$EMPTY_RESULTS = {
    result: [],
    duration: 0
};
const $0c35e478cf8dbc82$export$ab15aae48c593ecc = ({ postQueryDisabled: postQueryDisabled, onPreQueryStart: onPreQueryStart, onPreQuerySuccess: onPreQuerySuccess, onPreQueryFailure: onPreQueryFailure, onPostQueryChange: onPostQueryChange, onPostQueryStart: onPostQueryStart, onPostQuerySuccess: onPostQuerySuccess, onPostQueryFailure: onPostQueryFailure, onPostQueryCancel: onPostQueryCancel })=>{
    const [bootstrap] = (0, $j4ply.useBootstrap)();
    const isSearchReady = (0, $djVCD.useIsSearchReady)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const { selectedFilters: selectedFilters, entities: entities } = (0, $4VkIo.useSelectedFilters)({
        thirdPartyConfigs: bootstrap.thirdPartyConfigs,
        cloudId: bootstrap.cloudId
    });
    const logException = (0, $f8oYd.useLogException)();
    const [retryCount] = (0, $djVCD.useRetryCount)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const currentQueryFilter = (0, $4VmlX.useCurrentQueryFilter)();
    const selectedQueryFilters = (0, $4VmlX.useSelectedQueryFilters)();
    const { setJiraIssueFieldsLoading: setJiraIssueFieldsLoading, setRequestedBackendExperiments: setRequestedBackendExperiments } = (0, $djVCD.useSearchActions)();
    const serveUserShardUI = (0, $j4ply.useUserShardUI)();
    const serveUserShardModel = (0, $j4ply.useUserShardModel)();
    const prevQueryRef = (0, $gwFzn.useRef)();
    const prevQuickFindOpenRef = (0, $gwFzn.useRef)(quickFindOpen);
    const warmupRequestWasFired = (0, $gwFzn.useRef)(false);
    const prevSelectedQueryFiltersRef = (0, $gwFzn.useRef)(selectedQueryFilters);
    const prevSelectedFilters = (0, $gwFzn.useRef)();
    const fetchRecentActivitiesPromiseRef = (0, $gwFzn.useRef)();
    const preQueryPromiseRef = (0, $gwFzn.useRef)();
    const postQueryPromiseRef = (0, $gwFzn.useRef)();
    const { setUpdateRecentQueries: setUpdateRecentQueries, setFetchEntitiesRequestId: setFetchEntitiesRequestId, setFetchSpacesRequestId: setFetchSpacesRequestId } = (0, $4VmlX.useQuickFindActions)();
    const [preQueryLoading, setPreQueryLoading] = (0, $gwFzn.useState)(true);
    const [preQueryError, setPreQueryError] = (0, $gwFzn.useState)();
    const [postQueryLoading, setPostQueryLoading] = (0, $gwFzn.useState)(false);
    const [postQueryError, setPostQueryError] = (0, $gwFzn.useState)();
    const [recentQueries, setRecentQueries] = (0, $gwFzn.useState)([]);
    const [filteredRecentQueries, setFilteredRecentQueries] = (0, $gwFzn.useState)([]);
    const [filteredRecentActivities, setFilteredRecentActivities] = (0, $gwFzn.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [searchResults, setSearchResults] = (0, $gwFzn.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [peopleAndTeams, setPeopleAndTeams] = (0, $gwFzn.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    /**
	 * Callback to update recent queries for the current product and user
	 */ const fetchRecentQueries = (0, $gwFzn.useCallback)(()=>{
        if (!bootstrap.primaryProduct || !bootstrap.user?.id) return;
        const recentQueries = (0, $cA4A0.getRecentQueries)(bootstrap.primaryProduct, bootstrap.user.id);
        setRecentQueries(recentQueries);
    }, [
        bootstrap.primaryProduct,
        bootstrap.user?.id,
        setRecentQueries
    ]);
    /**
	 * Store the callback to update recent queries in the store. This is used to refresh recent queries
	 * when they are updated, e.g. when a search request is made or when a recent query is removed.
	 */ (0, $gwFzn.useEffect)(()=>{
        fetchRecentQueries();
        setUpdateRecentQueries(fetchRecentQueries);
    }, [
        fetchRecentQueries,
        setUpdateRecentQueries
    ]);
    /**
	 * Callback to fetch recent activities
	 */ const fetchRecentActivitiesCallback = (0, $gwFzn.useCallback)(async ()=>{
        if (bootstrap.cloudId) return (0, $c74az.fetchRecentActivities)(bootstrap.cloudId, bootstrap.aggAbsoluteUrl);
        else return [];
    }, [
        bootstrap.cloudId,
        bootstrap.aggAbsoluteUrl
    ]);
    /**
	 * Callback to fetch pre-query results and updates the store with the results
	 */ const fetchQuickFindPreQuery = (0, $gwFzn.useCallback)((query, product)=>{
        if (!fetchRecentActivitiesPromiseRef.current) {
            setPreQueryLoading(true);
            onPreQueryStart?.();
            const fetchRecentActivitiesPromise = (0, $8WnGI.measureAsyncFunction)(fetchRecentActivitiesCallback).then((result)=>{
                setPreQueryLoading(false);
                onPreQuerySuccess?.();
                return result;
            }).catch((error)=>{
                logException(error);
                setPreQueryError(error);
                onPreQueryFailure?.();
                return $0c35e478cf8dbc82$var$EMPTY_RESULTS;
            });
            fetchRecentActivitiesPromiseRef.current = fetchRecentActivitiesPromise;
        }
        const hideFilteredPreQueryResults = selectedQueryFilters.length > 0 || query.length && product !== undefined || query.length && serveUserShardUI;
        if (hideFilteredPreQueryResults) {
            setFilteredRecentQueries([]);
            setFilteredRecentActivities($0c35e478cf8dbc82$var$EMPTY_RESULTS);
            return;
        }
        const preQueryPromise = new (0, $czt8s.CancellablePromise)(fetchRecentActivitiesPromiseRef.current);
        preQueryPromise.promise().then((recentActivities)=>{
            const filteredRecentActivities = (0, $jjjIy.filterSearchResults)(recentActivities.result, query);
            const filteredRecentQueries = (0, $jjjIy.filterSearchResults)(recentQueries, query);
            setFilteredRecentQueries(filteredRecentQueries);
            setFilteredRecentActivities({
                result: filteredRecentActivities,
                duration: recentActivities.duration
            });
        }).catch((error)=>{
        // no-op on cancel
        });
    }, [
        fetchRecentActivitiesCallback,
        logException,
        onPreQueryFailure,
        onPreQueryStart,
        onPreQuerySuccess,
        recentQueries,
        selectedQueryFilters.length,
        serveUserShardUI
    ]);
    /**
	 * Callback to fetch confluence entities
	 */ const fetchConfluenceEntitiesCallback = (0, $gwFzn.useCallback)(async ()=>{
        return Promise.all([
            (0, $eK6Pl.fetchConfluenceAnd3PEntities)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, entities),
            (0, $eK6Pl.fetchConfluenceSpaces)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions)
        ]).then((results)=>{
            const [entities, spaces] = results;
            return {
                results: [
                    ...entities.fetchResults,
                    ...spaces.fetchResults
                ],
                fetchEntitiesRequestId: entities.fetchEntitiesRequestId ?? undefined,
                fetchSpacesRequestId: spaces.fetchSpacesRequestId ?? undefined
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        entities
    ]);
    /**
	 * Callback to fetch atlas entities
	 */ const fetchAtlasEntitiesCallback = (0, $gwFzn.useCallback)(async ()=>(0, $eK6Pl.fetchAtlasEntities)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments).then((results)=>{
            const { fetchResults: fetchResults, fetchEntitiesRequestId: fetchEntitiesRequestId } = results;
            return {
                results: fetchResults,
                fetchEntitiesRequestId: fetchEntitiesRequestId ?? undefined,
                fetchSpacesRequestId: undefined
            };
        }), [
        bootstrap.aggAbsoluteUrl,
        bootstrap.cloudId,
        bootstrap.primaryProduct,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        selectedFilters,
        quickFindQuery,
        searchSessionId,
        setRequestedBackendExperiments
    ]);
    /**
	 * Callback to fetch confluence entities
	 */ const fetchMercuryEntitiesCallback = (0, $gwFzn.useCallback)(async ()=>(0, $eK6Pl.fetchMercuryEntities)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments).then((results)=>{
            const { fetchResults: fetchResults, fetchEntitiesRequestId: fetchEntitiesRequestId } = results;
            return {
                results: [
                    ...fetchResults
                ],
                fetchEntitiesRequestId: fetchEntitiesRequestId ?? undefined,
                fetchSpacesRequestId: undefined
            };
        }), [
        bootstrap.aggAbsoluteUrl,
        bootstrap.cloudId,
        bootstrap.primaryProduct,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        selectedFilters,
        quickFindQuery,
        searchSessionId,
        setRequestedBackendExperiments
    ]);
    /**
	 *  Callback to fetch jira entities
	 */ const fetchJiraEntitiesCallback = (0, $gwFzn.useCallback)(async ()=>(0, $eK6Pl.fetchJiraEntities)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments).then((results)=>{
            const { fetchResults: fetchResults, fetchEntitiesRequestId: fetchEntitiesRequestId } = results;
            return {
                results: [
                    ...fetchResults
                ],
                fetchEntitiesRequestId: fetchEntitiesRequestId ?? undefined,
                fetchSpacesRequestId: undefined
            };
        }), [
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments
    ]);
    /**
	 * Callback to fetch people and teams results
	 */ const fetchPeopleAndTeamsCallback = (0, $gwFzn.useCallback)(async ()=>{
        const { orgId: orgId, primaryProduct: primaryProduct, user: user, cloudId: cloudId } = bootstrap;
        if (orgId && primaryProduct && user?.id && cloudId) {
            // When no query filters are selected, get people and teams results
            // using the query
            if (selectedQueryFilters.length === 0) return (0, $3zpmm.fetchPeopleAndTeamsResults)(quickFindQuery, orgId, primaryProduct, user.id, cloudId);
            // When a single query filter is selected and it is a contributor filter,
            // get people and teams results using the contributor name
            if (selectedQueryFilters.length === 1 && selectedQueryFilters[0].filterId === 'contributor') return (0, $3zpmm.fetchPeopleAndTeamsResults)(selectedQueryFilters[0].displayText, orgId, primaryProduct, user.id, cloudId);
        }
        return [];
    }, [
        bootstrap,
        quickFindQuery,
        selectedQueryFilters
    ]);
    /**
	 * Function which fetches the post query results. This consists of a call to get
	 * product search results and a call to get people and teams. Given that Promise.allSettled
	 * is used, the slowest request will determine the time it takes to resolve.
	 */ const fetchQuickFindPostQuery = (0, $gwFzn.useCallback)(()=>{
        const { cloudId: cloudId = '', aggAbsoluteUrl: aggAbsoluteUrl } = bootstrap;
        // TODO: this is too nested - refactor this into switch or if-else statements
        const fetchProductEntities = bootstrap.primaryProduct === 'confluence' ? fetchConfluenceEntitiesCallback : bootstrap.primaryProduct === 'townsquare' ? fetchAtlasEntitiesCallback : bootstrap.primaryProduct === 'mercury' ? fetchMercuryEntitiesCallback : bootstrap.primaryProduct === 'jira' ? fetchJiraEntitiesCallback : ()=>Promise.resolve({
                results: [],
                fetchEntitiesRequestId: undefined,
                fetchSpacesRequestId: undefined
            });
        const fetchPeopleAndTeams = bootstrap.primaryProduct !== 'mercury' && !selectedProduct ? fetchPeopleAndTeamsCallback : ()=>Promise.resolve([]);
        const postQueryPromise = new (0, $czt8s.CancellablePromise)(Promise.allSettled([
            (0, $8WnGI.measureAsyncFunction)(fetchProductEntities),
            (0, $8WnGI.measureAsyncFunction)(fetchPeopleAndTeams)
        ]));
        postQueryPromiseRef.current = postQueryPromise;
        onPostQueryStart?.();
        postQueryPromise.promise().then((results)=>{
            const productEntitiesStatus = results[0].status;
            const peopleAndTeamsStatus = results[1].status;
            // Post-query success is determined by product entities request, errors
            // from people and teams are ignored
            if (productEntitiesStatus === 'fulfilled') {
                const fetchedResults = results[0].value.result.results;
                setSearchResults({
                    result: fetchedResults,
                    duration: results[0].value.duration
                });
                const hasThirdPartyResults = fetchedResults.some((result)=>result.id.startsWith('ari:cloud:graph::document') || result.id.startsWith('ari:cloud:graph::remote-link'));
                setFetchEntitiesRequestId(results[0].value.result.fetchEntitiesRequestId);
                setFetchSpacesRequestId(results[0].value.result.fetchSpacesRequestId);
                const peopleAndTeams = peopleAndTeamsStatus === 'fulfilled' ? {
                    result: results[1].value.result,
                    duration: results[1].value.duration
                } : $0c35e478cf8dbc82$var$EMPTY_RESULTS;
                setPeopleAndTeams(peopleAndTeams);
                const allDurations = results.map((result)=>result.status === 'fulfilled' ? result.value.duration : 0);
                const maxDuration = Math.max(...allDurations);
                onPostQuerySuccess?.(maxDuration, hasThirdPartyResults);
            } else {
                setPostQueryError(new Error('Failed to fetch post query results'));
                onPostQueryFailure?.();
            }
            setPostQueryLoading(false);
            return results;
        }).then((results)=>{
            const issueStatus = results[0].status;
            if (issueStatus === 'fulfilled' && (0, $dh538.fg)('enable_status_jira_issues_quick_find')) {
                let fetchedResults = results[0].value.result.results;
                // Fetch extra fields for issues
                const issuesToFetch = [];
                if (fetchedResults && fetchedResults.length > 0) fetchedResults.forEach((result)=>{
                    if ((0, $8LSUr.isSearchResultJiraIssue)(result.data)) {
                        const issueKey = result.data.issue?.webUrl?.split('/').at(-1) || result.data.url.split('/').at(-1);
                        if (!!issueKey) issuesToFetch.push(issueKey);
                    }
                });
                if (issuesToFetch.length > 0) {
                    setJiraIssueFieldsLoading(true);
                    (0, $8N0Nm.fetchJiraFields)({
                        issueKeys: issuesToFetch,
                        cloudId: cloudId,
                        aggAbsoluteUrl: aggAbsoluteUrl
                    }).then((jiraHydrationResults)=>{
                        const issues = jiraHydrationResults.data?.jira.issuesByKey;
                        if (issues && fetchedResults) {
                            const issuesMap = new Map(issues.map((issue)=>[
                                    issue.id,
                                    issue
                                ]));
                            fetchedResults = fetchedResults.map((result)=>{
                                const issue = issuesMap.get(result.id);
                                if (issue) {
                                    const colorName = issue.statusField.status.statusCategory?.colorName;
                                    if (result.data && result.data.status) result.data.status.colorName = colorName;
                                }
                                return result;
                            });
                        }
                        const updatedResults = issueStatus === 'fulfilled' ? {
                            result: fetchedResults,
                            duration: results[0].value.duration
                        } : $0c35e478cf8dbc82$var$EMPTY_RESULTS;
                        setSearchResults(updatedResults);
                    }).finally(()=>{
                        setJiraIssueFieldsLoading(false);
                    });
                }
            }
        }).catch(()=>{
        // Promise.allSettled will never reject, hence rejections only occur
        // when the promise is cancelled. In this case, we don't need to do anything.
        });
    }, [
        bootstrap,
        fetchAtlasEntitiesCallback,
        fetchConfluenceEntitiesCallback,
        fetchJiraEntitiesCallback,
        fetchMercuryEntitiesCallback,
        fetchPeopleAndTeamsCallback,
        onPostQueryFailure,
        onPostQueryStart,
        onPostQuerySuccess,
        selectedProduct,
        setFetchEntitiesRequestId,
        setFetchSpacesRequestId,
        setJiraIssueFieldsLoading
    ]);
    /**
	 * Debounced fetch function for quick find results. This callback should never mutate
	 * as the only dependency is the timeout value, hence it can be safely used in dependency array.
	 */ const debouncedFetchQuickFindPostQuery = (0, $JQd0k.useDebouncedCallback)(fetchQuickFindPostQuery, $0c35e478cf8dbc82$var$DEBOUNCE_TIMEOUT);
    /**
	 * Warm-up request for user shard permissions cache when dialog is opened **for the first time**
	 * The user shard team has an idea to reduce 3p latency which is to pre-fetch documents and run them through LMC when the dialog opens.
	 * Queries that are not empty will be checked against those cached values, as a way to remove LMC latency from QF queries.
	 * The cache exists in searcher.
	 * For more information, see https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/122582/diff#comment-602538177
	 * Demo of how this works: https://www.loom.com/share/e190178ec2e048558273cd8d60a7006d
	 */ (0, $gwFzn.useEffect)(()=>{
        if (quickFindOpen && !warmupRequestWasFired.current && serveUserShardModel) {
            debouncedFetchQuickFindPostQuery();
            warmupRequestWasFired.current = true;
        }
    }, [
        quickFindOpen,
        debouncedFetchQuickFindPostQuery,
        serveUserShardModel
    ]);
    /**
	 * Updates results when various Quick Find states change, this includes:
	 * - when search is ready
	 * - when the dialog opens
	 * - when the query changes
	 * - when recent queries or activities change
	 * - when selected entities or filters change
	 */ (0, $gwFzn.useEffect)(()=>{
        if (!isSearchReady) return;
        if (preQueryPromiseRef.current) preQueryPromiseRef.current.cancel();
        fetchQuickFindPreQuery(quickFindQuery, selectedProduct);
        prevQuickFindOpenRef.current = quickFindOpen;
        if (!quickFindOpen || currentQueryFilter) return;
        if (quickFindQuery === prevQueryRef.current && selectedFilters === prevSelectedFilters.current) return;
        prevQueryRef.current = quickFindQuery;
        prevSelectedQueryFiltersRef.current = selectedQueryFilters;
        prevSelectedFilters.current = selectedFilters;
        if (postQueryDisabled) return;
        const hasQuery = quickFindQuery || selectedQueryFilters.length > 0;
        if (!hasQuery) onPostQueryCancel?.();
        setSearchResults({
            result: [],
            duration: 0
        });
        setPeopleAndTeams({
            result: [],
            duration: 0
        });
        setPostQueryLoading(true);
        setPostQueryError(undefined);
        if (hasQuery) {
            // Cancel the inflight request if there is one
            if (postQueryPromiseRef.current) postQueryPromiseRef.current.cancel();
            onPostQueryChange?.();
            setPostQueryLoading(true);
            debouncedFetchQuickFindPostQuery();
        }
    }, [
        fetchQuickFindPreQuery,
        debouncedFetchQuickFindPostQuery,
        quickFindQuery,
        retryCount,
        isSearchReady,
        quickFindOpen,
        selectedFilters,
        entities,
        onPostQueryCancel,
        onPostQueryChange,
        postQueryDisabled,
        currentQueryFilter,
        selectedQueryFilters,
        selectedProduct
    ]);
    return (0, $gwFzn.useMemo)(()=>(0, $6CCNp.getQuickFindContent)({
            // Using refs here to ensure new results state is returned only
            // when the various result variables in the dependency array change
            query: prevQueryRef.current,
            selectedQueryFilters: prevSelectedQueryFiltersRef.current,
            quickFindOpen: prevQuickFindOpenRef.current,
            preQueryError: preQueryError,
            preQueryLoading: preQueryLoading,
            postQueryError: postQueryError,
            postQueryLoading: postQueryLoading,
            filteredRecentQueries: filteredRecentQueries,
            filteredRecentActivities: filteredRecentActivities,
            searchResults: searchResults,
            peopleAndTeams: peopleAndTeams,
            postQueryDisabled: postQueryDisabled
        }), [
        filteredRecentActivities,
        filteredRecentQueries,
        peopleAndTeams,
        postQueryDisabled,
        postQueryError,
        postQueryLoading,
        preQueryError,
        preQueryLoading,
        searchResults
    ]);
};
const $0c35e478cf8dbc82$var$useSearchResultsShownAnalytics = ()=>{
    const previousStateRef = (0, $gwFzn.useRef)();
    const content = (0, $4VmlX.useContent)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const [requestedBackendExperiments] = (0, $djVCD.useRequestedBackendExperiments)();
    const are3PSmartLinksInResults = (0, $gwFzn.useMemo)(()=>{
        if (!content || !(0, $dh538.fg)('search_page_smart_link_analytics')) return false;
        const items = [
            ...'recentActivities' in content ? content.recentActivities : [],
            ...'searchResults' in content ? content.searchResults : []
        ];
        return items.map((result)=>result.id).some((0, $9ubz9.isResultSmartLink));
    }, [
        content
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // Store a copy of previous state before updating the ref
        const previousState = previousStateRef.current;
        previousStateRef.current = content ? content.state : undefined;
        // Don't fire analytics event if the dialog is closed
        if (!quickFindOpen || !content) return;
        // Don't fire analytics event if the state hasn't changed
        if (content.state === previousState) return;
        // Ignore states that do not have search results
        if (content.state === (0, $aE5mL.State).PREQUERY_LOADING || content.state === (0, $aE5mL.State).PREQUERY_ERROR || content.state === (0, $aE5mL.State).POSTQUERY_ERROR) return;
        /**
		 * Do not fire analytics event when the dialog is opened and post-query
		 * results are already returned. This is to have parity with the old
		 * quick find component.
		 *
		 * Whilst this may not be correct, this is here to ensure changes in metrics
		 * such as QSR and CTR are intentional.
		 *
		 * TODO: Discuss with DS/DE if this correct behaviour
		 */ if (content.state === (0, $aE5mL.State).POSTQUERY_RESULTS && previousState === undefined) return;
        const resultsTypeMap = {
            PREQUERY_RESULTS: 'preQuerySearchResults',
            PREQUERY_NO_RESULTS: 'preQuerySearchResults',
            POSTQUERY_LOADING: 'cachedResults',
            POSTQUERY_RESULTS: 'postQuerySearchResults',
            POSTQUERY_NO_RESULTS: 'postQuerySearchResults'
        };
        const resultsType = resultsTypeMap[content.state];
        const { sectionCount: sectionCount, resultCount: resultCount } = (0, $9wmQG.getSectionsAndResultsCount)();
        const resultTypeCounts = (0, $9wmQG.getResultTypeCounts)();
        const productsInResults = (0, $9wmQG.getProductsInResults)();
        const noResultsFetched = content.state === (0, $aE5mL.State).PREQUERY_NO_RESULTS || content.state === (0, $aE5mL.State).POSTQUERY_NO_RESULTS || resultCount === 0;
        // Don't fire cachedResults event if there are no results
        if (noResultsFetched && resultsType === 'cachedResults') return;
        const are3pResultsShown = productsInResults.some((0, $1yEFx.is3pProductKey));
        fireAnalyticsEvent((0, $ebR6f.onSearchResultsShown)({
            attributes: {
                ...commonAttributes,
                sectionCount: sectionCount,
                resultCount: resultCount,
                resultTypeCounts: resultTypeCounts,
                productsInResults: productsInResults,
                are3pResultsShown: are3pResultsShown,
                ...(0, $dh538.fg)('search_page_smart_link_analytics') && {
                    are3PSmartLinksInResults: are3PSmartLinksInResults
                },
                noResultsFetched: noResultsFetched,
                ...(0, $inrbX.getCommonQueryAttributes)(content.query),
                ...requestedBackendExperiments
            },
            nonPrivacySafeAttributes: {
                query: content.query
            },
            resultsType: resultsType
        }));
    }, [
        commonAttributes,
        content,
        fireAnalyticsEvent,
        quickFindOpen,
        requestedBackendExperiments,
        are3PSmartLinksInResults
    ]);
};
const $0c35e478cf8dbc82$export$da9d0159e5272189 = /*#__PURE__*/ (0, $gwFzn.memo)((options)=>{
    const callbacks = (0, $fqqqA.useQuickFindResultsCallbacks)();
    const useQuickFindResultsArgs = (0, $gwFzn.useMemo)(()=>({
            ...options,
            ...callbacks
        }), [
        options,
        callbacks
    ]);
    const content = $0c35e478cf8dbc82$export$ab15aae48c593ecc(useQuickFindResultsArgs);
    const { setContent: setContent } = (0, $4VmlX.useQuickFindActions)();
    (0, $gwFzn.useEffect)(()=>{
        setContent(content);
    }, [
        content,
        setContent
    ]);
    $0c35e478cf8dbc82$var$useSearchResultsShownAnalytics();
    return null;
});

});
parcelRegister("8LSUr", function(module, exports) {

$parcel$export(module.exports, "isSearchResultJiraProject", () => $36aa3ff758e375d9$export$aab3eed7c97209f8);
$parcel$export(module.exports, "mapJiraIssuePartial", () => $36aa3ff758e375d9$export$65f412f3857c35e0);
$parcel$export(module.exports, "mapJiraProjectPartial", () => $36aa3ff758e375d9$export$85182d219d5a304f);
$parcel$export(module.exports, "isSearchResultJiraIssue", () => $36aa3ff758e375d9$export$e221e36ba6e9f139);
$parcel$export(module.exports, "isJiraProjectField", () => $36aa3ff758e375d9$export$9c283c2de8ddb8fb);
$parcel$export(module.exports, "isSearchResultJiraFilter", () => $36aa3ff758e375d9$export$e0968d23c481cf04);
$parcel$export(module.exports, "isSearchResultJiraDashboard", () => $36aa3ff758e375d9$export$3e9a71746a0d5ef1);
$parcel$export(module.exports, "isSearchResultJiraBoard", () => $36aa3ff758e375d9$export$98e434e98950249c);
$parcel$export(module.exports, "isSearchJiraPartial", () => $36aa3ff758e375d9$export$5a36738ca5faa27f);
$parcel$export(module.exports, "getJiraPartials", () => $36aa3ff758e375d9$export$d1f9da0e5c74ebcb);

var $dh538 = parcelRequire("dh538");

var $kc79t = parcelRequire("kc79t");

var $6gi58 = parcelRequire("6gi58");
const $36aa3ff758e375d9$var$includeSocialSignalsDirective = ()=>(0, $dh538.fg)('rovo_disable_social_signal_on_qf') ? '@include(if: $includeSocialSignals) ' : '';
/**
 * Hydrating the project avatar field causes additional latency so it is removed in this GraphQL Query
 * Investigation: https://hello.atlassian.net/wiki/x/iKKu8w
 */ const $36aa3ff758e375d9$var$getSearchResultJiraProject = ()=>`
... on SearchResultJiraProject {
  projectId
  projectKey
  projectType
  lastModifiedDate
  project {
    webUrl
  }
	socialSignal(tenantId: $tenantId) ${$36aa3ff758e375d9$var$includeSocialSignalsDirective()}{
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}
	}
}`;
const $36aa3ff758e375d9$export$aab3eed7c97209f8 = (partial)=>{
    return partial.__typename === 'SearchResultJiraProject';
};
const $36aa3ff758e375d9$export$1f4b5d2e43f14510 = `
... on SearchResultJiraIssue {
  id
  title
  type
  description
  url
  iconUrl
  lastModifiedDate
  issueTypeId
  status {
    id
    name
  }
  issue {
    webUrl
	key
    fieldsById(ids: ["project"]) {
      edges {
        node {
          __typename
          name
          ... on JiraProjectField {
            project {
              id
              name
			  projectType
            }
          }
        }
      }
    }
  }
  socialSignal(tenantId: $tenantId) ${$36aa3ff758e375d9$var$includeSocialSignalsDirective()}{
	    signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
	    }
  }
  __typename
}
`;
const $36aa3ff758e375d9$export$65f412f3857c35e0 = (partial)=>{
    return {
        ...partial,
        url: partial.issue?.webUrl || partial.url
    };
};
const $36aa3ff758e375d9$export$85182d219d5a304f = (partial)=>({
        ...partial,
        url: partial.project?.webUrl || partial.url
    });
const $36aa3ff758e375d9$export$e221e36ba6e9f139 = (partial)=>{
    return partial.__typename === 'SearchResultJiraIssue';
};
const $36aa3ff758e375d9$export$9c283c2de8ddb8fb = (partial)=>{
    return partial.__typename === 'JiraProjectField' && partial.name === 'Project';
};
const $36aa3ff758e375d9$export$832b8ae8473ed171 = ``;
const $36aa3ff758e375d9$export$e0968d23c481cf04 = (partial)=>{
    return partial.__typename === 'SearchResultJiraFilter';
};
const $36aa3ff758e375d9$export$7860041bfeffea77 = ``;
const $36aa3ff758e375d9$export$3e9a71746a0d5ef1 = (partial)=>{
    return partial.__typename === 'SearchResultJiraDashboard';
};
const $36aa3ff758e375d9$export$f2ae751487c16c56 = `
... on SearchResultJiraBoard {
  boardId
  container {
		__typename
	}
  product
}
`;
const $36aa3ff758e375d9$export$98e434e98950249c = (partial)=>{
    return partial.__typename === 'SearchResultJiraBoard';
};
const $36aa3ff758e375d9$export$5a36738ca5faa27f = (partial)=>{
    return $36aa3ff758e375d9$export$aab3eed7c97209f8(partial) || $36aa3ff758e375d9$export$e221e36ba6e9f139(partial) || $36aa3ff758e375d9$export$e0968d23c481cf04(partial) || $36aa3ff758e375d9$export$3e9a71746a0d5ef1(partial) || $36aa3ff758e375d9$export$98e434e98950249c(partial);
};
const $36aa3ff758e375d9$export$d1f9da0e5c74ebcb = ()=>{
    return `
		${$36aa3ff758e375d9$var$getSearchResultJiraProject()}
		${$36aa3ff758e375d9$export$1f4b5d2e43f14510}
		${$36aa3ff758e375d9$export$832b8ae8473ed171}
		${$36aa3ff758e375d9$export$7860041bfeffea77}
		${$36aa3ff758e375d9$export$f2ae751487c16c56}
	`;
};

});
parcelRegister("kc79t", function(module, exports) {

$parcel$export(module.exports, "JiraStatusCategoryColor", () => $a91146fce116fa8b$export$539cfae207f2a8d6);
const $a91146fce116fa8b$export$539cfae207f2a8d6 = {
    MediumGray: 'MEDIUM_GRAY',
    Green: 'GREEN',
    Yellow: 'YELLOW',
    Brown: 'BROWN',
    Red: 'WARM_RED',
    BlueGray: 'BLUE_GRAY'
};

});

parcelRegister("6gi58", function(module, exports) {

$parcel$export(module.exports, "fetchJiraFieldsQuery", () => $4858f1196c57a1ec$export$16b4bc84d4d9549f);

var $4qT1X = parcelRequire("4qT1X");

var $2qzBQ = parcelRequire("2qzBQ");

var $hw4j5 = parcelRequire("hw4j5");

var $h4mQ0 = parcelRequire("h4mQ0");
const $4858f1196c57a1ec$var$cache = (0, $hw4j5.inMemoryCache)();
const $4858f1196c57a1ec$export$801183f161baaa36 = (variables)=>{
    const keyObj = {
        issueKeys: variables.issueKeys
    };
    return (0, $2qzBQ.generateHashFromVariables)(keyObj);
};
// Expire the cache if there are errors or results are empty
const $4858f1196c57a1ec$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    return data.jira.issuesByKey.length === 0;
};
const $4858f1196c57a1ec$export$16b4bc84d4d9549f = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    const graphQuery = (0, $h4mQ0.jiraFieldsQueryGenerator)();
    return $4858f1196c57a1ec$var$cache.inMemoryDecorator($4858f1196c57a1ec$export$801183f161baaa36(variables), ()=>(0, $4qT1X.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: 'SearchPageJiraFieldHydration'
        }), $4858f1196c57a1ec$var$expireWhen);
};

});
parcelRegister("4qT1X", function(module, exports) {

$parcel$export(module.exports, "fetchAgg", () => $d58482f4fb1880c9$export$f49dad89491f6bf2);

var $dwp40 = parcelRequire("dwp40");
const $d58482f4fb1880c9$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $d58482f4fb1880c9$export$f49dad89491f6bf2({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $d58482f4fb1880c9$var$DEFAULT_GRAPHQL_ENDPOINT, headers: headers }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName
            }
        }
    };
    return (0, $dwp40.utils).requestService({
        url: url
    }, options);
}

});

parcelRegister("2qzBQ", function(module, exports) {

$parcel$export(module.exports, "generateHash", () => $44766eafbe4aebec$export$daf4c137c5f56404);
$parcel$export(module.exports, "generateHashFromVariables", () => $44766eafbe4aebec$export$5c07a4287a46fa1f);
/**
 * Simple implementation of djb2 hashing.
 * The reason we have it internally is because at the moment we can't add new
 * dependencies into search-client package as it triggers a deprecated VR test in Editor
 * and it is locked down. So it fails to resolve the new dependency
 */ const $44766eafbe4aebec$export$daf4c137c5f56404 = (query)=>{
    let hash = 5381;
    for(let i = 0; i < query.length; i++){
        const char = query.charCodeAt(i);
        hash = (hash << 5) + hash + char; /* hash * 33 + char */ 
    }
    return hash;
};
const $44766eafbe4aebec$export$5c07a4287a46fa1f = (variables)=>{
    try {
        return $44766eafbe4aebec$export$daf4c137c5f56404(JSON.stringify(variables)).toString();
    } catch (e) {
        return '';
    }
};

});

parcelRegister("hw4j5", function(module, exports) {

$parcel$export(module.exports, "inMemoryCache", () => $553ad7df36a4ab29$export$26b8d9fa10eeb703);

var $3WVPu = parcelRequire("3WVPu");
const $553ad7df36a4ab29$export$26b8d9fa10eeb703 = (args)=>{
    const cacheInstance = (0, $3WVPu.getInstance)(args);
    const get = (key)=>key.length ? cacheInstance.get(key) : undefined;
    const set = (key, result)=>{
        if (key.length) cacheInstance.set(key, result);
    };
    const has = (key)=>cacheInstance.has(key);
    const clear = (key)=>cacheInstance.clear(key);
    const inMemoryDecorator = (key, supplier, expireWhen)=>{
        // Check if the key is already in the cache
        const cached = get(key);
        // If the key is in the cache, return the cached value
        if (cached) return cached;
        // If the key is not in the cache, call the supplier function
        const result = supplier();
        set(key, result);
        // If the promise is rejected, clear the cache
        result.catch(()=>{
            // If the promise is rejected, clear the cache
            cacheInstance.clear(key);
        });
        // Return the result
        // If the result should be expired, clear the cache
        return result.then((value)=>{
            if (expireWhen && expireWhen(value)) cacheInstance.clear(key);
            return value;
        });
    };
    return {
        get: get,
        set: set,
        has: has,
        clear: clear,
        inMemoryDecorator: inMemoryDecorator
    };
};

});
parcelRegister("3WVPu", function(module, exports) {

$parcel$export(module.exports, "getInstance", () => $fc16ad90038db0a8$export$8bedcca5bbd73999);
const $fc16ad90038db0a8$var$DEFAULT_EXPIRATION = 900000; // 15 mins in milliseconds
class $fc16ad90038db0a8$var$Cache {
    get(key, returnExpired = false) {
        const entry = this.map[key];
        if (entry) {
            if (entry.isExpired()) {
                delete this.map[key];
                return returnExpired ? entry.getResult() : undefined;
            } else return entry.getResult();
        }
        return;
    }
    set(key, result, expiration) {
        const entry = new $fc16ad90038db0a8$var$Entry({
            result: result,
            expirationTime: Date.now() + (expiration || this.expiration),
            accessCount: 0
        });
        this.map[key] = entry;
    }
    has(key) {
        return key in this.map;
    }
    clear(key) {
        if (key) delete this.map[key];
        else this.map = {};
    }
    async serialize() {
        const serialized = {};
        const resolvers = Object.entries(this.map).map(([key, entry])=>(async ()=>{
                serialized[key] = {
                    result: await entry.getResult(),
                    expirationTime: entry.getExpirationTime(),
                    accessCount: entry.getAccessCount()
                };
            })());
        await Promise.all(resolvers);
        return JSON.stringify(serialized);
    }
    deserialize(persisted) {
        try {
            const object = JSON.parse(persisted);
            for(const key in object){
                const { result: result, expirationTime: expirationTime, accessCount: accessCount } = object[key];
                this.map[key] = new $fc16ad90038db0a8$var$Entry({
                    result: Promise.resolve(result),
                    expirationTime: expirationTime,
                    accessCount: accessCount
                });
            }
        } catch (e) {
        // TODO: Log error via sentry
        }
    }
    isExpired(key) {
        const entry = this.map[key];
        return entry ? entry.isExpired() : true;
    }
    constructor(args = {}){
        this.map = void 0;
        this.expiration = void 0;
        const { expiration: expiration = $fc16ad90038db0a8$var$DEFAULT_EXPIRATION } = args;
        this.map = {};
        this.expiration = expiration;
    }
}
class $fc16ad90038db0a8$var$Entry {
    getResult() {
        this.accessCount++;
        return this.result;
    }
    isExpired() {
        return this.expirationTime < Date.now();
    }
    getExpirationTime() {
        return this.expirationTime;
    }
    getAccessCount() {
        return this.accessCount;
    }
    constructor({ result: result, expirationTime: expirationTime, accessCount: accessCount }){
        this.result = void 0;
        this.expirationTime = void 0;
        this.accessCount = void 0;
        this.result = result;
        this.expirationTime = expirationTime;
        this.accessCount = accessCount;
    }
}
const $fc16ad90038db0a8$export$8bedcca5bbd73999 = (args)=>{
    return new $fc16ad90038db0a8$var$Cache(args);
};

});


parcelRegister("h4mQ0", function(module, exports) {

$parcel$export(module.exports, "jiraFieldsQueryGenerator", () => $c59e27924968799d$export$42679f7213a051c);
const $c59e27924968799d$export$42679f7213a051c = ()=>{
    return `
	query SearchPageJiraFieldHydration (
		$issueKeys: [String!]!
		$cloudId: ID!
	) {
		jira {
			issuesByKey(cloudId: $cloudId, keys: $issueKeys) {
				id
				statusField {
					status {
						name
						statusCategory {
							colorName
						}
					}
				}
			}
		}
	}
	`;
};

});



parcelRegister("1yEFx", function(module, exports) {

$parcel$export(module.exports, "ProductKeys3P", () => $2acca743010e8c82$export$93aa518ca2694c2d);
$parcel$export(module.exports, "ProductKeys", () => $2acca743010e8c82$export$ef2c0ffddaaaf76c);
$parcel$export(module.exports, "allProductKeys", () => $2acca743010e8c82$export$73be91b73ebbdb05);
$parcel$export(module.exports, "all3pProductKeys", () => $2acca743010e8c82$export$57043b2770b3924d);
$parcel$export(module.exports, "all1pProductKeys", () => $2acca743010e8c82$export$225f36a2f261b1e7);
$parcel$export(module.exports, "is3pProductKey", () => $2acca743010e8c82$export$ae4856d6227d0649);
$parcel$export(module.exports, "PRODUCTS_ORDER", () => $2acca743010e8c82$export$64c23f2d9ef43822);
$parcel$export(module.exports, "PrimaryProductKeys", () => $2acca743010e8c82$export$15d12effc8830544);
$parcel$export(module.exports, "useProductConfigs", () => $2acca743010e8c82$export$e2c1afe0b1afaf49);
$parcel$export(module.exports, "MapProductToKnowledgeSources", () => $2acca743010e8c82$export$4fbc006e529fd6c0);

var $gwFzn = parcelRequire("gwFzn");

var $4Nwes = parcelRequire("4Nwes");
var $lAFHW = parcelRequire("lAFHW");

var $6LeZx = parcelRequire("6LeZx");

var $dJDhX = parcelRequire("dJDhX");

var $guzTv = parcelRequire("guzTv");

var $eQW47 = parcelRequire("eQW47");

var $g1L9J = parcelRequire("g1L9J");

var $lQxxH = parcelRequire("lQxxH");

var $7MUoO = parcelRequire("7MUoO");

var $foJyA = parcelRequire("foJyA");

var $hB77E = parcelRequire("hB77E");

var $9yyKc = parcelRequire("9yyKc");

var $9d1WC = parcelRequire("9d1WC");

var $aeVf1 = parcelRequire("aeVf1");

var $6ot6U = parcelRequire("6ot6U");

var $lWcry = parcelRequire("lWcry");

var $1ytgY = parcelRequire("1ytgY");

var $46Lo3 = parcelRequire("46Lo3");

var $fl27B = parcelRequire("fl27B");

var $bj3ok = parcelRequire("bj3ok");

var $itStc = parcelRequire("itStc");
const $2acca743010e8c82$var$ProductKeys1P = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Trello: 'trello',
    Focus: 'mercury'
};
const $2acca743010e8c82$export$93aa518ca2694c2d = (0, $hB77E.DO_NOT_IMPORT_ProductKeys3P);
const $2acca743010e8c82$export$ef2c0ffddaaaf76c = {
    ...$2acca743010e8c82$var$ProductKeys1P,
    ...(0, $hB77E.DO_NOT_IMPORT_ProductKeys3P)
};
const $2acca743010e8c82$export$73be91b73ebbdb05 = Object.values($2acca743010e8c82$export$ef2c0ffddaaaf76c);
const $2acca743010e8c82$export$57043b2770b3924d = Object.values((0, $hB77E.DO_NOT_IMPORT_ProductKeys3P));
const $2acca743010e8c82$export$225f36a2f261b1e7 = Object.values($2acca743010e8c82$var$ProductKeys1P);
const $2acca743010e8c82$export$65f9ab1ba49d5e68 = (key)=>$2acca743010e8c82$export$225f36a2f261b1e7.includes(key);
const $2acca743010e8c82$export$ae4856d6227d0649 = (key)=>$2acca743010e8c82$export$57043b2770b3924d.includes(key);
const $2acca743010e8c82$export$64c23f2d9ef43822 = [
    $2acca743010e8c82$export$ef2c0ffddaaaf76c.Confluence,
    $2acca743010e8c82$export$ef2c0ffddaaaf76c.Jira,
    $2acca743010e8c82$export$ef2c0ffddaaaf76c.JiraProductDiscovery,
    $2acca743010e8c82$export$ef2c0ffddaaaf76c.JiraServiceManagement,
    $2acca743010e8c82$export$ef2c0ffddaaaf76c.Atlas,
    $2acca743010e8c82$export$ef2c0ffddaaaf76c.Trello,
    $2acca743010e8c82$export$ef2c0ffddaaaf76c.Bitbucket,
    $2acca743010e8c82$export$ef2c0ffddaaaf76c.Compass,
    $2acca743010e8c82$export$ef2c0ffddaaaf76c.Focus,
    // ProductKeys.Opsgenie,
    ...(0, $hB77E.DO_NOT_IMPORT_ProductsOrder3P)
];
const $2acca743010e8c82$export$15d12effc8830544 = {
    // Fully supported as GA
    Atlas: 'townsquare',
    Confluence: 'confluence',
    // In development
    Assets: 'assets',
    Focus: 'mercury',
    Jira: 'jira',
    Elevate: 'elevate'
};
/**
 * This is the source of truth for the products that are supported in Full Page Search.
 * Note: there is additional logic in controllers/store/bootstrap/utils.ts for products being rolled out.
 *
 * For 3P products please see ./3p-product-configs
 */ const $2acca743010e8c82$var$products1P = {
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.Confluence]: {
        displayName: 'Confluence',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $9yyKc.getLogoVersion)((0, $guzTv.ConfluenceIcon), (0, $lAFHW.ConfluenceIcon)), 'Confluence'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $lWcry.ConfluenceSearchResultIcon), 'Confluence', 'large')
    },
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.Atlas]: {
        displayName: 'Home',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $4Nwes.AtlassianIcon), 'Home'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $9d1WC.AtlasSearchResultIcon), 'Home', 'large')
    },
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.Jira]: {
        displayName: 'Jira',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $9yyKc.getLogoVersion)((0, $g1L9J.JiraIcon), (0, $lAFHW.JiraIcon)), 'Jira'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $fl27B.JiraSearchResultIcon), 'Jira', 'large')
    },
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.JiraProductDiscovery]: {
        displayName: 'Jira Product Discovery',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $9yyKc.getLogoVersion)((0, $lQxxH.JiraProductDiscoveryIcon), (0, $lAFHW.JiraProductDiscoveryIcon)), 'Jira Product Discovery'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $46Lo3.JiraProductDiscoverySearchResultIcon), 'Jira Product Discovery', 'large')
    },
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.JiraServiceManagement]: {
        displayName: 'Jira Service Management',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $9yyKc.getLogoVersion)((0, $7MUoO.JiraServiceManagementIcon), (0, $lAFHW.JiraServiceManagementIcon)), 'Jira Service Management'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $bj3ok.JiraServiceManagementSearchResultIcon), 'Jira Service Management', 'large')
    },
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.Bitbucket]: {
        displayName: 'Bitbucket',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $9yyKc.getLogoVersion)((0, $6LeZx.BitbucketIcon), (0, $lAFHW.BitbucketIcon)), 'Bitbucket'),
        SearchResultIcon: (0, $9yyKc.getIconVersion)((0, $6LeZx.BitbucketIcon), (0, $aeVf1.BitbucketSearchResultIcon), 'Bitbucket', 'large')
    },
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.Trello]: {
        displayName: 'Trello',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $9yyKc.getLogoVersion)((0, $foJyA.TrelloIcon), (0, $lAFHW.TrelloIcon)), 'Trello'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $itStc.TrelloSearchResultIcon), 'Trello', 'large')
    },
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.Compass]: {
        displayName: 'Compass',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $9yyKc.getLogoVersion)((0, $dJDhX.CompassIcon), (0, $lAFHW.CompassIcon)), 'Compass'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $6ot6U.CompassSearchResultIcon), 'Compass', 'large')
    },
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.Focus]: {
        displayName: 'Focus',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $9yyKc.getLogoVersion)((0, $eQW47.FocusIcon), (0, $lAFHW.FocusIcon)), 'Focus'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $1ytgY.FocusSearchResultIcon), 'Focus', 'large')
    }
};
const $2acca743010e8c82$var$getProducts3PFromConfig = ()=>{
    // The use of Partial, the if (config) and the cast here are intentional TS gymnastics
    // We KNOW that this returns a config for all the ProductKeys3P, so we cast that
    // The TS compiler can't know that, and we'd be forced to write UI code like:
    //
    // const Icon = configs[productKey].Icon
    // return Icon && <Icon />
    //
    // Because TS can't prove productKey can be guaranteed to index into configs. But we know it can!
    const thirdPartyProducts = (0, $hB77E.ThirdPartyConfigs);
    const configs = {};
    $2acca743010e8c82$export$57043b2770b3924d.map((productKey3P)=>{
        const config = thirdPartyProducts.get(productKey3P);
        if (config) configs[productKey3P] = {
            displayName: config.displayName,
            Icon: config.icon,
            is3P: true,
            ...config.searchResultIcon && {
                SearchResultIcon: config.searchResultIcon
            }
        };
    });
    return configs;
};
const $2acca743010e8c82$export$e2c1afe0b1afaf49 = ()=>{
    return (0, $gwFzn.useMemo)(()=>{
        const thirdPartyProducts = $2acca743010e8c82$var$getProducts3PFromConfig();
        return {
            ...$2acca743010e8c82$var$products1P,
            ...thirdPartyProducts
        };
    }, []);
};
const $2acca743010e8c82$export$ede9abe489c9321b = (productKey)=>{
    return $2acca743010e8c82$export$e2c1afe0b1afaf49()[productKey];
};
// Used by SAIN to detrermine knowledge source filtering
var $2acca743010e8c82$var$KnowledgeSourceTypeValues = /*#__PURE__*/ function(KnowledgeSourceTypeValues) {
    KnowledgeSourceTypeValues["GITHUB"] = "github";
    KnowledgeSourceTypeValues["CONFLUENCE"] = "confluence";
    KnowledgeSourceTypeValues["JIRA"] = "jira";
    KnowledgeSourceTypeValues["ATLAS"] = "atlas";
    KnowledgeSourceTypeValues["HELP_AGGREGATOR"] = "help_aggregator";
    KnowledgeSourceTypeValues["GOOGLE_DRIVE"] = "google_drive";
    KnowledgeSourceTypeValues["MICROSOFT_SHAREPOINT"] = "microsoft_sharepoint";
    KnowledgeSourceTypeValues["SLACK"] = "slack";
    KnowledgeSourceTypeValues["MICROSOFT_TEAMS"] = "teams";
    KnowledgeSourceTypeValues["FIGMA"] = "figma";
    KnowledgeSourceTypeValues["CONFLUENCE_DC"] = "confluence-dc";
    KnowledgeSourceTypeValues["ATLASSIAN_WEB_CRAWLER"] = "atlassian-web-crawler";
    KnowledgeSourceTypeValues["LOOM"] = "loom";
    return KnowledgeSourceTypeValues;
}($2acca743010e8c82$var$KnowledgeSourceTypeValues || {});
const $2acca743010e8c82$export$4fbc006e529fd6c0 = {
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.Confluence]: "confluence",
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.Github]: "github",
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.Jira]: "jira",
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.Atlas]: "atlas",
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.GoogleDrive]: "google_drive",
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.Sharepoint]: "microsoft_sharepoint",
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.Slack]: "slack",
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.Teams]: "teams",
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.Figma]: "figma",
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.ConfluenceDC]: "confluence-dc",
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.AtlassianWebCrawler]: "atlassian-web-crawler",
    [$2acca743010e8c82$export$ef2c0ffddaaaf76c.Loom]: "loom"
};

});
parcelRegister("hB77E", function(module, exports) {

$parcel$export(module.exports, "ProductKeys3P", () => $4c19e47379f12858$export$93aa518ca2694c2d);
$parcel$export(module.exports, "ThirdPartyConfigs", () => $4c19e47379f12858$export$f7937c5f282f2571);
$parcel$export(module.exports, "BulkConnectProductOrder3P", () => $4c19e47379f12858$export$8753afadfd65ab0d);
$parcel$export(module.exports, "DO_NOT_IMPORT_ProductKeys3P", () => $4c19e47379f12858$export$1242fc8c436d51cf);
$parcel$export(module.exports, "DO_NOT_IMPORT_ProductsOrder3P", () => $4c19e47379f12858$export$9d22c431a2a02e31);

var $5rWtw = parcelRequire("5rWtw");

var $7jnfW = parcelRequire("7jnfW");

var $ecVyn = parcelRequire("ecVyn");

var $8DeZp = parcelRequire("8DeZp");

var $hLggb = parcelRequire("hLggb");

var $iPM8b = parcelRequire("iPM8b");

var $9zZIW = parcelRequire("9zZIW");

var $1254m = parcelRequire("1254m");

var $63TuK = parcelRequire("63TuK");

var $d44Rd = parcelRequire("d44Rd");

var $eBcqb = parcelRequire("eBcqb");

var $2Dcfm = parcelRequire("2Dcfm");

var $69cVS = parcelRequire("69cVS");

var $lFG0w = parcelRequire("lFG0w");

var $jEre1 = parcelRequire("jEre1");

var $7qxEX = parcelRequire("7qxEX");

var $ka78Z = parcelRequire("ka78Z");

var $D1Pzo = parcelRequire("D1Pzo");

var $eOOLq = parcelRequire("eOOLq");

var $kFIbV = parcelRequire("kFIbV");

var $6TSwY = parcelRequire("6TSwY");

var $hoqCT = parcelRequire("hoqCT");

var $4bMCY = parcelRequire("4bMCY");

var $7KevC = parcelRequire("7KevC");

var $i3Awy = parcelRequire("i3Awy");

var $3cOLO = parcelRequire("3cOLO");

var $a9AeJ = parcelRequire("a9AeJ");

var $4jyR1 = parcelRequire("4jyR1");

var $i5z78 = parcelRequire("i5z78");

var $dTjb3 = parcelRequire("dTjb3");

var $l1ZKm = parcelRequire("l1ZKm");

var $AHfI3 = parcelRequire("AHfI3");

var $4bZD7 = parcelRequire("4bZD7");

var $7ndEw = parcelRequire("7ndEw");

var $iAV9u = parcelRequire("iAV9u");

var $9QXBv = parcelRequire("9QXBv");

var $brQSC = parcelRequire("brQSC");

var $d2ZeT = parcelRequire("d2ZeT");

var $71C17 = parcelRequire("71C17");

var $9T8Zq = parcelRequire("9T8Zq");

var $3r3f3 = parcelRequire("3r3f3");

var $hGmpG = parcelRequire("hGmpG");

var $7k5Lz = parcelRequire("7k5Lz");

var $kdE7v = parcelRequire("kdE7v");

var $hXBdi = parcelRequire("hXBdi");

var $fsmrz = parcelRequire("fsmrz");

var $aBMKY = parcelRequire("aBMKY");

var $6XnCS = parcelRequire("6XnCS");

var $aaBRD = parcelRequire("aaBRD");

var $lOZuj = parcelRequire("lOZuj");

var $lHXnq = parcelRequire("lHXnq");
const $4c19e47379f12858$export$93aa518ca2694c2d = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3'
};
const $4c19e47379f12858$export$f7937c5f282f2571 = new Map([
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.AtlassianWebCrawler,
        (0, $9zZIW.atlassianWebCrawlerConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Figma,
        (0, $ka78Z.figmaConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Github,
        (0, $kFIbV.githubConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.GoogleDrive,
        (0, $4bMCY.googleDriveConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Sharepoint,
        (0, $7k5Lz.sharepointConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Loom,
        (0, $4jyR1.loomConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.OneDrive,
        (0, $7ndEw.oneDriveConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Dropbox,
        (0, $7qxEX.dropboxConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Slack,
        (0, $kdE7v.slackConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Teams,
        (0, $aBMKY.teamsConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.GoogleCalendar,
        (0, $7KevC.googleCalendarConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Gmail,
        (0, $hoqCT.gmailConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.OutlookCalendar,
        (0, $iAV9u.outlookCalendarConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.OutlookMail,
        (0, $9QXBv.outlookMail)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Asana,
        (0, $iPM8b.asanaConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Zendesk,
        (0, $lOZuj.zendeskConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Airtable,
        (0, $8DeZp.airtableConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Smartsheet,
        (0, $hXBdi.smartsheetConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Notion,
        (0, $4bZD7.notionConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Miro,
        (0, $dTjb3.miroConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Docusign,
        (0, $lFG0w.docusignConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Lucid,
        (0, $i5z78.lucidConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Monday,
        (0, $l1ZKm.mondayConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.AzureDevops,
        (0, $63TuK.azureDevopsConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Gitlab,
        (0, $6TSwY.gitlabConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.ConfluenceDC,
        (0, $69cVS.confluenceDCConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Canva,
        (0, $eBcqb.canvaConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Box,
        (0, $d44Rd.boxConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Zeplin,
        (0, $lHXnq.zeplinConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.ServiceNow,
        (0, $hGmpG.serviceNowConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Freshservice,
        (0, $D1Pzo.freshserviceConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.PowerBI,
        (0, $71C17.powerBIConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.ClickUp,
        (0, $2Dcfm.clickUpConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Amplitude,
        (0, $hLggb.amplitudeConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Stripe,
        (0, $fsmrz.stripeConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.AdobeXD,
        (0, $7jnfW.adobeXDConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Aha,
        (0, $ecVyn.ahaConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.AdobeSign,
        (0, $5rWtw.adobeSignConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Mural,
        (0, $AHfI3.muralConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Webex,
        (0, $aaBRD.webexConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Todoist,
        (0, $6XnCS.todoistConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.PagerDuty,
        (0, $brQSC.pagerDutyConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Pipedrive,
        (0, $d2ZeT.pipedriveConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Hubspot,
        (0, $i3Awy.hubSpotConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Dovetail,
        (0, $jEre1.dovetailConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.LaunchDarkly,
        (0, $a9AeJ.launchDarklyConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Salesforce,
        (0, $9T8Zq.salesforceConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Sentry,
        (0, $3r3f3.sentryConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.JiraDC,
        (0, $3cOLO.jiraDCConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.Gitbook,
        (0, $eOOLq.gitbookConfig)
    ],
    [
        $4c19e47379f12858$export$93aa518ca2694c2d.AWSS3,
        (0, $1254m.awss3Config)
    ]
]);
const $4c19e47379f12858$var$ProductsOrder3P = [
    // // Loom is actually a 1P so goes to the top
    $4c19e47379f12858$export$93aa518ca2694c2d.Loom,
    // Eventually this might be "smart"
    // For now this static order isn't strongly defined
    $4c19e47379f12858$export$93aa518ca2694c2d.GoogleDrive,
    $4c19e47379f12858$export$93aa518ca2694c2d.Sharepoint,
    $4c19e47379f12858$export$93aa518ca2694c2d.OneDrive,
    $4c19e47379f12858$export$93aa518ca2694c2d.Dropbox,
    $4c19e47379f12858$export$93aa518ca2694c2d.Slack,
    $4c19e47379f12858$export$93aa518ca2694c2d.Teams,
    $4c19e47379f12858$export$93aa518ca2694c2d.Github,
    $4c19e47379f12858$export$93aa518ca2694c2d.Figma,
    $4c19e47379f12858$export$93aa518ca2694c2d.GoogleCalendar,
    $4c19e47379f12858$export$93aa518ca2694c2d.Gmail,
    $4c19e47379f12858$export$93aa518ca2694c2d.OutlookCalendar,
    $4c19e47379f12858$export$93aa518ca2694c2d.OutlookMail,
    $4c19e47379f12858$export$93aa518ca2694c2d.Airtable,
    $4c19e47379f12858$export$93aa518ca2694c2d.Smartsheet,
    $4c19e47379f12858$export$93aa518ca2694c2d.Asana,
    $4c19e47379f12858$export$93aa518ca2694c2d.Zendesk,
    $4c19e47379f12858$export$93aa518ca2694c2d.Miro,
    $4c19e47379f12858$export$93aa518ca2694c2d.Docusign,
    $4c19e47379f12858$export$93aa518ca2694c2d.Lucid,
    $4c19e47379f12858$export$93aa518ca2694c2d.Monday,
    $4c19e47379f12858$export$93aa518ca2694c2d.AzureDevops,
    $4c19e47379f12858$export$93aa518ca2694c2d.Gitlab,
    $4c19e47379f12858$export$93aa518ca2694c2d.ConfluenceDC,
    $4c19e47379f12858$export$93aa518ca2694c2d.Canva,
    $4c19e47379f12858$export$93aa518ca2694c2d.Box,
    $4c19e47379f12858$export$93aa518ca2694c2d.Zeplin,
    $4c19e47379f12858$export$93aa518ca2694c2d.ServiceNow,
    $4c19e47379f12858$export$93aa518ca2694c2d.Freshservice,
    $4c19e47379f12858$export$93aa518ca2694c2d.PowerBI,
    $4c19e47379f12858$export$93aa518ca2694c2d.ClickUp,
    $4c19e47379f12858$export$93aa518ca2694c2d.Amplitude,
    $4c19e47379f12858$export$93aa518ca2694c2d.Stripe,
    $4c19e47379f12858$export$93aa518ca2694c2d.AdobeXD,
    $4c19e47379f12858$export$93aa518ca2694c2d.Aha,
    $4c19e47379f12858$export$93aa518ca2694c2d.AdobeSign,
    $4c19e47379f12858$export$93aa518ca2694c2d.Mural,
    $4c19e47379f12858$export$93aa518ca2694c2d.Webex,
    $4c19e47379f12858$export$93aa518ca2694c2d.PagerDuty,
    $4c19e47379f12858$export$93aa518ca2694c2d.Pipedrive,
    $4c19e47379f12858$export$93aa518ca2694c2d.Dovetail,
    $4c19e47379f12858$export$93aa518ca2694c2d.LaunchDarkly,
    $4c19e47379f12858$export$93aa518ca2694c2d.Salesforce,
    $4c19e47379f12858$export$93aa518ca2694c2d.Sentry,
    $4c19e47379f12858$export$93aa518ca2694c2d.Gitbook,
    $4c19e47379f12858$export$93aa518ca2694c2d.AWSS3,
    // New 3P? Add it here
    // Always last
    $4c19e47379f12858$export$93aa518ca2694c2d.AtlassianWebCrawler
];
const $4c19e47379f12858$export$8753afadfd65ab0d = [
    $4c19e47379f12858$export$93aa518ca2694c2d.GoogleDrive,
    $4c19e47379f12858$export$93aa518ca2694c2d.Slack,
    $4c19e47379f12858$export$93aa518ca2694c2d.Sharepoint,
    $4c19e47379f12858$export$93aa518ca2694c2d.Github,
    $4c19e47379f12858$export$93aa518ca2694c2d.Teams,
    $4c19e47379f12858$export$93aa518ca2694c2d.OneDrive,
    $4c19e47379f12858$export$93aa518ca2694c2d.Notion,
    $4c19e47379f12858$export$93aa518ca2694c2d.Asana,
    $4c19e47379f12858$export$93aa518ca2694c2d.Zendesk,
    $4c19e47379f12858$export$93aa518ca2694c2d.Miro,
    $4c19e47379f12858$export$93aa518ca2694c2d.Gitlab,
    $4c19e47379f12858$export$93aa518ca2694c2d.Monday,
    $4c19e47379f12858$export$93aa518ca2694c2d.Smartsheet,
    $4c19e47379f12858$export$93aa518ca2694c2d.ServiceNow,
    $4c19e47379f12858$export$93aa518ca2694c2d.Figma,
    $4c19e47379f12858$export$93aa518ca2694c2d.AzureDevops,
    $4c19e47379f12858$export$93aa518ca2694c2d.Notion,
    $4c19e47379f12858$export$93aa518ca2694c2d.Dropbox,
    $4c19e47379f12858$export$93aa518ca2694c2d.Lucid,
    $4c19e47379f12858$export$93aa518ca2694c2d.Box,
    $4c19e47379f12858$export$93aa518ca2694c2d.Airtable,
    $4c19e47379f12858$export$93aa518ca2694c2d.Docusign,
    $4c19e47379f12858$export$93aa518ca2694c2d.Gmail,
    //ProductKeys3P.Workday,
    $4c19e47379f12858$export$93aa518ca2694c2d.Aha,
    $4c19e47379f12858$export$93aa518ca2694c2d.AdobeSign,
    $4c19e47379f12858$export$93aa518ca2694c2d.GoogleCalendar,
    $4c19e47379f12858$export$93aa518ca2694c2d.OutlookMail,
    $4c19e47379f12858$export$93aa518ca2694c2d.OutlookCalendar,
    $4c19e47379f12858$export$93aa518ca2694c2d.AtlassianWebCrawler,
    $4c19e47379f12858$export$93aa518ca2694c2d.JiraDC,
    $4c19e47379f12858$export$93aa518ca2694c2d.ConfluenceDC,
    //ProductKeys3P.Loom,
    //New Full Fledged 3P Connector? Add it here in alphabetical order
    $4c19e47379f12858$export$93aa518ca2694c2d.PowerBI,
    $4c19e47379f12858$export$93aa518ca2694c2d.AdobeXD,
    $4c19e47379f12858$export$93aa518ca2694c2d.Salesforce,
    $4c19e47379f12858$export$93aa518ca2694c2d.Canva,
    $4c19e47379f12858$export$93aa518ca2694c2d.Stripe,
    $4c19e47379f12858$export$93aa518ca2694c2d.Mural,
    $4c19e47379f12858$export$93aa518ca2694c2d.Amplitude,
    $4c19e47379f12858$export$93aa518ca2694c2d.Pipedrive,
    $4c19e47379f12858$export$93aa518ca2694c2d.Dovetail,
    $4c19e47379f12858$export$93aa518ca2694c2d.Webex,
    $4c19e47379f12858$export$93aa518ca2694c2d.PagerDuty,
    $4c19e47379f12858$export$93aa518ca2694c2d.Todoist,
    $4c19e47379f12858$export$93aa518ca2694c2d.LaunchDarkly,
    $4c19e47379f12858$export$93aa518ca2694c2d.Hubspot,
    $4c19e47379f12858$export$93aa518ca2694c2d.Sentry,
    $4c19e47379f12858$export$93aa518ca2694c2d.Zeplin,
    $4c19e47379f12858$export$93aa518ca2694c2d.ClickUp
];
const $4c19e47379f12858$export$1242fc8c436d51cf = $4c19e47379f12858$export$93aa518ca2694c2d;
const $4c19e47379f12858$export$9d22c431a2a02e31 = $4c19e47379f12858$var$ProductsOrder3P;

});
parcelRegister("5rWtw", function(module, exports) {

$parcel$export(module.exports, "adobeSignConfig", () => $66e851fe802529fd$export$8130889f372e8ca5);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $cUGf9 = parcelRequire("cUGf9");

var $BqBqQ = parcelRequire("BqBqQ");
const $66e851fe802529fd$export$8130889f372e8ca5 = {
    displayName: 'Adobe Sign',
    id: 'adobe-sign',
    resourceType: 'adobe-sign-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $cUGf9.AdobeSignIcon), 'Adobe Sign', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $BqBqQ.AdobeSignSearchResultIcon), 'Adobe Sign', 'large'),
    integrationAri: 'ari:cloud:platform::integration/adobe',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("idpYy", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI", () => $d26db4dd231f5f64$export$d520529b4595d46c);
$parcel$export(module.exports, "DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI", () => $d26db4dd231f5f64$export$8bd7fa13a82672fe);
$parcel$export(module.exports, "DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI", () => $d26db4dd231f5f64$export$a752b216a5b9069f);
$parcel$export(module.exports, "DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI", () => $d26db4dd231f5f64$export$9d37c36d8b43baee);
$parcel$export(module.exports, "DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI", () => $d26db4dd231f5f64$export$a3d7cddace4fe237);
$parcel$export(module.exports, "DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI", () => $d26db4dd231f5f64$export$1e3b02869b42f77a);
$parcel$export(module.exports, "DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI", () => $d26db4dd231f5f64$export$4e0eae9edc1a8907);
$parcel$export(module.exports, "DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI", () => $d26db4dd231f5f64$export$d810eae89914369b);
$parcel$export(module.exports, "DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI", () => $d26db4dd231f5f64$export$1dc2d469fb044d48);
$parcel$export(module.exports, "DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI", () => $d26db4dd231f5f64$export$733c2acb2513a07a);
$parcel$export(module.exports, "DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI", () => $d26db4dd231f5f64$export$c28231fcae6448eb);
$parcel$export(module.exports, "DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI", () => $d26db4dd231f5f64$export$3268f1527392e5ac);
$parcel$export(module.exports, "DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI", () => $d26db4dd231f5f64$export$3e5409bef2addb56);
$parcel$export(module.exports, "DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI", () => $d26db4dd231f5f64$export$7bf025ec33e76761);
$parcel$export(module.exports, "DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI", () => $d26db4dd231f5f64$export$3f89e5cd56d4a568);
$parcel$export(module.exports, "DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI", () => $d26db4dd231f5f64$export$13c55dcee8605c46);
$parcel$export(module.exports, "DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI", () => $d26db4dd231f5f64$export$8dd471de1c2be682);
$parcel$export(module.exports, "CONFLUENCE_CALENDAR_ENTITY_ATI", () => $d26db4dd231f5f64$export$fd9583608bfd5225);
$parcel$export(module.exports, "CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI", () => $d26db4dd231f5f64$export$842fc5f4c9a103cc);
$parcel$export(module.exports, "CONFLUENCE_ANSWER_ENTITY_ATI", () => $d26db4dd231f5f64$export$85fae06d428ca65d);
$parcel$export(module.exports, "CONFLUENCE_QUESTION_ENTITY_ATI", () => $d26db4dd231f5f64$export$de533c0a50cfcba1);
$parcel$export(module.exports, "CONFLUENCE_GLIFFY_ENTITY_ATI", () => $d26db4dd231f5f64$export$bcdd6265f8049b41);
$parcel$export(module.exports, "JIRA_ISSUE_ENTITY_ATI", () => $d26db4dd231f5f64$export$4fb210ecd60bcccb);
$parcel$export(module.exports, "JIRA_PROJECT_ENTITY_ATI", () => $d26db4dd231f5f64$export$2d84b48cf0a2eca6);
$parcel$export(module.exports, "FEDERATED_GOOGLE_EMAIL_ENTITY_ATI", () => $d26db4dd231f5f64$export$6ec0530ffade9ab0);
$parcel$export(module.exports, "FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI", () => $d26db4dd231f5f64$export$dfd3b612305212b4);
$parcel$export(module.exports, "DEFAULT_ENTITY_ATI", () => $d26db4dd231f5f64$export$18938ead1fad4569);
$parcel$export(module.exports, "RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS", () => $d26db4dd231f5f64$export$423da9b1dcd76b7);
$parcel$export(module.exports, "RESULT_LIMIT_FOR_SINGLE_PRODUCT", () => $d26db4dd231f5f64$export$405ff9c6ee9ee7de);
const $d26db4dd231f5f64$export$c87d62ed9387fa60 = [
    'ati:cloud:townsquare:project',
    'ati:cloud:townsquare:goal',
    'ati:cloud:townsquare:tag'
];
const $d26db4dd231f5f64$export$e5280e1b46081838 = [
    'ati:cloud:mercury:focus-area',
    'ati:cloud:mercury:focus-area-status-update'
];
const $d26db4dd231f5f64$export$d520529b4595d46c = [
    'ati:cloud:graph:document'
];
const $d26db4dd231f5f64$export$8bd7fa13a82672fe = [
    'ati:cloud:graph:message'
];
const $d26db4dd231f5f64$export$a752b216a5b9069f = [
    'ati:cloud:graph:conversation'
];
const $d26db4dd231f5f64$export$9d37c36d8b43baee = [
    'ati:cloud:graph:design'
];
const $d26db4dd231f5f64$export$a3d7cddace4fe237 = [
    'ati:cloud:graph:video'
];
const $d26db4dd231f5f64$export$1e3b02869b42f77a = [
    'ati:cloud:graph:space'
];
const $d26db4dd231f5f64$export$4e0eae9edc1a8907 = [
    'ati:cloud:graph:comment'
];
const $d26db4dd231f5f64$export$d810eae89914369b = [
    'ati:cloud:graph:work-item'
];
const $d26db4dd231f5f64$export$1dc2d469fb044d48 = [
    'ati:cloud:graph:remote-link'
];
const $d26db4dd231f5f64$export$733c2acb2513a07a = [
    'ati:cloud:graph:calendar-event'
];
const $d26db4dd231f5f64$export$c28231fcae6448eb = [
    'ati:cloud:graph:repository'
];
const $d26db4dd231f5f64$export$3268f1527392e5ac = [
    'ati:cloud:graph:pull-request'
];
const $d26db4dd231f5f64$export$3e5409bef2addb56 = [
    'ati:cloud:graph:commit'
];
const $d26db4dd231f5f64$export$7bf025ec33e76761 = [
    'ati:cloud:graph:branch'
];
const $d26db4dd231f5f64$export$3f89e5cd56d4a568 = [
    'ati:cloud:graph:project'
];
const $d26db4dd231f5f64$export$13c55dcee8605c46 = [
    'ati:cloud:graph:deal'
];
const $d26db4dd231f5f64$export$8dd471de1c2be682 = [
    'ati:cloud:graph:customer-org'
];
const $d26db4dd231f5f64$export$2113db8105db1e2f = 'ati:cloud:confluence:';
const $d26db4dd231f5f64$export$c07a1c127052b557 = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:space',
    'ati:cloud:confluence:whiteboard'
];
const $d26db4dd231f5f64$export$1d1f9443ac350d6f = [
    'ati:cloud:confluence:comment',
    'ati:cloud:confluence:database',
    'ati:cloud:confluence:embed',
    'ati:cloud:confluence:folder'
];
const $d26db4dd231f5f64$export$fd9583608bfd5225 = 'confluence.com.atlassian.confluence.extra.team-calendars:calendar-content-type';
const $d26db4dd231f5f64$export$842fc5f4c9a103cc = 'confluence.com.atlassian.confluence.extra.team-calendars:space-calendars-view-content-type';
const $d26db4dd231f5f64$export$85fae06d428ca65d = 'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:answer';
const $d26db4dd231f5f64$export$de533c0a50cfcba1 = 'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:question';
const $d26db4dd231f5f64$export$bcdd6265f8049b41 = 'confluence.ac:com.gliffy.integration.confluence:gliffy-diagram';
const $d26db4dd231f5f64$export$4fb210ecd60bcccb = 'ati:cloud:jira:issue';
const $d26db4dd231f5f64$export$2d84b48cf0a2eca6 = 'ati:cloud:jira:project';
const $d26db4dd231f5f64$export$b4a7e1c18385196d = [
    $d26db4dd231f5f64$export$2d84b48cf0a2eca6,
    $d26db4dd231f5f64$export$4fb210ecd60bcccb
];
const $d26db4dd231f5f64$export$6ec0530ffade9ab0 = 'ati:third-party:google:email';
const $d26db4dd231f5f64$export$dfd3b612305212b4 = 'ati:third-party:microsoft:email';
const $d26db4dd231f5f64$export$50adf3273cb5cdeb = [
    $d26db4dd231f5f64$export$6ec0530ffade9ab0,
    $d26db4dd231f5f64$export$dfd3b612305212b4
];
const $d26db4dd231f5f64$export$d3361702bd2fd562 = [
    'message'
];
const $d26db4dd231f5f64$export$18938ead1fad4569 = [
    ...$d26db4dd231f5f64$export$c87d62ed9387fa60,
    ...$d26db4dd231f5f64$export$c07a1c127052b557,
    ...$d26db4dd231f5f64$export$b4a7e1c18385196d,
    ...$d26db4dd231f5f64$export$e5280e1b46081838
];
const $d26db4dd231f5f64$export$423da9b1dcd76b7 = 15;
const $d26db4dd231f5f64$export$405ff9c6ee9ee7de = 30;

});

parcelRegister("2Znam", function(module, exports) {

$parcel$export(module.exports, "TypeFilterValueKey", () => $1bd00f711ef18555$export$49f6cbb853d30562);
$parcel$export(module.exports, "allTypeFilterValueKeys", () => $1bd00f711ef18555$export$e01073b80ff953d5);
$parcel$export(module.exports, "NounSubtypeKey", () => $1bd00f711ef18555$export$1f2db89e0caa00c9);
const $1bd00f711ef18555$export$49f6cbb853d30562 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    Repository: 'repository',
    PullRequest: 'pull-request',
    Branch: 'branch',
    Commit: 'commit',
    WebPage: 'web-page',
    Conversation: 'conversation',
    Message: 'message',
    Video: 'video',
    Design: 'design',
    Page: 'page',
    Blogpost: 'blogpost',
    Attachment: 'attachment',
    Space: 'space',
    Whiteboard: 'whiteboard',
    Comment: 'comment',
    Database: 'database',
    Embed: 'embed',
    Folder: 'folder',
    Calendar: 'calendar',
    SpaceCalendar: 'space-calendar',
    Question: 'question',
    Answer: 'answer',
    Issue: 'issue',
    Component: 'component',
    Card: 'card',
    Project: 'project',
    Goal: 'goal',
    Tag: 'tag',
    WorkItem: 'work-item',
    Incident: 'incident',
    FocusArea: 'focus-area',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal',
    Gliffy: 'gliffy',
    CustomerOrg: 'customer-org'
};
const $1bd00f711ef18555$export$e01073b80ff953d5 = Object.values($1bd00f711ef18555$export$49f6cbb853d30562);
const $1bd00f711ef18555$export$1f2db89e0caa00c9 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    File: 'file',
    Database: 'database',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Design: 'design',
    Deal: 'deal',
    Video: 'video',
    Task: 'task',
    Issue: 'issue',
    Space: 'space',
    Project: 'project',
    Repository: 'repository',
    CustomerOrg: 'customer-org',
    Image: 'image',
    Archive: 'archive',
    Audio: 'audio',
    Code: 'code',
    Pdf: 'pdf',
    Other: 'other'
};

});

parcelRegister("9yyKc", function(module, exports) {

$parcel$export(module.exports, "RovoLogoFromGlyph", () => $a72f5a493e80638f$export$7b66a86355afbb91);
$parcel$export(module.exports, "RovoLogoFromSVG", () => $a72f5a493e80638f$export$dae027fade2c6d1d);
$parcel$export(module.exports, "RovoLogoFromLogo", () => $a72f5a493e80638f$export$32db889b380fa03c);
$parcel$export(module.exports, "get3PLogo", () => $a72f5a493e80638f$export$fab9faef3411dc6c);
$parcel$export(module.exports, "getLogoVersion", () => $a72f5a493e80638f$export$f2e275790a265e16);
$parcel$export(module.exports, "getIconVersion", () => $a72f5a493e80638f$export$2e76137c189bce0c);
/**
 * A RovoLogo is a subset API that works for both @atlaskit/logo and @atlaskit/icon
 * We use one or the other depending on 1P or 3P and need a consistent API internall
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $id7ja = parcelRequire("id7ja");

var $dh538 = parcelRequire("dh538");

var $20E4R = parcelRequire("20E4R");
/**
 * Due a bug in ADS custom icons are one size smaller (than atlaskit/logo)
 * To accommodate for this behavior you need to use one size bigger than what you need
 * See: https://atlassian.slack.com/archives/CFJ9DU39U/p1714096323217799
 */ const $a72f5a493e80638f$var$correctedSize = {
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};
const $a72f5a493e80638f$export$7b66a86355afbb91 = (glyph, defaultLabel = '', defaultSize)=>{
    return ({ size: size = defaultSize, label: label = defaultLabel, testId: testId })=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $id7ja.default), {
            label: label,
            testId: testId,
            glyph: glyph,
            size: size ? $a72f5a493e80638f$var$correctedSize[size] : defaultSize
        });
    };
};
const $a72f5a493e80638f$export$dae027fade2c6d1d = (glyph, defaultLabel = '', defaultSize)=>{
    return ({ label: label = defaultLabel, size: size = defaultSize, testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $20E4R.SVGIcon), {
            label: label,
            glyph: glyph,
            size: size ? $a72f5a493e80638f$var$correctedSize[size] : 'medium'
        });
};
const $a72f5a493e80638f$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'medium',
            appearance: "brand"
        });
    };
};
function $a72f5a493e80638f$export$fab9faef3411dc6c(iconGlyph, iconLabel, size) {
    return (0, $dh538.fg)('rovo_search_custom_icon_component') ? $a72f5a493e80638f$export$dae027fade2c6d1d(iconGlyph, iconLabel, size) : $a72f5a493e80638f$export$7b66a86355afbb91(iconGlyph, iconLabel);
}
function $a72f5a493e80638f$export$f2e275790a265e16(t25LogoComponent, LogoComponent) {
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? t25LogoComponent : LogoComponent;
}
function $a72f5a493e80638f$export$2e76137c189bce0c(t25Component, svgComponent, iconLabel, size) {
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? $a72f5a493e80638f$export$32db889b380fa03c(t25Component, size) : $a72f5a493e80638f$export$fab9faef3411dc6c(svgComponent, iconLabel, size);
}

});
parcelRegister("20E4R", function(module, exports) {

$parcel$export(module.exports, "SVGIcon", () => $b9faf8c762554e25$export$1776e6671850176d);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $b9faf8c762554e25$var$iconContainerStyles = {
    small: (0, $ecnYn.xcss)({
        width: '16px',
        height: '16px'
    }),
    medium: (0, $ecnYn.xcss)({
        width: '24px',
        height: '24px'
    }),
    large: (0, $ecnYn.xcss)({
        width: '40px',
        height: '40px'
    }),
    xlarge: (0, $ecnYn.xcss)({
        width: '48px',
        height: '48px'
    })
};
const $b9faf8c762554e25$var$t25IconContainerStyles = {
    small: (0, $ecnYn.xcss)({
        width: '16px',
        height: '16px'
    }),
    medium: (0, $ecnYn.xcss)({
        width: '24px',
        height: '24px'
    }),
    large: (0, $ecnYn.xcss)({
        width: '32px',
        height: '32px'
    }),
    //t25 tile icons do not get bumped up to 40/48px to avoid additional padding
    xlarge: (0, $ecnYn.xcss)({
        width: '32x',
        height: '32px'
    })
};
const $b9faf8c762554e25$var$iconStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $b9faf8c762554e25$export$1776e6671850176d = ({ glyph: SVG, label: label, size: size })=>{
    const useT25Styles = (0, $dh538.fg)('platform-team25-app-icon-tiles');
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: [
            useT25Styles ? $b9faf8c762554e25$var$t25IconContainerStyles[size] : $b9faf8c762554e25$var$iconContainerStyles[size],
            $b9faf8c762554e25$var$iconStyles
        ],
        "aria-label": label,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)(SVG, {})
    });
};

});


parcelRegister("cUGf9", function(module, exports) {

$parcel$export(module.exports, "AdobeSignIcon", () => $6ae04d3601d944f0$export$600af2172b0f5fb);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $6ae04d3601d944f0$export$600af2172b0f5fb = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-19.5",
                y: "-166.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#584CCC"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M25.7066 18.7523C25.0666 18.0399 23.8399 17.7112 22.0799 17.7112C21.1199 17.7112 20.1066 17.8208 19.1466 17.9852C18.5066 17.3824 17.9732 16.6701 17.4399 15.9578C17.0666 15.4099 16.6932 14.8619 16.3732 14.2592C16.9066 12.725 17.2266 11.0812 17.3332 9.43743C17.3332 7.95802 16.7466 6.36902 15.1466 6.36902C14.6132 6.36902 14.0799 6.69778 13.8132 7.19091C13.1199 8.39636 13.3866 10.8621 14.5066 13.4373C14.1332 14.588 13.7066 15.7386 13.2266 16.9989C12.7999 18.0947 12.3199 19.1358 11.7332 20.1221C10.0799 20.7796 6.61323 22.4234 6.29323 24.2316C6.18656 24.7795 6.34656 25.3274 6.77323 25.6562C7.14656 25.9849 7.6799 26.2041 8.21323 26.1493C10.2932 26.1493 12.3732 23.1905 13.8132 20.6152C14.6132 20.3413 15.4132 20.0673 16.2666 19.8481C17.1732 19.6289 18.0266 19.4098 18.8266 19.2454C21.0666 21.2179 23.0399 21.5467 23.9999 21.5467C25.3332 21.5467 25.8666 20.944 26.0266 20.4508C26.2399 19.8481 26.1332 19.1906 25.7066 18.7523ZM24.2666 19.7933C24.2132 20.1769 23.7866 20.4508 23.2532 20.4508C23.0932 20.4508 22.9332 20.4508 22.7732 20.396C21.7066 20.1221 20.6932 19.5742 19.8399 18.8618C20.5332 18.7523 21.2799 18.6975 21.9732 18.6975C22.4532 18.6975 22.9332 18.7523 23.4132 18.807C23.8932 18.9166 24.4266 19.1358 24.2666 19.7933ZM14.7199 7.68405C14.8266 7.51967 14.9866 7.41009 15.1999 7.35529C15.7332 7.35529 15.8399 7.95802 15.8399 8.50595C15.7866 9.76619 15.5732 10.9716 15.1999 12.1771C14.2932 9.82098 14.3999 8.23198 14.7199 7.68405ZM17.7066 18.2043C17.1199 18.3139 16.5332 18.4783 15.9466 18.6427C15.5199 18.7523 15.0932 18.9166 14.6132 19.0262C14.8266 18.5331 15.0399 18.0399 15.2532 17.6016C15.5199 16.9989 15.7332 16.3962 15.9466 15.7934C16.1599 16.1222 16.3199 16.3962 16.5332 16.6701C16.9066 17.218 17.3332 17.7112 17.7066 18.2043ZM11.2532 21.3823C9.9199 23.574 8.58656 24.9987 7.8399 24.9987C7.73323 24.9987 7.57323 24.9439 7.5199 24.8891C7.3599 24.7795 7.30656 24.5603 7.3599 24.3959C7.46656 23.574 9.01323 22.4234 11.2532 21.3823Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.82667 4H17.1733C18.72 4 20 5.28 20 6.82667V16.7467C20 18.32 18.72 19.5733 17.1733 19.5733H6.82667C5.28 19.6 4 18.32 4 16.7733V6.82667C4 5.28 5.28 4 6.82667 4Z",
                fill: "#584CCC"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.8533 13.0401C16.5333 12.6934 15.92 12.5334 15.04 12.5334C14.56 12.5334 14.0533 12.5868 13.5733 12.6668C13.2533 12.3734 12.9867 12.0268 12.72 11.6801C12.5333 11.4134 12.3467 11.1468 12.1867 10.8534C12.4533 10.1068 12.6133 9.30676 12.6667 8.50676C12.6667 7.78676 12.3733 7.01343 11.5733 7.01343C11.3067 7.01343 11.04 7.17343 10.9067 7.41343C10.56 8.00009 10.6933 9.20009 11.2533 10.4534C11.0667 11.0134 10.8533 11.5734 10.6133 12.1868C10.4 12.7201 10.16 13.2268 9.86668 13.7068C9.04001 14.0268 7.30668 14.8268 7.14668 15.7068C7.09334 15.9734 7.17334 16.2401 7.38668 16.4001C7.57334 16.5601 7.84001 16.6668 8.10668 16.6401C9.14668 16.6401 10.1867 15.2001 10.9067 13.9468C11.3067 13.8134 11.7067 13.6801 12.1333 13.5734C12.5867 13.4668 13.0133 13.3601 13.4133 13.2801C14.5333 14.2401 15.52 14.4001 16 14.4001C16.6667 14.4001 16.9333 14.1068 17.0133 13.8668C17.12 13.5734 17.0667 13.2534 16.8533 13.0401ZM16.1333 13.5468C16.1067 13.7334 15.8933 13.8668 15.6267 13.8668C15.5467 13.8668 15.4667 13.8668 15.3867 13.8401C14.8533 13.7068 14.3467 13.4401 13.92 13.0934C14.2667 13.0401 14.64 13.0134 14.9867 13.0134C15.2267 13.0134 15.4667 13.0401 15.7067 13.0668C15.9467 13.1201 16.2133 13.2268 16.1333 13.5468ZM11.36 7.65343C11.4133 7.57343 11.4933 7.52009 11.6 7.49343C11.8667 7.49343 11.92 7.78676 11.92 8.05343C11.8933 8.66676 11.7867 9.25343 11.6 9.84009C11.1467 8.69343 11.2 7.92009 11.36 7.65343ZM12.8533 12.7734C12.56 12.8268 12.2667 12.9068 11.9733 12.9868C11.76 13.0401 11.5467 13.1201 11.3067 13.1734C11.4133 12.9334 11.52 12.6934 11.6267 12.4801C11.76 12.1868 11.8667 11.8934 11.9733 11.6001C12.08 11.7601 12.16 11.8934 12.2667 12.0268C12.4533 12.2934 12.6667 12.5334 12.8533 12.7734ZM9.62668 14.3201C8.96001 15.3868 8.29334 16.0801 7.92001 16.0801C7.86668 16.0801 7.78668 16.0534 7.76001 16.0268C7.68001 15.9734 7.65334 15.8668 7.68001 15.7868C7.73334 15.3868 8.50668 14.8268 9.62668 14.3201Z",
                fill: "white"
            })
        ]
    });
};

});

parcelRegister("BqBqQ", function(module, exports) {

$parcel$export(module.exports, "AdobeSignSearchResultIcon", () => $18da8b9d7017c546$export$9efd1df023dc9339);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $18da8b9d7017c546$export$9efd1df023dc9339 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-19.5",
                y: "-166.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#584CCC"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M25.7066 18.7523C25.0666 18.0399 23.8399 17.7112 22.0799 17.7112C21.1199 17.7112 20.1066 17.8208 19.1466 17.9852C18.5066 17.3824 17.9732 16.6701 17.4399 15.9578C17.0666 15.4099 16.6932 14.8619 16.3732 14.2592C16.9066 12.725 17.2266 11.0812 17.3332 9.43743C17.3332 7.95802 16.7466 6.36902 15.1466 6.36902C14.6132 6.36902 14.0799 6.69778 13.8132 7.19091C13.1199 8.39636 13.3866 10.8621 14.5066 13.4373C14.1332 14.588 13.7066 15.7386 13.2266 16.9989C12.7999 18.0947 12.3199 19.1358 11.7332 20.1221C10.0799 20.7796 6.61323 22.4234 6.29323 24.2316C6.18656 24.7795 6.34656 25.3274 6.77323 25.6562C7.14656 25.9849 7.6799 26.2041 8.21323 26.1493C10.2932 26.1493 12.3732 23.1905 13.8132 20.6152C14.6132 20.3413 15.4132 20.0673 16.2666 19.8481C17.1732 19.6289 18.0266 19.4098 18.8266 19.2454C21.0666 21.2179 23.0399 21.5467 23.9999 21.5467C25.3332 21.5467 25.8666 20.944 26.0266 20.4508C26.2399 19.8481 26.1332 19.1906 25.7066 18.7523ZM24.2666 19.7933C24.2132 20.1769 23.7866 20.4508 23.2532 20.4508C23.0932 20.4508 22.9332 20.4508 22.7732 20.396C21.7066 20.1221 20.6932 19.5742 19.8399 18.8618C20.5332 18.7523 21.2799 18.6975 21.9732 18.6975C22.4532 18.6975 22.9332 18.7523 23.4132 18.807C23.8932 18.9166 24.4266 19.1358 24.2666 19.7933ZM14.7199 7.68405C14.8266 7.51967 14.9866 7.41009 15.1999 7.35529C15.7332 7.35529 15.8399 7.95802 15.8399 8.50595C15.7866 9.76619 15.5732 10.9716 15.1999 12.1771C14.2932 9.82098 14.3999 8.23198 14.7199 7.68405ZM17.7066 18.2043C17.1199 18.3139 16.5332 18.4783 15.9466 18.6427C15.5199 18.7523 15.0932 18.9166 14.6132 19.0262C14.8266 18.5331 15.0399 18.0399 15.2532 17.6016C15.5199 16.9989 15.7332 16.3962 15.9466 15.7934C16.1599 16.1222 16.3199 16.3962 16.5332 16.6701C16.9066 17.218 17.3332 17.7112 17.7066 18.2043ZM11.2532 21.3823C9.9199 23.574 8.58656 24.9987 7.8399 24.9987C7.73323 24.9987 7.57323 24.9439 7.5199 24.8891C7.3599 24.7795 7.30656 24.5603 7.3599 24.3959C7.46656 23.574 9.01323 22.4234 11.2532 21.3823Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.3 5H29.7C32.6 5 35 7.4 35 10.3V28.9C35 31.85 32.6 34.2 29.7 34.2H10.3C7.4 34.25 5 31.85 5 28.95V10.3C5 7.4 7.4 5 10.3 5Z",
                fill: "#584CCC"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M29.1 21.9501C28.5 21.3001 27.35 21.0001 25.7 21.0001C24.8 21.0001 23.85 21.1001 22.95 21.2501C22.35 20.7001 21.85 20.0501 21.35 19.4001C21 18.9001 20.65 18.4001 20.35 17.8501C20.85 16.4501 21.15 14.9501 21.25 13.4501C21.25 12.1001 20.7 10.6501 19.2 10.6501C18.7 10.6501 18.2 10.9501 17.95 11.4001C17.3 12.5001 17.55 14.7501 18.6 17.1001C18.25 18.1501 17.85 19.2001 17.4 20.3501C17 21.3501 16.55 22.3001 16 23.2001C14.45 23.8001 11.2 25.3001 10.9 26.9501C10.8 27.4501 10.95 27.9501 11.35 28.2501C11.7 28.5501 12.2 28.7501 12.7 28.7001C14.65 28.7001 16.6 26.0001 17.95 23.6501C18.7 23.4001 19.45 23.1501 20.25 22.9501C21.1 22.7501 21.9 22.5501 22.65 22.4001C24.75 24.2001 26.6 24.5001 27.5 24.5001C28.75 24.5001 29.25 23.9501 29.4 23.5001C29.6 22.9501 29.5 22.3501 29.1 21.9501ZM27.75 22.9001C27.7 23.2501 27.3 23.5001 26.8 23.5001C26.65 23.5001 26.5 23.5001 26.35 23.4501C25.35 23.2001 24.4 22.7001 23.6 22.0501C24.25 21.9501 24.95 21.9001 25.6 21.9001C26.05 21.9001 26.5 21.9501 26.95 22.0001C27.4 22.1001 27.9 22.3001 27.75 22.9001ZM18.8 11.8501C18.9 11.7001 19.05 11.6001 19.25 11.5501C19.75 11.5501 19.85 12.1001 19.85 12.6001C19.8 13.7501 19.6 14.8501 19.25 15.9501C18.4 13.8001 18.5 12.3501 18.8 11.8501ZM21.6 21.4501C21.05 21.5501 20.5 21.7001 19.95 21.8501C19.55 21.9501 19.15 22.1001 18.7 22.2001C18.9 21.7501 19.1 21.3001 19.3 20.9001C19.55 20.3501 19.75 19.8001 19.95 19.2501C20.15 19.5501 20.3 19.8001 20.5 20.0501C20.85 20.5501 21.25 21.0001 21.6 21.4501ZM15.55 24.3501C14.3 26.3501 13.05 27.6501 12.35 27.6501C12.25 27.6501 12.1 27.6001 12.05 27.5501C11.9 27.4501 11.85 27.2501 11.9 27.1001C12 26.3501 13.45 25.3001 15.55 24.3501Z",
                fill: "white"
            })
        ]
    });
};

});


parcelRegister("7jnfW", function(module, exports) {

$parcel$export(module.exports, "adobeXDConfig", () => $550d38c9b57936f7$export$e69f90b2aa757835);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $i0RdA = parcelRequire("i0RdA");

var $hs7cC = parcelRequire("hs7cC");
const $550d38c9b57936f7$export$e69f90b2aa757835 = {
    displayName: 'AdobeXD',
    id: 'adobexd',
    resourceType: 'smartlinks-connector-adobexd',
    icon: (0, $9yyKc.get3PLogo)((0, $i0RdA.AdobeXDIcon), 'AdobeXD', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $hs7cC.AdobeXDSearchResultIcon), 'AdobeXD', 'large'),
    integrationAri: 'ari:cloud:platform::integration/adobe',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("i0RdA", function(module, exports) {

$parcel$export(module.exports, "AdobeXDIcon", () => $fc6a0ef8f9f5c7bc$export$be8cba599441db6e);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $fc6a0ef8f9f5c7bc$export$be8cba599441db6e = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-635.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#470137"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.5802 7.40457L9.75898 12.1789L12.7683 17.2427C12.7871 17.2812 12.7965 17.3198 12.7871 17.3584C12.7777 17.397 12.7401 17.368 12.6836 17.3777H10.5301C10.3796 17.3777 10.2762 17.368 10.2104 17.2716C10.0129 16.8665 9.806 16.471 9.60851 16.0659C9.41103 15.6705 9.19473 15.2654 8.96903 14.8507C8.74334 14.4359 8.51764 14.0212 8.29194 13.5968H8.27313C8.07565 14.0115 7.85935 14.4263 7.64306 14.841C7.42677 15.2558 7.21047 15.6705 7.00359 16.0756C6.78729 16.4807 6.571 16.8954 6.3547 17.2909C6.31709 17.3873 6.24186 17.397 6.13841 17.397H4.06952C4.0319 17.397 4.00369 17.4163 4.00369 17.368C3.99429 17.3295 4.00369 17.2909 4.0225 17.262L6.94716 12.3429L4.09773 7.39492C4.06952 7.35634 4.06011 7.31776 4.07892 7.29847C4.09773 7.26953 4.13535 7.25989 4.17296 7.25989H6.30768C6.3547 7.25989 6.40173 7.26953 6.43934 7.27918C6.47696 7.29847 6.50517 7.3274 6.53338 7.36598C6.71206 7.78073 6.91895 8.19547 7.13524 8.61021C7.36094 9.02496 7.57723 9.43006 7.81233 9.83515C8.03803 10.2403 8.24492 10.6453 8.44241 11.0601H8.46122C8.6587 10.6357 8.86559 10.221 9.07248 9.81586C9.27937 9.41077 9.49566 9.00567 9.71196 8.60057C9.92825 8.19547 10.1351 7.78073 10.342 7.38528C10.3514 7.34669 10.3702 7.30811 10.3985 7.28882C10.4361 7.26953 10.4737 7.25989 10.5207 7.26953H12.505C12.552 7.25989 12.599 7.28882 12.6084 7.33705C12.6178 7.34669 12.599 7.38528 12.5802 7.40457Z",
                fill: "#FF61F6"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.9248 17.5803C16.2289 17.5899 15.533 17.4453 14.9029 17.1463C14.3105 16.8666 13.8215 16.4036 13.4829 15.8345C13.135 15.2462 12.9657 14.5131 12.9657 13.6354C12.9563 12.9217 13.135 12.2176 13.4829 11.6003C13.8403 10.9733 14.3575 10.4525 14.9782 10.1053C15.6364 9.72911 16.4264 9.54585 17.3574 9.54585C17.4044 9.54585 17.4702 9.54585 17.5549 9.5555C17.711 9.5733 17.8464 9.43978 17.8464 9.28259V6.52691C17.8464 6.45939 17.8746 6.42081 17.9404 6.42081H19.791C19.8299 6.42081 19.873 6.41051 19.9052 6.43245C19.9189 6.44186 19.9299 6.45544 19.937 6.4702C19.9425 6.48177 19.9435 6.50762 19.9435 6.50762C19.9435 6.50762 19.9435 6.50762 19.9435 6.50762V15.6898C19.9435 15.8635 19.9529 16.0564 19.9623 16.2686C19.9811 16.4711 19.9905 16.664 19.9999 16.828C19.9999 16.8955 19.9717 16.9534 19.9059 16.9823C19.4169 17.1945 18.8996 17.3488 18.373 17.4453C17.8934 17.5321 17.4138 17.5803 16.9248 17.5803ZM17.5438 15.7015C17.7293 15.7077 17.8464 15.5265 17.8464 15.3409V11.666C17.8464 11.5147 17.7428 11.3763 17.5925 11.3591C17.489 11.3495 17.3856 11.3399 17.2821 11.3399C16.9154 11.3399 16.5486 11.417 16.2195 11.5906C15.8998 11.7546 15.627 11.9957 15.4201 12.3044C15.2133 12.613 15.1098 13.0278 15.1098 13.5293C15.1004 13.8669 15.1568 14.2045 15.2697 14.5228C15.3637 14.7832 15.5048 15.0147 15.6929 15.2076C15.8715 15.3812 16.0878 15.5162 16.3323 15.5934C16.5862 15.6802 16.8496 15.7188 17.1129 15.7188C17.2409 15.7188 17.3612 15.7108 17.4737 15.7022C17.4964 15.7004 17.521 15.7007 17.5438 15.7015Z",
                fill: "#FF61F6"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.90598 4H17.5043C19.1111 4 20.4103 5.29915 20.4103 6.90598V17.094C20.4103 18.7009 19.1111 20 17.5043 20H6.90598C5.29915 20 4 18.7009 4 17.094V6.90598C4 5.29915 5.29915 4 6.90598 4Z",
                fill: "#470137"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.629 8.2051L10.5777 11.5897L12.7658 15.1795C12.7794 15.2068 12.7863 15.2342 12.7794 15.2615C12.7726 15.2889 12.7453 15.2684 12.7042 15.2752H11.1384C11.029 15.2752 10.9538 15.2684 10.9059 15.2C10.7624 14.9128 10.6119 14.6325 10.4683 14.3453C10.3247 14.0649 10.1675 13.7778 10.0034 13.4837C9.83928 13.1897 9.67518 12.8957 9.51107 12.5948H9.4974C9.35381 12.8889 9.19654 13.1829 9.03928 13.4769C8.88201 13.7709 8.72475 14.0649 8.57432 14.3521C8.41706 14.6393 8.25979 14.9333 8.10253 15.2136C8.07518 15.282 8.02047 15.2889 7.94526 15.2889H6.44099C6.41364 15.2889 6.39312 15.3025 6.39312 15.2684C6.38629 15.241 6.39312 15.2136 6.4068 15.1931L8.5333 11.706L6.4615 8.19827C6.44099 8.17092 6.43415 8.14356 6.44783 8.12989C6.4615 8.10938 6.48885 8.10254 6.5162 8.10254H8.06834C8.10253 8.10254 8.13671 8.10938 8.16406 8.11621C8.19142 8.12989 8.21193 8.1504 8.23244 8.17775C8.36236 8.47177 8.51278 8.76579 8.67005 9.0598C8.83415 9.35382 8.99142 9.641 9.16236 9.92818C9.32646 10.2154 9.47688 10.5025 9.62047 10.7966H9.63415C9.77774 10.4957 9.92817 10.2017 10.0786 9.9145C10.229 9.62733 10.3863 9.34015 10.5436 9.05297C10.7008 8.76579 10.8512 8.47177 11.0017 8.19143C11.0085 8.16408 11.0222 8.13673 11.0427 8.12305C11.07 8.10938 11.0974 8.10254 11.1316 8.10938H12.5743C12.6085 8.10254 12.6427 8.12305 12.6495 8.15724C12.6564 8.16408 12.6427 8.19143 12.629 8.2051Z",
                fill: "#FF61F6"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.788 15.4188C15.282 15.4256 14.776 15.323 14.3179 15.1111C13.8872 14.9128 13.5316 14.5846 13.2854 14.1812C13.0325 13.7641 12.9094 13.2444 12.9094 12.6222C12.9025 12.1162 13.0325 11.6171 13.2854 11.1794C13.5453 10.735 13.9213 10.3658 14.3726 10.1196C14.8513 9.85295 15.4256 9.72304 16.1025 9.72304C16.1367 9.72304 16.1846 9.72304 16.2461 9.72988C16.3077 9.73671 16.376 9.73671 16.4581 9.74355V7.58287C16.4581 7.53501 16.4786 7.50765 16.5265 7.50765H17.9145C17.9487 7.50082 17.976 7.52817 17.9829 7.55552C17.9829 7.56236 17.9829 7.56919 17.9829 7.56919V14.0786C17.9829 14.2017 17.9897 14.3384 17.9966 14.4889C18.0102 14.6324 18.0171 14.7692 18.0239 14.8854C18.0239 14.9333 18.0034 14.9743 17.9555 14.9948C17.6 15.1453 17.2239 15.2547 16.841 15.323C16.4923 15.3846 16.1436 15.4188 15.788 15.4188ZM16.4581 14.0512V11.0427C16.3966 11.029 16.335 11.0153 16.2735 11.0085C16.1983 11.0017 16.1231 10.9948 16.0478 10.9948C15.7812 10.9948 15.5145 11.0495 15.2752 11.1726C15.0427 11.2889 14.8444 11.4598 14.694 11.6786C14.5436 11.8974 14.4683 12.1914 14.4683 12.547C14.4615 12.7863 14.5025 13.0256 14.5846 13.2512C14.653 13.4359 14.7555 13.6 14.8923 13.7367C15.0222 13.8598 15.1795 13.9555 15.3572 14.0102C15.5419 14.0718 15.7333 14.0991 15.9248 14.0991C16.0273 14.0991 16.1231 14.0923 16.2119 14.0854C16.3008 14.0923 16.376 14.0786 16.4581 14.0512Z",
                fill: "#FF61F6"
            })
        ]
    });
};

});

parcelRegister("hs7cC", function(module, exports) {

$parcel$export(module.exports, "AdobeXDSearchResultIcon", () => $df497511c4b16838$export$145a936ff16d9011);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $df497511c4b16838$export$145a936ff16d9011 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-163.5",
                y: "-550.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
                fill: "#470137"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.7738 9.87271L13.0121 16.2385L17.0245 22.9902C17.0496 23.0416 17.0621 23.0931 17.0496 23.1445C17.0371 23.1959 16.9869 23.1574 16.9117 23.1702H14.0403C13.8397 23.1702 13.7018 23.1574 13.614 23.0288C13.3507 22.4886 13.0748 21.9614 12.8115 21.4212C12.5482 20.894 12.2598 20.3538 11.9589 19.8008C11.6579 19.2478 11.357 18.6948 11.0561 18.129H11.031C10.7677 18.682 10.4793 19.235 10.1909 19.788C9.90252 20.341 9.61413 20.894 9.33828 21.4341C9.04989 21.9742 8.76149 22.5272 8.4731 23.0545C8.42295 23.1831 8.32264 23.1959 8.18471 23.1959H5.42619C5.37603 23.1959 5.33842 23.2217 5.33842 23.1574C5.32588 23.1059 5.33842 23.0545 5.36349 23.0159L9.26304 16.4572L5.4638 9.85985C5.42619 9.80841 5.41365 9.75697 5.43872 9.73125C5.4638 9.69267 5.51396 9.67981 5.56411 9.67981H8.41041C8.4731 9.67981 8.5358 9.69267 8.58595 9.70553C8.63611 9.73125 8.67372 9.76983 8.71134 9.82127C8.94958 10.3743 9.22543 10.9273 9.51382 11.4802C9.81475 12.0332 10.1031 12.5734 10.4166 13.1135C10.7175 13.6536 10.9934 14.1938 11.2567 14.7468H11.2818C11.5451 14.1809 11.8209 13.6279 12.0968 13.0878C12.3727 12.5476 12.661 12.0075 12.9494 11.4674C13.2378 10.9273 13.5137 10.3743 13.7895 9.84699C13.8021 9.79555 13.8271 9.74411 13.8648 9.71839C13.9149 9.69267 13.9651 9.67981 14.0278 9.69267H16.6734C16.7361 9.67981 16.7988 9.71839 16.8114 9.78269C16.8239 9.79555 16.7988 9.84699 16.7738 9.87271Z",
                fill: "#FF61F6"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M22.5666 23.4404C21.6388 23.4533 20.7109 23.2604 19.8708 22.8617C19.0809 22.4887 18.4289 21.8714 17.9775 21.1127C17.5135 20.3282 17.2878 19.3508 17.2878 18.1806C17.2753 17.2289 17.5135 16.2901 17.9775 15.467C18.4539 14.6311 19.1436 13.9367 19.9711 13.4737C20.8488 12.9721 21.9021 12.7278 23.1434 12.7278C23.2061 12.7278 23.2939 12.7278 23.4067 12.7407C23.615 12.7644 23.7954 12.5864 23.7954 12.3768V8.70254C23.7954 8.61252 23.8331 8.56108 23.9208 8.56108H26.3882C26.4401 8.56108 26.4976 8.54735 26.5405 8.5766C26.5588 8.58915 26.5735 8.60725 26.5829 8.62694C26.5903 8.64235 26.5916 8.67682 26.5916 8.67682C26.5916 8.67682 26.5916 8.67682 26.5916 8.67682V20.9198C26.5916 21.1513 26.6041 21.4085 26.6167 21.6914C26.6417 21.9615 26.6543 22.2187 26.6668 22.4373C26.6668 22.5273 26.6292 22.6045 26.5414 22.6431C25.8894 22.926 25.1998 23.1318 24.4976 23.2604C23.8581 23.3761 23.2187 23.4404 22.5666 23.4404ZM23.3919 20.9354C23.6393 20.9437 23.7954 20.7021 23.7954 20.4546V15.5546C23.7954 15.3529 23.6573 15.1684 23.4569 15.1455C23.319 15.1327 23.181 15.1198 23.0431 15.1198C22.5541 15.1198 22.0651 15.2227 21.6262 15.4542C21.1999 15.6728 20.8363 15.9943 20.5604 16.4058C20.2846 16.8174 20.1467 17.3704 20.1467 18.0391C20.1341 18.4892 20.2094 18.9393 20.3598 19.3637C20.4852 19.7109 20.6733 20.0196 20.9241 20.2768C21.1623 20.5083 21.4507 20.6883 21.7767 20.7912C22.1152 20.9069 22.4663 20.9584 22.8174 20.9584C22.9881 20.9584 23.1485 20.9478 23.2985 20.9362C23.3288 20.9339 23.3616 20.9343 23.3919 20.9354Z",
                fill: "#FF61F6"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.3125 5H29.6875C32.625 5 35 7.375 35 10.3125V28.9375C35 31.875 32.625 34.25 29.6875 34.25H10.3125C7.375 34.25 5 31.875 5 28.9375V10.3125C5 7.375 7.375 5 10.3125 5Z",
                fill: "#470137"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.775 12.6876L17.025 18.8751L21.025 25.4376C21.05 25.4876 21.0625 25.5376 21.05 25.5876C21.0375 25.6376 20.9875 25.6001 20.9125 25.6126H18.05C17.85 25.6126 17.7125 25.6001 17.625 25.4751C17.3625 24.9501 17.0875 24.4376 16.825 23.9126C16.5625 23.4001 16.275 22.8751 15.975 22.3376C15.675 21.8001 15.375 21.2626 15.075 20.7126H15.05C14.7875 21.2501 14.5 21.7876 14.2125 22.3251C13.925 22.8626 13.6375 23.4001 13.3625 23.9251C13.075 24.4501 12.7875 24.9876 12.5 25.5001C12.45 25.6251 12.35 25.6376 12.2125 25.6376H9.46246C9.41246 25.6376 9.37496 25.6626 9.37496 25.6001C9.36246 25.5501 9.37496 25.5001 9.39996 25.4626L13.2875 19.0876L9.49996 12.6751C9.46246 12.6251 9.44996 12.5751 9.47496 12.5501C9.49996 12.5126 9.54996 12.5001 9.59996 12.5001H12.4375C12.5 12.5001 12.5625 12.5126 12.6125 12.5251C12.6625 12.5501 12.7 12.5876 12.7375 12.6376C12.975 13.1751 13.25 13.7126 13.5375 14.2501C13.8375 14.7876 14.125 15.3126 14.4375 15.8376C14.7375 16.3626 15.0125 16.8876 15.275 17.4251H15.3C15.5625 16.8751 15.8375 16.3376 16.1125 15.8126C16.3875 15.2876 16.675 14.7626 16.9625 14.2376C17.25 13.7126 17.525 13.1751 17.8 12.6626C17.8125 12.6126 17.8375 12.5626 17.875 12.5376C17.925 12.5126 17.975 12.5001 18.0375 12.5126H20.675C20.7375 12.5001 20.8 12.5376 20.8125 12.6001C20.825 12.6126 20.8 12.6626 20.775 12.6876Z",
                fill: "#FF61F6"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M26.55 25.8753C25.625 25.8878 24.7 25.7003 23.8625 25.3128C23.075 24.9503 22.425 24.3503 21.975 23.6128C21.5125 22.8503 21.2875 21.9003 21.2875 20.7628C21.275 19.8378 21.5125 18.9253 21.975 18.1253C22.45 17.3128 23.1375 16.6378 23.9625 16.1878C24.8375 15.7003 25.8875 15.4628 27.125 15.4628C27.1875 15.4628 27.275 15.4628 27.3875 15.4753C27.5 15.4878 27.625 15.4878 27.775 15.5003V11.5503C27.775 11.4628 27.8125 11.4128 27.9 11.4128H30.4375C30.5 11.4003 30.55 11.4503 30.5625 11.5003C30.5625 11.5128 30.5625 11.5253 30.5625 11.5253V23.4253C30.5625 23.6503 30.575 23.9003 30.5875 24.1753C30.6125 24.4378 30.625 24.6878 30.6375 24.9003C30.6375 24.9878 30.6 25.0628 30.5125 25.1003C29.8625 25.3753 29.175 25.5753 28.475 25.7003C27.8375 25.8128 27.2 25.8753 26.55 25.8753ZM27.775 23.3753V17.8753C27.6625 17.8503 27.55 17.8253 27.4375 17.8128C27.3 17.8003 27.1625 17.7878 27.025 17.7878C26.5375 17.7878 26.05 17.8878 25.6125 18.1128C25.1875 18.3253 24.825 18.6378 24.55 19.0378C24.275 19.4378 24.1375 19.9753 24.1375 20.6253C24.125 21.0628 24.2 21.5003 24.35 21.9128C24.475 22.2503 24.6625 22.5503 24.9125 22.8003C25.15 23.0253 25.4375 23.2003 25.7625 23.3003C26.1 23.4128 26.45 23.4628 26.8 23.4628C26.9875 23.4628 27.1625 23.4503 27.325 23.4378C27.4875 23.4503 27.625 23.4253 27.775 23.3753Z",
                fill: "#FF61F6"
            })
        ]
    });
};

});


parcelRegister("ecVyn", function(module, exports) {

$parcel$export(module.exports, "ahaConfig", () => $f55ccfed6e002ce8$export$ad976bfe08240460);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $4Uu16 = parcelRequire("4Uu16");

var $cTWxk = parcelRequire("cTWxk");
const $f55ccfed6e002ce8$export$ad976bfe08240460 = {
    displayName: 'Aha',
    id: 'aha',
    resourceType: 'aha-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $4Uu16.AhaIcon), 'Aha', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $cTWxk.AhaSearchResultIcon), 'Aha', 'large'),
    integrationAri: 'ari:cloud:platform::integration/aha',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("4Uu16", function(module, exports) {

$parcel$export(module.exports, "AhaIcon", () => $38d5eef3851b2cfa$export$f28fe6c5ebff8c30);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $38d5eef3851b2cfa$export$f28fe6c5ebff8c30 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-635.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.5114 14.3589C13.4961 13.9874 13.4858 13.6157 13.4829 13.2439C13.4806 12.9476 13.4822 12.6512 13.4798 12.3549C13.4779 12.1238 13.4776 11.8926 13.4483 11.6628C13.4314 11.5303 13.4041 11.4003 13.3459 11.2789C13.2429 11.0639 13.0729 10.9187 12.8595 10.8216C12.562 10.6863 12.2524 10.6769 11.9374 10.742C11.6833 10.7945 11.4482 10.8957 11.2248 11.0259C11.1582 11.0647 11.0935 11.1066 11.0248 11.1522C11.0248 11.139 11.0248 11.1317 11.0248 11.1242C11.024 10.9117 11.0232 10.6993 11.0223 10.4868C11.0205 10.0525 11.0181 9.61825 11.0083 9.18407C11.0075 9.14589 11.0068 9.1076 11.003 9.06965C10.9985 9.02436 10.9605 8.99346 10.9209 9.00118C10.7482 9.03488 10.5756 9.06898 10.403 9.10296C10.182 9.14651 9.96017 9.18597 9.73703 9.21771C9.63006 9.23294 9.52302 9.24761 9.41605 9.26266C9.40776 9.26384 9.39813 9.26496 9.39433 9.27313C9.38968 9.28299 9.39892 9.28864 9.4053 9.29306C9.41476 9.29956 9.4137 9.30885 9.41498 9.31786C9.43737 9.47365 9.45467 9.63006 9.46883 9.7868C9.49083 10.0299 9.5041 10.2737 9.51339 10.5176C9.52722 10.8799 9.53366 11.2423 9.53607 11.6048C9.54323 12.6756 9.53573 13.7464 9.52577 14.8172C9.52515 14.8822 9.54228 14.8991 9.60722 14.8982C9.9839 14.8933 10.3605 14.8882 10.7372 14.8834C10.8454 14.882 10.9536 14.8819 11.0617 14.88C11.1067 14.8793 11.1419 14.8617 11.1375 14.803C11.1263 14.6534 11.1212 14.5034 11.1135 14.3536C11.0966 14.0279 11.0824 13.7021 11.0754 13.376C11.0725 13.24 11.0686 13.104 11.0675 12.968C11.065 12.6502 11.064 12.3324 11.0619 12.0146C11.0618 12.0001 11.0668 11.9933 11.0802 11.9881C11.1314 11.9683 11.1821 11.9472 11.233 11.9266C11.3449 11.8813 11.4598 11.8553 11.582 11.8677C11.6869 11.8784 11.7678 11.9237 11.8182 12.0183C11.8354 12.0504 11.8491 12.0839 11.8596 12.1188C11.9079 12.2798 11.9208 12.4461 11.9309 12.6124C11.9449 12.8432 11.9481 13.0743 11.9491 13.3054C11.9514 13.8152 11.9454 14.3249 11.943 14.8346C11.9427 14.8967 11.9627 14.9166 12.025 14.9164C12.2432 14.9154 12.4613 14.9063 12.6794 14.9013C12.7968 14.8986 12.9143 14.8968 13.0318 14.9015C13.1743 14.9071 13.3167 14.9164 13.4594 14.9164C13.5133 14.9164 13.5378 14.89 13.5351 14.8365C13.527 14.6775 13.5179 14.5184 13.5113 14.3592L13.5114 14.3589Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9366 9.01969C19.8949 9.01381 19.8552 9.02663 19.8151 9.03307C19.5797 9.07063 19.3445 9.10948 19.1092 9.14766C18.8849 9.18405 18.6607 9.22071 18.4363 9.25626C18.3593 9.26846 18.3278 9.30709 18.335 9.3844C18.3477 9.52166 18.3605 9.65887 18.372 9.79624C18.3901 10.0134 18.4071 10.2308 18.4246 10.448C18.4441 10.6912 18.4592 10.9349 18.473 11.1785C18.4862 11.4092 18.4974 11.64 18.5087 11.8708C18.5253 12.2067 18.5413 12.5427 18.5572 12.8786C18.5601 12.9403 18.5901 12.9699 18.6524 12.9689C18.8259 12.966 18.9992 12.9627 19.1727 12.9596C19.1727 12.959 19.1727 12.9585 19.1727 12.9579C19.2109 12.9579 19.2491 12.9584 19.2874 12.9578C19.4272 12.9557 19.567 12.9535 19.7069 12.9509C19.7598 12.9499 19.7931 12.9184 19.7943 12.8695C19.7981 12.7158 19.8008 12.5621 19.8057 12.4084C19.8128 12.1849 19.8201 11.9614 19.8299 11.7379C19.8428 11.4466 19.8577 11.1554 19.8727 10.8642C19.8815 10.6958 19.8914 10.5274 19.9024 10.3592C19.9159 10.1537 19.9299 9.94834 19.9456 9.74312C19.9583 9.57691 19.9737 9.41088 19.9879 9.24479C19.9923 9.19379 19.9984 9.14279 20 9.09168C20.0016 9.04511 19.9823 9.02619 19.9366 9.01969H19.9366Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.8688 14.1793C19.8688 13.9604 19.8688 13.7414 19.8688 13.5225C19.8688 13.4553 19.8458 13.4339 19.7778 13.4396C19.7231 13.4441 19.6685 13.4514 19.6137 13.455C19.3336 13.4735 19.0533 13.4827 18.7725 13.4746C18.6672 13.4715 18.562 13.4672 18.4571 13.4573C18.4019 13.4521 18.3713 13.4753 18.3714 13.5236C18.3715 13.5886 18.3713 13.6537 18.3731 13.7185C18.3774 13.8731 18.3778 14.0277 18.3757 14.1823C18.3727 14.4096 18.372 14.6369 18.3711 14.8643C18.3709 14.9132 18.3988 14.9386 18.4468 14.9356C18.5296 14.9305 18.6123 14.9244 18.695 14.9194C18.9465 14.9041 19.198 14.9013 19.4498 14.9076C19.5653 14.9104 19.6808 14.9132 19.7964 14.9166C19.8276 14.9174 19.8511 14.9065 19.864 14.8775C19.8706 14.8627 19.8688 14.8464 19.8688 14.8306C19.8689 14.6135 19.8688 14.3964 19.8688 14.1793Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.07031 14.2687C8.61418 12.7687 8.15801 11.2688 7.70189 9.76881C7.63667 9.55441 7.57151 9.34 7.50612 9.1256C7.48597 9.05949 7.43526 9.0268 7.36791 9.03771C7.25763 9.05557 7.14763 9.07522 7.03735 9.09313C6.67802 9.15152 6.31852 9.20884 5.96031 9.274C5.86772 9.29085 5.80132 9.34224 5.77154 9.43248C5.18325 11.2134 4.59553 12.9943 4.00768 14.7753C3.98317 14.8496 4.01849 14.8982 4.09703 14.8982C4.53249 14.8982 4.96801 14.8982 5.40348 14.8983C5.42128 14.8983 5.43902 14.8983 5.45593 14.8922C5.47636 14.8849 5.49142 14.8721 5.49635 14.8498C5.51896 14.7472 5.54136 14.6445 5.56425 14.5419C5.6335 14.2314 5.70297 13.921 5.77233 13.6105C5.77546 13.5964 5.77815 13.5867 5.79847 13.587C6.27581 13.5939 6.7532 13.6 7.23054 13.6053C7.25254 13.6055 7.26054 13.6121 7.26508 13.633C7.3552 14.0446 7.446 14.456 7.53669 14.8675C7.54811 14.9193 7.56759 14.935 7.62116 14.9357C7.63141 14.9358 7.64165 14.9352 7.6519 14.9349C7.90072 14.9282 8.14961 14.9214 8.34341 14.9162C8.65494 14.9162 8.91138 14.9165 9.16782 14.9161C9.22923 14.916 9.25593 14.8791 9.2383 14.8211C9.18226 14.6369 9.12623 14.4528 9.07025 14.2686L9.07031 14.2687ZM7.00544 12.4829C6.70517 12.4823 6.4049 12.4822 6.10457 12.483C6.07881 12.4831 6.07909 12.4754 6.08486 12.4548C6.22089 11.9665 6.3497 11.4762 6.47397 10.9849C6.50952 10.8442 6.54289 10.703 6.57737 10.562C6.57866 10.5569 6.58056 10.5518 6.58465 10.5392C6.6816 10.937 6.76787 11.3295 6.85732 11.7211C6.91319 11.966 6.96978 12.2107 7.02739 12.4552C7.03299 12.479 7.02834 12.4829 7.0055 12.4828L7.00544 12.4829Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.6715 14.483C17.6508 14.1846 17.6368 13.8858 17.6337 13.5866C17.6292 13.1505 17.6392 12.7144 17.6459 12.2783C17.6489 12.0854 17.6451 11.8927 17.6116 11.7017C17.5626 11.4229 17.427 11.1973 17.2 11.0277C17.0326 10.9026 16.8409 10.8332 16.6391 10.7888C16.3129 10.7171 15.9826 10.7133 15.6513 10.735C15.4224 10.75 15.1954 10.7808 14.9697 10.822C14.7443 10.8632 14.5215 10.9154 14.3015 10.9796C14.2482 10.9951 14.2304 11.018 14.2279 11.0738C14.225 11.1361 14.2232 11.1986 14.2205 11.2609C14.2138 11.4201 14.2068 11.5793 14.2002 11.7385C14.1971 11.812 14.193 11.8856 14.1925 11.9591C14.192 12.0256 14.2482 12.0552 14.2961 12.0363C14.4737 11.9667 14.6519 11.899 14.8344 11.8434C15.1069 11.7603 15.3843 11.7096 15.6705 11.7156C15.765 11.7175 15.8584 11.726 15.9472 11.7617C16.0354 11.797 16.0909 11.8595 16.1043 11.9553C16.11 11.996 16.1065 12.0371 16.106 12.0781C16.1057 12.1005 16.0979 12.1097 16.0745 12.1129C15.9739 12.127 15.8735 12.1417 15.7735 12.1592C15.4704 12.2122 15.1722 12.2838 14.8841 12.3937C14.6487 12.4835 14.426 12.5963 14.2307 12.7575C14.0093 12.9403 13.8519 13.1654 13.7916 13.4492C13.733 13.7249 13.7543 13.9976 13.8446 14.2642C13.9131 14.4664 14.0269 14.6385 14.1966 14.7708C14.3761 14.9107 14.5826 14.976 14.8076 14.9892C14.8076 14.9907 14.8078 14.9922 14.808 14.9937H14.9647C14.9647 14.9921 14.9647 14.9906 14.9649 14.989C15.0468 14.9825 15.1278 14.9702 15.2076 14.9506C15.5361 14.87 15.8352 14.7248 16.1143 14.5361C16.1279 14.527 16.1412 14.5175 16.1583 14.5057V14.5414C16.1583 14.6448 16.1582 14.7483 16.1584 14.8517C16.1585 14.9143 16.1809 14.9365 16.2426 14.9356C16.3964 14.9334 16.5502 14.9309 16.7041 14.9288C17.0099 14.9245 17.3157 14.9204 17.6215 14.9161C17.6734 14.9154 17.696 14.8915 17.6952 14.8397C17.6951 14.8341 17.6948 14.8285 17.6945 14.823C17.6868 14.7095 17.6793 14.5962 17.6714 14.4828L17.6715 14.483ZM16.1219 13.3558C16.1219 13.4806 16.1214 13.6055 16.1224 13.7302C16.1226 13.7497 16.1161 13.76 16.0995 13.7695C15.9485 13.857 15.7891 13.9147 15.6115 13.9032C15.4004 13.8894 15.2482 13.7607 15.226 13.5542C15.2022 13.3329 15.2951 13.1667 15.5135 13.0711C15.6245 13.0225 15.7419 12.9981 15.861 12.9813C15.9384 12.9704 16.0164 12.9631 16.0939 12.9531C16.1155 12.9503 16.1227 12.9553 16.1224 12.9785C16.1213 13.1043 16.1219 13.2301 16.1219 13.3558Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.5116 14.3589C13.4963 13.9874 13.4861 13.6157 13.4831 13.2439C13.4808 12.9476 13.4825 12.6512 13.48 12.3549C13.4781 12.1238 13.4778 11.8926 13.4486 11.6628C13.4316 11.5303 13.4044 11.4003 13.3462 11.2789C13.2432 11.0639 13.0732 10.9187 12.8598 10.8216C12.5623 10.6863 12.2527 10.6769 11.9377 10.742C11.6836 10.7945 11.4485 10.8957 11.225 11.0259C11.1584 11.0647 11.0938 11.1066 11.0251 11.1522C11.0251 11.139 11.0251 11.1317 11.0251 11.1242C11.0242 10.9117 11.0234 10.6993 11.0225 10.4868C11.0208 10.0525 11.0184 9.61825 11.0086 9.18407C11.0077 9.14589 11.007 9.1076 11.0033 9.06965C10.9988 9.02436 10.9607 8.99346 10.9211 9.00118C10.7485 9.03488 10.5759 9.06898 10.4033 9.10296C10.1822 9.14651 9.96041 9.18597 9.73728 9.21771C9.6303 9.23294 9.52327 9.24761 9.41629 9.26266C9.40801 9.26384 9.39838 9.26496 9.39457 9.27313C9.38992 9.28299 9.39916 9.28864 9.40554 9.29306C9.415 9.29956 9.41394 9.30885 9.41523 9.31786C9.43762 9.47365 9.45492 9.63006 9.46908 9.7868C9.49108 10.0299 9.50435 10.2737 9.51364 10.5176C9.52747 10.8799 9.5339 11.2423 9.53631 11.6048C9.54348 12.6756 9.53597 13.7464 9.52601 14.8172C9.52539 14.8822 9.54252 14.8991 9.60746 14.8982C9.98415 14.8933 10.3608 14.8882 10.7375 14.8834C10.8456 14.882 10.9538 14.8819 11.0619 14.88C11.107 14.8793 11.1421 14.8617 11.1377 14.803C11.1265 14.6534 11.1215 14.5034 11.1137 14.3536C11.0969 14.0279 11.0826 13.7021 11.0756 13.376C11.0727 13.24 11.0688 13.104 11.0677 12.968C11.0652 12.6502 11.0642 12.3324 11.0621 12.0146C11.062 12.0001 11.0671 11.9933 11.0804 11.9881C11.1316 11.9683 11.1823 11.9472 11.2332 11.9266C11.3452 11.8813 11.46 11.8553 11.5822 11.8677C11.6871 11.8784 11.768 11.9237 11.8185 12.0183C11.8356 12.0504 11.8494 12.0839 11.8599 12.1188C11.9082 12.2798 11.921 12.4461 11.9311 12.6124C11.9451 12.8432 11.9483 13.0743 11.9493 13.3054C11.9516 13.8152 11.9457 14.3249 11.9432 14.8346C11.9429 14.8967 11.963 14.9166 12.0253 14.9164C12.2435 14.9154 12.4615 14.9063 12.6796 14.9013C12.7971 14.8986 12.9146 14.8968 13.032 14.9015C13.1745 14.9071 13.3169 14.9164 13.4597 14.9164C13.5135 14.9164 13.5381 14.89 13.5353 14.8365C13.5272 14.6775 13.5181 14.5184 13.5116 14.3592L13.5116 14.3589Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9364 9.01981C19.8947 9.01394 19.855 9.02676 19.8149 9.03319C19.5795 9.07075 19.3443 9.1096 19.109 9.14778C18.8847 9.18417 18.6605 9.22084 18.4361 9.25638C18.3591 9.26859 18.3276 9.30721 18.3348 9.38452C18.3475 9.52178 18.3603 9.65899 18.3718 9.79636C18.3899 10.0136 18.4069 10.2309 18.4244 10.4481C18.444 10.6914 18.459 10.935 18.4729 11.1787C18.486 11.4094 18.4972 11.6402 18.5086 11.8709C18.5251 12.2068 18.5411 12.5428 18.557 12.8788C18.5599 12.9404 18.5899 12.97 18.6523 12.969C18.8257 12.9661 18.9991 12.9628 19.1725 12.9597C19.1725 12.9592 19.1725 12.9586 19.1725 12.958C19.2107 12.958 19.249 12.9585 19.2872 12.9579C19.427 12.9558 19.5669 12.9537 19.7067 12.951C19.7597 12.95 19.793 12.9186 19.7941 12.8696C19.7979 12.7159 19.8006 12.5622 19.8055 12.4085C19.8127 12.185 19.8199 11.9615 19.8297 11.7381C19.8426 11.4468 19.8575 11.1555 19.8726 10.8643C19.8813 10.6959 19.8913 10.5276 19.9022 10.3593C19.9157 10.1538 19.9297 9.94846 19.9454 9.74324C19.9581 9.57703 19.9736 9.411 19.9877 9.24491C19.9921 9.19391 19.9982 9.14291 19.9999 9.0918C20.0014 9.04523 19.9821 9.02631 19.9364 9.01981H19.9364Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.8689 14.1793C19.8689 13.9604 19.8689 13.7414 19.8689 13.5225C19.8689 13.4553 19.8459 13.4339 19.7779 13.4396C19.7231 13.4441 19.6685 13.4514 19.6137 13.455C19.3337 13.4735 19.0533 13.4827 18.7726 13.4746C18.6673 13.4715 18.5621 13.4672 18.4572 13.4573C18.4019 13.4521 18.3713 13.4753 18.3714 13.5236C18.3716 13.5886 18.3714 13.6537 18.3732 13.7185C18.3774 13.8731 18.3779 14.0277 18.3758 14.1823C18.3728 14.4096 18.3721 14.6369 18.3712 14.8643C18.3709 14.9132 18.3989 14.9386 18.4468 14.9356C18.5296 14.9305 18.6123 14.9244 18.6951 14.9194C18.9465 14.9041 19.1981 14.9013 19.4498 14.9076C19.5654 14.9104 19.6809 14.9132 19.7965 14.9166C19.8276 14.9174 19.8512 14.9065 19.8641 14.8775C19.8706 14.8627 19.8689 14.8464 19.8689 14.8306C19.8689 14.6135 19.8689 14.3964 19.8689 14.1793Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.07031 14.2689C8.61418 12.7689 8.15801 11.269 7.70189 9.76905C7.63667 9.55465 7.57151 9.34025 7.50612 9.12585C7.48597 9.05973 7.43526 9.02704 7.36791 9.03796C7.25763 9.05582 7.14763 9.07546 7.03735 9.09338C6.67802 9.15176 6.31852 9.20909 5.96031 9.27425C5.86772 9.2911 5.80132 9.34249 5.77154 9.43273C5.18325 11.2136 4.59553 12.9946 4.00768 14.7756C3.98317 14.8498 4.01849 14.8984 4.09703 14.8984C4.53249 14.8984 4.96801 14.8984 5.40348 14.8985C5.42128 14.8985 5.43902 14.8985 5.45593 14.8925C5.47636 14.8851 5.49142 14.8724 5.49635 14.85C5.51896 14.7474 5.54136 14.6448 5.56425 14.5421C5.6335 14.2317 5.70297 13.9212 5.77233 13.6108C5.77546 13.5966 5.77815 13.587 5.79847 13.5872C6.27581 13.5942 6.7532 13.6003 7.23054 13.6056C7.25254 13.6058 7.26054 13.6124 7.26508 13.6332C7.3552 14.0448 7.446 14.4563 7.53669 14.8678C7.54811 14.9195 7.56759 14.9352 7.62116 14.9359C7.63141 14.936 7.64165 14.9354 7.6519 14.9351C7.90072 14.9284 8.14961 14.9217 8.34341 14.9165C8.65494 14.9165 8.91138 14.9167 9.16782 14.9163C9.22923 14.9162 9.25593 14.8793 9.2383 14.8213C9.18226 14.6371 9.12623 14.453 9.07025 14.2689L9.07031 14.2689ZM7.00544 12.4832C6.70517 12.4825 6.4049 12.4824 6.10457 12.4833C6.07881 12.4833 6.07909 12.4757 6.08486 12.455C6.22089 11.9667 6.3497 11.4765 6.47397 10.9851C6.50952 10.8444 6.54289 10.7032 6.57737 10.5623C6.57866 10.5571 6.58056 10.5521 6.58465 10.5394C6.6816 10.9372 6.76787 11.3297 6.85732 11.7214C6.91319 11.9662 6.96978 12.2109 7.02739 12.4554C7.03299 12.4792 7.02834 12.4831 7.0055 12.4831L7.00544 12.4832Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.6717 14.483C17.6511 14.1846 17.637 13.8858 17.634 13.5866C17.6294 13.1505 17.6394 12.7144 17.6462 12.2783C17.6491 12.0854 17.6453 11.8927 17.6118 11.7017C17.5628 11.4229 17.4273 11.1973 17.2002 11.0277C17.0328 10.9026 16.8412 10.8332 16.6394 10.7888C16.3131 10.7171 15.9828 10.7133 15.6516 10.735C15.4227 10.75 15.1956 10.7808 14.97 10.822C14.7445 10.8632 14.5217 10.9154 14.3018 10.9796C14.2485 10.9951 14.2307 11.018 14.2281 11.0738C14.2253 11.1361 14.2234 11.1986 14.2208 11.2609C14.2141 11.4201 14.2071 11.5793 14.2004 11.7385C14.1973 11.812 14.1932 11.8856 14.1927 11.9591C14.1923 12.0256 14.2484 12.0552 14.2963 12.0363C14.4739 11.9667 14.6521 11.899 14.8346 11.8434C15.1071 11.7603 15.3845 11.7096 15.6707 11.7156C15.7653 11.7175 15.8586 11.726 15.9475 11.7617C16.0357 11.797 16.0911 11.8595 16.1045 11.9553C16.1103 11.996 16.1068 12.0371 16.1062 12.0781C16.1059 12.1005 16.0981 12.1097 16.0747 12.1129C15.9742 12.127 15.8737 12.1417 15.7738 12.1592C15.4707 12.2122 15.1724 12.2838 14.8843 12.3937C14.6489 12.4835 14.4263 12.5963 14.2309 12.7575C14.0095 12.9403 13.8522 13.1654 13.7918 13.4492C13.7332 13.7249 13.7546 13.9976 13.8449 14.2642C13.9133 14.4664 14.0271 14.6385 14.1969 14.7708C14.3763 14.9107 14.5829 14.976 14.8078 14.9892C14.8079 14.9907 14.8081 14.9922 14.8083 14.9937H14.965C14.965 14.9921 14.965 14.9906 14.9652 14.989C15.0471 14.9825 15.128 14.9702 15.2078 14.9506C15.5364 14.87 15.8355 14.7248 16.1146 14.5361C16.1281 14.527 16.1414 14.5175 16.1586 14.5057V14.5414C16.1586 14.6448 16.1584 14.7483 16.1586 14.8517C16.1587 14.9143 16.1811 14.9365 16.2428 14.9356C16.3966 14.9334 16.5505 14.9309 16.7043 14.9288C17.0101 14.9245 17.3159 14.9204 17.6218 14.9161C17.6737 14.9154 17.6963 14.8915 17.6954 14.8397C17.6953 14.8341 17.695 14.8285 17.6947 14.823C17.687 14.7095 17.6795 14.5962 17.6717 14.4828L17.6717 14.483ZM16.1221 13.3558C16.1221 13.4806 16.1217 13.6055 16.1226 13.7302C16.1228 13.7497 16.1163 13.76 16.0998 13.7695C15.9488 13.857 15.7893 13.9147 15.6117 13.9032C15.4006 13.8894 15.2485 13.7607 15.2262 13.5542C15.2024 13.3329 15.2953 13.1667 15.5138 13.0711C15.6247 13.0225 15.7421 12.9981 15.8613 12.9813C15.9387 12.9704 16.0166 12.9631 16.0942 12.9531C16.1157 12.9503 16.1229 12.9553 16.1227 12.9785C16.1215 13.1043 16.1221 13.2301 16.1221 13.3558Z",
                fill: "#0172CE"
            })
        ]
    });
};

});

parcelRegister("cTWxk", function(module, exports) {

$parcel$export(module.exports, "AhaSearchResultIcon", () => $7e71d35b557ef27f$export$7dd76757b7d2d978);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $7e71d35b557ef27f$export$7dd76757b7d2d978 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-163.5",
                y: "-646.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.0155 19.1452C17.9951 18.6499 17.9814 18.1543 17.9775 17.6586C17.9744 17.2634 17.9766 16.8683 17.9734 16.4732C17.9708 16.1651 17.9704 15.8569 17.9314 15.5505C17.9089 15.3738 17.8725 15.2004 17.7949 15.0385C17.6576 14.7518 17.4309 14.5583 17.1463 14.4289C16.7497 14.2484 16.3369 14.2358 15.9169 14.3226C15.5781 14.3927 15.2646 14.5276 14.9667 14.7012C14.8779 14.7529 14.7917 14.8088 14.7001 14.8696C14.7001 14.8521 14.7001 14.8422 14.7001 14.8323C14.699 14.5489 14.6979 14.2657 14.6967 13.9824C14.6944 13.4033 14.6912 12.8243 14.6781 12.2454C14.677 12.1945 14.676 12.1435 14.671 12.0929C14.665 12.0325 14.6143 11.9913 14.5615 12.0016C14.3313 12.0465 14.1011 12.092 13.871 12.1373C13.5763 12.1953 13.2805 12.248 12.983 12.2903C12.8404 12.3106 12.6977 12.3301 12.5551 12.3502C12.544 12.3518 12.5312 12.3533 12.5261 12.3642C12.5199 12.3773 12.5322 12.3849 12.5407 12.3907C12.5533 12.3994 12.5519 12.4118 12.5536 12.4238C12.5835 12.6315 12.6066 12.8401 12.6254 13.0491C12.6548 13.3732 12.6725 13.6982 12.6849 14.0235C12.7033 14.5065 12.7119 14.9898 12.7151 15.4731C12.7246 16.9008 12.7146 18.3285 12.7013 19.7562C12.7005 19.843 12.7234 19.8654 12.8099 19.8643C13.3122 19.8577 13.8144 19.851 14.3166 19.8445C14.4608 19.8427 14.6051 19.8425 14.7492 19.8401C14.8093 19.839 14.8562 19.8156 14.8503 19.7373C14.8354 19.5379 14.8286 19.3379 14.8183 19.1381C14.7958 18.7039 14.7768 18.2695 14.7675 17.8347C14.7636 17.6533 14.7584 17.472 14.757 17.2906C14.7536 16.8669 14.7523 16.4432 14.7495 16.0195C14.7494 16.0002 14.7561 15.9911 14.7739 15.9842C14.8422 15.9578 14.9098 15.9296 14.9776 15.9022C15.1269 15.8417 15.2801 15.8071 15.4429 15.8236C15.5828 15.8378 15.6907 15.8982 15.758 16.0244C15.7808 16.0673 15.7992 16.1119 15.8131 16.1584C15.8776 16.3731 15.8947 16.5948 15.9082 16.8166C15.9268 17.1242 15.9311 17.4323 15.9324 17.7405C15.9355 18.4203 15.9276 19.0999 15.9243 19.7795C15.9239 19.8622 15.9506 19.8888 16.0337 19.8885C16.3246 19.8872 16.6154 19.8751 16.9062 19.8683C17.0627 19.8648 17.2194 19.8624 17.376 19.8686C17.566 19.8762 17.7559 19.8886 17.9463 19.8885C18.0181 19.8885 18.0508 19.8533 18.0471 19.7821C18.0363 19.5699 18.0242 19.3578 18.0154 19.1456L18.0155 19.1452Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M26.5819 12.0263C26.5263 12.0185 26.4734 12.0356 26.4199 12.0441C26.106 12.0942 25.7924 12.146 25.4787 12.1969C25.1797 12.2454 24.8807 12.2943 24.5815 12.3417C24.4788 12.358 24.4368 12.4095 24.4464 12.5126C24.4634 12.6956 24.4804 12.8785 24.4957 13.0617C24.5199 13.3513 24.5425 13.641 24.5658 13.9306C24.592 14.255 24.612 14.5799 24.6305 14.9048C24.648 15.2124 24.6629 15.5201 24.6781 15.8278C24.7001 16.2757 24.7215 16.7237 24.7427 17.1716C24.7465 17.2537 24.7865 17.2932 24.8697 17.2919C25.1009 17.288 25.3321 17.2837 25.5633 17.2795C25.5633 17.2787 25.5633 17.278 25.5633 17.2773C25.6143 17.2773 25.6653 17.2779 25.7162 17.2771C25.9027 17.2743 26.0891 17.2714 26.2756 17.2679C26.3462 17.2666 26.3906 17.2246 26.3922 17.1594C26.3973 16.9544 26.4008 16.7495 26.4073 16.5446C26.4169 16.2466 26.4265 15.9485 26.4397 15.6506C26.4568 15.2622 26.4767 14.8739 26.4968 14.4856C26.5084 14.2611 26.5217 14.0366 26.5363 13.8123C26.5542 13.5383 26.573 13.2645 26.5939 12.9909C26.6108 12.7693 26.6314 12.5479 26.6503 12.3264C26.6561 12.2584 26.6642 12.1904 26.6665 12.1223C26.6685 12.0602 26.6428 12.035 26.5818 12.0263H26.5819Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M26.4919 18.9057C26.4919 18.6137 26.4919 18.3218 26.4919 18.0299C26.4919 17.9403 26.4612 17.9118 26.3705 17.9194C26.2975 17.9254 26.2247 17.9351 26.1516 17.94C25.7782 17.9645 25.4044 17.9768 25.0301 17.966C24.8897 17.9619 24.7495 17.9562 24.6096 17.943C24.5359 17.9361 24.4951 17.967 24.4952 18.0314C24.4955 18.1181 24.4952 18.2049 24.4976 18.2912C24.5032 18.4975 24.5038 18.7035 24.5011 18.9097C24.497 19.2127 24.4961 19.5158 24.4949 19.8189C24.4946 19.8842 24.5318 19.9181 24.5958 19.9141C24.7062 19.9073 24.8164 19.8991 24.9268 19.8924C25.262 19.872 25.5974 19.8684 25.9331 19.8767C26.0872 19.8805 26.2412 19.8842 26.3953 19.8887C26.4368 19.8898 26.4683 19.8752 26.4854 19.8366C26.4942 19.8169 26.4919 19.7951 26.4919 19.774C26.4919 19.4846 26.4919 19.1951 26.4919 18.9057Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.0937 19.025C11.4855 17.025 10.8773 15.0251 10.2691 13.0252C10.1821 12.7393 10.0953 12.4534 10.0081 12.1676C9.98122 12.0794 9.91359 12.0358 9.8238 12.0504C9.67676 12.0742 9.53009 12.1004 9.38306 12.1243C8.90394 12.2021 8.42461 12.2785 7.94699 12.3654C7.82354 12.3879 7.73502 12.4564 7.69531 12.5767C6.91092 14.9512 6.12729 17.3259 5.3435 19.7005C5.31081 19.7995 5.3579 19.8643 5.46262 19.8643C6.04324 19.8643 6.62394 19.8643 7.20456 19.8644C7.22829 19.8644 7.25195 19.8644 7.27449 19.8564C7.30174 19.8466 7.32181 19.8296 7.32838 19.7998C7.35854 19.663 7.38839 19.5261 7.41892 19.3893C7.51125 18.9753 7.60388 18.5614 7.69635 18.1474C7.70053 18.1286 7.70412 18.1157 7.73121 18.1161C8.36766 18.1253 9.00419 18.1335 9.64064 18.1405C9.66997 18.1408 9.68064 18.1496 9.68669 18.1774C9.80686 18.7262 9.92792 19.2748 10.0488 19.8235C10.0641 19.8924 10.09 19.9134 10.1615 19.9143C10.1751 19.9144 10.1888 19.9136 10.2024 19.9133C10.5342 19.9043 10.8661 19.8953 11.1245 19.8884C11.5398 19.8884 11.8818 19.8887 12.2237 19.8882C12.3056 19.888 12.3412 19.8388 12.3177 19.7615C12.2429 19.5159 12.1682 19.2705 12.0936 19.0249L12.0937 19.025ZM9.34051 16.644C8.94015 16.6432 8.53978 16.643 8.13934 16.6441C8.10501 16.6442 8.10538 16.634 8.11307 16.6064C8.29444 15.9554 8.46619 15.3017 8.63188 14.6465C8.67928 14.459 8.72377 14.2707 8.76974 14.0828C8.77146 14.0759 8.774 14.0692 8.77945 14.0523C8.90872 14.5827 9.02374 15.106 9.14302 15.6283C9.21751 15.9548 9.29297 16.281 9.36977 16.607C9.37723 16.6387 9.37104 16.6439 9.34059 16.6438L9.34051 16.644Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M23.5622 19.3106C23.5346 18.9127 23.5159 18.5144 23.5118 18.1155C23.5057 17.5339 23.5191 16.9525 23.5281 16.3711C23.532 16.1138 23.5269 15.8569 23.4822 15.6023C23.4169 15.2305 23.2362 14.9298 22.9335 14.7035C22.7102 14.5368 22.4547 14.4442 22.1857 14.385C21.7507 14.2894 21.3103 14.2844 20.8686 14.3134C20.5634 14.3334 20.2606 14.3744 19.9598 14.4294C19.6592 14.4843 19.3621 14.5539 19.0689 14.6394C18.9978 14.6602 18.9741 14.6907 18.9707 14.765C18.9668 14.8482 18.9644 14.9314 18.9609 15.0146C18.9519 15.2268 18.9426 15.439 18.9337 15.6513C18.9296 15.7494 18.9242 15.8475 18.9235 15.9455C18.9229 16.0341 18.9977 16.0735 19.0616 16.0485C19.2984 15.9556 19.536 15.8654 19.7794 15.7912C20.1426 15.6804 20.5126 15.6128 20.8941 15.6208C21.0202 15.6234 21.1447 15.6347 21.2631 15.6822C21.3808 15.7294 21.4547 15.8127 21.4726 15.9404C21.4802 15.9947 21.4756 16.0495 21.4748 16.1041C21.4744 16.134 21.464 16.1462 21.4328 16.1506C21.2987 16.1693 21.1648 16.1889 21.0315 16.2122C20.6274 16.283 20.2297 16.3784 19.8456 16.5249C19.5317 16.6446 19.2349 16.795 18.9744 17.01C18.6792 17.2537 18.4694 17.5539 18.3889 17.9322C18.3108 18.2999 18.3393 18.6635 18.4597 19.019C18.551 19.2885 18.7027 19.518 18.929 19.6944C19.1683 19.8809 19.4436 19.968 19.7436 19.9856C19.7437 19.9876 19.7439 19.9896 19.7442 19.9917H19.9531C19.9531 19.9895 19.9531 19.9874 19.9534 19.9853C20.0626 19.9767 20.1706 19.9602 20.2769 19.9341C20.715 19.8266 21.1138 19.633 21.4859 19.3815C21.504 19.3693 21.5218 19.3567 21.5446 19.341V19.3885C21.5446 19.5264 21.5444 19.6644 21.5447 19.8023C21.5448 19.8857 21.5747 19.9153 21.6569 19.9141C21.862 19.9112 22.0671 19.9079 22.2723 19.905C22.68 19.8993 23.0878 19.8939 23.4955 19.8881C23.5647 19.8872 23.5949 19.8553 23.5937 19.7863C23.5936 19.7788 23.5932 19.7713 23.5928 19.7639C23.5825 19.6127 23.5725 19.4616 23.5621 19.3104L23.5622 19.3106ZM21.496 17.8077C21.496 17.9742 21.4954 18.1406 21.4967 18.307C21.4969 18.3329 21.4882 18.3466 21.4662 18.3593C21.2648 18.476 21.0523 18.5529 20.8154 18.5375C20.534 18.5192 20.3311 18.3477 20.3015 18.0723C20.2698 17.7772 20.3936 17.5557 20.6849 17.4282C20.8328 17.3634 20.9893 17.3308 21.1482 17.3084C21.2514 17.2939 21.3553 17.2842 21.4588 17.2708C21.4875 17.2671 21.497 17.2737 21.4967 17.3047C21.4952 17.4724 21.496 17.6401 21.496 17.8077Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M22.8343 24.048C22.8055 23.3514 22.7863 22.6545 22.7809 21.9574C22.7765 21.4017 22.7796 20.846 22.775 20.2904C22.7714 19.8572 22.7709 19.4237 22.716 18.9928C22.6843 18.7444 22.6332 18.5006 22.524 18.2729C22.3309 17.8697 22.0121 17.5976 21.612 17.4156C21.0543 17.1618 20.4737 17.1441 19.8831 17.2662C19.4067 17.3647 18.9658 17.5544 18.5469 17.7986C18.422 17.8713 18.3008 17.9498 18.172 18.0354C18.172 18.0107 18.172 17.9969 18.172 17.9829C18.1704 17.5845 18.1689 17.1861 18.1672 16.7877C18.1639 15.9734 18.1594 15.1592 18.141 14.3451C18.1395 14.2735 18.1381 14.2018 18.1311 14.1306C18.1227 14.0457 18.0513 13.9877 17.9771 14.0022C17.6534 14.0654 17.3297 14.1293 17.0061 14.193C16.5916 14.2747 16.1757 14.3487 15.7574 14.4082C15.5568 14.4368 15.3561 14.4643 15.1555 14.4925C15.14 14.4947 15.1219 14.4968 15.1148 14.5121C15.1061 14.5306 15.1234 14.5412 15.1354 14.5495C15.1531 14.5617 15.1511 14.5791 15.1535 14.596C15.1955 14.8881 15.2279 15.1814 15.2545 15.4753C15.2957 15.9311 15.3206 16.3881 15.338 16.8455C15.364 17.5247 15.376 18.2044 15.3806 18.8841C15.394 20.8918 15.3799 22.8995 15.3612 24.9072C15.3601 25.0292 15.3922 25.0608 15.514 25.0592C16.2202 25.05 16.9264 25.0404 17.6327 25.0314C17.8355 25.0288 18.0384 25.0285 18.2411 25.0251C18.3256 25.0236 18.3915 24.9907 18.3832 24.8806C18.3622 24.6002 18.3528 24.3189 18.3382 24.038C18.3066 23.4274 18.2799 22.8165 18.2668 22.2051C18.2613 21.95 18.254 21.695 18.252 21.4399C18.2473 20.844 18.2454 20.2483 18.2415 19.6524C18.2413 19.6252 18.2507 19.6124 18.2758 19.6028C18.3717 19.5656 18.4668 19.526 18.5623 19.4874C18.7722 19.4024 18.9876 19.3537 19.2166 19.377C19.4133 19.3969 19.5651 19.4818 19.6596 19.6593C19.6917 19.7196 19.7176 19.7824 19.7372 19.8477C19.8278 20.1496 19.8519 20.4615 19.8708 20.7733C19.8971 21.2059 19.903 21.6392 19.9049 22.0726C19.9092 23.0285 19.8981 23.9842 19.8935 24.94C19.893 25.0563 19.9305 25.0936 20.0474 25.0932C20.4565 25.0914 20.8653 25.0743 21.2743 25.0649C21.4945 25.0598 21.7148 25.0565 21.935 25.0653C22.2022 25.0759 22.4692 25.0933 22.7369 25.0932C22.8379 25.0932 22.8838 25.0437 22.8787 24.9435C22.8635 24.6452 22.8465 24.3469 22.8342 24.0485L22.8343 24.048Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M34.8808 14.0374C34.8026 14.0263 34.7282 14.0504 34.6529 14.0624C34.2116 14.1329 33.7705 14.2057 33.3294 14.2773C32.9089 14.3455 32.4884 14.4143 32.0677 14.4809C31.9233 14.5038 31.8642 14.5762 31.8777 14.7212C31.9016 14.9786 31.9256 15.2358 31.9471 15.4934C31.981 15.9006 32.0129 16.3081 32.0457 16.7154C32.0824 17.1715 32.1105 17.6283 32.1366 18.0852C32.1612 18.5178 32.1822 18.9505 32.2035 19.3832C32.2345 20.013 32.2646 20.643 32.2943 21.2729C32.2998 21.3885 32.356 21.444 32.473 21.4421C32.7981 21.4366 33.1232 21.4305 33.4484 21.4247C33.4484 21.4236 33.4484 21.4226 33.4484 21.4215C33.5201 21.4215 33.5918 21.4225 33.6635 21.4213C33.9256 21.4174 34.1878 21.4133 34.45 21.4084C34.5493 21.4065 34.6118 21.3475 34.614 21.2558C34.6211 20.9676 34.6262 20.6793 34.6353 20.3912C34.6487 19.9721 34.6623 19.553 34.6807 19.1341C34.7049 18.5879 34.7328 18.0418 34.761 17.4957C34.7774 17.18 34.7961 16.8644 34.8167 16.5489C34.8419 16.1637 34.8682 15.7786 34.8976 15.3938C34.9214 15.0822 34.9504 14.7708 34.9769 14.4594C34.9851 14.3638 34.9966 14.2682 34.9997 14.1723C35.0025 14.085 34.9664 14.0495 34.8807 14.0374H34.8808Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M34.7542 23.711C34.7542 23.3005 34.7542 22.89 34.7542 22.4795C34.7542 22.3535 34.711 22.3134 34.5835 22.324C34.4809 22.3325 34.3785 22.3462 34.2758 22.353C33.7506 22.3875 33.225 22.4048 32.6986 22.3896C32.5012 22.3838 32.304 22.3758 32.1073 22.3573C32.0037 22.3475 31.9462 22.391 31.9465 22.4816C31.9468 22.6034 31.9463 22.7255 31.9497 22.8469C31.9577 23.1369 31.9585 23.4266 31.9546 23.7166C31.949 24.1428 31.9477 24.569 31.9459 24.9953C31.9455 25.087 31.9979 25.1347 32.0878 25.1291C32.2431 25.1196 32.3981 25.108 32.5533 25.0986C33.0247 25.0699 33.4964 25.0648 33.9684 25.0765C34.1851 25.0819 34.4017 25.087 34.6184 25.0933C34.6768 25.095 34.721 25.0744 34.7451 25.0201C34.7574 24.9923 34.7542 24.9617 34.7542 24.9321C34.7543 24.5251 34.7542 24.118 34.7542 23.711Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.5068 23.8789C13.6516 21.0665 12.7963 18.2541 11.941 15.4417C11.8188 15.0397 11.6966 14.6377 11.574 14.2357C11.5362 14.1117 11.4411 14.0504 11.3148 14.0709C11.1081 14.1044 10.9018 14.1412 10.695 14.1748C10.0213 14.2843 9.34722 14.3918 8.67557 14.5139C8.50197 14.5455 8.37748 14.6419 8.32164 14.8111C7.2186 18.1502 6.11661 21.4896 5.01441 24.8289C4.96843 24.9681 5.03467 25.0592 5.18193 25.0592C5.99842 25.0592 6.81502 25.0592 7.63152 25.0594C7.6649 25.0594 7.69817 25.0594 7.72987 25.0481C7.76818 25.0344 7.79642 25.0104 7.80565 24.9685C7.84806 24.7761 7.89004 24.5836 7.93297 24.3913C8.06281 23.8091 8.19307 23.227 8.32311 22.6449C8.32899 22.6183 8.33403 22.6003 8.37213 22.6008C9.26714 22.6138 10.1623 22.6253 11.0573 22.6351C11.0985 22.6356 11.1135 22.6479 11.122 22.687C11.291 23.4588 11.4613 24.2302 11.6313 25.0018C11.6527 25.0988 11.6892 25.1283 11.7897 25.1295C11.8089 25.1298 11.8281 25.1286 11.8473 25.1281C12.3139 25.1155 12.7805 25.1029 13.1439 25.0931C13.728 25.0931 14.2088 25.0935 14.6897 25.0928C14.8048 25.0926 14.8549 25.0234 14.8218 24.9147C14.7167 24.5694 14.6117 24.2242 14.5067 23.8788L14.5068 23.8789ZM10.6352 20.5307C10.0722 20.5295 9.50918 20.5293 8.94606 20.5309C8.89778 20.531 8.8983 20.5166 8.90911 20.4779C9.16417 19.5623 9.40569 18.6431 9.6387 17.7218C9.70535 17.458 9.76791 17.1933 9.83257 16.929C9.83498 16.9193 9.83855 16.9099 9.84621 16.8862C10.028 17.632 10.1898 18.3679 10.3575 19.1023C10.4622 19.5614 10.5683 20.0202 10.6764 20.4786C10.6868 20.5233 10.6781 20.5306 10.6353 20.5304L10.6352 20.5307Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M30.6346 24.2803C30.5958 23.7208 30.5695 23.1606 30.5637 22.5997C30.5552 21.7818 30.574 20.9642 30.5866 20.1465C30.5922 19.7848 30.585 19.4235 30.5221 19.0654C30.4303 18.5426 30.1762 18.1197 29.7505 17.8016C29.4365 17.5671 29.0772 17.4369 28.6989 17.3537C28.0871 17.2192 27.4679 17.2122 26.8467 17.2529C26.4175 17.2811 25.9918 17.3387 25.5687 17.416C25.146 17.4933 24.7283 17.5911 24.3159 17.7114C24.2159 17.7406 24.1826 17.7835 24.1777 17.8881C24.1724 18.005 24.1689 18.122 24.164 18.2389C24.1514 18.5375 24.1383 18.8359 24.1258 19.1344C24.12 19.2723 24.1123 19.4102 24.1114 19.5481C24.1106 19.6727 24.2158 19.7281 24.3056 19.6929C24.6386 19.5623 24.9727 19.4354 25.315 19.3311C25.8258 19.1753 26.346 19.0802 26.8826 19.0914C27.0599 19.0951 27.235 19.111 27.4015 19.1778C27.567 19.2442 27.6709 19.3613 27.6961 19.5409C27.7068 19.6173 27.7003 19.6943 27.6992 19.7712C27.6987 19.8132 27.684 19.8304 27.6401 19.8365C27.4516 19.8628 27.2633 19.8904 27.0758 19.9232C26.5076 20.0227 25.9483 20.1568 25.4081 20.3628C24.9667 20.5312 24.5493 20.7427 24.183 21.0451C23.7679 21.3878 23.4728 21.8098 23.3597 22.3419C23.2498 22.8589 23.2899 23.3703 23.4592 23.8701C23.5875 24.2492 23.8009 24.5719 24.1192 24.8199C24.4557 25.0822 24.8429 25.2047 25.2647 25.2295C25.2648 25.2323 25.2651 25.2352 25.2656 25.238H25.5593C25.5593 25.235 25.5593 25.232 25.5598 25.2291C25.7133 25.217 25.8651 25.1938 26.0147 25.1571C26.6307 25.0059 27.1915 24.7337 27.7148 24.3799C27.7402 24.3628 27.7652 24.3451 27.7973 24.3229V24.3898C27.7973 24.5838 27.797 24.7777 27.7974 24.9717C27.7977 25.0891 27.8396 25.1306 27.9553 25.1289C28.2437 25.1248 28.5322 25.1202 28.8206 25.1161C29.394 25.1082 29.9674 25.1005 30.5408 25.0924C30.6381 25.091 30.6805 25.0462 30.679 24.9491C30.6787 24.9386 30.6782 24.9282 30.6776 24.9178C30.6632 24.7051 30.6491 24.4926 30.6345 24.2799L30.6346 24.2803ZM27.729 22.1668C27.729 22.4009 27.7282 22.6349 27.73 22.8689C27.7303 22.9053 27.7181 22.9246 27.6871 22.9425C27.4039 23.1066 27.105 23.2148 26.772 23.1931C26.3762 23.1674 26.0909 22.9261 26.0492 22.5389C26.0046 22.1239 26.1787 21.8124 26.5884 21.6331C26.7964 21.542 27.0165 21.4961 27.2399 21.4647C27.3851 21.4443 27.5312 21.4306 27.6766 21.4118C27.717 21.4066 27.7305 21.4159 27.7301 21.4595C27.7279 21.6952 27.729 21.9311 27.729 22.1668Z",
                fill: "#0172CE"
            })
        ]
    });
};

});


parcelRegister("8DeZp", function(module, exports) {

$parcel$export(module.exports, "airtableConfig", () => $a840f57b79db2ae9$export$962b0679c5bd2c33);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $d51Wr = parcelRequire("d51Wr");

var $5yrII = parcelRequire("5yrII");
const $a840f57b79db2ae9$export$962b0679c5bd2c33 = {
    displayName: 'Airtable',
    id: 'airtable',
    resourceType: 'airtable-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $d51Wr.AirtableIcon), 'Airtable', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $5yrII.AirtableSearchResultIcon), 'Airtable', 'large'),
    integrationAri: 'ari:cloud:platform::integration/airtable',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("d51Wr", function(module, exports) {

$parcel$export(module.exports, "AirtableIcon", () => $b6fac48c247386ba$export$88b64eee273831fd);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $b6fac48c247386ba$export$88b64eee273831fd = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-635.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.1447 5.16889L5.17945 7.63723C4.84772 7.77451 4.85115 8.24569 5.18496 8.37801L11.1751 10.7535C11.7015 10.9622 12.2876 10.9622 12.8139 10.7535L18.8042 8.37801C19.1379 8.24569 19.1414 7.77451 18.8096 7.63723L12.8445 5.16889C12.3002 4.9437 11.6888 4.9437 11.1447 5.16889Z",
                fill: "#FFBF00"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.5259 12.0506V17.9848C12.5259 18.2671 12.8105 18.4603 13.0728 18.3563L19.7477 15.7655C19.9001 15.705 20.0001 15.5578 20.0001 15.3939V9.45974C20.0001 9.17748 19.7155 8.98421 19.4531 9.08821L12.7782 11.6791C12.6259 11.7395 12.5259 11.8867 12.5259 12.0506Z",
                fill: "#26B5F8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.9672 12.3568L8.98623 13.3133L8.78509 13.4105L4.6034 15.4141C4.33833 15.542 4 15.3488 4 15.0544V9.48465C4 9.37811 4.05462 9.28613 4.12788 9.21686C4.15845 9.1862 4.19309 9.16097 4.22908 9.14098C4.32901 9.08102 4.47155 9.06501 4.59273 9.11295L10.9339 11.6254C11.2562 11.7533 11.2815 12.2049 10.9672 12.3568Z",
                fill: "#ED3049"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.9672 12.3568L8.98628 13.3133L4.12793 9.21686C4.1585 9.1862 4.19314 9.16097 4.22913 9.14098C4.32906 9.08102 4.4716 9.06501 4.59278 9.11295L10.934 11.6254C11.2563 11.7533 11.2816 12.2049 10.9672 12.3568Z",
                fill: "black",
                fillOpacity: "0.25"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.2515 6.14778L6.03189 8.30757C5.74163 8.4277 5.74464 8.83998 6.03672 8.95576L11.2781 11.0343C11.7387 11.2169 12.2515 11.2169 12.712 11.0343L17.9535 8.95576C18.2455 8.83998 18.2486 8.4277 17.9583 8.30757L12.7388 6.14778C12.2625 5.95074 11.7276 5.95074 11.2515 6.14778Z",
                fill: "#FFBF00"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.4601 12.1693V17.3617C12.4601 17.6087 12.7091 17.7778 12.9387 17.6868L18.7792 15.4198C18.9126 15.3669 19 15.2381 19 15.0947V9.90228C19 9.65531 18.751 9.4862 18.5214 9.5772L12.6809 11.8442C12.5476 11.8971 12.4601 12.0259 12.4601 12.1693Z",
                fill: "#26B5F8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.0963 12.4372L9.36295 13.2741L9.18695 13.3592L5.52798 15.1124C5.29604 15.2243 5 15.0552 5 14.7976V9.92405C5 9.83083 5.0478 9.75035 5.11189 9.68974C5.13864 9.66291 5.16895 9.64083 5.20045 9.62334C5.28789 9.57088 5.4126 9.55687 5.51864 9.59881L11.0672 11.7972C11.3492 11.9091 11.3714 12.3043 11.0963 12.4372Z",
                fill: "#ED3049"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.0963 12.4372L9.36293 13.2741L5.11188 9.68974C5.13862 9.66291 5.16893 9.64083 5.20043 9.62334C5.28787 9.57088 5.41258 9.55687 5.51862 9.59881L11.0671 11.7972C11.3492 11.9091 11.3713 12.3043 11.0963 12.4372Z",
                fill: "black",
                fillOpacity: "0.25"
            })
        ]
    });
};

});

parcelRegister("5yrII", function(module, exports) {

$parcel$export(module.exports, "AirtableSearchResultIcon", () => $c40804a00e4b92d9$export$826c628c1cea041a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $c40804a00e4b92d9$export$826c628c1cea041a = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-163.5",
                y: "-263.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "31",
                height: "31",
                rx: "7.5",
                stroke: "#0B1228",
                strokeOpacity: "0.14"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.8596 6.89182L6.90601 10.1829C6.46371 10.366 6.46829 10.9942 6.91336 11.1706L14.9003 14.3379C15.6021 14.6162 16.3836 14.6162 17.0853 14.3379L25.0723 11.1706C25.5172 10.9942 25.5219 10.366 25.0795 10.1829L17.126 6.89182C16.4003 6.59156 15.5852 6.59156 14.8596 6.89182Z",
                fill: "#FFBF00"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.7012 16.0675V23.9798C16.7012 24.3561 17.0807 24.6138 17.4305 24.4751L26.3303 21.0206C26.5335 20.9401 26.6667 20.7437 26.6667 20.5252V12.613C26.6667 12.2366 26.2873 11.9789 25.9375 12.1176L17.0376 15.5721C16.8345 15.6527 16.7012 15.849 16.7012 16.0675Z",
                fill: "#26B5F8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.6231 16.4758L11.9818 17.7511L11.7136 17.8807L6.13804 20.5522C5.7846 20.7227 5.3335 20.4652 5.3335 20.0725V12.6462C5.3335 12.5042 5.40633 12.3816 5.504 12.2892C5.54476 12.2483 5.59094 12.2147 5.63894 12.188C5.77218 12.1081 5.96222 12.0867 6.12381 12.1506L14.5787 15.5006C15.0085 15.6711 15.0422 16.2733 14.6231 16.4758Z",
                fill: "#ED3049"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.623 16.4758L11.9817 17.7511L5.50391 12.2892C5.54466 12.2483 5.59085 12.2147 5.63884 12.188C5.77209 12.1081 5.96213 12.0867 6.12371 12.1506L14.5786 15.5006C15.0084 15.6711 15.0421 16.2733 14.623 16.4758Z",
                fill: "black",
                fillOpacity: "0.25"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.3959 7.81668L7.21116 12.4448C6.58917 12.7022 6.59561 13.5857 7.2215 13.8338L18.4531 18.2877C19.44 18.6791 20.539 18.6791 21.5257 18.2877L32.7575 13.8338C33.3832 13.5857 33.3898 12.7022 32.7677 12.4448L21.583 7.81668C20.5626 7.39444 19.4163 7.39444 18.3959 7.81668Z",
                fill: "#FFBF00"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.9858 20.7199V31.8465C20.9858 32.3758 21.5195 32.7381 22.0114 32.5431L34.5268 27.6852C34.8126 27.572 34.9999 27.2959 34.9999 26.9886V15.862C34.9999 15.3328 34.4663 14.9704 33.9744 15.1654L21.4589 20.0233C21.1734 20.1366 20.9858 20.4126 20.9858 20.7199Z",
                fill: "#26B5F8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.0635 21.2941L14.3492 23.0875L13.972 23.2698L6.13138 27.0266C5.63437 27.2664 5 26.9042 5 26.3521V15.9088C5 15.7091 5.10242 15.5366 5.23977 15.4067C5.29709 15.3492 5.36204 15.3019 5.42953 15.2644C5.6169 15.152 5.88415 15.122 6.11137 15.2119L18.0011 19.9228C18.6054 20.1625 18.6529 21.0094 18.0635 21.2941Z",
                fill: "#ED3049"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.0635 21.2941L14.3492 23.0875L5.23981 15.4067C5.29712 15.3492 5.36207 15.3019 5.42956 15.2644C5.61693 15.152 5.88418 15.122 6.11141 15.2119L18.0011 19.9228C18.6055 20.1625 18.6529 21.0094 18.0635 21.2941Z",
                fill: "black",
                fillOpacity: "0.25"
            })
        ]
    });
};

});


parcelRegister("hLggb", function(module, exports) {

$parcel$export(module.exports, "amplitudeConfig", () => $0fca80b1ee670a5c$export$a0702b571a9392d4);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $ePw8X = parcelRequire("ePw8X");

var $33Dzi = parcelRequire("33Dzi");
const $0fca80b1ee670a5c$export$a0702b571a9392d4 = {
    displayName: 'Amplitude',
    id: 'amplitude',
    resourceType: 'smartlinks-connector-amplitude',
    icon: (0, $9yyKc.get3PLogo)((0, $ePw8X.AmplitudeIcon), 'Amplitude', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $33Dzi.AmplitudeSearchResultIcon), 'Amplitude', 'large'),
    integrationAri: 'ari:cloud:platform::integration/amplitude',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Dashboard
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("ePw8X", function(module, exports) {

$parcel$export(module.exports, "AmplitudeIcon", () => $e2057eb553a6eabc$export$5e013c7991ef7bd0);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $e2057eb553a6eabc$export$5e013c7991ef7bd0 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-683.5",
                y: "-507.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#007FD2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.0516 7.60124C11.0073 7.54277 10.9568 7.51208 10.9007 7.51208C10.8545 7.51208 10.8122 7.53281 10.7851 7.55016C10.3591 7.88478 9.77609 9.30229 9.29834 11.1701L9.72131 11.1749C10.5565 11.1844 11.419 11.1942 12.2715 11.2073C12.0468 10.3518 11.8344 9.61843 11.6397 9.02646C11.3552 8.16124 11.1629 7.77393 11.0516 7.60124Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 12.0001C20 16.4183 16.4183 20.0001 12 20.0001C7.58169 20.0001 4 16.4183 4 12.0001C4 7.58181 7.58169 4.00012 12 4.00012C16.4183 4.00012 20 7.58181 20 12.0001ZM17.9088 11.8171C17.9088 11.6117 17.764 11.4404 17.569 11.4014C17.5679 11.4012 17.5667 11.4009 17.5655 11.4006C17.5632 11.4003 17.561 11.3995 17.5587 11.3992L17.5508 11.3984C17.5301 11.395 17.5091 11.3929 17.4876 11.3926L17.4315 11.3873C16.0916 11.2914 14.7131 11.2536 13.4199 11.2278L13.4173 11.2183C12.788 8.85747 12.0018 6.44382 10.9417 6.44382C9.9539 6.44831 9.06345 8.03418 8.29446 11.1584C7.75116 11.1514 7.2559 11.1439 6.78892 11.1359C6.76241 11.1354 6.73863 11.1352 6.71743 11.1352C6.61783 11.1352 6.56916 11.1394 6.54506 11.1426C6.28209 11.1892 6.09124 11.4186 6.09124 11.6883C6.09124 11.9633 6.29655 12.1992 6.56402 12.2377L6.56948 12.2433H8.04257C7.90586 12.8684 7.78602 13.4865 7.68594 14.0821L7.64209 14.3442L7.64161 14.3567C7.64257 14.559 7.80787 14.7235 8.00996 14.7235C8.13815 14.7235 8.2543 14.6567 8.32064 14.5526L8.33108 14.5609L9.05526 12.2433H12.5435C12.81 13.2502 13.0864 14.2899 13.4517 15.2657C13.6471 15.7874 14.1044 17.0094 14.8688 17.0155H14.8774C16.0604 17.0155 16.5214 15.1047 16.8268 13.8398C16.8924 13.5677 16.9491 13.3327 17.0026 13.16L17.0239 13.0886H17.0238C17.0289 13.0719 17.0316 13.0543 17.0316 13.0358C17.0316 12.9346 16.9496 12.8525 16.8484 12.8525C16.7698 12.8525 16.703 12.9018 16.6768 12.9712L16.6765 12.971L16.6508 13.0421C16.5504 13.32 16.4575 13.5828 16.3753 13.8157L16.369 13.8332C15.857 15.2833 15.6233 15.9452 15.1655 15.9453L15.1542 15.9452L15.1478 15.9461L15.1364 15.9458C14.5504 15.9458 13.9986 13.5635 13.7908 12.6668C13.7549 12.5114 13.7219 12.3688 13.6916 12.2433H17.481C17.5521 12.2433 17.6191 12.2255 17.6779 12.1947C17.6784 12.1945 17.6787 12.1943 17.679 12.1942C17.685 12.1911 17.6906 12.1876 17.6964 12.1842C17.7028 12.1805 17.7091 12.1768 17.7152 12.1728C17.7182 12.1709 17.7211 12.1688 17.724 12.1667C17.7332 12.1604 17.742 12.1539 17.7507 12.1468C17.7513 12.1463 17.7518 12.1458 17.7524 12.1453C17.8479 12.0671 17.9088 11.9486 17.9088 11.8171Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.9329 7.05123C10.883 6.98545 10.8263 6.95093 10.7632 6.95093C10.7112 6.95093 10.6636 6.97424 10.6331 6.99376C10.1538 7.37021 9.49798 8.9649 8.96051 11.0662L9.43635 11.0716C10.3759 11.0823 11.3462 11.0933 12.3053 11.1081C12.0525 10.1456 11.8136 9.32057 11.5945 8.6546C11.2745 7.68123 11.0582 7.24551 10.9329 7.05123Z",
                fill: "#007FD2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21 12C21 16.9704 16.9706 21 12 21C7.0294 21 3 16.9704 3 12C3 7.0294 7.0294 3 12 3C16.9706 3 21 7.0294 21 12ZM18.6473 11.7942C18.6473 11.563 18.4845 11.3704 18.2651 11.3264C18.2639 11.3263 18.2626 11.3259 18.2611 11.3255C18.2586 11.3252 18.2561 11.3243 18.2536 11.3239L18.2447 11.323C18.2214 11.3192 18.1977 11.3169 18.1735 11.3165L18.1104 11.3105C16.603 11.2027 15.0522 11.1602 13.5974 11.1311L13.5945 11.1204C12.8864 8.46452 12.002 5.74916 10.8094 5.74916C9.69813 5.75422 8.69639 7.53831 7.83126 11.053C7.22006 11.0452 6.66289 11.0367 6.13753 11.0277C6.10771 11.0272 6.08096 11.027 6.05711 11.027C5.94506 11.027 5.8903 11.0317 5.86319 11.0353C5.56735 11.0877 5.35265 11.3458 5.35265 11.6492C5.35265 11.9586 5.58361 12.2239 5.88452 12.2673L5.89066 12.2736H7.54789C7.3941 12.9768 7.25928 13.6722 7.14669 14.3422L7.09735 14.6371L7.09681 14.6512C7.09789 14.8787 7.28385 15.0638 7.5112 15.0638C7.65542 15.0638 7.78608 14.9886 7.86072 14.8715L7.87247 14.8809L8.68717 12.2736H12.6114C12.9112 13.4064 13.2222 14.576 13.6332 15.6737C13.853 16.2607 14.3675 17.6355 15.2273 17.6423H15.2371C16.568 17.6423 17.0866 15.4927 17.4302 14.0696C17.5039 13.7635 17.5677 13.4991 17.6279 13.3048L17.6519 13.2246H17.6517C17.6575 13.2058 17.6606 13.1859 17.6606 13.1651C17.6606 13.0513 17.5683 12.9589 17.4544 12.9589C17.366 12.9589 17.2908 13.0144 17.2614 13.0925L17.261 13.0923L17.2321 13.1722C17.1192 13.4848 17.0147 13.7805 16.9222 14.0425L16.9151 14.0622C16.3392 15.6936 16.0762 16.4382 15.5611 16.4384L15.5485 16.4382L15.5413 16.4393L15.5284 16.4389C14.8692 16.4389 14.2484 13.7588 14.0147 12.75C13.9742 12.5752 13.9372 12.4148 13.903 12.2736H18.1661C18.2461 12.2736 18.3215 12.2536 18.3877 12.2189C18.3882 12.2187 18.3886 12.2185 18.3889 12.2183C18.3956 12.2149 18.4019 12.2109 18.4084 12.2071C18.4157 12.203 18.4227 12.1988 18.4296 12.1943C18.433 12.1921 18.4363 12.1898 18.4395 12.1874C18.4498 12.1804 18.4598 12.173 18.4695 12.165C18.4702 12.1645 18.4708 12.1639 18.4715 12.1634C18.5789 12.0754 18.6473 11.942 18.6473 11.7942Z",
                fill: "#007FD2"
            })
        ]
    });
};

});

parcelRegister("33Dzi", function(module, exports) {

$parcel$export(module.exports, "AmplitudeSearchResultIcon", () => $5b4da4c9c9d719ab$export$49b3130ea0e9d6dd);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $5b4da4c9c9d719ab$export$49b3130ea0e9d6dd = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-211.5",
                y: "-502.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
                fill: "#007FD2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.7351 10.135C14.676 10.057 14.6088 10.0161 14.534 10.0161C14.4723 10.0161 14.416 10.0437 14.3798 10.0669C13.8118 10.513 13.0345 12.403 12.3975 14.8934L12.9614 14.8999C14.075 14.9125 15.225 14.9256 16.3617 14.9431C16.062 13.8024 15.7789 12.8246 15.5193 12.0353C15.14 10.8817 14.8836 10.3652 14.7351 10.135Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.6666 16.0002C26.6666 21.891 21.891 26.6668 15.9999 26.6668C10.1088 26.6668 5.33325 21.891 5.33325 16.0002C5.33325 10.1091 10.1088 5.3335 15.9999 5.3335C21.891 5.3335 26.6666 10.1091 26.6666 16.0002ZM23.8783 15.7562C23.8783 15.4823 23.6853 15.2539 23.4252 15.2019C23.4237 15.2017 23.4222 15.2012 23.4205 15.2008C23.4175 15.2004 23.4145 15.1993 23.4115 15.1989L23.401 15.1978C23.3734 15.1933 23.3454 15.1905 23.3167 15.1901L23.2419 15.183C21.4553 15.0552 19.6174 15.0048 17.8931 14.9703L17.8897 14.9577C17.0505 11.81 16.0023 8.59176 14.5888 8.59176C13.2718 8.59775 12.0845 10.7122 11.0592 14.8778C10.3348 14.8686 9.67446 14.8585 9.05181 14.8478C9.01646 14.8472 8.98476 14.847 8.95649 14.847C8.82369 14.847 8.75879 14.8525 8.72667 14.8568C8.37604 14.9189 8.12158 15.2248 8.12158 15.5844C8.12158 15.9511 8.39531 16.2655 8.75194 16.317L8.75922 16.3244H10.7233C10.5411 17.1579 10.3813 17.9821 10.2478 18.7761L10.1894 19.1256L10.1887 19.1423C10.19 19.412 10.4104 19.6313 10.6799 19.6313C10.8508 19.6313 11.0056 19.5422 11.0941 19.4034L11.108 19.4146L12.0736 16.3244H16.7245C17.0799 17.667 17.4485 19.0532 17.9356 20.3542C18.196 21.0499 18.8058 22.6793 19.8249 22.6874H19.8365C21.4138 22.6874 22.0285 20.1396 22.4357 18.4531C22.5231 18.0902 22.5987 17.7769 22.67 17.5466L22.6985 17.4515H22.6983C22.7051 17.4292 22.7088 17.4057 22.7088 17.381C22.7088 17.2461 22.5993 17.1367 22.4644 17.1367C22.3597 17.1367 22.2705 17.2024 22.2356 17.2949L22.2352 17.2947L22.2009 17.3894C22.0671 17.7599 21.9433 18.1104 21.8336 18.4209L21.8252 18.4443C21.1426 20.3778 20.831 21.2602 20.2205 21.2605L20.2055 21.2602L20.197 21.2615L20.1818 21.2611C19.4004 21.2611 18.6647 18.0847 18.3877 16.8891C18.3397 16.6819 18.2958 16.4917 18.2553 16.3244H23.3079C23.4028 16.3244 23.4921 16.3007 23.5705 16.2595C23.5711 16.2593 23.5715 16.2591 23.572 16.2589C23.5799 16.2548 23.5874 16.2501 23.5951 16.2456C23.6037 16.2407 23.612 16.2358 23.6202 16.2304C23.6242 16.2278 23.6281 16.2251 23.6319 16.2223C23.6441 16.2139 23.6559 16.2051 23.6675 16.1957C23.6684 16.1951 23.669 16.1944 23.6699 16.1938C23.7971 16.0895 23.8783 15.9314 23.8783 15.7562Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.2217 11.7521C18.1385 11.6425 18.044 11.585 17.9388 11.585C17.8521 11.585 17.7729 11.6238 17.722 11.6563C16.9232 12.2838 15.8301 14.9416 14.9343 18.4437L15.7274 18.4527C17.2934 18.4705 18.9105 18.4889 20.509 18.5136C20.0876 16.9094 19.6894 15.5344 19.3244 14.4244C18.791 12.8021 18.4304 12.0759 18.2217 11.7521Z",
                fill: "#007FD2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M35 20C35 28.284 28.2843 35 20 35C11.7157 35 5 28.284 5 20C5 11.7157 11.7157 5 20 5C28.2843 5 35 11.7157 35 20ZM31.0789 19.6569C31.0789 19.2717 30.8075 18.9506 30.4419 18.8774C30.4398 18.8771 30.4377 18.8765 30.4352 18.8759C30.431 18.8753 30.4268 18.8738 30.4226 18.8732L30.4078 18.8717C30.369 18.8654 30.3295 18.8614 30.2892 18.8608L30.184 18.8509C27.6717 18.6711 25.087 18.6003 22.6623 18.5518L22.6575 18.534C21.4774 14.1075 20.0033 9.58193 18.0157 9.58193C16.1636 9.59036 14.494 12.5639 13.0521 18.4217C12.0334 18.4087 11.1048 18.3946 10.2292 18.3795C10.1795 18.3786 10.1349 18.3783 10.0952 18.3783C9.90843 18.3783 9.81717 18.3861 9.77199 18.3922C9.27892 18.4795 8.92108 18.9096 8.92108 19.4154C8.92108 19.931 9.30602 20.3732 9.80753 20.4455L9.81777 20.456H12.5798C12.3235 21.628 12.0988 22.7871 11.9111 23.9036L11.8289 24.3952L11.828 24.4187C11.8298 24.7979 12.1398 25.1063 12.5187 25.1063C12.759 25.1063 12.9768 24.981 13.1012 24.7858L13.1208 24.8015L14.4786 20.456H21.019C21.5187 22.344 22.037 24.2934 22.722 26.1229C23.0883 27.1012 23.9458 29.3925 25.3789 29.4039H25.3952C27.6133 29.4039 28.4777 25.8211 29.0503 23.4494C29.1732 22.9392 29.2795 22.4985 29.3798 22.1747L29.4199 22.041H29.4196C29.4292 22.0096 29.4343 21.9765 29.4343 21.9419C29.4343 21.7521 29.2804 21.5982 29.0907 21.5982C28.9434 21.5982 28.8181 21.6907 28.769 21.8208L28.7684 21.8205L28.7202 21.9536C28.5319 22.4747 28.3578 22.9675 28.2036 23.4042L28.1919 23.437C27.2319 26.156 26.7937 27.397 25.9352 27.3973L25.9142 27.397L25.9021 27.3988L25.8807 27.3982C24.7819 27.3982 23.7473 22.9313 23.3578 21.25C23.2904 20.9587 23.2286 20.6913 23.1717 20.456H30.2768C30.4102 20.456 30.5358 20.4226 30.6461 20.3648C30.647 20.3645 30.6476 20.3642 30.6482 20.3639C30.6593 20.3581 30.6699 20.3515 30.6807 20.3452C30.6928 20.3383 30.7045 20.3313 30.716 20.3238C30.7217 20.3202 30.7271 20.3163 30.7325 20.3124C30.7497 20.3006 30.7663 20.2883 30.7825 20.275C30.7837 20.2741 30.7846 20.2732 30.7858 20.2723C30.9648 20.1256 31.0789 19.9033 31.0789 19.6569Z",
                fill: "#007FD2"
            })
        ]
    });
};

});


parcelRegister("iPM8b", function(module, exports) {

$parcel$export(module.exports, "asanaConfig", () => $52e926522dd1141c$export$72c8845a87b8934e);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $ePyBB = parcelRequire("ePyBB");

var $crnrP = parcelRequire("crnrP");
const $52e926522dd1141c$export$72c8845a87b8934e = {
    displayName: 'Asana',
    id: 'asana',
    icon: (0, $9yyKc.get3PLogo)((0, $ePyBB.AsanaIcon), 'Asana', 'medium'),
    resourceType: 'asana-connector',
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $crnrP.AsanaSearchResultIcon), 'Asana', 'large'),
    integrationAri: 'ari:cloud:platform::integration/asana',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Task
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("ePyBB", function(module, exports) {

$parcel$export(module.exports, "AsanaIcon", () => $a16262d82ea80893$export$671541d0c7918cd9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $a16262d82ea80893$export$671541d0c7918cd9 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#F06A6A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.9553 12.3807C14.2737 12.3807 12.9105 13.7439 12.9105 15.4256C12.9105 17.1072 14.2737 18.4704 15.9553 18.4704C17.6369 18.4704 19 17.1072 19 15.4256C19 13.7439 17.6369 12.3807 15.9553 12.3807ZM8.04475 12.381C6.3632 12.381 5 13.7439 5 15.4256C5 17.1072 6.3632 18.4704 8.04475 18.4704C9.72637 18.4704 11.0896 17.1072 11.0896 15.4256C11.0896 13.7439 9.72637 12.381 8.04475 12.381ZM15.0447 8.57471C15.0447 10.2564 13.6816 11.6197 12 11.6197C10.3184 11.6197 8.95526 10.2564 8.95526 8.57471C8.95526 6.89336 10.3184 5.53003 12 5.53003C13.6816 5.53003 15.0447 6.89336 15.0447 8.57471Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.0853 12.8081C14.9233 12.8081 13.1707 14.5607 13.1707 16.7229C13.1707 18.8849 14.9233 20.6376 17.0853 20.6376C19.2474 20.6376 21 18.8849 21 16.7229C21 14.5607 19.2474 12.8081 17.0853 12.8081ZM6.91468 12.8084C4.75268 12.8084 3 14.5607 3 16.7229C3 18.8849 4.75268 20.6376 6.91468 20.6376C9.07677 20.6376 10.8295 18.8849 10.8295 16.7229C10.8295 14.5607 9.07677 12.8084 6.91468 12.8084ZM15.9146 7.91459C15.9146 10.0768 14.162 11.8296 12 11.8296C9.83793 11.8296 8.08533 10.0768 8.08533 7.91459C8.08533 5.75285 9.83793 4 12 4C14.162 4 15.9146 5.75285 15.9146 7.91459Z",
            fill: "#F06A6A"
        })
    });
};

});

parcelRegister("crnrP", function(module, exports) {

$parcel$export(module.exports, "AsanaSearchResultIcon", () => $c5f2f99b79d37b38$export$c3fa6bf9156b56f9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $c5f2f99b79d37b38$export$c3fa6bf9156b56f9 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-67.5",
                y: "-263.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#F06A6A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.2735 16.5076C19.0314 16.5076 17.2139 18.3252 17.2139 20.5674C17.2139 22.8095 19.0314 24.6271 21.2735 24.6271C23.5156 24.6271 25.3332 22.8095 25.3332 20.5674C25.3332 18.3252 23.5156 16.5076 21.2735 16.5076ZM10.7262 16.5079C8.4841 16.5079 6.6665 18.3252 6.6665 20.5674C6.6665 22.8095 8.4841 24.6271 10.7262 24.6271C12.9683 24.6271 14.786 22.8095 14.786 20.5674C14.786 18.3252 12.9683 16.5079 10.7262 16.5079ZM20.0594 11.4329C20.0594 13.6751 18.2419 15.4929 15.9999 15.4929C13.7577 15.4929 11.9402 13.6751 11.9402 11.4329C11.9402 9.19106 13.7577 7.37329 15.9999 7.37329C18.2419 7.37329 20.0594 9.19106 20.0594 11.4329Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.4756 20.9301C24.8722 20.9301 21.9512 23.8512 21.9512 27.4548C21.9512 31.0582 24.8722 33.9793 28.4756 33.9793C32.079 33.9793 35 31.0582 35 27.4548C35 23.8512 32.079 20.9301 28.4756 20.9301ZM11.5245 20.9306C7.92113 20.9306 5 23.8512 5 27.4548C5 31.0582 7.92113 33.9793 11.5245 33.9793C15.1279 33.9793 18.0492 31.0582 18.0492 27.4548C18.0492 23.8512 15.1279 20.9306 11.5245 20.9306ZM26.5243 12.7743C26.5243 16.3779 23.6033 19.2994 20.0001 19.2994C16.3965 19.2994 13.4756 16.3779 13.4756 12.7743C13.4756 9.17141 16.3965 6.25 20.0001 6.25C23.6033 6.25 26.5243 9.17141 26.5243 12.7743Z",
            fill: "#F06A6A"
        })
    });
};

});


parcelRegister("9zZIW", function(module, exports) {

$parcel$export(module.exports, "atlassianWebCrawlerConfig", () => $d81337e880eeaf11$export$fbd198cf40195606);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $buthI = parcelRequire("buthI");

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $3XOBF = parcelRequire("3XOBF");

var $bJkC3 = parcelRequire("bJkC3");
const $d81337e880eeaf11$export$fbd198cf40195606 = {
    displayName: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...(0, $3XOBF.messages)['atlassian-web-crawler']
    }),
    id: 'atlassian-web-crawler',
    resourceType: 'webcrawler-connector',
    icon: (0, $9yyKc.RovoLogoFromLogo)((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), 'Atlassian Web Crawler'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $bJkC3.WebDomainSearchResultIcon), 'Atlassian Web Crawler', 'large'),
    integrationAri: 'ari:cloud:platform::integration/atlassian-web-crawler',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: false,
    isEnabled: ()=>true
};

});
parcelRegister("3XOBF", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f79943a87d92fb5b$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $f79943a87d92fb5b$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    ['atlassian-web-crawler']: {
        id: "search-page.products.custom-website",
        defaultMessage: "Web page"
    }
});

});

parcelRegister("bJkC3", function(module, exports) {

$parcel$export(module.exports, "WebDomainSearchResultIcon", () => $96cf123f24fa5c68$export$b16288f56aa4a879);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $96cf123f24fa5c68$export$b16288f56aa4a879 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.5428 12.0273H8.26521C8.33797 10.243 8.6684 8.61411 9.18567 7.36406C9.26662 7.16841 9.35328 6.97932 9.44572 6.79843C7.34499 7.69706 5.81358 9.67046 5.5428 12.0273ZM12 4.77734C7.58172 4.77734 4 8.35907 4 12.7773C4 17.1956 7.58172 20.7773 12 20.7773C16.4183 20.7773 20 17.1956 20 12.7773C20 8.35907 16.4183 4.77734 12 4.77734ZM12 6.27734C11.849 6.27734 11.6359 6.34815 11.3684 6.62157C11.0985 6.89748 10.8208 7.3355 10.5717 7.93758C10.1403 8.98016 9.83856 10.4072 9.76656 12.0273H14.2334C14.1614 10.4072 13.8597 8.98016 13.4283 7.93758C13.1792 7.3355 12.9015 6.89748 12.6316 6.62157C12.3641 6.34815 12.151 6.27734 12 6.27734ZM15.7348 12.0273C15.662 10.243 15.3316 8.61411 14.8143 7.36406C14.7334 7.16841 14.6467 6.97931 14.5543 6.79843C16.655 7.69706 18.1864 9.67046 18.4572 12.0273H15.7348ZM14.2334 13.5273H9.76656C9.83856 15.1475 10.1403 16.5745 10.5717 17.6171C10.8208 18.2192 11.0985 18.6572 11.3684 18.9331C11.6359 19.2065 11.849 19.2773 12 19.2773C12.151 19.2773 12.3641 19.2065 12.6316 18.9331C12.9015 18.6572 13.1792 18.2192 13.4283 17.6171C13.8597 16.5745 14.1614 15.1475 14.2334 13.5273ZM14.5543 18.7563C14.6467 18.5754 14.7334 18.3863 14.8143 18.1906C15.3316 16.9406 15.662 15.3117 15.7348 13.5273H18.4572C18.1864 15.8842 16.655 17.8576 14.5543 18.7563ZM9.44572 18.7563C9.35328 18.5754 9.26662 18.3863 9.18567 18.1906C8.6684 16.9406 8.33797 15.3117 8.26521 13.5273H5.5428C5.81358 15.8842 7.34499 17.8576 9.44572 18.7563Z",
            fill: "currentColor"
        })
    });

});


parcelRegister("1254m", function(module, exports) {

$parcel$export(module.exports, "awss3Config", () => $7c234a4c5938682d$export$7a257877f5f8c5de);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $fUMIo = parcelRequire("fUMIo");

var $3vfTz = parcelRequire("3vfTz");
const $7c234a4c5938682d$export$7a257877f5f8c5de = {
    displayName: 'Amazon Web Services S3',
    id: 'aws-s3',
    icon: (0, $9yyKc.RovoLogoFromLogo)((0, $fUMIo.AWSS3Icon), 'Amazon Web Services S3'),
    resourceType: 'aws-s3-connector',
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $3vfTz.AWSS3SearchResultIcon), 'Amazon Web Services S3', 'large'),
    integrationAri: 'ari:cloud:platform::integration/graph-test-app',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    // Keeping this disabled for team demo. We only need GitBook enabled for demo.
    isEnabled: ()=>false
};

});
parcelRegister("fUMIo", function(module, exports) {

$parcel$export(module.exports, "AWSS3Icon", () => $a9e2eec98c2c075b$export$abf71a44e930800c);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $a9e2eec98c2c075b$export$abf71a44e930800c = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("title", {
                children: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                id: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                width: "24",
                height: "24",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                        id: "Icon-Architecture-BG/64/Storage",
                        fill: "#7AA116",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            id: "Rectangle",
                            x: "0",
                            y: "0",
                            width: "24",
                            height: "24"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                        id: "Icon-Service/64/Amazon-Simple-Storage-Service_64",
                        transform: "scale(0.3) translate(12.999900, 11.999600)",
                        fill: "#FFFFFF",
                        width: "24",
                        height: "24",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M47.836,30.893 L48.22,28.189 C51.761,30.31 51.807,31.186 51.8060132,31.21 C51.8,31.215 51.196,31.719 47.836,30.893 L47.836,30.893 Z M45.893,30.353 C39.773,28.501 31.25,24.591 27.801,22.961 C27.801,22.947 27.805,22.934 27.805,22.92 C27.805,21.595 26.727,20.517 25.401,20.517 C24.077,20.517 22.999,21.595 22.999,22.92 C22.999,24.245 24.077,25.323 25.401,25.323 C25.983,25.323 26.511,25.106 26.928,24.761 C30.986,26.682 39.443,30.535 45.608,32.355 L43.17,49.561 C43.163,49.608 43.16,49.655 43.16,49.702 C43.16,51.217 36.453,54 25.494,54 C14.419,54 7.641,51.217 7.641,49.702 C7.641,49.656 7.638,49.611 7.632,49.566 L2.538,12.359 C6.947,15.394 16.43,17 25.5,17 C34.556,17 44.023,15.4 48.441,12.374 L45.893,30.353 Z M2,8.478 C2.072,7.162 9.634,2 25.5,2 C41.364,2 48.927,7.161 49,8.478 L49,8.927 C48.13,11.878 38.33,15 25.5,15 C12.648,15 2.843,11.868 2,8.913 L2,8.478 Z M51,8.5 C51,5.035 41.066,0 25.5,0 C9.934,0 0,5.035 0,8.5 L0.094,9.254 L5.642,49.778 C5.775,54.31 17.861,56 25.494,56 C34.966,56 45.029,53.822 45.159,49.781 L47.555,32.884 C48.888,33.203 49.985,33.366 50.866,33.366 C52.049,33.366 52.849,33.077 53.334,32.499 C53.732,32.025 53.884,31.451 53.77,30.84 C53.511,29.456 51.868,27.964 48.522,26.055 L50.898,9.293 L51,8.5 Z",
                            id: "Amazon-Simple-Storage-Service-Icon_64_Squid"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("3vfTz", function(module, exports) {

$parcel$export(module.exports, "AWSS3SearchResultIcon", () => $4a9fa78211195885$export$30c777236008d219);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $4a9fa78211195885$export$30c777236008d219 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("title", {
                children: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                id: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                        id: "Icon-Architecture-BG/64/Storage",
                        fill: "#7AA116",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            id: "Rectangle",
                            x: "0",
                            y: "0",
                            width: "24",
                            height: "25"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                        id: "Icon-Service/64/Amazon-Simple-Storage-Service_64",
                        transform: "translate(12.999900, 11.999600)",
                        fill: "#FFFFFF",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M47.836,30.893 L48.22,28.189 C51.761,30.31 51.807,31.186 51.8060132,31.21 C51.8,31.215 51.196,31.719 47.836,30.893 L47.836,30.893 Z M45.893,30.353 C39.773,28.501 31.25,24.591 27.801,22.961 C27.801,22.947 27.805,22.934 27.805,22.92 C27.805,21.595 26.727,20.517 25.401,20.517 C24.077,20.517 22.999,21.595 22.999,22.92 C22.999,24.245 24.077,25.323 25.401,25.323 C25.983,25.323 26.511,25.106 26.928,24.761 C30.986,26.682 39.443,30.535 45.608,32.355 L43.17,49.561 C43.163,49.608 43.16,49.655 43.16,49.702 C43.16,51.217 36.453,54 25.494,54 C14.419,54 7.641,51.217 7.641,49.702 C7.641,49.656 7.638,49.611 7.632,49.566 L2.538,12.359 C6.947,15.394 16.43,17 25.5,17 C34.556,17 44.023,15.4 48.441,12.374 L45.893,30.353 Z M2,8.478 C2.072,7.162 9.634,2 25.5,2 C41.364,2 48.927,7.161 49,8.478 L49,8.927 C48.13,11.878 38.33,15 25.5,15 C12.648,15 2.843,11.868 2,8.913 L2,8.478 Z M51,8.5 C51,5.035 41.066,0 25.5,0 C9.934,0 0,5.035 0,8.5 L0.094,9.254 L5.642,49.778 C5.775,54.31 17.861,56 25.494,56 C34.966,56 45.029,53.822 45.159,49.781 L47.555,32.884 C48.888,33.203 49.985,33.366 50.866,33.366 C52.049,33.366 52.849,33.077 53.334,32.499 C53.732,32.025 53.884,31.451 53.77,30.84 C53.511,29.456 51.868,27.964 48.522,26.055 L50.898,9.293 L51,8.5 Z",
                            id: "Amazon-Simple-Storage-Service-Icon_64_Squid"
                        })
                    })
                ]
            })
        ]
    });

});


parcelRegister("63TuK", function(module, exports) {

$parcel$export(module.exports, "azureDevopsConfig", () => $952a8dcaa64c7f0f$export$f324080d91cfb196);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $iFvZ5 = parcelRequire("iFvZ5");

var $cEd7t = parcelRequire("cEd7t");
const $952a8dcaa64c7f0f$export$f324080d91cfb196 = {
    displayName: 'Azure DevOps',
    id: 'azure-devops',
    resourceType: 'azure-devops-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $iFvZ5.AzureDevopsIcon), 'AzureDevOps', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $cEd7t.AzureDevopsSearchResultIcon), 'AzureDevOps', 'large'),
    integrationAri: 'ari:cloud:platform::integration/azure-devops',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Repository
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("iFvZ5", function(module, exports) {

$parcel$export(module.exports, "AzureDevopsIcon", () => $fefeace148d8b1a3$export$2dcf704e717ca168);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $fefeace148d8b1a3$export$2dcf704e717ca168 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.5 7.30929V16.4293L15.75 19.5L9.9375 17.3839V19.4818L6.64714 15.1821L16.2375 15.9321V7.71964L19.5 7.30929ZM16.3029 7.76786L10.9221 4.5V6.64393L5.98071 8.09571L4.5 9.99643V14.3132L6.61929 15.2486V9.71679L16.3029 7.76786Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19 7.622V16.134L15.5 19L10.075 17.025V18.983L7.004 14.97L15.955 15.67V8.005L19 7.622ZM16.016 8.05L10.994 5V7.001L6.382 8.356L5 10.13V14.159L6.978 15.032V9.869L16.016 8.05Z",
                fill: "url(#paint0_linear_24_1001)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                    id: "paint0_linear_24_1001",
                    x1: "12",
                    y1: "18.956",
                    x2: "12",
                    y2: "5.026",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            stopColor: "#0078D4"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "0.16",
                            stopColor: "#1380DA"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "0.53",
                            stopColor: "#3C91E5"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "0.82",
                            stopColor: "#559CEC"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "1",
                            stopColor: "#5EA0EF"
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("cEd7t", function(module, exports) {

$parcel$export(module.exports, "AzureDevopsSearchResultIcon", () => $a4759d010fe75e4b$export$a64bb17da4dc2efb);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $a4759d010fe75e4b$export$a64bb17da4dc2efb = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M26 9.74571V21.9057L21 26L13.25 23.1786V25.9757L8.86286 20.2429L21.65 21.2429V10.2929L26 9.74571ZM21.7371 10.3571L14.5629 6V8.85857L7.97429 10.7943L6 13.3286V19.0843L8.82571 20.3314V12.9557L21.7371 10.3571Z",
            fill: "white"
        })
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M35 10.6186V28.8586L27.5 35L15.875 30.7679V34.9636L9.29429 26.3643L28.475 27.8643V11.4393L35 10.6186ZM28.6057 11.5357L17.8443 5V9.28786L7.96143 12.1914L5 15.9929V24.6264L9.23857 26.4971V15.4336L28.6057 11.5357Z",
                fill: "url(#paint0_linear_azure_devops)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                    id: "paint0_linear_azure_devops",
                    x1: "20",
                    y1: "34.9057",
                    x2: "20",
                    y2: "5.05571",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            stopColor: "#0078D4"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "0.16",
                            stopColor: "#1380DA"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "0.53",
                            stopColor: "#3C91E5"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "0.82",
                            stopColor: "#559CEC"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "1",
                            stopColor: "#5EA0EF"
                        })
                    ]
                })
            })
        ]
    });
};

});


parcelRegister("d44Rd", function(module, exports) {

$parcel$export(module.exports, "boxConfig", () => $f9ec6128a54edafb$export$3e7603f097ea326e);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $kTDXK = parcelRequire("kTDXK");

var $jLr6e = parcelRequire("jLr6e");
const $f9ec6128a54edafb$export$3e7603f097ea326e = {
    displayName: 'Box',
    id: 'box',
    resourceType: 'box-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $kTDXK.BoxIcon), 'Box', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $jLr6e.BoxSearchResultIcon), 'Box', 'large'),
    integrationAri: 'ari:cloud:platform::integration/box',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Presentation,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("kTDXK", function(module, exports) {

$parcel$export(module.exports, "BoxIcon", () => $0fb7bd9c7158811f$export$adedf1569d7107de);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $0fb7bd9c7158811f$export$adedf1569d7107de = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-683.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#0071F7"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.8589 15.3516C20.0587 15.6312 20.0187 15.9907 19.779 16.1905C19.4994 16.3902 19.0999 16.3502 18.9002 16.1106L17.5021 14.313L16.1439 16.0706C15.9441 16.3502 15.5447 16.3502 15.265 16.1505C14.9854 15.9508 14.9455 15.5913 15.1452 15.3116L16.7431 13.2344L15.1452 11.1571C14.9455 10.8775 15.0254 10.478 15.265 10.2783C15.5447 10.0786 15.9441 10.1585 16.1439 10.3982L17.5021 12.1958L18.9002 10.478C19.0999 10.1984 19.4595 10.1585 19.779 10.3582C20.0587 10.5579 20.0587 10.9574 19.8589 11.237L18.301 13.2743L19.8589 15.3516ZM12.5886 15.1119C11.55 15.1119 10.7111 14.313 10.7111 13.2743C10.7111 12.2757 11.55 11.4368 12.5886 11.4368C13.6272 11.4368 14.4661 12.2757 14.4661 13.2743C14.4261 14.313 13.5873 15.1119 12.5886 15.1119ZM7.07591 15.1119C6.03729 15.1119 5.19841 14.313 5.19841 13.2743C5.19841 12.2757 6.03729 11.4368 7.07591 11.4368C8.11453 11.4368 8.95342 12.2757 8.95342 13.2743C8.95342 14.313 8.11453 15.1119 7.07591 15.1119ZM12.5886 10.2384C11.4301 10.2384 10.3915 10.8775 9.8722 11.8362C9.35289 10.8775 8.31427 10.2384 7.11586 10.2384C6.39682 10.2384 5.75766 10.478 5.23835 10.8376V8.28097C5.23835 7.96139 4.95873 7.68176 4.63915 7.68176C4.27963 7.68176 4 7.96139 4 8.28097V13.3143C4.03995 14.9921 5.39814 16.3103 7.07591 16.3103C8.27432 16.3103 9.31294 15.6312 9.83225 14.6725C10.3516 15.6312 11.3902 16.3103 12.5486 16.3103C14.2664 16.3103 15.6645 14.9521 15.6645 13.2344C15.7045 11.5966 14.3063 10.2384 12.5886 10.2384Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M20.8413 15.6285C21.066 15.9431 21.0211 16.3476 20.7514 16.5723C20.4368 16.797 19.9874 16.752 19.7627 16.4824L18.1898 14.4601L16.6619 16.4375C16.4371 16.752 15.9877 16.752 15.6732 16.5273C15.3586 16.3026 15.3136 15.8982 15.5383 15.5836L17.336 13.2467L15.5383 10.9098C15.3136 10.5952 15.4035 10.1458 15.6732 9.92112C15.9877 9.69642 16.4371 9.7863 16.6619 10.0559L18.1898 12.0783L19.7627 10.1458C19.9874 9.83124 20.3919 9.7863 20.7514 10.011C21.066 10.2357 21.066 10.6851 20.8413 10.9997L19.0886 13.2916L20.8413 15.6285ZM12.6622 15.3589C11.4937 15.3589 10.55 14.4601 10.55 13.2916C10.55 12.1681 11.4937 11.2244 12.6622 11.2244C13.8306 11.2244 14.7744 12.1681 14.7744 13.2916C14.7294 14.4601 13.7857 15.3589 12.6622 15.3589ZM6.4604 15.3589C5.29196 15.3589 4.34821 14.4601 4.34821 13.2916C4.34821 12.1681 5.29196 11.2244 6.4604 11.2244C7.62885 11.2244 8.5726 12.1681 8.5726 13.2916C8.5726 14.4601 7.62885 15.3589 6.4604 15.3589ZM12.6622 9.87618C11.3589 9.87618 10.1904 10.5952 9.60622 11.6738C9.022 10.5952 7.85355 9.87618 6.50534 9.87618C5.69642 9.87618 4.97737 10.1458 4.39315 10.5503V7.6741C4.39315 7.31458 4.07857 7 3.71904 7C3.31458 7 3 7.31458 3 7.6741V13.3366C3.04494 15.2241 4.57291 16.7071 6.4604 16.7071C7.80861 16.7071 8.97706 15.9431 9.56128 14.8646C10.1455 15.9431 11.314 16.7071 12.6172 16.7071C14.5497 16.7071 16.1226 15.1791 16.1226 13.2467C16.1675 11.4041 14.5946 9.87618 12.6622 9.87618Z",
            fill: "#0071F7"
        })
    });
};

});

parcelRegister("jLr6e", function(module, exports) {

$parcel$export(module.exports, "BoxSearchResultIcon", () => $fdcbf77c9a3758b4$export$f9ea3a56c013af54);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $fdcbf77c9a3758b4$export$f9ea3a56c013af54 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-211.5",
                y: "-23.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#0071F7"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M26.4785 20.4687C26.7448 20.8416 26.6915 21.3209 26.372 21.5872C25.9991 21.8535 25.4665 21.8003 25.2002 21.4807L23.336 19.0839L21.5251 21.4275C21.2588 21.8003 20.7261 21.8003 20.3533 21.534C19.9805 21.2677 19.9272 20.7883 20.1935 20.4155L22.324 17.6458L20.1935 14.8762C19.9272 14.5033 20.0337 13.9707 20.3533 13.7044C20.7261 13.4381 21.2588 13.5446 21.5251 13.8642L23.336 16.261L25.2002 13.9707C25.4665 13.5979 25.9459 13.5446 26.372 13.8109C26.7448 14.0772 26.7448 14.6098 26.4785 14.9827L24.4013 17.6991L26.4785 20.4687ZM16.7847 20.1491C15.3999 20.1491 14.2814 19.0839 14.2814 17.6991C14.2814 16.3675 15.3999 15.249 16.7847 15.249C18.1695 15.249 19.288 16.3675 19.288 17.6991C19.2348 19.0839 18.1163 20.1491 16.7847 20.1491ZM9.43447 20.1491C8.04964 20.1491 6.93113 19.0839 6.93113 17.6991C6.93113 16.3675 8.04964 15.249 9.43447 15.249C10.8193 15.249 11.9378 16.3675 11.9378 17.6991C11.9378 19.0839 10.8193 20.1491 9.43447 20.1491ZM16.7847 13.6511C15.2401 13.6511 13.8553 14.5033 13.1629 15.7816C12.4704 14.5033 11.0856 13.6511 9.48773 13.6511C8.52901 13.6511 7.67681 13.9707 6.98439 14.4501V11.0412C6.98439 10.6151 6.61155 10.2423 6.18545 10.2423C5.70609 10.2423 5.33325 10.6151 5.33325 11.0412V17.7523C5.38651 19.9894 7.19744 21.747 9.43447 21.747C11.0323 21.747 12.4172 20.8416 13.1096 19.5633C13.802 20.8416 15.1868 21.747 16.7314 21.747C19.0217 21.747 20.8859 19.9361 20.8859 17.6458C20.9392 15.462 19.075 13.6511 16.7847 13.6511Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_2230_19065)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M34.0488 26.5488C34.4146 27.061 34.3415 27.7195 33.9024 28.0854C33.3902 28.4512 32.6585 28.3781 32.2927 27.939L29.7317 24.6463L27.2439 27.8659C26.878 28.3781 26.1463 28.3781 25.6341 28.0122C25.122 27.6463 25.0488 26.9878 25.4146 26.4756L28.3415 22.6707L25.4146 18.8659C25.0488 18.3537 25.1951 17.622 25.6341 17.2561C26.1463 16.8902 26.878 17.0366 27.2439 17.4756L29.7317 20.7683L32.2927 17.622C32.6585 17.1098 33.3171 17.0366 33.9024 17.4024C34.4146 17.7683 34.4146 18.5 34.0488 19.0122L31.1951 22.7439L34.0488 26.5488ZM20.7317 26.1098C18.8293 26.1098 17.2927 24.6463 17.2927 22.7439C17.2927 20.9146 18.8293 19.378 20.7317 19.378C22.6341 19.378 24.1707 20.9146 24.1707 22.7439C24.0976 24.6463 22.561 26.1098 20.7317 26.1098ZM10.6341 26.1098C8.73171 26.1098 7.19512 24.6463 7.19512 22.7439C7.19512 20.9146 8.73171 19.378 10.6341 19.378C12.5366 19.378 14.0732 20.9146 14.0732 22.7439C14.0732 24.6463 12.5366 26.1098 10.6341 26.1098ZM20.7317 17.1829C18.6098 17.1829 16.7073 18.3537 15.7561 20.1098C14.8049 18.3537 12.9024 17.1829 10.7073 17.1829C9.39024 17.1829 8.21951 17.622 7.26829 18.2805V13.5976C7.26829 13.0122 6.7561 12.5 6.17073 12.5C5.5122 12.5 5 13.0122 5 13.5976V22.8171C5.07317 25.8902 7.56098 28.3049 10.6341 28.3049C12.8293 28.3049 14.7317 27.061 15.6829 25.3049C16.6341 27.061 18.5366 28.3049 20.6585 28.3049C23.8049 28.3049 26.3659 25.8171 26.3659 22.6707C26.439 19.6707 23.878 17.1829 20.7317 17.1829Z",
                    fill: "#0071F7"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_2230_19065",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "30",
                        height: "16.0976",
                        fill: "white",
                        transform: "translate(5 12.5)"
                    })
                })
            })
        ]
    });
};

});


parcelRegister("eBcqb", function(module, exports) {

$parcel$export(module.exports, "canvaConfig", () => $77752e716bcbf673$export$75e56657ffc0207b);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $3CqxZ = parcelRequire("3CqxZ");

var $ikw8W = parcelRequire("ikw8W");
const $77752e716bcbf673$export$75e56657ffc0207b = {
    displayName: 'Canva',
    id: 'canva',
    resourceType: 'canva-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $3CqxZ.CanvaIcon), 'Canva', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $ikw8W.CanvaSearchResultIcon), 'Canva', 'large'),
    integrationAri: 'ari:cloud:platform::integration/canva',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("3CqxZ", function(module, exports) {

$parcel$export(module.exports, "CanvaIcon", () => $e8b95f2997ae5497$export$3ad1ba1bf426d64a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $e8b95f2997ae5497$export$3ad1ba1bf426d64a = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_1737_5849)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M17.0221 14.2091C16.9332 14.2091 16.855 14.2841 16.7737 14.4479C15.8548 16.3111 14.2679 17.6294 12.4314 17.6294C10.308 17.6294 8.993 15.7125 8.993 13.0644C8.993 8.57869 11.4923 5.98516 13.6875 5.98516C14.7133 5.98516 15.3398 6.62979 15.3398 7.65565C15.3398 8.87317 14.6481 9.51781 14.6481 9.94721C14.6481 10.14 14.768 10.2567 15.0057 10.2567C15.9609 10.2567 17.082 9.15909 17.082 7.60853C17.082 6.10509 15.7735 5 13.5783 5C9.95033 5 6.72607 8.36346 6.72607 13.0172C6.72607 16.6195 8.78313 19 11.9571 19C15.3258 19 17.2737 15.6483 17.2737 14.5604C17.2737 14.3194 17.1506 14.2091 17.0221 14.2091Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_1737_5849",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                        fill: "white"
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "#7D2AE7"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "url(#paint0_radial_24_1067)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "url(#paint1_radial_24_1067)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "url(#paint2_radial_24_1067)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "url(#paint3_radial_24_1067)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.4538 13.656C15.3878 13.656 15.3297 13.7118 15.2692 13.8338C14.5864 15.2204 13.4071 16.2016 12.0425 16.2016C10.4645 16.2016 9.48736 14.775 9.48736 12.804C9.48736 9.4655 11.3446 7.53522 12.9759 7.53522C13.7382 7.53522 14.2037 8.015 14.2037 8.77851C14.2037 9.68467 13.6897 10.1645 13.6897 10.484C13.6897 10.6275 13.7788 10.7144 13.9554 10.7144C14.6652 10.7144 15.4983 9.89747 15.4983 8.74344C15.4983 7.62448 14.526 6.802 12.8947 6.802C10.1988 6.802 7.8028 9.30531 7.8028 12.769C7.8028 15.45 9.3314 17.2217 11.69 17.2217C14.1933 17.2217 15.6408 14.7271 15.6408 13.9174C15.6408 13.7381 15.5493 13.656 15.4538 13.656Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint0_radial_24_1067",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.0906 18.2033) rotate(-49.4602) scale(12.3858 12.3828)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#6420FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6420FF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint1_radial_24_1067",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(8.23576 5.82176) rotate(54.7452) scale(13.9692 13.962)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00C4CC"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00C4CC",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint2_radial_24_1067",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.09053 18.2032) rotate(-45.2401) scale(12.2345 5.62672)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#6420FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6420FF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint3_radial_24_1067",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(10.5432 6.15916) rotate(66.5525) scale(12.6133 21.1075)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00C4CC",
                                stopOpacity: "0.725916"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.0001",
                                stopColor: "#00C4CC"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00C4CC",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("ikw8W", function(module, exports) {

$parcel$export(module.exports, "CanvaSearchResultIcon", () => $467a7e6b5107a82f$export$ac6bbd7ba99716e3);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $467a7e6b5107a82f$export$ac6bbd7ba99716e3 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_1737_5841)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "32",
                        height: "32",
                        rx: "8",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "32",
                        height: "32",
                        rx: "8",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "32",
                        height: "32",
                        rx: "8",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "32",
                        height: "32",
                        rx: "8",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "32",
                        height: "32",
                        rx: "8",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M22.6962 18.8754C22.5778 18.8754 22.4735 18.9755 22.365 19.1939C21.1399 21.6781 19.024 23.4358 16.5754 23.4358C13.7441 23.4358 11.9908 20.88 11.9908 17.3492C11.9908 11.3683 15.3232 7.91022 18.2502 7.91022C19.6179 7.91022 20.4532 8.76974 20.4532 10.1375C20.4532 11.7609 19.5309 12.6204 19.5309 13.193C19.5309 13.45 19.6908 13.6056 20.0078 13.6056C21.2814 13.6056 22.7762 12.1421 22.7762 10.0747C22.7762 8.07013 21.0315 6.59668 18.1046 6.59668C13.2673 6.59668 8.96826 11.0813 8.96826 17.2863C8.96826 22.0894 11.711 25.2633 15.9429 25.2633C20.4346 25.2633 23.0318 20.7944 23.0318 19.3438C23.0318 19.0226 22.8676 18.8754 22.6962 18.8754Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_1737_5841",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "32",
                        height: "32",
                        rx: "8",
                        fill: "white"
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9766 35C28.2479 35 34.9532 28.2843 34.9532 20C34.9532 11.7157 28.2479 5 19.9766 5C11.7053 5 5 11.7157 5 20C5 28.2843 11.7053 35 19.9766 35Z",
                fill: "#7D2AE7"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9766 35C28.2479 35 34.9532 28.2843 34.9532 20C34.9532 11.7157 28.2479 5 19.9766 5C11.7053 5 5 11.7157 5 20C5 28.2843 11.7053 35 19.9766 35Z",
                fill: "url(#paint0_radial_2230_19011)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9766 35C28.2479 35 34.9532 28.2843 34.9532 20C34.9532 11.7157 28.2479 5 19.9766 5C11.7053 5 5 11.7157 5 20C5 28.2843 11.7053 35 19.9766 35Z",
                fill: "url(#paint1_radial_2230_19011)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9766 35C28.2479 35 34.9532 28.2843 34.9532 20C34.9532 11.7157 28.2479 5 19.9766 5C11.7053 5 5 11.7157 5 20C5 28.2843 11.7053 35 19.9766 35Z",
                fill: "url(#paint2_radial_2230_19011)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9766 35C28.2479 35 34.9532 28.2843 34.9532 20C34.9532 11.7157 28.2479 5 19.9766 5C11.7053 5 5 11.7157 5 20C5 28.2843 11.7053 35 19.9766 35Z",
                fill: "url(#paint3_radial_2230_19011)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M26.4424 23.0771C26.3188 23.0771 26.21 23.1816 26.0968 23.4099C24.8186 26.0059 22.6109 27.8427 20.0561 27.8427C17.1021 27.8427 15.2728 25.1719 15.2728 21.4822C15.2728 15.2322 18.7497 11.6186 21.8036 11.6186C23.2306 11.6186 24.1021 12.5167 24.1021 13.9461C24.1021 15.6425 23.1398 16.5407 23.1398 17.139C23.1398 17.4075 23.3066 17.5701 23.6373 17.5701C24.9661 17.5701 26.5258 16.0409 26.5258 13.8804C26.5258 11.7857 24.7054 10.2459 21.6516 10.2459C16.6046 10.2459 12.1191 14.9323 12.1191 21.4165C12.1191 26.4357 14.9808 29.7524 19.3962 29.7524C24.0827 29.7524 26.7925 25.0823 26.7925 23.5666C26.7925 23.2309 26.6211 23.0771 26.4424 23.0771Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint0_radial_2230_19011",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(10.7858 31.5897) rotate(-49.4602) scale(23.1872 23.1816)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#6420FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6420FF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint1_radial_2230_19011",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(12.9297 8.41046) rotate(54.7452) scale(26.1514 26.1378)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00C4CC"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00C4CC",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint2_radial_2230_19011",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(10.7857 31.5895) rotate(-45.2401) scale(22.9038 10.5336)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#6420FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6420FF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint3_radial_2230_19011",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.2493 9.04211) rotate(66.5525) scale(23.613 39.5149)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00C4CC",
                                stopOpacity: "0.725916"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.0001",
                                stopColor: "#00C4CC"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00C4CC",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("2Dcfm", function(module, exports) {

$parcel$export(module.exports, "clickUpConfig", () => $c046599e1123811b$export$7ef79ba9bf00ce19);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $fBjER = parcelRequire("fBjER");

var $ishTP = parcelRequire("ishTP");
const $c046599e1123811b$export$7ef79ba9bf00ce19 = {
    displayName: 'ClickUp',
    id: 'clickup',
    resourceType: 'smartlinks-connector-clickup',
    icon: (0, $9yyKc.get3PLogo)((0, $fBjER.ClickUpIcon), 'ClickUp', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $ishTP.ClickUpSearchResultIcon), 'ClickUp', 'large'),
    integrationAri: 'ari:cloud:platform::integration/clickup',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("fBjER", function(module, exports) {

$parcel$export(module.exports, "ClickUpIcon", () => $ed645382243aaf78$export$592b235c95c5fb2b);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $ed645382243aaf78$export$592b235c95c5fb2b = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-602.5",
                y: "-268.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.48145 15.6486L7.88428 13.6389C9.16896 15.4425 10.525 16.2927 12.0238 16.2927C13.5226 16.2927 14.8549 15.4682 16.0682 13.6647L18.5186 15.6228C16.7581 18.1993 14.5694 19.5649 12.0238 19.5649C9.50203 19.5649 7.28952 18.1993 5.48145 15.6486Z",
                fill: "#6686FB"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 7.58303L7.53864 11.2685L5.48145 8.9621L12.0248 3.5647L18.5186 8.9621L16.4366 11.2447L12 7.58303Z",
                fill: "#FF6479"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5 16.0105L7.58713 13.8467C8.97035 15.7886 10.4304 16.704 12.0442 16.704C13.6579 16.704 15.0924 15.8163 16.3987 13.8744L19.0371 15.9828C17.1416 18.7569 14.785 20.2272 12.0442 20.2272C9.32896 20.2272 6.94675 18.7569 5 16.0105Z",
                fill: "url(#paint0_linear_384_122)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0186 7.32653L7.21498 11.2947L5 8.81138L12.0452 3L19.0371 8.81138L16.7954 11.2691L12.0186 7.32653Z",
                fill: "url(#paint1_linear_384_122)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint0_linear_384_122",
                        x1: "5",
                        y1: "17.04",
                        x2: "19.0485",
                        y2: "17.04",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#8930FD"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#49CCF9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint1_linear_384_122",
                        x1: "4.99875",
                        y1: "7.1459",
                        x2: "19.0224",
                        y2: "7.1459",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#FF02F0"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC800"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("ishTP", function(module, exports) {

$parcel$export(module.exports, "ClickUpSearchResultIcon", () => $32ca20b134ccb661$export$7ca2508a62493599);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $32ca20b134ccb661$export$7ca2508a62493599 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-115.5",
                y: "-263.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.508324",
                y: "0.508324",
                width: "30.9834",
                height: "30.9834",
                rx: "7.49168",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "1.01665"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.30859 20.8905L10.5124 18.2109C12.2253 20.6157 14.0334 21.7494 16.0318 21.7494C18.0302 21.7494 19.8065 20.65 21.4243 18.2453L24.6915 20.8562C22.3442 24.2915 19.4259 26.1123 16.0318 26.1123C12.6694 26.1123 9.71936 24.2915 7.30859 20.8905Z",
                fill: "#6686FB"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16 10.1366L10.0515 15.0505L7.30859 11.9753L16.0331 4.77881L24.6915 11.9753L21.9155 15.0188L16 10.1366Z",
                fill: "#FF6479"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 27.657L12.5053 23.8889C14.914 27.2706 17.4566 28.8648 20.2668 28.8648C23.077 28.8648 25.575 27.3189 27.85 23.9372L32.4444 27.6087C29.1436 32.4396 25.0397 35 20.2668 35C15.5385 35 11.3901 32.4396 8 27.657Z",
                fill: "url(#paint0_linear_click_up)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2222 12.5343L11.8572 19.4444L8 15.12L20.2687 5L32.4444 15.12L28.5408 19.3999L20.2222 12.5343Z",
                fill: "url(#paint1_linear_click_up)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint0_linear_click_up",
                        x1: "8",
                        y1: "29.4499",
                        x2: "32.4643",
                        y2: "29.4499",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#8930FD"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#49CCF9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint1_linear_click_up",
                        x1: "7.99782",
                        y1: "12.2197",
                        x2: "32.4187",
                        y2: "12.2197",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#FF02F0"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC800"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("69cVS", function(module, exports) {

$parcel$export(module.exports, "confluenceDCConfig", () => $85a80012baeabd4e$export$3dab4b73b27a9d7e);

var $lAFHW = parcelRequire("lAFHW");

var $dh538 = parcelRequire("dh538");

var $guzTv = parcelRequire("guzTv");

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $lWcry = parcelRequire("lWcry");
const $85a80012baeabd4e$export$3dab4b73b27a9d7e = {
    displayName: 'Confluence Data Center',
    id: 'confluence-dc',
    resourceType: 'confluence-dc-connector',
    icon: (0, $9yyKc.RovoLogoFromLogo)((0, $9yyKc.getLogoVersion)((0, $guzTv.ConfluenceIcon), (0, $lAFHW.ConfluenceIcon)), 'Confluence Data Center'),
    searchResultIcon: (0, $9yyKc.getIconVersion)((0, $guzTv.ConfluenceIcon), (0, $lWcry.ConfluenceSearchResultIcon), 'Confluence Data Center', 'large'),
    integrationAri: 'ari:cloud:platform::integration/confluence-dc',
    typeFilterConfig: (()=>{
        const typeFilter = new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Space,
                {
                    entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                    subTypes3P: [
                        (0, $2Znam.NounSubtypeKey).Space
                    ]
                }
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Page,
                {
                    entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    subTypes3P: [
                        (0, $2Znam.NounSubtypeKey).Page
                    ]
                }
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Blogpost,
                {
                    entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    subTypes3P: [
                        (0, $2Znam.NounSubtypeKey).Blogpost
                    ]
                }
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Comment,
                {
                    entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                    subTypes3P: []
                }
            ]
        ]);
        if ((0, $dh538.fg)('confluence-dc-attachments-filter')) typeFilter.set((0, $2Znam.TypeFilterValueKey).Attachment, {
            entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                (0, $2Znam.NounSubtypeKey).Archive,
                (0, $2Znam.NounSubtypeKey).Audio,
                (0, $2Znam.NounSubtypeKey).Code,
                (0, $2Znam.NounSubtypeKey).Document,
                (0, $2Znam.NounSubtypeKey).Image,
                (0, $2Znam.NounSubtypeKey).Pdf,
                (0, $2Znam.NounSubtypeKey).Presentation,
                (0, $2Znam.NounSubtypeKey).Spreadsheet,
                (0, $2Znam.NounSubtypeKey).Video,
                (0, $2Znam.NounSubtypeKey).WebPage,
                (0, $2Znam.NounSubtypeKey).Other
            ]
        });
        return typeFilter;
    })(),
    filters: [
        'lastUpdated',
        'onlyTitleMatch',
        'createdBy',
        'content',
        'space'
    ],
    requiresOauth: true,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};

});
parcelRegister("lWcry", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSearchResultIcon", () => $25d6378a84ef5509$export$93ca83db1787dea);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $25d6378a84ef5509$export$93ca83db1787dea = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_2230_18702)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                    clipPath: "url(#clip1_2230_18702)",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                        clipPath: "url(#clip2_2230_18702)",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M32.2106 25.0334C23.981 21.0541 21.5768 20.4595 18.1093 20.4595C14.0407 20.4595 10.5731 22.1519 7.47546 26.9087L6.96689 27.6863C6.55078 28.3267 6.45831 28.5553 6.45831 28.8298C6.45831 29.1042 6.59701 29.3329 7.10559 29.6531L12.33 32.9006C12.6074 33.0835 12.8386 33.175 13.0698 33.175C13.3472 33.175 13.5321 33.0378 13.8095 32.6261L14.6417 31.3454C15.9363 29.3787 17.0921 28.7383 18.5716 28.7383C19.8662 28.7383 21.3919 29.1042 23.2875 30.019L28.7431 32.5804C29.2979 32.8548 29.8989 32.7176 30.1763 32.0773L32.7654 26.4056C33.0428 25.7653 32.8579 25.3536 32.2106 25.0334ZM8.2152 15.0166C16.4448 18.9959 18.849 19.5905 22.3166 19.5905C26.3851 19.5905 29.8527 17.8981 32.9504 13.1413L33.4589 12.3637C33.875 11.7233 33.9675 11.4947 33.9675 11.2202C33.9675 10.9458 33.8288 10.7171 33.3202 10.3969L28.0958 7.14943C27.8184 6.96648 27.5872 6.875 27.3561 6.875C27.0787 6.875 26.8937 7.01222 26.6163 7.42387L25.7841 8.70457C24.4896 10.6713 23.3337 11.3117 21.8542 11.3117C20.5597 11.3117 19.0339 10.9458 17.1384 10.031L11.6827 7.46961C11.1279 7.19517 10.5269 7.33239 10.2495 7.97274L7.6604 13.6444C7.38299 14.2847 7.56793 14.6964 8.2152 15.0166Z",
                            fill: "#1868DB"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_2230_18702",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "40",
                            height: "40",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip1_2230_18702",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "40",
                            height: "40",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip2_2230_18702",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "27.5092",
                            height: "26.3",
                            fill: "white",
                            transform: "translate(6.45831 6.875)"
                        })
                    })
                ]
            })
        ]
    });

});


parcelRegister("lFG0w", function(module, exports) {

$parcel$export(module.exports, "docusignConfig", () => $8939dbaf0b2ff159$export$cee55280cabc1aa1);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $l02Lm = parcelRequire("l02Lm");

var $bvQoW = parcelRequire("bvQoW");
const $8939dbaf0b2ff159$export$cee55280cabc1aa1 = {
    displayName: 'Docusign',
    id: 'docusign',
    resourceType: 'docusign-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $l02Lm.DocusignIcon), 'Docusign', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $bvQoW.DocusignSearchResultIcon), 'Docusign', 'large'),
    integrationAri: 'ari:cloud:platform::integration/docusign',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("l02Lm", function(module, exports) {

$parcel$export(module.exports, "DocusignIcon", () => $67c131926920b640$export$393452da0e179bab);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $67c131926920b640$export$393452da0e179bab = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-115.5",
                y: "-166.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "31",
                height: "31",
                rx: "7.5",
                stroke: "#0B1228",
                strokeOpacity: "0.14"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.2568 20.2378V25.1619C20.2568 25.4206 20.0472 25.6295 19.7877 25.6295H6.80236C6.54285 25.6295 6.33325 25.4206 6.33325 25.1619V12.2299C6.33325 11.9712 6.54285 11.7623 6.80236 11.7623H11.733V19.7703C11.733 20.0289 11.9426 20.2378 12.2021 20.2378H20.2568Z",
                fill: "#4C00FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M25.6668 13.2943C25.6668 17.4325 23.2414 20.2278 20.257 20.2378V15.0252C20.257 14.876 20.1971 14.7267 20.0873 14.6273L17.3725 11.9215C17.2627 11.8121 17.123 11.7524 16.9732 11.7524H11.7432V6.83818C11.7432 6.57953 11.9528 6.37063 12.2123 6.37063H19.5284C23.0018 6.36068 25.6668 9.14605 25.6668 13.2943Z",
                fill: "#FF5252"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.0873 14.6171C20.1971 14.7266 20.257 14.8658 20.257 15.0151V20.2277H12.2123C11.9528 20.2277 11.7432 20.0188 11.7432 19.7601V11.7522H16.9732C17.123 11.7522 17.2727 11.8119 17.3725 11.9213L20.0873 14.6171Z",
                fill: "black"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.0826 15.0417V18.6075C15.0826 18.7948 14.9308 18.946 14.7429 18.946H5.3397C5.15178 18.946 5 18.7948 5 18.6075V9.24286C5 9.05557 5.15178 8.9043 5.3397 8.9043H8.91017V14.7031C8.91017 14.8904 9.06195 15.0417 9.24987 15.0417H15.0826Z",
                fill: "#4C00FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19 10.0137C19 13.0104 17.2437 15.0346 15.0826 15.0418V11.2671C15.0826 11.159 15.0393 11.051 14.9598 10.979L12.9938 9.0196C12.9143 8.94036 12.8131 8.89714 12.7047 8.89714H8.91742V5.33859C8.91742 5.15129 9.0692 5.00002 9.25712 5.00002H14.555C17.0702 4.99282 19 7.00981 19 10.0137Z",
                fill: "#FF5252"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.9598 10.9717C15.0393 11.051 15.0826 11.1518 15.0826 11.2599V15.0345H9.25712C9.0692 15.0345 8.91742 14.8832 8.91742 14.6959V8.89709H12.7047C12.8131 8.89709 12.9215 8.94032 12.9938 9.01955L14.9598 10.9717Z",
                fill: "black"
            })
        ]
    });
};

});

parcelRegister("bvQoW", function(module, exports) {

$parcel$export(module.exports, "DocusignSearchResultIcon", () => $578524381ae0907d$export$4cdd065eb81c5a09);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $578524381ae0907d$export$4cdd065eb81c5a09 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "31",
                height: "31",
                rx: "7.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "31",
                height: "31",
                rx: "7.5",
                stroke: "#0B1228",
                strokeOpacity: "0.14"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.2568 20.2378V25.1619C20.2568 25.4206 20.0472 25.6295 19.7877 25.6295H6.80236C6.54285 25.6295 6.33325 25.4206 6.33325 25.1619V12.2299C6.33325 11.9712 6.54285 11.7623 6.80236 11.7623H11.733V19.7703C11.733 20.0289 11.9426 20.2378 12.2021 20.2378H20.2568Z",
                fill: "#4C00FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M25.6668 13.2943C25.6668 17.4325 23.2414 20.2278 20.257 20.2378V15.0252C20.257 14.876 20.1971 14.7267 20.0873 14.6273L17.3725 11.9215C17.2627 11.8121 17.123 11.7524 16.9732 11.7524H11.7432V6.83818C11.7432 6.57953 11.9528 6.37063 12.2123 6.37063H19.5284C23.0018 6.36068 25.6668 9.14605 25.6668 13.2943Z",
                fill: "#FF5252"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.0873 14.6171C20.1971 14.7266 20.257 14.8658 20.257 15.0151V20.2277H12.2123C11.9528 20.2277 11.7432 20.0188 11.7432 19.7601V11.7522H16.9732C17.123 11.7522 17.2727 11.8119 17.3725 11.9213L20.0873 14.6171Z",
                fill: "black"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M26.6891 26.6013V34.2717C26.6891 34.6746 26.3626 35 25.9584 35H5.73074C5.3265 35 5 34.6746 5 34.2717V14.1271C5 13.7242 5.3265 13.3988 5.73074 13.3988H13.4113V25.873C13.4113 26.2759 13.7378 26.6013 14.1421 26.6013H26.6891Z",
                fill: "#4C00FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M35.116 15.7851C35.116 22.2314 31.3379 26.5858 26.6891 26.6012V18.4814C26.6891 18.249 26.5958 18.0166 26.4248 17.8616L22.1958 13.6467C22.0248 13.4763 21.8071 13.3833 21.5739 13.3833H13.4269V5.72835C13.4269 5.32545 13.7534 5.00004 14.1576 5.00004H25.5541C30.9647 4.98455 35.116 9.32338 35.116 15.7851Z",
                fill: "#FF5252"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M26.4248 17.846C26.5958 18.0165 26.6891 18.2334 26.6891 18.4659V26.5857H14.1576C13.7534 26.5857 13.4269 26.2603 13.4269 25.8574V13.3832H21.5739C21.8071 13.3832 22.0403 13.4762 22.1958 13.6467L26.4248 17.846Z",
                fill: "black"
            })
        ]
    });
};

});


parcelRegister("jEre1", function(module, exports) {

$parcel$export(module.exports, "dovetailConfig", () => $b03eb7cb3646ea18$export$74bb7abed969b4a3);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $8RtF5 = parcelRequire("8RtF5");

var $dRh37 = parcelRequire("dRh37");
const $b03eb7cb3646ea18$export$74bb7abed969b4a3 = {
    displayName: 'Dovetail',
    id: 'dovetail',
    resourceType: 'smartlinks-connector-dovetail',
    icon: (0, $9yyKc.get3PLogo)((0, $8RtF5.DovetailIcon), 'Dovetail', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $dRh37.DovetailSearchResultIcon), 'Dovetail', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dovetail',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("8RtF5", function(module, exports) {

$parcel$export(module.exports, "DovetailIcon", () => $bb144df551d9e565$export$e67ec9178da81ba8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $bb144df551d9e565$export$e67ec9178da81ba8 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-747.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77446 13.8484C5.74119 13.8676 5.74119 13.9156 5.77446 13.9349L8.90847 15.7448C8.93934 15.7626 8.95836 15.7956 8.95836 15.8312V19.4501C8.95836 19.4885 8.99997 19.5125 9.03327 19.4933L12.1673 17.6834C12.1981 17.6656 12.2172 17.6326 12.2172 17.597V13.9492C12.2172 13.9136 12.1981 13.8806 12.1672 13.8628L8.95836 12.0106L5.77446 13.8484Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77446 6.32257C5.74119 6.3418 5.74119 6.38983 5.77446 6.40903L8.90847 8.21896C8.93934 8.23681 8.95836 8.26975 8.95836 8.30542V12.0108L12.2172 10.1288V6.42346C12.2172 6.38779 12.1981 6.35482 12.1672 6.33697L9.00828 4.51363C8.97741 4.49578 8.93934 4.49578 8.90847 4.51363L5.77446 6.32257Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.2173 10.1281L15.4261 11.9813C15.457 11.9991 15.4761 12.0321 15.4761 12.0678V15.6866C15.4761 15.7251 15.5177 15.7491 15.5509 15.7299L18.6849 13.9199C18.7158 13.9021 18.7348 13.8691 18.7348 13.8335V10.1858C18.7348 10.1501 18.7158 10.1171 18.6849 10.0993L15.526 8.27594C15.4951 8.25812 15.457 8.25812 15.4261 8.27594L12.2173 10.1281Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.72 4H5.28C4.57308 4 4 4.57308 4 5.28V18.72C4 19.4269 4.57308 20 5.28 20H18.72C19.4269 20 20 19.4269 20 18.72V5.28C20 4.57308 19.4269 4 18.72 4Z",
                fill: "#0C0020"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.8497 13.2323C7.82752 13.2451 7.82752 13.2771 7.8497 13.2899L9.93904 14.4965C9.95962 14.5084 9.9723 14.5304 9.9723 14.5542V16.9667C9.9723 16.9924 10 17.0084 10.0222 16.9955L12.1116 15.7889C12.1321 15.777 12.1448 15.7551 12.1448 15.7313V13.2995C12.1448 13.2757 12.1321 13.2537 12.1115 13.2419L9.9723 12.0071L7.8497 13.2323Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.8497 8.21489C7.82752 8.22771 7.82752 8.25973 7.8497 8.27253L9.93904 9.47915C9.95962 9.49104 9.9723 9.513 9.9723 9.53678V12.007L12.1448 10.7524V8.28214C12.1448 8.25836 12.1321 8.23638 12.1115 8.22449L10.0056 7.00893C9.985 6.99702 9.95962 6.99702 9.93904 7.00893L7.8497 8.21489Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1448 10.7523L14.2841 11.9877C14.3047 11.9996 14.3174 12.0216 14.3174 12.0453V14.4579C14.3174 14.4835 14.3451 14.4995 14.3673 14.4867L16.4566 13.2801C16.4772 13.2682 16.4899 13.2463 16.4899 13.2225V10.7907C16.4899 10.7669 16.4772 10.7449 16.4566 10.733L14.3506 9.51745C14.33 9.50557 14.3047 9.50557 14.2841 9.51745L12.1448 10.7523Z",
                fill: "white"
            })
        ]
    });
};

});

parcelRegister("dRh37", function(module, exports) {

$parcel$export(module.exports, "DovetailSearchResultIcon", () => $df42b92f5da11926$export$ba101884e6c20332);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $df42b92f5da11926$export$ba101884e6c20332 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            "\\",
            ' ',
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-19.5",
                y: "-742.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.69929 18.4645C7.65493 18.4901 7.65493 18.5542 7.69929 18.5798L11.878 20.993C11.9191 21.0168 11.9445 21.0608 11.9445 21.1083V25.9335C11.9445 25.9847 12 26.0167 12.0444 25.9911L16.223 23.5779C16.2642 23.5541 16.2896 23.5102 16.2896 23.4626V18.599C16.2896 18.5514 16.2642 18.5075 16.223 18.4837L11.9445 16.0142L7.69929 18.4645Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.69929 8.43014C7.65493 8.45578 7.65493 8.51982 7.69929 8.54542L11.878 10.9587C11.9191 10.9825 11.9445 11.0264 11.9445 11.0739V16.0144L16.2896 13.5051V8.56466C16.2896 8.5171 16.2642 8.47314 16.223 8.44934L12.011 6.01822C11.9699 5.99442 11.9191 5.99442 11.878 6.01822L7.69929 8.43014Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.2896 13.5041L20.568 15.975C20.6092 15.9988 20.6346 16.0427 20.6346 16.0903V20.9155C20.6346 20.9667 20.6901 20.9987 20.7344 20.9731L24.9131 18.5599C24.9543 18.5361 24.9796 18.4921 24.9796 18.4446V13.581C24.9796 13.5334 24.9543 13.4895 24.9131 13.4657L20.7012 11.0345C20.66 11.0108 20.6092 11.0108 20.568 11.0345L16.2896 13.5041Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M32.6 5H7.4C6.07452 5 5 6.07452 5 7.4V32.6C5 33.9255 6.07452 35 7.4 35H32.6C33.9255 35 35 33.9255 35 32.6V7.4C35 6.07452 33.9255 5 32.6 5Z",
                fill: "#0C0020"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.2181 22.3104C12.1766 22.3344 12.1766 22.3944 12.2181 22.4185L16.1357 24.6809C16.1742 24.7032 16.198 24.7444 16.198 24.789V29.3125C16.198 29.3606 16.25 29.3906 16.2917 29.3665L20.2091 27.1042C20.2477 27.0819 20.2715 27.0407 20.2715 26.9961V22.4365C20.2715 22.3919 20.2477 22.3507 20.2091 22.3284L16.198 20.0132L12.2181 22.3104Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.2181 12.9029C12.1766 12.9269 12.1766 12.987 12.2181 13.011L16.1357 15.2734C16.1742 15.2957 16.198 15.3369 16.198 15.3815V20.0132L20.2715 17.6607V13.029C20.2715 12.9844 20.2477 12.9432 20.2091 12.9209L16.2604 10.6417C16.2218 10.6194 16.1742 10.6194 16.1357 10.6417L12.2181 12.9029Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2715 17.6607L24.2826 19.9771C24.3212 19.9994 24.345 20.0406 24.345 20.0852V24.6088C24.345 24.6568 24.397 24.6868 24.4386 24.6628L28.3561 22.4004C28.3947 22.3781 28.4185 22.3369 28.4185 22.2924V17.7327C28.4185 17.6881 28.3947 17.6469 28.3561 17.6247L24.4074 15.3454C24.3688 15.3232 24.3212 15.3232 24.2826 15.3454L20.2715 17.6607Z",
                fill: "white"
            })
        ]
    });
};

});


parcelRegister("7qxEX", function(module, exports) {

$parcel$export(module.exports, "dropboxConfig", () => $736ae5964b52ab76$export$4a63cdb15a145936);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $ebnE3 = parcelRequire("ebnE3");

var $hETzT = parcelRequire("hETzT");
const $736ae5964b52ab76$export$4a63cdb15a145936 = {
    displayName: 'Dropbox',
    id: 'dropbox',
    resourceType: 'dropbox-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $ebnE3.DropboxIcon), 'Dropbox', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $hETzT.DropboxSearchResultIcon), 'Dropbox', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dropbox',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Presentation,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("ebnE3", function(module, exports) {

$parcel$export(module.exports, "DropboxIcon", () => $d7ac9c127b9053c9$export$5e2362bb78414664);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $d7ac9c127b9053c9$export$5e2362bb78414664 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#0061FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.0098 8.48964L8.24219 10.8931L12.0098 13.2965L8.24219 15.7L4.47461 13.2836L8.24219 10.8801L4.47461 8.48964L8.24219 6.08618L12.0098 8.48964ZM8.2227 16.473L11.9903 14.0695L15.7579 16.473L11.9903 18.8765L8.2227 16.473ZM12.0098 13.2836L15.7773 10.8801L12.0098 8.48964L15.7579 6.08618L19.5254 8.48964L15.7579 10.8931L19.5254 13.2965L15.7579 15.7L12.0098 13.2836Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24px",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 43 40",
        version: "1.1",
        height: "24px",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z",
            fill: "#007EE5"
        })
    });
};

});

parcelRegister("hETzT", function(module, exports) {

$parcel$export(module.exports, "DropboxSearchResultIcon", () => $0ba946ccc5d1e455$export$197780c70679b508);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $0ba946ccc5d1e455$export$197780c70679b508 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-67.5",
                y: "-23.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#0061FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.0129 10.9983L10.9891 14.2031L16.0129 17.4079L10.9891 20.6128L5.96533 17.3906L10.9891 14.1858L5.96533 10.9983L10.9891 7.79346L16.0129 10.9983ZM10.9631 21.6435L15.9869 18.4387L21.0107 21.6435L15.9869 24.8483L10.9631 21.6435ZM16.0129 17.3906L21.0367 14.1858L16.0129 10.9983L21.0107 7.79346L26.0345 10.9983L21.0107 14.2031L26.0345 17.4079L21.0107 20.6128L16.0129 17.3906Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M20.0194 12.2907L12.5097 17.0814L20.0194 21.872L12.5097 26.6627L5 21.8461L12.5097 17.0555L5 12.2907L12.5097 7.5L20.0194 12.2907ZM12.4709 28.2035L19.9806 23.4128L27.4903 28.2035L19.9806 32.9942L12.4709 28.2035ZM20.0194 21.8461L27.5291 17.0555L20.0194 12.2907L27.4903 7.5L35 12.2907L27.4903 17.0814L35 21.872L27.4903 26.6627L20.0194 21.8461Z",
            fill: "#0061FF"
        })
    });
};

});


parcelRegister("ka78Z", function(module, exports) {

$parcel$export(module.exports, "figmaConfig", () => $ae51f698a2238858$export$e821d8af66e3adab);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $iTtPg = parcelRequire("iTtPg");

var $eGLlZ = parcelRequire("eGLlZ");
const $ae51f698a2238858$export$e821d8af66e3adab = {
    displayName: 'Figma',
    id: 'figma',
    resourceType: 'figma-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $iTtPg.FigmaIcon), 'Figma', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $eGLlZ.FigmaSearchResultIcon), 'Figma', 'large'),
    integrationAri: 'ari:cloud:platform::integration/figma',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("iTtPg", function(module, exports) {

$parcel$export(module.exports, "FigmaIcon", () => $b0408f51f36c91ad$export$54e0f4982aa79afe);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $b0408f51f36c91ad$export$54e0f4982aa79afe = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12 12C12 11.337 12.254 10.7011 12.7061 10.2322C13.1582 9.76339 13.7714 9.5 14.4107 9.5C15.0501 9.5 15.6633 9.76339 16.1153 10.2322C16.5674 10.7011 16.8214 11.337 16.8214 12C16.8214 12.663 16.5674 13.2989 16.1153 13.7678C15.6633 14.2366 15.0501 14.5 14.4107 14.5C13.7714 14.5 13.1582 14.2366 12.7061 13.7678C12.254 13.2989 12 12.663 12 12Z",
                        fill: "#1ABCFE"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.17871 17C7.17871 16.337 7.4327 15.7011 7.88479 15.2322C8.33689 14.7634 8.95006 14.5 9.58943 14.5H12.0001V17C12.0001 17.663 11.7462 18.2989 11.2941 18.7678C10.842 19.2366 10.2288 19.5 9.58943 19.5C8.95006 19.5 8.33689 19.2366 7.88479 18.7678C7.4327 18.2989 7.17871 17.663 7.17871 17V17Z",
                        fill: "#0ACF83"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12 4.5V9.5H14.4107C15.0501 9.5 15.6633 9.23661 16.1153 8.76777C16.5674 8.29893 16.8214 7.66304 16.8214 7C16.8214 6.33696 16.5674 5.70107 16.1153 5.23223C15.6633 4.76339 15.0501 4.5 14.4107 4.5H12Z",
                        fill: "#FF7262"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.17871 7C7.17871 7.66304 7.4327 8.29893 7.88479 8.76777C8.33689 9.23661 8.95006 9.5 9.58943 9.5H12.0001V4.5H9.58943C8.95006 4.5 8.33689 4.76339 7.88479 5.23223C7.4327 5.70107 7.17871 6.33696 7.17871 7V7Z",
                        fill: "#F24E1E"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.17871 12C7.17871 12.663 7.4327 13.2989 7.88479 13.7678C8.33689 14.2366 8.95006 14.5 9.58943 14.5H12.0001V9.5H9.58943C8.95006 9.5 8.33689 9.76339 7.88479 10.2322C7.4327 10.7011 7.17871 11.337 7.17871 12V12Z",
                        fill: "#A259FF"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_7_728)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M9.22776 20C10.6998 20 11.8944 18.8053 11.8944 17.3333V14.6666H9.22776C7.75576 14.6666 6.5611 15.8613 6.5611 17.3333C6.5611 18.8053 7.75576 20 9.22776 20Z",
                        fill: "#0ACF83"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M6.5611 12C6.5611 10.528 7.75576 9.33337 9.22776 9.33337H11.8944V14.6667H9.22776C7.75576 14.6667 6.5611 13.472 6.5611 12Z",
                        fill: "#A259FF"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M6.5611 6.66667C6.5611 5.19467 7.75576 4 9.22776 4H11.8944V9.33333H9.22776C7.75576 9.33333 6.5611 8.13867 6.5611 6.66667Z",
                        fill: "#F24E1E"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M11.8943 4H14.561C16.033 4 17.2277 5.19467 17.2277 6.66667C17.2277 8.13867 16.033 9.33333 14.561 9.33333H11.8943V4Z",
                        fill: "#FF7262"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M17.2277 12C17.2277 13.472 16.033 14.6667 14.561 14.6667C13.089 14.6667 11.8943 13.472 11.8943 12C11.8943 10.528 13.089 9.33337 14.561 9.33337C16.033 9.33337 17.2277 10.528 17.2277 12Z",
                        fill: "#1ABCFE"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_7_728",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("eGLlZ", function(module, exports) {

$parcel$export(module.exports, "FigmaSearchResultIcon", () => $fc193e0e706d6ae9$export$b31792ff95c3d83f);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $fc193e0e706d6ae9$export$b31792ff95c3d83f = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-67.5",
                y: "-550.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.9995 16C15.9995 15.1159 16.3382 14.2681 16.941 13.6429C17.5438 13.0178 18.3613 12.6666 19.2138 12.6666C20.0663 12.6666 20.8838 13.0178 21.4866 13.6429C22.0894 14.2681 22.4281 15.1159 22.4281 16C22.4281 16.884 22.0894 17.7319 21.4866 18.357C20.8838 18.9821 20.0663 19.3333 19.2138 19.3333C18.3613 19.3333 17.5438 18.9821 16.941 18.357C16.3382 17.7319 15.9995 16.884 15.9995 16Z",
                        fill: "#1ABCFE"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M9.57104 22.6666C9.57104 21.7825 9.90969 20.9347 10.5125 20.3096C11.1153 19.6844 11.9328 19.3333 12.7853 19.3333H15.9996V22.6666C15.9996 23.5506 15.661 24.3985 15.0582 25.0236C14.4554 25.6487 13.6378 25.9999 12.7853 25.9999C11.9328 25.9999 11.1153 25.6487 10.5125 25.0236C9.90969 24.3985 9.57104 23.5506 9.57104 22.6666V22.6666Z",
                        fill: "#0ACF83"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.9995 6V12.6667H19.2138C20.0663 12.6667 20.8838 12.3155 21.4866 11.6904C22.0894 11.0652 22.4281 10.2174 22.4281 9.33333C22.4281 8.44928 22.0894 7.60143 21.4866 6.97631C20.8838 6.35119 20.0663 6 19.2138 6H15.9995Z",
                        fill: "#FF7262"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M9.57129 9.33333C9.57129 10.2174 9.90994 11.0652 10.5127 11.6904C11.1155 12.3155 11.9331 12.6667 12.7856 12.6667H15.9999V6H12.7856C11.9331 6 11.1155 6.35119 10.5127 6.97631C9.90994 7.60143 9.57129 8.44928 9.57129 9.33333V9.33333Z",
                        fill: "#F24E1E"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M9.57104 16C9.57104 16.884 9.90969 17.7319 10.5125 18.357C11.1153 18.9821 11.9328 19.3333 12.7853 19.3333H15.9996V12.6666H12.7853C11.9328 12.6666 11.1153 13.0178 10.5125 13.6429C9.90969 14.2681 9.57104 15.1159 9.57104 16V16Z",
                        fill: "#A259FF"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_2230_18930)",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                    clipPath: "url(#clip1_2230_18930)",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M14.8021 35C17.5621 35 19.8021 32.76 19.8021 30V25H14.8021C12.0421 25 9.80206 27.24 9.80206 30C9.80206 32.76 12.0421 35 14.8021 35Z",
                            fill: "#0ACF83"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M9.80206 20C9.80206 17.24 12.0421 15 14.8021 15H19.8021V25H14.8021C12.0421 25 9.80206 22.76 9.80206 20Z",
                            fill: "#A259FF"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M9.80206 10C9.80206 7.24 12.0421 5 14.8021 5H19.8021V15H14.8021C12.0421 15 9.80206 12.76 9.80206 10Z",
                            fill: "#F24E1E"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M19.8019 5H24.8019C27.5619 5 29.8019 7.24 29.8019 10C29.8019 12.76 27.5619 15 24.8019 15H19.8019V5Z",
                            fill: "#FF7262"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M29.8019 20C29.8019 22.76 27.5619 25 24.8019 25C22.0419 25 19.8019 22.76 19.8019 20C19.8019 17.24 22.0419 15 24.8019 15C27.5619 15 29.8019 17.24 29.8019 20Z",
                            fill: "#1ABCFE"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_2230_18930",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "30",
                            height: "30",
                            fill: "white",
                            transform: "translate(5 5)"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip1_2230_18930",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "30",
                            height: "30",
                            fill: "white",
                            transform: "translate(5 5)"
                        })
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("D1Pzo", function(module, exports) {

$parcel$export(module.exports, "freshserviceConfig", () => $4e05e26811c637e9$export$8120804698f632ae);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $hKTaK = parcelRequire("hKTaK");

var $93uzv = parcelRequire("93uzv");
const $4e05e26811c637e9$export$8120804698f632ae = {
    displayName: 'Freshservice',
    id: 'freshservice',
    icon: (0, $9yyKc.get3PLogo)((0, $hKTaK.FreshserviceIcon), 'Freshservice', 'medium'),
    resourceType: 'freshservice-connector',
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $93uzv.FreshserviceSearchResultIcon), 'Freshservice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/freshservice',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("hKTaK", function(module, exports) {

$parcel$export(module.exports, "FreshserviceIcon", () => $c56e7422e28191c0$export$327de5bc0476c8b8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $c56e7422e28191c0$export$327de5bc0476c8b8 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-683.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#09C6FA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.6954 4.25008C15.7025 4.25008 16.7099 4.25338 17.7183 4.25008C18.2271 4.24619 18.6802 4.38244 19.0651 4.72054C19.4877 5.09067 19.7328 5.55604 19.7349 6.11783C19.7436 8.16046 19.767 10.2037 19.7289 12.2454C19.6945 14.0838 19.0364 15.7066 17.8236 17.091C16.5561 18.5389 14.9606 19.4014 13.0546 19.6709C11.5776 19.8805 10.1533 19.6736 8.79837 19.0498C6.90652 18.179 5.57016 16.7631 4.79229 14.8358C4.32449 13.676 4.16198 12.4628 4.29456 11.2138C4.46875 9.57492 5.09668 8.1346 6.17833 6.89283C7.22587 5.69708 8.52271 4.90171 10.0581 4.49714C10.7129 4.32786 11.3871 4.2451 12.0634 4.25098C12.9401 4.25158 13.8175 4.25128 14.6954 4.25008ZM13.1971 11.1482C12.6063 11.1482 12.0155 11.1464 11.4247 11.15C11.322 11.15 11.2897 11.1323 11.3274 11.0221C11.4729 10.5945 11.6099 10.1642 11.7503 9.73443C11.895 9.29243 12.0394 8.85042 12.1837 8.40841C12.2211 8.29372 12.1837 8.20089 12.084 8.14459C11.9844 8.08829 11.8838 8.10895 11.8087 8.20268C11.7668 8.25509 11.7291 8.31079 11.689 8.36529C11.0002 9.32517 10.3118 10.2847 9.62382 11.244C9.34987 11.6257 9.07501 12.0067 8.79926 12.3868C8.76505 12.4287 8.74371 12.4796 8.73781 12.5334C8.73192 12.5872 8.74172 12.6415 8.76604 12.6898C8.81722 12.8 8.9115 12.842 9.02673 12.8464C9.07581 12.8482 9.1252 12.8479 9.17428 12.8479H12.5042C12.7054 12.8479 12.709 12.8479 12.6449 13.0456C12.3744 13.8747 12.1026 14.7032 11.8296 15.5311C11.7802 15.6809 11.8036 15.7737 11.9113 15.8336C12.0191 15.8935 12.1128 15.8677 12.2106 15.7437C12.2247 15.7264 12.2376 15.7081 12.2507 15.6898C13.2284 14.3369 14.2055 12.9839 15.182 11.6309C15.2554 11.5294 15.2919 11.4237 15.2299 11.3063C15.168 11.1889 15.0626 11.1461 14.9288 11.1467C14.3518 11.1503 13.7745 11.1482 13.1971 11.1482Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M14.7823 4.00008C15.822 4.00008 16.8619 4.00348 17.9027 4.00008C18.428 3.99606 18.8957 4.13672 19.293 4.48571C19.7293 4.86779 19.9823 5.34817 19.9844 5.92808C19.9934 8.0366 20.0175 10.1457 19.9783 12.2533C19.9427 14.151 19.2634 15.8262 18.0115 17.2552C16.7031 18.7499 15.0561 19.6401 13.0887 19.9183C11.564 20.1347 10.0937 19.9211 8.69509 19.2772C6.74221 18.3783 5.36275 16.9168 4.55979 14.9272C4.0769 13.73 3.90914 12.4778 4.046 11.1884C4.22581 9.49669 4.87399 8.00991 5.99053 6.72809C7.07186 5.49376 8.41054 4.67273 9.99546 4.25511C10.6714 4.08037 11.3673 3.99494 12.0654 4.00101C12.9704 4.00163 13.8761 4.00132 14.7823 4.00008ZM13.2357 11.1207C12.6259 11.1207 12.016 11.1189 11.4061 11.1226C11.3002 11.1226 11.2668 11.1043 11.3057 10.9906C11.4559 10.5491 11.5974 10.1049 11.7423 9.66135C11.8916 9.20508 12.0407 8.74882 12.1896 8.29256C12.2282 8.17416 12.1896 8.07833 12.0867 8.02022C11.9839 7.9621 11.8801 7.98343 11.8025 8.08019C11.7593 8.13428 11.7203 8.19178 11.6789 8.24804C10.9679 9.23888 10.2573 10.2294 9.54717 11.2196C9.26438 11.6137 8.98066 12.0069 8.69601 12.3992C8.6607 12.4425 8.63867 12.4951 8.63258 12.5506C8.6265 12.6061 8.63662 12.6622 8.66172 12.7121C8.71455 12.8258 8.81187 12.8691 8.93082 12.8737C8.98148 12.8756 9.03246 12.8753 9.08313 12.8753H12.5205C12.7281 12.8753 12.7318 12.8753 12.6657 13.0793C12.3864 13.9352 12.1059 14.7904 11.8241 15.645C11.7732 15.7996 11.7973 15.8954 11.9085 15.9572C12.0197 16.0191 12.1164 15.9925 12.2174 15.8645C12.232 15.8466 12.2452 15.8277 12.2588 15.8089C13.2681 14.4122 14.2767 13.0156 15.2847 11.619C15.3604 11.5142 15.3981 11.4051 15.3341 11.2839C15.2702 11.1628 15.1614 11.1186 15.0233 11.1192C14.4277 11.1229 13.8317 11.1207 13.2357 11.1207Z",
            fill: "#09C6FA"
        })
    });
};

});

parcelRegister("93uzv", function(module, exports) {

$parcel$export(module.exports, "FreshserviceSearchResultIcon", () => $6d29efead71cf8c0$export$afb7a1d2b1e9186c);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $6d29efead71cf8c0$export$afb7a1d2b1e9186c = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-211.5",
                y: "-646.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
                fill: "#09C6FA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.5937 5.66673C20.9365 5.66673 22.2798 5.67113 23.6242 5.66673C24.3026 5.66154 24.9068 5.84322 25.42 6.29401C25.9835 6.78752 26.3103 7.40801 26.3131 8.15706C26.3247 10.8806 26.3558 13.6049 26.3051 16.3272C26.2592 18.7784 25.3817 20.9421 23.7647 22.788C22.0746 24.7185 19.9473 25.8685 17.406 26.2278C15.4367 26.5073 13.5375 26.2314 11.731 25.3997C9.20853 24.2386 7.42672 22.3508 6.38956 19.781C5.76583 18.2346 5.54914 16.6171 5.72592 14.9517C5.95817 12.7665 6.7954 10.8461 8.23761 9.19041C9.63432 7.59607 11.3635 6.53557 13.4106 5.99614C14.2837 5.77043 15.1826 5.66009 16.0843 5.66793C17.2533 5.66873 18.4231 5.66833 19.5937 5.66673ZM17.596 14.8642C16.8082 14.8642 16.0205 14.8618 15.2328 14.8666C15.0959 14.8666 15.0528 14.8431 15.1031 14.6961C15.297 14.1259 15.4798 13.5522 15.6669 12.9792C15.8598 12.3899 16.0524 11.8005 16.2448 11.2112C16.2947 11.0583 16.2448 10.9345 16.1119 10.8594C15.979 10.7843 15.8449 10.8119 15.7447 10.9369C15.6889 11.0067 15.6386 11.081 15.5851 11.1537C14.6667 12.4335 13.7489 13.7129 12.8316 14.992C12.4663 15.5009 12.0999 16.0088 11.7322 16.5156C11.6866 16.5715 11.6581 16.6394 11.6503 16.7111C11.6424 16.7828 11.6555 16.8553 11.6879 16.9197C11.7561 17.0667 11.8818 17.1226 12.0355 17.1285C12.1009 17.1309 12.1668 17.1305 12.2322 17.1305H16.6722C16.9403 17.1305 16.9451 17.1305 16.8597 17.3941C16.499 18.4996 16.1366 19.6042 15.7727 20.7081C15.7068 20.9078 15.738 21.0315 15.8816 21.1114C16.0253 21.1913 16.1502 21.1569 16.2807 20.9916C16.2994 20.9685 16.3166 20.9441 16.3342 20.9197C17.6378 19.1158 18.9406 17.3118 20.2426 15.5079C20.3403 15.3725 20.389 15.2316 20.3064 15.075C20.2238 14.9185 20.0833 14.8614 19.905 14.8622C19.1356 14.867 18.3658 14.8642 17.596 14.8642Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M25.2169 5.00016C27.1662 5.00016 29.116 5.00653 31.0676 5.00016C32.0524 4.99262 32.9294 5.25634 33.6744 5.91071C34.4923 6.62711 34.9668 7.52781 34.9708 8.61515C34.9876 12.5686 35.0328 16.5233 34.9592 20.475C34.8926 24.0332 33.6188 27.1741 31.2715 29.8536C28.8183 32.656 25.7301 34.3252 22.0413 34.8469C19.1825 35.2526 16.4257 34.8521 13.8033 33.6448C10.1416 31.9593 7.55515 29.2189 6.0496 25.4886C5.14418 23.2438 4.82963 20.8958 5.08625 18.4783C5.42339 15.3063 6.63873 12.5186 8.73225 10.1152C10.7597 7.8008 13.2698 6.26138 16.2415 5.47833C17.5089 5.15069 18.8137 4.99051 20.1227 5.0019C21.8196 5.00305 23.5177 5.00248 25.2169 5.00016ZM22.317 18.3513C21.1735 18.3513 20.03 18.3479 18.8865 18.3548C18.6878 18.3548 18.6252 18.3206 18.6982 18.1073C18.9798 17.2797 19.2451 16.4468 19.5167 15.615C19.7967 14.7595 20.0763 13.904 20.3555 13.0485C20.428 12.8266 20.3555 12.6469 20.1626 12.5379C19.9697 12.4289 19.7751 12.4689 19.6297 12.6504C19.5486 12.7518 19.4756 12.8596 19.398 12.9651C18.0649 14.8229 16.7325 16.6801 15.4009 18.5368C14.8707 19.2756 14.3387 20.0129 13.805 20.7486C13.7388 20.8297 13.6975 20.9282 13.6861 21.0323C13.6747 21.1364 13.6937 21.2416 13.7407 21.3351C13.8398 21.5484 14.0223 21.6296 14.2453 21.6383C14.3403 21.6418 14.4359 21.6412 14.5309 21.6412H20.976C21.3652 21.6412 21.3722 21.6412 21.2482 22.0237C20.7245 23.6284 20.1986 25.232 19.6703 26.8344C19.5747 27.1242 19.6199 27.3039 19.8284 27.4198C20.0369 27.5357 20.2183 27.4859 20.4077 27.2459C20.4349 27.2123 20.4598 27.177 20.4853 27.1416C22.3776 24.523 24.2688 21.9043 26.1588 19.2857C26.3007 19.0892 26.3714 18.8846 26.2515 18.6574C26.1316 18.4302 25.9277 18.3473 25.6687 18.3484C24.5519 18.3554 23.4344 18.3513 22.317 18.3513Z",
            fill: "#09C6FA"
        })
    });
};

});


parcelRegister("eOOLq", function(module, exports) {

$parcel$export(module.exports, "gitbookConfig", () => $16fc7b862509cb0a$export$49c4b548f63d5a90);

var $dh538 = parcelRequire("dh538");

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $hP2yW = parcelRequire("hP2yW");

var $bfWdZ = parcelRequire("bfWdZ");
const $16fc7b862509cb0a$export$49c4b548f63d5a90 = {
    displayName: 'GitBook',
    id: 'gitbook',
    icon: (0, $9yyKc.RovoLogoFromLogo)((0, $hP2yW.GitbookIcon), 'GitBook'),
    resourceType: 'gitbook-connector',
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $bfWdZ.GitbookSearchResultIcon), 'GitBook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/graph-test-app',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: false,
    userNeedsOAuth: false,
    // This will only be enabled on the demo instance
    isEnabled: ()=>(0, $dh538.fg)('forge-connector-demo')
};

});
parcelRegister("hP2yW", function(module, exports) {

$parcel$export(module.exports, "GitbookIcon", () => $4f39dbbcd3d9b471$export$6da1c7984975c183);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");
const $4f39dbbcd3d9b471$export$6da1c7984975c183 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M10.802 17.77a.703.703 0 1 1-.002 1.406.703.703 0 0 1 .002-1.406m11.024-4.347a.703.703 0 1 1 .001-1.406.703.703 0 0 1-.001 1.406m0-2.876a2.176 2.176 0 0 0-2.174 2.174c0 .233.039.465.115.691l-7.181 3.823a2.165 2.165 0 0 0-1.784-.937c-.829 0-1.584.475-1.95 1.216l-6.451-3.402c-.682-.358-1.192-1.48-1.138-2.502.028-.533.212-.947.493-1.107.178-.1.392-.092.62.027l.042.023c1.71.9 7.304 3.847 7.54 3.956.363.169.565.237 1.185-.057l11.564-6.014c.17-.064.368-.227.368-.474 0-.342-.354-.477-.355-.477-.658-.315-1.669-.788-2.655-1.25-2.108-.987-4.497-2.105-5.546-2.655-.906-.474-1.635-.074-1.765.006l-.252.125C7.78 6.048 1.46 9.178 1.1 9.397.457 9.789.058 10.57.006 11.539c-.08 1.537.703 3.14 1.824 3.727l6.822 3.518a2.175 2.175 0 0 0 2.15 1.862 2.177 2.177 0 0 0 2.173-2.14l7.514-4.073c.38.298.853.461 1.337.461A2.176 2.176 0 0 0 24 12.72a2.176 2.176 0 0 0-2.174-2.174"
        })
    });

});

parcelRegister("bfWdZ", function(module, exports) {

$parcel$export(module.exports, "GitbookSearchResultIcon", () => $8577bbb24d570958$export$65b356f251826206);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");
const $8577bbb24d570958$export$65b356f251826206 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`,
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M10.802 17.77a.703.703 0 1 1-.002 1.406.703.703 0 0 1 .002-1.406m11.024-4.347a.703.703 0 1 1 .001-1.406.703.703 0 0 1-.001 1.406m0-2.876a2.176 2.176 0 0 0-2.174 2.174c0 .233.039.465.115.691l-7.181 3.823a2.165 2.165 0 0 0-1.784-.937c-.829 0-1.584.475-1.95 1.216l-6.451-3.402c-.682-.358-1.192-1.48-1.138-2.502.028-.533.212-.947.493-1.107.178-.1.392-.092.62.027l.042.023c1.71.9 7.304 3.847 7.54 3.956.363.169.565.237 1.185-.057l11.564-6.014c.17-.064.368-.227.368-.474 0-.342-.354-.477-.355-.477-.658-.315-1.669-.788-2.655-1.25-2.108-.987-4.497-2.105-5.546-2.655-.906-.474-1.635-.074-1.765.006l-.252.125C7.78 6.048 1.46 9.178 1.1 9.397.457 9.789.058 10.57.006 11.539c-.08 1.537.703 3.14 1.824 3.727l6.822 3.518a2.175 2.175 0 0 0 2.15 1.862 2.177 2.177 0 0 0 2.173-2.14l7.514-4.073c.38.298.853.461 1.337.461A2.176 2.176 0 0 0 24 12.72a2.176 2.176 0 0 0-2.174-2.174"
        })
    });

});


parcelRegister("kFIbV", function(module, exports) {

$parcel$export(module.exports, "githubConfig", () => $90d5c696e3fdd30c$export$71c63cb45707eee);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $go3Ad = parcelRequire("go3Ad");

var $2e3ZR = parcelRequire("2e3ZR");
const $90d5c696e3fdd30c$export$71c63cb45707eee = {
    displayName: 'GitHub',
    id: 'github',
    resourceType: 'github-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $go3Ad.GithubIcon), 'Github', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $2e3ZR.GithubSearchResultIcon), 'Github', 'large'),
    integrationAri: 'ari:cloud:platform::integration/github',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("go3Ad", function(module, exports) {

$parcel$export(module.exports, "GithubIcon", () => $b28fd47f0e7211c2$export$e8e65f186ccd8749);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6fnsQ = parcelRequire("6fnsQ");
const $b28fd47f0e7211c2$export$e8e65f186ccd8749 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0001 4C7.58233 4 4 7.67232 4 12.2025C4 15.8266 6.29226 18.9013 9.47093 19.9859C9.87075 20.0618 10.0175 19.808 10.0175 19.5913C10.0175 19.3957 10.0101 18.7496 10.0067 18.0642C7.78105 18.5604 7.31141 17.0964 7.31141 17.0964C6.9475 16.1483 6.42315 15.8962 6.42315 15.8962C5.6973 15.3871 6.47786 15.3975 6.47786 15.3975C7.28121 15.4554 7.70421 16.2428 7.70421 16.2428C8.41774 17.4968 9.57572 17.1343 10.0322 16.9247C10.104 16.3945 10.3114 16.0327 10.5402 15.8279C8.76324 15.6204 6.8953 14.9171 6.8953 11.7741C6.8953 10.8786 7.20782 10.1469 7.71958 9.57245C7.63651 9.36585 7.36268 8.53158 7.79708 7.40174C7.79708 7.40174 8.46887 7.18129 9.99766 8.24253C10.6358 8.06079 11.3202 7.96965 12.0001 7.96653C12.6799 7.96965 13.3649 8.06079 14.0042 8.24253C15.5311 7.18129 16.202 7.40174 16.202 7.40174C16.6375 8.53158 16.3635 9.36585 16.2804 9.57245C16.7934 10.1469 17.1038 10.8786 17.1038 11.7741C17.1038 14.9246 15.2323 15.6183 13.4508 15.8213C13.7378 16.0759 13.9935 16.5751 13.9935 17.3403C13.9935 18.4378 13.9842 19.3211 13.9842 19.5913C13.9842 19.8096 14.1282 20.0654 14.5337 19.9848C17.7107 18.899 20 15.8254 20 12.2025C20 7.67232 16.4182 4 12.0001 4Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_6309_146339)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M10.0001 0C4.47791 0 0 4.59039 0 10.2532C0 14.7833 2.86533 18.6266 6.83867 19.9824C7.33844 20.0773 7.52192 19.76 7.52192 19.4891C7.52192 19.2446 7.51265 18.437 7.50834 17.5802C4.72631 18.2005 4.13927 16.3705 4.13927 16.3705C3.68437 15.1854 3.02894 14.8702 3.02894 14.8702C2.12163 14.2339 3.09733 14.2469 3.09733 14.2469C4.10151 14.3193 4.63026 15.3035 4.63026 15.3035C5.52217 16.871 6.96965 16.4178 7.5403 16.1559C7.63006 15.4932 7.88921 15.0409 8.1752 14.7848C5.95404 14.5256 3.61912 13.6464 3.61912 9.71766C3.61912 8.59825 4.00977 7.6836 4.64947 6.96556C4.54564 6.70731 4.20335 5.66448 4.74635 4.25218C4.74635 4.25218 5.58609 3.97661 7.49708 5.30317C8.29476 5.07599 9.15024 4.96206 10.0001 4.95816C10.8499 4.96206 11.7061 5.07599 12.5052 5.30317C14.4139 3.97661 15.2525 4.25218 15.2525 4.25218C15.7968 5.66448 15.4544 6.70731 15.3505 6.96556C15.9917 7.6836 16.3797 8.59825 16.3797 9.71766C16.3797 13.6557 14.0403 14.5228 11.8135 14.7767C12.1722 15.0949 12.4918 15.7188 12.4918 16.6754C12.4918 18.0473 12.4802 19.1514 12.4802 19.4891C12.4802 19.762 12.6602 20.0817 13.1671 19.981C17.1383 18.6237 20 14.7818 20 10.2532C20 4.59039 15.5227 0 10.0001 0Z",
                        fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_6309_146339",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`
                    })
                })
            })
        ]
    });
};

});

parcelRegister("2e3ZR", function(module, exports) {

$parcel$export(module.exports, "GithubSearchResultIcon", () => $8013d871d4b453d5$export$fa0f141eb732d2d7);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6fnsQ = parcelRequire("6fnsQ");
const $8013d871d4b453d5$export$fa0f141eb732d2d7 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-19.5",
                y: "-646.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16 5.33337C10.1097 5.33337 5.33325 10.2298 5.33325 16.2701C5.33325 21.1022 8.3896 25.2018 12.6278 26.6479C13.1609 26.7492 13.3566 26.4107 13.3566 26.1218C13.3566 25.861 13.3467 24.9995 13.3422 24.0856C10.3746 24.7472 9.74847 22.7952 9.74847 22.7952C9.26325 21.5311 8.56412 21.1949 8.56412 21.1949C7.59632 20.5162 8.63707 20.5301 8.63707 20.5301C9.70819 20.6073 10.2722 21.6571 10.2722 21.6571C11.2236 23.3291 12.7675 22.8457 13.3762 22.5663C13.472 21.8594 13.7484 21.377 14.0535 21.1039C11.6842 20.8273 9.19365 19.8895 9.19365 15.6989C9.19365 14.5048 9.61034 13.5292 10.2927 12.7633C10.1819 12.4878 9.81683 11.3755 10.396 9.86903C10.396 9.86903 11.2917 9.57509 13.3301 10.9901C14.181 10.7478 15.0935 10.6262 16 10.6221C16.9065 10.6262 17.8197 10.7478 18.6722 10.9901C20.7081 9.57509 21.6026 9.86903 21.6026 9.86903C22.1832 11.3755 21.8179 12.4878 21.7071 12.7633C22.3911 13.5292 22.8049 14.5048 22.8049 15.6989C22.8049 19.8995 20.3096 20.8244 17.9344 21.0952C18.317 21.4346 18.6579 22.1001 18.6579 23.1205C18.6579 24.5838 18.6455 25.7616 18.6455 26.1218C18.6455 26.4128 18.8375 26.7539 19.3782 26.6465C23.6141 25.1987 26.6666 21.1006 26.6666 16.2701C26.6666 10.2298 21.8909 5.33337 16 5.33337Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.0001 5C11.7169 5 5 11.8856 5 20.3798C5 27.1749 9.29799 32.9399 15.258 34.9736C16.0077 35.1159 16.2829 34.6399 16.2829 34.2337C16.2829 33.867 16.269 32.6554 16.2625 31.3703C12.0895 32.3007 11.2089 29.5557 11.2089 29.5557C10.5266 27.778 9.5434 27.3053 9.5434 27.3053C8.18244 26.3508 9.64599 26.3704 9.64599 26.3704C11.1523 26.4789 11.9454 27.9553 11.9454 27.9553C13.2833 30.3065 15.4545 29.6268 16.3105 29.2338C16.4451 28.2398 16.8338 27.5613 17.2628 27.1772C13.9311 26.7883 10.4287 25.4696 10.4287 19.5765C10.4287 17.8974 11.0147 16.5254 11.9742 15.4483C11.8185 15.061 11.305 13.4967 12.1195 11.3783C12.1195 11.3783 13.3791 10.9649 16.2456 12.9547C17.4421 12.614 18.7254 12.4431 20.0001 12.4372C21.2749 12.4431 22.5591 12.614 23.7579 12.9547C26.6209 10.9649 27.8787 11.3783 27.8787 11.3783C28.6952 13.4967 28.1815 15.061 28.0258 15.4483C28.9876 16.5254 29.5696 17.8974 29.5696 19.5765C29.5696 25.4836 26.0605 26.7843 22.7203 27.165C23.2583 27.6423 23.7377 28.5782 23.7377 30.0131C23.7377 32.071 23.7203 33.7272 23.7203 34.2337C23.7203 34.643 23.9904 35.1226 24.7507 34.9715C30.7075 32.9356 35 27.1726 35 20.3798C35 11.8856 28.2841 5 20.0001 5Z",
            fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`
        })
    });
};

});


parcelRegister("6TSwY", function(module, exports) {

$parcel$export(module.exports, "gitlabConfig", () => $04e57759b6e32a8a$export$72758f81cc2e21e1);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $tNEXZ = parcelRequire("tNEXZ");

var $iaIm5 = parcelRequire("iaIm5");
const $04e57759b6e32a8a$export$72758f81cc2e21e1 = {
    displayName: 'Gitlab',
    id: 'gitlab',
    resourceType: 'gitlab-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $tNEXZ.GitlabIcon), 'Gitlab', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $iaIm5.GitlabSearchResultIcon), 'Gitlab', 'large'),
    integrationAri: 'ari:cloud:platform::integration/gitlab',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Repository,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Repository
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("tNEXZ", function(module, exports) {

$parcel$export(module.exports, "GitlabIcon", () => $5fd4b746d8633c4e$export$8b4e5326778cce0f);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $5fd4b746d8633c4e$export$8b4e5326778cce0f = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-587.5",
                y: "-363.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.7331 10.3948L19.7115 10.3373L17.5339 4.65705C17.4898 4.54552 17.4114 4.4509 17.31 4.3869C17.2343 4.33846 17.1483 4.30842 17.059 4.29919C16.9696 4.28996 16.8793 4.30179 16.7953 4.33375C16.7113 4.3657 16.636 4.41688 16.5754 4.4832C16.5147 4.54951 16.4705 4.6291 16.4461 4.7156L14.9763 9.21564H9.02381L7.55392 4.7156C7.5294 4.62923 7.48504 4.54979 7.42438 4.4836C7.36371 4.41742 7.28842 4.36632 7.20451 4.3344C7.1206 4.30247 7.03039 4.29059 6.94107 4.2997C6.85175 4.30882 6.7658 4.33868 6.69007 4.3869C6.58865 4.4509 6.51022 4.54552 6.46615 4.65705L4.28957 10.3383L4.26697 10.3948C3.95361 11.2138 3.91501 12.1125 4.15698 12.9553C4.39895 13.7981 4.90838 14.5394 5.60846 15.0674L5.61668 15.0736L5.63517 15.088L8.94779 17.5706L10.5913 18.8125L11.5897 19.5675C11.7068 19.656 11.8496 19.7038 11.9964 19.7038C12.1432 19.7038 12.2861 19.656 12.4032 19.5675L13.4016 18.8125L15.0451 17.5706L18.3813 15.0736L18.3906 15.0664C19.0906 14.5386 19.6001 13.7975 19.8423 12.9549C20.0844 12.1123 20.0461 11.2138 19.7331 10.3948Z",
                fill: "#E24329"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.7329 10.3948L19.7114 10.3373C18.6504 10.555 17.6507 11.0047 16.7839 11.6541L12.0024 15.2698L15.047 17.5706L18.3832 15.0736L18.3925 15.0664C19.0922 14.5383 19.6012 13.7971 19.843 12.9545C20.0848 12.1119 20.0462 11.2135 19.7329 10.3948Z",
                fill: "#FC6D26"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.94775 17.5708L10.5912 18.8126L11.5896 19.5676C11.7068 19.6561 11.8496 19.7039 11.9964 19.7039C12.1432 19.7039 12.286 19.6561 12.4032 19.5676L13.4016 18.8126L15.045 17.5708L12.0005 15.2699L8.94775 17.5708Z",
                fill: "#FCA326"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.21598 11.6541C6.34952 11.005 5.35016 10.5556 4.28957 10.3383L4.26697 10.3948C3.95361 11.2137 3.91501 12.1124 4.15698 12.9552C4.39895 13.798 4.90838 14.5393 5.60846 15.0674L5.61668 15.0735L5.63517 15.0879L8.94779 17.5706L11.9944 15.2697L7.21598 11.6541Z",
                fill: "#FC6D26"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.7331 11.0987L19.7115 11.0412L17.5339 5.36091C17.4898 5.24937 17.4114 5.15476 17.31 5.09076C17.2343 5.04232 17.1483 5.01228 17.059 5.00304C16.9696 4.99381 16.8793 5.00565 16.7953 5.0376C16.7113 5.06956 16.636 5.12074 16.5754 5.18705C16.5147 5.25337 16.4705 5.33296 16.4461 5.41946L14.9763 9.91949H9.02381L7.55392 5.41946C7.5294 5.33309 7.48504 5.25364 7.42438 5.18746C7.36371 5.12127 7.28842 5.07018 7.20451 5.03825C7.1206 5.00632 7.03039 4.99444 6.94107 5.00356C6.85175 5.01268 6.7658 5.04254 6.69007 5.09076C6.58865 5.15476 6.51023 5.24937 6.46615 5.36091L4.28957 11.0422L4.26697 11.0987C3.95361 11.9177 3.91501 12.8163 4.15698 13.6591C4.39895 14.502 4.90838 15.2433 5.60846 15.7713L5.61668 15.7775L5.63517 15.7918L8.9478 18.2745L10.5913 19.5164L11.5897 20.2713C11.7068 20.3598 11.8496 20.4077 11.9964 20.4077C12.1432 20.4077 12.2861 20.3598 12.4032 20.2713L13.4016 19.5164L15.0451 18.2745L18.3813 15.7775L18.3906 15.7703C19.0906 15.2424 19.6001 14.5014 19.8423 13.6588C20.0844 12.8161 20.0461 11.9176 19.7331 11.0987Z",
                fill: "#E24329"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.7331 11.0987L19.7115 11.0411C18.6505 11.2589 17.6508 11.7085 16.784 12.358L12.0026 15.9736L15.0471 18.2745L18.3833 15.7774L18.3926 15.7702C19.0923 15.2421 19.6014 14.501 19.8431 13.6583C20.0849 12.8157 20.0463 11.9174 19.7331 11.0987Z",
                fill: "#FC6D26"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.94781 18.2745L10.5913 19.5163L11.5897 20.2713C11.7068 20.3598 11.8496 20.4077 11.9965 20.4077C12.1433 20.4077 12.2861 20.3598 12.4032 20.2713L13.4016 19.5163L15.0451 18.2745L12.0006 15.9736L8.94781 18.2745Z",
                fill: "#FCA326"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.21598 12.358C6.34952 11.7089 5.35016 11.2596 4.28957 11.0422L4.26697 11.0987C3.95361 11.9177 3.91501 12.8164 4.15698 13.6592C4.39895 14.502 4.90838 15.2433 5.60846 15.7713L5.61668 15.7775L5.63517 15.7919L8.9478 18.2745L11.9944 15.9737L7.21598 12.358Z",
                fill: "#FC6D26"
            })
        ]
    });
};

});

parcelRegister("iaIm5", function(module, exports) {

$parcel$export(module.exports, "GitlabSearchResultIcon", () => $39fd142ba4916877$export$b828123bc19648f9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $39fd142ba4916877$export$b828123bc19648f9 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                fill: "#F5F5F5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-115.5",
                y: "-358.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.508324",
                y: "0.508324",
                width: "30.9834",
                height: "30.9834",
                rx: "7.49168",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "1.01665"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M26.3107 13.8597L26.2819 13.783L23.3785 6.20936C23.3197 6.06065 23.2151 5.9345 23.0799 5.84916C22.979 5.78457 22.8644 5.74452 22.7452 5.73221C22.626 5.7199 22.5056 5.73568 22.3937 5.77829C22.2817 5.82089 22.1813 5.88914 22.1004 5.97755C22.0196 6.06597 21.9606 6.1721 21.9281 6.28743L19.9683 12.2875H12.0317L10.0718 6.28743C10.0391 6.17227 9.97998 6.06634 9.89909 5.9781C9.8182 5.88985 9.71782 5.82172 9.60593 5.77915C9.49405 5.73658 9.37377 5.72074 9.25468 5.7329C9.13559 5.74505 9.02099 5.78487 8.92002 5.84916C8.78479 5.9345 8.68022 6.06065 8.62145 6.20936L5.71935 13.7844L5.68922 13.8597C5.2714 14.9517 5.21993 16.1499 5.54256 17.2737C5.86519 18.3974 6.54443 19.3858 7.47787 20.0899L7.48882 20.0981L7.51348 20.1173L11.9303 23.4275L14.1216 25.0833L15.4528 26.0899C15.609 26.2079 15.7994 26.2717 15.9952 26.2717C16.1909 26.2717 16.3813 26.2079 16.5375 26.0899L17.8687 25.0833L20.06 23.4275L24.5084 20.0981L24.5207 20.0885C25.4541 19.3847 26.1334 18.3966 26.4563 17.2732C26.7791 16.1497 26.728 14.9517 26.3107 13.8597Z",
                fill: "#E24329"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M26.3105 13.8598L26.2817 13.7831C24.8671 14.0734 23.5342 14.6729 22.3785 15.5389L16.0032 20.3597L20.0626 23.4275L24.5109 20.0981L24.5232 20.0885C25.4561 19.3844 26.1349 18.3962 26.4573 17.2727C26.7796 16.1492 26.7281 14.9514 26.3105 13.8598Z",
                fill: "#FC6D26"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.9302 23.4277L14.1215 25.0835L15.4527 26.0901C15.6089 26.2081 15.7993 26.2719 15.995 26.2719C16.1908 26.2719 16.3812 26.2081 16.5374 26.0901L17.8686 25.0835L20.0599 23.4277L16.0005 20.3599L11.9302 23.4277Z",
                fill: "#FCA326"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.62123 15.5387C8.46595 14.6732 7.13347 14.0741 5.71935 13.7843L5.68922 13.8596C5.2714 14.9516 5.21993 16.1498 5.54256 17.2736C5.86519 18.3973 6.54443 19.3857 7.47787 20.0898L7.48882 20.098L7.51348 20.1172L11.9303 23.4274L15.9924 20.3596L9.62123 15.5387Z",
                fill: "#FC6D26"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M34.4996 16.435L34.4591 16.3272L30.3761 5.6767C30.2935 5.46758 30.1464 5.29018 29.9562 5.17018C29.8144 5.07934 29.6532 5.02302 29.4856 5.00571C29.318 4.9884 29.1487 5.01059 28.9912 5.07051C28.8337 5.13042 28.6925 5.22639 28.5788 5.35073C28.4651 5.47506 28.3821 5.6243 28.3365 5.78648L25.5805 14.2241H14.4196L11.6636 5.78648C11.6176 5.62454 11.5345 5.47558 11.4207 5.35149C11.307 5.22739 11.1658 5.13159 11.0085 5.07172C10.8511 5.01186 10.682 4.98958 10.5145 5.00668C10.347 5.02377 10.1859 5.07976 10.0439 5.17018C9.85372 5.29018 9.70667 5.46758 9.62403 5.6767L5.54295 16.3291L5.50058 16.435C4.91302 17.9706 4.84064 19.6556 5.29434 21.2359C5.74803 22.8162 6.70322 24.2061 8.01587 25.1962L8.03127 25.2077L8.06594 25.2347L14.2771 29.8897L17.3586 32.2182L19.2307 33.6337C19.4503 33.7997 19.7181 33.8894 19.9933 33.8894C20.2686 33.8894 20.5364 33.7997 20.756 33.6337L22.628 32.2182L25.7095 29.8897L31.965 25.2077L31.9823 25.1942C33.2949 24.2046 34.2502 22.8151 34.7042 21.2352C35.1583 19.6553 35.0864 17.9706 34.4996 16.435Z",
                fill: "#E24329"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M34.4996 16.4351L34.4591 16.3272C32.4698 16.7354 30.5954 17.5786 28.9702 18.7963L20.0049 25.5756L25.7134 29.8897L31.9689 25.2077L31.9862 25.1943C33.2981 24.2041 34.2526 22.8144 34.706 21.2345C35.1593 19.6546 35.0868 17.9702 34.4996 16.4351Z",
                fill: "#FC6D26"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.2771 29.8897L17.3586 32.2182L19.2306 33.6337C19.4503 33.7996 19.718 33.8894 19.9933 33.8894C20.2686 33.8894 20.5363 33.7996 20.756 33.6337L22.628 32.2182L25.7095 29.8897L20.001 25.5756L14.2771 29.8897Z",
                fill: "#FCA326"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.03 18.7963C9.40535 17.5792 7.53156 16.7367 5.54295 16.3291L5.50058 16.4351C4.91302 17.9706 4.84064 19.6556 5.29434 21.2359C5.74803 22.8162 6.70322 24.2062 8.01587 25.1962L8.03127 25.2077L8.06594 25.2347L14.2771 29.8897L19.9895 25.5756L11.03 18.7963Z",
                fill: "#FC6D26"
            })
        ]
    });
};

});


parcelRegister("hoqCT", function(module, exports) {

$parcel$export(module.exports, "gmailConfig", () => $6897f2334c0e7a05$export$c771ac380e225e02);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $69vQk = parcelRequire("69vQk");

var $h0X4l = parcelRequire("h0X4l");
const $6897f2334c0e7a05$export$c771ac380e225e02 = {
    displayName: 'Gmail',
    id: 'gmail',
    resourceType: 'gmail-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $69vQk.GmailIcon), 'Gmail', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $h0X4l.GmailSearchResultIcon), 'Gmail', 'large'),
    integrationAri: 'ari:cloud:platform::integration/google',
    requiresOauth: true,
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: [
                    (0, $idpYy.FEDERATED_GOOGLE_EMAIL_ENTITY_ATI)
                ],
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    isEnabled: ()=>true,
    isFederated: true
};

});
parcelRegister("69vQk", function(module, exports) {

$parcel$export(module.exports, "GmailIcon", () => $ff58957b80382e85$export$856bad9032bbc5ed);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $ff58957b80382e85$export$856bad9032bbc5ed = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M5.52273 17.625H7.90909V11.8295L4.5 9.27271V16.6023C4.5 17.1682 4.95852 17.625 5.52273 17.625Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M16.0908 17.625H18.4772C19.0431 17.625 19.4999 17.1665 19.4999 16.6023V9.27271L16.0908 11.8295",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M16.0908 7.3977V11.8295L19.4999 9.2727V7.90906C19.4999 6.64429 18.0562 5.92327 17.0454 6.68179",
                        fill: "#FBBC04"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.90918 11.8295V7.39771L12.0001 10.4659L16.091 7.39771V11.8295L12.0001 14.8977",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M4.5 7.90931V9.27294L7.90909 11.8298V7.39794L6.95455 6.68203C5.94205 5.92351 4.5 6.64453 4.5 7.90931Z",
                        fill: "#C5221F"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "37 37 115 80",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#4285f4",
                d: "M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#34a853",
                d: "M120 108h14c3.32 0 6-2.69 6-6V59l-20 15"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#fbbc04",
                d: "M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#ea4335",
                d: "M72 74V48l24 18 24-18v26L96 92"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#c5221f",
                d: "M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2"
            })
        ]
    });
};

});

parcelRegister("h0X4l", function(module, exports) {

$parcel$export(module.exports, "GmailSearchResultIcon", () => $67e458088a703c36$export$5abf8db8f9fa0429);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $67e458088a703c36$export$5abf8db8f9fa0429 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-67.5",
                y: "-71.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.508324",
                y: "0.508324",
                width: "30.9834",
                height: "30.9834",
                rx: "7.49168",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "1.01665"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.36364 23.8302H10.5455V16.1029L6 12.6938V22.4665C6 23.2211 6.61136 23.8302 7.36364 23.8302Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M21.4546 23.8302H24.6364C25.391 23.8302 26 23.2188 26 22.4665V12.6938L21.4546 16.1029",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M21.4546 10.1939V16.103L26 12.6939V10.8757C26 9.18931 24.075 8.22795 22.7273 9.23931",
                        fill: "#FBBC04"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M10.5454 16.1029V10.1938L16 14.2848L21.4545 10.1938V16.1029L16 20.1938",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M6 10.876V12.6942L10.5455 16.1033V10.1942L9.27273 9.23968C7.92273 8.22832 6 9.18968 6 10.876Z",
                        fill: "#C5221F"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_2230_19058)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.04545 31.25H11.8182V19.659L5 14.5454V29.2045C5 30.3363 5.91705 31.25 7.04545 31.25Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M28.1818 31.25H32.9546C34.0864 31.25 35 30.3329 35 29.2045V14.5454L28.1818 19.659",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M28.1818 10.7955V19.6591L35 14.5455V11.8182C35 9.28864 32.1125 7.8466 30.0909 9.36364",
                        fill: "#FBBC04"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M11.8182 19.659V10.7954L20 16.9318L28.1818 10.7954V19.659L20 25.7954",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M5 11.8182V14.5455L11.8182 19.6591V10.7955L9.90909 9.36364C7.88409 7.8466 5 9.28864 5 11.8182Z",
                        fill: "#C5221F"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_2230_19058",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "30",
                        height: "22.5",
                        fill: "white",
                        transform: "translate(5 8.75)"
                    })
                })
            })
        ]
    });
};

});


parcelRegister("4bMCY", function(module, exports) {

$parcel$export(module.exports, "googleDriveConfig", () => $6f79a547f5811124$export$6634ddcb22ed69a);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $lHRpG = parcelRequire("lHRpG");

var $519nT = parcelRequire("519nT");
const $6f79a547f5811124$export$6634ddcb22ed69a = {
    displayName: 'Google Drive',
    id: 'drive',
    resourceType: 'google-drive-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $lHRpG.GoogleDriveIcon), 'Google Drive', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $519nT.GoogleDriveSearchResultIcon), 'Google Drive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/google',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Presentation,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("lHRpG", function(module, exports) {

$parcel$export(module.exports, "GoogleDriveIcon", () => $068e81d162c29380$export$e16bd899bb4eebf9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $068e81d162c29380$export$e16bd899bb4eebf9 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-587.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M5.20962 17.0782L5.91523 18.2907C6.06186 18.546 6.27262 18.7466 6.52005 18.8925L9.04009 14.5529H4C4 14.8355 4.07331 15.1181 4.21993 15.3734L5.20962 17.0782Z",
                        fill: "#0066DA"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12 9.44751L9.47995 5.10791C9.23253 5.25378 9.02176 5.45435 8.87514 5.70962L4.21993 13.7324C4.07601 13.9822 4.00019 14.265 4 14.5529H9.04009L12 9.44751Z",
                        fill: "#00AC47"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M17.4799 18.8925C17.7273 18.7466 17.9381 18.546 18.0847 18.2907L18.3779 17.7893L19.78 15.3734C19.9266 15.1181 19.9999 14.8355 19.9999 14.5529H14.9595L16.032 16.6497L17.4799 18.8925Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12 9.4475L14.5201 5.1079C14.2726 4.96203 13.9886 4.8891 13.6953 4.8891H10.3047C10.0115 4.8891 9.7274 4.97115 9.47998 5.1079L12 9.4475Z",
                        fill: "#00832D"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.9594 14.5529H9.03958L6.51953 18.8925C6.76695 19.0383 7.05103 19.1113 7.34427 19.1113H16.6547C16.9479 19.1113 17.232 19.0292 17.4794 18.8925L14.9594 14.5529Z",
                        fill: "#2684FC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M17.4525 9.72101L15.1249 5.70962C14.9782 5.45435 14.7675 5.25378 14.52 5.10791L12 9.44751L14.9599 14.5529H19.9908C19.9908 14.2703 19.9175 13.9877 19.7709 13.7324L17.4525 9.72101Z",
                        fill: "#FFBA00"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_271_181643)",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                    clipPath: "url(#clip1_271_181643)",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            x: "2",
                            y: "2",
                            width: "20",
                            height: "20",
                            rx: "0.75",
                            fill: "white",
                            fillOpacity: "0.01"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                            clipPath: "url(#clip2_271_181643)",
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M3.51203 18.5459L4.39404 20.1089C4.57732 20.438 4.84078 20.6965 5.15006 20.8845L8.30011 15.2905H2C2 15.6548 2.09164 16.0192 2.27491 16.3482L3.51203 18.5459Z",
                                    fill: "#0066DA"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M12 8.70925L8.84994 3.11523C8.54066 3.30327 8.27721 3.56182 8.09393 3.89088L2.27491 14.2328C2.09501 14.5547 2.00024 14.9193 2 15.2904H8.30011L12 8.70925Z",
                                    fill: "#00AC47"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M18.85 20.8845C19.1593 20.6965 19.4227 20.438 19.606 20.1089L19.9725 19.4625L21.7251 16.3482C21.9084 16.0192 22 15.6548 22 15.2905H15.6995L17.0401 17.9935L18.85 20.8845Z",
                                    fill: "#EA4335"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M12.0002 8.70932L15.1502 3.1153C14.8409 2.92727 14.4858 2.83325 14.1193 2.83325H9.88103C9.51447 2.83325 9.15938 2.93902 8.8501 3.1153L12.0002 8.70932Z",
                                    fill: "#00832D"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M15.6997 15.2905H8.29996L5.1499 20.8845C5.45918 21.0726 5.81428 21.1666 6.18083 21.1666H17.8189C18.1854 21.1666 18.5405 21.0608 18.8498 20.8845L15.6997 15.2905Z",
                                    fill: "#2684FC"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M18.8156 9.06182L15.9061 3.89088C15.7228 3.56182 15.4593 3.30327 15.1501 3.11523L12 8.70925L15.6999 15.2904H21.9885C21.9885 14.9261 21.8969 14.5618 21.7136 14.2328L18.8156 9.06182Z",
                                    fill: "#FFBA00"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_271_181643",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "24",
                            height: "24",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip1_271_181643",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            x: "2",
                            y: "2",
                            width: "20",
                            height: "20",
                            rx: "0.75",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip2_271_181643",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "20",
                            height: "18.3333",
                            fill: "white",
                            transform: "translate(2 2.83325)"
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("519nT", function(module, exports) {

$parcel$export(module.exports, "GoogleDriveSearchResultIcon", () => $3be53feab8966d09$export$99050685a064f8e);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $3be53feab8966d09$export$99050685a064f8e = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-115.5",
                y: "-23.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.508324",
                y: "0.508324",
                width: "30.9834",
                height: "30.9834",
                rx: "7.49168",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "1.01665"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M6.94608 22.7709L7.8869 24.3877C8.08239 24.728 8.36342 24.9955 8.69331 25.1899L12.0534 19.4038H5.33325C5.33325 19.7806 5.431 20.1575 5.62649 20.4978L6.94608 22.7709Z",
                        fill: "#0066DA"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.9999 12.5966L12.6399 6.81049C12.31 7.00498 12.0289 7.2724 11.8334 7.61276L5.62649 18.3098C5.43459 18.6428 5.33351 19.02 5.33325 19.4038H12.0534L15.9999 12.5966Z",
                        fill: "#00AC47"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M23.3066 25.1899C23.6365 24.9955 23.9175 24.728 24.113 24.3877L24.504 23.7191L26.3734 20.4978C26.5689 20.1575 26.6667 19.7806 26.6667 19.4038H19.946L21.3761 22.1996L23.3066 25.1899Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M16 12.5967L19.36 6.81054C19.0301 6.61604 18.6513 6.5188 18.2604 6.5188H13.7395C13.3486 6.5188 12.9698 6.6282 12.6399 6.81054L16 12.5967Z",
                        fill: "#00832D"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M19.9463 19.4038H12.0532L8.69312 25.1899C9.02301 25.3844 9.40178 25.4817 9.79277 25.4817H22.2067C22.5977 25.4817 22.9764 25.3723 23.3063 25.1899L19.9463 19.4038Z",
                        fill: "#2684FC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M23.2697 12.9613L20.1662 7.61276C19.9707 7.2724 19.6897 7.00498 19.3598 6.81049L15.9998 12.5966L19.9463 19.4038H26.6542C26.6542 19.027 26.5565 18.6502 26.361 18.3098L23.2697 12.9613Z",
                        fill: "#FFBA00"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_2230_18945)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.26804 29.8189L8.59107 32.1635C8.86598 32.6571 9.26117 33.0449 9.72509 33.3269L14.4502 24.9359H5C5 25.4824 5.13746 26.0288 5.41237 26.5224L7.26804 29.8189Z",
                        fill: "#0066DA"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M20 15.0641L15.2749 6.6731C14.811 6.95515 14.4158 7.34297 14.1409 7.83656L5.41237 23.3494C5.14251 23.8323 5.00036 24.3792 5 24.9359H14.4502L20 15.0641Z",
                        fill: "#00AC47"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M30.2751 33.3269C30.739 33.0449 31.1342 32.6571 31.4091 32.1635L31.9589 31.1939L34.5878 26.5224C34.8627 26.0288 35.0002 25.4824 35.0002 24.9359H25.5493L27.5603 28.9904L30.2751 33.3269Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M20.0001 15.0641L24.7252 6.67308C24.2613 6.39103 23.7286 6.25 23.1788 6.25H16.8214C16.2716 6.25 15.7389 6.40865 15.275 6.67308L20.0001 15.0641Z",
                        fill: "#00832D"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M25.5497 24.9359H14.4501L9.72498 33.3269C10.1889 33.609 10.7215 33.75 11.2714 33.75H28.7284C29.2782 33.75 29.8109 33.5913 30.2748 33.3269L25.5497 24.9359Z",
                        fill: "#2684FC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M30.2234 15.593L25.8591 7.83656C25.5842 7.34297 25.189 6.95515 24.7251 6.6731L20 15.0641L25.5498 24.9359H34.9828C34.9828 24.3894 34.8454 23.843 34.5704 23.3494L30.2234 15.593Z",
                        fill: "#FFBA00"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_2230_18945",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "30",
                        height: "27.5",
                        fill: "white",
                        transform: "translate(5 6.25)"
                    })
                })
            })
        ]
    });
};

});


parcelRegister("7KevC", function(module, exports) {

$parcel$export(module.exports, "googleCalendarConfig", () => $d55193f0e88e1ac8$export$be326f2f9a08a3a4);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $hYjTw = parcelRequire("hYjTw");

var $ijPzY = parcelRequire("ijPzY");
const $d55193f0e88e1ac8$export$be326f2f9a08a3a4 = {
    displayName: 'Google Calendar',
    id: 'google-calendar',
    resourceType: 'google-calendar-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $hYjTw.GoogleCalendarIcon), 'Google Calendar', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $ijPzY.GoogleCalendarSearchResultIcon), 'Google Calendar', 'large'),
    integrationAri: 'ari:cloud:platform::integration/google',
    requiresOauth: true,
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    isEnabled: ()=>true
};

});
parcelRegister("hYjTw", function(module, exports) {

$parcel$export(module.exports, "GoogleCalendarIcon", () => $61ad3ffe7b1940bf$export$5d128e0a6ffc0558);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $61ad3ffe7b1940bf$export$5d128e0a6ffc0558 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-124.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.8208 8.17936L12.3822 7.7973L8.17949 8.17936L7.79736 12.0001L8.17942 15.8207L12.0001 16.2983L15.8208 15.8207L16.2029 11.9046L15.8208 8.17936Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M9.74654 14.1071C9.46096 13.9142 9.26322 13.6324 9.15527 13.2599L9.81819 12.9867C9.87837 13.216 9.98341 13.3936 10.1334 13.5197C10.2824 13.6458 10.4639 13.7079 10.6759 13.7079C10.8928 13.7079 11.079 13.642 11.2347 13.5101C11.3903 13.3783 11.4687 13.2102 11.4687 13.0068C11.4687 12.7986 11.3866 12.6285 11.2223 12.4967C11.058 12.365 10.8517 12.299 10.6052 12.299H10.2222V11.6428H10.566C10.7781 11.6428 10.9567 11.5856 11.1019 11.4709C11.2471 11.3563 11.3197 11.1997 11.3197 11C11.3197 10.8224 11.2547 10.681 11.1249 10.575C10.995 10.469 10.8306 10.4155 10.631 10.4155C10.4362 10.4155 10.2814 10.4671 10.1668 10.5712C10.0522 10.6753 9.96904 10.8033 9.91655 10.9542L9.26039 10.681C9.34728 10.4346 9.50684 10.2168 9.74081 10.0287C9.97484 9.8405 10.2738 9.74591 10.6367 9.74591C10.9051 9.74591 11.1468 9.79752 11.3608 9.90162C11.5747 10.0057 11.7428 10.15 11.8641 10.3333C11.9854 10.5176 12.0456 10.724 12.0456 10.9532C12.0456 11.1872 11.9893 11.3849 11.8766 11.5473C11.7638 11.7097 11.6253 11.8338 11.461 11.9208V11.9599C11.6779 12.0507 11.8546 12.1892 11.994 12.3754C12.1325 12.5617 12.2022 12.7843 12.2022 13.0441C12.2022 13.3039 12.1363 13.536 12.0045 13.7394C11.8726 13.9429 11.6902 14.1034 11.4591 14.2199C11.227 14.3364 10.9662 14.3956 10.6768 14.3956C10.3416 14.3966 10.0321 14.3001 9.74654 14.1071Z",
                        fill: "#1A73E8"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M13.8145 10.8175L13.0905 11.3438L12.7266 10.7917L14.0323 9.84991H14.5328V14.2924H13.8145V10.8175Z",
                        fill: "#1A73E8"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.8208 19.2592L19.2593 15.8206L17.54 15.0565L15.8208 15.8206L15.0566 17.5399L15.8208 19.2592Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.41504 17.54L8.17915 19.2593H15.8205V15.8207H8.17915L7.41504 17.54Z",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M5.88689 4.74078C5.25366 4.74078 4.74072 5.25372 4.74072 5.88695V15.8207L6.46001 16.5848L8.17929 15.8207V8.17935H15.8206L16.5847 6.46007L15.8207 4.74078H5.88689Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M4.74072 15.8207V18.1131C4.74072 18.7464 5.25366 19.2593 5.88689 19.2593H8.17929V15.8207H4.74072Z",
                        fill: "#188038"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.8203 8.17945V15.8208H19.2589V8.17945L17.5396 7.41534L15.8203 8.17945Z",
                        fill: "#FBBC04"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M19.2589 8.17929V5.88689C19.2589 5.25359 18.7459 4.74072 18.1127 4.74072H15.8203V8.17929H19.2589Z",
                        fill: "#1967D2"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        "aria-label": "Google Calendar",
        viewBox: "50 50 410 410 ",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#4285f4",
                d: "M100 340h74V174h166v-74H137q-37 0-37 35"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#1967d2",
                d: "M338 100v76h74v-41q0-35-35-35"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#fbbc04",
                d: "M338 174h74v164h-74"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#188038",
                d: "M100 338v39q0 35 35 35h41v-74"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#34a853",
                d: "M174 338h164v74H174"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#ea4335",
                d: "M338 412v-74h74"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "none",
                stroke: "#4285f4",
                strokeLinejoin: "bevel",
                strokeWidth: 15,
                d: "M204 229a25 22 1 1 1 25 27h-9 9a25 22 1 1 1-25 27m66-52 27-19h4v-7 103"
            })
        ]
    });
};
var $61ad3ffe7b1940bf$export$2e2bcd8739ae039 = $61ad3ffe7b1940bf$export$5d128e0a6ffc0558;

});

parcelRegister("ijPzY", function(module, exports) {

$parcel$export(module.exports, "GoogleCalendarSearchResultIcon", () => $1c53c24dc9ffba88$export$aed283b8fb73a449);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $1c53c24dc9ffba88$export$aed283b8fb73a449 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-19.5",
                y: "-119.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.508324",
                y: "0.508324",
                width: "30.9834",
                height: "30.9834",
                rx: "7.49168",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "1.01665"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M21.0942 10.8996L16.5094 10.3902L10.9057 10.8996L10.3962 15.9939L10.9056 21.0881L15.9999 21.7249L21.0942 21.0881L21.6036 15.8666L21.0942 10.8996Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12.9956 18.8033C12.6149 18.546 12.3512 18.1704 12.2073 17.6737L13.0912 17.3094C13.1714 17.6151 13.3115 17.8519 13.5114 18.0201C13.7101 18.1882 13.9521 18.271 14.2348 18.271C14.5239 18.271 14.7723 18.1831 14.9798 18.0073C15.1873 17.8315 15.2919 17.6074 15.2919 17.3362C15.2919 17.0586 15.1823 16.8318 14.9633 16.6561C14.7442 16.4804 14.4692 16.3925 14.1406 16.3925H13.6299V15.5176H14.0883C14.371 15.5176 14.6092 15.4412 14.8028 15.2884C14.9964 15.1355 15.0932 14.9267 15.0932 14.6605C15.0932 14.4236 15.0065 14.2351 14.8334 14.0938C14.6602 13.9525 14.4411 13.8811 14.1749 13.8811C13.9151 13.8811 13.7088 13.95 13.5559 14.0887C13.4031 14.2275 13.2923 14.3982 13.2223 14.5994L12.3474 14.2352C12.4633 13.9066 12.676 13.6162 12.988 13.3653C13.3 13.1145 13.6986 12.9883 14.1826 12.9883C14.5404 12.9883 14.8626 13.0572 15.148 13.196C15.4332 13.3348 15.6574 13.5271 15.8191 13.7716C15.9808 14.0173 16.0611 14.2925 16.0611 14.5981C16.0611 14.9101 15.986 15.1737 15.8356 15.3902C15.6853 15.6067 15.5007 15.7722 15.2816 15.8882V15.9403C15.5707 16.0613 15.8063 16.246 15.9923 16.4944C16.1769 16.7427 16.2698 17.0395 16.2698 17.3859C16.2698 17.7323 16.182 18.0418 16.0062 18.3131C15.8304 18.5844 15.5872 18.7983 15.279 18.9536C14.9696 19.109 14.6219 19.1879 14.236 19.1879C13.789 19.1892 13.3764 19.0606 12.9956 18.8033Z",
                        fill: "#1A73E8"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4191 14.4171L17.4537 15.1189L16.9685 14.3828L18.7095 13.127H19.3768V19.0503H18.4191V14.4171Z",
                        fill: "#1A73E8"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M21.0943 25.6728L25.679 21.088L23.3866 20.0692L21.0943 21.088L20.0754 23.3804L21.0943 25.6728Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M9.88672 23.3805L10.9055 25.6729H21.094V21.0881H10.9055L9.88672 23.3805Z",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.84902 6.31488C7.00472 6.31488 6.3208 6.9988 6.3208 7.8431V21.0881L8.61318 22.1069L10.9056 21.0881V10.8996H21.094L22.1128 8.60726L21.0941 6.31488H7.84902Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M6.3208 21.0881V24.1447C6.3208 24.9891 7.00472 25.6729 7.84902 25.6729H10.9056V21.0881H6.3208Z",
                        fill: "#188038"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M21.0938 10.8997V21.0882H25.6785V10.8997L23.3861 9.88092L21.0938 10.8997Z",
                        fill: "#FBBC04"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M25.6785 10.8996V7.84304C25.6785 6.99864 24.9946 6.31482 24.1503 6.31482H21.0938V10.8996H25.6785Z",
                        fill: "#1967D2"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_2230_18795)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M27.8948 12.1052L20.7896 11.3158L12.1054 12.1052L11.3158 20L12.1052 27.8948L20 28.8817L27.8948 27.8948L28.6843 19.8028L27.8948 12.1052Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.3441 24.3539C14.754 23.9552 14.3454 23.373 14.1224 22.6032L15.4922 22.0388C15.6165 22.5125 15.8336 22.8795 16.1435 23.1401C16.4514 23.4006 16.8264 23.5289 17.2646 23.5289C17.7126 23.5289 18.0975 23.3927 18.4191 23.1203C18.7407 22.8479 18.9027 22.5005 18.9027 22.0802C18.9027 21.65 18.7329 21.2985 18.3935 21.0263C18.054 20.754 17.6277 20.6177 17.1185 20.6177H16.3271V19.2618H17.0375C17.4756 19.2618 17.8448 19.1435 18.1448 18.9066C18.4448 18.6698 18.5948 18.3461 18.5948 17.9336C18.5948 17.5665 18.4605 17.2743 18.1922 17.0553C17.9238 16.8363 17.5842 16.7258 17.1717 16.7258C16.7691 16.7258 16.4493 16.8324 16.2125 17.0475C15.9756 17.2626 15.8039 17.5271 15.6954 17.8389L14.3396 17.2745C14.5191 16.7652 14.8488 16.3152 15.3323 15.9264C15.8159 15.5376 16.4336 15.3422 17.1836 15.3422C17.7381 15.3422 18.2375 15.4488 18.6797 15.6639C19.1217 15.879 19.4691 16.1771 19.7198 16.556C19.9704 16.9368 20.0948 17.3633 20.0948 17.8368C20.0948 18.3204 19.9784 18.7289 19.7454 19.0644C19.5125 19.4 19.2263 19.6565 18.8868 19.8362V19.917C19.3349 20.1045 19.7 20.3907 19.9881 20.7756C20.2743 21.1605 20.4183 21.6204 20.4183 22.1573C20.4183 22.6941 20.2821 23.1737 20.0097 23.5941C19.7373 24.0146 19.3604 24.3461 18.8828 24.5868C18.4032 24.8276 17.8644 24.95 17.2664 24.95C16.5737 24.9519 15.9342 24.7526 15.3441 24.3539Z",
                        fill: "#1A73E8"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M23.7495 17.5566L22.2534 18.6441L21.5015 17.5034L24.1995 15.5573H25.2338V24.7368H23.7495V17.5566Z",
                        fill: "#1A73E8"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M27.8948 35L35 27.8948L31.4474 26.3159L27.8948 27.8948L26.3159 31.4474L27.8948 35Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M10.5262 31.4474L12.1051 35H27.8946V27.8948H12.1051L10.5262 31.4474Z",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.36835 5C6.0599 5 5 6.0599 5 7.36835V27.8946L8.5526 29.4736L12.1052 27.8946V12.1052H27.8946L29.4736 8.5526L27.8948 5H7.36835Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M5 27.8948V32.6317C5 33.9403 6.0599 35 7.36835 35H12.1052V27.8948H5Z",
                        fill: "#188038"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M27.8943 12.1053V27.8948H34.9995V12.1053L31.4469 10.5264L27.8943 12.1053Z",
                        fill: "#FBBC04"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M34.9995 12.1052V7.36835C34.9995 6.05975 33.9396 5 32.6311 5H27.8943V12.1052H34.9995Z",
                        fill: "#1967D2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_2230_18795",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "30",
                        height: "30",
                        fill: "white",
                        transform: "translate(5 5)"
                    })
                })
            })
        ]
    });
};

});


parcelRegister("i3Awy", function(module, exports) {

$parcel$export(module.exports, "hubSpotConfig", () => $6501c29a91901a05$export$ba5f4c654d743419);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $iygo1 = parcelRequire("iygo1");

var $cYryu = parcelRequire("cYryu");
const $6501c29a91901a05$export$ba5f4c654d743419 = {
    displayName: 'HubSpot',
    id: 'hubspot',
    resourceType: 'hubspot-connector',
    icon: (0, $9yyKc.RovoLogoFromGlyph)((0, $iygo1.HubSpotFilterIcon), 'HubSpot'),
    searchResultIcon: (0, $9yyKc.RovoLogoFromGlyph)((0, $cYryu.HubSpotIcon), 'HubSpot'),
    integrationAri: 'ari:cloud:platform::integration/hubspot',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch',
        'lastUpdatedBy',
        'createdBy',
        'owner'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("iygo1", function(module, exports) {

$parcel$export(module.exports, "HubSpotFilterIcon", () => $d8abffbc9011bd03$export$bee6964e6c60da93);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $d8abffbc9011bd03$export$bee6964e6c60da93 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-587.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#FF5C35"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.2949 7.36118V9.2655C18.0986 9.53156 19.5395 10.8388 19.9091 12.5445C20.2788 14.2502 19.4994 15.9955 17.9542 16.9226C16.409 17.8496 14.4229 17.7632 12.9725 16.7059L11.3506 18.2537C11.3927 18.3793 11.4149 18.5101 11.4169 18.6419C11.4169 19.1911 11.0701 19.6864 10.5383 19.8966C10.0065 20.1068 9.39443 19.9906 8.98742 19.6022C8.5804 19.2138 8.45864 18.6296 8.67892 18.1221C8.8992 17.6147 9.41812 17.2837 9.99372 17.2837C10.1318 17.2857 10.2689 17.307 10.4005 17.3469L12.0399 15.7824C11.0063 14.3791 10.9796 12.5146 11.9727 11.0849L6.58545 7.08265C6.32553 7.22716 6.03031 7.30382 5.72949 7.30488C4.77318 7.30379 3.99886 6.56308 4 5.65047C4.00115 4.73785 4.77732 3.99891 5.73363 4C6.68995 4.00109 7.46428 4.7418 7.46314 5.65442C7.4609 5.79367 7.44004 5.93209 7.40104 6.06629L12.8803 10.1347C13.4781 9.67598 14.1922 9.37614 14.9504 9.2655V7.36118C14.4121 7.12126 14.0671 6.60659 14.0644 6.03963V5.99518C14.0667 5.18711 14.7525 4.53257 15.5993 4.5304H15.6459C16.4927 4.53257 17.1785 5.18711 17.1808 5.99518V6.03963C17.1782 6.60659 16.8331 7.12126 16.2949 7.36118ZM13.3789 13.3881C13.3789 14.5707 14.3835 15.5295 15.6228 15.5295C16.8621 15.5295 17.8667 14.5707 17.8667 13.3881C17.8667 12.2055 16.8621 11.2467 15.6228 11.2467C14.3835 11.2467 13.3789 12.2055 13.3789 13.3881Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.2949 7.36118V9.2655C18.0986 9.53156 19.5395 10.8388 19.9091 12.5445C20.2788 14.2502 19.4994 15.9955 17.9542 16.9226C16.409 17.8496 14.4229 17.7632 12.9725 16.7059L11.3506 18.2537C11.3927 18.3793 11.4149 18.5101 11.4169 18.6419C11.4169 19.1911 11.0701 19.6864 10.5383 19.8966C10.0065 20.1068 9.39443 19.9906 8.98742 19.6022C8.5804 19.2138 8.45864 18.6296 8.67892 18.1221C8.8992 17.6147 9.41812 17.2837 9.99372 17.2837C10.1318 17.2857 10.2689 17.307 10.4005 17.3469L12.0399 15.7824C11.0063 14.3791 10.9796 12.5146 11.9727 11.0849L6.58545 7.08265C6.32553 7.22716 6.03031 7.30382 5.72949 7.30488C4.77318 7.30379 3.99886 6.56308 4 5.65047C4.00115 4.73785 4.77732 3.99891 5.73363 4C6.68995 4.00109 7.46428 4.7418 7.46314 5.65442C7.4609 5.79367 7.44004 5.93209 7.40104 6.06629L12.8803 10.1347C13.4781 9.67598 14.1922 9.37614 14.9504 9.2655V7.36118C14.4121 7.12126 14.0671 6.60659 14.0644 6.03963V5.99518C14.0667 5.18711 14.7525 4.53257 15.5993 4.5304H15.6459C16.4927 4.53257 17.1785 5.18711 17.1808 5.99518V6.03963C17.1782 6.60659 16.8331 7.12126 16.2949 7.36118ZM13.3789 13.3881C13.3789 14.5707 14.3835 15.5295 15.6228 15.5295C16.8621 15.5295 17.8667 14.5707 17.8667 13.3881C17.8667 12.2055 16.8621 11.2467 15.6228 11.2467C14.3835 11.2467 13.3789 12.2055 13.3789 13.3881Z",
            fill: "#FF5C35"
        })
    });
};

});

parcelRegister("cYryu", function(module, exports) {

$parcel$export(module.exports, "HubSpotIcon", () => $ddf40ae0a235f4dc$export$c9a6a66ee7acc43a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $ddf40ae0a235f4dc$export$c9a6a66ee7acc43a = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-115.5",
                y: "-406.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#FF5C35"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.7267 9.81495V12.354C24.1316 12.7088 26.0529 14.4518 26.5457 16.726C27.0386 19.0003 25.9994 21.3274 23.9391 22.5635C21.8788 23.7995 19.2307 23.6843 17.2968 22.2746L15.1343 24.3383C15.1904 24.5057 15.2201 24.6801 15.2227 24.8558C15.2227 25.5882 14.7603 26.2486 14.0513 26.5288C13.3422 26.8091 12.5261 26.6542 11.9834 26.1363C11.4407 25.6184 11.2784 24.8395 11.5721 24.1629C11.8658 23.4863 12.5577 23.045 13.3251 23.045C13.5093 23.0476 13.692 23.076 13.8675 23.1293L16.0534 21.0432C14.6752 19.1722 14.6396 16.6862 15.9637 14.7799L8.78076 9.44358C8.4342 9.63626 8.04058 9.73846 7.63949 9.73989C6.3644 9.73843 5.33197 8.75082 5.3335 7.53399C5.33502 6.31718 6.36992 5.33192 7.64501 5.33338C8.9201 5.33483 9.95253 6.32244 9.95101 7.53927C9.94803 7.72494 9.92021 7.90949 9.86821 8.08843L17.1739 13.513C17.9709 12.9014 18.9231 12.5016 19.934 12.354V9.81495C19.2163 9.49505 18.7563 8.80883 18.7527 8.05287V7.99361C18.7557 6.91618 19.6702 6.04347 20.7993 6.04058H20.8613C21.9904 6.04347 22.9049 6.91618 22.9079 7.99361V8.05287C22.9044 8.80883 22.4444 9.49505 21.7267 9.81495ZM17.8387 17.8509C17.8387 19.4277 19.1782 20.706 20.8306 20.706C22.483 20.706 23.8225 19.4277 23.8225 17.8509C23.8225 16.274 22.483 14.9957 20.8306 14.9957C19.1782 14.9957 17.8387 16.274 17.8387 17.8509Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.0529 11.3022V14.8728C31.4349 15.3717 34.1366 17.8227 34.8296 21.0209C35.5228 24.2191 34.0614 27.4916 31.1641 29.2299C28.2669 30.968 24.543 30.806 21.8234 28.8236L18.7824 31.7256C18.8613 31.9611 18.903 32.2064 18.9066 32.4535C18.9066 33.4834 18.2565 34.412 17.2594 34.8061C16.2623 35.2002 15.1146 34.9824 14.3514 34.2541C13.5883 33.5259 13.36 32.4305 13.773 31.479C14.186 30.5275 15.159 29.907 16.2382 29.907C16.4972 29.9106 16.7541 29.9506 17.0009 30.0255L20.0749 27.092C18.1368 24.4609 18.0868 20.9649 19.9488 18.2841L9.84772 10.78C9.36036 11.0509 8.80684 11.1947 8.2428 11.1967C6.44971 11.1946 4.99786 9.80578 5 8.09462C5.00215 6.38347 6.45748 4.99796 8.25056 5C10.0437 5.00205 11.4955 6.39087 11.4934 8.10204C11.4892 8.36314 11.4501 8.62266 11.3769 8.8743L21.6506 16.5025C22.7714 15.6425 24.1104 15.0803 25.532 14.8728V11.3022C24.5226 10.8524 23.8758 9.88736 23.8708 8.8243V8.74096C23.875 7.22582 25.161 5.99857 26.7488 5.9945H26.836C28.4238 5.99857 29.7098 7.22582 29.714 8.74096V8.8243C29.7091 9.88736 29.0621 10.8524 28.0529 11.3022ZM22.5855 22.6027C22.5855 24.8201 24.4691 26.6177 26.7928 26.6177C29.1165 26.6177 31.0001 24.8201 31.0001 22.6027C31.0001 20.3852 29.1165 18.5876 26.7928 18.5876C24.4691 18.5876 22.5855 20.3852 22.5855 22.6027Z",
            fill: "#FF5C35"
        })
    });
};

});


parcelRegister("3cOLO", function(module, exports) {

$parcel$export(module.exports, "jiraDCConfig", () => $266323abfb0e99be$export$7441620f71b01d27);

var $lAFHW = parcelRequire("lAFHW");

var $g1L9J = parcelRequire("g1L9J");

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $fl27B = parcelRequire("fl27B");
const $266323abfb0e99be$export$7441620f71b01d27 = {
    displayName: 'Jira Data Center',
    id: 'jira-dc',
    resourceType: 'jira-dc-connector',
    icon: (0, $9yyKc.RovoLogoFromLogo)((0, $9yyKc.getLogoVersion)((0, $g1L9J.JiraIcon), (0, $lAFHW.JiraIcon)), 'Jira Data Center'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $fl27B.JiraSearchResultIcon), 'Jira Data Center', 'large'),
    integrationAri: 'ari:cloud:platform::integration/jira-dc',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Project,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Project
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Issue,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Issue
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'project',
        'assignee'
    ],
    requiresOauth: true,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};

});
parcelRegister("fl27B", function(module, exports) {

$parcel$export(module.exports, "JiraSearchResultIcon", () => $8beafb504c666551$export$f68d29dbb4f2da82);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $8beafb504c666551$export$f68d29dbb4f2da82 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_2230_18716)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                    clipPath: "url(#clip1_2230_18716)",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                        clipPath: "url(#clip2_2230_18716)",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M13.7923 27.2286H11.0183C6.83464 27.2286 3.83331 24.666 3.83331 20.9137H18.749C19.5221 20.9137 20.0223 21.4628 20.0223 22.2407V37.25C16.2934 37.25 13.7923 34.2299 13.7923 30.0199V27.2286ZM21.1592 19.7697H18.3852C14.2015 19.7697 11.2002 17.2529 11.2002 13.5006H26.1159C26.889 13.5006 27.4347 14.0039 27.4347 14.7819V29.7911C23.7058 29.7911 21.1592 26.771 21.1592 22.5611V19.7697ZM28.5715 12.3566H25.7976C21.6139 12.3566 18.6126 9.79401 18.6126 6.04169H33.5283C34.3014 6.04169 34.8016 6.59081 34.8016 7.32297V22.3323C31.0727 22.3323 28.5715 19.3121 28.5715 15.1022V12.3566Z",
                            fill: "#1868DB"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_2230_18716",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "40",
                            height: "40",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip1_2230_18716",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "40",
                            height: "40",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip2_2230_18716",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "30.9683",
                            height: "31.2083",
                            fill: "white",
                            transform: "translate(3.83331 6.04169)"
                        })
                    })
                ]
            })
        ]
    });

});


parcelRegister("a9AeJ", function(module, exports) {

$parcel$export(module.exports, "launchDarklyConfig", () => $e4be4a4ef13ff8c3$export$e45ddd51efe4cb0c);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $2C2BU = parcelRequire("2C2BU");

var $eTxga = parcelRequire("eTxga");
const $e4be4a4ef13ff8c3$export$e45ddd51efe4cb0c = {
    displayName: 'LaunchDarkly',
    id: 'launchdarkly',
    resourceType: 'smartlinks-connector-launchdarkly',
    icon: (0, $9yyKc.get3PLogo)((0, $2C2BU.LaunchDarklyIcon), 'LaunchDarkly', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $eTxga.LaunchDarklySearchResultIcon), 'LaunchDarkly', 'large'),
    integrationAri: 'ari:cloud:platform::integration/launchdarkly',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("2C2BU", function(module, exports) {

$parcel$export(module.exports, "LaunchDarklyIcon", () => $0c8cf6610d5ad1f2$export$68470e68dec0bc46);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $0c8cf6610d5ad1f2$export$68470e68dec0bc46 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-683.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.0232 12.0808C20.0002 12.2346 19.9148 12.3512 19.8075 12.4584C17.3508 14.9147 14.895 17.3719 12.4389 19.8288C12.4116 19.8561 12.3853 19.8845 12.3562 19.9098C12.2424 20.0088 12.113 20.0247 11.9781 19.9655C11.845 19.9072 11.7732 19.798 11.7632 19.6539C11.7574 19.5702 11.7891 19.4944 11.8388 19.4264C11.9362 19.2931 12.0329 19.1593 12.13 19.0257C12.7486 18.1738 13.3672 17.3218 13.9859 16.47C14.3904 15.913 14.795 15.3562 15.1995 14.7994C15.3066 14.6519 15.4141 14.5047 15.5208 14.357C15.5315 14.3423 15.5483 14.3295 15.5454 14.3065C15.5243 14.3004 15.5082 14.3131 15.4912 14.32C14.8996 14.5611 14.308 14.8024 13.7166 15.0438C13.2263 15.2439 12.7362 15.4442 12.246 15.6446C11.1843 16.0784 10.1224 16.5119 9.06106 16.9467C8.97552 16.9817 8.88978 17.0024 8.79819 16.9813C8.65305 16.9479 8.54691 16.8331 8.52155 16.684C8.49883 16.5505 8.56326 16.4093 8.68877 16.3339C8.9313 16.1881 9.17582 16.0455 9.41951 15.9016C10.289 15.3879 11.1584 14.8742 12.028 14.3607C12.7979 13.9061 13.568 13.4519 14.338 12.9974C14.3655 12.9812 14.3924 12.9642 14.4339 12.9389C14.3588 12.9323 14.2988 12.9253 14.2387 12.922C13.9713 12.9073 13.7038 12.894 13.4363 12.8793C13.2181 12.8673 13 12.8547 12.7819 12.8415C12.5296 12.8261 12.2774 12.8095 12.0251 12.7943C11.9225 12.788 11.8197 12.7846 11.717 12.7786C11.5224 12.7673 11.3279 12.7548 11.1333 12.7432C11.0542 12.7385 10.975 12.7358 10.8959 12.7303C10.7057 12.7172 10.515 12.711 10.3246 12.6999C10.0723 12.6852 9.82012 12.6679 9.56774 12.6531C9.48432 12.6482 9.40084 12.6449 9.31742 12.6397C9.0523 12.6232 8.78686 12.6112 8.52161 12.5966C8.29917 12.5844 8.07679 12.5711 7.85434 12.5583C7.62765 12.5453 7.40082 12.5335 7.17426 12.519C6.95188 12.5048 6.72956 12.4913 6.50699 12.4805C6.28229 12.4696 6.05785 12.4551 5.83328 12.4422C5.61083 12.4294 5.38845 12.4166 5.166 12.4038C4.94356 12.391 4.72111 12.3791 4.49873 12.3648C4.43675 12.3608 4.37431 12.3592 4.31284 12.3523C4.16358 12.3353 4.05918 12.256 4.00602 12.1135C3.99707 12.0894 3.99243 12.0637 3.97705 12.0422V11.9393C3.99733 11.9207 3.99932 11.8936 4.0091 11.8701C4.06504 11.736 4.16332 11.6549 4.30917 11.6409C4.4307 11.6293 4.5528 11.6239 4.67464 11.6167C4.89921 11.6034 5.12378 11.5908 5.34835 11.5778C5.5708 11.565 5.79318 11.5517 6.01569 11.5395C6.28312 11.5249 6.55069 11.513 6.818 11.4964C6.89929 11.4914 6.98058 11.4877 7.06188 11.483C7.24364 11.4725 7.42528 11.4591 7.60705 11.4487C7.79532 11.438 7.98384 11.432 8.17185 11.4184C8.25315 11.4125 8.33451 11.4106 8.4158 11.4056C8.60606 11.3938 8.79639 11.3816 8.98672 11.3705C9.08938 11.3644 9.19223 11.3612 9.2949 11.355C9.54721 11.3397 9.79945 11.3229 10.0518 11.3077C10.2741 11.2942 10.4967 11.282 10.7191 11.2693C10.9458 11.2563 11.1726 11.2433 11.3993 11.2303C11.6196 11.2176 11.8398 11.2048 12.0602 11.1922C12.2847 11.1792 12.5093 11.1658 12.7339 11.1535C13.0014 11.1389 13.2689 11.127 13.5362 11.1105C13.6175 11.1055 13.6988 11.1016 13.7801 11.0971C13.9812 11.0858 14.1821 11.0732 14.3832 11.0609C14.3985 11.0599 14.4156 11.0646 14.4308 11.0529C14.4137 11.033 14.3934 11.0251 14.3751 11.0143C13.5146 10.5062 12.654 9.99844 11.7936 9.49047C10.898 8.96178 10.0024 8.43308 9.10689 7.90432C8.96837 7.82258 8.82909 7.74206 8.69192 7.65813C8.56776 7.58211 8.50449 7.44392 8.52374 7.31442C8.55817 7.0829 8.80701 6.93975 9.02933 7.03359C9.54483 7.25121 10.0641 7.45969 10.5821 7.67152C11.5167 8.05372 12.4516 8.43553 13.3863 8.81767C14.0887 9.10486 14.7912 9.39225 15.4938 9.679C15.5099 9.68556 15.5262 9.70217 15.5467 9.68743C15.5473 9.66503 15.5315 9.65177 15.5205 9.63665C15.1123 9.07442 14.7037 8.51251 14.2954 7.95041C13.7824 7.24426 13.2698 6.53792 12.7569 5.8317C12.4532 5.41352 12.1522 4.99341 11.8443 4.57832C11.679 4.35536 11.8105 4.07621 12.0167 4.01719C12.031 4.01313 12.0443 4.00579 12.0581 4C12.101 4 12.1439 4 12.1868 4C12.282 4.02349 12.354 4.08136 12.4221 4.14939C14.8857 6.61367 17.3497 9.07744 19.8147 11.5404C19.9208 11.6464 20.0037 11.7613 20.0233 11.9138V12.081L20.0232 12.0808Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M19.9999 12.0808C19.977 12.2346 19.8919 12.3512 19.7849 12.4584C17.3353 14.9147 14.8865 17.3719 12.4375 19.8288C12.4103 19.8561 12.384 19.8845 12.355 19.9098C12.2415 20.0088 12.1125 20.0247 11.978 19.9655C11.8453 19.9072 11.7737 19.798 11.7638 19.6539C11.758 19.5702 11.7896 19.4944 11.8391 19.4264C11.9362 19.2931 12.0327 19.1593 12.1295 19.0257C12.7463 18.1738 13.3631 17.3218 13.98 16.47C14.3833 15.913 14.7867 15.3562 15.1901 14.7994C15.2969 14.6519 15.4041 14.5047 15.5105 14.357C15.5212 14.3423 15.5379 14.3295 15.535 14.3065C15.514 14.3004 15.4979 14.3131 15.481 14.32C14.891 14.5611 14.3012 14.8024 13.7115 15.0438C13.2226 15.2439 12.7339 15.4442 12.2451 15.6446C11.1865 16.0784 10.1277 16.5119 9.06936 16.9467C8.98407 16.9817 8.89858 17.0024 8.80725 16.9813C8.66253 16.9479 8.55669 16.8331 8.53141 16.684C8.50875 16.5505 8.573 16.4093 8.69815 16.3339C8.93998 16.1881 9.18379 16.0455 9.42678 15.9016C10.2938 15.3879 11.1607 14.8742 12.0278 14.3607C12.7954 13.9061 13.5634 13.4519 14.3311 12.9974C14.3585 12.9812 14.3854 12.9642 14.4267 12.9389C14.3518 12.9323 14.292 12.9253 14.232 12.922C13.9654 12.9073 13.6987 12.894 13.432 12.8793C13.2145 12.8673 12.997 12.8547 12.7795 12.8415C12.5279 12.8261 12.2765 12.8095 12.0249 12.7943C11.9225 12.788 11.82 12.7846 11.7177 12.7786C11.5237 12.7673 11.3296 12.7548 11.1356 12.7432C11.0568 12.7385 10.9777 12.7358 10.8989 12.7303C10.7092 12.7172 10.5191 12.711 10.3293 12.6999C10.0777 12.6852 9.82623 12.6679 9.57458 12.6531C9.49141 12.6482 9.40817 12.6449 9.32499 12.6397C9.06063 12.6232 8.79596 12.6112 8.53147 12.5966C8.30967 12.5844 8.08793 12.5711 7.86612 12.5583C7.64008 12.5453 7.41391 12.5335 7.188 12.519C6.96626 12.5048 6.74458 12.4913 6.52265 12.4805C6.2986 12.4696 6.0748 12.4551 5.85088 12.4422C5.62907 12.4294 5.40733 12.4166 5.18553 12.4038C4.96372 12.391 4.74192 12.3791 4.52018 12.3648C4.45837 12.3608 4.39612 12.3592 4.33483 12.3523C4.18599 12.3353 4.08189 12.256 4.02888 12.1135C4.01996 12.0894 4.01534 12.0637 4 12.0422V11.9393C4.02022 11.9207 4.02221 11.8936 4.03196 11.8701C4.08773 11.736 4.18574 11.6549 4.33117 11.6409C4.45234 11.6293 4.57409 11.6239 4.69558 11.6167C4.9195 11.6034 5.14343 11.5908 5.36735 11.5778C5.58915 11.565 5.81089 11.5517 6.03276 11.5395C6.29943 11.5249 6.56623 11.513 6.83276 11.4964C6.91382 11.4914 6.99488 11.4877 7.07594 11.483C7.25718 11.4725 7.4383 11.4591 7.61954 11.4487C7.80727 11.438 7.99525 11.432 8.18272 11.4184C8.26378 11.4125 8.3449 11.4106 8.42596 11.4056C8.61568 11.3938 8.80546 11.3816 8.99523 11.3705C9.0976 11.3644 9.20016 11.3612 9.30253 11.355C9.55411 11.3397 9.80563 11.3229 10.0572 11.3077C10.279 11.2942 10.5008 11.282 10.7226 11.2693C10.9487 11.2563 11.1748 11.2433 11.4008 11.2303C11.6205 11.2176 11.8401 11.2048 12.0598 11.1922C12.2837 11.1792 12.5077 11.1658 12.7316 11.1535C12.9983 11.1389 13.2651 11.127 13.5316 11.1105C13.6127 11.1055 13.6938 11.1016 13.7748 11.0971C13.9753 11.0858 14.1757 11.0732 14.3761 11.0609C14.3914 11.0599 14.4085 11.0646 14.4236 11.0529C14.4066 11.033 14.3863 11.0251 14.3681 11.0143C13.5101 10.5062 12.652 9.99844 11.794 9.49047C10.901 8.96178 10.008 8.43308 9.11506 7.90432C8.97694 7.82258 8.83806 7.74206 8.70129 7.65813C8.57749 7.58211 8.5144 7.44392 8.53359 7.31442C8.56793 7.0829 8.81604 6.93975 9.03772 7.03359C9.55174 7.25121 10.0695 7.45969 10.586 7.67152C11.5179 8.05372 12.4501 8.43553 13.3821 8.81767C14.0826 9.10486 14.783 9.39225 15.4836 9.679C15.4996 9.68556 15.5159 9.70217 15.5363 9.68743C15.5369 9.66503 15.5212 9.65177 15.5102 9.63665C15.1032 9.07442 14.6957 8.51251 14.2886 7.95041C13.7771 7.24426 13.2659 6.53792 12.7546 5.8317C12.4518 5.41352 12.1516 4.99341 11.8446 4.57832C11.6797 4.35536 11.8109 4.07621 12.0165 4.01719C12.0307 4.01313 12.044 4.00579 12.0578 4C12.1005 4 12.1433 4 12.1861 4C12.281 4.02349 12.3529 4.08136 12.4207 4.14939C14.8772 6.61367 17.3341 9.07744 19.792 11.5404C19.8978 11.6464 19.9805 11.7613 20 11.9138V12.081L19.9999 12.0808Z",
            fill: "black"
        })
    });
};

});

parcelRegister("eTxga", function(module, exports) {

$parcel$export(module.exports, "LaunchDarklySearchResultIcon", () => $44f00290f9c6b84b$export$66f000bb4bcf5fcd);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $44f00290f9c6b84b$export$66f000bb4bcf5fcd = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-211.5",
                y: "-406.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M26.6976 16.1078C26.667 16.3129 26.5531 16.4683 26.41 16.6113C23.1344 19.8863 19.86 23.1625 16.5853 26.4384C16.5489 26.4748 16.5137 26.5127 16.4749 26.5464C16.3232 26.6784 16.1507 26.6996 15.9708 26.6207C15.7934 26.543 15.6976 26.3974 15.6843 26.2053C15.6766 26.0937 15.7188 25.9925 15.7851 25.9019C15.9149 25.7242 16.0439 25.5457 16.1733 25.3676C16.9981 24.2317 17.823 23.0958 18.6479 21.96C19.1872 21.2174 19.7266 20.475 20.266 19.7325C20.4088 19.5359 20.5521 19.3397 20.6944 19.1427C20.7087 19.123 20.7311 19.1061 20.7272 19.0754C20.6991 19.0672 20.6776 19.0842 20.6549 19.0933C19.8661 19.4148 19.0774 19.7366 18.2888 20.0585C17.6351 20.3253 16.9816 20.5924 16.328 20.8594C14.9124 21.4379 13.4966 22.016 12.0814 22.5956C11.9674 22.6423 11.853 22.6699 11.7309 22.6418C11.5374 22.5972 11.3959 22.4442 11.3621 22.2454C11.3318 22.0674 11.4177 21.8792 11.585 21.7786C11.9084 21.5842 12.2344 21.394 12.5593 21.2021C13.7187 20.5173 14.8779 19.8323 16.0374 19.1477C17.0639 18.5415 18.0907 17.9359 19.1173 17.3299C19.1539 17.3083 19.1899 17.2856 19.2452 17.2519C19.145 17.2431 19.0651 17.2338 18.9849 17.2294C18.6284 17.2098 18.2717 17.192 17.9151 17.1724C17.6242 17.1565 17.3333 17.1397 17.0426 17.122C16.7062 17.1016 16.3699 17.0794 16.0335 17.0591C15.8966 17.0507 15.7596 17.0462 15.6227 17.0382C15.3633 17.0231 15.1038 17.0064 14.8444 16.991C14.7389 16.9847 14.6333 16.9811 14.5278 16.9738C14.2742 16.9563 14.02 16.948 13.7661 16.9333C13.4297 16.9137 13.0935 16.8905 12.757 16.8708C12.6458 16.8643 12.5345 16.8599 12.4232 16.8529C12.0697 16.831 11.7158 16.8149 11.3622 16.7955C11.0656 16.7792 10.7691 16.7614 10.4725 16.7445C10.1702 16.7271 9.86777 16.7114 9.56568 16.6921C9.26917 16.6731 8.97275 16.6551 8.67598 16.6407C8.37638 16.6262 8.07713 16.6069 7.7777 16.5896C7.48111 16.5726 7.1846 16.5555 6.888 16.5384C6.59141 16.5213 6.29482 16.5054 5.99831 16.4864C5.91566 16.4811 5.83242 16.479 5.75046 16.4697C5.55144 16.4471 5.41224 16.3414 5.34135 16.1513C5.32942 16.1193 5.32325 16.0849 5.30273 16.0563V15.9191C5.32977 15.8943 5.33243 15.8582 5.34547 15.8269C5.42005 15.6481 5.5511 15.5399 5.74557 15.5213C5.90759 15.5057 6.0704 15.4986 6.23285 15.489C6.53228 15.4712 6.83171 15.4544 7.13113 15.4372C7.42773 15.4201 7.72424 15.4023 8.02092 15.3861C8.3775 15.3666 8.73425 15.3506 9.09066 15.3286C9.19906 15.3219 9.30745 15.317 9.41584 15.3107C9.65819 15.2967 9.90038 15.2789 10.1427 15.265C10.3938 15.2507 10.6451 15.2428 10.8958 15.2246C11.0042 15.2167 11.1127 15.2142 11.2211 15.2075C11.4747 15.1918 11.7285 15.1755 11.9823 15.1606C12.1192 15.1526 12.2563 15.1484 12.3932 15.14C12.7296 15.1197 13.0659 15.0973 13.4024 15.077C13.6989 15.059 13.9955 15.0427 14.2921 15.0257C14.5944 15.0084 14.8967 14.9911 15.199 14.9737C15.4928 14.9568 15.7864 14.9398 16.0802 14.9229C16.3796 14.9057 16.6791 14.8877 16.9786 14.8714C17.3352 14.8519 17.6919 14.836 18.0483 14.814C18.1567 14.8073 18.2651 14.8022 18.3735 14.7962C18.6416 14.7811 18.9095 14.7643 19.1775 14.7478C19.198 14.7466 19.2208 14.7528 19.241 14.7372C19.2183 14.7107 19.1912 14.7001 19.1668 14.6857C18.0195 14.0083 16.8721 13.3313 15.7247 12.654C14.5306 11.9491 13.3365 11.2442 12.1425 10.5391C11.9578 10.4301 11.7721 10.3228 11.5892 10.2109C11.4237 10.1095 11.3393 9.92527 11.365 9.7526C11.4109 9.4439 11.7427 9.25304 12.0391 9.37816C12.7264 9.66832 13.4188 9.94629 14.1094 10.2287C15.3556 10.7383 16.6021 11.2474 17.8484 11.7569C18.785 12.1399 19.7216 12.523 20.6585 12.9054C20.6798 12.9141 20.7016 12.9363 20.7289 12.9166C20.7297 12.8867 20.7087 12.8691 20.6941 12.8489C20.1497 12.0993 19.6049 11.3501 19.0605 10.6006C18.3766 9.65905 17.693 8.71726 17.0092 7.77564C16.6043 7.21807 16.2029 6.65792 15.7924 6.10447C15.572 5.80719 15.7473 5.43499 16.0223 5.35629C16.0413 5.35088 16.0591 5.3411 16.0775 5.33337C16.1346 5.33337 16.1919 5.33337 16.249 5.33337C16.3759 5.3647 16.4721 5.44185 16.5628 5.53256C19.8475 8.81827 23.1329 12.1033 26.4196 15.3872C26.5611 15.5286 26.6716 15.6818 26.6977 15.885V16.1081L26.6976 16.1078Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M34.9999 20.1515C34.9569 20.4399 34.7972 20.6585 34.5966 20.8595C30.0036 25.4651 25.4122 30.0722 20.8203 34.679C20.7693 34.7302 20.72 34.7834 20.6656 34.8308C20.4528 35.0164 20.2109 35.0462 19.9587 34.9353C19.71 34.826 19.5757 34.6213 19.557 34.3511C19.5462 34.1942 19.6054 34.0519 19.6983 33.9245C19.8804 33.6745 20.0613 33.4236 20.2427 33.1731C21.3993 31.5758 22.5558 29.9785 23.7125 28.3812C24.4687 27.3369 25.2251 26.2929 25.9815 25.2488C26.1817 24.9723 26.3827 24.6963 26.5822 24.4194C26.6022 24.3917 26.6336 24.3678 26.6282 24.3247C26.5888 24.3132 26.5586 24.3371 26.5268 24.35C25.4207 24.802 24.3148 25.2545 23.209 25.7072C22.2924 26.0824 21.3761 26.458 20.4596 26.8335C18.4746 27.6469 16.4894 28.4599 14.5051 29.275C14.3451 29.3406 14.1848 29.3795 14.0136 29.3399C13.7422 29.2773 13.5438 29.0621 13.4964 28.7825C13.4539 28.5322 13.5744 28.2675 13.809 28.1261C14.2625 27.8527 14.7196 27.5853 15.1752 27.3154C16.8008 26.3524 18.4262 25.3891 20.0521 24.4264C21.4915 23.574 22.9313 22.7223 24.3708 21.8701C24.4221 21.8397 24.4726 21.8079 24.5501 21.7604C24.4096 21.748 24.2976 21.735 24.1851 21.7288C23.6852 21.7012 23.1851 21.6762 22.6851 21.6487C22.2771 21.6262 21.8693 21.6026 21.4616 21.5777C20.9899 21.549 20.5184 21.5179 20.0467 21.4893C19.8548 21.4776 19.6626 21.4712 19.4706 21.4599C19.1069 21.4387 18.7431 21.4152 18.3793 21.3936C18.2314 21.3847 18.0833 21.3796 17.9354 21.3693C17.5798 21.3447 17.2233 21.3331 16.8674 21.3123C16.3957 21.2848 15.9242 21.2522 15.4523 21.2245C15.2964 21.2153 15.1403 21.2091 14.9844 21.1994C14.4887 21.1685 13.9924 21.1459 13.4965 21.1186C13.0806 21.0957 12.6649 21.0707 12.249 21.0468C11.8252 21.0224 11.4011 21.0004 10.9775 20.9732C10.5617 20.9465 10.1461 20.9212 9.72996 20.9009C9.30987 20.8805 8.89025 20.8534 8.4704 20.8291C8.05451 20.8051 7.63875 20.7811 7.22286 20.7571C6.80698 20.733 6.3911 20.7107 5.97533 20.6839C5.85945 20.6764 5.74272 20.6736 5.6278 20.6605C5.34874 20.6287 5.15355 20.4801 5.05415 20.2128C5.03742 20.1676 5.02876 20.1194 5 20.0792V19.8862C5.03791 19.8513 5.04164 19.8005 5.05993 19.7565C5.1645 19.5051 5.34826 19.3529 5.62094 19.3267C5.84813 19.3049 6.07641 19.2948 6.30421 19.2813C6.72407 19.2564 7.14392 19.2327 7.56378 19.2084C7.97966 19.1844 8.39543 19.1594 8.81143 19.1366C9.31143 19.1092 9.81167 19.0868 10.3114 19.0558C10.4634 19.0464 10.6154 19.0395 10.7674 19.0307C11.1072 19.0109 11.4468 18.9859 11.7866 18.9663C12.1386 18.9462 12.4911 18.9351 12.8426 18.9095C12.9946 18.8984 13.1467 18.8949 13.2987 18.8855C13.6544 18.8634 14.0102 18.8405 14.3661 18.8196C14.558 18.8082 14.7503 18.8023 14.9422 18.7906C15.414 18.762 15.8856 18.7305 16.3573 18.7019C16.773 18.6767 17.189 18.6538 17.6049 18.6299C18.0288 18.6055 18.4527 18.5811 18.8765 18.5567C19.2884 18.533 19.7002 18.5091 20.1122 18.4853C20.532 18.461 20.9519 18.4358 21.3718 18.4129C21.8718 18.3855 22.3721 18.363 22.8718 18.3321C23.0238 18.3227 23.1758 18.3155 23.3278 18.307C23.7037 18.2859 24.0794 18.2623 24.4552 18.2391C24.4839 18.2373 24.5159 18.2461 24.5443 18.2241C24.5124 18.1868 24.4744 18.172 24.4402 18.1517C22.8314 17.1992 21.2225 16.2471 19.6137 15.2946C17.9394 14.3033 16.265 13.312 14.5907 12.3206C14.3318 12.1673 14.0714 12.0164 13.8149 11.859C13.5828 11.7165 13.4645 11.4573 13.5005 11.2145C13.5649 10.7804 14.0301 10.512 14.4457 10.688C15.4095 11.096 16.3804 11.4869 17.3487 11.8841C19.0961 12.6007 20.8439 13.3166 22.5915 14.0331C23.9048 14.5716 25.2181 15.1105 26.5318 15.6481C26.5617 15.6604 26.5923 15.6916 26.6306 15.6639C26.6316 15.6219 26.6022 15.5971 26.5817 15.5687C25.8184 14.5145 25.0545 13.461 24.2911 12.407C23.3321 11.083 22.3736 9.75859 21.4148 8.43444C20.8471 7.65035 20.2842 6.86265 19.7087 6.08435C19.3995 5.6663 19.6454 5.14289 20.0309 5.03222C20.0576 5.02462 20.0826 5.01086 20.1083 5C20.1884 5 20.2687 5 20.3489 5C20.5268 5.04405 20.6616 5.15255 20.7888 5.28011C25.3947 9.90064 30.0014 14.5202 34.61 19.1382C34.8084 19.3371 34.9634 19.5525 35 19.8383V20.152L34.9999 20.1515Z",
            fill: "black"
        })
    });
};

});


parcelRegister("4jyR1", function(module, exports) {

$parcel$export(module.exports, "loomConfig", () => $e9f18d11ddbc0577$export$9cb908560d4a0a78);

var $741y4 = parcelRequire("741y4");

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $fxukM = parcelRequire("fxukM");

var $jYHPz = parcelRequire("jYHPz");
const $e9f18d11ddbc0577$export$9cb908560d4a0a78 = {
    displayName: 'Loom',
    id: 'loom',
    icon: (0, $9yyKc.getIconVersion)((0, $741y4.LoomIcon), (0, $fxukM.LoomIcon), 'Loom', 'small'),
    searchResultIcon: (0, $9yyKc.getIconVersion)((0, $741y4.LoomIcon), (0, $jYHPz.LoomSearchResultIcon), 'Loom', 'large'),
    integrationAri: 'ari:cloud:platform::integration/loom',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Video
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};

});
parcelRegister("fxukM", function(module, exports) {

$parcel$export(module.exports, "LoomIcon", () => $d1307250e2c1420c$export$8d789f76fde3e05);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $d1307250e2c1420c$export$8d789f76fde3e05 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "2 2 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_271_181644)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M24.0115 12.9534H17.9154L23.1946 9.90666L22.1477 8.09334L16.8678 11.14L19.9151 5.86334L18.1014 4.81666L15.0534 10.092V4H12.9581V10.0927L9.91009 4.81666L8.09565 5.86334L11.1431 11.1387L5.86445 8.09334L4.81687 9.90666L10.0961 12.9534H4V15.0473H10.0955L4.81687 18.094L5.86378 19.9073L11.1437 16.8607L8.09565 22.1373L9.90943 23.184L12.9581 17.908V24H15.0534V17.7773L18.1574 23.1507L19.8585 22.1693L16.7537 16.7947L22.1463 19.9066L23.194 18.0934L17.9154 15.0466H24.0108V12.9534H24.0115ZM14.0057 16.8466C13.6317 16.8467 13.2613 16.7731 12.9158 16.6301C12.5703 16.487 12.2563 16.2773 11.9918 16.0129C11.7273 15.7486 11.5175 15.4347 11.3743 15.0893C11.2311 14.7438 11.1575 14.3736 11.1574 13.9997C11.1573 13.6257 11.2309 13.2554 11.374 12.91C11.5172 12.5646 11.7269 12.2506 11.9913 11.9862C12.2557 11.7218 12.5696 11.512 12.9152 11.3689C13.2607 11.2257 13.631 11.1521 14.0051 11.152C14.7604 11.1519 15.4848 11.4518 16.019 11.9857C16.5532 12.5197 16.8534 13.2439 16.8534 13.999C16.8535 14.7541 16.5536 15.4784 16.0195 16.0125C15.4854 16.5466 14.761 16.8466 14.0057 16.8466Z",
                    fill: "#5753F3"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_271_181644",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });

});

parcelRegister("jYHPz", function(module, exports) {

$parcel$export(module.exports, "LoomSearchResultIcon", () => $a5d238333844adb7$export$2e4be418f3f83dcc);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $a5d238333844adb7$export$2e4be418f3f83dcc = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M35 18.43H25.8611L33.7754 13.86L32.2059 11.14L24.2906 15.71L28.859 7.795L26.14 6.225L21.5705 14.138V5H18.4295V14.139L13.86 6.225L11.1399 7.795L15.7084 15.708L7.79507 11.14L6.22459 13.86L14.139 18.43H5V21.571H14.138L6.22459 26.141L7.79407 28.861L15.7094 24.291L11.1399 32.206L13.859 33.776L18.4295 25.862V35H21.5705V25.666L26.2239 33.726L28.7741 32.254L24.1196 24.1921L32.2039 28.86L33.7744 26.14L25.8611 21.57H34.999V18.43H35ZM20 24.27C19.4393 24.2701 18.884 24.1597 18.3661 23.9451C17.8481 23.7305 17.3773 23.416 16.9808 23.0194C16.5843 22.6229 16.2697 22.1521 16.0551 21.6339C15.8405 21.1157 15.73 20.5604 15.7299 19.9996C15.7298 19.4386 15.8402 18.8832 16.0547 18.365C16.2693 17.8468 16.5836 17.3759 16.9801 16.9793C17.3765 16.5827 17.8471 16.268 18.3652 16.0533C18.8831 15.8386 19.4383 15.7281 19.999 15.728C21.1313 15.7279 22.2174 16.1777 23.0182 16.9786C23.819 17.7796 24.269 18.8658 24.2691 19.9985C24.2692 21.1312 23.8196 22.2176 23.0189 23.0187C22.2183 23.8199 21.1323 24.2699 20 24.27Z",
            fill: "#5753F3"
        })
    });

});


parcelRegister("i5z78", function(module, exports) {

$parcel$export(module.exports, "lucidConfig", () => $230e1285d2217578$export$3cac442956139a7e);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $4OpyU = parcelRequire("4OpyU");

var $5zlfl = parcelRequire("5zlfl");
const $230e1285d2217578$export$3cac442956139a7e = {
    displayName: 'Lucid',
    id: 'lucid',
    resourceType: 'lucid-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $4OpyU.LucidIcon), 'Lucid', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $5zlfl.LucidSearchResultIcon), 'Lucid', 'large'),
    integrationAri: 'ari:cloud:platform::integration/lucid',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};

});
parcelRegister("4OpyU", function(module, exports) {

$parcel$export(module.exports, "LucidIcon", () => $11402a5a2444f870$export$8664694e1d7db2a0);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6fnsQ = parcelRequire("6fnsQ");
const $11402a5a2444f870$export$8664694e1d7db2a0 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-587.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.01072 13.6063C6.01072 11.5924 6.01608 9.57906 6.00429 7.5652C6.00268 7.28018 6.08739 7.12189 6.34258 6.97751C8.00454 6.03689 9.65525 5.07648 11.3097 4.12249C11.6394 3.93212 11.656 3.94067 11.656 4.31286C11.656 8.28657 11.656 12.2603 11.656 16.2345C11.656 16.3148 11.6614 16.3955 11.6555 16.4752C11.641 16.6773 11.7123 16.711 11.8844 16.6099C12.4002 16.3078 12.9197 16.0116 13.4376 15.7132C14.5972 15.0447 15.7568 14.3758 16.917 13.7079C17.192 13.5496 17.2231 13.5672 17.2231 13.8913C17.2241 15.7533 17.2241 17.6158 17.2231 19.4778C17.2231 19.8232 17.2027 19.843 16.8601 19.8436C15.2164 19.8462 13.5727 19.8425 11.9295 19.8543C11.663 19.8564 11.5697 19.7805 11.5751 19.5067C11.5912 18.7227 11.5815 17.9388 11.5804 17.1543C11.5804 16.8746 11.5751 16.8693 11.329 17.011C9.66543 17.9671 8.00347 18.9265 6.33936 19.8821C6.25144 19.9323 6.16191 20.0478 6.05469 19.9783C5.96676 19.9216 6.01126 19.796 6.01126 19.7013C6.00965 17.6698 6.00965 15.6383 6.00965 13.6068L6.01072 13.6063Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M6.01072 13.6063C6.01072 11.5924 6.01608 9.57906 6.00429 7.5652C6.00268 7.28018 6.08739 7.12189 6.34258 6.97751C8.00454 6.03689 9.65525 5.07648 11.3097 4.12249C11.6394 3.93212 11.656 3.94067 11.656 4.31286C11.656 8.28657 11.656 12.2603 11.656 16.2345C11.656 16.3148 11.6614 16.3955 11.6555 16.4752C11.641 16.6773 11.7123 16.711 11.8844 16.6099C12.4002 16.3078 12.9197 16.0116 13.4376 15.7132C14.5972 15.0447 15.7568 14.3758 16.917 13.7079C17.192 13.5496 17.2231 13.5672 17.2231 13.8913C17.2241 15.7533 17.2241 17.6158 17.2231 19.4778C17.2231 19.8232 17.2027 19.843 16.8601 19.8436C15.2164 19.8462 13.5727 19.8425 11.9295 19.8543C11.663 19.8564 11.5697 19.7805 11.5751 19.5067C11.5912 18.7227 11.5815 17.9388 11.5804 17.1543C11.5804 16.8746 11.5751 16.8693 11.329 17.011C9.66543 17.9671 8.00347 18.9265 6.33936 19.8821C6.25144 19.9323 6.16191 20.0478 6.05469 19.9783C5.96676 19.9216 6.01126 19.796 6.01126 19.7013C6.00965 17.6698 6.00965 15.6383 6.00965 13.6068L6.01072 13.6063Z",
            fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`
        })
    });
};

});

parcelRegister("5zlfl", function(module, exports) {

$parcel$export(module.exports, "LucidSearchResultIcon", () => $9919f1014ce9e785$export$6daa097ac5ffeb2c);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $9919f1014ce9e785$export$6daa097ac5ffeb2c = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-115.5",
                y: "-454.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.0143 18.1416C8.0143 15.4564 8.02145 12.772 8.00572 10.0868C8.00358 9.70682 8.11652 9.49577 8.45677 9.30326C10.6727 8.0491 12.8737 6.76856 15.0796 5.49657C15.5192 5.24274 15.5414 5.25415 15.5414 5.75039C15.5414 11.0487 15.5414 16.347 15.5414 21.646C15.5414 21.7529 15.5485 21.8606 15.5407 21.9668C15.5214 22.2363 15.6164 22.2813 15.8459 22.1465C16.5336 21.7437 17.2262 21.3487 17.9167 20.9508C19.4629 20.0596 21.0091 19.1676 22.5559 18.2771C22.9226 18.066 22.9641 18.0895 22.9641 18.5216C22.9655 21.0043 22.9655 23.4876 22.9641 25.9703C22.9641 26.4309 22.9369 26.4573 22.4802 26.458C20.2885 26.4616 18.0969 26.4566 15.9059 26.4723C15.5507 26.4751 15.4263 26.3739 15.4334 26.0088C15.4549 24.9636 15.442 23.9183 15.4406 22.8723C15.4406 22.4994 15.4334 22.4923 15.1053 22.6812C12.8872 23.9561 10.6713 25.2352 8.45248 26.5093C8.33525 26.5764 8.21588 26.7304 8.07291 26.6377C7.95568 26.5621 8.01501 26.3945 8.01501 26.2683C8.01287 23.5597 8.01287 20.851 8.01287 18.1423L8.0143 18.1416Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M10.0201 23.0117C10.0201 19.2357 10.0302 15.4607 10.008 11.6847C10.005 11.1503 10.1639 10.8535 10.6423 10.5828C13.7585 8.81916 16.8536 7.0184 19.9557 5.22966C20.5739 4.87272 20.6051 4.88876 20.6051 5.58661C20.6051 13.0373 20.6051 20.488 20.6051 27.9398C20.6051 28.0902 20.6151 28.2416 20.6041 28.391C20.5769 28.77 20.7106 28.8331 21.0333 28.6436C22.0003 28.0771 22.9744 27.5217 23.9454 26.9622C26.1197 25.7089 28.294 24.4545 30.4693 23.2022C30.985 22.9054 31.0433 22.9385 31.0433 23.5461C31.0453 27.0374 31.0453 30.5296 31.0433 34.0209C31.0433 34.6686 31.0051 34.7057 30.3627 34.7067C27.2807 34.7117 24.1987 34.7047 21.1177 34.7267C20.6181 34.7307 20.4432 34.5884 20.4533 34.075C20.4834 32.6051 20.4653 31.1352 20.4633 29.6643C20.4633 29.1399 20.4533 29.1299 19.9919 29.3956C16.8727 31.1884 13.7565 32.9871 10.6363 34.7789C10.4715 34.8731 10.3036 35.0897 10.1025 34.9593C9.93768 34.8531 10.0211 34.6174 10.0211 34.44C10.0181 30.6309 10.0181 26.8218 10.0181 23.0127L10.0201 23.0117Z",
            fill: "#222C35"
        })
    });
};

});


parcelRegister("dTjb3", function(module, exports) {

$parcel$export(module.exports, "miroConfig", () => $3a411c179a98e5e7$export$b11bada05d439596);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $6nc8t = parcelRequire("6nc8t");

var $b3bZx = parcelRequire("b3bZx");
const $3a411c179a98e5e7$export$b11bada05d439596 = {
    displayName: 'Miro',
    id: 'miro',
    resourceType: 'miro-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $6nc8t.MiroIcon), 'Miro', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $b3bZx.MiroSearchResultIcon), 'Miro', 'large'),
    integrationAri: 'ari:cloud:platform::integration/miro',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("6nc8t", function(module, exports) {

$parcel$export(module.exports, "MiroIcon", () => $75c08139eedf0275$export$38410c1d5582587e);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $75c08139eedf0275$export$38410c1d5582587e = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#FFDD33"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.0122 5.5H13.1097L14.6951 8.28547L11.2073 5.5H9.30491L11.0488 8.90456L7.40244 5.5H5.5L7.40244 9.83362L5.5 18.5H7.40244L11.0488 9.21453L9.30491 18.5H11.2073L14.6951 8.59544L13.1097 18.5H15.0122L18.5 7.6664L15.0122 5.5Z",
                fill: "black"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M4 8C4 5.79086 5.79086 4 8 4H16C18.2092 4 20 5.79086 20 8V16C20 18.2091 18.2092 20 16 20H8C5.79086 20 4 18.2091 4 16V8Z",
                fill: "#FFDD33"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.6372 7.05002H13.1848L14.3951 9.17662L11.7323 7.05002H10.2799L11.6113 9.64927L8.82744 7.05002H7.375L8.82744 10.3586L7.375 16.975H8.82744L11.6113 9.88592L10.2799 16.975H11.7323L14.3951 9.41327L13.1848 16.975H14.6372L17.3 8.70398L14.6372 7.05002Z",
                fill: "black"
            })
        ]
    });
};

});

parcelRegister("b3bZx", function(module, exports) {

$parcel$export(module.exports, "MiroSearchResultIcon", () => $36e837d8ce70b432$export$c22696a011659024);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $36e837d8ce70b432$export$c22696a011659024 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-19.5",
                y: "-454.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#FFDD33"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.0164 7.33325H17.4798L19.5936 11.0472L14.9432 7.33325H12.4067L14.7319 11.8727L9.87008 7.33325H7.3335L9.87008 13.1114L7.3335 24.6666H9.87008L14.7319 12.286L12.4067 24.6666H14.9432L19.5936 11.4605L17.4798 24.6666H20.0164L24.6668 10.2218L20.0164 7.33325Z",
                fill: "black"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M5 12.5C5 8.35786 8.35786 5 12.5 5H27.5C31.6422 5 35 8.35786 35 12.5V27.5C35 31.6422 31.6422 35 27.5 35H12.5C8.35786 35 5 31.6422 5 27.5V12.5Z",
                fill: "#FFDD33"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.9447 10.7188H22.2214L24.4908 14.7061L19.4981 10.7188H16.7748L19.2712 15.5923L14.0515 10.7188H11.3281L14.0515 16.9223L11.3281 29.3281H14.0515L19.2712 16.0361L16.7748 29.3281H19.4981L24.4908 15.1498L22.2214 29.3281H24.9447L29.9375 13.8199L24.9447 10.7188Z",
                fill: "black"
            })
        ]
    });
};

});


parcelRegister("l1ZKm", function(module, exports) {

$parcel$export(module.exports, "mondayConfig", () => $0a1292f152f9fefd$export$49283b8341865631);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $4C2Rb = parcelRequire("4C2Rb");

var $ie8NY = parcelRequire("ie8NY");
const $0a1292f152f9fefd$export$49283b8341865631 = {
    displayName: 'Monday',
    id: 'monday',
    resourceType: 'monday-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $4C2Rb.MondayIcon), 'Monday', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $ie8NY.MondaySearchResultIcon), 'Monday', 'large'),
    integrationAri: 'ari:cloud:platform::integration/monday',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("4C2Rb", function(module, exports) {

$parcel$export(module.exports, "MondayIcon", () => $2f8439e55801bd17$export$37b4104f63b2f4bd);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $2f8439e55801bd17$export$37b4104f63b2f4bd = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.36594 16.7731C6.03435 16.7738 5.70851 16.6807 5.42172 16.5032C5.13492 16.3257 4.89744 16.0701 4.73354 15.7627C4.57214 15.4574 4.49165 15.111 4.50068 14.7606C4.50972 14.4103 4.60793 14.0691 4.78482 13.7738L8.14648 8.14287C8.31854 7.84024 8.56281 7.59175 8.85436 7.42277C9.14592 7.2538 9.47429 7.1704 9.80595 7.18109C10.1373 7.18956 10.4607 7.2918 10.7429 7.47734C11.0251 7.66289 11.256 7.92507 11.412 8.23707C11.7254 8.86914 11.6862 9.6296 11.3109 10.2229L7.95133 15.8538C7.78097 16.137 7.54634 16.3697 7.2692 16.5304C6.99206 16.6911 6.68137 16.7746 6.36594 16.7731Z",
                fill: "#F62B54"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.1321 16.7728C11.454 16.7728 10.8301 16.3861 10.5025 15.7647C10.3415 15.4602 10.2612 15.1148 10.2702 14.7653C10.2793 14.4159 10.3773 14.0756 10.5538 13.7811L13.9091 8.16313C14.0786 7.85625 14.322 7.60333 14.614 7.43061C14.9061 7.25789 15.2361 7.17165 15.5699 7.18084C16.2537 7.19679 16.8733 7.60475 17.1867 8.2429C17.4979 8.88105 17.4523 9.64607 17.0656 10.2379L13.7111 15.8559C13.5412 16.1378 13.3075 16.3696 13.0316 16.5299C12.7556 16.6901 12.4463 16.7737 12.1321 16.7728Z",
                fill: "#FFCC00"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.7693 16.82C18.7251 16.82 19.4999 16.0108 19.4999 15.0126C19.4999 14.0145 18.7251 13.2053 17.7693 13.2053C16.8134 13.2053 16.0386 14.0145 16.0386 15.0126C16.0386 16.0108 16.8134 16.82 17.7693 16.82Z",
                fill: "#00CA72"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M5.99034 16.9904C5.63664 16.9912 5.28909 16.8981 4.98317 16.7205C4.67725 16.543 4.42393 16.2875 4.24911 15.98C4.07695 15.6747 3.99109 15.3283 4.00073 14.978C4.01037 14.6276 4.11513 14.2865 4.3038 13.9911L7.88959 8.36021C8.07311 8.05759 8.33368 7.80909 8.64467 7.64012C8.95566 7.47115 9.30592 7.38774 9.65969 7.39843C10.0132 7.40691 10.3581 7.50914 10.6591 7.69469C10.9601 7.88023 11.2064 8.14242 11.3728 8.45442C11.7071 9.08649 11.6653 9.84695 11.2649 10.4403L7.68143 16.0712C7.49971 16.3543 7.24944 16.5871 6.95382 16.7478C6.6582 16.9084 6.3268 16.9919 5.99034 16.9904Z",
                fill: "#F62B54"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.1409 16.9902C11.4177 16.9902 10.7522 16.6035 10.4027 15.9821C10.2309 15.6776 10.1453 15.3322 10.1549 14.9827C10.1645 14.6333 10.2691 14.2931 10.4574 13.9985L14.0363 8.38054C14.2172 8.07366 14.4768 7.82074 14.7883 7.64802C15.0998 7.47529 15.4519 7.38906 15.808 7.39825C16.5373 7.4142 17.1982 7.82216 17.5325 8.46031C17.8645 9.09846 17.8159 9.86347 17.4033 10.4553L13.8251 16.0733C13.644 16.3552 13.3947 16.587 13.1004 16.7473C12.806 16.9075 12.476 16.9911 12.1409 16.9902Z",
                fill: "#FFCC00"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.154 17.0374C19.1736 17.0374 20.0001 16.2282 20.0001 15.2301C20.0001 14.2319 19.1736 13.4227 18.154 13.4227C17.1344 13.4227 16.3079 14.2319 16.3079 15.2301C16.3079 16.2282 17.1344 17.0374 18.154 17.0374Z",
                fill: "#00CA72"
            })
        ]
    });
};

});

parcelRegister("ie8NY", function(module, exports) {

$parcel$export(module.exports, "MondaySearchResultIcon", () => $0cb52f295315cac1$export$bf10d2e61430fb53);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $0cb52f295315cac1$export$bf10d2e61430fb53 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-19.5",
                y: "-263.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "31",
                height: "31",
                rx: "7.5",
                stroke: "#0B1228",
                strokeOpacity: "0.14"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.48792 22.364C8.0458 22.365 7.61135 22.2409 7.22895 22.0042C6.84656 21.7675 6.52992 21.4268 6.31138 21.0168C6.09619 20.6097 5.98887 20.1479 6.00091 19.6808C6.01296 19.2136 6.14391 18.7588 6.37975 18.3649L10.862 10.8571C11.0914 10.4536 11.4171 10.1222 11.8058 9.89695C12.1946 9.67165 12.6324 9.56045 13.0746 9.5747C13.5165 9.586 13.9476 9.72232 14.3238 9.96971C14.7001 10.2171 15.008 10.5667 15.216 10.9827C15.6338 11.8254 15.5816 12.8394 15.0811 13.6305L10.6018 21.1384C10.3746 21.5159 10.0618 21.8262 9.69227 22.0405C9.32275 22.2547 8.9085 22.366 8.48792 22.364Z",
                fill: "#F62B54"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.176 22.3638C15.272 22.3638 14.4401 21.8482 14.0033 21.0196C13.7886 20.6137 13.6815 20.153 13.6935 19.6871C13.7056 19.2212 13.8363 18.7676 14.0717 18.3749L18.5453 10.8842C18.7714 10.475 19.0959 10.1378 19.4853 9.90752C19.8747 9.67722 20.3148 9.56224 20.7598 9.5745C21.6715 9.59577 22.4977 10.1397 22.9155 10.9906C23.3305 11.8414 23.2697 12.8615 22.7541 13.6505L18.2813 21.1412C18.0549 21.5171 17.7433 21.8262 17.3754 22.0399C17.0074 22.2536 16.595 22.365 16.176 22.3638Z",
                fill: "#FFCC00"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M23.6923 22.4266C24.9668 22.4266 25.9999 21.3477 25.9999 20.0168C25.9999 18.6859 24.9668 17.6071 23.6923 17.6071C22.4179 17.6071 21.3848 18.6859 21.3848 20.0168C21.3848 21.3477 22.4179 22.4266 23.6923 22.4266Z",
                fill: "#00CA72"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.73188 29.2367C8.06871 29.2381 7.41704 29.0635 6.84344 28.7306C6.26984 28.3978 5.79488 27.9187 5.46707 27.3422C5.14429 26.7697 4.9833 26.1203 5.00137 25.4634C5.01944 24.8064 5.21587 24.1668 5.56963 23.613L12.293 13.055C12.6371 12.4876 13.1256 12.0217 13.7088 11.7049C14.2919 11.388 14.9486 11.2317 15.6119 11.2517C16.2747 11.2676 16.9214 11.4593 17.4858 11.8072C18.0502 12.1551 18.512 12.6467 18.824 13.2317C19.4508 14.4168 19.3724 15.8427 18.6218 16.9552L11.9027 27.5131C11.562 28.044 11.0927 28.4804 10.5384 28.7817C9.98413 29.083 9.36276 29.2395 8.73188 29.2367Z",
                fill: "#F62B54"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.2641 29.2364C18.908 29.2364 17.6602 28.5113 17.005 27.3462C16.6829 26.7753 16.5223 26.1275 16.5404 25.4723C16.5584 24.8171 16.7545 24.1792 17.1075 23.6269L23.8181 13.0932C24.1571 12.5178 24.6439 12.0436 25.228 11.7197C25.8121 11.3959 26.4722 11.2342 27.1399 11.2514C28.5073 11.2813 29.7466 12.0463 30.3733 13.2428C30.9958 14.4393 30.9046 15.8737 30.1312 16.9834L23.4221 27.5171C23.0824 28.0458 22.615 28.4804 22.0631 28.7809C21.5112 29.0814 20.8925 29.238 20.2641 29.2364Z",
                fill: "#FFCC00"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M31.5387 29.3247C33.4503 29.3247 35 27.8076 35 25.936C35 24.0645 33.4503 22.5473 31.5387 22.5473C29.627 22.5473 28.0773 24.0645 28.0773 25.936C28.0773 27.8076 29.627 29.3247 31.5387 29.3247Z",
                fill: "#00CA72"
            })
        ]
    });
};

});


parcelRegister("AHfI3", function(module, exports) {

$parcel$export(module.exports, "muralConfig", () => $91e418846a9395a7$export$8855f5ba0dd32fb9);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $6Wdvw = parcelRequire("6Wdvw");

var $bwFIG = parcelRequire("bwFIG");
const $91e418846a9395a7$export$8855f5ba0dd32fb9 = {
    displayName: 'Mural',
    id: 'mural',
    resourceType: 'smartlinks-connector-mural',
    icon: (0, $9yyKc.get3PLogo)((0, $6Wdvw.MuralIcon), 'Mural', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $bwFIG.MuralSearchResultIcon), 'Mural', 'large'),
    integrationAri: 'ari:cloud:platform::integration/mural',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("6Wdvw", function(module, exports) {

$parcel$export(module.exports, "MuralIcon", () => $49b59ae3bd4569eb$export$807a21e0dcf114c4);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $49b59ae3bd4569eb$export$807a21e0dcf114c4 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.385264",
                y: "0.385264",
                width: "23.2295",
                height: "23.2295",
                rx: "5.61474",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.6754 16.1763C12.6757 14.0134 12.6843 11.8504 12.6739 9.68758C12.6654 7.94483 13.8929 6.44038 15.5576 6.08234C15.8132 6.02736 16.0709 5.99181 16.3335 6.00416C16.3754 6.06652 16.3699 6.13777 16.3701 6.20736C16.3708 6.83713 16.371 7.46704 16.3698 8.09681C16.3696 8.17062 16.3803 8.24819 16.3276 8.31236C15.8848 8.32742 15.5243 8.50576 15.2565 8.86034C15.089 9.08221 14.9992 9.3339 14.9928 9.61332C14.9914 9.67342 14.9908 9.73352 14.9908 9.79377C14.9908 11.8638 14.9908 13.9339 14.9905 16.0039C14.9905 16.0639 14.9863 16.1238 14.9842 16.1839C14.9391 16.2353 14.8769 16.2339 14.8176 16.2342C14.1625 16.2368 13.5073 16.2368 12.8522 16.2342C12.7888 16.2339 12.7197 16.2401 12.6755 16.1763H12.6754Z",
                fill: "#00843F"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9958 9.66997C19.997 9.7251 19.9991 9.78023 19.9991 9.83536C19.9992 12.6608 19.9994 15.4861 19.9988 18.3115C19.9988 18.5251 20.0262 18.4962 19.8174 18.4965C19.1651 18.4977 18.5127 18.497 17.8602 18.497C17.8251 18.497 17.7899 18.4955 17.7548 18.497C17.7016 18.4992 17.684 18.4709 17.6862 18.4226C17.6871 18.4025 17.6862 18.3825 17.6862 18.3623C17.6865 15.4716 17.6867 12.5811 17.687 9.69046C17.687 9.68548 17.6874 9.68036 17.6876 9.67539C17.7236 9.6043 17.7918 9.60324 17.8563 9.60294C18.5111 9.59948 19.1658 9.59963 19.8206 9.60249C19.8869 9.60279 19.9509 9.61213 19.9956 9.66982L19.9958 9.66997Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.31589 9.65845C6.31815 9.71343 6.32222 9.76841 6.32222 9.82339C6.32252 12.6568 6.32267 15.4902 6.32222 18.3237C6.32222 18.5291 6.34511 18.5007 6.1493 18.501C5.48729 18.502 4.82529 18.502 4.16344 18.5002C4.11208 18.5002 4.05183 18.5251 4.01025 18.4692C4.02758 18.4151 4.01538 18.3598 4.01538 18.3053C4.01628 15.4761 4.01613 12.6469 4.01613 9.81781C4.01613 9.61688 4.02682 9.60212 4.22535 9.60121C4.85738 9.5985 5.4894 9.59941 6.12143 9.60106C6.19072 9.60121 6.26407 9.59579 6.31604 9.65845H6.31589Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3296 18.485C11.282 18.508 11.2309 18.499 11.1813 18.4991C10.5242 18.5006 9.86683 18.5014 9.20965 18.5021C9.1845 18.5021 9.15949 18.5029 9.13434 18.502C9.06545 18.4995 9.02985 18.4615 9.02754 18.3881C9.02709 18.373 9.02754 18.358 9.02754 18.3429C9.02754 15.4932 9.02754 12.6434 9.02769 9.79368C9.02769 9.74864 9.03101 9.70361 9.03282 9.65842C9.08463 9.59651 9.15738 9.60103 9.22667 9.60073C9.86141 9.59907 10.4961 9.59907 11.1309 9.60073C11.2003 9.60088 11.2728 9.59711 11.3247 9.65857C11.3267 9.72364 11.3305 9.78871 11.3305 9.85378C11.3308 11.899 11.3306 13.9442 11.3311 15.9892C11.3311 16.0542 11.3234 16.1197 11.3409 16.1837C11.3704 16.2444 11.3702 16.3096 11.3702 16.3748C11.3704 17.0109 11.371 17.647 11.3696 18.283C11.3696 18.3521 11.3782 18.4246 11.3296 18.4847V18.485Z",
                fill: "#5887FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3247 9.65883C10.5607 9.65883 9.79675 9.65883 9.03263 9.65868C9.00822 9.44901 8.97343 9.24296 8.87477 9.05166C8.60861 8.53577 8.0406 8.24174 7.47124 8.32896C6.89584 8.41707 6.43884 8.87166 6.34515 9.45007C6.33401 9.5192 6.32557 9.58879 6.31593 9.65823C5.60302 9.65823 4.89011 9.65793 4.17719 9.65778C4.15716 9.65778 4.13682 9.65944 4.11694 9.65763C4.04795 9.65145 4.01226 9.67751 4.01753 9.75132C4.02039 9.79123 4.01783 9.8316 4.01783 9.87182C4.01783 12.6882 4.01783 15.5048 4.01753 18.3212C4.01753 18.3709 4.01286 18.4206 4.01015 18.4697C3.99267 18.4307 4.00307 18.3902 4.00307 18.351C4.00231 15.501 4.00201 12.6509 4.00277 9.80087C4.00277 9.28513 4.06874 8.77888 4.27389 8.30139C4.8172 7.03749 5.76675 6.26101 7.12404 6.04561C9.03022 5.74301 10.8088 6.97166 11.247 8.85389C11.3084 9.11794 11.3462 9.38605 11.3246 9.65883H11.3247Z",
                fill: "#FF4B4B"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9958 9.67086C19.816 9.6689 19.6361 9.66543 19.4563 9.66513C18.9213 9.66438 18.3864 9.66468 17.8514 9.66513C17.7967 9.66513 17.7413 9.65941 17.6878 9.67658C17.6785 9.52701 17.6637 9.37954 17.6171 9.23479C17.4522 8.72221 16.9529 8.33104 16.4019 8.3214C16.377 8.32094 16.3523 8.31612 16.3276 8.31326C16.3303 8.28344 16.3353 8.25361 16.3353 8.22379C16.335 7.48406 16.3343 6.74449 16.3337 6.00492C18.3515 5.97976 20.0257 7.66918 19.9958 9.67101V9.67086Z",
                fill: "#FC83FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3295 18.4854C11.3295 17.7731 11.3295 17.0608 11.3299 16.3486C11.3299 16.2938 11.3216 16.2382 11.3408 16.1844C11.7857 16.1819 12.2307 16.1793 12.6756 16.1768C12.7253 16.1795 12.7752 16.1844 12.8249 16.1844C13.5447 16.1849 14.2644 16.1846 14.9843 16.1844C14.9865 16.2343 14.9909 16.2843 14.9909 16.3342C14.9913 16.9954 14.9912 17.6568 14.9912 18.3181C14.9912 18.3532 14.99 18.3883 14.9909 18.4232C14.9921 18.4723 14.9705 18.4981 14.9201 18.4975C14.885 18.4972 14.8499 18.4982 14.8149 18.4982C13.7077 18.4982 12.6006 18.4982 11.4933 18.4981C11.4385 18.4981 11.3829 18.5051 11.3296 18.4853L11.3295 18.4854Z",
                fill: "#FFAA00"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.6756 16.1765C12.6759 14.0137 12.6845 11.8507 12.6741 9.68782C12.6657 7.94507 13.8931 6.44062 15.5579 6.08258C15.8135 6.0276 16.0712 5.99206 16.3337 6.00441C16.3756 6.06677 16.3702 6.13801 16.3703 6.2076C16.3711 6.83737 16.3712 7.46729 16.37 8.09706C16.3699 8.17086 16.3806 8.24844 16.3279 8.3126C15.885 8.32766 15.5246 8.50601 15.2568 8.86058C15.0893 9.08245 14.9995 9.33415 14.993 9.61356C14.9916 9.67366 14.991 9.73376 14.991 9.79401C14.991 11.8641 14.991 13.9341 14.9907 16.0042C14.9907 16.0641 14.9865 16.1241 14.9844 16.1842C14.9394 16.2355 14.8772 16.2342 14.8178 16.2345C14.1628 16.237 13.5075 16.237 12.8525 16.2345C12.789 16.2342 12.7199 16.2404 12.6758 16.1765H12.6756Z",
                fill: "#00843F"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9958 9.67021C19.997 9.72534 19.9991 9.78047 19.9991 9.8356C19.9992 12.661 19.9994 15.4863 19.9988 18.3118C19.9988 18.5254 20.0262 18.4965 19.8174 18.4968C19.1651 18.498 18.5127 18.4972 17.8602 18.4972C17.8251 18.4972 17.7899 18.4957 17.7548 18.4972C17.7016 18.4995 17.684 18.4712 17.6862 18.4228C17.6871 18.4028 17.6862 18.3827 17.6862 18.3625C17.6865 15.4719 17.6867 12.5814 17.687 9.6907C17.687 9.68573 17.6874 9.68061 17.6876 9.67564C17.7236 9.60454 17.7918 9.60349 17.8563 9.60319C18.5111 9.59972 19.1658 9.59987 19.8206 9.60273C19.8869 9.60303 19.9509 9.61237 19.9956 9.67006L19.9958 9.67021Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.31589 9.65857C6.31815 9.71355 6.32222 9.76853 6.32222 9.82351C6.32252 12.6569 6.32267 15.4904 6.32222 18.3238C6.32222 18.5292 6.34511 18.5008 6.1493 18.5011C5.48729 18.5021 4.82529 18.5021 4.16344 18.5003C4.11208 18.5003 4.05183 18.5252 4.01025 18.4693C4.02758 18.4152 4.01538 18.3599 4.01538 18.3054C4.01628 15.4762 4.01613 12.647 4.01613 9.81794C4.01613 9.617 4.02682 9.60224 4.22535 9.60133C4.85738 9.59862 5.4894 9.59953 6.12143 9.60118C6.19072 9.60133 6.26407 9.59591 6.31604 9.65857H6.31589Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3293 18.4851C11.2817 18.5081 11.2307 18.4991 11.1811 18.4992C10.5239 18.5008 9.86659 18.5015 9.20941 18.5023C9.18425 18.5023 9.15925 18.503 9.13409 18.5021C9.06521 18.4996 9.02961 18.4616 9.0273 18.3882C9.02685 18.3732 9.0273 18.3581 9.0273 18.343C9.0273 15.4933 9.0273 12.6435 9.02745 9.7938C9.02745 9.74877 9.03076 9.70373 9.03257 9.65854C9.08439 9.59663 9.15714 9.60115 9.22643 9.60085C9.86117 9.5992 10.4959 9.5992 11.1306 9.60085C11.2001 9.601 11.2725 9.59724 11.3245 9.65869C11.3265 9.72376 11.3302 9.78883 11.3302 9.8539C11.3305 11.8991 11.3304 13.9443 11.3308 15.9894C11.3308 16.0543 11.3231 16.1198 11.3406 16.1838C11.3701 16.2445 11.37 16.3097 11.37 16.375C11.3701 17.0111 11.3707 17.6472 11.3694 18.2831C11.3694 18.3522 11.378 18.4247 11.3293 18.4848V18.4851Z",
                fill: "#5887FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3247 9.65896C10.5607 9.65896 9.79675 9.65896 9.03263 9.65881C9.00822 9.44913 8.97343 9.24308 8.87477 9.05178C8.60861 8.53589 8.0406 8.24187 7.47124 8.32908C6.89584 8.41719 6.43884 8.87178 6.34515 9.45019C6.33401 9.51933 6.32557 9.58891 6.31593 9.65835C5.60302 9.65835 4.89011 9.65805 4.17719 9.6579C4.15716 9.6579 4.13682 9.65956 4.11694 9.65775C4.04795 9.65158 4.01226 9.67763 4.01753 9.75144C4.02039 9.79136 4.01783 9.83172 4.01783 9.87194C4.01783 12.6883 4.01783 15.5049 4.01753 18.3213C4.01753 18.371 4.01286 18.4207 4.01015 18.4698C3.99267 18.4308 4.00307 18.3903 4.00307 18.3511C4.00231 15.5011 4.00201 12.651 4.00277 9.801C4.00277 9.28525 4.06874 8.779 4.27389 8.30151C4.8172 7.03761 5.76675 6.26113 7.12404 6.04574C9.03022 5.74313 10.8088 6.97179 11.247 8.85401C11.3084 9.11806 11.3462 9.38617 11.3246 9.65896H11.3247Z",
                fill: "#FF4B4B"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9958 9.67086C19.816 9.6689 19.6361 9.66543 19.4563 9.66513C18.9213 9.66438 18.3864 9.66468 17.8514 9.66513C17.7967 9.66513 17.7413 9.65941 17.6878 9.67658C17.6785 9.52701 17.6637 9.37954 17.6171 9.23479C17.4522 8.72221 16.9529 8.33104 16.4019 8.3214C16.377 8.32094 16.3523 8.31612 16.3276 8.31326C16.3303 8.28344 16.3353 8.25361 16.3353 8.22379C16.335 7.48406 16.3343 6.74449 16.3337 6.00492C18.3515 5.97976 20.0257 7.66918 19.9958 9.67101V9.67086Z",
                fill: "#FC83FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3293 18.4856C11.3293 17.7733 11.3293 17.061 11.3298 16.3489C11.3298 16.294 11.3215 16.2385 11.3406 16.1847C11.7856 16.1821 12.2305 16.1796 12.6755 16.177C12.7252 16.1797 12.775 16.1847 12.8248 16.1847C13.5446 16.1851 14.2643 16.1848 14.9841 16.1847C14.9864 16.2345 14.9908 16.2845 14.9908 16.3344C14.9912 16.9957 14.9911 17.6571 14.9911 18.3183C14.9911 18.3534 14.9899 18.3885 14.9908 18.4234C14.992 18.4725 14.9704 18.4983 14.92 18.4977C14.8849 18.4974 14.8498 18.4985 14.8148 18.4985C13.7076 18.4985 12.6005 18.4985 11.4932 18.4983C11.4384 18.4983 11.3828 18.5054 11.3295 18.4855L11.3293 18.4856Z",
                fill: "#FFAA00"
            })
        ]
    });
};

});

parcelRegister("bwFIG", function(module, exports) {

$parcel$export(module.exports, "MuralSearchResultIcon", () => $4062cde1516d61dd$export$930cc976c0fd31d6);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $4062cde1516d61dd$export$930cc976c0fd31d6 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-67.5",
                y: "-454.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.513685",
                y: "0.513685",
                width: "30.9726",
                height: "30.9726",
                rx: "7.48631",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "1.02737"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.9007 21.5684C16.9012 18.6846 16.9126 15.8006 16.8987 12.9168C16.8875 10.5931 18.5241 8.58721 20.7437 8.10982C21.0845 8.03652 21.4282 7.98912 21.7782 8.00559C21.8341 8.08874 21.8268 8.18373 21.827 8.27652C21.828 9.11621 21.8282 9.9561 21.8266 10.7958C21.8264 10.8942 21.8407 10.9976 21.7704 11.0832C21.1799 11.1033 20.6993 11.3411 20.3423 11.8138C20.1189 12.1097 19.9992 12.4452 19.9906 12.8178C19.9888 12.8979 19.988 12.9781 19.988 13.0584C19.988 15.8185 19.988 18.5785 19.9876 21.3386C19.9876 21.4186 19.982 21.4985 19.9791 21.5786C19.9191 21.6471 19.8361 21.6453 19.757 21.6457C18.8836 21.6491 18.01 21.6491 17.1365 21.6457C17.052 21.6453 16.9598 21.6535 16.9009 21.5684H16.9007Z",
                fill: "#00843F"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M26.661 12.8934C26.6626 12.9669 26.6654 13.0404 26.6654 13.1139C26.6656 16.8812 26.6658 20.6482 26.665 24.4155C26.665 24.7003 26.7015 24.6617 26.4232 24.6621C25.5533 24.6637 24.6835 24.6627 23.8135 24.6627C23.7667 24.6627 23.7197 24.6607 23.6729 24.6627C23.602 24.6657 23.5785 24.628 23.5816 24.5635C23.5828 24.5368 23.5816 24.5101 23.5816 24.4832C23.582 20.6289 23.5822 16.7749 23.5826 12.9207C23.5826 12.9141 23.5832 12.9072 23.5834 12.9006C23.6314 12.8058 23.7223 12.8044 23.8083 12.804C24.6813 12.7994 25.5544 12.7996 26.4274 12.8034C26.5157 12.8038 26.6011 12.8163 26.6608 12.8932L26.661 12.8934Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.4211 12.8779C8.42412 12.9512 8.42954 13.0245 8.42954 13.0978C8.42994 16.8758 8.43014 20.6537 8.42954 24.4316C8.42954 24.7055 8.46007 24.6675 8.19898 24.6679C7.31631 24.6694 6.43364 24.6694 5.55117 24.6669C5.48269 24.6669 5.40235 24.7001 5.34692 24.6256C5.37002 24.5535 5.35375 24.4798 5.35375 24.4071C5.35496 20.6348 5.35476 16.8625 5.35476 13.0904C5.35476 12.8225 5.36902 12.8028 5.63372 12.8016C6.47642 12.798 7.31912 12.7992 8.16183 12.8014C8.25421 12.8016 8.35202 12.7944 8.42131 12.8779H8.4211Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.1058 24.6466C15.0423 24.6773 14.9742 24.6653 14.9081 24.6655C14.0319 24.6675 13.1555 24.6685 12.2792 24.6695C12.2457 24.6695 12.2123 24.6705 12.1788 24.6693C12.0869 24.666 12.0395 24.6154 12.0364 24.5175C12.0358 24.4974 12.0364 24.4773 12.0364 24.4572C12.0364 20.6576 12.0364 16.8578 12.0366 13.0582C12.0366 12.9982 12.041 12.9381 12.0434 12.8779C12.1125 12.7953 12.2095 12.8014 12.3019 12.801C13.1482 12.7988 13.9945 12.7988 14.8409 12.801C14.9334 12.8012 15.03 12.7962 15.0993 12.8781C15.1019 12.9649 15.107 13.0516 15.107 13.1384C15.1074 15.8653 15.1072 18.5922 15.1078 21.319C15.1078 21.4055 15.0975 21.4929 15.1208 21.5783C15.1602 21.6592 15.16 21.7462 15.16 21.8331C15.1602 22.6812 15.161 23.5294 15.1592 24.3773C15.1592 24.4695 15.1706 24.5661 15.1058 24.6462V24.6466Z",
                fill: "#5887FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.0995 12.8785C14.0809 12.8785 13.0623 12.8785 12.0434 12.8783C12.0109 12.5987 11.9645 12.324 11.8329 12.0689C11.4781 11.3811 10.7207 10.989 9.96157 11.1053C9.19438 11.2228 8.58504 11.8289 8.46012 12.6001C8.44526 12.6923 8.43402 12.7851 8.42116 12.8777C7.47061 12.8777 6.52006 12.8773 5.56951 12.8771C5.5428 12.8771 5.51568 12.8793 5.48917 12.8769C5.39719 12.8686 5.34959 12.9034 5.35662 13.0018C5.36044 13.055 5.35702 13.1088 5.35702 13.1625C5.35702 16.9177 5.35702 20.6731 5.35662 24.4283C5.35662 24.4946 5.3504 24.5609 5.34678 24.6263C5.32348 24.5743 5.33734 24.5203 5.33734 24.4681C5.33634 20.6681 5.33594 16.8679 5.33694 13.0679C5.33694 12.3802 5.42491 11.7052 5.69844 11.0686C6.42286 9.38336 7.68892 8.34805 9.49864 8.06086C12.0402 7.65738 14.4117 9.29559 14.9959 11.8052C15.0778 12.1573 15.1282 12.5148 15.0993 12.8785H15.0995Z",
                fill: "#FF4B4B"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M26.6612 12.8944C26.4214 12.8918 26.1816 12.8872 25.9418 12.8868C25.2284 12.8858 24.5153 12.8862 23.8019 12.8868C23.729 12.8868 23.6551 12.8791 23.5838 12.902C23.5714 12.7026 23.5517 12.506 23.4896 12.313C23.2697 11.6295 22.6039 11.108 21.8693 11.0951C21.8361 11.0945 21.8032 11.0881 21.7703 11.0843C21.7739 11.0445 21.7805 11.0047 21.7805 10.965C21.7801 9.97867 21.7791 8.99257 21.7783 8.00647C24.4687 7.97293 26.701 10.2255 26.6612 12.8946V12.8944Z",
                fill: "#FC83FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.1058 24.6473C15.1058 23.6975 15.1058 22.7478 15.1064 21.7982C15.1064 21.7251 15.0953 21.651 15.1208 21.5793C15.7141 21.5759 16.3074 21.5725 16.9006 21.5691C16.9669 21.5727 17.0334 21.5793 17.0997 21.5793C18.0595 21.5799 19.019 21.5795 19.9788 21.5793C19.9819 21.6458 19.9877 21.7125 19.9877 21.779C19.9883 22.6606 19.9881 23.5425 19.9881 24.4242C19.9881 24.471 19.9865 24.5177 19.9877 24.5643C19.9893 24.6298 19.9606 24.6642 19.8933 24.6634C19.8465 24.663 19.7997 24.6644 19.7531 24.6644C18.2768 24.6644 16.8006 24.6644 15.3243 24.6642C15.2512 24.6642 15.1771 24.6736 15.106 24.6471L15.1058 24.6473Z",
                fill: "#FFAA00"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M21.2668 27.0807C21.2674 23.0254 21.2835 18.9697 21.264 14.9144C21.2482 11.6468 23.5497 8.82592 26.671 8.1546C27.1503 8.05151 27.6335 7.98486 28.1258 8.00802C28.2043 8.12494 28.1941 8.25853 28.1944 8.38901C28.1958 9.56982 28.1961 10.7509 28.1938 11.9317C28.1936 12.0701 28.2136 12.2156 28.1148 12.3359C27.2844 12.3641 26.6086 12.6985 26.1064 13.3633C25.7924 13.7794 25.6241 14.2513 25.6119 14.7752C25.6094 14.8879 25.6082 15.0006 25.6082 15.1135C25.6082 18.9949 25.6082 22.8762 25.6077 26.7576C25.6077 26.87 25.5998 26.9824 25.5958 27.0951C25.5114 27.1914 25.3947 27.1889 25.2835 27.1894C24.0552 27.1942 22.8266 27.1942 21.5984 27.1894C21.4795 27.1889 21.3499 27.2004 21.2671 27.0807H21.2668Z",
                fill: "#00843F"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M34.9921 14.8817C34.9943 14.985 34.9983 15.0884 34.9983 15.1918C34.9986 20.4895 34.9989 25.7869 34.9977 31.0846C34.9977 31.4851 35.0491 31.4309 34.6577 31.4314C33.4345 31.4337 32.2113 31.4323 30.9879 31.4323C30.9221 31.4323 30.856 31.4294 30.7902 31.4323C30.6905 31.4365 30.6574 31.3834 30.6617 31.2927C30.6634 31.2552 30.6617 31.2176 30.6617 31.1798C30.6622 25.7598 30.6625 20.3401 30.6631 14.9201C30.6631 14.9107 30.6639 14.9011 30.6642 14.8918C30.7317 14.7585 30.8597 14.7565 30.9805 14.756C32.2082 14.7495 33.4359 14.7498 34.6636 14.7551C34.7879 14.7557 34.9079 14.7732 34.9918 14.8814L34.9921 14.8817Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.34229 14.8601C9.34653 14.9632 9.35415 15.0662 9.35415 15.1693C9.35472 20.482 9.355 25.7947 9.35415 31.1074C9.35415 31.4926 9.39708 31.4392 9.02993 31.4398C7.78868 31.4417 6.54742 31.4417 5.30645 31.4384C5.21014 31.4384 5.09718 31.485 5.01923 31.3802C5.0517 31.2788 5.02883 31.1751 5.02883 31.0729C5.03052 25.7681 5.03024 20.4634 5.03024 15.1589C5.03024 14.7821 5.05029 14.7544 5.42253 14.7527C6.60758 14.7477 7.79263 14.7494 8.97768 14.7525C9.1076 14.7527 9.24514 14.7426 9.34258 14.8601H9.34229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.7424 31.4098C18.6532 31.453 18.5575 31.436 18.4645 31.4363C17.2323 31.4392 15.9998 31.4406 14.7676 31.442C14.7204 31.442 14.6736 31.4434 14.6264 31.4417C14.4972 31.437 14.4305 31.3658 14.4262 31.2282C14.4253 31.1999 14.4262 31.1717 14.4262 31.1435C14.4262 25.8003 14.4262 20.4568 14.4264 15.1136C14.4264 15.0292 14.4327 14.9447 14.436 14.86C14.5332 14.7439 14.6696 14.7524 14.7995 14.7518C15.9897 14.7487 17.1798 14.7487 18.3699 14.7518C18.5001 14.7521 18.636 14.7451 18.7334 14.8603C18.7371 14.9823 18.7441 15.1043 18.7441 15.2263C18.7447 19.0611 18.7444 22.8958 18.7453 26.7303C18.7453 26.852 18.7309 26.9749 18.7636 27.0949C18.819 27.2087 18.8187 27.331 18.8187 27.4533C18.819 28.646 18.8201 29.8387 18.8176 31.031C18.8176 31.1607 18.8337 31.2965 18.7424 31.4092V31.4098Z",
                fill: "#5887FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.7338 14.8605C17.3014 14.8605 15.8689 14.8605 14.4362 14.8603C14.3904 14.4671 14.3252 14.0808 14.1402 13.7221C13.6412 12.7548 12.5761 12.2035 11.5086 12.367C10.4297 12.5322 9.57283 13.3846 9.39717 14.4691C9.37627 14.5987 9.36045 14.7292 9.34237 14.8594C8.00566 14.8594 6.66895 14.8588 5.33223 14.8586C5.29467 14.8586 5.25654 14.8617 5.21926 14.8583C5.08991 14.8467 5.02298 14.8956 5.03287 15.034C5.03823 15.1088 5.03343 15.1845 5.03343 15.2599C5.03343 20.5407 5.03343 25.8217 5.03287 31.1025C5.03287 31.1957 5.02411 31.2889 5.01903 31.3809C4.98627 31.3078 5.00575 31.2318 5.00575 31.1584C5.00434 25.8146 5.00378 20.4706 5.00519 15.1269C5.00519 14.1598 5.12889 13.2106 5.51355 12.3153C6.53225 9.94552 8.31266 8.48962 10.8576 8.08575C14.4317 7.51836 17.7665 9.8221 18.5881 13.3513C18.7033 13.8464 18.7742 14.3491 18.7335 14.8605H18.7338Z",
                fill: "#FF4B4B"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M34.9922 14.8828C34.655 14.8792 34.3178 14.8727 33.9805 14.8721C32.9774 14.8707 31.9745 14.8712 30.9713 14.8721C30.8688 14.8721 30.7649 14.8614 30.6646 14.8936C30.6471 14.6131 30.6194 14.3366 30.5322 14.0652C30.2229 13.1041 29.2867 12.3707 28.2536 12.3526C28.207 12.3517 28.1606 12.3427 28.1143 12.3373C28.1194 12.2814 28.1287 12.2255 28.1287 12.1696C28.1282 10.7826 28.1267 9.39589 28.1256 8.00919C31.909 7.96202 35.0481 11.1297 34.9922 14.8831V14.8828Z",
                fill: "#FC83FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.7425 31.4104C18.7425 30.0748 18.7425 28.7392 18.7433 27.4039C18.7433 27.3011 18.7278 27.1969 18.7637 27.0961C19.598 27.0913 20.4322 27.0865 21.2665 27.0817C21.3597 27.0867 21.4532 27.0961 21.5464 27.0961C22.8961 27.0969 24.2455 27.0964 25.5952 27.0961C25.5995 27.1896 25.6077 27.2833 25.6077 27.3768C25.6085 28.6166 25.6082 29.8568 25.6082 31.0966C25.6082 31.1624 25.606 31.2282 25.6077 31.2937C25.6099 31.3858 25.5695 31.4341 25.4749 31.433C25.4091 31.4324 25.3433 31.4344 25.2778 31.4344C23.2017 31.4344 21.1259 31.4344 19.0498 31.4341C18.947 31.4341 18.8428 31.4474 18.7428 31.4101L18.7425 31.4104Z",
                fill: "#FFAA00"
            })
        ]
    });
};

});


parcelRegister("4bZD7", function(module, exports) {

$parcel$export(module.exports, "notionConfig", () => $a642a047af5c5832$export$ddf7404f556e473a);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $hNdl8 = parcelRequire("hNdl8");

var $5YMI0 = parcelRequire("5YMI0");
const $a642a047af5c5832$export$ddf7404f556e473a = {
    displayName: 'Notion',
    id: 'notion',
    resourceType: 'notion-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $hNdl8.NotionIcon), 'Notion', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $5YMI0.NotionSearchResultIcon), 'Notion', 'large'),
    integrationAri: 'ari:cloud:platform::integration/notion',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("hNdl8", function(module, exports) {

$parcel$export(module.exports, "NotionIcon", () => $0f79891f03378486$export$694ff710b1e20299);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $0f79891f03378486$export$694ff710b1e20299 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-683.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M5.72382 5.14736L14.0236 4.53432C15.0431 4.44687 15.305 4.50582 15.9461 4.97186L18.5955 6.83828C19.0325 7.15927 19.178 7.24672 19.178 7.59621V17.8325C19.178 18.474 18.945 18.8535 18.1295 18.9114L8.49127 19.4952C7.87928 19.5241 7.58784 19.4367 7.26729 19.0282L5.31628 16.4912C4.96634 16.0243 4.82129 15.6748 4.82129 15.2662V6.16734C4.82129 5.6428 5.05423 5.20541 5.72382 5.14736Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.0236 4.53447L5.72382 5.14751C5.05423 5.20541 4.82129 5.64295 4.82129 6.16734V15.2662C4.82129 15.6746 4.96634 16.0241 5.31628 16.4912L7.26729 19.0281C7.58784 19.4365 7.87928 19.5241 8.49127 19.495L18.1296 18.9115C18.9446 18.8535 19.1781 18.474 19.1781 17.8326V7.59636C19.1781 7.26487 19.0472 7.16932 18.6617 6.88643L15.9461 4.97186C15.3052 4.50582 15.0431 4.44687 14.0236 4.53432V4.53447ZM8.70921 7.42882C7.92218 7.48177 7.74368 7.49377 7.29669 7.13032L6.16031 6.22644C6.04482 6.10944 6.10286 5.96349 6.39386 5.9344L14.3727 5.35136C15.0427 5.29286 15.3916 5.5264 15.6536 5.7304L17.0221 6.72188C17.0806 6.75143 17.2261 6.92588 17.051 6.92588L8.81121 7.42192L8.70921 7.42882ZM7.79168 17.7452V9.05539C7.79168 8.67589 7.90823 8.50085 8.25712 8.47145L17.721 7.91736C18.042 7.88841 18.1871 8.0924 18.1871 8.4713V17.1032C18.1871 17.4827 18.1286 17.8037 17.6046 17.8326L8.54827 18.3576C8.02433 18.3866 7.79183 18.2121 7.79183 17.7452H7.79168ZM16.7315 9.52128C16.7896 9.78377 16.7315 10.0463 16.469 10.0763L16.0325 10.1628V16.5786C15.6535 16.7826 15.3046 16.8992 15.013 16.8992C14.547 16.8992 14.4306 16.7532 14.0815 16.3161L11.2271 11.8252V16.1702L12.13 16.3746C12.13 16.3746 12.13 16.8996 11.4015 16.8996L9.39305 17.0162C9.33455 16.8992 9.39305 16.6077 9.5966 16.5497L10.1211 16.4042V10.6593L9.3932 10.6004C9.3347 10.3379 9.4802 9.95882 9.88819 9.92942L12.0432 9.78437L15.0131 14.3333V10.3089L14.2561 10.2219C14.1976 9.90047 14.4306 9.66692 14.7215 9.63842L16.7315 9.52128Z",
                fill: "#292A2E"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M5.8801 5.63103L13.9736 5.03323C14.9678 4.94796 15.2232 5.00544 15.8483 5.4599L18.4319 7.27992C18.858 7.59294 18.9999 7.67822 18.9999 8.01902V18.0009C18.9999 18.6265 18.7727 18.9965 17.9774 19.053L8.57877 19.6223C7.98199 19.6505 7.69779 19.5652 7.38521 19.1669L5.48269 16.6929C5.14144 16.2376 5 15.8968 5 15.4983V6.62566C5 6.11416 5.22716 5.68764 5.8801 5.63103Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.9736 5.03338L5.8801 5.63118C5.22716 5.68764 5 6.11431 5 6.62566V15.4983C5 15.8966 5.14144 16.2374 5.48269 16.6929L7.38521 19.1668C7.69779 19.5651 7.98199 19.6505 8.57877 19.6221L17.9776 19.0531C18.7723 18.9965 19 18.6265 19 18.001V8.01917C19 7.69591 18.8723 7.60274 18.4964 7.32688L15.8483 5.4599C15.2233 5.00544 14.9678 4.94796 13.9736 5.03323V5.03338ZM8.7913 7.85579C8.02382 7.90742 7.84976 7.91912 7.41388 7.56471L6.30574 6.68329C6.19312 6.5692 6.24972 6.42688 6.53349 6.39851L14.314 5.82996C14.9674 5.77291 15.3076 6.00066 15.5631 6.19958L16.8975 7.16642C16.9546 7.19524 17.0965 7.36535 16.9258 7.36535L8.89076 7.84906L8.7913 7.85579ZM7.89657 17.9157V9.44193C7.89657 9.07187 8.01022 8.90117 8.35044 8.8725L17.5791 8.33218C17.8922 8.30395 18.0336 8.50288 18.0336 8.87236V17.2897C18.0336 17.6598 17.9766 17.9728 17.4656 18.001L8.63435 18.513C8.12343 18.5412 7.89671 18.3711 7.89671 17.9157H7.89657ZM16.6142 9.89624C16.6708 10.1522 16.6142 10.4082 16.3582 10.4374L15.9326 10.5218V16.7782C15.563 16.9771 15.2227 17.0908 14.9384 17.0908C14.4839 17.0908 14.3704 16.9485 14.0301 16.5222L11.2466 12.1429V16.3799L12.1271 16.5793C12.1271 16.5793 12.1271 17.0912 11.4167 17.0912L9.45814 17.2049C9.40109 17.0908 9.45814 16.8066 9.65662 16.75L10.1681 16.6081V11.006L9.45828 10.9485C9.40124 10.6925 9.54312 10.3229 9.94097 10.2942L12.0424 10.1528L14.9385 14.5887V10.6643L14.2003 10.5795C14.1433 10.266 14.3704 10.0383 14.6542 10.0105L16.6142 9.89624Z",
                fill: "black"
            })
        ]
    });
};

});

parcelRegister("5YMI0", function(module, exports) {

$parcel$export(module.exports, "NotionSearchResultIcon", () => $a2d13c30f30cd7d0$export$7dd377a68ecb1d9f);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $a2d13c30f30cd7d0$export$7dd377a68ecb1d9f = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-211.5",
                y: "-263.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "31",
                height: "31",
                rx: "7.5",
                stroke: "#0B1228",
                strokeOpacity: "0.14"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.63209 6.86307L18.6985 6.04568C20.0578 5.92908 20.407 6.00768 21.2618 6.62907L24.7944 9.11762C25.3769 9.54561 25.5709 9.66221 25.5709 10.1282V23.7765C25.5709 24.6319 25.2604 25.1379 24.173 25.2151L11.322 25.9935C10.506 26.0321 10.1174 25.9155 9.69005 25.3709L7.0887 21.9882C6.62211 21.3656 6.42871 20.8996 6.42871 20.3548V8.22304C6.42871 7.52365 6.7393 6.94046 7.63209 6.86307Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.6985 6.04588L7.63209 6.86327C6.7393 6.94046 6.42871 7.52385 6.42871 8.22304V20.3548C6.42871 20.8994 6.62211 21.3654 7.0887 21.9882L9.69005 25.3707C10.1174 25.9153 10.506 26.0321 11.322 25.9933L24.1732 25.2153C25.2597 25.1379 25.5711 24.6319 25.5711 23.7767V10.1284C25.5711 9.68641 25.3965 9.55901 24.8826 9.18182L21.2618 6.62907C20.4072 6.00768 20.0578 5.92908 18.6985 6.04568V6.04588ZM11.6126 9.90501C10.5632 9.97561 10.3252 9.99161 9.72925 9.50701L8.21408 8.30184C8.06008 8.14584 8.13748 7.95125 8.52547 7.91245L19.1639 7.13506C20.0572 7.05706 20.5224 7.36846 20.8718 7.64045L22.6964 8.96243C22.7744 9.00182 22.9684 9.23442 22.735 9.23442L11.7486 9.89581L11.6126 9.90501ZM10.3892 23.6601V12.0738C10.3892 11.5678 10.5446 11.3344 11.0098 11.2952L23.6284 10.5564C24.0564 10.5178 24.2498 10.7898 24.2498 11.295V22.8042C24.2498 23.3101 24.1718 23.7381 23.4732 23.7767L11.398 24.4767C10.6994 24.5153 10.3894 24.2827 10.3894 23.6601H10.3892ZM22.309 12.695C22.3864 13.0449 22.309 13.3949 21.959 13.4349L21.377 13.5503V22.1048C20.8716 22.3768 20.4064 22.5322 20.0176 22.5322C19.3963 22.5322 19.2411 22.3376 18.7757 21.7548L14.9697 15.7669V21.5602L16.1737 21.8328C16.1737 21.8328 16.1737 22.5328 15.2023 22.5328L12.5244 22.6882C12.4464 22.5322 12.5244 22.1436 12.7958 22.0662L13.4952 21.8722V14.2123L12.5246 14.1337C12.4466 13.7837 12.6406 13.2783 13.1846 13.2391L16.0579 13.0457L20.0178 19.111V13.7451L19.0085 13.6291C18.9305 13.2005 19.2411 12.8892 19.6291 12.8512L22.309 12.695Z",
                fill: "#292A2E"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.05507 6.29423L24.6546 5.06816C26.6937 4.89326 27.2175 5.01116 28.4997 5.94324L33.7985 9.67607C34.6724 10.3181 34.9633 10.493 34.9633 11.1919V31.6644C34.9633 32.9475 34.4975 33.7065 32.8664 33.8223L13.59 34.9899C12.366 35.0478 11.7831 34.8729 11.142 34.056L7.23998 28.9819C6.54009 28.048 6.25 27.349 6.25 26.5318V8.33419C6.25 7.28511 6.71589 6.41033 8.05507 6.29423Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.6546 5.06846L8.05507 6.29453C6.71589 6.41033 6.25 7.28541 6.25 8.33419V26.5318C6.25 27.3487 6.54009 28.0477 7.23998 28.9819L11.142 34.0557C11.7831 34.8726 12.366 35.0478 13.59 34.9896L32.8667 33.8226C34.4966 33.7065 34.9636 32.9475 34.9636 31.6647V11.1922C34.9636 10.5293 34.7018 10.3382 33.9308 9.77237L28.4997 5.94324C27.2178 5.01116 26.6937 4.89326 24.6546 5.06816V5.06846ZM14.0259 10.8571C12.4518 10.963 12.0948 10.987 11.2008 10.2602L8.92805 8.45239C8.69705 8.2184 8.81315 7.9265 9.39514 7.8683L25.3527 6.70222C26.6928 6.58523 27.3906 7.05232 27.9147 7.46031L30.6515 9.44327C30.7685 9.50237 31.0595 9.85126 30.7094 9.85126L14.2298 10.8433L14.0259 10.8571ZM12.1908 31.4898V14.1103C12.1908 13.3513 12.4239 13.0012 13.1217 12.9424L32.0495 11.8342C32.6915 11.7763 32.9816 12.1843 32.9816 12.9421V30.2059C32.9816 30.9649 32.8646 31.6068 31.8167 31.6647L13.704 32.7147C12.6561 32.7726 12.1911 32.4237 12.1911 31.4898H12.1908ZM30.0704 15.0421C30.1865 15.5671 30.0704 16.092 29.5455 16.152L28.6725 16.3251V29.1568C27.9144 29.5648 27.2166 29.7979 26.6334 29.7979C25.7013 29.7979 25.4685 29.506 24.7704 28.6318L19.0616 19.65V28.3399L20.8675 28.7488C20.8675 28.7488 20.8675 29.7988 19.4104 29.7988L15.3935 30.0319C15.2765 29.7979 15.3935 29.215 15.8006 29.0989L16.8497 28.8079V17.3181L15.3938 17.2002C15.2768 16.6752 15.5678 15.9171 16.3838 15.8583L20.6938 15.5683L26.6337 24.6662V16.6173L25.1196 16.4433C25.0026 15.8004 25.4685 15.3334 26.0505 15.2764L30.0704 15.0421Z",
                fill: "black"
            })
        ]
    });
};

});


parcelRegister("7ndEw", function(module, exports) {

$parcel$export(module.exports, "oneDriveConfig", () => $2998c4f2928fc744$export$b3b3a7aaf94fe09);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $eeKhr = parcelRequire("eeKhr");

var $4hMyx = parcelRequire("4hMyx");
const $2998c4f2928fc744$export$b3b3a7aaf94fe09 = {
    displayName: 'OneDrive',
    id: 'onedrive',
    resourceType: 'onedrive-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $eeKhr.OneDriveIcon), 'OneDrive', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $4hMyx.OneDriveSearchResultIcon), 'OneDrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Presentation,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("eeKhr", function(module, exports) {

$parcel$export(module.exports, "OneDriveIcon", () => $fd00bcb624b7f12e$export$44884401d09e251c);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $fd00bcb624b7f12e$export$44884401d09e251c = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.0419 9.65028L10.042 9.64971L13.5059 11.7245L15.5699 10.8559C15.9893 10.6746 16.4415 10.5816 16.8985 10.5821C16.9746 10.5821 17.0499 10.5855 17.1247 10.5905C16.8766 9.62289 16.3527 8.74817 15.6168 8.07266C14.8809 7.39715 13.9646 6.94992 12.9794 6.78533C11.9941 6.62073 10.9822 6.74586 10.0667 7.1455C9.15118 7.54513 8.37146 8.20208 7.82227 9.0365C7.83991 9.03628 7.85729 9.03517 7.87497 9.03517C8.6405 9.03414 9.39106 9.24719 10.0419 9.65028Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.0421 9.64982L10.0419 9.65039C9.39112 9.2473 8.64056 9.03425 7.87503 9.03528C7.85734 9.03528 7.83994 9.03639 7.82232 9.03661C7.07306 9.04589 6.34049 9.25916 5.70334 9.65351C5.06618 10.0479 4.54853 10.6084 4.20601 11.2748C3.86349 11.9413 3.70904 12.6885 3.75928 13.4361C3.80951 14.1837 4.06252 14.9035 4.49112 15.5182L7.54571 14.2327L8.90358 13.6613L11.927 12.389L13.5059 11.7246L10.0421 9.64982Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.1247 10.5906C17.0499 10.5856 16.9746 10.5822 16.8985 10.5822C16.4416 10.5817 15.9894 10.675 15.57 10.8564L13.5059 11.7246L14.1044 12.0831L16.0663 13.2583L16.9223 13.771L19.8492 15.5242C20.1151 15.0305 20.253 14.4779 20.25 13.9171C20.2471 13.3564 20.1035 12.8053 19.8324 12.3144C19.5613 11.8235 19.1714 11.4084 18.6983 11.1073C18.2253 10.8061 17.6842 10.6285 17.1247 10.5906Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.9219 13.771L16.066 13.2582L14.104 12.0831L13.5055 11.7245L11.9266 12.389L8.90317 13.6613L7.54531 14.2327L4.49072 15.5181C4.87031 16.0639 5.37634 16.5096 5.9656 16.8174C6.55486 17.1251 7.20985 17.2856 7.87462 17.2853H16.8981C17.5031 17.2855 18.0969 17.1218 18.6164 16.8118C19.1359 16.5017 19.5618 16.0567 19.8488 15.5241L16.9219 13.771Z",
                fill: "#28A8EA"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "-1 0 26 26",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
            id: "OneDrive",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                    fill: "none",
                    width: "24",
                    height: "24"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M14.5,15l4.95-4.74A7.5,7.5,0,0,0,5.92,8C6,8,14.5,15,14.5,15Z",
                    fill: "#0364BA"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M9.15,8.89h0A6,6,0,0,0,6,8H5.92a6,6,0,0,0-4.84,9.43L8.5,16.5l5.69-4.59Z",
                    fill: "#0078D4"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M19.45,10.26h-.32a4.84,4.84,0,0,0-1.94.4h0l-3,1.26L17.5,16l5.92,1.44a4.88,4.88,0,0,0-4-7.18Z",
                    fill: "#1490DF"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M1.08,17.43A6,6,0,0,0,6,20H19.13a4.89,4.89,0,0,0,4.29-2.56l-9.23-5.53Z",
                    fill: "#28A8EA"
                })
            ]
        })
    });
};

});

parcelRegister("4hMyx", function(module, exports) {

$parcel$export(module.exports, "OneDriveSearchResultIcon", () => $93e6be9a540c3c0f$export$f2ab3f3a9966c07c);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $93e6be9a540c3c0f$export$f2ab3f3a9966c07c = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-19.5",
                y: "-23.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.508324",
                y: "0.508324",
                width: "30.9834",
                height: "30.9834",
                rx: "7.49168",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "1.01665"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.3891 12.867L13.3894 12.8662L18.0077 15.6326L20.7598 14.4745C21.319 14.2327 21.922 14.1088 22.5312 14.1094C22.6327 14.1094 22.733 14.114 22.8329 14.1206C22.502 12.8305 21.8035 11.6642 20.8223 10.7635C19.8411 9.86286 18.6195 9.26656 17.3058 9.0471C15.9921 8.82765 14.6429 8.99448 13.4222 9.52732C12.2016 10.0602 11.1619 10.9361 10.4297 12.0486C10.4532 12.0484 10.4764 12.0469 10.5 12.0469C11.5207 12.0455 12.5214 12.3296 13.3891 12.867Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.3894 12.8664L13.3892 12.8671C12.5214 12.3297 11.5207 12.0456 10.5 12.047C10.4764 12.047 10.4532 12.0485 10.4297 12.0488C9.43071 12.0611 8.45396 12.3455 7.60443 12.8713C6.75489 13.3971 6.0647 14.1444 5.608 15.033C5.15131 15.9216 4.94539 16.9179 5.01237 17.9147C5.07935 18.9115 5.41669 19.8713 5.98816 20.6908L10.0609 18.9769L11.8714 18.215L15.9026 16.5186L18.0078 15.6327L13.3894 12.8664Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M22.8327 14.1208C22.7329 14.1141 22.6325 14.1095 22.531 14.1095C21.9218 14.1089 21.3189 14.2333 20.7597 14.4751L18.0076 15.6327L18.8056 16.1107L21.4215 17.6776L22.5628 18.3613L26.4653 20.6988C26.8199 20.0405 27.0036 19.3038 26.9997 18.5561C26.9958 17.8084 26.8044 17.0737 26.4429 16.4191C26.0815 15.7646 25.5616 15.2112 24.9308 14.8097C24.3001 14.4081 23.5787 14.1713 22.8327 14.1208Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M22.5626 18.3612L21.4213 17.6776L18.8054 16.1107L18.0074 15.6327L15.9022 16.5186L11.871 18.215L10.0605 18.9768L5.98779 20.6907C6.49391 21.4184 7.16861 22.0127 7.95428 22.4231C8.73996 22.8334 9.61327 23.0474 10.4996 23.0469H22.5309C23.3376 23.0472 24.1292 22.829 24.8219 22.4156C25.5146 22.0021 26.0824 21.4089 26.4651 20.6988L22.5626 18.3612Z",
                fill: "#28A8EA"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.4398 15.3371L16.4401 15.3361L22.7379 19.1084L26.4906 17.5292C27.2532 17.1995 28.0755 17.0304 28.9063 17.0312C29.0447 17.0312 29.1815 17.0375 29.3176 17.0466C28.8664 15.2873 27.914 13.6969 26.576 12.4687C25.238 11.2405 23.5721 10.4274 21.7806 10.1282C19.9892 9.82889 18.1495 10.0564 16.4849 10.783C14.8204 11.5096 13.4027 12.704 12.4042 14.2212C12.4363 14.2208 12.4678 14.2187 12.5 14.2187C13.8919 14.2169 15.2565 14.6042 16.4398 15.3371Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.4401 15.3361L16.4398 15.3371C15.2565 14.6042 13.8919 14.2169 12.5 14.2188C12.4678 14.2188 12.4362 14.2208 12.4042 14.2212C11.0419 14.238 9.70995 14.6258 8.55149 15.3428C7.39304 16.0598 6.45186 17.0789 5.8291 18.2906C5.20634 19.5023 4.92553 20.8608 5.01687 22.2202C5.1082 23.5795 5.56822 24.8882 6.34749 26.0057L11.9012 23.6686L14.3701 22.6297L19.8671 20.3164L22.7379 19.1084L16.4401 15.3361Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M29.3176 17.0466C29.1815 17.0375 29.0447 17.0313 28.9063 17.0313C28.0755 17.0304 27.2534 17.2001 26.4908 17.5298L22.7379 19.1084L23.8261 19.7602L27.3933 21.8969L28.9496 22.8291L34.2712 26.0167C34.7547 25.119 35.0053 24.1144 34.9999 23.0948C34.9946 22.0752 34.7336 21.0733 34.2407 20.1807C33.7478 19.2882 33.0388 18.5336 32.1787 17.986C31.3186 17.4385 30.3349 17.1155 29.3176 17.0466Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M28.9496 22.8291L27.3933 21.8969L23.8261 19.7602L22.7379 19.1084L19.8672 20.3164L14.3701 22.6297L11.9013 23.6686L6.34753 26.0057C7.03769 26.998 7.95774 27.8085 9.02911 28.368C10.1005 28.9275 11.2914 29.2194 12.5 29.2188H28.9063C30.0063 29.2191 31.0859 28.9216 32.0305 28.3578C32.975 27.794 33.7493 26.985 34.2712 26.0167L28.9496 22.8291Z",
                fill: "#28A8EA"
            })
        ]
    });
};

});


parcelRegister("iAV9u", function(module, exports) {

$parcel$export(module.exports, "outlookCalendarConfig", () => $a54cb566eb58c8e6$export$3e5044818f2e9ef3);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $bopgU = parcelRequire("bopgU");

var $995xT = parcelRequire("995xT");
const $a54cb566eb58c8e6$export$3e5044818f2e9ef3 = {
    displayName: 'Outlook Calendar',
    id: 'outlook-calendar',
    resourceType: 'outlook-calendar-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $bopgU.OutlookCalendarIcon), 'Outlook Calendar', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $995xT.OutlookCalendarSearchResultIcon), 'Outlook Calendar', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("bopgU", function(module, exports) {

$parcel$export(module.exports, "OutlookCalendarIcon", () => $7af70a3b25535c1d$export$62b570fbaf793397);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $7af70a3b25535c1d$export$62b570fbaf793397 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.1963 5.81042H9.67074C9.33358 5.81042 9.05615 6.08496 9.05615 6.4186V7.10989L13.2978 8.40948L17.8109 7.10989V6.4186C17.8109 6.08496 17.5335 5.81042 17.1963 5.81042Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.5332 12.4833C18.5973 12.2839 18.6485 12.0806 18.6864 11.8747C18.6864 11.7717 18.6308 11.6762 18.5406 11.6247L18.535 11.6217L18.5332 11.6209L13.7889 8.94645C13.7685 8.93335 13.7473 8.92131 13.7255 8.91047C13.5418 8.82037 13.3257 8.82037 13.142 8.91047C13.1202 8.92131 13.099 8.93328 13.0785 8.94645L8.33435 11.6209L8.33257 11.6217L8.32684 11.6247C8.23674 11.6762 8.18109 11.7717 8.18115 11.8747C8.21904 12.0806 8.27023 12.2839 8.33435 12.4833L13.3648 16.124L18.5332 12.4833Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.1842 7.10992H12.1201L11.2354 8.40952L12.1201 9.70898L15.1842 12.308H17.8106V9.70898L15.1842 7.10992Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 7.10999H12.1203V9.70898H9.05615V7.10999Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 7.10999H17.811V9.70898H15.1846V7.10999Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.1845 12.308L12.1203 9.70898H9.05615V12.308L12.1203 14.907L16.8619 15.6729L15.1845 12.308Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1201 9.70898H15.1843V12.308H12.1201V9.70898Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 12.3081H12.1203V14.9071H9.05615V12.3081Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 12.3081H17.811V14.9071H15.1846V12.3081Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.5172 15.8678L8.35449 12.1426L8.57073 11.7662C8.57073 11.7662 13.2742 14.4171 13.346 14.457C13.4054 14.4806 13.4723 14.4788 13.5303 14.4518C13.5972 14.4145 18.3156 11.7532 18.3156 11.7532L18.5327 12.1296L13.5172 15.8678Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.5407 12.1248L18.535 12.1282L18.5337 12.1291L13.7895 14.8035C13.5981 14.9257 13.3556 14.9406 13.1504 14.8429L14.8028 17.0352L18.4159 17.8136V17.8154C18.5863 17.6935 18.6874 17.4976 18.6873 17.2895V11.8749C18.6874 11.9778 18.6317 12.0734 18.5416 12.1248H18.5407Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.6864 17.2894V16.9698L14.3164 14.5059L13.7889 14.803C13.5976 14.9251 13.3551 14.9401 13.1499 14.8424L14.8023 17.0347L18.4154 17.8131V17.8149C18.5858 17.6929 18.6868 17.497 18.6868 17.289L18.6864 17.2894Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.6645 17.4555L13.8743 14.7551L13.7889 14.8032C13.5976 14.9253 13.3551 14.9403 13.1499 14.8426L14.8023 17.0349L18.4154 17.8133V17.815C18.538 17.7271 18.6262 17.5999 18.6649 17.4551L18.6645 17.4555Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.33388 12.1304V12.1261H8.32955L8.31637 12.1175C8.23142 12.0657 8.17985 11.9736 8.18067 11.8749V17.2904C8.18067 17.6463 8.4767 17.9393 8.83646 17.9393H18.0299C18.0845 17.9387 18.1389 17.9314 18.1918 17.9176C18.2192 17.9129 18.2458 17.9041 18.2706 17.8916C18.2799 17.8907 18.2888 17.8877 18.2968 17.8829C18.3326 17.8684 18.3665 17.8495 18.3975 17.8266L18.415 17.8136L8.33388 12.1304Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.5581 15.6292V8.55423C12.5571 8.2378 12.2943 7.97775 11.9745 7.97681H9.06976V11.2065L8.33387 11.6215L8.33215 11.6223L8.32648 11.6254C8.23632 11.6769 8.18066 11.7724 8.18066 11.8753V16.2083V16.2065H11.9745C12.2943 16.2057 12.5571 15.9456 12.5581 15.6292Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.1204 16.0622V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V16.6414V16.6397H11.5368C11.8566 16.6387 12.1194 16.3787 12.1204 16.0622ZM12.1204 15.1959V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.5368C11.8566 15.7724 12.1194 15.5123 12.1204 15.1959ZM11.6826 15.1959V8.98728C11.6816 8.6709 11.4189 8.41086 11.0991 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.0991C11.4189 15.7724 11.6816 15.5123 11.6826 15.1959Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M5.26223 8.40955H11.0985C11.4186 8.40955 11.6821 8.67016 11.6821 8.98691V14.7624C11.6821 15.0791 11.4186 15.3398 11.0985 15.3398H5.26223C4.94213 15.3398 4.67871 15.0791 4.67871 14.7624V8.98691C4.67871 8.67016 4.94213 8.40955 5.26223 8.40955Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.37132 10.7781C6.52637 10.4511 6.77674 10.1774 7.09008 9.99232C7.4373 9.7956 7.83266 9.69762 8.2326 9.70902C8.603 9.70096 8.96862 9.7939 9.28929 9.97757C9.59104 10.1554 9.83409 10.4163 9.98876 10.7283C10.1572 11.0721 10.2413 11.4504 10.2339 11.8324C10.2421 12.2317 10.1556 12.6274 9.98137 12.9877C9.82327 13.3108 9.5729 13.581 9.26127 13.7648C8.92812 13.9543 8.54887 14.0498 8.16472 14.0407C7.7863 14.0496 7.41259 13.9557 7.08441 13.7691C6.7803 13.591 6.53433 13.3299 6.37616 13.0171C6.20659 12.6783 6.12158 12.304 6.1284 11.926C6.12088 11.5301 6.20411 11.1377 6.37176 10.7781H6.37132ZM7.13733 12.6225C7.22004 12.8292 7.36032 13.0086 7.54185 13.1397C7.72658 13.2677 7.94804 13.3338 8.17345 13.3282C8.41363 13.3375 8.65044 13.2694 8.84802 13.1341C9.02733 13.003 9.16391 12.8227 9.2407 12.6156C9.32705 12.3847 9.36958 12.14 9.36633 11.8939C9.36901 11.6457 9.32902 11.3986 9.24815 11.1636C9.17684 10.952 9.04516 10.7653 8.86903 10.6261C8.67667 10.4839 8.4405 10.4117 8.20064 10.4216C7.97032 10.4157 7.7439 10.4821 7.55408 10.6113C7.36917 10.7428 7.22577 10.9237 7.14083 11.1329C6.95299 11.6117 6.95191 12.143 7.13777 12.6225H7.13733Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M25.4456 5.5H12.5525C11.9748 5.5 11.4995 5.97531 11.4995 6.55295V7.74978L18.7665 9.99978L26.4985 7.74978V6.55295C26.4985 5.97531 26.0232 5.5 25.4456 5.5Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.7358 17.053C27.8457 16.7078 27.9334 16.3558 27.9983 15.9993C27.9984 15.821 27.903 15.6557 27.7486 15.5666L27.7389 15.5613L27.7358 15.5599L19.6078 10.9297C19.5728 10.907 19.5364 10.8861 19.4991 10.8674C19.1844 10.7114 18.8141 10.7114 18.4994 10.8674C18.4621 10.8861 18.4258 10.9069 18.3906 10.9297L10.2627 15.5599L10.2597 15.5613L10.2498 15.5666C10.0955 15.6557 10.0001 15.821 10.0002 15.9993C10.0652 16.3558 10.1529 16.7078 10.2627 17.053L18.8811 23.3563L27.7358 17.053Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M21.9988 7.74982H16.7491L15.2334 9.99982L16.7491 12.2496L21.9988 16.7493H26.4985V12.2496L21.9988 7.74982Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4996 7.74982H16.7493V12.2495H11.4996V7.74982Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.9989 7.74982H26.4986V12.2495H21.9989V7.74982Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M21.999 16.7492L16.7493 12.2496H11.4996V16.7492L16.7493 21.249L24.8728 22.5749L21.999 16.7492Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.7493 12.2496H21.9989V16.7492H16.7493V12.2496Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4996 16.7493H16.7493V21.2489H11.4996V16.7493Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.9989 16.7493H26.4986V21.2489H21.9989V16.7493Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.1423 22.9124L10.2974 16.4628L10.6678 15.8111C10.6678 15.8111 18.7261 20.4008 18.849 20.4698C18.9509 20.5107 19.0654 20.5075 19.1648 20.4608C19.2795 20.3963 27.3632 15.7886 27.3632 15.7886L27.7352 16.4403L19.1423 22.9124Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.7488 16.4321L27.7391 16.4381L27.7368 16.4396L19.6089 21.0699C19.2809 21.2813 18.8655 21.3072 18.5139 21.1381L21.3449 24.9336L27.5351 26.2813V26.2843C27.8269 26.0732 28.0001 25.7341 28 25.3739V15.9995C28.0001 16.1777 27.9047 16.3431 27.7503 16.4321H27.7488Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.9985 25.3738V24.8204L20.5117 20.5546L19.608 21.0691C19.2802 21.2805 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2835C27.8262 26.0723 27.9993 25.7333 27.9993 25.3731L27.9985 25.3738Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.9611 25.661L19.7543 20.9858L19.608 21.0691C19.2802 21.2805 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2835C27.7443 26.1312 27.8954 25.911 27.9618 25.6603L27.9611 25.661Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.2621 16.4419V16.4344H10.2547L10.2321 16.4195C10.0866 16.3299 9.99823 16.1703 9.99965 15.9995V25.3754C9.99965 25.9916 10.5068 26.4988 11.1232 26.4988H26.8737C26.9673 26.4978 27.0606 26.4853 27.1511 26.4613C27.1982 26.4531 27.2437 26.4379 27.2862 26.4163C27.3021 26.4147 27.3174 26.4096 27.3311 26.4013C27.3925 26.3762 27.4505 26.3435 27.5036 26.3037L27.5336 26.2813L10.2621 16.4419Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.4992 22.4993V10.2503C17.4976 9.70247 17.0473 9.25225 16.4995 9.25061H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V23.5019V23.4989H16.4995C17.0473 23.4973 17.4976 23.047 17.4992 22.4993Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.7493 23.2491V11.0002C16.7477 10.4525 16.2973 10.0022 15.7496 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V24.2519V24.2489H15.7496C16.2973 24.2472 16.7477 23.797 16.7493 23.2491ZM16.7493 21.7493V11.0002C16.7477 10.4525 16.2973 10.0022 15.7496 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V22.7519V22.749H15.7496C16.2973 22.7473 16.7477 22.2971 16.7493 21.7493ZM15.9993 21.7493V11.0002C15.9977 10.4525 15.5475 10.0022 14.9997 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V22.7519V22.749H14.9997C15.5475 22.7473 15.9977 22.2971 15.9993 21.7493Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M4.99971 9.99988H14.9988C15.5472 9.99988 15.9985 10.4511 15.9985 10.9995V20.9986C15.9985 21.547 15.5472 21.9984 14.9988 21.9984H4.99971C4.45131 21.9984 4 21.547 4 20.9986V10.9995C4 10.4511 4.45131 9.99988 4.99971 9.99988Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.90014 14.1005C7.16577 13.5344 7.59472 13.0606 8.13155 12.7401C8.72643 12.3995 9.40377 12.2299 10.089 12.2497C10.7236 12.2357 11.35 12.3966 11.8993 12.7146C12.4163 13.0225 12.8327 13.4741 13.0977 14.0143C13.3864 14.6095 13.5304 15.2645 13.5177 15.9259C13.5318 16.6172 13.3835 17.3023 13.085 17.9261C12.8142 18.4854 12.3852 18.9533 11.8513 19.2715C11.2806 19.5995 10.6308 19.7648 9.97268 19.7492C9.32435 19.7646 8.6841 19.6019 8.12185 19.2789C7.60083 18.9705 7.17941 18.5185 6.90843 17.977C6.61792 17.3903 6.47228 16.7425 6.48395 16.0879C6.47108 15.4025 6.61366 14.7231 6.9009 14.1005H6.90014ZM8.2125 17.2938C8.35421 17.6517 8.59454 17.9623 8.90555 18.1892C9.22203 18.4109 9.60145 18.5252 9.98763 18.5155C10.3991 18.5318 10.8048 18.4138 11.1433 18.1795C11.4505 17.9526 11.6845 17.6404 11.8161 17.2818C11.964 16.8821 12.0369 16.4585 12.0313 16.0324C12.0359 15.6026 11.9674 15.1749 11.8289 14.768C11.7067 14.4017 11.4811 14.0783 11.1793 13.8374C10.8498 13.5913 10.4452 13.4662 10.0342 13.4834C9.63963 13.4731 9.2517 13.5881 8.9265 13.8118C8.6097 14.0395 8.36403 14.3527 8.2185 14.7148C7.89668 15.5438 7.89483 16.4636 8.21326 17.2938H8.2125Z",
                fill: "white"
            })
        ]
    });
};

});

parcelRegister("995xT", function(module, exports) {

$parcel$export(module.exports, "OutlookCalendarSearchResultIcon", () => $bb93716e5602aa73$export$c93fd0887f18cc87);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $bb93716e5602aa73$export$c93fd0887f18cc87 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-19.5",
                y: "-71.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.508324",
                y: "0.508324",
                width: "30.9834",
                height: "30.9834",
                rx: "7.49168",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "1.01665"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M22.9285 7.74731H12.8944C12.4449 7.74731 12.075 8.11336 12.075 8.55822V9.47993L17.7305 11.2127L23.7479 9.47993V8.55822C23.7479 8.11336 23.378 7.74731 22.9285 7.74731Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M24.7109 16.6444C24.7964 16.3785 24.8647 16.1075 24.9152 15.8329C24.9153 15.6955 24.8411 15.5683 24.7208 15.4996L24.7133 15.4956L24.7109 15.4945L18.3853 11.9286C18.358 11.9111 18.3297 11.8951 18.3007 11.8806C18.0558 11.7605 17.7676 11.7605 17.5227 11.8806C17.4936 11.8951 17.4654 11.911 17.438 11.9286L11.1125 15.4945L11.1101 15.4956L11.1025 15.4996C10.9823 15.5683 10.9081 15.6955 10.9082 15.8329C10.9587 16.1075 11.027 16.3785 11.1125 16.6444L17.8197 21.4987L24.7109 16.6444Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.2461 9.47986H16.1606L14.981 11.2126L16.1606 12.9453L20.2461 16.4106H23.748V12.9453L20.2461 9.47986Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.075 9.47992H16.1605V12.9452H12.075V9.47992Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2461 9.47992H23.748V12.9452H20.2461V9.47992Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.2461 16.4106L16.1605 12.9453H12.075V16.4106L16.1605 19.876L22.4826 20.8972L20.2461 16.4106Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.1606 12.9453H20.2462V16.4106H16.1606V12.9453Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.075 16.4109H16.1605V19.8762H12.075V16.4109Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2461 16.4109H23.748V19.8762H20.2461V16.4109Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.0228 21.1571L11.1392 16.1901L11.4275 15.6882C11.4275 15.6882 17.6988 19.2228 17.7945 19.276C17.8738 19.3075 17.9629 19.305 18.0403 19.269C18.1295 19.2194 24.4207 15.6709 24.4207 15.6709L24.7102 16.1728L18.0228 21.1571Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M24.7207 16.1663L24.7132 16.1709L24.7114 16.1721L18.3858 19.738C18.1306 19.9008 17.8073 19.9207 17.5337 19.7905L19.7369 22.7135L24.5544 23.7514V23.7538C24.7815 23.5912 24.9163 23.33 24.9163 23.0526V15.8331C24.9163 15.9704 24.8421 16.0978 24.7219 16.1663H24.7207Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M24.9149 23.0525V22.6263L19.0883 19.3411L18.385 19.7373C18.1299 19.9002 17.8066 19.9202 17.533 19.7898L19.7362 22.7129L24.5537 23.7508V23.7531C24.7808 23.5905 24.9155 23.3294 24.9155 23.0519L24.9149 23.0525Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M24.8858 23.274L18.4989 19.6735L18.385 19.7376C18.1299 19.9004 17.8066 19.9204 17.533 19.7901L19.7362 22.7132L24.5537 23.7511V23.7534C24.7171 23.6361 24.8347 23.4665 24.8863 23.2734L24.8858 23.274Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.1118 16.1739V16.1681H11.106L11.0884 16.1566C10.9751 16.0876 10.9064 15.9647 10.9075 15.8331V23.0538C10.9075 23.5284 11.3022 23.919 11.7819 23.919H24.0397C24.1126 23.9182 24.1852 23.9086 24.2556 23.8901C24.2922 23.8838 24.3276 23.8721 24.3607 23.8555C24.3731 23.8542 24.385 23.8502 24.3957 23.8439C24.4434 23.8245 24.4886 23.7993 24.5299 23.7688L24.5533 23.7514L11.1118 16.1739Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.744 20.8389V11.4056C16.7427 10.9837 16.3924 10.637 15.966 10.6357H12.0929V14.942L11.1117 15.4953L11.1094 15.4965L11.1019 15.5005C10.9817 15.5692 10.9075 15.6965 10.9075 15.8337V21.6111V21.6087H15.966C16.3924 21.6075 16.7427 21.2607 16.744 20.8389Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.1604 21.4162V11.9829C16.1591 11.5611 15.8087 11.2144 15.3824 11.213H12.0929V14.9417L11.1117 15.495L11.1094 15.4962L11.1019 15.5002C10.9817 15.569 10.9075 15.6963 10.9075 15.8334V22.1884V22.1861H15.3824C15.8087 22.1848 16.1591 21.8381 16.1604 21.4162ZM16.1604 20.2611V11.9829C16.1591 11.5611 15.8087 11.2144 15.3824 11.213H12.0929V14.9417L11.1117 15.495L11.1094 15.4962L11.1019 15.5002C10.9817 15.569 10.9075 15.6963 10.9075 15.8334V21.0332V21.031H15.3824C15.8087 21.0297 16.1591 20.683 16.1604 20.2611ZM15.5767 20.2611V11.9829C15.5754 11.5611 15.2251 11.2144 14.7988 11.213H12.0929V14.9417L11.1117 15.495L11.1094 15.4962L11.1019 15.5002C10.9817 15.569 10.9075 15.6963 10.9075 15.8334V21.0332V21.031H14.7988C15.2251 21.0297 15.5754 20.683 15.5767 20.2611Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.0163 11.2128H14.7981C15.2249 11.2128 15.5761 11.5603 15.5761 11.9826V19.6832C15.5761 20.1056 15.2249 20.4531 14.7981 20.4531H7.0163C6.58951 20.4531 6.23828 20.1056 6.23828 19.6832V11.9826C6.23828 11.5603 6.58951 11.2128 7.0163 11.2128Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.49517 14.3708C8.7019 13.9348 9.03573 13.57 9.45352 13.3231C9.91648 13.0608 10.4436 12.9302 10.9769 12.9454C11.4707 12.9347 11.9582 13.0586 12.3858 13.3035C12.7881 13.5406 13.1122 13.8884 13.3184 14.3044C13.5431 14.7628 13.6551 15.2672 13.6453 15.7766C13.6562 16.309 13.5409 16.8366 13.3086 17.317C13.0978 17.7477 12.7639 18.1081 12.3484 18.3531C11.9042 18.6058 11.3986 18.733 10.8864 18.721C10.3818 18.7329 9.88354 18.6076 9.44597 18.3588C9.04048 18.1213 8.71252 17.7732 8.50162 17.3562C8.27553 16.9044 8.16219 16.4054 8.17128 15.9014C8.16126 15.3735 8.27222 14.8503 8.49577 14.3708H8.49517ZM9.51652 16.83C9.6268 17.1057 9.81384 17.3449 10.0559 17.5196C10.3022 17.6903 10.5975 17.7784 10.898 17.7709C11.2183 17.7834 11.534 17.6926 11.7974 17.5122C12.0365 17.3374 12.2186 17.097 12.321 16.8208C12.4361 16.513 12.4929 16.1867 12.4885 15.8586C12.4921 15.5276 12.4388 15.1982 12.331 14.8849C12.2359 14.6027 12.0603 14.3537 11.8255 14.1681C11.569 13.9786 11.2541 13.8823 10.9343 13.8955C10.6272 13.8876 10.3253 13.9762 10.0722 14.1485C9.82564 14.3238 9.63444 14.565 9.52119 14.8439C9.27073 15.4823 9.26929 16.1907 9.51711 16.83H9.51652Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M31.807 6.875H15.6906C14.9685 6.875 14.3744 7.46914 14.3744 8.19118V9.68723L23.4581 12.4997L33.1232 9.68723V8.19118C33.1232 7.46914 32.529 6.875 31.807 6.875Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M34.6699 21.3163C34.8073 20.8847 34.9169 20.4448 34.998 19.9992C34.9982 19.7762 34.879 19.5696 34.6859 19.4582L34.6738 19.4517L34.6699 19.4499L24.5099 13.6621C24.4661 13.6337 24.4207 13.6077 24.3741 13.5842C23.9807 13.3892 23.5179 13.3892 23.1244 13.5842C23.0778 13.6077 23.0324 13.6336 22.9885 13.6621L12.8286 19.4499L12.8248 19.4517L12.8125 19.4582C12.6195 19.5696 12.5004 19.7762 12.5005 19.9992C12.5816 20.4448 12.6913 20.8847 12.8286 21.3163L23.6016 29.1954L34.6699 21.3163Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.4985 9.68726H20.9364L19.0418 12.4998L20.9364 15.312L27.4985 20.9366H33.1231V15.312L27.4985 9.68726Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.3745 9.68726H20.9365V15.3118H14.3745V9.68726Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.4987 9.68726H33.1233V15.3118H27.4987V9.68726Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.4986 20.9365L20.9365 15.312H14.3745V20.9365L20.9365 26.5613L31.0909 28.2186L27.4986 20.9365Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.9366 15.312H27.4987V20.9365H20.9366V15.312Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.3745 20.9366H20.9365V26.5612H14.3745V20.9366Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.4987 20.9366H33.1233V26.5612H27.4987V20.9366Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M23.9279 28.6405L12.8717 20.5785L13.3348 19.7639C13.3348 19.7639 23.4076 25.501 23.5612 25.5873C23.6886 25.6384 23.8318 25.6343 23.956 25.576C24.0993 25.4954 34.204 19.7358 34.204 19.7358L34.669 20.5504L23.9279 28.6405Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M34.6859 20.5401L34.6738 20.5476L34.6709 20.5496L24.511 26.3374C24.1011 26.6016 23.5818 26.634 23.1423 26.4226L26.6811 31.167L34.4188 32.8516V32.8554C34.7836 32.5916 35.0001 32.1676 35 31.7173V19.9993C35.0001 20.2221 34.8808 20.4289 34.6878 20.5401H34.6859Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M34.9981 31.7173V31.0255L25.6396 25.6933L24.51 26.3364C24.1002 26.6007 23.5809 26.6331 23.1414 26.4216L26.6802 31.1661L34.4179 32.8506V32.8544C34.7826 32.5904 34.9991 32.1666 34.9991 31.7163L34.9981 31.7173Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M34.9513 32.0763L24.6928 26.2323L24.51 26.3363C24.1002 26.6006 23.5809 26.6331 23.1414 26.4216L26.6802 31.1661L34.4179 32.8506V32.8544C34.6804 32.664 34.8692 32.3887 34.9521 32.0753L34.9513 32.0763Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.8276 20.5524V20.543H12.8183L12.7901 20.5243C12.6082 20.4124 12.4977 20.2129 12.4995 19.9993V31.7192C12.4995 32.4896 13.1334 33.1235 13.9039 33.1235H33.5921C33.7091 33.1223 33.8257 33.1066 33.9388 33.0766C33.9976 33.0664 34.0545 33.0474 34.1077 33.0204C34.1276 33.0184 34.1467 33.012 34.1638 33.0016C34.2405 32.9702 34.313 32.9293 34.3794 32.8797L34.4169 32.8516L12.8276 20.5524Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M21.8739 28.1241V12.8129C21.8719 12.1281 21.3091 11.5653 20.6243 11.5632H14.4035V18.5527L12.8275 19.4508L12.8239 19.4527L12.8117 19.4592C12.6186 19.5708 12.4995 19.7774 12.4995 20.0001V29.3774V29.3736H20.6243C21.3091 29.3716 21.8719 28.8087 21.8739 28.1241Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.9365 29.0614V13.7502C20.9345 13.0656 20.3716 12.5028 19.6869 12.5006H14.4035V18.5527L12.8275 19.4508L12.8239 19.4527L12.8117 19.4592C12.6186 19.5708 12.4995 19.7774 12.4995 20.0001V30.3149V30.3111H19.6869C20.3716 30.309 20.9345 29.7462 20.9365 29.0614ZM20.9365 27.1866V13.7502C20.9345 13.0656 20.3716 12.5028 19.6869 12.5006H14.4035V18.5527L12.8275 19.4508L12.8239 19.4527L12.8117 19.4592C12.6186 19.5708 12.4995 19.7774 12.4995 20.0001V28.4399V28.4362H19.6869C20.3716 28.4342 20.9345 27.8714 20.9365 27.1866ZM19.999 27.1866V13.7502C19.997 13.0656 19.4342 12.5028 18.7495 12.5006H14.4035V18.5527L12.8275 19.4508L12.8239 19.4527L12.8117 19.4592C12.6186 19.5708 12.4995 19.7774 12.4995 20.0001V28.4399V28.4362H18.7495C19.4342 28.4342 19.997 27.8714 19.999 27.1866Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.24964 12.4999H18.7485C19.434 12.4999 19.9981 13.0639 19.9981 13.7494V26.2483C19.9981 26.9338 19.434 27.498 18.7485 27.498H6.24964C5.56414 27.498 5 26.9338 5 26.2483V13.7494C5 13.0639 5.56414 12.4999 6.24964 12.4999Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.62511 17.6256C8.95716 16.918 9.49334 16.3258 10.1644 15.9251C10.908 15.4994 11.7547 15.2874 12.6112 15.3121C13.4044 15.2946 14.1874 15.4957 14.8741 15.8932C15.5203 16.2781 16.0408 16.8426 16.3721 17.5179C16.7329 18.2619 16.9129 19.0806 16.8971 19.9074C16.9147 20.7715 16.7293 21.6279 16.3562 22.4076C16.0177 23.1067 15.4815 23.6916 14.8141 24.0894C14.1007 24.4994 13.2885 24.706 12.4658 24.6865C11.6554 24.7057 10.8551 24.5024 10.1522 24.0986C9.50097 23.7131 8.9742 23.1481 8.63547 22.4713C8.27234 21.7379 8.09029 20.9281 8.10488 20.1099C8.08879 19.2531 8.26702 18.4038 8.62606 17.6256H8.62511ZM10.2656 21.6172C10.4427 22.0646 10.7431 22.4529 11.1319 22.7365C11.5275 23.0136 12.0017 23.1565 12.4845 23.1444C12.9988 23.1647 13.506 23.0173 13.9291 22.7244C14.3131 22.4407 14.6056 22.0505 14.7701 21.6022C14.955 21.1026 15.0461 20.5731 15.0391 20.0405C15.0448 19.5032 14.9592 18.9686 14.786 18.46C14.6333 18.0021 14.3513 17.5979 13.9741 17.2967C13.5622 16.9891 13.0564 16.8328 12.5427 16.8542C12.0495 16.8414 11.5646 16.9851 11.1581 17.2648C10.7621 17.5494 10.455 17.9409 10.2731 18.3935C9.87079 19.4297 9.86847 20.5795 10.2665 21.6172H10.2656Z",
                fill: "white"
            })
        ]
    });
};

});


parcelRegister("9QXBv", function(module, exports) {

$parcel$export(module.exports, "outlookMail", () => $b7918401159d3e2e$export$31104d47075e6dfd);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $l9aZi = parcelRequire("l9aZi");

var $hiNbM = parcelRequire("hiNbM");
const $b7918401159d3e2e$export$31104d47075e6dfd = {
    displayName: 'Outlook Mail',
    id: 'outlook-mail',
    resourceType: 'outlook-mail-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $l9aZi.OutlookMailIcon), 'Outlook Mail', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $hiNbM.OutlookMailSearchResultIcon), 'Outlook Mail', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    requiresOauth: true,
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: [
                    (0, $idpYy.FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI)
                ],
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    isEnabled: ()=>true,
    isFederated: true
};

});
parcelRegister("l9aZi", function(module, exports) {

$parcel$export(module.exports, "OutlookMailIcon", () => $273f22d99aaf729c$export$d905606eb58fea64);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $273f22d99aaf729c$export$d905606eb58fea64 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.1963 5.81042H9.67074C9.33358 5.81042 9.05615 6.08496 9.05615 6.4186V7.10989L13.2978 8.40948L17.8109 7.10989V6.4186C17.8109 6.08496 17.5335 5.81042 17.1963 5.81042Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.5332 12.4833C18.5973 12.2839 18.6485 12.0806 18.6864 11.8747C18.6864 11.7717 18.6308 11.6762 18.5406 11.6247L18.535 11.6217L18.5332 11.6209L13.7889 8.94645C13.7685 8.93335 13.7473 8.92131 13.7255 8.91047C13.5418 8.82037 13.3257 8.82037 13.142 8.91047C13.1202 8.92131 13.099 8.93328 13.0785 8.94645L8.33435 11.6209L8.33257 11.6217L8.32684 11.6247C8.23674 11.6762 8.18109 11.7717 8.18115 11.8747C8.21904 12.0806 8.27023 12.2839 8.33435 12.4833L13.3648 16.124L18.5332 12.4833Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.1842 7.10992H12.1201L11.2354 8.40952L12.1201 9.70898L15.1842 12.308H17.8106V9.70898L15.1842 7.10992Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 7.10999H12.1203V9.70898H9.05615V7.10999Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 7.10999H17.811V9.70898H15.1846V7.10999Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.1845 12.308L12.1203 9.70898H9.05615V12.308L12.1203 14.907L16.8619 15.6729L15.1845 12.308Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1201 9.70898H15.1843V12.308H12.1201V9.70898Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 12.3081H12.1203V14.9071H9.05615V12.3081Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 12.3081H17.811V14.9071H15.1846V12.3081Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.5172 15.8678L8.35449 12.1426L8.57073 11.7662C8.57073 11.7662 13.2742 14.4171 13.346 14.457C13.4054 14.4806 13.4723 14.4788 13.5303 14.4518C13.5972 14.4145 18.3156 11.7532 18.3156 11.7532L18.5327 12.1296L13.5172 15.8678Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.5407 12.1248L18.535 12.1282L18.5337 12.1291L13.7895 14.8035C13.5981 14.9257 13.3556 14.9406 13.1504 14.8429L14.8028 17.0352L18.4159 17.8136V17.8154C18.5863 17.6935 18.6874 17.4976 18.6873 17.2895V11.8749C18.6874 11.9778 18.6317 12.0734 18.5416 12.1248H18.5407Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.6864 17.2894V16.9698L14.3164 14.5059L13.7889 14.803C13.5976 14.9251 13.3551 14.9401 13.1499 14.8424L14.8023 17.0347L18.4154 17.8131V17.8149C18.5858 17.6929 18.6868 17.497 18.6868 17.289L18.6864 17.2894Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.6645 17.4555L13.8743 14.7551L13.7889 14.8032C13.5976 14.9253 13.3551 14.9403 13.1499 14.8426L14.8023 17.0349L18.4154 17.8133V17.815C18.538 17.7271 18.6262 17.5999 18.6649 17.4551L18.6645 17.4555Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.33388 12.1304V12.1261H8.32955L8.31637 12.1175C8.23142 12.0657 8.17985 11.9736 8.18067 11.8749V17.2904C8.18067 17.6463 8.4767 17.9393 8.83646 17.9393H18.0299C18.0845 17.9387 18.1389 17.9314 18.1918 17.9176C18.2192 17.9129 18.2458 17.9041 18.2706 17.8916C18.2799 17.8907 18.2888 17.8877 18.2968 17.8829C18.3326 17.8684 18.3665 17.8495 18.3975 17.8266L18.415 17.8136L8.33388 12.1304Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.5581 15.6292V8.55423C12.5571 8.2378 12.2943 7.97775 11.9745 7.97681H9.06976V11.2065L8.33387 11.6215L8.33215 11.6223L8.32648 11.6254C8.23632 11.6769 8.18066 11.7724 8.18066 11.8753V16.2083V16.2065H11.9745C12.2943 16.2057 12.5571 15.9456 12.5581 15.6292Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.1204 16.0622V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V16.6414V16.6397H11.5368C11.8566 16.6387 12.1194 16.3787 12.1204 16.0622ZM12.1204 15.1959V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.5368C11.8566 15.7724 12.1194 15.5123 12.1204 15.1959ZM11.6826 15.1959V8.98728C11.6816 8.6709 11.4189 8.41086 11.0991 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.0991C11.4189 15.7724 11.6816 15.5123 11.6826 15.1959Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M5.26223 8.40955H11.0985C11.4186 8.40955 11.6821 8.67016 11.6821 8.98691V14.7624C11.6821 15.0791 11.4186 15.3398 11.0985 15.3398H5.26223C4.94213 15.3398 4.67871 15.0791 4.67871 14.7624V8.98691C4.67871 8.67016 4.94213 8.40955 5.26223 8.40955Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.37132 10.7781C6.52637 10.4511 6.77674 10.1774 7.09008 9.99232C7.4373 9.7956 7.83266 9.69762 8.2326 9.70902C8.603 9.70096 8.96862 9.7939 9.28929 9.97757C9.59104 10.1554 9.83409 10.4163 9.98876 10.7283C10.1572 11.0721 10.2413 11.4504 10.2339 11.8324C10.2421 12.2317 10.1556 12.6274 9.98137 12.9877C9.82327 13.3108 9.5729 13.581 9.26127 13.7648C8.92812 13.9543 8.54887 14.0498 8.16472 14.0407C7.7863 14.0496 7.41259 13.9557 7.08441 13.7691C6.7803 13.591 6.53433 13.3299 6.37616 13.0171C6.20659 12.6783 6.12158 12.304 6.1284 11.926C6.12088 11.5301 6.20411 11.1377 6.37176 10.7781H6.37132ZM7.13733 12.6225C7.22004 12.8292 7.36032 13.0086 7.54185 13.1397C7.72658 13.2677 7.94804 13.3338 8.17345 13.3282C8.41363 13.3375 8.65044 13.2694 8.84802 13.1341C9.02733 13.003 9.16391 12.8227 9.2407 12.6156C9.32705 12.3847 9.36958 12.14 9.36633 11.8939C9.36901 11.6457 9.32902 11.3986 9.24815 11.1636C9.17684 10.952 9.04516 10.7653 8.86903 10.6261C8.67667 10.4839 8.4405 10.4117 8.20064 10.4216C7.97032 10.4157 7.7439 10.4821 7.55408 10.6113C7.36917 10.7428 7.22577 10.9237 7.14083 11.1329C6.95299 11.6117 6.95191 12.143 7.13777 12.6225H7.13733Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M25.4456 5.5H12.5525C11.9748 5.5 11.4995 5.97531 11.4995 6.55295V7.74978L18.7665 9.99978L26.4985 7.74978V6.55295C26.4985 5.97531 26.0232 5.5 25.4456 5.5Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.7361 17.053C27.8459 16.7078 27.9336 16.3558 27.9985 15.9993C27.9986 15.821 27.9033 15.6557 27.7488 15.5666L27.7391 15.5613L27.7361 15.5599L19.608 10.9297C19.573 10.907 19.5367 10.8861 19.4994 10.8674C19.1846 10.7114 18.8144 10.7114 18.4997 10.8674C18.4623 10.8861 18.426 10.9069 18.3909 10.9297L10.263 15.5599L10.2599 15.5613L10.2501 15.5666C10.0957 15.6557 10.0004 15.821 10.0005 15.9993C10.0654 16.3558 10.1531 16.7078 10.263 17.053L18.8814 23.3563L27.7361 17.053Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M21.999 7.74976H16.7494L15.2336 9.99976L16.7494 12.2495L21.999 16.7492H26.4987V12.2495L21.999 7.74976Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4995 7.74976H16.7492V12.2494H11.4995V7.74976Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.999 7.74976H26.4987V12.2494H21.999V7.74976Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M21.9989 16.7493L16.7492 12.2496H11.4995V16.7493L16.7492 21.2491L24.8726 22.575L21.9989 16.7493Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.7493 12.2496H21.9989V16.7493H16.7493V12.2496Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4995 16.7493H16.7492V21.2489H11.4995V16.7493Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.999 16.7493H26.4987V21.2489H21.999V16.7493Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.1423 22.9124L10.2974 16.4629L10.6678 15.8112C10.6678 15.8112 18.7261 20.4008 18.849 20.4699C18.9509 20.5108 19.0654 20.5075 19.1648 20.4608C19.2795 20.3964 27.3632 15.7887 27.3632 15.7887L27.7352 16.4404L19.1423 22.9124Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.7488 16.4322L27.7391 16.4382L27.7368 16.4397L19.6089 21.0699C19.2809 21.2814 18.8655 21.3072 18.5139 21.1381L21.3449 24.9336L27.5351 26.2813V26.2844C27.8269 26.0733 28.0001 25.7341 28 25.3739V15.9995C28.0001 16.1778 27.9047 16.3431 27.7503 16.4322H27.7488Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.9985 25.3739V24.8205L20.5117 20.5547L19.608 21.0692C19.2802 21.2806 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2836C27.8262 26.0724 27.9993 25.7333 27.9993 25.3731L27.9985 25.3739Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.9611 25.6612L19.7543 20.986L19.608 21.0692C19.2802 21.2806 18.8648 21.3066 18.5132 21.1374L21.3442 24.933L27.5343 26.2806V26.2836C27.7443 26.1313 27.8954 25.9111 27.9618 25.6604L27.9611 25.6612Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.262 16.442V16.4345H10.2546L10.232 16.4195C10.0865 16.3299 9.99811 16.1703 9.99953 15.9995V25.3754C9.99953 25.9917 10.5067 26.4989 11.1231 26.4989H26.8736C26.9672 26.4979 27.0605 26.4853 27.151 26.4613C27.198 26.4531 27.2435 26.438 27.2861 26.4164C27.302 26.4147 27.3173 26.4096 27.331 26.4013C27.3923 26.3762 27.4504 26.3435 27.5035 26.3038L27.5335 26.2813L10.262 16.442Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.4991 22.4994V10.2504C17.4974 9.70259 17.0472 9.25237 16.4994 9.25073H11.5227V14.8423L10.262 15.5608L10.259 15.5623L10.2493 15.5675C10.0949 15.6568 9.99951 15.822 9.99951 16.0002V23.502V23.499H16.4994C17.0472 23.4975 17.4974 23.0471 17.4991 22.4994Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.7492 23.2493V11.0003C16.7475 10.4526 16.2972 10.0024 15.7495 10.0006H11.5227V14.8423L10.262 15.5608L10.259 15.5623L10.2493 15.5675C10.0949 15.6568 9.99951 15.822 9.99951 16.0002V24.252V24.249H15.7495C16.2972 24.2473 16.7475 23.7971 16.7492 23.2493ZM16.7492 21.7494V11.0003C16.7475 10.4526 16.2972 10.0024 15.7495 10.0006H11.5227V14.8423L10.262 15.5608L10.259 15.5623L10.2493 15.5675C10.0949 15.6568 9.99951 15.822 9.99951 16.0002V22.752V22.7491H15.7495C16.2972 22.7474 16.7475 22.2972 16.7492 21.7494ZM15.9992 21.7494V11.0003C15.9975 10.4526 15.5473 10.0024 14.9996 10.0006H11.5227V14.8423L10.262 15.5608L10.259 15.5623L10.2493 15.5675C10.0949 15.6568 9.99951 15.822 9.99951 16.0002V22.752V22.7491H14.9996C15.5473 22.7474 15.9975 22.2972 15.9992 21.7494Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M4.99971 9.99988H14.9988C15.5472 9.99988 15.9985 10.4511 15.9985 10.9995V20.9986C15.9985 21.547 15.5472 21.9984 14.9988 21.9984H4.99971C4.45131 21.9984 4 21.547 4 20.9986V10.9995C4 10.4511 4.45131 9.99988 4.99971 9.99988Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.90014 14.1006C7.16577 13.5345 7.59472 13.0607 8.13155 12.7402C8.72643 12.3996 9.40377 12.23 10.089 12.2497C10.7236 12.2358 11.35 12.3967 11.8993 12.7147C12.4163 13.0225 12.8327 13.4742 13.0977 14.0144C13.3864 14.6096 13.5304 15.2646 13.5177 15.926C13.5318 16.6173 13.3835 17.3024 13.085 17.9262C12.8142 18.4855 12.3852 18.9534 11.8513 19.2716C11.2806 19.5996 10.6308 19.7649 9.97268 19.7493C9.32435 19.7647 8.6841 19.602 8.12185 19.279C7.60083 18.9706 7.17941 18.5185 6.90843 17.9771C6.61792 17.3904 6.47228 16.7425 6.48395 16.088C6.47108 15.4026 6.61366 14.7231 6.9009 14.1006H6.90014ZM8.2125 17.2939C8.35421 17.6518 8.59454 17.9624 8.90555 18.1893C9.22203 18.411 9.60145 18.5253 9.98763 18.5156C10.3991 18.5318 10.8048 18.4139 11.1433 18.1796C11.4505 17.9527 11.6845 17.6404 11.8161 17.2819C11.964 16.8822 12.0369 16.4586 12.0313 16.0324C12.0359 15.6026 11.9674 15.175 11.8289 14.7681C11.7067 14.4018 11.4811 14.0784 11.1793 13.8374C10.8498 13.5913 10.4452 13.4663 10.0342 13.4834C9.63963 13.4732 9.2517 13.5882 8.9265 13.8119C8.6097 14.0396 8.36403 14.3528 8.2185 14.7148C7.89668 15.5438 7.89483 16.4637 8.21326 17.2939H8.2125Z",
                fill: "white"
            })
        ]
    });
};

});

parcelRegister("hiNbM", function(module, exports) {

$parcel$export(module.exports, "OutlookMailSearchResultIcon", () => $86cacec70bf484b1$export$f819ae7cc5008c40);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $86cacec70bf484b1$export$f819ae7cc5008c40 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-19.5",
                y: "-71.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.508324",
                y: "0.508324",
                width: "30.9834",
                height: "30.9834",
                rx: "7.49168",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "1.01665"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M22.9285 7.74731H12.8944C12.4449 7.74731 12.075 8.11336 12.075 8.55822V9.47993L17.7305 11.2127L23.7479 9.47993V8.55822C23.7479 8.11336 23.378 7.74731 22.9285 7.74731Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M24.7109 16.6444C24.7964 16.3785 24.8647 16.1075 24.9152 15.8329C24.9153 15.6955 24.8411 15.5683 24.7208 15.4996L24.7133 15.4956L24.7109 15.4945L18.3853 11.9286C18.358 11.9111 18.3297 11.8951 18.3007 11.8806C18.0558 11.7605 17.7676 11.7605 17.5227 11.8806C17.4936 11.8951 17.4654 11.911 17.438 11.9286L11.1125 15.4945L11.1101 15.4956L11.1025 15.4996C10.9823 15.5683 10.9081 15.6955 10.9082 15.8329C10.9587 16.1075 11.027 16.3785 11.1125 16.6444L17.8197 21.4987L24.7109 16.6444Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.2461 9.47986H16.1606L14.981 11.2126L16.1606 12.9453L20.2461 16.4106H23.748V12.9453L20.2461 9.47986Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.075 9.47992H16.1605V12.9452H12.075V9.47992Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2461 9.47992H23.748V12.9452H20.2461V9.47992Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.2461 16.4106L16.1605 12.9453H12.075V16.4106L16.1605 19.876L22.4826 20.8972L20.2461 16.4106Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.1606 12.9453H20.2462V16.4106H16.1606V12.9453Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.075 16.4109H16.1605V19.8762H12.075V16.4109Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2461 16.4109H23.748V19.8762H20.2461V16.4109Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.0228 21.1571L11.1392 16.1901L11.4275 15.6882C11.4275 15.6882 17.6988 19.2228 17.7945 19.276C17.8738 19.3075 17.9629 19.305 18.0403 19.269C18.1295 19.2194 24.4207 15.6709 24.4207 15.6709L24.7102 16.1728L18.0228 21.1571Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M24.7207 16.1663L24.7132 16.1709L24.7114 16.1721L18.3858 19.738C18.1306 19.9008 17.8073 19.9207 17.5337 19.7905L19.7369 22.7135L24.5544 23.7514V23.7538C24.7815 23.5912 24.9163 23.33 24.9163 23.0526V15.8331C24.9163 15.9704 24.8421 16.0978 24.7219 16.1663H24.7207Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M24.9149 23.0525V22.6263L19.0883 19.3411L18.385 19.7373C18.1299 19.9002 17.8066 19.9202 17.533 19.7898L19.7362 22.7129L24.5537 23.7508V23.7531C24.7808 23.5905 24.9155 23.3294 24.9155 23.0519L24.9149 23.0525Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M24.8858 23.274L18.4989 19.6735L18.385 19.7376C18.1299 19.9004 17.8066 19.9204 17.533 19.7901L19.7362 22.7132L24.5537 23.7511V23.7534C24.7171 23.6361 24.8347 23.4665 24.8863 23.2734L24.8858 23.274Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.1118 16.1739V16.1681H11.106L11.0884 16.1566C10.9751 16.0876 10.9064 15.9647 10.9075 15.8331V23.0538C10.9075 23.5284 11.3022 23.919 11.7819 23.919H24.0397C24.1126 23.9182 24.1852 23.9086 24.2556 23.8901C24.2922 23.8838 24.3276 23.8721 24.3607 23.8555C24.3731 23.8542 24.385 23.8502 24.3957 23.8439C24.4434 23.8245 24.4886 23.7993 24.5299 23.7688L24.5533 23.7514L11.1118 16.1739Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.744 20.8389V11.4056C16.7427 10.9837 16.3924 10.637 15.966 10.6357H12.0929V14.942L11.1117 15.4953L11.1094 15.4965L11.1019 15.5005C10.9817 15.5692 10.9075 15.6965 10.9075 15.8337V21.6111V21.6087H15.966C16.3924 21.6075 16.7427 21.2607 16.744 20.8389Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.1604 21.4162V11.9829C16.1591 11.5611 15.8087 11.2144 15.3824 11.213H12.0929V14.9417L11.1117 15.495L11.1094 15.4962L11.1019 15.5002C10.9817 15.569 10.9075 15.6963 10.9075 15.8334V22.1884V22.1861H15.3824C15.8087 22.1848 16.1591 21.8381 16.1604 21.4162ZM16.1604 20.2611V11.9829C16.1591 11.5611 15.8087 11.2144 15.3824 11.213H12.0929V14.9417L11.1117 15.495L11.1094 15.4962L11.1019 15.5002C10.9817 15.569 10.9075 15.6963 10.9075 15.8334V21.0332V21.031H15.3824C15.8087 21.0297 16.1591 20.683 16.1604 20.2611ZM15.5767 20.2611V11.9829C15.5754 11.5611 15.2251 11.2144 14.7988 11.213H12.0929V14.9417L11.1117 15.495L11.1094 15.4962L11.1019 15.5002C10.9817 15.569 10.9075 15.6963 10.9075 15.8334V21.0332V21.031H14.7988C15.2251 21.0297 15.5754 20.683 15.5767 20.2611Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.0163 11.2128H14.7981C15.2249 11.2128 15.5761 11.5603 15.5761 11.9826V19.6832C15.5761 20.1056 15.2249 20.4531 14.7981 20.4531H7.0163C6.58951 20.4531 6.23828 20.1056 6.23828 19.6832V11.9826C6.23828 11.5603 6.58951 11.2128 7.0163 11.2128Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.49517 14.3708C8.7019 13.9348 9.03573 13.57 9.45352 13.3231C9.91648 13.0608 10.4436 12.9302 10.9769 12.9454C11.4707 12.9347 11.9582 13.0586 12.3858 13.3035C12.7881 13.5406 13.1122 13.8884 13.3184 14.3044C13.5431 14.7628 13.6551 15.2672 13.6453 15.7766C13.6562 16.309 13.5409 16.8366 13.3086 17.317C13.0978 17.7477 12.7639 18.1081 12.3484 18.3531C11.9042 18.6058 11.3986 18.733 10.8864 18.721C10.3818 18.7329 9.88354 18.6076 9.44597 18.3588C9.04048 18.1213 8.71252 17.7732 8.50162 17.3562C8.27553 16.9044 8.16219 16.4054 8.17128 15.9014C8.16126 15.3735 8.27222 14.8503 8.49577 14.3708H8.49517ZM9.51652 16.83C9.6268 17.1057 9.81384 17.3449 10.0559 17.5196C10.3022 17.6903 10.5975 17.7784 10.898 17.7709C11.2183 17.7834 11.534 17.6926 11.7974 17.5122C12.0365 17.3374 12.2186 17.097 12.321 16.8208C12.4361 16.513 12.4929 16.1867 12.4885 15.8586C12.4921 15.5276 12.4388 15.1982 12.331 14.8849C12.2359 14.6027 12.0603 14.3537 11.8255 14.1681C11.569 13.9786 11.2541 13.8823 10.9343 13.8955C10.6272 13.8876 10.3253 13.9762 10.0722 14.1485C9.82564 14.3238 9.63444 14.565 9.52119 14.8439C9.27073 15.4823 9.26929 16.1907 9.51711 16.83H9.51652Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M31.807 6.875H15.6906C14.9685 6.875 14.3744 7.46914 14.3744 8.19118V9.68723L23.4581 12.4997L33.1232 9.68723V8.19118C33.1232 7.46914 32.529 6.875 31.807 6.875Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M34.6699 21.3163C34.8073 20.8847 34.9169 20.4448 34.998 19.9992C34.9982 19.7762 34.879 19.5696 34.6859 19.4582L34.6738 19.4517L34.6699 19.4499L24.5099 13.6621C24.4661 13.6337 24.4207 13.6077 24.3741 13.5842C23.9807 13.3892 23.5179 13.3892 23.1244 13.5842C23.0778 13.6077 23.0324 13.6336 22.9885 13.6621L12.8286 19.4499L12.8248 19.4517L12.8125 19.4582C12.6195 19.5696 12.5004 19.7762 12.5005 19.9992C12.5816 20.4448 12.6913 20.8847 12.8286 21.3163L23.6016 29.1954L34.6699 21.3163Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.4985 9.68726H20.9364L19.0418 12.4998L20.9364 15.312L27.4985 20.9366H33.1231V15.312L27.4985 9.68726Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.3745 9.68726H20.9365V15.3118H14.3745V9.68726Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.4987 9.68726H33.1233V15.3118H27.4987V9.68726Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.4986 20.9365L20.9365 15.312H14.3745V20.9365L20.9365 26.5613L31.0909 28.2186L27.4986 20.9365Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.9366 15.312H27.4987V20.9365H20.9366V15.312Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.3745 20.9366H20.9365V26.5612H14.3745V20.9366Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.4987 20.9366H33.1233V26.5612H27.4987V20.9366Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M23.9279 28.6405L12.8717 20.5785L13.3348 19.7639C13.3348 19.7639 23.4076 25.501 23.5612 25.5873C23.6886 25.6384 23.8318 25.6343 23.956 25.576C24.0993 25.4954 34.204 19.7358 34.204 19.7358L34.669 20.5504L23.9279 28.6405Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M34.6859 20.5401L34.6738 20.5476L34.6709 20.5496L24.511 26.3374C24.1011 26.6016 23.5818 26.634 23.1423 26.4226L26.6811 31.167L34.4188 32.8516V32.8554C34.7836 32.5916 35.0001 32.1676 35 31.7173V19.9993C35.0001 20.2221 34.8808 20.4289 34.6878 20.5401H34.6859Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M34.9981 31.7173V31.0255L25.6396 25.6933L24.51 26.3364C24.1002 26.6007 23.5809 26.6331 23.1414 26.4216L26.6802 31.1661L34.4179 32.8506V32.8544C34.7826 32.5904 34.9991 32.1666 34.9991 31.7163L34.9981 31.7173Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M34.9513 32.0763L24.6928 26.2323L24.51 26.3363C24.1002 26.6006 23.5809 26.6331 23.1414 26.4216L26.6802 31.1661L34.4179 32.8506V32.8544C34.6804 32.664 34.8692 32.3887 34.9521 32.0753L34.9513 32.0763Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.8276 20.5524V20.543H12.8183L12.7901 20.5243C12.6082 20.4124 12.4977 20.2129 12.4995 19.9993V31.7192C12.4995 32.4896 13.1334 33.1235 13.9039 33.1235H33.5921C33.7091 33.1223 33.8257 33.1066 33.9388 33.0766C33.9976 33.0664 34.0545 33.0474 34.1077 33.0204C34.1276 33.0184 34.1467 33.012 34.1638 33.0016C34.2405 32.9702 34.313 32.9293 34.3794 32.8797L34.4169 32.8516L12.8276 20.5524Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M21.8739 28.1241V12.8129C21.8719 12.1281 21.3091 11.5653 20.6243 11.5632H14.4035V18.5527L12.8275 19.4508L12.8239 19.4527L12.8117 19.4592C12.6186 19.5708 12.4995 19.7774 12.4995 20.0001V29.3774V29.3736H20.6243C21.3091 29.3716 21.8719 28.8087 21.8739 28.1241Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.9365 29.0614V13.7502C20.9345 13.0656 20.3716 12.5028 19.6869 12.5006H14.4035V18.5527L12.8275 19.4508L12.8239 19.4527L12.8117 19.4592C12.6186 19.5708 12.4995 19.7774 12.4995 20.0001V30.3149V30.3111H19.6869C20.3716 30.309 20.9345 29.7462 20.9365 29.0614ZM20.9365 27.1866V13.7502C20.9345 13.0656 20.3716 12.5028 19.6869 12.5006H14.4035V18.5527L12.8275 19.4508L12.8239 19.4527L12.8117 19.4592C12.6186 19.5708 12.4995 19.7774 12.4995 20.0001V28.4399V28.4362H19.6869C20.3716 28.4342 20.9345 27.8714 20.9365 27.1866ZM19.999 27.1866V13.7502C19.997 13.0656 19.4342 12.5028 18.7495 12.5006H14.4035V18.5527L12.8275 19.4508L12.8239 19.4527L12.8117 19.4592C12.6186 19.5708 12.4995 19.7774 12.4995 20.0001V28.4399V28.4362H18.7495C19.4342 28.4342 19.997 27.8714 19.999 27.1866Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.24964 12.4999H18.7485C19.434 12.4999 19.9981 13.0639 19.9981 13.7494V26.2483C19.9981 26.9338 19.434 27.498 18.7485 27.498H6.24964C5.56414 27.498 5 26.9338 5 26.2483V13.7494C5 13.0639 5.56414 12.4999 6.24964 12.4999Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.62511 17.6256C8.95716 16.918 9.49334 16.3258 10.1644 15.9251C10.908 15.4994 11.7547 15.2874 12.6112 15.3121C13.4044 15.2946 14.1874 15.4957 14.8741 15.8932C15.5203 16.2781 16.0408 16.8426 16.3721 17.5179C16.7329 18.2619 16.9129 19.0806 16.8971 19.9074C16.9147 20.7715 16.7293 21.6279 16.3562 22.4076C16.0177 23.1067 15.4815 23.6916 14.8141 24.0894C14.1007 24.4994 13.2885 24.706 12.4658 24.6865C11.6554 24.7057 10.8551 24.5024 10.1522 24.0986C9.50097 23.7131 8.9742 23.1481 8.63547 22.4713C8.27234 21.7379 8.09029 20.9281 8.10488 20.1099C8.08879 19.2531 8.26702 18.4038 8.62606 17.6256H8.62511ZM10.2656 21.6172C10.4427 22.0646 10.7431 22.4529 11.1319 22.7365C11.5275 23.0136 12.0017 23.1565 12.4845 23.1444C12.9988 23.1647 13.506 23.0173 13.9291 22.7244C14.3131 22.4407 14.6056 22.0505 14.7701 21.6022C14.955 21.1026 15.0461 20.5731 15.0391 20.0405C15.0448 19.5032 14.9592 18.9686 14.786 18.46C14.6333 18.0021 14.3513 17.5979 13.9741 17.2967C13.5622 16.9891 13.0564 16.8328 12.5427 16.8542C12.0495 16.8414 11.5646 16.9851 11.1581 17.2648C10.7621 17.5494 10.455 17.9409 10.2731 18.3935C9.87079 19.4297 9.86847 20.5795 10.2665 21.6172H10.2656Z",
                fill: "white"
            })
        ]
    });
};

});


parcelRegister("brQSC", function(module, exports) {

$parcel$export(module.exports, "pagerDutyConfig", () => $b44f483df20185b6$export$cc8a555111f14137);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $iZPwM = parcelRequire("iZPwM");

var $959Bo = parcelRequire("959Bo");
const $b44f483df20185b6$export$cc8a555111f14137 = {
    displayName: 'PagerDuty',
    id: 'pagerduty',
    resourceType: 'smartlinks-connector-pagerduty',
    icon: (0, $9yyKc.get3PLogo)((0, $iZPwM.PagerDutyIcon), 'PagerDuty', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $959Bo.PagerDutySearchResultIcon), 'PagerDuty', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pagerduty',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("iZPwM", function(module, exports) {

$parcel$export(module.exports, "PagerDutyIcon", () => $5543f2cb76bcbb1f$export$e9a3fd43f9d4bddc);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $5543f2cb76bcbb1f$export$e9a3fd43f9d4bddc = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-731.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#04AB38"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.33974 9.0588C7.33988 9.05866 7.33996 9.05847 7.33996 9.05827C7.33996 7.60876 7.34084 6.15925 7.3382 4.70974C7.3382 4.5796 7.33644 4.4987 7.51495 4.50002C9.30876 4.51057 11.1026 4.49738 12.8964 4.51892C13.9116 4.53123 14.8801 4.77262 15.7546 5.30858C16.8256 5.96414 17.4222 6.94066 17.6117 8.16868C17.8148 9.48551 17.6012 10.7206 16.7918 11.8057C16.1033 12.7294 15.1439 13.2175 14.0285 13.4329C13.3347 13.567 12.6326 13.5846 11.9309 13.5899C10.4668 13.6013 9.00231 13.5912 7.53781 13.5991C7.36414 13.6 7.33557 13.5411 7.33645 13.3859C7.34172 11.9438 7.33952 10.5014 7.33952 9.05933C7.33952 9.05913 7.3396 9.05894 7.33974 9.0588Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.35232 17.4818C7.35232 16.8821 7.35539 16.2819 7.34968 15.6822C7.34836 15.5516 7.36463 15.4905 7.52246 15.4931C8.14414 15.5037 8.76626 15.5024 9.38794 15.4931C9.53215 15.4909 9.55281 15.5415 9.55237 15.6681C9.54798 16.89 9.5471 18.1118 9.55325 19.3333C9.55413 19.4753 9.50841 19.5003 9.37959 19.499C8.75791 19.4929 8.13579 19.4911 7.51411 19.4999C7.3699 19.5021 7.34836 19.452 7.34968 19.3249C7.35583 18.7102 7.35232 18.096 7.35232 17.4813V17.4818Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.54312 8.99636C9.54312 8.1834 9.54488 7.37088 9.54093 6.55791C9.54049 6.43788 9.55148 6.37589 9.70184 6.37677C10.7051 6.38424 11.7084 6.36446 12.7113 6.38776C13.2833 6.40095 13.8408 6.53021 14.3464 6.81996C15.0103 7.20028 15.3295 7.79604 15.3967 8.54042C15.4464 9.09221 15.4223 9.63697 15.1853 10.1514C14.8072 10.9723 14.1037 11.3416 13.2675 11.521C12.8942 11.601 12.5143 11.6195 12.1332 11.6195C11.3422 11.619 10.5513 11.612 9.76075 11.6247C9.56818 11.6278 9.53697 11.565 9.53917 11.3913C9.5484 10.5933 9.54312 9.79481 9.54312 8.9968V8.99636Z",
                fill: "#04AB38"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9969 11.9995C19.9969 14.6225 19.9963 17.2458 19.9997 19.8688C19.9997 19.9713 19.985 19.9991 19.8741 19.9987C14.6273 19.995 9.38021 19.995 4.13343 19.9987C4.01562 19.9991 4 19.9684 4 19.8609C4.00312 14.62 4.00312 9.37906 4 4.13812C4 4.03094 4.015 4 4.13343 4C9.37521 4.00406 14.6167 4.00406 19.8584 4C19.98 4 20 4.03187 20 4.14562C19.9966 6.76359 19.9972 9.38125 19.9972 11.9992L19.9969 11.9995Z",
                fill: "#04AB38"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.67927 9.89217C8.67927 8.86191 8.6799 7.83166 8.67802 6.80141C8.67802 6.70891 8.67677 6.65142 8.80364 6.65236C10.0786 6.65985 11.3536 6.65048 12.6286 6.66579C13.3501 6.67454 14.0385 6.84609 14.6601 7.22701C15.4213 7.69292 15.8454 8.38694 15.9801 9.2597C16.1244 10.1956 15.9726 11.0733 15.3973 11.8446C14.9079 12.5011 14.226 12.8479 13.4332 13.001C12.9401 13.0964 12.4411 13.1089 11.9423 13.1126C10.9017 13.1207 9.86081 13.1135 8.81989 13.1192C8.69646 13.1198 8.67615 13.0779 8.67677 12.9676C8.68052 11.9427 8.67896 10.9174 8.67896 9.89248L8.67927 9.89217Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.68845 15.8778C8.68845 15.4515 8.69063 15.025 8.68657 14.5988C8.68563 14.506 8.6972 14.4625 8.80938 14.4644C9.25125 14.4719 9.69343 14.471 10.1353 14.4644C10.2378 14.4629 10.2525 14.4988 10.2522 14.5888C10.249 15.4572 10.2484 16.3256 10.2528 17.1936C10.2534 17.2946 10.2209 17.3124 10.1294 17.3114C9.68749 17.3071 9.24531 17.3058 8.80345 17.3121C8.70095 17.3136 8.68563 17.278 8.68657 17.1877C8.69095 16.7508 8.68845 16.3143 8.68845 15.8775V15.8778Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.2451 9.89333C10.2451 9.31556 10.2463 8.73809 10.2435 8.16031C10.2432 8.075 10.251 8.03094 10.3579 8.03157C11.071 8.03688 11.7841 8.02282 12.4969 8.03938C12.9035 8.04876 13.2997 8.14062 13.6591 8.34655C14.1309 8.61685 14.3578 9.04026 14.4056 9.56929C14.4409 9.96146 14.4237 10.3486 14.2553 10.7142C13.9866 11.2976 13.4866 11.5601 12.8922 11.6876C12.6269 11.7445 12.3569 11.7576 12.086 11.7576C11.5238 11.7573 10.9616 11.7523 10.3998 11.7613C10.2629 11.7635 10.2407 11.7189 10.2423 11.5954C10.2488 11.0283 10.2451 10.4608 10.2451 9.89365V9.89333Z",
                fill: "#04AB38"
            })
        ]
    });
};

});

parcelRegister("959Bo", function(module, exports) {

$parcel$export(module.exports, "PagerDutySearchResultIcon", () => $243dba8c72a6f28f$export$494d5ec19d75a736);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $243dba8c72a6f28f$export$494d5ec19d75a736 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-259.5",
                y: "-646.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
                fill: "#04AB38"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.78616 12.0784C9.78635 12.0782 9.78645 12.078 9.78645 12.0777C9.78645 10.145 9.78763 8.21234 9.78411 6.27966C9.78411 6.10613 9.78176 5.99826 10.0198 6.00002C12.4115 6.01409 14.8033 5.9965 17.195 6.02523C18.5486 6.04164 19.84 6.36349 21.006 7.07811C22.434 7.95219 23.2295 9.25421 23.4821 10.8916C23.753 12.6473 23.4681 14.2941 22.3889 15.7409C21.4708 16.9726 20.1917 17.6233 18.7045 17.9106C17.7795 18.0894 16.8433 18.1128 15.9077 18.1199C13.9556 18.1351 12.0029 18.1216 10.0502 18.1322C9.8187 18.1333 9.78059 18.0548 9.78176 17.8478C9.7888 15.9251 9.78587 14.0018 9.78587 12.0791C9.78587 12.0788 9.78597 12.0786 9.78616 12.0784Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.80268 23.3091C9.80268 22.5095 9.80678 21.7093 9.79916 20.9097C9.79741 20.7356 9.81909 20.6541 10.0295 20.6576C10.8584 20.6716 11.6879 20.6699 12.5168 20.6576C12.7091 20.6546 12.7367 20.7221 12.7361 20.8909C12.7302 22.5201 12.7291 24.1492 12.7373 25.7778C12.7384 25.9671 12.6775 26.0005 12.5057 25.9988C11.6768 25.9906 10.8473 25.9882 10.0184 25.9999C9.82613 26.0029 9.79741 25.936 9.79916 25.7666C9.80737 24.9471 9.80268 24.1281 9.80268 23.3085V23.3091Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.7242 11.9952C12.7242 10.9112 12.7265 9.82788 12.7212 8.74393C12.7206 8.58388 12.7353 8.50123 12.9358 8.5024C14.2735 8.51236 15.6113 8.48598 16.9484 8.51705C17.7111 8.53464 18.4544 8.70699 19.1285 9.09332C20.0137 9.60042 20.4393 10.3948 20.529 11.3873C20.5952 12.123 20.563 12.8493 20.247 13.5352C19.7429 14.6297 18.8049 15.1222 17.69 15.3614C17.1923 15.468 16.6858 15.4927 16.1775 15.4927C15.1229 15.4921 14.0684 15.4827 13.0143 15.4997C12.7576 15.5038 12.716 15.42 12.7189 15.1884C12.7312 14.1244 12.7242 13.0598 12.7242 11.9958V11.9952Z",
                fill: "#04AB38"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M34.9953 20.0003C34.9953 24.9187 34.9941 29.8378 35.0006 34.7562C35.0006 34.9484 34.973 35.0006 34.765 35C24.927 34.993 15.0883 34.993 5.2502 35C5.0293 35.0006 5 34.9432 5 34.7416C5.00586 24.9141 5.00586 15.0865 5 5.25899C5 5.05801 5.02813 5 5.2502 5C15.0789 5.00762 24.907 5.00762 34.7357 5C34.9637 5 35.0012 5.05977 35.0012 5.27305C34.9947 10.1821 34.9959 15.0906 34.9959 19.9997L34.9953 20.0003Z",
                fill: "#04AB38"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.7745 16.0467C13.7745 14.1148 13.7757 12.183 13.7722 10.2511C13.7722 10.0776 13.7699 9.96982 14.0078 9.97158C16.3984 9.98564 18.7891 9.96806 21.1798 9.99677C22.5327 10.0132 23.8236 10.3349 24.989 11.0491C26.4164 11.9228 27.2115 13.2242 27.4641 14.8607C27.7348 16.6157 27.45 18.2616 26.3713 19.7077C25.4537 20.9388 24.1751 21.5892 22.6886 21.8763C21.764 22.055 20.8282 22.0785 19.893 22.0855C17.9418 22.1007 15.99 22.0872 14.0382 22.0978C13.8068 22.099 13.7687 22.0204 13.7699 21.8136C13.7769 19.8917 13.774 17.9692 13.774 16.0473L13.7745 16.0467Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.791 27.2719C13.791 26.4727 13.7951 25.6729 13.7874 24.8737C13.7857 24.6996 13.8074 24.6182 14.0177 24.6217C14.8463 24.6358 15.6754 24.634 16.5039 24.6217C16.6961 24.6188 16.7236 24.6861 16.723 24.8549C16.7172 26.4833 16.716 28.1116 16.7242 29.7394C16.7254 29.9286 16.6645 29.962 16.4928 29.9603C15.6642 29.9521 14.8351 29.9497 14.0066 29.9614C13.8144 29.9644 13.7857 29.8976 13.7874 29.7282C13.7956 28.9091 13.791 28.0905 13.791 27.2714V27.2719Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.7108 16.0473C16.7108 14.9639 16.7131 13.8811 16.7079 12.7976C16.7073 12.6377 16.7219 12.5551 16.9223 12.5562C18.2595 12.5662 19.5966 12.5398 20.9331 12.5709C21.6955 12.5885 22.4384 12.7607 23.1123 13.1469C23.9971 13.6537 24.4225 14.4477 24.5121 15.4397C24.5783 16.1751 24.5461 16.901 24.2303 17.5866C23.7264 18.6806 22.7888 19.1728 21.6744 19.4118C21.1769 19.5185 20.6706 19.5431 20.1626 19.5431C19.1085 19.5425 18.0544 19.5331 17.0008 19.5501C16.7442 19.5542 16.7026 19.4704 16.7055 19.239C16.7178 18.1755 16.7108 17.1114 16.7108 16.0479V16.0473Z",
                fill: "#04AB38"
            })
        ]
    });
};

});


parcelRegister("d2ZeT", function(module, exports) {

$parcel$export(module.exports, "pipedriveConfig", () => $fd9a483df954975f$export$9441b0ee1f92e710);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $7Khha = parcelRequire("7Khha");

var $bJTyW = parcelRequire("bJTyW");
const $fd9a483df954975f$export$9441b0ee1f92e710 = {
    displayName: 'Pipedrive',
    id: 'pipedrive',
    resourceType: 'smartlinks-connector-pipedrive',
    icon: (0, $9yyKc.get3PLogo)((0, $7Khha.PipedriveIcon), 'Pipedrive', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $bJTyW.PipedriveSearchResultIcon), 'Pipedrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pipedrive',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("7Khha", function(module, exports) {

$parcel$export(module.exports, "PipedriveIcon", () => $3d42e42f367dc3a5$export$e66a8d6ac96d6ba1);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $3d42e42f367dc3a5$export$e66a8d6ac96d6ba1 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-635.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#017737"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.2336 10.1635C10.2336 11.5838 10.9541 13.1159 12.5396 13.1159C13.7154 13.1159 14.9043 12.198 14.9043 10.1427C14.9043 8.34075 13.9697 7.13106 12.5787 7.13106C11.4453 7.13106 10.2336 7.92728 10.2336 10.1635ZM13.1373 4.5C15.9802 4.5 17.8917 6.75159 17.8917 10.1032C17.8917 13.4022 15.878 15.7053 12.9993 15.7053C11.6268 15.7053 10.7476 15.1175 10.2879 14.6919C10.2912 14.7928 10.2933 14.9058 10.2933 15.0264V19.5H7.34834V7.58072C7.34834 7.40743 7.29292 7.3526 7.12122 7.3526H6.1084V4.74238H8.5796C9.71739 4.74238 10.0086 5.32145 10.0641 5.76782C10.5259 5.25017 11.4833 4.5 13.1373 4.5Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M10.4002 10.0411C10.4002 11.556 11.1687 13.1903 12.8599 13.1903C14.1142 13.1903 15.3823 12.2112 15.3823 10.0189C15.3823 8.0968 14.3854 6.80647 12.9017 6.80647C11.6927 6.80647 10.4002 7.65577 10.4002 10.0411ZM13.4975 4C16.5299 4 18.5688 6.4017 18.5688 9.97675C18.5688 13.4957 16.4209 15.9523 13.3503 15.9523C11.8862 15.9523 10.9485 15.3253 10.4582 14.8714C10.4616 14.979 10.4639 15.0995 10.4639 15.2282V20H7.32261V7.2861C7.32261 7.10126 7.26349 7.04278 7.08034 7.04278H6V4.25854H8.63594C9.84959 4.25854 10.1602 4.87621 10.2194 5.35234C10.712 4.80018 11.7332 4 13.4975 4Z",
            fill: "#017737"
        })
    });
};

});

parcelRegister("bJTyW", function(module, exports) {

$parcel$export(module.exports, "PipedriveSearchResultIcon", () => $136b66fff4ecef3e$export$18970dea61783916);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $136b66fff4ecef3e$export$18970dea61783916 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-163.5",
                y: "-406.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
                fill: "#017737"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.7389 13.5678C13.7389 15.4746 14.7062 17.5315 16.8349 17.5315C18.4135 17.5315 20.0096 16.2991 20.0096 13.5398C20.0096 11.1206 18.7549 9.49657 16.8874 9.49657C15.3657 9.49657 13.7389 10.5655 13.7389 13.5678ZM17.6373 5.96423C21.454 5.96423 24.0203 8.98711 24.0203 13.4868C24.0203 17.9158 21.3169 21.0079 17.452 21.0079C15.6093 21.0079 14.429 20.2187 13.8119 19.6474C13.8163 19.7829 13.8192 19.9345 13.8192 20.0965V26.1025H9.86537V10.1003C9.86537 9.86761 9.79096 9.79399 9.56045 9.79399H8.20068V6.28964H11.5184C13.0459 6.28964 13.4369 7.06707 13.5113 7.66635C14.1314 6.97137 15.4168 5.96423 17.6373 5.96423Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M16.2504 16.3271C16.2504 19.1676 17.6914 22.2318 20.8624 22.2318C23.2141 22.2318 25.5918 20.3959 25.5918 16.2854C25.5918 12.6815 23.7226 10.2621 20.9406 10.2621C18.6737 10.2621 16.2504 11.8546 16.2504 16.3271ZM22.0578 5C27.7435 5 31.5666 9.50318 31.5666 16.2064C31.5666 22.8043 27.5392 27.4106 21.7818 27.4106C19.0367 27.4106 17.2784 26.2349 16.359 25.3839C16.3656 25.5857 16.3699 25.8116 16.3699 26.0529V35H10.4799V11.1614C10.4799 10.8149 10.369 10.7052 10.0256 10.7052H8V5.48476H12.9424C15.218 5.48476 15.8005 6.6429 15.9113 7.53564C16.835 6.50033 18.7498 5 22.0578 5Z",
            fill: "#017737"
        })
    });
};

});


parcelRegister("71C17", function(module, exports) {

$parcel$export(module.exports, "powerBIConfig", () => $221343bdf65748f1$export$b883b80d867cc715);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $4aI1V = parcelRequire("4aI1V");

var $gCCOd = parcelRequire("gCCOd");
const $221343bdf65748f1$export$b883b80d867cc715 = {
    displayName: 'PowerBI',
    id: 'power-bi',
    resourceType: 'smartlinks-connector-power-bi',
    icon: (0, $9yyKc.get3PLogo)((0, $4aI1V.PowerBIIcon), 'PowerBI', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $gCCOd.PowerBISearchResultIcon), 'PowerBI', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Dashboard
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("4aI1V", function(module, exports) {

$parcel$export(module.exports, "PowerBIIcon", () => $4f8f46a558397ff4$export$8a27e4cfebfdcb7);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $4f8f46a558397ff4$export$8a27e4cfebfdcb7 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-602.5",
                y: "-507.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.4031 4H13.1618C12.7971 4 12.5015 4.29563 12.5015 4.66032V19.3397C12.5015 19.7044 12.7971 20 13.1618 20H17.4031C17.7677 20 18.0634 19.7044 18.0634 19.3397V4.66032C18.0634 4.29563 17.7677 4 17.4031 4Z",
                fill: "#B25400"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.787 19.3394V19.9998H9.88542C9.52072 19.9998 9.2251 19.7041 9.2251 19.3394V8.64738C9.2251 8.28268 9.52072 7.98706 9.88542 7.98706H14.1267C14.4914 7.98706 14.787 8.28268 14.787 8.64738V19.3394Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.787 19.3394V19.9998H9.88542C9.52072 19.9998 9.2251 19.7041 9.2251 19.3394V8.64738C9.2251 8.28268 9.52072 7.98706 9.88542 7.98706H14.1267C14.4914 7.98706 14.787 8.28268 14.787 8.64738V19.3394Z",
                fill: "#DE9800"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.5619 19.3394V19.9998H6.66032C6.29562 19.9998 6 19.7041 6 19.3394V12.6601C6 12.2954 6.29562 11.9998 6.66032 11.9998H10.9016C11.2663 11.9998 11.5619 12.2954 11.5619 12.6601V19.3394Z",
                fill: "#F3CD32"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.4032 4H13.1619C12.7972 4 12.5016 4.29563 12.5016 4.66032V19.3397C12.5016 19.7044 12.7972 20 13.1619 20H17.4032C17.7679 20 18.0635 19.7044 18.0635 19.3397V4.66032C18.0635 4.29563 17.7679 4 17.4032 4Z",
                fill: "url(#paint0_linear_384_141)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.7873 19.3397V20H9.88572C9.52102 20 9.2254 19.7044 9.2254 19.3397V8.64762C9.2254 8.28292 9.52102 7.9873 9.88572 7.9873H14.127C14.4917 7.9873 14.7873 8.28292 14.7873 8.64762V19.3397Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.7873 19.3397V20H9.88572C9.52102 20 9.2254 19.7044 9.2254 19.3397V8.64762C9.2254 8.28292 9.52102 7.9873 9.88572 7.9873H14.127C14.4917 7.9873 14.7873 8.28292 14.7873 8.64762V19.3397Z",
                fill: "url(#paint1_linear_384_141)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.5619 19.3397V20H6.66032C6.29562 20 6 19.7044 6 19.3397V12.6603C6 12.2956 6.29562 12 6.66032 12H10.9016C11.2663 12 11.5619 12.2956 11.5619 12.6603V19.3397Z",
                fill: "url(#paint2_linear_384_141)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint0_linear_384_141",
                        x1: "15.2561",
                        y1: "3.97968",
                        x2: "15.2561",
                        y2: "19.9797",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#EBBB14"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B25400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint1_linear_384_141",
                        x1: "11.9799",
                        y1: "7.93778",
                        x2: "11.9799",
                        y2: "19.9505",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#F9E583"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DE9800"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint2_linear_384_141",
                        x1: "8.75454",
                        y1: "11.9797",
                        x2: "8.75454",
                        y2: "19.9797",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#F9E68B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F3CD32"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("gCCOd", function(module, exports) {

$parcel$export(module.exports, "PowerBISearchResultIcon", () => $81a121caf3e5ea88$export$66bbf4ebbd8bb09);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $81a121caf3e5ea88$export$66bbf4ebbd8bb09 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-115.5",
                y: "-502.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.508324",
                y: "0.508324",
                width: "30.9834",
                height: "30.9834",
                rx: "7.49168",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "1.01665"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M23.2042 5.3335H17.5491C17.0629 5.3335 16.6687 5.72768 16.6687 6.21392V25.7864C16.6687 26.2727 17.0629 26.6668 17.5491 26.6668H23.2042C23.6904 26.6668 24.0846 26.2727 24.0846 25.7864V6.21392C24.0846 5.72768 23.6904 5.3335 23.2042 5.3335Z",
                fill: "#B25400"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.7162 25.7862V26.6666H13.1807C12.6945 26.6666 12.3003 26.2724 12.3003 25.7862V11.5301C12.3003 11.0438 12.6945 10.6497 13.1807 10.6497H18.8357C19.322 10.6497 19.7162 11.0438 19.7162 11.5301V25.7862Z",
                fill: "#DE9800"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.7162 25.7862V26.6666H13.1807C12.6945 26.6666 12.3003 26.2724 12.3003 25.7862V11.5301C12.3003 11.0438 12.6945 10.6497 13.1807 10.6497H18.8357C19.322 10.6497 19.7162 11.0438 19.7162 11.5301V25.7862Z",
                fill: "#DE9800"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.4159 25.7862V26.6667H8.88042C8.39416 26.6667 8 26.2725 8 25.7862V16.8804C8 16.3942 8.39416 16 8.88042 16H14.5354C15.0217 16 15.4159 16.3942 15.4159 16.8804V25.7862Z",
                fill: "#F3CD32"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M30.381 5H22.4286C21.7448 5 21.1905 5.55431 21.1905 6.2381V33.7619C21.1905 34.4457 21.7448 35 22.4286 35H30.381C31.0647 35 31.6191 34.4457 31.6191 33.7619V6.2381C31.6191 5.55431 31.0647 5 30.381 5Z",
                fill: "url(#paint0_linear_powerbi)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25.4762 33.7619V35H16.2857C15.6019 35 15.0476 34.4457 15.0476 33.7619V13.7143C15.0476 13.0305 15.6019 12.4762 16.2857 12.4762H24.2381C24.9219 12.4762 25.4762 13.0305 25.4762 13.7143V33.7619Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25.4762 33.7619V35H16.2857C15.6019 35 15.0476 34.4457 15.0476 33.7619V13.7143C15.0476 13.0305 15.6019 12.4762 16.2857 12.4762H24.2381C24.9219 12.4762 25.4762 13.0305 25.4762 13.7143V33.7619Z",
                fill: "url(#paint1_linear_powerbi)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.4286 33.7619V35H10.2381C9.55429 35 9 34.4457 9 33.7619V21.2381C9 20.5543 9.55429 20 10.2381 20H18.1905C18.8743 20 19.4286 20.5543 19.4286 21.2381V33.7619Z",
                fill: "url(#paint2_linear_powerbi)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint0_linear_powerbi",
                        x1: "26.3553",
                        y1: "4.9619",
                        x2: "26.3553",
                        y2: "34.9619",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#EBBB14"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B25400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint1_linear_powerbi",
                        x1: "20.2124",
                        y1: "12.3833",
                        x2: "20.2124",
                        y2: "34.9071",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#F9E583"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DE9800"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint2_linear_powerbi",
                        x1: "14.1648",
                        y1: "19.9619",
                        x2: "14.1648",
                        y2: "34.9619",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#F9E68B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F3CD32"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("9T8Zq", function(module, exports) {

$parcel$export(module.exports, "salesforceConfig", () => $5ce640630a674ea4$export$68b7906270c63e2d);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $6Azae = parcelRequire("6Azae");

var $lqrIl = parcelRequire("lqrIl");
const $5ce640630a674ea4$export$68b7906270c63e2d = {
    displayName: 'Salesforce',
    id: 'salesforce',
    resourceType: 'salesforce-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $6Azae.SalesforceIcon), 'Salesforce', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $lqrIl.SalesforceSearchResultIcon), 'Salesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/salesforce',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch',
        'lastUpdatedBy',
        'createdBy',
        'owner'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("6Azae", function(module, exports) {

$parcel$export(module.exports, "SalesforceIcon", () => $dd87d9abaea6cdea$export$89e1f2a7c57f2a4d);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $dd87d9abaea6cdea$export$89e1f2a7c57f2a4d = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.385264",
                y: "0.385264",
                width: "23.2295",
                height: "23.2295",
                rx: "5.61474",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                id: "mask0_719_13847",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "5",
                width: "18",
                height: "14",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M3 5.71326H21V18.2868H3V5.71326Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                mask: "url(#mask0_719_13847)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.4738 7.08983C11.0548 6.48497 11.8635 6.11041 12.7569 6.11041C13.9481 6.11041 14.9804 6.77218 15.5363 7.75821C16.0297 7.53763 16.5642 7.42374 17.1047 7.42402C19.2488 7.42402 20.9892 9.17769 20.9892 11.3417C20.9892 13.5056 19.2488 15.2593 17.1047 15.2593C16.8426 15.2593 16.5872 15.233 16.337 15.1832C15.8506 16.0501 14.9209 16.6391 13.862 16.6391C13.431 16.6399 13.0054 16.5422 12.6179 16.3532C12.1249 17.5113 10.9767 18.3253 9.63998 18.3253C8.24366 18.3253 7.0591 17.4451 6.60248 16.2076C6.39925 16.2505 6.1921 16.2721 5.98439 16.2719C4.32336 16.2719 2.97998 14.9087 2.97998 13.2344C2.97998 12.1094 3.58483 11.13 4.48219 10.6006C4.29181 10.1621 4.19382 9.689 4.19432 9.21091C4.19432 7.27856 5.7627 5.7168 7.69505 5.7168C8.82667 5.7168 9.83917 6.25614 10.4745 7.09327",
                    fill: "#00A1E0"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.6037 12.2516C5.59239 12.2812 5.60774 12.2873 5.61138 12.2925C5.64519 12.317 5.67954 12.3348 5.71395 12.3547C5.89792 12.452 6.07131 12.4804 6.25263 12.4804C6.62189 12.4804 6.85153 12.2839 6.85153 11.9675V11.9613C6.85153 11.6688 6.59211 11.5623 6.34991 11.4862L6.31821 11.4759C6.1349 11.4165 5.97674 11.3647 5.97674 11.2443V11.2381C5.97674 11.1349 6.06939 11.0588 6.21233 11.0588C6.37115 11.0588 6.56042 11.1117 6.68152 11.1786C6.68152 11.1786 6.71739 11.2018 6.73042 11.1671C6.7375 11.1484 6.79925 10.9832 6.80586 10.9646C6.81288 10.9453 6.80057 10.9306 6.78793 10.9231C6.64896 10.8384 6.45705 10.7808 6.25852 10.7808L6.22166 10.7809C5.8835 10.7809 5.64725 10.9854 5.64725 11.2779V11.2842C5.64725 11.5926 5.90798 11.6932 6.15151 11.7627L6.19069 11.7748C6.36804 11.8294 6.52157 11.8768 6.52157 12.0012V12.0074C6.52157 12.1219 6.42164 12.2072 6.2615 12.2072C6.19922 12.2072 6.00076 12.2062 5.78569 12.0703C5.75968 12.0551 5.74486 12.0442 5.72481 12.0319C5.71422 12.0255 5.68775 12.0139 5.67623 12.0486L5.60344 12.2511M11.0101 12.2511C10.9987 12.2806 11.0141 12.2868 11.0179 12.292C11.0515 12.3165 11.086 12.3342 11.1204 12.3541C11.3044 12.4514 11.4778 12.4799 11.6591 12.4799C12.0284 12.4799 12.258 12.2833 12.258 11.967V11.9608C12.258 11.6683 11.9993 11.5618 11.7564 11.4856L11.7247 11.4754C11.5414 11.416 11.3832 11.3642 11.3832 11.2438V11.2376C11.3832 11.1344 11.4759 11.0583 11.6188 11.0583C11.7776 11.0583 11.9662 11.1112 12.088 11.1781C12.088 11.1781 12.1239 11.2012 12.137 11.1666C12.144 11.1479 12.2058 10.9826 12.2118 10.9641C12.2188 10.9447 12.2065 10.9301 12.1939 10.9226C12.0549 10.8378 11.863 10.7803 11.6645 10.7803L11.6275 10.7804C11.2894 10.7804 11.0531 10.9849 11.0531 11.2774V11.2837C11.0531 11.5921 11.3139 11.6926 11.5574 11.7621L11.5965 11.7743C11.7745 11.8288 11.9274 11.8762 11.9274 12.0006V12.0069C11.9274 12.1213 11.8275 12.2067 11.6673 12.2067C11.6049 12.2067 11.4059 12.2056 11.1915 12.0697C11.1655 12.0546 11.1503 12.0441 11.1306 12.0314C11.1239 12.0272 11.0927 12.015 11.0821 12.0481L11.0093 12.2506M14.7019 11.6312C14.7019 11.8098 14.6686 11.9508 14.6033 12.0507C14.5382 12.1493 14.4398 12.1976 14.3029 12.1976C14.1659 12.1976 14.0679 12.1497 14.0037 12.0514C13.9391 11.9521 13.9065 11.8105 13.9065 11.6318C13.9065 11.4532 13.9393 11.3129 14.0037 11.2143C14.0678 11.1163 14.1652 11.0693 14.3029 11.0693C14.4405 11.0693 14.5385 11.1168 14.6033 11.2143C14.669 11.3129 14.7019 11.4532 14.7019 11.6318M15.0103 11.3003C14.9799 11.1977 14.9329 11.1077 14.87 11.0323C14.8071 10.9568 14.7277 10.8959 14.6331 10.8523C14.5391 10.8083 14.4279 10.7861 14.3022 10.7861C14.1765 10.7861 14.066 10.8084 13.9713 10.8523C13.8773 10.8962 13.7973 10.9568 13.7344 11.0323C13.6717 11.1077 13.6246 11.1977 13.5941 11.3003C13.564 11.4022 13.5487 11.5134 13.5487 11.6318C13.5487 11.7503 13.564 11.8615 13.5941 11.9634C13.6244 12.0659 13.6715 12.1559 13.7344 12.2314C13.7973 12.3068 13.8773 12.3671 13.9713 12.4101C14.066 12.4529 14.1771 12.4748 14.3022 12.4748C14.4273 12.4748 14.5385 12.4529 14.6324 12.4101C14.7264 12.3672 14.8065 12.3068 14.8693 12.2314C14.9321 12.1559 14.9792 12.0659 15.0096 11.9634C15.0397 11.8615 15.055 11.7503 15.055 11.6318C15.055 11.514 15.0397 11.4022 15.0096 11.3003M17.5442 12.1473C17.5341 12.1174 17.5048 12.1287 17.5048 12.1287C17.46 12.1458 17.4122 12.1617 17.3612 12.1696C17.3099 12.1777 17.2527 12.1818 17.1925 12.1818C17.0436 12.1818 16.9244 12.1374 16.8397 12.0494C16.7544 11.9614 16.7067 11.8198 16.7074 11.6279C16.7078 11.4532 16.7501 11.3221 16.8258 11.2215C16.9006 11.1223 17.0158 11.0707 17.168 11.0707C17.295 11.0707 17.3923 11.0854 17.4942 11.1173C17.4942 11.1173 17.5184 11.1278 17.53 11.096C17.557 11.0212 17.577 10.9676 17.6061 10.8856C17.6143 10.8621 17.5942 10.8521 17.5868 10.8493C17.5468 10.8337 17.4525 10.8081 17.381 10.7973C17.3142 10.7871 17.2367 10.7818 17.1494 10.7818C17.0197 10.7818 16.9045 10.804 16.8059 10.8479C16.7073 10.8918 16.6239 10.9525 16.5578 11.0279C16.4916 11.1033 16.4413 11.1933 16.4075 11.2959C16.3741 11.3978 16.3572 11.5097 16.3572 11.6281C16.3572 11.8836 16.4261 12.0907 16.5624 12.2422C16.6987 12.3944 16.9039 12.4712 17.1712 12.4712C17.3294 12.4712 17.4915 12.4393 17.608 12.3931C17.608 12.3931 17.6302 12.3824 17.6206 12.3565L17.5445 12.1473M18.0838 11.4591C18.0985 11.3598 18.1257 11.2771 18.1685 11.2129C18.2325 11.115 18.33 11.0614 18.467 11.0614C18.6039 11.0614 18.6946 11.1153 18.7595 11.2129C18.8025 11.2775 18.8213 11.3632 18.8283 11.4591L18.0805 11.459L18.0838 11.4591ZM19.1228 11.2407C19.0965 11.1421 19.0314 11.0422 18.9891 10.9965C18.9216 10.9244 18.8561 10.8734 18.7906 10.8457C18.696 10.8054 18.5942 10.7848 18.4914 10.785C18.3611 10.785 18.2426 10.807 18.1467 10.8518C18.0507 10.8969 17.97 10.9584 17.9064 11.0351C17.843 11.1119 17.7953 11.2025 17.7648 11.3064C17.7344 11.409 17.719 11.5215 17.719 11.6393C17.719 11.7598 17.735 11.8716 17.7663 11.9728C17.798 12.0748 17.8491 12.1641 17.9179 12.2382C17.9867 12.313 18.0747 12.3712 18.1806 12.4123C18.2858 12.4529 18.4135 12.4741 18.5598 12.4736C18.8616 12.4726 19.0204 12.4054 19.0852 12.369C19.0968 12.3626 19.1077 12.3514 19.0941 12.3191L19.0259 12.1279C19.0155 12.0994 18.9866 12.1097 18.9866 12.1097C18.9119 12.1376 18.806 12.1878 18.5578 12.1871C18.3957 12.1869 18.2759 12.139 18.2005 12.064C18.1237 11.9873 18.0853 11.8754 18.0794 11.7166L19.1249 11.7174C19.1249 11.7174 19.1525 11.7171 19.1553 11.6903C19.1564 11.6791 19.1911 11.4759 19.1242 11.2409L19.1228 11.2407ZM9.7257 11.4591C9.74046 11.3598 9.76772 11.2771 9.81041 11.2129C9.87447 11.115 9.97188 11.0614 10.1089 11.0614C10.2458 11.0614 10.3365 11.1153 10.4014 11.2129C10.4443 11.2775 10.4631 11.3632 10.4702 11.4591L9.72239 11.459L9.7257 11.4591ZM10.7647 11.2407C10.7385 11.1421 10.6733 11.0422 10.631 10.9965C10.5635 10.9244 10.498 10.8734 10.4325 10.8457C10.3379 10.8054 10.2361 10.7848 10.1333 10.785C10.003 10.785 9.88453 10.807 9.78857 10.8518C9.69261 10.8969 9.61188 10.9584 9.54835 11.0351C9.48502 11.1119 9.43717 11.2025 9.40673 11.3064C9.37636 11.409 9.36107 11.5215 9.36107 11.6393C9.36107 11.7598 9.37689 11.8716 9.40845 11.9728C9.44008 12.0748 9.49117 12.1641 9.55933 12.2382C9.62816 12.313 9.71617 12.3712 9.82206 12.4123C9.92728 12.4529 10.0543 12.4741 10.2012 12.4736C10.503 12.4726 10.6618 12.4054 10.7267 12.369C10.7382 12.3626 10.7492 12.3514 10.7355 12.3191L10.6673 12.1279C10.6568 12.0994 10.628 12.1097 10.628 12.1097C10.5532 12.1376 10.4473 12.1878 10.1991 12.1871C10.0377 12.1869 9.91722 12.139 9.84178 12.064C9.76501 11.9873 9.72663 11.8754 9.72067 11.7166L10.7663 11.7174C10.7663 11.7174 10.7938 11.7171 10.7966 11.6903C10.7978 11.6791 10.8324 11.4759 10.7654 11.2409L10.7647 11.2407ZM7.46908 12.1407C7.42812 12.108 7.42243 12.1 7.40886 12.0788C7.38815 12.0468 7.37756 12.0014 7.37756 11.9431C7.37756 11.8518 7.408 11.7856 7.47087 11.7413C7.47021 11.7414 7.56087 11.6632 7.77396 11.6658C7.86881 11.6675 7.96343 11.6756 8.05719 11.69V12.1645H8.05733C8.05733 12.1645 7.92497 12.193 7.77542 12.202C7.56299 12.2148 7.46902 12.1409 7.46968 12.1411L7.46908 12.1407ZM7.88467 11.4062C7.84232 11.4031 7.78739 11.4015 7.72188 11.4015C7.63254 11.4015 7.54585 11.4127 7.46511 11.4345C7.38372 11.4565 7.31026 11.4905 7.24739 11.5357C7.18435 11.5807 7.1325 11.6396 7.09585 11.7078C7.05886 11.7766 7.04 11.8574 7.04 11.9487C7.04 12.0413 7.05608 12.1214 7.08784 12.1869C7.11897 12.2519 7.16583 12.3081 7.22417 12.3504C7.2822 12.3926 7.35387 12.4238 7.43659 12.4424C7.51865 12.4611 7.6113 12.4706 7.71321 12.4706C7.82042 12.4706 7.92696 12.4616 8.03019 12.4441C8.11812 12.429 8.20571 12.4119 8.29292 12.3931C8.32772 12.3851 8.36637 12.3745 8.36637 12.3745C8.39218 12.368 8.3902 12.3404 8.3902 12.3404L8.3896 11.3874C8.3896 11.1783 8.33375 11.0228 8.2235 10.9269C8.11364 10.8309 7.95283 10.7826 7.74438 10.7826C7.66629 10.7826 7.53989 10.7932 7.46445 10.8083C7.46445 10.8083 7.23681 10.8525 7.14283 10.9261C7.14283 10.9261 7.12219 10.9388 7.13344 10.9676L7.20756 11.1661C7.21675 11.1919 7.24183 11.1831 7.24183 11.1831C7.24183 11.1831 7.24971 11.18 7.25897 11.1745C7.45949 11.0653 7.71361 11.0686 7.71361 11.0686C7.82611 11.0686 7.91346 11.0914 7.97169 11.1361C8.02867 11.1798 8.05772 11.246 8.05772 11.3849V11.4291C7.96839 11.4161 7.88567 11.4086 7.88567 11.4086L7.88467 11.4062ZM16.2891 10.8682C16.2906 10.8647 16.2914 10.8609 16.2914 10.8571C16.2914 10.8533 16.2907 10.8495 16.2892 10.846C16.2878 10.8425 16.2856 10.8394 16.2829 10.8367C16.2802 10.834 16.2769 10.832 16.2734 10.8306C16.2556 10.8238 16.1669 10.8051 16.0987 10.8009C15.9677 10.7926 15.8949 10.8148 15.8294 10.8441C15.7646 10.8733 15.693 10.9202 15.6533 10.9745L15.6532 10.8474C15.6532 10.83 15.6408 10.8159 15.6232 10.8159H15.3559C15.3385 10.8159 15.326 10.83 15.326 10.8474V12.4026C15.326 12.411 15.3293 12.419 15.3353 12.425C15.3412 12.4309 15.3492 12.4343 15.3577 12.4343H15.6316C15.64 12.4343 15.6481 12.4309 15.654 12.425C15.6599 12.419 15.6633 12.411 15.6633 12.4026V11.6217C15.6633 11.5171 15.6748 11.4133 15.6977 11.3477C15.7204 11.2829 15.7511 11.2313 15.7891 11.1942C15.8252 11.1584 15.8695 11.1319 15.9181 11.1168C15.9637 11.1037 16.0109 11.0971 16.0584 11.0971C16.113 11.0971 16.1729 11.1111 16.1729 11.1111C16.193 11.1133 16.2042 11.101 16.211 11.0829C16.2289 11.0352 16.2798 10.8923 16.2897 10.8639",
                fill: "#FFFFFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.7299 10.1503C13.6961 10.14 13.6616 10.1319 13.6267 10.1258C13.5799 10.118 13.5324 10.1143 13.4849 10.1148C13.2961 10.1148 13.1472 10.1681 13.0427 10.2735C12.939 10.378 12.8684 10.5373 12.833 10.7469L12.8202 10.8177H12.5832C12.5832 10.8177 12.5543 10.8165 12.5482 10.848L12.5093 11.0651C12.5066 11.0859 12.5155 11.0988 12.5433 11.0987H12.774L12.5399 12.4052C12.5216 12.5104 12.5006 12.597 12.4774 12.6626C12.4545 12.7273 12.4321 12.7758 12.4046 12.811C12.3779 12.8451 12.3527 12.8702 12.309 12.8848C12.273 12.8969 12.2316 12.9025 12.1862 12.9025C12.1609 12.9025 12.1273 12.8982 12.1025 12.8933C12.0777 12.8884 12.0648 12.8828 12.0462 12.875C12.0462 12.875 12.0191 12.8647 12.0085 12.8918C11.9998 12.914 11.9383 13.0831 11.931 13.104C11.9236 13.1246 11.934 13.1409 11.9471 13.1456C11.9778 13.1566 12.0007 13.1636 12.0425 13.1735C12.1006 13.1872 12.1496 13.188 12.1954 13.188C12.2915 13.188 12.3791 13.1745 12.4517 13.1483C12.5247 13.1219 12.5883 13.0759 12.6446 13.0137C12.7054 12.9465 12.7436 12.8761 12.7802 12.7802C12.8164 12.6851 12.8473 12.567 12.8719 12.4294L13.1071 11.0987H13.451C13.451 11.0987 13.48 11.0998 13.486 11.0683L13.5249 10.8513C13.5276 10.8305 13.5187 10.8175 13.4908 10.8177H13.1571C13.1587 10.8101 13.1739 10.6927 13.2122 10.5822C13.2286 10.535 13.2593 10.497 13.2854 10.4708C13.3098 10.4459 13.3397 10.4273 13.3728 10.4164C13.4091 10.4052 13.4469 10.3998 13.4849 10.4003C13.5163 10.4003 13.5471 10.4041 13.5706 10.4089C13.603 10.4158 13.6156 10.4195 13.624 10.422C13.6581 10.4324 13.6626 10.4223 13.6693 10.4058L13.7491 10.1867C13.7573 10.1631 13.7373 10.1532 13.7299 10.1503ZM9.0662 12.408C9.0662 12.4255 9.05376 12.4397 9.03629 12.4397H8.75947C8.74193 12.4397 8.72949 12.4255 8.72949 12.408V10.18C8.72949 10.1626 8.74193 10.1485 8.75947 10.1485H9.03629C9.05376 10.1485 9.0662 10.1626 9.0662 10.18V12.408Z",
                fill: "#FFFFFE"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                id: "mask0_7_630",
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "6",
                width: "18",
                height: "13",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M3 6H21V18.5735H3V6Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                mask: "url(#mask0_7_630)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.474 7.37645C11.055 6.77159 11.8637 6.39704 12.7571 6.39704C13.9483 6.39704 14.9806 7.0588 15.5365 8.04483C16.0299 7.82425 16.5644 7.71036 17.1049 7.71064C19.249 7.71064 20.9894 9.46431 20.9894 11.6283C20.9894 13.7923 19.249 15.5459 17.1049 15.5459C16.8428 15.5459 16.5874 15.5196 16.3372 15.4698C15.8508 16.3367 14.921 16.9257 13.8622 16.9257C13.4311 16.9266 13.0056 16.8288 12.6181 16.6398C12.1251 17.7979 10.9769 18.6119 9.64016 18.6119C8.24384 18.6119 7.05928 17.7317 6.60266 16.4942C6.39943 16.5371 6.19228 16.5587 5.98458 16.5586C4.32355 16.5586 2.98016 15.1953 2.98016 13.5211C2.98016 12.3961 3.58502 11.4167 4.48237 10.8872C4.292 10.4487 4.194 9.97562 4.1945 9.49754C4.1945 7.56518 5.76288 6.00342 7.69524 6.00342C8.82686 6.00342 9.83935 6.54276 10.4746 7.37989",
                    fill: "#00A1E0"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.6034 12.5383C5.59208 12.5678 5.60743 12.5739 5.61107 12.5792C5.64489 12.6036 5.67924 12.6214 5.71365 12.6413C5.89762 12.7386 6.071 12.767 6.25232 12.767C6.62159 12.767 6.85122 12.5705 6.85122 12.2542V12.2479C6.85122 11.9554 6.59181 11.8489 6.3496 11.7728L6.3179 11.7625C6.1346 11.7031 5.97643 11.6514 5.97643 11.5309V11.5248C5.97643 11.4215 6.06908 11.3454 6.21202 11.3454C6.37085 11.3454 6.56011 11.3983 6.68121 11.4652C6.68121 11.4652 6.71708 11.4884 6.73012 11.4538C6.7372 11.435 6.79894 11.2698 6.80556 11.2513C6.81257 11.2319 6.80026 11.2172 6.78762 11.2097C6.64865 11.125 6.45674 11.0674 6.25821 11.0674L6.22135 11.0676C5.88319 11.0676 5.64694 11.272 5.64694 11.5645V11.5708C5.64694 11.8792 5.90768 11.9798 6.15121 12.0493L6.19038 12.0615C6.36774 12.116 6.52126 12.1634 6.52126 12.2878V12.294C6.52126 12.4085 6.42134 12.4939 6.26119 12.4939C6.19892 12.4939 6.00046 12.4928 5.78538 12.3569C5.75937 12.3417 5.74455 12.3308 5.7245 12.3186C5.71391 12.3121 5.68744 12.3006 5.67593 12.3352L5.60313 12.5377M11.0097 12.5377C10.9984 12.5672 11.0138 12.5734 11.0176 12.5786C11.0512 12.6031 11.0857 12.6209 11.1201 12.6408C11.3041 12.738 11.4775 12.7665 11.6588 12.7665C12.0281 12.7665 12.2577 12.57 12.2577 12.2536V12.2474C12.2577 11.9549 11.999 11.8484 11.7561 11.7723L11.7244 11.762C11.5411 11.7026 11.3829 11.6508 11.3829 11.5304V11.5242C11.3829 11.421 11.4756 11.3449 11.6185 11.3449C11.7773 11.3449 11.9659 11.3978 12.0877 11.4647C12.0877 11.4647 12.1236 11.4878 12.1367 11.4532C12.1437 11.4345 12.2055 11.2693 12.2114 11.2507C12.2185 11.2313 12.2062 11.2167 12.1936 11.2092C12.0546 11.1245 11.8627 11.0669 11.6642 11.0669L11.6272 11.067C11.2891 11.067 11.0528 11.2715 11.0528 11.564V11.5703C11.0528 11.8787 11.3136 11.9793 11.5571 12.0488L11.5962 12.0609C11.7742 12.1155 11.9271 12.1628 11.9271 12.2873V12.2935C11.9271 12.408 11.8272 12.4933 11.667 12.4933C11.6046 12.4933 11.4056 12.4923 11.1912 12.3563C11.1652 12.3412 11.15 12.3307 11.1303 12.318C11.1236 12.3138 11.0924 12.3016 11.0817 12.3347L11.009 12.5372M14.7016 11.9178C14.7016 12.0965 14.6683 12.2374 14.603 12.3374C14.5379 12.436 14.4395 12.4843 14.3026 12.4843C14.1656 12.4843 14.0676 12.4364 14.0034 12.338C13.9388 12.2387 13.9062 12.0971 13.9062 11.9185C13.9062 11.7398 13.939 11.5995 14.0034 11.5009C14.0675 11.4029 14.1649 11.356 14.3026 11.356C14.4402 11.356 14.5381 11.4034 14.603 11.5009C14.6686 11.5995 14.7016 11.7398 14.7016 11.9185M15.01 11.5869C14.9796 11.4843 14.9326 11.3943 14.8697 11.3189C14.8068 11.2435 14.7274 11.1826 14.6328 11.1389C14.5388 11.0949 14.4276 11.0727 14.3019 11.0727C14.1762 11.0727 14.0656 11.095 13.971 11.1389C13.877 11.1828 13.797 11.2435 13.7341 11.3189C13.6714 11.3943 13.6242 11.4843 13.5938 11.5869C13.5637 11.6888 13.5484 11.8 13.5484 11.9185C13.5484 12.0369 13.5637 12.1481 13.5938 12.25C13.6241 12.3526 13.6712 12.4426 13.7341 12.518C13.797 12.5935 13.877 12.6537 13.971 12.6967C14.0656 12.7396 14.1768 12.7614 14.3019 12.7614C14.427 12.7614 14.5381 12.7396 14.6321 12.6967C14.7261 12.6538 14.8062 12.5935 14.869 12.518C14.9318 12.4426 14.9789 12.3526 15.0093 12.25C15.0394 12.1481 15.0547 12.0369 15.0547 11.9185C15.0547 11.8007 15.0394 11.6888 15.0093 11.5869M17.5439 12.434C17.5338 12.404 17.5045 12.4153 17.5045 12.4153C17.4597 12.4324 17.4119 12.4483 17.3609 12.4563C17.3096 12.4643 17.2524 12.4684 17.1922 12.4684C17.0433 12.4684 16.9241 12.424 16.8394 12.336C16.7541 12.248 16.7064 12.1064 16.7071 11.9145C16.7075 11.7398 16.7498 11.6087 16.8255 11.5082C16.9003 11.4089 17.0155 11.3573 17.1677 11.3573C17.2947 11.3573 17.392 11.372 17.4939 11.4039C17.4939 11.4039 17.5181 11.4145 17.5297 11.3826C17.5567 11.3078 17.5767 11.2542 17.6058 11.1722C17.614 11.1487 17.5938 11.1388 17.5865 11.1359C17.5465 11.1203 17.4522 11.0947 17.3807 11.0839C17.3139 11.0737 17.2364 11.0684 17.1491 11.0684C17.0194 11.0684 16.9042 11.0906 16.8056 11.1345C16.707 11.1784 16.6236 11.2391 16.5575 11.3145C16.4913 11.39 16.441 11.48 16.4072 11.5825C16.3738 11.6845 16.3569 11.7963 16.3569 11.9147C16.3569 12.1702 16.4258 12.3773 16.5621 12.5289C16.6984 12.6811 16.9036 12.7578 17.1709 12.7578C17.3291 12.7578 17.4912 12.7259 17.6077 12.6797C17.6077 12.6797 17.6299 12.669 17.6203 12.6431L17.5441 12.434M18.0835 11.7457C18.0982 11.6465 18.1254 11.5637 18.1682 11.4996C18.2322 11.4016 18.3297 11.348 18.4666 11.348C18.6036 11.348 18.6943 11.4019 18.7591 11.4996C18.8022 11.5641 18.821 11.6498 18.828 11.7457L18.0802 11.7456L18.0835 11.7457ZM19.1225 11.5274C19.0962 11.4287 19.0311 11.3288 18.9888 11.2832C18.9213 11.211 18.8558 11.1601 18.7903 11.1323C18.6957 11.0921 18.5939 11.0714 18.4911 11.0716C18.3608 11.0716 18.2423 11.0936 18.1464 11.1384C18.0504 11.1836 17.9697 11.245 17.9061 11.3217C17.8427 11.3985 17.795 11.4892 17.7645 11.5931C17.7341 11.6956 17.7187 11.8081 17.7187 11.9259C17.7187 12.0464 17.7347 12.1582 17.766 12.2595C17.7977 12.3614 17.8488 12.4507 17.9176 12.5248C17.9864 12.5996 18.0744 12.6578 18.1803 12.6989C18.2855 12.7396 18.4132 12.7607 18.5595 12.7602C18.8613 12.7592 19.0201 12.6921 19.0849 12.6557C19.0965 12.6492 19.1074 12.638 19.0938 12.6058L19.0256 12.4145C19.0152 12.386 18.9863 12.3963 18.9863 12.3963C18.9116 12.4242 18.8057 12.4744 18.5575 12.4737C18.3954 12.4735 18.2756 12.4256 18.2002 12.3507C18.1234 12.2739 18.085 12.162 18.0791 12.0032L19.1246 12.004C19.1246 12.004 19.1522 12.0038 19.155 11.9769C19.1561 11.9658 19.1908 11.7625 19.1238 11.5275L19.1225 11.5274ZM9.7254 11.7457C9.74015 11.6465 9.76742 11.5637 9.8101 11.4996C9.87416 11.4016 9.97157 11.348 10.1086 11.348C10.2455 11.348 10.3362 11.4019 10.4011 11.4996C10.444 11.5641 10.4628 11.6498 10.4699 11.7457L9.72209 11.7456L9.7254 11.7457ZM10.7644 11.5274C10.7382 11.4287 10.673 11.3288 10.6307 11.2832C10.5632 11.211 10.4977 11.1601 10.4322 11.1323C10.3376 11.0921 10.2358 11.0714 10.133 11.0716C10.0027 11.0716 9.88422 11.0936 9.78826 11.1384C9.69231 11.1836 9.61157 11.245 9.54804 11.3217C9.48471 11.3985 9.43687 11.4892 9.40643 11.5931C9.37605 11.6956 9.36076 11.8081 9.36076 11.9259C9.36076 12.0464 9.37658 12.1582 9.40815 12.2595C9.43978 12.3614 9.49087 12.4507 9.55903 12.5248C9.62785 12.5996 9.71587 12.6578 9.82175 12.6989C9.92697 12.7396 10.054 12.7607 10.2009 12.7602C10.5027 12.7592 10.6615 12.6921 10.7264 12.6557C10.7379 12.6492 10.7489 12.638 10.7352 12.6058L10.667 12.4145C10.6565 12.386 10.6276 12.3963 10.6276 12.3963C10.5529 12.4242 10.447 12.4744 10.1988 12.4737C10.0374 12.4735 9.91691 12.4256 9.84147 12.3507C9.76471 12.2739 9.72632 12.162 9.72037 12.0032L10.766 12.004C10.766 12.004 10.7935 12.0038 10.7963 11.9769C10.7975 11.9658 10.8321 11.7625 10.7651 11.5275L10.7644 11.5274ZM7.46878 12.4274C7.42782 12.3947 7.42213 12.3867 7.40856 12.3654C7.38785 12.3334 7.37726 12.288 7.37726 12.2297C7.37726 12.1384 7.4077 12.0722 7.47057 12.0279C7.4699 12.028 7.56057 11.9498 7.77365 11.9525C7.8685 11.9542 7.96313 11.9622 8.05689 11.9766V12.4511H8.05702C8.05702 12.4511 7.92467 12.4796 7.77511 12.4886C7.56268 12.5014 7.46871 12.4275 7.46938 12.4277L7.46878 12.4274ZM7.88437 11.6928C7.84201 11.6897 7.78709 11.6882 7.72157 11.6882C7.63224 11.6882 7.54554 11.6993 7.46481 11.7211C7.38341 11.7431 7.30996 11.7771 7.24709 11.8224C7.18405 11.8673 7.1322 11.9262 7.09554 11.9944C7.05855 12.0632 7.03969 12.144 7.03969 12.2353C7.03969 12.328 7.05577 12.408 7.08754 12.4735C7.11866 12.5385 7.16552 12.5947 7.22386 12.637C7.2819 12.6792 7.35357 12.7105 7.43629 12.729C7.51835 12.7477 7.61099 12.7572 7.7129 12.7572C7.82011 12.7572 7.92665 12.7482 8.02989 12.7308C8.11782 12.7156 8.20541 12.6986 8.29261 12.6797C8.32742 12.6717 8.36607 12.6612 8.36607 12.6612C8.39188 12.6546 8.38989 12.627 8.38989 12.627L8.38929 11.6741C8.38929 11.4649 8.33344 11.3094 8.22319 11.2135C8.11334 11.1175 7.95253 11.0692 7.74407 11.0692C7.66599 11.0692 7.53959 11.0798 7.46415 11.095C7.46415 11.095 7.2365 11.1392 7.14253 11.2127C7.14253 11.2127 7.12188 11.2255 7.13313 11.2542L7.20725 11.4528C7.21645 11.4785 7.24153 11.4697 7.24153 11.4697C7.24153 11.4697 7.2494 11.4666 7.25867 11.4611C7.45918 11.3519 7.7133 11.3552 7.7133 11.3552C7.8258 11.3552 7.91315 11.3781 7.97139 11.4227C8.02837 11.4665 8.05742 11.5326 8.05742 11.6715V11.7157C7.96808 11.7027 7.88536 11.6952 7.88536 11.6952L7.88437 11.6928ZM16.2888 11.1548C16.2903 11.1513 16.2911 11.1475 16.2911 11.1437C16.2911 11.1399 16.2904 11.1362 16.2889 11.1327C16.2874 11.1291 16.2853 11.126 16.2826 11.1233C16.2799 11.1207 16.2766 11.1186 16.2731 11.1172C16.2553 11.1104 16.1666 11.0917 16.0984 11.0875C15.9674 11.0793 15.8946 11.1014 15.8291 11.1308C15.7643 11.1599 15.6927 11.2069 15.653 11.2611L15.6529 11.1341C15.6529 11.1166 15.6405 11.1025 15.6229 11.1025H15.3556C15.3382 11.1025 15.3256 11.1166 15.3256 11.1341V12.6892C15.3257 12.6976 15.329 12.7057 15.335 12.7116C15.3409 12.7175 15.3489 12.7209 15.3573 12.7209H15.6313C15.6397 12.7209 15.6478 12.7175 15.6537 12.7116C15.6596 12.7057 15.6629 12.6976 15.6629 12.6892V11.9083C15.6629 11.8038 15.6745 11.6999 15.6974 11.6344C15.7201 11.5696 15.7508 11.5179 15.7888 11.4808C15.8249 11.445 15.8692 11.4185 15.9178 11.4034C15.9634 11.3903 16.0106 11.3837 16.0581 11.3837C16.1127 11.3837 16.1726 11.3977 16.1726 11.3977C16.1927 11.4 16.2039 11.3877 16.2107 11.3695C16.2286 11.3218 16.2795 11.1789 16.2894 11.1505",
                fill: "#FFFFFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.7299 10.437C13.6961 10.4268 13.6616 10.4186 13.6267 10.4125C13.5799 10.4047 13.5324 10.401 13.4849 10.4015C13.2961 10.4015 13.1472 10.4549 13.0427 10.5602C12.939 10.6648 12.8684 10.8241 12.833 11.0337L12.8202 11.1044H12.5832C12.5832 11.1044 12.5543 11.1032 12.5482 11.1348L12.5093 11.3518C12.5066 11.3726 12.5155 11.3856 12.5433 11.3854H12.774L12.5399 12.692C12.5216 12.7972 12.5006 12.8837 12.4774 12.9493C12.4545 13.0141 12.4321 13.0626 12.4046 13.0978C12.3779 13.1318 12.3527 13.1569 12.309 13.1716C12.273 13.1837 12.2316 13.1892 12.1862 13.1892C12.1609 13.1892 12.1273 13.185 12.1025 13.18C12.0777 13.1751 12.0648 13.1696 12.0462 13.1618C12.0462 13.1618 12.0191 13.1514 12.0085 13.1786C11.9998 13.2007 11.9383 13.3698 11.931 13.3907C11.9236 13.4114 11.934 13.4277 11.9471 13.4324C11.9778 13.4433 12.0007 13.4504 12.0425 13.4602C12.1006 13.4739 12.1496 13.4748 12.1954 13.4748C12.2915 13.4748 12.3791 13.4613 12.4517 13.4351C12.5247 13.4087 12.5883 13.3627 12.6446 13.3004C12.7054 13.2332 12.7436 13.1629 12.7802 13.0669C12.8164 12.9718 12.8473 12.8538 12.8719 12.7162L13.1071 11.3854H13.451C13.451 11.3854 13.48 11.3865 13.486 11.3551L13.5249 11.138C13.5276 11.1172 13.5187 11.1043 13.4908 11.1044H13.1571C13.1587 11.0969 13.1739 10.9795 13.2122 10.8689C13.2286 10.8218 13.2593 10.7837 13.2854 10.7576C13.3098 10.7327 13.3397 10.714 13.3728 10.7032C13.4091 10.692 13.4469 10.6865 13.4849 10.687C13.5163 10.687 13.5471 10.6908 13.5706 10.6957C13.603 10.7026 13.6156 10.7062 13.624 10.7087C13.6581 10.7191 13.6626 10.7091 13.6693 10.6926L13.7491 10.4734C13.7573 10.4498 13.7373 10.4399 13.7299 10.437ZM9.0662 12.6948C9.0662 12.7122 9.05376 12.7264 9.03629 12.7264H8.75947C8.74193 12.7264 8.72949 12.7122 8.72949 12.6948V10.4667C8.72949 10.4493 8.74193 10.4352 8.75947 10.4352H9.03629C9.05376 10.4352 9.0662 10.4493 9.0662 10.4667V12.6948Z",
                fill: "#FFFFFE"
            })
        ]
    });
};

});

parcelRegister("lqrIl", function(module, exports) {

$parcel$export(module.exports, "SalesforceSearchResultIcon", () => $1174195b34229da6$export$1c85788b02a4bdef);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $1174195b34229da6$export$1c85788b02a4bdef = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-19.5",
                y: "-406.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.513685",
                y: "0.513685",
                width: "30.9726",
                height: "30.9726",
                rx: "7.48631",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "1.02737"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                id: "mask0_719_13847",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "7",
                width: "26",
                height: "18",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M3.99902 7.61694H28.0009V24.383H3.99902V7.61694Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                mask: "url(#mask0_719_13847)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13.965 9.45256C14.7397 8.64602 15.8181 8.14657 17.0093 8.14657C18.5977 8.14657 19.9743 9.02899 20.7155 10.3438C21.3735 10.0497 22.0862 9.89782 22.8069 9.89818C25.6659 9.89818 27.9867 12.2366 27.9867 15.1221C27.9867 18.0077 25.6659 20.3461 22.8069 20.3461C22.4574 20.3461 22.1168 20.311 21.7833 20.2446C21.1347 21.4006 19.8949 22.1859 18.483 22.1859C17.9082 22.1871 17.3407 22.0567 16.824 21.8047C16.1666 23.349 14.6356 24.4343 12.8531 24.4343C10.9912 24.4343 9.41167 23.2607 8.8028 21.6106C8.53181 21.6678 8.25558 21.6965 7.97862 21.6964C5.76373 21.6964 3.97241 19.8786 3.97241 17.646C3.97241 16.1459 4.77895 14.8399 5.97551 14.134C5.72166 13.5492 5.591 12.9184 5.59166 12.2809C5.59166 9.70422 7.683 7.6217 10.2597 7.6217C11.7686 7.6217 13.1187 8.34088 13.9659 9.45715",
                    fill: "#00A1E0"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.47055 16.3355C7.45546 16.3749 7.47593 16.3831 7.48078 16.39C7.52587 16.4227 7.57167 16.4463 7.61756 16.4729C7.86287 16.6026 8.09407 16.6406 8.33585 16.6406C8.82824 16.6406 9.13444 16.3785 9.13444 15.9567V15.9484C9.13444 15.5584 8.78853 15.4163 8.46557 15.3148L8.4233 15.3011C8.17887 15.2219 7.96797 15.1529 7.96797 14.9923V14.9841C7.96797 14.8464 8.09151 14.7449 8.28211 14.7449C8.49389 14.7449 8.74627 14.8155 8.90775 14.9047C8.90775 14.9047 8.95558 14.9356 8.97296 14.8894C8.9824 14.8644 9.06473 14.6441 9.07356 14.6194C9.08291 14.5935 9.0665 14.574 9.04964 14.564C8.86433 14.451 8.60843 14.3742 8.3437 14.3742L8.29455 14.3744C7.84363 14.3744 7.52861 14.6471 7.52861 15.0371V15.0455C7.52861 15.4567 7.87628 15.5908 8.20102 15.6835L8.25326 15.6997C8.48974 15.7724 8.69447 15.8356 8.69447 16.0015V16.0098C8.69447 16.1625 8.56122 16.2763 8.34767 16.2763C8.26464 16.2763 8 16.2749 7.71321 16.0936C7.67853 16.0734 7.65877 16.0589 7.63203 16.0426C7.61791 16.034 7.58261 16.0185 7.56726 16.0648L7.47019 16.3348M14.6796 16.3348C14.6645 16.3742 14.685 16.3824 14.69 16.3893C14.7349 16.422 14.7809 16.4456 14.8268 16.4722C15.0721 16.6019 15.3033 16.6399 15.5451 16.6399C16.0375 16.6399 16.3437 16.3778 16.3437 15.956V15.9477C16.3437 15.5577 15.9986 15.4156 15.6748 15.3141L15.6325 15.3004C15.3881 15.2212 15.1772 15.1522 15.1772 14.9916V14.9834C15.1772 14.8457 15.3007 14.7442 15.4913 14.7442C15.7031 14.7442 15.9546 14.8147 16.117 14.904C16.117 14.904 16.1648 14.9348 16.1823 14.8887C16.1916 14.8637 16.274 14.6434 16.282 14.6187C16.2914 14.5928 16.2749 14.5733 16.2582 14.5633C16.0729 14.4503 15.8169 14.3735 15.5522 14.3735L15.503 14.3737C15.0521 14.3737 14.737 14.6464 14.737 15.0364V15.0448C14.737 15.456 15.0847 15.5901 15.4094 15.6828L15.4616 15.699C15.699 15.7717 15.9028 15.8349 15.9028 16.0008V16.0091C15.9028 16.1618 15.7696 16.2756 15.556 16.2756C15.4728 16.2756 15.2075 16.2742 14.9216 16.0929C14.8869 16.0727 14.8666 16.0588 14.8403 16.0418C14.8314 16.0362 14.7898 16.02 14.7756 16.0641L14.6785 16.3341M19.6025 15.5082C19.6025 15.7464 19.558 15.9344 19.471 16.0676C19.3841 16.1991 19.253 16.2635 19.0704 16.2635C18.8877 16.2635 18.7571 16.1996 18.6715 16.0685C18.5853 15.9361 18.5418 15.7473 18.5418 15.509C18.5418 15.2708 18.5856 15.0837 18.6715 14.9522C18.7569 14.8216 18.8868 14.759 19.0704 14.759C19.2539 14.759 19.3845 14.8222 19.471 14.9522C19.5585 15.0837 19.6025 15.2708 19.6025 15.509M20.0137 15.0669C19.9732 14.9302 19.9104 14.8102 19.8266 14.7096C19.7427 14.609 19.6369 14.5278 19.5107 14.4695C19.3854 14.4109 19.2371 14.3813 19.0695 14.3813C18.9018 14.3813 18.7544 14.411 18.6283 14.4695C18.503 14.5281 18.3962 14.609 18.3124 14.7096C18.2287 14.8102 18.1659 14.9302 18.1253 15.0669C18.0851 15.2028 18.0647 15.3511 18.0647 15.509C18.0647 15.667 18.0851 15.8152 18.1253 15.9511C18.1656 16.0879 18.2285 16.2079 18.3124 16.3085C18.3963 16.4091 18.503 16.4894 18.6283 16.5468C18.7544 16.6039 18.9027 16.6331 19.0695 16.6331C19.2363 16.6331 19.3845 16.6039 19.5098 16.5468C19.6351 16.4896 19.7419 16.4091 19.8257 16.3085C19.9095 16.2079 19.9722 16.0879 20.0128 15.9511C20.0528 15.8152 20.0732 15.667 20.0732 15.509C20.0732 15.352 20.0528 15.2028 20.0128 15.0669M23.3925 16.1964C23.379 16.1565 23.34 16.1716 23.34 16.1716C23.2802 16.1944 23.2164 16.2156 23.1485 16.2262C23.08 16.2369 23.0038 16.2423 22.9235 16.2423C22.7249 16.2423 22.5661 16.1831 22.4531 16.0658C22.3393 15.9485 22.2758 15.7596 22.2766 15.5037C22.2773 15.2708 22.3336 15.0961 22.4346 14.9619C22.5343 14.8296 22.6879 14.7607 22.8908 14.7607C23.0602 14.7607 23.19 14.7804 23.3258 14.823C23.3258 14.823 23.3581 14.837 23.3735 14.7945C23.4096 14.6948 23.4362 14.6233 23.475 14.5139C23.4859 14.4826 23.4591 14.4694 23.4493 14.4656C23.396 14.4447 23.2702 14.4106 23.1749 14.3962C23.0857 14.3826 22.9825 14.3756 22.866 14.3756C22.6931 14.3756 22.5395 14.4051 22.408 14.4637C22.2766 14.5222 22.1654 14.6031 22.0771 14.7037C21.9889 14.8043 21.9218 14.9243 21.8768 15.0611C21.8323 15.197 21.8098 15.3461 21.8098 15.5041C21.8098 15.8447 21.9015 16.1209 22.0833 16.323C22.2651 16.5259 22.5386 16.6283 22.8951 16.6283C23.106 16.6283 23.3222 16.5857 23.4775 16.5242C23.4775 16.5242 23.5072 16.5099 23.4943 16.4753L23.3928 16.1964M24.112 15.2787C24.1317 15.1464 24.1679 15.0361 24.2249 14.9505C24.3103 14.8199 24.4403 14.7484 24.6229 14.7484C24.8056 14.7484 24.9265 14.8202 25.013 14.9505C25.0703 15.0365 25.0954 15.1508 25.1047 15.2787L24.1076 15.2785L24.112 15.2787ZM25.4974 14.9875C25.4624 14.856 25.3756 14.7228 25.3192 14.6619C25.2291 14.5657 25.1418 14.4978 25.0544 14.4607C24.9283 14.4071 24.7926 14.3796 24.6556 14.3798C24.4817 14.3798 24.3238 14.4092 24.1958 14.4689C24.0679 14.5291 23.9602 14.611 23.8755 14.7134C23.7909 14.8157 23.7273 14.9366 23.6867 15.0751C23.6461 15.2119 23.6256 15.3619 23.6256 15.519C23.6256 15.6796 23.6469 15.8287 23.6887 15.9638C23.731 16.0996 23.799 16.2188 23.8908 16.3176C23.9825 16.4173 24.0999 16.495 24.2411 16.5497C24.3814 16.6039 24.5517 16.6321 24.7467 16.6315C25.1491 16.6302 25.3609 16.5406 25.4474 16.4921C25.4628 16.4834 25.4774 16.4685 25.4592 16.4255L25.3683 16.1705C25.3544 16.1325 25.3159 16.1462 25.3159 16.1462C25.2162 16.1835 25.075 16.2504 24.7441 16.2495C24.5279 16.2491 24.3682 16.1853 24.2676 16.0853C24.1652 15.983 24.114 15.8339 24.1061 15.6221L25.5003 15.6231C25.5003 15.6231 25.537 15.6228 25.5408 15.587C25.5423 15.5721 25.5886 15.3011 25.4993 14.9878L25.4974 14.9875ZM12.967 15.2787C12.9867 15.1464 13.023 15.0361 13.0799 14.9505C13.1654 14.8199 13.2952 14.7484 13.4779 14.7484C13.6606 14.7484 13.7815 14.8202 13.8679 14.9505C13.9252 15.0365 13.9503 15.1508 13.9597 15.2787L12.9626 15.2785L12.967 15.2787ZM14.3524 14.9875C14.3174 14.856 14.2306 14.7228 14.1741 14.6619C14.0841 14.5657 13.9968 14.4978 13.9094 14.4607C13.7833 14.4071 13.6476 14.3796 13.5106 14.3798C13.3367 14.3798 13.1788 14.4092 13.0508 14.4689C12.9229 14.5291 12.8152 14.611 12.7305 14.7134C12.646 14.8157 12.5822 14.9366 12.5417 15.0751C12.5012 15.2119 12.4808 15.3619 12.4808 15.519C12.4808 15.6796 12.5019 15.8287 12.544 15.9638C12.5861 16.0996 12.6543 16.2188 12.7451 16.3176C12.8369 16.4173 12.9543 16.495 13.0955 16.5497C13.2358 16.6039 13.4052 16.6321 13.6011 16.6315C14.0035 16.6302 14.2153 16.5406 14.3017 16.4921C14.3171 16.4834 14.3317 16.4685 14.3135 16.4255L14.2226 16.1705C14.2086 16.1325 14.1701 16.1462 14.1701 16.1462C14.0704 16.1835 13.9292 16.2504 13.5983 16.2495C13.383 16.2491 13.2224 16.1853 13.1218 16.0853C13.0194 15.983 12.9682 15.8339 12.9603 15.6221L14.3545 15.6231C14.3545 15.6231 14.3912 15.6228 14.395 15.587C14.3965 15.5721 14.4428 15.3011 14.3534 14.9878L14.3524 14.9875ZM9.95792 16.1876C9.9033 16.144 9.89571 16.1334 9.87762 16.105C9.85 16.0624 9.83588 16.0018 9.83588 15.9241C9.83588 15.8024 9.87647 15.7141 9.9603 15.655C9.95942 15.6552 10.0803 15.5509 10.3645 15.5544C10.4909 15.5567 10.6171 15.5674 10.7421 15.5866V16.2193H10.7423C10.7423 16.2193 10.5658 16.2573 10.3664 16.2693C10.0831 16.2864 9.95783 16.1878 9.95872 16.1881L9.95792 16.1876ZM10.5121 15.2081C10.4556 15.204 10.3824 15.202 10.295 15.202C10.1759 15.202 10.0603 15.2168 9.95263 15.2459C9.84409 15.2752 9.74614 15.3206 9.66231 15.3809C9.57825 15.4409 9.50911 15.5194 9.46023 15.6103C9.41091 15.7021 9.38576 15.8098 9.38576 15.9315C9.38576 16.0551 9.4072 16.1619 9.44956 16.2492C9.49106 16.3359 9.55354 16.4108 9.63134 16.4672C9.70872 16.5235 9.80429 16.5651 9.91459 16.5898C10.024 16.6148 10.1476 16.6274 10.2834 16.6274C10.4264 16.6274 10.5685 16.6154 10.7061 16.5922C10.8234 16.572 10.9402 16.5493 11.0565 16.5241C11.1029 16.5134 11.1544 16.4994 11.1544 16.4994C11.1888 16.4906 11.1862 16.4538 11.1862 16.4538L11.1854 15.1832C11.1854 14.9043 11.1109 14.6969 10.9639 14.569C10.8174 14.441 10.603 14.3766 10.325 14.3766C10.2209 14.3766 10.0523 14.3907 9.95174 14.4109C9.95174 14.4109 9.64819 14.4699 9.52289 14.568C9.52289 14.568 9.49535 14.585 9.51036 14.6233L9.60919 14.8881C9.62145 14.9224 9.6549 14.9107 9.6549 14.9107C9.6549 14.9107 9.6654 14.9065 9.67775 14.8992C9.94513 14.7536 10.284 14.758 10.284 14.758C10.434 14.758 10.5505 14.7885 10.6281 14.848C10.7041 14.9063 10.7428 14.9945 10.7428 15.1798V15.2387C10.6237 15.2214 10.5134 15.2114 10.5134 15.2114L10.5121 15.2081ZM21.7189 14.4907C21.7209 14.4861 21.7219 14.4811 21.722 14.476C21.722 14.4709 21.721 14.4659 21.719 14.4612C21.7171 14.4565 21.7142 14.4523 21.7106 14.4488C21.707 14.4452 21.7027 14.4424 21.698 14.4406C21.6742 14.4316 21.5559 14.4066 21.465 14.401C21.2903 14.39 21.1932 14.4195 21.1058 14.4587C21.0195 14.4976 20.9241 14.5602 20.8711 14.6325L20.8709 14.4631C20.8709 14.4398 20.8544 14.421 20.831 14.421H20.4745C20.4514 14.421 20.4346 14.4398 20.4346 14.4631V16.5368C20.4346 16.548 20.4391 16.5587 20.447 16.5667C20.4549 16.5746 20.4657 16.579 20.4769 16.5791H20.8422C20.8534 16.579 20.8641 16.5746 20.872 16.5667C20.8799 16.5587 20.8844 16.548 20.8844 16.5368V15.4955C20.8844 15.3561 20.8997 15.2176 20.9303 15.1302C20.9605 15.0438 21.0015 14.9749 21.0521 14.9255C21.1003 14.8778 21.1594 14.8424 21.2242 14.8222C21.285 14.8048 21.348 14.7959 21.4113 14.796C21.4841 14.796 21.5639 14.8147 21.5639 14.8147C21.5907 14.8177 21.6057 14.8012 21.6147 14.7771C21.6387 14.7134 21.7065 14.5229 21.7197 14.485",
                fill: "#FFFFFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.3067 13.5334C18.2615 13.5198 18.2156 13.5089 18.1691 13.5008C18.1066 13.4904 18.0433 13.4855 17.9799 13.4861C17.7282 13.4861 17.5297 13.5573 17.3904 13.6978C17.252 13.8372 17.1579 14.0496 17.1106 14.329L17.0936 14.4234H16.7776C16.7776 14.4234 16.7391 14.4218 16.7309 14.4639L16.6791 14.7533C16.6754 14.781 16.6874 14.7983 16.7244 14.7981H17.032L16.7199 16.5403C16.6955 16.6806 16.6675 16.796 16.6365 16.8835C16.606 16.9698 16.5762 17.0345 16.5395 17.0814C16.5039 17.1269 16.4702 17.1603 16.412 17.1798C16.364 17.1959 16.3088 17.2034 16.2483 17.2034C16.2145 17.2034 16.1697 17.1977 16.1366 17.1911C16.1035 17.1846 16.0863 17.1771 16.0615 17.1667C16.0615 17.1667 16.0254 17.153 16.0112 17.1891C15.9997 17.2187 15.9177 17.4442 15.908 17.4721C15.8981 17.4996 15.912 17.5213 15.9294 17.5276C15.9704 17.5422 16.0008 17.5516 16.0566 17.5647C16.1341 17.583 16.1994 17.5841 16.2605 17.5841C16.3886 17.5841 16.5054 17.5661 16.6022 17.5312C16.6996 17.496 16.7844 17.4346 16.8594 17.3516C16.9405 17.262 16.9915 17.1682 17.0403 17.0403C17.0886 16.9135 17.1297 16.7561 17.1626 16.5726L17.4762 14.7981H17.9347C17.9347 14.7981 17.9734 14.7995 17.9814 14.7576L18.0333 14.4682C18.0369 14.4405 18.0251 14.4232 17.9879 14.4234H17.5429C17.5451 14.4133 17.5653 14.2568 17.6164 14.1094C17.6382 14.0465 17.6792 13.9957 17.714 13.9609C17.7464 13.9277 17.7864 13.9028 17.8305 13.8884C17.8789 13.8734 17.9293 13.8661 17.9799 13.8668C18.0218 13.8668 18.063 13.8719 18.0943 13.8784C18.1374 13.8876 18.1542 13.8924 18.1655 13.8958C18.2109 13.9096 18.2169 13.8962 18.2259 13.8742L18.3323 13.582C18.3432 13.5506 18.3166 13.5373 18.3067 13.5334ZM12.0879 16.544C12.0879 16.5673 12.0713 16.5863 12.048 16.5863H11.6789C11.6555 16.5863 11.6389 16.5673 11.6389 16.544V13.5731C11.6389 13.5499 11.6555 13.5311 11.6789 13.5311H12.048C12.0713 13.5311 12.0879 13.5499 12.0879 13.5731V16.544Z",
                fill: "#FFFFFE"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                id: "mask0_2230_18832",
                maskUnits: "userSpaceOnUse",
                x: "5",
                y: "10",
                width: "30",
                height: "21",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M5 10H35V30.9559H5V10Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                mask: "url(#mask0_2230_18832)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.4566 12.2941C18.425 11.286 19.7728 10.6618 21.2618 10.6618C23.2471 10.6618 24.9677 11.7647 25.8941 13.4081C26.7165 13.0405 27.6073 12.8506 28.5081 12.8511C32.0816 12.8511 34.9824 15.7739 34.9824 19.3805C34.9824 22.9871 32.0816 25.9099 28.5081 25.9099C28.0713 25.9099 27.6456 25.866 27.2287 25.7831C26.418 27.2279 24.8684 28.2096 23.1037 28.2096C22.3852 28.211 21.6759 28.048 21.0302 27.7331C20.2085 29.6632 18.2949 31.0199 16.0669 31.0199C13.7397 31.0199 11.7654 29.5529 11.0044 27.4904C10.6657 27.5619 10.3204 27.5979 9.97427 27.5976C7.20589 27.5976 4.96692 25.3256 4.96692 22.5351C4.96692 20.6601 5.97501 19.0278 7.4706 18.1454C7.15331 17.4145 6.98999 16.6261 6.99082 15.8293C6.99082 12.6087 9.60479 10.0057 12.8254 10.0057C14.7114 10.0057 16.3989 10.9046 17.4577 12.2999",
                    fill: "#00A1E0"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.33897 20.8971C9.32011 20.9463 9.3457 20.9565 9.35177 20.9652C9.40813 21.006 9.46537 21.0356 9.52272 21.0688C9.82934 21.2309 10.1183 21.2784 10.4205 21.2784C11.036 21.2784 11.4187 20.9508 11.4187 20.4236V20.4132C11.4187 19.9257 10.9863 19.7481 10.5827 19.6213L10.5298 19.6042C10.2243 19.5052 9.9607 19.4189 9.9607 19.2182V19.2079C9.9607 19.0359 10.1151 18.909 10.3533 18.909C10.6181 18.909 10.9335 18.9971 11.1353 19.1087C11.1353 19.1087 11.1951 19.1473 11.2168 19.0896C11.2286 19.0584 11.3315 18.783 11.3426 18.7521C11.3543 18.7198 11.3338 18.6954 11.3127 18.6828C11.0811 18.5416 10.7612 18.4457 10.4303 18.4457L10.3689 18.4459C9.8053 18.4459 9.41155 18.7867 9.41155 19.2742V19.2847C9.41155 19.7987 9.84611 19.9663 10.252 20.0821L10.3173 20.1024C10.6129 20.1933 10.8688 20.2723 10.8688 20.4796V20.49C10.8688 20.6808 10.7022 20.8231 10.4353 20.8231C10.3315 20.8231 10.0007 20.8213 9.64228 20.5948C9.59894 20.5695 9.57423 20.5513 9.54081 20.5309C9.52317 20.5202 9.47905 20.5009 9.45986 20.5587L9.33853 20.8962M18.3496 20.8962C18.3307 20.9454 18.3563 20.9556 18.3626 20.9644C18.4187 21.0052 18.4762 21.0347 18.5335 21.0679C18.8402 21.2301 19.1291 21.2775 19.4313 21.2775C20.0468 21.2775 20.4295 20.9499 20.4295 20.4227V20.4123C20.4295 19.9248 19.9982 19.7473 19.5935 19.6204L19.5406 19.6033C19.2351 19.5043 18.9715 19.418 18.9715 19.2173V19.207C18.9715 19.035 19.1259 18.9081 19.3642 18.9081C19.6289 18.9081 19.9432 18.9963 20.1461 19.1078C20.1461 19.1078 20.2059 19.1464 20.2278 19.0887C20.2395 19.0575 20.3425 18.7821 20.3524 18.7512C20.3642 18.7189 20.3436 18.6945 20.3226 18.6819C20.091 18.5407 19.7711 18.4448 19.4403 18.4448L19.3787 18.445C18.8151 18.445 18.4214 18.7858 18.4214 19.2733V19.2838C18.4214 19.7978 18.8559 19.9654 19.2618 20.0812L19.327 20.1015C19.6237 20.1924 19.8785 20.2714 19.8785 20.4787V20.4891C19.8785 20.6799 19.7119 20.8222 19.445 20.8222C19.341 20.8222 19.0093 20.8204 18.652 20.5939C18.6086 20.5686 18.5833 20.5512 18.5504 20.53C18.5393 20.523 18.4873 20.5027 18.4696 20.5578L18.3482 20.8953M24.5027 19.863C24.5027 20.1607 24.4471 20.3957 24.3383 20.5622C24.2298 20.7266 24.0659 20.8071 23.8376 20.8071C23.6093 20.8071 23.446 20.7272 23.339 20.5633C23.2313 20.3979 23.1769 20.1619 23.1769 19.8641C23.1769 19.5663 23.2316 19.3324 23.339 19.1681C23.4458 19.0049 23.6082 18.9266 23.8376 18.9266C24.067 18.9266 24.2302 19.0056 24.3383 19.1681C24.4477 19.3324 24.5027 19.5663 24.5027 19.8641M25.0166 19.3115C24.966 19.1405 24.8876 18.9905 24.7828 18.8648C24.6779 18.7391 24.5457 18.6376 24.3879 18.5648C24.2313 18.4914 24.046 18.4545 23.8365 18.4545C23.6269 18.4545 23.4427 18.4917 23.285 18.5648C23.1284 18.638 22.9949 18.7391 22.8902 18.8648C22.7856 18.9905 22.7071 19.1405 22.6563 19.3115C22.6061 19.4813 22.5807 19.6666 22.5807 19.8641C22.5807 20.0615 22.6061 20.2468 22.6563 20.4166C22.7067 20.5876 22.7854 20.7376 22.8902 20.8633C22.995 20.9891 23.1284 21.0894 23.285 21.1611C23.4427 21.2326 23.628 21.269 23.8365 21.269C24.0449 21.269 24.2302 21.2326 24.3868 21.1611C24.5435 21.0896 24.6769 20.9891 24.7817 20.8633C24.8864 20.7376 24.9648 20.5876 25.0155 20.4166C25.0656 20.2468 25.0911 20.0615 25.0911 19.8641C25.0911 19.6677 25.0656 19.4813 25.0155 19.3115M29.2398 20.7232C29.2229 20.6733 29.1742 20.6921 29.1742 20.6921C29.0995 20.7207 29.0197 20.7472 28.9348 20.7604C28.8492 20.7739 28.7539 20.7806 28.6536 20.7806C28.4054 20.7806 28.2069 20.7066 28.0657 20.56C27.9234 20.4133 27.844 20.1773 27.8451 19.8574C27.8459 19.5663 27.9163 19.3479 28.0425 19.1802C28.1672 19.0148 28.3591 18.9288 28.6128 18.9288C28.8245 18.9288 28.9867 18.9534 29.1565 19.0065C29.1565 19.0065 29.1968 19.0241 29.2161 18.971C29.2612 18.8464 29.2945 18.757 29.3429 18.6203C29.3566 18.5811 29.3231 18.5646 29.3108 18.5598C29.2442 18.5338 29.0869 18.4911 28.9678 18.4731C28.8564 18.4562 28.7274 18.4473 28.5818 18.4473C28.3656 18.4473 28.1737 18.4843 28.0093 18.5575C27.845 18.6306 27.706 18.7318 27.5957 18.8575C27.4854 18.9832 27.4016 19.1332 27.3454 19.3042C27.2897 19.4741 27.2615 19.6605 27.2615 19.8579C27.2615 20.2836 27.3763 20.6288 27.6035 20.8814C27.8307 21.1351 28.1726 21.263 28.6182 21.263C28.8818 21.263 29.152 21.2098 29.3461 21.1329C29.3461 21.1329 29.3832 21.115 29.3671 21.0718L29.2402 20.7232M30.1391 19.5762C30.1637 19.4107 30.209 19.2729 30.2803 19.1659C30.387 19.0027 30.5494 18.9133 30.7777 18.9133C31.006 18.9133 31.1571 19.0031 31.2652 19.1659C31.3369 19.2734 31.3682 19.4163 31.3799 19.5762L30.1336 19.576L30.1391 19.5762ZM31.8707 19.2122C31.827 19.0479 31.7185 18.8813 31.6479 18.8052C31.5354 18.685 31.4263 18.6001 31.3171 18.5538C31.1594 18.4867 30.9898 18.4523 30.8185 18.4526C30.6013 18.4526 30.4038 18.4894 30.2439 18.564C30.084 18.6392 29.9494 18.7416 29.8435 18.8695C29.7378 18.9975 29.6582 19.1486 29.6075 19.3217C29.5568 19.4927 29.5312 19.6802 29.5312 19.8765C29.5312 20.0773 29.5578 20.2637 29.61 20.4324C29.6629 20.6023 29.7479 20.7512 29.8626 20.8747C29.9773 20.9993 30.124 21.0964 30.3005 21.1648C30.4759 21.2326 30.6887 21.2678 30.9325 21.267C31.4354 21.2653 31.7001 21.1534 31.8082 21.0927C31.8275 21.0819 31.8457 21.0633 31.823 21.0096L31.7094 20.6908C31.692 20.6433 31.6439 20.6605 31.6439 20.6605C31.5192 20.707 31.3428 20.7906 30.9292 20.7895C30.6589 20.7891 30.4593 20.7094 30.3336 20.5844C30.2056 20.4564 30.1417 20.2701 30.1317 20.0053L31.8744 20.0067C31.8744 20.0067 31.9203 20.0062 31.925 19.9614C31.9269 19.9429 31.9847 19.6041 31.8731 19.2126L31.8707 19.2122ZM16.209 19.5762C16.2336 19.4107 16.279 19.2729 16.3502 19.1659C16.4569 19.0027 16.6193 18.9133 16.8476 18.9133C17.0759 18.9133 17.227 19.0031 17.3351 19.1659C17.4067 19.2734 17.438 19.4163 17.4498 19.5762L16.2035 19.576L16.209 19.5762ZM17.9406 19.2122C17.8969 19.0479 17.7884 18.8813 17.7178 18.8052C17.6053 18.685 17.4961 18.6001 17.3869 18.5538C17.2293 18.4867 17.0597 18.4523 16.8884 18.4526C16.6711 18.4526 16.4737 18.4894 16.3138 18.564C16.1538 18.6392 16.0193 18.7416 15.9134 18.8695C15.8078 18.9975 15.7281 19.1486 15.6774 19.3217C15.6267 19.4927 15.6013 19.6802 15.6013 19.8765C15.6013 20.0773 15.6276 20.2637 15.6802 20.4324C15.7329 20.6023 15.8181 20.7512 15.9317 20.8747C16.0464 20.9993 16.1931 21.0964 16.3696 21.1648C16.5449 21.2326 16.7567 21.2678 17.0015 21.267C17.5045 21.2653 17.7692 21.1534 17.8773 21.0927C17.8965 21.0819 17.9148 21.0633 17.892 21.0096L17.7783 20.6908C17.7608 20.6433 17.7127 20.6605 17.7127 20.6605C17.5881 20.707 17.4116 20.7906 16.998 20.7895C16.7289 20.7891 16.5282 20.7094 16.4024 20.5844C16.2745 20.4564 16.2105 20.2701 16.2006 20.0053L17.9432 20.0067C17.9432 20.0067 17.9891 20.0062 17.9939 19.9614C17.9957 19.9429 18.0535 19.6041 17.9418 19.2126L17.9406 19.2122ZM12.4479 20.7122C12.3797 20.6577 12.3702 20.6444 12.3476 20.609C12.3131 20.5557 12.2954 20.4799 12.2954 20.3829C12.2954 20.2307 12.3461 20.1204 12.4509 20.0465C12.4498 20.0467 12.6009 19.9163 12.9561 19.9207C13.1141 19.9236 13.2719 19.937 13.4281 19.961V20.7518H13.4283C13.4283 20.7518 13.2078 20.7994 12.9585 20.8144C12.6045 20.8356 12.4478 20.7124 12.4489 20.7128L12.4479 20.7122ZM13.1406 19.488C13.07 19.4828 12.9785 19.4802 12.8693 19.4802C12.7204 19.4802 12.5759 19.4988 12.4413 19.5352C12.3057 19.5718 12.1832 19.6285 12.0785 19.7039C11.9734 19.7789 11.887 19.877 11.8259 19.9907C11.7642 20.1054 11.7328 20.2399 11.7328 20.3921C11.7328 20.5466 11.7596 20.68 11.8125 20.7892C11.8644 20.8975 11.9425 20.9912 12.0397 21.0616C12.1365 21.132 12.2559 21.1841 12.3938 21.2149C12.5306 21.2462 12.685 21.2619 12.8548 21.2619C13.0335 21.2619 13.2111 21.2469 13.3831 21.2179C13.5297 21.1926 13.6757 21.1643 13.821 21.1328C13.879 21.1194 13.9434 21.1019 13.9434 21.1019C13.9864 21.091 13.9831 21.045 13.9831 21.045L13.9821 19.4567C13.9821 19.1082 13.889 18.849 13.7053 18.6891C13.5222 18.5292 13.2542 18.4487 12.9068 18.4487C12.7766 18.4487 12.566 18.4663 12.4402 18.4916C12.4402 18.4916 12.0608 18.5652 11.9042 18.6879C11.9042 18.6879 11.8698 18.7091 11.8885 18.757L12.0121 19.0879C12.0274 19.1308 12.0692 19.1162 12.0692 19.1162C12.0692 19.1162 12.0823 19.111 12.0978 19.1018C12.432 18.9198 12.8555 18.9253 12.8555 18.9253C13.043 18.9253 13.1886 18.9634 13.2856 19.0378C13.3806 19.1107 13.429 19.2209 13.429 19.4526V19.5261C13.2801 19.5045 13.1422 19.492 13.1422 19.492L13.1406 19.488ZM27.1479 18.5913C27.1505 18.5854 27.1518 18.5792 27.1518 18.5729C27.1518 18.5665 27.1506 18.5602 27.1482 18.5544C27.1457 18.5486 27.1421 18.5433 27.1376 18.5388C27.1331 18.5344 27.1277 18.5309 27.1218 18.5286C27.0921 18.5174 26.9442 18.4862 26.8306 18.4791C26.6122 18.4654 26.4909 18.5023 26.3817 18.5512C26.2739 18.5999 26.1545 18.6781 26.0884 18.7685L26.0881 18.5567C26.0881 18.5276 26.0675 18.5041 26.0382 18.5041H25.5926C25.5637 18.5041 25.5427 18.5276 25.5427 18.5567V21.1487C25.5428 21.1627 25.5483 21.1761 25.5582 21.186C25.5681 21.1959 25.5816 21.2015 25.5956 21.2015H26.0522C26.0662 21.2015 26.0796 21.1959 26.0895 21.186C26.0993 21.1761 26.1049 21.1626 26.1049 21.1487V19.8472C26.1049 19.6729 26.1241 19.4998 26.1624 19.3906C26.2001 19.2826 26.2514 19.1964 26.3146 19.1347C26.3749 19.075 26.4486 19.0308 26.5296 19.0056C26.6057 18.9838 26.6844 18.9728 26.7635 18.9728C26.8545 18.9728 26.9543 18.9962 26.9543 18.9962C26.9878 18.9999 27.0064 18.9794 27.0178 18.9492C27.0477 18.8696 27.1325 18.6315 27.149 18.5841",
                fill: "#FFFFFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.8832 17.395C22.8268 17.378 22.7694 17.3643 22.7113 17.3542C22.6332 17.3412 22.554 17.335 22.4748 17.3359C22.1602 17.3359 21.9121 17.4248 21.7379 17.6004C21.565 17.7746 21.4473 18.0401 21.3883 18.3894L21.367 18.5073H20.9721C20.9721 18.5073 20.9239 18.5053 20.9137 18.558L20.8489 18.9197C20.8443 18.9544 20.8592 18.976 20.9056 18.9757H21.29L20.8999 21.1533C20.8694 21.3287 20.8344 21.4729 20.7957 21.5822C20.7575 21.6901 20.7203 21.7709 20.6744 21.8296C20.6299 21.8864 20.5878 21.9282 20.5151 21.9526C20.4551 21.9728 20.3861 21.982 20.3104 21.982C20.2683 21.982 20.2122 21.975 20.1709 21.9667C20.1295 21.9585 20.108 21.9493 20.077 21.9363C20.077 21.9363 20.0319 21.9191 20.0142 21.9643C19.9997 22.0012 19.8972 22.283 19.8851 22.3179C19.8728 22.3523 19.8901 22.3794 19.9119 22.3873C19.9631 22.4056 20.0011 22.4173 20.0708 22.4337C20.1677 22.4565 20.2493 22.458 20.3257 22.458C20.4859 22.458 20.6318 22.4355 20.7528 22.3918C20.8746 22.3478 20.9806 22.2711 21.0743 22.1673C21.1757 22.0554 21.2394 21.9381 21.3004 21.7782C21.3607 21.6197 21.4121 21.423 21.4533 21.1937L21.8453 18.9757H22.4183C22.4183 18.9757 22.4667 18.9775 22.4767 18.9251L22.5415 18.5634C22.5461 18.5287 22.5313 18.5071 22.4847 18.5073H21.9285C21.9313 18.4948 21.9565 18.2991 22.0204 18.1149C22.0477 18.0363 22.0989 17.9728 22.1424 17.9293C22.183 17.8878 22.2329 17.8567 22.2881 17.8386C22.3485 17.8199 22.4116 17.8108 22.4748 17.8117C22.5272 17.8117 22.5786 17.818 22.6178 17.8262C22.6717 17.8376 22.6926 17.8437 22.7068 17.8479C22.7635 17.8652 22.7711 17.8484 22.7822 17.821L22.9152 17.4557C22.9289 17.4164 22.8956 17.3999 22.8832 17.395ZM15.1104 21.1579C15.1104 21.187 15.0896 21.2107 15.0605 21.2107H14.5992C14.5699 21.2107 14.5492 21.187 14.5492 21.1579V17.4445C14.5492 17.4155 14.5699 17.392 14.5992 17.392H15.0605C15.0896 17.392 15.1104 17.4155 15.1104 17.4445V21.1579Z",
                fill: "#FFFFFE"
            })
        ]
    });
};

});


parcelRegister("3r3f3", function(module, exports) {

$parcel$export(module.exports, "sentryConfig", () => $b1c1bb33fa733897$export$6c52693ff10aea16);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $9phcm = parcelRequire("9phcm");

var $bkvSq = parcelRequire("bkvSq");
const $b1c1bb33fa733897$export$6c52693ff10aea16 = {
    displayName: 'Sentry',
    id: 'sentry',
    resourceType: 'smartlinks-connector-sentry',
    icon: (0, $9yyKc.get3PLogo)((0, $9phcm.SentryIcon), 'Sentry', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $bkvSq.SentrySearchResultIcon), 'Sentry', 'large'),
    integrationAri: 'ari:cloud:platform::integration/sentry',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("9phcm", function(module, exports) {

$parcel$export(module.exports, "SentryIcon", () => $48f15a0ebfeae12d$export$ddeafef64c08610e);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $48f15a0ebfeae12d$export$ddeafef64c08610e = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-779.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.2634 5.12647C13.1313 4.90729 12.9448 4.72597 12.722 4.6001C12.4992 4.47423 12.2477 4.40808 11.9918 4.40808C11.7359 4.40808 11.4844 4.47423 11.2616 4.6001C11.0388 4.72597 10.8523 4.90729 10.7202 5.12647L8.62849 8.70913C10.2265 9.50694 11.588 10.7089 12.5779 12.1956C13.5677 13.6823 14.1514 15.4021 14.2711 17.1842H12.8024C12.683 15.6566 12.1667 14.1867 11.3047 12.9199C10.4427 11.6531 9.26492 10.6334 7.8878 9.96162L5.95183 13.309C6.726 13.6562 7.40046 14.1925 7.91318 14.8686C8.4259 15.5446 8.76042 16.3387 8.88598 17.1778H5.51314C5.47313 17.175 5.43447 17.1622 5.40062 17.1407C5.36677 17.1192 5.33881 17.0896 5.31926 17.0546C5.2997 17.0196 5.28917 16.9803 5.28861 16.9402C5.28805 16.9001 5.29747 16.8605 5.31604 16.8249L6.25065 15.2355C5.93401 14.9713 5.57212 14.7667 5.18253 14.6315L4.25746 16.2209C4.16115 16.3861 4.09863 16.5688 4.07353 16.7584C4.04842 16.9479 4.06124 17.1406 4.11122 17.3251C4.16121 17.5097 4.24737 17.6825 4.3647 17.8335C4.48203 17.9844 4.62819 18.1106 4.7947 18.2046C5.01407 18.3282 5.26134 18.3938 5.51314 18.3953H10.1321C10.2179 17.3368 10.0289 16.274 9.58332 15.3099C9.13777 14.3459 8.45081 13.5132 7.58898 12.8926L8.32331 11.621C9.41096 12.3681 10.285 13.3858 10.8592 14.5738C11.4334 15.7618 11.6879 17.0789 11.5976 18.3953H15.5109C15.602 16.4012 15.1682 14.418 14.2528 12.6441C13.3373 10.8701 11.9724 9.36748 10.2943 8.28633L11.7788 5.74318C11.8119 5.68775 11.8655 5.64764 11.928 5.63156C11.9906 5.61549 12.0569 5.62476 12.1126 5.65735C12.2811 5.74954 18.5627 16.7105 18.6803 16.8377C18.701 16.8748 18.7115 16.9168 18.7108 16.9593C18.7101 17.0019 18.6982 17.0435 18.6763 17.0799C18.6543 17.1164 18.6232 17.1464 18.5859 17.1669C18.5487 17.1874 18.5066 17.1978 18.4641 17.1969H16.9509C16.97 17.6017 16.97 18.0054 16.9509 18.4081H18.4705C18.6634 18.4093 18.8547 18.3723 19.0333 18.2991C19.2118 18.226 19.3741 18.1181 19.5107 17.9818C19.6473 17.8455 19.7554 17.6835 19.829 17.5051C19.9025 17.3267 19.94 17.1355 19.9391 16.9426C19.9393 16.6877 19.8713 16.4374 19.742 16.2178L13.2634 5.12647Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M13.273 5.71839C13.1399 5.49921 12.952 5.31788 12.7275 5.19201C12.503 5.06614 12.2495 5 11.9916 5C11.7338 5 11.4803 5.06614 11.2558 5.19201C11.0313 5.31788 10.8434 5.49921 10.7103 5.71839L8.60252 9.30104C10.2128 10.0989 11.5848 11.3008 12.5822 12.7875C13.5796 14.2742 14.1679 15.994 14.2884 17.7761H12.8085C12.6881 16.2485 12.1679 14.7786 11.2993 13.5118C10.4307 12.2451 9.24383 11.2253 7.85614 10.5535L5.90531 13.901C6.68543 14.2482 7.36506 14.7844 7.88171 15.4605C8.39837 16.1365 8.73546 16.9306 8.86199 17.7697H5.46325C5.42294 17.7669 5.38397 17.7542 5.34987 17.7326C5.31576 17.7111 5.28758 17.6815 5.26788 17.6465C5.24817 17.6115 5.23756 17.5722 5.23699 17.5321C5.23643 17.492 5.24593 17.4524 5.26464 17.4169L6.20642 15.8274C5.88735 15.5632 5.52269 15.3586 5.1301 15.2234L4.19793 16.8129C4.10089 16.978 4.03789 17.1607 4.01259 17.3503C3.98729 17.5398 4.0002 17.7325 4.05057 17.917C4.10094 18.1016 4.18776 18.2744 4.30599 18.4254C4.42423 18.5764 4.57151 18.7025 4.73929 18.7965C4.96035 18.9201 5.20952 18.9858 5.46325 18.9873H10.1177C10.2041 17.9287 10.0136 16.8659 9.56468 15.9018C9.11571 14.9378 8.42348 14.1051 7.55503 13.4845L8.295 12.2129C9.391 12.96 10.2718 13.9777 10.8504 15.1657C11.429 16.3537 11.6854 17.6709 11.5944 18.9873H15.5377C15.6296 16.9931 15.1924 15.01 14.27 13.236C13.3475 11.462 11.9721 9.9594 10.2811 8.87825L11.777 6.3351C11.8104 6.27967 11.8644 6.23956 11.9274 6.22348C11.9904 6.20741 12.0572 6.21667 12.1134 6.24927C12.2831 6.34146 18.6129 17.3024 18.7315 17.4296C18.7523 17.4667 18.763 17.5087 18.7623 17.5512C18.7616 17.5938 18.7495 17.6354 18.7274 17.6718C18.7053 17.7083 18.6739 17.7383 18.6364 17.7588C18.5988 17.7794 18.5565 17.7897 18.5136 17.7888H16.9889C17.0081 18.1936 17.0081 18.5973 16.9889 19H18.52C18.7145 19.0012 18.9072 18.9642 19.0872 18.8911C19.2671 18.8179 19.4306 18.71 19.5682 18.5737C19.7059 18.4375 19.8149 18.2754 19.889 18.097C19.9631 17.9186 20.0008 17.7274 20 17.5345C20.0002 17.2796 19.9316 17.0294 19.8014 16.8097L13.273 5.71839Z",
            fill: "#362D59"
        })
    });
};

});

parcelRegister("bkvSq", function(module, exports) {

$parcel$export(module.exports, "SentrySearchResultIcon", () => $f59a247ac1201a93$export$18b7ca5aa35613ec);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $f59a247ac1201a93$export$18b7ca5aa35613ec = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-307.5",
                y: "-646.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.6843 6.83529C17.5082 6.54305 17.2596 6.30129 16.9626 6.13346C16.6655 5.96563 16.3301 5.87744 15.9889 5.87744C15.6477 5.87744 15.3123 5.96563 15.0153 6.13346C14.7182 6.30129 14.4696 6.54305 14.2935 6.83529L11.5045 11.6122C13.6352 12.6759 15.4505 14.2785 16.7703 16.2608C18.0901 18.2431 18.8684 20.5361 19.028 22.9122H17.0697C16.9105 20.8755 16.2221 18.9156 15.0728 17.2265C13.9235 15.5375 12.3531 14.1779 10.5169 13.2822L7.93561 17.7454C8.96784 18.2083 9.86712 18.9234 10.5507 19.8247C11.2344 20.7261 11.6804 21.7849 11.8478 22.9037H7.35068C7.29735 22.9 7.24579 22.883 7.20066 22.8543C7.15553 22.8256 7.11825 22.7862 7.09218 22.7395C7.06611 22.6928 7.05206 22.6404 7.05131 22.5869C7.05056 22.5335 7.06314 22.4806 7.08789 22.4333L8.33403 20.314C7.91184 19.9617 7.42933 19.6889 6.90987 19.5086L5.67645 21.6279C5.54804 21.8482 5.46468 22.0917 5.43121 22.3445C5.39774 22.5972 5.41482 22.8541 5.48147 23.1002C5.54811 23.3463 5.66299 23.5766 5.81944 23.7779C5.97588 23.9792 6.17076 24.1475 6.39277 24.2728C6.68527 24.4376 7.01495 24.5251 7.35068 24.5271H13.5093C13.6237 23.1157 13.3717 21.6987 12.7776 20.4132C12.1835 19.1278 11.2676 18.0176 10.1185 17.1901L11.0976 15.4947C12.5478 16.4907 13.7132 17.8477 14.4788 19.4317C15.2444 21.0157 15.5837 22.7719 15.4633 24.5271H20.681C20.8025 21.8682 20.2241 19.2241 19.0035 16.8588C17.7829 14.4935 15.963 12.49 13.7255 11.0484L15.7049 7.65757C15.749 7.58367 15.8205 7.53018 15.9039 7.50875C15.9872 7.48732 16.0757 7.49967 16.15 7.54313C16.3746 7.66605 24.75 22.2807 24.9069 22.4502C24.9345 22.4997 24.9486 22.5557 24.9476 22.6124C24.9467 22.6691 24.9308 22.7246 24.9015 22.7732C24.8723 22.8218 24.8307 22.8618 24.7811 22.8892C24.7314 22.9166 24.6754 22.9304 24.6187 22.9292H22.6011C22.6265 23.4689 22.6265 24.0072 22.6011 24.5441H24.6271C24.8844 24.5458 25.1394 24.4964 25.3775 24.3988C25.6156 24.3013 25.8319 24.1575 26.0141 23.9758C26.1962 23.794 26.3404 23.578 26.4385 23.3402C26.5366 23.1023 26.5865 22.8474 26.5854 22.5901C26.5856 22.2503 26.4949 21.9166 26.3226 21.6237L17.6843 6.83529Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M22.3868 8.33415C22.1373 7.9271 21.785 7.59036 21.364 7.3566C20.9431 7.12284 20.4678 7 19.9843 7C19.5009 7 19.0256 7.12284 18.6046 7.3566C18.1837 7.59036 17.8314 7.9271 17.5818 8.33415L13.6297 14.9877C16.649 16.4693 19.2214 18.7015 21.0916 21.4625C22.9618 24.2236 24.0647 27.4174 24.2908 30.727H21.5159C21.2902 27.8901 20.3148 25.1603 18.6862 22.8077C17.0576 20.4551 14.8322 18.5613 12.2303 17.3137L8.57245 23.5304C10.0352 24.1752 11.3095 25.1711 12.2782 26.4266C13.2469 27.6821 13.879 29.1568 14.1162 30.7152H7.74359C7.66801 30.7099 7.59495 30.6863 7.531 30.6463C7.46705 30.6064 7.41422 30.5514 7.37727 30.4864C7.34033 30.4214 7.32043 30.3484 7.31937 30.2739C7.31831 30.1994 7.33612 30.1259 7.3712 30.0599L9.13704 27.108C8.53878 26.6174 7.85504 26.2373 7.11894 25.9863L5.37112 28.9382C5.18916 29.2449 5.07104 29.5842 5.0236 29.9362C4.97617 30.2883 5.00038 30.646 5.09482 30.9888C5.18926 31.3316 5.35206 31.6524 5.57374 31.9328C5.79543 32.2132 6.07158 32.4475 6.38617 32.6221C6.80066 32.8517 7.26784 32.9736 7.74359 32.9763H16.4707C16.6328 31.0104 16.2756 29.0367 15.4338 27.2463C14.592 25.4559 13.294 23.9095 11.6657 22.757L13.0531 20.3955C15.1081 21.7828 16.7596 23.6729 17.8445 25.8791C18.9294 28.0854 19.4102 30.5316 19.2396 32.9763H26.6333C26.8054 29.2729 25.9858 25.5899 24.2562 22.2954C22.5266 19.0009 19.9476 16.2103 16.777 14.2025L19.5819 9.47947C19.6444 9.37654 19.7458 9.30203 19.8639 9.27218C19.982 9.24233 20.1073 9.25954 20.2126 9.32007C20.5309 9.49128 32.3993 29.8473 32.6215 30.0835C32.6606 30.1525 32.6806 30.2304 32.6792 30.3094C32.6779 30.3884 32.6554 30.4657 32.6139 30.5334C32.5725 30.6011 32.5136 30.6568 32.4432 30.695C32.3728 30.7331 32.2934 30.7523 32.2131 30.7506H29.3541C29.3901 31.5024 29.3901 32.2521 29.3541 32.9999H32.2251C32.5896 33.0023 32.9511 32.9335 33.2884 32.7977C33.6258 32.6618 33.9323 32.4615 34.1904 32.2084C34.4485 31.9553 34.6529 31.6544 34.7919 31.3231C34.9308 30.9918 35.0016 30.6367 35 30.2783C35.0003 29.805 34.8718 29.3402 34.6276 28.9323L22.3868 8.33415Z",
            fill: "#362D59"
        })
    });
};

});


parcelRegister("hGmpG", function(module, exports) {

$parcel$export(module.exports, "serviceNowConfig", () => $d3c7cad46ab257e1$export$d60233309c5c50ab);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $iXbSN = parcelRequire("iXbSN");

var $8x1sp = parcelRequire("8x1sp");
const $d3c7cad46ab257e1$export$d60233309c5c50ab = {
    displayName: 'ServiceNow',
    id: 'servicenow',
    icon: (0, $9yyKc.get3PLogo)((0, $iXbSN.ServiceNowIcon), 'ServiceNow', 'medium'),
    resourceType: 'servicenow-connector',
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $8x1sp.ServiceNowSearchResultIcon), 'ServiceNow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/servicenow',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("iXbSN", function(module, exports) {

$parcel$export(module.exports, "ServiceNowIcon", () => $97fd8ac63b70acdf$export$829928eabc615ce1);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $97fd8ac63b70acdf$export$829928eabc615ce1 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0473 4.00178C10.4382 3.99842 8.86528 4.4785 7.53234 5.37978C6.19941 6.28105 5.16796 7.56197 4.57171 9.05646C3.97546 10.5509 3.84191 12.1901 4.18837 13.7614C4.53483 15.3327 5.34532 16.7637 6.51478 17.8688C6.78908 18.13 7.14782 18.2844 7.52608 18.3041C7.90434 18.3237 8.27713 18.2073 8.57701 17.9759C9.56641 17.2396 10.7668 16.842 12.0001 16.842C13.2334 16.842 14.4339 17.2396 15.4233 17.9759C15.726 18.2078 16.1021 18.3232 16.4828 18.301C16.8635 18.2788 17.2236 18.1205 17.4973 17.8549C18.6576 16.7539 19.4626 15.3314 19.8092 13.7698C20.1558 12.2082 20.0282 10.5787 19.4426 9.09017C18.8571 7.60161 17.8404 6.32184 16.5228 5.41488C15.2052 4.50793 13.6467 4.01512 12.0473 3.99963M12.0001 16.0379C11.4713 16.0522 10.9451 15.9586 10.4536 15.7628C9.96216 15.567 9.51573 15.2731 9.1416 14.8991C8.76746 14.525 8.47347 14.0787 8.27754 13.5873C8.08161 13.0959 7.98787 12.5697 8.00202 12.0408C8.00202 10.9805 8.42326 9.96353 9.17305 9.21374C9.92284 8.46395 10.9398 8.04272 12.0001 8.04272C13.0605 8.04272 14.0774 8.46395 14.8272 9.21374C15.577 9.96353 15.9983 10.9805 15.9983 12.0408C16.0124 12.5697 15.9187 13.0959 15.7227 13.5873C15.5268 14.0787 15.2328 14.525 14.8587 14.8991C14.4846 15.2731 14.0381 15.567 13.5467 15.7628C13.0552 15.9586 12.529 16.0522 12.0001 16.0379Z",
                fill: "#62D84E"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.0473 5.00214C10.4382 4.99878 8.86528 5.47886 7.53234 6.38014C6.19941 7.28142 5.16796 8.56233 4.57171 10.0568C3.97546 11.5513 3.84191 13.1905 4.18837 14.7618C4.53483 16.333 5.34532 17.764 6.51478 18.8692C6.78908 19.1304 7.14782 19.2848 7.52608 19.3044C7.90434 19.3241 8.27713 19.2077 8.57701 18.9763C9.56641 18.24 10.7668 17.8423 12.0001 17.8423C13.2334 17.8423 14.4339 18.24 15.4233 18.9763C15.726 19.2082 16.1021 19.3236 16.4828 19.3013C16.8635 19.2791 17.2236 19.1208 17.4973 18.8553C18.6576 17.7542 19.4626 16.3317 19.8092 14.7702C20.1558 13.2086 20.0282 11.5791 19.4426 10.0905C18.8571 8.60198 17.8404 7.3222 16.5228 6.41525C15.2052 5.50829 13.6467 5.01549 12.0473 5M12.0001 17.0382C11.4713 17.0525 10.9451 16.9589 10.4536 16.7631C9.96216 16.5674 9.51573 16.2735 9.1416 15.8994C8.76746 15.5254 8.47347 15.0791 8.27754 14.5876C8.08161 14.0962 7.98787 13.57 8.00202 13.0412C8.00202 11.9808 8.42326 10.9639 9.17305 10.2141C9.92284 9.46432 10.9398 9.04309 12.0001 9.04309C13.0605 9.04309 14.0774 9.46432 14.8272 10.2141C15.577 10.9639 15.9983 11.9808 15.9983 13.0412C16.0124 13.57 15.9187 14.0962 15.7227 14.5876C15.5268 15.0791 15.2328 15.5254 14.8587 15.8994C14.4846 16.2735 14.0381 16.5674 13.5467 16.7631C13.0552 16.9589 12.529 17.0525 12.0001 17.0382Z",
            fill: "#62D84E"
        })
    });
};

});

parcelRegister("8x1sp", function(module, exports) {

$parcel$export(module.exports, "ServiceNowSearchResultIcon", () => $34e1b84dac95dcfd$export$4b2cdd8d303d18d0);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $34e1b84dac95dcfd$export$4b2cdd8d303d18d0 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-67.5",
                y: "-406.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.0629 5.33574C13.9175 5.33126 11.8203 5.97137 10.043 7.17308C8.2658 8.37478 6.89053 10.0827 6.09553 12.0753C5.30054 14.068 5.12247 16.2535 5.58441 18.3486C6.04636 20.4436 7.12701 22.3516 8.68629 23.8252C9.05202 24.1734 9.53035 24.3793 10.0347 24.4054C10.539 24.4316 11.0361 24.2764 11.4359 23.9679C12.7551 22.9862 14.3557 22.456 16.0001 22.456C17.6445 22.456 19.2451 22.9862 20.5643 23.9679C20.968 24.2771 21.4693 24.431 21.9769 24.4013C22.4846 24.3717 22.9647 24.1606 23.3296 23.8066C24.8767 22.3385 25.9501 20.4419 26.4122 18.3598C26.8743 16.2777 26.7041 14.105 25.9234 12.1203C25.1427 10.1355 23.7871 8.42916 22.0303 7.21988C20.2735 6.01061 18.1956 5.35353 16.0629 5.33289M16.0001 21.3839C15.295 21.4029 14.5934 21.2781 13.9381 21.0171C13.2828 20.756 12.6876 20.3642 12.1887 19.8655C11.6899 19.3668 11.2979 18.7716 11.0366 18.1164C10.7754 17.4612 10.6504 16.7596 10.6693 16.0545C10.6693 14.6407 11.2309 13.2848 12.2306 12.285C13.2304 11.2853 14.5863 10.7237 16.0001 10.7237C17.4139 10.7237 18.7698 11.2853 19.7696 12.285C20.7693 13.2848 21.3309 14.6407 21.3309 16.0545C21.3498 16.7596 21.2248 17.4612 20.9636 18.1164C20.7023 18.7716 20.3103 19.3668 19.8115 19.8655C19.3127 20.3642 18.7174 20.756 18.0621 21.0171C17.4068 21.2781 16.7052 21.4029 16.0001 21.3839Z",
                fill: "#62D84E"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.0886 7.00401C17.0717 6.99772 14.1224 7.89787 11.6231 9.58777C9.1239 11.2777 7.18993 13.6794 6.07196 16.4815C4.95399 19.2837 4.70358 22.3571 5.3532 25.3033C6.00281 28.2495 7.52248 30.9326 9.7152 33.0048C10.2295 33.4945 10.9022 33.784 11.6114 33.8208C12.3206 33.8576 13.0196 33.6394 13.5819 33.2055C15.437 31.825 17.6878 31.0793 20.0003 31.0793C22.3127 31.0793 24.5635 31.825 26.4186 33.2055C26.9863 33.6403 27.6913 33.8567 28.4052 33.815C29.119 33.7734 29.7942 33.4765 30.3074 32.9787C32.483 30.9142 33.9924 28.247 34.6423 25.319C35.2921 22.3911 35.0528 19.3358 33.9549 16.5448C32.8571 13.7537 30.9507 11.3541 28.4802 9.65359C26.0097 7.95305 23.0877 7.02904 20.0886 7M20.0003 29.5717C19.0087 29.5985 18.0221 29.423 17.1006 29.0559C16.179 28.6888 15.342 28.1378 14.6405 27.4364C13.939 26.7351 13.3878 25.8982 13.0204 24.9768C12.653 24.0554 12.4772 23.0688 12.5038 22.0773C12.5038 20.0891 13.2936 18.1823 14.6995 16.7765C16.1053 15.3706 18.0121 14.5808 20.0003 14.5808C21.9885 14.5808 23.8952 15.3706 25.3011 16.7765C26.7069 18.1823 27.4967 20.0891 27.4967 22.0773C27.5233 23.0688 27.3475 24.0554 26.9801 24.9768C26.6128 25.8982 26.0615 26.7351 25.36 27.4364C24.6585 28.1378 23.8215 28.6888 22.9 29.0559C21.9785 29.423 20.9918 29.5985 20.0003 29.5717Z",
            fill: "#62D84E"
        })
    });
};

});


parcelRegister("7k5Lz", function(module, exports) {

$parcel$export(module.exports, "sharepointConfig", () => $85cf9dcc986f9ef7$export$eb46bb6c4f0e628c);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $irtpm = parcelRequire("irtpm");

var $hux4I = parcelRequire("hux4I");
const $85cf9dcc986f9ef7$export$eb46bb6c4f0e628c = {
    displayName: 'Microsoft SharePoint',
    id: 'sharepoint',
    resourceType: 'sharepoint-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $irtpm.SharePointIcon), 'Sharepoint', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $hux4I.SharePointSearchResultIcon), 'Sharepoint', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Presentation,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("irtpm", function(module, exports) {

$parcel$export(module.exports, "SharePointIcon", () => $77d5e1f6fdebef0b$export$53d8bcde0f28cd56);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $77d5e1f6fdebef0b$export$53d8bcde0f28cd56 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-650.5",
                y: "-28.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#0B1228",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12.1863 13.1429C14.6523 13.1429 16.6514 11.0962 16.6514 8.57143C16.6514 6.0467 14.6523 4 12.1863 4C9.72029 4 7.72119 6.0467 7.72119 8.57143C7.72119 11.0962 9.72029 13.1429 12.1863 13.1429Z",
                        fill: "#036C70"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.907 16.9525C18.1675 16.9525 20 15.0763 20 12.762C20 10.4477 18.1675 8.57153 15.907 8.57153C13.6465 8.57153 11.814 10.4477 11.814 12.762C11.814 15.0763 13.6465 16.9525 15.907 16.9525Z",
                        fill: "#1A9BA1"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12.7443 20.0001C14.4911 20.0001 15.9071 18.5504 15.9071 16.762C15.9071 14.9737 14.4911 13.5239 12.7443 13.5239C10.9976 13.5239 9.58154 14.9737 9.58154 16.762C9.58154 18.5504 10.9976 20.0001 12.7443 20.0001Z",
                        fill: "#37C6D0"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.1",
                        d: "M12.9302 8.12585V16.2554C12.9283 16.5379 12.7611 16.7916 12.506 16.8992C12.4248 16.9344 12.3374 16.9525 12.2492 16.9525H9.58506C9.58134 16.8878 9.58134 16.8268 9.58134 16.762C9.5801 16.6984 9.58258 16.6348 9.58878 16.5716C9.65688 15.3538 10.3896 14.2794 11.4827 13.7944V13.0858C9.04996 12.6911 7.39032 10.3521 7.77583 7.86137C7.77851 7.84412 7.78127 7.82688 7.78414 7.80966C7.80266 7.68118 7.82876 7.55396 7.86228 7.42871H12.2493C12.6247 7.43017 12.9287 7.74144 12.9302 8.12585Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8772 7.80957H7.78421C7.37074 10.2958 9.00415 12.6544 11.4325 13.0777C11.5061 13.0906 11.5799 13.1015 11.654 13.1105C10.5005 13.6705 9.65993 15.261 9.58849 16.5715C9.5823 16.6348 9.57981 16.6984 9.58104 16.7619C9.58104 16.8267 9.58104 16.8877 9.58476 16.9524C9.59147 17.0805 9.60765 17.2078 9.63313 17.3334H11.8769C12.1528 17.3315 12.4006 17.1603 12.5057 16.8991C12.54 16.8159 12.5578 16.7265 12.5578 16.6362V8.50671C12.5564 8.12245 12.2526 7.81125 11.8772 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8772 7.80957H7.78418C7.37079 10.296 9.00445 12.6548 11.4331 13.078C11.4828 13.0867 11.5326 13.0945 11.5825 13.1014C10.4662 13.7018 9.65879 15.2884 9.58883 16.5715H11.8772C12.2521 16.5686 12.5553 16.2581 12.5581 15.8743V8.50671C12.5567 8.1223 12.2527 7.81103 11.8772 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.505 7.80957H7.78405C7.39371 10.1568 8.8303 12.4172 11.0845 13.0027C10.231 14.0012 9.70744 15.2502 9.58871 16.5715H11.505C11.8805 16.57 12.1845 16.2587 12.1859 15.8743V8.50671C12.1857 8.12178 11.881 7.80978 11.505 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M4.68205 7.80957H11.504C11.8807 7.80957 12.186 8.1222 12.186 8.50786V15.4922C12.186 15.8779 11.8807 16.1905 11.504 16.1905H4.68205C4.30536 16.1905 4 15.8779 4 15.4922V8.50786C4 8.1222 4.30536 7.80957 4.68205 7.80957Z",
                        fill: "#026D71"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.04621 11.9147C6.88638 11.8062 6.75286 11.6617 6.65588 11.4922C6.56192 11.3151 6.51508 11.1158 6.52007 10.9143C6.5117 10.6415 6.60162 10.3751 6.77272 10.1658C6.95251 9.95618 7.1849 9.80099 7.44472 9.717C7.74082 9.61722 8.05096 9.56805 8.36267 9.57148C8.77258 9.55614 9.18193 9.61482 9.57197 9.74481V10.621C9.40249 10.5159 9.21791 10.4388 9.02499 10.3924C8.81567 10.3399 8.60088 10.3135 8.38536 10.314C8.15809 10.3054 7.93227 10.3544 7.72787 10.4564C7.57007 10.5261 7.46774 10.6851 7.46741 10.861C7.46677 10.9677 7.50682 11.0705 7.57904 11.1475C7.66434 11.2382 7.76525 11.3121 7.87672 11.3654C8.00074 11.4286 8.18679 11.5127 8.43485 11.6176C8.46217 11.6264 8.48879 11.6374 8.51448 11.6504C8.75862 11.748 8.99415 11.867 9.21848 12.0058C9.38837 12.113 9.53095 12.26 9.63449 12.4347C9.74064 12.6328 9.79209 12.8566 9.78332 13.0824C9.79544 13.3624 9.71174 13.6381 9.54667 13.8618C9.38213 14.0674 9.16216 14.219 8.91411 14.2976C8.62236 14.3912 8.31786 14.4365 8.01215 14.4317C7.73787 14.433 7.46399 14.41 7.19355 14.3631C6.96521 14.3249 6.74237 14.2578 6.53011 14.1635V13.2397C6.733 13.388 6.95967 13.4989 7.19988 13.5673C7.43928 13.6437 7.68814 13.6845 7.93886 13.6884C8.17091 13.7035 8.40255 13.6532 8.60863 13.5429C8.75299 13.4595 8.84079 13.3015 8.83709 13.1319C8.83806 13.0138 8.79244 12.9004 8.71058 12.8172C8.60879 12.7149 8.49093 12.6308 8.36194 12.5684C8.2131 12.4922 7.99393 12.3918 7.70445 12.2671C7.47415 12.1723 7.25365 12.0543 7.04621 11.9147Z",
                        fill: "white"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_271_181641)",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                    clipPath: "url(#clip1_271_181641)",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M12.2328 13.4286C15.3153 13.4286 17.8142 10.8702 17.8142 7.71429C17.8142 4.55837 15.3153 2 12.2328 2C9.15024 2 6.65137 4.55837 6.65137 7.71429C6.65137 10.8702 9.15024 13.4286 12.2328 13.4286Z",
                            fill: "#036C70"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M16.8836 18.1906C19.7093 18.1906 21.9999 15.8454 21.9999 12.9525C21.9999 10.0595 19.7093 7.71436 16.8836 7.71436C14.058 7.71436 11.7673 10.0595 11.7673 12.9525C11.7673 15.8454 14.058 18.1906 16.8836 18.1906Z",
                            fill: "#1A9BA1"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M12.9303 22C15.1137 22 16.8838 20.1878 16.8838 17.9524C16.8838 15.717 15.1137 13.9048 12.9303 13.9048C10.7468 13.9048 8.97681 15.717 8.97681 17.9524C8.97681 20.1878 10.7468 22 12.9303 22Z",
                            fill: "#37C6D0"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            opacity: "0.1",
                            d: "M13.1628 7.15707V17.319C13.1605 17.6721 12.9515 17.9893 12.6326 18.1237C12.5311 18.1677 12.4219 18.1904 12.3117 18.1904H8.98144C8.9768 18.1094 8.9768 18.0333 8.9768 17.9523C8.97525 17.8728 8.97835 17.7933 8.9861 17.7142C9.07123 16.192 9.98715 14.849 11.3535 14.2428V13.3571C8.31257 12.8637 6.23802 9.93985 6.71991 6.82647C6.72326 6.8049 6.72671 6.78335 6.73029 6.76183C6.75344 6.60124 6.78607 6.44221 6.82797 6.28564H12.3117C12.781 6.28747 13.1611 6.67656 13.1628 7.15707Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.8464 6.76196H6.73014C6.2133 9.86973 8.25507 12.818 11.2906 13.3472C11.3825 13.3632 11.4748 13.3769 11.5673 13.3882C10.1255 14.0882 9.07479 16.0762 8.98549 17.7143C8.97775 17.7934 8.97463 17.8729 8.97618 17.9524C8.97618 18.0334 8.97618 18.1096 8.98083 18.1905C8.98922 18.3506 9.00944 18.5098 9.04129 18.6667H11.8459C12.1908 18.6644 12.5007 18.4504 12.632 18.1239C12.6749 18.0199 12.6971 17.9082 12.6971 17.7953V7.63339C12.6953 7.15306 12.3156 6.76406 11.8464 6.76196Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.8466 6.76196H6.73034C6.21361 9.87002 8.25569 12.8185 11.2915 13.3475C11.3536 13.3583 11.4158 13.3681 11.4783 13.3767C10.0829 14.1272 9.07361 16.1105 8.98616 17.7143H11.8466C12.3152 17.7107 12.6942 17.3227 12.6978 16.8429V7.63339C12.696 7.15288 12.316 6.76379 11.8466 6.76196Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.3814 6.76196H6.73019C6.24226 9.696 8.03799 12.5215 10.8558 13.2534C9.78883 14.5014 9.13442 16.0628 8.98601 17.7143H11.3814C11.8507 17.7125 12.2307 17.3234 12.2325 16.8429V7.63339C12.2323 7.15223 11.8513 6.76223 11.3814 6.76196Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M2.85256 6.76196H11.38C11.8509 6.76196 12.2326 7.15275 12.2326 7.63482V16.3653C12.2326 16.8474 11.8509 17.2382 11.38 17.2382H2.85256C2.3817 17.2382 2 16.8474 2 16.3653V7.63482C2 7.15275 2.3817 6.76196 2.85256 6.76196Z",
                            fill: "#04868B"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M5.80776 11.8932C5.60797 11.7575 5.44108 11.5769 5.31985 11.3651C5.20239 11.1437 5.14385 10.8946 5.15008 10.6427C5.13962 10.3017 5.25202 9.96868 5.46589 9.70702C5.69064 9.44505 5.98113 9.25105 6.30589 9.14606C6.67602 9.02134 7.0637 8.95988 7.45333 8.96416C7.96573 8.945 8.47741 9.01835 8.96496 9.18083V10.2761C8.75312 10.1447 8.52238 10.0483 8.28124 9.99036C8.01958 9.92467 7.7511 9.89173 7.4817 9.89226C7.19761 9.88158 6.91534 9.94276 6.65984 10.0704C6.46259 10.1575 6.33467 10.3561 6.33426 10.5761C6.33346 10.7095 6.38352 10.838 6.4738 10.9342C6.58043 11.0476 6.70656 11.1399 6.84589 11.2066C7.00093 11.2856 7.23349 11.3907 7.54357 11.5218C7.57771 11.5328 7.61099 11.5465 7.6431 11.5628C7.94828 11.6849 8.24269 11.8335 8.5231 12.007C8.73546 12.1411 8.91368 12.3249 9.04311 12.5432C9.1758 12.7908 9.24011 13.0706 9.22915 13.3528C9.2443 13.7029 9.13968 14.0474 8.93334 14.327C8.72767 14.5841 8.45269 14.7736 8.14264 14.8718C7.77795 14.9888 7.39733 15.0454 7.01519 15.0394C6.67234 15.041 6.32999 15.0123 5.99194 14.9537C5.70651 14.9059 5.42796 14.8221 5.16264 14.7042V13.5494C5.41625 13.7349 5.69959 13.8735 5.99985 13.9589C6.2991 14.0544 6.61017 14.1054 6.92357 14.1104C7.21363 14.1292 7.50318 14.0663 7.76078 13.9285C7.94123 13.8242 8.05098 13.6267 8.04637 13.4147C8.04757 13.2671 7.99055 13.1253 7.88823 13.0213C7.76098 12.8934 7.61366 12.7883 7.45242 12.7104C7.26638 12.6151 6.99242 12.4896 6.63056 12.3337C6.34269 12.2152 6.06706 12.0677 5.80776 11.8932Z",
                            fill: "white"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_271_181641",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "20",
                            height: "20",
                            fill: "white",
                            transform: "translate(2 2)"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip1_271_181641",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "20",
                            height: "20",
                            fill: "white",
                            transform: "translate(2 2)"
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("hux4I", function(module, exports) {

$parcel$export(module.exports, "SharePointSearchResultIcon", () => $200bd2d79addba31$export$65b9e0ddb04a51a1);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $200bd2d79addba31$export$65b9e0ddb04a51a1 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-163.5",
                y: "-23.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.508324",
                y: "0.508324",
                width: "30.9834",
                height: "30.9834",
                rx: "7.49168",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "1.01665"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M16.2482 17.5237C19.5362 17.5237 22.2017 14.7948 22.2017 11.4285C22.2017 8.06218 19.5362 5.33325 16.2482 5.33325C12.9601 5.33325 10.2947 8.06218 10.2947 11.4285C10.2947 14.7948 12.9601 17.5237 16.2482 17.5237Z",
                        fill: "#036C70"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M21.2091 22.6031C24.2231 22.6031 26.6664 20.1016 26.6664 17.0158C26.6664 13.93 24.2231 11.4285 21.2091 11.4285C18.1951 11.4285 15.7517 13.93 15.7517 17.0158C15.7517 20.1016 18.1951 22.6031 21.2091 22.6031Z",
                        fill: "#1A9BA1"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M16.9922 26.6667C19.3212 26.6667 21.2093 24.7337 21.2093 22.3492C21.2093 19.9647 19.3212 18.0317 16.9922 18.0317C14.6632 18.0317 12.7751 19.9647 12.7751 22.3492C12.7751 24.7337 14.6632 26.6667 16.9922 26.6667Z",
                        fill: "#37C6D0"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.1",
                        d: "M17.2403 10.8343V21.6737C17.2379 22.0503 17.0149 22.3887 16.6747 22.5321C16.5664 22.579 16.45 22.6032 16.3324 22.6032H12.7802C12.7752 22.5168 12.7752 22.4356 12.7752 22.3492C12.7736 22.2644 12.7769 22.1796 12.7851 22.0953C12.8759 20.4716 13.8529 19.0391 15.3104 18.3924V17.4476C12.0667 16.9214 9.85383 13.8026 10.3679 10.4817C10.3714 10.4587 10.3751 10.4357 10.3789 10.4127C10.4036 10.2414 10.4384 10.0718 10.4831 9.90479H16.3324C16.833 9.90674 17.2384 10.3218 17.2403 10.8343Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M15.8362 10.4126H10.3788C9.82749 13.7276 12.0054 16.8724 15.2432 17.4368C15.3413 17.4539 15.4397 17.4685 15.5385 17.4805C14.0005 18.2272 12.8797 20.3478 12.7845 22.0951C12.7762 22.1795 12.7729 22.2643 12.7746 22.3491C12.7746 22.4355 12.7746 22.5167 12.7795 22.6031C12.7885 22.7738 12.81 22.9436 12.844 23.111H15.8356C16.2035 23.1085 16.534 22.8802 16.6741 22.532C16.7199 22.4211 16.7435 22.3019 16.7435 22.1815V11.3421C16.7417 10.8298 16.3366 10.4148 15.8362 10.4126Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M15.8364 10.4126H10.379C9.8278 13.7279 12.006 16.8729 15.2442 17.4372C15.3104 17.4487 15.3768 17.4591 15.4434 17.4684C13.9551 18.2689 12.8785 20.3844 12.7852 22.0951H15.8364C16.3362 22.0913 16.7405 21.6774 16.7443 21.1656V11.3421C16.7424 10.8296 16.337 10.4145 15.8364 10.4126Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M15.3401 10.4126H10.3788C9.85836 13.5422 11.7738 16.5561 14.7794 17.3368C13.6414 18.668 12.9433 20.3335 12.785 22.0951H15.3401C15.8407 22.0932 16.2461 21.6782 16.248 21.1656V11.3421C16.2477 10.8289 15.8414 10.4129 15.3401 10.4126Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M6.24265 10.4126H15.3386C15.8408 10.4126 16.248 10.8294 16.248 11.3436V20.6561C16.248 21.1704 15.8408 21.5872 15.3386 21.5872H6.24265C5.7404 21.5872 5.33325 21.1704 5.33325 20.6561V11.3436C5.33325 10.8294 5.7404 10.4126 6.24265 10.4126Z",
                        fill: "#026D71"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M9.39487 15.886C9.18175 15.7413 9.00374 15.5487 8.87443 15.3227C8.74914 15.0866 8.68669 14.8209 8.69334 14.5522C8.68218 14.1884 8.80208 13.8332 9.03021 13.5541C9.26993 13.2747 9.57979 13.0677 9.92621 12.9558C10.321 12.8227 10.7345 12.7572 11.1501 12.7617C11.6967 12.7413 12.2425 12.8195 12.7625 12.9928V14.1611C12.5366 14.021 12.2905 13.9181 12.0332 13.8563C11.7541 13.7863 11.4678 13.7511 11.1804 13.7517C10.8774 13.7403 10.5763 13.8056 10.3037 13.9417C10.0933 14.0346 9.95691 14.2465 9.95647 14.4811C9.95561 14.6234 10.009 14.7604 10.1053 14.8631C10.219 14.9841 10.3536 15.0826 10.5022 15.1536C10.6676 15.2379 10.9156 15.35 11.2464 15.4899C11.2828 15.5017 11.3183 15.5163 11.3526 15.5336C11.6781 15.6638 11.9921 15.8224 12.2912 16.0075C12.5177 16.1504 12.7078 16.3465 12.8459 16.5794C12.9874 16.8434 13.056 17.1419 13.0443 17.4429C13.0605 17.8163 12.9489 18.1839 12.7288 18.4821C12.5094 18.7563 12.2161 18.9584 11.8854 19.0632C11.4964 19.188 11.0904 19.2484 10.6828 19.242C10.3171 19.2437 9.9519 19.2131 9.59132 19.1506C9.28686 19.0996 8.98974 19.0102 8.70674 18.8844V17.6527C8.97726 17.8505 9.27948 17.9983 9.59976 18.0895C9.91896 18.1913 10.2508 18.2457 10.5851 18.251C10.8945 18.2711 11.2033 18.204 11.4781 18.057C11.6706 17.9458 11.7876 17.7351 11.7827 17.5089C11.784 17.3515 11.7232 17.2002 11.614 17.0894C11.4783 16.9529 11.3212 16.8408 11.1492 16.7577C10.9507 16.6561 10.6585 16.5222 10.2725 16.3559C9.96545 16.2295 9.67145 16.0721 9.39487 15.886Z",
                        fill: "white"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_2230_18933)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M20.349 22.1428C24.9728 22.1428 28.7211 18.3053 28.7211 13.5714C28.7211 8.83755 24.9728 4.99999 20.349 4.99999C15.7252 4.99999 11.9769 8.83755 11.9769 13.5714C11.9769 18.3053 15.7252 22.1428 20.349 22.1428Z",
                        fill: "#036C70"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M27.3253 29.2857C31.5638 29.2857 34.9997 25.768 34.9997 21.4286C34.9997 17.0892 31.5638 13.5714 27.3253 13.5714C23.0868 13.5714 19.6509 17.0892 19.6509 21.4286C19.6509 25.768 23.0868 29.2857 27.3253 29.2857Z",
                        fill: "#1A9BA1"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M21.3953 35C24.6705 35 27.3255 32.2817 27.3255 28.9286C27.3255 25.5754 24.6705 22.8571 21.3953 22.8571C18.1201 22.8571 15.4651 25.5754 15.4651 28.9286C15.4651 32.2817 18.1201 35 21.3953 35Z",
                        fill: "#37C6D0"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.1",
                        d: "M21.7444 12.7357V27.9786C21.7409 28.5082 21.4274 28.984 20.949 29.1857C20.7967 29.2517 20.633 29.2857 20.4676 29.2857H15.4723C15.4653 29.1643 15.4653 29.05 15.4653 28.9285C15.463 28.8093 15.4676 28.6901 15.4793 28.5714C15.607 26.2882 16.9808 24.2736 19.0304 23.3643V22.0357C14.469 21.2956 11.3571 16.9099 12.08 12.2398C12.085 12.2074 12.0902 12.1751 12.0956 12.1428C12.1303 11.9019 12.1792 11.6634 12.2421 11.4286H20.4677C21.1717 11.4313 21.7417 12.0149 21.7444 12.7357Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M19.7695 12.1429H12.0951C11.3198 16.8045 14.3825 21.227 18.9357 22.0207C19.0736 22.0447 19.212 22.0652 19.3509 22.0822C17.1881 23.1322 15.6121 26.1143 15.4781 28.5714C15.4665 28.6901 15.4618 28.8094 15.4641 28.9286C15.4641 29.05 15.4641 29.1643 15.4711 29.2857C15.4837 29.5258 15.514 29.7646 15.5618 30H19.7688C20.2861 29.9965 20.7509 29.6755 20.9479 29.1857C21.0123 29.0298 21.0455 28.8622 21.0455 28.6929V13.45C21.0429 12.7295 20.4733 12.146 19.7695 12.1429Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M19.7701 12.1429H12.0956C11.3205 16.805 14.3837 21.2276 18.9373 22.0212C19.0305 22.0374 19.1239 22.052 19.2175 22.065C17.1245 23.1907 15.6105 26.1657 15.4794 28.5715H19.7701C20.473 28.566 21.0415 27.984 21.0468 27.2643V13.45C21.0441 12.7292 20.4741 12.1456 19.7701 12.1429Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M19.0721 12.1429H12.0954C11.3635 16.5439 14.0571 20.7822 18.2838 21.88C16.6834 23.7521 15.7017 26.0941 15.4791 28.5715H19.0722C19.7762 28.5687 20.3462 27.9851 20.3489 27.2643V13.45C20.3485 12.7283 19.7771 12.1433 19.0721 12.1429Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M6.27884 12.1429H19.07C19.7763 12.1429 20.3488 12.7291 20.3488 13.4522V26.5479C20.3488 27.271 19.7763 27.8572 19.07 27.8572H6.27884C5.57255 27.8572 5 27.271 5 26.5479V13.4522C5 12.7291 5.57255 12.1429 6.27884 12.1429Z",
                        fill: "url(#paint0_linear_sharepoint)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M10.7116 19.84C10.412 19.6365 10.1616 19.3655 9.97978 19.0479C9.80359 18.7158 9.71577 18.3421 9.72513 17.9643C9.70944 17.4528 9.87804 16.9532 10.1988 16.5607C10.536 16.1678 10.9717 15.8768 11.4588 15.7193C12.014 15.5322 12.5955 15.44 13.18 15.4464C13.9486 15.4177 14.7161 15.5277 15.4474 15.7714V17.4143C15.1297 17.2172 14.7836 17.0726 14.4219 16.9857C14.0294 16.8872 13.6267 16.8378 13.2226 16.8386C12.7964 16.8226 12.373 16.9143 11.9898 17.1057C11.6939 17.2364 11.502 17.5344 11.5014 17.8643C11.5002 18.0644 11.5753 18.2571 11.7107 18.4014C11.8706 18.5716 12.0598 18.7101 12.2688 18.81C12.5014 18.9286 12.8502 19.0862 13.3154 19.2829C13.3666 19.2995 13.4165 19.32 13.4647 19.3443C13.9224 19.5275 14.364 19.7504 14.7847 20.0107C15.1032 20.2118 15.3705 20.4875 15.5647 20.815C15.7637 21.1863 15.8602 21.6061 15.8437 22.0293C15.8664 22.5545 15.7095 23.0713 15.4 23.4907C15.0915 23.8763 14.679 24.1605 14.214 24.3079C13.6669 24.4834 13.096 24.5683 12.5228 24.5593C12.0085 24.5617 11.495 24.5187 10.9879 24.4307C10.5598 24.359 10.1419 24.2333 9.74396 24.0564V22.3243C10.1244 22.6025 10.5494 22.8104 10.9998 22.9386C11.4486 23.0818 11.9153 23.1583 12.3854 23.1657C12.8205 23.194 13.2548 23.0996 13.6412 22.8929C13.9118 22.7365 14.0765 22.4403 14.0696 22.1222C14.0714 21.9008 13.9858 21.6881 13.8323 21.5322C13.6415 21.3403 13.4205 21.1827 13.1786 21.0657C12.8996 20.9229 12.4886 20.7346 11.9458 20.5007C11.514 20.323 11.1006 20.1017 10.7116 19.84Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint0_linear_sharepoint",
                        x1: "7.6664",
                        y1: "11.1198",
                        x2: "18.0401",
                        y2: "28.6688",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#058F92"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.5",
                                stopColor: "#038489"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#026D71"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_2230_18933",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "30",
                            height: "30",
                            fill: "white",
                            transform: "translate(5 5)"
                        })
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("kdE7v", function(module, exports) {

$parcel$export(module.exports, "slackConfig", () => $d0d3a158a2299a2c$export$c33894e475506863);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $hj724 = parcelRequire("hj724");

var $47BrG = parcelRequire("47BrG");
const $d0d3a158a2299a2c$export$c33894e475506863 = {
    displayName: 'Slack',
    id: 'slack',
    resourceType: 'slack-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $hj724.SlackIcon), 'Slack', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $47BrG.SlackSearchResultIcon), 'Slack', 'large'),
    integrationAri: 'ari:cloud:platform::integration/slack',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("hj724", function(module, exports) {

$parcel$export(module.exports, "SlackIcon", () => $11de0cfb1be9779f$export$b33fb54b08bb6422);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $11de0cfb1be9779f$export$b33fb54b08bb6422 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-603.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.71235 13.9487C7.71235 14.8109 7.0155 15.5078 6.15329 15.5078C5.29109 15.5078 4.59424 14.8109 4.59424 13.9487C4.59424 13.0865 5.29109 12.3896 6.15329 12.3896H7.71235V13.9487ZM8.49188 13.9487C8.49188 13.0865 9.18873 12.3896 10.0509 12.3896C10.9131 12.3896 11.61 13.0865 11.61 13.9487V17.8463C11.61 18.7085 10.9131 19.4054 10.0509 19.4054C9.18873 19.4054 8.49188 18.7085 8.49188 17.8463V13.9487Z",
                        fill: "#E01E5A"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M10.051 7.68879C9.18882 7.68879 8.49197 6.99194 8.49197 6.12973C8.49197 5.26753 9.18882 4.57068 10.051 4.57068C10.9132 4.57068 11.6101 5.26753 11.6101 6.12973V7.68879H10.051ZM10.051 8.48013C10.9132 8.48013 11.6101 9.17698 11.6101 10.0392C11.6101 10.9014 10.9132 11.5982 10.051 11.5982H6.14157C5.27937 11.5982 4.58252 10.9014 4.58252 10.0392C4.58252 9.17698 5.27937 8.48013 6.14157 8.48013H10.051Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M16.299 10.0392C16.299 9.17698 16.9959 8.48013 17.8581 8.48013C18.7203 8.48013 19.4171 9.17698 19.4171 10.0392C19.4171 10.9014 18.7203 11.5982 17.8581 11.5982H16.299V10.0392ZM15.5195 10.0392C15.5195 10.9014 14.8226 11.5982 13.9604 11.5982C13.0982 11.5982 12.4014 10.9014 12.4014 10.0392V6.12973C12.4014 5.26753 13.0982 4.57068 13.9604 4.57068C14.8226 4.57068 15.5195 5.26753 15.5195 6.12973V10.0392Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M13.9604 16.2873C14.8226 16.2873 15.5195 16.9841 15.5195 17.8463C15.5195 18.7085 14.8226 19.4054 13.9604 19.4054C13.0982 19.4054 12.4014 18.7085 12.4014 17.8463V16.2873H13.9604ZM13.9604 15.5078C13.0982 15.5078 12.4014 14.8109 12.4014 13.9487C12.4014 13.0865 13.0982 12.3896 13.9604 12.3896H17.8699C18.7321 12.3896 19.4289 13.0865 19.4289 13.9487C19.4289 14.8109 18.7321 15.5078 17.8699 15.5078H13.9604Z",
                        fill: "#ECB22E"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_271_181639)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
                        fill: "#ECB22E"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
                        fill: "#E01E5A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_271_181639",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("47BrG", function(module, exports) {

$parcel$export(module.exports, "SlackSearchResultIcon", () => $6921c71c4bb6686b$export$9e3ecebaf98513b9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $6921c71c4bb6686b$export$9e3ecebaf98513b9 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-67.5",
                y: "-598.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0.513685 8C0.513685 3.86542 3.86542 0.513685 8 0.513685H24C28.1346 0.513685 31.4863 3.86542 31.4863 8V24C31.4863 28.1346 28.1346 31.4863 24 31.4863H8C3.86542 31.4863 0.513685 28.1346 0.513685 24V8Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "1.02737"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M10.6616 18.5983C10.6616 19.7479 9.7325 20.677 8.58289 20.677C7.43328 20.677 6.50415 19.7479 6.50415 18.5983C6.50415 17.4487 7.43328 16.5195 8.58289 16.5195H10.6616V18.5983ZM11.701 18.5983C11.701 17.4487 12.6301 16.5195 13.7797 16.5195C14.9293 16.5195 15.8585 17.4487 15.8585 18.5983V23.7951C15.8585 24.9447 14.9293 25.8739 13.7797 25.8739C12.6301 25.8739 11.701 24.9447 11.701 23.7951V18.5983Z",
                        fill: "#E01E5A"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M13.7796 10.2517C12.63 10.2517 11.7009 9.32258 11.7009 8.17298C11.7009 7.02337 12.63 6.09424 13.7796 6.09424C14.9292 6.09424 15.8584 7.02337 15.8584 8.17298V10.2517H13.7796ZM13.7796 11.3068C14.9292 11.3068 15.8584 12.236 15.8584 13.3856C15.8584 14.5352 14.9292 15.4643 13.7796 15.4643H8.56702C7.41742 15.4643 6.48828 14.5352 6.48828 13.3856C6.48828 12.236 7.41742 11.3068 8.56702 11.3068H13.7796Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M22.1104 13.3856C22.1104 12.236 23.0396 11.3068 24.1892 11.3068C25.3388 11.3068 26.2679 12.236 26.2679 13.3856C26.2679 14.5352 25.3388 15.4643 24.1892 15.4643H22.1104V13.3856ZM21.0711 13.3856C21.0711 14.5352 20.1419 15.4643 18.9923 15.4643C17.8427 15.4643 16.9136 14.5352 16.9136 13.3856V8.17298C16.9136 7.02337 17.8427 6.09424 18.9923 6.09424C20.1419 6.09424 21.0711 7.02337 21.0711 8.17298V13.3856Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.9923 21.7164C20.1419 21.7164 21.0711 22.6455 21.0711 23.7951C21.0711 24.9447 20.1419 25.8739 18.9923 25.8739C17.8427 25.8739 16.9136 24.9447 16.9136 23.7951V21.7164H18.9923ZM18.9923 20.677C17.8427 20.677 16.9136 19.7479 16.9136 18.5983C16.9136 17.4487 17.8427 16.5195 18.9923 16.5195H24.2049C25.3545 16.5195 26.2837 17.4487 26.2837 18.5983C26.2837 19.7479 25.3545 20.677 24.2049 20.677H18.9923Z",
                        fill: "#ECB22E"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.9995 5C14.3411 5.00122 12.999 6.34436 13.0002 7.99942C12.999 9.65449 14.3423 10.9976 16.0007 10.9988H19.0012V8.00065C19.0025 6.34558 17.6591 5.00245 15.9995 5C16.0007 5 16.0007 5 15.9995 5V5ZM15.9995 13.0001H8.00053C6.34215 13.0013 4.99878 14.3444 5 15.9995C4.99755 17.6546 6.34092 18.9977 7.9993 19.0002H15.9995C17.6579 18.9989 19.0012 17.6558 19 16.0007C19.0012 14.3444 17.6579 13.0013 15.9995 13.0001Z",
                fill: "#36C5F0"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M35.0002 15.9995C35.0014 14.3444 33.658 13.0013 31.9996 13.0001C30.3413 13.0013 28.9979 14.3444 28.9991 15.9995V19.0002H31.9996C33.658 18.9989 35.0014 17.6558 35.0002 15.9995ZM27 15.9995V7.99942C27.0012 6.34558 25.659 5.00245 24.0007 5C22.3423 5.00122 20.9989 6.34436 21.0001 7.99942V15.9995C20.9977 17.6546 22.3411 18.9977 23.9994 19.0002C25.6578 18.9989 27.0012 17.6558 27 15.9995Z",
                fill: "#2EB67D"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.9996 35.0001C25.658 34.9989 27.0014 33.6558 27.0002 32.0007C27.0014 30.3456 25.658 29.0025 23.9996 29.0013H20.9991V32.0007C20.9979 33.6545 22.3412 34.9977 23.9996 35.0001ZM23.9996 26.9988H31.9998C33.6582 26.9976 35.0016 25.6544 35.0004 23.9993C35.0028 22.3443 33.6594 21.0011 32.0011 20.9987H24.0008C22.3425 20.9999 20.9991 22.3431 21.0003 23.9981C20.9991 25.6544 22.3412 26.9976 23.9996 26.9988Z",
                fill: "#ECB22E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.00031 24.0003C4.99908 25.6554 6.34246 26.9985 8.00084 26.9997C9.65922 26.9985 11.0026 25.6554 11.0014 24.0003V21.0009H8.00084C6.34246 21.0021 4.99908 22.3452 5.00031 24.0003ZM13.0005 24.0003V32.0004C12.998 33.6555 14.3414 34.9986 15.9998 35.0011C17.6582 34.9998 19.0016 33.6567 19.0003 32.0016V24.0027C19.0028 22.3477 17.6594 21.0045 16.001 21.0021C14.3414 21.0021 12.9993 22.3452 13.0005 24.0003C13.0005 24.0015 13.0005 24.0003 13.0005 24.0003Z",
                fill: "#E01E5A"
            })
        ]
    });
};

});


parcelRegister("hXBdi", function(module, exports) {

$parcel$export(module.exports, "smartsheetConfig", () => $a489cce30842ec41$export$aad10bcf647ef696);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $hi4rq = parcelRequire("hi4rq");

var $5NHab = parcelRequire("5NHab");
const $a489cce30842ec41$export$aad10bcf647ef696 = {
    displayName: 'Smartsheet',
    id: 'smartsheet',
    resourceType: 'smartsheet-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $hi4rq.SmartsheetIcon), 'Smartsheet', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $5NHab.SmartsheetSearchResultIcon), 'Smartsheet', 'large'),
    integrationAri: 'ari:cloud:platform::integration/smartsheet',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("hi4rq", function(module, exports) {

$parcel$export(module.exports, "SmartsheetIcon", () => $5e10fcbb718a2514$export$dd0ad7bd8a5794f4);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $5e10fcbb718a2514$export$dd0ad7bd8a5794f4 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-171.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.2708 12.9524C12.0781 12.5707 11.8938 12.2011 11.6762 11.8499C11.4003 11.4042 11.1009 10.9773 10.6919 10.6414C10.3847 10.3891 10.0444 10.2293 9.63382 10.2899C9.27961 10.3422 8.99393 10.5287 8.73676 10.7652C8.60099 10.8901 8.47697 11.0271 8.36318 11.1923C8.42475 11.2006 8.47588 11.2054 8.52636 11.2146C8.8921 11.2813 9.17343 11.4943 9.4269 11.7487C9.85292 12.1767 10.1699 12.6838 10.4539 13.2121C11.0905 14.3964 11.5574 15.6505 11.9569 16.9316C11.9608 16.944 11.9643 16.9564 11.9732 16.9859C13.5754 13.1534 15.383 9.45358 17.8734 6.12915L17.9021 6.13874C17.9021 6.22486 17.9021 6.31098 17.9021 6.39688C17.9021 9.19064 17.9052 11.9844 17.9002 14.7784C17.8986 15.6202 17.8858 16.4624 17.8233 17.3027C17.8027 17.5811 17.7742 17.8593 17.6754 18.1242C17.5601 18.4333 17.3395 18.5127 17.0594 18.338C16.8218 18.1898 16.6373 17.9825 16.4822 17.754C16.1504 17.2654 15.831 16.7687 15.6093 16.2167C15.5952 16.1814 15.5917 16.1009 15.5142 16.1761C15.009 16.6673 14.4222 17.0471 13.8187 17.4003C12.0839 18.4152 10.2293 19.1317 8.28355 19.6187C7.58535 19.7934 6.88193 19.9416 6.1735 20.0672C6.10497 20.0794 6.08734 20.0753 6.10192 19.997C6.19656 19.4857 6.23986 18.9697 6.23986 18.449C6.23856 14.0349 6.23964 9.6208 6.23638 5.20669C6.23638 5.09615 6.26314 5.07239 6.37128 5.07239C10.1708 5.07544 13.9701 5.075 17.7696 5.075H17.9017C15.5708 7.38279 13.6026 9.93061 12.2715 12.9526L12.2708 12.9524Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M12.2752 13.0096C12.0792 12.6216 11.8919 12.246 11.6708 11.8889C11.3903 11.436 11.086 11.0021 10.6703 10.6606C10.358 10.4042 10.0121 10.2417 9.59481 10.3033C9.23477 10.3565 8.9444 10.546 8.68299 10.7864C8.54499 10.9134 8.41894 11.0526 8.30327 11.2206C8.36586 11.229 8.41783 11.2339 8.46914 11.2432C8.8409 11.311 9.12685 11.5275 9.38449 11.7861C9.81751 12.2211 10.1397 12.7366 10.4283 13.2736C11.0754 14.4773 11.55 15.752 11.9561 17.0542C11.96 17.0668 11.9636 17.0795 11.9726 17.1094C13.6012 13.2139 15.4386 9.45323 17.9699 6.07414L17.9991 6.08389C17.9991 6.17142 17.9991 6.25896 17.9991 6.34627C17.9991 9.18597 18.0022 12.0257 17.9971 14.8656C17.9955 15.7212 17.9825 16.5773 17.919 17.4314C17.898 17.7144 17.869 17.9971 17.7686 18.2664C17.6514 18.5806 17.4272 18.6613 17.1425 18.4838C16.901 18.3331 16.7135 18.1224 16.5558 17.8901C16.2186 17.3935 15.8939 16.8887 15.6686 16.3275C15.6542 16.2916 15.6506 16.2099 15.5719 16.2863C15.0584 16.7856 14.4619 17.1717 13.8485 17.5307C12.0852 18.5623 10.2001 19.2905 8.22233 19.7855C7.51265 19.963 6.79766 20.1137 6.07759 20.2414C6.00793 20.2538 5.99001 20.2496 6.00483 20.17C6.10103 19.6504 6.14504 19.1258 6.14504 18.5966C6.14371 14.1099 6.14482 9.62321 6.1415 5.13651C6.1415 5.02415 6.1687 5 6.27862 5C10.1406 5.0031 14.0024 5.00266 17.8644 5.00266H17.9986C15.6294 7.34839 13.6289 9.93811 12.2758 13.0098L12.2752 13.0096Z",
            fill: "#143158"
        })
    });
};

});

parcelRegister("5NHab", function(module, exports) {

$parcel$export(module.exports, "SmartsheetSearchResultIcon", () => $6fa817de366fe86e$export$3b8c4380ae1ed96d);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $6fa817de366fe86e$export$3b8c4380ae1ed96d = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-67.5",
                y: "-166.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.3609 17.2699C16.1039 16.7609 15.8582 16.2682 15.5681 15.7998C15.2003 15.2056 14.8011 14.6365 14.2557 14.1885C13.8461 13.8522 13.3923 13.6391 12.8449 13.7199C12.3726 13.7897 11.9917 14.0382 11.6488 14.3536C11.4678 14.5202 11.3025 14.7027 11.1507 14.9231C11.2328 14.9341 11.301 14.9405 11.3683 14.9527C11.856 15.0417 12.2311 15.3257 12.569 15.665C13.1371 16.2356 13.5597 16.9118 13.9383 17.6161C14.7871 19.1952 15.4097 20.8673 15.9423 22.5754C15.9476 22.592 15.9522 22.6086 15.9641 22.6478C18.1004 17.5379 20.5105 12.6048 23.831 8.1722L23.8693 8.18499C23.8693 8.29981 23.8693 8.41464 23.8693 8.52918C23.8693 12.2542 23.8734 15.9792 23.8667 19.7045C23.8647 20.8269 23.8476 21.9499 23.7643 23.0702C23.7367 23.4414 23.6987 23.8124 23.567 24.1656C23.4133 24.5778 23.1191 24.6836 22.7458 24.4507C22.429 24.2531 22.183 23.9766 21.9761 23.6719C21.5337 23.0205 21.1079 22.3583 20.8122 21.6222C20.7934 21.5751 20.7887 21.4679 20.6855 21.5682C20.0119 22.2231 19.2295 22.7295 18.4247 23.2004C16.1117 24.5536 13.6389 25.5089 11.0446 26.1583C10.1136 26.3911 9.17574 26.5888 8.23117 26.7563C8.13979 26.7725 8.11629 26.767 8.13573 26.6627C8.26192 25.981 8.31965 25.2929 8.31965 24.5987C8.31791 18.7132 8.31936 12.8277 8.31501 6.94225C8.31501 6.79487 8.35069 6.76318 8.49487 6.76318C13.5609 6.76725 18.6266 6.76667 23.6926 6.76667H23.8687C20.7609 9.84371 18.1366 13.2408 16.3618 17.2702L16.3609 17.2699Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M21.0973 20.7601C20.7118 19.9966 20.3432 19.2575 19.9081 18.555C19.3563 17.6637 18.7575 16.8099 17.9394 16.138C17.325 15.6335 16.6444 15.3138 15.8233 15.4351C15.1149 15.5397 14.5435 15.9125 14.0292 16.3856C13.7576 16.6355 13.5096 16.9093 13.282 17.2399C13.4052 17.2564 13.5074 17.266 13.6084 17.2843C14.3399 17.4178 14.9025 17.8438 15.4095 18.3527C16.2615 19.2086 16.8955 20.2229 17.4634 21.2794C18.7366 23.648 19.6705 26.1562 20.4694 28.7184C20.4772 28.7432 20.4842 28.7681 20.502 28.827C23.7065 21.1621 27.3217 13.7624 32.3024 7.11352L32.3599 7.13271C32.3599 7.30495 32.3599 7.47719 32.3599 7.64899C32.3599 13.2365 32.366 18.824 32.356 24.412C32.3529 26.0956 32.3273 27.78 32.2024 29.4605C32.161 30.0174 32.104 30.5738 31.9065 31.1036C31.6758 31.7219 31.2346 31.8806 30.6745 31.5313C30.1994 31.2348 29.8304 30.8201 29.5201 30.3631C28.8565 29.386 28.2177 28.3926 27.7743 27.2886C27.746 27.2179 27.739 27.057 27.5841 27.2075C26.5737 28.1899 25.4001 28.9495 24.193 29.6559C20.7235 31.6857 17.0143 33.1185 13.1228 34.0927C11.7264 34.4419 10.3195 34.7385 8.90267 34.9896C8.76559 35.014 8.73035 35.0057 8.7595 34.8492C8.94879 33.8267 9.03539 32.7945 9.03539 31.7533C9.03278 22.925 9.03495 14.0968 9.02843 5.2686C9.02843 5.04753 9.08195 5 9.29822 5C16.8973 5.0061 24.4958 5.00523 32.0949 5.00523H32.359C27.6972 9.6208 23.7609 14.7165 21.0986 20.7605L21.0973 20.7601Z",
            fill: "#143158"
        })
    });
};

});


parcelRegister("fsmrz", function(module, exports) {

$parcel$export(module.exports, "stripeConfig", () => $2ad7cc2fc111e558$export$3be693d67bbce82);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $fL9Ve = parcelRequire("fL9Ve");

var $7YLZm = parcelRequire("7YLZm");
const $2ad7cc2fc111e558$export$3be693d67bbce82 = {
    displayName: 'Stripe',
    id: 'stripe',
    resourceType: 'smartlinks-connector-stripe',
    icon: (0, $9yyKc.get3PLogo)((0, $fL9Ve.StripeIcon), 'Stripe', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $7YLZm.StripeSearchResultIcon), 'Stripe', 'large'),
    integrationAri: 'ari:cloud:platform::integration/stripe',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Invoice,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Invoice
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("fL9Ve", function(module, exports) {

$parcel$export(module.exports, "StripeIcon", () => $ec2be8ec238b2ddb$export$86ab8f6f2448222e);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $ec2be8ec238b2ddb$export$86ab8f6f2448222e = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#635BFF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.0639 9.32966C11.0639 8.76566 11.5259 8.54366 12.2939 8.54366C13.3979 8.54366 14.7899 8.87966 15.8939 9.47366V6.06566C14.6879 5.58566 13.4999 5.39966 12.2999 5.39966C9.35395 5.39966 7.39795 6.93566 7.39795 9.50366C7.39795 13.5057 12.9119 12.8697 12.9119 14.5977C12.9119 15.2637 12.3299 15.4797 11.5199 15.4797C10.3139 15.4797 8.77795 14.9877 7.55995 14.3217V17.7717C8.90995 18.3537 10.2719 18.5997 11.5199 18.5997C14.5379 18.5997 16.6139 17.1057 16.6139 14.5077C16.5899 10.1877 11.0639 10.9557 11.0639 9.32966Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5 5H19V19H5V5Z",
                fill: "#635BFF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4541 10.4422C11.4541 10.1132 11.7236 9.98366 12.1716 9.98366C12.8156 9.98366 13.6276 10.1797 14.2716 10.5262V8.53816C13.5681 8.25816 12.8751 8.14966 12.1751 8.14966C10.4566 8.14966 9.31555 9.04566 9.31555 10.5437C9.31555 12.8782 12.5321 12.5072 12.5321 13.5152C12.5321 13.9037 12.1926 14.0297 11.7201 14.0297C11.0166 14.0297 10.1206 13.7427 9.41005 13.3542V15.3667C10.1976 15.7062 10.9921 15.8497 11.7201 15.8497C13.4806 15.8497 14.6916 14.9782 14.6916 13.4627C14.6776 10.9427 11.4541 11.3907 11.4541 10.4422Z",
                fill: "white"
            })
        ]
    });
};

});

parcelRegister("7YLZm", function(module, exports) {

$parcel$export(module.exports, "StripeSearchResultIcon", () => $4814a0e19522a55b$export$efbbc3acb0731d93);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $4814a0e19522a55b$export$efbbc3acb0731d93 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-67.5",
                y: "-646.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#635BFF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.752 12.4395C14.752 11.6875 15.368 11.3915 16.392 11.3915C17.864 11.3915 19.72 11.8395 21.192 12.6315V8.08746C19.584 7.44746 18 7.19946 16.4 7.19946C12.472 7.19946 9.86401 9.24746 9.86401 12.6715C9.86401 18.0075 17.216 17.1595 17.216 19.4635C17.216 20.3515 16.44 20.6395 15.36 20.6395C13.752 20.6395 11.704 19.9835 10.08 19.0955V23.6955C11.88 24.4715 13.696 24.7995 15.36 24.7995C19.384 24.7995 22.152 22.8075 22.152 19.3435C22.12 13.5835 14.752 14.6075 14.752 12.4395Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5 6H35V36H5V6Z",
                fill: "#635BFF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.8301 17.662C18.8301 16.957 19.4076 16.6795 20.3676 16.6795C21.7476 16.6795 23.4876 17.0995 24.8676 17.842V13.582C23.3601 12.982 21.8751 12.7495 20.3751 12.7495C16.6926 12.7495 14.2476 14.6695 14.2476 17.8795C14.2476 22.882 21.1401 22.087 21.1401 24.247C21.1401 25.0795 20.4126 25.3495 19.4001 25.3495C17.8926 25.3495 15.9726 24.7345 14.4501 23.902V28.2145C16.1376 28.942 17.8401 29.2495 19.4001 29.2495C23.1726 29.2495 25.7676 27.382 25.7676 24.1345C25.7376 18.7345 18.8301 19.6945 18.8301 17.662Z",
                fill: "white"
            })
        ]
    });
};

});


parcelRegister("aBMKY", function(module, exports) {

$parcel$export(module.exports, "teamsConfig", () => $1dbab2ec75609d68$export$a579e078acf13bef);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $1RDRl = parcelRequire("1RDRl");

var $6QUTz = parcelRequire("6QUTz");
const $1dbab2ec75609d68$export$a579e078acf13bef = {
    displayName: 'Teams',
    id: 'teams',
    resourceType: 'microsoft-teams-connector',
    icon: (0, $9yyKc.get3PLogo)((0, $1RDRl.TeamsIcon), 'Teams', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $6QUTz.TeamsSearchResultIcon), 'Teams', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Conversation,
            {
                entities3P: [
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                    ...(0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Message,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("1RDRl", function(module, exports) {

$parcel$export(module.exports, "TeamsIcon", () => $a02e3255dc763cd4$export$1bcbc9c337da86da);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $a02e3255dc763cd4$export$1bcbc9c337da86da = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-506.5",
                y: "-603.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.4626 10.3286H18.3371C18.7032 10.3286 18.9999 10.6308 18.9999 11.0036V14.5978C18.9999 15.9679 17.9093 17.0786 16.564 17.0786H16.5525C15.2072 17.0788 14.1164 15.9682 14.1162 14.5981C14.1162 14.598 14.1162 14.5979 14.1162 14.5978V10.6814C14.1162 10.4866 14.2713 10.3286 14.4626 10.3286Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.0815 9.61849C17.9484 9.61849 18.6512 8.90274 18.6512 8.01982C18.6512 7.13689 17.9484 6.42114 17.0815 6.42114C16.2145 6.42114 15.5117 7.13689 15.5117 8.01982C15.5117 8.90274 16.2145 9.61849 17.0815 9.61849Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.1976 9.61839C13.4499 9.61839 14.465 8.58453 14.465 7.3092C14.465 6.03386 13.4499 5 12.1976 5C10.9453 5 9.93018 6.03386 9.93018 7.3092C9.93018 8.58453 10.9453 9.61839 12.1976 9.61839Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.2211 10.3286H8.82556C8.46387 10.3377 8.17775 10.6434 8.18614 11.0118V15.1111C8.13564 17.3217 9.85286 19.156 12.0233 19.2101C14.1938 19.156 15.911 17.3217 15.8605 15.1111V11.0118C15.8689 10.6434 15.5828 10.3377 15.2211 10.3286Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.1",
                d: "M12.3718 10.3286V16.0732C12.37 16.3366 12.2133 16.5733 11.9741 16.6736C11.8979 16.7064 11.8161 16.7233 11.7334 16.7233H8.49271C8.44736 16.6061 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.3718Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M12.0229 10.3286V16.4284C12.0229 16.5127 12.0063 16.596 11.9741 16.6736C11.8756 16.9172 11.6432 17.0768 11.3846 17.0786H8.65666C8.59736 16.9613 8.54154 16.8441 8.49271 16.7233C8.44387 16.6025 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M12.0229 10.3286V15.7179C12.0203 16.0759 11.736 16.3653 11.3845 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M11.6741 10.3286V15.7179C11.6714 16.0759 11.3872 16.3653 11.0357 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H11.6741Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.1",
                d: "M12.3722 8.49216V9.61123C12.3129 9.61478 12.2571 9.61834 12.1978 9.61834C12.1385 9.61834 12.0827 9.61479 12.0234 9.61123C11.9056 9.60328 11.7889 9.58425 11.6746 9.55439C10.9682 9.38403 10.3846 8.8795 10.1048 8.1973C10.0567 8.08274 10.0193 7.96378 9.99316 7.84204H11.7338C12.0859 7.8434 12.3709 8.13367 12.3722 8.49216Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M11.6742 8.84739V9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.0359C11.3879 8.19863 11.6729 8.48891 11.6742 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M4.63941 8.19727H11.0349C11.3881 8.19727 11.6744 8.48882 11.6744 8.84846V15.3618C11.6744 15.7214 11.3881 16.013 11.0349 16.013H4.63941C4.28627 16.013 4 15.7214 4 15.3618V8.84846C4 8.48882 4.28628 8.19727 4.63941 8.19727Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.51986 10.6761H8.24137V14.2216H7.42685V10.6761H6.1543V9.98828H9.51986V10.6761Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "1 1 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_3561_46629)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.0321 10H19.4879C19.9088 10 20.2501 10.3403 20.2501 10.76V14.8068C20.2501 16.3494 18.9959 17.6 17.4488 17.6H17.4355C15.8884 17.6002 14.634 16.3498 14.6338 14.8072C14.6338 14.8071 14.6338 14.8069 14.6338 14.8068V10.3972C14.6338 10.1778 14.8121 10 15.0321 10Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.0435 9.19961C19.0405 9.19961 19.8487 8.39372 19.8487 7.39961C19.8487 6.4055 19.0405 5.59961 18.0435 5.59961C17.0465 5.59961 16.2383 6.4055 16.2383 7.39961C16.2383 8.39372 17.0465 9.19961 18.0435 9.19961Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12.4274 9.20001C13.8675 9.20001 15.0349 8.03594 15.0349 6.6C15.0349 5.16406 13.8675 4 12.4274 4C10.9873 4 9.81982 5.16406 9.81982 6.6C9.81982 8.03594 10.9873 9.20001 12.4274 9.20001Z",
                        fill: "#7B83EB"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.904 10H8.54908C8.13313 10.0103 7.8041 10.3545 7.81375 10.7692V15.3848C7.75566 17.8737 9.73048 19.9391 12.2265 20C14.7226 19.9391 16.6974 17.8737 16.6393 15.3848V10.7692C16.649 10.3545 16.3199 10.0103 15.904 10Z",
                        fill: "#7B83EB"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.1",
                        d: "M12.6276 10V16.468C12.6256 16.7646 12.4454 17.0311 12.1703 17.144C12.0827 17.1809 11.9886 17.2 11.8935 17.2H8.16671C8.11456 17.068 8.06642 16.936 8.0263 16.8C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.6276Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2265 10V16.868C12.2265 16.9628 12.2074 17.0567 12.1703 17.144C12.0571 17.4183 11.7898 17.598 11.4924 17.6H8.35526C8.28706 17.468 8.22288 17.336 8.16671 17.2C8.11055 17.064 8.06642 16.936 8.0263 16.8C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.2265Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2265 10V16.068C12.2234 16.471 11.8965 16.797 11.4923 16.8H8.0263C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.2265Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8253 10V16.068C11.8223 16.471 11.4954 16.797 11.0912 16.8H8.0263C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H11.8253Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.1",
                        d: "M12.628 7.93121V9.19121C12.5598 9.19521 12.4956 9.19921 12.4274 9.19921C12.3592 9.19921 12.2951 9.19522 12.2269 9.19121C12.0914 9.18225 11.9572 9.16083 11.8257 9.12721C11.0133 8.93539 10.3422 8.36732 10.0205 7.59922C9.9651 7.47023 9.92213 7.33629 9.89209 7.19922H11.8939C12.2987 7.20075 12.6265 7.52757 12.628 7.93121Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2269 8.3316V9.1916C12.0915 9.18264 11.9572 9.16122 11.8257 9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.4928C11.8976 7.60114 12.2254 7.92797 12.2269 8.3316Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2269 8.3316V9.1916C12.0915 9.18264 11.9572 9.16122 11.8257 9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.4928C11.8976 7.60114 12.2254 7.92797 12.2269 8.3316Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8257 8.33161V9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.0916C11.4964 7.60115 11.8242 7.92798 11.8257 8.33161Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M3.73533 7.59961H11.0902C11.4964 7.59961 11.8256 7.92788 11.8256 8.33281V15.6664C11.8256 16.0713 11.4963 16.3996 11.0902 16.3996H3.73533C3.32921 16.3996 3 16.0713 3 15.6664V8.33281C3 7.92788 3.32922 7.59961 3.73533 7.59961Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M9.34796 10.3916H7.87769V14.3836H6.94098V10.3916H5.47754V9.61719H9.34796V10.3916Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_3561_46629",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "17.25",
                        height: "16",
                        fill: "white",
                        transform: "translate(3 4)"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("6QUTz", function(module, exports) {

$parcel$export(module.exports, "TeamsSearchResultIcon", () => $bbff60bddcb94f62$export$fa291efbf00e84d3);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $bbff60bddcb94f62$export$fa291efbf00e84d3 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-19.5",
                y: "-598.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.508324",
                y: "0.508324",
                width: "30.9834",
                height: "30.9834",
                rx: "7.49168",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "1.01665"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.2836 13.7715H24.4497C24.9377 13.7715 25.3334 14.1744 25.3334 14.6715V19.4637C25.3334 21.2905 23.8792 22.7714 22.0855 22.7714H22.0701C20.2764 22.7717 18.822 21.291 18.8218 19.4642C18.8218 19.464 18.8218 19.4639 18.8218 19.4637V14.2419C18.8218 13.9821 19.0286 13.7715 19.2836 13.7715Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M22.7749 12.8244C23.9308 12.8244 24.8679 11.8701 24.8679 10.6928C24.8679 9.51561 23.9308 8.56128 22.7749 8.56128C21.619 8.56128 20.6819 9.51561 20.6819 10.6928C20.6819 11.8701 21.619 12.8244 22.7749 12.8244Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.2635 12.8244C17.9332 12.8244 19.2867 11.4459 19.2867 9.74543C19.2867 8.04499 17.9332 6.6665 16.2635 6.6665C14.5938 6.6665 13.2402 8.04499 13.2402 9.74543C13.2402 11.4459 14.5938 12.8244 16.2635 12.8244Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.2947 13.7715H11.7673C11.2851 13.7836 10.9036 14.1912 10.9148 14.6824V20.1482C10.8474 23.0955 13.1371 25.5414 16.031 25.6135C18.925 25.5414 21.2146 23.0955 21.1473 20.1482V14.6824C21.1584 14.1912 20.777 13.7836 20.2947 13.7715Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.1",
                d: "M16.4959 13.7715V21.4309C16.4936 21.7821 16.2846 22.0977 15.9657 22.2314C15.8641 22.2752 15.755 22.2977 15.6448 22.2977H11.3239C11.2634 22.1414 11.2076 21.9851 11.1611 21.8241C10.9982 21.2805 10.9152 20.7155 10.9145 20.1472V14.681C10.9034 14.1906 11.2842 13.7836 11.7657 13.7715H16.4959Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M16.0308 13.7715V21.9046C16.0308 22.0169 16.0086 22.128 15.9657 22.2314C15.8344 22.5562 15.5245 22.7691 15.1796 22.7714H11.5425C11.4634 22.6151 11.389 22.4588 11.3239 22.2977C11.2587 22.1367 11.2076 21.9851 11.1611 21.8241C10.9982 21.2805 10.9152 20.7155 10.9145 20.1472V14.681C10.9034 14.1906 11.2842 13.7836 11.7657 13.7715H16.0308Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M16.0308 13.7715V20.9572C16.0272 21.4345 15.6482 21.8205 15.1796 21.8241H11.1611C10.9982 21.2805 10.9152 20.7155 10.9145 20.1472V14.681C10.9034 14.1906 11.2842 13.7836 11.7657 13.7715H16.0308Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M15.5657 13.7715V20.9572C15.5621 21.4345 15.1831 21.8205 14.7145 21.8241H11.1611C10.9982 21.2805 10.9152 20.7155 10.9145 20.1472V14.681C10.9034 14.1906 11.2842 13.7836 11.7657 13.7715H15.5657Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.1",
                d: "M16.4963 11.3226V12.8147C16.4172 12.8195 16.3428 12.8242 16.2637 12.8242C16.1847 12.8242 16.1102 12.8195 16.0312 12.8147C15.8742 12.8041 15.7185 12.7788 15.5661 12.7389C14.6242 12.5118 13.8461 11.8391 13.4731 10.9295C13.4089 10.7767 13.359 10.6181 13.3242 10.4558H15.6451C16.1145 10.4576 16.4945 10.8446 16.4963 11.3226Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M16.0308 11.7965V12.8149C15.8738 12.8043 15.7181 12.779 15.5657 12.7391C14.6238 12.512 13.8457 11.8393 13.4727 10.9297H15.1796C15.649 10.9315 16.029 11.3185 16.0308 11.7965Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M16.0308 11.7965V12.8149C15.8738 12.8043 15.7181 12.779 15.5657 12.7391C14.6238 12.512 13.8457 11.8393 13.4727 10.9297H15.1796C15.649 10.9315 16.029 11.3185 16.0308 11.7965Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M15.5657 11.7965V12.7391C14.6238 12.512 13.8457 11.8393 13.4727 10.9297H14.7145C15.1839 10.9315 15.5639 11.3185 15.5657 11.7965Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.1858 10.9297H14.7132C15.184 10.9297 15.5657 11.3184 15.5657 11.7979V20.4824C15.5657 20.9619 15.184 21.3507 14.7132 21.3507H6.1858C5.71495 21.3507 5.33325 20.9619 5.33325 20.4824V11.7979C5.33325 11.3184 5.71496 10.9297 6.1858 10.9297Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.693 14.2347H10.9883V18.962H9.9023V14.2347H8.20557V13.3176H12.693V14.2347Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M25.9254 16.9079H33.6744C34.4065 16.9079 35 17.5123 35 18.2579V25.4462C35 28.1865 32.8188 30.4078 30.1282 30.4078H30.1051C27.4145 30.4082 25.233 28.1872 25.2326 25.4469C25.2326 25.4467 25.2326 25.4465 25.2326 25.4462V17.6135C25.2326 17.2238 25.5428 16.9079 25.9254 16.9079Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M31.1625 15.4868C32.8964 15.4868 34.3021 14.0553 34.3021 12.2894C34.3021 10.5236 32.8964 9.09207 31.1625 9.09207C29.4286 9.09207 28.023 10.5236 28.023 12.2894C28.023 14.0553 29.4286 15.4868 31.1625 15.4868Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M21.3953 15.4868C23.8999 15.4868 25.9302 13.4191 25.9302 10.8684C25.9302 8.31773 23.8999 6.25 21.3953 6.25C18.8908 6.25 16.8605 8.31773 16.8605 10.8684C16.8605 13.4191 18.8908 15.4868 21.3953 15.4868Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.4421 16.9079H14.651C13.9276 16.9261 13.3554 17.5375 13.3722 18.2742V26.473C13.2712 30.894 16.7056 34.5628 21.0466 34.671C25.3875 34.5628 28.8219 30.894 28.7209 26.473V18.2742C28.7377 17.5375 28.1655 16.9261 27.4421 16.9079Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.1",
                d: "M21.7441 16.9079V28.3971C21.7406 28.9239 21.4271 29.3972 20.9487 29.5978C20.7964 29.6635 20.6327 29.6973 20.4673 29.6973H13.986C13.8953 29.4628 13.8115 29.2284 13.7418 28.9868C13.4976 28.1715 13.3729 27.3239 13.372 26.4715V18.2721C13.3552 17.5366 13.9265 16.9261 14.6487 16.9079H21.7441Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M21.0464 16.9079V29.1076C21.0464 29.276 21.0132 29.4427 20.9487 29.5978C20.7518 30.085 20.287 30.4043 19.7697 30.4078H14.3139C14.1953 30.1734 14.0836 29.9389 13.986 29.6973C13.8883 29.4557 13.8115 29.2284 13.7418 28.9868C13.4976 28.1715 13.3729 27.3239 13.372 26.4715V18.2721C13.3552 17.5366 13.9265 16.9261 14.6487 16.9079H21.0464Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M21.0464 16.9079V27.6865C21.0411 28.4024 20.4726 28.9814 19.7697 28.9868H13.7418C13.4976 28.1715 13.3729 27.3239 13.372 26.4715V18.2721C13.3552 17.5366 13.9265 16.9261 14.6487 16.9079H21.0464Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M20.3487 16.9079V27.6865C20.3434 28.4024 19.7749 28.9814 19.072 28.9868H13.7418C13.4976 28.1715 13.3729 27.3239 13.372 26.4715V18.2721C13.3552 17.5366 13.9265 16.9261 14.6487 16.9079H20.3487Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.1",
                d: "M21.7443 13.2344V15.4726C21.6257 15.4797 21.5141 15.4868 21.3955 15.4868C21.2769 15.4868 21.1653 15.4797 21.0467 15.4726C20.8112 15.4567 20.5776 15.4186 20.349 15.3589C18.9362 15.0182 17.769 14.0091 17.2095 12.6447C17.1132 12.4156 17.0384 12.1777 16.9862 11.9342H20.4676C21.1716 11.9369 21.7417 12.5175 21.7443 13.2344Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M21.0464 13.945V15.4726C20.8109 15.4567 20.5773 15.4186 20.3487 15.3589C18.9359 15.0182 17.7687 14.0091 17.2092 12.6447H19.7696C20.4736 12.6474 21.0437 13.228 21.0464 13.945Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M21.0464 13.945V15.4726C20.8109 15.4567 20.5773 15.4186 20.3487 15.3589C18.9359 15.0182 17.7687 14.0091 17.2092 12.6447H19.7696C20.4736 12.6474 21.0437 13.228 21.0464 13.945Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M20.3487 13.945V15.3589C18.9359 15.0182 17.7687 14.0091 17.2092 12.6447H19.0719C19.776 12.6474 20.346 13.228 20.3487 13.945Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.27882 12.6447H19.0699C19.7762 12.6447 20.3487 13.2278 20.3487 13.9471V26.9738C20.3487 27.6931 19.7762 28.2762 19.0699 28.2762H6.27882C5.57254 28.2762 5 27.6931 5 26.9738V13.9471C5 13.2278 5.57256 12.6447 6.27882 12.6447Z",
                fill: "url(#paint0_linear_teams)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.0398 17.6027H13.4829V24.6938H11.8538V17.6027H9.30872V16.2272H16.0398V17.6027Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                    id: "paint0_linear_teams",
                    x1: "7.66639",
                    y1: "11.6271",
                    x2: "17.9591",
                    y2: "29.1312",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            stopColor: "#5A62C3"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "0.5",
                            stopColor: "#4D55BD"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "1",
                            stopColor: "#3940AB"
                        })
                    ]
                })
            })
        ]
    });
};

});


parcelRegister("6XnCS", function(module, exports) {

$parcel$export(module.exports, "todoistConfig", () => $e5dc71fed4aef9e5$export$2ece5664272d405b);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $hLBua = parcelRequire("hLBua");

var $cVFF9 = parcelRequire("cVFF9");
const $e5dc71fed4aef9e5$export$2ece5664272d405b = {
    displayName: 'Todoist',
    id: 'todoist',
    resourceType: 'smartlinks-connector-todoist',
    icon: (0, $9yyKc.get3PLogo)((0, $hLBua.TodoistIcon), 'Todoist', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $cVFF9.TodoistSearchResultIcon), 'Todoist', 'large'),
    integrationAri: 'ari:cloud:platform::integration/todoist',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("hLBua", function(module, exports) {

$parcel$export(module.exports, "TodoistIcon", () => $20ca8932c8f35f66$export$e5f255e151507cba);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $20ca8932c8f35f66$export$e5f255e151507cba = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-731.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.7653 5.01575H7.2667C6.03236 5.01575 5.03174 6.01638 5.03174 7.25072V16.7493C5.03174 17.9837 6.03236 18.9843 7.2667 18.9843H16.7653C17.9996 18.9843 19.0002 17.9837 19.0002 16.7493V7.25072C19.0002 6.01638 17.9996 5.01575 16.7653 5.01575Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.98402 11.5604L10.7664 9.9593L10.7699 9.95712L13.6369 8.30708C13.7578 8.23724 13.7635 8.02335 13.6282 7.94565L13.5334 7.89152C13.3951 7.81295 13.2161 7.7108 13.1397 7.66628C13.0728 7.62983 12.9976 7.61118 12.9214 7.61209C12.8452 7.61301 12.7705 7.63347 12.7045 7.67151C12.6368 7.7108 8.12065 10.3072 7.96961 10.3932C7.88062 10.4441 7.77988 10.4708 7.67737 10.4708C7.57485 10.4708 7.47412 10.4441 7.38512 10.3932L5 9.00726V10.1854L5.02444 10.1994C5.61985 10.5464 7.02892 11.3671 7.37377 11.5613C7.58286 11.6792 7.78278 11.6766 7.98402 11.5604Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.98402 13.9142L10.7629 12.3148L10.7734 12.3087L13.6369 10.6608C13.7578 10.591 13.7635 10.3767 13.6282 10.2994L13.5334 10.2453C13.3955 10.1667 13.2161 10.0646 13.1397 10.02C13.0728 9.98359 12.9976 9.96494 12.9214 9.96585C12.8452 9.96677 12.7705 9.98723 12.7045 10.0253C12.6368 10.0641 8.12065 12.661 7.96961 12.7465C7.88062 12.7974 7.77988 12.8242 7.67737 12.8242C7.57485 12.8242 7.47412 12.7974 7.38512 12.7465C7.24282 12.6645 5 11.361 5 11.361V12.5387L5.02444 12.5531C5.62029 12.9002 7.02892 13.7204 7.37377 13.9151C7.58286 14.0329 7.78278 14.0303 7.98402 13.9142Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.7668 14.6663L7.98402 16.2679C7.78279 16.384 7.58242 16.3866 7.37377 16.2688C7.02892 16.0741 5.62029 15.2539 5.02444 14.9069L5 14.8924V13.7147L7.38512 15.1002C7.5654 15.2046 7.7889 15.2032 7.96961 15.1002C8.12065 15.0147 12.6368 12.4178 12.7045 12.3785C12.7705 12.3405 12.8452 12.32 12.9214 12.3191C12.9976 12.3182 13.0728 12.3369 13.1397 12.3733C13.3022 12.4673 13.4652 12.5604 13.6286 12.6527C13.7639 12.7304 13.7578 12.9447 13.6369 13.0146L10.7668 14.6663Z",
                fill: "#DE483A"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.4458 4H6.59025C5.17958 4 4.03601 5.14358 4.03601 6.55425V17.4098C4.03601 18.8205 5.17958 19.9641 6.59025 19.9641H17.4458C18.8564 19.9641 20 18.8205 20 17.4098V6.55425C20 5.14358 18.8564 4 17.4458 4Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.41031 11.4797L10.5901 9.64985L10.5941 9.64735L13.8707 7.7616C14.0089 7.68178 14.0154 7.43733 13.8608 7.34853L13.7525 7.28667C13.5944 7.19687 13.3898 7.08013 13.3025 7.02924C13.226 6.9876 13.1401 6.96627 13.053 6.96732C12.966 6.96837 12.8806 6.99175 12.8051 7.03523C12.7278 7.08013 7.56645 10.0475 7.39384 10.1457C7.29213 10.2039 7.17701 10.2345 7.05985 10.2345C6.94269 10.2345 6.82756 10.2039 6.72585 10.1457L4 8.5618V9.90827L4.02794 9.92423C4.7084 10.3208 6.31877 11.2587 6.71288 11.4807C6.95184 11.6154 7.18033 11.6124 7.41031 11.4797Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.41031 14.1697L10.5861 12.3418L10.5981 12.3348L13.8707 10.4515C14.0089 10.3717 14.0154 10.1268 13.8608 10.0385L13.7525 9.97661C13.5949 9.88681 13.3898 9.77007 13.3025 9.71919C13.226 9.67754 13.1401 9.65622 13.053 9.65726C12.966 9.65831 12.8806 9.68169 12.8051 9.72517C12.7278 9.76957 7.56645 12.7374 7.39384 12.8352C7.29213 12.8933 7.17701 12.9239 7.05985 12.9239C6.94269 12.9239 6.82756 12.8933 6.72585 12.8352C6.56322 12.7414 4 11.2517 4 11.2517V12.5977L4.02794 12.6142C4.7089 13.0108 6.31877 13.9482 6.71288 14.1707C6.95184 14.3054 7.18033 14.3024 7.41031 14.1697Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.5906 15.0292L7.41031 16.8596C7.18033 16.9923 6.95134 16.9953 6.71288 16.8606C6.31877 16.6381 4.7089 15.7007 4.02794 15.3041L4 15.2877V13.9417L6.72585 15.5251C6.93189 15.6444 7.18731 15.6429 7.39384 15.5251C7.56645 15.4273 12.7278 12.4595 12.8051 12.4146C12.8806 12.3711 12.966 12.3478 13.053 12.3467C13.1401 12.3457 13.226 12.367 13.3025 12.4086C13.4882 12.516 13.6745 12.6225 13.8613 12.7279C14.0159 12.8167 14.0089 13.0617 13.8707 13.1415L10.5906 15.0292Z",
                fill: "white"
            })
        ]
    });
};

});

parcelRegister("cVFF9", function(module, exports) {

$parcel$export(module.exports, "TodoistSearchResultIcon", () => $51916241e8b21132$export$c7baa9df7dbe4b13);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $51916241e8b21132$export$c7baa9df7dbe4b13 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-259.5",
                y: "-263.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M22.3534 6.68774H9.68868C8.04291 6.68774 6.70874 8.02192 6.70874 9.6677V22.3325C6.70874 23.9783 8.04291 25.3125 9.68868 25.3125H22.3534C23.9992 25.3125 25.3334 23.9783 25.3334 22.3325V9.6677C25.3334 8.02192 23.9992 6.68774 22.3534 6.68774Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.6452 15.4139L14.355 13.2791L14.3596 13.2762L18.1824 11.0761C18.3436 10.983 18.3511 10.6978 18.1707 10.5942L18.0444 10.522C17.8599 10.4173 17.6213 10.2811 17.5194 10.2217C17.4302 10.1731 17.33 10.1482 17.2284 10.1495C17.1268 10.1507 17.0272 10.178 16.9392 10.2287C16.849 10.2811 10.8274 13.7429 10.626 13.8576C10.5073 13.9254 10.373 13.9611 10.2363 13.9611C10.0996 13.9611 9.96533 13.9254 9.84666 13.8576L6.6665 12.0097V13.5806L6.6991 13.5992C7.49297 14.0619 9.37173 15.1561 9.83153 15.4151C10.1103 15.5722 10.3769 15.5687 10.6452 15.4139Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.6452 18.5522L14.3503 16.4197L14.3643 16.4116L18.1824 14.2144C18.3436 14.1213 18.3511 13.8355 18.1707 13.7325L18.0444 13.6603C17.8605 13.5556 17.6213 13.4194 17.5194 13.36C17.4302 13.3114 17.33 13.2865 17.2284 13.2878C17.1268 13.289 17.0272 13.3163 16.9392 13.367C16.849 13.4188 10.8274 16.8812 10.626 16.9953C10.5073 17.0632 10.373 17.0988 10.2363 17.0988C10.0996 17.0988 9.96533 17.0632 9.84666 16.9953C9.65692 16.8859 6.6665 15.148 6.6665 15.148V16.7183L6.6991 16.7375C7.49355 17.2002 9.37173 18.2938 9.83153 18.5534C10.1103 18.7105 10.3769 18.7071 10.6452 18.5522Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.3556 19.5552L10.6452 21.6906C10.3769 21.8455 10.1097 21.8489 9.83153 21.6918C9.37174 21.4322 7.49356 20.3386 6.6991 19.8759L6.6665 19.8567V18.2864L9.84666 20.1337C10.087 20.2728 10.385 20.2711 10.626 20.1337C10.8274 20.0196 16.849 16.5572 16.9392 16.5048C17.0272 16.4541 17.1268 16.4268 17.2284 16.4256C17.33 16.4244 17.4302 16.4492 17.5194 16.4978C17.7361 16.6231 17.9534 16.7473 18.1713 16.8703C18.3517 16.9739 18.3436 17.2597 18.1824 17.3528L14.3556 19.5552Z",
                fill: "#DE483A"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M30.2108 5H9.8567C7.2117 5 5.0675 7.14421 5.0675 9.78922V30.1434C5.0675 32.7884 7.2117 34.9326 9.8567 34.9326H30.2108C32.8558 34.9326 35 32.7884 35 30.1434V9.78922C35 7.14421 32.8558 5 30.2108 5Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3943 19.0246L17.3565 15.5935L17.364 15.5888L23.5076 12.0531C23.7667 11.9034 23.7789 11.445 23.4889 11.2785L23.2859 11.1626C22.9894 10.9942 22.6059 10.7753 22.4422 10.6799C22.2988 10.6018 22.1377 10.5618 21.9745 10.5638C21.8112 10.5658 21.6511 10.6096 21.5096 10.6911C21.3646 10.7753 11.6871 16.339 11.3635 16.5233C11.1727 16.6323 10.9569 16.6897 10.7372 16.6897C10.5175 16.6897 10.3017 16.6323 10.111 16.5233L5 13.5534V16.0781L5.05238 16.108C6.32825 16.8516 9.34769 18.6102 10.0867 19.0264C10.5347 19.279 10.9631 19.2734 11.3943 19.0246Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3943 24.0681L17.349 20.6408L17.3715 20.6277L23.5076 17.0966C23.7667 16.947 23.7789 16.4877 23.4889 16.3221L23.2859 16.2061C22.9904 16.0378 22.6059 15.8189 22.4422 15.7235C22.2988 15.6454 22.1377 15.6054 21.9745 15.6074C21.8112 15.6093 21.6511 15.6532 21.5096 15.7347C21.3646 15.8179 11.6871 21.3826 11.3635 21.5659C11.1727 21.675 10.9569 21.7323 10.7372 21.7323C10.5175 21.7323 10.3017 21.675 10.111 21.5659C9.80603 21.3901 5 18.597 5 18.597V21.1207L5.05238 21.1516C6.32919 21.8952 9.34769 23.6528 10.0867 24.07C10.5347 24.3226 10.9631 24.3169 11.3943 24.0681Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.3574 25.6798L11.3943 29.1118C10.9631 29.3606 10.5338 29.3662 10.0867 29.1137C9.34769 28.6965 6.32919 26.9389 5.05238 26.1952L5 26.1644V23.6407L10.111 26.6096C10.4973 26.8332 10.9762 26.8304 11.3635 26.6096C11.6871 26.4263 21.3646 20.8616 21.5096 20.7774C21.6511 20.6959 21.8112 20.6521 21.9745 20.6501C22.1377 20.6481 22.2988 20.6881 22.4422 20.7662C22.7904 20.9676 23.1396 21.1671 23.4899 21.3649C23.7798 21.5314 23.7667 21.9906 23.5076 22.1403L17.3574 25.6798Z",
                fill: "white"
            })
        ]
    });
};

});


parcelRegister("aaBRD", function(module, exports) {

$parcel$export(module.exports, "webexConfig", () => $a861cf12095eaed4$export$57d2eef9725d4993);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $3dNJ5 = parcelRequire("3dNJ5");

var $d56OO = parcelRequire("d56OO");
const $a861cf12095eaed4$export$57d2eef9725d4993 = {
    displayName: 'Webex',
    id: 'webex',
    resourceType: 'smartlinks-connector-webex',
    icon: (0, $9yyKc.get3PLogo)((0, $3dNJ5.WebexIcon), 'Webex', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $d56OO.WebexSearchResultIcon), 'Webex', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cisco',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Video,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Video
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("3dNJ5", function(module, exports) {

$parcel$export(module.exports, "WebexIcon", () => $756b739c78aa76b5$export$4079343fb47e7f0d);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $756b739c78aa76b5$export$4079343fb47e7f0d = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-554.5",
                y: "-363.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                id: "mask0_719_13847",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "6",
                width: "18",
                height: "13",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M20.5 6.177H3.5V18.551H20.5V6.177Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                mask: "url(#mask0_719_13847)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.77473 18.5019C5.62694 18.5019 4.55554 14.5209 4.31548 13.7465C3.71261 11.8018 3.52935 10.05 3.50994 9.86618C3.39799 8.80539 4.24877 8.06718 5.18252 8.06718C5.8895 8.06718 6.71005 8.49041 6.81877 9.51726C6.83761 9.68995 6.98136 11.1795 7.48984 12.8026C8.02049 14.4964 8.58341 15.1479 8.98879 15.1479C9.64347 15.1479 10.0429 13.4664 10.396 11.8653C10.6562 10.6857 10.9374 9.49712 11.4926 8.44128C12.4585 6.60445 13.9181 6.177 15.1791 6.177C17.944 6.177 19.3278 9.38049 19.3278 10.2105C19.3278 11.5975 18.1965 11.9513 17.7062 11.9513C16.6338 11.9513 16.2703 11.2327 15.9643 10.6029C15.689 10.0363 15.4016 9.56515 15.0299 9.56515C14.9078 9.56515 14.7946 9.62698 14.69 9.73341C13.7662 10.6723 13.4565 15.584 11.6095 17.4612C10.5856 18.5019 9.47152 18.5019 8.77473 18.5019Z",
                        fill: "#00BBFF"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.8181 8.06718C18.6934 8.06718 18.5681 8.07894 18.4451 8.1032C19.0296 8.94596 19.3221 9.82891 19.3221 10.2104C19.3221 11.5975 18.1907 11.9512 17.7004 11.9512C17.3178 11.9512 17.0254 11.8597 16.7937 11.7134C16.7916 11.7221 16.7895 11.7307 16.7873 11.7394C16.7184 12.0147 16.664 12.3159 16.5698 12.6092C16.3888 13.1729 16.1446 13.8168 15.8839 14.3151C15.6028 14.8523 15.3246 15.1666 14.9929 15.1501C14.6157 15.1314 14.3099 14.6452 13.9298 13.2711C13.8072 12.8281 13.6937 12.3423 13.5885 11.8653C13.3276 10.6822 13.0074 9.49254 12.4598 8.44128C11.5653 6.72426 10.0396 6.177 8.82156 6.177C7.69192 6.177 6.84795 6.71182 6.18495 7.3857C6.00175 7.57192 5.80158 7.82283 5.60059 8.11766C6.17886 8.25694 6.72565 8.69224 6.81293 9.51716C6.83015 9.67444 6.95085 10.9237 7.35628 12.3714C7.4726 12.0084 7.64222 11.4709 8.03625 10.6029C8.22939 10.2054 8.40369 9.94325 8.56092 9.78348C8.70514 9.63686 8.83499 9.57634 8.95193 9.57634C9.07804 9.57634 9.50861 9.69177 9.92778 11.1628C10.4477 12.9869 10.8346 15.8898 12.3086 17.4312C12.9587 18.1111 13.8685 18.551 15.1294 18.551C16.2358 18.551 17.1582 18.0637 17.8159 17.3859C18.8973 16.2712 19.4898 14.4284 19.7011 13.7465C20.3026 11.8064 20.4711 10.0518 20.4907 9.86618C20.6026 8.80539 19.709 8.06718 18.8181 8.06718Z",
                        fill: "#316AFF"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                id: "mask0_647_117",
                maskUnits: "userSpaceOnUse",
                x: "4",
                y: "6",
                width: "16",
                height: "12",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M20 6H4V17.6461H20V6Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                mask: "url(#mask0_647_117)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint0_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint1_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint2_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint3_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint4_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint5_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint6_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint7_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint8_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.9922 6C13.8054 6 12.4317 6.4023 11.5225 8.13109C11 9.12482 10.7353 10.2435 10.4905 11.3537C10.4099 11.719 10.3267 12.0888 10.2382 12.4394V17.4624C10.6873 17.3353 11.1697 17.0908 11.6326 16.6205C13.3709 14.8536 13.6625 10.2308 14.5319 9.34721C14.6303 9.24703 14.7369 9.18884 14.8518 9.18884C15.2016 9.18884 15.4722 9.63224 15.7312 10.1655C16.0192 10.7583 16.3613 11.4346 17.3707 11.4346C17.8322 11.4346 18.8969 11.1017 18.8969 9.79624C18.8969 9.01505 17.5945 6 14.9922 6Z",
                        fill: "url(#paint9_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint10_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint11_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint12_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint13_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint14_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "#316AFF"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint15_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint16_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint17_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint18_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint19_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint20_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint21_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint22_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint23_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint24_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint25_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint26_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint27_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint28_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint29_radial_647_117)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint0_linear_647_117",
                        x1: "17.2757",
                        y1: "9.40344",
                        x2: "6.80986",
                        y2: "12.8357",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#5CEE64"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00BBFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint1_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(10.09 12.186) rotate(-120.86) scale(6.85625 5.75574)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#007383"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.407867",
                                stopColor: "#00717E",
                                stopOpacity: "0.75"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.874482",
                                stopColor: "#007281",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint2_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(14.5948 10.9103) rotate(-126.734) scale(5.59154 3.67393)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#218970"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.459527",
                                stopColor: "#267E6A"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#026C51",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint3_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(9.6952 12.5099) rotate(-107.468) scale(4.554 2.37251)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#178697"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.407867",
                                stopColor: "#17838F",
                                stopOpacity: "0.79"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.874482",
                                stopColor: "#007281",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint4_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(11.7199 12.4856) rotate(-120.86) scale(11.5648 3.56733)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#25342F",
                                stopOpacity: "0.3"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#25342F",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint5_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(13.7828 11.0371) rotate(85.0979) scale(4.35562 2.47045)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#056D4F"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.232593",
                                stopColor: "#056C4E",
                                stopOpacity: "0.75"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.598902",
                                stopColor: "#056C4E",
                                stopOpacity: "0.300824"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.874482",
                                stopColor: "#056C4F",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint6_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(13.9754 3.99288) rotate(57.0774) scale(5.12012 2.6855)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#22B67B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.407867",
                                stopColor: "#24BE82"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#24BE82",
                                stopOpacity: "0.07"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint7_linear_647_117",
                        x1: "0.0633092",
                        y1: "11.6988",
                        x2: "7.4802",
                        y2: "11.7598",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#09F8FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint8_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(1.65669 5.0183) rotate(49.6506) scale(6.68716 6.67046)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#09F8FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint9_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.01337 1.6515) rotate(48.0118) scale(13.5629 13.5415)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00B8FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.745423",
                                stopColor: "#00B9FC",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint10_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.73139 11.8243) rotate(-107.468) scale(6.53747 4.52974)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00BCFF",
                                stopOpacity: "0.76"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.57273",
                                stopColor: "#00BAFC",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint11_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.6701 9.34133) rotate(-129.551) scale(4.62291 3.23649)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#5FEC50"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#3CC08E",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint12_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.0084 12.3189) rotate(-79.0944) scale(1.39957 0.968007)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#28855B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#14795C",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint13_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.941 12.2159) rotate(-77.8798) scale(1.15379 1.61246)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#28855B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#14795C",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint14_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(18.3155 10.1373) rotate(-132.79) scale(3.82739 2.68878)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#5FF05B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.813285",
                                stopColor: "#5DE955",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint15_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.1186 11.2367) rotate(37.4559) scale(3.40381 4.73123)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.966119",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint16_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.2718 11.6203) rotate(8.48611) scale(4.01618 5.99473)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.592487",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint17_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.5977 12.1185) rotate(24.6631) scale(3.43068 6.11312)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.756788",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint18_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.1948 12.3217) rotate(95.8028) scale(6.16725 3.37972)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.592487",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint19_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.1186 9.59893) rotate(93.6671) scale(7.42211 2.64877)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.884611",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint20_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(8.70726 11.1422) rotate(84.8296) scale(3.93849 2.08658)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.884611",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint21_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(8.70442 11.2481) rotate(87.2504) scale(4.11044 3.39354)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.884611",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint22_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(9.63961 15.1104) rotate(-23.1725) scale(4.58388 8.95991)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.708977",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint23_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(8.00865 10.2431) rotate(-159.526) scale(3.03689 5.19997)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#1A3DA0"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.708977",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint24_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(5.33541 11.2767) rotate(16.749) scale(5.79218 5.84719)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#1E3882"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.761404",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint25_linear_647_117",
                        x1: "3.51831",
                        y1: "8.07299",
                        x2: "9.22598",
                        y2: "11.7159",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.229329",
                                stopColor: "#1DC4FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1CC1FF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint26_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(1.65635 5.01803) rotate(49.6506) scale(6.68716 6.67046)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#09F8FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint27_linear_647_117",
                        x1: "3.8338",
                        y1: "8.25908",
                        x2: "5.43479",
                        y2: "9.71047",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#26FBFF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.637346",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint28_linear_647_117",
                        x1: "3.40845",
                        y1: "9.36998",
                        x2: "5.62288",
                        y2: "9.52796",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#26FBFF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.637346",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint29_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.73119 11.8243) rotate(-107.468) scale(6.53747 4.52974)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00BCFF",
                                stopOpacity: "0.76"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.57273",
                                stopColor: "#00BAFC",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("d56OO", function(module, exports) {

$parcel$export(module.exports, "WebexSearchResultIcon", () => $dfa5ceb7e6facbec$export$37506c98e5c4eabb);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $dfa5ceb7e6facbec$export$37506c98e5c4eabb = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-67.5",
                y: "-358.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.508324",
                y: "0.508324",
                width: "30.9834",
                height: "30.9834",
                rx: "7.49168",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "1.01665"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                id: "mask0_719_13847",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: "4",
                y: "8",
                width: "24",
                height: "17",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M27.3332 8.23584H4.6665V24.7345H27.3332V8.23584Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                mask: "url(#mask0_719_13847)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M11.6995 24.6691C7.50242 24.6691 6.07389 19.3611 5.75381 18.3285C4.94999 15.7356 4.70563 13.3998 4.67976 13.1547C4.5305 11.7404 5.66487 10.7561 6.90986 10.7561C7.85251 10.7561 8.94657 11.3204 9.09153 12.6895C9.11665 12.9198 9.30832 14.9059 9.98629 17.0699C10.6938 19.3284 11.4444 20.197 11.9849 20.197C12.8578 20.197 13.3903 17.955 13.8612 15.8203C14.2081 14.2475 14.583 12.6627 15.3233 11.2549C16.6112 8.80577 18.5573 8.23584 20.2386 8.23584C23.9252 8.23584 25.7703 12.5072 25.7703 13.6138C25.7703 15.4632 24.2619 15.9349 23.6081 15.9349C22.1783 15.9349 21.6936 14.9768 21.2855 14.137C20.9186 13.3815 20.5353 12.7534 20.0398 12.7534C19.877 12.7534 19.726 12.8358 19.5865 12.9777C18.3548 14.2295 17.9419 20.7785 15.4792 23.2815C14.114 24.6691 12.6285 24.6691 11.6995 24.6691Z",
                        fill: "#00BBFF"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M25.0906 10.7561C24.9244 10.7561 24.7573 10.7718 24.5934 10.8041C25.3726 11.9278 25.7626 13.1051 25.7626 13.6137C25.7626 15.4631 24.2542 15.9348 23.6004 15.9348C23.0902 15.9348 22.7004 15.8128 22.3915 15.6177C22.3886 15.6293 22.3858 15.6408 22.3829 15.6524C22.291 16.0194 22.2185 16.4211 22.093 16.8121C21.8516 17.5637 21.526 18.4223 21.1784 19.0866C20.8036 19.8029 20.4326 20.222 19.9904 20.2C19.4874 20.175 19.0797 19.5267 18.5729 17.6946C18.4095 17.1039 18.2581 16.4562 18.1179 15.8203C17.77 14.2428 17.343 12.6566 16.6129 11.2549C15.4203 8.96551 13.386 8.23584 11.7619 8.23584C10.2557 8.23584 9.13044 8.94893 8.24644 9.84744C8.00217 10.0957 7.73528 10.4303 7.46729 10.8234C8.23832 11.0091 8.96737 11.5895 9.08374 12.6894C9.10671 12.8991 9.26763 14.5647 9.80821 16.495C9.9633 16.0111 10.1895 15.2944 10.7148 14.137C10.9724 13.607 11.2048 13.2575 11.4144 13.0445C11.6067 12.849 11.7798 12.7683 11.9358 12.7683C12.1039 12.7683 12.678 12.9222 13.2369 14.8835C13.9301 17.3157 14.4459 21.1863 16.4113 23.2414C17.2781 24.1479 18.4912 24.7345 20.1724 24.7345C21.6476 24.7345 22.8775 24.0847 23.7544 23.181C25.1962 21.6948 25.9862 19.2377 26.268 18.3285C27.0699 15.7417 27.2946 13.4023 27.3207 13.1547C27.4699 11.7404 26.2784 10.7561 25.0906 10.7561Z",
                        fill: "#316AFF"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                id: "mask0_4156_8750",
                maskUnits: "userSpaceOnUse",
                x: "5",
                y: "9",
                width: "30",
                height: "22",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M35 9H5V30.8364H35V9Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                mask: "url(#mask0_4156_8750)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.8899 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint0_linear_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.8899 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint1_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.8899 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint2_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.8899 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint3_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.8899 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint4_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.8899 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint5_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.8899 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint6_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.8899 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint7_linear_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.8899 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint8_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M25.6103 9C23.3851 9 20.8094 9.75432 19.1047 12.9958C18.1249 14.859 17.6287 16.9566 17.1697 19.0382C17.0185 19.7232 16.8625 20.4165 16.6967 21.0739V30.492C17.5387 30.2537 18.4433 29.7953 19.3112 28.9134C22.5705 25.6005 23.1171 16.9328 24.7473 15.276C24.9319 15.0882 25.1317 14.9791 25.3471 14.9791C26.0031 14.9791 26.5103 15.8105 26.996 16.8104C27.536 17.9219 28.1775 19.19 30.07 19.19C30.9353 19.19 32.9316 18.5656 32.9316 16.118C32.9316 14.6532 30.4897 9 25.6103 9Z",
                        fill: "url(#paint9_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.8899 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint10_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.8899 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint11_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.8899 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint12_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.8899 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint13_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.8899 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint14_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M32.032 12.3356C31.812 12.3356 31.5908 12.3564 31.3738 12.3992C32.4052 13.8864 32.9213 15.4445 32.9213 16.1178C32.9213 18.5655 30.9249 19.1898 30.0596 19.1898C29.3844 19.1898 28.8685 19.0283 28.4596 18.7701C28.4557 18.7855 28.4521 18.8006 28.4482 18.816C28.3266 19.3017 28.2306 19.8334 28.0645 20.3509C27.7451 21.3456 27.3141 22.482 26.854 23.3614C26.358 24.3094 25.8669 24.864 25.2817 24.8349C24.616 24.8019 24.0763 23.9438 23.4056 21.519C23.1893 20.7372 22.989 19.8799 22.8034 19.0382C22.3429 16.9504 21.7777 14.851 20.8114 12.9958C19.233 9.96575 16.5406 9 14.391 9C12.3976 9 10.9082 9.94379 9.7382 11.133C9.41491 11.4616 9.06167 11.9044 8.70697 12.4247C9.72745 12.6705 10.6924 13.4387 10.8464 14.8944C10.8768 15.172 11.0898 17.3765 11.8053 19.9312C12.0105 19.2907 12.3098 18.3421 13.0052 16.8104C13.346 16.1089 13.6536 15.6463 13.9311 15.3644C14.1856 15.1056 14.4147 14.9988 14.6211 14.9988C14.8437 14.9988 15.6035 15.2025 16.3432 17.7984C17.2606 21.0174 17.9434 26.1403 20.5446 28.8603C21.6919 30.0601 23.2974 30.8364 25.5226 30.8364C27.475 30.8364 29.1028 29.9765 30.2634 28.7804C32.1717 26.8133 33.2173 23.5613 33.5903 22.358C34.6517 18.9343 34.9491 15.8379 34.9836 15.5103C35.1811 13.6383 33.6041 12.3356 32.032 12.3356Z",
                        fill: "#316AFF"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M32.032 12.3356C31.812 12.3356 31.5908 12.3564 31.3738 12.3992C32.4052 13.8864 32.9213 15.4445 32.9213 16.1178C32.9213 18.5655 30.9249 19.1898 30.0596 19.1898C29.3844 19.1898 28.8685 19.0283 28.4596 18.7701C28.4557 18.7855 28.4521 18.8006 28.4482 18.816C28.3266 19.3017 28.2306 19.8334 28.0645 20.3509C27.7451 21.3456 27.3141 22.482 26.854 23.3614C26.358 24.3094 25.8669 24.864 25.2817 24.8349C24.616 24.8019 24.0763 23.9438 23.4056 21.519C23.1893 20.7372 22.989 19.8799 22.8034 19.0382C22.3429 16.9504 21.7777 14.851 20.8114 12.9958C19.233 9.96575 16.5406 9 14.391 9C12.3976 9 10.9082 9.94379 9.7382 11.133C9.41491 11.4616 9.06167 11.9044 8.70697 12.4247C9.72745 12.6705 10.6924 13.4387 10.8464 14.8944C10.8768 15.172 11.0898 17.3765 11.8053 19.9312C12.0105 19.2907 12.3098 18.3421 13.0052 16.8104C13.346 16.1089 13.6536 15.6463 13.9311 15.3644C14.1856 15.1056 14.4147 14.9988 14.6211 14.9988C14.8437 14.9988 15.6035 15.2025 16.3432 17.7984C17.2606 21.0174 17.9434 26.1403 20.5446 28.8603C21.6919 30.0601 23.2974 30.8364 25.5226 30.8364C27.475 30.8364 29.1028 29.9765 30.2634 28.7804C32.1717 26.8133 33.2173 23.5613 33.5903 22.358C34.6517 18.9343 34.9491 15.8379 34.9836 15.5103C35.1811 13.6383 33.6041 12.3356 32.032 12.3356Z",
                        fill: "url(#paint15_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M32.032 12.3356C31.812 12.3356 31.5908 12.3564 31.3738 12.3992C32.4052 13.8864 32.9213 15.4445 32.9213 16.1178C32.9213 18.5655 30.9249 19.1898 30.0596 19.1898C29.3844 19.1898 28.8685 19.0283 28.4596 18.7701C28.4557 18.7855 28.4521 18.8006 28.4482 18.816C28.3266 19.3017 28.2306 19.8334 28.0645 20.3509C27.7451 21.3456 27.3141 22.482 26.854 23.3614C26.358 24.3094 25.8669 24.864 25.2817 24.8349C24.616 24.8019 24.0763 23.9438 23.4056 21.519C23.1893 20.7372 22.989 19.8799 22.8034 19.0382C22.3429 16.9504 21.7777 14.851 20.8114 12.9958C19.233 9.96575 16.5406 9 14.391 9C12.3976 9 10.9082 9.94379 9.7382 11.133C9.41491 11.4616 9.06167 11.9044 8.70697 12.4247C9.72745 12.6705 10.6924 13.4387 10.8464 14.8944C10.8768 15.172 11.0898 17.3765 11.8053 19.9312C12.0105 19.2907 12.3098 18.3421 13.0052 16.8104C13.346 16.1089 13.6536 15.6463 13.9311 15.3644C14.1856 15.1056 14.4147 14.9988 14.6211 14.9988C14.8437 14.9988 15.6035 15.2025 16.3432 17.7984C17.2606 21.0174 17.9434 26.1403 20.5446 28.8603C21.6919 30.0601 23.2974 30.8364 25.5226 30.8364C27.475 30.8364 29.1028 29.9765 30.2634 28.7804C32.1717 26.8133 33.2173 23.5613 33.5903 22.358C34.6517 18.9343 34.9491 15.8379 34.9836 15.5103C35.1811 13.6383 33.6041 12.3356 32.032 12.3356Z",
                        fill: "url(#paint16_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M32.032 12.3356C31.812 12.3356 31.5908 12.3564 31.3738 12.3992C32.4052 13.8864 32.9213 15.4445 32.9213 16.1178C32.9213 18.5655 30.9249 19.1898 30.0596 19.1898C29.3844 19.1898 28.8685 19.0283 28.4596 18.7701C28.4557 18.7855 28.4521 18.8006 28.4482 18.816C28.3266 19.3017 28.2306 19.8334 28.0645 20.3509C27.7451 21.3456 27.3141 22.482 26.854 23.3614C26.358 24.3094 25.8669 24.864 25.2817 24.8349C24.616 24.8019 24.0763 23.9438 23.4056 21.519C23.1893 20.7372 22.989 19.8799 22.8034 19.0382C22.3429 16.9504 21.7777 14.851 20.8114 12.9958C19.233 9.96575 16.5406 9 14.391 9C12.3976 9 10.9082 9.94379 9.7382 11.133C9.41491 11.4616 9.06167 11.9044 8.70697 12.4247C9.72745 12.6705 10.6924 13.4387 10.8464 14.8944C10.8768 15.172 11.0898 17.3765 11.8053 19.9312C12.0105 19.2907 12.3098 18.3421 13.0052 16.8104C13.346 16.1089 13.6536 15.6463 13.9311 15.3644C14.1856 15.1056 14.4147 14.9988 14.6211 14.9988C14.8437 14.9988 15.6035 15.2025 16.3432 17.7984C17.2606 21.0174 17.9434 26.1403 20.5446 28.8603C21.6919 30.0601 23.2974 30.8364 25.5226 30.8364C27.475 30.8364 29.1028 29.9765 30.2634 28.7804C32.1717 26.8133 33.2173 23.5613 33.5903 22.358C34.6517 18.9343 34.9491 15.8379 34.9836 15.5103C35.1811 13.6383 33.6041 12.3356 32.032 12.3356Z",
                        fill: "url(#paint17_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M32.032 12.3356C31.812 12.3356 31.5908 12.3564 31.3738 12.3992C32.4052 13.8864 32.9213 15.4445 32.9213 16.1178C32.9213 18.5655 30.9249 19.1898 30.0596 19.1898C29.3844 19.1898 28.8685 19.0283 28.4596 18.7701C28.4557 18.7855 28.4521 18.8006 28.4482 18.816C28.3266 19.3017 28.2306 19.8334 28.0645 20.3509C27.7451 21.3456 27.3141 22.482 26.854 23.3614C26.358 24.3094 25.8669 24.864 25.2817 24.8349C24.616 24.8019 24.0763 23.9438 23.4056 21.519C23.1893 20.7372 22.989 19.8799 22.8034 19.0382C22.3429 16.9504 21.7777 14.851 20.8114 12.9958C19.233 9.96575 16.5406 9 14.391 9C12.3976 9 10.9082 9.94379 9.7382 11.133C9.41491 11.4616 9.06167 11.9044 8.70697 12.4247C9.72745 12.6705 10.6924 13.4387 10.8464 14.8944C10.8768 15.172 11.0898 17.3765 11.8053 19.9312C12.0105 19.2907 12.3098 18.3421 13.0052 16.8104C13.346 16.1089 13.6536 15.6463 13.9311 15.3644C14.1856 15.1056 14.4147 14.9988 14.6211 14.9988C14.8437 14.9988 15.6035 15.2025 16.3432 17.7984C17.2606 21.0174 17.9434 26.1403 20.5446 28.8603C21.6919 30.0601 23.2974 30.8364 25.5226 30.8364C27.475 30.8364 29.1028 29.9765 30.2634 28.7804C32.1717 26.8133 33.2173 23.5613 33.5903 22.358C34.6517 18.9343 34.9491 15.8379 34.9836 15.5103C35.1811 13.6383 33.6041 12.3356 32.032 12.3356Z",
                        fill: "url(#paint18_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M32.032 12.3356C31.812 12.3356 31.5908 12.3564 31.3738 12.3992C32.4052 13.8864 32.9213 15.4445 32.9213 16.1178C32.9213 18.5655 30.9249 19.1898 30.0596 19.1898C29.3844 19.1898 28.8685 19.0283 28.4596 18.7701C28.4557 18.7855 28.4521 18.8006 28.4482 18.816C28.3266 19.3017 28.2306 19.8334 28.0645 20.3509C27.7451 21.3456 27.3141 22.482 26.854 23.3614C26.358 24.3094 25.8669 24.864 25.2817 24.8349C24.616 24.8019 24.0763 23.9438 23.4056 21.519C23.1893 20.7372 22.989 19.8799 22.8034 19.0382C22.3429 16.9504 21.7777 14.851 20.8114 12.9958C19.233 9.96575 16.5406 9 14.391 9C12.3976 9 10.9082 9.94379 9.7382 11.133C9.41491 11.4616 9.06167 11.9044 8.70697 12.4247C9.72745 12.6705 10.6924 13.4387 10.8464 14.8944C10.8768 15.172 11.0898 17.3765 11.8053 19.9312C12.0105 19.2907 12.3098 18.3421 13.0052 16.8104C13.346 16.1089 13.6536 15.6463 13.9311 15.3644C14.1856 15.1056 14.4147 14.9988 14.6211 14.9988C14.8437 14.9988 15.6035 15.2025 16.3432 17.7984C17.2606 21.0174 17.9434 26.1403 20.5446 28.8603C21.6919 30.0601 23.2974 30.8364 25.5226 30.8364C27.475 30.8364 29.1028 29.9765 30.2634 28.7804C32.1717 26.8133 33.2173 23.5613 33.5903 22.358C34.6517 18.9343 34.9491 15.8379 34.9836 15.5103C35.1811 13.6383 33.6041 12.3356 32.032 12.3356Z",
                        fill: "url(#paint19_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M32.032 12.3356C31.812 12.3356 31.5908 12.3564 31.3738 12.3992C32.4052 13.8864 32.9213 15.4445 32.9213 16.1178C32.9213 18.5655 30.9249 19.1898 30.0596 19.1898C29.3844 19.1898 28.8685 19.0283 28.4596 18.7701C28.4557 18.7855 28.4521 18.8006 28.4482 18.816C28.3266 19.3017 28.2306 19.8334 28.0645 20.3509C27.7451 21.3456 27.3141 22.482 26.854 23.3614C26.358 24.3094 25.8669 24.864 25.2817 24.8349C24.616 24.8019 24.0763 23.9438 23.4056 21.519C23.1893 20.7372 22.989 19.8799 22.8034 19.0382C22.3429 16.9504 21.7777 14.851 20.8114 12.9958C19.233 9.96575 16.5406 9 14.391 9C12.3976 9 10.9082 9.94379 9.7382 11.133C9.41491 11.4616 9.06167 11.9044 8.70697 12.4247C9.72745 12.6705 10.6924 13.4387 10.8464 14.8944C10.8768 15.172 11.0898 17.3765 11.8053 19.9312C12.0105 19.2907 12.3098 18.3421 13.0052 16.8104C13.346 16.1089 13.6536 15.6463 13.9311 15.3644C14.1856 15.1056 14.4147 14.9988 14.6211 14.9988C14.8437 14.9988 15.6035 15.2025 16.3432 17.7984C17.2606 21.0174 17.9434 26.1403 20.5446 28.8603C21.6919 30.0601 23.2974 30.8364 25.5226 30.8364C27.475 30.8364 29.1028 29.9765 30.2634 28.7804C32.1717 26.8133 33.2173 23.5613 33.5903 22.358C34.6517 18.9343 34.9491 15.8379 34.9836 15.5103C35.1811 13.6383 33.6041 12.3356 32.032 12.3356Z",
                        fill: "url(#paint20_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M32.032 12.3356C31.812 12.3356 31.5908 12.3564 31.3738 12.3992C32.4052 13.8864 32.9213 15.4445 32.9213 16.1178C32.9213 18.5655 30.9249 19.1898 30.0596 19.1898C29.3844 19.1898 28.8685 19.0283 28.4596 18.7701C28.4557 18.7855 28.4521 18.8006 28.4482 18.816C28.3266 19.3017 28.2306 19.8334 28.0645 20.3509C27.7451 21.3456 27.3141 22.482 26.854 23.3614C26.358 24.3094 25.8669 24.864 25.2817 24.8349C24.616 24.8019 24.0763 23.9438 23.4056 21.519C23.1893 20.7372 22.989 19.8799 22.8034 19.0382C22.3429 16.9504 21.7777 14.851 20.8114 12.9958C19.233 9.96575 16.5406 9 14.391 9C12.3976 9 10.9082 9.94379 9.7382 11.133C9.41491 11.4616 9.06167 11.9044 8.70697 12.4247C9.72745 12.6705 10.6924 13.4387 10.8464 14.8944C10.8768 15.172 11.0898 17.3765 11.8053 19.9312C12.0105 19.2907 12.3098 18.3421 13.0052 16.8104C13.346 16.1089 13.6536 15.6463 13.9311 15.3644C14.1856 15.1056 14.4147 14.9988 14.6211 14.9988C14.8437 14.9988 15.6035 15.2025 16.3432 17.7984C17.2606 21.0174 17.9434 26.1403 20.5446 28.8603C21.6919 30.0601 23.2974 30.8364 25.5226 30.8364C27.475 30.8364 29.1028 29.9765 30.2634 28.7804C32.1717 26.8133 33.2173 23.5613 33.5903 22.358C34.6517 18.9343 34.9491 15.8379 34.9836 15.5103C35.1811 13.6383 33.6041 12.3356 32.032 12.3356Z",
                        fill: "url(#paint21_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M32.032 12.3356C31.812 12.3356 31.5908 12.3564 31.3738 12.3992C32.4052 13.8864 32.9213 15.4445 32.9213 16.1178C32.9213 18.5655 30.9249 19.1898 30.0596 19.1898C29.3844 19.1898 28.8685 19.0283 28.4596 18.7701C28.4557 18.7855 28.4521 18.8006 28.4482 18.816C28.3266 19.3017 28.2306 19.8334 28.0645 20.3509C27.7451 21.3456 27.3141 22.482 26.854 23.3614C26.358 24.3094 25.8669 24.864 25.2817 24.8349C24.616 24.8019 24.0763 23.9438 23.4056 21.519C23.1893 20.7372 22.989 19.8799 22.8034 19.0382C22.3429 16.9504 21.7777 14.851 20.8114 12.9958C19.233 9.96575 16.5406 9 14.391 9C12.3976 9 10.9082 9.94379 9.7382 11.133C9.41491 11.4616 9.06167 11.9044 8.70697 12.4247C9.72745 12.6705 10.6924 13.4387 10.8464 14.8944C10.8768 15.172 11.0898 17.3765 11.8053 19.9312C12.0105 19.2907 12.3098 18.3421 13.0052 16.8104C13.346 16.1089 13.6536 15.6463 13.9311 15.3644C14.1856 15.1056 14.4147 14.9988 14.6211 14.9988C14.8437 14.9988 15.6035 15.2025 16.3432 17.7984C17.2606 21.0174 17.9434 26.1403 20.5446 28.8603C21.6919 30.0601 23.2974 30.8364 25.5226 30.8364C27.475 30.8364 29.1028 29.9765 30.2634 28.7804C32.1717 26.8133 33.2173 23.5613 33.5903 22.358C34.6517 18.9343 34.9491 15.8379 34.9836 15.5103C35.1811 13.6383 33.6041 12.3356 32.032 12.3356Z",
                        fill: "url(#paint22_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M32.032 12.3356C31.812 12.3356 31.5908 12.3564 31.3738 12.3992C32.4052 13.8864 32.9213 15.4445 32.9213 16.1178C32.9213 18.5655 30.9249 19.1898 30.0596 19.1898C29.3844 19.1898 28.8685 19.0283 28.4596 18.7701C28.4557 18.7855 28.4521 18.8006 28.4482 18.816C28.3266 19.3017 28.2306 19.8334 28.0645 20.3509C27.7451 21.3456 27.3141 22.482 26.854 23.3614C26.358 24.3094 25.8669 24.864 25.2817 24.8349C24.616 24.8019 24.0763 23.9438 23.4056 21.519C23.1893 20.7372 22.989 19.8799 22.8034 19.0382C22.3429 16.9504 21.7777 14.851 20.8114 12.9958C19.233 9.96575 16.5406 9 14.391 9C12.3976 9 10.9082 9.94379 9.7382 11.133C9.41491 11.4616 9.06167 11.9044 8.70697 12.4247C9.72745 12.6705 10.6924 13.4387 10.8464 14.8944C10.8768 15.172 11.0898 17.3765 11.8053 19.9312C12.0105 19.2907 12.3098 18.3421 13.0052 16.8104C13.346 16.1089 13.6536 15.6463 13.9311 15.3644C14.1856 15.1056 14.4147 14.9988 14.6211 14.9988C14.8437 14.9988 15.6035 15.2025 16.3432 17.7984C17.2606 21.0174 17.9434 26.1403 20.5446 28.8603C21.6919 30.0601 23.2974 30.8364 25.5226 30.8364C27.475 30.8364 29.1028 29.9765 30.2634 28.7804C32.1717 26.8133 33.2173 23.5613 33.5903 22.358C34.6517 18.9343 34.9491 15.8379 34.9836 15.5103C35.1811 13.6383 33.6041 12.3356 32.032 12.3356Z",
                        fill: "url(#paint23_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M32.032 12.3356C31.812 12.3356 31.5908 12.3564 31.3738 12.3992C32.4052 13.8864 32.9213 15.4445 32.9213 16.1178C32.9213 18.5655 30.9249 19.1898 30.0596 19.1898C29.3844 19.1898 28.8685 19.0283 28.4596 18.7701C28.4557 18.7855 28.4521 18.8006 28.4482 18.816C28.3266 19.3017 28.2306 19.8334 28.0645 20.3509C27.7451 21.3456 27.3141 22.482 26.854 23.3614C26.358 24.3094 25.8669 24.864 25.2817 24.8349C24.616 24.8019 24.0763 23.9438 23.4056 21.519C23.1893 20.7372 22.989 19.8799 22.8034 19.0382C22.3429 16.9504 21.7777 14.851 20.8114 12.9958C19.233 9.96575 16.5406 9 14.391 9C12.3976 9 10.9082 9.94379 9.7382 11.133C9.41491 11.4616 9.06167 11.9044 8.70697 12.4247C9.72745 12.6705 10.6924 13.4387 10.8464 14.8944C10.8768 15.172 11.0898 17.3765 11.8053 19.9312C12.0105 19.2907 12.3098 18.3421 13.0052 16.8104C13.346 16.1089 13.6536 15.6463 13.9311 15.3644C14.1856 15.1056 14.4147 14.9988 14.6211 14.9988C14.8437 14.9988 15.6035 15.2025 16.3432 17.7984C17.2606 21.0174 17.9434 26.1403 20.5446 28.8603C21.6919 30.0601 23.2974 30.8364 25.5226 30.8364C27.475 30.8364 29.1028 29.9765 30.2634 28.7804C32.1717 26.8133 33.2173 23.5613 33.5903 22.358C34.6517 18.9343 34.9491 15.8379 34.9836 15.5103C35.1811 13.6383 33.6041 12.3356 32.032 12.3356Z",
                        fill: "url(#paint24_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.89 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint25_linear_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.89 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint26_radial_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.89 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint27_linear_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.89 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint28_linear_4156_8750)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.3084 30.7499C8.75341 30.7499 6.86272 23.7246 6.43908 22.358C5.3752 18.9261 5.05179 15.8347 5.01755 15.5103C4.81999 13.6383 6.32136 12.3356 7.96915 12.3356C9.21677 12.3356 10.6648 13.0825 10.8567 14.8946C10.89 15.1993 11.1436 17.828 12.0409 20.6922C12.9773 23.6813 13.9707 24.831 14.6861 24.831C15.8414 24.831 16.5462 21.8637 17.1694 19.0382C17.6285 16.9566 18.1248 14.859 19.1046 12.9958C20.8091 9.75432 23.3849 9 25.6101 9C30.4894 9 32.9315 14.6532 32.9315 16.118C32.9315 18.5656 30.9351 19.19 30.0698 19.19C28.1773 19.19 27.5358 17.9219 26.9958 16.8104C26.5101 15.8105 26.0028 14.9791 25.347 14.9791C25.1315 14.9791 24.9317 15.0882 24.747 15.276C23.1169 16.9328 22.5703 25.6005 19.3109 28.9134C17.504 30.7499 15.538 30.7499 14.3084 30.7499Z",
                        fill: "url(#paint29_radial_4156_8750)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint0_linear_4156_8750",
                        x1: "29.892",
                        y1: "15.3814",
                        x2: "10.2685",
                        y2: "21.817",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#5CEE64"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00BBFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint1_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.4188 20.5988) rotate(-120.86) scale(12.8555 10.792)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#007383"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.407867",
                                stopColor: "#00717E",
                                stopOpacity: "0.75"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.874482",
                                stopColor: "#007281",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint2_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(24.8652 18.2068) rotate(-126.734) scale(10.4841 6.88862)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#218970"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.459527",
                                stopColor: "#267E6A"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#026C51",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint3_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(15.6785 21.2061) rotate(-107.468) scale(8.53875 4.44845)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#178697"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.407867",
                                stopColor: "#17838F",
                                stopOpacity: "0.79"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.874482",
                                stopColor: "#007281",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint4_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(19.4748 21.1606) rotate(-120.86) scale(21.6839 6.68874)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#25342F",
                                stopOpacity: "0.3"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#25342F",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint5_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(23.3427 18.4446) rotate(85.0979) scale(8.1668 4.6321)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#056D4F"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.232593",
                                stopColor: "#056C4E",
                                stopOpacity: "0.75"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.598902",
                                stopColor: "#056C4E",
                                stopOpacity: "0.300824"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.874482",
                                stopColor: "#056C4F",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint6_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(23.704 5.23664) rotate(57.0774) scale(9.60023 5.03531)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#22B67B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.407867",
                                stopColor: "#24BE82"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#24BE82",
                                stopOpacity: "0.07"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint7_linear_4156_8750",
                        x1: "-2.3813",
                        y1: "19.6852",
                        x2: "11.5254",
                        y2: "19.7995",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#09F8FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint8_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(0.606292 7.15932) rotate(49.6506) scale(12.5384 12.5071)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#09F8FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint9_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(10.6501 0.846567) rotate(48.0118) scale(25.4304 25.3903)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00B8FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.745423",
                                stopColor: "#00B9FC",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint10_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(11.9964 19.9205) rotate(-107.468) scale(12.2578 8.49327)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00BCFF",
                                stopOpacity: "0.76"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.57273",
                                stopColor: "#00BAFC",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint11_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(30.6315 15.265) rotate(-129.551) scale(8.66795 6.06842)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#5FEC50"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#3CC08E",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint12_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(29.3908 20.8479) rotate(-79.0944) scale(2.6242 1.81501)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#28855B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#14795C",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint13_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(29.2643 20.6548) rotate(-77.8798) scale(2.16335 3.02336)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#28855B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#14795C",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint14_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(31.8415 16.7574) rotate(-132.79) scale(7.17635 5.04146)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#5FF05B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.813285",
                                stopColor: "#5DE955",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint15_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(29.5973 18.8187) rotate(37.4559) scale(6.38215 8.87106)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.966119",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint16_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(28.0096 19.5381) rotate(8.48611) scale(7.53034 11.2401)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.592487",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint17_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(28.6206 20.4722) rotate(24.6631) scale(6.43252 11.4621)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.756788",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint18_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(27.8652 20.8533) rotate(95.8028) scale(11.5636 6.33698)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.592487",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint19_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(29.5973 15.748) rotate(93.6671) scale(13.9165 4.96645)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.884611",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint20_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(13.8261 18.6416) rotate(84.8296) scale(7.38468 3.91233)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.884611",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint21_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(13.8208 18.8402) rotate(87.2504) scale(7.70707 6.36288)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.884611",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint22_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(15.5743 26.0821) rotate(-23.1725) scale(8.59478 16.7998)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.708977",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint23_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(12.5162 16.9558) rotate(-159.526) scale(5.69417 9.74994)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#1A3DA0"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.708977",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint24_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.5039 18.8939) rotate(16.749) scale(10.8603 10.9635)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#1E3882"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.761404",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint25_linear_4156_8750",
                        x1: "4.09683",
                        y1: "12.8869",
                        x2: "14.7987",
                        y2: "19.7173",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.229329",
                                stopColor: "#1DC4FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1CC1FF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint26_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(0.60565 7.15881) rotate(49.6506) scale(12.5384 12.5071)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#09F8FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint27_linear_4156_8750",
                        x1: "4.68838",
                        y1: "13.2358",
                        x2: "7.69022",
                        y2: "15.9571",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#26FBFF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.637346",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint28_linear_4156_8750",
                        x1: "3.89084",
                        y1: "15.3187",
                        x2: "8.04291",
                        y2: "15.6149",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#26FBFF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.637346",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint29_radial_4156_8750",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(11.996 19.9206) rotate(-107.468) scale(12.2578 8.49327)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00BCFF",
                                stopOpacity: "0.76"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.57273",
                                stopColor: "#00BAFC",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("lOZuj", function(module, exports) {

$parcel$export(module.exports, "zendeskConfig", () => $dbe307790c376c63$export$74a2db0a5eb2da3f);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $9wl6S = parcelRequire("9wl6S");

var $jOMKt = parcelRequire("jOMKt");
const $dbe307790c376c63$export$74a2db0a5eb2da3f = {
    displayName: 'Zendesk',
    id: 'zendesk',
    icon: (0, $9yyKc.get3PLogo)((0, $9wl6S.ZendeskIcon), 'Zendesk', 'medium'),
    resourceType: 'zendesk-connector',
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $jOMKt.ZendeskSearchResultIcon), 'Zendesk', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zendesk',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $2Znam.TypeFilterValueKey).Document,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("9wl6S", function(module, exports) {

$parcel$export(module.exports, "ZendeskIcon", () => $9743e3ee64230db8$export$9969d63eaadfddf7);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $9743e3ee64230db8$export$9969d63eaadfddf7 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-219.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#03363D"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.6092 9.34881V17.3365H4.99316L11.6092 9.34881ZM11.6092 6.48242C11.6092 7.35976 11.2607 8.20117 10.6403 8.82155C10.0199 9.44192 9.17853 9.79044 8.30119 9.79044C7.42384 9.79044 6.58244 9.44192 5.96206 8.82155C5.34169 8.20117 4.99316 7.35976 4.99316 6.48242H11.6092ZM12.6991 17.3372C12.6991 16.4598 13.0477 15.6184 13.668 14.9981C14.2884 14.3777 15.1298 14.0292 16.0072 14.0292C16.8845 14.0292 17.7259 14.3777 18.3463 14.9981C18.9667 15.6184 19.3152 16.4598 19.3152 17.3372H12.6991ZM12.6991 14.4708V6.48242H19.3166L12.6991 14.4701V14.4708Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M11.4666 9.80166V17.609H5L11.4666 9.80166ZM11.4666 7C11.4666 7.85753 11.126 8.67994 10.5196 9.2863C9.91326 9.89267 9.09085 10.2333 8.23332 10.2333C7.37579 10.2333 6.55338 9.89267 5.94702 9.2863C5.34065 8.67994 5 7.85753 5 7H11.4666ZM12.532 17.6096C12.532 16.7521 12.8726 15.9297 13.479 15.3233C14.0854 14.717 14.9078 14.3763 15.7653 14.3763C16.6228 14.3763 17.4452 14.717 18.0516 15.3233C18.658 15.9297 18.9986 16.7521 18.9986 17.6096H12.532ZM12.532 14.808V7H19L12.532 14.8073V14.808Z",
            fill: "#03363D"
        })
    });
};

});

parcelRegister("jOMKt", function(module, exports) {

$parcel$export(module.exports, "ZendeskSearchResultIcon", () => $c00cbe8baf3d28b2$export$439dd6b525db0f9a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $c00cbe8baf3d28b2$export$439dd6b525db0f9a = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-19.5",
                y: "-214.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#03363D"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.4789 12.465V23.1153H6.65747L15.4789 12.465ZM15.4789 8.64319C15.4789 9.81298 15.0142 10.9349 14.187 11.762C13.3598 12.5892 12.238 13.0539 11.0682 13.0539C9.89838 13.0539 8.7765 12.5892 7.94933 11.762C7.12217 10.9349 6.65747 9.81298 6.65747 8.64319H15.4789ZM16.9321 23.1162C16.9321 21.9464 17.3968 20.8245 18.224 19.9974C19.0511 19.1702 20.173 18.7055 21.3428 18.7055C22.5126 18.7055 23.6345 19.1702 24.4616 19.9974C25.2888 20.8245 25.7535 21.9464 25.7535 23.1162H16.9321ZM16.9321 19.2943V8.64319H25.7554L16.9321 19.2934V19.2943Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M18.8571 14.7536V31.4835H5L18.8571 14.7536ZM18.8571 8.75C18.8571 10.5876 18.1271 12.3499 16.8278 13.6492C15.5284 14.9486 13.7661 15.6785 11.9286 15.6785C10.091 15.6785 8.32868 14.9486 7.02933 13.6492C5.72997 12.3499 5 10.5876 5 8.75H18.8571ZM21.1399 31.485C21.1399 29.6474 21.8699 27.8851 23.1693 26.5857C24.4686 25.2864 26.2309 24.5564 28.0685 24.5564C29.9061 24.5564 31.6684 25.2864 32.9677 26.5857C34.2671 27.8851 34.997 29.6474 34.997 31.485H21.1399ZM21.1399 25.4814V8.75H35L21.1399 25.4799V25.4814Z",
            fill: "#03363D"
        })
    });
};

});


parcelRegister("lHXnq", function(module, exports) {

$parcel$export(module.exports, "zeplinConfig", () => $ceae4f087f7be6ed$export$d198c255b2b88327);

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $9yyKc = parcelRequire("9yyKc");

var $3duvf = parcelRequire("3duvf");

var $1DlFA = parcelRequire("1DlFA");
const $ceae4f087f7be6ed$export$d198c255b2b88327 = {
    displayName: 'Zeplin',
    id: 'zeplin',
    resourceType: 'smartlinks-connector-zeplin',
    icon: (0, $9yyKc.get3PLogo)((0, $3duvf.ZeplinIcon), 'Zeplin', 'medium'),
    searchResultIcon: (0, $9yyKc.get3PLogo)((0, $1DlFA.ZeplinSearchResultIcon), 'Zeplin', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zeplin',
    typeFilterConfig: new Map([
        [
            (0, $2Znam.TypeFilterValueKey).Design,
            {
                entities3P: (0, $idpYy.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $2Znam.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};

});
parcelRegister("3duvf", function(module, exports) {

$parcel$export(module.exports, "ZeplinIcon", () => $98b84a63f383b652$export$81c909fcf490b72b);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $98b84a63f383b652$export$81c909fcf490b72b = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77432 14.5822L4.83263 14.9145L4.78223 17.6201L8.0417 16.4703C6.92361 16.1075 6.10732 15.4691 5.77432 14.5822Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.26698 11.7203L3 12.873L4.83299 14.9145L5.77438 14.5821C5.44228 13.6977 5.64688 12.6983 6.26698 11.7203Z",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.7655 7.81617C7.60483 9.28414 4.92255 12.3134 5.77454 14.5823L20.8407 9.26618C19.9887 6.99727 15.9259 6.34819 11.7655 7.81617Z",
                fill: "#FECF33"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.8498 16.0323C19.0101 14.564 21.6972 11.5483 20.8407 9.26611L5.77393 14.5822C6.63072 16.8645 10.6891 17.5002 14.8498 16.0323Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.8407 9.26611L5.77393 14.5822C6.06882 15.3681 7.19412 15.7552 8.7724 15.7552C10.3114 15.7552 12.2815 15.3875 14.3353 14.6628C18.4956 13.1948 21.4227 10.8178 20.8401 9.26611",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.8418 8.09302C16.3028 8.09302 14.3327 8.46074 12.2789 9.18545C8.11857 10.6534 5.19149 13.0301 5.77408 14.5821L20.8403 9.26601C20.5454 8.48015 19.4204 8.09302 17.8418 8.09302Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.0099 17.7638C16.5665 17.7638 15.9128 17.377 15.0659 16.6143C14.0648 15.712 12.9176 14.3903 11.8359 12.8925C10.7544 11.3953 9.86547 9.89801 9.33327 8.67692C8.75368 7.34629 8.67088 6.52827 9.08757 6.24516C9.17907 6.18315 9.28917 6.15186 9.41517 6.15186C9.75417 6.15186 10.4148 6.39555 11.6361 7.55724L11.6631 7.58245L11.6592 7.61867C11.6508 7.70213 11.6433 7.78645 11.6364 7.86904L11.6229 8.03305L11.5029 7.91656C10.1868 6.63577 9.60747 6.49755 9.41937 6.49755C9.36567 6.49755 9.32307 6.50798 9.29247 6.52885C9.11157 6.65142 9.09987 7.2524 9.66207 8.54217C10.185 9.74153 11.0607 11.2159 12.1281 12.694C13.196 14.1724 14.3255 15.4746 15.3092 16.3608C16.3697 17.3164 16.8476 17.4196 17.0042 17.4196C17.0582 17.4196 17.1017 17.4086 17.1344 17.3863C17.3249 17.257 17.3252 16.6132 16.6982 15.2246L16.6694 15.1611L16.7324 15.1278C16.7954 15.0945 16.8566 15.0617 16.9136 15.0304L16.9892 14.989L17.024 15.0658C17.4683 16.0496 17.8838 17.2999 17.339 17.6699C17.2472 17.7323 17.1365 17.7638 17.0099 17.7638Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.9505 15.9908L14.9445 16.0662C14.8392 17.3235 14.562 18.8346 13.8399 18.8961C13.8255 18.8972 13.8105 18.8978 13.7955 18.8978C13.3048 18.8978 12.8407 18.2189 12.4162 16.8801C12.0142 15.6133 11.7022 13.9129 11.5381 12.0911C11.3737 10.2702 11.3761 8.54257 11.545 7.2273C11.7289 5.7938 12.0793 5.04533 12.5863 5.00215C12.6013 5.00099 12.6169 5.00012 12.6322 5.00012C12.988 5.00012 13.5244 5.38957 14.0733 7.20238L13.7148 7.26903C13.5316 6.66341 13.3318 6.1708 13.1335 5.83176C12.9499 5.51881 12.7717 5.3464 12.6313 5.3464C12.6265 5.3464 12.622 5.3464 12.6172 5.34698C12.3976 5.36552 12.0775 5.88045 11.8993 7.2699C11.7334 8.56169 11.7313 10.2632 11.8933 12.061C12.0559 13.859 12.3625 15.5344 12.7573 16.7784C12.934 17.3354 13.1278 17.7947 13.318 18.1062C13.4932 18.3936 13.6627 18.5518 13.7952 18.5518C13.7997 18.5518 13.8042 18.5518 13.809 18.5512C14.019 18.5336 14.4153 17.9978 14.5821 16.1128L14.9505 15.9908Z",
                fill: "#EE6723"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77432 14.5822L4.83263 14.9145L4.78223 17.6201L8.0417 16.4703C6.92361 16.1075 6.10732 15.4691 5.77432 14.5822Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.26698 11.7203L3 12.873L4.83299 14.9145L5.77438 14.5821C5.44228 13.6977 5.64688 12.6983 6.26698 11.7203Z",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.7655 7.81617C7.60483 9.28414 4.92255 12.3134 5.77454 14.5823L20.8407 9.26618C19.9887 6.99727 15.9259 6.34819 11.7655 7.81617Z",
                fill: "#FECF33"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.8498 16.0323C19.0101 14.564 21.6972 11.5483 20.8407 9.26611L5.77393 14.5822C6.63072 16.8645 10.6891 17.5002 14.8498 16.0323Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.8407 9.26611L5.77393 14.5822C6.06882 15.3681 7.19412 15.7552 8.7724 15.7552C10.3114 15.7552 12.2815 15.3875 14.3353 14.6628C18.4956 13.1948 21.4227 10.8178 20.8401 9.26611",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.8418 8.09302C16.3028 8.09302 14.3327 8.46074 12.2789 9.18545C8.11857 10.6534 5.19149 13.0301 5.77408 14.5821L20.8403 9.26601C20.5454 8.48015 19.4204 8.09302 17.8418 8.09302Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.0099 17.7638C16.5665 17.7638 15.9128 17.377 15.0659 16.6143C14.0648 15.712 12.9176 14.3903 11.8359 12.8925C10.7544 11.3953 9.86547 9.89801 9.33327 8.67692C8.75368 7.34629 8.67088 6.52827 9.08757 6.24516C9.17907 6.18315 9.28917 6.15186 9.41517 6.15186C9.75417 6.15186 10.4148 6.39555 11.6361 7.55724L11.6631 7.58245L11.6592 7.61867C11.6508 7.70213 11.6433 7.78645 11.6364 7.86904L11.6229 8.03305L11.5029 7.91656C10.1868 6.63577 9.60747 6.49755 9.41937 6.49755C9.36567 6.49755 9.32307 6.50798 9.29247 6.52885C9.11157 6.65142 9.09987 7.2524 9.66207 8.54217C10.185 9.74153 11.0607 11.2159 12.1281 12.694C13.196 14.1724 14.3255 15.4746 15.3092 16.3608C16.3697 17.3164 16.8476 17.4196 17.0042 17.4196C17.0582 17.4196 17.1017 17.4086 17.1344 17.3863C17.3249 17.257 17.3252 16.6132 16.6982 15.2246L16.6694 15.1611L16.7324 15.1278C16.7954 15.0945 16.8566 15.0617 16.9136 15.0304L16.9892 14.989L17.024 15.0658C17.4683 16.0496 17.8838 17.2999 17.339 17.6699C17.2472 17.7323 17.1365 17.7638 17.0099 17.7638Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.9505 15.9908L14.9445 16.0662C14.8392 17.3235 14.562 18.8346 13.8399 18.8961C13.8255 18.8972 13.8105 18.8978 13.7955 18.8978C13.3048 18.8978 12.8407 18.2189 12.4162 16.8801C12.0142 15.6133 11.7022 13.9129 11.5381 12.0911C11.3737 10.2702 11.3761 8.54257 11.545 7.2273C11.7289 5.7938 12.0793 5.04533 12.5863 5.00215C12.6013 5.00099 12.6169 5.00012 12.6322 5.00012C12.988 5.00012 13.5244 5.38957 14.0733 7.20238L13.7148 7.26903C13.5316 6.66341 13.3318 6.1708 13.1335 5.83176C12.9499 5.51881 12.7717 5.3464 12.6313 5.3464C12.6265 5.3464 12.622 5.3464 12.6172 5.34698C12.3976 5.36552 12.0775 5.88045 11.8993 7.2699C11.7334 8.56169 11.7313 10.2632 11.8933 12.061C12.0559 13.859 12.3625 15.5344 12.7573 16.7784C12.934 17.3354 13.1278 17.7947 13.318 18.1062C13.4932 18.3936 13.6627 18.5518 13.7952 18.5518C13.7997 18.5518 13.8042 18.5518 13.809 18.5512C14.019 18.5336 14.4153 17.9978 14.5821 16.1128L14.9505 15.9908Z",
                fill: "#EE6723"
            })
        ]
    });
};

});

parcelRegister("1DlFA", function(module, exports) {

$parcel$export(module.exports, "ZeplinSearchResultIcon", () => $f4f5211a6674d99c$export$e3736b5ffc9fcc9e);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $f4f5211a6674d99c$export$e3736b5ffc9fcc9e = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-19.5",
                y: "-550.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0.513685 8C0.513685 3.86542 3.86542 0.513685 8 0.513685H24C28.1346 0.513685 31.4863 3.86542 31.4863 8V24C31.4863 28.1346 28.1346 31.4863 24 31.4863H8C3.86542 31.4863 0.513685 28.1346 0.513685 24V8Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "1.02737"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.69901 19.4429L6.44342 19.886L6.37622 23.4935L10.7222 21.9604C9.2314 21.4767 8.14301 20.6255 7.69901 19.4429Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.35597 15.6271L4 17.164L6.44398 19.8859L7.69917 19.4428C7.25638 18.2636 7.52918 16.931 8.35597 15.6271Z",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.6872 10.4215C10.1396 12.3788 6.56324 16.4178 7.69923 19.443L27.7875 12.3549C26.6515 9.32966 21.2343 8.46421 15.6872 10.4215Z",
                fill: "#FECF33"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.7998 21.3764C25.347 19.4187 28.9298 15.3978 27.7878 12.3549L7.69873 19.443C8.84112 22.486 14.2523 23.3337 19.7998 21.3764Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.7878 12.3549L7.69873 19.443C8.09193 20.4908 9.59232 21.007 11.6967 21.007C13.7487 21.007 16.3755 20.5167 19.1138 19.5504C24.661 17.5931 28.5638 14.4238 27.787 12.3549",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.7894 10.7908C21.7374 10.7908 19.1106 11.2811 16.3722 12.2474C10.8251 14.2047 6.92231 17.3736 7.6991 19.4429L27.7874 12.3548C27.3942 11.3069 25.8942 10.7908 23.7894 10.7908Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.6798 23.685C22.0886 23.685 21.217 23.1692 20.0878 22.1523C18.753 20.9492 17.2234 19.187 15.7811 17.1899C14.3391 15.1936 13.1539 13.1973 12.4443 11.5691C11.6715 9.79497 11.5611 8.70428 12.1167 8.3268C12.2387 8.24412 12.3855 8.20239 12.5535 8.20239C13.0055 8.20239 13.8863 8.52732 15.5147 10.0762L15.5507 10.1099L15.5455 10.1582C15.5343 10.2694 15.5243 10.3819 15.5151 10.492L15.4971 10.7106L15.3371 10.5553C13.5823 8.84762 12.8099 8.66332 12.5591 8.66332C12.4875 8.66332 12.4307 8.67723 12.3899 8.70505C12.1487 8.86848 12.1331 9.66979 12.8827 11.3895C13.5799 12.9886 14.7475 14.9544 16.1707 16.9253C17.5946 18.8965 19.1006 20.6328 20.4122 21.8143C21.8262 23.0885 22.4634 23.226 22.6722 23.226C22.7442 23.226 22.8022 23.2114 22.8458 23.1816C23.0998 23.0093 23.1002 22.1508 22.2642 20.2994L22.2258 20.2147L22.3098 20.1703C22.3938 20.1259 22.4754 20.0822 22.5514 20.0405L22.6522 19.9852L22.6986 20.0876C23.291 21.3993 23.845 23.0665 23.1186 23.5599C22.9962 23.6429 22.8486 23.685 22.6798 23.685Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.9342 21.3212L19.9262 21.4216C19.7858 23.098 19.4162 25.1129 18.4534 25.1948C18.4342 25.1964 18.4142 25.1971 18.3942 25.1971C17.7398 25.1971 17.121 24.2919 16.555 22.5069C16.019 20.8177 15.603 18.5506 15.3842 16.1215C15.1651 13.6936 15.1683 11.3901 15.3934 9.63644C15.6386 7.72511 16.1058 6.72714 16.7818 6.66957C16.8018 6.66803 16.8226 6.66687 16.843 6.66687C17.3174 6.66687 18.0326 7.18614 18.7646 9.60321L18.2866 9.69208C18.0422 8.88458 17.7758 8.22777 17.5114 7.77573C17.2666 7.35846 17.029 7.12857 16.8418 7.12857C16.8354 7.12857 16.8294 7.12857 16.823 7.12934C16.5302 7.15407 16.1034 7.84063 15.8658 9.69324C15.6446 11.4156 15.6418 13.6843 15.8578 16.0813C16.0746 18.4787 16.4834 20.7126 17.0098 22.3713C17.2454 23.1139 17.5038 23.7263 17.7574 24.1416C17.991 24.5249 18.217 24.7358 18.3938 24.7358C18.3998 24.7358 18.4058 24.7358 18.4122 24.735C18.6922 24.7115 19.2206 23.9971 19.443 21.4838L19.9342 21.3212Z",
                fill: "#EE6723"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.62389 23.9703L8.0544 24.5242L7.9704 29.0335L13.4029 27.1172C11.5394 26.5125 10.1789 25.4486 9.62389 23.9703Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.445 19.2006L5 21.1217L8.05498 24.5241L9.62397 23.9702C9.07047 22.4962 9.41147 20.8305 10.445 19.2006Z",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.6089 12.6933C12.6745 15.1399 8.20398 20.1887 9.62397 23.9702L34.7343 15.11C33.3143 11.3285 26.5429 10.2467 19.6089 12.6933Z",
                fill: "#FECF33"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.7499 26.387C31.6838 23.9398 36.1623 18.9138 34.7348 15.11L9.62347 23.9703C11.0515 27.774 17.8154 28.8336 24.7499 26.387Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M34.7348 15.11L9.62347 23.9703C10.115 25.28 11.9905 25.9253 14.6209 25.9253C17.1859 25.9253 20.4694 25.3124 23.8924 24.1045C30.8263 21.6579 35.7048 17.6962 34.7338 15.11",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M29.7368 13.155C27.1718 13.155 23.8883 13.7679 20.4654 14.9758C13.5314 17.4224 8.65295 21.3836 9.62394 23.9702L34.7343 15.11C34.2428 13.8003 32.3678 13.155 29.7368 13.155Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28.3499 29.2725C27.6109 29.2725 26.5214 28.6278 25.1099 27.3567C23.4414 25.8528 21.5294 23.65 19.7264 21.1537C17.924 18.6583 16.4425 16.1628 15.5555 14.1277C14.5895 11.91 14.4515 10.5466 15.146 10.0748C15.2985 9.97141 15.482 9.91925 15.692 9.91925C16.257 9.91925 17.358 10.3254 19.3934 12.2616L19.4384 12.3036L19.4319 12.3639C19.4179 12.503 19.4054 12.6436 19.3939 12.7812L19.3714 13.0546L19.1714 12.8604C16.978 10.7258 16.0125 10.4954 15.699 10.4954C15.6095 10.4954 15.5385 10.5128 15.4875 10.5476C15.186 10.7519 15.1665 11.7535 16.1035 13.9031C16.975 15.902 18.4345 18.3593 20.2134 20.8228C21.9934 23.2869 23.8759 25.4572 25.5154 26.9341C27.2829 28.5269 28.0794 28.6988 28.3404 28.6988C28.4304 28.6988 28.5029 28.6805 28.5574 28.6433C28.8749 28.4279 28.8754 27.3548 27.8304 25.0404L27.7824 24.9347L27.8874 24.8791C27.9924 24.8236 28.0944 24.769 28.1894 24.7169L28.3154 24.6478L28.3734 24.7758C29.1139 26.4154 29.8064 28.4993 28.8984 29.1161C28.7454 29.2199 28.5609 29.2725 28.3499 29.2725Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.9179 26.3179L24.9079 26.4434C24.7324 28.5389 24.2704 31.0575 23.0669 31.1599C23.0429 31.1619 23.0179 31.1628 22.9929 31.1628C22.1749 31.1628 21.4014 30.0313 20.6939 27.8C20.0239 25.6886 19.5039 22.8546 19.2304 19.8183C18.9564 16.7834 18.9604 13.9041 19.2419 11.712C19.5484 9.3228 20.1324 8.07534 20.9774 8.00338C21.0024 8.00145 21.0284 8 21.0539 8C21.6469 8 22.5409 8.64909 23.4559 11.6704L22.8584 11.7815C22.5529 10.7721 22.2199 9.95112 21.8894 9.38607C21.5834 8.86448 21.2864 8.57713 21.0524 8.57713C21.0444 8.57713 21.0369 8.57713 21.0289 8.57809C20.6629 8.609 20.1294 9.46721 19.8324 11.783C19.5559 13.936 19.5524 16.7718 19.8224 19.7681C20.0934 22.7648 20.6044 25.5572 21.2624 27.6305C21.5569 28.5587 21.8799 29.3242 22.1969 29.8434C22.4889 30.3225 22.7714 30.5862 22.9924 30.5862C22.9999 30.5862 23.0074 30.5862 23.0154 30.5852C23.3654 30.5557 24.0259 29.6628 24.3039 26.5212L24.9179 26.3179Z",
                fill: "#EE6723"
            })
        ]
    });
};

});



parcelRegister("9d1WC", function(module, exports) {

$parcel$export(module.exports, "AtlasSearchResultIcon", () => $a167bd50b2e4c9cb$export$b0a52366c3fb9b);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $a167bd50b2e4c9cb$export$b0a52366c3fb9b = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_2230_18710)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                    clipPath: "url(#clip1_2230_18710)",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                        clipPath: "url(#clip2_2230_18710)",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M34.4312 30.4727L21.2001 4.01056C20.9397 3.43756 20.6792 3.33337 20.3667 3.33337C20.1062 3.33337 19.7937 3.43756 19.4811 3.95846C17.6058 6.92764 16.7724 10.3656 16.7724 13.9599C16.7724 18.9606 19.3248 23.6488 23.0754 31.202C23.4921 32.0354 23.8047 32.1917 24.5339 32.1917H33.7019C34.3791 32.1917 34.7437 31.9313 34.7437 31.4103C34.7437 31.1499 34.6916 30.9936 34.4312 30.4727ZM15.2097 17.9709C14.1679 16.4082 13.8553 16.304 13.5949 16.304C13.3344 16.304 13.1781 16.4082 12.7093 17.3458L6.09377 30.5769C5.8854 30.9936 5.83331 31.1499 5.83331 31.3583C5.83331 31.775 6.19795 32.1917 6.97931 32.1917H16.3036C16.9287 32.1917 17.3975 31.6708 17.6579 30.6811C17.9705 29.4309 18.0747 28.337 18.0747 27.0347C18.0747 23.3884 16.4598 19.8462 15.2097 17.9709Z",
                            fill: "#1868DB"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_2230_18710",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "40",
                            height: "40",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip1_2230_18710",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "40",
                            height: "40",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip2_2230_18710",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "28.9104",
                            height: "28.8583",
                            fill: "white",
                            transform: "translate(5.83331 3.33337)"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("aeVf1", function(module, exports) {

$parcel$export(module.exports, "BitbucketSearchResultIcon", () => $fefb7306a9b2abdf$export$55fe4cb1c7fb17e1);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $fefb7306a9b2abdf$export$55fe4cb1c7fb17e1 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_2230_18696)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M31.9828 19.5142L29.96 31.8711C29.8281 32.6187 29.3004 33.0584 28.5528 33.0584H11.4026C10.655 33.0584 10.1273 32.6187 9.99541 31.8711L6.43345 9.83969C6.30152 9.09212 6.6973 8.6084 7.40089 8.6084H32.5545C33.2581 8.6084 33.6539 9.09212 33.5219 9.83969L32.5545 15.6444C32.4226 16.4799 31.9388 16.8317 31.1473 16.8317H16.02C15.8001 16.8317 15.6682 16.9636 15.7121 17.2275L16.8995 24.5273C16.9434 24.7032 17.0754 24.8351 17.2513 24.8351H22.7041C22.88 24.8351 23.012 24.7032 23.0559 24.5273L23.8915 19.2503C23.9794 18.5907 24.4191 18.3268 25.0348 18.3268H30.9714C31.8509 18.3268 32.1147 18.7666 31.9828 19.5142Z",
                    fill: "#1868DB"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_2230_18696",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "40",
                        height: "40",
                        fill: "white"
                    })
                })
            })
        ]
    });

});

parcelRegister("6ot6U", function(module, exports) {

$parcel$export(module.exports, "CompassSearchResultIcon", () => $e108be1bca7d778f$export$4b1b9db11d699ccb);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $e108be1bca7d778f$export$4b1b9db11d699ccb = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_2230_18698)",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                    clipPath: "url(#clip1_2230_18698)",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M19.5833 19.3159V26.7434H12.1417V19.3159H19.5833V11.8934H6.00833C5.28333 11.8984 4.7 12.4801 4.705 13.1934C4.705 13.1993 4.705 13.2051 4.705 13.2109V32.8876C4.69 33.6009 5.26583 34.1901 5.99 34.2051C5.99583 34.2051 6.0025 34.2051 6.00833 34.2051H25.7033C26.4283 34.2001 27.0117 33.6184 27.0067 32.9051C27.0067 32.8993 27.0067 32.8934 27.0067 32.8876V19.3159H19.5833Z",
                            fill: "#1868DB"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M19.5833 4.46666V11.8933H27.0425V19.3158H34.4616V5.76666C34.4766 5.05332 33.9008 4.46416 33.1766 4.44916C33.1708 4.44916 33.1641 4.44916 33.1583 4.44916L19.5833 4.46666Z",
                            fill: "#1868DB"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_2230_18698",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "40",
                            height: "40",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip1_2230_18698",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "40",
                            height: "40",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("1ytgY", function(module, exports) {

$parcel$export(module.exports, "FocusSearchResultIcon", () => $506871dc04f0c8db$export$4d0238652f4b6bc4);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $506871dc04f0c8db$export$4d0238652f4b6bc4 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_2230_18694)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                    clipPath: "url(#clip1_2230_18694)",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M37.8564 20.4181C34.509 17.0708 29.0684 17.1063 25.7566 20.4181L22.9696 23.2051C21.4309 24.7439 18.9314 24.7439 17.3927 23.2051L15.0771 20.8895L9.02573 26.9409L11.3413 29.2565C16.2215 34.1367 24.1378 34.1367 29.018 29.2565L37.8564 20.4181ZM2.5 19.5848C5.84737 22.9322 11.2198 22.9648 14.5671 19.6174L17.3897 16.7948C18.9285 15.256 21.4279 15.256 22.9667 16.7948L25.2823 19.1104L31.3336 13.0591L29.018 10.7435C24.1378 5.86326 16.2215 5.86326 11.3413 10.7435L2.50296 19.5818L2.5 19.5848Z",
                        fill: "#1868DB"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_2230_18694",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "40",
                            height: "40",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip1_2230_18694",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "40",
                            height: "40",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("46Lo3", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoverySearchResultIcon", () => $b412ffda38aeedd7$export$1afe31d4b2891d7a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $b412ffda38aeedd7$export$1afe31d4b2891d7a = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_2230_18700)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                    clipPath: "url(#clip1_2230_18700)",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                        clipPath: "url(#clip2_2230_18700)",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M22.0686 7.09728C25.7026 8.16332 29.3723 8.16332 33.0063 7.09728C33.3269 7.02621 33.5407 7.23942 33.4694 7.55923C32.4362 11.2904 32.4362 14.7372 33.4694 18.4683C33.5407 18.7526 33.3269 19.0014 33.0063 18.8948C29.3723 17.8998 25.7026 17.8998 22.0686 18.8948C21.7836 19.0014 21.5342 18.7526 21.6411 18.4683C22.603 14.7372 22.603 11.2904 21.6411 7.55923C21.5342 7.23942 21.7836 7.02621 22.0686 7.09728ZM23.5294 20.3161V20.9202C23.5294 23.7275 21.5698 25.7885 19.1472 25.7885C16.7245 25.7885 14.8006 23.8341 14.8006 21.4177C14.8006 19.0014 16.7601 17.0825 19.5034 17.0825H20.216V8.58973C19.8597 8.5542 19.5034 8.5542 19.1472 8.5542C12.0217 8.5542 6.25 14.3108 6.25 21.4532C6.25 28.5957 12.0217 34.3168 19.1472 34.3168C26.2727 34.3168 32.08 28.5602 32.08 21.4532V20.3161H23.5294Z",
                            fill: "#1868DB"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_2230_18700",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "40",
                            height: "40",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip1_2230_18700",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "40",
                            height: "40",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip2_2230_18700",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "27.2333",
                            height: "27.2333",
                            fill: "white",
                            transform: "translate(6.25 7.08334)"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("bj3ok", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementSearchResultIcon", () => $dfcfcba5660e06b1$export$ceeb1de9ca56c2f7);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $dfcfcba5660e06b1$export$ceeb1de9ca56c2f7 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_2230_18708)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                    clipPath: "url(#clip1_2230_18708)",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                        clipPath: "url(#clip2_2230_18708)",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M23.4886 16.3121H32.6441C34.0191 16.3121 34.4886 17.62 33.6502 18.6596L19.3301 36.3334C14.702 32.6444 15.138 26.809 18.5252 22.5499L23.4886 16.3121ZM16.4124 23.3547H7.2569C5.8819 23.3547 5.41238 22.0468 6.2508 21.0072L20.5709 3.3334C25.199 7.02243 24.6959 12.7907 21.3423 17.0834L16.4124 23.3547Z",
                            fill: "#0C66E4"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_2230_18708",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "40",
                            height: "40",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip1_2230_18708",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "40",
                            height: "40",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip2_2230_18708",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "28.2341",
                            height: "33",
                            fill: "white",
                            transform: "translate(5.83331 3.33334)"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("itStc", function(module, exports) {

$parcel$export(module.exports, "TrelloSearchResultIcon", () => $c190735ed0251a79$export$7221b4e3b691d1b3);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $c190735ed0251a79$export$7221b4e3b691d1b3 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_2230_18718)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                    clipPath: "url(#clip1_2230_18718)",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M30.3575 6.41167H9.64252C7.85835 6.41167 6.41168 7.85833 6.41168 9.6425V30.3575C6.41168 32.1417 7.85835 33.5883 9.64252 33.5883H30.3575C32.1417 33.5883 33.5884 32.1417 33.5884 30.3575V9.6425C33.5884 7.85833 32.1417 6.41167 30.3575 6.41167ZM18.1184 25.9858C18.1184 26.5792 17.6375 27.0592 17.045 27.0592H12.5025C11.9092 27.0592 11.4292 26.5783 11.4292 25.9858V12.5025C11.4292 11.9092 11.91 11.4292 12.5025 11.4292H17.045C17.6383 11.4292 18.1184 11.91 18.1184 12.5025V25.9858ZM28.5709 19.7958C28.5709 20.3892 28.09 20.8692 27.4975 20.8692H22.955C22.3617 20.8692 21.8817 20.3883 21.8817 19.7958V12.5025C21.8817 11.9092 22.3625 11.4292 22.955 11.4292H27.4975C28.0909 11.4292 28.5709 11.91 28.5709 12.5025V19.7958Z",
                        fill: "#1868DB"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_2230_18718",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "40",
                            height: "40",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip1_2230_18718",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "40",
                            height: "40",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });

});


parcelRegister("jjjIy", function(module, exports) {

$parcel$export(module.exports, "filterSearchResultsWithHighlighting", () => $f4ae55a82e2fef50$export$399f177751711473);
$parcel$export(module.exports, "filterSearchResults", () => $f4ae55a82e2fef50$export$18f3758fc3685a84);
// Modified from platform/packages/search/product-search-dialog/src/extensible/product-router/product/result-provider/faster-search-helpers.ts

var $bloXB = parcelRequire("bloXB");
function $f4ae55a82e2fef50$export$399f177751711473(searchResults, query, numberOfResultItems = 3, negateTitleHighlight) {
    const wordsInQuery = query.split(' ');
    const itemScoreMap = {};
    const filteredResults = searchResults.flatMap((result)=>{
        // 1st pass
        const doAllWordsMatch = wordsInQuery.reduce((acc, word)=>{
            if (!acc) return acc;
            return result.title.toLowerCase().includes(word.toLowerCase());
        }, true);
        if (doAllWordsMatch) {
            // 2nd and 3rd Pass
            const { highlightedTitle: highlightedTitle, negatedHighlightedTitle: negatedHighlightedTitle, score: score = 0 } = (0, $bloXB.highlightMatchedText)(result.title, wordsInQuery);
            itemScoreMap[result.title] = score;
            return [
                {
                    ...result,
                    highlightedTitle: negateTitleHighlight ? negatedHighlightedTitle : highlightedTitle
                }
            ];
        }
        return [];
    }).sort((item, secondItem)=>item && secondItem ? itemScoreMap[secondItem.title] - itemScoreMap[item.title] : 0).slice(0, numberOfResultItems);
    return filteredResults;
}
function $f4ae55a82e2fef50$export$18f3758fc3685a84(searchResults, query) {
    const wordsInQuery = query.split(' ');
    const itemScoreMap = {};
    const filteredResults = searchResults.flatMap((result)=>{
        // 1st pass
        const doAllWordsMatch = wordsInQuery.reduce((acc, word)=>{
            if (!acc) return acc;
            return result.title.toLowerCase().includes(word.toLowerCase());
        }, true);
        if (doAllWordsMatch) {
            // 2nd and 3rd Pass
            const { score: score = 0 } = (0, $bloXB.highlightMatchedText)(result.title, wordsInQuery);
            itemScoreMap[result.title] = score;
            return [
                {
                    ...result
                }
            ];
        }
        return [];
    }).sort((item, secondItem)=>item && secondItem ? itemScoreMap[secondItem.title] - itemScoreMap[item.title] : 0);
    return filteredResults;
}

});
parcelRegister("bloXB", function(module, exports) {

$parcel$export(module.exports, "highlightMatchedText", () => $6609f2e7706baea1$export$9f4c92a576b56d82);
/**
 * Breakdown of the filtering & ordering logic :
 *
 * 0th pass: if the string has any highlight tags, remove them and continue
 * An alternate could be to exit early, but then we don't have the scoring information from the later passes
 *
 * 1st Pass - Complete match of query broken by words - This checks that all the words of the query must occur somewhere in the Title.
 *    - This is case insensitive.
 *    - This is unordered.
 *    For eg -
 *    Query - "mad max" will NOT let "Nomad" or "Climax" pass through,
 *    but  "Nomad Climax", "Madmax", "max Mad" will pass through
 *
 * 2nd Pass Scoring - Score calculation based on the kind of matches.
 *    There are 3 types - Exact match, StartsWith match & Partial match
 *    For eg -
 *    Exact Match (Score = 100) - Query: "Mad" will score "mad", "mad max" with 100.
 *            Note: Special characters stripped -  "Mad" will score "mad-max", "max-mad" with 100.
 *    StartsWith Match (Score = 10) - Query: "ark" will score "ARKK" and "Arkose Meeting" as 10
 *    Partial Match (Score = 1) - Query: "mad max" will score "Nomad Climax" as 2
 *
 *    Mix of multiple matching scenarios is possible.
 *    For example - "mad max" query will score "Mad Climax" as 100 (Exact) + 1 (Partial) = 101
 *
 * 3rd Pass - Sorting & Highlighting
 *    Sorting happens in the descending order of the score.
 *    Highlighting will match the entered query and inject necessary tags.
 *    Note: if both StartsWith and Partial matching exists in the same word then only StartsWith is highlighted
 *
 *    Two new properties are populated:
 *    1. highlightedText - highlights the query
 *    2. negatedHighlightedText - highights everything except the part that matches the query
 */ const $6609f2e7706baea1$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $6609f2e7706baea1$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $6609f2e7706baea1$var$SPECIAL_CHARACTER_REGEX = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g;
const $6609f2e7706baea1$var$CONSECUTIVE_START_REGEX = new RegExp(`${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}`, 'g');
const $6609f2e7706baea1$var$CONSECUTIVE_END_REGEX = new RegExp(`${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`, 'g');
const $6609f2e7706baea1$var$CONSECUTIVE_START_END_REGEX = new RegExp(`${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`, 'g');
const $6609f2e7706baea1$var$ESCAPE_SPECIAL_CHARACTERS = /[.*+?^${}()|[\]\\]/g;
const $6609f2e7706baea1$var$cleanStartRegex = new RegExp($6609f2e7706baea1$var$HIGHLIGHT_START_TAG, 'g');
const $6609f2e7706baea1$var$cleanEndRegex = new RegExp($6609f2e7706baea1$var$HIGHLIGHT_END_TAG, 'g');
const $6609f2e7706baea1$export$9f4c92a576b56d82 = (source, matchWords)=>{
    // Remove any previous highlighting and regenerate
    // Supports the use case where we perform this on the frontend, and later the backend starts doing it for us first
    const cleanedSource = source.replace($6609f2e7706baea1$var$cleanStartRegex, '').replace($6609f2e7706baea1$var$cleanEndRegex, '');
    const lowerCaseMatchWords = matchWords.filter((word)=>word !== '').map((word)=>word.toLowerCase());
    const wordsDetails = cleanedSource.split(' ').map((word)=>{
        const lowerCaseWord = word.toLowerCase();
        const alphabetOnlyWord = lowerCaseWord.replace($6609f2e7706baea1$var$SPECIAL_CHARACTER_REGEX, ' ').split(' ');
        let partialCount = 0;
        let startsWithCount = 0;
        let exactMatchCount = 0;
        let exactMatch = '';
        let partialMatch = '';
        let startsWithMatch = '';
        for(let i = 0; i < lowerCaseMatchWords.length; ++i){
            if (lowerCaseWord === lowerCaseMatchWords[i] || alphabetOnlyWord.includes(lowerCaseMatchWords[i])) {
                exactMatchCount++;
                exactMatch = lowerCaseMatchWords[i];
                break;
            }
            if (lowerCaseWord.startsWith(lowerCaseMatchWords[i])) {
                startsWithCount++;
                startsWithMatch = lowerCaseMatchWords[i];
                continue;
            }
            if (lowerCaseWord.includes(lowerCaseMatchWords[i])) {
                partialCount++;
                partialMatch = lowerCaseMatchWords[i];
            }
        }
        const score = 100 * exactMatchCount + 10 * startsWithCount + partialCount;
        if (exactMatchCount > 0 || startsWithCount > 0 || partialCount > 0) {
            const pattern = exactMatchCount > 0 ? exactMatch : startsWithCount > 0 ? startsWithMatch : partialMatch;
            const regExp = new RegExp(`(${pattern.replace($6609f2e7706baea1$var$ESCAPE_SPECIAL_CHARACTERS, '\\$&')})`, 'ig');
            const openingClosingRegExp = new RegExp(`(${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}|${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG})`, 'ig');
            const highlighted = word.replace(regExp, `${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}$1${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`).replace($6609f2e7706baea1$var$CONSECUTIVE_START_END_REGEX, ``);
            const mirror = {
                [`${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}`]: `${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`,
                [`${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`]: `${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}`
            };
            const mirroredHighlighted = highlighted.replace(openingClosingRegExp, (ch)=>mirror[ch]);
            const negatedHighlight = `${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}${mirroredHighlighted}${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`.replace($6609f2e7706baea1$var$CONSECUTIVE_START_REGEX, `${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}`).replace($6609f2e7706baea1$var$CONSECUTIVE_END_REGEX, `${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`).replace($6609f2e7706baea1$var$CONSECUTIVE_START_END_REGEX, '');
            return {
                highlighted: highlighted,
                negatedHighlight: negatedHighlight,
                score: score
            };
        }
        // no match scenario
        return {
            negatedHighlight: `${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}${word}${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`,
            highlighted: word,
            score: score
        };
    });
    const highlightedTitle = wordsDetails.map((wordObj)=>wordObj.highlighted).join(' ');
    const negatedHighlightedTitle = wordsDetails.map((wordObj)=>wordObj.negatedHighlight).join(' ');
    const finalScore = wordsDetails.reduce((acc, word)=>acc + word.score, 0);
    if (highlightedTitle !== '' && highlightedTitle !== cleanedSource) return {
        highlightedTitle: highlightedTitle,
        negatedHighlightedTitle: negatedHighlightedTitle,
        score: finalScore
    };
    return {};
};

});


parcelRegister("8WnGI", function(module, exports) {

$parcel$export(module.exports, "measureAsyncFunction", () => $cf5ef1e7c875b308$export$45bde04e7d1842b0);

var $kyKWe = parcelRequire("kyKWe");
async function $cf5ef1e7c875b308$export$45bde04e7d1842b0(asyncFunction) {
    const markName = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    performance.mark(`${markName}-start`);
    const result = await asyncFunction();
    performance.mark(`${markName}-end`);
    performance.measure(markName, `${markName}-start`, `${markName}-end`);
    const measure = performance.getEntriesByName(markName)[0];
    const duration = measure.duration;
    // Clear the marks and measure to avoid memory leaks
    performance.clearMarks(`${markName}-start`);
    performance.clearMarks(`${markName}-end`);
    performance.clearMeasures(markName);
    return {
        result: result,
        duration: duration
    };
}

});

parcelRegister("9wmQG", function(module, exports) {

$parcel$export(module.exports, "SearchDialogHeaderAnalyticsWrapper", () => $c5fb920fb7e7d9be$export$8814e97d826fd90d);
$parcel$export(module.exports, "SearchDialogResultAnalyticsWrapper", () => $c5fb920fb7e7d9be$export$e01f22447ddebe43);
$parcel$export(module.exports, "getProductsInResults", () => $c5fb920fb7e7d9be$export$e21758a6ca606f0a);
$parcel$export(module.exports, "getResultTypeCounts", () => $c5fb920fb7e7d9be$export$334c5c15d40bbec1);
$parcel$export(module.exports, "getSectionsAndResultsCount", () => $c5fb920fb7e7d9be$export$e9dac44129e02fa9);
$parcel$export(module.exports, "getNodePosition", () => $c5fb920fb7e7d9be$export$39e67138c277998b);
/**
 * This file provides the necessary wrappers and utility functions to provide
 * analytics data for Quick Find result positions. Quick Find analytics contains
 * data such as the number of results, the number of sections, and the
 * position / section of a selected result.
 *
 * It does this by using the DOM as the source of truth rather than having to
 * maintain section objects and indexes in the code. This allows rendering
 * display components to be simplified and could prove to be more robust, e.g.
 * if a search result doesn't render due to an error and subsequently hits
 * its error boundary, section and results count remain correct.
 *
 * There is however the requirement that all heading and results components
 * are siblings in the DOM tree.
 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $c5fb920fb7e7d9be$export$e7b6022782937b95 = 'search-dialog-heading';
const $c5fb920fb7e7d9be$export$926357658a80ff2a = 'search-dialog-result';
const $c5fb920fb7e7d9be$var$resultTypes = [
    'peopleAndTeams',
    'recentQueries',
    'recentActivities',
    'queryFilters',
    'searchResults'
];
const $c5fb920fb7e7d9be$export$8814e97d826fd90d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(({ children: children, id: id, ...rest }, ref)=>{
    return(// Ignoring this check as class is not being used for styling
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: $c5fb920fb7e7d9be$export$e7b6022782937b95,
        "data-section-id": id,
        ref: ref,
        ...rest,
        children: children
    }));
});
const $c5fb920fb7e7d9be$export$e01f22447ddebe43 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(({ children: children, resultType: resultType, product: product, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        // Ignoring this check as class is not being used for styling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: $c5fb920fb7e7d9be$export$926357658a80ff2a,
        "data-result-type": resultType,
        "data-product": product,
        ref: ref,
        ...rest,
        children: children
    });
});
const $c5fb920fb7e7d9be$export$e21758a6ca606f0a = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    const productSet = new Set();
    for(let i = 0; i < resultNodes.length; i++){
        const product = resultNodes[i].getAttribute('data-product');
        product && productSet.add(product);
    }
    const productsInResults = Array.from(productSet);
    return productsInResults;
};
const $c5fb920fb7e7d9be$export$334c5c15d40bbec1 = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    return $c5fb920fb7e7d9be$var$resultTypes.reduce((o, resultType)=>{
        o[resultType] = resultNodes.filter((node)=>node.getAttribute('data-result-type') === resultType).length || 0;
        return o;
    }, {});
};
const $c5fb920fb7e7d9be$var$getAllHeadingsAndResults = ()=>{
    const headingNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$e7b6022782937b95));
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    if (!headingNodes.length || !resultNodes.length) return {
        allNodes: [],
        headingNodes: [],
        resultNodes: []
    };
    const parentNode = headingNodes.length ? headingNodes[0].parentNode : resultNodes.length ? resultNodes[0].parentNode : undefined;
    if (!parentNode) throw new Error('Could not find a parent node for headings and results');
    for (const node of [
        ...headingNodes,
        ...resultNodes
    ]){
        if (node.parentNode !== parentNode) throw new Error('All headings and results do not share a parent');
    }
    const allNodes = Array.from(parentNode.children).filter((e)=>$c5fb920fb7e7d9be$var$isHeading(e) || $c5fb920fb7e7d9be$var$isResult(e));
    return {
        allNodes: allNodes,
        headingNodes: headingNodes,
        resultNodes: resultNodes
    };
};
const $c5fb920fb7e7d9be$var$isHeading = (e)=>{
    return e.classList.contains($c5fb920fb7e7d9be$export$e7b6022782937b95);
};
const $c5fb920fb7e7d9be$var$isResult = (e)=>{
    return e.classList.contains($c5fb920fb7e7d9be$export$926357658a80ff2a);
};
const $c5fb920fb7e7d9be$export$e9dac44129e02fa9 = ()=>{
    try {
        const { allNodes: allNodes, headingNodes: headingNodes, resultNodes: resultNodes } = $c5fb920fb7e7d9be$var$getAllHeadingsAndResults();
        // If the first node is a result, then we count it as a section
        const sectionCount = allNodes.length ? headingNodes.length + ($c5fb920fb7e7d9be$var$isResult(allNodes[0]) ? 1 : 0) : 0;
        return {
            sectionCount: sectionCount,
            resultCount: resultNodes.length
        };
    } catch (e) {
        return {};
    }
};
const $c5fb920fb7e7d9be$export$39e67138c277998b = (targetNode)=>{
    try {
        const { sectionCount: sectionCount, resultCount: resultCount } = $c5fb920fb7e7d9be$export$e9dac44129e02fa9();
        const { allNodes: allNodes } = $c5fb920fb7e7d9be$var$getAllHeadingsAndResults();
        // If the first node is a result, then we count it as a section
        let sectionIndex = allNodes.length ? $c5fb920fb7e7d9be$var$isResult(allNodes[0]) ? 0 : -1 : -1;
        let sectionId = '';
        // Initialise variables to -1 as when we encounter a node,
        // we increment to represent the current index of the node
        let resultIndex = -1;
        let indexWithinSection = -1;
        for (const node of allNodes){
            if ($c5fb920fb7e7d9be$var$isHeading(node)) {
                sectionIndex++;
                sectionId = node.dataset.sectionId || '';
                indexWithinSection = -1;
            }
            if ($c5fb920fb7e7d9be$var$isResult(node)) {
                resultIndex++;
                indexWithinSection++;
            }
            if (node === targetNode) break;
        }
        return {
            sectionId: sectionId,
            sectionCount: sectionCount,
            resultCount: resultCount,
            sectionIndex: sectionIndex,
            globalIndex: resultIndex,
            indexWithinSection: indexWithinSection
        };
    } catch (e) {
        return {};
    }
};

});

parcelRegister("ebR6f", function(module, exports) {

$parcel$export(module.exports, "onSearchResultsShown", () => $e1a1aba41a097938$export$2d1da932f40a427e);
const $e1a1aba41a097938$export$2d1da932f40a427e = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, resultsType: resultsType })=>({
        eventType: 'ui',
        action: 'shown',
        actionSubject: 'searchResults',
        actionSubjectId: resultsType,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("aE5mL", function(module, exports) {

$parcel$export(module.exports, "State", () => $7c0d6974c60a6f80$export$7254cc27399e90bd);
$parcel$export(module.exports, "isPreQueryState", () => $7c0d6974c60a6f80$export$bbc0e9ab60a7c746);
$parcel$export(module.exports, "isPostQueryState", () => $7c0d6974c60a6f80$export$f33d0292f2f7a82a);
$parcel$export(module.exports, "isPostQueryLoadingOrResults", () => $7c0d6974c60a6f80$export$3d387094581134ab);
$parcel$export(module.exports, "isLoadingState", () => $7c0d6974c60a6f80$export$de6adf92470c6d4);
const $7c0d6974c60a6f80$export$7254cc27399e90bd = {
    PREQUERY_ERROR: 'PREQUERY_ERROR',
    PREQUERY_LOADING: 'PREQUERY_LOADING',
    PREQUERY_NO_RESULTS: 'PREQUERY_NO_RESULTS',
    PREQUERY_RESULTS: 'PREQUERY_RESULTS',
    POSTQUERY_ERROR: 'POSTQUERY_ERROR',
    POSTQUERY_LOADING: 'POSTQUERY_LOADING',
    POSTQUERY_NO_RESULTS: 'POSTQUERY_NO_RESULTS',
    POSTQUERY_RESULTS: 'POSTQUERY_RESULTS'
};
const $7c0d6974c60a6f80$export$bbc0e9ab60a7c746 = (state)=>{
    return state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_ERROR || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_LOADING || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_NO_RESULTS || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_RESULTS;
};
const $7c0d6974c60a6f80$export$f33d0292f2f7a82a = (state)=>{
    return state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_ERROR || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_LOADING || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_NO_RESULTS || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_RESULTS;
};
const $7c0d6974c60a6f80$export$3d387094581134ab = (state)=>{
    return state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_LOADING || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_RESULTS;
};
const $7c0d6974c60a6f80$export$de6adf92470c6d4 = (state)=>{
    return state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_LOADING || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_LOADING;
};

});

parcelRegister("JQd0k", function(module, exports) {

$parcel$export(module.exports, "useDebouncedCallback", () => $e31678cde9628b17$export$e70e6da722faba05);

var $gwFzn = parcelRequire("gwFzn");

var $2jjxD = parcelRequire("2jjxD");
const $e31678cde9628b17$export$e70e6da722faba05 = (callback, debounceTime)=>{
    const ref = (0, $gwFzn.useRef)();
    (0, $gwFzn.useEffect)(()=>{
        ref.current = callback;
    }, [
        callback
    ]);
    const debouncedCallback = (0, $gwFzn.useMemo)(()=>{
        const func = ()=>{
            ref.current?.();
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(func, debounceTime);
    }, [
        debounceTime
    ]);
    return debouncedCallback;
};

});

parcelRegister("9ubz9", function(module, exports) {

$parcel$export(module.exports, "getAttributes", () => $727cf3a51c81de07$export$fe94072fee8a6976);
$parcel$export(module.exports, "isResultSmartLink", () => $727cf3a51c81de07$export$c5fdbcc9e7462013);

var $6yNqK = parcelRequire("6yNqK");

var $1yEFx = parcelRequire("1yEFx");

var $a0M2t = parcelRequire("a0M2t");
const $727cf3a51c81de07$var$SMART_LINK_ENTITY_REGEX = /^ari:.*::remote-link/;
const $727cf3a51c81de07$export$fe94072fee8a6976 = ({ searchSessionId: searchSessionId, requestId: requestId, searchQuery: searchQuery, inputQuery: inputQuery, filters: filters, queryUpdatedTime: queryUpdatedTime, productSelected: productSelected, availableProducts: availableProducts, sort: sort, experimentConfig: experimentConfig, applicationMode: applicationMode, productEdition: productEdition })=>{
    const { filterSelections: filterSelections, filters: filterCategories } = filters;
    const has3pProducts = !!availableProducts.find((product)=>(0, $1yEFx.is3pProductKey)(product));
    const { frontendExperiments: frontendExperiments = {} } = experimentConfig;
    const is3pSearch = !!(has3pProducts && !productSelected || productSelected && (0, $1yEFx.is3pProductKey)(productSelected));
    const archivedStatus = filterSelections.some((selection)=>selection.value === (0, $6yNqK.OptionIds).ARCHIVED) ? [
        (0, $6yNqK.CURRENT),
        (0, $6yNqK.ARCHIVED)
    ] : [
        (0, $6yNqK.CURRENT)
    ];
    const commonAttributes = {
        searchSessionId: searchSessionId,
        traceId: requestId,
        productSelected: productSelected || (0, $6yNqK.ALL_PRODUCTS_STRING),
        availableProducts: availableProducts,
        mode: applicationMode,
        has3pProducts: has3pProducts,
        is3pSearch: is3pSearch,
        numberOfTerms: (searchQuery.match(/\w+/g) || []).length,
        queryLength: searchQuery.length,
        inputQueryLength: inputQuery.length,
        queryHash: (0, $a0M2t.sha256Hash)(searchQuery),
        filters: filterCategories,
        filterSelections: filterSelections,
        containerStatuses: archivedStatus,
        contentStatuses: archivedStatus,
        productEdition: productEdition,
        frontendExperiments: {
            activeExperiments: Object.keys(frontendExperiments).filter((experiment)=>frontendExperiments[experiment]?.serveExperiment),
            ...frontendExperiments
        },
        version: 2,
        api: (0, $6yNqK.CROSSPRODUCT_SEARCH_API),
        wordCount: (searchQuery.match(/\w+/g) || []).length,
        isCQL: false,
        queryUpdatedAgo: queryUpdatedTime ? Date.now() - queryUpdatedTime : undefined,
        sort: sort
    };
    const nonPrivacySafeAttributes = {
        query: searchQuery,
        inputQuery: inputQuery
    };
    return {
        commonAttributes: commonAttributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};
const $727cf3a51c81de07$export$c5fdbcc9e7462013 = (resultNodeId)=>$727cf3a51c81de07$var$SMART_LINK_ENTITY_REGEX.test(resultNodeId);

});
parcelRegister("6yNqK", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_GAS_CHANNEL", () => $f8b501d0c94c20b2$export$ed78826c06dd24e3);
$parcel$export(module.exports, "EVENT_SOURCE", () => $f8b501d0c94c20b2$export$ad44d4a0591d8dba);
$parcel$export(module.exports, "ACTION_SUBJECT_PREFIX", () => $f8b501d0c94c20b2$export$98bd2afc08f981ef);
$parcel$export(module.exports, "OptionIds", () => $f8b501d0c94c20b2$export$1118b8908e5d0501);
$parcel$export(module.exports, "CURRENT", () => $f8b501d0c94c20b2$export$eed19b551669af14);
$parcel$export(module.exports, "ARCHIVED", () => $f8b501d0c94c20b2$export$c936349447a77fe0);
$parcel$export(module.exports, "CROSSPRODUCT_SEARCH_API", () => $f8b501d0c94c20b2$export$a4c5cde0daa9b961);
$parcel$export(module.exports, "ALL_PRODUCTS_STRING", () => $f8b501d0c94c20b2$export$2be5c31192ba8783);
$parcel$export(module.exports, "ERROR_SCREEN_NAME", () => $f8b501d0c94c20b2$export$cabdc1d3c523c88);
$parcel$export(module.exports, "QueryState", () => $f8b501d0c94c20b2$export$15029b2eda44c6a7);
const $f8b501d0c94c20b2$export$e8d1ded05852e864 = {
    source: 'source'
};
const $f8b501d0c94c20b2$export$d1fe2a1199482e6d = {
    release: 'release',
    product: 'product',
    cloudId: 'cloudId',
    userId: 'userId',
    primaryProduct: 'primaryProduct',
    experimentId: 'experimentId',
    experimentLayers: 'experimentLayers',
    frontendExperiments: 'frontendExperiments',
    abTestId: 'abTestId',
    isHello: 'isHello',
    version: 'version',
    mode: 'mode',
    requestId: 'requestId'
};
const $f8b501d0c94c20b2$export$ed78826c06dd24e3 = 'fabric-elements';
const $f8b501d0c94c20b2$export$ad44d4a0591d8dba = 'advancedSearchScreen';
const $f8b501d0c94c20b2$export$98bd2afc08f981ef = 'searchPage';
var $f8b501d0c94c20b2$export$1118b8908e5d0501 = /*#__PURE__*/ function(OptionIds) {
    OptionIds["TITLE"] = "title";
    OptionIds["ARCHIVED"] = "archived";
    OptionIds["ANCESTOR"] = "ancestor";
    OptionIds["TO"] = "to";
    OptionIds["FROM"] = "from";
    OptionIds["LAST_MODIFIED"] = "lastModified";
    return OptionIds;
}({});
const $f8b501d0c94c20b2$export$eed19b551669af14 = 'CURRENT';
const $f8b501d0c94c20b2$export$c936349447a77fe0 = 'ARCHIVED';
const $f8b501d0c94c20b2$export$a4c5cde0daa9b961 = 'crossProductSearch';
const $f8b501d0c94c20b2$export$2be5c31192ba8783 = 'all';
const $f8b501d0c94c20b2$export$cabdc1d3c523c88 = 'fullPageSearchErrorScreen';
var $f8b501d0c94c20b2$export$15029b2eda44c6a7 = /*#__PURE__*/ function(QueryState) {
    QueryState["POSTQUERY"] = "PostQuery";
    QueryState["PREQUERY"] = "PreQuery";
    return QueryState;
}({});

});

parcelRegister("a0M2t", function(module, exports) {

$parcel$export(module.exports, "sha256Hash", () => $14560c03b964676f$export$e9131c78c1110376);

var $3rxD2 = parcelRequire("3rxD2");
const $14560c03b964676f$export$e9131c78c1110376 = (str)=>(0, (/*@__PURE__*/$parcel$interopDefault($3rxD2))).createHash('sha256').update(str).digest('hex');

});


parcelRegister("1nJM3", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $58d4b2eeaa52f5f4$export$e926676385687eaf);
$parcel$export(module.exports, "useLogException", () => (parcelRequire("f8oYd")).useLogException);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $bg4YX = parcelRequire("bg4YX");

var $6zh3X = parcelRequire("6zh3X");

var $3CshZ = parcelRequire("3CshZ");

var $f8oYd = parcelRequire("f8oYd");
const $58d4b2eeaa52f5f4$export$e926676385687eaf = (props)=>{
    const logException = (0, $f8oYd.useLogException)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const onException = (0, $gwFzn.useCallback)((error)=>{
        fireAnalyticsEvent((0, $6zh3X.onErrorBoundaryHit)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            failSection: props.section
        }));
        logException(error);
    }, [
        logException,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        props.section
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bg4YX.ErrorBoundary), {
        ...props,
        onException: onException,
        children: props.children
    });
};

});
parcelRegister("6zh3X", function(module, exports) {

$parcel$export(module.exports, "onErrorBoundaryHit", () => $ee0af2ae8a3f715b$export$2804e03de329c539);
const $ee0af2ae8a3f715b$export$2804e03de329c539 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, failSection: failSection })=>{
    return {
        eventType: 'track',
        source: failSection,
        actionSubject: 'searchPageErrorBoundary',
        action: 'failed',
        attributes: {
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};

});

parcelRegister("3CshZ", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", () => $484f7910e7f707a3$export$e955abb82869dc84);
$parcel$export(module.exports, "useCommonAndPrivateAttributes", () => $484f7910e7f707a3$export$58bac47385d8e8f4);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $6yNqK = parcelRequire("6yNqK");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $djVCD = parcelRequire("djVCD");

var $9ubz9 = parcelRequire("9ubz9");
const $484f7910e7f707a3$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // analytics attributes passed in from the product
    const [analyticsAttributes] = (0, $j4ply.useAnalyticsAttributes)();
    // use this hook to fire UI, track, and operational event types
    const fireAnalyticsEvent = (0, $gwFzn.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            source: payload.source || (0, $6yNqK.EVENT_SOURCE),
            attributes: {
                ...payload.attributes.commonAttributes,
                ...payload.attributes.additionalAttributes,
                ...analyticsAttributes,
                isFullPageSearch: true
            }
        }).fire((0, $6yNqK.DEFAULT_GAS_CHANNEL));
    }, [
        analyticsAttributes,
        createAnalyticsEvent
    ]);
    // use this hook to fire screen event types
    const fireAnalyticsScreenEvent = (0, $gwFzn.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            eventType: 'screen',
            source: (0, $6yNqK.EVENT_SOURCE),
            attributes: {
                ...payload.attributes.commonAttributes,
                ...payload.attributes.additionalAttributes,
                ...analyticsAttributes,
                isFullPageSearch: true
            }
        }).fire((0, $6yNqK.DEFAULT_GAS_CHANNEL));
    }, [
        analyticsAttributes,
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent,
        fireAnalyticsScreenEvent: fireAnalyticsScreenEvent
    };
};
const $484f7910e7f707a3$export$58bac47385d8e8f4 = ()=>{
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [requestId] = (0, $djVCD.useResultsRequestId)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const [inputQuery] = (0, $djVCD.useInputQuery)();
    const [queryUpdatedTime] = (0, $djVCD.useQueryUpdatedTime)();
    const [productSelected] = (0, $djVCD.useSelectedProduct)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [sort] = (0, $djVCD.useResultsSort)();
    const [experimentConfig] = (0, $j4ply.useExperimentConfig)();
    const filters = (0, $djVCD.useFilterAttributesForTracking)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const [productEdition] = (0, $j4ply.useProductEdition)();
    return (0, $9ubz9.getAttributes)({
        searchSessionId: searchSessionId,
        requestId: requestId,
        searchQuery: searchQuery,
        inputQuery: inputQuery,
        filters: filters,
        queryUpdatedTime: queryUpdatedTime,
        productSelected: productSelected,
        availableProducts: availableProducts,
        sort: sort,
        experimentConfig: experimentConfig,
        applicationMode: applicationMode,
        productEdition: productEdition
    });
};

});
parcelRegister("j4ply", function(module, exports) {

$parcel$export(module.exports, "BootstrapStoreContainer", () => $ee8d6df68f0b570c$export$557bf45c8d0f5bd);
$parcel$export(module.exports, "useBootstrapActions", () => $ee8d6df68f0b570c$export$cf715ed8590c209b);
$parcel$export(module.exports, "useBootstrap", () => $ee8d6df68f0b570c$export$9ba1f1f28043c5bf);
$parcel$export(module.exports, "useAnalyticsAttributes", () => $ee8d6df68f0b570c$export$1fd8522aeddaccda);
$parcel$export(module.exports, "useAvailableProducts", () => $ee8d6df68f0b570c$export$5afbfe6edea8e998);
$parcel$export(module.exports, "useIsAvailableProductsLoaded", () => $ee8d6df68f0b570c$export$9e9836415b9aa240);
$parcel$export(module.exports, "useBootstrapLoading", () => $ee8d6df68f0b570c$export$f7c6299b3492081c);
$parcel$export(module.exports, "usePrimaryProduct", () => $ee8d6df68f0b570c$export$92c6f3c7c09f3247);
$parcel$export(module.exports, "useSearchSessionId", () => $ee8d6df68f0b570c$export$e1e7a4797df1a656);
$parcel$export(module.exports, "useIsHello", () => $ee8d6df68f0b570c$export$1a0be923fb1117e4);
$parcel$export(module.exports, "useFeatures", () => $ee8d6df68f0b570c$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useBackendExperiment", () => $ee8d6df68f0b570c$export$9e89c81d9ff2c758);
$parcel$export(module.exports, "useFrontendExperiments", () => $ee8d6df68f0b570c$export$d2c28b106f1bf70b);
$parcel$export(module.exports, "getIsDropAttachmentsCommentsFrmAllTypesEnabled", () => $ee8d6df68f0b570c$export$56d963647a9700db);
$parcel$export(module.exports, "useIsDropAttachmentsCommentsFrmAllTypesEnabled", () => $ee8d6df68f0b570c$export$740cb31e8098078a);
$parcel$export(module.exports, "serveUserShardModel", () => $ee8d6df68f0b570c$export$2300db9903c1302f);
$parcel$export(module.exports, "serveUserShardUI", () => $ee8d6df68f0b570c$export$d9ee534a20391486);
$parcel$export(module.exports, "useUserShardModel", () => $ee8d6df68f0b570c$export$5fec6e207833a0a8);
$parcel$export(module.exports, "useUserShardUI", () => $ee8d6df68f0b570c$export$9b58fc8767fb017f);
$parcel$export(module.exports, "useExperimentConfig", () => $ee8d6df68f0b570c$export$b9e6179ff71a6122);
$parcel$export(module.exports, "useIntercomHmac", () => $ee8d6df68f0b570c$export$8ab143228c6f49a2);
$parcel$export(module.exports, "useIsNounsAvailable", () => $ee8d6df68f0b570c$export$efd66ec4f7062878);
$parcel$export(module.exports, "useApplicationMode", () => $ee8d6df68f0b570c$export$150d84149ef86e81);
$parcel$export(module.exports, "useUser", () => $ee8d6df68f0b570c$export$23bbbc4533528f03);
$parcel$export(module.exports, "useReferrer", () => $ee8d6df68f0b570c$export$e99d08753f6dce85);
$parcel$export(module.exports, "useInitialTextQueryParam", () => $ee8d6df68f0b570c$export$84529f276bb721c4);
$parcel$export(module.exports, "useOrgId", () => $ee8d6df68f0b570c$export$52a03a3207af3687);
$parcel$export(module.exports, "useCloudId", () => $ee8d6df68f0b570c$export$9da0f7c65f28ed16);
$parcel$export(module.exports, "useAutoSelectPrimaryProduct", () => $ee8d6df68f0b570c$export$c7f4a8f2f4902c5b);
$parcel$export(module.exports, "useProductEdition", () => $ee8d6df68f0b570c$export$83e4de12d3240f53);
$parcel$export(module.exports, "useIsTypeFilteredToIncident", () => $ee8d6df68f0b570c$export$98a75a8d27d2d106);

var $dsBQ6 = parcelRequire("dsBQ6");

var $iFWZA = parcelRequire("iFWZA");
var $2S0Fz = parcelRequire("2S0Fz");
var $gMCSJ = parcelRequire("gMCSJ");
var $4ZoIm = parcelRequire("4ZoIm");

var $kyKWe = parcelRequire("kyKWe");

var $dh538 = parcelRequire("dh538");

var $9vOy1 = parcelRequire("9vOy1");

var $4cq9O = parcelRequire("4cq9O");

var $2Znam = parcelRequire("2Znam");

var $1yEFx = parcelRequire("1yEFx");

var $fKv9F = parcelRequire("fKv9F");

var $lwP5K = parcelRequire("lwP5K");

var $NwuTK = parcelRequire("NwuTK");

var $5XpfZ = parcelRequire("5XpfZ");

var $lIbf3 = parcelRequire("lIbf3");
const $ee8d6df68f0b570c$export$d4c72bab9d6cc13a = {
    products: [],
    nouns: [],
    allFilterExcludedProducts: [],
    thirdPartyConfigs: {},
    searchSessionId: '',
    queryParams: {},
    prevQueryParams: {},
    initialSpaceARIs: [],
    experimentConfig: {
        backendExperiment: undefined,
        frontendExperiments: undefined,
        dynamicExperiments: undefined,
        nonOverlappingBackendExperiment: undefined,
        isMutuallyExclusive: false
    },
    isNounsAvailable: false,
    isRovoEnabled: false,
    isConfigLoaded: false,
    rovoFeatures: {}
};
const $ee8d6df68f0b570c$export$e324594224ef24da = {
    setState: (partialState)=>({ setState: setState })=>{
            setState(partialState);
        },
    setQueryParams: (queryParam)=>({}, { queryParams: queryParams, queryParamsCallback: queryParamsCallback = ()=>{} })=>{
            const areEqualQueryParams = (0, $lIbf3.areAllEqualQueryParams)(queryParam, (0, $lIbf3.parseQueryParams)(queryParams ?? {}));
            if (areEqualQueryParams) return;
            queryParamsCallback((0, $lIbf3.toQueryParamsRaw)(queryParam));
        },
    syncQueryParams: ()=>({ setState: setState, getState: getState }, { queryParams: queryParams, queryParamsCallback: queryParamsCallback = ()=>{} })=>{
            // queryParams is the query params coming from the URL or React Router in this case
            const { prevQueryParams: prevQueryParams, queryParams: diffQueryParamsState } = getState();
            const queryParamsURL = (0, $lIbf3.parseQueryParams)(queryParams ?? {});
            const prevQueryParamsString = (0, $lIbf3.toQueryString)(prevQueryParams);
            const diffQueryParamsURLString = (0, $lIbf3.toQueryString)(queryParamsURL);
            const diffQueryParamsStateString = (0, $lIbf3.toQueryString)(diffQueryParamsState);
            const allQueryParamsAreEqual = (0, $lIbf3.areAllEqualQueryParams)(queryParamsURL, prevQueryParams, diffQueryParamsState);
            if (allQueryParamsAreEqual) return;
            // Any changes from the url takes the highest precedence
            const hasURLQueryParams = !!queryParams;
            if (hasURLQueryParams && prevQueryParamsString !== diffQueryParamsURLString) {
                setState({
                    prevQueryParams: queryParamsURL,
                    queryParams: queryParamsURL
                });
                return;
            }
            if (prevQueryParamsString !== diffQueryParamsStateString) {
                //  NOTE: If you are running the callback and you don't see the query params being updated,
                //  the callback might be sanitising the query parameters. This is the case for Confluence.
                queryParamsCallback((0, $lIbf3.toQueryParamsRaw)(diffQueryParamsState));
                setState({
                    prevQueryParams: diffQueryParamsState,
                    queryParams: diffQueryParamsState
                });
                return;
            }
        },
    refreshSearchSessionId: ()=>({ setState: setState })=>{
            setState({
                searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
            });
        },
    clearReferrer: ()=>({ setState: setState })=>{
            setState({
                referrer: undefined
            });
        }
};
const $ee8d6df68f0b570c$var$buildProducts = (0, (/*@__PURE__*/$parcel$interopDefault($dsBQ6)))((a, b)=>{
    return [
        ...new Set([
            ...a,
            ...b
        ])
    ];
}, (a, b)=>a.join('') + b.join(''));
// Keep store private and use hooks to access state and actions
const $ee8d6df68f0b570c$var$Store = (0, $4ZoIm.createStore)({
    initialState: $ee8d6df68f0b570c$export$d4c72bab9d6cc13a,
    actions: $ee8d6df68f0b570c$export$e324594224ef24da,
    name: 'bootstrap'
});
const $ee8d6df68f0b570c$export$543309f9b943a423 = {
    onInit: ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { initialProps: initialProps, queryParams: queryParams })=>{
            const parsedQueryParams = queryParams && (0, $lIbf3.parseQueryParams)(queryParams);
            setState({
                ...getState(),
                ...initialProps,
                ...queryParams && {
                    queryParams: parsedQueryParams
                },
                referrer: parsedQueryParams?.referrer,
                initialTextQueryParam: parsedQueryParams?.text,
                searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
            });
        },
    onUpdate: ()=>({ setState: setState, getState: getState, dispatch: dispatch }, { initialProps: initialProps, queryParams: queryParams })=>{
            const parsedQueryParams = queryParams && (0, $lIbf3.parseQueryParams)(queryParams);
            const products = (0, $dh538.fg)('platform_confluence_memoized_products_company_hub') ? $ee8d6df68f0b570c$var$buildProducts(getState().products, initialProps?.products ?? []) : [
                ...new Set([
                    ...getState().products,
                    ...initialProps?.products ?? []
                ])
            ];
            setState({
                ...getState(),
                ...initialProps,
                products: products,
                referrer: parsedQueryParams?.referrer
            });
            dispatch($ee8d6df68f0b570c$export$e324594224ef24da.syncQueryParams());
        }
};
const $ee8d6df68f0b570c$export$557bf45c8d0f5bd = (0, $2S0Fz.createContainer)($ee8d6df68f0b570c$var$Store, $ee8d6df68f0b570c$export$543309f9b943a423);
const $ee8d6df68f0b570c$export$cf715ed8590c209b = (0, $iFWZA.createActionsHook)($ee8d6df68f0b570c$var$Store);
const $ee8d6df68f0b570c$export$9ba1f1f28043c5bf = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store);
const $ee8d6df68f0b570c$export$1fd8522aeddaccda = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.analyticsAttributes
});
const $ee8d6df68f0b570c$export$5afbfe6edea8e998 = (0, $iFWZA.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.products
});
const $ee8d6df68f0b570c$export$9e9836415b9aa240 = (0, $iFWZA.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.products && state.products.length > 0
});
const $ee8d6df68f0b570c$export$f7c6299b3492081c = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.products.length === 0
});
const $ee8d6df68f0b570c$export$92c6f3c7c09f3247 = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.primaryProduct
});
const $ee8d6df68f0b570c$export$e1e7a4797df1a656 = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.searchSessionId
});
const $ee8d6df68f0b570c$export$1a0be923fb1117e4 = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>(0, $5XpfZ.isHello)(state.cloudId)
});
const $ee8d6df68f0b570c$export$4a39035bacc4ed76 = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.features
});
const $ee8d6df68f0b570c$export$9e89c81d9ff2c758 = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state, entities)=>{
        return (0, $NwuTK.getBackendExperiment)({
            experimentConfig: state.experimentConfig,
            entities: entities,
            productEdition: state.productEdition,
            isHello: (0, $5XpfZ.isHello)(state.cloudId),
            productDataRegions: state.productDataRegions,
            experience: (0, $4cq9O.SEARCH_PAGE),
            tenantId: state.cloudId
        });
    }
});
const $ee8d6df68f0b570c$export$d2c28b106f1bf70b = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.experimentConfig.frontendExperiments
});
const $ee8d6df68f0b570c$export$56d963647a9700db = (experimentConfig)=>!!experimentConfig.frontendExperiments?.['exp-plex-drop-attachments-comments-frm-all-types']?.serveExperiment || (0, $dh538.fg)('plex_drop_attachments_comments');
const $ee8d6df68f0b570c$export$740cb31e8098078a = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>!!state.experimentConfig.frontendExperiments?.['exp-plex-drop-attachments-comments-frm-all-types']?.serveExperiment || (0, $dh538.fg)('plex_drop_attachments_comments')
});
const $ee8d6df68f0b570c$export$2300db9903c1302f = (experimentConfig)=>{
    const cohort = experimentConfig.frontendExperiments?.['quick-find-user-shard-search-experiment']?.cohort;
    return cohort === 'model-only' || cohort === 'test';
};
const $ee8d6df68f0b570c$export$d9ee534a20391486 = (experimentConfig)=>{
    const cohort = experimentConfig.frontendExperiments?.['quick-find-user-shard-search-experiment']?.cohort;
    return cohort === 'test';
};
const $ee8d6df68f0b570c$export$5fec6e207833a0a8 = (0, $iFWZA.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>$ee8d6df68f0b570c$export$2300db9903c1302f(state.experimentConfig)
});
const $ee8d6df68f0b570c$export$9b58fc8767fb017f = (0, $iFWZA.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>$ee8d6df68f0b570c$export$d9ee534a20391486(state.experimentConfig)
});
const $ee8d6df68f0b570c$export$b9e6179ff71a6122 = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.experimentConfig
});
const $ee8d6df68f0b570c$export$8ab143228c6f49a2 = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.intercomHmac
});
const $ee8d6df68f0b570c$export$efd66ec4f7062878 = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.isNounsAvailable
});
const $ee8d6df68f0b570c$export$150d84149ef86e81 = (0, $iFWZA.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (0, $gMCSJ.createSelector)([
        (state)=>state.isRovoEnabled
    ], (isRovoEnabled)=>(0, $NwuTK.getApplicationMode)({
            isRovoEnabled: isRovoEnabled
        }))
});
const $ee8d6df68f0b570c$export$23bbbc4533528f03 = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>{
        const user = state.user;
        if (!user || !user.id) return {
            status: (0, $lwP5K.UserStatus).Unauthenticated,
            id: null,
            name: null,
            email: null
        };
        if (user.id === 'unidentified') return {
            status: (0, $lwP5K.UserStatus).Anonymous,
            ...user
        };
        return {
            status: (0, $lwP5K.UserStatus).Authenticated,
            ...user
        };
    }
});
const $ee8d6df68f0b570c$export$e99d08753f6dce85 = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.referrer
});
const $ee8d6df68f0b570c$export$84529f276bb721c4 = (0, $iFWZA.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.initialTextQueryParam
});
const $ee8d6df68f0b570c$export$52a03a3207af3687 = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.orgId
});
const $ee8d6df68f0b570c$export$9da0f7c65f28ed16 = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (0, $gMCSJ.createSelector)([
        (state)=>state.cloudId
    ], (cloudId)=>cloudId)
});
const $ee8d6df68f0b570c$export$c7f4a8f2f4902c5b = (0, $iFWZA.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (0, $gMCSJ.createSelector)([
        (state)=>state.products,
        (state)=>state.primaryProduct,
        (state)=>state.isRovoEnabled,
        (state)=>state.queryParams.product,
        (state)=>state.queryParams.cql
    ], (products, primaryProduct, isRovoEnabled, currentSelectedProduct, currentCql)=>{
        const applicationMode = (0, $NwuTK.getApplicationMode)({
            isRovoEnabled: isRovoEnabled
        });
        const primaryProductToSelect = (0, $fKv9F.productKeySchema).safeParse(primaryProduct);
        const shouldAutoSelectPrimaryProduct = !currentSelectedProduct && !currentCql && products && products.length > 0 && applicationMode === (0, $9vOy1.ApplicationModes).Unified && primaryProductToSelect.success && primaryProductToSelect.data !== (0, $1yEFx.ProductKeys).Atlas;
        if (shouldAutoSelectPrimaryProduct) return primaryProductToSelect.data;
        else return null;
    })
});
const $ee8d6df68f0b570c$export$dfc6af34d0b0a7e1 = (0, $iFWZA.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (0, $gMCSJ.createSelector)([
        (state)=>state.isConfigLoaded
    ], (isConfigLoaded)=>isConfigLoaded)
});
const $ee8d6df68f0b570c$export$27738d748ac05943 = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>!!state.rovoFeatures?.scas
});
const $ee8d6df68f0b570c$export$83e4de12d3240f53 = (0, $iFWZA.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.productEdition
});
const $ee8d6df68f0b570c$export$98a75a8d27d2d106 = (0, $iFWZA.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.queryParams?.type === (0, $2Znam.TypeFilterValueKey).Incident
});

});
parcelRegister("4cq9O", function(module, exports) {

$parcel$export(module.exports, "SEARCH_PAGE", () => $9acf3b09df50dcf8$export$944168d706dc6466);
const $9acf3b09df50dcf8$export$944168d706dc6466 = 'search-page';

});

parcelRegister("fKv9F", function(module, exports) {

$parcel$export(module.exports, "productKeySchema", () => $0c3c63d3552875fa$export$1cbda5ccc2e23e06);
$parcel$export(module.exports, "ProductKey", () => $0c3c63d3552875fa$export$f3a53bd43617a593);
$parcel$export(module.exports, "ContentType", () => $0c3c63d3552875fa$export$e2e108cbe2e4f865);
$parcel$export(module.exports, "LastModified", () => $0c3c63d3552875fa$export$e6747eee8f26f8c0);
$parcel$export(module.exports, "searchQueryParamsBaseSchema", () => $0c3c63d3552875fa$export$7b58b3b9a7b83d61);
$parcel$export(module.exports, "searchQueryParamsValidators", () => $0c3c63d3552875fa$export$ff67c0a0b67bb249);

var $2ci8P = parcelRequire("2ci8P");

var $bxnmj = parcelRequire("bxnmj");

var $2Znam = parcelRequire("2Znam");

var $1yEFx = parcelRequire("1yEFx");
const $0c3c63d3552875fa$export$ffa5bf38ea9a76ee = (0, $2ci8P.z).enum([
    'true',
    'false'
]).transform((x)=>x === 'true');
const $0c3c63d3552875fa$export$236bfa8a18b6097 = (0, $2ci8P.z).string().transform((x)=>x.split(','));
const $0c3c63d3552875fa$export$2a34288fa7fd44e4 = (0, $2ci8P.z).nativeEnum({
    Asana: 'asana',
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Focus: 'mercury',
    GoogleDrive: 'drive',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    // Opsgenie: 'opsgenie',
    Sharepoint: 'sharepoint',
    Slack: 'slack',
    Trello: 'trello',
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Teams: 'teams',
    Figma: 'figma',
    Github: 'github',
    Loom: 'loom',
    OneDrive: 'onedrive',
    GoogleCalendar: 'google-calendar',
    Dropbox: 'dropbox',
    Gmail: 'gmail',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Zendesk: 'zendesk',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    AdobeSign: 'adobe-sign',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3'
});
const $0c3c63d3552875fa$export$1cbda5ccc2e23e06 = (0, $2ci8P.z).nativeEnum((0, $1yEFx.ProductKeys));
const $0c3c63d3552875fa$export$f3a53bd43617a593 = $0c3c63d3552875fa$export$1cbda5ccc2e23e06.enum;
const $0c3c63d3552875fa$export$7a844b7429919d2 = (0, $2ci8P.z).nativeEnum({
    All: 'all'
});
const $0c3c63d3552875fa$export$ec20ab1a5eb36014 = $0c3c63d3552875fa$export$7a844b7429919d2.enum;
const $0c3c63d3552875fa$export$ddfc756f87e8324d = (0, $2ci8P.z).nativeEnum({
    Goal: 'goal',
    Learning: 'learning',
    Project: 'project',
    Tag: 'tag'
});
const $0c3c63d3552875fa$export$48b648eee115c3e5 = $0c3c63d3552875fa$export$ddfc756f87e8324d.enum;
const $0c3c63d3552875fa$export$578ac6cc3cc5997a = (0, $2ci8P.z).nativeEnum({
    WorkItem: 'work-item'
});
const $0c3c63d3552875fa$export$721015a6e24d06a0 = $0c3c63d3552875fa$export$578ac6cc3cc5997a.enum;
const $0c3c63d3552875fa$export$d872f0aa011c3a9d = (0, $2ci8P.z).nativeEnum({
    Answer: 'answer',
    Attachment: 'attachment',
    Blogpost: 'blogpost',
    Calendar: 'calendar',
    Comment: 'comment',
    Database: 'database',
    Document: 'document',
    Embed: 'embed',
    Folder: 'folder',
    Gliffy: 'gliffy',
    Page: 'page',
    Question: 'question',
    Space: 'space',
    SpaceCalendar: 'space-calendar',
    Whiteboard: 'whiteboard'
});
const $0c3c63d3552875fa$export$98ac9eece9e68319 = $0c3c63d3552875fa$export$d872f0aa011c3a9d.enum;
const $0c3c63d3552875fa$export$340da7d4450f4487 = (0, $2ci8P.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet'
});
const $0c3c63d3552875fa$export$bcc0874ed7743007 = $0c3c63d3552875fa$export$340da7d4450f4487.enum;
const $0c3c63d3552875fa$export$2d13808294fd047f = (0, $2ci8P.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet'
});
const $0c3c63d3552875fa$export$847712e479ca402d = $0c3c63d3552875fa$export$2d13808294fd047f.enum;
const $0c3c63d3552875fa$export$dbec9fc36dbba98b = (0, $2ci8P.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet'
});
const $0c3c63d3552875fa$export$8c76eb96ebfefeac = $0c3c63d3552875fa$export$dbec9fc36dbba98b.enum;
const $0c3c63d3552875fa$export$e31a67e5bb829f5c = (0, $2ci8P.z).nativeEnum({
    Project: 'project',
    Incident: 'incident',
    Issue: 'issue',
    Filter: 'filter',
    Dashboard: 'dashboard',
    Board: 'board'
});
const $0c3c63d3552875fa$export$e3ddf72248eaf972 = $0c3c63d3552875fa$export$e31a67e5bb829f5c.enum;
const $0c3c63d3552875fa$export$e3c670f5c4b4df75 = (0, $2ci8P.z).nativeEnum({
    Component: 'component'
});
const $0c3c63d3552875fa$export$39271a5a1b74da02 = $0c3c63d3552875fa$export$e3c670f5c4b4df75.enum;
const $0c3c63d3552875fa$export$3f35493c0e1fe9ec = (0, $2ci8P.z).nativeEnum({
    FocusArea: 'focus-area'
});
const $0c3c63d3552875fa$export$145fdb32ff1a4acf = $0c3c63d3552875fa$export$3f35493c0e1fe9ec.enum;
const $0c3c63d3552875fa$export$15f07c0375d70d62 = (0, $2ci8P.z).nativeEnum({
    Board: 'board',
    Card: 'card'
});
const $0c3c63d3552875fa$export$309520b897e0c0b = $0c3c63d3552875fa$export$15f07c0375d70d62.enum;
const $0c3c63d3552875fa$export$78ff7f7a3ef7dca8 = (0, $2ci8P.z).nativeEnum({
    Message: 'message',
    Conversation: 'conversation'
});
const $0c3c63d3552875fa$export$d51b5367809bb96 = $0c3c63d3552875fa$export$78ff7f7a3ef7dca8.enum;
const $0c3c63d3552875fa$export$e362a3dbc1368cf2 = (0, $2ci8P.z).nativeEnum({
    Message: 'message',
    Conversation: 'conversation'
});
const $0c3c63d3552875fa$export$c69d59ad598aee72 = $0c3c63d3552875fa$export$e362a3dbc1368cf2.enum;
const $0c3c63d3552875fa$export$3d532d345dacbf34 = (0, $2ci8P.z).nativeEnum({
    Repository: 'repository',
    PullRequest: 'pull-request',
    Commit: 'commit',
    Branch: 'branch'
});
const $0c3c63d3552875fa$export$8de16d71f5b0d410 = $0c3c63d3552875fa$export$3d532d345dacbf34.enum;
const $0c3c63d3552875fa$export$c30d3299c2899a1f = (0, $2ci8P.z).nativeEnum({
    WebPage: 'web-page'
});
const $0c3c63d3552875fa$export$bf86d9f770860253 = $0c3c63d3552875fa$export$c30d3299c2899a1f.enum;
const $0c3c63d3552875fa$export$f4b8db47840ea062 = (0, $2ci8P.z).nativeEnum({
    Design: 'design'
});
const $0c3c63d3552875fa$export$66f84ff942de6e1f = $0c3c63d3552875fa$export$f4b8db47840ea062.enum;
const $0c3c63d3552875fa$export$915266ba4ee70164 = (0, $2ci8P.z).nativeEnum({
    Video: 'video'
});
const $0c3c63d3552875fa$export$56591a3ad34d704b = $0c3c63d3552875fa$export$915266ba4ee70164.enum;
const $0c3c63d3552875fa$export$8669b3074569e564 = (0, $2ci8P.z).nativeEnum({
    WorkItem: 'work-item',
    Document: 'document'
});
const $0c3c63d3552875fa$export$fd3bdf5548c7bf84 = $0c3c63d3552875fa$export$8669b3074569e564.enum;
const $0c3c63d3552875fa$export$ff8ed9d399173456 = (0, $2ci8P.z).nativeEnum({
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal'
});
const $0c3c63d3552875fa$export$6b45e4ca3151b046 = $0c3c63d3552875fa$export$ff8ed9d399173456.enum;
const $0c3c63d3552875fa$export$e7eef498de91d92 = (0, $2ci8P.z).nativeEnum({
    Deal: 'deal',
    CustomerOrg: 'customer-org'
});
const $0c3c63d3552875fa$export$9325d29d4a9658a4 = $0c3c63d3552875fa$export$e7eef498de91d92.enum;
const $0c3c63d3552875fa$export$f63d577c43feca48 = (0, $2ci8P.z).nativeEnum({
    Deal: 'deal',
    CustomerOrg: 'customer-org'
});
const $0c3c63d3552875fa$export$7c597234a357d5f7 = $0c3c63d3552875fa$export$f63d577c43feca48.enum;
const $0c3c63d3552875fa$export$593c74387f9db963 = (0, $2ci8P.z).nativeEnum({
    ...$0c3c63d3552875fa$export$ec20ab1a5eb36014,
    ...$0c3c63d3552875fa$export$721015a6e24d06a0,
    ...$0c3c63d3552875fa$export$48b648eee115c3e5,
    ...$0c3c63d3552875fa$export$98ac9eece9e68319,
    ...$0c3c63d3552875fa$export$bcc0874ed7743007,
    ...$0c3c63d3552875fa$export$847712e479ca402d,
    ...$0c3c63d3552875fa$export$e3ddf72248eaf972,
    ...$0c3c63d3552875fa$export$39271a5a1b74da02,
    ...$0c3c63d3552875fa$export$145fdb32ff1a4acf,
    ...$0c3c63d3552875fa$export$309520b897e0c0b,
    ...$0c3c63d3552875fa$export$d51b5367809bb96,
    ...$0c3c63d3552875fa$export$c69d59ad598aee72,
    ...$0c3c63d3552875fa$export$66f84ff942de6e1f,
    ...$0c3c63d3552875fa$export$8de16d71f5b0d410,
    ...$0c3c63d3552875fa$export$56591a3ad34d704b,
    ...$0c3c63d3552875fa$export$bf86d9f770860253,
    ...$0c3c63d3552875fa$export$8c76eb96ebfefeac,
    ...$0c3c63d3552875fa$export$fd3bdf5548c7bf84,
    ...$0c3c63d3552875fa$export$6b45e4ca3151b046,
    ...$0c3c63d3552875fa$export$9325d29d4a9658a4,
    ...$0c3c63d3552875fa$export$7c597234a357d5f7
});
const $0c3c63d3552875fa$export$4f29dba8e623c3d1 = (0, $2ci8P.z).nativeEnum({
    ...(0, $2Znam.TypeFilterValueKey),
    ...$0c3c63d3552875fa$export$ec20ab1a5eb36014
});
const $0c3c63d3552875fa$export$e2e108cbe2e4f865 = $0c3c63d3552875fa$export$4f29dba8e623c3d1.enum;
const $0c3c63d3552875fa$export$8a9f7fff0151f0f7 = (0, $2ci8P.z).nativeEnum({
    ...(0, $bxnmj.PageStatusFilterValueKey),
    ...$0c3c63d3552875fa$export$ec20ab1a5eb36014
});
const $0c3c63d3552875fa$export$7c078c2ec2ab4e93 = (0, $2ci8P.z).nativeEnum({
    Anytime: 'anytime',
    Today: 'today',
    Yesterday: 'yesterday',
    Past7Days: 'past7Days',
    Past30Days: 'past30Days',
    PastYear: 'pastYear',
    Custom: 'custom'
});
const $0c3c63d3552875fa$export$e6747eee8f26f8c0 = $0c3c63d3552875fa$export$7c078c2ec2ab4e93.enum;
const $0c3c63d3552875fa$export$7b58b3b9a7b83d61 = (0, $2ci8P.z).object({
    text: (0, $2ci8P.z).optional((0, $2ci8P.z).string().max(200)),
    originalQuery: (0, $2ci8P.z).optional((0, $2ci8P.z).string().max(200)),
    product: (0, $2ci8P.z).optional((0, $2ci8P.z).string().pipe($0c3c63d3552875fa$export$1cbda5ccc2e23e06)),
    type: (0, $2ci8P.z).optional((0, $2ci8P.z).string().pipe($0c3c63d3552875fa$export$4f29dba8e623c3d1)),
    // Last Modified
    lastModified: (0, $2ci8P.z).optional((0, $2ci8P.z).string().pipe($0c3c63d3552875fa$export$7c078c2ec2ab4e93)),
    lastModified_lt: (0, $2ci8P.z).optional((0, $2ci8P.z).string().pipe((0, $2ci8P.z).coerce.date())),
    lastModified_gt: (0, $2ci8P.z).optional((0, $2ci8P.z).string().pipe((0, $2ci8P.z).coerce.date())),
    from: (0, $2ci8P.z).optional((0, $2ci8P.z).string()),
    to: (0, $2ci8P.z).optional((0, $2ci8P.z).string()),
    titleMatch: (0, $2ci8P.z).optional($0c3c63d3552875fa$export$ffa5bf38ea9a76ee),
    // Confluence filters
    contributors: (0, $2ci8P.z).optional($0c3c63d3552875fa$export$236bfa8a18b6097),
    owners: (0, $2ci8P.z).optional($0c3c63d3552875fa$export$236bfa8a18b6097),
    ancestor: (0, $2ci8P.z).optional((0, $2ci8P.z).string()),
    spaces: (0, $2ci8P.z).optional($0c3c63d3552875fa$export$236bfa8a18b6097),
    verified: (0, $2ci8P.z).optional($0c3c63d3552875fa$export$ffa5bf38ea9a76ee),
    labels: (0, $2ci8P.z).optional($0c3c63d3552875fa$export$236bfa8a18b6097),
    pageStatus: (0, $2ci8P.z).optional((0, $2ci8P.z).string().pipe($0c3c63d3552875fa$export$8a9f7fff0151f0f7)),
    archived: (0, $2ci8P.z).optional($0c3c63d3552875fa$export$ffa5bf38ea9a76ee),
    // Jira Filters
    jAssignee: (0, $2ci8P.z).optional($0c3c63d3552875fa$export$236bfa8a18b6097),
    jProject: (0, $2ci8P.z).optional($0c3c63d3552875fa$export$236bfa8a18b6097),
    // Mercury Filters
    focusAreaTypes: (0, $2ci8P.z).optional($0c3c63d3552875fa$export$236bfa8a18b6097),
    focusAreaUnder: (0, $2ci8P.z).optional($0c3c63d3552875fa$export$236bfa8a18b6097),
    createdBy: (0, $2ci8P.z).optional($0c3c63d3552875fa$export$236bfa8a18b6097),
    lastUpdatedBy: (0, $2ci8P.z).optional($0c3c63d3552875fa$export$236bfa8a18b6097),
    referrer: (0, $2ci8P.z).optional((0, $2ci8P.z).string()),
    cql: (0, $2ci8P.z).optional((0, $2ci8P.z).string())
});
const $0c3c63d3552875fa$export$f374b5430ac28f4c = $0c3c63d3552875fa$export$7b58b3b9a7b83d61.keyof().enum;
const $0c3c63d3552875fa$export$ff67c0a0b67bb249 = [
    (queryParams)=>{
        if (queryParams.lastModified !== 'custom') {
            const { lastModified_gt: lastModified_gt, lastModified_lt: lastModified_lt, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    },
    (queryParams)=>{
        const { lastModified_lt: lastModified_lt, lastModified_gt: lastModified_gt } = queryParams;
        if (lastModified_lt && lastModified_gt && lastModified_lt > lastModified_gt) {
            const { lastModified: lastModified, lastModified_gt: lastModified_gt, lastModified_lt: lastModified_lt, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    }
];
const $0c3c63d3552875fa$export$83efce6e50d7c43b = (0, $2ci8P.z).nativeEnum({
    ...$0c3c63d3552875fa$export$f3a53bd43617a593,
    ...$0c3c63d3552875fa$export$e2e108cbe2e4f865,
    ...$0c3c63d3552875fa$export$e6747eee8f26f8c0,
    ...$0c3c63d3552875fa$export$f374b5430ac28f4c
});
const $0c3c63d3552875fa$export$3d21d7040623da50 = $0c3c63d3552875fa$export$83efce6e50d7c43b.enum;

});
parcelRegister("bxnmj", function(module, exports) {

$parcel$export(module.exports, "PageStatusFilterValueKey", () => $960a8dbfa01645b5$export$dbcc81d768a46013);
$parcel$export(module.exports, "allPageStatusFilterValueKeys", () => $960a8dbfa01645b5$export$48932d85514b3629);
$parcel$export(module.exports, "PageStatusFilterValue", () => $960a8dbfa01645b5$export$106c1c66f1b4a23e);
// these are values for the query params
const $960a8dbfa01645b5$export$dbcc81d768a46013 = {
    RoughDraft: 'roughDraft',
    InProgress: 'inProgress',
    ReadyForReview: 'readyForReview',
    Verified: 'verified'
};
const $960a8dbfa01645b5$export$48932d85514b3629 = Object.values($960a8dbfa01645b5$export$dbcc81d768a46013);
const $960a8dbfa01645b5$export$106c1c66f1b4a23e = {
    [$960a8dbfa01645b5$export$dbcc81d768a46013.RoughDraft]: 'Rough draft',
    [$960a8dbfa01645b5$export$dbcc81d768a46013.InProgress]: 'In progress',
    [$960a8dbfa01645b5$export$dbcc81d768a46013.ReadyForReview]: 'Ready for review',
    [$960a8dbfa01645b5$export$dbcc81d768a46013.Verified]: 'Verified'
};

});


parcelRegister("lwP5K", function(module, exports) {

$parcel$export(module.exports, "UserStatus", () => $049f30ab6612ce17$export$a82073022ded66e8);
var $049f30ab6612ce17$export$a82073022ded66e8 = /*#__PURE__*/ function(UserStatus) {
    UserStatus["Unauthenticated"] = "unauthenticated";
    UserStatus["Anonymous"] = "anonymous";
    UserStatus["Authenticated"] = "authenticated";
    return UserStatus;
}({});

});

parcelRegister("NwuTK", function(module, exports) {

$parcel$export(module.exports, "getAccessibleProducts", () => $77c8468249754403$export$b38c0215344366f7);
$parcel$export(module.exports, "getBackendExperiment", () => $77c8468249754403$export$9009723727c24828);
$parcel$export(module.exports, "getApplicationMode", () => $77c8468249754403$export$daea4e28213a211a);

var $dh538 = parcelRequire("dh538");

var $3w0K2 = parcelRequire("3w0K2");

var $2hfy2 = parcelRequire("2hfy2");

var $hB77E = parcelRequire("hB77E");

var $9vOy1 = parcelRequire("9vOy1");

var $4cq9O = parcelRequire("4cq9O");

var $5XpfZ = parcelRequire("5XpfZ");
const $77c8468249754403$export$b38c0215344366f7 = ({ supportedProducts: supportedProducts, products: products, accessibleProducts: accessibleProducts })=>{
    if (!accessibleProducts) return [];
    const disabledProducts3PFromConfig = [];
    (0, $hB77E.ThirdPartyConfigs).forEach((config, productKey3P)=>{
        if (config && !config.isEnabled()) disabledProducts3PFromConfig.push(productKey3P);
    });
    const accessibleAndSupportedProducts = accessibleProducts.filter((productKey)=>!disabledProducts3PFromConfig.find((featureGatedProduct)=>featureGatedProduct === productKey)).filter((productKey)=>supportedProducts.includes(productKey));
    if (products) {
        const allowedProducts = products.filter((product)=>accessibleAndSupportedProducts.includes(product));
        return allowedProducts;
    } else return accessibleAndSupportedProducts;
};
const $77c8468249754403$export$9009723727c24828 = ({ experimentConfig: experimentConfig, entities: entities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId })=>{
    if ((0, $dh538.fg)('search-experiment-overrides-backend')) return experimentConfig.backendExperiment;
    if (!experimentConfig.dynamicExperiments || experimentConfig.isMutuallyExclusive) return undefined;
    const requestedEntities = entities.flatMap((entity)=>{
        try {
            const { resourceOwner: resourceOwner, resourceType: resourceType } = (0, $3w0K2.Ati).parse(entity);
            return [
                {
                    entity: resourceOwner,
                    subEntity: resourceType.toUpperCase()
                }
            ];
        } catch  {
            return [];
        }
    });
    if ((0, $dh538.fg)('search_platform_non_overlapping_domain')) {
        if (experimentConfig.nonOverlappingBackendExperiment?.mutualExclusion) return (0, $2hfy2.mapNonOverlappingBackendExperiment)({
            nonOverlappingExperiment: experimentConfig.nonOverlappingBackendExperiment
        });
    }
    return (0, $2hfy2.mapDynamicExperiments)({
        dynamicExperiments: experimentConfig.dynamicExperiments,
        productEdition: productEdition,
        isHello: isHello,
        requestedEntities: requestedEntities,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId
    });
};
const $77c8468249754403$export$dc300b2560197657 = (state, entities)=>$77c8468249754403$export$9009723727c24828({
        experimentConfig: state.experimentConfig,
        entities: entities,
        productEdition: state.productEdition,
        isHello: (0, $5XpfZ.isHello)(state.cloudId),
        productDataRegions: state.productDataRegions,
        experience: (0, $4cq9O.SEARCH_PAGE),
        tenantId: state.cloudId
    });
const $77c8468249754403$export$daea4e28213a211a = ({ isRovoEnabled: isRovoEnabled })=>{
    if (isRovoEnabled) return (0, $9vOy1.ApplicationModes).Rovo;
    return (0, $9vOy1.ApplicationModes).Unified;
};
const $77c8468249754403$export$4e187d62cf7d1f3a = (state)=>state.experimentConfig.frontendExperiments;

});
parcelRegister("2hfy2", function(module, exports) {

$parcel$export(module.exports, "mapNonOverlappingBackendExperiment", () => $c517901dc1a94583$export$6e49a8b8335c9b2b);
$parcel$export(module.exports, "mapDynamicExperiments", () => $c517901dc1a94583$export$37bc8313287bf4ea);

var $dh538 = parcelRequire("dh538");

var $4OGlb = parcelRequire("4OGlb");

var $hm6w9 = parcelRequire("hm6w9");
const $c517901dc1a94583$var$WILDCARD = '*';
const $c517901dc1a94583$export$6e49a8b8335c9b2b = ({ nonOverlappingExperiment: nonOverlappingExperiment })=>{
    if (nonOverlappingExperiment) {
        const experimentLayers = [
            [
                (0, $4OGlb.STATSIG_SEARCH_BACKEND_L1_LAYER_NAME),
                nonOverlappingExperiment.l1Id
            ],
            [
                (0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_LAYER_NAME),
                nonOverlappingExperiment.l2Id
            ],
            [
                (0, $4OGlb.STATSIG_SEARCH_BACKEND_L3_LAYER_NAME),
                nonOverlappingExperiment.l3Id
            ],
            [
                (0, $4OGlb.STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER_NAME),
                nonOverlappingExperiment.qrId
            ]
        ];
        return {
            experimentLayers: experimentLayers.map(([layerType, layerId])=>{
                return {
                    name: layerType,
                    layerId: null,
                    shadowId: null,
                    definitions: [
                        {
                            layerId: layerId,
                            shadowId: null,
                            entity: $c517901dc1a94583$var$WILDCARD,
                            subEntity: $c517901dc1a94583$var$WILDCARD
                        }
                    ]
                };
            })
        };
    }
    return {
        experimentLayers: []
    };
};
const $c517901dc1a94583$export$37bc8313287bf4ea = ({ dynamicExperiments: dynamicExperiments, requestedEntities: requestedEntities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId })=>{
    const experiments = dynamicExperiments.filter($c517901dc1a94583$var$containsTenantId(tenantId)).filter($c517901dc1a94583$export$647cb61786ce5ae0(productEdition)).filter($c517901dc1a94583$var$containsExperience(experience)).filter($c517901dc1a94583$var$isHelloTenant(isHello)).filter($c517901dc1a94583$var$containsRequestedEntities(requestedEntities)).filter($c517901dc1a94583$var$containsRequestedSubEntities(requestedEntities)).filter($c517901dc1a94583$var$satisfiesProductDataRegions(productDataRegions)).reduce((layerFunctions, currentLayerFunction)=>{
        if ((0, $dh538.fg)('ensure_search_layer_functions_are_non_overlapping')) {
            // IF there are more than one definitions with the same layerType, hello, entity and subEntity
            // THEN only add the first one defined, (do not add this one)
            const containsCollision = layerFunctions.find((layerFunction)=>layerFunction.layerType === currentLayerFunction.layerType && (layerFunction.entity === currentLayerFunction.entity || currentLayerFunction.entity === $c517901dc1a94583$var$WILDCARD || layerFunction.entity === $c517901dc1a94583$var$WILDCARD) && (layerFunction.subEntity === currentLayerFunction.subEntity || currentLayerFunction.subEntity === $c517901dc1a94583$var$WILDCARD || layerFunction.subEntity === $c517901dc1a94583$var$WILDCARD));
            return containsCollision ? layerFunctions : [
                ...layerFunctions,
                currentLayerFunction
            ];
        } else return [
            ...layerFunctions,
            currentLayerFunction
        ];
    }, []).map((dynamicExp)=>{
        const { layerId: layerId, shadowId: shadowId, abTestId: abTestId, controlId: controlId } = (0, $hm6w9.getLayerValues)(dynamicExp.statsigLayerId);
        return {
            definition: {
                layerId: layerId,
                shadowId: shadowId,
                entity: dynamicExp.entity,
                subEntity: dynamicExp.subEntity,
                abTestId: abTestId,
                controlId: controlId,
                statsigLayerId: dynamicExp.statsigLayerId
            },
            layerType: dynamicExp.layerType
        };
    });
    const groupedExperimentLayers = experiments.reduce((experimentLayers, definitionWithLayerType)=>{
        const existingLayer = experimentLayers.find((layer)=>layer.name === definitionWithLayerType.layerType);
        const { abTestId: abTestId, controlId: controlId, statsigLayerId: statsigLayerId, ...newDefinition } = definitionWithLayerType.definition;
        const analyticsDefinition = definitionWithLayerType.definition;
        if (!existingLayer) {
            experimentLayers.push({
                name: definitionWithLayerType.layerType,
                layerId: null,
                shadowId: null,
                definitions: [
                    newDefinition
                ],
                analyticsDefinitions: [
                    analyticsDefinition
                ]
            });
            return experimentLayers;
        }
        existingLayer.definitions?.push(newDefinition);
        existingLayer.analyticsDefinitions?.push(analyticsDefinition);
        return experimentLayers;
    }, []);
    return {
        experimentLayers: groupedExperimentLayers
    };
};
const $c517901dc1a94583$export$647cb61786ce5ae0 = (productEdition)=>(dynamicExp)=>{
        // Opt for specificity. Does not filter out values that do not have the confluenceTier attribute
        if (!dynamicExp.confluenceTier || dynamicExp.confluenceTier.length === 0) return true;
        return !!dynamicExp.confluenceTier?.find((experimentTier)=>productEdition?.['confluence'] === experimentTier);
    };
const $c517901dc1a94583$var$isHelloTenant = (isHello)=>(dynamicExp)=>{
        if (dynamicExp.hello === undefined || dynamicExp.hello === null) return true;
        return dynamicExp.hello === isHello;
    };
const $c517901dc1a94583$var$containsRequestedEntities = (entityFilter)=>(dynamicExp)=>{
        if (!dynamicExp.entity || dynamicExp.entity === $c517901dc1a94583$var$WILDCARD) return true;
        const isFilteredEntity = entityFilter.find((filteredEntity)=>dynamicExp.entity === filteredEntity.entity);
        return isFilteredEntity ?? false;
    };
const $c517901dc1a94583$var$containsRequestedSubEntities = (entityFilter)=>(dynamicExp)=>{
        if (!dynamicExp.subEntity || dynamicExp.subEntity === $c517901dc1a94583$var$WILDCARD) return true;
        const isFilteredSubEntity = entityFilter.find((filteredEntity)=>dynamicExp.subEntity === filteredEntity.subEntity);
        return isFilteredSubEntity ?? false;
    };
/**
 * Determines whether the provided data regions (dataRegions) are defined in
 * the dynamic configuration (dynamicExp). Every data region for a given product
 * in the dynamic configuration must be specified  in order for the given
 * experiment layer to be eligible.
 *
 * @param dataRegions Represents where the data comes from comes from for
 * each product.
 * ```
 * { 'confluence': ["us-west-2"], 'compass': ["us-east-1"] }`
 * ```
 *
 * @returns a boolean that indicates whether or not the provided data regions
 * (dataRegions) are specified in the dynamic configuration (dynamicExp).
 */ const $c517901dc1a94583$var$satisfiesProductDataRegions = (dataRegions)=>(dynamicExp)=>{
        if (!dynamicExp.productDataRegions) return true;
        return Object.keys(dynamicExp.productDataRegions).map((product)=>{
            const productDataRegions = dynamicExp.productDataRegions?.[product];
            const isProductEligible = dataRegions?.[product]?.every((dataRegion)=>{
                return productDataRegions?.includes(dataRegion);
            });
            return !!isProductEligible;
        }).reduce((prev, curr)=>prev && curr);
    };
const $c517901dc1a94583$var$containsExperience = (experience)=>(dynamicExp)=>{
        if (!dynamicExp.experiences || dynamicExp.experiences.length === 0) return true;
        return dynamicExp.experiences?.find((dynamicExpExperience)=>experience === dynamicExpExperience);
    };
const $c517901dc1a94583$var$containsTenantId = (tenantId)=>(dynamicExp)=>{
        if ((0, $dh538.fg)('tenant_id_search_scalable_statsig_layer_targeting')) {
            if (!dynamicExp.tenantIds || dynamicExp.tenantIds.length === 0) return true;
            return dynamicExp.tenantIds?.find((dynamicExpTenantId)=>tenantId === dynamicExpTenantId);
        } else return true;
    };

});

parcelRegister("5XpfZ", function(module, exports) {

$parcel$export(module.exports, "isHello", () => $26280c05cdeea98c$export$8e3fc93123f96c19);
const $26280c05cdeea98c$var$HELLO_TENANT_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $26280c05cdeea98c$export$8e3fc93123f96c19 = (cloudId)=>cloudId === $26280c05cdeea98c$var$HELLO_TENANT_ID;

});


parcelRegister("lIbf3", function(module, exports) {

$parcel$export(module.exports, "parseQueryParams", () => $d1c4c8d8da3b5693$export$67c4cee80a3410cd);
$parcel$export(module.exports, "toQueryString", () => $d1c4c8d8da3b5693$export$249cc09c933c4d7a);
$parcel$export(module.exports, "toQueryParamsRaw", () => $d1c4c8d8da3b5693$export$f30b1e6bbcaec160);
$parcel$export(module.exports, "areAllEqualQueryParams", () => $d1c4c8d8da3b5693$export$e247f217269cd2eb);

var $fKv9F = parcelRequire("fKv9F");
const $d1c4c8d8da3b5693$export$17d9a81ce3c86a85 = (urlSearchParams)=>{
    const queryParamsObject = Array.from(urlSearchParams.entries()).reduce((paramsObject, [paramKey, value])=>{
        return {
            ...paramsObject,
            [paramKey]: value
        };
    }, {});
    return queryParamsObject;
};
const $d1c4c8d8da3b5693$export$67c4cee80a3410cd = (queryParams, options)=>{
    const filteredParsedQueryParamEntries = Object.entries((0, $fKv9F.searchQueryParamsBaseSchema).shape).map(([key, schema])=>{
        const queryParamValue = queryParams[key];
        const parsedRawValue = schema.safeParse(queryParamValue);
        if (parsedRawValue.success || !options?.commaSeparatedValues) return [
            key,
            parsedRawValue.data
        ];
        const commaSeparatedString = Array.isArray(queryParamValue) && queryParamValue.length ? queryParamValue.join(',') : undefined;
        const parsedString = schema.safeParse(commaSeparatedString);
        return [
            key,
            parsedString.success ? parsedString.data : null
        ];
    }).filter(([_, value])=>!(value === null || value === undefined));
    const parsedQueryParams = Object.fromEntries(filteredParsedQueryParamEntries);
    const validatedQueryParams = (0, $fKv9F.searchQueryParamsValidators).reduce((queryParams, validator)=>validator(queryParams), parsedQueryParams);
    return validatedQueryParams;
};
const $d1c4c8d8da3b5693$export$60eb5b58f94d0071 = (oldQueryParams, newQueryParams)=>{
    const oldQueryParamEntries = Object.entries(oldQueryParams).filter(([_, value])=>!Array.isArray(value));
    const newQueryParamEntries = Object.entries(newQueryParams).filter(([_, value])=>!Array.isArray(value));
    const oldQueryParamArrayEntries = Object.entries(oldQueryParams).filter(([_, value])=>Array.isArray(value));
    const newQueryParamArrayEntries = Object.entries(newQueryParams).filter(([_, value])=>Array.isArray(value));
    const mergedQueryStringParamKeys = [
        ...new Set([
            ...oldQueryParamArrayEntries,
            ...newQueryParamArrayEntries
        ].map(([key])=>key))
    ];
    const mergedSearchQueryArrays = mergedQueryStringParamKeys.map((key)=>{
        return [
            key,
            [
                ...new Set([
                    ...oldQueryParams[key] ?? [],
                    ...newQueryParams[key] ?? []
                ])
            ]
        ];
    });
    return {
        ...Object.fromEntries(oldQueryParamEntries),
        ...Object.fromEntries(newQueryParamEntries),
        ...Object.fromEntries(mergedSearchQueryArrays)
    };
};
const $d1c4c8d8da3b5693$export$fc8e8d0c43c32316 = (queryParams)=>{
    return Object.entries(queryParams).flatMap((queryParam)=>{
        const [key, value] = queryParam;
        if (Array.isArray(value)) return [
            [
                key,
                value.join(',')
            ]
        ];
        return [
            [
                key,
                value
            ]
        ];
    });
};
const $d1c4c8d8da3b5693$export$17404cc52c459484 = (queryParams)=>{
    const queryParamRawEntries = Object.entries(queryParams).flatMap((queryParam)=>{
        const [paramKey, value] = queryParam;
        if (value instanceof Date) {
            const dateFormatOptions = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            };
            const dateFormatter = new Intl.DateTimeFormat('en-US', dateFormatOptions);
            const { month: month, day: day, year: year } = Object.fromEntries(dateFormatter.formatToParts(value).map((part)=>[
                    part.type,
                    part.value
                ]));
            return [
                [
                    paramKey,
                    `${year}-${month}-${day}`
                ]
            ];
        }
        if (value === false || value === true) return [
            [
                paramKey,
                String(value)
            ]
        ];
        if (Array.isArray(value)) return [
            [
                paramKey,
                value.join(',')
            ]
        ];
        return [
            [
                paramKey,
                value
            ]
        ];
    }).sort(([firstKey], [secondKey])=>firstKey < secondKey ? 1 : -1);
    return Object.fromEntries(queryParamRawEntries);
};
const $d1c4c8d8da3b5693$export$249cc09c933c4d7a = (queryParams)=>{
    const sanitizedQueryParams = Object.fromEntries(Object.entries(queryParams).filter(([_, value])=>value !== undefined));
    return new URLSearchParams($d1c4c8d8da3b5693$export$fc8e8d0c43c32316($d1c4c8d8da3b5693$export$17404cc52c459484(sanitizedQueryParams))).toString();
};
const $d1c4c8d8da3b5693$export$f30b1e6bbcaec160 = (queryParams)=>{
    return Object.fromEntries($d1c4c8d8da3b5693$export$fc8e8d0c43c32316($d1c4c8d8da3b5693$export$17404cc52c459484(queryParams)));
};
const $d1c4c8d8da3b5693$export$e247f217269cd2eb = (...queryParamArray)=>{
    const queryParamStrings = queryParamArray.map((queryParams)=>$d1c4c8d8da3b5693$export$249cc09c933c4d7a(queryParams));
    const allQueryParamsAreEqual = new Set(queryParamStrings).size === 1;
    return allQueryParamsAreEqual;
};

});


parcelRegister("djVCD", function(module, exports) {

$parcel$export(module.exports, "SearchStoreContainer", () => $674906c2a738886a$export$bf072992274c9fb);
$parcel$export(module.exports, "useSearch", () => $674906c2a738886a$export$bd221a7c56b93941);
$parcel$export(module.exports, "useSearchActions", () => $674906c2a738886a$export$c5a5afdff2ff0385);
$parcel$export(module.exports, "useFilters", () => $674906c2a738886a$export$973ca22476b0e05f);
$parcel$export(module.exports, "useInputQuery", () => $674906c2a738886a$export$da992673b1309795);
$parcel$export(module.exports, "useSearchQuery", () => $674906c2a738886a$export$e985158d10c27e34);
$parcel$export(module.exports, "useOriginalQuery", () => $674906c2a738886a$export$c2380c4d76e63cc4);
$parcel$export(module.exports, "useAutoCorrection", () => $674906c2a738886a$export$ba2ad669c5b27bca);
$parcel$export(module.exports, "useRetryCount", () => $674906c2a738886a$export$140d37088821fcb1);
$parcel$export(module.exports, "useProductResultCountMap", () => $674906c2a738886a$export$275c72361969d62c);
$parcel$export(module.exports, "useQueryInfo", () => $674906c2a738886a$export$34418e307d9100b4);
$parcel$export(module.exports, "useQueryState", () => $674906c2a738886a$export$8a4c65ea4f241b48);
$parcel$export(module.exports, "useQueryUpdatedTime", () => $674906c2a738886a$export$a2b38489a4538322);
$parcel$export(module.exports, "useResults", () => $674906c2a738886a$export$bda9ac73817ceec3);
$parcel$export(module.exports, "useResultsError", () => $674906c2a738886a$export$1c9622ace43d770d);
$parcel$export(module.exports, "useResultsRequestId", () => $674906c2a738886a$export$49f5dec896c355cd);
$parcel$export(module.exports, "useIsLoading", () => $674906c2a738886a$export$4dface15d86304a4);
$parcel$export(module.exports, "useResultsSort", () => $674906c2a738886a$export$f59185497e80e274);
$parcel$export(module.exports, "useQueryVersion", () => $674906c2a738886a$export$e2d0c00df99a687c);
$parcel$export(module.exports, "useResultsState", () => $674906c2a738886a$export$1e51d2073b60bd88);
$parcel$export(module.exports, "useSelectedProducts", () => $674906c2a738886a$export$826bdf756a8bf13a);
$parcel$export(module.exports, "useSelectedProduct", () => $674906c2a738886a$export$387e1da2bc9c93cc);
$parcel$export(module.exports, "useIsJiraHydrationLoading", () => $674906c2a738886a$export$8c11ef422551818);
$parcel$export(module.exports, "useIsCompassTeamsLoading", () => $674906c2a738886a$export$795623048d841bf2);
$parcel$export(module.exports, "useIsSearchReady", () => $674906c2a738886a$export$8dc083eb9766b48);
$parcel$export(module.exports, "usePageEndCursor", () => $674906c2a738886a$export$e80788222dba30a3);
$parcel$export(module.exports, "useFetchFromCursor", () => $674906c2a738886a$export$bedf78a7ab879711);
$parcel$export(module.exports, "useIsLoadingMore", () => $674906c2a738886a$export$f258398dab7c75ba);
$parcel$export(module.exports, "useProducts", () => $674906c2a738886a$export$964e8498268f0fe3);
$parcel$export(module.exports, "getTypeEntities", () => $674906c2a738886a$export$a50dff3bb8b597ca);
$parcel$export(module.exports, "useTypeEntities", () => $674906c2a738886a$export$59086fbf0d8f8d2a);
$parcel$export(module.exports, "useSelectFilterStore", () => $674906c2a738886a$export$aad641f503e4b4a8);
$parcel$export(module.exports, "useBooleanFilterStore", () => $674906c2a738886a$export$c724ec2cbd2fedce);
$parcel$export(module.exports, "useFiltersToDisplay", () => $674906c2a738886a$export$94c94f88577d66b2);
$parcel$export(module.exports, "useSelectedFilterCount", () => $674906c2a738886a$export$754cc306c2d9241e);
$parcel$export(module.exports, "useFilterAttributesForTracking", () => $674906c2a738886a$export$a63314038bf0cbf9);
$parcel$export(module.exports, "useCQL", () => $674906c2a738886a$export$33ca33de08a5b6bb);
$parcel$export(module.exports, "useAnyFilterSelected", () => $674906c2a738886a$export$210935c1afa2c65c);
$parcel$export(module.exports, "useLeapQueryResult", () => $674906c2a738886a$export$1f88edaa1bb97b87);
$parcel$export(module.exports, "useRequestedBackendExperiments", () => $674906c2a738886a$export$64ea42df9468ccc0);
$parcel$export(module.exports, "useJsmIncidentFilterIds", () => $674906c2a738886a$export$5ce42807c47ad171);

var $iFWZA = parcelRequire("iFWZA");
var $2S0Fz = parcelRequire("2S0Fz");
var $gMCSJ = parcelRequire("gMCSJ");
var $4ZoIm = parcelRequire("4ZoIm");

var $dh538 = parcelRequire("dh538");

var $b8N8h = parcelRequire("b8N8h");
var $8LSUr = parcelRequire("8LSUr");
var $2zuvB = parcelRequire("2zuvB");

var $6yNqK = parcelRequire("6yNqK");

var $5iakG = parcelRequire("5iakG");

var $1yEFx = parcelRequire("1yEFx");

var $fZ3l2 = parcelRequire("fZ3l2");

var $gQ44d = parcelRequire("gQ44d");

var $lIbf3 = parcelRequire("lIbf3");

var $fUcm0 = parcelRequire("fUcm0");

var $nnnU7 = parcelRequire("nnnU7");

var $3JX0d = parcelRequire("3JX0d");

var $1ryLq = parcelRequire("1ryLq");
const $674906c2a738886a$var$initialState = {
    // Search Input states
    inputQuery: '',
    searchQuery: '',
    // Product States
    primaryProduct: null,
    // Filter States
    filters: {},
    filterSelectionOrder: [],
    selectedProducts: [],
    availableProducts: [],
    allFilterExcludedProducts: [],
    jsmIncidentFilterIds: [],
    // Rest of store states
    resultsSort: {
        field: 'relevance',
        order: 'DESC'
    },
    retryCount: 0,
    queryVersion: 0,
    queryUpdatedTime: undefined,
    isLoading: false,
    isJiraHydrationLoading: false,
    isCompassTeamsLoading: false,
    shownCount: 0,
    results: undefined,
    resultError: undefined,
    productResultCountMap: null,
    paginationTokens: [],
    isLoadingMore: false,
    leapQuery: {
        loading: false,
        candidates: [],
        titleIndex: 0
    },
    requestedBackendExperiments: undefined
};
const $674906c2a738886a$var$convertQueryParamsToStringArray = (queryParams, keys)=>{
    return keys.reduce((acc, key)=>{
        if (queryParams[key] === undefined) return acc;
        if (Array.isArray(queryParams[key])) return {
            ...acc,
            [key]: queryParams[key]
        };
        if (typeof queryParams[key] === 'string' || typeof queryParams[key] === 'boolean') return {
            ...acc,
            [key]: [
                queryParams[key].toString()
            ]
        };
        return acc;
    }, {});
};
const $674906c2a738886a$var$getUpdatedFilterSelectionOrder = (previousOrder, newFilterId, selected)=>{
    let filterSelectionOrder = new Set([
        ...previousOrder,
        newFilterId
    ]);
    if (!selected) filterSelectionOrder.delete(newFilterId);
    return [
        ...filterSelectionOrder
    ];
};
/**
 * Only these keys can get set before the updateQueryParams loop when updateQueryParams=true in setSearchStoreState
 */ const $674906c2a738886a$var$safeStateKeys = [
    'filterSelectionOrder',
    'resultsSort',
    'retryCount'
];
/**
 * Please use setSearchStoreState instead of setState within the Search Store controller.
 *
 * This is because we treat the URL as the source of truth for some state. Filter value states are set in the URL directly and then we listen to URL state changs to represent them in our state.
 *
 * @param newState - state properties to set
 * @param {boolean} options.updateQueryParams - [false] Whether a setState call should trigger an URL update
 *
 * Notes on updateQueryParams:
 *
 * When false, this function acts like a standard setState
 * When true, this function will allow only the {safeStateKeys} to be set and will then use the provided query/filter etc state to set the URL directly, relying on the URL observer to complete the loop
 *
 * Non-url updates should NEVER trigger the setQueryParams callback. Otherwise, this will cause infinite loops or extra render cycles.
 **/ const $674906c2a738886a$var$setSearchStoreState = (newState, options)=>({ getState: getState, setState: setState }, { setQueryParams: setQueryParams, allFilters: allFilters, config: config, availableProducts: availableProducts })=>{
        // TODO future refactoring: we should instead query the newState object for any URL-state changes, then clean up the setState we perform, then update the URL. Then a consumer of this function will not need to care about any of this and can simply pass `newState` as expected
        if (!options?.updateQueryParams) {
            setState({
                ...newState,
                availableProducts: availableProducts
            });
            return;
        }
        // We still want to set variables in state that do NOT participate in the URL
        // Initially we'll allow-list this set, as the set of filters (the disallow set) will grow over time
        const safeNewState = Object.fromEntries(Object.entries(newState).filter(([key])=>$674906c2a738886a$var$safeStateKeys.includes(key)));
        if (Object.keys(safeNewState).length > 0) setState(safeNewState);
        const { searchQuery: newSearchQuery, inputQuery: newInputQuery } = newState;
        const { inputQuery: oldInputQuery } = getState();
        const { selectedProducts: selectedProducts, filters: allFilterStates } = {
            ...getState(),
            ...newState
        };
        const staticFilters = Object.values(allFilters).filter((f)=>{
            const filterState = f.getInitialState(config).getState();
            return selectedProducts.length === 0 ? filterState.universal : filterState.products.some((product)=>selectedProducts.includes(product));
        });
        const filterQueryParamValues = staticFilters.map((staticFilter)=>{
            const filterState = allFilterStates[staticFilter.id];
            if (!staticFilter.isCompatible(filterState?.id)) return {};
            return staticFilter.withState(filterState, config).queryParams.get();
        });
        const filterQueryParams = Object.assign({}, ...filterQueryParamValues);
        const text = [
            newSearchQuery,
            newInputQuery,
            oldInputQuery
        ].find(Boolean);
        const parsedQueryParams = (0, $lIbf3.parseQueryParams)({
            product: selectedProducts[0],
            text: text !== '' ? text : undefined,
            ...filterQueryParams
        }, {
            commaSeparatedValues: true
        });
        setQueryParams(parsedQueryParams);
    };
const $674906c2a738886a$export$f14fed79ef571627 = $674906c2a738886a$var$setSearchStoreState;
const $674906c2a738886a$var$privateStoreActions = {
    initialiseStore: ()=>async ({ dispatch: dispatch }, { allFilters: allFilters, queryParams: queryParams, config: config, setQueryParams: setQueryParams, availableProducts: availableProducts, allFilterExcludedProducts: allFilterExcludedProducts })=>{
            const { getSelectedProducts: getSelectedProducts, filtersByProduct: filtersByProduct, isMissingProductSelection: isMissingProductSelection } = (0, $1ryLq.FilterUtils)(allFilters, {});
            const selectedProducts = getSelectedProducts(queryParams);
            const cql = queryParams.cql?.toString();
            if (isMissingProductSelection(queryParams)) {
                setQueryParams({
                    ...queryParams,
                    product: selectedProducts[0]
                });
                return;
            }
            const { staticFilterValues: staticFiltersByProduct } = filtersByProduct(selectedProducts);
            const resolvedQueryParams = await Promise.allSettled(staticFiltersByProduct.map((staticFilter)=>{
                const queryParamsKeys = [
                    staticFilter.queryParams.key
                ];
                if (staticFilter.isSupportCustomValue && staticFilter.customValueFields) queryParamsKeys.push(...staticFilter.customValueFields);
                return staticFilter.getInitialState(config).queryParams.set($674906c2a738886a$var$convertQueryParamsToStringArray(queryParams, queryParamsKeys));
            }));
            const filterStatesByProduct = resolvedQueryParams.flatMap((promise)=>{
                switch(promise.status){
                    case 'fulfilled':
                        return [
                            promise.value.getState()
                        ];
                    case 'rejected':
                        return [];
                }
            });
            const { filterStates: filterStates } = (0, $1ryLq.FilterUtils)(staticFiltersByProduct, filterStatesByProduct);
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filters: filterStates,
                selectedProducts: selectedProducts,
                inputQuery: String(queryParams.text ?? ''),
                searchQuery: String(queryParams.text ?? ''),
                originalQuery: String(queryParams.originalQuery ?? ''),
                availableProducts: availableProducts,
                allFilterExcludedProducts: allFilterExcludedProducts,
                cql: cql
            }, {
                updateQueryParams: false
            }));
        },
    updateStore: ()=>async ({ dispatch: dispatch, getState: getState }, { allFilters: allFilters, queryParams: queryParams, config: config, availableProducts: availableProducts })=>{
            const { filters: filterStates } = getState();
            const { getSelectedProducts: getSelectedProducts, filtersByProduct: filtersByProduct } = (0, $1ryLq.FilterUtils)(allFilters, filterStates);
            const selectedProducts = getSelectedProducts(queryParams);
            const cql = queryParams.cql?.toString();
            const { staticFilterValues: staticFiltersByProduct, filterStates: filterStatesByProduct } = filtersByProduct(selectedProducts);
            const resolvedQueryParams = await Promise.allSettled(staticFiltersByProduct.map((staticFilter)=>{
                const filterState = filterStatesByProduct[staticFilter.id];
                const queryParamsKeys = [
                    staticFilter.queryParams.key
                ];
                if (staticFilter.isSupportCustomValue && staticFilter.customValueFields) queryParamsKeys.push(...staticFilter.customValueFields);
                const queryParamStringArray = $674906c2a738886a$var$convertQueryParamsToStringArray(queryParams, queryParamsKeys);
                if (!staticFilter.isCompatible(filterState?.id)) return staticFilter.getInitialState(config).queryParams.set(queryParamStringArray);
                return staticFilter.withState(filterState, config).queryParams.set(queryParamStringArray);
            }));
            const fullfilledFilterStates = resolvedQueryParams.flatMap((promise)=>{
                switch(promise.status){
                    case 'fulfilled':
                        return [
                            promise.value.getState()
                        ];
                    case 'rejected':
                        return [];
                }
            });
            const { getFiltersWithSelection: getFiltersWithSelection, filterStates: resolvedFilterStates } = (0, $1ryLq.FilterUtils)(staticFiltersByProduct, fullfilledFilterStates);
            // In order, ensure all filters with values are added to selection
            // Ensures filters enter selection order from resume-from-url
            // TODO: this should be done with the global ordering, but we don't have that in constants yet
            let { filterSelectionOrder: filterSelectionOrder } = getState();
            getFiltersWithSelection().map((filterId)=>{
                filterSelectionOrder = $674906c2a738886a$var$getUpdatedFilterSelectionOrder(filterSelectionOrder, filterId, resolvedFilterStates[filterId]?.hasSelection);
            });
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filters: resolvedFilterStates,
                selectedProducts: getSelectedProducts(queryParams),
                filterSelectionOrder: filterSelectionOrder,
                inputQuery: String(queryParams.text ?? ''),
                searchQuery: String(queryParams.text ?? ''),
                originalQuery: String(queryParams.originalQuery ?? ''),
                availableProducts: availableProducts,
                paginationTokens: [],
                cql: cql
            }, {
                updateQueryParams: false
            }));
        },
    setFilter: (state, shouldSetQueryParams)=>async ({ dispatch: dispatch, getState: getState }, { allFilters: allFilters, config: config })=>{
            const staticFilter = allFilters[state.id];
            const { filters: allFiltersState } = getState();
            if (!staticFilter.isCompatible(staticFilter.id)) return;
            const filterWithState = staticFilter.withState(state, config).getState();
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filters: {
                    ...allFiltersState,
                    [staticFilter.id]: filterWithState
                }
            }, {
                updateQueryParams: shouldSetQueryParams
            }));
        },
    updateFilterSelectionOrder: (filterId, selected)=>async ({ dispatch: dispatch, getState: getState })=>{
            const { filterSelectionOrder: oldSelectionOrder } = getState();
            const newFilterSelectionOrder = $674906c2a738886a$var$getUpdatedFilterSelectionOrder(oldSelectionOrder, filterId, selected);
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filterSelectionOrder: newFilterSelectionOrder
            }));
        }
};
const $674906c2a738886a$export$e324594224ef24da = {
    loadInitialSelectFilterOptions: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $nnnU7.isSelectFilter)(staticSelectFilter.type)) return;
            const newFilter = staticSelectFilter.withState(filterState, config);
            await newFilter.loadInitialOptions((stateChange)=>{
                dispatch($674906c2a738886a$var$privateStoreActions.setFilter(stateChange));
            });
        },
    clearSelectFilterOptions: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $nnnU7.isSelectFilter)(staticSelectFilter.type)) return;
            const newFilterState = staticSelectFilter.withState(filterState, config).clear().getState();
            dispatch($674906c2a738886a$var$privateStoreActions.setFilter(newFilterState, true));
            dispatch($674906c2a738886a$var$privateStoreActions.updateFilterSelectionOrder(props.filterId, newFilterState.hasSelection));
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: null
            }));
        },
    setSelectFilterOption: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $nnnU7.isSelectFilter)(staticSelectFilter.type)) return;
            const newFilterState = staticSelectFilter.withState(filterState, config).setOption(props.optionChange, props.customValue).getState();
            dispatch($674906c2a738886a$var$privateStoreActions.setFilter(newFilterState, true));
            dispatch($674906c2a738886a$var$privateStoreActions.updateFilterSelectionOrder(props.filterId, newFilterState.hasSelection));
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: null
            }));
        },
    setSelectFilterLookupInput: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $nnnU7.isSelectFilter)(staticSelectFilter.type)) return;
            await staticSelectFilter.withState(filterState, config).setLookupInput(props.query, (stateChange)=>{
                dispatch($674906c2a738886a$var$privateStoreActions.setFilter(stateChange));
            });
        },
    setBooleanFilterValue: (props, privateActions = $674906c2a738886a$var$privateStoreActions)=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticBooleanFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticBooleanFilter.isCompatible(filterState?.id)) return;
            if (staticBooleanFilter.type !== 'boolean') return;
            const newBooleanFilterState = staticBooleanFilter.withState(filterState, config).setValue(props.value).getState();
            dispatch(privateActions.setFilter(newBooleanFilterState, true));
            dispatch(privateActions.updateFilterSelectionOrder(props.filterId, newBooleanFilterState.hasSelection));
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: null
            }));
        },
    clearAllFilters: ()=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const { filters: allFilterStates } = getState();
            const staticFilters = Object.values(allFilters);
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filters: $674906c2a738886a$var$clearFilters(allFilterStates, staticFilters, config),
                selectedProducts: [],
                filterSelectionOrder: []
            }, {
                updateQueryParams: true
            }));
        },
    clearAllAvailableFilters: ()=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticFilters = Object.values(allFilters);
            const { filters: allFilterStates } = getState();
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filters: $674906c2a738886a$var$clearFilters(allFilterStates, staticFilters, config),
                filterSelectionOrder: []
            }, {
                updateQueryParams: true
            }));
        },
    // Product filter actions
    selectProductFilter: (productKey)=>({ getState: getState, dispatch: dispatch })=>{
            const { selectedProducts: selectedProducts, filters: filters, filterSelectionOrder: filterSelectionOrder } = getState();
            if (productKey && selectedProducts.includes(productKey)) return;
            const persistedFilters = {};
            // Persist selected universal filters if they are relevant to the selected product
            for (const [id, filter] of Object.entries(filters)){
                if (!filter) continue;
                if (filter.universal && filter.hasSelection && (!productKey || productKey && filter.products.includes(productKey))) persistedFilters[id] = filter;
            }
            // Type is a universal filter, but type needs to be cleared if we're filtering away from Atlas
            // This is because selecting a global noun sets product AND type values
            if (selectedProducts.includes((0, $1yEFx.ProductKeys).Atlas)) delete persistedFilters[0, $5iakG.universalTypeFilterId];
            // Universal filters being persisted also retain their ordering
            const newFilterSelectionOrder = filterSelectionOrder.filter((f)=>{
                return Object.keys(persistedFilters).includes(f);
            });
            dispatch($674906c2a738886a$var$setSearchStoreState({
                selectedProducts: productKey ? [
                    productKey
                ] : [],
                filterSelectionOrder: newFilterSelectionOrder,
                filters: persistedFilters,
                resultsSort: $674906c2a738886a$var$initialState.resultsSort
            }, {
                updateQueryParams: true
            }));
        },
    unselectProductFilter: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$export$e324594224ef24da.selectProductFilter(undefined));
        },
    // Search Input Actions
    setInputQuery: (inputQuery)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                inputQuery: inputQuery.trim()
            }));
        },
    setSearchQuery: (searchQuery)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                searchQuery: searchQuery.trim()
            }, {
                updateQueryParams: true
            }));
        },
    triggerSearch: ()=>({ getState: getState, dispatch: dispatch })=>{
            const { inputQuery: inputQuery, searchQuery: searchQuery, retryCount: retryCount, productResultCountMap: productResultCountMap } = getState();
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: searchQuery === inputQuery ? productResultCountMap : null
            }));
            dispatch($674906c2a738886a$var$setSearchStoreState({
                searchQuery: inputQuery,
                retryCount: searchQuery === inputQuery ? retryCount + 1 : 0
            }, {
                updateQueryParams: true
            }));
        },
    retrySearch: ()=>({ dispatch: dispatch, getState: getState })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                retryCount: getState().retryCount + 1
            }));
        },
    // Sorting actions
    setSortField: (sortField)=>({ dispatch: dispatch, getState: getState })=>{
            const { resultsSort: resultsSort } = getState();
            dispatch($674906c2a738886a$var$setSearchStoreState({
                resultsSort: {
                    ...resultsSort,
                    field: sortField
                },
                paginationTokens: []
            }));
        },
    setSortOrder: (sortOrder)=>({ dispatch: dispatch, getState: getState })=>{
            const { resultsSort: resultsSort } = getState();
            dispatch($674906c2a738886a$var$setSearchStoreState({
                resultsSort: {
                    ...resultsSort,
                    order: sortOrder
                },
                paginationTokens: []
            }));
        },
    resetSort: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                resultsSort: $674906c2a738886a$var$initialState.resultsSort,
                paginationTokens: []
            }));
        },
    // Rest of Search Actions
    setQueryUpdatedTime: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                queryUpdatedTime: Date.now()
            }));
        },
    resetQueryVersion: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                queryVersion: 0
            }));
        },
    incrementQueryVersion: ()=>({ getState: getState, setState: setState })=>{
            const { queryVersion: queryVersion } = getState();
            setState({
                queryVersion: queryVersion + 1
            });
        },
    setIsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isLoading: isLoading
            }));
        },
    // Results actions
    setResults: (results, error, requestId)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isLoading: false,
                results: results,
                resultError: error,
                requestId: requestId
            }));
        },
    appendMoreResults: (results)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: currentResults } = getState();
            if (!currentResults || !results) return;
            const currentEdges = currentResults.edges;
            const newEdges = results.edges;
            const newResults = {
                ...currentResults,
                edges: currentEdges.concat(newEdges),
                pageInfo: results?.pageInfo
            };
            dispatch($674906c2a738886a$var$setSearchStoreState({
                results: newResults,
                isLoadingMore: false
            }));
        },
    setFetchFromCursor: (cursor)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                paginationTokens: [
                    {
                        cursor: cursor
                    }
                ]
            }));
        },
    setIsLoadingMore: (isLoadingMore)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isLoadingMore: isLoadingMore
            }));
        },
    setJiraIssueFieldsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isJiraHydrationLoading: isLoading
            }));
        },
    setJiraIssueDetails: (issueData)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: results } = getState();
            let hydratedResults = [];
            if (results?.edges && results.edges.length > 0 && issueData.length > 0) {
                // TODO: fix colorName being passed twice with inconsistent values, see the unit test for context
                hydratedResults = [
                    ...results.edges
                ].map((edge)=>{
                    if ((0, $8LSUr.isSearchResultJiraIssue)(edge.node)) {
                        const id = edge.node.id;
                        const hydratedIssue = issueData.find((issue)=>issue.id === id);
                        if (edge.node.status && hydratedIssue) {
                            edge.node.status.name = hydratedIssue.statusField.status.name;
                            edge.node.status.colorName = hydratedIssue.statusField.status.statusCategory?.colorName;
                        }
                    }
                    return edge;
                });
                dispatch($674906c2a738886a$var$setSearchStoreState({
                    results: {
                        ...results,
                        edges: hydratedResults
                    }
                }));
            }
        },
    setCompassTeamsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isCompassTeamsLoading: isLoading
            }));
        },
    setCompassTeams: (teamData)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: results } = getState();
            let resultsWithTeamNames = [];
            if (results?.edges && results.edges.length > 0 && teamData.length > 0) {
                resultsWithTeamNames = [
                    ...results.edges
                ].map((edge)=>{
                    if ((0, $b8N8h.isSearchCompassPartial)(edge.node)) {
                        const teamId = (0, $fUcm0.getTeamId)(edge.node.ownerId);
                        const team = teamData.find((team)=>team.id === teamId);
                        edge.node.ownerName = team?.displayName;
                    }
                    return edge;
                });
                dispatch($674906c2a738886a$var$setSearchStoreState({
                    results: {
                        ...results,
                        edges: resultsWithTeamNames
                    }
                }));
            }
        },
    resetResults: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isLoading: false,
                shownCount: 0,
                results: undefined,
                resultError: undefined,
                requestId: undefined
            }));
        },
    setAutoCorrection: (autoCorrection)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                autoCorrection: autoCorrection
            }));
        },
    setLeapQuery: ({ candidates: candidates, titleIndex: titleIndex, loading: loading })=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                leapQuery: {
                    loading: loading,
                    candidates: candidates,
                    titleIndex: titleIndex
                }
            }));
        },
    setProductResultCount: (totalCounts)=>({ dispatch: dispatch, getState: getState })=>{
            if (totalCounts === undefined) {
                dispatch($674906c2a738886a$var$setSearchStoreState({
                    productResultCountMap: null
                }));
                return;
            }
            const { filters: filterStates, availableProducts: availableProducts, productResultCountMap: oldProductResultCountMap } = getState();
            const filtersWithSelection = Object.values(filterStates).filter((filter)=>filter?.hasSelection);
            const productsCorrespondingToAllSelectedFilters = filtersWithSelection.length ? availableProducts.filter((product)=>filtersWithSelection.every((filter)=>filter?.products?.includes(product))) : availableProducts;
            const resultsCountsAdjustedForSelectedFilters = totalCounts.map((resultCount)=>{
                if (productsCorrespondingToAllSelectedFilters.includes(resultCount.product)) return resultCount;
                else return {
                    ...resultCount,
                    count: 0
                };
            });
            const productResultCountMap = resultsCountsAdjustedForSelectedFilters.reduce((acc, { product: product, count: count })=>{
                if (product) acc[product] = count;
                return acc;
            }, {});
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: {
                    ...oldProductResultCountMap,
                    ...productResultCountMap
                }
            }));
        },
    // For backwards compatibility
    clearHybridFilters: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$export$e324594224ef24da.clearAllFilters());
        },
    /**
	 * Considered unsafe since it's using queryParams to change the state.
	 * Ideally we should set it directly in the state, but that requires introducing a new action.
	 * This is because the cooresponding "Type" filter that this selects isn't available or easy to set from outside
	 * The product=townsquare&type=project will correctly hydrate the filter from the URL after params are set though!
	 *
	 * We hope to improve Atlassian Home / global noun handling after GA
	 *
	 * @param value: a noun to be set
	 */ unsafe_setAtlasNouns: (value)=>({ dispatch: dispatch }, { queryParams: queryParams, setQueryParams: setQueryParams })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: null
            }));
            if (!value) {
                const { product: product, type: type, ...queryParamsWithResetNounFilter } = queryParams;
                setQueryParams({
                    ...queryParamsWithResetNounFilter
                });
            } else {
                const { text: text, originalQuery: originalQuery, lastModified: lastModified } = queryParams;
                // We explicitly only keep text and lastModified
                setQueryParams({
                    product: (0, $1yEFx.ProductKeys).Atlas,
                    type: value,
                    text: text,
                    originalQuery: originalQuery,
                    lastModified: lastModified
                });
            }
        },
    setRequestedBackendExperiments: (requestedBackendExperiments)=>({ setState: setState })=>{
            const experimentLayers = requestedBackendExperiments?.experimentLayers?.map((layer)=>{
                const { analyticsDefinitions: analyticsDefinitions, definitions: definitions, ...rest } = layer;
                return {
                    ...rest,
                    definitions: analyticsDefinitions
                };
            });
            setState({
                requestedBackendExperiments: {
                    experimentLayers: experimentLayers
                }
            });
        },
    setJsmIncidentFilterIds: (jsmIncidentFilterIds)=>({ getState: getState, setState: setState })=>{
            if (getState().jsmIncidentFilterIds === jsmIncidentFilterIds) return;
            setState({
                jsmIncidentFilterIds: jsmIncidentFilterIds
            });
        }
};
const $674906c2a738886a$var$clearFilters = (allFilterStates, filters, config)=>{
    const clearedFilters = filters.map((filter)=>{
        const filterState = allFilterStates[filter.id];
        if (!filter.isCompatible(filterState?.id)) return [];
        return [
            filter.id,
            filter.withState(filterState, config).clear().getState()
        ];
    });
    return Object.fromEntries(clearedFilters);
};
// Keep store private and use hooks to access state and actions
const $674906c2a738886a$var$Store = (0, $4ZoIm.createStore)({
    initialState: $674906c2a738886a$var$initialState,
    actions: $674906c2a738886a$export$e324594224ef24da,
    name: 'search'
});
const $674906c2a738886a$export$b8f9c0e048639dd4 = (0, $iFWZA.createActionsHook)($674906c2a738886a$var$Store);
const $674906c2a738886a$export$bf072992274c9fb = (0, $2S0Fz.createContainer)($674906c2a738886a$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$privateStoreActions.initialiseStore());
        },
    onUpdate: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$privateStoreActions.updateStore());
        },
    onCleanup: ()=>({ setState: setState })=>{
            setState($674906c2a738886a$var$initialState);
        }
});
const $674906c2a738886a$export$bd221a7c56b93941 = (0, $iFWZA.createHook)($674906c2a738886a$var$Store);
const $674906c2a738886a$export$c5a5afdff2ff0385 = (0, $iFWZA.createActionsHook)($674906c2a738886a$var$Store);
const $674906c2a738886a$export$973ca22476b0e05f = (0, $iFWZA.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.filters
});
const $674906c2a738886a$export$da992673b1309795 = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.inputQuery
});
const $674906c2a738886a$export$e985158d10c27e34 = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.searchQuery
});
const $674906c2a738886a$export$c2380c4d76e63cc4 = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.originalQuery
});
const $674906c2a738886a$export$ba2ad669c5b27bca = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.autoCorrection
});
const $674906c2a738886a$export$140d37088821fcb1 = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.retryCount
});
const $674906c2a738886a$export$275c72361969d62c = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.productResultCountMap
});
const $674906c2a738886a$export$14279a3fbdb52451 = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.results?.abTest
});
const $674906c2a738886a$export$34418e307d9100b4 = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.results?.queryInfo
});
const $674906c2a738886a$export$8a4c65ea4f241b48 = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.searchQuery ? (0, $6yNqK.QueryState).POSTQUERY : (0, $6yNqK.QueryState).PREQUERY
});
const $674906c2a738886a$export$a2b38489a4538322 = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.queryUpdatedTime
});
const $674906c2a738886a$export$bda9ac73817ceec3 = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.results
});
const $674906c2a738886a$export$1c9622ace43d770d = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.resultError
});
const $674906c2a738886a$export$49f5dec896c355cd = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.requestId
});
const $674906c2a738886a$export$4dface15d86304a4 = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.isLoading
});
const $674906c2a738886a$export$f59185497e80e274 = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.resultsSort
});
const $674906c2a738886a$export$e2d0c00df99a687c = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.queryVersion
});
const $674906c2a738886a$export$5f38673942a99ffe = (0, $iFWZA.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.allFilterExcludedProducts
});
const $674906c2a738886a$export$1e51d2073b60bd88 = (0, $iFWZA.createStateHook)($674906c2a738886a$var$Store, {
    selector: (0, $gMCSJ.createSelector)([
        (state)=>state.results,
        (state)=>state.isLoading,
        (state)=>state.resultError
    ], (results, isLoading, resultError)=>$674906c2a738886a$export$71923aa45c7aa566({
            results: results,
            isLoading: isLoading,
            resultError: resultError
        }))
});
const $674906c2a738886a$export$71923aa45c7aa566 = ({ results: results, isLoading: isLoading, resultError: resultError })=>{
    if (isLoading) return (0, $fZ3l2.ResultsStates).IS_LOADING;
    if (results && results.edges && results.edges.length > 0) return (0, $fZ3l2.ResultsStates).RESULTS;
    // If there are no entities for a query, an error will throw
    // when no entities for query is equivalent to no results
    if (resultError instanceof (0, $gQ44d.EmptyEntitiesError) || results && (results.edges ?? []).length === 0) return (0, $fZ3l2.ResultsStates).NO_RESULTS;
    if (resultError) return (0, $fZ3l2.ResultsStates).ERROR;
    if (!results) return (0, $fZ3l2.ResultsStates).INITIAL;
    return (0, $fZ3l2.ResultsStates).ERROR;
};
const $674906c2a738886a$export$826bdf756a8bf13a = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.selectedProducts
});
const $674906c2a738886a$export$387e1da2bc9c93cc = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.selectedProducts[0]
});
const $674906c2a738886a$export$8c11ef422551818 = (0, $iFWZA.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.isJiraHydrationLoading
});
const $674906c2a738886a$export$795623048d841bf2 = (0, $iFWZA.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.isCompassTeamsLoading
});
const $674906c2a738886a$export$8dc083eb9766b48 = (0, $iFWZA.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.availableProducts && state.availableProducts.length > 0
});
const $674906c2a738886a$export$e80788222dba30a3 = (0, $iFWZA.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.results?.pageInfo?.endCursor
});
const $674906c2a738886a$export$bedf78a7ab879711 = (0, $iFWZA.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.paginationTokens[0]?.cursor
});
const $674906c2a738886a$export$f258398dab7c75ba = (0, $iFWZA.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.isLoadingMore
});
const $674906c2a738886a$export$964e8498268f0fe3 = (0, $iFWZA.createStateHook)($674906c2a738886a$var$Store, {
    selector: (0, $gMCSJ.createSelector)([
        (state)=>state.selectedProducts,
        (state)=>state.availableProducts
    ], (selectedProducts, availableProducts)=>{
        return {
            selectedProduct: selectedProducts.at(0),
            filteredProducts: selectedProducts[0] ? [
                selectedProducts[0]
            ] : availableProducts,
            availableProducts: availableProducts
        };
    })
});
const $674906c2a738886a$export$6466dd1b74ba3dff = (productsToSearch, typeFilter, thirdPartyConfigs, availableProducts, dropAttachmentsComments)=>{
    // This early return is to appease Typescript. The typeFilter is always defined and is always single select.
    if (!typeFilter || !(typeFilter.type === 'single-select')) return {
        selectedEntities: [],
        entitiesForQuery: [],
        entitiesForResultsCountQuery: []
    };
    const defaultOptionValue = typeFilter.options?.find((option)=>option.isDefault)?.value;
    const selectedTypes = typeFilter.value.filter((value)=>value !== defaultOptionValue).filter(Boolean);
    const { entitiesForQuery: entitiesForQuery, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $3JX0d.getEntitiesForQuery)(productsToSearch, selectedTypes, thirdPartyConfigs, availableProducts, dropAttachmentsComments);
    return {
        selectedEntities: selectedTypes,
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery
    };
};
const $674906c2a738886a$export$a50dff3bb8b597ca = ({ availableProducts: availableProducts, filters: filters, selectedProducts: selectedProducts, allFilterExcludedProducts: allFilterExcludedProducts }, { thirdPartyConfigs: thirdPartyConfigs, dropAttachmentsComments: dropAttachmentsComments })=>{
    // Filter out excluded products from "All" filter
    const allFilterIncludedProducts = availableProducts.filter((product)=>!allFilterExcludedProducts.includes(product));
    const productsToSearch = selectedProducts[0] ? [
        selectedProducts[0]
    ] : allFilterIncludedProducts;
    const typeFilter = filters[0, $5iakG.universalTypeFilterId];
    return $674906c2a738886a$export$6466dd1b74ba3dff(productsToSearch, typeFilter, thirdPartyConfigs, availableProducts, dropAttachmentsComments);
};
const $674906c2a738886a$export$59086fbf0d8f8d2a = (0, $iFWZA.createStateHook)($674906c2a738886a$var$Store, {
    selector: (0, $gMCSJ.createSelector)([
        (state)=>state.availableProducts,
        (state)=>state.selectedProducts,
        (state)=>state.allFilterExcludedProducts,
        (state)=>state.filters[0, $5iakG.universalTypeFilterId],
        (_, props)=>props
    ], (availableProducts, selectedProducts, allFilterExcludedProducts, typeFilter, props)=>{
        const { thirdPartyConfigs: thirdPartyConfigs, dropAttachmentsComments: dropAttachmentsComments } = props;
        // Filter out excluded products from "All" filter
        const allFilterIncludedProducts = availableProducts.filter((product)=>!allFilterExcludedProducts.includes(product));
        const productsToSearch = selectedProducts[0] ? [
            selectedProducts[0]
        ] : allFilterIncludedProducts;
        return $674906c2a738886a$export$6466dd1b74ba3dff(productsToSearch, typeFilter, thirdPartyConfigs, availableProducts, dropAttachmentsComments);
    })
});
const $674906c2a738886a$export$aad641f503e4b4a8 = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state, props)=>{
        const filter = state.filters[props.filterId];
        if (filter === undefined) return undefined;
        if (!(0, $nnnU7.isSelectFilter)(filter.type)) throw new Error('Not a select filter');
        return {
            ...filter,
            selectedProducts: state.selectedProducts,
            availableProducts: state.availableProducts,
            allFilterExcludedProducts: state.allFilterExcludedProducts
        };
    }
});
const $674906c2a738886a$export$c724ec2cbd2fedce = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state, props)=>{
        const filter = state.filters[props.filterId];
        if (filter === undefined) return undefined;
        if (filter?.type !== 'boolean') throw new Error('Not a boolean filter');
        return filter;
    }
});
const $674906c2a738886a$export$1c5018e1c1ce99ae = (filters)=>{
    const filterIdOrdering = (0, $5iakG.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        return filter && filter.universal ? [
            filter
        ] : [];
    });
};
const $674906c2a738886a$export$a8734449e402b6ca = (filters, selectedProducts)=>{
    const filterIdOrdering = (0, $5iakG.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        if (filter && f === 'content' && selectedProducts.includes((0, $1yEFx.ProductKeys).ConfluenceDC)) return (0, $dh538.fg)('confluence-dc-content-filter') ? [
            filter
        ] : [];
        else return filter && selectedProducts.some((product)=>filter?.products.includes(product)) ? [
            filter
        ] : [];
    });
};
/**
 * All available filters in the initial ordering
 */ const $674906c2a738886a$var$getAllAvailableFilters = (filters, selectedProducts)=>{
    return selectedProducts.length === 0 ? $674906c2a738886a$export$1c5018e1c1ce99ae(filters) : $674906c2a738886a$export$a8734449e402b6ca(filters, selectedProducts);
};
/**
 * All available filters are always returned for inline, but the ordering depends on selection
 * The caller UI is responsible for deciding how many can be rendered by available width
 */ const $674906c2a738886a$var$getFilterIdsForInline = (filters, selectedProducts, filterSelectionOrder)=>{
    const allAvailableFilterIds = $674906c2a738886a$var$getAllAvailableFilters(filters, selectedProducts).map((a)=>a.id);
    // using the selection order, filter from the available (removes any invalid filters to show)
    let filtersForInline = filterSelectionOrder.filter((f)=>allAvailableFilterIds.includes(f));
    // then simply add the rest back (with a set for deduplication)
    return [
        ...new Set([
            ...filtersForInline,
            ...allAvailableFilterIds
        ])
    ];
};
const $674906c2a738886a$export$94c94f88577d66b2 = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: ({ filters: filters, selectedProducts: selectedProducts, filterSelectionOrder: filterSelectionOrder })=>{
        // All filters always show in the dropdown, in order
        const filtersInDropdown = $674906c2a738886a$var$getAllAvailableFilters(filters, selectedProducts).map((f)=>f.id);
        const filtersInLine = $674906c2a738886a$var$getFilterIdsForInline(filters, selectedProducts, filterSelectionOrder);
        return {
            filtersInDropdown: filtersInDropdown,
            filtersInLine: filtersInLine,
            filterSelectionOrder: filterSelectionOrder
        };
    }
});
const $674906c2a738886a$export$754cc306c2d9241e = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: ({ selectedProducts: selectedProducts, filters: filters, resultsSort: resultsSort })=>{
        const selectedFilters = Object.values(filters).filter((filter)=>filter?.hasSelection).filter((filter)=>{
            const isAtlasSelected = selectedProducts.includes((0, $1yEFx.ProductKeys).Atlas);
            const isTypeFilter = filter?.id === (0, $5iakG.universalTypeFilterId);
            return isAtlasSelected ? !isTypeFilter : true;
        });
        const { field: field } = resultsSort;
        const isNotSortedByDefault = field !== (0, $2zuvB.SORT_FIELD_KEY).RELEVANCE;
        return {
            selectedFilterCount: selectedFilters.length + (isNotSortedByDefault ? 1 : 0)
        };
    }
});
const $674906c2a738886a$export$a63314038bf0cbf9 = (0, $iFWZA.createStateHook)($674906c2a738886a$var$Store, {
    selector: ({ filters: filters })=>{
        const filterAttributes = Object.values(filters).flatMap((filter)=>{
            return filter ? [
                filter
            ] : [];
        }).map((filter)=>{
            const filterType = filter.type;
            switch(filterType){
                case 'boolean':
                    return {
                        filters: [
                            filter.id
                        ],
                        filterSelections: filter.value ? [
                            {
                                value: String(filter.value),
                                isSmartDefault: false,
                                filterId: filter.id
                            }
                        ] : []
                    };
                case 'multi-select':
                case 'single-select':
                    return {
                        filters: [
                            filter.id
                        ],
                        filterSelections: filter.options.filter((filterOption)=>filterOption.isSelected).map((filterOption)=>({
                                value: filterOption.trackingKey || filterOption.value,
                                isSmartDefault: filterOption.isSuggested,
                                filterId: filter.id
                            }))
                    };
                default:
                    return filterType;
            }
        }).filter((attributes)=>attributes.filterSelections.length).reduce((acc, curr)=>{
            return {
                filters: [
                    ...acc.filters,
                    ...curr.filters
                ],
                filterSelections: [
                    ...acc.filterSelections,
                    ...curr.filterSelections
                ]
            };
        }, {
            filters: [],
            filterSelections: []
        });
        return filterAttributes;
    }
});
const $674906c2a738886a$export$33ca33de08a5b6bb = (0, $iFWZA.createStateHook)($674906c2a738886a$var$Store, {
    selector: ({ cql: cql })=>cql
});
const $674906c2a738886a$export$210935c1afa2c65c = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: ({ selectedProducts: selectedProducts, filters: filters })=>{
        const hasSelectedProduct = selectedProducts[0];
        if (hasSelectedProduct) return true;
        return Object.values(filters).some((filter)=>filter?.hasSelection);
    }
});
const $674906c2a738886a$export$1f88edaa1bb97b87 = (0, $iFWZA.createStateHook)($674906c2a738886a$var$Store, {
    selector: ({ leapQuery: leapQuery })=>leapQuery
});
const $674906c2a738886a$export$64ea42df9468ccc0 = (0, $iFWZA.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>({
            backendExperiments: state.requestedBackendExperiments
        })
});
const $674906c2a738886a$export$5ce42807c47ad171 = (0, $iFWZA.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.jsmIncidentFilterIds
});

});
parcelRegister("b8N8h", function(module, exports) {

$parcel$export(module.exports, "getCompassPartials", () => $a1dfc2d141dab226$export$72cf2e1294c50ff4);
$parcel$export(module.exports, "isSearchCompassPartial", () => $a1dfc2d141dab226$export$b8968ce5f9785283);
const $a1dfc2d141dab226$var$SearchResultCompassComponent = `
... on SearchResultCompassComponent {
	lastModifiedDate
	ownerId
	tier
	component {
		description
		state
	}
}
`;
const $a1dfc2d141dab226$export$72cf2e1294c50ff4 = ()=>{
    return $a1dfc2d141dab226$var$SearchResultCompassComponent;
};
const $a1dfc2d141dab226$export$b8968ce5f9785283 = (partial)=>{
    return partial.__typename === 'SearchResultCompassComponent';
};

});

parcelRegister("2zuvB", function(module, exports) {

$parcel$export(module.exports, "SORT_FIELD_KEY", () => $46c1a866454c924b$export$fdf34174678f07b6);
$parcel$export(module.exports, "RESULTS_SORT_FIELDS", () => $46c1a866454c924b$export$6b492fdcc7e8d1f4);
$parcel$export(module.exports, "ResultsSortOptions", () => $46c1a866454c924b$export$76673e1b214c1378);
$parcel$export(module.exports, "getOptionKey", () => $46c1a866454c924b$export$d3cbda30e53df6f6);
const $46c1a866454c924b$export$fdf34174678f07b6 = {
    RELEVANCE: 'relevance',
    LAST_MODIFIED_DATE: 'latestModifiedDate',
    CREATED_DATE: 'createdDate'
};
const $46c1a866454c924b$export$d33cb9b119034d29 = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $46c1a866454c924b$var$SORT_FIELD_KEY_RELEVANCE_DESC = `${$46c1a866454c924b$export$fdf34174678f07b6.RELEVANCE}${$46c1a866454c924b$export$d33cb9b119034d29.DESC}`;
const $46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC = `${$46c1a866454c924b$export$fdf34174678f07b6.LAST_MODIFIED_DATE}${$46c1a866454c924b$export$d33cb9b119034d29.DESC}`;
const $46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC = `${$46c1a866454c924b$export$fdf34174678f07b6.LAST_MODIFIED_DATE}${$46c1a866454c924b$export$d33cb9b119034d29.ASC}`;
const $46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_DESC = `${$46c1a866454c924b$export$fdf34174678f07b6.CREATED_DATE}${$46c1a866454c924b$export$d33cb9b119034d29.DESC}`;
const $46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_ASC = `${$46c1a866454c924b$export$fdf34174678f07b6.CREATED_DATE}${$46c1a866454c924b$export$d33cb9b119034d29.ASC}`;
const $46c1a866454c924b$export$6b492fdcc7e8d1f4 = {
    [$46c1a866454c924b$var$SORT_FIELD_KEY_RELEVANCE_DESC]: {
        field: $46c1a866454c924b$export$fdf34174678f07b6.RELEVANCE,
        order: $46c1a866454c924b$export$d33cb9b119034d29.DESC,
        labelKey: $46c1a866454c924b$var$SORT_FIELD_KEY_RELEVANCE_DESC,
        selectedLabelKey: `${$46c1a866454c924b$var$SORT_FIELD_KEY_RELEVANCE_DESC}Selected`,
        drawerOrder: 0
    },
    [$46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC]: {
        field: $46c1a866454c924b$export$fdf34174678f07b6.LAST_MODIFIED_DATE,
        order: $46c1a866454c924b$export$d33cb9b119034d29.DESC,
        labelKey: $46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC,
        selectedLabelKey: `${$46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC}Selected`,
        drawerOrder: 1
    },
    [$46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC]: {
        field: $46c1a866454c924b$export$fdf34174678f07b6.LAST_MODIFIED_DATE,
        order: $46c1a866454c924b$export$d33cb9b119034d29.ASC,
        labelKey: $46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC,
        selectedLabelKey: `${$46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC}Selected`,
        drawerOrder: 2
    },
    [$46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_DESC]: {
        field: $46c1a866454c924b$export$fdf34174678f07b6.CREATED_DATE,
        order: $46c1a866454c924b$export$d33cb9b119034d29.DESC,
        labelKey: $46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_DESC,
        selectedLabelKey: `${$46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_DESC}Selected`,
        drawerOrder: 3
    },
    [$46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_ASC]: {
        field: $46c1a866454c924b$export$fdf34174678f07b6.CREATED_DATE,
        order: $46c1a866454c924b$export$d33cb9b119034d29.ASC,
        labelKey: $46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_ASC,
        selectedLabelKey: `${$46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_ASC}Selected`,
        drawerOrder: 4
    }
};
const $46c1a866454c924b$export$76673e1b214c1378 = Object.values($46c1a866454c924b$export$6b492fdcc7e8d1f4).sort((a, b)=>a.drawerOrder - b.drawerOrder);
const $46c1a866454c924b$export$d3cbda30e53df6f6 = (field, order)=>`${field}${order}`;

});

parcelRegister("5iakG", function(module, exports) {

$parcel$export(module.exports, "universalTypeFilterId", () => $6a0cb6a98d99c2c1$export$62fed45313a13eff);
$parcel$export(module.exports, "getFilterIdOrdering", () => $6a0cb6a98d99c2c1$export$1fd3303b0f1dd4fb);

var $dh538 = parcelRequire("dh538");
const $6a0cb6a98d99c2c1$export$62fed45313a13eff = 'universalTypeFilter';
const $6a0cb6a98d99c2c1$export$64f2f70bb9f8e772 = [
    'lastUpdated',
    $6a0cb6a98d99c2c1$export$62fed45313a13eff,
    'contributor',
    'space',
    'owner',
    'createdBy',
    'lastUpdatedBy',
    'focusAreaType',
    'focusAreaUnder',
    'assignee',
    'project',
    'content',
    'label',
    'pageStatus',
    'verified',
    'onlyTitleMatch',
    'archived'
];
const $6a0cb6a98d99c2c1$export$1fd3303b0f1dd4fb = ()=>{
    return $6a0cb6a98d99c2c1$export$64f2f70bb9f8e772.filter((filterId)=>{
        if (filterId === 'label') // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        return (0, $dh538.fg)('rovo_search_confluence_label_filter');
        else if (filterId === 'pageStatus') // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        return (0, $dh538.fg)('add_confluence_status_filter');
        else return true;
    });
};

});

parcelRegister("fZ3l2", function(module, exports) {

$parcel$export(module.exports, "ResultsStates", () => $c3268331ff3eb240$export$cdcda2a8fcb980fa);
const $c3268331ff3eb240$export$cdcda2a8fcb980fa = {
    NO_RESULTS: 'noResults',
    INITIAL: 'initial',
    RESULTS: 'results',
    ERROR: 'error',
    IS_LOADING: 'isLoading'
};

});

parcelRegister("gQ44d", function(module, exports) {

$parcel$export(module.exports, "ResultsFetchError", () => $ff3b77c829810981$export$94cd2e6f39615373);
$parcel$export(module.exports, "EmptyEntitiesError", () => $ff3b77c829810981$export$8ba86dff7c04c14c);
class $ff3b77c829810981$export$94cd2e6f39615373 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResultsFetchError';
    }
}
class $ff3b77c829810981$export$8ba86dff7c04c14c extends $ff3b77c829810981$export$94cd2e6f39615373 {
    constructor(){
        super('No entities provided to fetch results');
        this.name = 'EmptyEntitiesError';
    }
}

});

parcelRegister("fUcm0", function(module, exports) {

$parcel$export(module.exports, "getTeamId", () => $5c084a67f28eba8a$export$e8eac31981efe1fb);

var $fnecL = parcelRequire("fnecL");

var $24hNR = parcelRequire("24hNR");
const $5c084a67f28eba8a$export$e8eac31981efe1fb = (ari)=>{
    let teamId = null;
    if (!ari) return teamId;
    const isTeamsAri = (0, $24hNR.TeamsTeamAri).check(ari);
    const isIdentityTeamsAri = (0, $fnecL.IdentityTeamAri).check(ari);
    if (isTeamsAri) teamId = (0, $24hNR.TeamsTeamAri).parse(ari).teamId;
    else if (isIdentityTeamsAri) teamId = (0, $fnecL.IdentityTeamAri).parse(ari).teamId;
    if (teamId === 'unidentified') teamId = null;
    return teamId;
};

});

parcelRegister("nnnU7", function(module, exports) {

$parcel$export(module.exports, "isSelectFilter", () => $d445fe68fdb751ef$export$8e6bea29334a2099);
const $d445fe68fdb751ef$export$8e6bea29334a2099 = (type)=>{
    return type === 'single-select' || type === 'multi-select';
};

});

parcelRegister("3JX0d", function(module, exports) {

$parcel$export(module.exports, "lookupOptions", () => $17f4c3b31de02ed7$export$cf63d35399eb18ae);
$parcel$export(module.exports, "getAllTypeOptions", () => $17f4c3b31de02ed7$export$b220eb3fbdd854af);
$parcel$export(module.exports, "getEntitiesForQuery", () => $17f4c3b31de02ed7$export$e085e94f90daa6c8);

var $dh538 = parcelRequire("dh538");

var $2Znam = parcelRequire("2Znam");

var $1yEFx = parcelRequire("1yEFx");

var $fKv9F = parcelRequire("fKv9F");

var $1xk5k = parcelRequire("1xk5k");

var $7jUYs = parcelRequire("7jUYs");
const $17f4c3b31de02ed7$export$521c196d70b6785e = (availableProducts, product, thirdPartyConfigs)=>{
    if ((0, $1yEFx.is3pProductKey)(product)) return availableProducts.includes(product) && !thirdPartyConfigs[product]?.userNeedsOAuth;
    else return availableProducts.includes(product);
};
const $17f4c3b31de02ed7$export$cf63d35399eb18ae = (query, config)=>{
    const allOptions = $17f4c3b31de02ed7$export$b220eb3fbdd854af(config);
    const matchingOptions = allOptions.filter((option)=>$17f4c3b31de02ed7$export$e902a1c7f3216533(query, option.label)).map((option)=>({
            label: option.label,
            trackingKey: option.value,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault
        }));
    return matchingOptions;
};
const $17f4c3b31de02ed7$export$c0b4470d000520ff = (ati, selectedTypes, dropAttachmentsComments)=>{
    if (selectedTypes.length === 0) return !(0, $1xk5k.featureGateNotRequestedATIsInAllTypesFilter)(dropAttachmentsComments).includes(ati);
    return true;
};
const $17f4c3b31de02ed7$export$e085e94f90daa6c8 = (products, selectedTypes, thirdPartyConfigs, availableProducts, dropAttachmentsComments)=>{
    if ((0, $dh538.fg)('confluence_performance_improve_search_query')) return $17f4c3b31de02ed7$export$d9f0dc47e74a61d2({
        products: products,
        selectedTypes: selectedTypes,
        thirdPartyConfigs: thirdPartyConfigs,
        availableProducts: availableProducts,
        dropAttachmentsComments: dropAttachmentsComments
    });
    const selectedEntities = new Set();
    const unselectedEntities = new Set();
    const types = selectedTypes.length === 0 ? (0, $2Znam.allTypeFilterValueKeys) : selectedTypes;
    const typeMapping = (0, $1xk5k.getTypeMapping)();
    const otherProducts = availableProducts.filter((product)=>!products.includes(product));
    types.forEach((type)=>{
        const productToEntityMap = typeMapping[type].entities;
        products.forEach((product)=>{
            if ($17f4c3b31de02ed7$export$521c196d70b6785e(products, product, thirdPartyConfigs)) productToEntityMap[product]?.forEach((ati)=>{
                if ($17f4c3b31de02ed7$export$c0b4470d000520ff(ati, selectedTypes, dropAttachmentsComments)) selectedEntities.add(ati);
            });
        });
        // collect unselected entities
        otherProducts.forEach((product)=>{
            if ($17f4c3b31de02ed7$export$521c196d70b6785e(otherProducts, product, thirdPartyConfigs)) productToEntityMap[product]?.forEach((ati)=>{
                if (!selectedEntities.has(ati)) unselectedEntities.add(ati);
            });
        });
    });
    /// result count wants all entities for selected type
    const entitiesForResultsCountQuery = Array.from([
        ...selectedEntities,
        ...unselectedEntities
    ]).sort();
    // Do not show Atlas goal and tag results when no product is selected
    if (types.includes('project') && products.length > 1) {
        selectedEntities.delete('ati:cloud:townsquare:goal');
        selectedEntities.delete('ati:cloud:townsquare:tag');
    }
    // Sorting helps a ton in testing
    const entitiesForQuery = Array.from(selectedEntities).sort();
    return {
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery
    };
};
const $17f4c3b31de02ed7$var$isProductEntitiesIncludedSimplified = (availableProducts, product, thirdPartyConfigs)=>{
    // Main change from the original code
    if ((0, $1yEFx.is3pProductKey)(product)) return availableProducts.includes(product) && !thirdPartyConfigs[product]?.userNeedsOAuth;
    return availableProducts.includes(product);
};
const $17f4c3b31de02ed7$var$getProductsWithEntities = (products, thirdPartyConfigs)=>{
    return products.reduce((acc, product)=>{
        if ($17f4c3b31de02ed7$var$isProductEntitiesIncludedSimplified(products, product, thirdPartyConfigs)) acc.push(product);
        return acc;
    }, []);
};
const $17f4c3b31de02ed7$export$d9f0dc47e74a61d2 = ({ products: products, selectedTypes: selectedTypes, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts, dropAttachmentsComments: dropAttachmentsComments })=>{
    const otherProducts = availableProducts.filter((product)=>!products.includes(product));
    const productsWithEntities = $17f4c3b31de02ed7$var$getProductsWithEntities(products, thirdPartyConfigs);
    const otherProductsWithEntities = otherProducts.reduce((acc, otherProduct)=>{
        if ($17f4c3b31de02ed7$export$521c196d70b6785e(otherProducts, otherProduct, thirdPartyConfigs)) acc.push(otherProduct);
        return acc;
    }, []);
    // Stuff that we can't be cached that easy
    const selectedEntities = new Set();
    const unselectedEntities = new Set();
    const types = selectedTypes.length === 0 ? (0, $2Znam.allTypeFilterValueKeys) : selectedTypes;
    const typeMapping = (0, $1xk5k.getTypeMapping)();
    // Using normal-loop to reduce overhead and improve performance
    for(let i = 0; i < types.length; i++){
        const type = types[i];
        const productToEntityMap = typeMapping[type].entities;
        for(let h = 0; h < productsWithEntities.length; h++){
            const product = productsWithEntities[h];
            const arr = productToEntityMap[product];
            if (!arr || !Array.isArray(arr)) continue;
            for(let w = 0; w < arr.length; w++){
                const ati = arr[w];
                if ($17f4c3b31de02ed7$export$c0b4470d000520ff(ati, selectedTypes, dropAttachmentsComments)) selectedEntities.add(ati);
            }
        }
        for(let j = 0; j < otherProductsWithEntities.length; j++){
            const product = productsWithEntities[j];
            const arr = productToEntityMap[product];
            if (!arr || !Array.isArray(arr)) continue;
            for(let w = 0; w < arr.length; w++){
                const ati = arr[w];
                if (!selectedEntities.has(ati)) unselectedEntities.add(ati);
            }
        }
    }
    /// result count wants all entities for selected type
    const entitiesForResultsCountQuery = Array.from([
        ...selectedEntities,
        ...unselectedEntities
    ]).sort();
    // Do not show Atlas goal and tag results when no product is selected
    if (types.includes('project') && products.length > 1) {
        selectedEntities.delete('ati:cloud:townsquare:goal');
        selectedEntities.delete('ati:cloud:townsquare:tag');
    }
    // Sorting helps a ton in testing
    const entitiesForQuery = Array.from(selectedEntities).sort();
    return {
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery
    };
};
const $17f4c3b31de02ed7$export$e902a1c7f3216533 = (query, label)=>{
    return label.toLowerCase().includes(query.toLowerCase());
};
const $17f4c3b31de02ed7$export$b220eb3fbdd854af = (config)=>{
    const typeMapping = (0, $1xk5k.getTypeMapping)();
    const allOption = {
        products: [],
        label: config.intl?.formatMessage((0, $7jUYs.typeLabels)['all']) || '',
        value: 'all',
        trackingKey: 'all',
        queryParamValue: (0, $fKv9F.ContentType)['All'],
        isDefault: true
    };
    const typeOptions = (0, $2Znam.allTypeFilterValueKeys).map((type)=>{
        const messageKey = type === 'page' && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in') ? 'pageAndLiveDoc' : type;
        return {
            products: typeMapping[type].products,
            value: type,
            trackingKey: type,
            queryParamValue: type,
            isDefault: false,
            label: config.intl?.formatMessage((0, $7jUYs.typeLabels)[messageKey]) || ''
        };
    });
    return [
        allOption,
        ...typeOptions
    ];
};

});
parcelRegister("1xk5k", function(module, exports) {

$parcel$export(module.exports, "featureGateNotRequestedATIsInAllTypesFilter", () => $b7f1b9f5c8cf1139$export$e3e01c012e38223a);
$parcel$export(module.exports, "getTypeMapping", () => $b7f1b9f5c8cf1139$export$a7663ee59d66492f);

var $hB77E = parcelRequire("hB77E");

var $idpYy = parcelRequire("idpYy");

var $2Znam = parcelRequire("2Znam");

var $1yEFx = parcelRequire("1yEFx");
/**
 * A mapping between 1P Products
 * - ProductKey1P e.g. 'confluence'
 *
 * UI values for the type filter
 * - TypeFilterKey e.g. 'Spreadsheet'
 *
 * and entities to request from Aggregator
 *
 * - ATIString[] e.g. ['ati:cloud:confluence:blogpost']
 */ const $b7f1b9f5c8cf1139$var$typeFilter1PMapping = new Map([
    [
        (0, $1yEFx.ProductKeys).Confluence,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Document,
                [
                    'ati:cloud:confluence:blogpost',
                    'ati:cloud:confluence:page',
                    'ati:cloud:confluence:attachment'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Page,
                [
                    'ati:cloud:confluence:page'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Blogpost,
                [
                    'ati:cloud:confluence:blogpost'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Attachment,
                [
                    'ati:cloud:confluence:attachment'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Space,
                [
                    'ati:cloud:confluence:space'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Comment,
                [
                    'ati:cloud:confluence:comment'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Whiteboard,
                [
                    'ati:cloud:confluence:whiteboard'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Database,
                [
                    'ati:cloud:confluence:database'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Embed,
                [
                    'ati:cloud:confluence:embed'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Folder,
                [
                    'ati:cloud:confluence:folder'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Calendar,
                [
                    (0, $idpYy.CONFLUENCE_CALENDAR_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).SpaceCalendar,
                [
                    (0, $idpYy.CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Question,
                [
                    (0, $idpYy.CONFLUENCE_QUESTION_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Answer,
                [
                    (0, $idpYy.CONFLUENCE_ANSWER_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Gliffy,
                [
                    (0, $idpYy.CONFLUENCE_GLIFFY_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $1yEFx.ProductKeys).Jira,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Issue,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Project,
                [
                    (0, $idpYy.JIRA_PROJECT_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $1yEFx.ProductKeys).JiraProductDiscovery,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Issue,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Project,
                [
                    (0, $idpYy.JIRA_PROJECT_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $1yEFx.ProductKeys).JiraServiceManagement,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Issue,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Project,
                [
                    (0, $idpYy.JIRA_PROJECT_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Incident,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $1yEFx.ProductKeys).Compass,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Component,
                [
                    'ati:cloud:compass:component'
                ]
            ]
        ])
    ],
    [
        (0, $1yEFx.ProductKeys).Focus,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).FocusArea,
                [
                    'ati:cloud:mercury:focus-area',
                    'ati:cloud:mercury:focus-area-status-update'
                ]
            ]
        ])
    ],
    [
        (0, $1yEFx.ProductKeys).Trello,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Card,
                [
                    'ati:cloud:trello:card'
                ]
            ]
        ])
    ],
    [
        (0, $1yEFx.ProductKeys).Atlas,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Project,
                [
                    'ati:cloud:townsquare:project'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Goal,
                [
                    'ati:cloud:townsquare:goal'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Tag,
                [
                    'ati:cloud:townsquare:tag'
                ]
            ]
        ])
    ],
    [
        (0, $1yEFx.ProductKeys).Bitbucket,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Commit,
                [
                    'ati:cloud:graph:commit'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).PullRequest,
                [
                    'ati:cloud:graph:pull-request'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Repository,
                [
                    'ati:cloud:graph:repository'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Branch,
                [
                    'ati:cloud:graph:branch'
                ]
            ]
        ])
    ]
]);
const $b7f1b9f5c8cf1139$export$e3e01c012e38223a = (dropAttachmentsComments)=>{
    return [
        [
            dropAttachmentsComments,
            'ati:cloud:confluence:comment'
        ],
        [
            dropAttachmentsComments,
            'ati:cloud:confluence:attachment'
        ]
    ].flatMap(([dropATI, entityATI])=>dropATI ? entityATI : []);
};
// Simple first-call-fills cache
let $b7f1b9f5c8cf1139$var$cachedTypeMapping;
const $b7f1b9f5c8cf1139$export$a7663ee59d66492f = ()=>{
    if ($b7f1b9f5c8cf1139$var$cachedTypeMapping) return $b7f1b9f5c8cf1139$var$cachedTypeMapping;
    const mappings = Object.fromEntries((0, $2Znam.allTypeFilterValueKeys).map((TypeFilterValueKey)=>{
        const baseMapping = {
            entities: {},
            products: [],
            subCategories: []
        };
        return [
            TypeFilterValueKey,
            baseMapping
        ];
    }));
    // Add all the 1P products
    $b7f1b9f5c8cf1139$var$typeFilter1PMapping.forEach((_, productKey1P)=>{
        $b7f1b9f5c8cf1139$var$typeFilter1PMapping.get(productKey1P)?.forEach((_, typeFilterValueKey)=>{
            mappings[typeFilterValueKey].products.push(productKey1P);
            mappings[typeFilterValueKey].entities[productKey1P] = $b7f1b9f5c8cf1139$var$typeFilter1PMapping.get(productKey1P)?.get(typeFilterValueKey);
        });
    });
    // Add all the 3P products
    (0, $hB77E.ThirdPartyConfigs).forEach((thirdPartyConfig, productKey3P)=>{
        const typeFilterConfigs = thirdPartyConfig?.typeFilterConfig;
        if (!typeFilterConfigs) return;
        typeFilterConfigs.forEach((typeFilterValue3PEntities, typeFilterValueKey)=>{
            mappings[typeFilterValueKey].products.push(productKey3P);
            mappings[typeFilterValueKey].entities[productKey3P] = typeFilterValue3PEntities.entities3P;
            mappings[typeFilterValueKey].subCategories = [
                ...mappings[typeFilterValueKey].subCategories,
                ...typeFilterValue3PEntities.subTypes3P
            ];
            mappings[typeFilterValueKey].subCategories = [
                ...new Set(mappings[typeFilterValueKey].subCategories)
            ]; // dedupe
        });
    });
    $b7f1b9f5c8cf1139$var$cachedTypeMapping = mappings;
    return mappings;
};

});

parcelRegister("7jUYs", function(module, exports) {

$parcel$export(module.exports, "typeLabels", () => $b8cf047080ff9c5f$export$9f8e6b98f3e412c5);

var $2nPZH = parcelRequire("2nPZH");
const $b8cf047080ff9c5f$export$9f8e6b98f3e412c5 = (0, $2nPZH.defineMessages)({
    all: {
        id: "search-page.filter.type.all",
        defaultMessage: "All"
    },
    document: {
        id: "search-page.filter.type.documents",
        defaultMessage: "Documents"
    },
    spreadsheet: {
        id: "search-page.filter.type.spreadsheet",
        defaultMessage: "Spreadsheets"
    },
    presentation: {
        id: "search-page.filter.type.presentation",
        defaultMessage: "Presentations"
    },
    repository: {
        id: "search-page.filter.type.repository",
        defaultMessage: "Repositories"
    },
    'pull-request': {
        id: "search-page.filter.type.pull-request",
        defaultMessage: "Pull requests"
    },
    branch: {
        id: "search-page.filter.type.branch",
        defaultMessage: "Branches"
    },
    commit: {
        id: "search-page.filter.type.commit",
        defaultMessage: "Commits"
    },
    conversation: {
        id: "search-page.filter.type.conversation",
        defaultMessage: "Conversations"
    },
    message: {
        id: "search-page.filter.type.message",
        defaultMessage: "Messages"
    },
    video: {
        id: "search-page.filter.type.video",
        defaultMessage: "Videos"
    },
    design: {
        id: "search-page.filter.type.design",
        defaultMessage: "Designs"
    },
    pageAndLiveDoc: {
        id: "search-page.filter.type.page",
        defaultMessage: "Pages and Live Docs"
    },
    page: {
        id: "search-page.filter.type.page",
        defaultMessage: "Pages"
    },
    blogpost: {
        id: "search-page.filter.type.blogpost",
        defaultMessage: "Blog posts"
    },
    attachment: {
        id: "search-page.filter.type.attachment",
        defaultMessage: "Attachments"
    },
    space: {
        id: "search-page.filter.type.space",
        defaultMessage: "Spaces"
    },
    whiteboard: {
        id: "search-page.filter.type.whiteboard",
        defaultMessage: "Whiteboards"
    },
    issue: {
        id: "search-page.filter.type.issue",
        defaultMessage: "Issues"
    },
    project: {
        id: "search-page.filter.type.project",
        defaultMessage: "Projects"
    },
    goal: {
        id: "search-page.filter.type.goal",
        defaultMessage: "Goals"
    },
    tag: {
        id: "search-page.filter.type.tag",
        defaultMessage: "Tags"
    },
    'web-page': {
        id: "search-page.filter.type.web-page",
        defaultMessage: "Web pages"
    },
    comment: {
        id: "search-page.filter.type.comment",
        defaultMessage: "Comments"
    },
    database: {
        id: "search-page.filter.type.database",
        defaultMessage: "Databases"
    },
    embed: {
        id: "search-page.filter.type.embed",
        defaultMessage: "Smart Links"
    },
    folder: {
        id: "search-page.filter.type.folder",
        defaultMessage: "Folders"
    },
    calendar: {
        id: "search-page.filter.type.calendar",
        defaultMessage: "Calendars"
    },
    'space-calendar': {
        id: "search-page.filter.type.space-calendar",
        defaultMessage: "Space calendars"
    },
    answer: {
        id: "search-page.filter.type.answer",
        defaultMessage: "Answers"
    },
    question: {
        id: "search-page.filter.type.question",
        defaultMessage: "Questions"
    },
    component: {
        id: "search-page.filter.type.component",
        defaultMessage: "Components"
    },
    'work-item': {
        id: "search-page.filter.type.work-item",
        defaultMessage: "Tasks"
    },
    card: {
        id: "search-page.filter.type.card",
        defaultMessage: "Card"
    },
    incident: {
        id: "search-page.filter.type.incident",
        defaultMessage: "Incident"
    },
    'focus-area': {
        id: "search-page.filter.type.focus-area",
        defaultMessage: "Focus areas"
    },
    dashboard: {
        id: "search-page.filter.type.dashboard",
        defaultMessage: "Dashboards"
    },
    invoice: {
        id: "search-page.filter.type.invoice",
        defaultMessage: "Invoices"
    },
    deal: {
        id: "search-page.filter.type.deal",
        defaultMessage: "Deals"
    },
    gliffy: {
        id: "search-page.filter.type.gliffy",
        defaultMessage: "Gliffy Diagrams"
    },
    'customer-org': {
        id: "search-page.filter.type.customer-org",
        defaultMessage: "Customer Organizations"
    }
});

});


parcelRegister("1ryLq", function(module, exports) {

$parcel$export(module.exports, "FilterUtils", () => $5c0e8234bd4941e7$export$a97e25c038594c73);

var $fKv9F = parcelRequire("fKv9F");

var $dOOW1 = parcelRequire("dOOW1");
const $5c0e8234bd4941e7$export$a97e25c038594c73 = (staticFilters, filterStates)=>{
    const staticFilterValues = Array.isArray(staticFilters) ? staticFilters : Object.values(staticFilters);
    const staticFiltersRecord = Array.isArray(staticFilters) ? Object.fromEntries(staticFilters.map((staticFilter)=>[
            staticFilter.id,
            staticFilter
        ])) : staticFilters;
    const filterStateValues = Array.isArray(filterStates) ? filterStates : Object.values(filterStates).filter((0, $dOOW1.notEmpty));
    const filterStatesRecord = Array.isArray(filterStates) ? Object.fromEntries(filterStates.map((filterState)=>[
            filterState.id,
            filterState
        ])) : filterStates;
    return {
        staticFilters: staticFiltersRecord,
        staticFilterValues: staticFilterValues,
        filterStates: filterStatesRecord,
        filterStateValues: filterStateValues,
        getSelectedProducts: (queryParams)=>{
            const queryParamKeys = Object.keys(queryParams);
            const productKey = (0, $fKv9F.productKeySchema).safeParse(queryParams.product);
            if (productKey.success) return [
                productKey.data
            ];
            const allProductsWithSelections = staticFilterValues.filter((staticFilter)=>!staticFilter.universal) // Ignore universal filters as they are relevant to every product
            .filter((staticFilter)=>queryParamKeys.includes(staticFilter.queryParams.key)).map((staticFilter)=>staticFilter.products).flat();
            const selectedProducts = Array.from(new Set(allProductsWithSelections)); // might have to sort this based on some priority
            return selectedProducts;
        },
        isMissingProductSelection: (queryParams)=>{
            const selectedProducts = $5c0e8234bd4941e7$export$a97e25c038594c73(staticFilters, filterStates).getSelectedProducts(queryParams);
            const productKey = (0, $fKv9F.productKeySchema).safeParse(queryParams.product).data;
            return selectedProducts.length > 0 && !productKey;
        },
        filtersByProduct: (products)=>{
            const staticFiltersByProduct = staticFilterValues.filter((staticFilterValue)=>{
                if (!products.length) return staticFilterValue.universal; // Only universal filters are relevant if no apps are selected
                return staticFilterValue.products.some((product)=>products.includes(product));
            });
            const staticFiltersByProductKeys = staticFiltersByProduct.map((staticFilter)=>staticFilter.id);
            const filterStatesByProduct = filterStateValues.filter((filterState)=>staticFiltersByProductKeys.includes(filterState.id));
            return $5c0e8234bd4941e7$export$a97e25c038594c73(staticFiltersByProduct, filterStatesByProduct);
        },
        getFiltersWithSelection: ()=>{
            const filterIDsWithSelection = filterStateValues.filter((x)=>x.hasSelection).map((x)=>x.id);
            return filterIDsWithSelection;
        }
    };
};

});
parcelRegister("dOOW1", function(module, exports) {

$parcel$export(module.exports, "getEmptySelectedFilters", () => $a113941c76257cbc$export$b7b676578c62639d);
$parcel$export(module.exports, "convertCustomDateToRange", () => $a113941c76257cbc$export$79cd775d0d5c2a2);
$parcel$export(module.exports, "convertLastUpdatedToDateRange", () => $a113941c76257cbc$export$50da93f10cdc6a84);
$parcel$export(module.exports, "getConfluenceDateOptionFromCustomDates", () => $a113941c76257cbc$export$e048252fb7949a77);
$parcel$export(module.exports, "getConfluenceDateOptionValues", () => $a113941c76257cbc$export$405f2efecb6f5de6);
$parcel$export(module.exports, "baseIntegrationARIs", () => $a113941c76257cbc$export$d82a82f2333502ad);
$parcel$export(module.exports, "getIntegrationARIsFromConfig", () => $a113941c76257cbc$export$2703353a19002efe);
$parcel$export(module.exports, "getThirdPartyFilters", () => $a113941c76257cbc$export$3766c9ce0c94452);
$parcel$export(module.exports, "DateRangeError", () => $a113941c76257cbc$export$b367612b2293421c);
$parcel$export(module.exports, "getInvalidDateRange", () => $a113941c76257cbc$export$d3eb8baea7b2ff96);
$parcel$export(module.exports, "getProducts3PFromConfigForFilter", () => $a113941c76257cbc$export$ef6dfb919b1d7267);
$parcel$export(module.exports, "notEmpty", () => $a113941c76257cbc$export$b29ea735dcfba3c1);

var $dh538 = parcelRequire("dh538");

var $hB77E = parcelRequire("hB77E");

var $1yEFx = parcelRequire("1yEFx");

var $9d9t8 = parcelRequire("9d9t8");

var $fKv9F = parcelRequire("fKv9F");
const $a113941c76257cbc$var$GOOGLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/google';
const $a113941c76257cbc$var$MICROSOFT_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $a113941c76257cbc$var$WEB_CRAWLER_INTEGRATION_ARI = 'ari:cloud:platform::integration/atlassian-web-crawler';
const $a113941c76257cbc$var$GITHUB_INTEGRATION_ARI = 'ari:cloud:platform::integration/github';
const $a113941c76257cbc$var$TEAMS_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $a113941c76257cbc$var$FIGMA_INTEGRATION_ARI = 'ari:cloud:platform::integration/figma';
const $a113941c76257cbc$var$LOOM_INTEGRATION_ARI = 'ari:cloud:platform::integration/loom';
const $a113941c76257cbc$var$DROPBOX_INTEGRATION_ARI = 'ari:cloud:platform::integration/dropbox';
const $a113941c76257cbc$var$AIRTABLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/airtable';
const $a113941c76257cbc$var$SMARTSHEET_INTEGRATION_ARI = 'ari:cloud:platform::integration/smartsheet';
const $a113941c76257cbc$var$BITBUCKET_INTEGRATION_ARI = 'ari:cloud:platform::integration/bitbucket';
const $a113941c76257cbc$var$NOTION_INTEGRATION_ARI = 'ari:cloud:platform::integration/notion';
const $a113941c76257cbc$var$MIRO_INTEGRATION_ARI = 'ari:cloud:platform::integration/miro';
const $a113941c76257cbc$var$ZENDESK_INTEGRATION_ARI = 'ari:cloud:platform::integration/zendesk';
const $a113941c76257cbc$var$DOCUSIGN_INTEGRATION_ARI = 'ari:cloud:platform::integration/docusign';
const $a113941c76257cbc$var$LUCID_INTEGRATION_ARI = 'ari:cloud:platform::integration/lucid';
const $a113941c76257cbc$var$MONDAY_INTEGRATION_ARI = 'ari:cloud:platform::integration/monday';
const $a113941c76257cbc$var$AZURE_DEVOPS_INTEGRATION_ARI = 'ari:cloud:platform::integration/azure-devops';
const $a113941c76257cbc$var$GITLAB_INTEGRATION_ARI = 'ari:cloud:platform::integration/gitlab';
const $a113941c76257cbc$var$CONFLUENCE_DC_INTEGRATION_ARI = 'ari:cloud:platform::integration/confluence-dc';
const $a113941c76257cbc$var$CANVA_INTEGRATION_ARI = 'ari:cloud:platform::integration/canva';
const $a113941c76257cbc$var$ASANA_INTEGRATION_ARI = 'ari:cloud:platform::integration/asana';
const $a113941c76257cbc$var$BOX_INTEGRATION_ARI = 'ari:cloud:platform::integration/box';
const $a113941c76257cbc$var$ZEPLIN_INTEGRATION_ARI = 'ari:cloud:platform::integration/zeplin';
const $a113941c76257cbc$var$SERVICENOW_INTEGRATION_ARI = 'ari:cloud:platform::integration/servicenow';
const $a113941c76257cbc$var$FRESHSERVICE_INTEGRATION_ARI = 'ari:cloud:platform::integration/freshservice';
const $a113941c76257cbc$var$POWERBI_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $a113941c76257cbc$var$CLICKUP_INTEGRATION_ARI = 'ari:cloud:platform::integration/clickup';
const $a113941c76257cbc$var$AMPLITUDE_INTEGRATION_ARI = 'ari:cloud:platform::integration/amplitude';
const $a113941c76257cbc$var$STRIPE_INTEGRATION_ARI = 'ari:cloud:platform::integration/stripe';
const $a113941c76257cbc$var$ADOBE_INTEGRATION_ARI = 'ari:cloud:platform::integration/adobe';
const $a113941c76257cbc$var$AHA_INTEGRATION_ARI = 'ari:cloud:platform::integration/aha';
const $a113941c76257cbc$var$MURAL_INTEGRATION_ARI = 'ari:cloud:platform::integration/mural';
const $a113941c76257cbc$var$WEBEX_INTEGRATION_ARI = 'ari:cloud:platform::integration/cisco';
const $a113941c76257cbc$var$TODOIST_INTEGRATION_ARI = 'ari:cloud:platform::integration/todoist';
const $a113941c76257cbc$var$PAGERDUTY_INTEGRATION_ARI = 'ari:cloud:platform::integration/pagerduty';
const $a113941c76257cbc$var$PIPEDRIVE_INTEGRATION_ARI = 'ari:cloud:platform::integration/pipedrive';
const $a113941c76257cbc$var$HUBSPOT_INTEGRATION_ARI = 'ari:cloud:platform::integration/hubspot';
const $a113941c76257cbc$var$DOVETAIL_INTEGRATION_ARI = 'ari:cloud:platform::integration/dovetail';
const $a113941c76257cbc$var$LAUNCHDARKLY_INTEGRATION_ARI = 'ari:cloud:platform::integration/launchdarkly';
const $a113941c76257cbc$var$SALESFORCE_INTEGRATION_ARI = 'ari:cloud:platform::integration/salesforce';
const $a113941c76257cbc$var$SENTRY_INTEGRATION_ARI = 'ari:cloud:platform::integration/sentry';
const $a113941c76257cbc$var$JIRA_DC_INTEGRATION_ARI = 'ari:cloud:platform::integration/jira-dc';
const $a113941c76257cbc$var$GITBOOK_INTEGRATION_ARI = 'ari:cloud:platform::integration/graph-test-app';
const $a113941c76257cbc$export$b7b676578c62639d = ()=>({
        commonFilters: {},
        confluenceFilters: {
            spacesFilter: [],
            contributorsFilter: [],
            ancestorIdsFilter: [],
            range: [],
            owners: [],
            labelsFilter: [],
            titleMatchOnly: false,
            contentStatuses: [],
            containerStatus: []
        },
        jiraFilters: {
            issueFilter: {
                assigneeARIs: [],
                projectARIs: [],
                issueTypeIDs: []
            }
        },
        mercuryFilters: {
            owners: [],
            focusAreaTypeIds: [],
            ancestorIds: []
        },
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: [],
            integrations: [],
            createdBy: [],
            lastUpdatedBy: [],
            assignees: []
        }
    });
const $a113941c76257cbc$export$79cd775d0d5c2a2 = (from, to)=>{
    const fromDate = from ? new Date(from) : new Date();
    const startOfTheFromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), 0, 0, 0, 0);
    const toDate = to ? new Date(to) : new Date();
    const endOfTheToDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), 23, 59, 59, 999);
    return {
        gt: from ? startOfTheFromDate.toISOString().split('Z')[0] : undefined,
        lt: to ? endOfTheToDate.toISOString().split('Z')[0] : undefined
    };
};
const $a113941c76257cbc$export$8db446d8af54b4b5 = (fromOffset, toOffset)=>{
    const currentDate = new Date();
    return {
        gt: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()).getTime() - fromOffset * 86400000).toISOString().split('Z')[0],
        lt: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999).getTime() - toOffset * 86400000).toISOString().split('Z')[0]
    };
};
const $a113941c76257cbc$export$50da93f10cdc6a84 = (lastUpdated)=>{
    let dateRangeValues;
    switch(lastUpdated){
        case 'today':
            dateRangeValues = $a113941c76257cbc$export$8db446d8af54b4b5(0, 0);
            break;
        case 'yesterday':
            dateRangeValues = $a113941c76257cbc$export$8db446d8af54b4b5(1, 1);
            break;
        case 'past7Days':
            dateRangeValues = $a113941c76257cbc$export$8db446d8af54b4b5(7, 0);
            break;
        case 'past30Days':
            dateRangeValues = $a113941c76257cbc$export$8db446d8af54b4b5(30, 0);
            break;
        case 'pastYear':
            dateRangeValues = $a113941c76257cbc$export$8db446d8af54b4b5(365, 0);
            break;
        default:
            dateRangeValues = {
                gt: '',
                lt: ''
            };
    }
    return dateRangeValues;
};
const $a113941c76257cbc$export$e048252fb7949a77 = (from, to)=>{
    const { gt: gt, lt: lt } = $a113941c76257cbc$export$79cd775d0d5c2a2(from, to);
    return {
        field: 'LASTMODIFIED',
        gt: gt,
        lt: lt
    };
};
const $a113941c76257cbc$export$405f2efecb6f5de6 = (selectedDateOption)=>{
    const dateRangeValues = $a113941c76257cbc$export$50da93f10cdc6a84(selectedDateOption);
    const { gt: gt, lt: lt } = dateRangeValues;
    return {
        field: 'LASTMODIFIED',
        gt: gt,
        lt: lt
    };
};
const $a113941c76257cbc$export$d82a82f2333502ad = {
    [(0, $fKv9F.ProductKey).GoogleDrive]: $a113941c76257cbc$var$GOOGLE_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Sharepoint]: $a113941c76257cbc$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).AtlassianWebCrawler]: $a113941c76257cbc$var$WEB_CRAWLER_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Teams]: $a113941c76257cbc$var$TEAMS_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Figma]: $a113941c76257cbc$var$FIGMA_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Gitbook]: $a113941c76257cbc$var$GITBOOK_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Loom]: $a113941c76257cbc$var$LOOM_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).OneDrive]: $a113941c76257cbc$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Github]: $a113941c76257cbc$var$GITHUB_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Bitbucket]: $a113941c76257cbc$var$BITBUCKET_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Airtable]: $a113941c76257cbc$var$AIRTABLE_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Smartsheet]: $a113941c76257cbc$var$SMARTSHEET_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Notion]: $a113941c76257cbc$var$NOTION_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Miro]: $a113941c76257cbc$var$MIRO_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Zendesk]: $a113941c76257cbc$var$ZENDESK_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Docusign]: $a113941c76257cbc$var$DOCUSIGN_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Lucid]: $a113941c76257cbc$var$LUCID_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Monday]: $a113941c76257cbc$var$MONDAY_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).AzureDevops]: $a113941c76257cbc$var$AZURE_DEVOPS_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Gitlab]: $a113941c76257cbc$var$GITLAB_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).ConfluenceDC]: $a113941c76257cbc$var$CONFLUENCE_DC_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Canva]: $a113941c76257cbc$var$CANVA_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).OutlookCalendar]: $a113941c76257cbc$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Asana]: $a113941c76257cbc$var$ASANA_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Zeplin]: $a113941c76257cbc$var$ZEPLIN_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).ServiceNow]: $a113941c76257cbc$var$SERVICENOW_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Freshservice]: $a113941c76257cbc$var$FRESHSERVICE_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).PowerBI]: $a113941c76257cbc$var$POWERBI_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).ClickUp]: $a113941c76257cbc$var$CLICKUP_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Amplitude]: $a113941c76257cbc$var$AMPLITUDE_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Stripe]: $a113941c76257cbc$var$STRIPE_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).AdobeXD]: $a113941c76257cbc$var$ADOBE_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Aha]: $a113941c76257cbc$var$AHA_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).AdobeSign]: $a113941c76257cbc$var$ADOBE_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Mural]: $a113941c76257cbc$var$MURAL_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Webex]: $a113941c76257cbc$var$WEBEX_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Todoist]: $a113941c76257cbc$var$TODOIST_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).PagerDuty]: $a113941c76257cbc$var$PAGERDUTY_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Pipedrive]: $a113941c76257cbc$var$PIPEDRIVE_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Hubspot]: $a113941c76257cbc$var$HUBSPOT_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Dovetail]: $a113941c76257cbc$var$DOVETAIL_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).LaunchDarkly]: $a113941c76257cbc$var$LAUNCHDARKLY_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Salesforce]: $a113941c76257cbc$var$SALESFORCE_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Sentry]: $a113941c76257cbc$var$SENTRY_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).JiraDC]: $a113941c76257cbc$var$JIRA_DC_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Box]: $a113941c76257cbc$var$BOX_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Dropbox]: $a113941c76257cbc$var$DROPBOX_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).GoogleCalendar]: $a113941c76257cbc$var$GOOGLE_INTEGRATION_ARI,
    [(0, $fKv9F.ProductKey).Gmail]: $a113941c76257cbc$var$GOOGLE_INTEGRATION_ARI
};
const $a113941c76257cbc$export$2703353a19002efe = ()=>{
    const integrationMap = {};
    (0, $hB77E.ThirdPartyConfigs).forEach((config, productKey3P)=>{
        if (config.isEnabled()) integrationMap[productKey3P] = config.integrationAri;
    });
    return integrationMap;
};
const $a113941c76257cbc$export$3766c9ce0c94452 = (products, titleMatchValue, // entities is the frontend filtered, already selected values
entities, thirdPartyConfigs, baseIntegrationARIs, range, assignees, containerAris, createdBy, lastUpdatedBy, ancestorAris)=>{
    if (!products.length || products.some((p)=>(0, $1yEFx.is3pProductKey)(p) || p === (0, $fKv9F.ProductKey).Bitbucket)) {
        // Conditionally create the dynamic integration ARIs based on the config
        const integrationARIsFromConfig = $a113941c76257cbc$export$2703353a19002efe();
        // Combine static and dynamic integration ARIs
        let productToIntegrationARIMap = integrationARIsFromConfig;
        // this is not covered under 3p static config
        productToIntegrationARIMap = {
            ...productToIntegrationARIMap,
            [(0, $fKv9F.ProductKey).Bitbucket]: $a113941c76257cbc$var$BITBUCKET_INTEGRATION_ARI
        };
        // get the subtypes by looking at each type's subcategories
        let allSubtypes = [];
        let thirdPartyProducts = products.filter((product)=>(0, $1yEFx.is3pProductKey)(product) && thirdPartyConfigs[product] !== undefined && !thirdPartyConfigs[product]?.userNeedsOAuth && !thirdPartyConfigs[product]?.isFederated).filter((product)=>{
            return thirdPartyConfigs[product]?.isEnabled();
        }).map((product)=>{
            const thirdPartyConfig = thirdPartyConfigs[product];
            if (!thirdPartyConfig) // this wont happen because of the above filter,
            // but typescript doesnt believe it.
            return undefined;
            let localSubtypes = [];
            thirdPartyConfig.typeFilterConfig?.forEach((entitiesConfig, entityValue)=>{
                if (entities.includes(entityValue)) localSubtypes = [
                    ...localSubtypes,
                    ...entitiesConfig.subTypes3P
                ];
            });
            allSubtypes = [
                ...new Set([
                    ...allSubtypes,
                    ...localSubtypes
                ])
            ]; // concat and dedupe subtypes
            const integrationId = thirdPartyConfig.integrationAri;
            const providerId = thirdPartyConfig.providerId;
            const connectorSources = thirdPartyConfig.connectorSources;
            return {
                integrationId: integrationId,
                subtypes: allSubtypes,
                providerId: providerId,
                product: product,
                connectorSources: connectorSources
            };
        });
        if (thirdPartyProducts) {
            // Add Loom and Bitbucket to the thirdPartyProducts filter
            const firstPartyProductsFor3pFilters = [
                (0, $fKv9F.ProductKey).Loom,
                (0, $fKv9F.ProductKey).Bitbucket
            ];
            const result = firstPartyProductsFor3pFilters.filter((product)=>products.includes(product) && !thirdPartyProducts?.some((p)=>p.product === product)).map((product)=>({
                    integrationId: productToIntegrationARIMap[product] || '',
                    subtypes: allSubtypes,
                    product: product,
                    connectorSources: [
                        (0, $9d9t8.FULL_CONNECTOR_SOURCE)
                    ]
                }));
            thirdPartyProducts = thirdPartyProducts.concat(result);
        }
        const createdByFilterField = (0, $dh538.fg)('enable_created_by_filter') ? {
            createdBy: createdBy || []
        } : {};
        const lastUpdatedByFilterField = (0, $dh538.fg)('enable_last_updated_by_filter') ? {
            lastUpdatedBy: lastUpdatedBy || []
        } : {};
        if (Object.keys(productToIntegrationARIMap).length !== 0) {
            const integrationARIs = products.filter((product)=>!(0, $1yEFx.is3pProductKey)(product) || !thirdPartyConfigs[product]?.userNeedsOAuth).map((product)=>productToIntegrationARIMap[product]).filter((ari)=>!!ari)// remove duplicates (eg sharepoint, teams)
            .filter((ari, pos, arr)=>{
                return arr.indexOf(ari) === pos;
            });
            return {
                range: range,
                titleMatchOnly: titleMatchValue,
                subtypes: allSubtypes,
                integrations: integrationARIs,
                thirdPartyProducts: thirdPartyProducts,
                assignees: assignees,
                containerAris: containerAris || [],
                ...createdByFilterField,
                ancestorAris: ancestorAris || [],
                ...lastUpdatedByFilterField
            };
        } else return {
            range: range,
            titleMatchOnly: titleMatchValue,
            subtypes: allSubtypes,
            thirdPartyProducts: thirdPartyProducts,
            assignees: assignees,
            containerAris: containerAris || [],
            ...createdByFilterField,
            ancestorAris: ancestorAris || [],
            ...lastUpdatedByFilterField
        };
    }
    return {
        titleMatchOnly: false,
        subtypes: [],
        integrations: []
    };
};
var $a113941c76257cbc$export$b367612b2293421c = /*#__PURE__*/ function(DateRangeError) {
    DateRangeError["FROM_AFTER_TO_ERROR"] = "fromAfterToError";
    DateRangeError["FROM_IN_FUTURE_ERROR"] = "fromInFutureError";
    DateRangeError["TO_IN_FUTURE_ERROR"] = "toInFutureError";
    return DateRangeError;
}({});
const $a113941c76257cbc$export$d3eb8baea7b2ff96 = (from, to)=>{
    if (!from && !to) return null;
    const dateFrom = new Date(`${from}${from ? 'T00:00:00' : ''}`);
    const dateTo = new Date(`${to}${to ? 'T00:00:00' : ''}`);
    const now = new Date();
    if (dateFrom > now) return "fromInFutureError";
    if (dateFrom > dateTo) return "fromAfterToError";
    if (dateTo > now) return "toInFutureError";
    return null;
};
const $a113941c76257cbc$export$ef6dfb919b1d7267 = (filterId)=>{
    const productsForFilter = [];
    (0, $hB77E.ThirdPartyConfigs).forEach((_, productKey3P)=>{
        if ((0, $hB77E.ThirdPartyConfigs).get(productKey3P)?.filters?.includes(filterId)) productsForFilter.push(productKey3P);
    });
    return productsForFilter;
};
const $a113941c76257cbc$export$b29ea735dcfba3c1 = (value)=>{
    return value !== null && value !== undefined;
};

});
parcelRegister("9d9t8", function(module, exports) {

$parcel$export(module.exports, "SMARTLINKS_RESOURCE_TYPE_PREFIX", () => $320daaf61e2ab33a$export$e88fb694deeca21a);
$parcel$export(module.exports, "FEDERATED_CONNECTOR_SOURCE", () => $320daaf61e2ab33a$export$7ad7a95070d8bb93);
$parcel$export(module.exports, "SMARTLINKS_CONNECTOR_SOURCE", () => $320daaf61e2ab33a$export$c14e5e3fa6d8b46);
$parcel$export(module.exports, "FULL_CONNECTOR_SOURCE", () => $320daaf61e2ab33a$export$aa06c0b5cc41ad9a);
const $320daaf61e2ab33a$export$e88fb694deeca21a = 'smartlinks-connector';
const $320daaf61e2ab33a$export$7ad7a95070d8bb93 = 'federated';
const $320daaf61e2ab33a$export$c14e5e3fa6d8b46 = 'smartlinks';
const $320daaf61e2ab33a$export$aa06c0b5cc41ad9a = 'full-connector';

});





parcelRegister("f8oYd", function(module, exports) {

$parcel$export(module.exports, "useLogException", () => $ef865eddba22b4a1$export$67ff3bc9583d7c16);

var $gwFzn = parcelRequire("gwFzn");

var $4JgC8 = parcelRequire("4JgC8");
var $bXE8w = parcelRequire("bXE8w");

var $j4ply = parcelRequire("j4ply");
const $ef865eddba22b4a1$export$f86b2a1a2ce291b3 = async (error, userId, primaryProduct)=>{
    try {
        const SentryClient = await (0, $bXE8w.getSentryClient)();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            for (const [key, value] of Object.entries((0, $4JgC8.COMMON_TAGS)))scope.setTag(key, value);
            scope.setUser({
                id: userId || (0, $4JgC8.UNKNOWN_TAG)
            });
            scope.setTag('product', primaryProduct || (0, $4JgC8.UNKNOWN_TAG));
            SentryClient.captureException(error, scope);
        });
    } catch (error) {
        // When there was an error with Sentry, just output to console
        // eslint-disable-next-line no-console
        console.error(error);
    }
};
const $ef865eddba22b4a1$export$67ff3bc9583d7c16 = ()=>{
    const [{ primaryProduct: primaryProduct, user: user }] = (0, $j4ply.useBootstrap)();
    // Store data required for logging exceptions in refs to prevent re-renders
    return (0, $gwFzn.useCallback)(async (error)=>await $ef865eddba22b4a1$export$f86b2a1a2ce291b3(error, user?.id, primaryProduct), [
        primaryProduct,
        user?.id
    ]);
};

});
parcelRegister("4JgC8", function(module, exports) {

$parcel$export(module.exports, "SENTRY_DSN", () => $ffd07bcdf31e3a99$export$6faa4a850bc4d0ce);
$parcel$export(module.exports, "UNKNOWN_TAG", () => $ffd07bcdf31e3a99$export$ea77880e3935182d);
$parcel$export(module.exports, "COMMON_TAGS", () => $ffd07bcdf31e3a99$export$d60e93659f587f71);
// https://atlassian-2y.sentry.io/projects/search-page/getting-started
const $ffd07bcdf31e3a99$export$6faa4a850bc4d0ce = 'https://dcf49f8a57e71c9e77d30808a7708f8c@o55978.ingest.us.sentry.io/4506951588773888';
const $ffd07bcdf31e3a99$export$ea77880e3935182d = 'unknown';
const $ffd07bcdf31e3a99$export$d60e93659f587f71 = {
    search: true
};

});

parcelRegister("bXE8w", function(module, exports) {

$parcel$export(module.exports, "getSentryClient", () => $d7518b5a9314f4be$export$f553e8b08ef59d31);

var $5QinP = parcelRequire("5QinP");

var $4JgC8 = parcelRequire("4JgC8");
let $d7518b5a9314f4be$var$Sentry;
const $d7518b5a9314f4be$var$getEnvironment = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};
const $d7518b5a9314f4be$var$beforeSend = (event)=>{
    if (event.environment === 'development') return null;
    // Ignore errors that do not come from search projects
    if (!event.tags?.search) return null;
    // Delete the query string as it contains UGC
    if (event.request?.url) event.request.url = event.request.url.split('?')[0];
    if (event.request?.headers?.Referer) event.request.headers.Referer = event.request.headers.Referer.split('?')[0];
    return event;
};

const $d7518b5a9314f4be$export$f553e8b08ef59d31 = async ()=>{
    if (!$d7518b5a9314f4be$var$Sentry) $d7518b5a9314f4be$var$Sentry = (parcelRequire("9ieOA")).then((SentryModule)=>{
        SentryModule.init({
            dsn: (0, $4JgC8.SENTRY_DSN),
            attachStacktrace: true,
            release: (0, $5QinP.PRODUCT_BUILD) || (0, $4JgC8.UNKNOWN_TAG),
            environment: $d7518b5a9314f4be$var$getEnvironment(),
            beforeSend: $d7518b5a9314f4be$var$beforeSend
        });
        return SentryModule;
    }).catch(()=>{
    // TODO: Retry mechanism for chunk loading failures?
    });
    return $d7518b5a9314f4be$var$Sentry;
};

});
parcelRegister("5QinP", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_BUILD", () => $eb9263707673332f$export$668f31ea3127f48f);
// @ts-nocheck - extra properties on window are not known
/**
 * Constants for the build version of the product. Each product specifies
 * build version in a different way.
 *  - Jira: window.BUILD_KEY
 *  - Confluence: window.__buildInfo.FRONTEND_VERSION
 */ const $eb9263707673332f$export$668f31ea3127f48f = window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION;

});

parcelRegister("9ieOA", function(module, exports) {

let $6c41496cf4ac9eb8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6c41496cf4ac9eb8$var$load("4hOv8"),
    $6c41496cf4ac9eb8$var$load("5LCFM")
]).then(()=>parcelRequire('huNwZ'));

});




parcelRegister("4VkIo", function(module, exports) {

$parcel$export(module.exports, "getSelectedFilters", () => $9dfab17f37eb0047$export$f6546bb98204a0ca);
$parcel$export(module.exports, "useSelectedFilters", () => $9dfab17f37eb0047$export$e90e90fddddd8154);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $bnGHl = parcelRequire("bnGHl");

var $1yEFx = parcelRequire("1yEFx");

var $dOOW1 = parcelRequire("dOOW1");

var $fzQve = parcelRequire("fzQve");

var $j4ply = parcelRequire("j4ply");

var $djVCD = parcelRequire("djVCD");
parcelRequire("ehGUC");
var $fw303 = parcelRequire("fw303");
var $5X4Ay = parcelRequire("5X4Ay");
var $dQXZO = parcelRequire("dQXZO");
var $aGXLL = parcelRequire("aGXLL");
var $c5dmm = parcelRequire("c5dmm");
var $6jSbc = parcelRequire("6jSbc");
var $e7L4o = parcelRequire("e7L4o");
var $gwbWt = parcelRequire("gwbWt");
var $huubg = parcelRequire("huubg");
var $1uGSo = parcelRequire("1uGSo");
var $5ousX = parcelRequire("5ousX");
var $1sswv = parcelRequire("1sswv");
var $gHwfH = parcelRequire("gHwfH");
var $a97k3 = parcelRequire("a97k3");
var $iaYRG = parcelRequire("iaYRG");
var $bF9JE = parcelRequire("bF9JE");

var $gY9AU = parcelRequire("gY9AU");
const $9dfab17f37eb0047$export$f6546bb98204a0ca = ({ filters: filters, selectedProducts: selectedProducts, availableProducts: products, allFilterExcludedProducts: allFilterExcludedProducts, thirdPartyConfigs: thirdPartyConfigs, experimentConfig: experimentConfig, jsmIncidentFilterIds: jsmIncidentFilterIds })=>{
    const isDropAttachmentsCommentsFrmAllTypesEnabled = (0, $j4ply.getIsDropAttachmentsCommentsFrmAllTypesEnabled)(experimentConfig);
    const { selectedProduct: selectedProduct, filteredProducts: filteredProducts, availableProducts: availableProducts } = (0, $fzQve.getProducts)({
        selectedProducts: selectedProducts,
        availableProducts: products
    });
    const { selectedEntities: selectedEntities, entitiesForQuery: entitiesForQuery, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $djVCD.getTypeEntities)({
        availableProducts: availableProducts,
        filters: filters,
        selectedProducts: selectedProducts,
        allFilterExcludedProducts: allFilterExcludedProducts
    }, {
        thirdPartyConfigs: thirdPartyConfigs,
        dropAttachmentsComments: isDropAttachmentsCommentsFrmAllTypesEnabled
    });
    const titleMatchValue = (0, $gY9AU.getBooleanFilterValue)(filters[(0, $iaYRG.filter).id]);
    const selectedDateRange = (0, $gY9AU.getSelectedDateRange)(filters[(0, $1uGSo.filter).id]);
    const filterDateRange = (0, $gY9AU.getFilterDateRange)(filters[(0, $1uGSo.filter).id]);
    const commonContributors = (0, $gY9AU.getSelectFilterValue)(filters[(0, $aGXLL.filter).id]).length ? (0, $gY9AU.getSelectFilterValue)(filters[(0, $aGXLL.filter).id]) : undefined;
    const pageStatusValue = (0, $gY9AU.getSelectFilterValue)(filters[(0, $1sswv.filter).id])[0];
    const assigneeARIValues = (0, $gY9AU.getSelectFilterValue)(filters[(0, $5X4Ay.filter).id]).map((assigneeId)=>{
        return `ari:cloud:identity::user/${assigneeId}`;
    });
    const assignee3PValues = (0, $gY9AU.getSelectFilterValue)(filters[(0, $5X4Ay.filter).id]).map((assigneeId)=>{
        if (assigneeId.startsWith('ari:cloud:')) return (0, $bnGHl.IdentityUserAri).parse(assigneeId).resourceId;
        return assigneeId;
    });
    let containerAris = (0, $gY9AU.getSelectFilterValue)(filters[(0, $gHwfH.filter).id]);
    if ((0, $dh538.fg)('confluence-dc-space-filter')) containerAris = [
        ...containerAris,
        ...(0, $gY9AU.getSelectFilterValue)(filters[(0, $a97k3.filter).id])
    ];
    const createdByValues = (0, $gY9AU.getSelectFilterValue)(filters[(0, $c5dmm.filter).id]);
    const lastUpdatedByValues = (0, $gY9AU.getSelectFilterValue)(filters[(0, $huubg.filter).id]);
    const ancestorAris = (0, $gY9AU.getSelectFilterValue)(filters[(0, $dQXZO.filter).id]);
    const selectedFilters = {
        commonFilters: {
            range: {
                lastModified: selectedDateRange
            },
            contributorsFilter: commonContributors
        },
        jiraFilters: {
            issueFilter: {
                projectARIs: (0, $gY9AU.omitNonJiraFilterValues)((0, $gY9AU.getSelectFilterValue)(filters[(0, $gHwfH.filter).id]), selectedProduct),
                assigneeARIs: (0, $gY9AU.omitNonJiraFilterValues)(assigneeARIValues, selectedProduct),
                issueTypeIDs: (0, $dh538.fg)('search-page-relay-useselectedfilters') ? jsmIncidentFilterIds : []
            },
            projectFilter: {
                projectTypes: (0, $gY9AU.getJiraProjectFilter)(selectedProduct)
            }
        },
        confluenceFilters: {
            spacesFilter: (0, $gY9AU.getSelectFilterValue)(filters[(0, $a97k3.filter).id]),
            isVerified: (0, $gY9AU.getBooleanFilterValue)(filters[(0, $bF9JE.filter).id]) || undefined,
            contributorsFilter: (0, $gY9AU.getSelectFilterValue)(filters[(0, $aGXLL.filter).id]),
            ancestorIdsFilter: (0, $gY9AU.getSelectFilterValue)(filters[(0, $dQXZO.filter).id]),
            range: selectedProduct !== (0, $1yEFx.ProductKeys).Confluence ? filterDateRange : [],
            owners: (0, $gY9AU.getSelectFilterValue)(filters[(0, $5ousX.filter).id]),
            labelsFilter: (0, $gY9AU.getSelectFilterValue)(filters[(0, $gwbWt.filter).id]),
            ...(0, $dh538.fg)('add_confluence_title_match_filter') ? {
                titleMatchOnly: titleMatchValue
            } : {},
            ...pageStatusValue && (0, $dh538.fg)('add_confluence_status_filter') ? {
                pageStatus: [
                    pageStatusValue
                ]
            } : {},
            contentStatuses: selectedProduct === (0, $1yEFx.ProductKeys).Confluence ? (0, $gY9AU.getContentStatusValue)(filters[(0, $fw303.filter).id]) : [],
            containerStatus: selectedProduct === (0, $1yEFx.ProductKeys).Confluence ? (0, $gY9AU.getContainerStatusValue)(filters[(0, $fw303.filter).id]) : []
        },
        mercuryFilters: {
            owners: (0, $gY9AU.getSelectFilterValue)(filters[(0, $5ousX.filter).id]),
            focusAreaTypeIds: (0, $gY9AU.getSelectFilterValue)(filters[(0, $6jSbc.filter).id]),
            ancestorIds: (0, $dh538.fg)('search_enable_mercury_content_filter') ? (0, $gY9AU.getSelectFilterValue)(filters[(0, $e7L4o.filter).id]) : []
        },
        thirdPartyFilters: (0, $dOOW1.getThirdPartyFilters)(filteredProducts, titleMatchValue, selectedEntities, thirdPartyConfigs, (0, $dOOW1.baseIntegrationARIs), filterDateRange, assignee3PValues, containerAris, createdByValues, lastUpdatedByValues, ancestorAris)
    };
    const unselectedProductsThirdPartyFilters = (0, $dOOW1.getThirdPartyFilters)(availableProducts, titleMatchValue, selectedEntities, thirdPartyConfigs, (0, $dOOW1.baseIntegrationARIs), filterDateRange);
    const { commonFilters: commonFilters, jiraFilters: jiraFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, thirdPartyFilters: thirdPartyFilters } = selectedFilters;
    const isEmpty = !commonFilters.range.lastModified && selectedEntities.length === 0 && confluenceFilters.spacesFilter.length === 0 && !confluenceFilters.isVerified && !confluenceFilters.titleMatchOnly && confluenceFilters.contentStatuses.length === 0 && confluenceFilters.containerStatus.length === 0 && confluenceFilters.contributorsFilter.length === 0 && confluenceFilters.ancestorIdsFilter.length === 0 && confluenceFilters.range.length === 0 && confluenceFilters.owners.length === 0 && confluenceFilters.labelsFilter.length === 0 && (!confluenceFilters.pageStatus || confluenceFilters.pageStatus.length === 0) && jiraFilters.issueFilter.assigneeARIs.length === 0 && jiraFilters.issueFilter.projectARIs.length === 0 && mercuryFilters.owners.length === 0 && mercuryFilters.focusAreaTypeIds.length === 0 && mercuryFilters.ancestorIds.length === 0 && (!thirdPartyFilters.range || thirdPartyFilters?.range?.length === 0) && !thirdPartyFilters.titleMatchOnly && thirdPartyFilters.subtypes.length === 0 && (!thirdPartyFilters.assignees || thirdPartyFilters.assignees?.length === 0) && (!thirdPartyFilters.lastUpdatedBy || thirdPartyFilters.lastUpdatedBy?.length === 0) && (!thirdPartyFilters.createdBy || thirdPartyFilters.createdBy?.length === 0) && (!thirdPartyFilters.ancestorAris || thirdPartyFilters.ancestorAris?.length === 0);
    return {
        selectedFilters: selectedFilters,
        unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters,
        selectedEntities: selectedEntities,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery,
        entities: entitiesForQuery,
        hasFiltersSelected: !isEmpty
    };
};
const $9dfab17f37eb0047$var$useWrappedSelectedFilters = ({ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs })=>{
    const filters = (0, $djVCD.useFilters)();
    const [isDropAttachmentsCommentsFrmAllTypesEnabled] = (0, $j4ply.useIsDropAttachmentsCommentsFrmAllTypesEnabled)();
    const { selectedProduct: selectedProduct, filteredProducts: filteredProducts, availableProducts: availableProducts } = (0, $djVCD.useProducts)();
    const useTypeEntitiesArgs = (0, $gwFzn.useMemo)(()=>({
            thirdPartyConfigs: thirdPartyConfigs,
            dropAttachmentsComments: isDropAttachmentsCommentsFrmAllTypesEnabled
        }), [
        thirdPartyConfigs,
        isDropAttachmentsCommentsFrmAllTypesEnabled
    ]);
    const { selectedEntities: selectedEntities, entitiesForQuery: entitiesForQuery, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $djVCD.useTypeEntities)(useTypeEntitiesArgs);
    // This call can be removed when cleaning up search-page-relay-useselectedfilters
    const jiraIssueTypeFilters = (0, $gY9AU.useJiraIssueTypeFilters)(cloudId, selectedEntities); // contains a fetch call
    const jsmIncidentFilterIds = (0, $djVCD.useJsmIncidentFilterIds)(); // just a getter from state
    const titleMatchValue = (0, $gwFzn.useMemo)(()=>(0, $gY9AU.getBooleanFilterValue)(filters[(0, $iaYRG.filter).id]), [
        filters
    ]);
    const selectedDateRange = (0, $gwFzn.useMemo)(()=>(0, $gY9AU.getSelectedDateRange)(filters[(0, $1uGSo.filter).id]), [
        filters
    ]);
    const filterDateRange = (0, $gwFzn.useMemo)(()=>(0, $gY9AU.getFilterDateRange)(filters[(0, $1uGSo.filter).id]), [
        filters
    ]);
    const commonContributors = (0, $gwFzn.useMemo)(()=>{
        const contributors = (0, $gY9AU.getSelectFilterValue)(filters[(0, $aGXLL.filter).id]);
        return contributors.length ? contributors : undefined;
    }, [
        filters
    ]);
    const pageStatusValue = (0, $gwFzn.useMemo)(()=>(0, $gY9AU.getSelectFilterValue)(filters[(0, $1sswv.filter).id])[0], [
        filters
    ]);
    const assigneeARIValues = (0, $gwFzn.useMemo)(()=>(0, $gY9AU.getSelectFilterValue)(filters[(0, $5X4Ay.filter).id]).map((assigneeId)=>{
            return `ari:cloud:identity::user/${assigneeId}`;
        }), [
        filters
    ]);
    const assignee3PValues = (0, $gwFzn.useMemo)(()=>(0, $gY9AU.getSelectFilterValue)(filters[(0, $5X4Ay.filter).id]), [
        filters
    ]);
    const projectFilterValues = (0, $gwFzn.useMemo)(()=>(0, $gY9AU.getSelectFilterValue)(filters[(0, $gHwfH.filter).id]), [
        filters
    ]);
    const spaceFilterValues = (0, $gwFzn.useMemo)(()=>(0, $gY9AU.getSelectFilterValue)(filters[(0, $a97k3.filter).id]), [
        filters
    ]);
    const containerAris = (0, $gwFzn.useMemo)(()=>{
        if ((0, $dh538.fg)('confluence-dc-space-filter')) return [
            ...projectFilterValues,
            ...spaceFilterValues
        ];
        return projectFilterValues;
    }, [
        projectFilterValues,
        spaceFilterValues
    ]);
    const ancestorAris = (0, $gwFzn.useMemo)(()=>(0, $gY9AU.getSelectFilterValue)(filters[(0, $dQXZO.filter).id]), [
        filters
    ]);
    const createdByValues = (0, $gwFzn.useMemo)(()=>(0, $gY9AU.getSelectFilterValue)(filters[(0, $c5dmm.filter).id]), [
        filters
    ]);
    const lastUpdatedByValues = (0, $gwFzn.useMemo)(()=>(0, $gY9AU.getSelectFilterValue)(filters[(0, $huubg.filter).id]), [
        filters
    ]);
    const selectedFilters = (0, $gwFzn.useMemo)(()=>({
            commonFilters: {
                range: {
                    lastModified: selectedDateRange
                },
                contributorsFilter: commonContributors
            },
            jiraFilters: {
                issueFilter: {
                    projectARIs: (0, $gY9AU.omitNonJiraFilterValues)((0, $gY9AU.getSelectFilterValue)(filters[(0, $gHwfH.filter).id]), selectedProduct),
                    assigneeARIs: (0, $gY9AU.omitNonJiraFilterValues)(assigneeARIValues, selectedProduct),
                    issueTypeIDs: (0, $dh538.fg)('search-page-relay-useselectedfilters') ? jsmIncidentFilterIds : jiraIssueTypeFilters
                },
                projectFilter: {
                    projectTypes: (0, $gY9AU.getJiraProjectFilter)(selectedProduct)
                }
            },
            confluenceFilters: {
                spacesFilter: selectedProduct === (0, $1yEFx.ProductKeys).Confluence ? (0, $gY9AU.getSelectFilterValue)(filters[(0, $a97k3.filter).id]) : [],
                isVerified: (0, $gY9AU.getBooleanFilterValue)(filters[(0, $bF9JE.filter).id]) || undefined,
                contributorsFilter: (0, $gY9AU.getSelectFilterValue)(filters[(0, $aGXLL.filter).id]),
                ancestorIdsFilter: selectedProduct === (0, $1yEFx.ProductKeys).Confluence ? (0, $gY9AU.getSelectFilterValue)(filters[(0, $dQXZO.filter).id]) : [],
                range: selectedProduct !== (0, $1yEFx.ProductKeys).Confluence ? filterDateRange : [],
                owners: (0, $gY9AU.getSelectFilterValue)(filters[(0, $5ousX.filter).id]),
                labelsFilter: (0, $gY9AU.getSelectFilterValue)(filters[(0, $gwbWt.filter).id]),
                ...(0, $dh538.fg)('add_confluence_title_match_filter') ? {
                    titleMatchOnly: titleMatchValue
                } : {},
                ...pageStatusValue && (0, $dh538.fg)('add_confluence_status_filter') ? {
                    pageStatus: [
                        pageStatusValue
                    ]
                } : {},
                contentStatuses: selectedProduct === (0, $1yEFx.ProductKeys).Confluence ? (0, $gY9AU.getContentStatusValue)(filters[(0, $fw303.filter).id]) : [],
                containerStatus: selectedProduct === (0, $1yEFx.ProductKeys).Confluence ? (0, $gY9AU.getContainerStatusValue)(filters[(0, $fw303.filter).id]) : []
            },
            mercuryFilters: {
                owners: (0, $gY9AU.getSelectFilterValue)(filters[(0, $5ousX.filter).id]),
                focusAreaTypeIds: (0, $gY9AU.getSelectFilterValue)(filters[(0, $6jSbc.filter).id]),
                ancestorIds: (0, $dh538.fg)('search_enable_mercury_content_filter') ? (0, $gY9AU.getSelectFilterValue)(filters[(0, $e7L4o.filter).id]) : []
            },
            thirdPartyFilters: (0, $dOOW1.getThirdPartyFilters)(filteredProducts, titleMatchValue, selectedEntities, thirdPartyConfigs, (0, $dOOW1.baseIntegrationARIs), filterDateRange, assignee3PValues, containerAris, createdByValues, lastUpdatedByValues, ancestorAris)
        }), [
        filterDateRange,
        filteredProducts,
        filters,
        thirdPartyConfigs,
        selectedDateRange,
        selectedEntities,
        selectedProduct,
        titleMatchValue,
        commonContributors,
        jiraIssueTypeFilters,
        jsmIncidentFilterIds,
        pageStatusValue,
        assigneeARIValues,
        assignee3PValues,
        containerAris,
        createdByValues,
        lastUpdatedByValues,
        ancestorAris
    ]);
    const unselectedProductsThirdPartyFilters = (0, $gwFzn.useMemo)(()=>(0, $dOOW1.getThirdPartyFilters)(availableProducts, titleMatchValue, selectedEntities, thirdPartyConfigs, (0, $dOOW1.baseIntegrationARIs), filterDateRange), [
        availableProducts,
        titleMatchValue,
        selectedEntities,
        thirdPartyConfigs,
        filterDateRange
    ]);
    const { commonFilters: commonFilters, jiraFilters: jiraFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, thirdPartyFilters: thirdPartyFilters } = selectedFilters;
    const isEmpty = !commonFilters.range.lastModified && selectedEntities.length === 0 && confluenceFilters.spacesFilter.length === 0 && !confluenceFilters.isVerified && !confluenceFilters.titleMatchOnly && confluenceFilters.contentStatuses.length === 0 && confluenceFilters.containerStatus.length === 0 && confluenceFilters.contributorsFilter.length === 0 && confluenceFilters.ancestorIdsFilter.length === 0 && confluenceFilters.range.length === 0 && confluenceFilters.owners.length === 0 && confluenceFilters.labelsFilter.length === 0 && (!confluenceFilters.pageStatus || confluenceFilters.pageStatus.length === 0) && jiraFilters.issueFilter.assigneeARIs.length === 0 && jiraFilters.issueFilter.projectARIs.length === 0 && mercuryFilters.owners.length === 0 && mercuryFilters.focusAreaTypeIds.length === 0 && mercuryFilters.ancestorIds.length === 0 && (!thirdPartyFilters.range || thirdPartyFilters?.range?.length === 0) && !thirdPartyFilters.titleMatchOnly && thirdPartyFilters.subtypes.length === 0 && (!thirdPartyFilters.assignees || thirdPartyFilters.assignees?.length === 0) && (!thirdPartyFilters.lastUpdatedBy || thirdPartyFilters.lastUpdatedBy?.length === 0) && (!thirdPartyFilters.createdBy || thirdPartyFilters.createdBy?.length === 0) && (!thirdPartyFilters.ancestorAris || thirdPartyFilters.ancestorAris?.length === 0);
    return (0, $gwFzn.useMemo)(()=>{
        return {
            selectedFilters: selectedFilters,
            unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters,
            selectedEntities: selectedEntities,
            entitiesForResultsCountQuery: entitiesForResultsCountQuery,
            entities: entitiesForQuery,
            hasFiltersSelected: !isEmpty
        };
    }, [
        entitiesForQuery,
        entitiesForResultsCountQuery,
        isEmpty,
        selectedEntities,
        selectedFilters,
        unselectedProductsThirdPartyFilters
    ]);
};
const $9dfab17f37eb0047$export$de282177b3cc9a16 = ()=>{
    const [search] = (0, $djVCD.useSearch)();
    const [bootstrap] = (0, $j4ply.useBootstrap)();
    const { filters: filters, selectedProducts: selectedProducts, jsmIncidentFilterIds: jsmIncidentFilterIds } = search;
    const { products: products, allFilterExcludedProducts: allFilterExcludedProducts, thirdPartyConfigs: thirdPartyConfigs, experimentConfig: experimentConfig } = bootstrap;
    return (0, $gwFzn.useMemo)(()=>{
        return $9dfab17f37eb0047$export$f6546bb98204a0ca({
            filters: filters,
            selectedProducts: selectedProducts,
            availableProducts: products,
            allFilterExcludedProducts: allFilterExcludedProducts,
            thirdPartyConfigs: thirdPartyConfigs,
            experimentConfig: experimentConfig,
            jsmIncidentFilterIds: jsmIncidentFilterIds
        });
    }, [
        filters,
        selectedProducts,
        products,
        allFilterExcludedProducts,
        thirdPartyConfigs,
        experimentConfig,
        jsmIncidentFilterIds
    ]);
};
const $9dfab17f37eb0047$export$e90e90fddddd8154 = ({ cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs })=>{
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return (0, $dh538.fg)('search-page-relay-useselectedfilters') ? $9dfab17f37eb0047$export$de282177b3cc9a16() : $9dfab17f37eb0047$var$useWrappedSelectedFilters({
        thirdPartyConfigs: thirdPartyConfigs,
        cloudId: cloudId
    });
};

});
parcelRegister("fzQve", function(module, exports) {

$parcel$export(module.exports, "getProducts", () => $9616a9c1193b17e6$export$68a801b7b3c0bfaa);
const $9616a9c1193b17e6$export$561a56b49197d768 = (state)=>{
    return state.paginationTokens[0]?.cursor;
};
const $9616a9c1193b17e6$export$e9ba53b9cde9212a = (state)=>state.selectedProducts[0];
const $9616a9c1193b17e6$export$68a801b7b3c0bfaa = ({ selectedProducts: selectedProducts, availableProducts: availableProducts })=>{
    const selectedProduct = selectedProducts?.[0];
    const filteredProducts = selectedProduct ? [
        selectedProduct
    ] : availableProducts;
    return {
        selectedProduct: selectedProduct,
        filteredProducts: filteredProducts,
        availableProducts: availableProducts
    };
};

});

parcelRegister("ehGUC", function(module, exports) {

$parcel$export(module.exports, "allFilters", () => $7ad99be56c688d66$export$d8428ac7d93fb69a);
$parcel$export(module.exports, "archivedFilter", () => (parcelRequire("fw303")).filter);
$parcel$export(module.exports, "assigneeFilter", () => (parcelRequire("5X4Ay")).filter);
$parcel$export(module.exports, "createdByFilter", () => (parcelRequire("c5dmm")).filter);
$parcel$export(module.exports, "contentFilter", () => (parcelRequire("dQXZO")).filter);
$parcel$export(module.exports, "contributorFilter", () => (parcelRequire("aGXLL")).filter);
$parcel$export(module.exports, "lastUpdatedFilter", () => (parcelRequire("1uGSo")).filter);
$parcel$export(module.exports, "lastUpdatedByFilter", () => (parcelRequire("huubg")).filter);
$parcel$export(module.exports, "pageStatusFilter", () => (parcelRequire("1sswv")).filter);
$parcel$export(module.exports, "projectFilter", () => (parcelRequire("gHwfH")).filter);
$parcel$export(module.exports, "spaceFilter", () => (parcelRequire("a97k3")).filter);
$parcel$export(module.exports, "verifiedFilter", () => (parcelRequire("bF9JE")).filter);
$parcel$export(module.exports, "titleMatchFilter", () => (parcelRequire("iaYRG")).filter);
$parcel$export(module.exports, "ownerFilter", () => (parcelRequire("5ousX")).filter);
$parcel$export(module.exports, "labelFilter", () => (parcelRequire("gwbWt")).filter);
$parcel$export(module.exports, "focusAreaTypeFilter", () => (parcelRequire("6jSbc")).filter);
$parcel$export(module.exports, "focusAreaUnderFilter", () => (parcelRequire("e7L4o")).filter);

var $5iakG = parcelRequire("5iakG");

var $fw303 = parcelRequire("fw303");

var $5X4Ay = parcelRequire("5X4Ay");

var $dQXZO = parcelRequire("dQXZO");

var $aGXLL = parcelRequire("aGXLL");

var $c5dmm = parcelRequire("c5dmm");

var $6jSbc = parcelRequire("6jSbc");

var $e7L4o = parcelRequire("e7L4o");

var $gwbWt = parcelRequire("gwbWt");

var $1uGSo = parcelRequire("1uGSo");

var $huubg = parcelRequire("huubg");

var $5ousX = parcelRequire("5ousX");

var $1sswv = parcelRequire("1sswv");

var $gHwfH = parcelRequire("gHwfH");

var $a97k3 = parcelRequire("a97k3");

var $iaYRG = parcelRequire("iaYRG");

var $dUIpv = parcelRequire("dUIpv");

var $bF9JE = parcelRequire("bF9JE");
const $7ad99be56c688d66$export$d8428ac7d93fb69a = Object.freeze({
    [(0, $1uGSo.filter).id]: (0, $1uGSo.filter),
    [(0, $aGXLL.filter).id]: (0, $aGXLL.filter),
    [(0, $a97k3.filter).id]: (0, $a97k3.filter),
    [(0, $bF9JE.filter).id]: (0, $bF9JE.filter),
    [(0, $5X4Ay.filter).id]: (0, $5X4Ay.filter),
    [(0, $gHwfH.filter).id]: (0, $gHwfH.filter),
    [(0, $5iakG.universalTypeFilterId)]: (0, $dUIpv.filter),
    [(0, $dQXZO.filter).id]: (0, $dQXZO.filter),
    [(0, $iaYRG.filter).id]: (0, $iaYRG.filter),
    [(0, $5ousX.filter).id]: (0, $5ousX.filter),
    [(0, $c5dmm.filter).id]: (0, $c5dmm.filter),
    [(0, $gwbWt.filter).id]: (0, $gwbWt.filter),
    [(0, $6jSbc.filter).id]: (0, $6jSbc.filter),
    [(0, $e7L4o.filter).id]: (0, $e7L4o.filter),
    [(0, $1sswv.filter).id]: (0, $1sswv.filter),
    [(0, $fw303.filter).id]: (0, $fw303.filter),
    [(0, $huubg.filter).id]: (0, $huubg.filter)
});

});
parcelRegister("fw303", function(module, exports) {

$parcel$export(module.exports, "filter", () => $28f6a41f8eb2075f$export$3dea766d36a8935f);

var $dh538 = parcelRequire("dh538");

var $1yEFx = parcelRequire("1yEFx");

var $dOOW1 = parcelRequire("dOOW1");

var $ffbvg = parcelRequire("ffbvg");
const $28f6a41f8eb2075f$var$productKeys1P = [];
const $28f6a41f8eb2075f$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('archived');
const $28f6a41f8eb2075f$var$getProducts1P = ()=>{
    return (0, $dh538.fg)('enable_confluence_archived_content_filter') ? [
        (0, $1yEFx.ProductKeys).Confluence
    ] : $28f6a41f8eb2075f$var$productKeys1P;
};
const $28f6a41f8eb2075f$export$3dea766d36a8935f = (0, $ffbvg.createBooleanFilter)({
    id: 'archived',
    queryParams: {
        key: 'archived'
    },
    products: [
        ...$28f6a41f8eb2075f$var$getProducts1P(),
        ...$28f6a41f8eb2075f$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});

});
parcelRegister("ffbvg", function(module, exports) {

$parcel$export(module.exports, "useBooleanFilter", () => $2df2afcc09d5a44d$export$c97cd60200241832);
$parcel$export(module.exports, "createBooleanFilter", () => $2df2afcc09d5a44d$export$2963583aeb05fcae);

var $djVCD = parcelRequire("djVCD");
const $2df2afcc09d5a44d$export$c97cd60200241832 = ({ filterId: filterId })=>{
    const [state, storeActions] = (0, $djVCD.useBooleanFilterStore)({
        filterId: filterId
    });
    const viewActions = {
        toggle: ()=>{
            if (!state) return;
            storeActions.setBooleanFilterValue({
                filterId: filterId,
                value: !state.value
            });
        }
    };
    if (!state) return [
        ,
        viewActions
    ];
    const viewState = {
        value: state.value,
        autoFocus: state.alwaysVisible === false
    };
    return [
        viewState,
        viewActions
    ];
};
const $2df2afcc09d5a44d$export$2963583aeb05fcae = (initial)=>{
    const initialState = {
        ...initial,
        type: 'boolean',
        value: false,
        hasSelection: false,
        universal: initial.universal
    };
    return {
        id: initial.id,
        type: initialState.type,
        products: initial.products,
        universal: initial.universal,
        queryParams: {
            key: initialState.queryParams.key
        },
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$2df2afcc09d5a44d$export$cd193ee4357dee7f({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$2df2afcc09d5a44d$export$cd193ee4357dee7f({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: false
    };
};
const $2df2afcc09d5a44d$export$cd193ee4357dee7f = ({ initial: initial, state: state, config: config })=>{
    const filterState = {
        ...state,
        hasSelection: state.value
    };
    return {
        ...filterState,
        setValue: $2df2afcc09d5a44d$var$setValue({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: ()=>filterState.value,
        getState: ()=>filterState,
        queryParams: {
            key: initial.queryParams.key,
            get: $2df2afcc09d5a44d$var$getQueryParams({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $2df2afcc09d5a44d$var$setQueryParams({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        clear: $2df2afcc09d5a44d$var$clear({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $2df2afcc09d5a44d$var$setValue = ({ initial: initial, state: state, config: config })=>{
    return (value)=>{
        const newState = {
            ...state,
            value: value,
            hasSelection: value
        };
        return $2df2afcc09d5a44d$export$cd193ee4357dee7f({
            initial: initial,
            state: newState,
            config: config
        });
    };
};
const $2df2afcc09d5a44d$var$getQueryParams = ({ initial: initial, state: state })=>{
    return ()=>({
            [initial.queryParams.key]: state.value === true ? [
                'true'
            ] : undefined
        });
};
const $2df2afcc09d5a44d$var$setQueryParams = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams)=>{
        const queryParamValue = queryParams[initial.queryParams.key];
        const booleanValue = queryParamValue?.at(0) === 'true' ? true : false;
        return $2df2afcc09d5a44d$export$cd193ee4357dee7f({
            initial: initial,
            state: {
                ...state,
                value: booleanValue,
                hasSelection: booleanValue
            },
            config: config
        });
    };
};
const $2df2afcc09d5a44d$var$clear = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $2df2afcc09d5a44d$export$cd193ee4357dee7f({
            initial: initial,
            state: state,
            config: config
        });
        return filter.setValue(false);
    };
};

});


parcelRegister("5X4Ay", function(module, exports) {

$parcel$export(module.exports, "filter", () => $d4c3bf3cbd6e1760$export$3dea766d36a8935f);

var $3paC4 = parcelRequire("3paC4");
var $2CQZl = parcelRequire("2CQZl");
var $iUYhn = parcelRequire("iUYhn");
var $i8MOh = parcelRequire("i8MOh");

var $1yEFx = parcelRequire("1yEFx");

var $dOOW1 = parcelRequire("dOOW1");

var $6Ea6j = parcelRequire("6Ea6j");

var $4bHQd = parcelRequire("4bHQd");
const $d4c3bf3cbd6e1760$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $d4c3bf3cbd6e1760$var$loadInitialOptions = async (config)=>{
    if (config.product === (0, $1yEFx.ProductKeys).JiraDC) return (0, $4bHQd.loadRecommendedUsers)(config);
    return $d4c3bf3cbd6e1760$var$searchJiraCloudAssignee('', config);
};
const $d4c3bf3cbd6e1760$var$searchAssignee = async (query, config)=>{
    if (config.product === (0, $1yEFx.ProductKeys).JiraDC) return $d4c3bf3cbd6e1760$var$searchAssignees3P(query, config);
    return $d4c3bf3cbd6e1760$var$searchJiraCloudAssignee(query, config);
};
const $d4c3bf3cbd6e1760$var$searchAssignees3P = async (query, config)=>{
    if (!config.intl) return []; // base on existing interface, can only query with intl
    const response = await (0, $2CQZl.getAssignees)({
        query: query,
        cloudId: config.cloudId || '',
        userId: config.userId || '',
        productKey: (0, $1yEFx.ProductKeys).Confluence,
        maxNumberOfResults: $d4c3bf3cbd6e1760$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) return [];
    return response.map((assignee)=>({
            trackingKey: assignee.id,
            value: assignee.id,
            label: assignee.name,
            avatarUrl: assignee.avatarUrl,
            queryParamValue: assignee.id
        }));
};
const $d4c3bf3cbd6e1760$var$searchJiraCloudAssignee = async (query, config)=>{
    const searchClient = (0, $3paC4.createClient)({
        cloudId: config.cloudId || ''
    });
    const searchAssigneesResponse = await searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $iUYhn.Scope).People
        ],
        analytics: {
            identifier: 'search-page'
        }
    });
    const [searchAssigneeResults] = searchAssigneesResponse.response.rawData.scopes ?? [];
    const allAssignees = searchAssigneeResults.results.map((user)=>({
            picture: user.avatarUrl,
            name: user.name,
            id: user.id,
            accountId: user.id
        }));
    const userIds = new Set();
    const assigneeOptions = allAssignees.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
    .map((user)=>({
            trackingKey: user.id,
            value: user.id,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId
        }));
    return assigneeOptions;
};
const $d4c3bf3cbd6e1760$var$productKeys1P = [
    (0, $1yEFx.ProductKeys).Jira,
    (0, $1yEFx.ProductKeys).JiraProductDiscovery,
    (0, $1yEFx.ProductKeys).JiraServiceManagement
];
const $d4c3bf3cbd6e1760$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('assignee');
const $d4c3bf3cbd6e1760$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'assignee',
    products: [
        ...$d4c3bf3cbd6e1760$var$productKeys1P,
        ...$d4c3bf3cbd6e1760$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'jAssignee',
        fetcher: async (queryParams, _)=>{
            const initialUsersResponse = await (0, $i8MOh.usersQuery)(queryParams);
            const allAssignees = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            const assigneeOptions = allAssignees.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId
                }));
            return assigneeOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $d4c3bf3cbd6e1760$var$loadInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $d4c3bf3cbd6e1760$var$searchAssignee(query, config);
        }
    }
});

});
parcelRegister("2CQZl", function(module, exports) {

$parcel$export(module.exports, "getAssignees", () => $807072fc846be7b2$export$83f72e15d115a0e7);

var $5kTPO = parcelRequire("5kTPO");
const $807072fc846be7b2$export$83f72e15d115a0e7 = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'assignee',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $5kTPO.default)(requestParams, intl);
};

});

parcelRegister("i8MOh", function(module, exports) {

$parcel$export(module.exports, "usersQuery", () => $00597ab6f62a5638$export$ef7fb495aeba8901);

var $4qT1X = parcelRequire("4qT1X");

var $hw4j5 = parcelRequire("hw4j5");
const $00597ab6f62a5638$export$69a3209f1a06c04d = (0, $hw4j5.inMemoryCache)();
const $00597ab6f62a5638$var$GQL_OPERATION_NAME = 'SearchPageUserQuery';
const $00597ab6f62a5638$var$getUserQuery = ()=>`
query ${$00597ab6f62a5638$var$GQL_OPERATION_NAME}($accountId: ID!) {
  user(accountId: $accountId) {
    id
    accountId
    name
    picture
  }
}
`;
const $00597ab6f62a5638$export$25f4d46d5dabadfc = (accountId)=>{
    return $00597ab6f62a5638$export$69a3209f1a06c04d.inMemoryDecorator(accountId, async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $00597ab6f62a5638$var$getUserQuery(),
            variables: {
                accountId: accountId
            },
            operationName: $00597ab6f62a5638$var$GQL_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
const $00597ab6f62a5638$export$c3d7afa7f49d431e = (0, $hw4j5.inMemoryCache)();
const $00597ab6f62a5638$var$GQL_USERS_OPERATION_NAME = 'SearchPageUsersQuery';
const $00597ab6f62a5638$var$getUsersQuery = ()=>`
query ${$00597ab6f62a5638$var$GQL_USERS_OPERATION_NAME}($accountIds: [ID!]!) {
  users(accountIds: $accountIds) {
    id
    name
    picture
    accountId
  }
}
`;
const $00597ab6f62a5638$export$ef7fb495aeba8901 = (accountIds)=>{
    return $00597ab6f62a5638$export$c3d7afa7f49d431e.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per user id
    accountIds.join(','), async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $00597ab6f62a5638$var$getUsersQuery(),
            variables: {
                accountIds: accountIds
            },
            operationName: $00597ab6f62a5638$var$GQL_USERS_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};

});

parcelRegister("6Ea6j", function(module, exports) {

$parcel$export(module.exports, "createMultiSelectFilter", () => $bbb289b791cf3bdd$export$9c05e038f495cba8);

var $5cssW = parcelRequire("5cssW");
const $bbb289b791cf3bdd$export$9c05e038f495cba8 = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'multi-select',
        didMount: false,
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$bbb289b791cf3bdd$export$63027158d47e5479({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$bbb289b791cf3bdd$export$63027158d47e5479({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: false
    };
};
const $bbb289b791cf3bdd$export$63027158d47e5479 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $5cssW.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: (0, $5cssW.getQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: (0, $5cssW.setQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $5cssW.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: (0, $5cssW.setOption)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $5cssW.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $5cssW.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $5cssW.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $5cssW.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $5cssW.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};

});
parcelRegister("5cssW", function(module, exports) {

$parcel$export(module.exports, "useSelectFilter", () => $ded31ca78b6b8828$export$ac822ab68badd883);
$parcel$export(module.exports, "useUniversalSelectFilter", () => $ded31ca78b6b8828$export$eb312ee1d3a7a748);
$parcel$export(module.exports, "getState", () => $ded31ca78b6b8828$export$50fdfeece43146fd);
$parcel$export(module.exports, "getQueryParams", () => $ded31ca78b6b8828$export$e2de15bbd9edf9c6);
$parcel$export(module.exports, "setQueryParams", () => $ded31ca78b6b8828$export$7755017099c85a0d);
$parcel$export(module.exports, "loadInitialOptions", () => $ded31ca78b6b8828$export$ad6c12f692e14555);
$parcel$export(module.exports, "setOption", () => $ded31ca78b6b8828$export$b2a7969df3fe0aa3);
$parcel$export(module.exports, "clearOptions", () => $ded31ca78b6b8828$export$69017055aa8b346e);
$parcel$export(module.exports, "setLookupInput", () => $ded31ca78b6b8828$export$92164aa84e23cd67);
$parcel$export(module.exports, "getOptions", () => $ded31ca78b6b8828$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "getValue", () => $ded31ca78b6b8828$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "deselectOptions", () => $ded31ca78b6b8828$export$d0f857db6e3e26d7);

var $dBxQj = parcelRequire("dBxQj");

var $dh538 = parcelRequire("dh538");

var $2Znam = parcelRequire("2Znam");

var $1yEFx = parcelRequire("1yEFx");

var $djVCD = parcelRequire("djVCD");

var $7jUYs = parcelRequire("7jUYs");
const $ded31ca78b6b8828$export$ac822ab68badd883 = ({ filterId: filterId, optionValuesToExclude: optionValuesToExclude })=>{
    const [state, storeActions] = (0, $djVCD.useSelectFilterStore)({
        filterId: filterId
    });
    const viewActions = {
        setOption: (option, customValue)=>{
            const options = Array.isArray(option) ? option : [
                option
            ];
            const optionChange = options.map((option)=>({
                    value: option.value,
                    isSelected: !option.isSelected
                }));
            return storeActions.setSelectFilterOption({
                filterId: filterId,
                optionChange: optionChange,
                customValue: customValue
            });
        },
        loadInitialOptions: ()=>storeActions.loadInitialSelectFilterOptions({
                filterId: filterId
            }),
        setLookupInput: (query)=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: query
            }),
        clearLookupInput: ()=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: ''
            }),
        clearOptions: ()=>storeActions.clearSelectFilterOptions({
                filterId: filterId
            })
    };
    if (!state) return [
        ,
        viewActions
    ];
    const filteredOptions = state.options.filter((option)=>{
        if (optionValuesToExclude) return !optionValuesToExclude.includes(option.value);
        return true;
    });
    const selectedOptionsCount = state.selectedOptions.length;
    const viewState = {
        defaultIsOpen: state.alwaysVisible === false,
        isLookupDefined: state.lookup.isDefined,
        isLoading: state.queryParams.isLoading || state.initialOptions.isLoading || state.lookup.isLoading,
        lookupInput: state.lookup.input,
        options: filteredOptions,
        suggestedOptions: filteredOptions.filter((option)=>!option.isSelected && option.isSuggested),
        selectedOptions: state.selectedOptions,
        isLookupActive: state.lookup.isActive,
        alwaysVisible: state.alwaysVisible,
        customValue: state.customValue,
        badgeLabel: selectedOptionsCount > 1 ? `+${selectedOptionsCount - 1}` : undefined,
        firstSelectedOptionLabel: state.selectedOptions.at(0)?.label
    };
    return [
        viewState,
        viewActions
    ];
};
const $ded31ca78b6b8828$export$eb312ee1d3a7a748 = ({ filterId: filterId, optionsToProducts: optionsToProducts })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [state, storeActions] = (0, $djVCD.useSelectFilterStore)({
        filterId: filterId
    });
    const viewActions = {
        setOption: (option)=>{
            const options = Array.isArray(option) ? option : [
                option
            ];
            const optionChange = options.map((option)=>({
                    value: option.value,
                    isSelected: !option.isSelected
                }));
            return storeActions.setSelectFilterOption({
                filterId: filterId,
                optionChange: optionChange
            });
        },
        loadInitialOptions: ()=>storeActions.loadInitialSelectFilterOptions({
                filterId: filterId
            }),
        setLookupInput: (query)=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: query
            }),
        clearLookupInput: ()=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: ''
            }),
        clearOptions: ()=>storeActions.clearSelectFilterOptions({
                filterId: filterId
            })
    };
    if (!state) return [
        ,
        viewActions
    ];
    const selectedProductsAvailable = state.selectedProducts.length > 0;
    const products = selectedProductsAvailable ? state.selectedProducts : state.availableProducts;
    const filteredOptions = state.options.filter((option)=>option.isDefault || option.isSelected || optionsToProducts[option.value]?.some((product)=>products.includes(product)))// This is a temporary hack to filter out Atlas specific types, unless Atlas is the selected product
    .filter((option)=>!(state.selectedProducts[0] !== (0, $1yEFx.ProductKeys).Atlas && (option.value === 'goal' || option.value === 'tag')))// Filtering out all options that are tied exclusively to allFilterExcludedProducts for universal types
    .filter((option)=>!selectedProductsAvailable && optionsToProducts[option.value]?.length ? optionsToProducts[option.value].some((product)=>!state.allFilterExcludedProducts.includes(product)) : true);
    const selectedOptions = state.selectedOptions.map((option)=>({
            ...option
        }));
    if (products.length === 1 && products[0] === (0, $1yEFx.ProductKeys).ConfluenceDC && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in')) {
        const isPageOption = (option)=>option.value === (0, $2Znam.TypeFilterValueKey).Page;
        // Update both filtered and selected options that match Page type
        [
            filteredOptions,
            selectedOptions
        ].flatMap((options)=>options.filter(isPageOption)).forEach((option)=>{
            option.label = formatMessage((0, $7jUYs.typeLabels).page);
        });
    }
    const viewState = {
        defaultIsOpen: state.alwaysVisible === false,
        isLookupDefined: state.lookup.isDefined,
        isLoading: state.queryParams.isLoading || state.initialOptions.isLoading || state.lookup.isLoading,
        lookupInput: state.lookup.input,
        options: filteredOptions,
        suggestedOptions: filteredOptions.filter((option)=>!option.isSelected && option.isSuggested),
        selectedOptions: selectedOptions,
        isLookupActive: state.lookup.isActive,
        alwaysVisible: state.alwaysVisible
    };
    return [
        viewState,
        viewActions
    ];
};
const $ded31ca78b6b8828$export$639eaf0f64f8fe4 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: $ded31ca78b6b8828$export$50fdfeece43146fd({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: $ded31ca78b6b8828$export$e2de15bbd9edf9c6({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $ded31ca78b6b8828$export$7755017099c85a0d({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: $ded31ca78b6b8828$export$ad6c12f692e14555({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $ded31ca78b6b8828$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: $ded31ca78b6b8828$export$69017055aa8b346e({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: $ded31ca78b6b8828$export$92164aa84e23cd67({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: $ded31ca78b6b8828$export$d2312e68e1f5ad00({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: $ded31ca78b6b8828$export$bf7199a9ebcb84a9({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: $ded31ca78b6b8828$export$d0f857db6e3e26d7({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $ded31ca78b6b8828$export$50fdfeece43146fd = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $ded31ca78b6b8828$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const allOptions = filter.getOptions({
            isLookupActive: false
        });
        const newOptions = filter.getOptions({
            isLookupActive: state.lookup.isActive
        });
        const selectedOptions = allOptions.filter((option)=>option.isSelected);
        const newState = {
            ...state,
            options: newOptions,
            selectedOptions: selectedOptions,
            hasSelection: selectedOptions.length > 0,
            value: filter.getValue()
        };
        return newState;
    };
};
const $ded31ca78b6b8828$export$7755017099c85a0d = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams, onStateChange)=>{
        const queryParamValues = queryParams[initial.queryParams.key];
        const filter = $ded31ca78b6b8828$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        if (!queryParamValues) {
            const clearedOptions = filter.clearOptions();
            onStateChange?.(clearedOptions.getState());
            return clearedOptions;
        }
        const allCurrentOptions = filter.getOptions({
            isLookupActive: false
        });
        const allQueryParamValues = allCurrentOptions.map((option)=>option.queryParamValue);
        const queryParamsToHydrate = queryParamValues.filter((value)=>!allQueryParamValues.includes(value));
        if (queryParamsToHydrate.length === 0) {
            const newOptions = allCurrentOptions.map((option)=>({
                    isSelected: queryParamValues.includes(option.queryParamValue),
                    value: option.value
                }));
            const filterWithNewOptions = filter.setOption(newOptions);
            onStateChange?.(filterWithNewOptions.getState());
            return filterWithNewOptions;
        }
        // At this point we need to hydrate the filters with new options from
        // the query params
        const newQueryParamOptions = [
            ...state.queryParams.options
        ];
        const fetcher = initial.queryParams.fetcher;
        if (fetcher) {
            onStateChange?.({
                ...state,
                queryParams: {
                    ...state.queryParams,
                    isLoading: true
                }
            });
            const fetchedOptions = await fetcher(queryParamsToHydrate, config);
            fetchedOptions.forEach((option)=>{
                const mappedOption = {
                    isSelected: true,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label,
                    metadata: option.metadata
                };
                newQueryParamOptions.push(mappedOption);
            });
        }
        const selectedOptionsFromQueryParams = newQueryParamOptions.map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const selectedInitialOptionsFromQueryParams = [
            ...state.initialOptions.options
        ].map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const hydratedQueryParams = $ded31ca78b6b8828$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                queryParams: {
                    ...state.queryParams,
                    options: selectedOptionsFromQueryParams,
                    isLoading: false
                },
                initialOptions: {
                    ...state.initialOptions,
                    options: selectedInitialOptionsFromQueryParams
                }
            },
            config: config
        });
        onStateChange?.(hydratedQueryParams.getState());
        return hydratedQueryParams;
    };
};
const $ded31ca78b6b8828$export$e2de15bbd9edf9c6 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const queryParamValue = $ded31ca78b6b8828$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        }).filter((option)=>option.isSelected).map((option)=>option.queryParamValue);
        return {
            [initial.queryParams.key]: queryParamValue
        };
    };
};
const $ded31ca78b6b8828$export$ad6c12f692e14555 = ({ initial: initial, state: state, config: config })=>{
    return async (onStateChange)=>{
        if (state.didMount) {
            const newDropdownState = {
                ...state
            };
            onStateChange?.(newDropdownState);
            return $ded31ca78b6b8828$export$639eaf0f64f8fe4({
                initial: initial,
                state: newDropdownState,
                config: config
            });
        }
        const newOptions = [
            ...state.initialOptions.options
        ];
        const fetcher = initial.initialOptions?.fetcher;
        if (fetcher) {
            const fetchingInitialOptionsState = {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    isLoading: true
                }
            };
            onStateChange?.(fetchingInitialOptionsState);
            try {
                const fetchedOptions = await fetcher(config);
                fetchedOptions.forEach((option)=>{
                    const mappedOption = {
                        isSelected: false,
                        trackingKey: option.trackingKey,
                        value: option.value,
                        queryParamValue: option.queryParamValue,
                        isSuggested: true,
                        isDefault: option.isDefault ?? false,
                        avatarUrl: option.avatarUrl,
                        label: option.label,
                        metadata: option.metadata
                    };
                    newOptions.push(mappedOption);
                });
            } catch  {
                const fetchFailedState = {
                    ...state,
                    initialOptions: {
                        ...state.initialOptions,
                        isLoading: false
                    }
                };
                onStateChange?.(fetchFailedState);
            }
        }
        const newInitialOptionsState = {
            ...state,
            didMount: true,
            initialOptions: {
                ...state.initialOptions,
                options: newOptions,
                isLoading: false
            }
        };
        onStateChange?.(newInitialOptionsState);
        return $ded31ca78b6b8828$export$639eaf0f64f8fe4({
            initial: initial,
            state: newInitialOptionsState,
            config: config
        });
    };
};
const $ded31ca78b6b8828$export$d2312e68e1f5ad00 = ({ initial: initial, state: state })=>{
    return (options)=>{
        const allSelectedValues = new Set([
            ...state.queryParams.options.filter((option)=>option.isSelected).map((option)=>option.value),
            ...state.initialOptions.options.filter((option)=>option.isSelected).map((option)=>option.value),
            ...state.lookup.options.filter((lookupOption)=>lookupOption.isSelected).map((option)=>option.value)
        ]);
        if (options.isLookupActive) {
            const lookupResults = state.lookup.lookupResultOptions.map((option)=>({
                    ...option,
                    isSelected: allSelectedValues.has(option.value)
                }));
            return lookupResults;
        }
        const duplicateOptions = new Set();
        const newOptions = [
            ...state.queryParams.options,
            // Query Params first
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // The 'interacted' options are persisted in  state.lookup.options
            ...state.lookup.options,
            ...state.initialOptions.options
        ].filter((option)=>!duplicateOptions.has(option.value) && duplicateOptions.add(option.value) // remove duplicates
        ).map((option)=>({
                ...option,
                isSelected: allSelectedValues.has(option.value)
            }));
        if (initial.sortCompareFn) return newOptions.sort(initial.sortCompareFn);
        return newOptions;
    };
};
const $ded31ca78b6b8828$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option)=>{
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const optionsToChangeRecord = Object.fromEntries(optionsToChange.map((option)=>[
                option.value,
                option
            ]));
        const queryParamOptions = state.queryParams.options.map((option)=>{
            if (!optionsToChange.find((x)=>x.value === option.value)) return option;
            return {
                ...option,
                isSelected: optionsToChangeRecord[option.value]?.isSelected ?? false
            };
        });
        const initialOptions = state.initialOptions.options.map((option)=>{
            if (!optionsToChange.find((x)=>x.value === option.value)) return option;
            return {
                ...option,
                isSelected: optionsToChangeRecord[option.value]?.isSelected ?? false
            };
        });
        const duplicateOptions = new Set();
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // The 'interacted' options are persisted in  state.lookup.options
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].filter((option)=>!duplicateOptions.has(option.value) && duplicateOptions.add(option.value) // remove duplicates
        ).map((option)=>({
                ...option,
                isSuggested: true,
                isSelected: optionsToChangeRecord[option.value]?.isSelected ?? option.isSelected
            }));
        return $ded31ca78b6b8828$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
const $ded31ca78b6b8828$export$69017055aa8b346e = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const queryParamOptions = state.queryParams.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        const initialOptions = state.initialOptions.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        const lookupOptions = state.lookup.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        return $ded31ca78b6b8828$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
const $ded31ca78b6b8828$export$92164aa84e23cd67 = ({ initial: initial, state: state, config: config })=>{
    return async (query, onStateChange)=>{
        if (!initial.lookup || query.length === 0 || state.lookup.input === query) {
            const noQueryState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    isLoading: false,
                    isActive: false
                }
            };
            onStateChange?.(noQueryState);
            return $ded31ca78b6b8828$export$639eaf0f64f8fe4({
                initial: initial,
                state: noQueryState,
                config: config
            });
        }
        const fetchingLookupOptionsState = {
            ...state,
            lookup: {
                ...state.lookup,
                input: query,
                isLoading: true,
                isActive: true
            }
        };
        onStateChange?.(fetchingLookupOptionsState);
        try {
            const fetchedLookupOptions = await initial.lookup.fetcher(query, config);
            const newLookupOptions = fetchedLookupOptions.map((option)=>{
                const mappedOption = {
                    isSelected: false,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label,
                    metadata: option.metadata
                };
                return mappedOption;
            });
            const newLookupOptionsState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    lookupResultOptions: newLookupOptions,
                    isLoading: false,
                    isActive: true
                }
            };
            onStateChange?.(newLookupOptionsState);
            return $ded31ca78b6b8828$export$639eaf0f64f8fe4({
                initial: initial,
                state: newLookupOptionsState,
                config: config
            });
        } catch  {
            const failedLookupOptionsState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    isLoading: false,
                    isActive: true
                }
            };
            onStateChange?.(failedLookupOptionsState);
            return $ded31ca78b6b8828$export$639eaf0f64f8fe4({
                initial: initial,
                state: failedLookupOptionsState,
                config: config
            });
        }
    };
};
const $ded31ca78b6b8828$export$bf7199a9ebcb84a9 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        return $ded31ca78b6b8828$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        }).filter((option)=>option.isSelected).map((option)=>option.value);
    };
};
const $ded31ca78b6b8828$export$d0f857db6e3e26d7 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $ded31ca78b6b8828$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const allOptions = [
            ...filter.getOptions({
                isLookupActive: true
            }),
            ...filter.getOptions({
                isLookupActive: false
            })
        ].map((option)=>({
                value: option.value,
                isSelected: false
            }));
        return filter.setOption(allOptions);
    };
};

});


parcelRegister("4bHQd", function(module, exports) {

$parcel$export(module.exports, "loadRecommendedUsers", () => $3fbd92d1a753d7ae$export$8e839a938752e935);

var $cxsgw = parcelRequire("cxsgw");
var $i8MOh = parcelRequire("i8MOh");
const $3fbd92d1a753d7ae$var$MAX_SMART_DEFAULT_OPTIONS = 5;
const $3fbd92d1a753d7ae$export$8e839a938752e935 = async (config)=>{
    const initialUsersQuery = (0, $i8MOh.usersQuery)([
        ...config.userId ? [
            config.userId
        ] : []
    ]);
    const recommendedUserQuery = (0, $cxsgw.smartsRecommendedUserQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            userId: config.userId || '',
            tenantId: config.cloudId || '',
            maxNumberOfResults: $3fbd92d1a753d7ae$var$MAX_SMART_DEFAULT_OPTIONS
        }
    });
    const [initialUsersReponse, smartsRecommendedUserResponse] = await Promise.all([
        initialUsersQuery,
        recommendedUserQuery
    ]);
    const recommendedUsersResults = smartsRecommendedUserResponse.data?.smarts.results ?? [];
    const allRecommendedUsers = [
        ...initialUsersReponse.data?.users ?? [],
        ...recommendedUsersResults.flatMap((recommendedUsers)=>!!recommendedUsers && !!recommendedUsers.user ? {
                id: recommendedUsers.id,
                ...recommendedUsers.user
            } : [])
    ];
    const recommendedUserOptions = allRecommendedUsers.map((user)=>({
            trackingKey: user.accountId,
            value: user.accountId,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId
        }));
    return recommendedUserOptions;
};

});
parcelRegister("cxsgw", function(module, exports) {

$parcel$export(module.exports, "smartsRecommendedUserQuery", () => $647d8a1794bbb565$export$74adda2a74e06fa9);

var $4qT1X = parcelRequire("4qT1X");

var $2qzBQ = parcelRequire("2qzBQ");

var $hw4j5 = parcelRequire("hw4j5");
const $647d8a1794bbb565$var$operationName = 'FPSConfluenceSmartUsersQuery';
const $647d8a1794bbb565$var$SmartsRecommendedUserQuery = `
query ${$647d8a1794bbb565$var$operationName}($userId: String!, $tenantId: String!, $maxNumberOfResults: Int!) {
  smarts {
    results: recommendedUser(
      recommendationsQuery: {
        context: {
          userId: $userId
          tenantId: $tenantId
          product: "confluence"
        },
        modelRequestParams: {
          caller: "full-page-search"
          experience: "CgUserNearbyUser"
        }
        requestingUserId: $userId
        maxNumberOfResults: $maxNumberOfResults
      }
    ) {
      id
      user {
        accountId
        name
        picture
      }
    }
  }
}
`;
const $647d8a1794bbb565$export$69a3209f1a06c04d = (0, $hw4j5.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $647d8a1794bbb565$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    const { results: results } = data.smarts;
    return !results || results.length === 0;
};
const $647d8a1794bbb565$export$74adda2a74e06fa9 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>$647d8a1794bbb565$export$69a3209f1a06c04d.inMemoryDecorator((0, $2qzBQ.generateHashFromVariables)(variables), ()=>(0, $4qT1X.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $647d8a1794bbb565$var$SmartsRecommendedUserQuery,
            operationName: $647d8a1794bbb565$var$operationName
        }), $647d8a1794bbb565$var$expireWhen);

});



parcelRegister("dQXZO", function(module, exports) {

$parcel$export(module.exports, "filter", () => $5955e72d8edc423d$export$3dea766d36a8935f);

var $johDC = parcelRequire("johDC");
var $jxvxe = parcelRequire("jxvxe");
var $i14PY = parcelRequire("i14PY");

var $aU479 = parcelRequire("aU479");

var $1yEFx = parcelRequire("1yEFx");

var $dOOW1 = parcelRequire("dOOW1");

var $cOUgi = parcelRequire("cOUgi");
const $5955e72d8edc423d$var$getContentId = (ari)=>{
    const EXTRACT_ID = /ari:.*?:.*?:.*?:.*?\/(.*)?.*/;
    const matches = ari.match(EXTRACT_ID);
    // content id of the ari
    return matches && matches.length > 1 ? matches[1] : '';
};
const $5955e72d8edc423d$var$searchContent = async (query, config)=>{
    const location = `ari:cloud:confluence::site/${config.cloudId}`;
    const product = config.product;
    let contentPagesResponse;
    if (product === (0, $1yEFx.ProductKeys).ConfluenceDC) {
        contentPagesResponse = await (0, $johDC.confluenceDcContentFilterOptionsQuery)({
            variables: {
                query: query,
                cloudIdARI: location,
                limit: 10,
                entities: [
                    'ati:cloud:graph:document'
                ],
                product: product
            },
            aggAbsoluteUrl: config.aggAbsoluteUrl
        });
        return contentPagesResponse.data?.search?.search?.edges.map((content)=>({
                trackingKey: content.node.id,
                value: content.node.id,
                label: (0, $aU479.cleanExcerpt)(content.node.title),
                queryParamValue: content.node.id
            })) || [];
    }
    contentPagesResponse = await (0, $i14PY.searchEntitiesQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            query: query,
            first: 10,
            filters: {
                entities: [
                    'ati:cloud:confluence:page'
                ],
                locations: [
                    location
                ]
            }
        }
    });
    const allContentPages = contentPagesResponse.data?.search?.results.edges.map((content)=>({
            title: content.node.title,
            id: content.node.id
        })) || [];
    const contentOptions = allContentPages.map((content)=>{
        const contentId = $5955e72d8edc423d$var$getContentId(content.id);
        return {
            trackingKey: contentId,
            value: contentId,
            label: content.title,
            queryParamValue: contentId
        };
    });
    return contentOptions;
};
const $5955e72d8edc423d$var$productKeys1P = [
    (0, $1yEFx.ProductKeys).Confluence
];
const $5955e72d8edc423d$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('content');
const $5955e72d8edc423d$export$3dea766d36a8935f = (0, $cOUgi.createSingleSelectFilter)({
    id: 'content',
    products: [
        ...$5955e72d8edc423d$var$productKeys1P,
        ...$5955e72d8edc423d$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'ancestor',
        fetcher: async (queryParams, config)=>{
            const product = config.product;
            const location = `ari:cloud:confluence::site/${config.cloudId}`;
            if (product === (0, $1yEFx.ProductKeys).ConfluenceDC) {
                const contentPagesResponse = await (0, $johDC.confluenceDcPagesQuery)({
                    variables: {
                        query: '',
                        cloudIdARI: location,
                        limit: 10,
                        entities: [
                            'ati:cloud:graph:document'
                        ],
                        product: product,
                        ancestorIds: queryParams
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl
                });
                return contentPagesResponse.data?.external_entities?.document?.map((content)=>({
                        trackingKey: content.id,
                        value: content.id,
                        label: content.displayName,
                        queryParamValue: content.id
                    })) || [];
            }
            const initialContentARIs = queryParams.map((contentId)=>`ari:cloud:confluence:${config.cloudId}:page/${contentId}`);
            const initialContentResponse = await (0, $jxvxe.confluencePagesQuery)(initialContentARIs);
            const allContentPages = initialContentResponse.data?.confluence.pages.map((page)=>({
                    title: page.title,
                    id: page.id
                })) || [];
            const contentOptions = allContentPages.map((content)=>{
                const contentId = $5955e72d8edc423d$var$getContentId(content.id);
                return {
                    trackingKey: contentId,
                    value: contentId,
                    label: content.title,
                    queryParamValue: contentId
                };
            });
            return contentOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $5955e72d8edc423d$var$searchContent('', config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $5955e72d8edc423d$var$searchContent(query, config);
        }
    }
});

});
parcelRegister("johDC", function(module, exports) {

$parcel$export(module.exports, "cache", () => $f5004564c119f753$export$69a3209f1a06c04d);
$parcel$export(module.exports, "generateCacheKey", () => $f5004564c119f753$export$a4f9b7f788f9e71f);
$parcel$export(module.exports, "searchPageQuery", () => $f5004564c119f753$export$8d55189398f4cde7);
$parcel$export(module.exports, "searchDialogQuery", () => $f5004564c119f753$export$b62744f7ecc07873);
$parcel$export(module.exports, "resultsCountQuery", () => $f5004564c119f753$export$3dbd5bda6e5269b6);
$parcel$export(module.exports, "jiraDcProjectFilterOptionsQuery", () => $f5004564c119f753$export$c9f4828c7e4e077e);
$parcel$export(module.exports, "spaceARIEntitiesQuery", () => $f5004564c119f753$export$e261ee95abda868c);
$parcel$export(module.exports, "confluenceDcContentFilterOptionsQuery", () => $f5004564c119f753$export$d18b1cb9e3a2ff17);
$parcel$export(module.exports, "confluenceDcPagesQuery", () => $f5004564c119f753$export$b2301b91ba090677);
$parcel$export(module.exports, "confluenceDcSpaceFilterOptionsQuery", () => $f5004564c119f753$export$a4620a3105d92aba);

var $dh538 = parcelRequire("dh538");

var $4qT1X = parcelRequire("4qT1X");

var $2qzBQ = parcelRequire("2qzBQ");

var $hw4j5 = parcelRequire("hw4j5");

var $2IDcZ = parcelRequire("2IDcZ");
const $f5004564c119f753$export$69a3209f1a06c04d = (0, $hw4j5.inMemoryCache)();
const $f5004564c119f753$export$a4f9b7f788f9e71f = (variables, originalQuery)=>{
    /**
	 * Results once fetched will be used for upto 15 minutes from an in memory cache.
	 * 1. Generate key based on query, entities, filters
	 * 2. Serve from cache if present without resetting the expiration, evict if results are expired
	 * 3. If not present or expired then invoke the api
	 * 4. If API is invoked then store response in the cache with expiration and return back the response
	 */ const keyObj = {
        query: variables.query,
        entities: variables.entities,
        commonFilters: variables.commonFilters,
        confluenceFilters: variables.confluenceFilters,
        jiraFilters: variables.jiraFilters,
        mercuryFilters: variables.mercuryFilters,
        thirdPartyFilters: variables.thirdPartyFilters,
        cloudIdARI: variables.cloudIdARI,
        sortField: variables.sort.at(0)?.field ?? '',
        sortOrder: variables.sort.at(0)?.order ?? '',
        after: variables.after,
        originalQuery: originalQuery
    };
    return (0, $2qzBQ.generateHashFromVariables)(keyObj);
};
// Expire the cache if there are errors or edges are empty
const $f5004564c119f753$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || !data.search || errors && errors.length > 0) return true;
    return data.search?.results.edges.length === 0;
};
const $f5004564c119f753$var$searchQuery = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, useCache: useCache, operationName: operationName })=>{
    // Default experience is search-page
    variables.experience = variables.experience || 'search-page';
    // Default skip3pEntityHydration is false
    variables.skip3pEntityHydration = variables.skip3pEntityHydration || false;
    variables.includeConfluenceDCReactions = variables.includeConfluenceDCReactions || false;
    if ((0, $dh538.fg)('rovo_disable_social_signal_on_qf')) // Since the default experience is search-page, default experience is to include social signals
    variables.includeSocialSignals = variables.includeSocialSignals === undefined ? true : variables.includeSocialSignals;
    const graphQuery = (0, $2IDcZ.queryGenerator)(operationName);
    if (useCache) return $f5004564c119f753$export$69a3209f1a06c04d.inMemoryDecorator($f5004564c119f753$export$a4f9b7f788f9e71f(variables, originalQuery), ()=>(0, $4qT1X.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: operationName
        }), $f5004564c119f753$var$expireWhen);
    else return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: operationName
    });
};
const $f5004564c119f753$export$8d55189398f4cde7 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery })=>{
    return $f5004564c119f753$var$searchQuery({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        originalQuery: originalQuery,
        useCache: true,
        operationName: (0, $2IDcZ.SEARCH_PAGE_OPERATION_NAME)
    });
};
const $f5004564c119f753$export$b62744f7ecc07873 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery })=>{
    return $f5004564c119f753$var$searchQuery({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        originalQuery: originalQuery,
        useCache: false,
        operationName: (0, $2IDcZ.SEARCH_DIALOG_OPERATION_NAME)
    });
};
const $f5004564c119f753$export$3dbd5bda6e5269b6 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery })=>{
    const graphQuery = (0, $2IDcZ.resultsCountQueryGenerator)();
    return $f5004564c119f753$export$69a3209f1a06c04d.inMemoryDecorator('count' + $f5004564c119f753$export$a4f9b7f788f9e71f(variables, originalQuery), ()=>(0, $4qT1X.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: (0, $2IDcZ.resultsCountOperationName)
        }));
};
const $f5004564c119f753$export$c9f4828c7e4e077e = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    const graphQuery = (0, $2IDcZ.dcSpaceFilterOptionsQueryGenerator)((0, $2IDcZ.jiraDcProjectFilterOptionsOperationName));
    return (0, $4qT1X.fetchAgg)({
        variables: {
            ...variables,
            integration: 'ari:cloud:platform::integration/jira-dc'
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $2IDcZ.jiraDcProjectFilterOptionsOperationName)
    });
};
const $f5004564c119f753$export$e261ee95abda868c = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    const graphQuery = (0, $2IDcZ.spaceARIEntitiesQueryGenerator)();
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $2IDcZ.spaceARIEntitiesOperationName)
    });
};
const $f5004564c119f753$export$d18b1cb9e3a2ff17 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    const graphQuery = (0, $2IDcZ.confluenceDcContentFilterOptionsQueryGenerator)();
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $2IDcZ.confluenceDcContentFilterOptionsOperationName)
    });
};
const $f5004564c119f753$export$b2301b91ba090677 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    const graphQuery = (0, $2IDcZ.confluenceDcPagesQueryGenerator)();
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $2IDcZ.confluenceDcPagesOperationName)
    });
};
const $f5004564c119f753$export$a4620a3105d92aba = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    const graphQuery = (0, $2IDcZ.dcSpaceFilterOptionsQueryGenerator)((0, $2IDcZ.confluenceDcSpaceFilterOptionsOperationName));
    return (0, $4qT1X.fetchAgg)({
        variables: {
            ...variables,
            integration: 'ari:cloud:platform::integration/confluence-dc'
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $2IDcZ.confluenceDcSpaceFilterOptionsOperationName)
    });
};

});
parcelRegister("2IDcZ", function(module, exports) {

$parcel$export(module.exports, "SEARCH_PAGE_OPERATION_NAME", () => $785ae870bae9105a$export$ba7243e49f8daaa4);
$parcel$export(module.exports, "SEARCH_DIALOG_OPERATION_NAME", () => $785ae870bae9105a$export$87e857ecc7765700);
$parcel$export(module.exports, "queryGenerator", () => $785ae870bae9105a$export$bcad4d0714f0772f);
$parcel$export(module.exports, "resultsCountOperationName", () => $785ae870bae9105a$export$59ff8b98cf7da770);
$parcel$export(module.exports, "resultsCountQueryGenerator", () => $785ae870bae9105a$export$35addfdbe1c7b563);
$parcel$export(module.exports, "jiraDcProjectFilterOptionsOperationName", () => $785ae870bae9105a$export$fa19606e35da8d6d);
$parcel$export(module.exports, "confluenceDcSpaceFilterOptionsOperationName", () => $785ae870bae9105a$export$56917484085c839f);
$parcel$export(module.exports, "dcSpaceFilterOptionsQueryGenerator", () => $785ae870bae9105a$export$5fcc1d1055e1b5a6);
$parcel$export(module.exports, "spaceARIEntitiesOperationName", () => $785ae870bae9105a$export$4cc1a613b784cede);
$parcel$export(module.exports, "spaceARIEntitiesQueryGenerator", () => $785ae870bae9105a$export$402074cb9d99809d);
$parcel$export(module.exports, "confluenceDcContentFilterOptionsOperationName", () => $785ae870bae9105a$export$11124ad4475d739f);
$parcel$export(module.exports, "confluenceDcContentFilterOptionsQueryGenerator", () => $785ae870bae9105a$export$80a2987504e5746a);
$parcel$export(module.exports, "confluenceDcPagesOperationName", () => $785ae870bae9105a$export$b12a4e91aeaa7036);
$parcel$export(module.exports, "confluenceDcPagesQueryGenerator", () => $785ae870bae9105a$export$feafc9cb648273dc);

var $dh538 = parcelRequire("dh538");

var $7jIfa = parcelRequire("7jIfa");

var $b8N8h = parcelRequire("b8N8h");

var $4TTdD = parcelRequire("4TTdD");

var $8LSUr = parcelRequire("8LSUr");

var $HOiSI = parcelRequire("HOiSI");

var $fLF8J = parcelRequire("fLF8J");

var $7ZetK = parcelRequire("7ZetK");

var $aXWlG = parcelRequire("aXWlG");
const $785ae870bae9105a$export$3f23d3d88b2b0734 = `
description
iconUrl
id
title
type
url
__typename
`;
const $785ae870bae9105a$export$9f64d624a5905b0b = ()=>{
    return `
		${(0, $4TTdD.getConfluencePartials)()}
		${(0, $8LSUr.getJiraPartials)()}
		${(0, $aXWlG.getTrelloPartials)()}
		${(0, $7jIfa.getAtlasPartials)()}
		${(0, $b8N8h.getCompassPartials)()}
		${(0, $HOiSI.getMercuryPartials)()}
		${(0, $7ZetK.getGraphPartials)()}
		${(0, $fLF8J.getFederatedPartials)()}
	`;
};
const $785ae870bae9105a$export$ba7243e49f8daaa4 = 'SearchPageQuery';
const $785ae870bae9105a$export$87e857ecc7765700 = 'SearchDialogQuery';
const $785ae870bae9105a$var$includeSocialSignalsParam = ()=>{
    if ((0, $dh538.fg)('rovo_disable_social_signal_on_qf')) return '\n		$includeSocialSignals: Boolean!';
    else return '';
};
const $785ae870bae9105a$export$bcad4d0714f0772f = (operationName)=>{
    const partials = $785ae870bae9105a$export$9f64d624a5905b0b();
    const graphQuery = `
	query ${operationName}(
		$query: String!
		$cloudIdARI: String!
		$tenantId: ID!
		$limit: Int!
		$entities: [String!]!
		$queryVersion: Int
		$searchSessionId: String
		$commonFilters: SearchCommonFilter
		$confluenceFilters: SearchConfluenceFilter
		$jiraFilters: SearchJiraFilter
		$mercuryFilters: SearchMercuryFilter
		$thirdPartyFilters:  SearchThirdPartyFilter
		$sort: [SearchSortInput]
		$sourceProduct: String
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
		$after: String
		$disableQueryReplacement: Boolean
		$experience: String!
		$enableHighlighting: Boolean
		$skip3pEntityHydration: Boolean!
		$includeConfluenceDCReactions: Boolean!${$785ae870bae9105a$var$includeSocialSignalsParam()}
	) {
		search {
			results: search(
				experience: $experience
				enableHighlighting: $enableHighlighting
				query: $query
				first: $limit
				after: $after
				sort: $sort
				disableQueryReplacement: $disableQueryReplacement
				filters: {
					entities: $entities
					locations: [$cloudIdARI]
					commonFilters: $commonFilters
					confluenceFilters: $confluenceFilters
					jiraFilters: $jiraFilters
					mercuryFilters: $mercuryFilters
					thirdPartyFilters: $thirdPartyFilters
				}
				analytics: {
					queryVersion: $queryVersion
					searchSessionId: $searchSessionId
					sourceProduct: $sourceProduct
				}
				experimentContext: {
					experimentId: $experimentId
					shadowExperimentId: $shadowExperimentId
					experimentLayers: $experimentLayers
				}
			) {
				edges {
					node {
						${$785ae870bae9105a$export$3f23d3d88b2b0734}
						${partials}
					}
				}
				queryInfo {
					originalQuery
					replacementQuery
					suggestedQuery
					originalQueryType
					confidenceScore
					shouldTriggerAutocorrectionExperience
				}
				abTest {
					abTestId
					controlId
					experimentId
				}
				totalCount
				totalCounts {
					product
					count
				}
        pageInfo {
          endCursor
        }
			}
		}
	}
	`;
    return graphQuery;
};
const $785ae870bae9105a$export$59ff8b98cf7da770 = 'ResultsCountQuery';
const $785ae870bae9105a$export$35addfdbe1c7b563 = ()=>{
    const graphQuery = `
	query ${$785ae870bae9105a$export$59ff8b98cf7da770}(
		$query: String!
		$cloudIdARI: String!
		$limit: Int!
		$entities: [String!]!
		$queryVersion: Int
		$searchSessionId: String
		$commonFilters: SearchCommonFilter
		$confluenceFilters: SearchConfluenceFilter
		$jiraFilters: SearchJiraFilter
		$mercuryFilters: SearchMercuryFilter
		$thirdPartyFilters:  SearchThirdPartyFilter
		$sort: [SearchSortInput]
		$sourceProduct: String
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
		$disableQueryReplacement: Boolean
	) {
		search {
			results: search(
				experience: "search-page"
				query: $query
				first: $limit
				sort: $sort
				disableQueryReplacement: $disableQueryReplacement
				filters: {
					entities: $entities
					locations: [$cloudIdARI]
					commonFilters: $commonFilters
					confluenceFilters: $confluenceFilters
					jiraFilters: $jiraFilters
					mercuryFilters: $mercuryFilters
					thirdPartyFilters: $thirdPartyFilters
				}
		analytics: {
					queryVersion: $queryVersion
					searchSessionId: $searchSessionId
					sourceProduct: $sourceProduct
				}
		experimentContext: {
			experimentId: $experimentId
			shadowExperimentId: $shadowExperimentId
			experimentLayers: $experimentLayers
		}
			) {

				queryInfo {
					originalQuery
					replacementQuery
					originalQueryType
					confidenceScore
					shouldTriggerAutocorrectionExperience
				}
				abTest {
					abTestId
					controlId
					experimentId
				}
				totalCount
				totalCounts {
					product
					count
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $785ae870bae9105a$export$fa19606e35da8d6d = 'jiraDcProjectFilterOptionsQuery';
const $785ae870bae9105a$export$56917484085c839f = 'confluenceDcSpaceFilterOptionsQuery';
const $785ae870bae9105a$export$5fcc1d1055e1b5a6 = (operationName)=>{
    const graphQuery = `
		query ${operationName} (
			$query: String!
			$cloudIdARI: String!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$integration: String!
			) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				thirdPartyFilters: {
					thirdPartyProducts:[
						{
							product: $product,
							integrationId: $integration,
					subtypes:[]
					}
					]
				},
				locations: [$cloudIdARI]
			}
			experience: "search-page"
			) {
				edges {
					node {
					...on SearchResultGraphDocument {
						entity {
							...on ExternalSpace {
									id
									key
									displayName
									icon {
										height
										isDefault
										url
										width
									}
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $785ae870bae9105a$export$4cc1a613b784cede = 'spaceIdFilterOptionsQuery';
const $785ae870bae9105a$export$402074cb9d99809d = ()=>{
    const graphQuery = `
		query ${$785ae870bae9105a$export$4cc1a613b784cede} ($ids: [ID!]!) {
			external_entities(ids: $ids) @optIn(to: "ExternalDataDepotQueryV2"){
				space {
					id
					displayName
					icon {
						url
					}
				}
			}
		}`;
    return graphQuery;
};
const $785ae870bae9105a$export$11124ad4475d739f = 'confluenceDcContentFilterOptionsQuery';
const $785ae870bae9105a$export$80a2987504e5746a = ()=>{
    const graphQuery = `
		query ${$785ae870bae9105a$export$11124ad4475d739f} (
			$query: String!
			$cloudIdARI: String!
			$limit: Int!
			$entities: [String!]!
			$product: String!
		) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				locations: [$cloudIdARI],
				thirdPartyFilters: {
					thirdPartyProducts:[
						{
							product: $product,
							integrationId:"ari:cloud:platform::integration/confluence-dc",
							subtypes:[]
						}
					]
				}
			}
			analytics: {searchSessionId: "graphql"}
			experience: "search-page"
			) {
				edges {
					node {
					id
					title
					description
					... on SearchResultGraphDocument {
							entity {
								...on ExternalDocument {
									type {
										category
									}
									parentId
									container @optIn(to: "ExternalDataDepotQueryV2") {
										...on ExternalSpace {
											id
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $785ae870bae9105a$export$b12a4e91aeaa7036 = 'confluenceDcPagesQuery';
const $785ae870bae9105a$export$feafc9cb648273dc = ()=>{
    const graphQuery = `
		query ${$785ae870bae9105a$export$b12a4e91aeaa7036} (
			$ancestorIds: [ID!]!
		) {
			external_entities(ids: $ancestorIds) @optIn(to: "ExternalDataDepotQueryV2") {
				document {
					id
					displayName
				}
			}
		}
	`;
    return graphQuery;
};

});
parcelRegister("7jIfa", function(module, exports) {

$parcel$export(module.exports, "isSearchResultAtlasProjectPartial", () => $c12c29bc71ee9715$export$1724df33341798e0);
$parcel$export(module.exports, "isSearchResultAtlasGoalPartial", () => $c12c29bc71ee9715$export$1d556a3125797ca6);
$parcel$export(module.exports, "isSearchAtlasPartial", () => $c12c29bc71ee9715$export$750af6f011d7ee10);
$parcel$export(module.exports, "getAtlasPartials", () => $c12c29bc71ee9715$export$272c689528faac47);
const $c12c29bc71ee9715$var$SearchDefaultResultAtlas = ``;
const $c12c29bc71ee9715$var$SearchResultAtlasProject = `
... on SearchResultAtlasProject {
  project {
    key
    state {
      label
      value
    }
    dueDate {
      label
    }
    isPrivate
  }
}
`;
const $c12c29bc71ee9715$var$SearchResultAtlasGoal = `
... on SearchResultAtlasGoal {
  goal {
    description
    key
    status {
      localizedLabel {
        messageId
      }
      value
      score
    }
    targetDate {
      label
    }
  }
}
`;
const $c12c29bc71ee9715$export$1724df33341798e0 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasProject';
};
const $c12c29bc71ee9715$export$1d556a3125797ca6 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasGoal';
};
const $c12c29bc71ee9715$export$bff995b1cea89df3 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasTag';
};
const $c12c29bc71ee9715$export$aa63de26c950cf0f = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchDefaultResult';
};
const $c12c29bc71ee9715$export$750af6f011d7ee10 = (partial)=>{
    return $c12c29bc71ee9715$export$1d556a3125797ca6(partial) || $c12c29bc71ee9715$export$1724df33341798e0(partial) || $c12c29bc71ee9715$export$bff995b1cea89df3(partial) || $c12c29bc71ee9715$export$aa63de26c950cf0f(partial);
};
const $c12c29bc71ee9715$export$272c689528faac47 = ()=>{
    return `
		${$c12c29bc71ee9715$var$SearchResultAtlasGoal}
		${$c12c29bc71ee9715$var$SearchResultAtlasProject}
		${$c12c29bc71ee9715$var$SearchDefaultResultAtlas}
	`;
};

});

parcelRegister("4TTdD", function(module, exports) {

$parcel$export(module.exports, "isSearchConfluencePageBlogAttachment", () => $ce6442228f6f128a$export$c89c057fd480d10c);
$parcel$export(module.exports, "isSearchConfluenceSpace", () => $ce6442228f6f128a$export$4619f000f23ee8d1);
$parcel$export(module.exports, "isSearchConfluencePartial", () => $ce6442228f6f128a$export$e4e5a86cb4c1e3e4);
$parcel$export(module.exports, "getConfluencePartials", () => $ce6442228f6f128a$export$d1ddb94b35ac2d77);

var $dh538 = parcelRequire("dh538");
const $ce6442228f6f128a$var$includeSocialSignalsDirective = ()=>(0, $dh538.fg)('rovo_disable_social_signal_on_qf') ? '@include(if: $includeSocialSignals) ' : '';
const $ce6442228f6f128a$var$SearchConfluencePageBlogAttachment = ()=>`
... on SearchConfluencePageBlogAttachment {
	lastModified
	isVerified
	space {
		id
		name
		webUiLink
	}
	__typename
	confluenceEntity {
		... on ConfluencePage {
			subtype
			${(0, $dh538.fg)('search_page_limit_agg_hydration') ? '' : `
			ancestors {
				id
				title
				links {
					webUi
				}
			}
			metadata {
				titleEmojiPublished {
					id
					value
				}
			}
			`}
			commentCountSummary {
				total
			}
			likesSummary {
				count
			}
		}
	}
	socialSignal(tenantId: $tenantId) ${$ce6442228f6f128a$var$includeSocialSignalsDirective()}{
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}
	}
}
`;
const $ce6442228f6f128a$export$c89c057fd480d10c = (partial)=>{
    return partial.__typename === 'SearchConfluencePageBlogAttachment';
};
const $ce6442228f6f128a$var$SearchConfluenceSpace = `
... on SearchConfluenceSpace {
	key
	lastModified
	iconPath
	socialSignal(tenantId: $tenantId) ${$ce6442228f6f128a$var$includeSocialSignalsDirective()}{
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}

	}
}
`;
const $ce6442228f6f128a$export$4619f000f23ee8d1 = (partial)=>{
    return partial.__typename === 'SearchConfluenceSpace';
};
const $ce6442228f6f128a$export$e4e5a86cb4c1e3e4 = (partial)=>{
    return $ce6442228f6f128a$export$c89c057fd480d10c(partial) || $ce6442228f6f128a$export$4619f000f23ee8d1(partial);
};
const $ce6442228f6f128a$export$d1ddb94b35ac2d77 = ()=>{
    return `
		${$ce6442228f6f128a$var$SearchConfluencePageBlogAttachment()}
		${$ce6442228f6f128a$var$SearchConfluenceSpace}
	`;
};

});

parcelRegister("HOiSI", function(module, exports) {

$parcel$export(module.exports, "isSearchResultMercuryFocusAreaPartial", () => $99673f5e61e3ceb4$export$8b0a4c9077b7d09b);
$parcel$export(module.exports, "isSearchResultMercuryFocusAreaStatusUpdatePartial", () => $99673f5e61e3ceb4$export$c43349f9a39b01bd);
$parcel$export(module.exports, "isSearchMercuryPartial", () => $99673f5e61e3ceb4$export$bbfb216d33463101);
$parcel$export(module.exports, "getMercuryPartials", () => $99673f5e61e3ceb4$export$fabaf03f9e1d6e25);
const $99673f5e61e3ceb4$var$SearchResultMercuryFocusArea = `
... on SearchResultMercuryFocusArea {
	lastModifiedDate
	focusArea {
		id
		name
		focusAreaType {
			id
			name
			hierarchyLevel
		}
		status {
			key
			displayName
		}
		health {
			key
			color
			displayName
		}
		targetDate {
			targetDate
			targetDateType
		}
		owner {
			accountId
			name
		}
	}
}
`;
const $99673f5e61e3ceb4$var$SearchResultMercuryFocusAreaStatusUpdate = `
... on SearchResultMercuryFocusAreaStatusUpdate {
	lastModifiedDate
	focusArea {
		name
	}
}
`;
const $99673f5e61e3ceb4$export$8b0a4c9077b7d09b = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryFocusArea';
};
const $99673f5e61e3ceb4$export$c43349f9a39b01bd = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryFocusAreaStatusUpdate';
};
const $99673f5e61e3ceb4$export$bbfb216d33463101 = (partial)=>{
    return $99673f5e61e3ceb4$export$8b0a4c9077b7d09b(partial) || $99673f5e61e3ceb4$export$c43349f9a39b01bd(partial);
};
const $99673f5e61e3ceb4$export$fabaf03f9e1d6e25 = ()=>{
    return `
		${$99673f5e61e3ceb4$var$SearchResultMercuryFocusArea}
		${$99673f5e61e3ceb4$var$SearchResultMercuryFocusAreaStatusUpdate}
	`;
};

});

parcelRegister("fLF8J", function(module, exports) {

$parcel$export(module.exports, "getFederatedPartials", () => $fc6808f27e8b1a8d$export$68ef445facedc0d5);
$parcel$export(module.exports, "isSearchResultFederated", () => $fc6808f27e8b1a8d$export$4fafa9bf7ad5438a);
$parcel$export(module.exports, "isSearchFederatedEmailEntity", () => $fc6808f27e8b1a8d$export$c0c573cc3dff9ad6);

var $jLIWc = parcelRequire("jLIWc");

var $eUkvc = parcelRequire("eUkvc");
const $fc6808f27e8b1a8d$var$SearchResultFederatedPartial = `
... on SearchResultFederated {
	lastModifiedDate
	entity {
		${(0, $eUkvc.FederatedEmailPartial)}
	}
}
`;
var $fc6808f27e8b1a8d$var$ResourceType = /*#__PURE__*/ function(ResourceType) {
    ResourceType["EMAIL"] = "email";
    return ResourceType;
}($fc6808f27e8b1a8d$var$ResourceType || {});
const $fc6808f27e8b1a8d$export$68ef445facedc0d5 = ()=>{
    return $fc6808f27e8b1a8d$var$SearchResultFederatedPartial;
};
const $fc6808f27e8b1a8d$export$4fafa9bf7ad5438a = (partial)=>partial.__typename === 'SearchResultFederated';
const $fc6808f27e8b1a8d$export$c0c573cc3dff9ad6 = (partial)=>{
    const { resourceType: resourceType } = (0, $jLIWc.AnyAri).parse(partial.id);
    return resourceType === "email";
};

});
parcelRegister("eUkvc", function(module, exports) {

$parcel$export(module.exports, "FederatedEmailPartial", () => $e45ad8a5309338bf$export$7c3d5c670817fb18);
const $e45ad8a5309338bf$export$7c3d5c670817fb18 = `
... on SearchFederatedEmailEntity {
	sender {
		email
		name
	}
}
`;

});


parcelRegister("7ZetK", function(module, exports) {

$parcel$export(module.exports, "getGraphPartials", () => $2bedd5b6e3cb42cc$export$e169b729a14ad5f8);
$parcel$export(module.exports, "isSearchResultGraphEntity", () => $2bedd5b6e3cb42cc$export$7dd4baba91338caa);
$parcel$export(module.exports, "isConversationEntity", () => $2bedd5b6e3cb42cc$export$6c20afe8743cb761);
$parcel$export(module.exports, "isDesignEntity", () => $2bedd5b6e3cb42cc$export$8dc9be81b5b6266b);
$parcel$export(module.exports, "isMessageEntity", () => $2bedd5b6e3cb42cc$export$33e8c1bbf9148b0e);
$parcel$export(module.exports, "isVideoEntity", () => $2bedd5b6e3cb42cc$export$9cfcc6ca7fb6e839);
$parcel$export(module.exports, "isBranchEntity", () => $2bedd5b6e3cb42cc$export$9a3959a38fa67fd0);
$parcel$export(module.exports, "isCommitEntity", () => $2bedd5b6e3cb42cc$export$ece3e91c16809748);
$parcel$export(module.exports, "isCommentEntity", () => $2bedd5b6e3cb42cc$export$5bdc07901b0022c6);
$parcel$export(module.exports, "isPullRequestEntity", () => $2bedd5b6e3cb42cc$export$5ba84cc314040e0c);
$parcel$export(module.exports, "isRepositoryEntity", () => $2bedd5b6e3cb42cc$export$9c4afe4ccb574692);
$parcel$export(module.exports, "isDocumentEntity", () => $2bedd5b6e3cb42cc$export$32c06ee7e0e9b79e);
$parcel$export(module.exports, "isProjectEntity", () => $2bedd5b6e3cb42cc$export$791f1b4852e2a184);
$parcel$export(module.exports, "isCalendarEventEntity", () => $2bedd5b6e3cb42cc$export$92306a022e0703e0);
$parcel$export(module.exports, "isDealEntity", () => $2bedd5b6e3cb42cc$export$e23befac5f018c0b);
$parcel$export(module.exports, "isCustomerOrgEntity", () => $2bedd5b6e3cb42cc$export$1aff0f2a91c0ea03);
$parcel$export(module.exports, "isWorkItemEntity", () => $2bedd5b6e3cb42cc$export$162dad7a1238d377);

var $jLIWc = parcelRequire("jLIWc");

var $gJtY1 = parcelRequire("gJtY1");

var $lg5f1 = parcelRequire("lg5f1");

var $kAvaS = parcelRequire("kAvaS");

var $9SGbr = parcelRequire("9SGbr");

var $jj5HY = parcelRequire("jj5HY");

var $3pr5k = parcelRequire("3pr5k");

var $9mUth = parcelRequire("9mUth");

var $aJW2w = parcelRequire("aJW2w");

var $4tpwN = parcelRequire("4tpwN");

var $iCTu1 = parcelRequire("iCTu1");

var $kRTZx = parcelRequire("kRTZx");

var $4Kdn3 = parcelRequire("4Kdn3");

var $kt77u = parcelRequire("kt77u");

var $7lYRh = parcelRequire("7lYRh");

var $kZuSh = parcelRequire("kZuSh");

var $bwf3l = parcelRequire("bwf3l");
const $2bedd5b6e3cb42cc$var$TEAMS_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $2bedd5b6e3cb42cc$var$SearchThirdPartyGraphDocumentPartial = `
... on SearchResultGraphDocument {
	excerpt,
	permissionLevel,
	initialContributors {
		name
		id
		externalId
	}
	subtype
	integrationId
	providerId
	lastModifiedDate
	linkedEntities {
		id
		title
		excerpt,
		permissionLevel,
		subtype
		integrationId
		lastModifiedDate
		entity @skip(if: $skip3pEntityHydration) {
			${(0, $iCTu1.ExternalMessagePartial)}
		}
		initialContributors {
			name
			id
			externalId
		}
		containerName @optIn(to: "SearchPerformanceImprovementChanges")
		allContributors @optIn(to: "SearchPerformanceImprovementChanges") {
			id
			accountId
			externalId
			name
			nickname
			email
			picture
			extendedProfile {
				jobTitle
				department
				organization
			}
		}
	}
	entity @skip(if: $skip3pEntityHydration) {
		${(0, $gJtY1.ExternalBranchPartial)}
		${(0, $lg5f1.ExternalCalendarEventPartial)}
		${(0, $9mUth.ExternalDealPartial)}
		${(0, $3pr5k.ExternalCustomerOrgPartial)}
		${(0, $9SGbr.ExternalCommitPartial)}
		${(0, $jj5HY.ExternalConversationPartial)}
		${(0, $aJW2w.ExternalDesignPartial)}
		${(0, $4tpwN.ExternalDocumentPartial)}
		${(0, $iCTu1.ExternalMessagePartial)}
		${(0, $kRTZx.ExternalProjectPartial)}
		${(0, $4Kdn3.ExternalPullRequestPartial)}
		${(0, $7lYRh.ExternalRepositoryPartial)}
		${(0, $kZuSh.ExternalVideoPartial)}
		${(0, $bwf3l.ExternalWorkItemPartial)}
		${(0, $kAvaS.ExternalCommentPartial)}
		${(0, $kt77u.ExternalRemoteLinkPartial)}
	}
	containerName @optIn(to: "SearchPerformanceImprovementChanges")
	allContributors @optIn(to: "SearchPerformanceImprovementChanges") {
		id
		accountId
		externalId
		name
		nickname
		email
		picture
		extendedProfile {
			jobTitle
			department
			organization
		}
	}
}
`;
var $2bedd5b6e3cb42cc$var$AccountStatus = /*#__PURE__*/ function(AccountStatus) {
    AccountStatus[AccountStatus["active"] = 0] = "active";
    AccountStatus[AccountStatus["inactive"] = 1] = "inactive";
    AccountStatus[AccountStatus["closed"] = 2] = "closed";
    return AccountStatus;
}($2bedd5b6e3cb42cc$var$AccountStatus || {});
var $2bedd5b6e3cb42cc$var$ExternalDocumentCategory = /*#__PURE__*/ function(ExternalDocumentCategory) {
    ExternalDocumentCategory[ExternalDocumentCategory["ARCHIVE"] = 0] = "ARCHIVE";
    ExternalDocumentCategory[ExternalDocumentCategory["AUDIO"] = 1] = "AUDIO";
    ExternalDocumentCategory[ExternalDocumentCategory["CODE"] = 2] = "CODE";
    ExternalDocumentCategory[ExternalDocumentCategory["DOCUMENT"] = 3] = "DOCUMENT";
    ExternalDocumentCategory[ExternalDocumentCategory["FOLDER"] = 4] = "FOLDER";
    ExternalDocumentCategory[ExternalDocumentCategory["FORM"] = 5] = "FORM";
    ExternalDocumentCategory[ExternalDocumentCategory["IMAGE"] = 6] = "IMAGE";
    ExternalDocumentCategory[ExternalDocumentCategory["OTHER"] = 7] = "OTHER";
    ExternalDocumentCategory[ExternalDocumentCategory["PDF"] = 8] = "PDF";
    ExternalDocumentCategory[ExternalDocumentCategory["PRESENTATION"] = 9] = "PRESENTATION";
    ExternalDocumentCategory[ExternalDocumentCategory["SHORTCUT"] = 10] = "SHORTCUT";
    ExternalDocumentCategory[ExternalDocumentCategory["SPREADSHEET"] = 11] = "SPREADSHEET";
    ExternalDocumentCategory[ExternalDocumentCategory["VIDEO"] = 12] = "VIDEO";
    ExternalDocumentCategory[ExternalDocumentCategory["WEB_PAGE"] = 13] = "WEB_PAGE";
    return ExternalDocumentCategory;
}($2bedd5b6e3cb42cc$var$ExternalDocumentCategory || {});
var $2bedd5b6e3cb42cc$var$ExternalEventType = /*#__PURE__*/ function(ExternalEventType) {
    ExternalEventType["APPOINTMENT"] = "appointment";
    ExternalEventType["BIRTHDAY"] = "birthday";
    ExternalEventType["DEFAULT"] = "default";
    ExternalEventType["EVENT"] = "event";
    ExternalEventType["FOCUS_TIME"] = "focus_time";
    ExternalEventType["OUT_OF_OFFICE"] = "out_of_office";
    ExternalEventType["REMINDER"] = "reminder";
    ExternalEventType["TASK"] = "task";
    ExternalEventType["WORKING_LOCATION"] = "working_location";
    return ExternalEventType;
}($2bedd5b6e3cb42cc$var$ExternalEventType || {});
var $2bedd5b6e3cb42cc$var$ExternalAttendeeRsvpStatus = /*#__PURE__*/ function(ExternalAttendeeRsvpStatus) {
    ExternalAttendeeRsvpStatus["ACCEPTED"] = "accepted";
    ExternalAttendeeRsvpStatus["DECLINED"] = "declined";
    ExternalAttendeeRsvpStatus["NOT_RESPONDED"] = "not_responded";
    ExternalAttendeeRsvpStatus["OTHER"] = "other";
    ExternalAttendeeRsvpStatus["TENATIVELY_ACCEPTED"] = "tenatively_accepted";
    return ExternalAttendeeRsvpStatus;
}($2bedd5b6e3cb42cc$var$ExternalAttendeeRsvpStatus || {});
var $2bedd5b6e3cb42cc$var$ExternalWorkItemType = /*#__PURE__*/ function(ExternalWorkItemType) {
    ExternalWorkItemType["TASK"] = "task";
    ExternalWorkItemType["DEFAULT_TASK"] = "default_task";
    ExternalWorkItemType["WORK_ITEM"] = "work_item";
    ExternalWorkItemType["EPIC"] = "epic";
    ExternalWorkItemType["BUG"] = "bug";
    ExternalWorkItemType["STORY"] = "story";
    ExternalWorkItemType["MILESTONE"] = "milestone";
    ExternalWorkItemType["SECTION"] = "section";
    ExternalWorkItemType["APPROVAL"] = "approval";
    ExternalWorkItemType["PROBLEM"] = "problem";
    ExternalWorkItemType["INCIDENT"] = "incident";
    ExternalWorkItemType["QUESTION"] = "question";
    ExternalWorkItemType["ISSUE"] = "issue";
    ExternalWorkItemType["OTHER"] = "other";
    return ExternalWorkItemType;
}($2bedd5b6e3cb42cc$var$ExternalWorkItemType || {});
var $2bedd5b6e3cb42cc$var$ExternalMembershipType = /*#__PURE__*/ function(ExternalMembershipType) {
    ExternalMembershipType["PRIVATE"] = "PRIVATE";
    ExternalMembershipType["PUBLIC"] = "PUBLIC";
    ExternalMembershipType["SHARED"] = "SHARED";
    return ExternalMembershipType;
}($2bedd5b6e3cb42cc$var$ExternalMembershipType || {});
var $2bedd5b6e3cb42cc$var$ExternalConversationType = /*#__PURE__*/ function(ExternalConversationType) {
    ExternalConversationType["CHANNEL"] = "CHANNEL";
    ExternalConversationType["DIRECT_MESSAGE"] = "DIRECT_MESSAGE";
    ExternalConversationType["GROUP_DIRECT_MESSAGE"] = "GROUP_DIRECT_MESSAGE";
    return ExternalConversationType;
}($2bedd5b6e3cb42cc$var$ExternalConversationType || {});
var $2bedd5b6e3cb42cc$var$ResourceType = /*#__PURE__*/ function(ResourceType) {
    ResourceType["BRANCH"] = "branch";
    ResourceType["CALENDAR_EVENT"] = "calendar-event";
    ResourceType["DEAL"] = "deal";
    ResourceType["CUSTOMER_ORG"] = "customer-org";
    ResourceType["COMMENT"] = "comment";
    ResourceType["COMMIT"] = "commit";
    ResourceType["CONVERSATION"] = "conversation";
    ResourceType["DESIGN"] = "design";
    ResourceType["DOCUMENT"] = "document";
    ResourceType["MESSAGE"] = "message";
    ResourceType["PROJECT"] = "project";
    ResourceType["PULL_REQUEST"] = "pull-request";
    ResourceType["REPOSITORY"] = "repository";
    ResourceType["VIDEO"] = "video";
    ResourceType["WORK_ITEM"] = "work-item";
    return ResourceType;
}($2bedd5b6e3cb42cc$var$ResourceType || {});
const $2bedd5b6e3cb42cc$export$e169b729a14ad5f8 = ()=>{
    //TODO: update for GitHub graph entities
    return $2bedd5b6e3cb42cc$var$SearchThirdPartyGraphDocumentPartial;
};
const $2bedd5b6e3cb42cc$export$7dd4baba91338caa = (partial)=>partial.__typename === 'SearchResultGraphDocument';
const $2bedd5b6e3cb42cc$export$6c20afe8743cb761 = (partial)=>{
    const { resourceType: resourceType } = (0, $jLIWc.AnyAri).parse(partial.id);
    return resourceType === "conversation";
};
const $2bedd5b6e3cb42cc$export$8dc9be81b5b6266b = (partial)=>{
    const { resourceType: resourceType } = (0, $jLIWc.AnyAri).parse(partial.id);
    return resourceType === "design";
};
const $2bedd5b6e3cb42cc$export$33e8c1bbf9148b0e = (partial)=>{
    const { resourceType: resourceType } = (0, $jLIWc.AnyAri).parse(partial.id);
    return resourceType === "message";
};
const $2bedd5b6e3cb42cc$export$9cfcc6ca7fb6e839 = (partial)=>{
    const { resourceType: resourceType } = (0, $jLIWc.AnyAri).parse(partial.id);
    return resourceType === "video";
};
const $2bedd5b6e3cb42cc$export$9a3959a38fa67fd0 = (partial)=>{
    const { resourceType: resourceType } = (0, $jLIWc.AnyAri).parse(partial.id);
    return resourceType === "branch";
};
const $2bedd5b6e3cb42cc$export$ece3e91c16809748 = (partial)=>{
    const { resourceType: resourceType } = (0, $jLIWc.AnyAri).parse(partial.id);
    return resourceType === "commit";
};
const $2bedd5b6e3cb42cc$export$5bdc07901b0022c6 = (partial)=>{
    const { resourceType: resourceType } = (0, $jLIWc.AnyAri).parse(partial.id);
    return resourceType === "comment";
};
const $2bedd5b6e3cb42cc$export$5ba84cc314040e0c = (partial)=>{
    const { resourceType: resourceType } = (0, $jLIWc.AnyAri).parse(partial.id);
    return resourceType === "pull-request";
};
const $2bedd5b6e3cb42cc$export$9c4afe4ccb574692 = (partial)=>{
    const { resourceType: resourceType } = (0, $jLIWc.AnyAri).parse(partial.id);
    return resourceType === "repository";
};
const $2bedd5b6e3cb42cc$export$32c06ee7e0e9b79e = (partial)=>{
    const { resourceType: resourceType } = (0, $jLIWc.AnyAri).parse(partial.id);
    return resourceType === "document";
};
const $2bedd5b6e3cb42cc$export$791f1b4852e2a184 = (partial)=>{
    const { resourceType: resourceType } = (0, $jLIWc.AnyAri).parse(partial.id);
    return resourceType === "project";
};
const $2bedd5b6e3cb42cc$export$92306a022e0703e0 = (partial)=>{
    const { resourceType: resourceType } = (0, $jLIWc.AnyAri).parse(partial.id);
    return resourceType === "calendar-event";
};
const $2bedd5b6e3cb42cc$export$e23befac5f018c0b = (partial)=>{
    const { resourceType: resourceType } = (0, $jLIWc.AnyAri).parse(partial.id);
    return resourceType === "deal";
};
const $2bedd5b6e3cb42cc$export$1aff0f2a91c0ea03 = (partial)=>{
    const { resourceType: resourceType } = (0, $jLIWc.AnyAri).parse(partial.id);
    return resourceType === "customer-org";
};
const $2bedd5b6e3cb42cc$export$40f90006d8fc8dee = (partial)=>$2bedd5b6e3cb42cc$export$33e8c1bbf9148b0e(partial) && partial.integrationId === $2bedd5b6e3cb42cc$var$TEAMS_INTEGRATION_ARI;
const $2bedd5b6e3cb42cc$export$162dad7a1238d377 = (partial)=>{
    const { resourceType: resourceType } = (0, $jLIWc.AnyAri).parse(partial.id);
    return resourceType === "work-item";
};

});
parcelRegister("gJtY1", function(module, exports) {

$parcel$export(module.exports, "ExternalBranchPartial", () => $db19e1fa6f2ae0df$export$5b6173385ccfaeaa);
const $db19e1fa6f2ae0df$export$5b6173385ccfaeaa = `
... on ExternalBranch {
    name
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository {
            name
        }
    }
}
`;

});

parcelRegister("lg5f1", function(module, exports) {

$parcel$export(module.exports, "ExternalCalendarEventPartial", () => $a3f6d52c4a595b9b$export$253480f0254db4f8);
const $a3f6d52c4a595b9b$export$253480f0254db4f8 = `
... on ExternalCalendarEvent {
	attachments {
		byteSize
		mimeType
		thumbnailUrl
		title
		url
	}
	attendees {
		isOptional
		rsvpStatus
		user {
			thirdPartyUser {
				id
				email
				name
			}
			user {
				name
			}
		}
	}
	createdBy {
		thirdPartyUser {
			id
			email
			externalId
			name
			picture
		}
		user {
			name
		}
	}
	eventEndTime
	eventStartTime
	eventType
	location {
		address
		coordinates
		name
		url
	}
	recurringEventId
	videoMeetingUrl
}
`;

});

parcelRegister("kAvaS", function(module, exports) {

$parcel$export(module.exports, "ExternalCommentPartial", () => $0120149ae6de1c61$export$fd6f695cd68738d3);
const $0120149ae6de1c61$export$fd6f695cd68738d3 = `
... on ExternalComment {
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
		displayName
		url
	   }
	}
}
`;

});

parcelRegister("9SGbr", function(module, exports) {

$parcel$export(module.exports, "ExternalCommitPartial", () => $39d0f148140689b8$export$3dcd3e619ad10a8c);
const $39d0f148140689b8$export$3dcd3e619ad10a8c = `
... on ExternalCommit {
    author {
        user {
            name
        }
    }
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository{
            name
        }
    }
}
`;

});

parcelRegister("jj5HY", function(module, exports) {

$parcel$export(module.exports, "ExternalConversationPartial", () => $f7fca3b302c4ee56$export$4597d51c3a28368e);
const $f7fca3b302c4ee56$export$4597d51c3a28368e = `
... on ExternalConversation {
    id
    memberCount
    displayName
    membershipType
    workspace
    topic
    members {
        thirdPartyUser {
            id
            name
        }
        user {
            id
            name
        }
    }
}
`;

});

parcelRegister("3pr5k", function(module, exports) {

$parcel$export(module.exports, "ExternalCustomerOrgPartial", () => $f54ec1bcc8120248$export$7a4547f8268cefd4);
const $f54ec1bcc8120248$export$7a4547f8268cefd4 = `
... on ExternalCustomerOrg {
	contacts {
		thirdPartyUser {
			id
			accountId
			externalId
			name
			nickname
			email
			picture
			extendedProfile {
				jobTitle
				department
				organization
			}
		}
		user {
			id
			name
		}
	}
	customerOrgLastActivity {
		lastActivityAt
		event
	}
	lifeTimeValue {
		value
		currencyCode
	}
	websiteUrl
	industry
	contributors {
		thirdPartyUser {
			id
			name
		}
	}
	country
	accountType
	thirdPartyId
}
`;

});

parcelRegister("9mUth", function(module, exports) {

$parcel$export(module.exports, "ExternalDealPartial", () => $f5fd0a4589b8034c$export$d80c383820958dae);
const $f5fd0a4589b8034c$export$d80c383820958dae = `
... on ExternalDeal {
	contact {
        thirdPartyUser {
            id
            accountId
            externalId
            name
            nickname
            email
			picture
            extendedProfile {
                jobTitle
                department
                organization
            }
        }
        user {
            id
            name
        }
	}
	stage
	accountName
	lastActivity {
		lastActivityAt
		event
	}
	dealClosedAt
	opportunityAmount {
		value
		currencyCode
	}
	isClosed
	contributors {
		user {
			thirdPartyUser {
				id
				name
			}
		}
	}
}
`;

});

parcelRegister("aJW2w", function(module, exports) {

$parcel$export(module.exports, "ExternalDesignPartial", () => $39e53f175a761c4f$export$5eda2cda79f28143);
const $39e53f175a761c4f$export$5eda2cda79f28143 = `
... on ExternalDesign {
    thumbnail {
        externalUrl
    }
}
`;

});

parcelRegister("4tpwN", function(module, exports) {

$parcel$export(module.exports, "ExternalDocumentPartial", () => $5294e72074a3a62d$export$6193eef58692a804);
const $5294e72074a3a62d$export$6193eef58692a804 = `
... on ExternalDocument {
    type {
        iconUrl
    }
    thirdPartyId
    parent @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalDocument {
            displayName
            url
        }
    }
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
            displayName
            url
		}
	}
    reactions @include(if: $includeConfluenceDCReactions){
        reactionType
        total
    }
}
`;

});

parcelRegister("iCTu1", function(module, exports) {

$parcel$export(module.exports, "ExternalMessagePartial", () => $0641c5f18f3be5c0$export$3b9ed83b2b731ba0);
const $0641c5f18f3be5c0$export$3b9ed83b2b731ba0 = `
... on ExternalMessage {
    lastUpdated
    lastActive
    description
    attachments {
	    title
        mimeType
        thumbnailUrl
        url
    }
    createdBy {
        thirdPartyUser {
            id
            accountId
            externalId
            name
            nickname
            email
			picture
            extendedProfile {
                jobTitle
                department
                organization
            }
        }
        user {
            id
            name
        }
    }
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalConversation {
            id
            displayName
            memberCount
            membershipType
            type
            members {
                thirdPartyUser {
                    id
                    name
                    nickname
                    email
                    extendedProfile {
                        jobTitle
                        department
                        organization
                    }
                }
            }
        }
    }
    associatedWith {
        edges {
            node {
                id
                createdBy {
                    thirdPartyUser {
                        id
                        accountId
                        externalId
                        name
                        email
                    }
                }
                entity {
					__typename
					... on ExternalConversation {
						id
						displayName
						channelId:externalId
					}
					... on ThirdPartyUser {
                        id
                        email
						externalId
                        name
                        nickname
                        picture
                        extendedProfile {
                            jobTitle
                            department
                            organization
                        }
                    }
                }
            }
        }
    }
}
`;

});

parcelRegister("kRTZx", function(module, exports) {

$parcel$export(module.exports, "ExternalProjectPartial", () => $a189d094eec8b8a7$export$f35cf9a497ba81f2);
const $a189d094eec8b8a7$export$f35cf9a497ba81f2 = `
... on ExternalProject {
	assignee {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	attachments {
		byteSize
		mimeType
		thumbnailUrl
		title
		url
	}
	createdBy {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	dueDate
	key
	status
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
		displayName
		url
	   }
	}
}
`;

});

parcelRegister("4Kdn3", function(module, exports) {

$parcel$export(module.exports, "ExternalPullRequestPartial", () => $2ff98bb615bc49d0$export$fa7eefb2a03609fe);
const $2ff98bb615bc49d0$export$fa7eefb2a03609fe = `
... on ExternalPullRequest {
    title
    lastUpdate
	pullRequestId
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository {
            name
        }
    }
}
`;

});

parcelRegister("kt77u", function(module, exports) {

$parcel$export(module.exports, "ExternalRemoteLinkPartial", () => $2324352047e71f08$export$2d22922c940459cd);
const $2324352047e71f08$export$2d22922c940459cd = `
... on ExternalRemoteLink {
  thumbnail {
    externalUrl
  }
}
`;

});

parcelRegister("7lYRh", function(module, exports) {

$parcel$export(module.exports, "ExternalRepositoryPartial", () => $420e540ce0776fdb$export$82972f33e243e789);
const $420e540ce0776fdb$export$82972f33e243e789 = `
... on ExternalRepository {
    name
}
`;

});

parcelRegister("kZuSh", function(module, exports) {

$parcel$export(module.exports, "ExternalVideoPartial", () => $7bbf9fdc766a97ba$export$d872aa2b0db5eb10);
const $7bbf9fdc766a97ba$export$d872aa2b0db5eb10 = `
... on ExternalVideo {
    durationInSeconds
    thumbnailUrl
    chapters {
        title
        startTimeInSeconds
    }
    createdBy {
        thirdPartyUser {
            id
            email
            name
        }
        user {
            name
        }
    }
}
`;

});

parcelRegister("bwf3l", function(module, exports) {

$parcel$export(module.exports, "ExternalWorkItemPartial", () => $b22e61a89b72835b$export$a50a1db4dd4e2aa3);
const $b22e61a89b72835b$export$a50a1db4dd4e2aa3 = `
... on ExternalWorkItem {
	assignee {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	attachments {
		byteSize
		mimeType
		thumbnailUrl
		title
		url
	}
	collaborators {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	createdBy {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	dueDate
	exceedsMaxCollaborators
	workItemProject {
		id
		name
	}
	status
	subtype
	team
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
		displayName
		url
	   }
	}
}
`;

});


parcelRegister("aXWlG", function(module, exports) {

$parcel$export(module.exports, "isSearchTrelloPartial", () => $e09ee1476032fa0c$export$6ed59678949b7701);
$parcel$export(module.exports, "getTrelloPartials", () => $e09ee1476032fa0c$export$73993ded7a48a460);
const $e09ee1476032fa0c$var$SearchResultTrelloBoard = `
... on SearchResultTrelloBoard {
	type
	description
	lastModifiedDate
}
`;
const $e09ee1476032fa0c$export$d40aaa445b6f7858 = (partial)=>{
    return partial.__typename === 'SearchResultTrelloBoard';
};
const $e09ee1476032fa0c$var$SearchResultTrelloCard = `
... on SearchResultTrelloCard {
	type
	description
	lastModifiedDate
	boardName
	commentsCount
}
`;
const $e09ee1476032fa0c$export$980cabf11d827509 = (partial)=>{
    return partial.__typename === 'SearchResultTrelloCard';
};
const $e09ee1476032fa0c$export$6ed59678949b7701 = (partial)=>{
    return $e09ee1476032fa0c$export$d40aaa445b6f7858(partial) || $e09ee1476032fa0c$export$980cabf11d827509(partial);
};
const $e09ee1476032fa0c$export$73993ded7a48a460 = ()=>{
    return `
		${$e09ee1476032fa0c$var$SearchResultTrelloBoard}
		${$e09ee1476032fa0c$var$SearchResultTrelloCard}
	`;
};

});



parcelRegister("jxvxe", function(module, exports) {

$parcel$export(module.exports, "confluencePagesQuery", () => $48a5c8423b40f47c$export$eeab7469706cab80);

var $4qT1X = parcelRequire("4qT1X");

var $hw4j5 = parcelRequire("hw4j5");
const $48a5c8423b40f47c$export$fe2cce9cc2f02a10 = (0, $hw4j5.inMemoryCache)();
const $48a5c8423b40f47c$var$GQL_CF_PAGES_OPERATION_NAME = 'SearchPageConfluencePagesQuery';
const $48a5c8423b40f47c$var$getConfluencePagesQuery = ()=>`
query ${$48a5c8423b40f47c$var$GQL_CF_PAGES_OPERATION_NAME}($pageIds: [ID]!) {
  confluence {
    pages(ids: $pageIds) {
      id
      title
      type
      links {
        base
      }
    }
  }
}
`;
const $48a5c8423b40f47c$export$eeab7469706cab80 = (pageIds)=>{
    return $48a5c8423b40f47c$export$fe2cce9cc2f02a10.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per page id
    pageIds.join(','), async ()=>{
        if (pageIds.length === 0) return {
            data: {
                confluence: {
                    pages: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $48a5c8423b40f47c$var$getConfluencePagesQuery(),
            variables: {
                pageIds: pageIds
            },
            operationName: $48a5c8423b40f47c$var$GQL_CF_PAGES_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};

});

parcelRegister("i14PY", function(module, exports) {

$parcel$export(module.exports, "searchEntitiesQuery", () => $654994348c889f70$export$98f1867fd4cb2c65);

var $4qT1X = parcelRequire("4qT1X");

var $2qzBQ = parcelRequire("2qzBQ");

var $hw4j5 = parcelRequire("hw4j5");
const $654994348c889f70$var$operationName = 'SearchEntitiesQuery';
const $654994348c889f70$var$getSearchEntitiesQuery = ({ includeSpaceKey: includeSpaceKey })=>{
    const SearchConfluenceSpace = `
    ... on SearchConfluenceSpace {
      key
    }
  `;
    return `
  query ${$654994348c889f70$var$operationName}(
		$experience: String!, 
		$query: String!, 
		$first: Int, 
		$filters: SearchFilterInput!
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
	) {
    search {
      results: search(
        experience: $experience
        query: $query
        first: $first
        filters: $filters
				experimentContext: {
					experimentId: $experimentId
					shadowExperimentId: $shadowExperimentId
					experimentLayers: $experimentLayers
				}
      ) {
        edges {
          node {
            id
            title
            type
            url
            iconUrl
            ${includeSpaceKey ? SearchConfluenceSpace : ``}
          }
        }
      }
    }
  }
  `;
};
const $654994348c889f70$export$69a3209f1a06c04d = (0, $hw4j5.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $654994348c889f70$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    return data.search?.results.edges.length === 0;
};
const $654994348c889f70$export$98f1867fd4cb2c65 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, includeSpaceKey: includeSpaceKey })=>$654994348c889f70$export$69a3209f1a06c04d.inMemoryDecorator((0, $2qzBQ.generateHashFromVariables)(variables), ()=>(0, $4qT1X.fetchAgg)({
            variables: {
                first: 20,
                experience: '',
                ...variables
            },
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $654994348c889f70$var$getSearchEntitiesQuery({
                includeSpaceKey: includeSpaceKey
            }),
            operationName: $654994348c889f70$var$operationName
        }), $654994348c889f70$var$expireWhen);

});

parcelRegister("aU479", function(module, exports) {

$parcel$export(module.exports, "cleanExcerpt", () => $d5e09354796e09eb$export$7512fe8206a7f75b);
$parcel$export(module.exports, "hashData", () => $d5e09354796e09eb$export$7904c6256691057a);
$parcel$export(module.exports, "getUserPath", () => $d5e09354796e09eb$export$451f7a1e7c934f54);
$parcel$export(module.exports, "getTeamPath", () => $d5e09354796e09eb$export$9456a8e088bfede1);

var $3rxD2 = parcelRequire("3rxD2");
const $d5e09354796e09eb$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
// copied over from @confluence/hash
const $d5e09354796e09eb$var$hash = (algorithm, data, asBytes = false)=>{
    const hash = (0, (/*@__PURE__*/$parcel$interopDefault($3rxD2))).createHash(algorithm);
    hash.update(data);
    if (asBytes) return Array.from(hash.digest());
    return hash.digest('hex');
};
const $d5e09354796e09eb$export$5fdf8c875acfc1b3 = (data)=>{
    return $d5e09354796e09eb$var$hash('sha256', data, true);
};
const $d5e09354796e09eb$export$7904c6256691057a = (data)=>{
    return $d5e09354796e09eb$var$hash('sha256', data);
};
const $d5e09354796e09eb$export$451f7a1e7c934f54 = (userId, primaryProduct, orgId, cloudId)=>{
    if (primaryProduct === 'confluence') return `/wiki/people/${userId}`;
    else if (primaryProduct === 'townsquare') return `/o/${orgId}/people/${userId}?cloudId=${cloudId}`;
};
const $d5e09354796e09eb$export$9456a8e088bfede1 = (teamId, primaryProduct, orgId, cloudId)=>{
    if (primaryProduct === 'confluence') return `/wiki/people/team/${teamId}`;
    else if (primaryProduct === 'townsquare') return `/o/${orgId}/people/team/${teamId}?cloudId=${cloudId}`;
};

});

parcelRegister("cOUgi", function(module, exports) {

$parcel$export(module.exports, "createSingleSelectFilter", () => $a80a8ee27d53487e$export$b77715d04a87c12b);

var $5cssW = parcelRequire("5cssW");
const $a80a8ee27d53487e$export$b77715d04a87c12b = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'single-select',
        didMount: false,
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$a80a8ee27d53487e$export$767f444f15b8d660({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$a80a8ee27d53487e$export$767f444f15b8d660({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: false
    };
};
const $a80a8ee27d53487e$export$767f444f15b8d660 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $5cssW.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: (0, $5cssW.getQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: (0, $5cssW.setQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $5cssW.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $a80a8ee27d53487e$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $5cssW.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $5cssW.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $5cssW.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $5cssW.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $5cssW.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $a80a8ee27d53487e$var$updateOptionState = (props)=>(option)=>{
        if (option.isDefault) return {
            ...option,
            isSelected: false
        };
        return {
            ...option,
            isSelected: props.firstSelectedOption?.value === option.value
        };
    };
const $a80a8ee27d53487e$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option)=>{
        // Theoretically this should only ever give you one option to change
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const firstSelectedOption = optionsToChange.at(0);
        const isOptionAlreadySelected = state.options.filter((x)=>x.isSelected).find((x)=>x.value === firstSelectedOption?.value);
        if (isOptionAlreadySelected) // do nothing
        return $a80a8ee27d53487e$export$767f444f15b8d660({
            initial: initial,
            state: state,
            config: config
        });
        const queryParamOptions = state.queryParams.options.map($a80a8ee27d53487e$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        const initialOptions = state.initialOptions.options.map($a80a8ee27d53487e$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // These 'interacted' options need to be persisted if a user wants to select them again
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].map($a80a8ee27d53487e$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        return $a80a8ee27d53487e$export$767f444f15b8d660({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};

});


parcelRegister("aGXLL", function(module, exports) {

$parcel$export(module.exports, "CONTRIBUTOR_FILTER_QUERY_KEYWORDS", () => $a7df8cf79771da11$export$a4d01c087c4a6f1c);
$parcel$export(module.exports, "filter", () => $a7df8cf79771da11$export$3dea766d36a8935f);

var $8RDn3 = parcelRequire("8RDn3");
var $i8MOh = parcelRequire("i8MOh");

var $1yEFx = parcelRequire("1yEFx");

var $6Ea6j = parcelRequire("6Ea6j");

var $4bHQd = parcelRequire("4bHQd");
const $a7df8cf79771da11$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $a7df8cf79771da11$export$a4d01c087c4a6f1c = [
    '@',
    'contributor:'
];
// Filter out Trello for milestone 1 (QS-4733)
// Focus does not have contributor field
const $a7df8cf79771da11$var$productKeys1P = (0, $1yEFx.all1pProductKeys).filter((key)=>key !== (0, $1yEFx.ProductKeys).Trello && key !== (0, $1yEFx.ProductKeys).Focus);
// Figma doesn't support contributor
// https://atlassian.slack.com/archives/C07P3MD2U9Z/p1733868616441159?thread_ts=1733866616.102409&cid=C07P3MD2U9Z
const $a7df8cf79771da11$var$all3pProductKeysExceptFigma = (0, $1yEFx.all3pProductKeys).filter((key)=>key !== (0, $1yEFx.ProductKeys3P).Figma);
const $a7df8cf79771da11$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'contributor',
    // 1P only for now (excluding Trello)
    products: [
        ...$a7df8cf79771da11$var$productKeys1P,
        ...$a7df8cf79771da11$var$all3pProductKeysExceptFigma
    ],
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'contributors',
        fetcher: async (queryParams, _)=>{
            const initialUsersReponse = await (0, $i8MOh.usersQuery)([
                ...queryParams
            ]);
            const allRecommendedUsers = initialUsersReponse.data?.users ?? [];
            const recommendedUserOptions = allRecommendedUsers.map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId
                }));
            return recommendedUserOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return (0, $4bHQd.loadRecommendedUsers)(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return []; // base on existing interface, can only query contributors with intl
            const response = await (0, $8RDn3.getContributors)({
                query: query,
                cloudId: config.cloudId || '',
                userId: config.userId || '',
                productKey: (0, $1yEFx.ProductKeys).Confluence,
                maxNumberOfResults: $a7df8cf79771da11$var$MAX_SEARCHED_OPTIONS_RESULTS,
                intl: config.intl
            });
            if (!response) // TODO: log not found somewhere
            return [];
            return response.map((contributor)=>({
                    trackingKey: contributor.id,
                    value: contributor.id,
                    label: contributor.name,
                    avatarUrl: contributor.avatarUrl,
                    queryParamValue: contributor.id
                }));
        }
    }
});

});
parcelRegister("8RDn3", function(module, exports) {

$parcel$export(module.exports, "getContributors", () => $ed0ac8d2f9bf46f2$export$f63f2da3517cdf9c);

var $5kTPO = parcelRequire("5kTPO");
const $ed0ac8d2f9bf46f2$export$f63f2da3517cdf9c = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'contributors',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $5kTPO.default)(requestParams, intl);
};

});


parcelRegister("c5dmm", function(module, exports) {

$parcel$export(module.exports, "filter", () => $8bdf2fa783a54336$export$3dea766d36a8935f);

var $dh538 = parcelRequire("dh538");

var $lEZ2M = parcelRequire("lEZ2M");
var $i8MOh = parcelRequire("i8MOh");

var $1yEFx = parcelRequire("1yEFx");

var $dOOW1 = parcelRequire("dOOW1");

var $6Ea6j = parcelRequire("6Ea6j");

var $4bHQd = parcelRequire("4bHQd");
const $8bdf2fa783a54336$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $8bdf2fa783a54336$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('createdBy');
const $8bdf2fa783a54336$var$getProducts3PFromConfig = ()=>{
    return (0, $dh538.fg)('enable_created_by_filter') ? $8bdf2fa783a54336$var$products3PFromConfig : [];
};
const $8bdf2fa783a54336$var$loadInitialOptions = async (config)=>{
    return (0, $4bHQd.loadRecommendedUsers)(config);
};
const $8bdf2fa783a54336$var$searchCreatedBy = async (query, config)=>{
    if (!config.intl) return []; // base on existing interface, can only query with intl
    const response = await (0, $lEZ2M.getCreatedBy)({
        query: query,
        cloudId: config.cloudId || '',
        userId: config.userId || '',
        productKey: (0, $1yEFx.ProductKeys).Confluence,
        maxNumberOfResults: $8bdf2fa783a54336$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) return [];
    return response.map((user)=>({
            trackingKey: user.id,
            value: user.id,
            label: user.name,
            avatarUrl: user.avatarUrl,
            queryParamValue: user.id
        }));
};
const $8bdf2fa783a54336$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'createdBy',
    products: [
        ...$8bdf2fa783a54336$var$getProducts3PFromConfig()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'createdBy',
        fetcher: async (queryParams, _)=>{
            const initialUsersResponse = await (0, $i8MOh.usersQuery)(queryParams);
            const allCreatedBy = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            const createdByOptions = allCreatedBy.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId
                }));
            return createdByOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $8bdf2fa783a54336$var$loadInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $8bdf2fa783a54336$var$searchCreatedBy(query, config);
        }
    }
});

});
parcelRegister("lEZ2M", function(module, exports) {

$parcel$export(module.exports, "getCreatedBy", () => $f6e777910b6712c8$export$cc8468b84430954);

var $5kTPO = parcelRequire("5kTPO");
const $f6e777910b6712c8$export$cc8468b84430954 = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'createdBy',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $5kTPO.default)(requestParams, intl);
};

});


parcelRegister("6jSbc", function(module, exports) {

$parcel$export(module.exports, "filter", () => $9bc69c6e351ac6c8$export$3dea766d36a8935f);

var $4yWWa = parcelRequire("4yWWa");

var $1yEFx = parcelRequire("1yEFx");

var $6Ea6j = parcelRequire("6Ea6j");
/**
 * Queries all focus area types from graphQL and returns all options as suggested but unselected
 * @param config
 * @returns
 */ const $9bc69c6e351ac6c8$var$getInitialOptions = async (config)=>{
    const focusAreaTypesResponse = await (0, $4yWWa.mercuryFocusAreaTypesQuery)(config.cloudId || '');
    const focusAreaTypes = focusAreaTypesResponse.data?.mercury.focusAreaTypes ?? [];
    return focusAreaTypes.map((focusAreaType)=>({
            trackingKey: focusAreaType.id,
            label: focusAreaType.name,
            value: focusAreaType.id,
            queryParamValue: focusAreaType.id
        }));
};
/**
 * Queries all focus area types from graphQL and returns all options as suggested and query params are suggested
 * @param queryParams
 * @param config
 * @returns
 */ const $9bc69c6e351ac6c8$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const focusAreaTypeOptions = await $9bc69c6e351ac6c8$var$getInitialOptions(config);
    return focusAreaTypeOptions.filter((option)=>queryParams.includes(option.value));
};
/**
 * Queries all focus area types from graphQL and filters out options that do not match the text query
 * @param query
 * @param config
 * @returns
 */ const $9bc69c6e351ac6c8$var$getOptionsFilteredByTextQuery = async (query, config)=>{
    const focusAreaTypeOptions = await $9bc69c6e351ac6c8$var$getInitialOptions(config);
    return focusAreaTypeOptions.filter((option)=>option.label.toLowerCase().includes(query.toLowerCase()));
};
const $9bc69c6e351ac6c8$var$productKeys1P = [
    (0, $1yEFx.ProductKeys).Focus
];
const $9bc69c6e351ac6c8$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'focusAreaType',
    products: $9bc69c6e351ac6c8$var$productKeys1P,
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'focusAreaTypes',
        fetcher: $9bc69c6e351ac6c8$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: $9bc69c6e351ac6c8$var$getInitialOptions
    },
    lookup: {
        fetcher: $9bc69c6e351ac6c8$var$getOptionsFilteredByTextQuery
    }
});

});
parcelRegister("4yWWa", function(module, exports) {

$parcel$export(module.exports, "mercuryFocusAreaTypesQuery", () => $2c6215c9ce99d54a$export$780cc3f06f467bfe);

var $4qT1X = parcelRequire("4qT1X");

var $hw4j5 = parcelRequire("hw4j5");
const $2c6215c9ce99d54a$export$fb16ff36c6030271 = (0, $hw4j5.inMemoryCache)();
const $2c6215c9ce99d54a$var$GQL_MERCURY_FOCUS_AREA_TYPES_OPERATION_NAME = 'FocusAreaTypes';
const $2c6215c9ce99d54a$var$mercuryFocusAreaTypesQueryString = `query ${$2c6215c9ce99d54a$var$GQL_MERCURY_FOCUS_AREA_TYPES_OPERATION_NAME}($cloudId: ID!) {
  mercury {
    focusAreaTypes(cloudId: $cloudId) @optIn(to: "Mercury") {
      id
      name
      hierarchyLevel
    }
  }
}`;
const $2c6215c9ce99d54a$export$780cc3f06f467bfe = (cloudId)=>{
    return $2c6215c9ce99d54a$export$fb16ff36c6030271.inMemoryDecorator(cloudId, async ()=>{
        if (!cloudId) return {
            data: {
                mercury: {
                    focusAreaTypes: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $2c6215c9ce99d54a$var$mercuryFocusAreaTypesQueryString,
            variables: {
                cloudId: cloudId
            },
            operationName: $2c6215c9ce99d54a$var$GQL_MERCURY_FOCUS_AREA_TYPES_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};

});


parcelRegister("e7L4o", function(module, exports) {

$parcel$export(module.exports, "filter", () => $617022314357c679$export$3dea766d36a8935f);

var $dh538 = parcelRequire("dh538");

var $6vkAh = parcelRequire("6vkAh");

var $d95gt = parcelRequire("d95gt");

var $1yEFx = parcelRequire("1yEFx");

var $6Ea6j = parcelRequire("6Ea6j");
// Number of results returned in dropdown
const $617022314357c679$var$FOCUS_AREA_RESULTS_LIMIT = 20;
const $617022314357c679$var$mapFocusAreaResult = (focusArea)=>{
    const currentStatus = (focusArea.node?.health ? focusArea.node.health.key : focusArea.node?.status.key) || 'pending';
    const status = (0, $6vkAh.isFocusAreaStatus)(currentStatus) ? currentStatus : 'pending';
    return {
        trackingKey: focusArea.node?.id || '',
        label: focusArea.node?.name || '',
        value: focusArea.node?.id || '',
        queryParamValue: focusArea.node?.id || '',
        metadata: {
            type: focusArea.node?.focusAreaType.name,
            owner: focusArea.node?.owner?.name,
            status: status
        }
    };
};
/**
 * Queries focus areas by search term
 * @param query
 * @param config
 * @returns
 */ const $617022314357c679$var$searchFocusAreas = async (query, config)=>{
    const mqlQuery = `(search LIKE '${query}')`;
    const focusAreasResponse = await (0, $d95gt.mercuryFocusAreasQuery)(config.cloudId || '', mqlQuery, $617022314357c679$var$FOCUS_AREA_RESULTS_LIMIT);
    const focusAreas = focusAreasResponse.data?.mercury.focusAreas.edges ?? [];
    return focusAreas.map($617022314357c679$var$mapFocusAreaResult);
};
/**
 * Queries all selected focus areas by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $617022314357c679$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const mqlQuery = `(${queryParams.map((id)=>`id = '${id}'`).join(' OR ')})`;
    const focusAreasResponse = await (0, $d95gt.mercuryFocusAreasQuery)(config.cloudId || '', mqlQuery, $617022314357c679$var$FOCUS_AREA_RESULTS_LIMIT);
    const focusAreas = focusAreasResponse.data?.mercury.focusAreas.edges ?? [];
    return focusAreas.map($617022314357c679$var$mapFocusAreaResult);
};
const $617022314357c679$var$productKeys1P = [
    (0, $1yEFx.ProductKeys).Focus
];
const $617022314357c679$var$getProducts1P = ()=>{
    return (0, $dh538.fg)('search_enable_mercury_content_filter') ? [
        (0, $1yEFx.ProductKeys).Focus
    ] : $617022314357c679$var$productKeys1P;
};
const $617022314357c679$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'focusAreaUnder',
    products: $617022314357c679$var$getProducts1P(),
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'focusAreaUnder',
        fetcher: $617022314357c679$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $617022314357c679$var$searchFocusAreas('', config);
        }
    },
    lookup: {
        fetcher: $617022314357c679$var$searchFocusAreas
    }
});

});
parcelRegister("6vkAh", function(module, exports) {

$parcel$export(module.exports, "isFocusAreaStatus", () => $d78197ae56dd41fa$export$78192d4e53523287);
function $d78197ae56dd41fa$export$78192d4e53523287(status) {
    return [
        'pending',
        'paused',
        'on_track',
        'off_track',
        'at_risk',
        'completed'
    ].indexOf(status) !== -1;
}

});

parcelRegister("d95gt", function(module, exports) {

$parcel$export(module.exports, "mercuryFocusAreasQuery", () => $7ddfceef9c6f7249$export$f9d9785ff9cc54a6);

var $4qT1X = parcelRequire("4qT1X");

var $hw4j5 = parcelRequire("hw4j5");
const $7ddfceef9c6f7249$export$7e54d23e8f945514 = (0, $hw4j5.inMemoryCache)();
const $7ddfceef9c6f7249$var$GQL_MERCURY_FOCUS_AREAS_OPERATION_NAME = 'FocusAreas';
const $7ddfceef9c6f7249$var$mercuryFocusAreasQueryString = `query ${$7ddfceef9c6f7249$var$GQL_MERCURY_FOCUS_AREAS_OPERATION_NAME}($cloudId: ID!, $q: String, $first: Int, $sort: [MercuryFocusAreaSort]) {
  mercury {
    focusAreas(cloudId: $cloudId, q: $q, first: $first, sort: $sort) @optIn(to: "Mercury") {
      edges {
        node {
          id
          name
          status {
		    key            
          }
          health {
            key
          }
          focusAreaType {
		  	name
            hierarchyLevel
          }
		  owner {
            name
          }
        }
      }
    }
  }
}`;
const $7ddfceef9c6f7249$var$MercuryFocusAreaSortField = {
    Budget: 'BUDGET',
    FocusAreaType: 'FOCUS_AREA_TYPE',
    HasParent: 'HAS_PARENT',
    HierarchyLevel: 'HIERARCHY_LEVEL',
    LastUpdated: 'LAST_UPDATED',
    Name: 'NAME',
    Spend: 'SPEND',
    Status: 'STATUS',
    TargetDate: 'TARGET_DATE',
    Watching: 'WATCHING'
};
const $7ddfceef9c6f7249$var$MercuryFocusAreaSortOrder = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $7ddfceef9c6f7249$export$f9d9785ff9cc54a6 = (cloudId, q, first = 20, sort = [
    {
        field: $7ddfceef9c6f7249$var$MercuryFocusAreaSortField.FocusAreaType,
        order: $7ddfceef9c6f7249$var$MercuryFocusAreaSortOrder['ASC']
    },
    {
        field: $7ddfceef9c6f7249$var$MercuryFocusAreaSortField.Name,
        order: $7ddfceef9c6f7249$var$MercuryFocusAreaSortOrder['ASC']
    }
])=>{
    return $7ddfceef9c6f7249$export$7e54d23e8f945514.inMemoryDecorator(`${cloudId}-${q}-${first}-${JSON.stringify(sort)}`, async ()=>{
        if (!cloudId) return {
            data: {
                mercury: {
                    focusAreas: {
                        edges: []
                    }
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $7ddfceef9c6f7249$var$mercuryFocusAreasQueryString,
            variables: {
                cloudId: cloudId,
                q: q,
                first: first,
                sort: sort
            },
            operationName: $7ddfceef9c6f7249$var$GQL_MERCURY_FOCUS_AREAS_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};

});


parcelRegister("gwbWt", function(module, exports) {

$parcel$export(module.exports, "filter", () => $08baf0c4c2bfd1f5$export$3dea766d36a8935f);

var $1tvnk = parcelRequire("1tvnk");

var $1yEFx = parcelRequire("1yEFx");

var $dOOW1 = parcelRequire("dOOW1");

var $6Ea6j = parcelRequire("6Ea6j");
const $08baf0c4c2bfd1f5$var$productKeys1P = [
    (0, $1yEFx.ProductKeys).Confluence
];
const $08baf0c4c2bfd1f5$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('label');
const $08baf0c4c2bfd1f5$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'label',
    products: [
        ...$08baf0c4c2bfd1f5$var$productKeys1P,
        ...$08baf0c4c2bfd1f5$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'labels',
        fetcher: async (queryParams, _)=>{
            return queryParams.map((label)=>({
                    trackingKey: label,
                    value: label,
                    queryParamValue: label,
                    label: label
                }));
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return []; // base on existing interface, can only query contributors with intl
            if (config.cloudId === undefined) return [];
            const initialLabelsResponse = await (0, $1tvnk.confluenceLabelsQuery)(config.cloudId, query, 10);
            const suggestedLabels = initialLabelsResponse.data?.confluence.searchLabels.suggestedLabels || [];
            const otherLabels = initialLabelsResponse.data?.confluence.searchLabels.otherLabels || [];
            return [
                ...suggestedLabels,
                ...otherLabels
            ].map((label)=>({
                    trackingKey: label.label || '',
                    value: label.label || '',
                    queryParamValue: label.label || '',
                    label: label.label || ''
                })) ?? [];
        }
    }
});

});
parcelRegister("1tvnk", function(module, exports) {

$parcel$export(module.exports, "confluenceLabelsQuery", () => $d787c8d425cdec7f$export$b9ea4761dac8a473);

var $4qT1X = parcelRequire("4qT1X");

var $hw4j5 = parcelRequire("hw4j5");
const $d787c8d425cdec7f$export$a8f449a3d81f3a4c = (0, $hw4j5.inMemoryCache)();
const $d787c8d425cdec7f$var$GQL_CF_LABEL_OPERATION_NAME = 'SearchLabelsQuery';
const $d787c8d425cdec7f$var$getConfluenceLabelsQuery = ()=>`
query ${$d787c8d425cdec7f$var$GQL_CF_LABEL_OPERATION_NAME}($cloudId: ID! $searchText: String!, $limit: Int) {
  confluence {
    searchLabels(cloudId: $cloudId, searchText: $searchText, limit: $limit) @optIn(to: "ConfluenceExperimentalSearchLabels") {
	  otherLabels {
        label
      }
      suggestedLabels {
        label
      }
    }
  }
}
`;
const $d787c8d425cdec7f$export$b9ea4761dac8a473 = (cloudId, searchText, limit)=>{
    return $d787c8d425cdec7f$export$a8f449a3d81f3a4c.inMemoryDecorator(searchText, async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $d787c8d425cdec7f$var$getConfluenceLabelsQuery(),
            variables: {
                cloudId: cloudId,
                searchText: searchText,
                limit: limit
            },
            operationName: $d787c8d425cdec7f$var$GQL_CF_LABEL_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};

});


parcelRegister("1uGSo", function(module, exports) {

$parcel$export(module.exports, "filter", () => $c804900efc0ed3cd$export$3dea766d36a8935f);

var $1yEFx = parcelRequire("1yEFx");

var $fKv9F = parcelRequire("fKv9F");

var $dOOW1 = parcelRequire("dOOW1");

var $7GRRM = parcelRequire("7GRRM");

var $03xXc = parcelRequire("03xXc");
const $c804900efc0ed3cd$var$LAST_UPDATED_VALUES = [
    'today',
    'yesterday',
    'past7Days',
    'past30Days',
    'pastYear',
    'custom'
];
const $c804900efc0ed3cd$var$sortCompareFn = (a, b)=>{
    return $c804900efc0ed3cd$var$LAST_UPDATED_VALUES.indexOf(a.value) - $c804900efc0ed3cd$var$LAST_UPDATED_VALUES.indexOf(b.value);
};
const $c804900efc0ed3cd$var$isIsoDate = (str)=>{
    if (!str) return false;
    if (!/\d{4}-\d{2}-\d{2}/.test(str)) return false;
    const d = new Date(str);
    return !isNaN(d.getTime());
};
const $c804900efc0ed3cd$var$productKeys1P = [
    (0, $1yEFx.ProductKeys).Atlas,
    (0, $1yEFx.ProductKeys).Confluence,
    (0, $1yEFx.ProductKeys).Focus,
    (0, $1yEFx.ProductKeys).Jira,
    (0, $1yEFx.ProductKeys).JiraProductDiscovery,
    (0, $1yEFx.ProductKeys).JiraServiceManagement,
    (0, $1yEFx.ProductKeys).Compass,
    (0, $1yEFx.ProductKeys).Trello,
    (0, $1yEFx.ProductKeys).Bitbucket
];
const $c804900efc0ed3cd$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('lastUpdated');
const $c804900efc0ed3cd$export$3dea766d36a8935f = (0, $7GRRM.createSingleWithCustomOptionSelectFilter)({
    id: 'lastUpdated',
    products: [
        ...$c804900efc0ed3cd$var$productKeys1P,
        ...$c804900efc0ed3cd$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'lastModified',
        fetcher: async (_, config)=>{
            return $c804900efc0ed3cd$var$LAST_UPDATED_VALUES.map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $03xXc.lastUpdatedLabels)[value]) || (0, $03xXc.lastUpdatedLabels)[value].defaultMessage,
                    value: value,
                    queryParamValue: value
                }));
        },
        customValueParser: (queryParams)=>{
            const { to: to, from: from } = queryParams;
            const isToDateValid = $c804900efc0ed3cd$var$isIsoDate(to?.[0]);
            const isFromDateValid = $c804900efc0ed3cd$var$isIsoDate(from?.[0]);
            const toDate = isToDateValid && to?.[0] ? to?.[0] : '';
            const fromDate = isFromDateValid && from?.[0] ? from?.[0] : '';
            const invalidDateRange = (0, $dOOW1.getInvalidDateRange)(fromDate, toDate);
            if (!invalidDateRange) return {
                to: toDate,
                from: fromDate
            };
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return [
                {
                    trackingKey: 'anytime',
                    label: config.intl?.formatMessage((0, $03xXc.lastUpdatedLabels)['anytime']) || (0, $03xXc.lastUpdatedLabels)['anytime'].defaultMessage,
                    value: 'anytime',
                    isDefault: true,
                    queryParamValue: (0, $fKv9F.LastModified).Anytime
                },
                ...$c804900efc0ed3cd$var$LAST_UPDATED_VALUES.map((value)=>({
                        trackingKey: value,
                        label: config.intl?.formatMessage((0, $03xXc.lastUpdatedLabels)[value]) || (0, $03xXc.lastUpdatedLabels)[value].defaultMessage,
                        value: value,
                        queryParamValue: value
                    }))
            ];
        }
    },
    sortCompareFn: $c804900efc0ed3cd$var$sortCompareFn,
    customValueFields: [
        'to',
        'from'
    ]
});

});
parcelRegister("7GRRM", function(module, exports) {

$parcel$export(module.exports, "createSingleWithCustomOptionSelectFilter", () => $89c49071fea602e5$export$711b0a1d273f9525);

var $7iBhV = parcelRequire("7iBhV");

var $5cssW = parcelRequire("5cssW");
const $89c49071fea602e5$export$711b0a1d273f9525 = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'single-select',
        didMount: false,
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$89c49071fea602e5$export$44d389225cc01eb5({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$89c49071fea602e5$export$44d389225cc01eb5({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: true
    };
};
const $89c49071fea602e5$export$e2de15bbd9edf9c6 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const options = $89c49071fea602e5$export$44d389225cc01eb5({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        });
        const selectedOptions = options.filter((option)=>option.isSelected);
        const queryParamValue = selectedOptions.map((option)=>option.queryParamValue);
        const isCustomOptionSelected = selectedOptions.find((option)=>option.value === (0, $7iBhV.CUSTOM_OPTION_VALUE));
        const customValueQueryParam = isCustomOptionSelected && state.customValue ? state.customValue : {};
        return {
            [initial.queryParams.key]: queryParamValue,
            ...customValueQueryParam
        };
    };
};
const $89c49071fea602e5$export$7755017099c85a0d = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams, onStateChange)=>{
        const queryParamValues = queryParams[initial.queryParams.key];
        const filter = $89c49071fea602e5$export$44d389225cc01eb5({
            initial: initial,
            state: state,
            config: config
        });
        if (!queryParamValues) {
            const clearedOptions = filter.clearOptions();
            onStateChange?.(clearedOptions.getState());
            return clearedOptions;
        }
        const allCurrentOptions = filter.getOptions({
            isLookupActive: false
        });
        const allQueryParamValues = allCurrentOptions.map((option)=>option.queryParamValue);
        const queryParamsToHydrate = queryParamValues.filter((value)=>!allQueryParamValues.includes(value));
        if (queryParamsToHydrate.length === 0) {
            const newOptions = allCurrentOptions.map((option)=>({
                    isSelected: queryParamValues.includes(option.queryParamValue),
                    value: option.value
                }));
            const isCustomOptionSelected = newOptions.find((option)=>option.value === (0, $7iBhV.CUSTOM_OPTION_VALUE))?.isSelected;
            const customValueParser = initial.queryParams.customValueParser;
            let customValue;
            if (isCustomOptionSelected) {
                if (customValueParser) customValue = customValueParser(queryParams);
                else customValue = initial.customValueFields ? initial.customValueFields.reduce((acc, field)=>({
                        ...acc,
                        [field]: queryParams[field]?.at(0) ?? ''
                    }), {}) : {};
            }
            const filterWithNewOptions = filter.setOption(newOptions, customValue);
            onStateChange?.(filterWithNewOptions.getState());
            return filterWithNewOptions;
        }
        // At this point we need to hydrate the filters with new options from
        // the query params
        const newQueryParamOptions = [
            ...state.queryParams.options
        ];
        const fetcher = initial.queryParams.fetcher;
        if (fetcher) {
            onStateChange?.({
                ...state,
                queryParams: {
                    ...state.queryParams,
                    isLoading: true
                }
            });
            const fetchedOptions = await fetcher(queryParamsToHydrate, config);
            fetchedOptions.forEach((option)=>{
                const mappedOption = {
                    isSelected: true,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label,
                    metadata: option.metadata
                };
                newQueryParamOptions.push(mappedOption);
            });
        }
        const selectedOptionsFromQueryParams = newQueryParamOptions.map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const selectedInitialOptionsFromQueryParams = [
            ...state.initialOptions.options
        ].map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const hydratedQueryParams = $89c49071fea602e5$export$44d389225cc01eb5({
            initial: initial,
            state: {
                ...state,
                queryParams: {
                    ...state.queryParams,
                    options: selectedOptionsFromQueryParams,
                    isLoading: false
                },
                initialOptions: {
                    ...state.initialOptions,
                    options: selectedInitialOptionsFromQueryParams
                }
            },
            config: config
        });
        onStateChange?.(hydratedQueryParams.getState());
        return hydratedQueryParams;
    };
};
const $89c49071fea602e5$export$44d389225cc01eb5 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $5cssW.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: $89c49071fea602e5$export$e2de15bbd9edf9c6({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $89c49071fea602e5$export$7755017099c85a0d({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $5cssW.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $89c49071fea602e5$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $5cssW.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $5cssW.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $5cssW.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $5cssW.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $5cssW.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $89c49071fea602e5$var$updateOptionState = (props)=>(option)=>{
        if (option.isDefault) return {
            ...option,
            isSelected: false
        };
        return {
            ...option,
            isSelected: props.selectedOption ? props.selectedOption.value === option.value : option.isSelected
        };
    };
const $89c49071fea602e5$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option, customValue)=>{
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const selectedOption = optionsToChange.filter((o)=>o.isSelected).at(0);
        const queryParamOptions = state.queryParams.options.map($89c49071fea602e5$var$updateOptionState({
            selectedOption: selectedOption
        }));
        const initialOptions = state.initialOptions.options.map($89c49071fea602e5$var$updateOptionState({
            selectedOption: selectedOption
        }));
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // These 'interacted' options need to be persisted if a user wants to select them again
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].map($89c49071fea602e5$var$updateOptionState({
            selectedOption: selectedOption
        }));
        return $89c49071fea602e5$export$44d389225cc01eb5({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                },
                customValue: customValue
            },
            config: config
        });
    };
};

});
parcelRegister("7iBhV", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_OPTION_VALUE", () => $ec40d4e0b09453d5$export$5ef321009a5b450c);
const $ec40d4e0b09453d5$export$5ef321009a5b450c = 'custom';
const $ec40d4e0b09453d5$export$62fed45313a13eff = 'universalTypeFilter';

});


parcelRegister("03xXc", function(module, exports) {

$parcel$export(module.exports, "lastUpdatedLabels", () => $a33c6cc099d6cfe5$export$3f164da8f895a853);

var $2nPZH = parcelRequire("2nPZH");
const $a33c6cc099d6cfe5$export$3f164da8f895a853 = (0, $2nPZH.defineMessages)({
    anytime: {
        id: "search-page.filter.last.updated.anytime",
        defaultMessage: "Anytime"
    },
    today: {
        id: "search-page.filter.last.updated.today",
        defaultMessage: "Today"
    },
    yesterday: {
        id: "search-page.filter.last.updated.yesterday",
        defaultMessage: "Yesterday"
    },
    past7Days: {
        id: "search-page.filter.last.updated.past7Days",
        defaultMessage: "Past 7 days"
    },
    past30Days: {
        id: "search-page.filter.last.updated.past30Days",
        defaultMessage: "Past 30 days"
    },
    pastYear: {
        id: "search-page.filter.last.updated.pastYear",
        defaultMessage: "Past year"
    },
    custom: {
        id: "search-page.filter.last.updated.costum",
        defaultMessage: "Custom"
    }
});

});


parcelRegister("huubg", function(module, exports) {

$parcel$export(module.exports, "filter", () => $602c33df522af7cd$export$3dea766d36a8935f);

var $dh538 = parcelRequire("dh538");

var $98IoL = parcelRequire("98IoL");
var $i8MOh = parcelRequire("i8MOh");

var $1yEFx = parcelRequire("1yEFx");

var $dOOW1 = parcelRequire("dOOW1");

var $6Ea6j = parcelRequire("6Ea6j");

var $4bHQd = parcelRequire("4bHQd");
const $602c33df522af7cd$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $602c33df522af7cd$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('lastUpdatedBy');
const $602c33df522af7cd$var$getProducts3PFromConfig = ()=>{
    return (0, $dh538.fg)('enable_last_updated_by_filter') ? $602c33df522af7cd$var$products3PFromConfig : [
        (0, $1yEFx.ProductKeys).Salesforce,
        (0, $1yEFx.ProductKeys).Hubspot
    ];
};
const $602c33df522af7cd$var$loadInitialOptions = async (config)=>{
    return (0, $4bHQd.loadRecommendedUsers)(config);
};
const $602c33df522af7cd$var$searchlastUpdatedBy = async (query, config)=>{
    if (!config.intl) return []; // base on existing interface, can only query with intl
    const response = await (0, $98IoL.getLastUpdatedBy)({
        query: query,
        cloudId: config.cloudId || '',
        userId: config.userId || '',
        productKey: (0, $1yEFx.ProductKeys).Salesforce,
        maxNumberOfResults: $602c33df522af7cd$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) return [];
    return response.map((user)=>({
            trackingKey: user.id,
            value: user.id,
            label: user.name,
            avatarUrl: user.avatarUrl,
            queryParamValue: user.id
        }));
};
const $602c33df522af7cd$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'lastUpdatedBy',
    products: [
        ...$602c33df522af7cd$var$getProducts3PFromConfig()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'lastUpdatedBy',
        fetcher: async (queryParams, _)=>{
            const initialUsersResponse = await (0, $i8MOh.usersQuery)(queryParams);
            const allLastUpdatedBy = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            const lastUpdatedByOptions = allLastUpdatedBy.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId
                }));
            return lastUpdatedByOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $602c33df522af7cd$var$loadInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $602c33df522af7cd$var$searchlastUpdatedBy(query, config);
        }
    }
});

});
parcelRegister("98IoL", function(module, exports) {

$parcel$export(module.exports, "getLastUpdatedBy", () => $c7b96c55ef1af949$export$5fc95d9e84e12fd3);

var $5kTPO = parcelRequire("5kTPO");
const $c7b96c55ef1af949$export$5fc95d9e84e12fd3 = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'lastUpdatedBy',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $5kTPO.default)(requestParams, intl);
};

});


parcelRegister("5ousX", function(module, exports) {

$parcel$export(module.exports, "filter", () => $94bac5f8fcf7120c$export$3dea766d36a8935f);

var $3Pbzb = parcelRequire("3Pbzb");
var $cxsgw = parcelRequire("cxsgw");
var $i8MOh = parcelRequire("i8MOh");

var $1yEFx = parcelRequire("1yEFx");

var $dOOW1 = parcelRequire("dOOW1");

var $6Ea6j = parcelRequire("6Ea6j");
const $94bac5f8fcf7120c$var$MAX_SMART_DEFAULT_OPTIONS = 5;
const $94bac5f8fcf7120c$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $94bac5f8fcf7120c$var$loadRecommendedOwner = async (config)=>{
    const initialUsersQuery = (0, $i8MOh.usersQuery)([
        ...config.userId ? [
            config.userId
        ] : []
    ]);
    const recommendedUserQuery = (0, $cxsgw.smartsRecommendedUserQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            userId: config.userId || '',
            tenantId: config.cloudId || '',
            maxNumberOfResults: $94bac5f8fcf7120c$var$MAX_SMART_DEFAULT_OPTIONS
        }
    });
    const [initialUsersResponse, smartsRecommendedUserResponse] = await Promise.all([
        initialUsersQuery,
        recommendedUserQuery
    ]);
    const recommendedUsersResults = smartsRecommendedUserResponse.data?.smarts.results ?? [];
    const allRecommendedUsers = [
        ...initialUsersResponse.data?.users ?? [],
        ...recommendedUsersResults.flatMap((recommendedUsers)=>!!recommendedUsers && !!recommendedUsers.user ? {
                id: recommendedUsers.id,
                ...recommendedUsers.user
            } : [])
    ];
    const recommendedUserOptions = allRecommendedUsers.map((user)=>({
            trackingKey: user.accountId,
            value: user.accountId,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId
        }));
    return recommendedUserOptions;
};
const $94bac5f8fcf7120c$var$productKeys1P = [
    (0, $1yEFx.ProductKeys).Confluence,
    (0, $1yEFx.ProductKeys).Focus
];
const $94bac5f8fcf7120c$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('owner');
const $94bac5f8fcf7120c$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'owner',
    products: [
        ...$94bac5f8fcf7120c$var$productKeys1P,
        ...$94bac5f8fcf7120c$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'owners',
        fetcher: async (queryParams, _)=>{
            const initialUsersReponse = await (0, $i8MOh.usersQuery)([
                ...queryParams
            ]);
            const allRecommendedUsers = initialUsersReponse.data?.users ?? [];
            const recommendedUserOptions = allRecommendedUsers.map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId
                }));
            return recommendedUserOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $94bac5f8fcf7120c$var$loadRecommendedOwner(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return [];
            const response = await (0, $3Pbzb.getOwners)({
                query: query,
                cloudId: config.cloudId || '',
                userId: config.userId || '',
                productKey: (0, $1yEFx.ProductKeys).Confluence,
                maxNumberOfResults: $94bac5f8fcf7120c$var$MAX_SEARCHED_OPTIONS_RESULTS,
                intl: config.intl
            });
            if (!response) // TODO: log not found somewhere
            return [];
            return response.map((owner)=>({
                    trackingKey: owner.id,
                    value: owner.id,
                    label: owner.name,
                    avatarUrl: owner.avatarUrl,
                    queryParamValue: owner.id
                }));
        }
    }
});

});
parcelRegister("3Pbzb", function(module, exports) {

$parcel$export(module.exports, "getOwners", () => $04a21b2c3e4676ff$export$148de59b68ce26ae);

var $5kTPO = parcelRequire("5kTPO");
const $04a21b2c3e4676ff$export$148de59b68ce26ae = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'owners',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $5kTPO.default)(requestParams, intl);
};

});


parcelRegister("1sswv", function(module, exports) {

$parcel$export(module.exports, "filter", () => $eaf2688e5c2f5e7e$export$3dea766d36a8935f);

var $1yEFx = parcelRequire("1yEFx");

var $dOOW1 = parcelRequire("dOOW1");

var $cOUgi = parcelRequire("cOUgi");

var $islLe = parcelRequire("islLe");
const $eaf2688e5c2f5e7e$var$productKeys1P = [
    (0, $1yEFx.ProductKeys).Confluence
];
const $eaf2688e5c2f5e7e$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('pageStatus');
const $eaf2688e5c2f5e7e$var$loadQueryParams = (queryParams, config)=>{
    const allOptions = (0, $islLe.getAllPageStatusOptions)(config);
    return allOptions.filter((option)=>!option.isDefault).filter((option)=>queryParams.includes(option.queryParamValue));
};
const $eaf2688e5c2f5e7e$var$getInitialOptions = (config)=>{
    const allOptions = (0, $islLe.getAllPageStatusOptions)(config);
    return allOptions;
};
const $eaf2688e5c2f5e7e$export$3dea766d36a8935f = (0, $cOUgi.createSingleSelectFilter)({
    id: 'pageStatus',
    products: [
        ...$eaf2688e5c2f5e7e$var$productKeys1P,
        ...$eaf2688e5c2f5e7e$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'pageStatus',
        fetcher: async (queryParams, config)=>{
            return $eaf2688e5c2f5e7e$var$loadQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $eaf2688e5c2f5e7e$var$getInitialOptions(config);
        }
    }
});

});
parcelRegister("islLe", function(module, exports) {

$parcel$export(module.exports, "getAllPageStatusOptions", () => $c955cefe55fc9981$export$3195c4e56ca4af29);

var $bxnmj = parcelRequire("bxnmj");

var $6LxJr = parcelRequire("6LxJr");
const $c955cefe55fc9981$export$3195c4e56ca4af29 = (config)=>{
    const allOption = {
        value: 'all',
        trackingKey: 'all',
        queryParamValue: 'all',
        isDefault: true,
        label: config.intl?.formatMessage((0, $6LxJr.pageStatusLabels)['all']) ?? ''
    };
    const pageStatusOptions = (0, $bxnmj.allPageStatusFilterValueKeys).map((key)=>({
            value: (0, $bxnmj.PageStatusFilterValue)[key],
            trackingKey: key,
            queryParamValue: key,
            isDefault: false,
            label: config.intl?.formatMessage((0, $6LxJr.pageStatusLabels)[key]) ?? ''
        }));
    return [
        allOption,
        ...pageStatusOptions
    ];
};

});
parcelRegister("6LxJr", function(module, exports) {

$parcel$export(module.exports, "pageStatusLabels", () => $0e27a4402a5009a7$export$29ee4a15a943675b);

var $2nPZH = parcelRequire("2nPZH");
const $0e27a4402a5009a7$export$29ee4a15a943675b = (0, $2nPZH.defineMessages)({
    all: {
        id: "search-page.filter.pageStatus.all",
        defaultMessage: "All"
    },
    roughDraft: {
        id: "search-page.filter.pageStatus.roughDraft",
        defaultMessage: "Rough draft"
    },
    inProgress: {
        id: "search-page.filter.pageStatus.inProgress",
        defaultMessage: "In progress"
    },
    readyForReview: {
        id: "search-page.filter.pageStatus.readyForReview",
        defaultMessage: "Ready for review"
    },
    verified: {
        id: "search-page.filter.pageStatus.verified",
        defaultMessage: "Verified"
    }
});

});



parcelRegister("gHwfH", function(module, exports) {

$parcel$export(module.exports, "filter", () => $42927da814457d11$export$3dea766d36a8935f);

var $3paC4 = parcelRequire("3paC4");
var $johDC = parcelRequire("johDC");
var $1WLN3 = parcelRequire("1WLN3");
var $iUYhn = parcelRequire("iUYhn");

var $idpYy = parcelRequire("idpYy");

var $1yEFx = parcelRequire("1yEFx");

var $dOOW1 = parcelRequire("dOOW1");

var $6Ea6j = parcelRequire("6Ea6j");
const $42927da814457d11$var$projectIdToARI = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $42927da814457d11$var$searchProject = async (query, config)=>{
    const searchClient = (0, $3paC4.createClient)({
        cloudId: config.cloudId || ''
    });
    let searchProjectsResponse, searchedProjects;
    const product = config.product;
    if (product === (0, $1yEFx.ProductKeys).JiraDC) {
        searchProjectsResponse = await (0, $johDC.jiraDcProjectFilterOptionsQuery)({
            variables: {
                query: query,
                cloudIdARI: `ari:cloud:confluence::site/${config.cloudId}`,
                limit: 5,
                entities: (0, $idpYy.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                product: product
            }
        });
        return searchProjectsResponse?.data?.search?.search?.edges?.map((edge)=>({
                trackingKey: edge.node.entity.id,
                value: edge.node.entity.id,
                label: edge.node.entity.displayName,
                avatarUrl: edge?.node?.entity?.icon?.url,
                queryParamValue: edge.node.entity.id
            })) || [];
    }
    searchProjectsResponse = await searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $iUYhn.Scope).JiraProject
        ],
        analytics: {
            identifier: 'search-page'
        }
    });
    searchedProjects = searchProjectsResponse.response.rawData.scopes.length > 0 ? searchProjectsResponse.response.rawData.scopes[0].results.map((projectResult)=>({
            projectId: projectResult.id,
            name: projectResult.name,
            avatar: {
                small: 'url' in projectResult.attributes.avatar ? projectResult.attributes.avatar.url : undefined
            }
        })) : [];
    return searchedProjects.map((project)=>({
            trackingKey: $42927da814457d11$var$projectIdToARI(config.cloudId || '', project.projectId),
            value: $42927da814457d11$var$projectIdToARI(config.cloudId || '', project.projectId),
            label: project.name,
            avatarUrl: project.avatar?.small,
            queryParamValue: project.projectId
        }));
};
const $42927da814457d11$var$productKeys1P = [
    (0, $1yEFx.ProductKeys).Jira,
    (0, $1yEFx.ProductKeys).JiraProductDiscovery,
    (0, $1yEFx.ProductKeys).JiraServiceManagement
];
const $42927da814457d11$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('project');
const $42927da814457d11$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'project',
    products: [
        ...$42927da814457d11$var$productKeys1P,
        ...$42927da814457d11$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'jProject',
        fetcher: async (queryParams, config)=>{
            if (config.product === (0, $1yEFx.ProductKeys).JiraDC) {
                const initialProjectsResponse = await (0, $johDC.spaceARIEntitiesQuery)({
                    variables: {
                        ids: queryParams
                    }
                });
                const projectOptions = initialProjectsResponse.data?.external_entities?.space?.map((space)=>({
                        trackingKey: space.id,
                        value: space.id,
                        label: space.displayName,
                        avatarUrl: space.icon?.url || '',
                        queryParamValue: space.id
                    }));
                return projectOptions || [];
            } else {
                const initialProjectARIs = queryParams.map((projectId)=>$42927da814457d11$var$projectIdToARI(config.cloudId || '', projectId));
                const initialProjectsResponse = await (0, $1WLN3.jiraProjectsQuery)(initialProjectARIs);
                const initialProjects = initialProjectsResponse.data?.jira.jiraProjects ?? [];
                const allProjects = initialProjects;
                const projectOptions = allProjects.map((project)=>({
                        trackingKey: $42927da814457d11$var$projectIdToARI(config.cloudId || '', project.projectId),
                        value: $42927da814457d11$var$projectIdToARI(config.cloudId || '', project.projectId),
                        label: project.name,
                        avatarUrl: project.avatar?.small,
                        queryParamValue: project.projectId
                    }));
                return projectOptions;
            }
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $42927da814457d11$var$searchProject('', config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $42927da814457d11$var$searchProject(query, config);
        }
    }
});

});
parcelRegister("1WLN3", function(module, exports) {

$parcel$export(module.exports, "jiraProjectsQuery", () => $0ec6fc46fa2dbafd$export$fd1d4a933080bfe2);

var $4qT1X = parcelRequire("4qT1X");

var $hw4j5 = parcelRequire("hw4j5");
const $0ec6fc46fa2dbafd$export$56d694fb8fe349ab = (0, $hw4j5.inMemoryCache)();
const $0ec6fc46fa2dbafd$var$GQL_JIRA_PROJECTS_OPERATION_NAME = 'SearchPageJiraProjectQuery';
const $0ec6fc46fa2dbafd$var$jiraProjectsQueryString = `query ${$0ec6fc46fa2dbafd$var$GQL_JIRA_PROJECTS_OPERATION_NAME}($projectIds: [ID!]!) {
  jira {
    jiraProjects(ids: $projectIds) {
			projectId
      name
      avatar {
        small
      }
    }
  }
}`;
const $0ec6fc46fa2dbafd$export$fd1d4a933080bfe2 = (projectIds)=>{
    return $0ec6fc46fa2dbafd$export$56d694fb8fe349ab.inMemoryDecorator(projectIds.join(','), async ()=>{
        if (projectIds.length === 0) return {
            data: {
                jira: {
                    jiraProjects: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $0ec6fc46fa2dbafd$var$jiraProjectsQueryString,
            variables: {
                projectIds: projectIds
            },
            operationName: $0ec6fc46fa2dbafd$var$GQL_JIRA_PROJECTS_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return $0ec6fc46fa2dbafd$var$filterProjectsWithoutId(response);
    });
};
const $0ec6fc46fa2dbafd$var$filterProjectsWithoutId = (response)=>{
    const filteredProjects = response.data?.jira.jiraProjects?.filter((project)=>project.projectId);
    return {
        ...response,
        data: {
            jira: {
                jiraProjects: filteredProjects
            }
        }
    };
};

});


parcelRegister("a97k3", function(module, exports) {

$parcel$export(module.exports, "filter", () => $f270dad94ab1fad4$export$3dea766d36a8935f);

var $dh538 = parcelRequire("dh538");

var $johDC = parcelRequire("johDC");
var $IpMWN = parcelRequire("IpMWN");
var $2XoKG = parcelRequire("2XoKG");
var $i14PY = parcelRequire("i14PY");
var $8hQhN = parcelRequire("8hQhN");

var $aU479 = parcelRequire("aU479");

var $idpYy = parcelRequire("idpYy");

var $1yEFx = parcelRequire("1yEFx");

var $NwuTK = parcelRequire("NwuTK");

var $dOOW1 = parcelRequire("dOOW1");

var $5XpfZ = parcelRequire("5XpfZ");

var $6Ea6j = parcelRequire("6Ea6j");
const $f270dad94ab1fad4$var$productKeys1P = [
    (0, $1yEFx.ProductKeys).Confluence
];
const $f270dad94ab1fad4$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('space');
const $f270dad94ab1fad4$var$getProducts3PFromConfig = ()=>{
    return (0, $dh538.fg)('confluence-dc-space-filter') ? $f270dad94ab1fad4$var$products3PFromConfig : [];
};
const $f270dad94ab1fad4$var$LOOKUP_ENTITIES = [
    'ati:cloud:confluence:space'
];
async function $f270dad94ab1fad4$var$searchDcSpaces(query, config) {
    let spacesResponse = await (0, $johDC.confluenceDcSpaceFilterOptionsQuery)({
        variables: {
            query: query,
            cloudIdARI: `ari:cloud:confluence::site/${config.cloudId}`,
            limit: 5,
            entities: (0, $idpYy.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
            product: (0, $1yEFx.ProductKeys).ConfluenceDC
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl
    });
    return spacesResponse?.data?.search?.search?.edges?.map(({ node: node })=>({
            trackingKey: node.entity.id,
            value: node.entity.id,
            queryParamValue: node.entity.id,
            avatarUrl: node.entity?.icon?.url,
            label: (0, $aU479.cleanExcerpt)(node.entity.displayName)
        })) ?? [];
}
const $f270dad94ab1fad4$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'space',
    products: [
        ...$f270dad94ab1fad4$var$productKeys1P,
        ...$f270dad94ab1fad4$var$getProducts3PFromConfig()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'spaces',
        fetcher: async (queryParams, config)=>{
            if (config.product === (0, $1yEFx.ProductKeys).ConfluenceDC && (0, $dh538.fg)('confluence-dc-space-filter')) {
                const spacesResponse = await (0, $johDC.spaceARIEntitiesQuery)({
                    variables: {
                        ids: queryParams
                    }
                });
                const spacesOptions = spacesResponse.data?.external_entities?.space?.map((space)=>({
                        trackingKey: space.id,
                        value: space.id,
                        label: space.displayName,
                        avatarUrl: space.icon?.url || '',
                        queryParamValue: space.id
                    }));
                return spacesOptions || [];
            }
            const cloudId = config.cloudId;
            // Practically cloudId should always be present, but we need to satisfy the type checker
            if (!cloudId) return [];
            const response = await (0, $IpMWN.confluenceSpaceKeysToIdsQuery)({
                spaceKeys: queryParams,
                cloudId: cloudId
            });
            const spaceIds = response.data?.spaces?.nodes?.map((node)=>node?.id).filter((0, $dOOW1.notEmpty)) ?? [];
            const spaceARIs = spaceIds.map((id)=>`ari:cloud:confluence:${cloudId}:space/${id}`);
            const initialSpacesResponse = await (0, $2XoKG.confluenceSpacesQuery)(spaceARIs);
            const allRecommendedSpaces = initialSpacesResponse.data?.confluence.spaces.map((space)=>({
                    key: space.key,
                    name: space.name,
                    ari: space.id,
                    avatarUrl: space.links?.base && space.icon?.path ? `${space.links.base}${space.icon.path}` : ''
                })) || [];
            return allRecommendedSpaces.map((space)=>({
                    trackingKey: space.ari,
                    value: space.key,
                    queryParamValue: space.key,
                    avatarUrl: space.avatarUrl,
                    label: space.name || ''
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            if (config.product === (0, $1yEFx.ProductKeys).ConfluenceDC && (0, $dh538.fg)('confluence-dc-space-filter')) return $f270dad94ab1fad4$var$searchDcSpaces('', config);
            const recommendedSpacesResponse = await (0, $8hQhN.smartsRecommendedContainerQuery)({
                aggAbsoluteUrl: config.aggAbsoluteUrl,
                variables: {
                    userId: config.userId || '',
                    tenantId: config.cloudId || ''
                }
            });
            const allRecommendedSpaces = recommendedSpacesResponse.data?.smarts.results?.flatMap(({ container: container })=>{
                if (!(container && container.key)) return [];
                return [
                    {
                        key: container.key,
                        name: container.name,
                        ari: container.id,
                        avatarUrl: container.links?.base && container.icon?.path ? `${container.links.base}${container.icon.path}` : ''
                    }
                ];
            }) || [];
            const recommendedSpaceOptions = allRecommendedSpaces.map((space)=>{
                return {
                    trackingKey: space.ari,
                    value: space.key,
                    queryParamValue: space.key,
                    avatarUrl: space.avatarUrl,
                    label: space.name || ''
                };
            });
            return recommendedSpaceOptions;
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (config.product === (0, $1yEFx.ProductKeys).ConfluenceDC && (0, $dh538.fg)('confluence-dc-space-filter')) return $f270dad94ab1fad4$var$searchDcSpaces(query, config);
            const backendExperiment = config.experimentConfig && (0, $NwuTK.getBackendExperiment)({
                experimentConfig: config.experimentConfig,
                entities: $f270dad94ab1fad4$var$LOOKUP_ENTITIES,
                productEdition: config.productEdition,
                isHello: (0, $5XpfZ.isHello)(config.cloudId),
                productDataRegions: config.productDataRegions,
                experience: 'search-page-space-filter',
                tenantId: config.cloudId
            });
            const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
            const response = await (0, $i14PY.searchEntitiesQuery)({
                aggAbsoluteUrl: config.aggAbsoluteUrl,
                variables: {
                    query: query,
                    first: 15,
                    filters: {
                        entities: [
                            'ati:cloud:confluence:space'
                        ],
                        locations: [
                            `ari:cloud:confluence::site/${config.cloudId}`
                        ]
                    },
                    experience: 'full-page-search-space-filter',
                    experimentId: experimentId,
                    shadowExperimentId: shadowExperimentId,
                    experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                            name: name,
                            layerId: layerId,
                            shadowId: shadowId,
                            definitions: definitions
                        }))
                },
                includeSpaceKey: true
            });
            const { data: data } = response;
            if (!data) return [];
            return data.search?.results.edges.map(({ node: node })=>({
                    trackingKey: node.id || '',
                    value: node.key || '',
                    queryParamValue: node.key ?? '',
                    avatarUrl: node.iconUrl || undefined,
                    label: node.title
                })) ?? [];
        }
    }
});

});
parcelRegister("IpMWN", function(module, exports) {

$parcel$export(module.exports, "confluenceSpaceKeysToIdsQuery", () => $ea45c916174bba4e$export$726cc5bea9d2607e);

var $4qT1X = parcelRequire("4qT1X");

var $hw4j5 = parcelRequire("hw4j5");
const $ea45c916174bba4e$var$spacesCache = (0, $hw4j5.inMemoryCache)();
const $ea45c916174bba4e$var$GRAPHQL_OPERATION_NAME = 'ConfluenceSpaceKeysToIdsQuery';
const $ea45c916174bba4e$var$getConfluenceSpaceKeysToIdsQuery = ()=>`
query ${$ea45c916174bba4e$var$GRAPHQL_OPERATION_NAME}($spaceKeys: [String]) {
  spaces(spaceKeys: $spaceKeys) {
    nodes {
      id
 	}
  }
}
`;
const $ea45c916174bba4e$export$726cc5bea9d2607e = ({ spaceKeys: spaceKeys, cloudId: cloudId })=>{
    return $ea45c916174bba4e$var$spacesCache.inMemoryDecorator(`${spaceKeys.join(',')}-${cloudId}`, async ()=>{
        // Technically fetchAgg is a util to fetch from AGG, but since we're overriding the URL it works with cc-graphql.
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $ea45c916174bba4e$var$getConfluenceSpaceKeysToIdsQuery(),
            variables: {
                spaceKeys: spaceKeys
            },
            operationName: $ea45c916174bba4e$var$GRAPHQL_OPERATION_NAME,
            aggAbsoluteUrl: `/gateway/api/ex/confluence/${cloudId}/graphql`
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};

});

parcelRegister("2XoKG", function(module, exports) {

$parcel$export(module.exports, "confluenceSpacesQuery", () => $85b6e230af4df339$export$d8fbf668d55936f8);

var $4qT1X = parcelRequire("4qT1X");

var $hw4j5 = parcelRequire("hw4j5");
const $85b6e230af4df339$export$f400862b5c7e6c62 = (0, $hw4j5.inMemoryCache)();
const $85b6e230af4df339$var$GQL_CF_SPACES_OPERATION_NAME = 'SearchPageConfluenceSpacesQuery';
const $85b6e230af4df339$var$getConfluenceSpacesQuery = ()=>`
query ${$85b6e230af4df339$var$GQL_CF_SPACES_OPERATION_NAME}($spaceIds: [ID]!) {
  confluence {
    spaces(ids: $spaceIds) {
      id
      spaceId
      name
      key
      links {
        base
      }
      icon {
        path
      }
    }
  }
}
`;
const $85b6e230af4df339$export$d8fbf668d55936f8 = (spaceIds)=>{
    return $85b6e230af4df339$export$f400862b5c7e6c62.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per page id
    spaceIds.join(','), async ()=>{
        if (spaceIds.length === 0) return {
            data: {
                confluence: {
                    spaces: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $85b6e230af4df339$var$getConfluenceSpacesQuery(),
            variables: {
                spaceIds: spaceIds
            },
            operationName: $85b6e230af4df339$var$GQL_CF_SPACES_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};

});

parcelRegister("8hQhN", function(module, exports) {

$parcel$export(module.exports, "smartsRecommendedContainerQuery", () => $d33e20668d2d4273$export$9d6625cf80401405);

var $4qT1X = parcelRequire("4qT1X");

var $2qzBQ = parcelRequire("2qzBQ");

var $hw4j5 = parcelRequire("hw4j5");
const $d33e20668d2d4273$var$operationName = 'SmartsRecommendedContainerQuery';
const $d33e20668d2d4273$var$SmartsRecommendedContainerQuery = `
query ${$d33e20668d2d4273$var$operationName}($userId: String!, $tenantId: String!) {
  smarts {
    results: recommendedContainer(
      recommendationsQuery: {
        context: {
          userId: $userId,
          tenantId: $tenantId,
          product: "confluence"
        },
        modelRequestParams: {
          caller: "full-page-search",
          experience: "CgContainerNearbyUser"
        },
        requestingUserId: $userId
      }
    ) {
      id
      score
      container {
        createdDate
        id
        key
        name
        spaceId
        status
        type
        links {
          base
        }
        icon {
          path
        }
      }
    }
  }
}
`;
const $d33e20668d2d4273$export$69a3209f1a06c04d = (0, $hw4j5.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $d33e20668d2d4273$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    const { results: results } = data.smarts;
    return !results || results.length === 0;
};
const $d33e20668d2d4273$export$9d6625cf80401405 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>$d33e20668d2d4273$export$69a3209f1a06c04d.inMemoryDecorator((0, $2qzBQ.generateHashFromVariables)(variables), ()=>(0, $4qT1X.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $d33e20668d2d4273$var$SmartsRecommendedContainerQuery,
            operationName: $d33e20668d2d4273$var$operationName
        }), $d33e20668d2d4273$var$expireWhen);

});


parcelRegister("iaYRG", function(module, exports) {

$parcel$export(module.exports, "filter", () => $d7ef0e88ac518c51$export$3dea766d36a8935f);

var $dh538 = parcelRequire("dh538");

var $1yEFx = parcelRequire("1yEFx");

var $dOOW1 = parcelRequire("dOOW1");

var $ffbvg = parcelRequire("ffbvg");
const $d7ef0e88ac518c51$var$productKeys1P = [];
const $d7ef0e88ac518c51$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('onlyTitleMatch');
const $d7ef0e88ac518c51$var$getProducts1P = ()=>{
    return (0, $dh538.fg)('add_confluence_title_match_filter') ? [
        (0, $1yEFx.ProductKeys).Confluence
    ] : $d7ef0e88ac518c51$var$productKeys1P;
};
const $d7ef0e88ac518c51$export$3dea766d36a8935f = (0, $ffbvg.createBooleanFilter)({
    id: 'onlyTitleMatch',
    queryParams: {
        key: 'titleMatch'
    },
    products: [
        ...$d7ef0e88ac518c51$var$getProducts1P(),
        ...$d7ef0e88ac518c51$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});

});

parcelRegister("dUIpv", function(module, exports) {

$parcel$export(module.exports, "filter", () => $8238dcc2ebd02683$export$3dea766d36a8935f);

var $5iakG = parcelRequire("5iakG");

var $1yEFx = parcelRequire("1yEFx");

var $cOUgi = parcelRequire("cOUgi");

var $3JX0d = parcelRequire("3JX0d");
const $8238dcc2ebd02683$var$loadQueryParams = (queryParams, config)=>{
    const allOptions = (0, $3JX0d.getAllTypeOptions)(config);
    return allOptions.filter((option)=>!option.isDefault).filter((option)=>queryParams.includes(option.queryParamValue)).map((option)=>({
            trackingKey: option.value,
            label: option.label,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault
        }));
};
const $8238dcc2ebd02683$var$getInitialOptions = (config)=>{
    const allOptions = (0, $3JX0d.getAllTypeOptions)(config);
    return allOptions.map((option)=>({
            trackingKey: option.value,
            label: option.label,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault
        }));
};
const $8238dcc2ebd02683$var$sortCompareFn = (a, b)=>{
    const allOption = (0, $3JX0d.getAllTypeOptions)({
        intl: undefined
    });
    return allOption.findIndex((option)=>option.queryParamValue === a.queryParamValue) - allOption.findIndex((option)=>option.queryParamValue === b.queryParamValue);
};
const $8238dcc2ebd02683$export$3dea766d36a8935f = (0, $cOUgi.createSingleSelectFilter)({
    id: (0, $5iakG.universalTypeFilterId),
    products: (0, $1yEFx.allProductKeys),
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'type',
        fetcher: async (queryParams, config)=>{
            return $8238dcc2ebd02683$var$loadQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $8238dcc2ebd02683$var$getInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            // NOTE: this is the first step of filtering options
            //  the store does product specific filtering
            return (0, $3JX0d.lookupOptions)(query, config);
        }
    },
    sortCompareFn: $8238dcc2ebd02683$var$sortCompareFn
});

});

parcelRegister("bF9JE", function(module, exports) {

$parcel$export(module.exports, "filter", () => $fdf2d9a71ec7e494$export$3dea766d36a8935f);

var $1yEFx = parcelRequire("1yEFx");

var $dOOW1 = parcelRequire("dOOW1");

var $ffbvg = parcelRequire("ffbvg");
const $fdf2d9a71ec7e494$var$productKeys1P = [
    (0, $1yEFx.ProductKeys).Confluence
];
const $fdf2d9a71ec7e494$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('verified');
const $fdf2d9a71ec7e494$export$3dea766d36a8935f = (0, $ffbvg.createBooleanFilter)({
    id: 'verified',
    queryParams: {
        key: 'verified'
    },
    products: [
        ...$fdf2d9a71ec7e494$var$productKeys1P,
        ...$fdf2d9a71ec7e494$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});

});


parcelRegister("gY9AU", function(module, exports) {

$parcel$export(module.exports, "getContentStatusValue", () => $397b5a5e3acc8878$export$a240a4826113d43);
$parcel$export(module.exports, "getBooleanFilterValue", () => $397b5a5e3acc8878$export$49b41db8fadc5da);
$parcel$export(module.exports, "getContainerStatusValue", () => $397b5a5e3acc8878$export$b934b4f495e2c091);
$parcel$export(module.exports, "JiraProductProjectFilterKey", () => $397b5a5e3acc8878$export$ba6044efb2e123e9);
$parcel$export(module.exports, "omitNonJiraFilterValues", () => $397b5a5e3acc8878$export$e1f376159111dbe6);
$parcel$export(module.exports, "getJiraIssueTypesFilter", () => $397b5a5e3acc8878$export$4df832a1d124a3d4);
$parcel$export(module.exports, "useJiraIssueTypeFilters", () => $397b5a5e3acc8878$export$59c68936335dd81b);
$parcel$export(module.exports, "getSelectFilterValue", () => $397b5a5e3acc8878$export$75ec3b8bb22cb14f);
$parcel$export(module.exports, "getSelectedDateRange", () => $397b5a5e3acc8878$export$7efdc6b7aa39e72a);
$parcel$export(module.exports, "getFilterDateRange", () => $397b5a5e3acc8878$export$9ec55eff3923c72);
$parcel$export(module.exports, "getJiraProjectFilter", () => $397b5a5e3acc8878$export$ac0baabacf9504ae);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $brNow = parcelRequire("brNow");

var $7iBhV = parcelRequire("7iBhV");

var $1yEFx = parcelRequire("1yEFx");

var $dOOW1 = parcelRequire("dOOW1");

var $nnnU7 = parcelRequire("nnnU7");

var $b2caI = parcelRequire("b2caI");
const $397b5a5e3acc8878$export$1c47b2cd6d3f5b5a = {
    ['showCurrent']: [],
    ['showArchived']: [
        'ARCHIVED',
        'CURRENT'
    ]
};
const $397b5a5e3acc8878$export$7069271803c33dc3 = {
    ['showCurrent']: [],
    ['showArchived']: [
        'ARCHIVED',
        'CURRENT',
        'DRAFT'
    ]
};
const $397b5a5e3acc8878$export$a240a4826113d43 = (filter)=>{
    const archivedContentOption = $397b5a5e3acc8878$export$49b41db8fadc5da(filter);
    return archivedContentOption ? $397b5a5e3acc8878$export$7069271803c33dc3['showArchived'] : $397b5a5e3acc8878$export$7069271803c33dc3['showCurrent'];
};
const $397b5a5e3acc8878$export$b934b4f495e2c091 = (filter)=>{
    const archivedContentOption = $397b5a5e3acc8878$export$49b41db8fadc5da(filter);
    return archivedContentOption ? $397b5a5e3acc8878$export$1c47b2cd6d3f5b5a['showArchived'] : $397b5a5e3acc8878$export$1c47b2cd6d3f5b5a['showCurrent'];
};
const $397b5a5e3acc8878$export$ba6044efb2e123e9 = {
    [(0, $1yEFx.ProductKeys).Jira]: [
        'software',
        'business'
    ],
    [(0, $1yEFx.ProductKeys).JiraProductDiscovery]: [
        'product_discovery'
    ],
    [(0, $1yEFx.ProductKeys).JiraServiceManagement]: [
        'service_desk'
    ]
};
const $397b5a5e3acc8878$export$e1f376159111dbe6 = (filterValues, selectedProduct)=>{
    // when all products are searched
    if (!selectedProduct) // don't return any values in all product selected mode for assignee and project filters
    return [];
    switch(selectedProduct){
        case (0, $1yEFx.ProductKeys).Jira:
        case (0, $1yEFx.ProductKeys).JiraProductDiscovery:
        case (0, $1yEFx.ProductKeys).JiraServiceManagement:
            return filterValues;
    }
    return [];
};
const $397b5a5e3acc8878$export$5c4691ac7ffb1183 = 'DUMMY_JIRA_ISSUE_TYPE_ID';
const $397b5a5e3acc8878$export$4df832a1d124a3d4 = async (cloudId, intl, issueType)=>{
    if (!cloudId) return $397b5a5e3acc8878$export$5c4691ac7ffb1183;
    const searchString = intl.formatMessage((0, $b2caI.messages)[issueType]);
    const issueTypes = await (0, $brNow.jiraIssueTypeJQLQuery)(cloudId, searchString);
    const ids = issueTypes?.data?.jira.jqlBuilder.fieldValues.edges;
    if (!ids || ids.length === 0) return $397b5a5e3acc8878$export$5c4691ac7ffb1183;
    if (ids.length > 1) {
        const issueTypeNode = ids.find((id)=>id.node?.displayName === searchString);
        if (!issueTypeNode) return $397b5a5e3acc8878$export$5c4691ac7ffb1183;
        const issueType = issueTypeNode.node?.issueTypes[0];
        return issueType && issueType.issueTypeId ? issueType.issueTypeId : $397b5a5e3acc8878$export$5c4691ac7ffb1183;
    } else {
        const node = ids[0].node;
        if (!node) return $397b5a5e3acc8878$export$5c4691ac7ffb1183;
        return node.issueTypes[0].issueTypeId || $397b5a5e3acc8878$export$5c4691ac7ffb1183;
    }
};
const $397b5a5e3acc8878$export$59c68936335dd81b = (cloudId, selectedEntities)=>{
    const intl = (0, $dBxQj.default)();
    const [jiraIssueTypeFilters, setJiraIssueTypeFilters] = (0, $gwFzn.useState)([]);
    (0, $gwFzn.useEffect)(()=>{
        const getJiraIssues = async ()=>{
            if (selectedEntities.includes('incident')) {
                const issueType = await $397b5a5e3acc8878$export$4df832a1d124a3d4(cloudId, intl, 'incident');
                setJiraIssueTypeFilters([
                    issueType
                ]);
            } else setJiraIssueTypeFilters([]);
        };
        getJiraIssues();
    }, [
        selectedEntities,
        cloudId,
        intl
    ]);
    return jiraIssueTypeFilters;
};
const $397b5a5e3acc8878$export$75ec3b8bb22cb14f = (filter)=>{
    return (0, $nnnU7.isSelectFilter)(filter?.type) ? filter.value : [];
};
const $397b5a5e3acc8878$export$1800e9d06ef0f63b = (filter)=>{
    return (0, $nnnU7.isSelectFilter)(filter?.type) ? filter.customValue : {};
};
const $397b5a5e3acc8878$export$49b41db8fadc5da = (filter)=>{
    return filter?.type === 'boolean' ? filter.value : false;
};
const $397b5a5e3acc8878$export$7efdc6b7aa39e72a = (filter)=>{
    const selectedDateOption = $397b5a5e3acc8878$export$75ec3b8bb22cb14f(filter).at(0);
    if (selectedDateOption && selectedDateOption !== (0, $7iBhV.CUSTOM_OPTION_VALUE)) return (0, $dOOW1.convertLastUpdatedToDateRange)(selectedDateOption);
    else if (selectedDateOption === (0, $7iBhV.CUSTOM_OPTION_VALUE)) {
        const customDateRange = $397b5a5e3acc8878$export$1800e9d06ef0f63b(filter);
        if (customDateRange?.from || customDateRange?.to) return (0, $dOOW1.convertCustomDateToRange)(customDateRange.from, customDateRange.to);
    }
    return;
};
const $397b5a5e3acc8878$export$9ec55eff3923c72 = (filter)=>{
    const selectedDateOption = $397b5a5e3acc8878$export$75ec3b8bb22cb14f(filter).at(0);
    if (selectedDateOption && selectedDateOption !== (0, $7iBhV.CUSTOM_OPTION_VALUE)) return [
        (0, $dOOW1.getConfluenceDateOptionValues)(selectedDateOption)
    ];
    else if (selectedDateOption === (0, $7iBhV.CUSTOM_OPTION_VALUE)) {
        const customDateRange = $397b5a5e3acc8878$export$1800e9d06ef0f63b(filter);
        if (customDateRange?.from && customDateRange?.to) return [
            (0, $dOOW1.getConfluenceDateOptionFromCustomDates)(customDateRange.from, customDateRange.to)
        ];
    }
    return [];
};
const $397b5a5e3acc8878$export$ac0baabacf9504ae = (selectedProduct)=>{
    // when all products are searched
    if (!selectedProduct) return Object.values($397b5a5e3acc8878$export$ba6044efb2e123e9).flatMap((x)=>x);
    switch(selectedProduct){
        case (0, $1yEFx.ProductKeys).Jira:
        case (0, $1yEFx.ProductKeys).JiraProductDiscovery:
        case (0, $1yEFx.ProductKeys).JiraServiceManagement:
            return $397b5a5e3acc8878$export$ba6044efb2e123e9[selectedProduct];
    }
    return [];
};

});
parcelRegister("brNow", function(module, exports) {

$parcel$export(module.exports, "jiraIssueTypeJQLQuery", () => $c2ce3ac8cb311ba1$export$299504e13b0b41d4);

var $4qT1X = parcelRequire("4qT1X");

var $hw4j5 = parcelRequire("hw4j5");
const $c2ce3ac8cb311ba1$var$GQL_JIRA_ISSUE_TYPE_OPERATION_NAME = 'SearchPageJiraIssueTypeQuery';
const $c2ce3ac8cb311ba1$var$jqlIssueTypeQueryString = `query ${$c2ce3ac8cb311ba1$var$GQL_JIRA_ISSUE_TYPE_OPERATION_NAME}(
	$cloudId: ID!,
	$first: Int = 10,
	$jqlTerm: String!,
	$jql: String!,
	$searchString: String!) {
		jira {
			jqlBuilder(cloudId: $cloudId) {
				fieldValues (
					first: $first
					jqlTerm: $jqlTerm
					jqlContext: $jql
					searchString: $searchString
				) {
					edges {
						node {
							displayName
							... on JiraJqlIssueTypeFieldValue {
								issueTypes {
									issueTypeId
								}
							}
						}
					}
          		}
			}
		}
	}`;
const $c2ce3ac8cb311ba1$export$bd7a9ccdb07f26a6 = (0, $hw4j5.inMemoryCache)();
const $c2ce3ac8cb311ba1$export$299504e13b0b41d4 = async (cloudId, searchString)=>{
    return $c2ce3ac8cb311ba1$export$bd7a9ccdb07f26a6.inMemoryDecorator(`${cloudId}-${searchString}`, async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $c2ce3ac8cb311ba1$var$jqlIssueTypeQueryString,
            variables: {
                cloudId: cloudId,
                jqlTerm: 'type',
                searchString: searchString,
                jql: ''
            },
            operationName: $c2ce3ac8cb311ba1$var$GQL_JIRA_ISSUE_TYPE_OPERATION_NAME,
            headers: {
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};

});

parcelRegister("b2caI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ff70e75a80572c21$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $ff70e75a80572c21$export$c054401256af44b9 = '[System] Incident';
const $ff70e75a80572c21$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    incident: {
        id: "search-client.jira.issue.incident.label",
        defaultMessage: "[System] Incident"
    }
});

});



parcelRegister("8N0Nm", function(module, exports) {

$parcel$export(module.exports, "fetchResults", () => $11256674f3e3aa30$export$46f82b8a3ce2a183);
$parcel$export(module.exports, "fetchJiraFields", () => $11256674f3e3aa30$export$6405a4ba66d50345);

var $dh538 = parcelRequire("dh538");

var $h4dmn = parcelRequire("h4dmn");
var $6gi58 = parcelRequire("6gi58");
var $johDC = parcelRequire("johDC");
var $2zuvB = parcelRequire("2zuvB");

var $gQ44d = parcelRequire("gQ44d");

var $dOOW1 = parcelRequire("dOOW1");
const $11256674f3e3aa30$export$46f82b8a3ce2a183 = async ({ cql: cql, query: query, originalQuery: originalQuery, entities: entities, selectedFilters: selectedFilters, cloudId: cloudId, aggAbsoluteUrl: aggAbsoluteUrl, searchSessionId: searchSessionId, sort: sort, sourceProduct: sourceProduct, experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers, after: after, limit: limit, enableHighlighting: enableHighlighting, skip3pEntityHydration: skip3pEntityHydration, includeConfluenceDCReactions: includeConfluenceDCReactions = false })=>{
    if (cql) {
        const response = (0, $h4dmn.confluenceCQLQuery)({
            cql: cql,
            first: limit,
            after: after
        }, cloudId);
        return response;
    }
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, thirdPartyFilters: thirdPartyFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const sortVariables = sort.field === (0, $2zuvB.SORT_FIELD_KEY).RELEVANCE ? [] : [
        sort
    ];
    // If the original query param is present, we want to disable query replacement
    const disableQueryReplacement = !!originalQuery;
    const variables = {
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: limit,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        searchSessionId: searchSessionId,
        sort: sortVariables,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                name: name,
                layerId: layerId,
                shadowId: shadowId,
                definitions: definitions
            })),
        after: (0, $dh538.fg)('rovo-search-results-pagination-fps') ? after : undefined,
        disableQueryReplacement: disableQueryReplacement,
        enableHighlighting: enableHighlighting,
        skip3pEntityHydration: skip3pEntityHydration,
        includeConfluenceDCReactions: includeConfluenceDCReactions,
        includeSocialSignals: true
    };
    if (entities.length === 0) throw new (0, $gQ44d.EmptyEntitiesError)();
    const response = (0, $johDC.searchPageQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        originalQuery: originalQuery
    });
    // TODO: QS-6145 maybe here is a good place to merge results into cache store as HTTP response parts come in ?
    // const deferredResponse = deferredSearchPageQuery({ variables, aggAbsoluteUrl, originalQuery });
    // If the original query param is not present, we want to cache the response with the replacement query
    if (!originalQuery && (0, $dh538.fg)('rovo-search-spelling-correction')) {
        const value = await response;
        const queryInfo = value.data?.search?.results?.queryInfo;
        if (queryInfo && queryInfo.replacementQuery && queryInfo.originalQuery && queryInfo.replacementQuery !== queryInfo.originalQuery) (0, $johDC.cache).set((0, $johDC.generateCacheKey)({
            ...variables,
            query: queryInfo.replacementQuery
        }, queryInfo.originalQuery), response);
    }
    return response;
};
const $11256674f3e3aa30$export$6405a4ba66d50345 = async ({ issueKeys: issueKeys, cloudId: cloudId, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    const variables = {
        issueKeys: issueKeys,
        cloudId: cloudId
    };
    const response = (0, $6gi58.fetchJiraFieldsQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl
    });
    return response;
};

});
parcelRegister("h4dmn", function(module, exports) {

$parcel$export(module.exports, "confluenceCQLQuery", () => $5ce8de2fb4ccbeff$export$1f8a74b0d98cee30);

var $4qT1X = parcelRequire("4qT1X");

var $hw4j5 = parcelRequire("hw4j5");
const $5ce8de2fb4ccbeff$export$fe2cce9cc2f02a10 = (0, $hw4j5.inMemoryCache)();
const $5ce8de2fb4ccbeff$var$OPERATION_NAME = 'SearchPageCQLQuery';
const $5ce8de2fb4ccbeff$var$getConfluenceCQLQuery = ()=>`
query ${$5ce8de2fb4ccbeff$var$OPERATION_NAME}($cql: String!, $first: Int, $after: String) {
  search(cql: $cql, first: $first, after: $after) {
    nodes {
      title
      excerpt
      url
      lastModified
      links {
        base
      }
      content {
        id
        type
        space {
          id
          name
          links {
            webui
          }
        }
      }
    }
    pageInfo {
      endCursor
    }
  }
}
`;
const $5ce8de2fb4ccbeff$var$mapResultNodeToSearchPageEdge = (node, cloudId)=>({
        node: {
            id: `ari:cloud:confluence:${cloudId}:${node.content.type}/${node.content.id}`,
            title: node.title,
            description: node.excerpt,
            type: node.content.type,
            url: `${node.links.base}${node.url}`,
            lastModified: node.lastModified,
            isVerified: null,
            space: node.content.space.id && node.content.space.name ? {
                id: `ari:cloud:confluence:${cloudId}:space/${node.content.space.id}`,
                name: node.content.space.name,
                webUiLink: node.content.space.links?.webui
            } : null,
            socialSignal: null,
            __typename: 'SearchConfluencePageBlogAttachment'
        }
    });
const $5ce8de2fb4ccbeff$var$mapToSearchPageData = (response, cloudId)=>{
    const { data: data, ...rest } = response;
    if (!data) return {
        data: {
            search: {
                results: {
                    edges: [],
                    totalCount: 0,
                    pageInfo: {
                        endCursor: null
                    },
                    abTest: {},
                    totalCounts: []
                }
            }
        },
        ...rest
    };
    const { nodes: nodes, pageInfo: pageInfo } = data.search;
    const edges = nodes.map((node)=>$5ce8de2fb4ccbeff$var$mapResultNodeToSearchPageEdge(node, cloudId));
    const totalCount = nodes.length;
    return {
        data: {
            search: {
                results: {
                    edges: edges,
                    totalCount: // total count is a mandatory field, but for cql case, it's inaccurate as we can't get total count from cql and also it won't be used in the UI
                    totalCount,
                    pageInfo: pageInfo,
                    abTest: {},
                    totalCounts: []
                }
            }
        },
        ...rest
    };
};
const $5ce8de2fb4ccbeff$export$1f8a74b0d98cee30 = ({ cql: cql, first: first, after: after }, cloudId)=>{
    return $5ce8de2fb4ccbeff$export$fe2cce9cc2f02a10.inMemoryDecorator(`${cql}-${first}-${after}`, async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $5ce8de2fb4ccbeff$var$getConfluenceCQLQuery(),
            variables: {
                cql: cql,
                first: first,
                after: after
            },
            operationName: $5ce8de2fb4ccbeff$var$OPERATION_NAME,
            aggAbsoluteUrl: `/gateway/api/ex/confluence/${cloudId}/graphql`
        });
        const mappedResponse = $5ce8de2fb4ccbeff$var$mapToSearchPageData(response, cloudId);
        const hasErrors = mappedResponse.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(mappedResponse);
        return mappedResponse;
    });
};

});


parcelRegister("4VmlX", function(module, exports) {

$parcel$export(module.exports, "useQuickFindActions", () => $3dbdec4d6deb14f5$export$5125bb5a97b0c344);
$parcel$export(module.exports, "useQuickFindOpen", () => $3dbdec4d6deb14f5$export$6f7ec6ed84e85154);
$parcel$export(module.exports, "useQuickFindQuery", () => $3dbdec4d6deb14f5$export$db9af4f90ab0e536);
$parcel$export(module.exports, "useContent", () => $3dbdec4d6deb14f5$export$ee83783e2ce4cc63);
$parcel$export(module.exports, "useIsFeedbackModalOpen", () => $3dbdec4d6deb14f5$export$5bdbafc4abc135c7);
$parcel$export(module.exports, "useIsBulkConnectModalOpen", () => $3dbdec4d6deb14f5$export$f79c2ea8890445d8);
$parcel$export(module.exports, "useFetchSpacesRequestId", () => $3dbdec4d6deb14f5$export$e260c85752b77e7c);
$parcel$export(module.exports, "useFetchEntitiesRequestId", () => $3dbdec4d6deb14f5$export$8d6bc416cb50c4b8);
$parcel$export(module.exports, "useUpdateRecentQueries", () => $3dbdec4d6deb14f5$export$65391f387dac24a5);
$parcel$export(module.exports, "useSelectedQueryFilters", () => $3dbdec4d6deb14f5$export$285abcbc8aa402a2);
$parcel$export(module.exports, "useCurrentQueryFilter", () => $3dbdec4d6deb14f5$export$31b21a5d8580f4a9);
$parcel$export(module.exports, "QuickFindStoreContainer", () => $3dbdec4d6deb14f5$export$3e5bb5570cf53089);

var $atveb = parcelRequire("atveb");

var $iFWZA = parcelRequire("iFWZA");
var $2S0Fz = parcelRequire("2S0Fz");
var $4ZoIm = parcelRequire("4ZoIm");
const $3dbdec4d6deb14f5$export$d4c72bab9d6cc13a = {
    quickFindOpen: false,
    quickFindQuery: '',
    isFeedbackModalOpen: false,
    isBulkConnectModalOpen: false,
    retryCount: 0,
    updateRecentQueries: undefined,
    selectedQueryFilters: []
};
const $3dbdec4d6deb14f5$var$actions = {
    setQuickFindOpen: (quickFindOpen)=>({ setState: setState })=>{
            setState({
                quickFindOpen: quickFindOpen
            });
        },
    setQuickFindQuery: (quickFindQuery)=>({ setState: setState })=>{
            setState({
                quickFindQuery: quickFindQuery
            });
        },
    setContent: (content)=>({ setState: setState })=>{
            setState({
                content: content
            });
        },
    setIsBulkConnectModalOpen: (isBulkConnectModalOpen)=>({ setState: setState })=>{
            setState({
                isBulkConnectModalOpen: isBulkConnectModalOpen
            });
        },
    setIsFeedbackModalOpen: (isFeedbackModalOpen)=>({ setState: setState })=>{
            setState({
                isFeedbackModalOpen: isFeedbackModalOpen
            });
        },
    setRetryCount: (retryCount)=>({ setState: setState })=>{
            setState({
                retryCount: retryCount
            });
        },
    setFetchSpacesRequestId: (fetchSpacesRequestId)=>({ setState: setState })=>{
            setState({
                fetchSpacesRequestId: fetchSpacesRequestId
            });
        },
    setFetchEntitiesRequestId: (fetchEntitiesRequestId)=>({ setState: setState })=>{
            setState({
                fetchEntitiesRequestId: fetchEntitiesRequestId
            });
        },
    setUpdateRecentQueries: (updateRecentQueries)=>({ setState: setState })=>{
            setState({
                updateRecentQueries: updateRecentQueries
            });
        },
    addSelectedQueryFilter: (queryFilter)=>({ setState: setState, getState: getState })=>{
            const { selectedQueryFilters: selectedQueryFilters } = getState();
            const duplicate = selectedQueryFilters.find((currentQueryFilter)=>(0, (/*@__PURE__*/$parcel$interopDefault($atveb)))(JSON.stringify(currentQueryFilter), JSON.stringify(queryFilter)));
            if (!duplicate) setState({
                selectedQueryFilters: [
                    ...selectedQueryFilters,
                    queryFilter
                ]
            });
        },
    deleteSelectedQueryFilter: (queryFilter)=>({ setState: setState, getState: getState })=>{
            const { selectedQueryFilters: selectedQueryFilters } = getState();
            const newSelectedQueryFilters = selectedQueryFilters.filter((currentQueryFilter)=>!(0, (/*@__PURE__*/$parcel$interopDefault($atveb)))(JSON.stringify(currentQueryFilter), JSON.stringify(queryFilter)));
            setState({
                selectedQueryFilters: newSelectedQueryFilters
            });
        },
    resetSelectedQueryFilters: ()=>({ setState: setState })=>{
            setState({
                selectedQueryFilters: []
            });
        },
    setCurrentQueryFilter: (currentQueryFilter)=>({ setState: setState })=>{
            setState({
                currentQueryFilter: currentQueryFilter
            });
        }
};
const $3dbdec4d6deb14f5$var$Store = (0, $4ZoIm.createStore)({
    initialState: $3dbdec4d6deb14f5$export$d4c72bab9d6cc13a,
    actions: $3dbdec4d6deb14f5$var$actions,
    name: 'quick-find'
});
const $3dbdec4d6deb14f5$export$5125bb5a97b0c344 = (0, $iFWZA.createActionsHook)($3dbdec4d6deb14f5$var$Store);
const $3dbdec4d6deb14f5$export$6f7ec6ed84e85154 = (0, $iFWZA.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.quickFindOpen
});
const $3dbdec4d6deb14f5$export$db9af4f90ab0e536 = (0, $iFWZA.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.quickFindQuery
});
const $3dbdec4d6deb14f5$export$ee83783e2ce4cc63 = (0, $iFWZA.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.content
});
const $3dbdec4d6deb14f5$export$5bdbafc4abc135c7 = (0, $iFWZA.createHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.isFeedbackModalOpen
});
const $3dbdec4d6deb14f5$export$f79c2ea8890445d8 = (0, $iFWZA.createHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.isBulkConnectModalOpen
});
const $3dbdec4d6deb14f5$export$140d37088821fcb1 = (0, $iFWZA.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.retryCount
});
const $3dbdec4d6deb14f5$export$e260c85752b77e7c = (0, $iFWZA.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.fetchSpacesRequestId
});
const $3dbdec4d6deb14f5$export$8d6bc416cb50c4b8 = (0, $iFWZA.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.fetchEntitiesRequestId
});
const $3dbdec4d6deb14f5$export$65391f387dac24a5 = (0, $iFWZA.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.updateRecentQueries
});
const $3dbdec4d6deb14f5$export$285abcbc8aa402a2 = (0, $iFWZA.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.selectedQueryFilters
});
const $3dbdec4d6deb14f5$export$31b21a5d8580f4a9 = (0, $iFWZA.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.currentQueryFilter
});
const $3dbdec4d6deb14f5$export$3e5bb5570cf53089 = (0, $2S0Fz.createContainer)($3dbdec4d6deb14f5$var$Store);

});

parcelRegister("inrbX", function(module, exports) {

$parcel$export(module.exports, "useQuickFindAnalytics", () => $3a401808d4c266ad$export$82052fbad762998f);
$parcel$export(module.exports, "useQuickFindAttributes", () => $3a401808d4c266ad$export$380f10e960af9b57);
$parcel$export(module.exports, "getCommonQueryAttributes", () => $3a401808d4c266ad$export$e44a494bf5ca923a);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $6yNqK = parcelRequire("6yNqK");

var $a0M2t = parcelRequire("a0M2t");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $4VmlX = parcelRequire("4VmlX");
const $3a401808d4c266ad$export$82052fbad762998f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $gwFzn.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            source: 'searchDialog'
        }).fire((0, $6yNqK.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};
const $3a401808d4c266ad$export$380f10e960af9b57 = ()=>{
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const fetchEntitiesRequestId = (0, $4VmlX.useFetchEntitiesRequestId)();
    const fetchSpacesRequestId = (0, $4VmlX.useFetchSpacesRequestId)();
    const [queryUpdatedTime] = (0, $djVCD.useQueryUpdatedTime)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const [queryVersion] = (0, $djVCD.useQueryVersion)();
    const [experimentConfig] = (0, $j4ply.useExperimentConfig)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const [analyticsAttributes] = (0, $j4ply.useAnalyticsAttributes)();
    const [productSelected] = (0, $djVCD.useSelectedProduct)();
    const filters = (0, $djVCD.useFilterAttributesForTracking)();
    const [productEdition] = (0, $j4ply.useProductEdition)();
    const { frontendExperiments: frontendExperiments = {} } = experimentConfig;
    const { filterSelections: filterSelections, filters: filterCategories } = filters;
    const commonAttributes = {
        productEdition: productEdition,
        frontendExperiments: {
            activeExperiments: Object.keys(frontendExperiments).filter((experiment)=>frontendExperiments[experiment]?.serveExperiment),
            ...frontendExperiments
        },
        ...$3a401808d4c266ad$export$e44a494bf5ca923a(quickFindQuery),
        queryUpdatedAgo: queryUpdatedTime ? Date.now() - queryUpdatedTime : undefined,
        queryVersion: queryVersion,
        searchSessionId: searchSessionId,
        fetchEntitiesTraceId: fetchEntitiesRequestId,
        fetchSpacesTraceId: fetchSpacesRequestId,
        isQuickFind: true,
        mode: applicationMode,
        productSelected: productSelected || (0, $6yNqK.ALL_PRODUCTS_STRING),
        filters: filterCategories,
        filterSelections: filterSelections,
        ...analyticsAttributes
    };
    const nonPrivacySafeAttributes = {
        query: quickFindQuery
    };
    return {
        commonAttributes: commonAttributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};
const $3a401808d4c266ad$export$e44a494bf5ca923a = (query)=>{
    return {
        numberOfTerms: (query.match(/\w+/g) || []).length,
        queryHash: (0, $a0M2t.sha256Hash)(query),
        queryHashSHA256: (0, $a0M2t.sha256Hash)(query),
        queryLength: query.length,
        wordCount: (query.match(/\w+/g) || []).length
    };
};

});

parcelRegister("c74az", function(module, exports) {

$parcel$export(module.exports, "fetchRecentActivities", () => $198609fd26633f18$export$ae65634d024c5427);

var $dh538 = parcelRequire("dh538");

var $hWR4v = parcelRequire("hWR4v");
var $ja8yA = parcelRequire("ja8yA");
const $198609fd26633f18$export$48de245659972a87 = [
    'confluence',
    'jira',
    'townsquare',
    'graph'
];
const $198609fd26633f18$export$742b5ce6018da1f4 = [
    'page',
    'blogpost',
    'whiteboard',
    'issue',
    'project',
    'goal',
    'content',
    'document',
    'remote-link'
];
const $198609fd26633f18$export$ae65634d024c5427 = async (cloudId, aggAbsoluteUrl)=>{
    return await (0, $ja8yA.recentActivitiesQuery)({
        variables: {
            filteredProducts: $198609fd26633f18$export$48de245659972a87,
            filteredObjectTypes: (0, $dh538.fg)('smartlinks-qf-recents') ? $198609fd26633f18$export$742b5ce6018da1f4 : $198609fd26633f18$export$742b5ce6018da1f4.filter((type)=>type !== 'remote-link'),
            filteredRootContainerIds: [
                `ari:cloud:platform::site/${cloudId}`,
                `ari:cloud:townsquare::site/${cloudId}`
            ],
            itemsLimit: 200
        },
        aggAbsoluteUrl: aggAbsoluteUrl
    }).then((response)=>{
        const edges = response.data?.activity?.myActivity?.all?.edges || [];
        return edges.map($198609fd26633f18$export$cf1f13813d90479a);
    });
};
const $198609fd26633f18$export$cf1f13813d90479a = (result)=>{
    const product = result.node.object.product;
    let title = '';
    if ((0, $hWR4v.is1PActivity)(result.node.object)) {
        if (product === 'confluence') title = result.node.object.data?.title || '';
        else if (product === 'jira') {
            const key = result.node.object.data?.key;
            const summary = result.node.object.data?.fieldsById?.edges?.[0]?.node?.text;
            title = key && summary ? `${key}: ${summary}` : '';
        } else if (product === 'townsquare') title = result.node.object.data?.name || '';
    } else if ((0, $hWR4v.isGraphActivity)(result.node.object) && ((0, $hWR4v.isDocumentActivity)(result.node.object) || (0, $hWR4v.isRemoteLinkActivity)(result.node.object))) title = result.node.object.data?.displayName || '';
    else title = '';
    return {
        id: result.node.object.id,
        title: title,
        data: result,
        type: 'recent-activity'
    };
};

});
parcelRegister("hWR4v", function(module, exports) {

$parcel$export(module.exports, "ActivityProduct", () => $410f9d395e302635$export$3ca4051c67b8ec7b);
$parcel$export(module.exports, "isRemoteLinkActivity", () => $410f9d395e302635$export$b7d2f1faf131fc56);
$parcel$export(module.exports, "isDocumentActivity", () => $410f9d395e302635$export$8d4b7c5856642df3);
$parcel$export(module.exports, "isGraphActivity", () => $410f9d395e302635$export$ed71d50c78c3618b);
$parcel$export(module.exports, "is1PActivity", () => $410f9d395e302635$export$d26e891d2764b7d7);
var $410f9d395e302635$export$3ca4051c67b8ec7b = /*#__PURE__*/ function(ActivityProduct) {
    ActivityProduct["JIRA"] = "jira";
    ActivityProduct["CONFLUENCE"] = "confluence";
    ActivityProduct["ATLAS"] = "townsquare";
    ActivityProduct["GRAPH"] = "graph";
    return ActivityProduct;
}({});
var $410f9d395e302635$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SL_VIEWED"] = "sl-viewed";
    return VIEWED_EVENT;
}({});
var $410f9d395e302635$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
var $410f9d395e302635$var$ExternalDocumentCategory = /*#__PURE__*/ function(ExternalDocumentCategory) {
    ExternalDocumentCategory["DOCUMENT"] = "DOCUMENT";
    ExternalDocumentCategory["PRESENTATION"] = "PRESENTATION";
    ExternalDocumentCategory["SPREADSHEET"] = "SPREADSHEET";
    return ExternalDocumentCategory;
}($410f9d395e302635$var$ExternalDocumentCategory || {});
const $410f9d395e302635$export$b7d2f1faf131fc56 = (activity)=>{
    return activity.type === 'remote-link';
};
const $410f9d395e302635$export$8d4b7c5856642df3 = (activity)=>{
    return activity.type === 'document';
};
const $410f9d395e302635$export$ed71d50c78c3618b = (activity)=>{
    return activity.product === 'graph';
};
const $410f9d395e302635$export$d26e891d2764b7d7 = (activity)=>{
    return activity.product === 'confluence' || activity.product === 'jira' || activity.product === 'townsquare';
};

});

parcelRegister("ja8yA", function(module, exports) {

$parcel$export(module.exports, "recentActivitiesQuery", () => $8055f1273433c91e$export$ba6bff93c920ff4a);

var $4qT1X = parcelRequire("4qT1X");

var $g3BZH = parcelRequire("g3BZH");
const $8055f1273433c91e$export$ba6bff93c920ff4a = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $g3BZH.quickFindRecentActivitiesQuery),
        operationName: $g3BZH.operationName
    });
};

});
parcelRegister("g3BZH", function(module, exports) {

$parcel$export(module.exports, "operationName", () => $96bd0be78eb47b74$export$5db520940cf00715);
$parcel$export(module.exports, "quickFindRecentActivitiesQuery", () => $96bd0be78eb47b74$export$8a781e50bcd90a75);
const $96bd0be78eb47b74$var$ConfluencePageFragment = `
  fragment ConfluencePageFragment on ConfluencePage {
    __typename
    title
    pageStatus: status
    subtype
    ancestors {
      __typename
      id
      title
    }
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $96bd0be78eb47b74$var$ConfluenceBlogPostFragment = `
  fragment ConfluenceBlogPostFragment on ConfluenceBlogPost {
    __typename
    title
    blogStatus: status
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $96bd0be78eb47b74$var$ConfluenceWhiteboardFragment = `
  fragment ConfluenceWhiteboardFragment on ConfluenceWhiteboard {
    __typename
    title
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $96bd0be78eb47b74$var$AtlasProjectFragment = `
  fragment AtlasProjectFragment on TownsquareProject {
    __typename
    key
    name
    url
    iconData
  }
`;
const $96bd0be78eb47b74$var$AtlasGoalFragment = `
  fragment AtlasGoalFragment on TownsquareGoal {
    __typename
    key
    name
    url
    iconData
  }
`;
const $96bd0be78eb47b74$var$JiraSingleIssueLineTextFieldFragment = `
  fragment JiraSingleIssueLineTextFieldFragment on JiraSingleLineTextField {
    text
  }
`;
const $96bd0be78eb47b74$var$JiraIssueFragment = `
  fragment JiraIssueFragment on JiraIssue {
    __typename
    key
    webUrl
    statusCategory {
      name,
      colorName
    }
    fieldsById(ids: ["summary"]) {
      edges {
        node {
          __typename
          ...JiraSingleIssueLineTextFieldFragment
        }
      }
    }
  }
  ${$96bd0be78eb47b74$var$JiraSingleIssueLineTextFieldFragment}
`;
const $96bd0be78eb47b74$var$GraphDocumentFragment = `
  fragment GraphDocumentFragment on ExternalDocument {
    id
    type {
        category
    }
    displayName
    parent @optIn(to: "ExternalDataDepotQueryV2"){
        ... on ExternalDocument {
            displayName
        }
    }
    url
    provider {
        providerId
    }
  }
`;
const $96bd0be78eb47b74$var$GraphRemoteLinkFragment = `
  fragment GraphRemoteLinkFragment on ExternalRemoteLink {
	  id
		displayName
		category @optIn(to: "ExternalDataDepotQueryV2")
		url
    provider {
			providerId
		}
  }
`;
const $96bd0be78eb47b74$export$5db520940cf00715 = 'QuickFindActivitiesQuery';
const $96bd0be78eb47b74$export$8a781e50bcd90a75 = `
  query ${$96bd0be78eb47b74$export$5db520940cf00715}(
    $filteredProducts: [String!]
    $filteredObjectTypes: [String!]
    $itemsLimit: Int!
    $filteredRootContainerIds: [ID!]
  ) {
    activity {
      myActivity {
        all(
          filter: {
            arguments: {
              products: $filteredProducts
              objectTypes: $filteredObjectTypes
            }
            rootContainerIds: $filteredRootContainerIds
          }
          first: $itemsLimit
        ) {
          __typename
          edges {
            __typename
            node {
              __typename
              object {
                __typename
                id
                type
                product
                data {
                  __typename
                  ...ConfluencePageFragment
                  ...ConfluenceBlogPostFragment
                  ...ConfluenceWhiteboardFragment
                  ...AtlasProjectFragment
                  ...AtlasGoalFragment
                  ...JiraIssueFragment
                  ...GraphDocumentFragment
									...GraphRemoteLinkFragment
                }
              }
              event {
                __typename
                eventType
                timestamp
              }
            }
          }
        }
      }
    }
  }
  ${$96bd0be78eb47b74$var$ConfluencePageFragment}
  ${$96bd0be78eb47b74$var$ConfluenceBlogPostFragment}
  ${$96bd0be78eb47b74$var$ConfluenceWhiteboardFragment}
  ${$96bd0be78eb47b74$var$AtlasProjectFragment}
  ${$96bd0be78eb47b74$var$AtlasGoalFragment}
  ${$96bd0be78eb47b74$var$JiraIssueFragment}
  ${$96bd0be78eb47b74$var$GraphDocumentFragment}
	${$96bd0be78eb47b74$var$GraphRemoteLinkFragment}
`;

});



parcelRegister("fqqqA", function(module, exports) {

$parcel$export(module.exports, "useQuickFindResultsCallbacks", () => $a755cc866a3495f8$export$483ef80309da5ade);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $kJsRi = parcelRequire("kJsRi");

var $4TXTZ = parcelRequire("4TXTZ");

var $9NDUe = parcelRequire("9NDUe");
var $5aVN7 = parcelRequire("5aVN7");

var $3R0ts = parcelRequire("3R0ts");

var $6SihM = parcelRequire("6SihM");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $j4ply = parcelRequire("j4ply");

var $inrbX = parcelRequire("inrbX");
const $a755cc866a3495f8$export$483ef80309da5ade = ()=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const serveUserShardModel = (0, $j4ply.useUserShardModel)();
    const { incrementQueryVersion: incrementQueryVersion } = (0, $djVCD.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const [isHello] = (0, $j4ply.useIsHello)();
    const ufoPreQueryLoadExperience = (0, $gwFzn.useRef)(new (0, $5aVN7.UFOExperience)(`${primaryProduct}-pre-query-results-load`, {
        type: (0, $9NDUe.ExperienceTypes).Experience,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
        platform: {
            component: 'search-dialog'
        }
    }));
    const ufoPostQueryLoadExperience = (0, $gwFzn.useRef)(new (0, $5aVN7.UFOExperience)(`${primaryProduct}-post-query-results-load`, {
        type: (0, $9NDUe.ExperienceTypes).Experience,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
        platform: {
            component: 'search-dialog'
        }
    }));
    const onPreQueryStart = (0, $gwFzn.useCallback)(()=>{
        ufoPreQueryLoadExperience.current.start();
    }, []);
    const onPreQuerySuccess = (0, $gwFzn.useCallback)(()=>{
        ufoPreQueryLoadExperience.current.success({
            metadata: {
                isQuickFind: true
            }
        });
    }, []);
    const onPreQueryFailure = (0, $gwFzn.useCallback)(()=>{
        ufoPreQueryLoadExperience.current.failure();
    }, []);
    const onPostQueryChange = (0, $gwFzn.useCallback)(()=>{
        if ((0, $dh538.fg)('quick_find_metrics_using_ufo_react')) (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_POST_QUERY_INTERACTION));
    }, []);
    const onPostQueryStart = (0, $gwFzn.useCallback)(()=>{
        const restartMetric = async ()=>{
            await ufoPostQueryLoadExperience.current.abort();
            await ufoPostQueryLoadExperience.current.start();
        };
        restartMetric();
    }, []);
    const onPostQuerySuccess = (0, $gwFzn.useCallback)((duration, hasThirdPartyResults)=>{
        incrementQueryVersion();
        ufoPostQueryLoadExperience.current.success({
            metadata: {
                isQuickFind: true,
                isHello: isHello,
                use3PResults: serveUserShardModel,
                hasThirdPartyResults: hasThirdPartyResults
            }
        });
        fireAnalyticsEvent((0, $6SihM.onSearchRequestCompleted)({
            attributes: {
                ...commonAttributes,
                postQueryRequestDurationMs: duration,
                hasThirdPartyResults: hasThirdPartyResults
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        incrementQueryVersion,
        nonPrivacySafeAttributes,
        isHello,
        serveUserShardModel
    ]);
    const onPostQueryFailure = (0, $gwFzn.useCallback)(()=>{
        ufoPostQueryLoadExperience.current.failure();
        if ((0, $dh538.fg)('quick_find_metrics_using_ufo_react')) (0, $kJsRi.setInteractionError)((0, $3R0ts.QUICK_FIND_POST_QUERY_INTERACTION), {
            errorMessage: 'request failed',
            name: 'request failed'
        });
    }, []);
    const onPostQueryCancel = (0, $gwFzn.useCallback)(()=>{
        ufoPostQueryLoadExperience.current.abort();
    }, []);
    return (0, $gwFzn.useMemo)(()=>({
            onPreQueryStart: onPreQueryStart,
            onPreQuerySuccess: onPreQuerySuccess,
            onPreQueryFailure: onPreQueryFailure,
            onPostQueryChange: onPostQueryChange,
            onPostQueryStart: onPostQueryStart,
            onPostQuerySuccess: onPostQuerySuccess,
            onPostQueryFailure: onPostQueryFailure,
            onPostQueryCancel: onPostQueryCancel
        }), [
        onPostQueryCancel,
        onPostQueryFailure,
        onPostQueryChange,
        onPostQueryStart,
        onPostQuerySuccess,
        onPreQueryFailure,
        onPreQueryStart,
        onPreQuerySuccess
    ]);
};

});
parcelRegister("kJsRi", function(module, exports) {

$parcel$export(module.exports, "setInteractionError", () => $e6b26cca3d43530b$export$5b689ca7b019e89f);

var $4u5NT = parcelRequire("4u5NT");
function $e6b26cca3d43530b$export$5b689ca7b019e89f(interactionName, error) {
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (!interaction) return;
    if (interaction.ufoName !== interactionName) return;
    (0, $4u5NT.addError)(interaction.id, error.name, null, 'Manual interaction error', error.errorMessage, undefined, true);
}

});

parcelRegister("3R0ts", function(module, exports) {

$parcel$export(module.exports, "SEARCH_DIALOG_WIDTH_OBSERVER_ID", () => $979dcbe39352dbbd$export$194e5f2c2ebfcf47);
$parcel$export(module.exports, "QUICK_FIND_OPEN_INTERACTION", () => $979dcbe39352dbbd$export$954ad19cca7aaecd);
$parcel$export(module.exports, "QUICK_FIND_CLOSE_INTERACTION", () => $979dcbe39352dbbd$export$d73367afdae3e8ef);
$parcel$export(module.exports, "QUICK_FIND_POST_QUERY_INTERACTION", () => $979dcbe39352dbbd$export$529299d30909140a);
$parcel$export(module.exports, "QUICK_FIND_LOADING_HOLD", () => $979dcbe39352dbbd$export$b1255d59856835f2);
const $979dcbe39352dbbd$export$194e5f2c2ebfcf47 = 'quick-find-dialog';
const $979dcbe39352dbbd$export$954ad19cca7aaecd = 'quick-find-open';
const $979dcbe39352dbbd$export$d73367afdae3e8ef = 'quick-find-close';
const $979dcbe39352dbbd$export$529299d30909140a = 'quick-find-post-query';
const $979dcbe39352dbbd$export$b1255d59856835f2 = 'quick-find-loading';

});

parcelRegister("6SihM", function(module, exports) {

$parcel$export(module.exports, "onSearchRequestCompleted", () => $33a13590dc77f914$export$caa45abe6a87e5b5);
const $33a13590dc77f914$export$caa45abe6a87e5b5 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'completed',
        actionSubject: 'searchRequest',
        actionSubjectId: 'postQuerySearchResults',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});


parcelRegister("3zpmm", function(module, exports) {

$parcel$export(module.exports, "fetchPeopleAndTeamsResults", () => $6e53edd4c7804f3e$export$290039782fc4e47);

var $1L3gY = parcelRequire("1L3gY");
const $6e53edd4c7804f3e$export$290039782fc4e47 = async (query, organizationId, primaryProduct, principalId, siteId)=>{
    // Override townsquare with watermelon as URS does not support townsquare as a primary product
    const productKey = primaryProduct === 'townsquare' ? 'watermelon' : primaryProduct;
    const response = await (0, $1L3gY.default)({
        query: query,
        context: {
            contextType: 'quick_find',
            siteId: siteId,
            productKey: productKey,
            principalId: principalId,
            organizationId: organizationId
        },
        includeUsers: true,
        includeTeams: true,
        includeGroups: false,
        maxNumberOfResults: 2,
        performSearchQueryOnly: false,
        searchQuery: {
            filter: 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)'
        }
    });
    return response.map($6e53edd4c7804f3e$export$cf1f13813d90479a);
};
const $6e53edd4c7804f3e$export$cf1f13813d90479a = (result)=>({
        id: result.id,
        title: result.name || result.displayName || '',
        data: result,
        type: 'people-and-teams'
    });

});

parcelRegister("eK6Pl", function(module, exports) {

$parcel$export(module.exports, "fetchConfluenceAnd3PEntities", () => $d482bbe0b8132b8c$export$9605a5c4a68b2654);
$parcel$export(module.exports, "fetchConfluenceSpaces", () => $d482bbe0b8132b8c$export$919c2c6ec09a9e2);
$parcel$export(module.exports, "fetchAtlasEntities", () => $d482bbe0b8132b8c$export$65df7212bf163b08);
$parcel$export(module.exports, "fetchMercuryEntities", () => $d482bbe0b8132b8c$export$60162ce0dfbba9f8);
$parcel$export(module.exports, "fetchJiraEntities", () => $d482bbe0b8132b8c$export$cfa5e5437133749b);

var $dh538 = parcelRequire("dh538");

var $johDC = parcelRequire("johDC");

var $1yEFx = parcelRequire("1yEFx");

var $NwuTK = parcelRequire("NwuTK");

var $dOOW1 = parcelRequire("dOOW1");

var $5XpfZ = parcelRequire("5XpfZ");

var $a5OFf = parcelRequire("a5OFf");

var $j4ply = parcelRequire("j4ply");

var $lDo65 = parcelRequire("lDo65");
const $d482bbe0b8132b8c$var$experience = 'quick-find';
const $d482bbe0b8132b8c$export$263a3384b7ce18b1 = (thirdPartyConfigs)=>{
    const smartlinkProducts = Object.keys(thirdPartyConfigs).filter((productKey)=>(0, $a5OFf.isProductSmartlink)({
            productKey: productKey,
            thirdPartyConfigs: thirdPartyConfigs
        }));
    const quickFind3PProducts = [
        (0, $1yEFx.ProductKeys3P).GoogleDrive,
        (0, $1yEFx.ProductKeys3P).Sharepoint
    ].concat((0, $dh538.fg)('quickfind-smartlinks') ? [
        ...smartlinkProducts
    ] : []);
    const quickFind3PEntities = quickFind3PProducts.filter((productKey)=>!thirdPartyConfigs[productKey]?.userNeedsOAuth).map((productKey)=>Array.from(thirdPartyConfigs[productKey]?.typeFilterConfig?.keys() ?? [])).flat();
    const quickFindIntegrationARIs = (0, $dOOW1.getIntegrationARIsFromConfig)();
    const titleMatchValue = false;
    return (0, $dOOW1.getThirdPartyFilters)(quickFind3PProducts, titleMatchValue, quickFind3PEntities, thirdPartyConfigs, quickFindIntegrationARIs);
};
const $d482bbe0b8132b8c$export$9605a5c4a68b2654 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, filteredEntities)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // refer to fetchJiraEntities
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const isUserShardModel = (0, $j4ply.serveUserShardModel)(experimentConfig);
    const isUserShardUI = (0, $j4ply.serveUserShardUI)(experimentConfig);
    const supportedEntities = [
        'ati:cloud:confluence:page',
        'ati:cloud:confluence:blogpost',
        'ati:cloud:confluence:attachment',
        'ati:cloud:confluence:whiteboard',
        'ati:cloud:confluence:database',
        'ati:cloud:confluence:embed',
        'ati:cloud:confluence:folder',
        ...isUserShardModel ? [
            'ati:cloud:graph:document'
        ] : [],
        ...(0, $dh538.fg)('quickfind-smartlinks') ? [
            'ati:cloud:graph:remote-link'
        ] : []
    ];
    const entities = supportedEntities.filter((supportedEntity)=>filteredEntities.includes(supportedEntity));
    const backendExperiment = (0, $NwuTK.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const finalExperimentId = isUserShardModel ? 'L1-usershard' : experimentId;
    const finalExperimentLayers = isUserShardModel ? [
        {
            name: 'search_platform_layer_l1',
            layerId: 'L1-usershard-shosexp',
            shadowId: null
        },
        {
            name: 'search_platform_layer_l2',
            layerId: 'L2-pipelineOnly',
            shadowId: null
        }
    ] : experimentLayers;
    const limit = isUserShardUI ? 10 : 7;
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: limit,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: [],
                issueTypeIDs: []
            }
        },
        mercuryFilters: mercuryFilters,
        thirdPartyFilters: {
            titleMatchOnly: true,
            subtypes: []
        },
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sourceProduct: sourceProduct,
        experimentId: finalExperimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(finalExperimentLayers),
        includeConfluenceDCReactions: false,
        includeSocialSignals: false
    };
    const response = await (0, $johDC.searchDialogQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl
    });
    const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
    return {
        fetchResults: nodes.map($d482bbe0b8132b8c$export$cf1f13813d90479a),
        fetchEntitiesRequestId: response.extensions?.gateway?.request_id
    };
};
const $d482bbe0b8132b8c$export$919c2c6ec09a9e2 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    // refer to fetchJiraEntities
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const entities = [
        'ati:cloud:confluence:space'
    ];
    const backendExperiment = (0, $NwuTK.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 1,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: [],
                issueTypeIDs: []
            }
        },
        mercuryFilters: mercuryFilters,
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: []
        },
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeConfluenceDCReactions: false,
        includeSocialSignals: false
    };
    const response = await (0, $johDC.searchDialogQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl
    });
    const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
    return {
        fetchResults: nodes.map($d482bbe0b8132b8c$export$cf1f13813d90479a),
        fetchSpacesRequestId: response.extensions?.gateway?.request_id
    };
};
const $d482bbe0b8132b8c$export$65df7212bf163b08 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    // refer to fetchJiraEntities
    const { commonFilters: commonFilters, mercuryFilters: mercuryFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const entities = [
        'ati:cloud:townsquare:project',
        'ati:cloud:townsquare:goal',
        'ati:cloud:townsquare:tag'
    ];
    const backendExperiment = (0, $NwuTK.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 6,
        commonFilters: commonFilters,
        confluenceFilters: {
            spacesFilter: [],
            contributorsFilter: [],
            ancestorIdsFilter: [],
            range: [],
            owners: [],
            labelsFilter: [],
            titleMatchOnly: true,
            contentStatuses: [],
            containerStatus: []
        },
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: [],
                issueTypeIDs: []
            }
        },
        mercuryFilters: mercuryFilters,
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: []
        },
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeConfluenceDCReactions: false,
        includeSocialSignals: false
    };
    const response = await (0, $johDC.searchDialogQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl
    });
    const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
    return {
        fetchResults: nodes.map($d482bbe0b8132b8c$export$cf1f13813d90479a),
        fetchEntitiesRequestId: response.extensions?.gateway?.request_id
    };
};
const $d482bbe0b8132b8c$export$60162ce0dfbba9f8 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    // refer to fetchJiraEntities
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, thirdPartyFilters: thirdPartyFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const entities = [
        'ati:cloud:mercury:focus-area',
        'ati:cloud:mercury:focus-area-status-update'
    ];
    const backendExperiment = (0, $NwuTK.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 6,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeConfluenceDCReactions: false,
        includeSocialSignals: false
    };
    const response = await (0, $johDC.searchDialogQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl
    });
    const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
    return {
        fetchResults: nodes.map($d482bbe0b8132b8c$export$cf1f13813d90479a),
        fetchEntitiesRequestId: response.extensions?.gateway?.request_id
    };
};
/**
 * The experiment layers are mapped to ensure permitted attributes are sent into search requests.
 */ const $d482bbe0b8132b8c$var$mapExperimentLayers = (experimentLayers)=>experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
            name: name,
            layerId: layerId,
            shadowId: shadowId,
            definitions: definitions
        }));
const $d482bbe0b8132b8c$export$cfa5e5437133749b = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments)=>{
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, thirdPartyFilters: thirdPartyFilters, jiraFilters: jiraFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const entities = [
        'ati:cloud:jira:board',
        'ati:cloud:jira:dashboard',
        'ati:cloud:jira:filter',
        'ati:cloud:jira:issue',
        'ati:cloud:jira:project'
    ];
    const backendExperiment = (0, $NwuTK.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:jira::site/${cloudId}`,
        tenantId: cloudId,
        limit: 7,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sourceProduct: sourceProduct,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeConfluenceDCReactions: false,
        includeSocialSignals: false
    };
    const response = await (0, $johDC.searchDialogQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl
    });
    const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
    return {
        fetchResults: nodes.map($d482bbe0b8132b8c$export$cf1f13813d90479a),
        fetchEntitiesRequestId: response.extensions?.gateway?.request_id
    };
};
const $d482bbe0b8132b8c$export$cf1f13813d90479a = (result)=>({
        id: result.id,
        title: result.title,
        data: result,
        type: 'search-result'
    });
const $d482bbe0b8132b8c$export$80a74e60556dec79 = async ()=>{
    const response = await Promise.resolve((0, $lDo65.userShardMock));
    const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
    return {
        results: nodes.map($d482bbe0b8132b8c$export$cf1f13813d90479a),
        fetchEntitiesRequestId: undefined,
        fetchSpacesRequestId: undefined
    };
};

});
parcelRegister("a5OFf", function(module, exports) {

$parcel$export(module.exports, "isProductSmartlink", () => $4d7a3d27ae0dfe35$export$edde6dcae8734ece);
$parcel$export(module.exports, "OAuthContainer", () => $4d7a3d27ae0dfe35$export$83d3a14acfdb8d27);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dpPtd = parcelRequire("dpPtd");

var $9d9t8 = parcelRequire("9d9t8");

var $hB77E = parcelRequire("hB77E");

var $1yEFx = parcelRequire("1yEFx");

var $auKt6 = parcelRequire("auKt6");

var $5A2fk = parcelRequire("5A2fk");
const $4d7a3d27ae0dfe35$export$edde6dcae8734ece = ({ productKey: productKey, thirdPartyConfigs: thirdPartyConfigs })=>{
    const product3PConfig = productKey && (0, $1yEFx.is3pProductKey)(productKey) ? thirdPartyConfigs[productKey] : null;
    return product3PConfig?.connectorSources?.length === 1 && product3PConfig.connectorSources[0] === (0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE);
};
const $4d7a3d27ae0dfe35$export$83d3a14acfdb8d27 = ({ isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts, isHello: isHello, useOAuthHandlers: useOAuthHandlers })=>{
    let productOrder = [];
    if (isOnSearchDialog) productOrder = [
        (0, $1yEFx.ProductKeys3P).GoogleDrive,
        (0, $1yEFx.ProductKeys3P).Sharepoint,
        (0, $1yEFx.ProductKeys3P).Teams,
        (0, $1yEFx.ProductKeys3P).Slack,
        (0, $1yEFx.ProductKeys3P).Github,
        (0, $1yEFx.ProductKeys3P).Figma,
        (0, $1yEFx.ProductKeys3P).Gitbook
    ];
    else {
        const requiredProducts = [];
        (0, $hB77E.ThirdPartyConfigs).forEach((_, productKey3P)=>{
            if ((0, $hB77E.ThirdPartyConfigs).get(productKey3P)?.requiresOauth) requiredProducts.push(productKey3P);
        });
        // Filter and order the products based on PRODUCTS_ORDER
        productOrder = (0, $1yEFx.PRODUCTS_ORDER).filter((product)=>requiredProducts.includes(product));
    }
    const productsToBeDisplayed = productOrder.filter((product)=>availableProducts.includes(product));
    let displayedProduct;
    let displayedProduct3PConfig;
    for (const product of productsToBeDisplayed){
        const config = thirdPartyConfigs[product];
        if (config && config.userNeedsOAuth && (0, $5A2fk.shouldShowOAuthBanner)(product, isHello)) {
            displayedProduct = product;
            displayedProduct3PConfig = config;
            break;
        }
    }
    const outboundAuthUrl = displayedProduct3PConfig?.oAuthOutboundUrl;
    // a little redundant way of getting this value, but just making use of common function
    const isSmartlink = $4d7a3d27ae0dfe35$export$edde6dcae8734ece({
        productKey: displayedProduct,
        thirdPartyConfigs: thirdPartyConfigs
    });
    return displayedProduct && outboundAuthUrl ? isOnSearchDialog ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $auKt6.OAuthBanner), {
        product: displayedProduct,
        outboundAuthUrl: outboundAuthUrl,
        useOAuthHandlers: useOAuthHandlers,
        isSmartlink: isSmartlink,
        isOnSearchDialog: isOnSearchDialog
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dpPtd.FlagsProvider), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $auKt6.OAuthBanner), {
            product: displayedProduct,
            outboundAuthUrl: outboundAuthUrl,
            useOAuthHandlers: useOAuthHandlers,
            isSmartlink: isSmartlink
        })
    }) : null;
};

});
parcelRegister("auKt6", function(module, exports) {

$parcel$export(module.exports, "OAuthBanner", () => $627ae985e76305b5$export$4177cdcc6454d6f2);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $1yEFx = parcelRequire("1yEFx");

var $h9iS7 = parcelRequire("h9iS7");

var $kllYG = parcelRequire("kllYG");

var $5A2fk = parcelRequire("5A2fk");
const $627ae985e76305b5$var$oauthBannerContainerStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.075',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $627ae985e76305b5$export$4177cdcc6454d6f2 = ({ product: product, outboundAuthUrl: outboundAuthUrl, isOnSearchDialog: isOnSearchDialog, isSmartlink: isSmartlink, useOAuthHandlers: useOAuthHandlers })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const products = (0, $1yEFx.useProductConfigs)();
    const [isDismissed, setIsDismissed] = (0, $gwFzn.useState)(false);
    const productString = product === 'sharepoint' ? 'SharePoint' : products[product]?.displayName || '';
    const Icon = products[product].Icon;
    const showAlternateConnectMessage = product === (0, $1yEFx.ProductKeys).Figma || isSmartlink;
    const { onAuthorize: onAuthorize, onDismiss: onDismiss } = useOAuthHandlers({
        product: product,
        successFlagTitle: formatMessage((0, $kllYG.messages).authorizationSuccess, {
            product: productString
        }),
        failFlagTitle: formatMessage((0, $kllYG.messages).authorizationFail, {
            product: productString
        }),
        outboundAuthUrl: outboundAuthUrl,
        onCompletedAction: ()=>{
            setIsDismissed(true);
        },
        onDismissAction: ()=>{
            setIsDismissed(true);
            (0, $5A2fk.increaseProductDismissCount)(product);
        },
        isOnSearchDialog: isOnSearchDialog
    });
    const title = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...showAlternateConnectMessage ? (0, $kllYG.messages).connectThirdPartyProductTitleAlternate : (0, $kllYG.messages).connectThirdPartyProductTitle,
        values: {
            product: productString
        }
    });
    const description = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...(0, $kllYG.messages).connectThirdPartyProductDescription
    });
    if (isDismissed) return null;
    const messageContent = {
        title: title,
        description: description,
        connectText: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $kllYG.messages).connect
        }),
        MessageIcon: Icon
    };
    const messageProps = {
        content: messageContent,
        onAuthorize: onAuthorize,
        onDismiss: onDismiss
    };
    return isOnSearchDialog ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $627ae985e76305b5$var$oauthBannerContainerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h9iS7.OAuthMessage), {
            ...messageProps,
            isOnSearchDialog: true
        })
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h9iS7.OAuthMessage), {
        ...messageProps
    });
};

});
parcelRegister("h9iS7", function(module, exports) {

$parcel$export(module.exports, "OAuthMessage", () => $52087ab64c3a7923$export$1b25a7895791d4fc);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $7hXDW = parcelRequire("7hXDW");

var $1jfCH = parcelRequire("1jfCH");

var $cwkWT = parcelRequire("cwkWT");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $2W0qg = parcelRequire("2W0qg");

var $5dK2X = parcelRequire("5dK2X");

var $dfZ5P = parcelRequire("dfZ5P");

var $6VHti = parcelRequire("6VHti");
const $52087ab64c3a7923$var$containerBaseStyles = (0, $ecnYn.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'border.radius',
    backgroundColor: 'color.background.neutral'
});
const $52087ab64c3a7923$var$searchResultsContainerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
});
const $52087ab64c3a7923$var$searchDialogContainerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $52087ab64c3a7923$var$searchDialogContainerWithLeftPaddingStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.100',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $52087ab64c3a7923$var$connectPressableStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    paddingInline: 'space.150',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    color: 'color.link',
    ':hover': {
        textDecoration: 'underline',
        color: 'color.link.pressed'
    },
    ':active': {
        textDecoration: 'underline',
        color: 'color.link.pressed'
    },
    whiteSpace: 'nowrap' // so that "Connect" doesn't get broken up needlessly
});
const $52087ab64c3a7923$var$actionsContainer = (0, $ecnYn.xcss)({
    flexBasis: 'fit-content'
});
const $52087ab64c3a7923$export$1b25a7895791d4fc = (props)=>{
    const { content: content, onAuthorize: onAuthorize, onDismiss: onDismiss, isOnSearchDialog: isOnSearchDialog, isBulkConnect: isBulkConnect, testId: testId } = props;
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const ctaButton = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
        onClick: onAuthorize,
        backgroundColor: "color.background.neutral.subtle",
        xcss: $52087ab64c3a7923$var$connectPressableStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
            weight: "medium",
            size: "medium",
            color: "color.link",
            children: content.connectText
        })
    });
    const DismissIcon = isBulkConnect && isOnSearchDialog ? (0, $dfZ5P.RemoveIcon) : (0, (/*@__PURE__*/$parcel$interopDefault($1jfCH)));
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $cwkWT.default), {
        alignItems: "center",
        templateColumns: isBulkConnect ? 'min-content auto 1fr auto' : 'min-content 1fr auto',
        columnGap: isBulkConnect && isOnSearchDialog ? 'space.075' : 'space.150',
        testId: testId,
        xcss: [
            $52087ab64c3a7923$var$containerBaseStyles,
            isOnSearchDialog ? content.iconNeedsPadding ? $52087ab64c3a7923$var$searchDialogContainerWithLeftPaddingStyles : $52087ab64c3a7923$var$searchDialogContainerStyles : $52087ab64c3a7923$var$searchResultsContainerStyles
        ],
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)(content.MessageIcon, {
                size: 'small'
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                space: !isBulkConnect && isOnSearchDialog ? 'space.025' : 'space.050',
                alignBlock: "center",
                shouldWrap: true,
                children: [
                    isOnSearchDialog || isBulkConnect ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                        size: "medium",
                        as: isBulkConnect ? undefined : 'strong',
                        weight: isBulkConnect ? 'medium' : undefined,
                        children: content.title
                    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                        size: "small",
                        children: content.title
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                        size: "medium",
                        color: isOnSearchDialog ? 'color.text.subtle' : undefined,
                        children: content.description
                    })
                ]
            }),
            isBulkConnect && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                testId: testId && `${testId}--actions-cta`,
                alignBlock: "center",
                children: ctaButton
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                testId: testId && `${testId}--actions`,
                space: "space.150",
                rowSpace: "space.0",
                alignBlock: "center",
                xcss: $52087ab64c3a7923$var$actionsContainer,
                children: [
                    !isBulkConnect && ctaButton,
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)(DismissIcon, {
                                ...iconProps,
                                label: "",
                                LEGACY_size: "medium",
                                color: "currentColor"
                            }),
                        onClick: onDismiss,
                        label: formatMessage((0, $6VHti.messages).dismiss),
                        appearance: 'subtle',
                        spacing: 'compact'
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("dfZ5P", function(module, exports) {

$parcel$export(module.exports, "RemoveIcon", () => $89d26229a3844411$export$6382847193091a26);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $89d26229a3844411$export$6382847193091a26 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.185 7.4 12 10.585 8.815 7.399a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.7-.7a.496.496 0 0 0 .004-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.507.507 0 0 0-.36-.153.5.5 0 0 0-.353.15h-.001Z",
            fill: "var(--ds-icon, #44546F)"
        })
    });

});

parcelRegister("6VHti", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1dfe068c1a1bfcd2$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $1dfe068c1a1bfcd2$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    dismiss: {
        id: "oauth-message-dismiss",
        defaultMessage: "Dismiss"
    }
});

});


parcelRegister("kllYG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $270ff42eb089344c$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $270ff42eb089344c$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    authorizationFail: {
        id: "oauth-banner.authorization-fail",
        defaultMessage: "Failed to connect to {product}."
    },
    authorizationSuccess: {
        id: "oauth-banner.authorization-success",
        defaultMessage: "Account connected to {product}."
    },
    connectThirdPartyProductTitle: {
        id: "connect_third_party_product_title",
        defaultMessage: "Your admin has added {product}!"
    },
    connectThirdPartyProductTitleAlternate: {
        id: "connect_third_party_product_title_alternate",
        defaultMessage: "{product} is now available!"
    },
    connectThirdPartyProductDescription: {
        id: "connect_third_party_product_description",
        defaultMessage: "Connect your account to see missing results"
    },
    connect: {
        id: "oauth-message-connect",
        defaultMessage: "Connect"
    }
});

});

parcelRegister("5A2fk", function(module, exports) {

$parcel$export(module.exports, "shouldShowOAuthBanner", () => $c8070074de509682$export$afe8c16e492e553f);
$parcel$export(module.exports, "increaseProductDismissCount", () => $c8070074de509682$export$94f957a0ee1d39c8);
const $c8070074de509682$var$OAUTH_BANNER_DISMISS_KEY = 'atlassian.unified-search.oauth-banner-dismiss-counts';
const $c8070074de509682$export$afe8c16e492e553f = (product, isHello)=>{
    const dismissCounts = $c8070074de509682$var$getLocalStorageData();
    const hasUserDismissedThisProductBefore = (dismissCounts[product] ?? 0) > 0;
    if (isHello) return !(hasUserDismissedThisProductBefore || $c8070074de509682$export$67e3eb5caec4ff4c(dismissCounts));
    return !hasUserDismissedThisProductBefore;
};
/**
 * The max number of times the user dismisses **across products**
 */ const $c8070074de509682$var$MAX_DISMISSALS = 4;
const $c8070074de509682$export$67e3eb5caec4ff4c = (dismissCounts)=>{
    const totalDismissalsAcrossProducts = Object.values(dismissCounts).reduce((prev, curr)=>prev + curr, 0);
    return totalDismissalsAcrossProducts >= $c8070074de509682$var$MAX_DISMISSALS;
};
const $c8070074de509682$export$94f957a0ee1d39c8 = (product)=>{
    const dismissCounts = $c8070074de509682$var$getLocalStorageData();
    dismissCounts[product] = (dismissCounts[product] ?? 0) + 1;
    $c8070074de509682$var$saveToLocalStorage(dismissCounts);
};
/**
 * @returns the local storage object that stores products and their dismiss counts
 */ const $c8070074de509682$var$getLocalStorageData = ()=>{
    const serializedDismissCounts = localStorage.getItem($c8070074de509682$var$OAUTH_BANNER_DISMISS_KEY);
    if (!serializedDismissCounts) return {};
    let localStorageObject;
    try {
        localStorageObject = JSON.parse(serializedDismissCounts);
    } catch (_) {
        return {};
    }
    return localStorageObject;
};
/**
 * Saves the local storage object that stores products and their dismiss counts
 */ const $c8070074de509682$var$saveToLocalStorage = (localStorageObject)=>{
    localStorage.setItem($c8070074de509682$var$OAUTH_BANNER_DISMISS_KEY, JSON.stringify(localStorageObject));
};

});



parcelRegister("lDo65", function(module, exports) {

$parcel$export(module.exports, "userShardMock", () => $823d921a43c527c1$export$6cf111bd7d77355d);
const $823d921a43c527c1$export$6cf111bd7d77355d = {
    data: {
        search: {
            results: {
                edges: [
                    {
                        node: {
                            description: 'Write instead talk prove individual however strategy. So herself difference. Research authority style dark number.',
                            iconUrl: 'https://picsum.photos/691/320',
                            id: '5acc5def-79d4-40ac-8f52-ae46d6831c73',
                            title: 'Southern reach director conference bar.',
                            type: 'page',
                            url: 'http://hicks.com/',
                            __typename: 'SearchConfluencePageBlogAttachment',
                            product: 'confluence',
                            lastModified: '2006-04-04T04:18:40.945099',
                            isVerified: false,
                            space: {
                                id: 'ab59b2b6-589b-4f2e-8d2d-170d16deb5e6',
                                name: 'Cardenas, Bell and Williams',
                                webUiLink: 'categories/app/categories'
                            },
                            socialSignal: {
                                signal: 'comment',
                                timestamp: '2019-08-13T21:01:17.929899',
                                user: {
                                    accountId: '9b283ff5-4969-4b9d-a34d-bd808ee6f0ee',
                                    name: 'Richard Contreras',
                                    picture: 'https://dummyimage.com/450x361',
                                    email: 'angelahahn@example.org',
                                    extendedProfile: {
                                        jobTitle: 'Video editor'
                                    }
                                }
                            },
                            users_viewed: [
                                'd18c7954-52a1-44d1-80f3-75c2939a3c4f',
                                '6acea4a7-216c-4047-b19c-d01b251b17ec',
                                'e291b395-cd37-4c11-8c53-12bf086a6a4f',
                                '4c4fd265-0762-4144-853c-9891aa592aec',
                                '992bb120-3caf-4680-8f59-4106b3749005'
                            ],
                            users_commented: [
                                '2a41863c-9279-48f1-a808-3e2c2f98f0e1',
                                '074d9b19-d8d0-4c0e-a3ce-70630a56cc43',
                                '7872c24c-a7b4-48ba-9f9e-8bb4467133dd',
                                'b9a4ef38-0704-4289-bdc1-d46820bb5ff1',
                                '91fd1340-d1f0-4b7b-a2c9-44960ce3062e'
                            ],
                            user_edited: [
                                'd7f7b4a6-509b-42f5-a5ff-c647b4d736c9',
                                'ddf897f1-c28a-4a87-9ca6-bc3ca146868b',
                                '2c025aad-a99d-4a57-8a38-f21b026e1e4a',
                                '0b682e46-31f3-4ec6-8ba1-c34a31cb3822',
                                '9850ce5d-8fd0-4485-9dc3-9e1b04b177d6'
                            ],
                            confluenceEntity: {
                                ancestors: [
                                    {
                                        id: 'da24cfeb-7bc9-40bd-bac2-d3444e011a95',
                                        title: 'Building free share must role.',
                                        links: {
                                            webUi: 'wp-content/category/main'
                                        }
                                    },
                                    {
                                        id: '6c89b66c-4c22-4484-bccf-e1dd8593734e',
                                        title: 'Congress institution where better now stop actually.',
                                        links: {
                                            webUi: 'blog'
                                        }
                                    }
                                ],
                                metadata: {
                                    titleEmojiPublished: {
                                        id: null,
                                        value: null
                                    }
                                },
                                commentCountSummary: {
                                    total: 97
                                },
                                likesSummary: {
                                    count: 27
                                }
                            }
                        }
                    },
                    {
                        node: {
                            description: 'Probably upon sing short out do. Behavior increase southern long agree address risk us.',
                            iconUrl: 'https://placekitten.com/986/579',
                            id: '7bc0f818-ad94-4cbd-b88c-ff8b49b06610',
                            title: 'Heart maintain learn despite mouth clearly seem.',
                            type: 'gdoc_document',
                            url: 'http://www.davis-ruiz.com/',
                            __typename: 'SearchResultGoogleDocument',
                            product: 'google',
                            lastModified: '1995-01-15T11:05:46.063993',
                            isVerified: true,
                            space: {
                                id: 'a09eb82a-639e-41e4-8e21-8b921c352762',
                                name: 'Davis-Andrews',
                                webUiLink: 'tag/app'
                            },
                            socialSignal: {
                                signal: 'comment',
                                timestamp: '1990-06-21T02:48:25.697280',
                                user: {
                                    accountId: '848f760f-d398-41eb-ac62-eb47ec2448be',
                                    name: 'Sarah Foley',
                                    picture: 'https://dummyimage.com/683x208',
                                    email: 'rodney86@example.org',
                                    extendedProfile: {
                                        jobTitle: 'Energy manager'
                                    }
                                }
                            },
                            users_viewed: [
                                'ebda7fa5-dd22-4b2b-91fb-273727b80d4f',
                                '02e50818-734e-4118-8fae-b756f41490af',
                                '90f28367-962c-41fc-866b-9f2ce0e59ff7',
                                'e3008455-4e68-4f03-9588-607a611c5a44',
                                '7391fb8e-d99c-477e-91e2-f673c1aeec0c'
                            ],
                            users_commented: [
                                '833dc991-5548-4b89-8db6-3563bd6ad67c',
                                '42ffad7c-c67b-4f8a-ba38-6623d1c77008',
                                '1fa026ba-84ee-47f7-a7ad-578d816f69b5',
                                '635f46fb-64ca-4932-a7df-942ef9116455',
                                'ee33c5c2-4992-4506-95e1-920de4c6da3d'
                            ],
                            user_edited: [
                                '3a059892-9c26-465f-a5d9-64436247517d',
                                '086f550d-2c78-46ce-b66a-3cbe2cf5dbca',
                                'a51e9325-41d2-4923-8c53-905f88092c78',
                                '32749082-f541-47d2-a349-318375d2d7c9',
                                '5b5651ef-0e1a-496f-8e88-7bcf0960cee6'
                            ],
                            googleDocEntity: []
                        }
                    },
                    {
                        node: {
                            description: 'Effort modern thing college. His result couple vote act city. Material rate deep finish.\nMaybe sport upon. Somebody factor require class fund. Him he cost door organization however effect.',
                            iconUrl: 'https://placekitten.com/936/487',
                            id: 'b312225a-f5f7-4c6a-b41a-5a947dca56bb',
                            title: 'Music bit test opportunity four.',
                            type: 'page',
                            url: 'http://bonilla.net/',
                            __typename: 'SearchConfluencePageBlogAttachment',
                            product: 'confluence',
                            lastModified: '2010-05-26T18:03:36.431642',
                            isVerified: false,
                            space: {
                                id: '44538462-d330-40d6-a9bd-d7d8b25305bd',
                                name: 'Richardson-Perry',
                                webUiLink: 'tag'
                            },
                            socialSignal: {
                                signal: 'comment',
                                timestamp: '1988-02-04T09:02:52.372568',
                                user: {
                                    accountId: '3cef5fb2-d266-4fa8-b412-b8bf2100f9de',
                                    name: 'Andrew Bradley',
                                    picture: 'https://placekitten.com/930/981',
                                    email: 'rhondagates@example.net',
                                    extendedProfile: {
                                        jobTitle: 'Production manager'
                                    }
                                }
                            },
                            users_viewed: [
                                '37bd8038-2c6e-4831-bd87-489929f39956',
                                '6d0609cc-7431-4ee7-87f1-f562cac0cfed',
                                'bb0c92db-8435-4c7e-a595-0f7240b1b03d',
                                '6cc0acbe-0862-49f6-a97b-4c6d8e3a0cbc',
                                '947ff689-cbf6-4110-97d8-f1bfb6eab5d5'
                            ],
                            users_commented: [
                                'f28f50b7-9681-4c6f-abcf-0aede1e5e510',
                                'e70104cf-5a38-40f8-a91c-6eacbd77a56e',
                                '7d67ba23-0d34-4efe-99c2-afafd58b3e5e',
                                '2c1d666d-a6fe-43bc-9cf8-7d1c41487de5',
                                'bbdbb39b-a98f-4925-a7db-7c631d04d26a'
                            ],
                            user_edited: [
                                '38a2cf95-bfae-4654-9a4d-741d7f8e3400',
                                '9b40e3fb-0a83-47aa-9b6a-f390862302f1',
                                '51fc97fa-3409-44a1-a90b-a3883aecc345',
                                '79b44666-390a-4534-ad8c-c7c01d10fb5a',
                                '53df2510-6207-47bf-8b35-d1ab47245cb0'
                            ],
                            confluenceEntity: {
                                ancestors: [
                                    {
                                        id: '6a41be89-d3cc-4af7-8ec3-96a5386642f5',
                                        title: 'Group example second information statement.',
                                        links: {
                                            webUi: 'blog'
                                        }
                                    },
                                    {
                                        id: '68a3c9af-132c-4262-8f78-ab19841f0164',
                                        title: 'Personal all interest society behavior person.',
                                        links: {
                                            webUi: 'list/blog/app'
                                        }
                                    }
                                ],
                                metadata: {
                                    titleEmojiPublished: {
                                        id: null,
                                        value: null
                                    }
                                },
                                commentCountSummary: {
                                    total: 72
                                },
                                likesSummary: {
                                    count: 1
                                }
                            }
                        }
                    },
                    {
                        node: {
                            description: 'Member growth will if. They experience challenge enough. Brother sound realize fast.\nSong plant anything medical.',
                            iconUrl: 'https://placekitten.com/151/653',
                            id: '5c46b39b-a668-41d0-92df-012eac9e138f',
                            title: 'Hot read painting policy environmental.',
                            type: 'gdoc_document',
                            url: 'https://www.brooks-osborne.com/',
                            __typename: 'SearchResultGoogleDocument',
                            product: 'google',
                            lastModified: '2004-09-19T18:19:21.096056',
                            isVerified: true,
                            space: {
                                id: '863891d4-e0a9-4145-82cd-53545e02bb2d',
                                name: 'Johnson and Sons',
                                webUiLink: 'blog'
                            },
                            socialSignal: {
                                signal: 'comment',
                                timestamp: '2008-03-03T12:49:25.101438',
                                user: {
                                    accountId: '105d2bd6-29e3-4208-96a9-146286d6630f',
                                    name: 'Jason Garcia',
                                    picture: 'https://dummyimage.com/494x74',
                                    email: 'mike20@example.org',
                                    extendedProfile: {
                                        jobTitle: 'Field trials officer'
                                    }
                                }
                            },
                            users_viewed: [
                                '961f188b-d0fe-4f39-b5fa-a9fab3c5cc4b',
                                '7ac03ca9-c40e-4abc-869f-46431b6205bb',
                                'cfe88c6d-0a50-499e-a64e-de69d13fe94a',
                                '38039b13-6599-406f-9bea-9570fc58ca95',
                                'e1df89c4-bd94-4d67-ab26-aba538212ebb'
                            ],
                            users_commented: [
                                '1e53b7b5-acb4-4ee8-80b1-7a9d12a2ff43',
                                '851f91fd-e9d8-4800-9caa-9b5a1239c65c',
                                '8e0ce91a-330c-427c-ba9a-2f222498d550',
                                'd7090eae-6301-402b-8c9c-a5221bbe6c2a',
                                '7464f611-5d04-41b1-8a6e-394de940bc0d'
                            ],
                            user_edited: [
                                '7a1ddde1-ff48-4a28-82e2-5097a45d6aa3',
                                'c06da3f2-7e4b-4105-b916-7879de52f690',
                                'de43c9f6-6463-4cce-9a04-bd6188878f31',
                                '8f1620f5-3bf6-480f-a62c-97a080301840',
                                'accf2adb-af6c-4e4e-9dd2-d37d0843b192'
                            ],
                            googleDocEntity: []
                        }
                    },
                    {
                        node: {
                            description: 'Example while glass else unit. Pass play wife hundred heavy.\nFeeling see behavior southern already some work they. At bit head administration seek amount.',
                            iconUrl: 'https://dummyimage.com/622x468',
                            id: '46d468f8-348b-4a43-92bb-04d7fbc857b3',
                            title: 'Receive window often box.',
                            type: 'gdoc_document',
                            url: 'http://www.dillon.com/',
                            __typename: 'SearchResultGoogleDocument',
                            product: 'google',
                            lastModified: '2000-05-02T23:30:56.447866',
                            isVerified: false,
                            space: {
                                id: 'c0e21975-ce5e-4edd-a0a0-8786cef6c63c',
                                name: 'Green and Sons',
                                webUiLink: 'tags/category'
                            },
                            socialSignal: {
                                signal: 'comment',
                                timestamp: '1978-02-16T23:04:15.102121',
                                user: {
                                    accountId: '2f4d4944-7414-4eae-a2c5-0af0d7163de1',
                                    name: 'Anthony Barton',
                                    picture: 'https://placekitten.com/838/568',
                                    email: 'julia92@example.org',
                                    extendedProfile: {
                                        jobTitle: 'Oceanographer'
                                    }
                                }
                            },
                            users_viewed: [
                                '137661fb-56c9-4ced-af69-0be68c7068e8',
                                '198815d1-6e0d-477f-99d5-e3078c03af34',
                                '9aa16d7b-58b9-49e8-a28f-3792c02ecfff',
                                'e718aec4-d6c2-41e5-9b46-6bffe9234474',
                                '174a4d14-df8a-4274-a073-f1680daaa0eb'
                            ],
                            users_commented: [
                                '0064ca05-61c3-46f3-a335-e73f0a6ae728',
                                'c70237db-90e5-40d5-b356-8718f37e669b',
                                'a8076405-3c1d-4f4d-9012-e0bbedf10d8f',
                                '684a7b9e-dfd2-4329-94e0-b25792a4ea7b',
                                'a7e49dee-7d37-41b6-be8b-d05f60c315f8'
                            ],
                            user_edited: [
                                'e5e45afd-c7f9-4665-8969-c8c7da938b2d',
                                'ec996965-4ca7-4037-9e29-ba0f45dd5e0f',
                                '81751370-a21d-4751-9a5b-f9d2a0867b3e',
                                '9c00622a-6f7f-4861-ac97-3358cb4e2850',
                                '73543537-c543-494a-9876-4b3ecf9ff4ca'
                            ],
                            googleDocEntity: []
                        }
                    },
                    {
                        node: {
                            description: 'Mention break southern phone work. Network marriage hold way country church.\nHappy sea hotel serious finally next.\nIt give who.\nInstead thousand lawyer according care.',
                            iconUrl: 'https://placekitten.com/350/291',
                            id: '00579406-d861-4122-83a0-bbb423f95b14',
                            title: 'Stay wind computer control star career range.',
                            type: 'page',
                            url: 'http://carter-flores.info/',
                            __typename: 'SearchConfluencePageBlogAttachment',
                            product: 'confluence',
                            lastModified: '2016-07-17T15:51:11.675432',
                            isVerified: true,
                            space: {
                                id: '6b128d94-ce67-4448-9be2-b52d0da5f269',
                                name: 'Rodriguez-Doyle',
                                webUiLink: 'wp-content'
                            },
                            socialSignal: {
                                signal: 'comment',
                                timestamp: '2015-05-01T06:23:48.066278',
                                user: {
                                    accountId: '57d8845c-21cc-49a8-be97-3ba36068090c',
                                    name: 'Christopher Gonzalez',
                                    picture: 'https://dummyimage.com/2x1012',
                                    email: 'iramos@example.com',
                                    extendedProfile: {
                                        jobTitle: 'Television production assistant'
                                    }
                                }
                            },
                            users_viewed: [
                                '1d35dd66-6ad2-4b2f-96c6-8ba70f14cff5',
                                'f87c3dba-d909-40d4-b685-68a4e9426887',
                                '91182508-a548-457d-8ea4-8c9f2d3cfca0',
                                '654f1539-663c-434f-bbdb-8886d78f4328',
                                '51bdf189-8ab0-4904-aee0-34fb44a91dea'
                            ],
                            users_commented: [
                                '7a0302ce-7ef2-4464-bc09-042049430c40',
                                'bca173b4-9567-4348-9bd5-ce873d2c8a15',
                                '47b0c102-25a6-40d4-b4c7-6c39c1fde4f2',
                                '67853ce0-8a04-4b4b-8271-d6db3aa3728b',
                                '324539eb-7fb9-4f6d-b1da-fecfbaa2b375'
                            ],
                            user_edited: [
                                '6666e520-a652-4209-b2a8-6214d3bd10dd',
                                'c0637267-2896-4833-a3a7-59906fc8b753',
                                'f98e9ad2-f9a0-4c4a-9d49-064b52c9070b',
                                'f3b85911-3dac-4a0d-9cff-f90b84c62ae2',
                                '02304ebb-e870-4e80-8611-44869668f504'
                            ],
                            confluenceEntity: {
                                ancestors: [
                                    {
                                        id: '4a1205f3-5391-4fa1-954c-ed39f5ade15b',
                                        title: 'Dog young benefit improve girl.',
                                        links: {
                                            webUi: 'categories'
                                        }
                                    },
                                    {
                                        id: '5be5cb73-af2e-4c24-9a3d-d16bfe0dc928',
                                        title: 'Lose nor ready same develop if.',
                                        links: {
                                            webUi: 'wp-content'
                                        }
                                    }
                                ],
                                metadata: {
                                    titleEmojiPublished: {
                                        id: null,
                                        value: null
                                    }
                                },
                                commentCountSummary: {
                                    total: 8
                                },
                                likesSummary: {
                                    count: 44
                                }
                            }
                        }
                    }
                ],
                queryInfo: null,
                abTest: {
                    abTestId: 'no_ab_test_id',
                    controlId: 'L1-OS-3recalllimitknn_L2-3pdocprod___QR-cloudberry',
                    experimentId: 'L1-OS-3recalllimitknn_L2-3pdocprod___QR-cloudberry'
                },
                totalCount: 1318761,
                totalCounts: [
                    {
                        product: 'confluence',
                        count: 1318761
                    }
                ],
                pageInfo: {
                    endCursor: '5388cd59-45ed-40c8-991d-b7546e1dd79e'
                }
            }
        }
    },
    extensions: {
        gateway: {
            request_id: '82bca72a-4471-4bed-ae6c-ff9ccb99b727',
            crossRegion: false,
            edgeCrossRegion: false
        }
    }
};

});


parcelRegister("cA4A0", function(module, exports) {

$parcel$export(module.exports, "getRecentQueries", () => $1435b53be5ab4d50$export$d6415f081f333b17);

var $1SV4e = parcelRequire("1SV4e");
const $1435b53be5ab4d50$export$d6415f081f333b17 = (primaryProduct, userId)=>{
    const recentSearches = (0, $1SV4e.getRecentSearches)(userId, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
    return recentSearches.map($1435b53be5ab4d50$export$cf1f13813d90479a);
};
const $1435b53be5ab4d50$export$cf1f13813d90479a = (query)=>({
        id: query,
        title: query,
        data: query,
        type: 'recent-query'
    });

});
parcelRegister("1SV4e", function(module, exports) {

$parcel$export(module.exports, "RECENT_SEARCH_KEY", () => $8ca6facece17d017$export$ec4722d39a5031c0);
$parcel$export(module.exports, "addRecentSearch", () => $8ca6facece17d017$export$74e99d9695eabee6);
$parcel$export(module.exports, "getRecentSearches", () => $8ca6facece17d017$export$1216255791599668);
$parcel$export(module.exports, "removeRecentSearch", () => $8ca6facece17d017$export$6adb2cc1366d1e30);
const $8ca6facece17d017$export$ec4722d39a5031c0 = 'atlassian.unified-search.recent-searches';
const $8ca6facece17d017$export$c1b7badf23670c19 = 50;
const $8ca6facece17d017$export$74e99d9695eabee6 = (value, userId, product, recentSearchKey)=>{
    const recentSearchesRaw = $8ca6facece17d017$var$getLocalStorageItem(recentSearchKey);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    if (!recentSearches[userId]) recentSearches[userId] = {};
    let userSearches = recentSearches[userId];
    if (!userSearches[product]) userSearches[product] = [];
    let productSearches = userSearches[product];
    const trimmedValue = value.trim();
    // Pop the last value of the array if it is too long
    if (productSearches.length === $8ca6facece17d017$export$c1b7badf23670c19) productSearches.pop();
    // If the given value is a duplicate, remove it from the array
    if (productSearches.includes(trimmedValue)) productSearches = productSearches.filter((v)=>v !== trimmedValue);
    productSearches.unshift(trimmedValue);
    recentSearches[userId][product] = productSearches;
    $8ca6facece17d017$var$setLocalStorageItem(recentSearchKey, JSON.stringify(recentSearches));
};
const $8ca6facece17d017$export$1216255791599668 = (userId, product, recentSearchKey)=>{
    const recentSearchesRaw = $8ca6facece17d017$var$getLocalStorageItem(recentSearchKey);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    const userSearches = recentSearches[userId] || {};
    return userSearches[product] || [];
};
const $8ca6facece17d017$export$6adb2cc1366d1e30 = (value, userId, product, recentSearchKey)=>{
    const recentSearchesRaw = $8ca6facece17d017$var$getLocalStorageItem(recentSearchKey);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    if (!recentSearches[userId] || !recentSearches[userId][product]) return [];
    recentSearches[userId][product] = recentSearches[userId][product].filter((v)=>v !== value);
    $8ca6facece17d017$var$setLocalStorageItem(recentSearchKey, JSON.stringify(recentSearches));
    return recentSearches[userId][product];
};
const $8ca6facece17d017$var$setLocalStorageItem = (key, value)=>{
    window.localStorage.setItem(key, value);
};
const $8ca6facece17d017$var$getLocalStorageItem = (key)=>{
    return window.localStorage.getItem(key);
};

});


parcelRegister("6CCNp", function(module, exports) {

$parcel$export(module.exports, "getQuickFindContent", () => $2bb736a7e62c9305$export$35ead133d529e85e);
const $2bb736a7e62c9305$var$preQueryErrorHandler = ({ query: query, selectedQueryFilters: selectedQueryFilters, preQueryError: preQueryError, postQueryDisabled: postQueryDisabled })=>{
    const hasQuery = query || selectedQueryFilters.length > 0;
    if ((!hasQuery || postQueryDisabled) && preQueryError) return {
        state: 'PREQUERY_ERROR',
        query: ''
    };
};
const $2bb736a7e62c9305$var$preQueryLoadingHandler = ({ query: query, selectedQueryFilters: selectedQueryFilters, preQueryLoading: preQueryLoading, filteredRecentQueries: filteredRecentQueries, postQueryDisabled: postQueryDisabled })=>{
    const hasQuery = query || selectedQueryFilters.length > 0;
    if ((!hasQuery || postQueryDisabled) && preQueryLoading) return {
        state: 'PREQUERY_LOADING',
        query: '',
        recentQueries: filteredRecentQueries
    };
};
const $2bb736a7e62c9305$var$preQueryNoResultsHandler = ({ query: query, selectedQueryFilters: selectedQueryFilters, filteredRecentActivities: filteredRecentActivities, postQueryDisabled: postQueryDisabled })=>{
    const hasQuery = query || selectedQueryFilters.length > 0;
    const totalResults = filteredRecentActivities.result.length;
    if ((!hasQuery || postQueryDisabled) && totalResults === 0) return {
        state: 'PREQUERY_NO_RESULTS',
        query: ''
    };
};
const $2bb736a7e62c9305$var$preQueryResultsHandler = ({ query: query, selectedQueryFilters: selectedQueryFilters, filteredRecentQueries: filteredRecentQueries, filteredRecentActivities: filteredRecentActivities, postQueryDisabled: postQueryDisabled })=>{
    const hasQuery = query || selectedQueryFilters.length > 0;
    const totalResults = filteredRecentActivities.result.length;
    if ((!hasQuery || postQueryDisabled) && totalResults > 0) return {
        state: 'PREQUERY_RESULTS',
        query: '',
        recentQueries: filteredRecentQueries,
        recentActivities: filteredRecentActivities.result
    };
};
const $2bb736a7e62c9305$var$postQueryErrorHandler = ({ query: query, selectedQueryFilters: selectedQueryFilters, postQueryError: postQueryError, postQueryDisabled: postQueryDisabled })=>{
    const hasQuery = query || selectedQueryFilters.length > 0;
    if (hasQuery && !postQueryDisabled && postQueryError) return {
        state: 'POSTQUERY_ERROR',
        query: query || ''
    };
};
const $2bb736a7e62c9305$var$postQueryLoadingHandler = ({ query: query, selectedQueryFilters: selectedQueryFilters, postQueryLoading: postQueryLoading, filteredRecentActivities: filteredRecentActivities, postQueryDisabled: postQueryDisabled })=>{
    const hasQuery = query || selectedQueryFilters.length > 0;
    if (hasQuery && !postQueryDisabled && postQueryLoading) return {
        state: 'POSTQUERY_LOADING',
        query: query || '',
        recentActivities: filteredRecentActivities.result
    };
};
const $2bb736a7e62c9305$var$postQueryNoResultsHandler = ({ query: query, selectedQueryFilters: selectedQueryFilters, searchResults: searchResults, peopleAndTeams: peopleAndTeams, postQueryDisabled: postQueryDisabled })=>{
    const hasQuery = query || selectedQueryFilters.length > 0;
    const totalResults = searchResults.result.length + peopleAndTeams.result.length;
    if (hasQuery && !postQueryDisabled && totalResults === 0) return {
        state: 'POSTQUERY_NO_RESULTS',
        query: query || ''
    };
};
const $2bb736a7e62c9305$var$postQueryResultsHandler = ({ query: query, selectedQueryFilters: selectedQueryFilters, filteredRecentQueries: filteredRecentQueries, filteredRecentActivities: filteredRecentActivities, searchResults: searchResults, peopleAndTeams: peopleAndTeams, postQueryDisabled: postQueryDisabled })=>{
    const hasQuery = query || selectedQueryFilters.length > 0;
    const totalResults = searchResults.result.length + peopleAndTeams.result.length;
    if (hasQuery && !postQueryDisabled && totalResults > 0) return {
        state: 'POSTQUERY_RESULTS',
        query: query || '',
        recentQueries: filteredRecentQueries,
        recentActivities: filteredRecentActivities.result,
        searchResults: searchResults.result,
        peopleAndTeams: peopleAndTeams.result
    };
};
const $2bb736a7e62c9305$export$35ead133d529e85e = (args)=>{
    if (!args.quickFindOpen) return;
    const handlers = [
        $2bb736a7e62c9305$var$preQueryErrorHandler,
        $2bb736a7e62c9305$var$preQueryLoadingHandler,
        $2bb736a7e62c9305$var$preQueryNoResultsHandler,
        $2bb736a7e62c9305$var$preQueryResultsHandler,
        $2bb736a7e62c9305$var$postQueryErrorHandler,
        $2bb736a7e62c9305$var$postQueryLoadingHandler,
        $2bb736a7e62c9305$var$postQueryNoResultsHandler,
        $2bb736a7e62c9305$var$postQueryResultsHandler
    ];
    for (const handler of handlers){
        const result = handler(args);
        if (result) return result;
    }
    // This should never happen, but default to error state
    if (!args.query) return {
        state: 'PREQUERY_ERROR',
        query: ''
    };
    else return {
        state: 'POSTQUERY_ERROR',
        query: args.query
    };
};

});


parcelRegister("2tzUc", function(module, exports) {

$parcel$export(module.exports, "BootstrapStoreProvider", () => $d178f4c20cce9572$export$8a525a626086c807);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $dbl1i = parcelRequire("dbl1i");
var $gkXKl = parcelRequire("gkXKl");
var $hm6w9 = parcelRequire("hm6w9");
var $iA4lt = parcelRequire("iA4lt");

var $1yEFx = parcelRequire("1yEFx");

var $NwuTK = parcelRequire("NwuTK");

var $4U2Rj = parcelRequire("4U2Rj");

var $embLz = parcelRequire("embLz");
parcelRequire("1nJM3");
var $f8oYd = parcelRequire("f8oYd");

var $j4ply = parcelRequire("j4ply");
const $d178f4c20cce9572$export$8a525a626086c807 = ({ children: children, ...props })=>{
    const { cloudId: cloudId, configFetchAbsoluteUrl: configFetchAbsoluteUrl, user: user, thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, SAINHostName: SAINHostName, aggregatorHostName: aggregatorHostName, orgId: orgId, analyticsAttributes: analyticsAttributes, products: products, queryParams: queryParams, features: features, searchSessionId: searchSessionId, callbacks: callbacks, statsigLayer: statsigLayer, experimentLayers: experimentLayers, isSSR: isSSR } = props;
    const { accessibleProducts: accessibleProducts, accessibleNouns: accessibleNouns, thirdPartyConfigs: thirdPartyConfigs, firstCloudId: firstCloudId, intercomHmac: intercomHmac, isNounsAvailable: isNounsAvailable, isRovoEnabled: isRovoEnabled, productEdition: productEdition, productDataRegions: productDataRegions, rovoFeatures: rovoFeatures, isConfigLoaded: isConfigLoaded } = (0, $embLz.useFetchConfig)({
        cloudId: cloudId,
        configFetchAbsoluteUrl: configFetchAbsoluteUrl,
        aggregatorHostName: aggregatorHostName,
        userId: user?.id,
        thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl,
        primaryProduct: primaryProduct
    });
    const onError = (0, $f8oYd.useLogException)();
    const experimentConfig = (0, $gwFzn.useMemo)(()=>{
        const enableNonOverlappingBEExperimentDomain = (0, $dh538.fg)('search_platform_non_overlapping_domain');
        const { frontendExperiment: frontendExperiment, backendExperiment: backendExperiment, isMutuallyExclusive: isMutuallyExclusive } = (0, $gkXKl.getBackendExperimentsWithOverrides)(features?.sideBySide?.experiments, statsigLayer, onError, true);
        const exampleFrontendExperiment = (0, $iA4lt.getFrontendExperiment)({
            abTestId: 'fe_search_experiment'
        });
        const nonOverlappingBackendExperiment = enableNonOverlappingBEExperimentDomain ? (0, $hm6w9.getBackendNonOverlappingDomainLayerValues)() : undefined;
        return {
            isMutuallyExclusive: isMutuallyExclusive,
            backendExperiment: backendExperiment,
            frontendExperiments: {
                // the frontend experiment that's mutually exclusive to other BE and FE experiments
                ...frontendExperiment?.abTestId && {
                    [frontendExperiment.abTestId]: frontendExperiment
                },
                // add other frontend experiments that can be run alongside backend experiments here
                // NOTE: these aren't mutually exclusive to other BE or FE experiments
                [exampleFrontendExperiment.abTestId]: exampleFrontendExperiment
            },
            dynamicExperiments: (0, $dbl1i.dynamicExperimentsSchema).safeParse(experimentLayers).data,
            nonOverlappingBackendExperiment: nonOverlappingBackendExperiment
        };
    }, [
        experimentLayers,
        features?.sideBySide?.experiments,
        onError,
        statsigLayer
    ]);
    const allFilterExcludedProducts = (0, $gwFzn.useMemo)(()=>[
            (0, $1yEFx.ProductKeys).Trello,
            (0, $1yEFx.ProductKeys).Gmail,
            (0, $1yEFx.ProductKeys).OutlookMail
        ], []);
    const getInitialProps = (0, $gwFzn.useCallback)(()=>{
        let storeContainerInitialProps = {
            cloudId: cloudId ?? firstCloudId,
            aggAbsoluteUrl: aggAbsoluteUrl,
            SAINHostName: SAINHostName,
            aggregatorHostName: aggregatorHostName,
            user: user,
            primaryProduct: primaryProduct,
            orgId: orgId,
            analyticsAttributes: analyticsAttributes,
            features: features,
            experimentConfig: experimentConfig,
            intercomHmac: intercomHmac,
            isNounsAvailable: isNounsAvailable,
            isRovoEnabled: isRovoEnabled,
            isConfigLoaded: isConfigLoaded,
            products: (0, $NwuTK.getAccessibleProducts)({
                supportedProducts: (0, $1yEFx.allProductKeys),
                products: products,
                accessibleProducts: accessibleProducts
            }),
            nouns: accessibleNouns,
            allFilterExcludedProducts: allFilterExcludedProducts,
            productEdition: productEdition,
            productDataRegions: productDataRegions,
            rovoFeatures: rovoFeatures
        };
        if (searchSessionId) storeContainerInitialProps.searchSessionId = searchSessionId;
        if (accessibleProducts) storeContainerInitialProps.thirdPartyConfigs = thirdPartyConfigs;
        return storeContainerInitialProps;
    }, [
        cloudId,
        firstCloudId,
        aggAbsoluteUrl,
        SAINHostName,
        aggregatorHostName,
        user,
        primaryProduct,
        orgId,
        analyticsAttributes,
        features,
        experimentConfig,
        intercomHmac,
        isNounsAvailable,
        isRovoEnabled,
        isConfigLoaded,
        products,
        accessibleProducts,
        accessibleNouns,
        allFilterExcludedProducts,
        productEdition,
        productDataRegions,
        searchSessionId,
        thirdPartyConfigs,
        rovoFeatures
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $j4ply.BootstrapStoreContainer), {
                initialProps: getInitialProps(),
                queryParams: queryParams,
                queryParamsCallback: callbacks?.updateQueryParameters,
                getSpaceIdsFromSpaceKeys: callbacks?.getSpaceIdsFromSpaceKeys,
                children: children
            }),
            !isSSR && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4U2Rj.UpdateBulkConnectLocalStorage), {
                accessibleProducts: accessibleProducts,
                isConfigLoaded: isConfigLoaded
            })
        ]
    });
};

});
parcelRegister("dbl1i", function(module, exports) {

$parcel$export(module.exports, "dynamicExperimentsSchema", () => $de7a36fee3572948$export$4b5312b6cfd0d20a);

var $2ci8P = parcelRequire("2ci8P");
const $de7a36fee3572948$var$experimentExperienceEnum = (0, $2ci8P.z).enum([
    'search-page',
    'quick-find',
    'search-page-space-filter',
    'quick-search',
    'advanced-search'
]);
const $de7a36fee3572948$export$b2d47fe90e426516 = (0, $2ci8P.z).string().transform((str, ctx)=>{
    try {
        return JSON.parse(str);
    } catch (e) {
        ctx.addIssue({
            code: 'custom',
            message: 'Invalid JSON'
        });
        return (0, $2ci8P.z).NEVER;
    }
}).pipe((0, $2ci8P.z).object({
    layerType: (0, $2ci8P.z).string().startsWith('search_platform_layer_').optional(),
    statsigLayerId: (0, $2ci8P.z).string().startsWith('search_platform_'),
    entity: (0, $2ci8P.z).string().optional(),
    subEntity: (0, $2ci8P.z).string().optional(),
    hello: (0, $2ci8P.z).boolean().optional(),
    confluenceTier: (0, $2ci8P.z).string().array().optional(),
    productDataRegions: (0, $2ci8P.z).record((0, $2ci8P.z).string(), (0, $2ci8P.z).string().array()).optional(),
    experiences: $de7a36fee3572948$var$experimentExperienceEnum.array().optional(),
    tenantIds: (0, $2ci8P.z).string().array().optional()
}));
const $de7a36fee3572948$export$4b5312b6cfd0d20a = (0, $2ci8P.z).array((0, $2ci8P.z).string()).transform((arrayJSONStrings)=>{
    return arrayJSONStrings.map((jsonStr)=>$de7a36fee3572948$export$b2d47fe90e426516.safeParse(jsonStr).data).flatMap((dynamicConfig)=>dynamicConfig ? dynamicConfig : []);
}).refine((dynamicConfig)=>dynamicConfig.length); // The schema is invalid if all JSON strings are invalid

});

parcelRegister("4U2Rj", function(module, exports) {

$parcel$export(module.exports, "UpdateBulkConnectLocalStorage", () => $4692372338c5c26e$export$35d561c6d0f4f45);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $1yEFx = parcelRequire("1yEFx");

var $f2dRI = parcelRequire("f2dRI");

var $d5Ozh = parcelRequire("d5Ozh");

var $dsrEB = parcelRequire("dsrEB");
const $4692372338c5c26e$export$35d561c6d0f4f45 = /*#__PURE__*/ (0, $gwFzn.memo)(({ accessibleProducts: accessibleProducts, isConfigLoaded: isConfigLoaded })=>{
    // eslint-disable-next-line @atlassian/search-common/no-use-local-storage
    const [localStorageState, setLocalStorageState] = (0, $d5Ozh.useLocalStorageSearchPagePersistedState)();
    (0, $gwFzn.useEffect)(()=>{
        if (!isConfigLoaded) return;
        if ((0, $dh538.fg)('3p_bulk_connect')) {
            const thirdPartyProductKeys = accessibleProducts?.filter((product)=>(0, $1yEFx.is3pProductKey)(product)) || [];
            const currentTime = Date.now().toString();
            let hasNewProducts = false;
            const newState = {
                ...localStorageState,
                previous3pProducts: localStorageState?.previous3pProducts ?? {}
            };
            if (!localStorageState || !localStorageState.previous3pProducts) {
                // Local storage does not store this information yet. We assume this is the first time a user is seeing these products, and store all products with current timestamp
                newState.previous3pProducts = thirdPartyProductKeys.reduce((acc, product)=>({
                        ...acc,
                        [product]: currentTime
                    }), {});
                hasNewProducts = true;
            } else {
                // Compare with previous state and store newly visible products with current timestamp, while keeping the previous timestamps for existing products
                const previous3pProducts = (0, $dsrEB.isProductKeyWithTimestampMap)(localStorageState.previous3pProducts) ? localStorageState.previous3pProducts : {};
                thirdPartyProductKeys.forEach((product)=>{
                    if (!(0, $1yEFx.is3pProductKey)(product)) return;
                    if (!previous3pProducts[product]) {
                        newState.previous3pProducts[product] = currentTime;
                        hasNewProducts = true;
                    } else newState.previous3pProducts[product] = previous3pProducts[product];
                });
            }
            if (hasNewProducts) // if there are new products, we need to reset the secondary banner dismissal state
            newState.bulkConnectBanner = {
                ...localStorageState?.bulkConnectBanner || (0, $f2dRI.DEFAULT_BULK_CONNECT_BANNER_STATE),
                secondaryBannerDismissed: false
            };
            setLocalStorageState(newState);
        }
    }, [
        accessibleProducts,
        isConfigLoaded,
        localStorageState,
        setLocalStorageState
    ]);
    return null;
});

});
parcelRegister("f2dRI", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_BULK_CONNECT_BANNER_STATE", () => $e32b2ca45b3e5cab$export$f43a15fa94a98f93);
$parcel$export(module.exports, "useBulkConnectBanner", () => $e32b2ca45b3e5cab$export$96f3857cd44a8432);

var $gwFzn = parcelRequire("gwFzn");

var $1yEFx = parcelRequire("1yEFx");

var $gweXX = parcelRequire("gweXX");
const $e32b2ca45b3e5cab$export$f43a15fa94a98f93 = {
    initialBannerDismissed: false,
    secondaryBannerDismissed: false
};
const $e32b2ca45b3e5cab$export$96f3857cd44a8432 = ({ thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts, newlyConnectedProducts: newlyConnectedProducts, useLocalStorage: useLocalStorage })=>{
    // eslint-disable-next-line @atlassian/search-common/no-use-local-storage
    const [storedState, setState] = useLocalStorage();
    const hasProductsNeedingOAuth = availableProducts.some((product)=>{
        if ((0, $1yEFx.is3pProductKey)(product) && thirdPartyConfigs[product]?.userNeedsOAuth) return true;
        return false;
    });
    const bannerState = (0, $gwFzn.useMemo)(()=>{
        if (!storedState || !storedState.bulkConnectBanner) return $e32b2ca45b3e5cab$export$f43a15fa94a98f93;
        return storedState.bulkConnectBanner;
    }, [
        storedState
    ]);
    const bannerType = (0, $gwFzn.useMemo)(()=>{
        if (!bannerState.initialBannerDismissed && hasProductsNeedingOAuth) return (0, $gweXX.BannerType).INITIAL;
        if (!bannerState.secondaryBannerDismissed && newlyConnectedProducts.length > 0) return (0, $gweXX.BannerType).SECONDARY;
        return (0, $gweXX.BannerType).NONE;
    }, [
        bannerState,
        hasProductsNeedingOAuth,
        newlyConnectedProducts
    ]);
    const dismissBanner = (0, $gwFzn.useCallback)(()=>{
        if (bannerType === (0, $gweXX.BannerType).NONE) return;
        setState({
            ...storedState,
            bulkConnectBanner: {
                initialBannerDismissed: true,
                secondaryBannerDismissed: true
            }
        });
    }, [
        bannerType,
        storedState,
        setState
    ]);
    return {
        bannerType: bannerType,
        dismissBanner: dismissBanner
    };
};

});
parcelRegister("gweXX", function(module, exports) {

$parcel$export(module.exports, "BannerType", () => $10e3922610d69238$export$d64159bfaa8703dd);
const $10e3922610d69238$export$d64159bfaa8703dd = {
    INITIAL: 'initial',
    SECONDARY: 'secondary',
    NONE: null
};

});


parcelRegister("d5Ozh", function(module, exports) {

$parcel$export(module.exports, "useLocalStorageSearchPagePersistedState", () => $1c4554ee5c804e71$export$93013e196693bef5);
/**
 * Derived from from https://github.com/uidotdev/usehooks/blob/main/index.js
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $le4qT = parcelRequire("le4qT");
const $1c4554ee5c804e71$export$fc07bdd4368035fa = 'search-page-persisted-state';
function $1c4554ee5c804e71$var$dispatchStorageEvent(key, newValue) {
    window.dispatchEvent(new StorageEvent('storage', {
        key: key,
        newValue: newValue
    }));
}
const $1c4554ee5c804e71$var$setLocalStorageItem = (key, value)=>{
    const stringifiedValue = JSON.stringify(value);
    window.localStorage.setItem(key, stringifiedValue);
    $1c4554ee5c804e71$var$dispatchStorageEvent(key, stringifiedValue);
};
const $1c4554ee5c804e71$var$removeLocalStorageItem = (key)=>{
    window.localStorage.removeItem(key);
    $1c4554ee5c804e71$var$dispatchStorageEvent(key, null);
};
const $1c4554ee5c804e71$var$getLocalStorageItem = (key)=>{
    return window.localStorage.getItem(key);
};
const $1c4554ee5c804e71$var$useLocalStorageSubscribe = (callback)=>{
    const unbind = (0, $d8F95.bind)(window, {
        type: 'storage',
        listener: callback
    });
    return unbind;
};
function $1c4554ee5c804e71$export$86e2cef2561044ac(key) {
    const getSnapshot = ()=>$1c4554ee5c804e71$var$getLocalStorageItem(key);
    const store = (0, $le4qT.useSyncExternalStore)($1c4554ee5c804e71$var$useLocalStorageSubscribe, getSnapshot);
    const setState = (0, $gwFzn.useCallback)((v)=>{
        try {
            const nextState = typeof v === 'function' && store !== null ? v(JSON.parse(store)) : v;
            if (nextState === undefined || nextState === null) $1c4554ee5c804e71$var$removeLocalStorageItem(key);
            else $1c4554ee5c804e71$var$setLocalStorageItem(key, nextState);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn(e);
        }
    }, [
        key,
        store
    ]);
    return (0, $gwFzn.useMemo)(()=>{
        return [
            store ? JSON.parse(store) : store,
            setState
        ];
    }, [
        setState,
        store
    ]);
}
function $1c4554ee5c804e71$export$93013e196693bef5() {
    // eslint-disable-next-line @atlassian/search-common/no-use-local-storage
    return $1c4554ee5c804e71$export$86e2cef2561044ac($1c4554ee5c804e71$export$fc07bdd4368035fa);
}

});

parcelRegister("dsrEB", function(module, exports) {

$parcel$export(module.exports, "isProductKeyWithTimestampMap", () => $5c200fe288e4fb70$export$412863348c3febc0);
$parcel$export(module.exports, "useNewlyConnectedProducts", () => $5c200fe288e4fb70$export$6771115db1dfb376);
$parcel$export(module.exports, "useInitializeBulkConnect", () => $5c200fe288e4fb70$export$5cb3d9d254f29aa6);
$parcel$export(module.exports, "useBulkConnectState", () => $5c200fe288e4fb70$export$719ab3f262bf69f0);
$parcel$export(module.exports, "useBulkConnectModalOpenState", () => $5c200fe288e4fb70$export$293a4cdece12aaf1);

var $1yEFx = parcelRequire("1yEFx");

var $a5OFf = parcelRequire("a5OFf");

var $j4ply = parcelRequire("j4ply");

var $ba5MN = parcelRequire("ba5MN");

var $d5Ozh = parcelRequire("d5Ozh");
const $5c200fe288e4fb70$var$TWENTY_FOUR_HOURS_MS = 86400000;
const $5c200fe288e4fb70$export$412863348c3febc0 = (value)=>{
    if (!value || typeof value !== 'object') return false;
    return Object.entries(value).every(([key, timestamp])=>(0, $1yEFx.is3pProductKey)(key) && typeof timestamp === 'string' && !isNaN(parseInt(timestamp, 10)));
};
const $5c200fe288e4fb70$export$6771115db1dfb376 = ()=>{
    // eslint-disable-next-line @atlassian/search-common/no-use-local-storage
    const [storedState] = (0, $d5Ozh.useLocalStorageSearchPagePersistedState)();
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const getNewProducts = ()=>{
        const currentTime = Date.now();
        const previous3pProducts = $5c200fe288e4fb70$export$412863348c3febc0(storedState?.previous3pProducts) ? storedState.previous3pProducts : {};
        const entries = Object.entries(previous3pProducts).map(([key, timestamp])=>[
                key,
                parseInt(timestamp, 10)
            ]);
        return entries.filter(([productKey, timestamp])=>{
            const productConfig = thirdPartyConfigs?.[productKey];
            if (!productConfig) return false;
            return currentTime - timestamp < $5c200fe288e4fb70$var$TWENTY_FOUR_HOURS_MS && // check if the product was noticed within the last 24 hours
            productConfig.userNeedsOAuth && // check if the user needs to OAuth
            !(0, $a5OFf.isProductSmartlink)({
                productKey: productKey,
                thirdPartyConfigs: thirdPartyConfigs
            }) && // make sure the connector is not a smartlink type
            !productConfig.isFederated && // make sure the connector is not federated type
            productConfig.isEnabled;
        }).sort((a, b)=>b[1] - a[1]) // ordered by the most recent product
        .map(([productKey])=>productKey);
    };
    return getNewProducts();
};
const $5c200fe288e4fb70$export$5cb3d9d254f29aa6 = (availableProducts, recentlyConnectedProducts)=>{
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const { initializeProductState: initializeProductState } = (0, $ba5MN.useBulkConnectActions)();
    initializeProductState(availableProducts, recentlyConnectedProducts, thirdPartyConfigs);
};
const $5c200fe288e4fb70$export$719ab3f262bf69f0 = ()=>{
    const { setProductStatus: setProductStatus, setProductConnectedInSession: setProductConnectedInSession } = (0, $ba5MN.useBulkConnectActions)();
    const [productStatuses] = (0, $ba5MN.useProductStatuses)();
    const [productOrder] = (0, $ba5MN.useProductOrder)();
    const [productConnectedInSession] = (0, $ba5MN.useProductConnectedInSession)();
    return {
        productStatuses: productStatuses,
        productOrder: productOrder,
        productConnectedInSession: productConnectedInSession,
        setProductStatus: setProductStatus,
        setProductConnectedInSession: setProductConnectedInSession
    };
};
const $5c200fe288e4fb70$export$293a4cdece12aaf1 = ()=>{
    const [isBulkConnectModalOpen] = (0, $ba5MN.useIsBulkConnectModalOpen)();
    const { setIsBulkConnectModalOpen: setIsBulkConnectModalOpen } = (0, $ba5MN.useBulkConnectActions)();
    return {
        isBulkConnectModalOpen: isBulkConnectModalOpen,
        setIsBulkConnectModalOpen: setIsBulkConnectModalOpen
    };
};

});
parcelRegister("ba5MN", function(module, exports) {

$parcel$export(module.exports, "useBulkConnectActions", () => $4b530d6da1f157fc$export$279e536e36cc41a4);
$parcel$export(module.exports, "useProductOrder", () => $4b530d6da1f157fc$export$fb69e55e842cc5ed);
$parcel$export(module.exports, "useProductStatuses", () => $4b530d6da1f157fc$export$a7191da1f749953c);
$parcel$export(module.exports, "useProductConnectedInSession", () => $4b530d6da1f157fc$export$d911036f1661e7c);
$parcel$export(module.exports, "useIsBulkConnectModalOpen", () => $4b530d6da1f157fc$export$f79c2ea8890445d8);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");

var $hB77E = parcelRequire("hB77E");
const $4b530d6da1f157fc$export$d4c72bab9d6cc13a = {
    productOrder: [],
    productStatuses: new Map(),
    connectedProducts: [],
    productConnectedInSession: false,
    isBulkConnectModalOpen: false
};
const $4b530d6da1f157fc$var$actions = {
    setProductStatus: (productKey, status)=>({ setState: setState, getState: getState })=>{
            const { productStatuses: productStatuses } = getState();
            const updatedProductStatuses = new Map(productStatuses);
            updatedProductStatuses.set(productKey, status);
            setState({
                ...getState(),
                productStatuses: updatedProductStatuses
            });
        },
    initializeProductState: (availableProducts, recentlyConnectedProducts, thirdPartyConfigs)=>({ setState: setState, getState: getState })=>{
            // First, set product statuses
            const productStatuses = new Map();
            availableProducts.forEach((productKey)=>{
                const connectStatus = !thirdPartyConfigs[productKey]?.userNeedsOAuth;
                productStatuses.set(productKey, connectStatus);
            });
            // Then, determine connected products
            const connectedProducts = [];
            productStatuses.forEach((status, productKey)=>{
                if (status) connectedProducts.push(productKey);
            });
            // Finally, set product order
            const productOrder = [];
            recentlyConnectedProducts.forEach((productKey)=>productOrder.push(productKey));
            (0, $hB77E.BulkConnectProductOrder3P).filter((productKey)=>availableProducts.includes(productKey) && !connectedProducts.includes(productKey) && !recentlyConnectedProducts.includes(productKey)).forEach((productKey)=>productOrder.push(productKey));
            connectedProducts.filter((productKey)=>!recentlyConnectedProducts.includes(productKey)).forEach((productKey)=>productOrder.push(productKey));
            // Set all state at once
            setState({
                ...getState(),
                productStatuses: productStatuses,
                connectedProducts: connectedProducts,
                productOrder: productOrder
            });
        },
    setProductConnectedInSession: (productConnectedInSession)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                productConnectedInSession: productConnectedInSession
            });
        },
    setIsBulkConnectModalOpen: (isBulkConnectModalOpen)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                isBulkConnectModalOpen: isBulkConnectModalOpen
            });
        }
};
const $4b530d6da1f157fc$var$Store = (0, $4ZoIm.createStore)({
    initialState: $4b530d6da1f157fc$export$d4c72bab9d6cc13a,
    actions: $4b530d6da1f157fc$var$actions,
    name: 'bulk-connect-dialog'
});
const $4b530d6da1f157fc$export$279e536e36cc41a4 = (0, $iFWZA.createActionsHook)($4b530d6da1f157fc$var$Store);
const $4b530d6da1f157fc$export$fb69e55e842cc5ed = (0, $iFWZA.createHook)($4b530d6da1f157fc$var$Store, {
    selector: (state)=>state.productOrder
});
const $4b530d6da1f157fc$export$a7191da1f749953c = (0, $iFWZA.createHook)($4b530d6da1f157fc$var$Store, {
    selector: (state)=>state.productStatuses
});
const $4b530d6da1f157fc$export$2ceb3d56f6da5c5d = (0, $iFWZA.createHook)($4b530d6da1f157fc$var$Store, {
    selector: (state)=>state.connectedProducts
});
const $4b530d6da1f157fc$export$d911036f1661e7c = (0, $iFWZA.createHook)($4b530d6da1f157fc$var$Store, {
    selector: (state)=>state.productConnectedInSession
});
const $4b530d6da1f157fc$export$f79c2ea8890445d8 = (0, $iFWZA.createHook)($4b530d6da1f157fc$var$Store, {
    selector: (state)=>state.isBulkConnectModalOpen
});

});



parcelRegister("embLz", function(module, exports) {

$parcel$export(module.exports, "useFetchConfig", () => $79c4d57fc1792dc7$export$2b0ac18f7cd43e19);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $kNUwp = parcelRequire("kNUwp");

var $hB77E = parcelRequire("hB77E");

var $4EMbH = parcelRequire("4EMbH");

var $1yEFx = parcelRequire("1yEFx");

var $9d9t8 = parcelRequire("9d9t8");

var $dmTG5 = parcelRequire("dmTG5");

var $cFN1h = parcelRequire("cFN1h");

var $3CshZ = parcelRequire("3CshZ");
parcelRequire("1nJM3");
var $f8oYd = parcelRequire("f8oYd");

var $j4ply = parcelRequire("j4ply");
const $79c4d57fc1792dc7$var$EXTRACT_PRODUCT = /ari:cloud:(.*)?::/;
const $79c4d57fc1792dc7$var$EXTRACT_CLOUD_ID = /ari:cloud:.*?\/(.*)/;
const $79c4d57fc1792dc7$var$BITBUCKET_WORKSPACE_ARI = 'ari:cloud:bitbucket::workspace';
const $79c4d57fc1792dc7$var$getFirstCloudId = (firstPartyResponse)=>{
    const match = firstPartyResponse.resources[0]?.id.match($79c4d57fc1792dc7$var$EXTRACT_CLOUD_ID);
    const extractedCloudId = match ? match[1] : '';
    return extractedCloudId;
};
const $79c4d57fc1792dc7$var$isNounsAvailable = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isNounsAvailable;
};
const $79c4d57fc1792dc7$var$isRovoEnabled = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isRovoEnabled;
};
const $79c4d57fc1792dc7$var$getProductEdition = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productEdition)?.productEdition;
};
const $79c4d57fc1792dc7$var$getProductDataRegions = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productDataRegions)?.productDataRegions;
};
const $79c4d57fc1792dc7$var$getRovoFeatures = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.rovoFeatures)?.rovoFeatures;
};
const $79c4d57fc1792dc7$export$2b0ac18f7cd43e19 = ({ cloudId: cloudIdProp, configFetchAbsoluteUrl: configFetchAbsoluteUrl, aggregatorHostName: aggregatorHostName, userId: userId, thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl, thirdPartyDisabled: thirdPartyDisabled, primaryProduct: primaryProduct })=>{
    const supportedProducts = (0, $1yEFx.useProductConfigs)();
    const [firstPartyResponse, setFirstPartyResponse] = (0, $gwFzn.useState)();
    const [isUserLoomAuthed, setIsUserLoomAuthed] = (0, $gwFzn.useState)(false);
    const [isConfigLoaded, setIsConfigLoaded] = (0, $gwFzn.useState)(false);
    const [accessibleProductsConfig, setAccessibleProductsConfig] = (0, $gwFzn.useState)({
        nouns: []
    });
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const logException = (0, $f8oYd.useLogException)();
    const firstCloudId = (0, $gwFzn.useMemo)(()=>{
        if (!cloudIdProp && firstPartyResponse) return $79c4d57fc1792dc7$var$getFirstCloudId(firstPartyResponse);
        return '';
    }, [
        firstPartyResponse,
        cloudIdProp
    ]);
    const thirdPartyResponse = $79c4d57fc1792dc7$export$4fc2f66fb6e9d067({
        cloudId: cloudIdProp || firstCloudId || '',
        userId: userId,
        absoluteUrl: thirdPartyAbsoluteUrl,
        disabled: thirdPartyDisabled
    });
    (0, $gwFzn.useEffect)(()=>{
        //this endpoint only works in confluence and atlas, show loom to other products for now
        if (!isUserLoomAuthed) {
            if (primaryProduct === (0, $1yEFx.PrimaryProductKeys).Confluence || primaryProduct === (0, $1yEFx.PrimaryProductKeys).Atlas) (0, $kNUwp.getUserLoomAuthStatus)({
                userId: userId,
                cloudId: cloudIdProp
            }).then((response)=>setIsUserLoomAuthed(response?.status === 'mastered')).catch((error)=>{
                logException(error);
                setIsUserLoomAuthed(false);
            });
            else setIsUserLoomAuthed(true);
        }
    }, [
        isUserLoomAuthed,
        setIsUserLoomAuthed,
        userId,
        logException,
        cloudIdProp,
        primaryProduct
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!firstPartyResponse) {
            // DegradedDependency may not be visible to the end-user due to request caching. This is a health metric for our BE
            const degradationCallback = (reason)=>{
                fireAnalyticsEvent((0, $dmTG5.onDegradedDependency)({
                    dependency: 'search-config',
                    searchSessionId: searchSessionId,
                    reason: reason
                }));
            };
            const searchConfigParams = {
                cloudId: cloudIdProp,
                absoluteUrl: configFetchAbsoluteUrl,
                hostName: aggregatorHostName,
                userId: userId,
                degradationCallback: degradationCallback
            };
            (0, $kNUwp.getSearchConfigV2)(searchConfigParams).then((response)=>{
                setFirstPartyResponse(response);
            }).catch((error)=>{
                logException(error);
                // FailedDependency is visible to the end-user. This is a health metric for our UX
                fireAnalyticsEvent((0, $cFN1h.onFailedDependency)({
                    dependency: 'search-config',
                    searchSessionId: searchSessionId
                }));
                setFirstPartyResponse({
                    resources: [],
                    intercomHmac: '',
                    siteMetadata: []
                });
            });
        }
    }, [
        firstPartyResponse,
        setFirstPartyResponse,
        cloudIdProp,
        configFetchAbsoluteUrl,
        aggregatorHostName,
        userId,
        logException,
        fireAnalyticsEvent,
        searchSessionId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (thirdPartyResponse.productKeys && firstPartyResponse && !accessibleProductsConfig.products) {
            let allAccessibleProducts = [];
            const firstPartyProducts = [
                ...new Set(firstPartyResponse.resources.flatMap((resource)=>{
                    const { id: id } = resource;
                    const match = id.match($79c4d57fc1792dc7$var$EXTRACT_PRODUCT);
                    if (match && match.length >= 2 && match[1] in supportedProducts) return [
                        match[1]
                    ];
                    return [];
                }))
            ];
            if (firstPartyProducts.length === 0 && primaryProduct) // Use the primary product if the 1P Search Config request fails
            allAccessibleProducts.push(primaryProduct);
            else allAccessibleProducts.push(...firstPartyProducts);
            // We are currently migrating Goal and Project nouns from townsquare (Atlas) into their own separate Products
            // within Identity. As part of this migration we are decommissioning the isNounsAvailable flag on siteMetadata
            // and moving the nouns into the first party product list.
            //
            // If a site has isNounsAvailable set to false then we want to return the available
            // nouns from the firstPartyResponse. If isNounsAvailable is true then the site hasn't been migrated yet and
            // should continue with the old behaviour.
            const areNounsEnabledThroughLegacyFlag = $79c4d57fc1792dc7$var$isNounsAvailable(firstPartyResponse, cloudIdProp);
            const accessibleNouns = areNounsEnabledThroughLegacyFlag ? [] : firstPartyResponse.resources.flatMap((resource)=>{
                const { id: id } = resource;
                const match = id.match($79c4d57fc1792dc7$var$EXTRACT_PRODUCT);
                if (match && match.length >= 2 && match[1] in (0, $4EMbH.nouns)) return [
                    match[1]
                ];
                return [];
            });
            // If nouns are available we also need to add Townsquare to the list of accessible products.
            // This way Projects will be fetched by default when no filters are selected.
            if (accessibleNouns.length > 0 && !areNounsEnabledThroughLegacyFlag) allAccessibleProducts.push((0, $1yEFx.ProductKeys).Atlas);
            // Remove Bitbucket from the list of resources if:
            // * The user doesn't have access to the Bitbucket product
            // * There are no bitbucket workspaces
            // See https://hello.atlassian.net/wiki/x/1hI6CQE for details
            if (allAccessibleProducts.includes('bitbucket') && !firstPartyResponse.resources.find((r)=>r.id.includes($79c4d57fc1792dc7$var$BITBUCKET_WORKSPACE_ARI))) allAccessibleProducts = allAccessibleProducts.filter((product)=>product !== (0, $1yEFx.ProductKeys).Bitbucket);
            // user may have loom entitlement but not the correct auth status
            if (!isUserLoomAuthed) allAccessibleProducts = allAccessibleProducts.filter((product)=>product !== (0, $1yEFx.ProductKeys).Loom);
            // Allow 3P products only if a user has Rovo enabled.
            // Long-term it won't be needed if the 3p-configuration check ensures Rovo eligibility.
            // See https://hello.atlassian.net/wiki/spaces/SEARCH/pages/4469899124.
            const doesUserHaveRovo = $79c4d57fc1792dc7$var$isRovoEnabled(firstPartyResponse, cloudIdProp);
            if (doesUserHaveRovo) {
                const thirdPartyProductKeys = thirdPartyResponse.productKeys || [];
                allAccessibleProducts.push(...thirdPartyProductKeys);
                setAccessibleProductsConfig({
                    products: allAccessibleProducts,
                    nouns: accessibleNouns,
                    thirdPartyConfigs: thirdPartyResponse.thirdPartyConfigs
                });
            } else setAccessibleProductsConfig({
                products: allAccessibleProducts,
                nouns: accessibleNouns,
                thirdPartyConfigs: {}
            });
            setIsConfigLoaded(true);
        }
    }, [
        isUserLoomAuthed,
        thirdPartyResponse,
        firstPartyResponse,
        setAccessibleProductsConfig,
        primaryProduct,
        fireAnalyticsEvent,
        logException,
        cloudIdProp,
        accessibleProductsConfig.products,
        supportedProducts
    ]);
    return {
        accessibleProducts: accessibleProductsConfig.products,
        accessibleNouns: accessibleProductsConfig.nouns,
        thirdPartyConfigs: accessibleProductsConfig.thirdPartyConfigs,
        firstCloudId: firstCloudId,
        intercomHmac: firstPartyResponse?.intercomHmac,
        isNounsAvailable: $79c4d57fc1792dc7$var$isNounsAvailable(firstPartyResponse, cloudIdProp),
        isRovoEnabled: $79c4d57fc1792dc7$var$isRovoEnabled(firstPartyResponse, cloudIdProp),
        productEdition: $79c4d57fc1792dc7$var$getProductEdition(firstPartyResponse, cloudIdProp),
        productDataRegions: $79c4d57fc1792dc7$var$getProductDataRegions(firstPartyResponse, cloudIdProp),
        rovoFeatures: $79c4d57fc1792dc7$var$getRovoFeatures(firstPartyResponse, cloudIdProp),
        isConfigLoaded: isConfigLoaded
    };
};
const $79c4d57fc1792dc7$export$6750011b01164bda = ()=>{
    // old sharepoint product key is put here (kept for backwards compatibility), as the new one is in the config
    const oldThirdPartyTypes = {
        'ai-3p-connector:sharepoint-domain': `sharepoint`,
        'ai-3p-connector:google-workspace': `drive`
    };
    const thirdPartyTypes = {
        ...oldThirdPartyTypes,
        // add third party types for dual connectors
        'smartlinks-connector-gdrive': `drive`,
        'smartlinks-connector-salesforce': `salesforce`,
        'smartlinks-connector-airtable': `airtable`,
        'smartlinks-connector-figma': `figma`,
        'smartlinks-connector-gitlab': `gitlab`,
        'smartlinks-connector-miro': `miro`,
        'smartlinks-connector-asana': `asana`,
        'smartlinks-connector-smartsheet': `smartsheet`,
        'smartlinks-connector-dropbox': `dropbox`,
        'smartlinks-connector-box': `box`,
        'smartlinks-connector-lucid': `lucid`,
        'smartlinks-connector-hubspot': `hubspot`,
        'smartlinks-connector-docusign': `docusign`,
        'smartlinks-connector-slack': `slack`,
        'smartlinks-connector-teams': `teams`,
        'smartlinks-connector-azure-devops': `azure-devops`,
        'smartlinks-connector-notion': `notion`
    };
    (0, $hB77E.ThirdPartyConfigs).forEach((config)=>{
        if (config.resourceType) thirdPartyTypes[config.resourceType] = config.id;
    });
    return thirdPartyTypes;
};
const $79c4d57fc1792dc7$export$b58c1135b7f9df6d = async ({ cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId, degradationCallback: degradationCallback })=>{
    const THIRD_PARTY_TYPES = $79c4d57fc1792dc7$export$6750011b01164bda();
    const resources = await (0, $kNUwp.get3pSearchConfig)({
        cloudId: cloudId,
        absoluteUrl: absoluteUrl,
        userId: userId,
        degradationCallback: degradationCallback
    });
    // since we aren't getting anything back from connected-data-sources, we hardcode the connectors here
    if ((0, $dh538.fg)('forge-connector-demo')) {
        resources.push({
            type: 'aws-s3-connector',
            providerId: '',
            outboundAuthUrl: '',
            isUserOAuthed: false,
            workspaceName: ''
        });
        // This is done for Pio
        const isProdProvider = (0, $dh538.fg)('forge-team25-gitbook-prod-search-provider');
        resources.push({
            type: 'gitbook-connector',
            providerId: isProdProvider ? 'dzfCxy061BNL8sEFZdIM9xXXkyL49RPb' : 'HBV0Q5GB1FgcIjYXt9jadwXSDjStqaMv',
            outboundAuthUrl: '',
            isUserOAuthed: true,
            workspaceName: ''
        });
    }
    // Use a map to track connector sources for each providerId
    // This is useful for deduping search results for providers that are hybrid smartlink and full connectors
    const connectorSourceMap = new Map();
    let productKeys = [];
    let thirdPartyConfigsWithAPIResponse = {};
    resources.forEach((resource)=>{
        const productKey = THIRD_PARTY_TYPES[resource.type] || '';
        if (!productKey) return;
        const { providerId: providerId } = resource;
        productKeys.push(productKey);
        let config = {};
        const staticConfig = (0, $hB77E.ThirdPartyConfigs).get(productKey);
        if (staticConfig) {
            const sourceType = staticConfig.isFederated ? (0, $9d9t8.FEDERATED_CONNECTOR_SOURCE) : resource.type.startsWith((0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE)) ? (0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE) : (0, $9d9t8.FULL_CONNECTOR_SOURCE);
            connectorSourceMap.set(providerId, (connectorSourceMap.get(providerId) || new Set()).add(sourceType));
            const existingConfig = thirdPartyConfigsWithAPIResponse[productKey];
            const isExistingConfigFullConnectorSource = existingConfig?.connectorSources?.includes((0, $9d9t8.FULL_CONNECTOR_SOURCE)) || false;
            const oAuthOutboundUrl = isExistingConfigFullConnectorSource && existingConfig?.oAuthOutboundUrl ? existingConfig.oAuthOutboundUrl : resource.outboundAuthUrl;
            const userNeedsOAuth = isExistingConfigFullConnectorSource && existingConfig ? existingConfig.userNeedsOAuth : !resource.isUserOAuthed;
            config = {
                ...staticConfig,
                oAuthOutboundUrl: oAuthOutboundUrl,
                userNeedsOAuth: userNeedsOAuth,
                providerId: providerId,
                workspaceName: resource.workspaceName,
                ...(0, $dh538.fg)('ai3w_smartlink_ui_support') ? {
                    connectorSources: Array.from(connectorSourceMap.get(providerId) || [])
                } : {}
            };
            thirdPartyConfigsWithAPIResponse[productKey] = config;
        }
    });
    productKeys = productKeys.filter((productKey)=>(0, $1yEFx.allProductKeys).includes(productKey));
    return {
        productKeys: productKeys,
        thirdPartyConfigs: thirdPartyConfigsWithAPIResponse
    };
};
const $79c4d57fc1792dc7$var$EMPTY_RESPONSE = [];
const $79c4d57fc1792dc7$export$4fc2f66fb6e9d067 = ({ cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId, disabled: disabled } = {})=>{
    const [config, setConfig] = (0, $gwFzn.useState)({});
    const logException = (0, $f8oYd.useLogException)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    (0, $gwFzn.useEffect)(()=>{
        if (!config.productKeys) {
            if (!disabled && cloudId) {
                // DegradedDependency may not be visible to the end-user due to request caching. This is a health metric for our BE
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $dmTG5.onDegradedDependency)({
                        dependency: 'search-3p-config',
                        searchSessionId: searchSessionId,
                        reason: reason
                    }));
                };
                $79c4d57fc1792dc7$export$b58c1135b7f9df6d({
                    cloudId: cloudId,
                    absoluteUrl: absoluteUrl,
                    userId: userId,
                    degradationCallback: degradationCallback
                }).then((data)=>{
                    setConfig({
                        productKeys: data.productKeys,
                        thirdPartyConfigs: data.thirdPartyConfigs
                    });
                }).catch((error)=>{
                    // FailedDependency is visible to the end-user. This is a health metric for our UX
                    fireAnalyticsEvent((0, $cFN1h.onFailedDependency)({
                        dependency: 'search-3p-config',
                        searchSessionId: searchSessionId
                    }));
                    setConfig({
                        productKeys: $79c4d57fc1792dc7$var$EMPTY_RESPONSE,
                        thirdPartyConfigs: {}
                    });
                    logException(error);
                });
            } else setConfig({
                productKeys: $79c4d57fc1792dc7$var$EMPTY_RESPONSE,
                thirdPartyConfigs: {}
            });
        }
    }, [
        cloudId,
        absoluteUrl,
        userId,
        disabled,
        config,
        logException,
        fireAnalyticsEvent,
        searchSessionId
    ]);
    return config;
};

});
parcelRegister("kNUwp", function(module, exports) {

$parcel$export(module.exports, "SEARCH_3P_CONFIG", () => $c1ef33da072a3fc0$export$cf95148f36a28b96);
$parcel$export(module.exports, "getSearchConfigV2", () => $c1ef33da072a3fc0$export$c6f4290269f11bd5);
$parcel$export(module.exports, "get3pSearchConfig", () => $c1ef33da072a3fc0$export$6916ea7f169882e0);
$parcel$export(module.exports, "generate3pHash", () => $c1ef33da072a3fc0$export$f80795c7fd0ce9fc);
$parcel$export(module.exports, "getUserLoomAuthStatus", () => $c1ef33da072a3fc0$export$46e3d34ee7b8c58a);

var $dwp40 = parcelRequire("dwp40");

var $2qzBQ = parcelRequire("2qzBQ");

var $jnPv4 = parcelRequire("jnPv4");

var $3Tbc2 = parcelRequire("3Tbc2");
const $c1ef33da072a3fc0$var$RELATIVE_URL = '/gateway/api/xpsearch-aggregator/configuration/v1';
const $c1ef33da072a3fc0$var$RELATIVE_URL_V2 = '/gateway/api/xpsearch-aggregator/api/v2/configuration';
const $c1ef33da072a3fc0$var$RELATIVE_3P_URL = '/gateway/api/third-party-configuration/connected-data-sources';
const $c1ef33da072a3fc0$var$RELATIVE_LOOM_AUTH_URL = '/gateway/api/loom-auth/api/internal/identity/user-status';
const $c1ef33da072a3fc0$export$19524a749d98a458 = 'search-config';
const $c1ef33da072a3fc0$export$cf95148f36a28b96 = 'search-3p-config';
const $c1ef33da072a3fc0$export$44d1e7c4ef26c467 = 'loom-user-auth';
const { refreshOnAccessDecorator: $c1ef33da072a3fc0$var$refreshOnAccessDecoratorSearch } = (0, $jnPv4.promiseCache)({
    name: $c1ef33da072a3fc0$export$19524a749d98a458
});
const { refreshOnAccessDecorator: $c1ef33da072a3fc0$var$refreshOnAccessDecorator3pSearch } = (0, $jnPv4.promiseCache)({
    name: $c1ef33da072a3fc0$export$cf95148f36a28b96,
    expiration: 300000
});
const { refreshOnAccessDecorator: $c1ef33da072a3fc0$var$refreshOnAccessDecoratorUserLoomAuth } = (0, $jnPv4.promiseCache)({
    name: $c1ef33da072a3fc0$export$44d1e7c4ef26c467
});
const $c1ef33da072a3fc0$var$SITELESS_PRODUCTS = [
    'trello',
    'bitbucket'
];
const $c1ef33da072a3fc0$export$2e9655e8b4177582 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ef33da072a3fc0$var$RELATIVE_URL}`;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $2qzBQ.generateHash)(`1p|${userId}|${cloudId}`);
    const supplier = ()=>(0, $dwp40.utils).requestService({
            url: url
        }, options).then((data)=>{
            const resources = data.resources.filter((resource)=>cloudId ? resource.id.includes(cloudId) || $c1ef33da072a3fc0$var$SITELESS_PRODUCTS.find((product)=>resource.id.includes(product)) // Allow access to products that are not associated with a site
                 : true);
            return {
                resources: resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
    return $c1ef33da072a3fc0$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration
    });
};
const $c1ef33da072a3fc0$export$c6f4290269f11bd5 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, degradationCallback: degradationCallback = ()=>{} })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ef33da072a3fc0$var$RELATIVE_URL_V2}/${cloudId}`;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $2qzBQ.generateHash)(`1p|${userId}|${cloudId}|v2`);
    const supplier = ()=>{
        const searchConfigPromise = (0, $dwp40.utils).requestService({
            url: url
        }, options).then((data)=>{
            return {
                resources: data.resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecoratorSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $3Tbc2.DegradablePromise)(searchConfigPromise, degradationCallback);
        return degrader.promise();
    };
    return $c1ef33da072a3fc0$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration
    });
};
const $c1ef33da072a3fc0$export$6916ea7f169882e0 = async ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, degradationCallback: degradationCallback = ()=>{} })=>{
    const baseUrl = absoluteUrl || $c1ef33da072a3fc0$var$RELATIVE_3P_URL;
    const url = `${baseUrl}/${cloudId}`;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = $c1ef33da072a3fc0$export$f80795c7fd0ce9fc(userId || '', cloudId || '');
    const supplier = ()=>{
        const searchConfig3PPromise = (0, $dwp40.utils).requestService({
            url: url
        }, options);
        // Two cases here, due to the promiseCache from refreshOnAccessDecorator3pSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $3Tbc2.DegradablePromise)(searchConfig3PPromise, degradationCallback);
        return degrader.promise();
    };
    return $c1ef33da072a3fc0$var$refreshOnAccessDecorator3pSearch({
        key: key.toString(),
        supplier: supplier,
        returnExpired: false,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration
    });
};
const $c1ef33da072a3fc0$export$f80795c7fd0ce9fc = (userId, cloudId)=>(0, $2qzBQ.generateHash)(`3p|${userId}|${cloudId}`);
const $c1ef33da072a3fc0$export$46e3d34ee7b8c58a = async ({ cloudId: cloudId, userId: userId })=>{
    const url = $c1ef33da072a3fc0$var$RELATIVE_LOOM_AUTH_URL;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = $c1ef33da072a3fc0$export$42b67d93e908c9dc(userId || '', cloudId || '');
    const supplier = ()=>(0, $dwp40.utils).requestService({
            url: url
        }, options);
    return $c1ef33da072a3fc0$var$refreshOnAccessDecoratorUserLoomAuth({
        key: key.toString(),
        supplier: supplier,
        returnExpired: false
    });
};
const $c1ef33da072a3fc0$export$42b67d93e908c9dc = (userId, cloudId)=>(0, $2qzBQ.generateHash)(`loom|${userId}|${cloudId}`);

});
parcelRegister("jnPv4", function(module, exports) {

$parcel$export(module.exports, "promiseCache", () => $582af5ffd704fa53$export$e89e805418f4d2c);

var $3WVPu = parcelRequire("3WVPu");

var $diBHZ = parcelRequire("diBHZ");
const $582af5ffd704fa53$export$e89e805418f4d2c = (args)=>{
    const { name: name } = args;
    const cacheInstance = (0, $3WVPu.getInstance)(args);
    const persistedState = (0, $diBHZ.getLocalStorageItem)(name);
    if (persistedState) cacheInstance.deserialize(persistedState);
    const get = (key, returnExpired)=>{
        const storedValue = cacheInstance.get(key, returnExpired ?? true); // fetch expired result by default
        const isExpired = cacheInstance.isExpired(key);
        return {
            storedValue: storedValue,
            isExpired: isExpired
        };
    };
    const set = async (key, result, expiration)=>{
        cacheInstance.set(key, result, expiration);
        try {
            await result;
            const serialized = await cacheInstance.serialize();
            if (serialized) (0, $diBHZ.setLocalStorageItem)(name, serialized);
        } catch (_) {
        // noop - an exception in the result promise or serialisation should be ignored so we dont throw unhandled exceptions
        }
    };
    const refreshOnAccessDecorator = ({ key: key, supplier: supplier, returnExpired: returnExpired, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration })=>{
        const { storedValue: storedValue, isExpired: isExpired } = get(key, returnExpired);
        const shouldRefresh = onlyRefreshIfExpired ? isExpired : true;
        if (!storedValue || shouldRefresh) {
            const apiPromise = supplier();
            set(key, apiPromise, expiration);
            // If there was already a stored value prior to refreshing, return it
            return storedValue || apiPromise;
        } else return storedValue;
    };
    return {
        get: get,
        refreshOnAccessDecorator: refreshOnAccessDecorator
    };
};

});
parcelRegister("diBHZ", function(module, exports) {

$parcel$export(module.exports, "setLocalStorageItem", () => $712c731d946d9c9b$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $712c731d946d9c9b$export$93d719890ad66653);
const $712c731d946d9c9b$export$5aa524d86254b4f = (key, value)=>{
    window.localStorage.setItem(key, value);
};
const $712c731d946d9c9b$export$93d719890ad66653 = (key)=>{
    return window.localStorage.getItem(key);
};

});


parcelRegister("3Tbc2", function(module, exports) {

$parcel$export(module.exports, "DegradablePromise", () => $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9);
class $3c05ea8f13f2fd4c$export$85bf8e4fb143676a extends Error {
    constructor(...args){
        super(...args);
        this.isDegraded = true;
    }
}
const $3c05ea8f13f2fd4c$export$ff01cc10d3c607be = 6000;
const $3c05ea8f13f2fd4c$var$DEGRADE_ERROR = new $3c05ea8f13f2fd4c$export$85bf8e4fb143676a('Promise is degraded');
class $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9 {
    static from(wrapped, degradationCallback = ()=>{}) {
        return new $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9(wrapped, degradationCallback);
    }
    constructor(wrapped, degradationCallback){
        this.degradablePromiseInternal = void 0;
        this.degradeTimeout = void 0;
        this.degradeInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.timeout = ()=>{
            this.degradeInternal();
        };
        this.promise = ()=>this.degradablePromiseInternal;
        const degrader = new Promise((_, reject)=>{
            this.degradeInternal = ()=>{
                reject($3c05ea8f13f2fd4c$var$DEGRADE_ERROR);
                degradationCallback('timeout');
            };
        });
        // Call the degradation callback with 'failed' if the wrapped promise fails, easy way to track metrics at fetch level
        wrapped.catch(()=>{
            degradationCallback('failure');
        });
        // Build a finally chain into the wrapped promise so if it resolves early, we cancel the degradation
        const wrappedFinally = wrapped.finally(()=>{
            if (this.degradeTimeout) clearTimeout(this.degradeTimeout);
        });
        const wrapper = Promise.race([
            wrappedFinally,
            degrader
        ]);
        this.degradablePromiseInternal = wrapper;
        this.degradeTimeout = setTimeout(this.timeout, $3c05ea8f13f2fd4c$export$ff01cc10d3c607be);
    }
}

});


parcelRegister("4EMbH", function(module, exports) {

$parcel$export(module.exports, "NounKeys", () => $518be078bbe36df5$export$a93cddd79e3ea530);
$parcel$export(module.exports, "isNounKey", () => $518be078bbe36df5$export$cc6a3ce6b37346b2);
$parcel$export(module.exports, "nouns", () => $518be078bbe36df5$export$5cb7c19fcb84c9cd);
$parcel$export(module.exports, "NOUNS_ORDER", () => $518be078bbe36df5$export$341b1567666c2663);

var $buthI = parcelRequire("buthI");

var $gJsgh = parcelRequire("gJsgh");

var $bVHZY = parcelRequire("bVHZY");

var $7akaY = parcelRequire("7akaY");

var $1BtHN = parcelRequire("1BtHN");

var $9dz3u = parcelRequire("9dz3u");

var $9yyKc = parcelRequire("9yyKc");

var $gSuKp = parcelRequire("gSuKp");
const $518be078bbe36df5$export$a93cddd79e3ea530 = {
    project: 'project',
    goal: 'goal',
    // tag: 'tag',
    AtlassianWebCrawler: 'atlassian-web-crawler'
};
const $518be078bbe36df5$export$cc6a3ce6b37346b2 = (key)=>{
    return Object.values($518be078bbe36df5$export$a93cddd79e3ea530).includes(key);
};
const $518be078bbe36df5$export$5cb7c19fcb84c9cd = {
    [$518be078bbe36df5$export$a93cddd79e3ea530.project]: {
        displayName: (0, $gSuKp.messages).project,
        displayNamePlural: (0, $gSuKp.messages).projects,
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $9yyKc.getLogoVersion)((0, $9dz3u.ProjectsIcon), (0, (/*@__PURE__*/$parcel$interopDefault($bVHZY)))), 'Project')
    },
    [$518be078bbe36df5$export$a93cddd79e3ea530.goal]: {
        displayName: (0, $gSuKp.messages).goal,
        displayNamePlural: (0, $gSuKp.messages).goals,
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $9yyKc.getLogoVersion)((0, $1BtHN.GoalsIcon), (0, (/*@__PURE__*/$parcel$interopDefault($gJsgh)))), 'Goal')
    },
    //Tag Noun has been omitted because it is not currently implemented in FPS and risks visual degradation with the t25 icon update
    //Discussion here: https://atlassian.slack.com/archives/C08HFJLM7J5/p1742856483784089
    // [NounKeys.tag]: {
    // 	displayName: messages.tag,
    // 	displayNamePlural: messages.tags,
    // 	Icon: RovoLogoFromLogo(HashtagIcon, 'Tag'),
    // },
    [$518be078bbe36df5$export$a93cddd79e3ea530.AtlassianWebCrawler]: {
        displayName: (0, $gSuKp.messages).webPage,
        displayNamePlural: (0, $gSuKp.messages).webPages,
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $9yyKc.getLogoVersion)((0, $7akaY.CustomLinkIcon), (0, (/*@__PURE__*/$parcel$interopDefault($buthI)))), 'Atlassian Web Crawler')
    }
};
const $518be078bbe36df5$export$341b1567666c2663 = [
    $518be078bbe36df5$export$a93cddd79e3ea530.project,
    $518be078bbe36df5$export$a93cddd79e3ea530.goal,
    // NounKeys.tag,
    $518be078bbe36df5$export$a93cddd79e3ea530.AtlassianWebCrawler // Web Crawler is not a noun, we should improve this
];

});
parcelRegister("gSuKp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $40bcb23b548b87bc$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $40bcb23b548b87bc$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    webPage: {
        id: "search-page.products.custom-website",
        defaultMessage: "Web page"
    },
    webPages: {
        id: "search-page.products.custom-websites",
        defaultMessage: "Web pages"
    },
    project: {
        id: "search-page.nouns.project",
        defaultMessage: "Project"
    },
    projects: {
        id: "search-page.nouns.projects",
        defaultMessage: "Projects"
    },
    goal: {
        id: "search-page.nouns.goal",
        defaultMessage: "Goal"
    },
    goals: {
        id: "search-page.nouns.goals",
        defaultMessage: "Goals"
    },
    tag: {
        id: "search-page.nouns.tag",
        defaultMessage: "Tag"
    },
    tags: {
        id: "search-page.nouns.tags",
        defaultMessage: "Tags"
    }
});

});


parcelRegister("dmTG5", function(module, exports) {

$parcel$export(module.exports, "onDegradedDependency", () => $8edbe48163a779a2$export$e98932ab9e22c265);

var $6yNqK = parcelRequire("6yNqK");
const $8edbe48163a779a2$export$e98932ab9e22c265 = ({ dependency: dependency, searchSessionId: searchSessionId, reason: reason })=>{
    return {
        source: (0, $6yNqK.EVENT_SOURCE),
        action: 'degradedDependency',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                degradedDependency: dependency,
                reason: reason,
                searchSessionId: searchSessionId
            }
        }
    };
};

});

parcelRegister("cFN1h", function(module, exports) {

$parcel$export(module.exports, "onFailedDependency", () => $d17b2d1acf87bd34$export$7199f2d13e6ae9f7);

var $6yNqK = parcelRequire("6yNqK");
const $d17b2d1acf87bd34$export$7199f2d13e6ae9f7 = ({ dependency: dependency, searchSessionId: searchSessionId })=>{
    return {
        source: (0, $6yNqK.EVENT_SOURCE),
        action: 'failedDependency',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                failedDependency: dependency,
                searchSessionId: searchSessionId
            }
        }
    };
};

});



parcelRegister("is3gE", function(module, exports) {

$parcel$export(module.exports, "QuickFindStoreProvider", () => $f58c1f7467c49dec$export$5f60ff1bbe7f1a37);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4VmlX = parcelRequire("4VmlX");
const $f58c1f7467c49dec$export$5f60ff1bbe7f1a37 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4VmlX.QuickFindStoreContainer), {
        children: children
    });
};

});

parcelRegister("bHLTK", function(module, exports) {

$parcel$export(module.exports, "SearchStoreProvider", () => $4622611068a1c461$export$3776ece9f99ed2df);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $j4ply = parcelRequire("j4ply");

var $j4ply = parcelRequire("j4ply");

var $ehGUC = parcelRequire("ehGUC");

var $djVCD = parcelRequire("djVCD");
const $4622611068a1c461$export$3776ece9f99ed2df = ({ children: children })=>{
    const [shouldAutoSelectPrimaryProduct, setShouldAutoSelectPrimaryProduct] = (0, $gwFzn.useState)(true);
    const intl = (0, $dBxQj.default)();
    const [{ queryParams: queryParams, cloudId: cloudId, aggAbsoluteUrl: aggAbsoluteUrl, initialSpaceARIs: initialSpaceARIs, user: user, products: products, allFilterExcludedProducts: allFilterExcludedProducts, primaryProduct: primaryProduct, experimentConfig: experimentConfig, productEdition: productEdition, productDataRegions: productDataRegions }, { setQueryParams: setQueryParams }] = (0, $j4ply.useBootstrap)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const primaryProductToAutoSelect = (0, $j4ply.useAutoSelectPrimaryProduct)();
    const config = (0, $gwFzn.useMemo)(()=>({
            aggAbsoluteUrl: aggAbsoluteUrl,
            ari: '',
            cloudId: cloudId,
            experimentConfig: experimentConfig,
            initialSpaceARIs: initialSpaceARIs,
            intl: intl,
            productDataRegions: productDataRegions,
            productEdition: productEdition,
            userId: user?.id || '',
            product: queryParams?.product || ''
        }), [
        aggAbsoluteUrl,
        cloudId,
        experimentConfig,
        initialSpaceARIs,
        intl,
        productDataRegions,
        productEdition,
        user?.id,
        queryParams?.product
    ]);
    const queryParamsInUse = (0, $gwFzn.useMemo)(()=>{
        const { lastModified_lt: lastModified_lt, lastModified_gt: lastModified_gt, ...queryParamsInUse } = queryParams;
        return queryParamsInUse;
    }, [
        queryParams
    ]);
    // primaryProductToAutoSelect will be set to the primary product if the user is in unified search
    // and no product is selected
    // This is to ensure that the primary product is selected by default for unified search
    (0, $gwFzn.useEffect)(()=>{
        if (products && products.length > 0) {
            if (shouldAutoSelectPrimaryProduct && primaryProductToAutoSelect) setQueryParams({
                ...queryParams,
                product: primaryProductToAutoSelect
            });
            setShouldAutoSelectPrimaryProduct(false);
        }
    }, [
        applicationMode,
        primaryProduct,
        primaryProductToAutoSelect,
        products,
        queryParams,
        setQueryParams,
        shouldAutoSelectPrimaryProduct
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $djVCD.SearchStoreContainer), {
        queryParams: queryParamsInUse,
        allFilters: (0, $ehGUC.allFilters),
        config: config,
        setQueryParams: setQueryParams,
        availableProducts: products,
        allFilterExcludedProducts: allFilterExcludedProducts,
        applicationMode: applicationMode,
        primaryProduct: primaryProduct,
        children: children
    });
};

});

parcelRegister("h9lDJ", function(module, exports) {

$parcel$export(module.exports, "SearchDialog", () => $71af45ffeeb47c72$export$2aadebb53f6015f6);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $fwDOR = parcelRequire("fwDOR");

var $hWR4v = parcelRequire("hWR4v");
var $4TTdD = parcelRequire("4TTdD");
var $7ZetK = parcelRequire("7ZetK");

var $9vOy1 = parcelRequire("9vOy1");

var $1yEFx = parcelRequire("1yEFx");

var $3R0ts = parcelRequire("3R0ts");

var $7WbA8 = parcelRequire("7WbA8");

var $5Lref = parcelRequire("5Lref");

var $39Swq = parcelRequire("39Swq");

var $86ob4 = parcelRequire("86ob4");

var $kIdP4 = parcelRequire("kIdP4");

var $a5OFf = parcelRequire("a5OFf");

var $iEwMm = parcelRequire("iEwMm");

var $fr375 = parcelRequire("fr375");

var $5I2eK = parcelRequire("5I2eK");

var $aE5mL = parcelRequire("aE5mL");

var $19BAV = parcelRequire("19BAV");

var $dsrEB = parcelRequire("dsrEB");

var $1nJM3 = parcelRequire("1nJM3");

var $gGFxq = parcelRequire("gGFxq");

var $inrbX = parcelRequire("inrbX");

var $dSjat = parcelRequire("dSjat");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $j4ply = parcelRequire("j4ply");

var $d5Ozh = parcelRequire("d5Ozh");

var $4VmlX = parcelRequire("4VmlX");

var $NvPpA = parcelRequire("NvPpA");

var $2nHbb = parcelRequire("2nHbb");

var $e79Fp = parcelRequire("e79Fp");

var $cuvog = parcelRequire("cuvog");

var $47juE = parcelRequire("47juE");

var $d6thU = parcelRequire("d6thU");

var $cu2Tg = parcelRequire("cu2Tg");

var $a0YSD = parcelRequire("a0YSD");

var $kMtrE = parcelRequire("kMtrE");

var $aBMZB = parcelRequire("aBMZB");

var $iUdW4 = parcelRequire("iUdW4");

var $8SdvD = parcelRequire("8SdvD");

var $fvCil = parcelRequire("fvCil");

var $lTdhv = parcelRequire("lTdhv");

var $2FGXW = parcelRequire("2FGXW");

var $fKnXN = parcelRequire("fKnXN");

var $hPvza = parcelRequire("hPvza");

var $8IQPm = parcelRequire("8IQPm");

var $hDfbs = parcelRequire("hDfbs");

var $fscQt = parcelRequire("fscQt");

var $3qFOk = parcelRequire("3qFOk");

var $5BL1t = parcelRequire("5BL1t");
const $71af45ffeeb47c72$var$searchDialogStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    position: 'absolute',
    flexDirection: 'column',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: '4px',
    boxShadow: 'elevation.shadow.overlay',
    marginTop: 'space.100',
    width: '100%'
});
const $71af45ffeeb47c72$var$searchResultsSectionStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingBlockStart: 'space.100',
    paddingBlockEnd: 'space.100',
    gap: 'space.025',
    maxHeight: 'calc(100vh - 220px)',
    overflowY: 'auto'
});
const $71af45ffeeb47c72$export$2aadebb53f6015f6 = ({ dialogId: dialogId, dialogRef: dialogRef, localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef })=>{
    const intl = (0, $dBxQj.default)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { retrySearch: retrySearch } = (0, $djVCD.useSearchActions)();
    const [{ thirdPartyConfigs: thirdPartyConfigs, products: availableProducts }] = (0, $j4ply.useBootstrap)();
    const serveUserShardModel = (0, $j4ply.useUserShardModel)();
    const serveUserShardUI = (0, $j4ply.useUserShardUI)();
    const content = (0, $4VmlX.useContent)();
    const [isHello] = (0, $j4ply.useIsHello)();
    const allItems = $71af45ffeeb47c72$var$useBody(content, serveUserShardUI);
    $71af45ffeeb47c72$var$useResetSessionAnalytics();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    $71af45ffeeb47c72$var$useAnalyticsEvents(fireAnalyticsEvent, commonAttributes, nonPrivacySafeAttributes);
    const resultOnClick = (0, $dSjat.useQuickFindResultOnClick)();
    const resultOnContextMenu = (0, $dSjat.useQuickFindResultOnContextMenu)();
    const resultOnHighlighted = (0, $dSjat.useQuickFindResultOnHighlighted)();
    const footerOnClick = (0, $dSjat.useQuickFindFooterOnClick)();
    const queryFiltersBody = (0, $fKnXN.useQueryFilterResults)({
        localQuery: localQuery,
        setLocalQuery: setLocalQuery,
        inputRef: inputRef
    });
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    let hasThirdPartyResults = false;
    const localDialogRef = (0, $gwFzn.useRef)(null);
    (0, $86ob4.useWidthObserverRegistration)((0, $3R0ts.SEARCH_DIALOG_WIDTH_OBSERVER_ID), localDialogRef);
    if (!content) return null;
    const { state: state } = content;
    const body = [];
    let searchResultItemBody;
    for (const content of allItems){
        if ((0, $5BL1t.isErrorItem)(content)) body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $47juE.ErrorScreen), {
            onRetry: retrySearch
        }, content.id));
        if ((0, $5BL1t.isLandingItem)(content)) body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $aBMZB.LandingScreen), {}, content.id));
        if ((0, $5BL1t.isNoResultsItem)(content)) body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $8SdvD.NoResultsScreen), {
            onRetry: retrySearch
        }, content.id));
        if ((0, $5BL1t.isHeadingItem)(content)) body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $39Swq.Heading), {
            id: content.id,
            text: content.data,
            includeInAnalytics: content.includeInAnalytics
        }, content.id));
        if ((0, $5BL1t.isSkeletonItem)(content)) body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $hDfbs.SearchResultSkeleton), {}, content.id));
        if ((0, $5BL1t.isRecentQueryItem)(content)) body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $8IQPm.RecentQuery), {
            result: content.data,
            state: state
        }, content.id));
        if ((0, $5BL1t.isRecentActivityItem)(content)) body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPvza.RecentActivity), {
            result: content.data,
            state: state,
            onClick: resultOnClick,
            onContextMenu: resultOnContextMenu,
            onHighlighted: resultOnHighlighted
        }, content.id));
        if ((0, $5BL1t.isSearchResultItem)(content)) {
            const productEntity = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lTdhv.ProductEntity), {
                result: content.data,
                state: state,
                onClick: resultOnClick,
                onContextMenu: resultOnContextMenu,
                onHighlighted: resultOnHighlighted
            }, content.id);
            if (serveUserShardModel) {
                if (!searchResultItemBody) {
                    searchResultItemBody = [];
                    body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Profiler), {
                        id: "QuickFindSearchDialogResults",
                        onRender: (_, phase, actualDuration)=>{
                            if (phase === 'mount' && localQuery.length) fireAnalyticsEvent((0, $5I2eK.onSearchResultsRendered)({
                                attributes: {
                                    ...commonAttributes,
                                    durationMs: actualDuration,
                                    hasThirdPartyResults: hasThirdPartyResults
                                },
                                nonPrivacySafeAttributes: nonPrivacySafeAttributes
                            }));
                        },
                        children: searchResultItemBody
                    }));
                }
                searchResultItemBody.push(productEntity);
                if ((0, $7ZetK.isSearchResultGraphEntity)(content.data)) hasThirdPartyResults = true;
            } else body.push(productEntity);
        }
        if ((0, $5BL1t.isPeopleAndTeamsItem)(content)) body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $fvCil.PeopleAndTeams), {
            result: content.data,
            state: state,
            onClick: resultOnClick,
            onContextMenu: resultOnContextMenu,
            onHighlighted: resultOnHighlighted
        }, content.id));
    }
    const footer = (()=>{
        // Post-query state with Confluence or Focus
        if ((primaryProduct === (0, $1yEFx.PrimaryProductKeys).Confluence || primaryProduct === (0, $1yEFx.PrimaryProductKeys).Focus) && (0, $aE5mL.isPostQueryState)(state)) return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $19BAV.default), {
                    requiredMode: (0, $9vOy1.ApplicationModes).Rovo,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cuvog.Divider), {}),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fscQt.SearchPageLink), {
                            state: state,
                            onClick: footerOnClick
                        })
                    ]
                }),
                !(0, $dh538.fg)('quick_find_filters') && (0, $aE5mL.isPostQueryLoadingOrResults)(state) && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cuvog.Divider), {}),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3qFOk.SearchPagePrimaryProductLink), {
                            state: state,
                            onClick: footerOnClick
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cuvog.Divider), {}),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d6thU.FeedbackFooter), {})
            ]
        });
        if (primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira) return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cuvog.Divider), {}),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fscQt.SearchPageLink), {
                    state: state,
                    onClick: footerOnClick
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a0YSD.JiraAdvancedSearchLink), {
                    state: state,
                    onClick: footerOnClick
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kMtrE.JiraSingleSiteSearch), {
                    state: state,
                    onClick: footerOnClick
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d6thU.FeedbackFooter), {})
            ]
        });
        // Pre-query footer
        return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $19BAV.default), {
                    requiredMode: (0, $9vOy1.ApplicationModes).Rovo,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cuvog.Divider), {}),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fscQt.SearchPageLink), {
                            state: state,
                            onClick: footerOnClick
                        })
                    ]
                }),
                !(0, $dh538.fg)('quick_find_filters') && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $19BAV.default), {
                    requiredMode: (0, $9vOy1.ApplicationModes).Unified,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cuvog.Divider), {}),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3qFOk.SearchPagePrimaryProductLink), {
                            state: state,
                            onClick: footerOnClick
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cuvog.Divider), {}),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d6thU.FeedbackFooter), {})
            ]
        });
    })();
    const isAIEnabled = isRovoLLMEnabled || isAdminHubAIEnabled;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $71af45ffeeb47c72$var$searchDialogStyles,
        "aria-label": intl.formatMessage((0, $iUdW4.messages).searchDialogAriaLabel),
        testId: 'search-dialog',
        ref: (0, $kIdP4.mergeRefs)(dialogRef, localDialogRef),
        id: dialogId,
        children: queryFiltersBody ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $71af45ffeeb47c72$var$searchResultsSectionStyles,
            children: queryFiltersBody
        }) : /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                    xcss: $71af45ffeeb47c72$var$searchResultsSectionStyles,
                    children: [
                        primaryProduct === (0, $1yEFx.PrimaryProductKeys).Assets && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2nHbb.AssetsUnavailableBanner), {}),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $19BAV.default), {
                            requiredMode: (0, $9vOy1.ApplicationModes).Rovo,
                            children: [
                                (0, $aE5mL.isPreQueryState)(state) && ((0, $dh538.fg)('3p_bulk_connect') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1nJM3.ErrorBoundary), {
                                    section: "QuickFindSearchDialogBulkConnectBanner",
                                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5Lref.BulkConnectBanner), {
                                                thirdPartyConfigs: thirdPartyConfigs,
                                                availableProducts: availableProducts,
                                                useNewlyConnectedProducts: (0, $dsrEB.useNewlyConnectedProducts),
                                                useLocalStorage: (0, $d5Ozh.useLocalStorageSearchPagePersistedState),
                                                useIsBulkConnectModalOpenQuickFind: (0, $4VmlX.useIsBulkConnectModalOpen),
                                                isOnSearchDialog: true
                                            }),
                                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $NvPpA.BulkConnectModal), {
                                                isOnSearchDialog: true
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1nJM3.ErrorBoundary), {
                                    section: "QuickFindSearchDialogOAuthContainer",
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5OFf.OAuthContainer), {
                                        isOnSearchDialog: true,
                                        thirdPartyConfigs: thirdPartyConfigs,
                                        availableProducts: availableProducts,
                                        isHello: isHello,
                                        useOAuthHandlers: (0, $gGFxq.useOAuthHandlers)
                                    })
                                })),
                                $71af45ffeeb47c72$export$50d89b0bfbd161a1(state, isAIEnabled) && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $e79Fp.RovoTipBanner), {}),
                                (0, $aE5mL.isPostQueryState)(state) && (0, $dh538.fg)('quick_find_filters') && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cu2Tg.QuickFindFilters), {}),
                                (0, $aE5mL.isPostQueryLoadingOrResults)(state) && !(0, $dh538.fg)('quick_find_filters') && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2FGXW.ProductFilterHeader), {
                                    availableProducts: availableProducts
                                })
                            ]
                        }),
                        (0, $aE5mL.isLoadingState)(state) && (0, $dh538.fg)('quick_find_metrics_using_ufo_react') && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwDOR.default), {
                            name: (0, $3R0ts.QUICK_FIND_LOADING_HOLD)
                        }),
                        body
                    ]
                }),
                footer
            ]
        })
    });
};
const $71af45ffeeb47c72$var$useBody = (content, serveUserShardUI)=>{
    const intl = (0, $dBxQj.default)();
    return (0, $gwFzn.useMemo)(()=>{
        if (!content) return [];
        const { state: state } = content;
        const items = [];
        const recentsHeadingItem = {
            id: 'recent-activities',
            type: 'heading',
            data: intl.formatMessage((0, $iUdW4.messages).recentsHeading)
        };
        const searchResultsHeadingItem = {
            id: 'search-results',
            type: 'heading',
            data: intl.formatMessage(serveUserShardUI ? (0, $iUdW4.messages).forYou : (0, $iUdW4.messages).searchResultsHeading)
        };
        if (state === (0, $aE5mL.State).PREQUERY_ERROR) items.push({
            id: 'error',
            type: 'error'
        });
        if (state === (0, $aE5mL.State).PREQUERY_LOADING) {
            items.push(...content.recentQueries.slice(0, 3));
            items.push(recentsHeadingItem);
            for(let i = 0; i < 7; i++)items.push({
                id: `skeleton-${i}`,
                type: 'skeleton'
            });
        }
        if (state === (0, $aE5mL.State).PREQUERY_NO_RESULTS) items.push({
            id: 'landing',
            type: 'landing'
        });
        if (state === (0, $aE5mL.State).PREQUERY_RESULTS) {
            items.push(...content.recentQueries.slice(0, 3));
            if (content.recentActivities.length > 0) {
                items.push(recentsHeadingItem);
                const filteredRecentActivities = content.recentActivities.filter((activity)=>activity.data.node.object.data !== null).slice(0, 7);
                items.push(...filteredRecentActivities);
            }
        }
        if (state === (0, $aE5mL.State).POSTQUERY_ERROR) items.push({
            id: 'error',
            type: 'error'
        });
        if (state === (0, $aE5mL.State).POSTQUERY_LOADING) {
            if (content.recentActivities.length > 0) {
                items.push(recentsHeadingItem);
                const filteredRecentActivities = content.recentActivities.filter((activity)=>activity.data.node.object.data !== null).slice(0, 5);
                items.push(...filteredRecentActivities);
            }
            items.push({
                ...searchResultsHeadingItem,
                includeInAnalytics: false
            });
            for(let i = 0; i < 5; i++)items.push({
                id: `skeleton-${i}`,
                type: 'skeleton'
            });
        }
        if (state === (0, $aE5mL.State).POSTQUERY_NO_RESULTS) items.push({
            id: 'no-results',
            type: 'no-results'
        });
        if (state === (0, $aE5mL.State).POSTQUERY_RESULTS) {
            const dedupedSearchResults = content.searchResults.filter((searchResult)=>{
                const isDuplicate = content.recentActivities.filter((activity)=>activity.data.node.object.data !== null).slice(0, 5).some((recentlyViewedResult)=>{
                    const activityObject = recentlyViewedResult.data.node.object;
                    const id = (0, $hWR4v.isGraphActivity)(activityObject) ? activityObject.data?.id : recentlyViewedResult.id;
                    return id === searchResult.id;
                });
                return searchResult.id && !isDuplicate;
            });
            const filteredSearchResults = dedupedSearchResults.filter((result)=>!(0, $4TTdD.isSearchConfluenceSpace)(result.data));
            const confluenceSpaceResult = dedupedSearchResults.find((result)=>(0, $4TTdD.isSearchConfluenceSpace)(result.data));
            if (content.recentActivities.length > 0) {
                items.push(recentsHeadingItem);
                const filteredRecentActivities = content.recentActivities.filter((activity)=>activity.data.node.object.data !== null).slice(0, 5);
                items.push(...filteredRecentActivities);
            }
            const showSearchResultsSection = Boolean(dedupedSearchResults.length + content.peopleAndTeams.length + content.recentQueries.length);
            if (showSearchResultsSection) {
                items.push(searchResultsHeadingItem);
                if (serveUserShardUI) items.push(...filteredSearchResults.slice(0, confluenceSpaceResult ? 10 : 11));
                else items.push(...filteredSearchResults.slice(0, confluenceSpaceResult ? 5 : 6));
                confluenceSpaceResult && items.push(confluenceSpaceResult);
                items.push(...content.peopleAndTeams.slice(0, 2));
                items.push(...content.recentQueries.slice(0, 1));
            }
        }
        return items;
    }, [
        content,
        intl,
        serveUserShardUI
    ]);
};
const $71af45ffeeb47c72$var$useAnalyticsEvents = (fireAnalyticsEvent, commonAttributes, nonPrivacySafeAttributes)=>{
    (0, $gwFzn.useEffect)(()=>{
        fireAnalyticsEvent((0, $fr375.onSearchDialogShown)({
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        return ()=>{
            fireAnalyticsEvent((0, $iEwMm.onSearchDialogDismissed)({
                attributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
        };
    // Only want these events to fire when the dialog opens and closes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
const $71af45ffeeb47c72$var$useResetSessionAnalytics = ()=>{
    const { refreshSearchSessionId: refreshSearchSessionId } = (0, $j4ply.useBootstrapActions)();
    const { resetQueryVersion: resetQueryVersion } = (0, $djVCD.useSearchActions)();
    (0, $gwFzn.useEffect)(()=>{
        refreshSearchSessionId();
        resetQueryVersion();
    }, [
        refreshSearchSessionId,
        resetQueryVersion
    ]);
};
const $71af45ffeeb47c72$export$50d89b0bfbd161a1 = (state, isAIEnabled = false)=>{
    const isCorrectState = (0, $aE5mL.isPreQueryState)(state) || (0, $aE5mL.isPostQueryLoadingOrResults)(state);
    if ((0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25')) return isCorrectState && isAIEnabled;
    return isCorrectState;
};

});
parcelRegister("5Lref", function(module, exports) {

$parcel$export(module.exports, "BulkConnectBanner", () => $3b2b2e90ee1bdc57$export$df17046610238203);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $1yEFx = parcelRequire("1yEFx");

var $f2dRI = parcelRequire("f2dRI");

var $gweXX = parcelRequire("gweXX");

var $h9iS7 = parcelRequire("h9iS7");

var $8SFFA = parcelRequire("8SFFA");
const $3b2b2e90ee1bdc57$var$bulkConnectBannerContainerStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.075',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $3b2b2e90ee1bdc57$export$df17046610238203 = ({ thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts, useNewlyConnectedProducts: useNewlyConnectedProducts, isOnSearchDialog: isOnSearchDialog, useLocalStorage: useLocalStorage, useIsBulkConnectModalOpenQuickFind: useIsBulkConnectModalOpenQuickFind, useBulkConnectModalOpenState: useBulkConnectModalOpenState })=>{
    const allProducts = (0, $1yEFx.useProductConfigs)();
    const newlyConnectedProducts = useNewlyConnectedProducts();
    // Get Full Page Search modal state if available
    const fullPageSearchModalState = useBulkConnectModalOpenState?.() ?? {
        isBulkConnectModalOpen: false,
        setIsBulkConnectModalOpen: ()=>{}
    };
    // For QuickFind, use store state store/quick-find. For Full Page Search, use store/3p-bulk-connect
    const modalState = useIsBulkConnectModalOpenQuickFind?.() ?? [
        fullPageSearchModalState.isBulkConnectModalOpen,
        {
            setIsBulkConnectModalOpen: fullPageSearchModalState.setIsBulkConnectModalOpen
        }
    ];
    const [_, { setIsBulkConnectModalOpen: setIsBulkConnectModalOpen }] = modalState;
    const { bannerType: bannerType, dismissBanner: dismissBanner } = (0, $f2dRI.useBulkConnectBanner)({
        thirdPartyConfigs: thirdPartyConfigs,
        availableProducts: availableProducts,
        newlyConnectedProducts: newlyConnectedProducts,
        useLocalStorage: useLocalStorage
    });
    if (bannerType === (0, $gweXX.BannerType).NONE) return null;
    const handleAuthorize = ()=>{
        setIsBulkConnectModalOpen(true);
    };
    const messageContent = (0, $8SFFA.getBannerContent)(newlyConnectedProducts, allProducts, bannerType);
    if (!messageContent) return null;
    const messageProps = {
        content: messageContent,
        isBulkConnect: true,
        onAuthorize: handleAuthorize,
        onDismiss: dismissBanner
    };
    return isOnSearchDialog ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $3b2b2e90ee1bdc57$var$bulkConnectBannerContainerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h9iS7.OAuthMessage), {
            ...messageProps,
            isOnSearchDialog: true
        })
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h9iS7.OAuthMessage), {
            ...messageProps
        })
    });
};

});
parcelRegister("8SFFA", function(module, exports) {

$parcel$export(module.exports, "getBannerContent", () => $c1a60f43d48fd8c6$export$f1ebf496f3ee873f);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $tvI67 = parcelRequire("tvI67");

var $9yyKc = parcelRequire("9yyKc");

var $gweXX = parcelRequire("gweXX");

var $kdJBj = parcelRequire("kdJBj");
const $c1a60f43d48fd8c6$var$getProductDisplayName = (product, products)=>{
    return product === 'sharepoint' ? 'SharePoint' : products[product]?.displayName || '';
};
const $c1a60f43d48fd8c6$export$f1ebf496f3ee873f = (newlyAddedProducts, allProducts, bannerType)=>{
    if (bannerType === (0, $gweXX.BannerType).NONE) return null;
    if (bannerType === (0, $gweXX.BannerType).INITIAL) return {
        title: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $kdJBj.messages).initialBannerTitle
        }),
        description: null,
        connectText: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $kdJBj.messages).initialBannerConnectText
        }),
        MessageIcon: (0, $9yyKc.RovoLogoFromLogo)((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), 'App'),
        iconNeedsPadding: true
    };
    // it is a secondary banner
    const newlyAddedProductCount = newlyAddedProducts.length;
    if (newlyAddedProductCount === 1) {
        const product = newlyAddedProducts[0];
        const productString = $c1a60f43d48fd8c6$var$getProductDisplayName(product, allProducts);
        const Icon = allProducts[product]?.Icon;
        return {
            title: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $kdJBj.messages).singleProductBannerTitle,
                values: {
                    product: productString
                }
            }),
            description: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $kdJBj.messages).singleProductBannerDescription,
                values: {
                    product: productString
                }
            }),
            connectText: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $kdJBj.messages).singleProductBannerConnectText
            }),
            MessageIcon: Icon
        };
    }
    // it is a secondary banner with multiple new products
    return {
        title: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $kdJBj.messages).multipleProductsBannerTitle,
            values: {
                count: newlyAddedProductCount
            }
        }),
        description: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $kdJBj.messages).multipleProductsBannerDescription
        }),
        connectText: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $kdJBj.messages).multipleProductsBannerConnectText
        }),
        MessageIcon: (0, $9yyKc.RovoLogoFromLogo)((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), 'App'),
        iconNeedsPadding: true
    };
};

});
parcelRegister("kdJBj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b22eb13e43ff38f6$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $b22eb13e43ff38f6$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    initialBannerTitle: {
        id: "search.bulk-connect-banner.initial.banner.title",
        defaultMessage: "Your teammates leverage top apps to do their best work ever!"
    },
    initialBannerConnectText: {
        id: "search.bulk-connect-banner.initial.banner.connect.text",
        defaultMessage: "Let\u2019s connect them"
    },
    singleProductBannerTitle: {
        id: "search.bulk-connect-banner.single.product.banner.title",
        defaultMessage: "Your admin just added {product}!"
    },
    singleProductBannerDescription: {
        id: "search.bulk-connect-banner.single.product.banner.description",
        defaultMessage: "Connect your account to get missing results"
    },
    singleProductBannerConnectText: {
        id: "search.bulk-connect-banner.single.product.banner.connect.text",
        defaultMessage: "Connect"
    },
    multipleProductsBannerTitle: {
        id: "search.bulk-connect-banner.multiple.products.banner.title",
        defaultMessage: "{count, plural, one {Your admin approved # new app!} other {Your admin approved # new apps!}}"
    },
    multipleProductsBannerDescription: {
        id: "search.bulk-connect-banner.multiple.products.banner.description",
        defaultMessage: "Connect your accounts to get missing results"
    },
    multipleProductsBannerConnectText: {
        id: "search.bulk-connect-banner.multiple.products.banner.connect.text",
        defaultMessage: "Let's do this"
    }
});

});



parcelRegister("39Swq", function(module, exports) {

$parcel$export(module.exports, "Heading", () => $5cfb43da7e344c6a$export$a8a3e93435678ff9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $9wmQG = parcelRequire("9wmQG");
const $5cfb43da7e344c6a$var$containerStyles = (0, $ecnYn.xcss)({
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100'
});
const $5cfb43da7e344c6a$var$headingStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small',
    fontWeight: 'font.weight.semibold',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    width: '100%',
    padding: 'space.100',
    userSelect: 'none'
});
const $5cfb43da7e344c6a$export$a8a3e93435678ff9 = ({ id: id, text: text, includeInAnalytics: includeInAnalytics = true })=>{
    const headingWithoutAnalyticsWrapper = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $5cfb43da7e344c6a$var$containerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $5cfb43da7e344c6a$var$headingStyles,
            children: text
        })
    });
    return includeInAnalytics ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9wmQG.SearchDialogHeaderAnalyticsWrapper), {
        id: id,
        children: headingWithoutAnalyticsWrapper
    }) : headingWithoutAnalyticsWrapper;
};

});

parcelRegister("kIdP4", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $1c4bb92f3ae586c5$export$c9058316764c140e);
const $1c4bb92f3ae586c5$export$c9058316764c140e = (...refs)=>(node)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(node);
            else if (ref != null) ref.current = node;
        });
    };

});

parcelRegister("iEwMm", function(module, exports) {

$parcel$export(module.exports, "onSearchDialogDismissed", () => $57230a101297e6c3$export$bcff6baaecbbc96);
const $57230a101297e6c3$export$bcff6baaecbbc96 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'dismissed',
        actionSubject: `searchDialog`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("fr375", function(module, exports) {

$parcel$export(module.exports, "onSearchDialogShown", () => $de62c0fb6467b42a$export$39e1d377a6a3de5d);
const $de62c0fb6467b42a$export$39e1d377a6a3de5d = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        action: 'shown',
        actionSubject: `searchDialog`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("5I2eK", function(module, exports) {

$parcel$export(module.exports, "onSearchResultsRendered", () => $71aa6db8e0b63681$export$ccb93b1cc213aa40);
const $71aa6db8e0b63681$export$ccb93b1cc213aa40 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'rendered',
        actionSubject: `searchResults`,
        actionSubjectId: `postQuerySearchResults`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("19BAV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c33ab075ce0a02db$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $j4ply = parcelRequire("j4ply");
/**
 * A component to control rendering of Rovo/Unified Search components.
 * To be used when a component/experience is only available in a specific application mode.
 *
 * Example usage:
 * <ShowIfEligible requiredMode={ApplicationModes.Rovo}>
 *   <SomeCoolRovoFeature />
 * </ShowIfEligible>
 */ const $c33ab075ce0a02db$var$ShowIfEligible = ({ requiredMode: requiredMode, children: children })=>{
    const currentMode = (0, $j4ply.useApplicationMode)();
    if (currentMode === requiredMode) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
    return null;
};
var $c33ab075ce0a02db$export$2e2bcd8739ae039 = $c33ab075ce0a02db$var$ShowIfEligible;

});

parcelRegister("gGFxq", function(module, exports) {

$parcel$export(module.exports, "useOAuthHandlers", () => $b53784fc0aedebc4$export$4de3515a937b03f6);
$parcel$export(module.exports, "useIsUserOAuthed", () => $b53784fc0aedebc4$export$e90b3746b95097c9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dpPtd = parcelRequire("dpPtd");

var $jzhw9 = parcelRequire("jzhw9");

var $5L38b = parcelRequire("5L38b");

var $3uVVG = parcelRequire("3uVVG");

var $6fnsQ = parcelRequire("6fnsQ");

var $kNUwp = parcelRequire("kNUwp");
var $johDC = parcelRequire("johDC");
var $flR86 = parcelRequire("flR86");

var $1yEFx = parcelRequire("1yEFx");

var $7WbA8 = parcelRequire("7WbA8");

var $dnIVK = parcelRequire("dnIVK");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $4VmlX = parcelRequire("4VmlX");
const $b53784fc0aedebc4$var$refreshOAuthCache = (product, userId, cloudId, thirdPartyConfigs)=>{
    const key = (0, $kNUwp.generate3pHash)(userId, cloudId);
    const newThirdPartyConfigs = {
        ...thirdPartyConfigs
    };
    const item = localStorage.getItem((0, $kNUwp.SEARCH_3P_CONFIG));
    if (!item) return newThirdPartyConfigs;
    let object;
    try {
        object = JSON.parse(item);
    } catch (_) {
        return newThirdPartyConfigs;
    }
    const thirdPartyConfigCache = object?.[key]?.result?.find((config)=>config.id === product || /// can be removed after statis config is rolled out
        config.type.includes(product) || config.integrationId.includes('google') && product === 'drive');
    if (!thirdPartyConfigCache) return newThirdPartyConfigs;
    thirdPartyConfigCache.isUserOAuthed = true;
    const updatedConfig = newThirdPartyConfigs[product];
    if (updatedConfig) updatedConfig.userNeedsOAuth = false;
    localStorage.setItem((0, $kNUwp.SEARCH_3P_CONFIG), JSON.stringify(object));
    return newThirdPartyConfigs;
};
const $b53784fc0aedebc4$export$4de3515a937b03f6 = ({ product: product, successFlagTitle: successFlagTitle, failFlagTitle: failFlagTitle, outboundAuthUrl: outboundAuthUrl, onCompletedAction: onCompletedAction = ()=>{}, onDismissAction: onDismissAction = ()=>{}, onFailAction: onFailAction = ()=>{}, isOnSearchDialog: isOnSearchDialog, isBulkConnect: isBulkConnect, query: query = '' })=>{
    const [{ cloudId: cloudId, user: user, thirdPartyConfigs: thirdPartyConfigs }, { setState: setState }] = (0, $j4ply.useBootstrap)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const userId = user?.id;
    const { retrySearch: retrySearch } = (0, $djVCD.useSearchActions)();
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const onOAuthStarted = (0, $dnIVK.useFireOAuthStarted)({
        product: product || '',
        cloudId: cloudId || '',
        isOnSearchDialog: isOnSearchDialog
    });
    const onOAuthCompleted = (0, $dnIVK.useFireOAuthCompleted)({
        product: product || '',
        cloudId: cloudId || '',
        isOnSearchDialog: isOnSearchDialog
    });
    const onSuccess = ()=>{
        onOAuthCompleted();
        if (product === 'slack') (0, $flR86.sendSlackAuthSuccessRequest)({
            cloudId: cloudId
        });
        onCompletedAction();
        showFlag({
            title: successFlagTitle,
            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jzhw9))), {
                spacing: "spacious",
                label: "",
                color: `var(--ds-icon-success, ${(0, $6fnsQ.G300)})`
            }),
            isAutoDismiss: true
        });
        const newOutboundAuthConfigs = $b53784fc0aedebc4$var$refreshOAuthCache(product, userId || '', cloudId || '', thirdPartyConfigs || {});
        setState({
            thirdPartyConfigs: newOutboundAuthConfigs
        });
        (0, $johDC.cache).clear();
        retrySearch();
        if (!isBulkConnect && isOnSearchDialog) {
            setQuickFindOpen(false);
            /* TODO: use onNavigate callback once bootstrap store is lifted. Details in https://hello.atlassian.net/wiki/spaces/CASE/pages/4670854655/3P+Discoverability+Bug
      const onNavigateCallback =
      	typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
      onNavigateCallback(
      	generateSearchUrl({
      		...queryParams,
      		text: query,
      		product: product,
      	}),
      	'push',
      );
      */ const searchUrl = generateSearchUrl({
                ...queryParams,
                text: query,
                product: product
            });
            window.location.href = searchUrl;
        }
    };
    const onFail = ()=>{
        onFailAction();
        showFlag({
            title: failFlagTitle,
            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5L38b))), {
                spacing: "spacious",
                label: "",
                color: `var(--ds-icon-danger, ${(0, $6fnsQ.R400)})`
            }),
            isAutoDismiss: true
        });
    };
    const onAuthorize = ()=>{
        onOAuthStarted();
        (0, $3uVVG.auth)(outboundAuthUrl).then(onSuccess).catch(onFail);
    };
    const onDismiss = ()=>{
        onDismissAction();
    };
    return {
        onAuthorize: onAuthorize,
        onDismiss: onDismiss,
        onSuccess: onSuccess,
        onFail: onFail
    };
};
const $b53784fc0aedebc4$export$e90b3746b95097c9 = (productKey)=>{
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    let userNeedsOAuth, outboundAuthUrl;
    if (!productKey || !(0, $1yEFx.is3pProductKey)(productKey)) return {
        userNeedsOAuth: userNeedsOAuth,
        outboundAuthUrl: outboundAuthUrl
    };
    const productOutboundAuthConfig = thirdPartyConfigs[productKey];
    if (!productOutboundAuthConfig) return {
        userNeedsOAuth: userNeedsOAuth,
        outboundAuthUrl: outboundAuthUrl
    };
    userNeedsOAuth = productOutboundAuthConfig.userNeedsOAuth;
    outboundAuthUrl = productOutboundAuthConfig.oAuthOutboundUrl;
    return {
        userNeedsOAuth: userNeedsOAuth,
        outboundAuthUrl: outboundAuthUrl
    };
};

});
parcelRegister("flR86", function(module, exports) {

$parcel$export(module.exports, "sendSlackAuthSuccessRequest", () => $d6887d0799a850df$export$e5c324cf2a7795e0);
const $d6887d0799a850df$export$e5c324cf2a7795e0 = ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId })=>{
    const relativeSlackUrl = `/gateway/api/third-party-user-auth/slack/user-authed`;
    const baseUrl = absoluteUrl || relativeSlackUrl;
    const url = `${baseUrl}/${cloudId}`;
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

});

parcelRegister("dnIVK", function(module, exports) {

$parcel$export(module.exports, "useFireOAuthStarted", () => $8aec6073a00f3ac5$export$694cb0e3f167dbc8);
$parcel$export(module.exports, "useFireOAuthCompleted", () => $8aec6073a00f3ac5$export$cbd7e681ca5b8fd4);

var $gwFzn = parcelRequire("gwFzn");

var $ckkm9 = parcelRequire("ckkm9");

var $3CshZ = parcelRequire("3CshZ");
const $8aec6073a00f3ac5$export$694cb0e3f167dbc8 = ({ cloudId: cloudId, product: product, isOnSearchDialog: isOnSearchDialog })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const callback = (0, $gwFzn.useCallback)(()=>{
        fireAnalyticsEvent((0, $ckkm9.onOAuthStarted)({
            cloudId: cloudId,
            product: product,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog
    ]);
    return callback;
};
const $8aec6073a00f3ac5$export$cbd7e681ca5b8fd4 = ({ cloudId: cloudId, product: product, isOnSearchDialog: isOnSearchDialog })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const callback = (0, $gwFzn.useCallback)(()=>{
        fireAnalyticsEvent((0, $ckkm9.onOAuthCompleted)({
            cloudId: cloudId,
            product: product,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog
    ]);
    return callback;
};

});
parcelRegister("ckkm9", function(module, exports) {

$parcel$export(module.exports, "onOAuthStarted", () => $07e03f86f3cec1e3$export$54863d2084195ac7);
$parcel$export(module.exports, "onOAuthCompleted", () => $07e03f86f3cec1e3$export$1caeb8956b6720dc);

var $6yNqK = parcelRequire("6yNqK");
const $07e03f86f3cec1e3$var$SEARCH_DIALOG_EVENT_SOURCE = 'searchDialog';
const $07e03f86f3cec1e3$export$54863d2084195ac7 = ({ cloudId: cloudId, product: product, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog })=>{
    return {
        source: isOnSearchDialog ? $07e03f86f3cec1e3$var$SEARCH_DIALOG_EVENT_SOURCE : (0, $6yNqK.EVENT_SOURCE),
        action: 'clicked',
        actionSubject: 'thirdPartyOAuth',
        attributes: {
            additionalAttributes: {
                cloudId: cloudId,
                product: product
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'track'
    };
};
const $07e03f86f3cec1e3$export$1caeb8956b6720dc = ({ cloudId: cloudId, product: product, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog })=>{
    return {
        source: isOnSearchDialog ? $07e03f86f3cec1e3$var$SEARCH_DIALOG_EVENT_SOURCE : (0, $6yNqK.EVENT_SOURCE),
        action: 'completed',
        actionSubject: 'thirdPartyOAuth',
        attributes: {
            additionalAttributes: {
                cloudId: cloudId,
                product: product
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'operational'
    };
};

});



parcelRegister("dSjat", function(module, exports) {

$parcel$export(module.exports, "getActionSubjectId", () => $6926da8980239f02$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "useQuickFindResultOnClick", () => $6926da8980239f02$export$8a7aec9b1f72e063);
$parcel$export(module.exports, "useQuickFindResultOnContextMenu", () => $6926da8980239f02$export$bc76edbc675e4404);
$parcel$export(module.exports, "useQuickFindResultOnHighlighted", () => $6926da8980239f02$export$3f21dcaf9a5530d9);
$parcel$export(module.exports, "useQuickFindFooterOnClick", () => $6926da8980239f02$export$eb0ecd911360e8d4);

var $gwFzn = parcelRequire("gwFzn");

var $1SV4e = parcelRequire("1SV4e");

var $2vZke = parcelRequire("2vZke");

var $782qq = parcelRequire("782qq");

var $dQShB = parcelRequire("dQShB");

var $3RYZm = parcelRequire("3RYZm");

var $aE5mL = parcelRequire("aE5mL");

var $j4ply = parcelRequire("j4ply");

var $4VmlX = parcelRequire("4VmlX");

var $inrbX = parcelRequire("inrbX");
function $6926da8980239f02$export$b6f8db3ad0711b02(state) {
    switch(state){
        case (0, $aE5mL.State).PREQUERY_RESULTS:
            return 'preQuerySearchResults';
        case (0, $aE5mL.State).PREQUERY_LOADING:
            return 'preQueryLoadingSearchResults';
        case (0, $aE5mL.State).POSTQUERY_LOADING:
            return 'cachedResults';
        case (0, $aE5mL.State).POSTQUERY_RESULTS:
            return 'postQuerySearchResults';
        default:
            return '';
    }
}
const $6926da8980239f02$export$8a7aec9b1f72e063 = ()=>{
    const [user] = (0, $j4ply.useUser)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    return (0, $gwFzn.useCallback)((props)=>{
        const { event: event, data: data, state: state, additionalAnalyticsAttributes: additionalAnalyticsAttributes, options: options } = props;
        const { addCurrentQueryAsRecentQuery: addCurrentQueryAsRecentQuery = true } = options || {};
        const newTab = event && (event.ctrlKey || event.metaKey || event.shiftKey);
        if (!newTab) setQuickFindOpen(false);
        if (addCurrentQueryAsRecentQuery) {
            const trimmedInuptQuery = quickFindQuery.trim();
            if (trimmedInuptQuery !== '' && user && user.id && primaryProduct) {
                (0, $1SV4e.addRecentSearch)(trimmedInuptQuery, user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
                updateRecentQueries?.();
            }
        }
        const actionSubjectId = $6926da8980239f02$export$b6f8db3ad0711b02(state);
        fireAnalyticsEvent((0, $3RYZm.onSearchDialogResultSelected)({
            actionSubjectId: actionSubjectId,
            attributes: {
                ...commonAttributes,
                ...additionalAnalyticsAttributes,
                ...data
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        quickFindQuery,
        nonPrivacySafeAttributes,
        primaryProduct,
        setQuickFindOpen,
        updateRecentQueries,
        user
    ]);
};
const $6926da8980239f02$export$bc76edbc675e4404 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    return (0, $gwFzn.useCallback)((props)=>{
        const { data: data, state: state, additionalAnalyticsAttributes: additionalAnalyticsAttributes } = props;
        const actionSubjectId = $6926da8980239f02$export$b6f8db3ad0711b02(state);
        fireAnalyticsEvent((0, $782qq.onSearchDialogResultContextMenuOpened)({
            actionSubjectId: actionSubjectId,
            attributes: {
                ...commonAttributes,
                ...additionalAnalyticsAttributes,
                ...data
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes
    ]);
};
const $6926da8980239f02$export$3f21dcaf9a5530d9 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    return (0, $gwFzn.useCallback)((props)=>{
        const { data: data, state: state, additionalAnalyticsAttributes: additionalAnalyticsAttributes } = props;
        const actionSubjectId = $6926da8980239f02$export$b6f8db3ad0711b02(state);
        fireAnalyticsEvent((0, $dQShB.onSearchDialogResultHighlighted)({
            actionSubjectId: actionSubjectId,
            attributes: {
                ...commonAttributes,
                ...additionalAnalyticsAttributes,
                ...data
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes
    ]);
};
const $6926da8980239f02$export$eb0ecd911360e8d4 = ()=>{
    const [user] = (0, $j4ply.useUser)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    return (0, $gwFzn.useCallback)((props)=>{
        const { event: event, state: state, options: options, actionSubjectId: actionSubjectId } = props;
        const { addCurrentQueryAsRecentQuery: addCurrentQueryAsRecentQuery = true } = options || {};
        const newTab = event.ctrlKey || event.metaKey || event.shiftKey;
        if (!newTab) setQuickFindOpen(false);
        if (addCurrentQueryAsRecentQuery) {
            const trimmedInputQuery = quickFindQuery.trim();
            if (trimmedInputQuery !== '' && user && user.id && primaryProduct) {
                (0, $1SV4e.addRecentSearch)(trimmedInputQuery, user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
                updateRecentQueries?.();
            }
        }
        if (!primaryProduct) return;
        fireAnalyticsEvent((0, $2vZke.onAdvancedSearchLinkSelected)({
            actionSubjectId: actionSubjectId,
            attributes: {
                ...commonAttributes,
                trigger: 'click',
                newTab: newTab,
                isLoading: state === (0, $aE5mL.State).PREQUERY_LOADING || state === (0, $aE5mL.State).POSTQUERY_LOADING
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        quickFindQuery,
        nonPrivacySafeAttributes,
        primaryProduct,
        setQuickFindOpen,
        updateRecentQueries,
        user
    ]);
};

});
parcelRegister("2vZke", function(module, exports) {

$parcel$export(module.exports, "onAdvancedSearchLinkSelected", () => $b2e1078ac279219a$export$50f1b1860bee88e0);
const $b2e1078ac279219a$export$50f1b1860bee88e0 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, actionSubjectId: actionSubjectId })=>({
        eventType: 'track',
        action: 'selected',
        actionSubject: 'advancedSearchLink',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("782qq", function(module, exports) {

$parcel$export(module.exports, "onSearchDialogResultContextMenuOpened", () => $bb6e90fe17bdbf50$export$4d9e9e3a052b2865);
const $bb6e90fe17bdbf50$export$4d9e9e3a052b2865 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'contextMenu opened',
        actionSubject: 'searchResult',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("dQShB", function(module, exports) {

$parcel$export(module.exports, "onSearchDialogResultHighlighted", () => $a6985f2e364fb5e8$export$d17f8c02a91cd2a5);
const $a6985f2e364fb5e8$export$d17f8c02a91cd2a5 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'highlighted',
        actionSubject: 'searchResult',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("3RYZm", function(module, exports) {

$parcel$export(module.exports, "onSearchDialogResultSelected", () => $dd727cd9033cfd92$export$1d3be7f4bb8882c3);
const $dd727cd9033cfd92$export$1d3be7f4bb8882c3 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'selected',
        actionSubject: 'searchResult',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});


parcelRegister("NvPpA", function(module, exports) {

$parcel$export(module.exports, "BulkConnectModal", () => $d2d166e4ebe22d13$export$617e3c82390dc021);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6xdDU = parcelRequire("6xdDU");

var $1yEFx = parcelRequire("1yEFx");

var $bXBX8 = parcelRequire("bXBX8");

var $dsrEB = parcelRequire("dsrEB");

var $gGFxq = parcelRequire("gGFxq");

var $j4ply = parcelRequire("j4ply");

var $d5Ozh = parcelRequire("d5Ozh");

var $4VmlX = parcelRequire("4VmlX");
const $d2d166e4ebe22d13$export$617e3c82390dc021 = ({ isOnSearchDialog: isOnSearchDialog })=>{
    const [{ thirdPartyConfigs: thirdPartyConfigs, products: availableProducts }] = (0, $j4ply.useBootstrap)();
    const newlyConnectedProducts = (0, $dsrEB.useNewlyConnectedProducts)();
    const availableProductsAs3P = availableProducts.filter((productKey)=>(0, $1yEFx.is3pProductKey)(productKey));
    // eslint-disable-next-line @atlassian/search-common/no-use-local-storage
    const [storedState, setState] = (0, $d5Ozh.useLocalStorageSearchPagePersistedState)();
    const quickFindState = (0, $4VmlX.useIsBulkConnectModalOpen)();
    const fullPageState = (0, $dsrEB.useBulkConnectModalOpenState)();
    const [isBulkConnectModalOpen, { setIsBulkConnectModalOpen: setIsBulkConnectModalOpen }] = isOnSearchDialog ? quickFindState : [
        fullPageState.isBulkConnectModalOpen,
        {
            setIsBulkConnectModalOpen: fullPageState.setIsBulkConnectModalOpen
        }
    ];
    const onCloseModal = (0, $gwFzn.useCallback)((wasConnected, closedByButton)=>{
        if (wasConnected && closedByButton) setState({
            ...storedState,
            bulkConnectBanner: {
                initialBannerDismissed: true,
                secondaryBannerDismissed: true
            }
        });
        setIsBulkConnectModalOpen(false);
    }, [
        setIsBulkConnectModalOpen,
        setState,
        storedState
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6xdDU.default), {
        children: isBulkConnectModalOpen && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bXBX8.BulkConnectDialog), {
            availableProducts: availableProductsAs3P,
            newlyConnected: newlyConnectedProducts,
            onClose: onCloseModal,
            thirdPartyConfigs: thirdPartyConfigs,
            useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
            useInitializeBulkConnect: (0, $dsrEB.useInitializeBulkConnect),
            useBulkConnectState: (0, $dsrEB.useBulkConnectState)
        })
    });
};

});
parcelRegister("bXBX8", function(module, exports) {

$parcel$export(module.exports, "BulkConnectDialog", () => $0ed0ea59341156e8$export$7cf36e4566bf969a);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $ccHMk = parcelRequire("ccHMk");

var $jluld = parcelRequire("jluld");

var $gj7hi = parcelRequire("gj7hi");

var $ekolh = parcelRequire("ekolh");
var $1DHa6 = parcelRequire("1DHa6");
var $8o1lj = parcelRequire("8o1lj");
var $9ot3w = parcelRequire("9ot3w");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $cwkWT = parcelRequire("cwkWT");
var $dcJ7R = parcelRequire("dcJ7R");
var $bWLcG = parcelRequire("bWLcG");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $4noo5 = parcelRequire("4noo5");

var $1yEFx = parcelRequire("1yEFx");

var $fwCi9 = parcelRequire("fwCi9");

var $kiASw = parcelRequire("kiASw");

var $7l75S = parcelRequire("7l75S");

var $bKNBB = parcelRequire("bKNBB");
const $0ed0ea59341156e8$var$titleStyles = (0, $ecnYn.xcss)({
    color: 'color.text',
    font: 'font.heading.medium',
    fontFamily: 'font.family.brand.heading',
    fontWeight: 'font.weight.medium',
    paddingBottom: 'space.200',
    width: '100%'
});
const $0ed0ea59341156e8$var$subheadingStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    font: 'font.body',
    fontFamily: 'font.family.brand.body',
    fontWeight: 'font.weight.regular',
    paddingBottom: 'space.200',
    width: '100%'
});
const $0ed0ea59341156e8$var$inputStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100',
    color: 'color.text.subtlest'
});
const $0ed0ea59341156e8$var$iconStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.025',
    paddingRight: 'space.025'
});
const $0ed0ea59341156e8$var$searchBarStyles = (0, $ecnYn.xcss)({
    width: '100%',
    borderRadius: '5px',
    border: '1px solid',
    borderColor: 'color.border.input',
    background: "var(--ds-background-input, #FFFFFF)"
});
//makes product tiles grid display responsive
const $0ed0ea59341156e8$var$productTileGridStyles = (0, $ecnYn.xcss)({
    gridTemplateColumns: 'repeat(5, 1fr)',
    // 5 in full size / default
    [(0, $bWLcG.media).above.xxs]: {
        gridTemplateColumns: 'repeat(2, 1fr)'
    },
    [(0, $bWLcG.media).above.xs]: {
        gridTemplateColumns: 'repeat(3, 1fr)'
    },
    [(0, $bWLcG.media).above.sm]: {
        gridTemplateColumns: 'repeat(4, 1fr)'
    },
    [(0, $bWLcG.media).above.md]: {
        gridTemplateColumns: 'repeat(5, 1fr)'
    },
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
});
const $0ed0ea59341156e8$var$noResultsContainerStyles = (0, $ecnYn.xcss)({
    alignContent: 'center',
    alignItems: 'center',
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
});
const $0ed0ea59341156e8$var$noResultsImageStyles = (0, $ecnYn.xcss)({
    height: '104px',
    width: '104px'
});
const $0ed0ea59341156e8$var$noResultsTextStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    fontFamily: 'font.family.brand.body',
    fontWeight: 'font.weight.medium'
});
const $0ed0ea59341156e8$export$7cf36e4566bf969a = ({ availableProducts: availableProducts, newlyConnected: newlyConnected, onClose: onClose, thirdPartyConfigs: thirdPartyConfigs, useOAuthHandlers: useOAuthHandlers, useInitializeBulkConnect: useInitializeBulkConnect, useBulkConnectState: useBulkConnectState, isOnSearchDialog: isOnSearchDialog })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    useInitializeBulkConnect(availableProducts, newlyConnected);
    const productOrder = useBulkConnectState().productOrder;
    const [productsToRender, setProductsToRender] = (0, $gwFzn.useState)(productOrder);
    const productConnectedInSession = useBulkConnectState().productConnectedInSession;
    const onChange = (e)=>{
        const input = e.currentTarget.value.toLowerCase().trim();
        const filteredProductsToRender = input ? productOrder.filter((productKey)=>{
            const displayName = thirdPartyConfigs[productKey] !== thirdPartyConfigs[(0, $1yEFx.ProductKeys3P).ConfluenceDC] ? thirdPartyConfigs[productKey]?.displayName : thirdPartyConfigs?.[(0, $1yEFx.ProductKeys3P).ConfluenceDC]?.workspaceName;
            return typeof displayName === 'string' && displayName.toLowerCase().trim().includes(input);
        }) : productOrder;
        setProductsToRender(filteredProductsToRender);
    };
    const renderProductTiles = (0, $gwFzn.useMemo)(()=>{
        if (productsToRender.length === 0) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $0ed0ea59341156e8$var$noResultsContainerStyles,
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
                space: "space.150",
                alignBlock: "center",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $0ed0ea59341156e8$var$noResultsImageStyles,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gj7hi.default), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($7l75S))),
                            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($kiASw))),
                            role: "presentation"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $0ed0ea59341156e8$var$noResultsTextStyles,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $bKNBB.messages).noResults
                        })
                    })
                ]
            })
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cwkWT.default), {
            xcss: $0ed0ea59341156e8$var$productTileGridStyles,
            gap: "space.150",
            children: productsToRender.map((productKey)=>{
                let config = thirdPartyConfigs[productKey];
                if (config) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwCi9.ProductTile), {
                    icon: config.searchResultIcon && productKey !== (0, $1yEFx.ProductKeys3P).ConfluenceDC ? config.searchResultIcon : config.icon,
                    productName: config?.displayName,
                    productKey: productKey,
                    url: config?.oAuthOutboundUrl ?? '',
                    newlyConnected: newlyConnected.includes(productKey),
                    useOAuthHandlers: useOAuthHandlers,
                    useBulkConnectState: useBulkConnectState,
                    isOnSearchDialog: isOnSearchDialog,
                    thirdPartyConfigs: thirdPartyConfigs
                });
            })
        });
    }, [
        productsToRender,
        thirdPartyConfigs,
        newlyConnected,
        useOAuthHandlers,
        useBulkConnectState,
        isOnSearchDialog
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $ekolh.default), {
        onClose: (e)=>onClose(productConnectedInSession, false),
        width: 'x-large',
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9ot3w.default), {
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
                    grow: "fill",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $0ed0ea59341156e8$var$titleStyles,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                ...(0, $bKNBB.messages).modalTitle
                            })
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $0ed0ea59341156e8$var$subheadingStyles,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                ...(0, $bKNBB.messages).modalSubheading
                            })
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $0ed0ea59341156e8$var$searchBarStyles,
                            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                                space: "space.025",
                                xcss: $0ed0ea59341156e8$var$inputStyles,
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                        xcss: $0ed0ea59341156e8$var$iconStyles,
                                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                                            label: formatMessage((0, $bKNBB.messages).searchIconLabel)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4noo5.default), {
                                        placeholder: formatMessage((0, $bKNBB.messages).searchPlaceholder),
                                        appearance: "none",
                                        onChange: onChange
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1DHa6.default), {
                children: renderProductTiles
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8o1lj.default), {
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                    gap: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                            onClick: (e)=>onClose(productConnectedInSession, true),
                            appearance: "subtle",
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                ...(0, $bKNBB.messages).cancel
                            })
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                            onClick: (e)=>onClose(productConnectedInSession, true),
                            appearance: "primary",
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                ...(0, $bKNBB.messages).done
                            })
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("fwCi9", function(module, exports) {

$parcel$export(module.exports, "ProductTile", () => $308587e607e6bd51$export$300c95c2b37c13cb);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $cvXh8 = parcelRequire("cvXh8");

var $iEKnc = parcelRequire("iEKnc");

var $eWgaW = parcelRequire("eWgaW");

var $5nBzc = parcelRequire("5nBzc");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $2W0qg = parcelRequire("2W0qg");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $1yEFx = parcelRequire("1yEFx");

var $epmmL = parcelRequire("epmmL");
const $308587e607e6bd51$var$tileStyles = (0, $ecnYn.xcss)({
    width: '174px',
    maxWidth: '174px',
    height: '134px',
    border: '1px solid',
    borderRadius: '4px',
    borderColor: 'color.border',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.075',
    overflow: 'hidden',
    boxSizing: 'border-box'
});
const $308587e607e6bd51$var$contentStyles = (0, $ecnYn.xcss)({
    boxSizing: 'border-box',
    padding: 'space.200',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    width: '142px',
    height: '86px'
});
const $308587e607e6bd51$var$iconStyles = (0, $ecnYn.xcss)({
    width: '32px',
    height: '32px',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    paddingBottom: 'space.100'
});
const $308587e607e6bd51$var$productTitleStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    maxWidth: '130px',
    overflow: 'hidden',
    boxSizing: 'border-box'
});
const $308587e607e6bd51$var$titleTextStyles = (0, $ecnYn.xcss)({
    color: 'color.text',
    font: 'font.body',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $308587e607e6bd51$var$connectLinkStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    font: 'font.body',
    fontStyle: 'normal',
    textDecoration: 'none',
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.150',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    ':hover': {
        color: 'color.link',
        textDecoration: 'underline'
    }
});
const $308587e607e6bd51$var$connectedLinkStyles = (0, $ecnYn.xcss)({
    color: 'color.text.accent.green',
    font: 'font.body',
    fontStyle: 'normal',
    textDecoration: 'none',
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.150'
});
const $308587e607e6bd51$var$errorLinkStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    font: 'font.body',
    fontStyle: 'normal',
    textDecoration: 'none'
});
const $308587e607e6bd51$var$errorMessageStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body',
    fontStyle: 'normal',
    paddingLeft: 'space.025',
    paddingRight: 'space.025'
});
const $308587e607e6bd51$var$connectIconStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 'space.075',
    paddingRight: 'space.075'
});
const $308587e607e6bd51$var$connectPressableStyles = (0, $ecnYn.xcss)({
    ':hover': {
        textDecoration: 'underline'
    }
});
const $308587e607e6bd51$export$300c95c2b37c13cb = ({ icon: icon, productName: productName, productKey: productKey, url: url, newlyConnected: newlyConnected, useOAuthHandlers: useOAuthHandlers, useBulkConnectState: useBulkConnectState, isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { setProductStatus: setProductStatus, setProductConnectedInSession: setProductConnectedInSession, productStatuses: productStatuses } = useBulkConnectState();
    const [curConnectStatus, setCurConnectStatus] = (0, $gwFzn.useState)('default');
    let productDisplayName = productKey !== (0, $1yEFx.ProductKeys).ConfluenceDC ? productName : thirdPartyConfigs?.[(0, $1yEFx.ProductKeys3P).ConfluenceDC]?.workspaceName;
    (0, $gwFzn.useEffect)(()=>{
        setCurConnectStatus(productStatuses.get(productKey) ? 'connected' : 'default');
    }, [
        productStatuses,
        productKey
    ]);
    const { onAuthorize: onAuthorize } = useOAuthHandlers({
        product: productKey,
        successFlagTitle: formatMessage((0, $epmmL.messages).authorizationSuccess, {
            product: productDisplayName
        }),
        failFlagTitle: formatMessage((0, $epmmL.messages).authorizationFail, {
            product: productDisplayName
        }),
        outboundAuthUrl: url,
        onCompletedAction: ()=>{
            setCurConnectStatus('connected');
            setProductStatus(productKey, true);
            setProductConnectedInSession(true);
        },
        onFailAction: ()=>{
            setCurConnectStatus('error');
        },
        isOnSearchDialog: isOnSearchDialog,
        isBulkConnect: true
    });
    const onConnectClick = ()=>{
        onAuthorize();
    };
    let ProductIcon = icon;
    let connectAction;
    switch(curConnectStatus){
        case 'connected':
            connectAction = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                space: "space.050",
                alignBlock: "center",
                xcss: $308587e607e6bd51$var$connectedLinkStyles,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                        label: formatMessage((0, $epmmL.messages).checkIconLabel),
                        color: "var(--ds-icon-accent-green, #22A06B)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $epmmL.messages).connected
                        })
                    })
                ]
            });
            break;
        case 'error':
            connectAction = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
                onClick: onConnectClick,
                xcss: $308587e607e6bd51$var$connectPressableStyles,
                backgroundColor: "color.background.neutral.subtle",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                            space: "space.050",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iEKnc))), {
                                    label: formatMessage((0, $epmmL.messages).errorIconLabel),
                                    color: "var(--ds-icon-danger, #C9372C)"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                    xcss: $308587e607e6bd51$var$errorMessageStyles,
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                        ...(0, $epmmL.messages).failed
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $308587e607e6bd51$var$errorLinkStyles,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                ...(0, $epmmL.messages).retry
                            })
                        })
                    ]
                })
            });
            break;
        default:
            connectAction = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
                onClick: onConnectClick,
                xcss: $308587e607e6bd51$var$connectPressableStyles,
                backgroundColor: "color.background.neutral.subtle",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $308587e607e6bd51$var$connectLinkStyles,
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                xcss: $308587e607e6bd51$var$connectIconStyles,
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eWgaW))), {
                                    label: formatMessage((0, $epmmL.messages).externalLinkIconlabel)
                                })
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                    ...(0, $epmmL.messages).connect
                                })
                            })
                        ]
                    })
                })
            });
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $308587e607e6bd51$var$tileStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $308587e607e6bd51$var$contentStyles,
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
                space: "space.025",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $308587e607e6bd51$var$iconStyles,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)(ProductIcon, {})
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                        xcss: $308587e607e6bd51$var$productTitleStyles,
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                xcss: $308587e607e6bd51$var$titleTextStyles,
                                children: productDisplayName
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                children: newlyConnected && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5nBzc.default), {
                                    appearance: "new",
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                        ...(0, $epmmL.messages).new
                                    })
                                })
                            })
                        ]
                    }),
                    connectAction
                ]
            })
        })
    });
};

});
parcelRegister("eWgaW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1959b1db9d7d7f74dcc029cd008a599f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae0307963ceb2bce$var$_react = $ae0307963ceb2bce$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $ae0307963ceb2bce$var$_baseNew = $ae0307963ceb2bce$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $ae0307963ceb2bce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for links that open up a new tab as a secondary/tertiary action.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ae0307963ceb2bce$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $ae0307963ceb2bce$var$_react.default.createElement($ae0307963ceb2bce$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.688 2.5a.19.19 0 0 0-.188.188v6.624c0 .104.084.188.188.188h6.624a.19.19 0 0 0 .188-.187V8.5H11v.813C11 10.244 10.245 11 9.313 11H2.686A1.687 1.687 0 0 1 1 9.313V2.686C1 1.757 1.756 1 2.688 1H3.5v1.5zM5.75 1h4.5a.75.75 0 0 1 .75.75v4.5H9.5V3.56L5.53 7.53 4.47 6.47 8.44 2.5H5.75z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$ae0307963ceb2bce$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $ae0307963ceb2bce$var$_default = module.exports.default = $ae0307963ceb2bce$var$LinkExternalIcon;

});

parcelRegister("epmmL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6b2589c809fb2f52$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $6b2589c809fb2f52$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    connected: {
        id: "product-tile-connected",
        defaultMessage: "Connected"
    },
    failed: {
        id: "product-tile-failed",
        defaultMessage: "Failed."
    },
    retry: {
        id: "product-tile-try-again",
        defaultMessage: "Try again"
    },
    connect: {
        id: "product-tile-connect",
        defaultMessage: "Connect"
    },
    new: {
        id: "product-tile-new",
        defaultMessage: "New"
    },
    checkIconLabel: {
        id: "product-tile-check-icon-label",
        defaultMessage: "Check Icon"
    },
    errorIconLabel: {
        id: "product-tile-error-icon-label",
        defaultMessage: "Error Icon"
    },
    externalLinkIconlabel: {
        id: "product-tile-external-link-icon-label",
        defaultMessage: "External Link Icon"
    },
    authorizationSuccess: {
        id: "product-tile-oauth-warning.authorization-success",
        defaultMessage: "Successfully connected to {product}"
    },
    authorizationFail: {
        id: "product-tile-oauth-warning.authorization-fail",
        defaultMessage: "Failed to connect to {product}"
    }
});

});


parcelRegister("kiASw", function(module, exports) {
module.exports = new URL("no-results-dark.a00ae47b.svg", import.meta.url).toString();

});

parcelRegister("7l75S", function(module, exports) {
module.exports = new URL("no-results-light.5ca83755.svg", import.meta.url).toString();

});

parcelRegister("bKNBB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $349cf30d16a41fce$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $349cf30d16a41fce$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    modalTitle: {
        id: "bulk-connect-dialog-title",
        defaultMessage: "Connect your apps"
    },
    modalSubheading: {
        id: "bulk-connect-dialog-subheading",
        defaultMessage: "Find your work more efficiently by individually connecting the apps you use"
    },
    cancel: {
        id: "bulk-connect-cancel",
        defaultMessage: "Cancel"
    },
    done: {
        id: "bulk-connect-done",
        defaultMessage: "Done"
    },
    searchIconLabel: {
        id: "search-icon-label",
        defaultMessage: "Search"
    },
    searchPlaceholder: {
        id: "search-icon-placeholder",
        defaultMessage: "Search"
    },
    noResults: {
        id: "bulk-connect-no-results",
        defaultMessage: "We couldn't find apps matching your search"
    }
});

});



parcelRegister("2nHbb", function(module, exports) {

$parcel$export(module.exports, "AssetsUnavailableBanner", () => $0028c77a13fa2c26$export$d2e895abf2051d81);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $2Nwuj = parcelRequire("2Nwuj");

var $6f0Oj = parcelRequire("6f0Oj");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $aoVih = parcelRequire("aoVih");

var $4VmlX = parcelRequire("4VmlX");

var $kCOhL = parcelRequire("kCOhL");
const $0028c77a13fa2c26$export$d2e895abf2051d81 = ()=>{
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $0028c77a13fa2c26$var$containerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aoVih.default), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $kCOhL.messages).assetsUnavailableMessage,
                values: {
                    bold: (chunks)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                            weight: 'bold',
                            children: chunks
                        }),
                    searchLink: (chunks)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
                            href: '/jira/assets?showSearch=true',
                            onClick: ()=>setQuickFindOpen(false),
                            children: chunks
                        })
                }
            })
        })
    });
};
const $0028c77a13fa2c26$var$containerStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.075',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});

});
parcelRegister("kCOhL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $be39043139f18c46$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $be39043139f18c46$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    assetsUnavailableMessage: {
        id: "search_dialog_assets_unavailable_message",
        defaultMessage: "<bold>Assets</bold> will be available here soon. For now, try <searchLink>Assets search</searchLink>."
    }
});

});


parcelRegister("e79Fp", function(module, exports) {

$parcel$export(module.exports, "RovoTipBanner", () => $238c7f3a77e6e665$export$4d99a070549a9300);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $1qfLF = parcelRequire("1qfLF");

var $3HOqx = parcelRequire("3HOqx");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $4SPhZ = parcelRequire("4SPhZ");

var $5tPRL = parcelRequire("5tPRL");
var $dfZ5P = parcelRequire("dfZ5P");

var $j4ply = parcelRequire("j4ply");

var $8drE0 = parcelRequire("8drE0");
const $238c7f3a77e6e665$var$RovoTipMessageStyle = (0, $ecnYn.xcss)({
    width: '95%',
    marginLeft: 'space.050',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.050'
});
const $238c7f3a77e6e665$var$RovoTipContainerStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.075',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $238c7f3a77e6e665$var$RovoTipStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    minHeight: `${"var(--ds-space-500, 40px)"}`,
    paddingLeft: 'space.150',
    paddingRight: 'space.100',
    borderRadius: `${"var(--ds-space-050, 4px)"}`,
    backgroundColor: 'color.background.accent.purple.subtlest',
    color: 'color.text.accent.purple'
});
const $238c7f3a77e6e665$export$4d99a070549a9300 = ()=>{
    const [showRovoTip, setShowRovoTip] = (0, $gwFzn.useState)(false);
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [user] = (0, $j4ply.useUser)();
    (0, $gwFzn.useEffect)(()=>{
        if (!primaryProduct || !user || !user.id) return;
        const rovoTipFromLocalStorage = (0, $4SPhZ.getRovoTip)(primaryProduct, user.id);
        setShowRovoTip(rovoTipFromLocalStorage);
    }, [
        primaryProduct,
        user
    ]);
    const dismissRovoTip = (0, $gwFzn.useCallback)(()=>{
        if (!primaryProduct || !user || !user.id) return;
        const rovoTipFromLocalStorage = (0, $4SPhZ.setRovoTip)(primaryProduct, user.id);
        setShowRovoTip(rovoTipFromLocalStorage);
    }, [
        primaryProduct,
        user
    ]);
    if (!showRovoTip) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $238c7f3a77e6e665$var$RovoTipContainerStyle,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
            xcss: $238c7f3a77e6e665$var$RovoTipStyle,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
                    label: "blank",
                    color: "var(--ds-text-accent-purple, #5E4DB2)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                    xcss: $238c7f3a77e6e665$var$RovoTipMessageStyle,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("b", {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                ...(0, $8drE0.messages).rovoTip
                            })
                        }),
                        ' ',
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $8drE0.messages).rovoBannerMessage
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedReturnIconContainer), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                        icon: (0, $dfZ5P.RemoveIcon),
                        spacing: 'compact',
                        onClick: (event)=>{
                            event.preventDefault();
                            event.stopPropagation();
                            dismissRovoTip();
                        },
                        label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $8drE0.messages).dismissBannerLabel
                        }),
                        appearance: 'subtle'
                    })
                })
            ]
        })
    });
};

});
parcelRegister("4SPhZ", function(module, exports) {

$parcel$export(module.exports, "getRovoTip", () => $801ec4174110d9b1$export$b9330795d9444727);
$parcel$export(module.exports, "setRovoTip", () => $801ec4174110d9b1$export$297a6fb093b042a3);
const $801ec4174110d9b1$export$568e0ce3cc5a9972 = 'atlassian.unified-search.quick-find-rovo-tip';
const $801ec4174110d9b1$export$4bac6b574c2c1d97 = 'anonymous-user';
const $801ec4174110d9b1$export$b9330795d9444727 = (productId, userId)=>{
    const userIdOrAnonymous = userId || $801ec4174110d9b1$export$4bac6b574c2c1d97;
    const quickFindRovoTipRaw = $801ec4174110d9b1$var$getLocalStorageItem($801ec4174110d9b1$export$568e0ce3cc5a9972);
    const rovoTip = quickFindRovoTipRaw ? JSON.parse(quickFindRovoTipRaw) : {};
    const rovoTipProducts = rovoTip[userIdOrAnonymous] || {};
    return rovoTipProducts[productId] === undefined ? true : rovoTipProducts[productId];
};
const $801ec4174110d9b1$export$297a6fb093b042a3 = (productId, userId)=>{
    const userIdOrAnonymous = userId || $801ec4174110d9b1$export$4bac6b574c2c1d97;
    const quickFindRovoTipRaw = $801ec4174110d9b1$var$getLocalStorageItem($801ec4174110d9b1$export$568e0ce3cc5a9972);
    const rovoTip = quickFindRovoTipRaw ? JSON.parse(quickFindRovoTipRaw) : {};
    if (!rovoTip[userIdOrAnonymous]) rovoTip[userIdOrAnonymous] = {};
    rovoTip[userIdOrAnonymous][productId] = false;
    $801ec4174110d9b1$var$setLocalStorageItem($801ec4174110d9b1$export$568e0ce3cc5a9972, JSON.stringify(rovoTip));
    return rovoTip[userIdOrAnonymous][productId];
};
const $801ec4174110d9b1$var$setLocalStorageItem = (key, value)=>{
    window.localStorage.setItem(key, value);
};
const $801ec4174110d9b1$var$getLocalStorageItem = (key)=>{
    return window.localStorage.getItem(key);
};

});

parcelRegister("5tPRL", function(module, exports) {

$parcel$export(module.exports, "ResultLink", () => $d4baf0504b42b38c$export$d0a8235d2583609);
$parcel$export(module.exports, "ResultContentWrapper", () => $d4baf0504b42b38c$export$87a308048e18f5d7);
$parcel$export(module.exports, "EnlargedResultContentWrapper", () => $d4baf0504b42b38c$export$e10965f6350456f8);
$parcel$export(module.exports, "ReturnIconContainer", () => $d4baf0504b42b38c$export$b7244afbfdf4cb9a);
$parcel$export(module.exports, "EnlargedReturnIconContainer", () => $d4baf0504b42b38c$export$cc248e72bc9d7b85);
$parcel$export(module.exports, "IconContainer", () => $d4baf0504b42b38c$export$8f314e512d92575f);
$parcel$export(module.exports, "EnlargedIconContainer", () => $d4baf0504b42b38c$export$ca5c00fa71c2e27e);
$parcel$export(module.exports, "ResultTitleContainer", () => $d4baf0504b42b38c$export$9c613d6c52df949a);
$parcel$export(module.exports, "EnlargedResultTitleContainer", () => $d4baf0504b42b38c$export$e97ece467686c93c);
$parcel$export(module.exports, "ResultLabel", () => $d4baf0504b42b38c$export$a999164f6ebc756c);
$parcel$export(module.exports, "ResultDetail", () => $d4baf0504b42b38c$export$b695f824f00c1cb0);
$parcel$export(module.exports, "CollapsedResultDetail", () => $d4baf0504b42b38c$export$addf7aa0f753bbe8);
$parcel$export(module.exports, "EnlargedCollapsedResultDetail", () => $d4baf0504b42b38c$export$a44951d703db9a17);
$parcel$export(module.exports, "EnlargedResultTitleContainerSkeleton", () => $d4baf0504b42b38c$export$c571ffd341b1e6fe);
$parcel$export(module.exports, "EnlargedResultDetail", () => $d4baf0504b42b38c$export$c8ec38cc79b76eaa);
$parcel$export(module.exports, "EnlargedResultDetailSkeleton", () => $d4baf0504b42b38c$export$a15ed502bc39849a);
$parcel$export(module.exports, "CollapsedResultDetailWrapper", () => $d4baf0504b42b38c$export$43a2b5c94cb85d9c);
$parcel$export(module.exports, "EnlargedCollapsedResultDetailWrapper", () => $d4baf0504b42b38c$export$2dfb537c5a7f8cc3);
$parcel$export(module.exports, "DetailsSeparator", () => $d4baf0504b42b38c$export$35507434feaa4496);
$parcel$export(module.exports, "CollapsedResultContentWrapper", () => $d4baf0504b42b38c$export$ee32d1086c278cfc);
$parcel$export(module.exports, "EnlargedSkeletonIcon", () => $d4baf0504b42b38c$export$3c77a9b2eee1dfc5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2azjJ = parcelRequire("2azjJ");

var $kPBHE = parcelRequire("kPBHE");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $d4baf0504b42b38c$export$d0a8235d2583609 = /*#__PURE__*/ (0, $gwrgp.default)((0, $kPBHE.Link), {
    target: "e8crcwv0"
})({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    textDecoration: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.primaryTextColour),
    '&:hover': {
        textDecoration: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: (0, $2azjJ.primaryTextColour)
    },
    '&:focus': {
        outlineOffset: '-2px'
    },
    '&:visited': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: (0, $2azjJ.primaryTextColour),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.SearchDialogResultTitle': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: (0, $2azjJ.visitedLinkColor)
        }
    }
});
const $d4baf0504b42b38c$export$87a308048e18f5d7 = (0, $gwrgp.default)("div", {
    target: "e8crcwv1"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $2azjJ.grid).multiple(props.isCollapsed ? 5 : 4).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `0 ${(0, $2azjJ.grid).twice().px}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $2azjJ.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $2azjJ.itemHighlightColor)
        }
    }));
const $d4baf0504b42b38c$export$e10965f6350456f8 = (0, $gwrgp.default)("div", {
    target: "e8crcwv2"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        borderRadius: "var(--ds-space-075, 6px)",
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $2azjJ.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $2azjJ.itemHighlightColor)
        }
    }));
const $d4baf0504b42b38c$export$b7244afbfdf4cb9a = (0, $gwrgp.default)("div", {
    target: "e8crcwv3"
})((props)=>({
        borderRadius: '3px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: (0, $2azjJ.grid).half().px,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $2azjJ.grid).multiple(3).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $2azjJ.grid).twice().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        right: (0, $2azjJ.grid).multiple(1.5).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        top: props.isCollapsed ? (0, $2azjJ.grid).px : (0, $2azjJ.grid).half().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.isKeyboardHighlighted ? 1 : 0
    }));
const $d4baf0504b42b38c$export$cc248e72bc9d7b85 = (0, $gwrgp.default)("div", {
    target: "e8crcwv4"
})({
    name: "1l17wfx",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);margin-left:var(--ds-space-150, 12px);"
});
const $d4baf0504b42b38c$export$d84276b3ae03593f = /*#__PURE__*/ (0, $gwrgp.default)($d4baf0504b42b38c$export$b7244afbfdf4cb9a, {
    target: "e8crcwv5"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $2azjJ.grid).multiple(2.5).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $2azjJ.grid).multiple(2.5).px,
    opacity: 1
});
const $d4baf0504b42b38c$export$8f314e512d92575f = (0, $gwrgp.default)("div", {
    target: "e8crcwv6"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $2azjJ.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $2azjJ.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flex: `0 0 ${(0, $2azjJ.grid).twice().px}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $2azjJ.grid).twice().px,
    display: 'flex',
    alignItems: 'center'
});
const $d4baf0504b42b38c$export$ca5c00fa71c2e27e = (0, $gwrgp.default)("div", {
    target: "e8crcwv7"
})({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    marginRight: "var(--ds-space-100, 8px)",
    flex: `0 0 ${"var(--ds-space-300, 24px)"}`,
    display: 'flex',
    alignItems: 'center'
});
const $d4baf0504b42b38c$export$9c613d6c52df949a = (0, $gwrgp.default)("div", {
    target: "e8crcwv8"
})((0, $2azjJ.nowrapEllipsis), " width:", (props)=>props.isCollapsed ? 'initial' : (0, $2azjJ.grid).multiple(47).px, ";line-height:16px;flex:1 0 auto;color:", (0, $2azjJ.primaryTextColour), ";@media screen and (max-width:", (0, $2azjJ.dialogPageTakeoverWidth), "px){width:100%;}");
const $d4baf0504b42b38c$export$e97ece467686c93c = (0, $gwrgp.default)("div", {
    target: "e8crcwv9"
})((0, $2azjJ.nowrapEllipsis), " line-height:14px;flex:1 0 auto;color:", (0, $2azjJ.primaryTextColour), ";height:16px;@media screen and (max-width:", (0, $2azjJ.dialogPageTakeoverWidth), "px){width:100%;}width:90%;");
const $d4baf0504b42b38c$export$a999164f6ebc756c = (0, $gwrgp.default)("span", {
    target: "e8crcwv10"
})((0, $2azjJ.nowrapEllipsis), {
    color: "var(--ds-text-subtle, #5E6C84)",
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $2azjJ.grid).px
});
const $d4baf0504b42b38c$export$b695f824f00c1cb0 = (0, $gwrgp.default)("div", {
    target: "e8crcwv11"
})((0, $2azjJ.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.itemLinkSecondaryColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginLeft: (0, $2azjJ.grid).multiple(3).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $2azjJ.grid).multiple(19).px
});
const $d4baf0504b42b38c$export$addf7aa0f753bbe8 = (0, $gwrgp.default)("div", {
    target: "e8crcwv12"
})((0, $2azjJ.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.itemLinkSecondaryColor),
    maxWidth: "'initial'"
});
const $d4baf0504b42b38c$export$a44951d703db9a17 = (0, $gwrgp.default)("div", {
    target: "e8crcwv13"
})((0, $2azjJ.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.itemLinkSecondaryColor),
    maxWidth: "'initial'"
});
const $d4baf0504b42b38c$export$c571ffd341b1e6fe = (0, $gwrgp.default)("div", {
    target: "e8crcwv14"
})({
    maxWidth: '100%',
    width: '256px',
    height: '14px',
    marginBottom: "var(--ds-space-025, 2px)",
    borderRadius: "var(--ds-space-050, 4px)",
    backgroundColor: `var(--ds-skeleton, ${(0, $6fnsQ.N20A)})`
});
const $d4baf0504b42b38c$export$c8ec38cc79b76eaa = (0, $gwrgp.default)("div", {
    target: "e8crcwv15"
})((0, $2azjJ.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.itemLinkSecondaryColor),
    maxWidth: "'initial'",
    minWidth: 'fit-content',
    marginLeft: "var(--ds-space-150, 12px)"
});
const $d4baf0504b42b38c$export$a15ed502bc39849a = (0, $gwrgp.default)("div", {
    target: "e8crcwv16"
})({
    maxWidth: '100%',
    width: '100px',
    height: '12px',
    borderRadius: "var(--ds-space-050, 4px)",
    backgroundColor: `var(--ds-skeleton, ${(0, $6fnsQ.N20A)})`
});
const $d4baf0504b42b38c$export$43a2b5c94cb85d9c = (0, $gwrgp.default)("div", {
    target: "e8crcwv17"
})({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $2azjJ.grid).multiple(54).px
});
const $d4baf0504b42b38c$export$2dfb537c5a7f8cc3 = (0, $gwrgp.default)("div", {
    target: "e8crcwv18"
})({
    name: "jn0r0q",
    styles: "display:flex;width:90%;"
});
const $d4baf0504b42b38c$export$35507434feaa4496 = (0, $gwrgp.default)("div", {
    target: "e8crcwv19"
})({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.itemLinkSecondaryColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${(0, $2azjJ.grid).px}`
});
const $d4baf0504b42b38c$export$ee32d1086c278cfc = (0, $gwrgp.default)("div", {
    target: "e8crcwv20"
})({
    name: "1a9l0m2",
    styles: "display:block;min-width:0;flex-grow:1;"
});
const $d4baf0504b42b38c$export$2cacbb382e8a2ce4 = (0, $gwrgp.default)("button", {
    target: "e8crcwv21"
})({
    name: "1qpf3mh",
    styles: "background-color:transparent;border:none;cursor:pointer;padding:0;width:100%;text-align:left;"
});
const $d4baf0504b42b38c$export$3c77a9b2eee1dfc5 = (0, $gwrgp.default)("div", {
    target: "e8crcwv22"
})({
    width: '100%',
    height: '100%',
    borderRadius: "var(--ds-space-050, 4px)",
    backgroundColor: `var(--ds-skeleton, ${(0, $6fnsQ.N20A)})`
});

});
parcelRegister("kPBHE", function(module, exports) {

$parcel$export(module.exports, "Link", () => $1e87bb95c8c7b16d$export$a6c7ac8248d6e38a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $1e87bb95c8c7b16d$export$a6c7ac8248d6e38a = ({ linkComponent: linkComponent, ...props })=>{
    // Hack?
    const Component = linkComponent || 'a';
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        ...props
    });
};

});


parcelRegister("8drE0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $57957bf3159c123e$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $57957bf3159c123e$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    rovoTip: {
        id: "search_dialog_rovo_tip",
        defaultMessage: "Rovo tip:"
    },
    dismissBannerLabel: {
        id: "search_dialog_dismiss_banner_label",
        defaultMessage: "Dismiss banner"
    },
    rovoBannerMessage: {
        id: "search_dialog_rovo_banner_message",
        defaultMessage: "Enter a question like \u201CWhat\u2019s the vacation policy?\u201D and Rovo will find the answer"
    }
});

});


parcelRegister("cuvog", function(module, exports) {

$parcel$export(module.exports, "Divider", () => $92cb390251785e80$export$2e0a83ec2e27ecbb);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $92cb390251785e80$var$dividerStyles = (0, $ecnYn.xcss)({
    height: '0',
    width: '100%',
    borderTop: '1px solid',
    borderColor: 'color.border'
});
const $92cb390251785e80$export$2e0a83ec2e27ecbb = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $92cb390251785e80$var$dividerStyles
    });
};

});

parcelRegister("47juE", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", () => $5e4b8c366d6ef407$export$42f84e610f279c31);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $2W0qg = parcelRequire("2W0qg");

var $8u7zP = parcelRequire("8u7zP");

var $inrbX = parcelRequire("inrbX");

var $iKNBc = parcelRequire("iKNBc");

const $5e4b8c366d6ef407$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("aKipV")));
const $5e4b8c366d6ef407$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.200',
    color: 'color.text'
});
const $5e4b8c366d6ef407$var$imageFallbackStyles = (0, $ecnYn.xcss)({
    width: '124px',
    height: '124px'
});
const $5e4b8c366d6ef407$var$headingStyles = (0, $ecnYn.xcss)({
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    marginTop: 'space.100'
});
const $5e4b8c366d6ef407$var$bodyStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    font: 'font.body'
});
const $5e4b8c366d6ef407$var$pressableStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    font: 'font.body',
    color: 'color.link',
    padding: 'space.0',
    ':hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    }
});
const $5e4b8c366d6ef407$export$42f84e610f279c31 = ({ onRetry: onRetry })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    (0, $gwFzn.useEffect)(()=>{
        fireAnalyticsEvent((0, $8u7zP.onSearchDialogErrorShown)({
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    // Same as other analytics events, we only want this to fire when the screen displays
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $5e4b8c366d6ef407$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $5e4b8c366d6ef407$var$imageFallbackStyles
                }),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($5e4b8c366d6ef407$var$Image, {})
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $5e4b8c366d6ef407$var$headingStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $iKNBc.messages).errorSearchHeading
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $5e4b8c366d6ef407$var$bodyStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $iKNBc.messages).errorSearchBody,
                    values: {
                        button: (s)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
                                xcss: $5e4b8c366d6ef407$var$pressableStyles,
                                onClick: onRetry,
                                children: s
                            })
                    }
                })
            })
        ]
    });
};

});
parcelRegister("8u7zP", function(module, exports) {

$parcel$export(module.exports, "onSearchDialogErrorShown", () => $c81ca25909252d74$export$8657eff97a198097);
const $c81ca25909252d74$export$8657eff97a198097 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        action: 'shown',
        actionSubject: `searchDialogError`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("iKNBc", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7e87035b4b825004$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $7e87035b4b825004$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    errorSearchHeading: {
        id: "search_dialog_error_search_heading",
        defaultMessage: "We're having trouble loading your recently viewed content."
    },
    errorSearchBody: {
        id: "search_dialog_error_search_body",
        defaultMessage: "It might just be a hiccup. Please try refreshing the page or <button>try again</button>."
    }
});

});

parcelRegister("aKipV", function(module, exports) {

let $7d2c7c8baa46136b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7d2c7c8baa46136b$var$load("4KiYL").then(()=>parcelRequire('9Wb1k'));

});


parcelRegister("d6thU", function(module, exports) {

$parcel$export(module.exports, "FeedbackFooter", () => $67539e0ab092f04e$export$e7b87342306a8337);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $8UOsA = parcelRequire("8UOsA");

var $7Yuqm = parcelRequire("7Yuqm");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $4VmlX = parcelRequire("4VmlX");

var $heoiU = parcelRequire("heoiU");
const $67539e0ab092f04e$var$footerContainerStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.150',
    paddingBlockEnd: 'space.150',
    paddingInlineStart: 'space.200',
    paddingInlineEnd: 'space.200',
    color: 'color.text',
    gap: 'space.150'
});
const $67539e0ab092f04e$export$e7b87342306a8337 = ()=>{
    const [feedbackIsOpen, { setIsFeedbackModalOpen: setIsFeedbackModalOpen }] = (0, $4VmlX.useIsFeedbackModalOpen)();
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [experimentConfig] = (0, $j4ply.useExperimentConfig)();
    const [isHello] = (0, $j4ply.useIsHello)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [selectedProducts] = (0, $djVCD.useSelectedProducts)();
    const [user] = (0, $j4ply.useUser)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const requestId = (0, $4VmlX.useFetchEntitiesRequestId)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        xcss: $67539e0ab092f04e$var$footerContainerStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $heoiU.messages).feedbackFooter
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UOsA.FeedbackButton), {
                onClick: (e)=>{
                    e.preventDefault();
                    setIsFeedbackModalOpen(true);
                }
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7Yuqm.default), {
                cloudId: cloudId || '',
                experimentConfig: experimentConfig,
                isHello: isHello,
                isOpen: feedbackIsOpen,
                primaryProduct: primaryProduct || '',
                product: selectedProducts.length ? selectedProducts.join(', ') : 'no product filter',
                setIsOpen: setIsFeedbackModalOpen,
                source: "quick-find",
                userId: user.id || '',
                userName: user.name || '',
                mode: applicationMode,
                requestId: requestId || ''
            })
        ]
    });
};

});
parcelRegister("8UOsA", function(module, exports) {

$parcel$export(module.exports, "FeedbackButton", () => $db4f68a9c93392e4$export$116fedbe5e2e2bd8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $ecnYn = parcelRequire("ecnYn");

var $2W0qg = parcelRequire("2W0qg");

var $ktiIl = parcelRequire("ktiIl");
const $db4f68a9c93392e4$var$feedbackButtonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.link',
    padding: 'space.0',
    ':hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    }
});
const $db4f68a9c93392e4$export$116fedbe5e2e2bd8 = ({ onClick: onClick })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
        xcss: $db4f68a9c93392e4$var$feedbackButtonStyles,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $ktiIl.messages).feedbackButton
        })
    });

});
parcelRegister("ktiIl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7ad591125a6bb6cf$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $7ad591125a6bb6cf$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    feedbackButton: {
        id: "feedback_button",
        defaultMessage: "Give feedback"
    }
});

});


parcelRegister("7Yuqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ed018b70d6fe5e9$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $6uGcC = parcelRequire("6uGcC");

var $iLCTn = parcelRequire("iLCTn");

var $5kBVi = parcelRequire("5kBVi");

var $kAUyK = parcelRequire("kAUyK");

const $2ed018b70d6fe5e9$export$67d3c3516a0ee4ec = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("islOg")).then((module)=>{
        return {
            default: module.default
        };
    }));

const $2ed018b70d6fe5e9$var$AkFeedbackFlag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("islOg")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $2ed018b70d6fe5e9$var$FeedbackCollector = ({ cloudId: cloudId, experimentConfig: experimentConfig, isHello: isHello, isOpen: isOpen, primaryProduct: primaryProduct, product: product, setIsOpen: setIsOpen, source: source, userId: userId, userName: userName, mode: mode, requestId: requestId })=>{
    const { locale: locale } = (0, $dBxQj.default)();
    const [displayFlag, setDisplayFlag] = (0, $gwFzn.useState)(false);
    const feedbackContext = (0, $kAUyK.getFeedbackCollectorContext)({
        experimentLayers: experimentConfig.backendExperiment?.experimentLayers,
        frontendExperiments: experimentConfig.frontendExperiments,
        version: (0, $5kBVi.BUILD_VERSION),
        release: (0, $iLCTn.getProductReleaseVersion)(primaryProduct),
        source: source,
        product: product,
        primaryProduct: primaryProduct,
        cloudId: cloudId,
        userId: userId,
        isHello: isHello,
        mode: mode,
        requestId: requestId
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            isOpen && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($2ed018b70d6fe5e9$export$67d3c3516a0ee4ec, {
                    locale: locale,
                    onClose: ()=>setIsOpen(false),
                    onSubmit: ()=>setDisplayFlag(true),
                    atlassianAccountId: userId,
                    name: userName,
                    entrypointId: (0, $5kBVi.ENTRYPOINT_ID),
                    additionalFields: [
                        {
                            id: (0, $5kBVi.FEEDBACK_CONTEXT_CF),
                            value: feedbackContext
                        }
                    ]
                })
            }),
            displayFlag && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6uGcC.default), {
                onDismissed: ()=>setDisplayFlag(false),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                    fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)($2ed018b70d6fe5e9$var$AkFeedbackFlag, {
                        locale: locale
                    })
                })
            })
        ]
    });
};
var $2ed018b70d6fe5e9$export$2e2bcd8739ae039 = $2ed018b70d6fe5e9$var$FeedbackCollector;

});
parcelRegister("iLCTn", function(module, exports) {

$parcel$export(module.exports, "getProductReleaseVersion", () => $e71cbd5e593c3cac$export$d521605fb33b0dfd);
const $e71cbd5e593c3cac$var$memoizedQuerySelector = (selectors)=>{
    let element = null;
    return ()=>{
        if (!element) element = document.querySelector(selectors);
        return element;
    };
};
const $e71cbd5e593c3cac$export$d521605fb33b0dfd = (product)=>{
    switch(product?.toLowerCase()){
        case 'confluence':
            return window.__buildInfo?.FRONTEND_VERSION || 'noversion';
        case 'jira':
            return window.BUILD_KEY;
        case 'townsquare':
            const versionMeta = $e71cbd5e593c3cac$var$memoizedQuerySelector('meta[name="release-version"]');
            if (versionMeta instanceof HTMLMetaElement) return versionMeta.content;
    }
    return 'noversion';
};

});

parcelRegister("5kBVi", function(module, exports) {

$parcel$export(module.exports, "BUILD_VERSION", () => $135f97f348b2ff15$export$2db401a6b81eceee);
$parcel$export(module.exports, "ENTRYPOINT_ID", () => $135f97f348b2ff15$export$25dc0a1e75f58d8f);
$parcel$export(module.exports, "FEEDBACK_CONTEXT_CF", () => $135f97f348b2ff15$export$d04cd98bb7625919);
const $135f97f348b2ff15$var$packageName = "platform-pkg";
const $135f97f348b2ff15$var$packageVersion = "0.0.0-use.local";
const $135f97f348b2ff15$export$2db401a6b81eceee = `${$135f97f348b2ff15$var$packageName}@${$135f97f348b2ff15$var$packageVersion}`;
const $135f97f348b2ff15$export$25dc0a1e75f58d8f = '9b88e53b-d04d-4f1c-ae85-6d7f59d1ca7a';
const $135f97f348b2ff15$export$d04cd98bb7625919 = 'customfield_10047';
const $135f97f348b2ff15$export$83c8d7110915321e = 'search-page';

});

parcelRegister("kAUyK", function(module, exports) {

$parcel$export(module.exports, "getFeedbackCollectorContext", () => $a7df8303f8002da0$export$e0fccaef47ee61b8);
const $a7df8303f8002da0$export$e0fccaef47ee61b8 = (keys)=>{
    return JSON.stringify(keys);
};

});

parcelRegister("islOg", function(module, exports) {

let $d6fbc277c5241685$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d6fbc277c5241685$var$load("c6MKV"),
    $d6fbc277c5241685$var$load("aZinD"),
    $d6fbc277c5241685$var$load("joJy8"),
    $d6fbc277c5241685$var$load("aHE9G"),
    $d6fbc277c5241685$var$load("cyGuT")
]).then(()=>parcelRequire('biiXa'));

});


parcelRegister("heoiU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5514968f55e57b26$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $5514968f55e57b26$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    feedbackFooter: {
        id: "search_dialog_feedback_footer",
        defaultMessage: "Help us improve search"
    }
});

});


parcelRegister("cu2Tg", function(module, exports) {

$parcel$export(module.exports, "QuickFindFilters", () => $b21d47feb05d9034$export$cc5615a202a2ea8c);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $isYda = parcelRequire("isYda");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $3R0ts = parcelRequire("3R0ts");

var $86ob4 = parcelRequire("86ob4");

var $djVCD = parcelRequire("djVCD");

var $5xYfl = parcelRequire("5xYfl");

var $9Pz4M = parcelRequire("9Pz4M");

var $9fB7u = parcelRequire("9fB7u");
const $b21d47feb05d9034$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    paddingInline: 'space.200',
    paddingBlockStart: 'space.025',
    paddingBlockEnd: 'space.075'
});
const $b21d47feb05d9034$var$filterDropdownIconStyles = (0, $ecnYn.xcss)({
    padding: 'space.050',
    marginInlineEnd: 'space.100'
});
const $b21d47feb05d9034$export$cc5615a202a2ea8c = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const dialogWidth = (0, $86ob4.useElementWidth)((0, $3R0ts.SEARCH_DIALOG_WIDTH_OBSERVER_ID));
    const isDialogAbove275px = dialogWidth > 275;
    const displayCustomizeIcon = isDialogAbove275px || !selectedProduct;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $b21d47feb05d9034$var$containerStyles,
        children: [
            displayCustomizeIcon && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $b21d47feb05d9034$var$filterDropdownIconStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
                    label: formatMessage((0, $9fB7u.i18n).filterByIcon)
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5xYfl.InlineAppSelector), {}),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9Pz4M.InlineProductFilters), {})
        ]
    });
};

});
parcelRegister("5xYfl", function(module, exports) {

$parcel$export(module.exports, "InlineAppSelector", () => $e1138a05237425a8$export$863a72861bb447a2);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $eWgaW = parcelRequire("eWgaW");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $3gadb = parcelRequire("3gadb");

var $1yEFx = parcelRequire("1yEFx");

var $7WbA8 = parcelRequire("7WbA8");

var $eoZmS = parcelRequire("eoZmS");

var $5FKsO = parcelRequire("5FKsO");

var $a5OFf = parcelRequire("a5OFf");

var $5xGHP = parcelRequire("5xGHP");

var $1nJM3 = parcelRequire("1nJM3");

var $gGFxq = parcelRequire("gGFxq");

var $inrbX = parcelRequire("inrbX");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $4VmlX = parcelRequire("4VmlX");

var $1FKBY = parcelRequire("1FKBY");

var $9g3OD = parcelRequire("9g3OD");
const $e1138a05237425a8$var$inlineFilterStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100'
});
const $e1138a05237425a8$var$inlineFilterSeparator = (0, $ecnYn.xcss)({
    width: '1px',
    height: '29px',
    // As specified in the designs
    alignSelf: 'center',
    borderRight: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $e1138a05237425a8$var$AppButtonFor3PApps = ({ productKey: productKey, redirectToFPSWithProductSelected: redirectToFPSWithProductSelected, trigger: trigger })=>{
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const isSmartlink = (0, $a5OFf.isProductSmartlink)({
        productKey: productKey,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const { userNeedsOAuth: userNeedsOAuth } = (0, $gGFxq.useIsUserOAuthed)(productKey);
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    if (userNeedsOAuth) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1nJM3.ErrorBoundary), {
        section: "QuickFindAppButtonFor3PAppsOAuthWrapper",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eoZmS.OAuthWarningWrapper), {
            product: productKey,
            postAuthAction: ()=>{
                redirectToFPSWithProductSelected();
            },
            trigger: (triggerProps)=>trigger({
                    ...triggerProps,
                    userNeedsAuth: true
                }),
            isOnSearchDialog: true,
            useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
            useIsUserOAuthed: (0, $gGFxq.useIsUserOAuthed),
            isSmartlink: isSmartlink,
            searchQuery: quickFindQuery
        }, productKey)
    });
    return trigger({
        userNeedsAuth: false
    });
};
const $e1138a05237425a8$export$863a72861bb447a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { onNavigate: onNavigate, generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { selectProductFilter: selectProductFilter } = (0, $djVCD.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { apps1PToDisplay: apps1PToDisplay, apps3PToDisplay: apps3PToDisplay, isDialogAbove400px: isDialogAbove400px, isDialogAbove450px: isDialogAbove450px, primaryProduct: primaryProduct, selectedProduct: selectedProduct } = (0, $9g3OD.useInlineAppSelector)();
    const onAppFilterSelected = (productKey, options)=>{
        const newSelectedProduct = selectedProduct === productKey ? undefined : productKey;
        fireAnalyticsEvent((0, $5xGHP.onAppFilterSelect)({
            actionSubjectId: productKey,
            action: newSelectedProduct === undefined ? 'unselected' : 'selected',
            attributes: {
                ...commonAttributes,
                isPostAuthAction: options.isPostAuthAction,
                isRedirectedToFPS: options.redirectToFPS
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        if (!options.redirectToFPS) {
            selectProductFilter(newSelectedProduct);
            return;
        }
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...queryParams,
            product: productKey,
            text: quickFindQuery
        }), 'push');
        setQuickFindOpen(false);
    };
    const apps3pComponent = apps3PToDisplay.map(({ productKey: productKey, productConfig: productConfig })=>{
        const Icon = productConfig.Icon;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
            content: formatMessage((0, $1FKBY.i18n).appTooltipFor3PApps, {
                productName: productConfig.displayName
            }),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($e1138a05237425a8$var$AppButtonFor3PApps, {
                productKey: productKey,
                productConfig: productConfig,
                redirectToFPSWithProductSelected: ()=>onAppFilterSelected(productKey, {
                        redirectToFPS: true,
                        isPostAuthAction: true
                    }),
                trigger: ({ triggerProps: triggerProps, userNeedsAuth: userNeedsAuth })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5FKsO.FilterButton), {
                        ...triggerProps,
                        contentFit: isDialogAbove450px ? 'default' : 'compact',
                        iconAfter: !userNeedsAuth && /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eWgaW))), {
                            label: formatMessage((0, $1FKBY.i18n).externalLinkIconLabel),
                            color: "currentColor"
                        }),
                        iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
                            size: "small"
                        }),
                        isSelected: false,
                        onClick: ()=>{
                            if (!userNeedsAuth) onAppFilterSelected(productKey, {
                                redirectToFPS: true,
                                isPostAuthAction: false
                            });
                        },
                        spacing: !userNeedsAuth || isDialogAbove400px ? 'default' : 'compact',
                        children: isDialogAbove400px && productConfig.displayName
                    })
            }, productKey)
        }, productKey);
    });
    const apps1PComponent = apps1PToDisplay.map(({ productKey: productKey, productConfig: productConfig, redirectToFPS: redirectToFPS })=>{
        const AppIcon = productConfig.Icon;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5FKsO.FilterButton), {
            "aria-current": selectedProduct === productKey,
            contentFit: isDialogAbove450px ? 'default' : 'compact',
            iconAfter: redirectToFPS && /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eWgaW))), {
                label: formatMessage((0, $1FKBY.i18n).externalLinkIconLabel),
                color: "currentColor"
            }),
            iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)(AppIcon, {
                size: "small"
            }),
            isSelected: selectedProduct === productKey,
            onClick: ()=>onAppFilterSelected(productKey, {
                    redirectToFPS: redirectToFPS,
                    isPostAuthAction: false
                }),
            spacing: isDialogAbove400px ? 'default' : 'compact',
            children: isDialogAbove400px && productConfig.displayName
        }, productKey);
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        testId: "qf-inline-app-selector",
        xcss: $e1138a05237425a8$var$inlineFilterStyles,
        children: [
            primaryProduct === (0, $1yEFx.PrimaryProductKeys).Confluence && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    apps1PComponent,
                    apps3pComponent
                ]
            }),
            primaryProduct !== (0, $1yEFx.PrimaryProductKeys).Confluence && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    apps3pComponent,
                    apps1PComponent
                ]
            }),
            selectedProduct && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $e1138a05237425a8$var$inlineFilterSeparator
            })
        ]
    });
};

});
parcelRegister("eoZmS", function(module, exports) {

$parcel$export(module.exports, "OAuthWarningWrapper", () => $c151e079e3af8d1c$export$3415e5401c1f1ae1);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $ccHMk = parcelRequire("ccHMk");

var $dpPtd = parcelRequire("dpPtd");

var $l6Qdw = parcelRequire("l6Qdw");

var $lGgRw = parcelRequire("lGgRw");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $1yEFx = parcelRequire("1yEFx");

var $dQilu = parcelRequire("dQilu");
const $c151e079e3af8d1c$var$popupContentStyles = (0, $ecnYn.xcss)({
    width: '20rem',
    padding: 'space.200',
    display: 'flex',
    flexDirection: 'column'
});
const $c151e079e3af8d1c$var$buttonContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row'
});
const $c151e079e3af8d1c$var$buttonStyles = (0, $ecnYn.xcss)({
    margin: 'space.100'
});
const $c151e079e3af8d1c$var$infoIconStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.050',
    cursor: 'pointer'
});
const $c151e079e3af8d1c$var$popupTriggerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});
const $c151e079e3af8d1c$var$connectButtonStyles = (0, $ecnYn.xcss)({
    marginLeft: 'auto',
    right: 'space.200'
});
const $c151e079e3af8d1c$var$sidebarStyles = (0, $ecnYn.xcss)({
    width: '100%',
    paddingBottom: 'space.025'
});
const $c151e079e3af8d1c$var$connectTextStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    ':hover': {
        color: 'color.link.pressed',
        textDecoration: 'underline'
    }
});
const $c151e079e3af8d1c$export$14011507d36518b5 = ({ product: product, isSmartlink: isSmartlink, isInline: isInline, trigger: trigger, isOnSearchDialog: isOnSearchDialog, searchQuery: searchQuery, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, option: option, index: index, postAuthAction: postAuthAction })=>{
    const products = (0, $1yEFx.useProductConfigs)();
    const [isPopupOpen, setIsPopupOpen] = (0, $gwFzn.useState)(false);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { userNeedsOAuth: userNeedsOAuth, outboundAuthUrl: outboundAuthUrl } = useIsUserOAuthed(product);
    const productString = (product && products[product]?.displayName) ?? '';
    const { onAuthorize: onAuthorize, onDismiss: onDismiss } = useOAuthHandlers({
        product: product,
        successFlagTitle: formatMessage((0, $dQilu.messages).authorizationSuccess, {
            product: productString
        }),
        failFlagTitle: formatMessage((0, $dQilu.messages).authorizationFail, {
            product: productString
        }),
        outboundAuthUrl: outboundAuthUrl || '',
        onCompletedAction: ()=>{
            setIsPopupOpen(false);
            option?.showFilter();
            option?.onSelect();
            postAuthAction?.();
        },
        onDismissAction: ()=>{
            setIsPopupOpen(false);
        },
        isOnSearchDialog: isOnSearchDialog,
        query: searchQuery
    });
    const connectMessage = product === (0, $1yEFx.ProductKeys).Figma || isSmartlink ? (0, $dQilu.messages).authorizeConnectThirdPartyProductAlternate : (0, $dQilu.messages).authorizeConnectThirdPartyProduct;
    //This component is a functional wrapper that turns the trigger prop into a popup trigger.
    // if no warning is needed, we just render the trigger
    if (!product || !userNeedsOAuth || !outboundAuthUrl) return trigger({
        isDisabled: false
    });
    const onOpenPopup = ()=>{
        setIsPopupOpen(!isPopupOpen);
    };
    const triggerComponent = (triggerProps)=>{
        const oAuthWarning = isInline ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $c151e079e3af8d1c$var$infoIconStyles,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l6Qdw))), {
                LEGACY_margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
                label: "oauth warning",
                LEGACY_size: "small",
                color: "var(--ds-icon-brand, #0C66E4)"
            })
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1GzhS.default), {
            xcss: $c151e079e3af8d1c$var$connectButtonStyles,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $c151e079e3af8d1c$var$connectTextStyles,
                children: formatMessage((0, $dQilu.messages).connect)
            })
        });
        return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            onClick: onOpenPopup,
            xcss: [
                $c151e079e3af8d1c$var$popupTriggerStyles,
                !isInline && !isOnSearchDialog && $c151e079e3af8d1c$var$sidebarStyles
            ],
            children: trigger({
                oAuthWarning: oAuthWarning,
                isDisabled: true,
                triggerProps: triggerProps
            })
        }));
    };
    const isFurtherDownThanFourth = index && index > 3;
    const rightRailPopupPlacement = isFurtherDownThanFourth ? 'left-end' : 'left-start';
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lGgRw.default), {
        isOpen: isPopupOpen,
        onClose: ()=>setIsPopupOpen(false),
        placement: isOnSearchDialog || isInline ? 'bottom-start' : rightRailPopupPlacement,
        trigger: triggerComponent,
        shouldRenderToParent: true,
        content: ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                xcss: $c151e079e3af8d1c$var$popupContentStyles,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1GzhS.default), {
                        space: "space.100",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                            children: formatMessage(connectMessage, {
                                product: productString,
                                strong: (text)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                                        as: "strong",
                                        children: text
                                    }),
                                br: /*#__PURE__*/ (0, $7UHDa.jsx)("br", {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
                        xcss: $c151e079e3af8d1c$var$buttonContainerStyles,
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1GzhS.default), {
                                xcss: $c151e079e3af8d1c$var$buttonStyles,
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                                    onClick: onDismiss,
                                    children: formatMessage((0, $dQilu.messages).notNow)
                                })
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1GzhS.default), {
                                xcss: $c151e079e3af8d1c$var$buttonStyles,
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                                    onClick: onAuthorize,
                                    appearance: "primary",
                                    children: formatMessage((0, $dQilu.messages).connect)
                                })
                            })
                        ]
                    })
                ]
            })
    });
};
const $c151e079e3af8d1c$export$3415e5401c1f1ae1 = (props)=>{
    return props.isOnSearchDialog ? /*#__PURE__*/ (0, $7UHDa.jsx)($c151e079e3af8d1c$export$14011507d36518b5, {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dpPtd.FlagsProvider), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($c151e079e3af8d1c$export$14011507d36518b5, {
            ...props
        })
    });
};

});
parcelRegister("dQilu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c62e19c9051d98ef$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $c62e19c9051d98ef$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    authorizeConnectThirdPartyProduct: {
        id: "sidebar-authorize_connect_third_party_product",
        defaultMessage: "Your admin has added <strong>{product}!</strong>{br} Connect your account to see missing results, including documents only you have access to."
    },
    authorizeConnectThirdPartyProductAlternate: {
        id: "sidebar-authorize_connect_third_party_product_alternate_msg",
        defaultMessage: "<strong>{product} is now available!</strong>{br} Connect your account to see missing results, including content only you have access to."
    },
    dismiss: {
        id: "sidebar-oauth-warning-dismiss",
        defaultMessage: "Dismiss"
    },
    authorize: {
        id: "sidebar-oauth-warning-authorize",
        defaultMessage: "Authorize"
    },
    authorizationFail: {
        id: "sidebar-oauth-warning.authorization-fail",
        defaultMessage: "Failed to connect to {product}."
    },
    authorizationSuccess: {
        id: "sidebar-oauth-warning.authorization-success",
        defaultMessage: "Successfully connected to {product}."
    },
    notNow: {
        id: "sidebar-oauth-warning.not-now",
        defaultMessage: "Not now"
    },
    connect: {
        id: "sidebar-oauth-warning.connect",
        defaultMessage: "Connect"
    }
});

});


parcelRegister("5FKsO", function(module, exports) {

$parcel$export(module.exports, "FilterButton", () => $0c4269204833e8a1$export$fb46dd9777cc6db0);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");
const $0c4269204833e8a1$var$defaultFilterButtonStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.075',
    color: 'color.text.subtle',
    borderRadius: '4px',
    paddingInline: 'space.150',
    paddingBlock: 'space.050',
    minHeight: '32px',
    // As specified on Figma
    maxWidth: '164px',
    // As specified on Figma
    backgroundColor: 'color.background.neutral.subtle',
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    whiteSpace: 'nowrap',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $0c4269204833e8a1$var$compactContentFitStyles = (0, $ecnYn.xcss)({
    maxWidth: '113px' // As specified on Figma
});
const $0c4269204833e8a1$var$minWidthZeroStyles = (0, $ecnYn.xcss)({
    minWidth: '0' // Allow the button to shrink as much as possible
});
const $0c4269204833e8a1$var$filterButtonSelectedStateStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected',
    border: `1px solid ${"var(--ds-border-selected, #0C66E4)"}`,
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    }
});
const $0c4269204833e8a1$var$compactSpacingStyles = (0, $ecnYn.xcss)({
    paddingInline: 'space.050'
});
const $0c4269204833e8a1$var$filterButtonContentStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $0c4269204833e8a1$export$fb46dd9777cc6db0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(function FilterButton({ children: children, contentFit: contentFit = 'default', iconAfter: iconAfter, iconBefore: iconBefore, isSelected: isSelected, minWidthZero: minWidthZero = false, spacing: spacing = 'default', ...pressableProps }, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2W0qg.default), {
        ...pressableProps,
        ref: ref,
        xcss: [
            $0c4269204833e8a1$var$defaultFilterButtonStyles,
            isSelected && $0c4269204833e8a1$var$filterButtonSelectedStateStyles,
            spacing === 'compact' && $0c4269204833e8a1$var$compactSpacingStyles,
            contentFit === 'compact' && $0c4269204833e8a1$var$compactContentFitStyles,
            minWidthZero && $0c4269204833e8a1$var$minWidthZeroStyles
        ],
        children: [
            iconBefore,
            children && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $0c4269204833e8a1$var$filterButtonContentStyles,
                children: children
            }),
            iconAfter
        ]
    });
});

});

parcelRegister("5xGHP", function(module, exports) {

$parcel$export(module.exports, "onAppFilterSelect", () => $00b64bc742da3325$export$abf7f7ce81b5b4bb);
const $00b64bc742da3325$export$abf7f7ce81b5b4bb = ({ action: action, actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: action,
        actionSubject: 'appSelector',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("1FKBY", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $1aa60baca70ed4d4$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $1aa60baca70ed4d4$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    externalLinkIconLabel: {
        id: "inline-app-selector.external-link-icon.label",
        defaultMessage: "External Link Icon"
    },
    appTooltipFor3PApps: {
        id: "inline-app-selector.3p-app-tooltip",
        defaultMessage: "Open a full page search for this term filtered by {productName} results"
    }
});

});

parcelRegister("9g3OD", function(module, exports) {

$parcel$export(module.exports, "useInlineAppSelector", () => $9fbf3b40278c59cd$export$6b2b316097ae586c);

var $gwFzn = parcelRequire("gwFzn");

var $l8wXo = parcelRequire("l8wXo");

var $kZ0dZ = parcelRequire("kZ0dZ");

var $9yyKc = parcelRequire("9yyKc");

var $1yEFx = parcelRequire("1yEFx");

var $3R0ts = parcelRequire("3R0ts");

var $86ob4 = parcelRequire("86ob4");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");
// TODO: Render dynamic 1P products, hardcoded for now for Team 25
const $9fbf3b40278c59cd$var$supported1PApps = (primaryProduct)=>{
    if (!primaryProduct) return [];
    switch(primaryProduct){
        case (0, $1yEFx.PrimaryProductKeys).Confluence:
            return [
                {
                    productKey: (0, $1yEFx.ProductKeys).Confluence,
                    redirectToFPS: false
                }
            ];
        default:
            return [
                {
                    productKey: (0, $1yEFx.ProductKeys).Confluence,
                    redirectToFPS: true
                },
                {
                    productKey: (0, $1yEFx.ProductKeys).Jira,
                    redirectToFPS: true
                }
            ];
    }
};
// TODO: Render dynamic 1P products, hardcoded for now for Team 25
const $9fbf3b40278c59cd$var$supported3PApps = [
    (0, $1yEFx.ProductKeys).GoogleDrive,
    (0, $1yEFx.ProductKeys).Slack
];
// TODO: Render the icons based on configuration, hardcoded for now for Team 25
const $9fbf3b40278c59cd$var$appSelectorIcons = {
    [(0, $1yEFx.ProductKeys).GoogleDrive]: (0, $9yyKc.RovoLogoFromSVG)((0, $l8wXo.GoogleDriveAppSelectorIcon)),
    [(0, $1yEFx.ProductKeys).Slack]: (0, $9yyKc.RovoLogoFromSVG)((0, $kZ0dZ.SlackAppSelectorIcon))
};
const $9fbf3b40278c59cd$export$6b2b316097ae586c = ()=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const dialogWidth = (0, $86ob4.useElementWidth)((0, $3R0ts.SEARCH_DIALOG_WIDTH_OBSERVER_ID));
    const isDialogAbove400px = dialogWidth > 400;
    const isDialogAbove450px = dialogWidth > 450;
    const apps3PToDisplay = (0, $gwFzn.useMemo)(()=>$9fbf3b40278c59cd$var$supported3PApps.filter((supported3PApp)=>availableProducts.includes(supported3PApp)).filter((_)=>!selectedProduct).map((productKey)=>({
                productKey: productKey,
                productConfig: productConfigs[productKey]
            }))// TODO: Remove the following Icon override of the icons when we render the icons based on a configuration
        .map(({ productKey: productKey, productConfig: productConfig })=>({
                productKey: productKey,
                productConfig: {
                    ...productConfig,
                    ...$9fbf3b40278c59cd$var$appSelectorIcons[productKey] ? {
                        Icon: $9fbf3b40278c59cd$var$appSelectorIcons[productKey]
                    } : {}
                }
            })), [
        availableProducts,
        productConfigs,
        selectedProduct
    ]);
    const apps1PToDisplay = (0, $gwFzn.useMemo)(()=>$9fbf3b40278c59cd$var$supported1PApps(primaryProduct).filter((supported1PApp)=>availableProducts.includes(supported1PApp.productKey)).filter((supported1PApp)=>!selectedProduct || supported1PApp.productKey === selectedProduct).map((supportedApp)=>({
                ...supportedApp,
                productConfig: productConfigs[supportedApp.productKey]
            })), [
        availableProducts,
        primaryProduct,
        productConfigs,
        selectedProduct
    ]);
    return {
        apps1PToDisplay: apps1PToDisplay,
        apps3PToDisplay: apps3PToDisplay,
        isDialogAbove400px: isDialogAbove400px,
        isDialogAbove450px: isDialogAbove450px,
        primaryProduct: primaryProduct,
        selectedProduct: selectedProduct
    };
};

});
parcelRegister("l8wXo", function(module, exports) {

$parcel$export(module.exports, "GoogleDriveAppSelectorIcon", () => $8f03b897883d0b88$export$e087ba40596ff085);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $8f03b897883d0b88$export$e087ba40596ff085 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_271_181643)",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                    clipPath: "url(#clip1_271_181643)",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            x: "2",
                            y: "2",
                            width: "20",
                            height: "20",
                            rx: "0.75",
                            fill: "white",
                            fillOpacity: "0.01"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                            clipPath: "url(#clip2_271_181643)",
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M3.51203 18.5459L4.39404 20.1089C4.57732 20.438 4.84078 20.6965 5.15006 20.8845L8.30011 15.2905H2C2 15.6548 2.09164 16.0192 2.27491 16.3482L3.51203 18.5459Z",
                                    fill: "#0066DA"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M12 8.70925L8.84994 3.11523C8.54066 3.30327 8.27721 3.56182 8.09393 3.89088L2.27491 14.2328C2.09501 14.5547 2.00024 14.9193 2 15.2904H8.30011L12 8.70925Z",
                                    fill: "#00AC47"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M18.85 20.8845C19.1593 20.6965 19.4227 20.438 19.606 20.1089L19.9725 19.4625L21.7251 16.3482C21.9084 16.0192 22 15.6548 22 15.2905H15.6995L17.0401 17.9935L18.85 20.8845Z",
                                    fill: "#EA4335"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M12.0002 8.70932L15.1502 3.1153C14.8409 2.92727 14.4858 2.83325 14.1193 2.83325H9.88103C9.51447 2.83325 9.15938 2.93902 8.8501 3.1153L12.0002 8.70932Z",
                                    fill: "#00832D"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M15.6997 15.2905H8.29996L5.1499 20.8845C5.45918 21.0726 5.81428 21.1666 6.18083 21.1666H17.8189C18.1854 21.1666 18.5405 21.0608 18.8498 20.8845L15.6997 15.2905Z",
                                    fill: "#2684FC"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M18.8156 9.06182L15.9061 3.89088C15.7228 3.56182 15.4593 3.30327 15.1501 3.11523L12 8.70925L15.6999 15.2904H21.9885C21.9885 14.9261 21.8969 14.5618 21.7136 14.2328L18.8156 9.06182Z",
                                    fill: "#FFBA00"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_271_181643",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "24",
                            height: "24",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip1_271_181643",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            x: "2",
                            y: "2",
                            width: "20",
                            height: "20",
                            rx: "0.75",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip2_271_181643",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "20",
                            height: "18.3333",
                            fill: "white",
                            transform: "translate(2 2.83325)"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("kZ0dZ", function(module, exports) {

$parcel$export(module.exports, "SlackAppSelectorIcon", () => $fa17f1a0bfd05113$export$f11b42d1aefdd173);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $fa17f1a0bfd05113$export$f11b42d1aefdd173 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_271_181639)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
                        fill: "#ECB22E"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
                        fill: "#E01E5A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_271_181639",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });

});



parcelRegister("9Pz4M", function(module, exports) {

$parcel$export(module.exports, "InlineProductFilters", () => $f4dec8f243f8bf8c$export$b1ad550c251413b4);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $eWgaW = parcelRequire("eWgaW");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $7WbA8 = parcelRequire("7WbA8");

var $5FKsO = parcelRequire("5FKsO");

var $hML65 = parcelRequire("hML65");

var $inrbX = parcelRequire("inrbX");

var $djVCD = parcelRequire("djVCD");

var $4VmlX = parcelRequire("4VmlX");

var $idGm7 = parcelRequire("idGm7");

var $hMKYS = parcelRequire("hMKYS");
const $f4dec8f243f8bf8c$var$inlineProductFilterStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    paddingInlineStart: 'space.100',
    gap: 'space.100',
    width: '100%',
    minWidth: '0' // Prevents the filter buttons from overflowing from its container and allow it to shrink as much as possible
});
const $f4dec8f243f8bf8c$export$b1ad550c251413b4 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    if (!selectedProduct) return null;
    const moreButtonOnClick = ()=>{
        setQuickFindOpen(false);
        fireAnalyticsEvent((0, $hML65.onMoreProductFiltersSelected)({
            actionSubjectId: 'more-product-filters',
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        // TODO: This is a temporary measure until we do QS-6716 post Team 25 where it syncs filters with FPS.
        // For now, executing a search query on FPS search will always clear the filters in QF as FPS filters
        // is the source of truth for filter state.
        clearAllFilters();
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...queryParams,
            text: quickFindQuery
        }), 'push');
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $f4dec8f243f8bf8c$var$inlineProductFilterStyles,
        testId: "qf-product-filters",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $idGm7.SpaceFilter), {}),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5FKsO.FilterButton), {
                onClick: moreButtonOnClick,
                iconAfter: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eWgaW))), {
                    label: formatMessage((0, $hMKYS.i18n).externalLinkIconLabel),
                    color: "currentColor"
                }),
                children: formatMessage((0, $hMKYS.i18n).moreButtonLabel)
            })
        ]
    });
};

});
parcelRegister("hML65", function(module, exports) {

$parcel$export(module.exports, "onMoreProductFiltersSelected", () => $b7cdee9969fa612b$export$59708e770734a297);
const $b7cdee9969fa612b$export$59708e770734a297 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'selected',
        actionSubject: 'moreProductFilters',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("idGm7", function(module, exports) {

$parcel$export(module.exports, "SpaceFilter", () => $5bd43442241df578$export$2414da0e5c5cdf82);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $c4sKh = parcelRequire("c4sKh");

var $eG1e2 = parcelRequire("eG1e2");

var $jQ2up = parcelRequire("jQ2up");

var $5FKsO = parcelRequire("5FKsO");

var $946uu = parcelRequire("946uu");

var $5cssW = parcelRequire("5cssW");

var $a97k3 = parcelRequire("a97k3");

var $hqP8k = parcelRequire("hqP8k");
const $5bd43442241df578$export$2414da0e5c5cdf82 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $a97k3.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive, badgeLabel: badgeLabel, firstSelectedOptionLabel: firstSelectedOptionLabel } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $hqP8k.i18n).confluenceFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $hqP8k.i18n).confluenceFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $946uu.FilterPopupSelect), {
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $hqP8k.i18n).space),
        placeholder: formatMessage((0, $hqP8k.i18n).confluenceFilterSpacePlaceholder),
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: clearOptions,
        target: ({ isOpen: isOpen, ...targetProps })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5FKsO.FilterButton), {
                ...targetProps,
                isSelected: !!selectedOptions.length,
                iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))), {
                    label: formatMessage((0, $hqP8k.i18n).confluenceFilterSpaceIcon)
                }),
                iconAfter: badgeLabel && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c4sKh.default), {
                    appearance: "primary",
                    children: badgeLabel
                }),
                minWidthZero: true,
                children: firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $hqP8k.i18n).space)
            })
    });
};

});
parcelRegister("jQ2up", function(module, exports) {

$parcel$export(module.exports, "createOptionLabelFormatter", () => $b87e75291ab80188$export$100d0de045bdee7c);
$parcel$export(module.exports, "formatAvatarOptionLabel", () => $b87e75291ab80188$export$aaa1dc33930567f9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $esRft = parcelRequire("esRft");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");
const $b87e75291ab80188$var$optionTextWrapperStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginLeft: 'space.100',
    color: 'color.text',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $b87e75291ab80188$export$2cf7ef1e2dd6c6b1 = ({ option: option, state: state, children: children })=>{
    if (state.context === 'menu' || state.context === 'value') {
        const spaces = {
            menu: 'space.050',
            value: undefined
        };
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1GzhS.default), {
            space: spaces[state.context],
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                alignItems: "center",
                children: [
                    children,
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $b87e75291ab80188$var$optionTextWrapperStyles,
                        children: option.label
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $b87e75291ab80188$var$optionTextWrapperStyles,
        children: option.label
    });
};
const $b87e75291ab80188$export$100d0de045bdee7c = (Component)=>(option, state)=>{
        const props = {
            option: option,
            state: state
        };
        return /*#__PURE__*/ (0, $7UHDa.jsx)($b87e75291ab80188$export$2cf7ef1e2dd6c6b1, {
            ...props,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                ...props
            })
        });
    };
const $b87e75291ab80188$var$AvatarOptionLabel = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
        src: props.option.avatarUrl,
        appearance: "circle",
        size: "small",
        borderColor: "none"
    });
const $b87e75291ab80188$export$aaa1dc33930567f9 = $b87e75291ab80188$export$100d0de045bdee7c($b87e75291ab80188$var$AvatarOptionLabel);

});

parcelRegister("946uu", function(module, exports) {

$parcel$export(module.exports, "FilterPopupSelect", () => $40387639b8effd2d$export$381eb977a1d9bc81);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $c9mMn = parcelRequire("c9mMn");
var $cuAuQ = parcelRequire("cuAuQ");

var $k5mzm = parcelRequire("k5mzm");

var $ls6iZ = parcelRequire("ls6iZ");
const $40387639b8effd2d$export$381eb977a1d9bc81 = ({ defaultIsOpen: defaultIsOpen = false, isSearchable: isSearchable = false, isLoading: isLoading = false, canClearFilter: canClearFilter = false, checkboxIndicators: checkboxIndicators = false, formatOptionLabel: formatOptionLabel, placeholder: placeholder, searchInput: searchInput, onSearchInputChange: onSearchInputChange, onSelectChange: onSelectChange, onDropdownOpen: onDropdownOpen, onDropdownClose: onDropdownClose, options: options, label: label, noOptionsMessage: noOptionsMessage, onClearOptions: onClearOptions, minMenuWidth: minMenuWidth, target: target })=>{
    const debounceTimeout = (0, $gwFzn.useRef)(null);
    // TODO: this can be removed if we have debounce in the store when lookup
    const [currentSearchInput, setCurrentSearchInput] = (0, $gwFzn.useState)(searchInput);
    const handleInputChange = (0, $gwFzn.useCallback)((value, action)=>{
        if (action.action !== 'input-change') return;
        setCurrentSearchInput(value);
        if (!onSearchInputChange) return;
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(()=>{
            onSearchInputChange(value);
        }, 300);
    }, [
        onSearchInputChange
    ]);
    const handleChange = (0, $gwFzn.useCallback)((value)=>{
        onSelectChange(value);
    }, [
        onSelectChange
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cuAuQ.default), {
        blurInputOnSelect: false,
        canClearFilter: canClearFilter,
        closeMenuOnSelect: !checkboxIndicators,
        components: {
            Control: $k5mzm.Control,
            MenuList: $ls6iZ.MenuList,
            ...checkboxIndicators ? {
                Option: (0, $c9mMn.CheckboxOption)
            } : {}
        },
        defaultIsOpen: defaultIsOpen,
        // @ts-ignore - https://product-fabric.atlassian.net/browse/DSP-21000
        defaultOptions: false,
        formatOptionLabel: formatOptionLabel,
        inputValue: currentSearchInput,
        isClearable: false,
        isLoading: isLoading,
        isOptionSelected: (option)=>option.isSelected,
        isSearchable: isSearchable,
        label: label,
        maxMenuHeight: 400,
        maxMenuWidth: "22rem",
        menuPlacement: "bottom",
        minMenuWidth: minMenuWidth,
        noOptionsMessage: currentSearchInput ? undefined : ()=>noOptionsMessage,
        onChange: handleChange,
        onClearOptions: onClearOptions,
        onInputChange: handleInputChange,
        onMenuClose: ()=>{
            setCurrentSearchInput('');
            onDropdownClose?.();
        },
        onMenuOpen: onDropdownOpen,
        options: options,
        placeholder: placeholder,
        popperProps: {
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                },
                {
                    name: 'preventOverflow',
                    enabled: false
                }
            ]
        },
        searchThreshold: -1,
        shouldCloseMenuOnTab: false,
        target: target
    });
};

});
parcelRegister("k5mzm", function(module, exports) {

$parcel$export(module.exports, "Control", () => $1ca63d475ea1e3a7$export$7a7fa4424cb20976);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $3hOY6 = parcelRequire("3hOY6");
const $1ca63d475ea1e3a7$var$boxStyles = (0, $ecnYn.xcss)({
    borderRadius: 'border.radius',
    boxSizing: 'border-box'
});
const $1ca63d475ea1e3a7$export$7a7fa4424cb20976 = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: props.selectProps.isSearchable && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            paddingInline: "space.100",
            paddingBlockStart: "space.100",
            xcss: $1ca63d475ea1e3a7$var$boxStyles,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3hOY6.components).Control, {
                ...props
            })
        })
    });

});

parcelRegister("ls6iZ", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $4c5bd174a9ae63a6$export$d4c4e98c5044dc8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $3hOY6 = parcelRequire("3hOY6");

var $6fnsQ = parcelRequire("6fnsQ");

var $hFx5x = parcelRequire("hFx5x");
const $4c5bd174a9ae63a6$var$clearFilterOptionsButtonStyles = (0, $ecnYn.xcss)({
    background: `var(--ds-background-input, ${(0, $6fnsQ.N0)})`,
    color: 'color.text.subtle',
    border: 'none',
    paddingLeft: 'space.250',
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '36px',
    width: '100%',
    ':hover': {
        backgroundColor: 'color.background.input.hovered'
    },
    ':disabled': {
        color: 'color.text.accent.gray',
        cursor: 'default'
    }
});
const $4c5bd174a9ae63a6$var$ClearFilterOptionsButton = ({ onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
        onClick: onClick,
        xcss: $4c5bd174a9ae63a6$var$clearFilterOptionsButtonStyles,
        children: children
    });
};
const $4c5bd174a9ae63a6$var$menuFooterStyles = (0, $ecnYn.xcss)({
    borderTop: `${`var(--ds-border, ${(0, $6fnsQ.N40)})`} solid 1px`
});
const $4c5bd174a9ae63a6$export$d4c4e98c5044dc8 = (props)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3hOY6.components).MenuList, {
                ...props
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $4c5bd174a9ae63a6$var$menuFooterStyles,
                children: props.selectProps.canClearFilter && /*#__PURE__*/ (0, $7UHDa.jsx)($4c5bd174a9ae63a6$var$ClearFilterOptionsButton, {
                    onClick: ()=>props.selectProps.onClearOptions(),
                    children: formatMessage((0, $hFx5x.i18n).searchClearFilterLabel)
                })
            })
        ]
    });
};

});
parcelRegister("hFx5x", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $1c530652ce05bde3$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $1c530652ce05bde3$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    searchClearFilterLabel: {
        id: "search-page.filter.clear.filter.label",
        defaultMessage: "Clear filter"
    }
});

});



parcelRegister("hqP8k", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $98def20fb816381d$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $98def20fb816381d$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    space: {
        id: "search-page.filters.names.space",
        defaultMessage: "Space"
    },
    confluenceFilterSpacePlaceholder: {
        id: "search-page.confluence.filter.space.placeholder",
        defaultMessage: "Find spaces"
    },
    confluenceFilterLabelSelected: {
        id: "search-page.confluence.filter.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelUnselected: {
        id: "search-page.confluence.filter.label.unselected",
        defaultMessage: "Suggested"
    },
    confluenceFilterSpaceIcon: {
        id: "search-page.confluence.filter.space.icon",
        defaultMessage: "Space Icon"
    }
});

});


parcelRegister("hMKYS", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $db27a10ae551c873$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $db27a10ae551c873$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    externalLinkIconLabel: {
        id: "inline-product-filters.external-link-icon.label",
        defaultMessage: "External Link Icon"
    },
    moreButtonLabel: {
        id: "inline-product-filters.more-filters.label",
        defaultMessage: "More"
    }
});

});


parcelRegister("9fB7u", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $77e9ec5198e0dc0e$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $77e9ec5198e0dc0e$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    filterByIcon: {
        id: "quick-find-filters.filter-by-icon-label",
        defaultMessage: "Filter by Icon"
    }
});

});


parcelRegister("a0YSD", function(module, exports) {

$parcel$export(module.exports, "JiraAdvancedSearchLink", () => $e02869b185b9e3c4$export$104db48ac99dc257);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $jluld = parcelRequire("jluld");

var $u9agA = parcelRequire("u9agA");

var $ltx9b = parcelRequire("ltx9b");

var $k2YFb = parcelRequire("k2YFb");

var $1yEFx = parcelRequire("1yEFx");

var $7WbA8 = parcelRequire("7WbA8");

var $83gV2 = parcelRequire("83gV2");

var $4VmlX = parcelRequire("4VmlX");

var $g8fQj = parcelRequire("g8fQj");
const $e02869b185b9e3c4$var$ACTION_SUBJECT_ID = 'jiraAdvancedIssueSearch';
const $e02869b185b9e3c4$export$104db48ac99dc257 = ({ state: state, onClick: onClick })=>{
    const intl = (0, $dBxQj.default)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
        label: intl.formatMessage((0, $g8fQj.messages).jira_advanced_search),
        color: "currentColor"
    });
    const rightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ltx9b.CommandIcon), {}),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
        ]
    });
    const onResultClicked = (0, $gwFzn.useCallback)((event)=>{
        onClick({
            state: state,
            event: event,
            actionSubjectId: $e02869b185b9e3c4$var$ACTION_SUBJECT_ID
        });
    }, [
        onClick,
        state
    ]);
    const url = generateSearchUrl({
        ...queryParams,
        product: (0, $1yEFx.PrimaryProductKeys).Jira,
        text: quickFindQuery
    }, true);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $83gV2.SearchFooter), {
        icon: icon,
        title: intl.formatMessage((0, $g8fQj.messages).jira_advanced_search),
        rightMetadata: rightMetadata,
        url: url,
        onResultClicked: onResultClicked
    });
};

});
parcelRegister("ltx9b", function(module, exports) {

$parcel$export(module.exports, "CommandIcon", () => $738ebcb5194247d5$export$76bfbab5e3f9a6a3);
// Copied from packages/search/product-search-dialog/src/extensible/quick-find/icons/command-icon.tsx

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");
const $738ebcb5194247d5$export$76bfbab5e3f9a6a3 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.89453 8.89551H6.88965C5.80957 8.89551 4.93457 8.04785 4.93457 6.96094C4.93457 5.87402 5.80957 4.99902 6.88965 4.99902C7.96973 4.99902 8.84473 5.87402 8.84473 6.96094V7.95898H11.1553V6.96094C11.1553 5.87402 12.0303 4.99902 13.1104 4.99902C14.1904 4.99902 15.0654 5.87402 15.0654 6.96094C15.0654 8.04785 14.1904 8.89551 13.1104 8.89551H12.1123V11.2402H13.1104C14.1904 11.2402 15.0654 12.0879 15.0654 13.1748C15.0654 14.2617 14.1904 15.1367 13.1104 15.1367C12.0303 15.1367 11.1553 14.2617 11.1553 13.1748V12.1768H8.84473V13.1748C8.84473 14.2617 7.96973 15.1367 6.88965 15.1367C5.80957 15.1367 4.93457 14.2617 4.93457 13.1748C4.93457 12.0879 5.80957 11.2402 6.88965 11.2402H7.89453V8.89551ZM6.88965 7.97266H7.89453V6.96094C7.89453 6.40723 7.43652 5.95605 6.88965 5.95605C6.34277 5.95605 5.88477 6.40723 5.88477 6.96094C5.88477 7.51465 6.34277 7.97266 6.88965 7.97266ZM13.1104 7.97266C13.6572 7.97266 14.1152 7.51465 14.1152 6.96094C14.1152 6.40723 13.6572 5.95605 13.1104 5.95605C12.5635 5.95605 12.1123 6.40723 12.1123 6.96094V7.97266H13.1104ZM8.84473 11.2539H11.1553V8.88184H8.84473V11.2539ZM6.88965 12.1562C6.34277 12.1562 5.88477 12.6143 5.88477 13.168C5.88477 13.7217 6.34277 14.1729 6.88965 14.1729C7.43652 14.1729 7.89453 13.7217 7.89453 13.168V12.1562H6.88965ZM13.1104 12.1562H12.1123V13.168C12.1123 13.7217 12.5635 14.1729 13.1104 14.1729C13.6572 14.1729 14.1152 13.7217 14.1152 13.168C14.1152 12.6143 13.6572 12.1562 13.1104 12.1562Z",
                fill: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
            })
        ]
    });

});

parcelRegister("k2YFb", function(module, exports) {

$parcel$export(module.exports, "ReturnIcon", () => $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");
const $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "nonzero",
                d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
                fill: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
            })
        ]
    });

});

parcelRegister("83gV2", function(module, exports) {

$parcel$export(module.exports, "SearchFooter", () => $02caee92bec6b3d2$export$64ded8b71dfcba9e);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $26eSY = parcelRequire("26eSY");

var $icqFF = parcelRequire("icqFF");

var $7WbA8 = parcelRequire("7WbA8");
const $02caee92bec6b3d2$var$resultStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.100',
    paddingBlockEnd: 'space.100',
    paddingInlineStart: 'space.200',
    paddingInlineEnd: 'space.200',
    display: 'flex',
    alignItems: 'center'
});
const $02caee92bec6b3d2$var$resultHoveredStlyes = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $02caee92bec6b3d2$var$keyboardHighlightedStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $02caee92bec6b3d2$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $02caee92bec6b3d2$var$middleAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    flex: 1,
    marginLeft: 'space.150'
});
const $02caee92bec6b3d2$var$titleStyles = (0, $ecnYn.xcss)({
    overflow: 'clip',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'font.body',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $02caee92bec6b3d2$var$textOverflowStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $02caee92bec6b3d2$var$rightSectionStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: 'space.150'
});
const $02caee92bec6b3d2$var$linkStyles = (0, $ecnYn.xcss)({
    color: 'color.text',
    textDecoration: 'none',
    display: 'inline-block',
    width: '100%',
    ':focus-visible': {
        outlineStyle: 'solid',
        outlineColor: 'color.border.accent.blue',
        outlineWidth: 'space.025',
        // @ts-ignore
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    ':hover': {
        textDecoration: 'none',
        color: 'color.text'
    },
    ':visited': {
        textDecoration: 'none',
        color: 'color.text'
    }
});
const $02caee92bec6b3d2$export$64ded8b71dfcba9e = ({ icon: icon, title: title, rightMetadata: rightMetadata, url: url, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu })=>{
    const ref = (0, $gwFzn.useRef)();
    const [isHovered, setIsHovered] = (0, $gwFzn.useState)(false);
    const { linkComponent: Link } = (0, $7WbA8.useAppContext)();
    const [isKeyboardHighlighted, setRef] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: ()=>{
            ref.current?.click();
        },
        onHighlightedCallback: ()=>{}
    });
    const onClick = (0, $gwFzn.useCallback)((event)=>{
        onResultClicked?.(event);
    }, [
        onResultClicked
    ]);
    const onContextMenu = (0, $gwFzn.useCallback)((event)=>{
        onResultContextMenu?.(event);
    }, [
        onResultContextMenu
    ]);
    return (0, $dh538.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
        backgroundColor: "color.background.neutral.subtle",
        onClick: onClick,
        onContextMenu: onContextMenu,
        testId: "search-dialog-footer",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)(Link, {
            xcss: [
                $02caee92bec6b3d2$var$linkStyles
            ],
            href: url,
            testId: "search-dialog-footer-link",
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                xcss: [
                    $02caee92bec6b3d2$var$resultStyles,
                    isHovered && $02caee92bec6b3d2$var$resultHoveredStlyes,
                    isKeyboardHighlighted && $02caee92bec6b3d2$var$keyboardHighlightedStyles
                ],
                ref: (node)=>{
                    ref.current = node;
                    setRef(node);
                },
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$iconAreaStyles,
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$middleAreaStyles,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: [
                                $02caee92bec6b3d2$var$titleStyles,
                                $02caee92bec6b3d2$var$textOverflowStyles
                            ],
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$rightSectionStyles,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $26eSY.Show), {
                            above: "xs",
                            children: rightMetadata
                        })
                    })
                ]
            })
        })
    }) : // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        onClick: onClick,
        onContextMenu: onContextMenu,
        testId: "search-dialog-footer",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)(Link, {
            xcss: [
                $02caee92bec6b3d2$var$linkStyles
            ],
            href: url,
            testId: "search-dialog-footer-link",
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                xcss: [
                    $02caee92bec6b3d2$var$resultStyles,
                    isHovered && $02caee92bec6b3d2$var$resultHoveredStlyes,
                    isKeyboardHighlighted && $02caee92bec6b3d2$var$keyboardHighlightedStyles
                ],
                ref: (node)=>{
                    ref.current = node;
                    setRef(node);
                },
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$iconAreaStyles,
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$middleAreaStyles,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: [
                                $02caee92bec6b3d2$var$titleStyles,
                                $02caee92bec6b3d2$var$textOverflowStyles
                            ],
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$rightSectionStyles,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $26eSY.Show), {
                            above: "xs",
                            children: rightMetadata
                        })
                    })
                ]
            })
        })
    });
};

});

parcelRegister("g8fQj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $cb4c307b2668c972$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $cb4c307b2668c972$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    jira_advanced_search: {
        id: "jira_advanced_search",
        defaultMessage: "Jira Advanced Search"
    }
});

});


parcelRegister("kMtrE", function(module, exports) {

$parcel$export(module.exports, "JiraSingleSiteSearch", () => $ad3c6b6b491bd60c$export$72bf2a5ecf09330e);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $fEibl = parcelRequire("fEibl");

var $fpGTa = parcelRequire("fpGTa");
var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $6fnsQ = parcelRequire("6fnsQ");

var $4VmlX = parcelRequire("4VmlX");

var $e8RPG = parcelRequire("e8RPG");
const $ad3c6b6b491bd60c$var$styles = (0, $ecnYn.xcss)({
    height: '100%',
    display: 'inline-block'
});
const $ad3c6b6b491bd60c$var$singleSiteContainer = (0, $ecnYn.xcss)({
    padding: 'space.100'
});
const $ad3c6b6b491bd60c$var$iconContainer = (0, $ecnYn.xcss)({
    marginLeft: 'space.150',
    marginRight: 'space.150'
});
const $ad3c6b6b491bd60c$var$labelContainer = (0, $ecnYn.xcss)({
    marginRight: 'space.100',
    marginLeft: 'space.050',
    color: 'color.text',
    ':hover': {
        color: 'color.text'
    },
    ':focus': {
        color: 'color.text'
    }
});
const $ad3c6b6b491bd60c$var$styleLink = (0, $ecnYn.xcss)({
    WebkitBoxAlign: 'baseline',
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'inline-flex',
    justifyContent: 'center',
    fontWeight: 'font.weight.medium',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    border: `2px solid ${`var(--ds-border, ${(0, $6fnsQ.N900)})`}`,
    borderRadius: '4px',
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    marginRight: 'space.100',
    color: 'color.text.subtle',
    textDecoration: 'none',
    transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    ':hover': {
        color: 'color.text.subtle',
        backgroundColor: 'color.background.neutral.hovered',
        textDecoration: 'none',
        transition: 'background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
    },
    ':visited': {
        color: 'color.text.subtle'
    },
    ':focus-visible': {
        color: 'color.text.subtle'
    },
    ':focus': {
        color: 'color.text.subtle'
    }
});
var $ad3c6b6b491bd60c$var$JiraFooterLinkActionSubjectId = /*#__PURE__*/ function(JiraFooterLinkActionSubjectId) {
    JiraFooterLinkActionSubjectId["JIRA_BOARDS"] = "jiraBoardsSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_FILTERS"] = "jiraFiltersSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_PROJECTS"] = "jiraProjectsSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_PLANS"] = "jiraPlansSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_PEOPLE"] = "jiraPeopleSearchLink";
    return JiraFooterLinkActionSubjectId;
}($ad3c6b6b491bd60c$var$JiraFooterLinkActionSubjectId || {});
const $ad3c6b6b491bd60c$export$4c85ccfa2dce935c = (query)=>{
    const allLinks = {
        board: {
            href: `/secure/ManageRapidViews.jspa?contains=${query}`,
            message: (0, $e8RPG.messages).jira_quick_find_boards,
            actionSubjectId: "jiraBoardsSearchLink"
        },
        project: {
            href: `/projects?contains=${query}`,
            message: (0, $e8RPG.messages).jira_quick_find_projects,
            actionSubjectId: "jiraProjectsSearchLink"
        },
        filters: {
            href: `/secure/ManageFilters.jspa?Search=Search&filterView=search&name=${query}`,
            message: (0, $e8RPG.messages).jira_quick_find_filters,
            actionSubjectId: "jiraFiltersSearchLink"
        },
        plans: {
            href: `/jira/plans`,
            message: (0, $e8RPG.messages).jira_quick_find_plans,
            actionSubjectId: "jiraPlansSearchLink"
        },
        people: {
            href: `/jira/people/search?q=${query}`,
            message: (0, $e8RPG.messages).jira_quick_find_people,
            actionSubjectId: "jiraPeopleSearchLink"
        }
    };
    return allLinks;
};
const $ad3c6b6b491bd60c$export$72bf2a5ecf09330e = ({ state: state, onClick: onClick })=>{
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const searchConfiguration = $ad3c6b6b491bd60c$export$4c85ccfa2dce935c(quickFindQuery);
    const onFilterClick = (0, $gwFzn.useCallback)((event, actionSubjectId)=>{
        onClick({
            state: state,
            event: event,
            actionSubjectId: actionSubjectId
        });
    }, [
        onClick,
        state
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $ad3c6b6b491bd60c$var$singleSiteContainer,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                as: "span",
                xcss: $ad3c6b6b491bd60c$var$iconContainer,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fEibl))), {
                    label: "navigate-single-site-icon"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                as: "span",
                xcss: $ad3c6b6b491bd60c$var$labelContainer,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $e8RPG.messages).jira_quick_find_single_site_label
                })
            }),
            Object.keys(searchConfiguration).map((key)=>{
                const { href: href, message: message, actionSubjectId: actionSubjectId } = searchConfiguration[key];
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    role: "none",
                    xcss: $ad3c6b6b491bd60c$var$styles,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fpGTa.default), {
                        xcss: $ad3c6b6b491bd60c$var$styleLink,
                        href: href,
                        onClick: (event)=>onFilterClick(event, actionSubjectId),
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...message
                        })
                    })
                }, `single_site_${key}`);
            })
        ]
    });
};

});
parcelRegister("e8RPG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2edb72d725c5d8f9$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $2edb72d725c5d8f9$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    jira_quick_find_single_site_label: {
        id: "jira_single_site_label",
        defaultMessage: "Navigate to"
    },
    jira_quick_find_projects: {
        id: "jira_single_site_projects",
        defaultMessage: "Projects"
    },
    jira_quick_find_boards: {
        id: "jira_single_site_boards",
        defaultMessage: "Boards"
    },
    jira_quick_find_filters: {
        id: "jira_single_site_filters",
        defaultMessage: "Filters"
    },
    jira_quick_find_plans: {
        id: "jira_single_site_plans",
        defaultMessage: "Plans"
    },
    jira_quick_find_people: {
        id: "jira_single_site_people",
        defaultMessage: "People"
    }
});

});


parcelRegister("aBMZB", function(module, exports) {

$parcel$export(module.exports, "LandingScreen", () => $9ebd3fccc7b29e09$export$144e5acf8752ad4a);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $9vOy1 = parcelRequire("9vOy1");

var $7WbA8 = parcelRequire("7WbA8");

var $j4ply = parcelRequire("j4ply");

var $kG9Ys = parcelRequire("kG9Ys");

const $9ebd3fccc7b29e09$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("d6iVp")));
const $9ebd3fccc7b29e09$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.200',
    color: 'color.text'
});
const $9ebd3fccc7b29e09$var$imageFallbackStyles = (0, $ecnYn.xcss)({
    width: '124px',
    height: '124px'
});
const $9ebd3fccc7b29e09$var$headingStyles = (0, $ecnYn.xcss)({
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    marginTop: 'space.100'
});
const $9ebd3fccc7b29e09$var$bodyStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    font: 'font.body'
});
const $9ebd3fccc7b29e09$export$144e5acf8752ad4a = ()=>{
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const bodyCopy = applicationMode === (0, $9vOy1.ApplicationModes).Rovo ? (0, $kG9Ys.messages).quickFindNoContentBodyWithRovo : isAdminHubAIEnabled ? (0, $kG9Ys.messages).quickFindNoContentBodyWithAtlassianIntelligence : (0, $kG9Ys.messages).quickFindNoContentBodyDefault;
    const newBodyCopy = applicationMode === (0, $9vOy1.ApplicationModes).Rovo && isRovoLLMEnabled || isAdminHubAIEnabled ? (0, $kG9Ys.messages).quickFindNoContentBodyWithAI : (0, $kG9Ys.messages).quickFindNoContentBody;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $9ebd3fccc7b29e09$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $9ebd3fccc7b29e09$var$imageFallbackStyles
                }),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($9ebd3fccc7b29e09$var$Image, {})
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $9ebd3fccc7b29e09$var$headingStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25') ? newBodyCopy : bodyCopy
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $9ebd3fccc7b29e09$var$bodyStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $kG9Ys.messages).quickFindNoContentHeading
                })
            })
        ]
    });
};

});
parcelRegister("kG9Ys", function(module, exports) {

$parcel$export(module.exports, "messages", () => $678282c0e0260f8c$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $678282c0e0260f8c$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    quickFindNoContentHeading: {
        id: "search_dialog_no_content_heading",
        defaultMessage: "Seek and you shall find"
    },
    quickFindNoContentBodyWithRovo: {
        id: "search_dialog_no_content_body_with_rovo",
        defaultMessage: "Search or ask Rovo what you're looking for in your Atlassian and integrated products"
    },
    quickFindNoContentBodyWithAtlassianIntelligence: {
        id: "search_dialog_no_content_body_with_atlassian_intelligence",
        defaultMessage: "Search or ask anything across your Atlassian products"
    },
    quickFindNoContentBodyDefault: {
        id: "search_dialog_no_content_body",
        defaultMessage: "Search for anything across your Atlassian products"
    },
    quickFindNoContentBody: {
        id: "search_dialog_no_content_body",
        defaultMessage: "Search for what you're looking for in your Atlassian and integrated products"
    },
    quickFindNoContentBodyWithAI: {
        id: "search_dialog_no_content_body_with_atlassian_intelligence",
        defaultMessage: "Search or ask what you're looking for in your Atlassian and integrated products"
    }
});

});

parcelRegister("d6iVp", function(module, exports) {

let $989a8402a1e78ab9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $989a8402a1e78ab9$var$load("atmg2").then(()=>parcelRequire('iTSW4'));

});


parcelRegister("iUdW4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3f03f084e86b29e6$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $3f03f084e86b29e6$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    searchDialogAriaLabel: {
        id: "search_dialog_aria_label",
        defaultMessage: "Search Dialog"
    },
    recentsHeading: {
        id: "search_dialog_recents_heading",
        defaultMessage: "Recently viewed"
    },
    searchResultsHeading: {
        id: "recents_heading",
        defaultMessage: "Search Results"
    },
    forYou: {
        id: "for_you_heading",
        defaultMessage: "For You"
    }
});

});

parcelRegister("8SdvD", function(module, exports) {

$parcel$export(module.exports, "NoResultsScreen", () => $c5e5408b5df96d67$export$373c6a9b01d625eb);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $7WbA8 = parcelRequire("7WbA8");

var $4VmlX = parcelRequire("4VmlX");

var $eWG0a = parcelRequire("eWG0a");

const $c5e5408b5df96d67$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("34gzq")));
const $c5e5408b5df96d67$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.200',
    color: 'color.text'
});
const $c5e5408b5df96d67$var$imageFallbackStyles = (0, $ecnYn.xcss)({
    width: '124px',
    height: '124px'
});
const $c5e5408b5df96d67$var$headingStyles = (0, $ecnYn.xcss)({
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    marginTop: 'space.100'
});
const $c5e5408b5df96d67$var$bodyStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    font: 'font.body'
});
const $c5e5408b5df96d67$var$pressableStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    font: 'font.body',
    color: 'color.link',
    padding: 'space.0',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    }
});
const $c5e5408b5df96d67$export$373c6a9b01d625eb = ({ onRetry: onRetry })=>{
    const { linkComponent: Link, generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $c5e5408b5df96d67$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $c5e5408b5df96d67$var$imageFallbackStyles
                }),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($c5e5408b5df96d67$var$Image, {})
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $c5e5408b5df96d67$var$headingStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $eWG0a.messages).noResultsHeading,
                    values: {
                        button: (s)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
                                xcss: $c5e5408b5df96d67$var$pressableStyles,
                                onClick: onRetry,
                                children: s
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $c5e5408b5df96d67$var$bodyStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $eWG0a.messages).noResultsBody,
                    values: {
                        link: (s)=>/*#__PURE__*/ (0, $7UHDa.jsx)(Link, {
                                xcss: $c5e5408b5df96d67$var$pressableStyles,
                                href: generateSearchUrl({
                                    ...queryParams,
                                    text: quickFindQuery
                                }),
                                children: s
                            })
                    }
                })
            })
        ]
    });
};

});
parcelRegister("eWG0a", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bc6e38173da21e1a$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $bc6e38173da21e1a$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    noResultsHeading: {
        id: "search_dialog_no_results_heading",
        defaultMessage: "We couldn't find any results with that title"
    },
    noResultsBody: {
        id: "search_dialog_error_search_body",
        defaultMessage: "<link>Search all content across your organization</link> or try again with a different term."
    }
});

});

parcelRegister("34gzq", function(module, exports) {

let $23be995ad26ad65d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $23be995ad26ad65d$var$load("g5R8w").then(()=>parcelRequire('6r800'));

});


parcelRegister("fvCil", function(module, exports) {

$parcel$export(module.exports, "PeopleAndTeams", () => $18e1948c3888bb1b$export$c84e51771b9ba67c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $esRft = parcelRequire("esRft");

var $u9agA = parcelRequire("u9agA");

var $c5JjN = parcelRequire("c5JjN");

var $icWhS = parcelRequire("icWhS");
var $aU479 = parcelRequire("aU479");
var $bloXB = parcelRequire("bloXB");

var $k2YFb = parcelRequire("k2YFb");

var $7WbA8 = parcelRequire("7WbA8");

var $eKxuB = parcelRequire("eKxuB");

var $j4ply = parcelRequire("j4ply");

var $4VmlX = parcelRequire("4VmlX");

var $hr82m = parcelRequire("hr82m");
const $18e1948c3888bb1b$export$c84e51771b9ba67c = ({ result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted })=>{
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [orgId] = (0, $j4ply.useOrgId)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const { generateTeamUrl: generateTeamUrl, generateUserUrl: generateUserUrl } = (0, $7WbA8.useAppContext)();
    const id = result.id;
    const userTitle = result.name;
    const teamTitle = result.displayName;
    const title = result.entityType === (0, $c5JjN.EntityType).USER ? userTitle : teamTitle;
    const highlightedTitle = title && quickFindQuery ? (0, $bloXB.highlightMatchedText)(title, quickFindQuery.split(' ')).highlightedTitle : undefined;
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
    });
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
        appearance: result.entityType === (0, $c5JjN.EntityType).USER ? 'circle' : 'square',
        borderColor: "transparent",
        name: title,
        size: 'small',
        src: result.avatarUrl || result.smallAvatarImageUrl
    });
    const userMetadata = [
        'user-metadata',
        result.title
    ];
    const teamMetadata = [
        'team-metadata',
        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $hr82m.messages).team
        })
    ];
    const metadata = result.entityType === (0, $c5JjN.EntityType).USER ? [
        userMetadata
    ] : [
        teamMetadata
    ];
    let path;
    // TODO remove this statement once all products have specified their own generateUserUrl and generateTeamUrl props
    if (primaryProduct && orgId && cloudId) path = result.entityType === (0, $c5JjN.EntityType).USER ? (0, $aU479.getUserPath)(result.id, primaryProduct, orgId, cloudId) : (0, $aU479.getTeamPath)(result.id, primaryProduct, orgId, cloudId);
    if (generateUserUrl && result.entityType === (0, $c5JjN.EntityType).USER) path = generateUserUrl(result.id);
    else if (generateTeamUrl && result.entityType !== (0, $c5JjN.EntityType).USER) path = generateTeamUrl(result.id);
    const url = path && new URL(path, window.location.origin).href;
    const analyticsMetadata = (0, $gwFzn.useMemo)(()=>({
            contentId: id,
            contentType: 'user'
        }), [
        id
    ]);
    const onResultClicked = (0, $gwFzn.useCallback)((event, data)=>{
        onClick?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: {
                metadata: analyticsMetadata
            }
        });
    }, [
        analyticsMetadata,
        onClick,
        state
    ]);
    const onResultContextMenu = (0, $gwFzn.useCallback)((event, data)=>{
        onContextMenu?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: {
                metadata: analyticsMetadata
            }
        });
    }, [
        analyticsMetadata,
        onContextMenu,
        state
    ]);
    const onResultHighlighted = (0, $gwFzn.useCallback)((data)=>{
        onHighlighted?.({
            data: data,
            state: state,
            additionalAnalyticsAttributes: {
                metadata: analyticsMetadata
            }
        });
    }, [
        analyticsMetadata,
        onHighlighted,
        state
    ]);
    if (!title || !metadata || !url) return null;
    const urlWithAnalyticsQueryParams = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: url,
        searchSessionId: searchSessionId
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eKxuB.SearchResult), {
        id: id,
        icon: icon,
        resultType: "peopleAndTeams",
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: urlWithAnalyticsQueryParams,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onResultHighlighted: onResultHighlighted
    });
};

});
parcelRegister("icWhS", function(module, exports) {

$parcel$export(module.exports, "getConfluenceUrlWithAnalyticsQueryParams", () => $2ffa685ce1f1083f$export$ce6d1d009c92f1be);
$parcel$export(module.exports, "getJiraUrlWithAnalyticsQueryParams", () => $2ffa685ce1f1083f$export$b780bd7096d811c5);
$parcel$export(module.exports, "getGenericUrlWithAnalyticsQueryParams", () => $2ffa685ce1f1083f$export$a5abc05a86b8de68);

var $aU479 = parcelRequire("aU479");
const $2ffa685ce1f1083f$var$CONFLUENCE_VALUE_SEPARATOR = '---';
const $2ffa685ce1f1083f$var$CONFLUENCE_ATTRIBUTE_SEPARATOR = '___';
const $2ffa685ce1f1083f$export$ce6d1d009c92f1be = ({ url: url, query: query, searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics })=>{
    const urlObject = new URL(url);
    urlObject.searchParams.set('search_id', searchSessionId);
    let events = [];
    if (query) events.push(`queryHash${$2ffa685ce1f1083f$var$CONFLUENCE_VALUE_SEPARATOR}${(0, $aU479.hashData)(query)}`);
    if (additionalAnalytics) Object.entries(additionalAnalytics).forEach(([attribute, value])=>{
        events.push(`${attribute}${$2ffa685ce1f1083f$var$CONFLUENCE_VALUE_SEPARATOR}${value}`);
    });
    if (events.length === 0) return urlObject.toString();
    const analyticsFormattedForUrlParsing = encodeURIComponent(events.join($2ffa685ce1f1083f$var$CONFLUENCE_ATTRIBUTE_SEPARATOR));
    urlObject.searchParams.set('additional_analytics', analyticsFormattedForUrlParsing);
    return urlObject.toString();
};
const $2ffa685ce1f1083f$export$2e67c54459604a9 = (additionalAnalytics)=>{
    const formattedEvents = {};
    if (typeof additionalAnalytics !== 'string') return formattedEvents;
    const events = additionalAnalytics?.split($2ffa685ce1f1083f$var$CONFLUENCE_ATTRIBUTE_SEPARATOR);
    events.forEach((event)=>{
        const formattedEvent = event?.split($2ffa685ce1f1083f$var$CONFLUENCE_VALUE_SEPARATOR);
        const hasProperlyFormattedEvent = formattedEvent.length === 2;
        if (hasProperlyFormattedEvent) formattedEvents[formattedEvent[0]] = formattedEvent[1];
    });
    return formattedEvents;
};
const $2ffa685ce1f1083f$export$b780bd7096d811c5 = ({ url: url, searchSessionId: searchSessionId, resultId: resultId, projectId: projectId })=>{
    const jiraResultARIPattern = /^ari:cloud:jira:[a-z0-9-]+:[a-z]+\/[0-9]+$/;
    if (!resultId.match(jiraResultARIPattern)) return url;
    const jiraProjectARIPattern = /^ari:cloud:jira:[a-z0-9-]+:project\/[0-9]+$/;
    if (projectId && !projectId.match(jiraProjectARIPattern)) return url;
    const urlObject = new URL(url);
    urlObject.searchParams.set('searchSessionId', searchSessionId);
    const searchObjectId = resultId.split('/').pop();
    searchObjectId && urlObject.searchParams.set('searchObjectId', searchObjectId);
    const searchContentType = resultId.split('/')[0].split(':').pop();
    searchContentType && urlObject.searchParams.set('searchContentType', searchContentType);
    const searchContainerId = projectId?.split('/').pop();
    searchContainerId && urlObject.searchParams.set('searchContainerId', searchContainerId);
    return urlObject.toString();
};
const $2ffa685ce1f1083f$export$a5abc05a86b8de68 = ({ url: url, searchSessionId: searchSessionId })=>{
    const urlObject = new URL(url);
    urlObject.searchParams.set('search_id', searchSessionId);
    return urlObject.toString();
};

});

parcelRegister("eKxuB", function(module, exports) {

$parcel$export(module.exports, "SearchResult", () => $2944de3e13791145$export$a2def421b23768aa);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $26eSY = parcelRequire("26eSY");

var $9lW6K = parcelRequire("9lW6K");

var $icqFF = parcelRequire("icqFF");

var $9wmQG = parcelRequire("9wmQG");

var $7WbA8 = parcelRequire("7WbA8");

var $a7nUd = parcelRequire("a7nUd");
const $2944de3e13791145$var$containerStyles = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.100',
    marginInlineEnd: 'space.100'
});
const $2944de3e13791145$var$resultStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.075',
    paddingBlockEnd: 'space.075',
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100',
    borderRadius: 'border.radius.200',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
});
const $2944de3e13791145$var$resultHoveredStlyes = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $2944de3e13791145$var$keyboardHighlightedStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $2944de3e13791145$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $2944de3e13791145$var$middleAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    flex: 1,
    marginLeft: 'space.150'
});
const $2944de3e13791145$var$titleStyles = (0, $ecnYn.xcss)({
    overflow: 'clip',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'font.body',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $2944de3e13791145$var$metadataStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    font: 'font.body.small',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '13px',
    display: 'flex',
    alignItems: 'center',
    minWidth: '0'
});
const $2944de3e13791145$var$textOverflowStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $2944de3e13791145$var$rightSectionStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: 'space.150'
});
const $2944de3e13791145$var$linkStyles = (0, $ecnYn.xcss)({
    color: 'color.text',
    textDecoration: 'none',
    display: 'inline-block',
    width: '100%',
    borderRadius: 'border.radius.200',
    ':hover': {
        textDecoration: 'none',
        color: 'color.text'
    },
    ':visited': {
        textDecoration: 'none',
        color: 'color.text'
    }
});
const $2944de3e13791145$var$headingStyle = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    gap: 'space.075',
    alignItems: 'center',
    maxWidth: '100%'
});
const $2944de3e13791145$export$a2def421b23768aa = ({ icon: icon, title: title, resultType: resultType, product: product, metadata: metadata = [], rightMetadata: rightMetadata, hoveredRightMetadata: hoveredRightMetadata, highlightedRightMetadata: highlightedRightMetadata, url: url, isThirdParty: isThirdParty = false, highlightedTitle: highlightedTitle, includeInAnalytics: includeInAnalytics = true, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onResultHighlighted: onResultHighlighted, titleMetadataParts: titleMetadataParts })=>{
    const wrapperRef = (0, $gwFzn.useRef)(null);
    const ref = (0, $gwFzn.useRef)();
    const [isHovered, setIsHovered] = (0, $gwFzn.useState)(false);
    const { linkComponent: Link } = (0, $7WbA8.useAppContext)();
    const [isKeyboardHighlighted, setRef] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: (e)=>{
            /**
			 * Two different event listeners are used to handle enter key presses
			 * when the input is focused:
			 * - the onKeyDown callback on the Textfield component which uses
			 *   React's synthetic event listeners (onKeyDown)
			 * - the keyboard highlight provider's onKeydownCallback which
			 *   uses native event listeners (window.addEventListener). This one
			 *   will only be called if a search result is highlighted.
			 * Ideally there should be only one event listener however, it isn't
			 * worth the effort to refactor the keyboard highlight provider right now.
			 *
			 * Given that the keyboard highlight provider's callback uses native
			 * event listeners, it will always be called first. This is a problem
			 * because there is no way for the keyboard highlight provider to
			 * communicate that the event has been handled, resulting in a bug
			 * where we try to handle the event twice if a search result was
			 * highlighted. It must be noted that it cannot be guaranteed that
			 * the search results are still highlighted after the native event
			 * listener has executed as it could close the search dialog.
			 *
			 * To fix this, a somewhat hacky solution has been added to delay
			 * the click event in the keyboard highlight provdier by one frame
			 * in search-dialog-result/index. This allows the React synthetic
			 * event to decide if it should handle the event by checking if a
			 * search result is highlighted, otherwise it will do nothing and
			 * let the keyboard highlight provider handle the event.
			 */ requestAnimationFrame(()=>{
                if (e.key === 'Enter') ref.current?.click();
            });
        },
        onHighlightedCallback: ()=>{
            const data = wrapperRef.current ? (0, $9wmQG.getNodePosition)(wrapperRef.current) : {};
            onResultHighlighted?.(data);
        }
    });
    const onClick = (0, $gwFzn.useCallback)((event)=>{
        const data = wrapperRef.current ? (0, $9wmQG.getNodePosition)(wrapperRef.current) : {};
        onResultClicked?.(event, data);
    }, [
        onResultClicked
    ]);
    const onContextMenu = (0, $gwFzn.useCallback)((event)=>{
        const data = wrapperRef.current ? (0, $9wmQG.getNodePosition)(wrapperRef.current) : {};
        onResultContextMenu?.(event, data);
    }, [
        onResultContextMenu
    ]);
    const metadataPartsWithTextOverflow = metadata.map((part, i)=>i === metadata.length - 1 && typeof part === 'string' ? [
            part,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$textOverflowStyles,
                as: "span",
                children: part
            })
        ] : part);
    const content = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        ref: (node)=>{
            ref.current = node;
            setRef(node);
        },
        xcss: [
            $2944de3e13791145$var$resultStyles,
            isHovered && $2944de3e13791145$var$resultHoveredStlyes,
            isKeyboardHighlighted && $2944de3e13791145$var$keyboardHighlightedStyles
        ],
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$iconAreaStyles,
                children: icon
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$middleAreaStyles,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                        xcss: $2944de3e13791145$var$headingStyle,
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                xcss: [
                                    $2944de3e13791145$var$titleStyles,
                                    $2944de3e13791145$var$textOverflowStyles
                                ],
                                children: highlightedTitle ? (0, $9lW6K.enrichResultTitle)(highlightedTitle) : title
                            }),
                            titleMetadataParts && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7nUd.SearchMetadata), {
                                    parts: titleMetadataParts
                                })
                            })
                        ]
                    }),
                    metadata.length >= 1 && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $2944de3e13791145$var$metadataStyles
                        ],
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7nUd.SearchMetadata), {
                            parts: metadataPartsWithTextOverflow
                        })
                    })
                ]
            }),
            hoveredRightMetadata && isHovered ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$rightSectionStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $26eSY.Show), {
                    above: "xs",
                    children: hoveredRightMetadata
                })
            }) : highlightedRightMetadata && isKeyboardHighlighted ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$rightSectionStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $26eSY.Show), {
                    above: "xs",
                    children: highlightedRightMetadata
                })
            }) : rightMetadata ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$rightSectionStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $26eSY.Show), {
                    above: "xs",
                    children: rightMetadata
                })
            }) : null
        ]
    });
    const resultWithoutAnalyticsWrapper = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $2944de3e13791145$var$containerStyles,
        children: (0, $dh538.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
            backgroundColor: "color.background.neutral.subtle",
            onClick: onClick,
            onContextMenu: onContextMenu,
            children: url ? /*#__PURE__*/ (0, $7UHDa.jsx)(Link, {
                xcss: [
                    $2944de3e13791145$var$linkStyles
                ],
                rel: isThirdParty ? 'noreferrer' : '',
                target: isThirdParty ? '_blank' : undefined,
                href: url,
                children: content
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                children: content
            })
        }) : // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            onClick: onClick,
            onContextMenu: onContextMenu,
            children: url ? /*#__PURE__*/ (0, $7UHDa.jsx)(Link, {
                xcss: $2944de3e13791145$var$linkStyles,
                rel: isThirdParty ? 'noreferrer' : '',
                target: isThirdParty ? '_blank' : undefined,
                href: url,
                children: content
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                children: content
            })
        })
    });
    return includeInAnalytics ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9wmQG.SearchDialogResultAnalyticsWrapper), {
        role: "listitem",
        "data-testid": "search-dialog-result",
        ref: wrapperRef,
        resultType: resultType,
        product: product,
        children: resultWithoutAnalyticsWrapper
    }) : resultWithoutAnalyticsWrapper;
};

});
parcelRegister("9lW6K", function(module, exports) {

$parcel$export(module.exports, "enrichResultTitle", () => $d2d3be1d2699235a$export$c43ff622b37ceaa9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
const $d2d3be1d2699235a$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $d2d3be1d2699235a$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $d2d3be1d2699235a$var$highlightRE = new RegExp(`${$d2d3be1d2699235a$var$HIGHLIGHT_START_TAG}(.*?)${$d2d3be1d2699235a$var$HIGHLIGHT_END_TAG}.*`);
const $d2d3be1d2699235a$var$openingTagRE = new RegExp(`(.*?)${$d2d3be1d2699235a$var$HIGHLIGHT_START_TAG}`);
const $d2d3be1d2699235a$export$c43ff622b37ceaa9 = (title)=>{
    const enrichedTitle = [];
    // counter added to maintain uniqueness of element key
    // during subsequent rerenders due to query changes
    let counter = 0;
    if (!title.match($d2d3be1d2699235a$var$highlightRE)) // if there are no matches then return the title as is
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        as: "span",
        children: title
    }, title + counter);
    while(title){
        const [preMatch, preText] = title.match($d2d3be1d2699235a$var$openingTagRE) || [];
        title = title.replace(preText, '');
        if (preText && preText !== '') enrichedTitle.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            as: "span",
            children: preText
        }, preText + counter));
        const [boldMatch, highlightText] = title.match($d2d3be1d2699235a$var$highlightRE) || [];
        title = title.replace(`${$d2d3be1d2699235a$var$HIGHLIGHT_START_TAG}${highlightText}${$d2d3be1d2699235a$var$HIGHLIGHT_END_TAG}`, '');
        if (highlightText && highlightText !== '') enrichedTitle.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            as: "strong",
            children: highlightText
        }, highlightText + counter));
        if (preMatch === undefined && boldMatch === undefined) {
            if (title !== '') enrichedTitle.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                as: "span",
                children: title
            }, title + counter));
            break;
        }
        counter++;
    }
    return enrichedTitle;
};

});

parcelRegister("a7nUd", function(module, exports) {

$parcel$export(module.exports, "SearchMetadata", () => $d8124c60cf01e764$export$8e7fb1f8fe599124);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $1yEFx = parcelRequire("1yEFx");

var $Y34Hw = parcelRequire("Y34Hw");

var $h7sRY = parcelRequire("h7sRY");

var $mdlgz = parcelRequire("mdlgz");

var $gCEkV = parcelRequire("gCEkV");
const $d8124c60cf01e764$var$socialMetadataStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    paddingInlineStart: 'space.050',
    paddingInlineEnd: 'space.050'
});
const $d8124c60cf01e764$var$subheadingStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body'
});
const $d8124c60cf01e764$var$subheadingLeftAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'hidden'
});
const $d8124c60cf01e764$var$inlineStyles = (0, $ecnYn.xcss)({
    flex: '1 0 auto',
    position: 'absolute',
    zIndex: 'card',
    alignItems: 'center'
});
const $d8124c60cf01e764$var$hiddenReferenceInlineStyles = (0, $ecnYn.xcss)({
    flex: '1 0 auto',
    visibility: 'hidden',
    position: 'relative',
    zIndex: '1',
    alignItems: 'center'
});
const $d8124c60cf01e764$var$metadataItemStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    alignItems: 'center'
});
const $d8124c60cf01e764$var$renderParts = (part, spacer)=>{
    const [key, value] = Array.isArray(part) ? part : [
        part,
        part
    ];
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            value,
            spacer && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $mdlgz.Spacer), {})
        ]
    }, key);
};
const $d8124c60cf01e764$var$filterPart = (part)=>{
    if (Array.isArray(part)) return !!part[1];
    return !!part;
};
const $d8124c60cf01e764$var$renderSocialMetadata = (defaultSocialParts)=>{
    const socialSignalIndex = defaultSocialParts.findIndex((item)=>Array.isArray(item) && item[1] === 'social-signal');
    const hasBreadcrumb = socialSignalIndex !== -1;
    const parts = defaultSocialParts.filter((_, index)=>index !== socialSignalIndex).filter($d8124c60cf01e764$var$filterPart);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                space: "space.150",
                xcss: $d8124c60cf01e764$var$socialMetadataStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                    children: parts?.map((m)=>$d8124c60cf01e764$var$renderParts(m, false))
                })
            }),
            hasBreadcrumb && defaultSocialParts[defaultSocialParts.length - 1]
        ]
    });
};
const $d8124c60cf01e764$var$SearchMetadataWithOverflowObserver = ({ metadataItems: metadataItems, searchResultId: searchResultId, containerRef: containerRef })=>{
    const headerMetadataWithIds = metadataItems.map((item, index)=>{
        const prefix = searchResultId || 'default';
        return {
            id: `metadata-${prefix}-${index}`,
            content: item
        };
    });
    const headerMetadataRefs = (0, $gwFzn.useRef)([]);
    headerMetadataRefs.current = headerMetadataWithIds.map((_, i)=>headerMetadataRefs.current[i] ?? /*#__PURE__*/ (0, $gwFzn.createRef)());
    const visibleItems = (0, $gCEkV.useOverflowObserver)({
        containerRef: containerRef,
        itemRefs: headerMetadataRefs,
        itemIds: headerMetadataWithIds.map((item)=>item.id)
    });
    const hasHiddenItems = headerMetadataWithIds.length > visibleItems.length;
    const processVisibleItems = ()=>{
        const visibleMetadata = headerMetadataWithIds.filter((item)=>visibleItems.includes(item.id));
        // If we have hidden items, remove spacer from last visible item
        if (hasHiddenItems && visibleMetadata.length > 0) {
            const lastIndex = visibleMetadata.length - 1;
            visibleMetadata[lastIndex] = {
                ...visibleMetadata[lastIndex],
                content: (0, $Y34Hw.filterSpacer)(visibleMetadata[lastIndex].content)
            };
        }
        return visibleMetadata;
    };
    const processedVisibleItems = processVisibleItems();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: [
            $d8124c60cf01e764$var$subheadingLeftAreaStyles,
            $d8124c60cf01e764$var$subheadingStyles
        ],
        testId: "search-page-result-metadata",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                xcss: [
                    $d8124c60cf01e764$var$hiddenReferenceInlineStyles
                ],
                testId: "search-page-result-metadata-hidden",
                children: headerMetadataWithIds.map((item, index)=>{
                    const elementId = `reference:${item.id}`;
                    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        id: elementId,
                        ref: headerMetadataRefs.current[index],
                        xcss: $d8124c60cf01e764$var$metadataItemStyles,
                        children: item.content
                    }, elementId);
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                xcss: [
                    $d8124c60cf01e764$var$inlineStyles
                ],
                testId: "search-page-result-metadata-visible",
                children: [
                    processedVisibleItems.map((item)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $d8124c60cf01e764$var$metadataItemStyles,
                            children: item.content
                        }, `visible-${item.id}`)),
                    hasHiddenItems && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h7sRY.MetadataPopupButton), {
                        metadata: headerMetadataWithIds.filter((item)=>!visibleItems.includes(item.id)).map((item)=>item.content),
                        isFirstElement: processedVisibleItems.length === 0
                    })
                ]
            })
        ]
    });
};
const $d8124c60cf01e764$export$8e7fb1f8fe599124 = ({ searchResultId: searchResultId, product: product, productSelected: productSelected, parts: defaultParts = [], socialParts: defaultSocialParts = [], displaySpacer: displaySpacer = true, containerRef: containerRef })=>{
    const products = (0, $1yEFx.useProductConfigs)();
    // TODO: Shouldn't need to cast here, need to clean up the stack above this to not pass string around as product
    const productDisplayName = !product || productSelected ? '' : products[product]?.displayName || '';
    const parts = defaultParts.filter($d8124c60cf01e764$var$filterPart);
    const hasSocialParts = defaultSocialParts.filter($d8124c60cf01e764$var$filterPart).length > 0;
    if (hasSocialParts) parts.push([
        'social-metadata',
        $d8124c60cf01e764$var$renderSocialMetadata(defaultSocialParts)
    ]);
    if (productDisplayName) parts.unshift([
        'product-display-name',
        productDisplayName
    ]);
    const metadataItems = parts.map((m, i)=>$d8124c60cf01e764$var$renderParts(m, displaySpacer && i < parts.length - 1));
    // If we don't have a containerRef, we don't want to use the overflow observer
    return containerRef ? /*#__PURE__*/ (0, $7UHDa.jsx)($d8124c60cf01e764$var$SearchMetadataWithOverflowObserver, {
        metadataItems: metadataItems,
        searchResultId: searchResultId,
        containerRef: containerRef
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: metadataItems
    });
};

});
parcelRegister("Y34Hw", function(module, exports) {

$parcel$export(module.exports, "getWorkspaceNameFromProduct", () => $74113bae213f2e9f$export$ee0bd2121a6df2d5);
$parcel$export(module.exports, "processExcerpt", () => $74113bae213f2e9f$export$16c2ab98757b54d6);
$parcel$export(module.exports, "enrichExcerpt", () => $74113bae213f2e9f$export$b847312d69858d61);
$parcel$export(module.exports, "isNonPublic", () => $74113bae213f2e9f$export$f2f9c8e083d34d6b);
$parcel$export(module.exports, "isAWSThumbnailUrlExpired", () => $74113bae213f2e9f$export$c32a8291d21fb086);
$parcel$export(module.exports, "getRelativeTimeSince", () => $74113bae213f2e9f$export$fdcae512e9fdc5ad);
$parcel$export(module.exports, "getIntegrationKey", () => $74113bae213f2e9f$export$fb63ba58603395b8);
$parcel$export(module.exports, "getExternalMessageDmIntegrationInfo", () => $74113bae213f2e9f$export$596e547f4ce626bc);
$parcel$export(module.exports, "getUserData", () => $74113bae213f2e9f$export$3f90b926bc531097);
$parcel$export(module.exports, "getProductFromProviderId", () => $74113bae213f2e9f$export$b697429ad83cc9eb);
$parcel$export(module.exports, "getProductDisplayNameFromProviderId", () => $74113bae213f2e9f$export$eed5b9b4caf40e24);
$parcel$export(module.exports, "filterSpacer", () => $74113bae213f2e9f$export$325faed136549eaf);
/**
 * This file was adapted from confluence/next/packages/search-utils/src/excerpt.tsx
 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
var $iXCQx = parcelRequire("iXCQx");

var $iG0NV = parcelRequire("iG0NV");

var $1yEFx = parcelRequire("1yEFx");
const $74113bae213f2e9f$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?\/\[\]_\-+=`~\|:;{}\\]+/;
const $74113bae213f2e9f$var$MAX_EXCERPT_LENGTH = 80;
const $74113bae213f2e9f$export$2f5ba0d1129fe71 = (inputStr)=>{
    const htmlEntities = {
        '&nbsp;': ' ',
        '&lt;': '<',
        '&amp;': '&',
        '&quot;': '"',
        '&gt;': '>'
    };
    return Object.keys(htmlEntities).reduce((str, entity)=>{
        return str.replace(new RegExp(entity, 'g'), htmlEntities[entity]);
    }, inputStr);
};
const $74113bae213f2e9f$export$ee0bd2121a6df2d5 = (product, thirdPartyConfigs)=>{
    let workspaceName;
    if (product && (0, $1yEFx.is3pProductKey)(product) && thirdPartyConfigs) workspaceName = thirdPartyConfigs[product]?.displayWorkspaceNameAsProductName && thirdPartyConfigs[product]?.workspaceName;
    return workspaceName;
};
const $74113bae213f2e9f$export$16c2ab98757b54d6 = (excerpt, noLeadingEllipsis, prefix)=>{
    if (!excerpt) return [
        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
            children: ''
        }, "empty")
    ];
    excerpt = $74113bae213f2e9f$export$2f5ba0d1129fe71(excerpt).trim();
    if (!excerpt) return [
        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
            children: ''
        }, "empty")
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($74113bae213f2e9f$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipsis prefix if beginning of excerpt isn't a URL and excerpt length is greater than 80
    if (!noLeadingEllipsis && !beginsWithUrl && excerpt.length > $74113bae213f2e9f$var$MAX_EXCERPT_LENGTH) excerpt = '...'.concat(excerpt);
    // Add ellipsis suffix if excerpt doesn't end with ending punctuation and if length is greater than 80
    if (excerpt.length > $74113bae213f2e9f$var$MAX_EXCERPT_LENGTH && !excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with separators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $74113bae213f2e9f$export$b847312d69858d61(excerpt, prefix);
};
// Utility function to insert zero-width space every N characters
const $74113bae213f2e9f$var$insertZeroWidthSpace = (str, interval)=>{
    let result = '';
    for(let i = 0; i < str.length; i++){
        result += str[i];
        if ((i + 1) % interval === 0) result += '\u200B';
    }
    return result;
};
const $74113bae213f2e9f$export$ca7c2d622a259944 = (segment)=>{
    return segment.split(' ').map((word)=>{
        if (word.length > 20) return $74113bae213f2e9f$var$insertZeroWidthSpace(word, 5);
        return word;
    }).join(' ');
};
const $74113bae213f2e9f$export$b847312d69858d61 = (excerpt, prefix)=>{
    if (!excerpt) return [
        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
            children: ''
        }, "empty")
    ];
    excerpt = $74113bae213f2e9f$export$2f5ba0d1129fe71(excerpt).trim();
    if (!excerpt) return [
        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
            children: ''
        }, "empty")
    ];
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                as: "span",
                children: $74113bae213f2e9f$export$ca7c2d622a259944(excerpt)
            }, excerpt));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            as: "span",
            children: $74113bae213f2e9f$export$ca7c2d622a259944(pre)
        }, `pre-${i}`));
        if (textMatch) res.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            as: "strong",
            children: $74113bae213f2e9f$export$ca7c2d622a259944(textMatch)
        }, `textMatch-${i}`));
        i++;
    }
    return(// NOTE: wrapping these in <div> previously broke focus rings
    // in search results
    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            prefix,
            res
        ]
    }));
};
function $74113bae213f2e9f$export$f2f9c8e083d34d6b(permissionLevel) {
    return permissionLevel === 'restricted' || permissionLevel === 'private';
}
const $74113bae213f2e9f$export$85fedc4ba4240156 = (input, maxLength)=>{
    if (input.length <= maxLength) return input;
    return input.substring(0, maxLength) + '...';
};
const $74113bae213f2e9f$export$c32a8291d21fb086 = (thumbnailUrl)=>{
    // Parse the URL
    const urlObj = new URL(thumbnailUrl);
    const params = urlObj.searchParams;
    // Extract the required parameters
    const amzExpires = params.get('X-Amz-Expires');
    const amzDate = params.get('X-Amz-Date');
    // if we lose the format, we should not attempt to render the thumbnail
    if (!amzExpires || !amzDate) return true;
    // Convert X-Amz-Date to a Date object
    const amzDateObj = new Date(parseInt(amzDate.substring(0, 4)), parseInt(amzDate.substring(4, 6)) - 1, parseInt(amzDate.substring(6, 8)), parseInt(amzDate.substring(9, 11)), parseInt(amzDate.substring(11, 13)), parseInt(amzDate.substring(13, 15)));
    // Calculate the expiration time in milliseconds
    const expirationTime = amzDateObj.getTime() + parseInt(amzExpires) * 1000;
    // Get the current time in milliseconds
    const currentTime = Date.now();
    // Determine if the current time is greater than the expiration time
    return currentTime > expirationTime;
};
const $74113bae213f2e9f$export$fdcae512e9fdc5ad = (timestamp)=>{
    return $74113bae213f2e9f$export$96e2a37e068d7fac($74113bae213f2e9f$export$7e0fd00186ff29c6(timestamp));
};
const $74113bae213f2e9f$export$158516eb8829fc93 = (timestamp)=>{
    if (!timestamp) timestamp = new Date();
    const now = new Date();
    return (now.getTime() - new Date(timestamp).getTime()) / 1000;
};
const $74113bae213f2e9f$export$7e0fd00186ff29c6 = (timestamp)=>{
    if (!timestamp) timestamp = new Date();
    const secondsPast = $74113bae213f2e9f$export$158516eb8829fc93(timestamp);
    const timeUnits = {
        seconds: secondsPast,
        minutes: secondsPast / 60,
        hours: secondsPast / 3600,
        days: secondsPast / 86400,
        months: secondsPast / 2592000,
        years: secondsPast / 31536000
    };
    return {
        seconds: Math.floor(timeUnits.seconds),
        minutes: Math.floor(timeUnits.minutes),
        hours: Math.floor(timeUnits.hours),
        days: Math.floor(timeUnits.days),
        months: Math.floor(timeUnits.months),
        years: Math.floor(timeUnits.years)
    };
};
const $74113bae213f2e9f$export$96e2a37e068d7fac = ({ seconds: seconds, minutes: minutes, hours: hours, days: days, months: months, years: years })=>{
    return $74113bae213f2e9f$export$3e6e07f5a5b9cd48(seconds, minutes, hours, days, months, years);
};
const $74113bae213f2e9f$export$3e6e07f5a5b9cd48 = (seconds, minutes, hours, days, months, years)=>{
    if (years > 0) return {
        unit: 'year',
        value: years
    };
    else if (months > 0) return {
        unit: 'month',
        value: months
    };
    else if (days > 0) return {
        unit: 'day',
        value: days
    };
    else if (hours > 0) return {
        unit: 'hour',
        value: hours
    };
    else if (minutes > 0) return {
        unit: 'minute',
        value: minutes
    };
    else return {
        unit: 'second',
        value: seconds
    };
};
const $74113bae213f2e9f$export$fb63ba58603395b8 = (integrationId)=>{
    return integrationId ? (0, $iG0NV.PlatformIntegrationAri).parse(integrationId).integrationKey : undefined;
};
const $74113bae213f2e9f$export$596e547f4ce626bc = (integrationId, thirdPartyUser)=>{
    if (!integrationId || !thirdPartyUser) return;
    const isSlack = integrationId === 'ari:cloud:platform::integration/slack';
    const isMsTeams = integrationId === 'ari:cloud:platform::integration/microsoft';
    if (isSlack) {
        const openDmUrl = $74113bae213f2e9f$export$9eb522d6e073fba0(thirdPartyUser);
        if (openDmUrl) return {
            integration: 'slack',
            openDmUrl: openDmUrl
        };
    } else if (isMsTeams) {
        const openDmUrl = $74113bae213f2e9f$export$198aa8f5b10ebb27(thirdPartyUser);
        if (openDmUrl) return {
            integration: 'ms-teams',
            openDmUrl: openDmUrl
        };
    }
};
const $74113bae213f2e9f$export$3f90b926bc531097 = (thirdPartyUser)=>{
    if (!thirdPartyUser || !thirdPartyUser.name) return;
    // We are waiting for this commit ticket to complete for jobTitle & profileUrl
    // https://hello.jira.atlassian.cloud/browse/COMMIT-14774
    return {
        name: thirdPartyUser.name,
        profilePicUrl: thirdPartyUser.picture ?? undefined,
        jobTitle: thirdPartyUser.extendedProfile?.jobTitle,
        profileUrl: null
    };
};
const $74113bae213f2e9f$export$9eb522d6e073fba0 = (thirdPartyUser)=>{
    const externalId = thirdPartyUser?.externalId;
    if (!externalId) return;
    return `https://slack.com/app_redirect?channel=${externalId}`;
};
const $74113bae213f2e9f$export$198aa8f5b10ebb27 = (thirdPartyUser)=>{
    const email = thirdPartyUser?.email;
    if (!email) return;
    return `https://teams.microsoft.com/l/chat/0/0?users=${email}`;
};
const $74113bae213f2e9f$export$b697429ad83cc9eb = (thirdPartyConfigs, providerId)=>{
    if (!providerId) return undefined;
    const [product] = Object.entries(thirdPartyConfigs).find(([, config])=>config.providerId === providerId) || [];
    return product;
};
const $74113bae213f2e9f$export$eed5b9b4caf40e24 = (thirdPartyConfigs, providerId)=>{
    if (!providerId) return undefined;
    const [displayName] = Object.entries(thirdPartyConfigs).find(([, config])=>config.providerId === providerId) || [];
    return displayName;
};
const $74113bae213f2e9f$export$325faed136549eaf = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(node)) return node;
    // Check if element is a Spacer component
    if (typeof node.type === 'function' && node.type.IS_METADATA_SPACER) return null;
    // If the element has children, filter out spacers
    if (node.props.children) {
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.toArray(node.props.children);
        const filteredChildren = children.filter((child)=>!/*#__PURE__*/ ((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(child) && typeof child.type === 'function' && child.type.IS_METADATA_SPACER));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).cloneElement(node, node.props, ...filteredChildren);
    }
    return node;
};

});

parcelRegister("h7sRY", function(module, exports) {

$parcel$export(module.exports, "MetadataPopupButton", () => $7ee3c09784cf4e4a$export$b31e3e19fb9e4d37);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1qfLF = parcelRequire("1qfLF");

var $2wS8M = parcelRequire("2wS8M");

var $lGgRw = parcelRequire("lGgRw");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $Y34Hw = parcelRequire("Y34Hw");
const $7ee3c09784cf4e4a$var$popupContentContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    padding: 'space.200',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 'space.100',
    borderRadius: 'border.radius.100',
    background: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay'
});
const $7ee3c09784cf4e4a$var$subheadingStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body'
});
const $7ee3c09784cf4e4a$var$iconButtonContainerStyles = (0, $ecnYn.xcss)({
    margin: 'space.025',
    marginLeft: 'space.075',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $7ee3c09784cf4e4a$var$iconButtonContainerIsFirstElementStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.025'
});
const $7ee3c09784cf4e4a$export$b31e3e19fb9e4d37 = ({ metadata: metadata, isFirstElement: isFirstElement })=>{
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $7ee3c09784cf4e4a$var$popupContentContainerStyles,
                    $7ee3c09784cf4e4a$var$subheadingStyles
                ],
                children: metadata.map((item, index)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        children: (0, $Y34Hw.filterSpacer)(item)
                    }, index))
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $7ee3c09784cf4e4a$var$iconButtonContainerStyles,
                    isFirstElement && $7ee3c09784cf4e4a$var$iconButtonContainerIsFirstElementStyles
                ],
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                    ...triggerProps,
                    appearance: "subtle",
                    spacing: "compact",
                    isSelected: isOpen,
                    onClick: ()=>setIsOpen(!isOpen),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($2wS8M))),
                    label: "More"
                })
            })
    });
};

});

parcelRegister("mdlgz", function(module, exports) {

$parcel$export(module.exports, "Spacer", () => $20801d48939844b3$export$d7a54cba636a8cd6);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $20801d48939844b3$var$metadataSpacerStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});
const $20801d48939844b3$export$d7a54cba636a8cd6 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        as: "span",
        xcss: $20801d48939844b3$var$metadataSpacerStyles,
        children: "\u2022"
    });
$20801d48939844b3$export$d7a54cba636a8cd6.IS_METADATA_SPACER = true;

});

parcelRegister("gCEkV", function(module, exports) {

$parcel$export(module.exports, "useOverflowObserver", () => $36ce85b8deff1c0a$export$c376cfef3a1f950d);

var $gwFzn = parcelRequire("gwFzn");
const $36ce85b8deff1c0a$export$c376cfef3a1f950d = ({ containerRef: containerRef, itemRefs: itemRefs, itemIds: itemIds, alwaysVisibleRef: alwaysVisibleRef })=>{
    const observerRef = (0, $gwFzn.useRef)(null);
    const [visibleItems, setVisibleItems] = (0, $gwFzn.useState)(itemIds);
    const rightNavWidth = alwaysVisibleRef ? alwaysVisibleRef.current?.offsetWidth ?? 80 : 0;
    const rootMargin = `0px -${rightNavWidth}px 0px 0px`;
    (0, $gwFzn.useEffect)(()=>{
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const target = entry.target;
                const targetId = target.getAttribute('id');
                const isReferenceElement = targetId?.startsWith('reference:');
                if (isReferenceElement && targetId) {
                    const elementId = targetId.split('reference:')[1];
                    // Set visibility for corresponding target element from reference element id
                    if (entry.isIntersecting) setVisibleItems((prev)=>[
                            ...prev.filter((id)=>id !== elementId),
                            elementId
                        ]);
                    else setVisibleItems((prev)=>prev.filter((id)=>id !== elementId));
                }
            });
        }, {
            root: containerRef.current,
            rootMargin: rootMargin,
            threshold: 0.99
        });
        observerRef.current = observer;
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        rootMargin
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const observer = observerRef.current;
        if (!observer) return;
        itemRefs.current.forEach((itemRef)=>{
            if (itemRef?.current) observer.observe(itemRef.current);
        });
    }, [
        itemRefs,
        itemIds
    ]);
    return visibleItems;
};

});



parcelRegister("hr82m", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d0b52bf4302d81ca$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $d0b52bf4302d81ca$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    team: {
        id: "search_dialog_team",
        defaultMessage: "Team"
    }
});

});


parcelRegister("lTdhv", function(module, exports) {

$parcel$export(module.exports, "ProductEntity", () => $0e1f91acee299cdf$export$c9f98fed0b66ba21);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $2BDjU = parcelRequire("2BDjU");

var $6vkAh = parcelRequire("6vkAh");

var $lqEjG = parcelRequire("lqEjG");

var $kMYZ2 = parcelRequire("kMYZ2");

var $7ZetK = parcelRequire("7ZetK");
var $7jIfa = parcelRequire("7jIfa");
var $4TTdD = parcelRequire("4TTdD");
var $8LSUr = parcelRequire("8LSUr");
var $HOiSI = parcelRequire("HOiSI");
var $6h3V2 = parcelRequire("6h3V2");
var $gzcCN = parcelRequire("gzcCN");

var $icWhS = parcelRequire("icWhS");
var $bloXB = parcelRequire("bloXB");

var $k2YFb = parcelRequire("k2YFb");

var $1yEFx = parcelRequire("1yEFx");

var $3E8x9 = parcelRequire("3E8x9");

var $aRSt4 = parcelRequire("aRSt4");

var $9LULT = parcelRequire("9LULT");

var $e9NQR = parcelRequire("e9NQR");

var $eKxuB = parcelRequire("eKxuB");

var $Y34Hw = parcelRequire("Y34Hw");

var $92zSJ = parcelRequire("92zSJ");

var $9ubz9 = parcelRequire("9ubz9");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $4VmlX = parcelRequire("4VmlX");

var $lAvUJ = parcelRequire("lAvUJ");
const $0e1f91acee299cdf$var$typeLabelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $0e1f91acee299cdf$var$mapConfluenceSearchResult = (result, query, searchSessionId, isUserShardJiraResult)=>{
    const id = result.id;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Confluence
    });
    const title = result.title;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const space = (0, $4TTdD.isSearchConfluencePageBlogAttachment)(result) && result.space?.name ? result.space.name : null;
    const spaceId = (0, $4TTdD.isSearchConfluencePageBlogAttachment)(result) && result.space?.id;
    const isLiveDoc = (0, $4TTdD.isSearchConfluencePageBlogAttachment)(result) && result.confluenceEntity?.subtype === (0, $gzcCN.SearchConfluenceSubtype).LIVE && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in');
    const metadata = [
        isUserShardJiraResult ? 'Jira' : 'Confluence',
        [
            'type',
            isUserShardJiraResult ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $lAvUJ.messages).issue
            }) : isLiveDoc ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $lAvUJ.messages).liveDoc
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: result.type
            })
        ],
        space
    ];
    const timestamp = result.lastModified || '';
    const eventType = (0, $3E8x9.WORKED_EVENT).UPDATED;
    const rightMetadata = result.lastModified ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: false
    }) : null;
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
        ]
    });
    const url = (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
        url: result.url,
        query: query,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        containerId: spaceId,
        contentType: `confluence ${result.type}`,
        product: `confluence`
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapAtlasSearchResult = (result, query, searchSessionId)=>{
    const id = result.id;
    const productIcon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Atlas
    });
    const icon = productIcon;
    const title = result.title;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const metadata = [
        'Atlas',
        [
            'type',
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: result.type
            })
        ]
    ];
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
    });
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `atlas ${result.type}`,
        product: `atlas`
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapMercurySearchResult = (result, query, searchSessionId)=>{
    const { id: id } = result;
    let icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Focus
    });
    let resultType, title, highlightedTitle, metadata;
    if ((0, $HOiSI.isSearchResultMercuryFocusAreaPartial)(result)) {
        const { focusArea: focusArea } = result;
        const currentStatus = (focusArea?.health ? focusArea.health.key : focusArea?.status.key) || 'pending';
        const status = (0, $6vkAh.isFocusAreaStatus)(currentStatus) ? currentStatus : 'pending';
        if ((0, $dh538.fg)('mercury_enable_new_focus_area_icons')) icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2BDjU.default), {
            status: status
        });
        else {
            const hierarchyLevel = focusArea?.focusAreaType.hierarchyLevel || 0;
            const level = (0, $kMYZ2.isFocusAreaHierarchyLevel)(hierarchyLevel) ? hierarchyLevel : 0;
            icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lqEjG.default), {
                level: level,
                status: status
            });
        }
        title = result.title;
        highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
        resultType = 'Focus area';
        metadata = [
            'Focus',
            [
                'type',
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                    children: resultType
                })
            ],
            result.focusArea ? [
                'focusAreaType',
                result.focusArea?.focusAreaType.name
            ] : null
        ];
    }
    if ((0, $HOiSI.isSearchResultMercuryFocusAreaStatusUpdatePartial)(result)) {
        title = (0, $92zSJ.getSummarizedAdfContent)(result.description, query);
        highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
        resultType = 'Focus area update';
        metadata = [
            'Focus',
            [
                'type',
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                    children: resultType
                })
            ]
        ];
    }
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
    });
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `mercury ${result.type}`,
        product: `mercury`
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapThirdPartySearchResult = (result, query, searchSessionId, thirdPartyConfigs)=>{
    const id = result.id;
    const thirdPartyId = result.entity?.thirdPartyId;
    let product = '';
    if (result.providerId) product = (0, $Y34Hw.getProductFromProviderId)(thirdPartyConfigs, result.providerId) || 'graph';
    if ((product === 'graph' || !result.providerId) && thirdPartyId) {
        const { resourceOwner: resourceOwner } = (0, $6h3V2.parseThirdPartyARI)(thirdPartyId);
        const resourceType = resourceOwner.split('.').at(1);
        product = resourceType === 'google-drive' ? 'drive' : resourceType || '';
    }
    if (!Object.values((0, $1yEFx.ProductKeys)).includes(product)) return;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: product
    });
    const title = result.title;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const typeLabel = (0, $9LULT.getDocumentSubtypeLabel)({
        product: product,
        subtype: result?.subtype
    });
    const parentName = (0, $7ZetK.isDocumentEntity)(result) ? result.entity?.parent?.displayName : null;
    const metadata = [
        [
            'type',
            typeLabel ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...typeLabel
                })
            }) : result?.subtype ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: result?.subtype.charAt(0).toUpperCase() + result?.subtype.substring(1).toLowerCase()
            }) : null
        ],
        parentName ?? null
    ];
    const timestamp = result.lastModifiedDate || '';
    const eventType = (0, $3E8x9.WORKED_EVENT).UPDATED;
    const rightMetadata = result.lastModifiedDate ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: false
    }) : null;
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
        ]
    });
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${result.subtype}`,
        product: product
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapJiraSearchResult = (result, query, searchSessionId, isStatusLoading)=>{
    const id = result.id;
    const analyticsMetadata = {
        contentId: id,
        contentType: `jira ${result.type}`,
        product: `jira`
    };
    const title = result.title;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Jira
    });
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const status = (0, $8LSUr.isSearchResultJiraIssue)(result) ? (0, $e9NQR.getStatus)(result.status?.name, result.status?.colorName, isStatusLoading) : null;
    const titleMetadataParts = status && (0, $dh538.fg)('enable_status_jira_issues_quick_find') ? [
        [
            'status',
            status
        ]
    ] : [];
    const metadata = [
        'Jira',
        [
            'type',
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: result.type
            })
        ]
    ];
    const rightMetadata = (0, $8LSUr.isSearchResultJiraIssue)(result) ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: result.lastModifiedDate || '',
        eventType: (0, $3E8x9.WORKED_EVENT).UPDATED,
        isMyActivityData: false
    }) : null;
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
    });
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    return {
        id: id,
        title: title,
        highlightedTitle: highlightedTitle,
        icon: icon,
        status: status,
        analyticsMetadata: analyticsMetadata,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        rightMetadata: rightMetadata,
        url: url,
        titleMetadataParts: titleMetadataParts
    };
};
const $0e1f91acee299cdf$var$mapSearchResult = (result, query, searchSessionId, thirdPartyConfigs, isStatusLoading)=>{
    if ((0, $4TTdD.isSearchConfluencePartial)(result)) return $0e1f91acee299cdf$var$mapConfluenceSearchResult(result, query, searchSessionId);
    else if ((0, $7jIfa.isSearchAtlasPartial)(result)) return $0e1f91acee299cdf$var$mapAtlasSearchResult(result, query, searchSessionId);
    else if ((0, $HOiSI.isSearchMercuryPartial)(result)) return $0e1f91acee299cdf$var$mapMercurySearchResult(result, query, searchSessionId);
    else if ((0, $7ZetK.isSearchResultGraphEntity)(result)) return $0e1f91acee299cdf$var$mapThirdPartySearchResult(result, query, searchSessionId, thirdPartyConfigs);
    else if ((0, $8LSUr.isSearchJiraPartial)(result)) return $0e1f91acee299cdf$var$mapJiraSearchResult(result, query, searchSessionId, isStatusLoading);
    else return null;
};
const $0e1f91acee299cdf$export$c9f98fed0b66ba21 = ({ result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted })=>{
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const isHydrationLoading = (0, $djVCD.useIsJiraHydrationLoading)();
    const mappedResult = $0e1f91acee299cdf$var$mapSearchResult(result, quickFindQuery, searchSessionId, thirdPartyConfigs, isHydrationLoading);
    const additionalAnalyticsAttributes = (0, $gwFzn.useMemo)(()=>({
            metadata: mappedResult?.analyticsMetadata,
            is3pLink: (0, $1yEFx.all3pProductKeys).includes(mappedResult?.analyticsMetadata.product),
            ...(0, $dh538.fg)('search_page_smart_link_analytics') && {
                is3pSmartLink: (0, $9ubz9.isResultSmartLink)(result.id)
            }
        }), [
        mappedResult,
        result.id
    ]);
    const onResultClicked = (0, $gwFzn.useCallback)((event, data)=>{
        onClick?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onClick,
        state
    ]);
    const onResultContextMenu = (0, $gwFzn.useCallback)((event, data)=>{
        onContextMenu?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onContextMenu,
        state
    ]);
    const onResultHighlighted = (0, $gwFzn.useCallback)((data)=>{
        onHighlighted?.({
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onHighlighted,
        state
    ]);
    if (!mappedResult) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eKxuB.SearchResult), {
        ...mappedResult,
        resultType: "searchResults",
        product: mappedResult.analyticsMetadata.product,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onResultHighlighted: onResultHighlighted
    });
};

});
parcelRegister("2BDjU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ff1b999d67869c$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $k0doW = parcelRequire("k0doW");
const $b9ff1b999d67869c$export$9fa64e8c3e32f949 = {
    pending: "var(--ds-icon-accent-gray, #758195)",
    paused: "var(--ds-icon-accent-gray, #758195)",
    on_track: "var(--ds-icon-accent-lime, #6A9A23)",
    at_risk: "var(--ds-icon-warning, #E56910)",
    off_track: "var(--ds-icon-accent-red, #C9372C)",
    completed: "var(--ds-icon-accent-gray, #758195)"
};
function $b9ff1b999d67869c$export$2e2bcd8739ae039({ status: status, customColor: customColor, spacing: spacing, testId: testId, label: label }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k0doW))), {
        color: customColor || $b9ff1b999d67869c$export$9fa64e8c3e32f949[status || 'pending'],
        spacing: spacing || 'none',
        label: label || '',
        testId: testId
    });
}

});
parcelRegister("k0doW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5214d474784a87576e9d4de9982f1966>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8fe33f1dd72fd95$var$_react = $e8fe33f1dd72fd95$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $e8fe33f1dd72fd95$var$_baseNew = $e8fe33f1dd72fd95$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e8fe33f1dd72fd95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Capture".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/core/capture
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e8fe33f1dd72fd95$var$CaptureIcon = (props)=>/*#__PURE__*/ $e8fe33f1dd72fd95$var$_react.default.createElement($e8fe33f1dd72fd95$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v3H1V3a2 2 0 0 1 2-2h3v1.5zm10 0h-3V1h3a2 2 0 0 1 2 2v3h-1.5V3a.5.5 0 0 0-.5-.5M8 6.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M4.75 8a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0M2.5 10v3a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2v-3zm11 3v-3H15v3a2 2 0 0 1-2 2h-3v-1.5h3a.5.5 0 0 0 .5-.5" clip-rule="evenodd"/>`
    }, props));
$e8fe33f1dd72fd95$var$CaptureIcon.displayName = 'CaptureIcon';
var $e8fe33f1dd72fd95$var$_default = module.exports.default = $e8fe33f1dd72fd95$var$CaptureIcon;

});


parcelRegister("lqEjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c704531fdb19e4bf$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $2BDjU = parcelRequire("2BDjU");

var $e8kWw = parcelRequire("e8kWw");
const $c704531fdb19e4bf$export$9fa64e8c3e32f949 = {
    pending: "var(--ds-icon-accent-gray, #758195)",
    paused: "var(--ds-icon-accent-gray, #758195)",
    on_track: "var(--ds-icon-accent-lime, #6A9A23)",
    at_risk: "var(--ds-icon-warning, #E56910)",
    off_track: "var(--ds-icon-accent-red, #C9372C)",
    completed: "var(--ds-icon-accent-gray, #758195)"
};
const $c704531fdb19e4bf$var$iconContainer = (0, $ecnYn.xcss)({
    flexShrink: 0,
    lineHeight: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
});
function $c704531fdb19e4bf$export$2e2bcd8739ae039({ size: size, level: level, status: status, customColor: customColor, testId: testId, label: label }) {
    // Focus area icons have been migrated to the new @atlassian/focus-area-icon
    if ((0, $dh538.fg)('mercury_enable_new_focus_area_icons')) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2BDjU.default), {
        status: status,
        // Since the customColor prop here does not enforce the new IconColor type and to avoid backwards
        // compatility issues, please use @atlassian/focus-area-icon if customColor prop is needed
        // https://hello.atlassian.net/wiki/spaces/DST/pages/3748692796/New+ADS+iconography+Code+migration+guide
        spacing: size === 'medium' || size === 'large' ? 'spacious' : 'compact',
        testId: testId,
        label: label
    });
    const adjustedSize = size === 'xsmall' ? 'xxsmall' : size;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $c704531fdb19e4bf$var$iconContainer,
        as: "span",
        children: (0, $e8kWw.FocusAreaIconMap)[level](customColor ?? (status ? $c704531fdb19e4bf$export$9fa64e8c3e32f949[status] : 'currentColor'), adjustedSize ?? 'medium', testId, label)
    });
}

});
parcelRegister("e8kWw", function(module, exports) {

$parcel$export(module.exports, "FocusAreaIconMap", () => $7d59de8f7f9d41d6$export$885129de440ed9d8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $7d59de8f7f9d41d6$export$85f83f46f1a8949d = {
    xxsmall: '16',
    small: '24',
    medium: '32',
    large: '48'
};
const $7d59de8f7f9d41d6$export$b367b0f8b81333e = 'Focus area icon';
const $7d59de8f7f9d41d6$var$iconViewBox = (size)=>size === 'xxsmall' ? '4 4 16 16' : '0 0 24 24';
const $7d59de8f7f9d41d6$export$885129de440ed9d8 = {
    0: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "11.9167",
                    cy: "7.375",
                    r: "1.625",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "17.4583",
                    cy: "16.875",
                    r: "1.625",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeWidth: "1.5",
                    d: "M11.917 9.065v2.938m0 0h3.541a2 2 0 0 1 2 2v.84m-5.541-2.84H8.375a2 2 0 0 0-2 2v1.053m5.542-3.053v3.053"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "11.9167",
                    cy: "16.875",
                    r: "1.625",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "6.375",
                    cy: "16.875",
                    r: "1.625",
                    strokeWidth: "1.5"
                })
            ]
        }),
    1: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "11.9879",
                    cy: "6.99597",
                    r: "1.99597",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeWidth: "1.5",
                    d: "M12.099 9.214v2.543m0 0H14.2a2 2 0 0 1 2 2v.668M12.1 11.757H9.996a2 2 0 0 0-2 2v.668"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "16.2015",
                    cy: "16.754",
                    r: "1.99597",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "7.99597",
                    cy: "16.754",
                    r: "1.99597",
                    strokeWidth: "1.5"
                })
            ]
        }),
    2: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "6.66667",
                    cy: "17.3333",
                    r: "1.91667",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "1.91667",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "17.3334",
                    cy: "6.66667",
                    r: "1.91667",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeWidth: "1.5",
                    d: "M6.667 15.556v-2.37c0-.655.53-1.186 1.185-1.186h2.37M17.333 8.444v2.37c0 .655-.53 1.186-1.185 1.186h-2.37"
                })
            ]
        }),
    3: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "17.569",
                    cy: "16.6379",
                    r: "1.86207",
                    strokeWidth: "1.5",
                    transform: "rotate(90 17.569 16.638)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "6.86205",
                    cy: "6.86207",
                    r: "1.86207",
                    strokeWidth: "1.5",
                    transform: "rotate(90 6.862 6.862)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeWidth: "1.5",
                    d: "M8.048 6.897h1.074a2.5 2.5 0 0 1 2.5 2.5v4.775a2.5 2.5 0 0 0 2.5 2.5h2.28"
                })
            ]
        }),
    4: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "16.8001",
                    cy: "16.8",
                    r: "2.2",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "7.95",
                    cy: "7.95",
                    r: "2.2",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeLinecap: "round",
                    strokeWidth: "1.5",
                    d: "M7.95 10.446v6.104c0 .138.112.25.25.25h5.877m2.723-2.95V8.2a.25.25 0 0 0-.25-.25H10.9"
                })
            ]
        }),
    5: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "16.7059",
                    cy: "15.7059",
                    r: "2.29412",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "8.29412",
                    cy: "7.29412",
                    r: "2.29412",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeLinecap: "round",
                    strokeWidth: "1.5",
                    d: "M8.322 9.875v5.554c0 .138.111.25.25.25h5.553"
                })
            ]
        }),
    6: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            // Level 6 icon uses a custom xxsmall viewport to fit and center icon
            viewBox: size === 'xxsmall' ? '3 5 16.2 16.2' : '0 0 24 24',
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "12.6111",
                    cy: "7.58333",
                    r: "1.83333",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeLinecap: "round",
                    strokeWidth: "1.5",
                    d: "M10.028 7.583H5a1 1 0 0 0-1 1v7.612M11.75 20.5h5.028a1 1 0 0 0 1-1v-7.611"
                })
            ]
        }),
    7: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "14.4451",
                    cy: "16.3594",
                    r: "2.39062",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeLinecap: "round",
                    strokeWidth: "1.5",
                    d: "M7 6v10.2c0 .139.112.25.25.25h4.258M7.41 9.893h3.688"
                })
            ]
        }),
    8: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "15.5189",
                    cy: "15.3112",
                    r: "1.98113",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeLinecap: "round",
                    strokeWidth: "1.5",
                    d: "M7 6v4.505c0 .138.112.25.25.25h5.803"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fill: color,
                    stroke: "none",
                    d: "M10.777 10.854a.75.75 0 1 0-1.5 0h1.5Zm-1.5 0v3.987h1.5v-3.987h-1.5Zm1 4.987h2.776v-1.5h-2.776v1.5Zm-1-1a1 1 0 0 0 1 1v-1.5a.5.5 0 0 1 .5.5h-1.5Z"
                })
            ]
        }),
    9: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "11.6249",
                    cy: "11.6249",
                    r: "2.08929",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeLinecap: "round",
                    strokeWidth: "1.5",
                    d: "M5 12.098v5.152a1 1 0 0 0 1 1h5.625M18.25 11.152V6a1 1 0 0 0-1-1h-5.625"
                })
            ]
        })
};

});


parcelRegister("kMYZ2", function(module, exports) {

$parcel$export(module.exports, "isFocusAreaHierarchyLevel", () => $08d78abb43143d38$export$a7630963491fabb6);
function $08d78abb43143d38$export$a7630963491fabb6(level) {
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].indexOf(level) !== -1;
}
function $08d78abb43143d38$export$78192d4e53523287(status) {
    return [
        'pending',
        'paused',
        'on_track',
        'off_track',
        'at_risk',
        'completed'
    ].indexOf(status) !== -1;
}

});

parcelRegister("6h3V2", function(module, exports) {

$parcel$export(module.exports, "getProductAndIDFromARI", () => $1c92067bef9e66d6$export$d8a746fe35b1c95d);
$parcel$export(module.exports, "parseThirdPartyARI", () => $1c92067bef9e66d6$export$2f432ca99e30467e);

var $fRK8K = parcelRequire("fRK8K");
const $1c92067bef9e66d6$export$d8a746fe35b1c95d = (ari)=>{
    const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $1c92067bef9e66d6$export$fccbae65febb6fd4(ari) ? $1c92067bef9e66d6$export$2f432ca99e30467e(ari) : (0, $fRK8K.parse)(ari);
    return [
        resourceOwner,
        cloudId,
        resourceType,
        resourceId
    ];
};
const $1c92067bef9e66d6$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $1c92067bef9e66d6$export$2f432ca99e30467e = (ari)=>{
    const result = $1c92067bef9e66d6$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$1c92067bef9e66d6$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner, resourceType, resourceId] = result;
    return {
        resourceId: resourceId,
        resourceOwner: resourceOwner,
        resourceType: resourceType,
        cloudId: resourceId
    };
};
const $1c92067bef9e66d6$export$fccbae65febb6fd4 = (ari)=>$1c92067bef9e66d6$var$thirdPartyRegex.test(ari);

});

parcelRegister("gzcCN", function(module, exports) {

$parcel$export(module.exports, "SearchConfluenceSubtype", () => $78275d0f42176934$export$fb160374438e1cd7);
var $78275d0f42176934$export$fb160374438e1cd7 = /*#__PURE__*/ function(SearchConfluenceSubtype) {
    SearchConfluenceSubtype["LIVE"] = "LIVE";
    return SearchConfluenceSubtype;
}({});

});

parcelRegister("3E8x9", function(module, exports) {

$parcel$export(module.exports, "WORKED_EVENT", () => $38e9d08a360f6294$export$eb4e9f525aef1cc3);
$parcel$export(module.exports, "EventTypeMessage", () => $38e9d08a360f6294$export$9e4fb3fb50a3c754);
// Copied from confluence/next/packages/navigation-search-dialog/src/suppliers/utils/eventTypeMessage.tsx
// Extracted from @atlassian/recent-work-ui activity-event-type-message to create this
// helper function to convert timestamp to readable metadata

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $lDMQ2 = parcelRequire("lDMQ2");

var $eaVC4 = parcelRequire("eaVC4");

var $4oRNp = parcelRequire("4oRNp");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $hrzSy = parcelRequire("hrzSy");

var $5mJ0F = parcelRequire("5mJ0F");
var $Lyrmh = parcelRequire("Lyrmh");
var $38e9d08a360f6294$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SL_VIEWED"] = "sl-viewed";
    return VIEWED_EVENT;
}({});
var $38e9d08a360f6294$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
function $38e9d08a360f6294$export$e873c799b137eec4(date) {
    return (0, $lDMQ2.default)(new Date(date), $38e9d08a360f6294$var$startOfOneWeekAgo());
}
function $38e9d08a360f6294$var$startOfOneWeekAgo() {
    return (0, $eaVC4.default)((0, $4oRNp.default)(new Date(), 1));
}
const $38e9d08a360f6294$export$9e4fb3fb50a3c754 = ({ eventType: eventType, timestamp: timestamp, isMyActivityData: isMyActivityData })=>{
    const isAbsolute = $38e9d08a360f6294$export$e873c799b137eec4(timestamp);
    const message = (0, $Lyrmh.useEventTypeMessage)(eventType, {
        isMyActivityData: isMyActivityData,
        isAbsolute: isAbsolute
    });
    const { value: value, unit: unit } = (0, $5mJ0F.selectUnit)(new Date(timestamp).getTime(), new Date(), {
        day: 7
    });
    const values = isAbsolute ? {
        // Show the absolute time if the activity was more than a week ago
        // e.g: You viewed on January 1, 2021
        absoluteTime: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2nPZH.FormattedDate), {
            value: timestamp,
            month: "short",
            day: "2-digit",
            year: "numeric"
        })
    } : {
        // Show the relative time if the activity was within a week ago
        // e.g: You viewed 2 hours ago
        relativeTime: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hrzSy.default), {
            value: value,
            unit: unit
        })
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...message,
        values: values
    });
};

});

parcelRegister("aRSt4", function(module, exports) {

$parcel$export(module.exports, "ProductIcon", () => $6ae4bffafe6abebf$export$1a199e029d5e93d6);
$parcel$export(module.exports, "ProductOrNounIcon", () => $6ae4bffafe6abebf$export$fe03eddc92730a5c);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $tvI67 = parcelRequire("tvI67");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $6fnsQ = parcelRequire("6fnsQ");

var $4EMbH = parcelRequire("4EMbH");

var $1yEFx = parcelRequire("1yEFx");
const $6ae4bffafe6abebf$var$nounIconStyles = (0, $ecnYn.xcss)({
    padding: 'space.050'
});
const $6ae4bffafe6abebf$export$1a199e029d5e93d6 = ({ product: product, size: size = 'large', isSelected: isSelected = false, ...props })=>{
    const products = (0, $1yEFx.useProductConfigs)();
    let Icon;
    if (product) {
        Icon = products[product].Icon;
        return /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
            ...props,
            size: size
        });
    } else return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
        label: "",
        spacing: "spacious",
        color: isSelected ? `var(--ds-icon-selected, ${0, $6fnsQ.B400})` : `var(--ds-icon, ${0, $6fnsQ.N500})`
    });
};
const $6ae4bffafe6abebf$export$fe03eddc92730a5c = ({ productOrNounKey: productOrNounKey, size: size = 'large', isSelected: isSelected = false, ...props })=>{
    const products = (0, $1yEFx.useProductConfigs)();
    const useNounIconStyles = !(0, $dh538.fg)('platform-team25-app-icon-tiles');
    let Icon;
    if (productOrNounKey) {
        const isNounFilter = (0, $4EMbH.isNounKey)(productOrNounKey);
        if (isNounFilter) Icon = (0, $4EMbH.nouns)[productOrNounKey].Icon;
        else Icon = products[productOrNounKey].Icon;
        return isNounFilter ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: useNounIconStyles && $6ae4bffafe6abebf$var$nounIconStyles,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
                ...props,
                size: !useNounIconStyles ? size : undefined
            })
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
            ...props,
            size: size
        });
    } else return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
        label: "",
        spacing: "spacious",
        color: isSelected ? `var(--ds-icon-selected, ${0, $6fnsQ.B400})` : `var(--ds-icon, ${0, $6fnsQ.N500})`
    });
};

});

parcelRegister("9LULT", function(module, exports) {

$parcel$export(module.exports, "getDocumentSubtypeLabel", () => $db7c0f516add704a$export$a47c0c6de01249fd);
$parcel$export(module.exports, "getRemoteLinkSubtypeLabel", () => $db7c0f516add704a$export$19dc2415a5fa9123);

var $1yEFx = parcelRequire("1yEFx");

var $75nfs = parcelRequire("75nfs");
const $db7c0f516add704a$export$a47c0c6de01249fd = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const SUBTYPE_DOCUMENT = 'DOCUMENT';
    const SUBTYPE_PRESENTATION = 'PRESENTATION';
    const SUBTYPE_SPREADSHEET = 'SPREADSHEET';
    const GOOGLE_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $75nfs.messages).googleDocsLabel,
        [SUBTYPE_PRESENTATION]: (0, $75nfs.messages).googleSlidesLabel,
        [SUBTYPE_SPREADSHEET]: (0, $75nfs.messages).googleSheetsLabel
    };
    const MICROSOFT_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $75nfs.messages).msWordLabel,
        [SUBTYPE_PRESENTATION]: (0, $75nfs.messages).msPowerpointLabel,
        [SUBTYPE_SPREADSHEET]: (0, $75nfs.messages).msExcelLabel
    };
    const normalizedSubtype = subtype?.toUpperCase();
    let label;
    if (product === (0, $1yEFx.ProductKeys).Sharepoint || product === (0, $1yEFx.ProductKeys).OneDrive) label = MICROSOFT_LABELS[normalizedSubtype];
    else if (product.includes((0, $1yEFx.ProductKeys).GoogleDrive)) label = GOOGLE_LABELS[normalizedSubtype];
    return label;
};
const $db7c0f516add704a$export$19dc2415a5fa9123 = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const labelKey = `${subtype}Label`;
    if (labelKey in (0, $75nfs.messages)) return (0, $75nfs.messages)[labelKey];
    else return (0, $75nfs.messages).otherLabel;
};

});
parcelRegister("75nfs", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b9359f0728408764$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $b9359f0728408764$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    googleDocsLabel: {
        id: "document-search-result.google-docs-label",
        defaultMessage: "Docs"
    },
    googleSlidesLabel: {
        id: "document-search-result.google-slides-label",
        defaultMessage: "Slides"
    },
    googleSheetsLabel: {
        id: "document-search-result.google-sheets-label",
        defaultMessage: "Sheets"
    },
    msWordLabel: {
        id: "document-search-result.ms-word-label",
        defaultMessage: "Word"
    },
    msPowerpointLabel: {
        id: "document-search-result.ms-powerpoint-label",
        defaultMessage: "PowerPoint"
    },
    msExcelLabel: {
        id: "document-search-result.ms-excel-label",
        defaultMessage: "Excel"
    },
    documentLabel: {
        id: "document.label",
        defaultMessage: "Document"
    },
    spreadsheetLabel: {
        id: "spreadsheet.label",
        defaultMessage: "Spreadsheet"
    },
    presentationLabel: {
        id: "presentation.label",
        defaultMessage: "Presentation"
    },
    fileLabel: {
        id: "file.label",
        defaultMessage: "File"
    },
    databaseLabel: {
        id: "database.label",
        defaultMessage: "Database"
    },
    webPageLabel: {
        id: "web-page.label",
        defaultMessage: "Web Page"
    },
    pageLabel: {
        id: "page.label",
        defaultMessage: "Page"
    },
    blogpostLabel: {
        id: "blogpost.label",
        defaultMessage: "Blogpost"
    },
    dashboardLabel: {
        id: "dashboard.label",
        defaultMessage: "Dashboard"
    },
    invoiceLabel: {
        id: "invoice.label",
        defaultMessage: "Invoice"
    },
    designLabel: {
        id: "design.label",
        defaultMessage: "Design"
    },
    dealLabel: {
        id: "deal.label",
        defaultMessage: "Deal"
    },
    videoLabel: {
        id: "video.label",
        defaultMessage: "Video"
    },
    taskLabel: {
        id: "task.label",
        defaultMessage: "Task"
    },
    issueLabel: {
        id: "issue.label",
        defaultMessage: "Issue"
    },
    spaceLabel: {
        id: "space.label",
        defaultMessage: "Space"
    },
    projectLabel: {
        id: "project.label",
        defaultMessage: "Project"
    },
    repositoryLabel: {
        id: "repository.label",
        defaultMessage: "Repository"
    },
    customerOrgLabel: {
        id: "customer-org.label",
        defaultMessage: "Customer Org"
    },
    imageLabel: {
        id: "image.label",
        defaultMessage: "Image"
    },
    archiveLabel: {
        id: "archive.label",
        defaultMessage: "Archive"
    },
    audioLabel: {
        id: "audio.label",
        defaultMessage: "Audio"
    },
    pdfLabel: {
        id: "pdf.label",
        defaultMessage: "PDF"
    },
    codeLabel: {
        id: "code.label",
        defaultMessage: "Code"
    },
    channelLabel: {
        id: "channel.label",
        defaultMessage: "Channel"
    },
    otherLabel: {
        id: "other.label",
        defaultMessage: "Other"
    }
});

});


parcelRegister("e9NQR", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $781b55e9f82a6669$export$b70265791d2079d4);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5nBzc = parcelRequire("5nBzc");

var $kc79t = parcelRequire("kc79t");

var $1hlFx = parcelRequire("1hlFx");
const $781b55e9f82a6669$var$jiraIssueStatusToLozengeMap = {
    [(0, $kc79t.JiraStatusCategoryColor).Red]: 'removed',
    [(0, $kc79t.JiraStatusCategoryColor).Brown]: 'default',
    [(0, $kc79t.JiraStatusCategoryColor).Green]: 'success',
    [(0, $kc79t.JiraStatusCategoryColor).Yellow]: 'moved',
    [(0, $kc79t.JiraStatusCategoryColor).BlueGray]: 'inprogress',
    [(0, $kc79t.JiraStatusCategoryColor).MediumGray]: 'default'
};
const $781b55e9f82a6669$var$STATUS_REGEX = /[\s-]+/g;
/**
 * Remove when visual refresh flag is removed
 */ const $781b55e9f82a6669$var$getAppearance = (name)=>{
    name = name.replace($781b55e9f82a6669$var$STATUS_REGEX, '').toLowerCase();
    switch(true){
        case [
            'todo',
            'unavailable',
            'minor',
            'notstarted'
        ].includes(name):
            return 'default';
        case [
            'available',
            'completed',
            'done',
            'approved',
            'resolved',
            'added',
            'closed'
        ].includes(name):
            return 'success';
        case [
            'error',
            'declined',
            'deleted',
            'failed',
            'rejected'
        ].includes(name):
            return 'removed';
        case [
            'inprogress',
            'open',
            'modified'
        ].includes(name):
            return 'inprogress';
    }
    return 'default';
};
const $781b55e9f82a6669$export$b70265791d2079d4 = (name, color, isLoading)=>{
    if (name) {
        if (isLoading) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1hlFx.MetaDataItemSkeleton), {});
        if (color) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5nBzc.default), {
            isBold: true,
            appearance: $781b55e9f82a6669$var$jiraIssueStatusToLozengeMap[color],
            testId: "jira-status-lozenge-test-id",
            children: name
        });
        const appearance = $781b55e9f82a6669$var$getAppearance(name);
        if (appearance) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5nBzc.default), {
            appearance: appearance,
            testId: "jira-status-lozenge-test-id",
            children: name
        });
    }
    if (isLoading) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1hlFx.MetaDataItemSkeleton), {});
    return null;
};

});
parcelRegister("1hlFx", function(module, exports) {

$parcel$export(module.exports, "MetaDataItemSkeleton", () => $d0f7782f05ea6f67$export$9ecbe061c4358be9);
$parcel$export(module.exports, "MetaDataItemSkeletonWide", () => $d0f7782f05ea6f67$export$a72c2188d2b05fba);
$parcel$export(module.exports, "SearchResultSkeleton", () => $d0f7782f05ea6f67$export$dd3282b157ef6f7a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $9WEcF = parcelRequire("9WEcF");
const $d0f7782f05ea6f67$var$commonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest'
});
const $d0f7782f05ea6f67$var$skeletonTextStyles = (0, $ecnYn.xcss)({
    borderRadius: 'border.radius.400'
});
const $d0f7782f05ea6f67$var$titleStyles = (0, $ecnYn.xcss)({
    width: '280px',
    height: "var(--ds-space-200, 16px)",
    marginBottom: 'space.050'
});
const $d0f7782f05ea6f67$var$iconStyles = (0, $ecnYn.xcss)({
    width: 'size.400',
    height: 'size.400',
    borderRadius: 'border.radius.100'
});
const $d0f7782f05ea6f67$var$containerStyles = (0, $ecnYn.xcss)({
    pointerEvents: 'none'
});
const $d0f7782f05ea6f67$var$descriptionContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    rowGap: 'space.100'
});
const $d0f7782f05ea6f67$var$descriptionStyles = (0, $ecnYn.xcss)({
    width: '100%',
    height: "var(--ds-space-150, 12px)"
});
const $d0f7782f05ea6f67$var$metadataStyles = (0, $ecnYn.xcss)({
    width: '200px',
    height: "var(--ds-space-150, 12px)",
    marginBottom: 'space.050'
});
const $d0f7782f05ea6f67$var$metadataItemStyles = (0, $ecnYn.xcss)({
    height: "var(--ds-space-150, 12px)",
    borderRadius: 'border.radius.200'
});
const $d0f7782f05ea6f67$var$narrowMetadataItemStyles = (0, $ecnYn.xcss)({
    width: '50px'
});
const $d0f7782f05ea6f67$var$wideMetadataItemStyles = (0, $ecnYn.xcss)({
    width: '100px'
});
const $d0f7782f05ea6f67$export$9ecbe061c4358be9 = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: [
            $d0f7782f05ea6f67$var$commonStyles,
            $d0f7782f05ea6f67$var$metadataItemStyles,
            $d0f7782f05ea6f67$var$narrowMetadataItemStyles
        ]
    });
};
const $d0f7782f05ea6f67$export$a72c2188d2b05fba = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: [
            $d0f7782f05ea6f67$var$commonStyles,
            $d0f7782f05ea6f67$var$metadataItemStyles,
            $d0f7782f05ea6f67$var$wideMetadataItemStyles
        ]
    });
};
const $d0f7782f05ea6f67$export$dd3282b157ef6f7a = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $d0f7782f05ea6f67$var$containerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9WEcF.SearchResult), {
            description: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                xcss: [
                    $d0f7782f05ea6f67$var$descriptionContainerStyles
                ],
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $d0f7782f05ea6f67$var$commonStyles,
                            $d0f7782f05ea6f67$var$skeletonTextStyles,
                            $d0f7782f05ea6f67$var$descriptionStyles
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $d0f7782f05ea6f67$var$commonStyles,
                            $d0f7782f05ea6f67$var$skeletonTextStyles,
                            $d0f7782f05ea6f67$var$descriptionStyles
                        ]
                    })
                ]
            }),
            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $d0f7782f05ea6f67$var$commonStyles,
                    $d0f7782f05ea6f67$var$iconStyles
                ]
            }),
            title: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $d0f7782f05ea6f67$var$commonStyles,
                    $d0f7782f05ea6f67$var$skeletonTextStyles,
                    $d0f7782f05ea6f67$var$titleStyles
                ]
            }),
            headerMetadataParts: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: [
                        $d0f7782f05ea6f67$var$commonStyles,
                        $d0f7782f05ea6f67$var$skeletonTextStyles,
                        $d0f7782f05ea6f67$var$metadataStyles
                    ]
                })
            ],
            // TODO: QS-7036 consolidate the logic of the loading state as it's now split between
            //  this component and the SearchResult component (hence the prop)
            isLoadingSkeleton: true
        })
    });
};

});
parcelRegister("9WEcF", function(module, exports) {

$parcel$export(module.exports, "SearchResult", () => $caeb18e39a927b2a$export$a2def421b23768aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $cwkWT = parcelRequire("cwkWT");
var $ecnYn = parcelRequire("ecnYn");

var $4iqRj = parcelRequire("4iqRj");

var $a7nUd = parcelRequire("a7nUd");

var $1rVFx = parcelRequire("1rVFx");
const $caeb18e39a927b2a$var$searchResultContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $caeb18e39a927b2a$var$iconAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'icon',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: "var(--ds-space-600, 48px)"
});
const $caeb18e39a927b2a$var$newIconStyles = (0, $ecnYn.xcss)({
    marginBlockStart: 'space.075'
});
const $caeb18e39a927b2a$var$iconStyles = (0, $ecnYn.xcss)({
    padding: 'space.050'
});
const $caeb18e39a927b2a$var$headerRightAreaStylesInVisible = (0, $ecnYn.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $caeb18e39a927b2a$var$headerRightAreaStylesVisible = (0, $ecnYn.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $caeb18e39a927b2a$var$bodyAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'body',
    paddingTop: 'space.050',
    overflowWrap: 'break-word'
});
const $caeb18e39a927b2a$var$footerAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'footer'
});
const $caeb18e39a927b2a$export$a2def421b23768aa = ({ id: id, product: product, productSelected: productSelected, primaryProduct: primaryProduct, description: description, footer: footer, icon: icon, url: url, showAISummary: showAISummary = false, cloudId: cloudId, title: // required for AI Summaries
title, isThirdParty: isThirdParty, appMode: appMode, headerMetadataParts: headerMetadataParts, headerMetadataSocialParts: headerMetadataSocialParts, titleMetadata: titleMetadata, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, isLoadingSkeleton: isLoadingSkeleton = false })=>{
    const [isHovered, setIsHovered] = (0, $gwFzn.useState)(false);
    const [isFocused, setIsFocused] = (0, $gwFzn.useState)(false);
    const [isContextMenuOpen, setIsContextMenuOpen] = (0, $gwFzn.useState)(false);
    const isContextMenuVisible = isHovered || isFocused || isContextMenuOpen;
    const containerRef = (0, $gwFzn.useRef)(null);
    const aiSummaryEnabled = Boolean(showAISummary && id && cloudId && primaryProduct);
    const useNewIconStyles = (0, $dh538.fg)('platform-team25-app-icon-tiles');
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        role: "listitem",
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false),
        testId: isLoadingSkeleton ? 'search-page-result-skeleton' : 'search-page-result',
        ref: containerRef,
        xcss: $caeb18e39a927b2a$var$searchResultContainerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $cwkWT.default), {
            columnGap: "space.150",
            rowGap: "space.050",
            templateAreas: [
                'icon heading header-right',
                'icon subheading-left header-right',
                'icon body body',
                'icon footer footer'
            ],
            templateColumns: "auto 1fr auto",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $caeb18e39a927b2a$var$iconAreaStyles,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: useNewIconStyles ? $caeb18e39a927b2a$var$newIconStyles : $caeb18e39a927b2a$var$iconStyles,
                        children: icon
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1rVFx.SearchResultTitle), {
                    id: id,
                    title: title,
                    url: url,
                    isThirdParty: isThirdParty,
                    appMode: appMode,
                    onResultClicked: onResultClicked,
                    onResultContextMenu: onResultContextMenu,
                    onCopyLinkButtonClicked: onCopyLinkButtonClicked,
                    isHovered: isHovered,
                    titleMetadata: titleMetadata
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7nUd.SearchMetadata), {
                    searchResultId: id,
                    product: product,
                    productSelected: productSelected,
                    parts: headerMetadataParts,
                    socialParts: headerMetadataSocialParts,
                    containerRef: containerRef
                }),
                !isLoadingSkeleton && // Context Menu should not be rendered when rendering as a loading skeleton
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: isContextMenuVisible ? $caeb18e39a927b2a$var$headerRightAreaStylesVisible : $caeb18e39a927b2a$var$headerRightAreaStylesInVisible,
                    testId: "search-result-context-menu",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4iqRj.default), {
                        url: url,
                        isContextMenuOpen: isContextMenuOpen,
                        setIsContextMenuOpen: setIsContextMenuOpen,
                        setIsFocused: setIsFocused,
                        setIsHovered: setIsHovered,
                        id: id || '',
                        cloudId: cloudId,
                        aiSummaryEnabled: aiSummaryEnabled
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $caeb18e39a927b2a$var$bodyAreaStyles,
                    children: description
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $caeb18e39a927b2a$var$footerAreaStyles,
                    children: footer
                })
            ]
        })
    });
};

});
parcelRegister("4iqRj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6487e77d6f03314$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $52EPl = parcelRequire("52EPl");
var $dAYOx = parcelRequire("dAYOx");
var $ahaN7 = parcelRequire("ahaN7");

var $a6IPc = parcelRequire("a6IPc");

var $8Q3VW = parcelRequire("8Q3VW");

var $8JHjV = parcelRequire("8JHjV");

var $lGgRw = parcelRequire("lGgRw");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $4Ejup = parcelRequire("4Ejup");

var $1yEFx = parcelRequire("1yEFx");

var $lIoAO = parcelRequire("lIoAO");
const $b6487e77d6f03314$var$popupWrapperStyle = (0, $ecnYn.xcss)({
    borderRadius: 'border.radius.100',
    boxShadow: 'elevation.shadow.overlay',
    ':focus': {
        outline: 'none'
    }
});
const $b6487e77d6f03314$export$ab558c171679016e = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ...props,
        ref: ref,
        role: "dialog",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $b6487e77d6f03314$var$popupWrapperStyle,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1GzhS.default), {
                space: "space.150",
                children: children
            })
        })
    });
});
const $b6487e77d6f03314$var$SearchResultContextMenu = ({ url: url, isContextMenuOpen: isContextMenuOpen, setIsContextMenuOpen: setIsContextMenuOpen, setIsFocused: setIsFocused, setIsHovered: setIsHovered, id: id, cloudId: cloudId, aiSummaryEnabled: aiSummaryEnabled = false })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [isAISummaryOpen, setIsAISummaryOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(false);
    const divRef = (0, $gwFzn.useRef)(null);
    const copyToClipboard = async ()=>{
        setIsHovered(false);
        setIsFocused(false);
        if (!url) return;
        await navigator.clipboard.writeText(url);
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lGgRw.Popup), {
        placement: "right",
        isOpen: aiSummaryEnabled && isAISummaryOpen,
        onClose: ()=>{
            setIsAISummaryOpen(false);
            setIsHovered(false);
            setIsFocused(false);
        },
        popupComponent: $b6487e77d6f03314$export$ab558c171679016e,
        content: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4Ejup.AIStreamingSummaryContent), {
                url: url,
                cloudId: cloudId,
                ari: id,
                agentNamedId: 'summary_agent',
                product: (0, $1yEFx.ProductKeys).Confluence,
                experienceId: "page-summaries"
            }),
        trigger: ({ 'aria-expanded': boolean, ...triggerProps })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                ...triggerProps,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $52EPl.default), {
                    trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                            ...props,
                            appearance: "subtle",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8JHjV))),
                            label: formatMessage((0, $lIoAO.messages).moreActionsLabel),
                            isTooltipDisabled: false,
                            spacing: "compact",
                            ref: triggerRef
                        }),
                    placement: "right-start",
                    testId: "search-result-context-menu",
                    onOpenChange: ()=>setIsContextMenuOpen(!isContextMenuOpen),
                    isOpen: isContextMenuOpen,
                    returnFocusRef: divRef,
                    zIndex: 2,
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $ahaN7.default), {
                        testId: "search-result-context-menu-dropdown",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                onMouseDown: copyToClipboard,
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dAYOx.default), {
                                    elemBefore: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Q3VW))), {
                                        color: "currentColor",
                                        label: "copy-link-icon",
                                        LEGACY_size: "medium",
                                        spacing: "spacious"
                                    }),
                                    testId: "copy-link-button",
                                    children: formatMessage((0, $lIoAO.messages).copyLinkLabel)
                                })
                            }),
                            aiSummaryEnabled && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                onMouseDown: ()=>{
                                    setIsAISummaryOpen(true);
                                    setIsFocused(true);
                                    setIsHovered(true);
                                    setIsContextMenuOpen(false);
                                },
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dAYOx.default), {
                                    elemBefore: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))), {
                                        color: "currentColor",
                                        label: "ai-summary-button",
                                        LEGACY_size: "medium",
                                        spacing: "spacious"
                                    }),
                                    testId: "ai-summary-button",
                                    children: formatMessage((0, $lIoAO.messages).aiSummaryLabel)
                                })
                            })
                        ]
                    })
                })
            })
    });
};
var $b6487e77d6f03314$export$2e2bcd8739ae039 = $b6487e77d6f03314$var$SearchResultContextMenu;

});
parcelRegister("4Ejup", function(module, exports) {

$parcel$export(module.exports, "AIStreamingSummaryContent", () => $124a060f08693806$export$409e1b836965a8a4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $gUu2y = parcelRequire("gUu2y");

var $4Gau4 = parcelRequire("4Gau4");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $iyIyT = parcelRequire("iyIyT");

var $lL1Cj = parcelRequire("lL1Cj");

var $9xDvS = parcelRequire("9xDvS");

var $1XMIO = parcelRequire("1XMIO");

var $iXZ1H = parcelRequire("iXZ1H");
const $124a060f08693806$var$styles = (0, $ecnYn.xcss)({
    width: '500px'
});
const $124a060f08693806$var$MAX_HEIGHT_SUMMARY = 358;
const $124a060f08693806$export$dc4d0f4ecc47d21c = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c81ixg _c71lgbqg _18m91wug _1i4q1hna _o5724jg8 _1suq18uv _1ke8u2gc _155au2gc _aaynm7j4 _1ogl15ej",
            __cmplp.className
        ])
    });
});
const $124a060f08693806$export$409e1b836965a8a4 = /*#__PURE__*/ (0, $gwFzn.memo)((props)=>{
    const summaryRef = (0, $gwFzn.useRef)(null);
    const { content: content, state: state } = (0, $lL1Cj.useAISummaryStreaming)({
        ...props,
        summaryStyle: 'medium',
        summaryOutputMimetype: 'text/markdown',
        delayChunkUpdate: {
            gap: 10,
            time: 20
        },
        featureFlags: {
            showFollowUps: false
        },
        onProgress: ()=>{
            scrollToBottom();
        }
    });
    const scrollToBottom = ()=>{
        const summaryBody = summaryRef?.current;
        if (summaryBody) summaryBody.scrollTop = summaryBody.scrollHeight;
    };
    const renderPopupContent = ()=>{
        switch(state){
            case (0, $iyIyT.AISummaryStreamingState).Initialization:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1XMIO.StreamingSummaryLoading), {});
            // TODO we need to integrate FollowUp properly
            // at the moment we have it only in confluence
            // case AISummaryStreamingState.FollowUp:
            case (0, $iyIyT.AISummaryStreamingState).AnswerPart:
            case (0, $iyIyT.AISummaryStreamingState).FinalResponse:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    padding: "space.250",
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
                        space: "space.250",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)($124a060f08693806$export$dc4d0f4ecc47d21c, {
                                ref: summaryRef,
                                "data-testid": "ai-summary-body-content",
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gUu2y.default), {
                                    children: content
                                })
                            }),
                            state === (0, $iyIyT.AISummaryStreamingState).FinalResponse && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9xDvS.StreamingSummaryFooter), {})
                        ]
                    })
                });
        }
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $124a060f08693806$var$styles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXZ1H.StreamingThemedContainer), {
            loading: state === (0, $iyIyT.AISummaryStreamingState).Initialization,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                ...(0, $4Gau4.useResizingHeight)(),
                children: renderPopupContent()
            })
        })
    });
});

});
parcelRegister("iyIyT", function(module, exports) {

$parcel$export(module.exports, "AISummaryStreamingState", () => $c16bce224d83709b$export$93af043be4836651);
var $c16bce224d83709b$export$93af043be4836651 = /*#__PURE__*/ function(AISummaryStreamingState) {
    AISummaryStreamingState["Initialization"] = "Initialization";
    AISummaryStreamingState["AnswerPart"] = "AnswerPart";
    AISummaryStreamingState["FinalResponse"] = "FinalResponse";
    AISummaryStreamingState["FollowUp"] = "FollowUp";
    AISummaryStreamingState["Error"] = "Error";
    return AISummaryStreamingState;
}({});

});

parcelRegister("lL1Cj", function(module, exports) {

$parcel$export(module.exports, "useAISummaryStreaming", () => $407aa891086c405a$export$4bde2604d76545ee);

var $guQFZ = parcelRequire("guQFZ");

var $eJ5lO = parcelRequire("eJ5lO");

var $4iZtC = parcelRequire("4iZtC");

var $7CiAC = parcelRequire("7CiAC");

var $eByKY = parcelRequire("eByKY");

var $1HDbh = parcelRequire("1HDbh");

var $kkxph = parcelRequire("kkxph");

var $3CH4j = parcelRequire("3CH4j");

var $8EEqM = parcelRequire("8EEqM");

var $d7x0s = parcelRequire("d7x0s");
var $92kN7 = parcelRequire("92kN7");
var $89BX5 = parcelRequire("89BX5");

var $iyIyT = parcelRequire("iyIyT");

var $hbElZ = parcelRequire("hbElZ");
var $5zeW3 = parcelRequire("5zeW3");
const $407aa891086c405a$var$memoAISummaryStreamingState = (aiSummaryConfigPrev, aiSummaryConfigPrevNext)=>{
    if ('ari' in aiSummaryConfigPrev && 'ari' in aiSummaryConfigPrevNext) return aiSummaryConfigPrev.ari === aiSummaryConfigPrevNext.ari;
    if ('url' in aiSummaryConfigPrev && 'url' in aiSummaryConfigPrevNext) return aiSummaryConfigPrev.url === aiSummaryConfigPrevNext.url;
    return false;
};
function $407aa891086c405a$export$4bde2604d76545ee(config, initialState = {
    content: '',
    state: (0, $iyIyT.AISummaryStreamingState).Initialization
}) {
    const { onStart: onStart, onStreamStart: onStreamStart, onProgress: onProgress, onError: onError, onDone: onDone, delayChunkUpdate: delayChunkUpdate, withRefetch: withRefetch } = config;
    const aiSummaryStreamingState$ = (0, $hbElZ.useObservable)((inputs$)=>inputs$.pipe((0, $7CiAC.distinctUntilChanged)(([aiSummaryConfigPrev], [aiSummaryConfigPrevNext])=>$407aa891086c405a$var$memoAISummaryStreamingState(aiSummaryConfigPrev, aiSummaryConfigPrevNext)), (0, $eByKY.map)(([aiSummaryConfig, initialState])=>({
                aiSummaryConfig: aiSummaryConfig,
                initialState: initialState,
                requestUrl: (0, $89BX5.mapToURL)(aiSummaryConfig)
            })), (0, $eByKY.map)(({ aiSummaryConfig: aiSummaryConfig, initialState: initialState, requestUrl: requestUrl })=>({
                requestOptions: (0, $92kN7.mapToAIAgentRequest)(aiSummaryConfig, requestUrl),
                initialState: initialState
            })), (0, $kkxph.switchMap)(({ requestOptions: requestOptions, initialState: initialState })=>{
            onStart?.();
            return (0, $d7x0s.makeAIAgentStreamRequest)(requestOptions, initialState);
        }), (0, $8EEqM.timeInterval)(), (0, $eJ5lO.concatMap)((nextState)=>{
            if (!delayChunkUpdate) return (0, $guQFZ.of)(nextState.value);
            const { time: time, gap: gap } = delayChunkUpdate;
            if (nextState.interval < gap) return (0, $guQFZ.of)(nextState.value).pipe((0, $4iZtC.delay)(time));
            return (0, $guQFZ.of)(nextState.value);
        }), (0, $3CH4j.tap)(({ state: state, answerChunkIndex: answerChunkIndex, error: error })=>{
            switch(state){
                case (0, $iyIyT.AISummaryStreamingState).AnswerPart:
                    if (answerChunkIndex === 0) onStreamStart?.();
                    onProgress?.();
                    break;
                case (0, $iyIyT.AISummaryStreamingState).FinalResponse:
                    onDone?.();
                    break;
                case (0, $iyIyT.AISummaryStreamingState).Error:
                    onError?.(error);
            }
        })), [
        config,
        initialState
    ]);
    const [state, refetch] = (0, $5zeW3.useObservableState)((aiSummarySubject$)=>aiSummarySubject$.pipe((0, $1HDbh.startWith)(initialState), (0, $kkxph.switchMap)(()=>aiSummaryStreamingState$)), {
        ...initialState
    });
    if (withRefetch) return [
        state,
        refetch
    ];
    return state;
}

});
parcelRegister("d7x0s", function(module, exports) {

$parcel$export(module.exports, "makeAIAgentStreamRequest", () => $f9052ebc240ffef1$export$f08c4fd1705b0192);

var $iX7e9 = parcelRequire("iX7e9");

var $iyIyT = parcelRequire("iyIyT");

var $c8LjI = parcelRequire("c8LjI");
const $f9052ebc240ffef1$export$f08c4fd1705b0192 = ({ requestUrl: requestUrl, requestOptions: requestOptions, featureFlags: featureFlags = {} }, initialState)=>{
    const behaviorSubject = new (0, $iX7e9.BehaviorSubject)({
        ...initialState
    });
    fetch(requestUrl, {
        credentials: 'include',
        ...requestOptions
    }).then((response)=>(0, $c8LjI.readStream)(response)).then(async (stream)=>{
        let bufferContent = '';
        let answerChunkIndex = 0;
        for await (const chunk of stream){
            const state = behaviorSubject.getValue();
            switch(chunk.type){
                case 'ANSWER_PART':
                    bufferContent += chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        state: (0, $iyIyT.AISummaryStreamingState).AnswerPart,
                        content: bufferContent,
                        answerChunkIndex: answerChunkIndex
                    });
                    answerChunkIndex += 1;
                    break;
                case 'FINAL_RESPONSE':
                    bufferContent = chunk.message.message.content;
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        state: (0, $iyIyT.AISummaryStreamingState).FinalResponse,
                        content: bufferContent
                    });
                    break;
                case 'FOLLOW_UP_QUERIES':
                    if (!featureFlags?.showFollowUps) return;
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        followUpContent: chunk.message.follow_ups ?? [],
                        state: (0, $iyIyT.AISummaryStreamingState).FollowUp
                    });
                    break;
                case 'ERROR':
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        state: (0, $iyIyT.AISummaryStreamingState).Error,
                        error: {
                            ...chunk
                        }
                    });
                    break;
            }
        }
    }).finally(()=>{
        behaviorSubject.complete();
    });
    return behaviorSubject;
};

});
parcelRegister("c8LjI", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $063fa47b2ffd0ad9$export$e45226161c660403);

var $bddW2 = parcelRequire("bddW2");

var $agEvB = parcelRequire("agEvB");
async function* $063fa47b2ffd0ad9$export$e45226161c660403(response) {
    // covered HTTP errors only from this doc
    // https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3420210503/Error+message+formats+-+assistance-service
    const possibleHTTPError = await (0, $bddW2.match)(response).returnType().with({
        status: 201
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: No answer was generated by Open AI. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $agEvB.ErrorMessage).NO_ANSWER,
                status_code: response.status
            }
        };
    }).with({
        status: 400
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: BAD_REQUEST or NO_AGENT or EXCEEDING_CONTEXT_LENGTH_ERROR. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $agEvB.ErrorMessage).NO_AGENT,
                status_code: response.status
            }
        };
    }).with({
        status: 403
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: FEATURE_DISABLED_ON_SITE or FEATURE_DISABLED or HIPAA_CONTENT_DETECTED. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $agEvB.ErrorMessage).AI_DISABLED,
                status_code: response.status
            }
        };
    }).with({
        status: 429
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: RATE_LIMIT or OPENAI_RATE_LIMIT_USER_ABUSE. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $agEvB.ErrorMessage).RATE_LIMIT,
                status_code: response.status
            }
        };
    }).with({
        status: 500
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: INTERNAL_SERVER_ERROR. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $agEvB.ErrorMessage).UNEXPECTED,
                status_code: response.status
            }
        };
    }).with({
        status: (0, $bddW2.P).not(200)
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: OTHER_SERVER_ERROR. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $agEvB.ErrorMessage).UNEXPECTED,
                status_code: response.status
            }
        };
    }).otherwise(()=>Promise.resolve(null));
    if (possibleHTTPError) {
        yield possibleHTTPError;
        return;
    }
    if (!response.body) {
        const responseText = await response.text();
        yield {
            type: 'ERROR',
            message: {
                content: `[Error]: response.body is missing. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $agEvB.ErrorMessage).NETWORK_ERROR,
                status_code: response.status
            }
        };
        return;
    }
    try {
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        let done = false;
        while(!done){
            const { value: value, done: doneReading } = await reader.read();
            const decodedValue = decoder.decode(value);
            done = doneReading;
            buffer = `${buffer}${decodedValue}`;
            // Split the buffer by line breaks
            const lines = buffer.split('\n');
            // Process all complete lines, except for the last one (which might be incomplete)
            while(lines.length > 1){
                const line = lines.shift();
                const parsedData = JSON.parse(line);
                yield parsedData;
            }
            // Keep the last (potentially incomplete) line in the buffer
            buffer = lines[0];
        }
        return;
    } catch (parsingError) {
        let errorText = '';
        if (typeof parsingError === 'string') errorText = parsingError.toUpperCase();
        else if (parsingError instanceof Error) errorText = parsingError.message;
        yield {
            type: 'ERROR',
            message: {
                content: `[Stream Error]: ${errorText}. locked status: ${response.body.locked}. statusCode: ${response.status}`,
                message_template: (0, $agEvB.ErrorMessage).UNEXPECTED
            }
        };
        return;
    }
}

});


parcelRegister("92kN7", function(module, exports) {

$parcel$export(module.exports, "mapToAIAgentRequest", () => $96f8f0852628c5c9$export$f9ad2230f0827c88);
function $96f8f0852628c5c9$export$f9ad2230f0827c88(aiSummaryStreamingConfig, requestUrl) {
    const { headers: headers, agentNamedId: agentNamedId, locale: locale, agentPrompt: agentPrompt, experienceId: experienceId, product: product, summaryOutputMimetype: summaryOutputMimetype, summaryStyle: summaryStyle, ari: ari, promptId: promptId, featureFlags: featureFlags, updateType: updateType, jsonStructured: jsonStructured, outputMimetype: outputMimetype, endTimeMs: endTimeMs, cloudId: cloudId, selectedVersions: selectedVersions } = aiSummaryStreamingConfig;
    const payload = {
        recipient_agent_named_id: agentNamedId,
        agent_input_prompt: agentPrompt,
        agent_input_context: {
            content_ari: ari,
            summary_style: summaryStyle,
            prompt_id: promptId,
            update_type: updateType,
            locale: locale,
            ...summaryOutputMimetype ? {
                summary_output_mimetype: summaryOutputMimetype
            } : {},
            ...outputMimetype ? {
                output_mimetype: outputMimetype
            } : {},
            json_structured: jsonStructured,
            ...endTimeMs ? {
                end_time_ms: endTimeMs
            } : {},
            ...selectedVersions || {}
        }
    };
    if ('url' in aiSummaryStreamingConfig) {
        // Send URL even if ari is present as it can be used as a fallback
        const { url: url } = aiSummaryStreamingConfig;
        payload.agent_input_context.content_url = url;
    }
    const requestHeaders = new Headers({
        'content-type': 'application/json;charset=UTF-8',
        'x-experience-id': experienceId,
        'x-product': product,
        ...headers
    });
    if (cloudId) requestHeaders.set('x-cloudid', cloudId);
    const requestOptions = {
        method: 'POST',
        headers: requestHeaders,
        body: JSON.stringify(payload)
    };
    return {
        requestUrl: requestUrl,
        requestOptions: requestOptions,
        featureFlags: featureFlags
    };
}

});

parcelRegister("89BX5", function(module, exports) {

$parcel$export(module.exports, "mapToURL", () => $0cd86d8ed4a7e434$export$eeb0f71528628f71);

var $hcD0d = parcelRequire("hcD0d");
function $0cd86d8ed4a7e434$export$eeb0f71528628f71(aiSummaryStreamingConfig, streaming = true) {
    const { baseUrl: baseUrl } = aiSummaryStreamingConfig;
    const baseStreamURL = baseUrl ?? (0, $hcD0d.BASE_STREAM_URL);
    const chatPath = streaming ? (0, $hcD0d.CHAT_STREAM_PATH) : (0, $hcD0d.CHAT_PATH);
    const requestUrl = `${baseStreamURL}/${chatPath}`;
    return requestUrl;
}

});
parcelRegister("hcD0d", function(module, exports) {

$parcel$export(module.exports, "CHAT_STREAM_PATH", () => $ceca5b6d907f1cd0$export$82796cc300bdfa9d);
$parcel$export(module.exports, "CHAT_PATH", () => $ceca5b6d907f1cd0$export$54306dc3a5fddc77);
$parcel$export(module.exports, "BASE_STREAM_URL", () => $ceca5b6d907f1cd0$export$7c03f5942efb8a41);
const $ceca5b6d907f1cd0$export$82796cc300bdfa9d = 'chat/v1/invoke_agent/stream';
const $ceca5b6d907f1cd0$export$54306dc3a5fddc77 = 'chat/v1/invoke_agent';
const $ceca5b6d907f1cd0$export$7c03f5942efb8a41 = '/gateway/api/assist';

});


parcelRegister("hbElZ", function(module, exports) {

$parcel$export(module.exports, "useObservable", () => $5f64958511fe1beb$export$262b072b280a540c);
/**
 * @license observable-hooks
 * index.ts
 *
 * Copyright (c) 2023 CRIMX<straybugs@gmail.com>
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable react-hooks/rules-of-hooks */ 
var $gwFzn = parcelRequire("gwFzn");

var $iX7e9 = parcelRequire("iX7e9");
/**
 * @template TOutput Output value within Observable.
 * @template TInputs A readonly tuple of all dependencies.
 *
 * @param useCustomEffect useEffect or useLayoutEffect
 * @param init A pure function that, when applied to an Observable,
 * returns an Observable.
 * @param inputs An dependency array with fixed length. When one of the dependencies
 * changes the Observable in `init` will emit an array of all the dependencies.
 */ function $5f64958511fe1beb$var$useObservableInternal(init, inputs) {
    // Even though hooks are under conditional block
    // it is for a completely different use case
    // which unlikely coexists with the other one.
    // A warning is also added to the docs.
    if (!inputs) return (0, $gwFzn.useState)(init)[0];
    const [inputs$] = (0, $gwFzn.useState)(()=>new (0, $iX7e9.BehaviorSubject)(inputs));
    const [source$] = (0, $gwFzn.useState)(()=>init(inputs$));
    const firstEffectRef = (0, $gwFzn.useRef)(true);
    (0, $gwFzn.useEffect)(()=>{
        if (firstEffectRef.current) {
            firstEffectRef.current = false;
            return;
        }
        inputs$.next(inputs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
    return source$;
}
function $5f64958511fe1beb$export$262b072b280a540c(init, inputs) {
    return $5f64958511fe1beb$var$useObservableInternal(init, inputs);
}

});

parcelRegister("5zeW3", function(module, exports) {

$parcel$export(module.exports, "useObservableState", () => $c2a30628d915f915$export$561674a65351b693);
/**
 * @license observable-hooks
 * index.ts
 *
 * Copyright (c) 2023 CRIMX<straybugs@gmail.com>
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable react-hooks/rules-of-hooks */ 
var $gwFzn = parcelRequire("gwFzn");

var $iX7e9 = parcelRequire("iX7e9");

var $2Ixil = parcelRequire("2Ixil");

var $81DRH = parcelRequire("81DRH");

var $1Kwkp = parcelRequire("1Kwkp");
function $c2a30628d915f915$export$561674a65351b693(state$OrInit, initialState) {
    // Even though hooks are under conditional block
    // it is for a completely different use case
    // which unlikely coexists with the other one.
    // A warning is also added to the docs.
    if ((0, $81DRH.isObservable)(state$OrInit)) {
        const state$ = state$OrInit;
        const [state, setState] = (0, $gwFzn.useState)(()=>{
            if (state$ instanceof (0, $iX7e9.BehaviorSubject) || state$.value !== undefined) return state$.value;
            if (typeof initialState === 'function') return initialState();
            return initialState;
        });
        (0, $1Kwkp.useSubscription)(state$, setState);
        (0, $gwFzn.useDebugValue)(state);
        return state;
    } else {
        const init = state$OrInit;
        const [state, setState] = (0, $gwFzn.useState)(initialState);
        const [input$] = (0, $gwFzn.useState)((0, $2Ixil.getEmptySubject));
        const [state$] = (0, $gwFzn.useState)(()=>init(input$, state));
        const callback = (0, $gwFzn.useRef)((state)=>input$.next(state)).current;
        (0, $1Kwkp.useSubscription)(state$, setState);
        (0, $gwFzn.useDebugValue)(state);
        return [
            state,
            callback
        ];
    }
}

});
parcelRegister("2Ixil", function(module, exports) {

$parcel$export(module.exports, "getEmptySubject", () => $f9ef89eea28f6a31$export$515c0fda29e99c0d);

var $cC77I = parcelRequire("cC77I");
const $f9ef89eea28f6a31$export$515c0fda29e99c0d = ()=>new (0, $cC77I.Subject)();

});

parcelRegister("81DRH", function(module, exports) {

$parcel$export(module.exports, "isObservable", () => $15d1c4c89f3eed98$export$5cd057a6046189f9);

var $7Qfu8 = parcelRequire("7Qfu8");
const $15d1c4c89f3eed98$export$5cd057a6046189f9 = (obj)=>obj instanceof (0, $7Qfu8.Observable);

});

parcelRegister("1Kwkp", function(module, exports) {

$parcel$export(module.exports, "useSubscription", () => $d21f8f3e14380598$export$368b4214baeb914c);
/**
 * @license observable-hooks
 * index.ts
 *
 * Copyright (c) 2023 CRIMX<straybugs@gmail.com>
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $bLfXj = parcelRequire("bLfXj");
const $d21f8f3e14380598$var$toObserver = (args)=>args[1]?.next ? args[1] : {
        next: args[1],
        error: args[2],
        complete: args[3]
    };
/**
 *
 * @template TInput Input value within Observable.
 *
 * @param useCustomEffect useEffect or useLayoutEffect
 * @param args collected arguments
 */ function $d21f8f3e14380598$var$useSubscriptionInternal(args) {
    const argsRef = (0, $gwFzn.useRef)(args);
    const observerRef = (0, $gwFzn.useRef)();
    const subscriptionRef = (0, $gwFzn.useRef)();
    const deps = args[0];
    // Update the latest observable and callbacks
    // synchronously after render being committed
    (0, $bLfXj.useIsomorphicLayoutEffect)(()=>{
        argsRef.current = args;
        observerRef.current = $d21f8f3e14380598$var$toObserver(args);
    });
    (0, $gwFzn.useEffect)(()=>{
        // keep in closure for checking staleness
        const input$ = argsRef.current[0];
        /* istanbul ignore if: Just in case the layoutEffect order is agnostic */ if (!observerRef.current) observerRef.current = $d21f8f3e14380598$var$toObserver(argsRef.current);
        const subscription = input$.subscribe({
            next: (value)=>{
                if (input$ === argsRef.current[0]) observerRef.current.next?.(value);
            // else: stale observable
            },
            error: (error)=>{
                if (input$ === argsRef.current[0]) observerRef.current.error ? observerRef.current.error(error) : console.error(error);
            // else: stale observable
            },
            complete: ()=>{
                if (input$ === argsRef.current[0]) observerRef.current.complete?.();
            // else: stale observable
            }
        });
        subscriptionRef.current = subscription;
        return ()=>{
            subscription.unsubscribe();
        };
    }, [
        deps
    ]);
    return subscriptionRef;
}
function $d21f8f3e14380598$export$368b4214baeb914c(input$, observerOrNext$, error, complete) {
    return $d21f8f3e14380598$var$useSubscriptionInternal([
        input$,
        observerOrNext$,
        error,
        complete
    ]);
}

});
parcelRegister("bLfXj", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $fe769f18701d2af2$export$700979bc83e7db82);
/**
 * @license observable-hooks
 * index.ts
 *
 * Copyright (c) 2023 CRIMX<straybugs@gmail.com>
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $gwFzn = parcelRequire("gwFzn");
const $fe769f18701d2af2$export$700979bc83e7db82 = /* @__PURE__ */ (()=>/* istanbul ignore next */ typeof window === 'undefined' ? (0, $gwFzn.useEffect) : (0, $gwFzn.useLayoutEffect))();

});




parcelRegister("9xDvS", function(module, exports) {

$parcel$export(module.exports, "StreamingSummaryFooter", () => $83edcaeea1a9640d$export$eb9f2b031d5e4a48);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $3Mg7y = parcelRequire("3Mg7y");

var $2Nwuj = parcelRequire("2Nwuj");

var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $1QO6w = parcelRequire("1QO6w");
const $83edcaeea1a9640d$var$StreamingSummaryFooterStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small'
});
const $83edcaeea1a9640d$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $83edcaeea1a9640d$export$eb9f2b031d5e4a48 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1GzhS.default), {
        space: "space.200",
        xcss: $83edcaeea1a9640d$var$StreamingSummaryFooterStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...(0, $1QO6w.i18n).footerQualityDescriptor,
                        values: {
                            learnMoreLink: (chunks)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
                                    href: $83edcaeea1a9640d$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK,
                                    target: "_blank",
                                    testId: "learn-why-link",
                                    children: chunks
                                })
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                    space: "space.050",
                    alignBlock: "center",
                    children: [
                        formatMessage((0, $1QO6w.i18n).poweredBy),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
                            color: "var(--ds-icon, #44546F)",
                            label: formatMessage((0, $1QO6w.i18n).atlassianIntelligenceIconAlt)
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("1QO6w", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $30c6677c2b3daf45$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $30c6677c2b3daf45$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    footerQualityDescriptor: {
        id: "ai-summary.ai-summary-footer.quality-descriptor",
        defaultMessage: "Information quality may vary. <learnMoreLink>Learn why</learnMoreLink>"
    },
    poweredBy: {
        id: "ai-summary.ai-summary-footer.powered-by",
        defaultMessage: "Powered by"
    },
    atlassianIntelligenceIconAlt: {
        id: "ai-summary.ai-summary-footer.atlassian-intelligence-icon",
        defaultMessage: "Atlassian Intelligence"
    },
    betaLozenge: {
        id: "ai-summary.ai-summary-footer.beta-lozenge",
        defaultMessage: "Beta"
    }
});

});


parcelRegister("1XMIO", function(module, exports) {

$parcel$export(module.exports, "StreamingSummaryLoading", () => $cdced3a964b3890a$export$f12de511c7aacfbd);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $iaRcD = parcelRequire("iaRcD");

var $6Hw7i = parcelRequire("6Hw7i");
const $cdced3a964b3890a$var$streamingSummaryLoadingStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle'
});
const $cdced3a964b3890a$export$f12de511c7aacfbd = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        padding: "space.300",
        xcss: $cdced3a964b3890a$var$streamingSummaryLoadingStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.025",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iaRcD.GeneratingStreamAnimation), {
                    alt: formatMessage((0, $6Hw7i.i18n).generatingSummaryAnimationAlt)
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $6Hw7i.i18n).generatingSummaryText
                })
            ]
        })
    });
};

});
parcelRegister("iaRcD", function(module, exports) {

$parcel$export(module.exports, "GeneratingStreamAnimation", () => $6ff9a1f6f746b02e$export$3709887a1be0e305);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $6ff9a1f6f746b02e$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "#0C66E4",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "#1D7AFC",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "#388BFF",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};

});

parcelRegister("6Hw7i", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $4d1d4a0ea18c6e5b$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $4d1d4a0ea18c6e5b$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    generatingSummaryText: {
        id: "ai-summary.stream-loading.body",
        defaultMessage: "Atlassian Intelligence is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-summary.stream-loading.generating-summary-animation",
        defaultMessage: "Generating summary"
    }
});

});


parcelRegister("iXZ1H", function(module, exports) {

$parcel$export(module.exports, "StreamingThemedContainer", () => $3a526eca8e47b748$export$515033a01bd299fc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $7hpmn = parcelRequire("7hpmn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a526eca8e47b748$var$GradientPropertyContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb1osq _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $3a526eca8e47b748$var$outerContainerStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    position: 'relative',
    borderRadius: 'border.radius.100',
    background: `conic-gradient(
    from var(--gradient-angle, 270deg),
    #1d7afc 10%,
    #8bdbe5 30%,
    #f8e6a0 50%,
    #8bdbe5 70%,
    #1d7afc 90%
  )`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...(0, $7hpmn.reduceMotionAsPerUserPreference)
});
const $3a526eca8e47b748$var$animationStyles = (0, $ecnYn.xcss)({
    animation: 'rotationAnimation linear 2s infinite'
});
const $3a526eca8e47b748$var$glowStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    filter: 'blur(25px)',
    opacity: '0.5',
    height: '100%',
    width: '100%'
});
const $3a526eca8e47b748$var$innerContainerStyles = (0, $ecnYn.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface.overlay'
});
const $3a526eca8e47b748$export$515033a01bd299fc = ({ loading: loading = false, children: children })=>{
    const isReducedMotion = (0, $7hpmn.useIsReducedMotion)();
    const shouldRotate = loading && !isReducedMotion;
    const containerStyles = shouldRotate ? [
        $3a526eca8e47b748$var$outerContainerStyles,
        $3a526eca8e47b748$var$animationStyles
    ] : [
        $3a526eca8e47b748$var$outerContainerStyles
    ];
    return /*#__PURE__*/ (0, $7UHDa.jsxs)($3a526eca8e47b748$var$GradientPropertyContainer, {
        children: [
            shouldRotate && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $3a526eca8e47b748$var$outerContainerStyles,
                    $3a526eca8e47b748$var$animationStyles,
                    $3a526eca8e47b748$var$glowStyles
                ],
                testId: "loading-glow"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                padding: "space.025",
                xcss: containerStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $3a526eca8e47b748$var$innerContainerStyles,
                    children: children
                })
            })
        ]
    });
};

});


parcelRegister("lIoAO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dec63c756dcbc0c4$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $dec63c756dcbc0c4$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    copyLinkLabel: {
        id: "copy-content-link-label",
        defaultMessage: "Copy link"
    },
    aiSummaryLabel: {
        id: "ai-summary-label",
        defaultMessage: "Summarize"
    },
    moreActionsLabel: {
        id: "more-actions-label",
        defaultMessage: "More Actions"
    }
});

});


parcelRegister("1rVFx", function(module, exports) {

$parcel$export(module.exports, "SearchResultTitle", () => $ab9ed5f36da1b106$export$9e8cf942b0ab74d9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $cwkWT = parcelRequire("cwkWT");
var $ecnYn = parcelRequire("ecnYn");

var $9vOy1 = parcelRequire("9vOy1");

var $7WbA8 = parcelRequire("7WbA8");

var $fm8DG = parcelRequire("fm8DG");

var $976IZ = parcelRequire("976IZ");
const $ab9ed5f36da1b106$var$headingAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'heading',
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    minWidth: '476px'
});
const $ab9ed5f36da1b106$var$titleStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    overflow: 'hidden'
});
const $ab9ed5f36da1b106$var$titleTextStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $ab9ed5f36da1b106$var$visitedLinkStyles = (0, $ecnYn.xcss)({
    textDecoration: 'none',
    ':visited:active': {
        color: 'color.link.visited.pressed'
    },
    ':visited': {
        color: 'color.link.visited'
    }
});
const $ab9ed5f36da1b106$var$visitedLinkPatchStyles = (0, $ecnYn.xcss)({
    color: 'color.link.visited',
    ':active': {
        color: 'color.link.visited.pressed'
    }
});
const $ab9ed5f36da1b106$var$titleMetadataStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    justifyContent: 'end'
});
const $ab9ed5f36da1b106$export$9e8cf942b0ab74d9 = ({ id: id, title: title, url: url, isThirdParty: isThirdParty = false, appMode: appMode, isHovered: isHovered, titleMetadata: titleMetadata, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked })=>{
    const showCopyLink = appMode === (0, $9vOy1.ApplicationModes).Rovo;
    /**
   * A dynamic search_id query param and queryHash is appended to the document URL for 1P search results.
   * As result we are unable to use the browser's visited links history to determine if a link has been visited.
   * This is workaround until we have a better solution.
   */ const visitedLinks = (0, $976IZ.getVisitedLinks)();
    const isVisitedLink = id ? (0, $976IZ.isVisited)(visitedLinks, id) : false;
    const { linkComponent: Link } = (0, $7WbA8.useAppContext)();
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $ab9ed5f36da1b106$var$headingAreaStyles,
        onClick: ()=>{
            if (id) (0, $976IZ.addVisitedLink)(id);
            onResultClicked?.();
        },
        onContextMenu: onResultContextMenu,
        children: id && url ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $cwkWT.default), {
            templateColumns: "minmax(50%, 1fr) min-content",
            gap: "space.400",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)(Link, {
                            xcss: [
                                $ab9ed5f36da1b106$var$visitedLinkStyles,
                                isVisitedLink && $ab9ed5f36da1b106$var$visitedLinkPatchStyles,
                                $ab9ed5f36da1b106$var$titleStyles
                            ],
                            rel: isThirdParty ? 'noreferrer' : '',
                            target: isThirdParty ? '_blank' : undefined,
                            href: url,
                            testId: "search-page-result-link",
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                xcss: $ab9ed5f36da1b106$var$titleTextStyles,
                                children: title
                            })
                        }),
                        isHovered && showCopyLink && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fm8DG.CopyLinkButton), {
                            showSuccess: true,
                            testId: id,
                            fullResultUrl: url,
                            onClick: onCopyLinkButtonClicked
                        })
                    ]
                }),
                titleMetadata && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $ab9ed5f36da1b106$var$titleMetadataStyles,
                    children: titleMetadata
                })
            ]
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $ab9ed5f36da1b106$var$titleStyles,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $ab9ed5f36da1b106$var$titleTextStyles,
                children: title
            })
        })
    }));
};

});
parcelRegister("fm8DG", function(module, exports) {

$parcel$export(module.exports, "CopyLinkButton", () => $4850c225b0c92f37$export$534d10f1c5b9c7b3);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $1bY7o = parcelRequire("1bY7o");

var $aUEBE = parcelRequire("aUEBE");

var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $3gadb = parcelRequire("3gadb");

var $8sH83 = parcelRequire("8sH83");
const $4850c225b0c92f37$var$TIMEOUT_DELAY = 2500;
const $4850c225b0c92f37$var$cursorDisabledStyles = (0, $ecnYn.xcss)({
    cursor: 'default'
});
const $4850c225b0c92f37$var$buttonStyles = (0, $ecnYn.xcss)({
    borderRadius: 'border.radius.100',
    height: `${24 / 14}em`,
    width: `${24 / 14}em`,
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0',
    ':hover': {
        background: "var(--ds-background-neutral, #091E420F)"
    },
    ':active': {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    ':disabled': {
        background: 'transparent'
    }
});
const $4850c225b0c92f37$export$534d10f1c5b9c7b3 = ({ showSuccess: showSuccess, fullResultUrl: fullResultUrl, isButton: isButton, testId: testId, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [isCopied, setIsCopied] = (0, $gwFzn.useState)(false);
    const [tooltipLabel, setTooltipLabel] = (0, $gwFzn.useState)(formatMessage((0, $8sH83.i18n).copyLinkTooltipLabel));
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useLayoutEffect(()=>{
        updateTooltip.current?.();
    }, [
        tooltipLabel
    ]);
    const copyToClipboard = async ()=>{
        // Call the onClick callback if it exists
        onClick?.();
        if (!fullResultUrl) return;
        await navigator.clipboard.writeText(typeof fullResultUrl === 'function' ? fullResultUrl() : fullResultUrl);
        if (showSuccess) {
            setIsCopied(true);
            setTooltipLabel(formatMessage((0, $8sH83.i18n).copiedLinkTooltipLabel));
            setTimeout(()=>{
                setIsCopied(false);
                setTooltipLabel(formatMessage((0, $8sH83.i18n).copyLinkTooltipLabel));
            }, $4850c225b0c92f37$var$TIMEOUT_DELAY);
        }
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltipLabel;
        },
        position: "top",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
            isDisabled: isCopied,
            onClick: copyToClipboard,
            testId: testId,
            "aria-label": formatMessage((0, $8sH83.i18n).copyLinkButtonLabel),
            backgroundColor: "color.background.neutral.subtle",
            xcss: [
                isButton && $4850c225b0c92f37$var$buttonStyles,
                isCopied && $4850c225b0c92f37$var$cursorDisabledStyles
            ],
            children: isCopied ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aUEBE))), {
                label: formatMessage((0, $8sH83.i18n).successIconLabel),
                color: "var(--ds-icon-accent-green, #22A06B)"
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                label: formatMessage((0, $8sH83.i18n).linkIconLabel),
                color: "var(--ds-icon-subtle, #626F86)"
            })
        })
    });
};

});
parcelRegister("8sH83", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $7c784569f8558ead$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $7c784569f8558ead$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    copyLinkTooltipLabel: {
        id: "copy-link-tooltip-label",
        defaultMessage: "Copy link"
    },
    copiedLinkTooltipLabel: {
        id: "copied-link-tooltip-label",
        defaultMessage: "Copied!"
    },
    successIconLabel: {
        id: "copy-link-success-icon-label",
        defaultMessage: "Success icon"
    },
    linkIconLabel: {
        id: "copy-link-link-icon-label",
        defaultMessage: "Link icon"
    },
    copyLinkButtonLabel: {
        id: "copy-link-button-label",
        defaultMessage: "Copy Link Button",
        descsription: 'Label for the button that copies content URL'
    }
});

});


parcelRegister("976IZ", function(module, exports) {

$parcel$export(module.exports, "addVisitedLink", () => $5de3908e70286a2a$export$5d8cdaf303406828);
$parcel$export(module.exports, "getVisitedLinks", () => $5de3908e70286a2a$export$ea4ff4efe040153f);
$parcel$export(module.exports, "isVisited", () => $5de3908e70286a2a$export$df30b8dffa0e57a6);
const $5de3908e70286a2a$var$SEARCH_PAGE_VISITED_KEY = 'atlassian.search-page.visited';
const $5de3908e70286a2a$var$setLocalStorageItem = (key, value)=>{
    window.localStorage.setItem(key, value);
};
const $5de3908e70286a2a$var$getLocalStorageItem = (key)=>{
    return window.localStorage.getItem(key);
};
const $5de3908e70286a2a$export$5d8cdaf303406828 = (value)=>{
    $5de3908e70286a2a$var$setLocalStorageItem($5de3908e70286a2a$var$SEARCH_PAGE_VISITED_KEY, JSON.stringify([
        ...$5de3908e70286a2a$export$ea4ff4efe040153f(),
        value
    ]));
};
const $5de3908e70286a2a$export$ea4ff4efe040153f = ()=>{
    const visitedLinksRaw = $5de3908e70286a2a$var$getLocalStorageItem($5de3908e70286a2a$var$SEARCH_PAGE_VISITED_KEY);
    return new Set(visitedLinksRaw ? JSON.parse(visitedLinksRaw) : []);
};
const $5de3908e70286a2a$export$df30b8dffa0e57a6 = (visitedLinks, id)=>{
    return visitedLinks.has(id);
};

});





parcelRegister("92zSJ", function(module, exports) {

$parcel$export(module.exports, "getSummarizedAdfContent", () => $3b640916832a713a$export$c40fed6f44bda628);

var $bOpS4 = parcelRequire("bOpS4");
const $3b640916832a713a$var$getContentString = (adf, level = 0)=>{
    let aggregatedString = '';
    if (adf.content) adf.content.forEach((node)=>{
        if (node.type === 'text') aggregatedString += node.text;
        else if (node.content && level < 15) aggregatedString += ' ' + $3b640916832a713a$var$getContentString(node, ++level);
    });
    return aggregatedString;
};
const $3b640916832a713a$export$c40fed6f44bda628 = (description, query)=>{
    /**
	 * This description can be either a complicated JSON which is actually an ADF (Atlassian Document Format) schema of the entire content of the jira issue.
	 * or it could be a simple excerpt. This uncertainity is due to the progressive development of the BE feature and rolling it out.
	 */ try {
        const adf = JSON.parse(description);
        const text = $3b640916832a713a$var$getContentString(adf);
        return (0, $bOpS4.truncateTextWithQuery)(text, query);
    } catch (e) {
        return description.length > (0, $bOpS4.MAX_CHARACTERS_IN_EXCERPT) ? description.substring(0, (0, $bOpS4.MAX_CHARACTERS_IN_EXCERPT)) + '...' : description.substring(0, (0, $bOpS4.MAX_CHARACTERS_IN_EXCERPT));
    }
};

});
parcelRegister("bOpS4", function(module, exports) {

$parcel$export(module.exports, "MAX_CHARACTERS_IN_EXCERPT", () => $93d9d061d8a03301$export$6e2b3cea5902982b);
$parcel$export(module.exports, "truncateTextWithQuery", () => $93d9d061d8a03301$export$91c2cc655c44ef69);
const $93d9d061d8a03301$var$MAX_WORDS = 20;
const $93d9d061d8a03301$export$6e2b3cea5902982b = 250;
const $93d9d061d8a03301$export$91c2cc655c44ef69 = (text, query)=>{
    if (!text) return '';
    const lowerCaseQuery = query.toLowerCase();
    const words = text.split(' ');
    const indexOfQuery = words.findIndex((value)=>lowerCaseQuery === value.toLowerCase());
    if (indexOfQuery > $93d9d061d8a03301$var$MAX_WORDS) return [
        '...'
    ].concat(words.slice(indexOfQuery - $93d9d061d8a03301$var$MAX_WORDS, indexOfQuery + $93d9d061d8a03301$var$MAX_WORDS)).concat('...').join(' ');
    return words.slice(0, 2 * $93d9d061d8a03301$var$MAX_WORDS).join(' ').substring(0, $93d9d061d8a03301$export$6e2b3cea5902982b) + (text.length > $93d9d061d8a03301$export$6e2b3cea5902982b ? '...' : '');
};

});


parcelRegister("lAvUJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0559f7291a65cc73$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $0559f7291a65cc73$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    liveDoc: {
        id: "live_doc_type",
        defaultMessage: "Live Doc"
    },
    statusUpdateTitle: {
        id: "quick-find.mercury.focus-area-status-update.title",
        defaultMessage: "Update for {focusAreaName}"
    },
    issue: {
        id: "issue_type",
        defaultMessage: "Issue"
    }
});

});


parcelRegister("2FGXW", function(module, exports) {

$parcel$export(module.exports, "ProductFilterHeader", () => $af73fd345568e68c$export$21c17ab78196b771);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $isYda = parcelRequire("isYda");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $6fnsQ = parcelRequire("6fnsQ");

var $1yEFx = parcelRequire("1yEFx");

var $d5Ozh = parcelRequire("d5Ozh");

var $adz0l = parcelRequire("adz0l");
const $af73fd345568e68c$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    flexShrink: '0',
    alignItems: 'center',
    justifyContent: 'center'
});
const $af73fd345568e68c$var$productFilterHeaderContainerStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.075',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
});
const $af73fd345568e68c$var$productFilterHeaderStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 'space.100',
    overflowX: 'hidden',
    marginLeft: 'space.150'
});
const $af73fd345568e68c$export$21c17ab78196b771 = ({ availableProducts: availableProducts })=>{
    // eslint-disable-next-line @atlassian/search-common/no-use-local-storage
    const [storedState] = (0, $d5Ozh.useLocalStorageSearchPagePersistedState)();
    const hiddenProducts = (0, $gwFzn.useMemo)(()=>{
        if (!storedState || !storedState.filters) return [];
        return Object.keys(storedState.filters).filter((product)=>storedState.filters[product].hidden).map((product)=>product);
    }, [
        storedState
    ]);
    const combinedProducts = (0, $gwFzn.useMemo)(()=>{
        const products1P = [
            (0, $1yEFx.ProductKeys).Confluence,
            (0, $1yEFx.ProductKeys).Jira
        ].filter((product)=>availableProducts.includes(product)).filter((product)=>!hiddenProducts.includes(product));
        const products3P = [
            (0, $1yEFx.ProductKeys).GoogleDrive,
            (0, $1yEFx.ProductKeys).Sharepoint,
            (0, $1yEFx.ProductKeys).Teams,
            (0, $1yEFx.ProductKeys).Slack
        ].filter((product)=>availableProducts.includes(product)).filter((product)=>!hiddenProducts.includes(product)).slice(0, 2);
        return [
            ...products1P,
            ...products3P
        ];
    }, [
        availableProducts,
        hiddenProducts
    ]);
    if (combinedProducts.length === 0) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $af73fd345568e68c$var$productFilterHeaderContainerStyle,
        id: "product-filter-header",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $af73fd345568e68c$var$iconAreaStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
                    spacing: "none",
                    label: '',
                    color: `var(--ds-icon, ${(0, $6fnsQ.N500)})`
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $af73fd345568e68c$var$productFilterHeaderStyle,
                children: combinedProducts.map((product)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $adz0l.HeaderProductButtonFinal), {
                        otherProps: {},
                        productKey: product
                    }, product))
            })
        ]
    });
};

});
parcelRegister("adz0l", function(module, exports) {

$parcel$export(module.exports, "HeaderProductButtonFinal", () => $f6ba6e0a08941574$export$3b6e7b728016bc27);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $1SV4e = parcelRequire("1SV4e");

var $1yEFx = parcelRequire("1yEFx");

var $7WbA8 = parcelRequire("7WbA8");

var $eoZmS = parcelRequire("eoZmS");

var $aRSt4 = parcelRequire("aRSt4");

var $a5OFf = parcelRequire("a5OFf");

var $9hejW = parcelRequire("9hejW");

var $1nJM3 = parcelRequire("1nJM3");

var $gGFxq = parcelRequire("gGFxq");

var $inrbX = parcelRequire("inrbX");

var $j4ply = parcelRequire("j4ply");

var $4VmlX = parcelRequire("4VmlX");
const $f6ba6e0a08941574$var$baseStyles = (0, $ecnYn.xcss)({
    height: 'size.300',
    paddingInline: 'space.150',
    borderRadius: 'border.radius.100',
    color: 'color.text',
    backgroundColor: 'color.background.neutral',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    }
});
const $f6ba6e0a08941574$var$buttonWrapperStyles = (0, $ecnYn.xcss)({
    maxWidth: '280px' // matches dropdown of 312px (and padding)
});
const $f6ba6e0a08941574$var$textStyles = (0, $ecnYn.xcss)({
    // ellipsis for overflow text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)"
});
const $f6ba6e0a08941574$var$HeaderProductButton = ({ otherProps: otherProps, triggerProps: triggerProps, productKey: productKey, label: label, onClick: onClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $f6ba6e0a08941574$var$buttonWrapperStyles,
        ...triggerProps,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
            onClick: onClick,
            ...otherProps,
            testId: testId,
            xcss: $f6ba6e0a08941574$var$baseStyles,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                alignInline: "start",
                space: "space.100",
                spread: "space-between",
                alignBlock: "center",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                    alignBlock: "center",
                    alignInline: "start",
                    xcss: $f6ba6e0a08941574$var$textStyles,
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductOrNounIcon), {
                            label: "",
                            size: "small",
                            productOrNounKey: productKey
                        }),
                        label && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $f6ba6e0a08941574$var$textStyles,
                            children: label
                        })
                    ]
                })
            })
        })
    });
};
const $f6ba6e0a08941574$export$3b6e7b728016bc27 = ({ otherProps: otherProps, productKey: productKey, onClick: onClick, testId: testId })=>{
    const { userNeedsOAuth: userNeedsOAuth } = (0, $gGFxq.useIsUserOAuthed)(productKey);
    const products = (0, $1yEFx.useProductConfigs)();
    const productLabel = products[productKey].displayName;
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const isSmartlink = (0, $a5OFf.isProductSmartlink)({
        productKey: productKey,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const { generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [{ primaryProduct: primaryProduct, user: user }] = (0, $j4ply.useBootstrap)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const onClickNoOauth = (0, $gwFzn.useCallback)(()=>{
        if (!primaryProduct) return;
        // Store search in recent searches
        if (quickFindQuery.trim() !== '' && user && user.id && primaryProduct) {
            (0, $1SV4e.addRecentSearch)(quickFindQuery.trim(), user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
            updateRecentQueries?.();
        }
        setQuickFindOpen(false);
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...queryParams,
            product: productKey,
            text: quickFindQuery
        }), 'push');
        fireAnalyticsEvent((0, $9hejW.onProductFilterSelected)({
            actionSubjectId: productKey,
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        primaryProduct,
        quickFindQuery,
        user,
        setQuickFindOpen,
        onNavigate,
        generateSearchUrl,
        queryParams,
        productKey,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        updateRecentQueries
    ]);
    if (!userNeedsOAuth) return /*#__PURE__*/ (0, $7UHDa.jsx)($f6ba6e0a08941574$var$HeaderProductButton, {
        otherProps: otherProps,
        productKey: productKey,
        label: productLabel,
        onClick: onClickNoOauth,
        testId: testId
    });
    else return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1nJM3.ErrorBoundary), {
        section: "QuickFindHeaderProductButtonOAuthWrapper",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eoZmS.OAuthWarningWrapper), {
            product: productKey,
            trigger: ({ isDisabled: isDisabled, oAuthWarning: oAuthWarning, triggerProps: triggerProps })=>/*#__PURE__*/ (0, $7UHDa.jsx)($f6ba6e0a08941574$var$HeaderProductButton, {
                    otherProps: otherProps,
                    triggerProps: triggerProps,
                    productKey: productKey,
                    label: productLabel,
                    onClick: onClick,
                    testId: testId
                }),
            isOnSearchDialog: true,
            useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
            useIsUserOAuthed: (0, $gGFxq.useIsUserOAuthed),
            isSmartlink: isSmartlink,
            searchQuery: quickFindQuery
        }, productKey)
    });
};

});
parcelRegister("9hejW", function(module, exports) {

$parcel$export(module.exports, "onProductFilterSelected", () => $e6d04984988c7e76$export$37a6fcdc5420268c);
const $e6d04984988c7e76$export$37a6fcdc5420268c = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'selected',
        actionSubject: 'productFilter',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});



parcelRegister("fKnXN", function(module, exports) {

$parcel$export(module.exports, "useQueryFilterResults", () => $8215af3ea39f4647$export$385c746fbc3d50c5);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $esRft = parcelRequire("esRft");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $5cssW = parcelRequire("5cssW");

var $4VmlX = parcelRequire("4VmlX");
parcelRequire("ehGUC");
var $aGXLL = parcelRequire("aGXLL");

var $9SKNj = parcelRequire("9SKNj");

var $fHXCw = parcelRequire("fHXCw");

var $h5ei1 = parcelRequire("h5ei1");
const $8215af3ea39f4647$var$titleContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $8215af3ea39f4647$var$iconStyles = (0, $ecnYn.xcss)({
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $8215af3ea39f4647$var$titleStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.075',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $8215af3ea39f4647$var$ContributorQueryFilterOptions = ({ localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef })=>{
    const [filterData, { setOption: setOption }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $aGXLL.filter).id
    });
    if (filterData?.isLoading) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fHXCw.FilterOptionSkeletons), {});
    if (!filterData || filterData.options.length === 0) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h5ei1.NoOptions), {});
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: filterData.options.map((option)=>{
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9SKNj.Option), {
                title: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                    xcss: $8215af3ea39f4647$var$titleContainerStyles,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $8215af3ea39f4647$var$iconStyles,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
                                src: option.avatarUrl,
                                size: "small",
                                borderColor: "transparent",
                                appearance: "circle",
                                name: option.label
                            })
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $8215af3ea39f4647$var$titleStyles,
                            as: "span",
                            children: option.label
                        })
                    ]
                }),
                option: option,
                setOption: setOption,
                localQuery: localQuery,
                setLocalQuery: setLocalQuery,
                inputRef: inputRef
            }, option.value);
        })
    });
};
const $8215af3ea39f4647$export$385c746fbc3d50c5 = ({ localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef })=>{
    const currentQueryFilter = (0, $4VmlX.useCurrentQueryFilter)();
    if (!currentQueryFilter) return null;
    if (currentQueryFilter.filterId === 'contributor') return /*#__PURE__*/ (0, $7UHDa.jsx)($8215af3ea39f4647$var$ContributorQueryFilterOptions, {
        localQuery: localQuery,
        setLocalQuery: setLocalQuery,
        inputRef: inputRef
    });
    return null;
};

});
parcelRegister("9SKNj", function(module, exports) {

$parcel$export(module.exports, "Option", () => $9dcebcedad235590$export$36d18380658d5d20);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $4AkKf = parcelRequire("4AkKf");

var $u9agA = parcelRequire("u9agA");

var $k2YFb = parcelRequire("k2YFb");

var $eKxuB = parcelRequire("eKxuB");

var $kI4Ow = parcelRequire("kI4Ow");

var $inrbX = parcelRequire("inrbX");

var $hvVqi = parcelRequire("hvVqi");

var $4VmlX = parcelRequire("4VmlX");

var $68IrG = parcelRequire("68IrG");
const $9dcebcedad235590$export$36d18380658d5d20 = ({ title: title, option: option, setOption: setOption, localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef })=>{
    const intl = (0, $dBxQj.default)();
    const currentQueryFilter = (0, $4VmlX.useCurrentQueryFilter)();
    const { addSelectedQueryFilter: addSelectedQueryFilter } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
        label: intl.formatMessage((0, $68IrG.messages).filterIconLabel)
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
    });
    const onResultClicked = (0, $gwFzn.useCallback)(()=>{
        if (!currentQueryFilter) return;
        // Set the filter
        setOption({
            ...option,
            isSelected: false
        });
        // Update the query shown in the input
        const newLocalQuery = (0, $hvVqi.getInputQueryWithNewSelectedQueryFilter)(localQuery, currentQueryFilter?.keyword, option.label);
        setLocalQuery(newLocalQuery);
        // Update the selected query filters
        addSelectedQueryFilter({
            filterId: currentQueryFilter.filterId,
            keyword: currentQueryFilter.keyword,
            displayText: currentQueryFilter.keyword + option.label,
            option: option
        });
        // Fire analytics event
        fireAnalyticsEvent((0, $kI4Ow.onQueryFilterSelected)({
            actionSubjectId: currentQueryFilter.filterId,
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        inputRef?.current?.focus();
    }, [
        addSelectedQueryFilter,
        commonAttributes,
        currentQueryFilter,
        fireAnalyticsEvent,
        inputRef,
        localQuery,
        nonPrivacySafeAttributes,
        option,
        setLocalQuery,
        setOption
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eKxuB.SearchResult), {
        id: option.value,
        icon: icon,
        title: title,
        resultType: 'queryFilters',
        onResultClicked: onResultClicked,
        highlightedRightMetadata: highlightedRightMetadata
    });
};

});
parcelRegister("kI4Ow", function(module, exports) {

$parcel$export(module.exports, "onQueryFilterSelected", () => $e6d2962f130fd57e$export$724848965240e03c);
const $e6d2962f130fd57e$export$724848965240e03c = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'selected',
        actionSubject: 'queryFilter',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("hvVqi", function(module, exports) {

$parcel$export(module.exports, "useFilterKeywordToFilterId", () => $a00b54be6ab004d4$export$c37f199dbeef0d2c);
$parcel$export(module.exports, "useFilterKeywordToFilterActions", () => $a00b54be6ab004d4$export$170a7ded78a9d477);
$parcel$export(module.exports, "findQueryFilterKeyword", () => $a00b54be6ab004d4$export$a47046b35fa42e2d);
$parcel$export(module.exports, "getFilterLookupQuery", () => $a00b54be6ab004d4$export$3141a593bcb9212f);
$parcel$export(module.exports, "getQueryWithoutSelectedQueryFilters", () => $a00b54be6ab004d4$export$f0a1ecf34ab38b2d);
$parcel$export(module.exports, "getInputQueryWithNewSelectedQueryFilter", () => $a00b54be6ab004d4$export$53fd39a93e83286f);

var $gwFzn = parcelRequire("gwFzn");

var $5cssW = parcelRequire("5cssW");

var $aGXLL = parcelRequire("aGXLL");
const $a00b54be6ab004d4$export$c37f199dbeef0d2c = ()=>{
    return (0, $gwFzn.useMemo)(()=>{
        const contributorFilterMapping = Object.fromEntries((0, $aGXLL.CONTRIBUTOR_FILTER_QUERY_KEYWORDS).map((keyword)=>[
                keyword,
                (0, $aGXLL.filter).id
            ]));
        return {
            ...contributorFilterMapping
        };
    }, []);
};
const $a00b54be6ab004d4$export$170a7ded78a9d477 = ()=>{
    const contributorFilterFromStore = (0, $5cssW.useSelectFilter)({
        filterId: (0, $aGXLL.filter).id
    });
    return (0, $gwFzn.useMemo)(()=>{
        const contributorFilterMapping = Object.fromEntries((0, $aGXLL.CONTRIBUTOR_FILTER_QUERY_KEYWORDS).map((keyword)=>[
                keyword,
                contributorFilterFromStore[1]
            ]));
        return {
            ...contributorFilterMapping
        };
    // Only want to make this object once as we only need access to the actions
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
const $a00b54be6ab004d4$export$a47046b35fa42e2d = (query, filterKeywords)=>{
    for (const keyword of filterKeywords){
        if (query.includes(keyword)) return keyword;
    }
};
const $a00b54be6ab004d4$export$3141a593bcb9212f = (query, filterKeyword)=>{
    if (!query.includes(filterKeyword)) return;
    const lookupQueryIndexStart = query.lastIndexOf(filterKeyword) + filterKeyword.length;
    const lookupQuery = query.substring(lookupQueryIndexStart);
    return lookupQuery;
};
const $a00b54be6ab004d4$export$f0a1ecf34ab38b2d = (inputQuery, selectedQueryFilters)=>{
    let filteredQuery = inputQuery;
    for (const selectedQueryFilter of selectedQueryFilters)filteredQuery = filteredQuery.replace(selectedQueryFilter.displayText, '');
    return filteredQuery;
};
const $a00b54be6ab004d4$export$53fd39a93e83286f = (inputQuery, keyword, displayText)=>{
    // Find the last occurrence of the keyword
    const keywordIndex = inputQuery.lastIndexOf(keyword);
    return inputQuery.substring(0, keywordIndex) + keyword + displayText;
};

});

parcelRegister("68IrG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $becbf29994847995$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $becbf29994847995$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    filterIconLabel: {
        id: "filter",
        defaultMessage: "Filter icon"
    }
});

});


parcelRegister("fHXCw", function(module, exports) {

$parcel$export(module.exports, "FilterOptionSkeletons", () => $51a381ed95ba126a$export$cc8f1bc150ee9d84);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $51a381ed95ba126a$var$containerStyles = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.100',
    marginInlineEnd: 'space.100'
});
const $51a381ed95ba126a$var$resultStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.075',
    paddingBlockEnd: 'space.075',
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100',
    borderRadius: 'border.radius.200',
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'none'
});
const $51a381ed95ba126a$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $51a381ed95ba126a$var$iconStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius.100'
});
const $51a381ed95ba126a$var$middleAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    flex: 1,
    marginLeft: 'space.150'
});
const $51a381ed95ba126a$var$titleStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius.100',
    height: '16px',
    width: '40%'
});
const $51a381ed95ba126a$export$1983fc89ea4805f2 = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $51a381ed95ba126a$var$containerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
            xcss: [
                $51a381ed95ba126a$var$resultStyles
            ],
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $51a381ed95ba126a$var$iconAreaStyles,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $51a381ed95ba126a$var$iconStyles
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $51a381ed95ba126a$var$middleAreaStyles,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $51a381ed95ba126a$var$titleStyles
                        ]
                    })
                })
            ]
        })
    });
};
const $51a381ed95ba126a$export$cc8f1bc150ee9d84 = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)($51a381ed95ba126a$export$1983fc89ea4805f2, {}),
            /*#__PURE__*/ (0, $7UHDa.jsx)($51a381ed95ba126a$export$1983fc89ea4805f2, {}),
            /*#__PURE__*/ (0, $7UHDa.jsx)($51a381ed95ba126a$export$1983fc89ea4805f2, {})
        ]
    });
};

});

parcelRegister("h5ei1", function(module, exports) {

$parcel$export(module.exports, "NoOptions", () => $b44fb3788556f802$export$eac7c78123119abb);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $bk7QC = parcelRequire("bk7QC");
const $b44fb3788556f802$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 'space.200'
});
const $b44fb3788556f802$export$eac7c78123119abb = ()=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $b44fb3788556f802$var$containerStyles,
        children: intl.formatMessage((0, $bk7QC.messages).noOptions)
    });
};

});
parcelRegister("bk7QC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5fda3f2bb8e62542$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $5fda3f2bb8e62542$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    noOptions: {
        id: "noOptions",
        defaultMessage: "No options"
    }
});

});



parcelRegister("hPvza", function(module, exports) {

$parcel$export(module.exports, "RecentActivity", () => $bfef7c7cb8b104c2$export$8d9137fcb112aeab);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $hWR4v = parcelRequire("hWR4v");
var $6h3V2 = parcelRequire("6h3V2");
var $gzcCN = parcelRequire("gzcCN");

var $icWhS = parcelRequire("icWhS");
var $bloXB = parcelRequire("bloXB");

var $k2YFb = parcelRequire("k2YFb");

var $1yEFx = parcelRequire("1yEFx");

var $3E8x9 = parcelRequire("3E8x9");

var $aRSt4 = parcelRequire("aRSt4");

var $9LULT = parcelRequire("9LULT");

var $e9NQR = parcelRequire("e9NQR");

var $eKxuB = parcelRequire("eKxuB");

var $Y34Hw = parcelRequire("Y34Hw");

var $9ubz9 = parcelRequire("9ubz9");

var $j4ply = parcelRequire("j4ply");

var $4VmlX = parcelRequire("4VmlX");

var $adUP1 = parcelRequire("adUP1");
const $bfef7c7cb8b104c2$var$labelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $bfef7c7cb8b104c2$var$mapConfluenceActivityToSearchResult = (activity, query)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { title: title, space: space, links: links } = activity.object.data;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Confluence
    });
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const isLiveDoc = activity.object.data?.subtype === (0, $gzcCN.SearchConfluenceSubtype).LIVE && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in');
    const type = [
        'confluence-type',
        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: isLiveDoc ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $adUP1.messages).liveDoc
            }) : activity.object.type
        })
    ];
    const spaceName = space?.name || '';
    const metadata = [
        type,
        spaceName
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
        ]
    });
    const urlBase = links?.base;
    const urlWebUi = links?.webUi;
    const url = urlBase && urlWebUi && `${urlBase}${urlWebUi}`;
    const spaceId = space?.id;
    const analyticsMetadata = {
        contentId: id,
        containerId: spaceId,
        contentType: `confluence ${activity.object.type}`,
        product: `confluence`
    };
    if (!title || !url) return undefined;
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$var$mapJiraActivityToSearchResult = (activity, query)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { key: key, fieldsById: fieldsById, webUrl: webUrl } = activity.object.data;
    const statusName = activity.object.data?.statusCategory?.name;
    const statusColor = activity.object.data?.statusCategory?.colorName;
    const status = (0, $e9NQR.getStatus)(statusName, statusColor);
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Jira
    });
    const summary = fieldsById?.edges?.[0]?.node?.text;
    const title = key && summary && `${key}: ${summary}`;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const titleMetadataParts = status && (0, $dh538.fg)('enable_status_jira_issues_quick_find') ? [
        [
            'status',
            status
        ]
    ] : [];
    const type = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $bfef7c7cb8b104c2$var$labelContainer,
        children: activity.object.type
    });
    const metadata = [
        [
            'jira-type',
            type
        ]
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
        ]
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `jira ${activity.object.type}`,
        product: `jira`
    };
    if (!title || !webUrl) return undefined;
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: webUrl,
        analyticsMetadata: analyticsMetadata,
        titleMetadataParts: titleMetadataParts
    };
};
const $bfef7c7cb8b104c2$var$mapTownsquareActivityToSearchResult = (activity, query)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { name: name, key: key, url: url } = activity.object.data;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Atlas
    });
    const highlightedTitle = name && query ? (0, $bloXB.highlightMatchedText)(name, query.split(' ')).highlightedTitle : undefined;
    const type = [
        'type',
        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: activity.object.type
        })
    ];
    const metadata = [
        type,
        key ?? null
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
        ]
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `townsquare ${activity.object.type}`,
        product: `townsquare`
    };
    if (!name || !url) return undefined;
    return {
        id: id,
        icon: icon,
        title: name,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$var$mapGraphDocumentActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if (!activity.object.data) return;
    const { type: type, displayName: displayName, parent: parent, url: url, provider: provider } = activity.object.data;
    const id = activity.object.id;
    const providerId = provider?.providerId;
    let product = '';
    if (providerId) product = (0, $Y34Hw.getProductFromProviderId)(thirdPartyConfigs, providerId) || 'graph';
    if ((product === 'graph' || !providerId) && id) {
        const { resourceOwner: resourceOwner } = (0, $6h3V2.parseThirdPartyARI)(id);
        const resourceType = resourceOwner.split('.').at(1);
        product = resourceType === 'google-drive' ? 'drive' : resourceType || '';
    }
    if (!Object.values((0, $1yEFx.ProductKeys)).includes(product)) return;
    const subtype = type?.category?.toLowerCase();
    const label = (0, $9LULT.getDocumentSubtypeLabel)({
        product: product,
        subtype: subtype
    });
    const title = displayName;
    if (!title || !url) return undefined;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: product
    });
    const typeLabel = [
        'typeLabel',
        label ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...label
            })
        }) : subtype ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase()
        }) : null
    ];
    const parentName = parent?.displayName ?? null;
    const metadata = [
        typeLabel,
        parentName
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
        ]
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${subtype}`,
        product: product
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$var$mapGraphRemoteLinkActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if (!activity.object.data) return;
    const { category: category, displayName: displayName, url: url, provider: provider } = activity.object.data;
    const id = activity.object.id;
    const providerId = provider?.providerId;
    let product = '';
    let productDisplayName = '';
    if (providerId) {
        product = (0, $Y34Hw.getProductFromProviderId)(thirdPartyConfigs, providerId) || 'graph';
        productDisplayName = (0, $Y34Hw.getProductDisplayNameFromProviderId)(thirdPartyConfigs, providerId) || '';
    }
    if ((product === 'graph' || !providerId) && id) {
        const { resourceOwner: resourceOwner } = (0, $6h3V2.parseThirdPartyARI)(id);
        const resourceType = resourceOwner.split('.').at(1);
        product = resourceType === 'google-drive' ? 'drive' : resourceType || '';
    }
    if (!Object.values((0, $1yEFx.ProductKeys)).includes(product)) return;
    const subtype = category?.toLowerCase();
    const label = (0, $9LULT.getRemoteLinkSubtypeLabel)({
        product: product,
        subtype: subtype
    });
    const title = displayName;
    if (!title || !url) return undefined;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: product
    });
    const productLabel = [
        'productLabel',
        productDisplayName ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: productDisplayName
        }) : null
    ];
    const typeLabel = [
        'typeLabel',
        label ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...label
            })
        }) : null
    ];
    const metadata = [
        productLabel,
        typeLabel
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
        ]
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${subtype}`,
        product: product
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$var$mapGraphActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if ((0, $hWR4v.isDocumentActivity)(activity.object)) return $bfef7c7cb8b104c2$var$mapGraphDocumentActivityToSearchResult(activity, query, thirdPartyConfigs);
    if ((0, $hWR4v.isRemoteLinkActivity)(activity.object) && (0, $dh538.fg)('smartlinks-qf-recents')) return $bfef7c7cb8b104c2$var$mapGraphRemoteLinkActivityToSearchResult(activity, query, thirdPartyConfigs);
    return undefined;
};
const $bfef7c7cb8b104c2$export$1d02b83d52558ed = (edge, query, searchSessionId, thirdPartyConfigs)=>{
    const activity = edge.node;
    const product = activity.object.product;
    const result = (0, $hWR4v.isGraphActivity)(activity.object) ? $bfef7c7cb8b104c2$var$mapGraphActivityToSearchResult(activity, query, thirdPartyConfigs) : product === 'confluence' ? $bfef7c7cb8b104c2$var$mapConfluenceActivityToSearchResult(activity, query) : product === 'jira' ? $bfef7c7cb8b104c2$var$mapJiraActivityToSearchResult(activity, query) : product === 'townsquare' ? $bfef7c7cb8b104c2$var$mapTownsquareActivityToSearchResult(activity, query) : undefined;
    if (!result) return undefined;
    const urlWithAnalyticsQueryParams = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    return {
        ...result,
        url: urlWithAnalyticsQueryParams
    };
};
const $bfef7c7cb8b104c2$export$8d9137fcb112aeab = ({ result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted })=>{
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const mappedResult = $bfef7c7cb8b104c2$export$1d02b83d52558ed(result, quickFindQuery, searchSessionId, thirdPartyConfigs);
    const additionalAnalyticsAttributes = (0, $gwFzn.useMemo)(()=>({
            isCached: true,
            metadata: mappedResult?.analyticsMetadata,
            is3pLink: (0, $1yEFx.all3pProductKeys).includes(mappedResult?.analyticsMetadata.product),
            ...(0, $dh538.fg)('search_page_smart_link_analytics') && {
                is3pSmartLink: (0, $9ubz9.isResultSmartLink)(result.node.object.id)
            }
        }), [
        mappedResult,
        result.node.object.id
    ]);
    const onResultClicked = (0, $gwFzn.useCallback)((event, data)=>{
        onClick?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onClick,
        state
    ]);
    const onResultContextMenu = (0, $gwFzn.useCallback)((event, data)=>{
        onContextMenu?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onContextMenu,
        state
    ]);
    const onResultHighlighted = (0, $gwFzn.useCallback)((data)=>{
        onHighlighted?.({
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onHighlighted,
        state
    ]);
    if (!mappedResult) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eKxuB.SearchResult), {
        ...mappedResult,
        resultType: "recentActivities",
        product: mappedResult.analyticsMetadata.product,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onResultHighlighted: onResultHighlighted
    });
};

});
parcelRegister("adUP1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3a985a01f765cd1f$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $3a985a01f765cd1f$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    liveDoc: {
        id: "live_doc_type",
        defaultMessage: "Live Doc"
    }
});

});


parcelRegister("8IQPm", function(module, exports) {

$parcel$export(module.exports, "RecentQuery", () => $8aeaf6643ef42bf9$export$de317f365b3e4c5c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $kevJM = parcelRequire("kevJM");

var $lnqHu = parcelRequire("lnqHu");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");

var $1SV4e = parcelRequire("1SV4e");

var $k2YFb = parcelRequire("k2YFb");

var $7WbA8 = parcelRequire("7WbA8");

var $eKxuB = parcelRequire("eKxuB");

var $4PIs2 = parcelRequire("4PIs2");

var $inrbX = parcelRequire("inrbX");

var $dSjat = parcelRequire("dSjat");

var $j4ply = parcelRequire("j4ply");

var $4VmlX = parcelRequire("4VmlX");

var $e1gWV = parcelRequire("e1gWV");
const $8aeaf6643ef42bf9$export$de317f365b3e4c5c = ({ result: result, state: state })=>{
    const intl = (0, $dBxQj.default)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [user] = (0, $j4ply.useUser)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const onResultClicked = (0, $gwFzn.useCallback)((event)=>{
        const newTab = event && (event.ctrlKey || event.metaKey || event.shiftKey);
        if (!newTab) setQuickFindOpen(false);
        // Move this recent query to the top of the list
        if (result && user && user.id && primaryProduct) {
            (0, $1SV4e.addRecentSearch)(result, user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
            updateRecentQueries?.();
        }
        fireAnalyticsEvent((0, $4PIs2.onRecentQuerySelected)({
            actionSubjectId: (0, $dSjat.getActionSubjectId)(state),
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes,
        primaryProduct,
        result,
        setQuickFindOpen,
        state,
        updateRecentQueries,
        user
    ]);
    const mapRecentQueryToSearchResult = (0, $gwFzn.useCallback)((query)=>{
        const id = query;
        const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            label: intl.formatMessage((0, $e1gWV.messages).recentSearch),
            color: "currentColor"
        });
        const title = query;
        const onClick = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            if (user.id && primaryProduct) {
                (0, $1SV4e.removeRecentSearch)(query, user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
                updateRecentQueries?.();
            }
        };
        const rightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            children: intl.formatMessage((0, $e1gWV.messages).recentSearch)
        });
        const hoveredRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    children: intl.formatMessage((0, $e1gWV.messages).recentSearch)
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))), {
                            ...iconProps,
                            size: "small"
                        }),
                    spacing: 'compact',
                    onClick: onClick,
                    label: intl.formatMessage((0, $e1gWV.messages).recentSearch)
                })
            ]
        });
        const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    children: intl.formatMessage((0, $e1gWV.messages).recentSearch)
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
            ]
        });
        const url = generateSearchUrl({
            ...queryParams,
            text: query,
            search_id: searchSessionId
        });
        return {
            id: id,
            icon: icon,
            title: title,
            url: url,
            rightMetadata: rightMetadata,
            hoveredRightMetadata: hoveredRightMetadata,
            highlightedRightMetadata: highlightedRightMetadata
        };
    }, [
        intl,
        generateSearchUrl,
        queryParams,
        searchSessionId,
        user.id,
        primaryProduct,
        updateRecentQueries
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eKxuB.SearchResult), {
        resultType: "recentQueries",
        ...mapRecentQueryToSearchResult(result),
        onResultClicked: onResultClicked
    });
};

});
parcelRegister("4PIs2", function(module, exports) {

$parcel$export(module.exports, "onRecentQuerySelected", () => $7ce255b0a50b97ee$export$18593f729c2ce860);
const $7ce255b0a50b97ee$export$18593f729c2ce860 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'selected',
        actionSubject: 'recentQuery',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("e1gWV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $59ce0bd6e733cc83$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $59ce0bd6e733cc83$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    recentSearch: {
        id: "search_dialog_recent_search",
        defaultMessage: "Recent search"
    },
    removeRecentSearch: {
        id: "search_dialog_remove_recent_search_label",
        defaultMessage: "Remove recent search"
    }
});

});


parcelRegister("hDfbs", function(module, exports) {

$parcel$export(module.exports, "SearchResultSkeleton", () => $191ce2f0a4d53c1e$export$dd3282b157ef6f7a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $191ce2f0a4d53c1e$var$containerStyles = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.100',
    marginInlineEnd: 'space.100'
});
const $191ce2f0a4d53c1e$var$resultStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.075',
    paddingBlockEnd: 'space.075',
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100',
    borderRadius: 'border.radius.200',
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'none'
});
const $191ce2f0a4d53c1e$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $191ce2f0a4d53c1e$var$iconStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius.100'
});
const $191ce2f0a4d53c1e$var$middleAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    flex: 1,
    marginLeft: 'space.150'
});
const $191ce2f0a4d53c1e$var$titleStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius.100',
    height: '16px',
    width: '40%'
});
const $191ce2f0a4d53c1e$var$metadataStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'color.skeleton',
    width: '20%',
    borderRadius: 'border.radius.100',
    height: '13px'
});
const $191ce2f0a4d53c1e$export$dd3282b157ef6f7a = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $191ce2f0a4d53c1e$var$containerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
            xcss: [
                $191ce2f0a4d53c1e$var$resultStyles
            ],
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $191ce2f0a4d53c1e$var$iconAreaStyles,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $191ce2f0a4d53c1e$var$iconStyles
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                    xcss: $191ce2f0a4d53c1e$var$middleAreaStyles,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: [
                                $191ce2f0a4d53c1e$var$titleStyles
                            ]
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: [
                                $191ce2f0a4d53c1e$var$metadataStyles
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("fscQt", function(module, exports) {

$parcel$export(module.exports, "SearchPageLink", () => $130bb7db5dbd93df$export$bf6cf7fe2100de5c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $jluld = parcelRequire("jluld");

var $dh538 = parcelRequire("dh538");

var $u9agA = parcelRequire("u9agA");

var $k2YFb = parcelRequire("k2YFb");

var $7WbA8 = parcelRequire("7WbA8");

var $83gV2 = parcelRequire("83gV2");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $4VmlX = parcelRequire("4VmlX");

var $c6Son = parcelRequire("c6Son");
const $130bb7db5dbd93df$export$bf6cf7fe2100de5c = ({ state: state, onClick: onClick })=>{
    const intl = (0, $dBxQj.default)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const onResultClicked = (0, $gwFzn.useCallback)((event)=>{
        onClick({
            state: state,
            event: event,
            actionSubjectId: `${primaryProduct?.toLowerCase() || ''}AdvancedSearchLink`
        });
        if ((0, $dh538.fg)('quick_find_filters')) // TODO: This is a temporary measure until we do QS-6716 post Team 25 where it syncs filters with FPS.
        // For now, executing a search query on FPS search will always clear the filters in QF as FPS filters
        // is the source of truth for filter state.
        clearAllFilters();
    }, [
        onClick,
        state,
        primaryProduct,
        clearAllFilters
    ]);
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
        label: intl.formatMessage((0, $c6Son.messages).searchAcrossProducts),
        color: "currentColor"
    });
    const title = intl.formatMessage((0, $c6Son.messages).searchAcrossProducts);
    const rightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
    });
    const url = generateSearchUrl({
        ...queryParams,
        text: quickFindQuery
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $83gV2.SearchFooter), {
        icon: icon,
        title: title,
        rightMetadata: rightMetadata,
        url: url,
        onResultClicked: onResultClicked
    });
};

});
parcelRegister("c6Son", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fbb70dd8ca3729b4$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $fbb70dd8ca3729b4$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    searchAcrossProducts: {
        id: "search_dialog_search_across_products",
        defaultMessage: "Search across products"
    }
});

});


parcelRegister("3qFOk", function(module, exports) {

$parcel$export(module.exports, "SearchPagePrimaryProductLink", () => $3cfecd681a6a1322$export$2b7ed2e07f16b196);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $4AkKf = parcelRequire("4AkKf");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $9vOy1 = parcelRequire("9vOy1");

var $ltx9b = parcelRequire("ltx9b");

var $e4RDM = parcelRequire("e4RDM");

var $k2YFb = parcelRequire("k2YFb");

var $1yEFx = parcelRequire("1yEFx");

var $7WbA8 = parcelRequire("7WbA8");

var $aRSt4 = parcelRequire("aRSt4");

var $83gV2 = parcelRequire("83gV2");

var $19BAV = parcelRequire("19BAV");

var $j4ply = parcelRequire("j4ply");

var $4VmlX = parcelRequire("4VmlX");

var $3SISy = parcelRequire("3SISy");
const $3cfecd681a6a1322$var$titleStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $3cfecd681a6a1322$var$confluenceIconContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    paddingInline: 'space.050',
    alignItems: 'end'
});
const $3cfecd681a6a1322$export$2b7ed2e07f16b196 = ({ state: state, onClick: onClick })=>{
    const intl = (0, $dBxQj.default)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const onResultClicked = (0, $gwFzn.useCallback)((event)=>{
        onClick({
            event: event,
            state: state,
            actionSubjectId: `${primaryProduct?.toLowerCase() || ''}AdvancedSearchLink`
        });
    }, [
        onClick,
        state,
        primaryProduct
    ]);
    const title = (0, $gwFzn.useMemo)(()=>{
        if (primaryProduct === 'confluence') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $3cfecd681a6a1322$var$titleStyles,
            children: intl.formatMessage((0, $3SISy.messages).filterByConfluence, {
                confluenceIcon: (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $3cfecd681a6a1322$var$confluenceIconContainerStyles,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
                        product: (0, $1yEFx.ProductKeys).Confluence,
                        size: "small"
                    })
                }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
                    product: (0, $1yEFx.ProductKeys).Confluence,
                    size: "small"
                })
            })
        });
        else if (primaryProduct === 'mercury') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $3cfecd681a6a1322$var$titleStyles,
            children: intl.formatMessage((0, $3SISy.messages).filterByMercury)
        });
        else return null;
    }, [
        primaryProduct,
        intl
    ]);
    const rightMetadata = (0, $gwFzn.useMemo)(()=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $19BAV.default), {
                    requiredMode: (0, $9vOy1.ApplicationModes).Rovo,
                    children: window.navigator.userAgent.includes('Mac') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ltx9b.CommandIcon), {}) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $e4RDM.ControlIcon), {})
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
            ]
        }), []);
    if (title === null) return null;
    const url = generateSearchUrl({
        ...queryParams,
        product: primaryProduct,
        text: quickFindQuery
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $83gV2.SearchFooter), {
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
            label: "" // Icon is only for display purposes and this footer button purpose is in the title
            ,
            color: "currentColor"
        }),
        title: title,
        rightMetadata: rightMetadata,
        url: url,
        onResultClicked: onResultClicked
    });
};

});
parcelRegister("e4RDM", function(module, exports) {

$parcel$export(module.exports, "ControlIcon", () => $cf009b9a2e935b27$export$1de95e9d7dda5112);
// Copied from packages/search/product-search-dialog/src/extensible/quick-find/icons/control-icon.tsx

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $cf009b9a2e935b27$var$IconContainer = (0, $gwrgp.default)("span", {
    target: "e1uibf2e0"
})({
    background: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`,
    height: "var(--ds-space-300, 24px)",
    borderRadius: "var(--ds-border-radius-400, 4px)",
    border: "'1px solid transparent'",
    color: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    display: 'flex',
    alignItems: 'center',
    padding: `0 ${"var(--ds-space-075, 6px)"}`
});
const $cf009b9a2e935b27$export$1de95e9d7dda5112 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($cf009b9a2e935b27$var$IconContainer, {
        children: "Ctrl"
    });

});

parcelRegister("3SISy", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1617c7a5c0a1c8ce$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $1617c7a5c0a1c8ce$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    filterByConfluence: {
        id: "search_dialog_filter_by_confluence",
        defaultMessage: "Filter by {confluenceIcon} Confluence spaces, contributors and more"
    },
    filterByMercury: {
        id: "search_dialog_filter_by_mercury",
        defaultMessage: "Filter by focus areas"
    }
});

});


parcelRegister("5BL1t", function(module, exports) {

$parcel$export(module.exports, "isErrorItem", () => $aed36fde90c7e426$export$6500cdbd153f3497);
$parcel$export(module.exports, "isLandingItem", () => $aed36fde90c7e426$export$6dc914a1cb2e7113);
$parcel$export(module.exports, "isNoResultsItem", () => $aed36fde90c7e426$export$993e95eb6704a94c);
$parcel$export(module.exports, "isHeadingItem", () => $aed36fde90c7e426$export$9050e45a166250f);
$parcel$export(module.exports, "isSkeletonItem", () => $aed36fde90c7e426$export$d680994c1f15882e);
$parcel$export(module.exports, "isRecentQueryItem", () => $aed36fde90c7e426$export$871ba967042323cb);
$parcel$export(module.exports, "isRecentActivityItem", () => $aed36fde90c7e426$export$329ac1434313f6b2);
$parcel$export(module.exports, "isSearchResultItem", () => $aed36fde90c7e426$export$746233dd1618793c);
$parcel$export(module.exports, "isPeopleAndTeamsItem", () => $aed36fde90c7e426$export$bc8d42212d76a15c);
const $aed36fde90c7e426$export$6500cdbd153f3497 = (item)=>{
    return item.type === 'error';
};
const $aed36fde90c7e426$export$6dc914a1cb2e7113 = (item)=>{
    return item.type === 'landing';
};
const $aed36fde90c7e426$export$993e95eb6704a94c = (item)=>{
    return item.type === 'no-results';
};
const $aed36fde90c7e426$export$9050e45a166250f = (item)=>{
    return item.type === 'heading';
};
const $aed36fde90c7e426$export$d680994c1f15882e = (item)=>{
    return item.type === 'skeleton';
};
const $aed36fde90c7e426$export$871ba967042323cb = (item)=>{
    return item.type === 'recent-query';
};
const $aed36fde90c7e426$export$329ac1434313f6b2 = (item)=>{
    return item.type === 'recent-activity';
};
const $aed36fde90c7e426$export$746233dd1618793c = (item)=>{
    return item.type === 'search-result';
};
const $aed36fde90c7e426$export$bc8d42212d76a15c = (item)=>{
    return item.type === 'people-and-teams';
};

});


parcelRegister("f8Fnp", function(module, exports) {

$parcel$export(module.exports, "SearchTextField", () => $33671f0d02952dbc$export$fb8d8fbc0c4c1705);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $4TXTZ = parcelRequire("4TXTZ");

var $1SV4e = parcelRequire("1SV4e");

var $icqFF = parcelRequire("icqFF");

var $9vOy1 = parcelRequire("9vOy1");

var $1yEFx = parcelRequire("1yEFx");

var $3R0ts = parcelRequire("3R0ts");

var $7WbA8 = parcelRequire("7WbA8");

var $hr2Qv = parcelRequire("hr2Qv");

var $2ok43 = parcelRequire("2ok43");

var $2vZke = parcelRequire("2vZke");

var $aE5mL = parcelRequire("aE5mL");

var $inrbX = parcelRequire("inrbX");

var $hvVqi = parcelRequire("hvVqi");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $4VmlX = parcelRequire("4VmlX");

var $kW291 = parcelRequire("kW291");

var $b8c3g = parcelRequire("b8c3g");
const $33671f0d02952dbc$export$fb8d8fbc0c4c1705 = ({ dialogId: dialogId, inputRef: inputRef, localQuery: localQuery, setLocalQuery: setLocalQuery, textfieldComponent: textfieldComponent, postQueryDisabled: postQueryDisabled })=>{
    const previousTextQueryParam = (0, $gwFzn.useRef)();
    const [mounted, setMounted] = (0, $gwFzn.useState)(false);
    const { generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, queryParams: queryParams, isNav4Enabled: isNav4Enabled, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $7WbA8.useAppContext)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const [{ primaryProduct: primaryProduct, user: user }] = (0, $j4ply.useBootstrap)();
    const content = (0, $4VmlX.useContent)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const keyboardHighlight = (0, $icqFF.useKeyboardHighlightProvider)();
    const getSelectedIndex = keyboardHighlight?.getSelectedIndex;
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const selectedQueryFilters = (0, $4VmlX.useSelectedQueryFilters)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const { setQuickFindOpen: setQuickFindOpen, resetSelectedQueryFilters: resetSelectedQueryFilters } = (0, $4VmlX.useQuickFindActions)();
    const { setQueryUpdatedTime: setQueryUpdatedTime, clearAllFilters: clearAllFilters, setInputQuery: setInputQuery } = (0, $djVCD.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const debouncedOnTextEnteredAnalyticsCallback = (0, $b8c3g.useDebouncedOnTextEnteredAnalyticsCallback)();
    (0, $2ok43.useInputSkeleton)({
        localQuery: localQuery,
        inputRef: inputRef
    });
    /**
	 * Handles the case when the input is hydrated after SSR. This effect
	 * retains the value, focus and cursor position of the input if the user
	 * started typing before hydration.
	 *
	 * If this component was not SSR'd, then the result of this effect
	 * is that the initial value is rendered only after the second render.
	 */ (0, $gwFzn.useEffect)(()=>{
        if (inputRef?.current) {
            if (inputRef.current.value) setLocalQuery(inputRef.current.value);
            const isFocused = document.activeElement === inputRef.current;
            const selectionStart = isFocused ? inputRef.current.selectionStart : null;
            const selectionEnd = isFocused ? inputRef.current.selectionEnd : null;
            if (isFocused) requestAnimationFrame(()=>{
                inputRef?.current?.focus();
                if (selectionStart !== null && selectionEnd !== null) inputRef?.current?.setSelectionRange(selectionStart, selectionEnd);
            });
        }
        setMounted(true);
    }, [
        inputRef,
        setLocalQuery
    ]);
    (0, $kW291.useQueryFilters)(localQuery, postQueryDisabled);
    // Only when the text query param changes, update the local query. If the
    // local query without selected query filters is the same as text query param,
    // do nothing.
    (0, $gwFzn.useEffect)(()=>{
        if (queryParams.text === previousTextQueryParam.current) return;
        previousTextQueryParam.current = queryParams.text;
        const localQueryWithoutSelectedQueryFilters = (0, $hvVqi.getQueryWithoutSelectedQueryFilters)(localQuery, selectedQueryFilters);
        const newLocalQuery = typeof queryParams.text === 'string' ? queryParams.text : '';
        if (localQueryWithoutSelectedQueryFilters !== newLocalQuery) {
            setInputQuery(newLocalQuery);
            setLocalQuery(newLocalQuery);
            clearAllFilters();
            resetSelectedQueryFilters();
        }
    }, [
        clearAllFilters,
        queryParams.text,
        resetSelectedQueryFilters,
        selectedQueryFilters,
        setLocalQuery,
        localQuery,
        setInputQuery
    ]);
    // Update query time when query changes
    (0, $gwFzn.useEffect)(()=>{
        setQueryUpdatedTime();
    }, [
        setQueryUpdatedTime,
        localQuery
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (quickFindOpen) inputRef?.current?.focus();
        else inputRef?.current?.blur();
    }, [
        inputRef,
        quickFindOpen
    ]);
    const onKeyDown = (0, $gwFzn.useCallback)((event)=>{
        /**
			 * Ignore enter key press if a search result is highlighted as we let
			 * the keyboard highlight provider handle the event in this case.
			 */ const resultHighlighted = getSelectedIndex && getSelectedIndex() !== undefined;
        if (event.key === 'Enter' && !resultHighlighted) {
            if (!primaryProduct) return;
            /**
				 * Stop the event from propagating to prevent UFO
				 * VC90 metric from being cancelled on route change.
				 */ event.stopPropagation();
            // Store search in recent searches
            if (quickFindQuery.trim() !== '' && user && user.id && primaryProduct) {
                (0, $1SV4e.addRecentSearch)(quickFindQuery.trim(), user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
                updateRecentQueries?.();
            }
            event.currentTarget.blur();
            setQuickFindOpen(false);
            fireAnalyticsEvent((0, $2vZke.onAdvancedSearchLinkSelected)({
                actionSubjectId: `${primaryProduct.toLowerCase()}AdvancedSearchLink`,
                attributes: {
                    ...commonAttributes,
                    trigger: 'return',
                    newTab: false,
                    isLoading: content?.state === (0, $aE5mL.State).PREQUERY_LOADING || content?.state === (0, $aE5mL.State).POSTQUERY_LOADING
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
            const searchForPrimaryProduct = !selectedProduct && (applicationMode === (0, $9vOy1.ApplicationModes).Rovo && (event.metaKey || event.ctrlKey) || applicationMode !== (0, $9vOy1.ApplicationModes).Rovo && !(event.metaKey || event.ctrlKey));
            if ((0, $dh538.fg)('quick_find_filters')) // TODO: This is a temporary measure until we do QS-6716 post Team 25 where it syncs filters with FPS.
            // For now, executing a search query on FPS search will always clear the filters in QF as FPS filters
            // is the source of truth for filter state.
            clearAllFilters();
            if ((0, $dh538.fg)('quick_find_metrics_using_ufo_react')) (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), event.timeStamp);
            const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
            onNavigateCallback(generateSearchUrl({
                ...queryParams,
                product: searchForPrimaryProduct ? primaryProduct : undefined,
                text: quickFindQuery
            }, !!(primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira && (event.metaKey || event.ctrlKey))), 'push');
        }
        if (event.key === 'Escape') {
            event.currentTarget.blur();
            setQuickFindOpen(false);
            if ((0, $dh538.fg)('quick_find_metrics_using_ufo_react')) (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), event.timeStamp);
        }
    }, [
        getSelectedIndex,
        primaryProduct,
        quickFindQuery,
        user,
        setQuickFindOpen,
        fireAnalyticsEvent,
        commonAttributes,
        content?.state,
        nonPrivacySafeAttributes,
        selectedProduct,
        applicationMode,
        clearAllFilters,
        onNavigate,
        generateSearchUrl,
        queryParams,
        updateRecentQueries
    ]);
    const onChange = (0, $gwFzn.useCallback)((event)=>{
        const newQuery = event.currentTarget.value;
        setLocalQuery(newQuery);
        debouncedOnTextEnteredAnalyticsCallback();
    }, [
        debouncedOnTextEnteredAnalyticsCallback,
        setLocalQuery
    ]);
    const onFocus = (0, $gwFzn.useCallback)((event)=>{
        setQuickFindOpen(true);
        if ((0, $dh538.fg)('quick_find_metrics_using_ufo_react')) {
            if (!quickFindOpen) (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_OPEN_INTERACTION), event.timeStamp);
        }
    }, [
        setQuickFindOpen,
        quickFindOpen
    ]);
    const Textfield = textfieldComponent || (0, $hr2Qv.Textfield);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Textfield, {
        value: mounted ? localQuery : undefined,
        dialogId: dialogId,
        inputRef: inputRef,
        appMode: applicationMode,
        quickFindOpen: quickFindOpen,
        isNav4Enabled: isNav4Enabled,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onChange: onChange,
        onClear: ()=>{
            setLocalQuery('');
            inputRef?.current?.focus();
        }
    });
};

});
parcelRegister("kW291", function(module, exports) {

$parcel$export(module.exports, "useQueryFilters", () => $908389ef2c25a547$export$d3538183feb90c1a);

var $gwFzn = parcelRequire("gwFzn");

var $fVdiF = parcelRequire("fVdiF");

var $hvVqi = parcelRequire("hvVqi");

var $4VmlX = parcelRequire("4VmlX");
const $908389ef2c25a547$export$d3538183feb90c1a = (localQuery, postQueryDisabled)=>{
    const filterKeywordToFilterId = (0, $hvVqi.useFilterKeywordToFilterId)();
    const filterKeywordToFilterActions = (0, $hvVqi.useFilterKeywordToFilterActions)();
    const selectedQueryFilters = (0, $4VmlX.useSelectedQueryFilters)();
    const { setQuickFindQuery: setQuickFindQuery, deleteSelectedQueryFilter: deleteSelectedQueryFilter, setCurrentQueryFilter: setCurrentQueryFilter } = (0, $4VmlX.useQuickFindActions)();
    const [debouncedSetLookupInput, cancelDebouncedSetLookupInput] = (0, $fVdiF.default)((lookupInput, setLookupInput)=>{
        setLookupInput(lookupInput);
    }, 300);
    (0, $gwFzn.useEffect)(()=>{
        const queryWithoutSelectedQueryFilters = (0, $hvVqi.getQueryWithoutSelectedQueryFilters)(localQuery, selectedQueryFilters);
        const trimmedQuery = queryWithoutSelectedQueryFilters.trim();
        setQuickFindQuery(trimmedQuery);
    }, [
        localQuery,
        selectedQueryFilters,
        setQuickFindQuery
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (postQueryDisabled) return;
        // Deselect select query filters if their display text is no longer in the query
        for (const selectedQueryFilter of selectedQueryFilters)if (!localQuery.includes(selectedQueryFilter.displayText)) {
            const filterActions = filterKeywordToFilterActions[selectedQueryFilter.keyword];
            if (filterActions && selectedQueryFilter.option) {
                filterActions.setOption({
                    ...selectedQueryFilter.option,
                    isSelected: true
                });
                deleteSelectedQueryFilter(selectedQueryFilter);
            }
        }
        // To determine if a user is accessing a query filter, we use the query without
        // selected query filters to allow for multiple query filters to be used at once
        const queryWithoutSelectedQueryFilters = (0, $hvVqi.getQueryWithoutSelectedQueryFilters)(localQuery, selectedQueryFilters);
        // Determine if the user is using a query filter
        const filterKeywords = Object.keys(filterKeywordToFilterId);
        const keyword = (0, $hvVqi.findQueryFilterKeyword)(queryWithoutSelectedQueryFilters, filterKeywords);
        // Reset current query filter if keyword is not found
        if (!keyword) {
            cancelDebouncedSetLookupInput();
            setCurrentQueryFilter(undefined);
            return;
        }
        // Get the filter id and actioins for the filter corresponding to the keyword
        const filterId = filterKeywordToFilterId[keyword];
        const filterActions = filterKeywordToFilterActions[keyword];
        const filterLookupQuery = (0, $hvVqi.getFilterLookupQuery)(queryWithoutSelectedQueryFilters, keyword);
        // Load the options for the filter
        if (filterId && filterActions && filterLookupQuery !== undefined) {
            setCurrentQueryFilter({
                filterId: filterId,
                keyword: keyword
            });
            cancelDebouncedSetLookupInput();
            if (filterLookupQuery === '') {
                filterActions.loadInitialOptions();
                filterActions.setLookupInput('');
            } else debouncedSetLookupInput(filterLookupQuery, filterActions.setLookupInput);
        }
    }, [
        selectedQueryFilters,
        filterKeywordToFilterId,
        filterKeywordToFilterActions,
        deleteSelectedQueryFilter,
        setCurrentQueryFilter,
        localQuery,
        cancelDebouncedSetLookupInput,
        debouncedSetLookupInput,
        postQueryDisabled
    ]);
};

});

parcelRegister("b8c3g", function(module, exports) {

$parcel$export(module.exports, "useDebouncedOnTextEnteredAnalyticsCallback", () => $9fa79de2eb008d7c$export$fe11394d33dcb3dd);

var $gwFzn = parcelRequire("gwFzn");

var $ioxS0 = parcelRequire("ioxS0");

var $JQd0k = parcelRequire("JQd0k");

var $inrbX = parcelRequire("inrbX");

var $4VmlX = parcelRequire("4VmlX");
const $9fa79de2eb008d7c$var$ON_TEXT_ENTERED_ANALYTICS_DEBOUNCE_TIME = 300;
const $9fa79de2eb008d7c$export$fe11394d33dcb3dd = ()=>{
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const fireOnTextEnteredAnalyticsCallback = (0, $gwFzn.useCallback)(()=>{
        if (!quickFindOpen) return;
        fireAnalyticsEvent((0, $ioxS0.onTextEntered)({
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes,
        quickFindOpen
    ]);
    return (0, $JQd0k.useDebouncedCallback)(fireOnTextEnteredAnalyticsCallback, $9fa79de2eb008d7c$var$ON_TEXT_ENTERED_ANALYTICS_DEBOUNCE_TIME);
};

});
parcelRegister("ioxS0", function(module, exports) {

$parcel$export(module.exports, "onTextEntered", () => $4af3204510a58241$export$db28d8e16fb16e80);
const $4af3204510a58241$export$db28d8e16fb16e80 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'entered',
        actionSubject: 'text',
        actionSubjectId: 'searchDialogTextField',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});



parcelRegister("jQSTy", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", () => $00b97e1dc9e8581d$export$92dae2778ae88f9d);

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $dh538 = parcelRequire("dh538");

var $4nUpd = parcelRequire("4nUpd");

var $4TXTZ = parcelRequire("4TXTZ");

var $3R0ts = parcelRequire("3R0ts");

var $4VmlX = parcelRequire("4VmlX");
const $00b97e1dc9e8581d$export$92dae2778ae88f9d = ({ dialogRef: dialogRef, inputBoxRef: inputBoxRef })=>{
    const mouseDownInside = (0, $gwFzn.useRef)(false);
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const [isFeedbackModalOpen] = (0, $4VmlX.useIsFeedbackModalOpen)();
    const [isBulkConnectModalOpen] = (0, $4VmlX.useIsBulkConnectModalOpen)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    (0, $gwFzn.useEffect)(()=>{
        const onMouseDown = (event)=>{
            mouseDownInside.current = false;
            const { target: target } = event;
            const targetNode = target;
            const isClickOnPopup = dialogRef.current && dialogRef.current.contains(targetNode);
            const isClickOnTrigger = inputBoxRef.current && inputBoxRef.current.contains(targetNode);
            if (isClickOnPopup || isClickOnTrigger) mouseDownInside.current = true;
        };
        const onClick = (event)=>{
            const { target: target } = event;
            const targetNode = target;
            if (isFeedbackModalOpen) return;
            if (isBulkConnectModalOpen && (0, $dh538.fg)('3p_bulk_connect')) return;
            const isClickOnPopup = dialogRef.current && dialogRef.current.contains(targetNode);
            const isClickOnTrigger = inputBoxRef.current && inputBoxRef.current.contains(targetNode);
            if (!isClickOnPopup && !isClickOnTrigger && !mouseDownInside.current) {
                setQuickFindOpen(false);
                if ((0, $dh538.fg)('quick_find_metrics_using_ufo_react')) {
                    if (quickFindOpen) (0, $4nUpd.default)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), event);
                }
            }
        };
        const onKeyDown = (event)=>{
            const { key: key } = event;
            if (key === 'Escape' || key === 'Esc') {
                setQuickFindOpen(false);
                if ((0, $dh538.fg)('quick_find_metrics_using_ufo_react')) {
                    if (quickFindOpen) (0, $4nUpd.default)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), event);
                }
            }
        };
        const onBlur = (e)=>{
            const activeElement = document.activeElement;
            const activeElementIsIFrame = activeElement instanceof HTMLIFrameElement;
            // Close Quick Find if the new active element is an iframe, we need
            // to do this check since click events are not fired on iframes
            if (activeElementIsIFrame) {
                setQuickFindOpen(false);
                if ((0, $dh538.fg)('quick_find_metrics_using_ufo_react')) {
                    if (quickFindOpen) (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), performance.now());
                }
            }
        };
        const unbind = (0, $d8F95.bindAll)(window, [
            {
                type: 'mousedown',
                listener: onMouseDown,
                options: {
                    capture: false
                }
            },
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: true
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'blur',
                listener: onBlur
            }
        ]);
        return ()=>{
            unbind();
        };
    }, [
        setQuickFindOpen,
        isFeedbackModalOpen,
        isBulkConnectModalOpen,
        quickFindOpen,
        dialogRef,
        inputBoxRef
    ]);
};

});
parcelRegister("4nUpd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d262149e5e5b88f$export$2e2bcd8739ae039);

var $9HkI0 = parcelRequire("9HkI0");

var $1haRI = parcelRequire("1haRI");

var $53d5Q = parcelRequire("53d5Q");

var $feexy = parcelRequire("feexy");

var $4u5NT = parcelRequire("4u5NT");

var $ic4nn = parcelRequire("ic4nn");
function $3d262149e5e5b88f$var$mapToInteractionType(eventType) {
    if (eventType === 'click' || eventType === 'dblclick' || eventType === 'mousedown') return 'press';
    if (eventType === 'mouseenter' || eventType === 'mouseover') return 'hover';
    return undefined;
}
function $3d262149e5e5b88f$var$traceUFOInteraction(name, event) {
    if (!event || !event.isTrusted) return;
    const interactionType = $3d262149e5e5b88f$var$mapToInteractionType(event.type);
    if (!interactionType) // when interactionType is falsy we do not yet support this type of event. should we blow up with throwing error instead?
    return;
    const rate = (0, $53d5Q.getInteractionRate)(name, interactionType);
    const pressInteractionsList = (0, $53d5Q.getDoNotAbortActivePressInteraction)();
    if (pressInteractionsList?.includes(name)) {
        const interaction = (0, $4u5NT.getActiveInteraction)();
        if (interaction?.ufoName !== 'unknown' && interaction?.type === 'press') return;
    }
    if ((0, $1haRI.default)(rate)) {
        (0, $4u5NT.abortAll)('new_interaction', name);
        const startTimestamp = event.timeStamp ?? performance.now();
        const newId = (0, $9HkI0.v4)();
        (0, $feexy.DefaultInteractionID).current = newId;
        (0, $4u5NT.addNewInteraction)(newId, name, 'press', startTimestamp, rate, [], (0, $ic4nn.default).current);
    }
}
var $3d262149e5e5b88f$export$2e2bcd8739ae039 = $3d262149e5e5b88f$var$traceUFOInteraction;

});


parcelRegister("j5QtW", function(module, exports) {

$parcel$export(module.exports, "usePreQueryDwellTimeAnalytics", () => $37f7a1f5b4662dd4$export$20260e4d2b6c9d50);

var $gwFzn = parcelRequire("gwFzn");

var $7WbA8 = parcelRequire("7WbA8");

var $2ok43 = parcelRequire("2ok43");

var $bfgmu = parcelRequire("bfgmu");

var $g9TqG = parcelRequire("g9TqG");

var $inrbX = parcelRequire("inrbX");

var $4VmlX = parcelRequire("4VmlX");
const $37f7a1f5b4662dd4$export$20260e4d2b6c9d50 = ()=>{
    const { queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const hadInitialQuery = (0, $gwFzn.useRef)(Boolean((0, $2ok43.getInitialQuery)() || queryParams.text));
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { start: startTimer, stop: stopTimer, cancel: cancelTimer } = (0, $g9TqG.useTimer)({
        onTimerEnd: (ms)=>fireAnalyticsEvent((0, $bfgmu.onPreQueryDwelled)({
                attributes: {
                    ...commonAttributes,
                    duration: ms
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }))
    });
    // Analytics to track the first transition from pre-query to post-query
    (0, $gwFzn.useEffect)(()=>{
        // Do nothing if the page loaded with a query
        if (hadInitialQuery.current) return;
        // Start the timer when the dialog is opened
        if (quickFindOpen) startTimer();
        // Cancel the timer when the dialog is closed
        if (!quickFindOpen) cancelTimer(); // no-ops if the timer hasn't started or has already finished
        // Stop the timer when the user starts typing
        if (quickFindQuery) stopTimer();
    }, [
        cancelTimer,
        quickFindOpen,
        quickFindQuery,
        startTimer,
        stopTimer
    ]);
};

});
parcelRegister("bfgmu", function(module, exports) {

$parcel$export(module.exports, "onPreQueryDwelled", () => $b7759cf22d019191$export$24139682747f5c4);
const $b7759cf22d019191$export$24139682747f5c4 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'dwelled',
        actionSubject: 'searchResults',
        actionSubjectId: 'preQuerySearchResults',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("g9TqG", function(module, exports) {

$parcel$export(module.exports, "useTimer", () => $aca2bc20d4823d2b$export$632123ff591ac565);

var $gwFzn = parcelRequire("gwFzn");
function $aca2bc20d4823d2b$export$632123ff591ac565({ onTimerEnd: onTimerEnd }) {
    const [timer, setTimer] = (0, $gwFzn.useState)({
        status: 'idle'
    });
    const start = (0, $gwFzn.useCallback)(()=>{
        setTimer((state)=>{
            if (state.status !== 'idle') return state;
            return {
                ...state,
                startTime: new Date(),
                status: 'running'
            };
        });
    }, []);
    const stop = (0, $gwFzn.useCallback)(()=>{
        setTimer((state)=>{
            if (state.status !== 'running') return state;
            const end = new Date().getTime() - (timer.startTime?.getTime() ?? 0);
            onTimerEnd?.(end);
            return {
                ...state,
                endTime: new Date(),
                milliseconds: end,
                status: 'finished'
            };
        });
    }, [
        onTimerEnd,
        timer.startTime
    ]);
    const cancel = (0, $gwFzn.useCallback)(()=>{
        setTimer((state)=>{
            if (state.status !== 'running') return state;
            return {
                ...state,
                status: 'cancelled'
            };
        });
    }, []);
    return {
        start: start,
        stop: stop,
        cancel: cancel,
        status: timer.status,
        milliseconds: timer.milliseconds
    };
}

});


parcelRegister("57tKZ", function(module, exports) {

$parcel$export(module.exports, "useSyncStates", () => $64ab60c9a8f30827$export$29d6913fc893cfe8);

var $gwFzn = parcelRequire("gwFzn");
function $64ab60c9a8f30827$export$29d6913fc893cfe8(stateA, setStateA, stateB, setStateB) {
    const prevA = (0, $gwFzn.useRef)();
    const prevB = (0, $gwFzn.useRef)();
    (0, $gwFzn.useEffect)(()=>{
        // Do nothing if any of the arguments are undefined
        if (stateA === undefined || setStateA === undefined || stateB === undefined || setStateB === undefined) return;
        // On mount, use stateA as the source of truth
        if (prevA.current === undefined && prevB.current === undefined) {
            prevA.current = stateA;
            prevB.current = stateA;
            setStateB(stateA);
            return;
        }
        // If updates to both states are updated to the same value in the
        // same render cycle, ensure previous values are updated
        if (stateA === stateB) {
            prevA.current = stateA;
            prevB.current = stateB;
            return;
        }
        // If stateA has changed, update stateB to match
        if (prevA.current !== stateA) {
            prevA.current = stateA;
            prevB.current = stateA;
            setStateB(stateA);
            // Exit here as only one state should be updated, otherwise an infinite
            // loop will occur. This means that stateA takes precedence if both
            // states are changed in the same render cycle.
            return;
        }
        // If stateB has changed, update stateA to match
        if (prevB.current !== stateB) {
            prevA.current = stateB;
            prevB.current = stateB;
            setStateA(stateB);
        }
    }, [
        setStateA,
        setStateB,
        stateA,
        stateB
    ]);
}

});




parcelRegister("7Fvok", function(module, exports) {

$parcel$export(module.exports, "ExtensibleCrossProductSearchDialog", () => $8a27c616de5aba0e$export$c89d6fd97d04eec5);

var $gwFzn = parcelRequire("gwFzn");

var $jtVoy = parcelRequire("jtVoy");
var $5wbh9 = parcelRequire("5wbh9");
var $fx9tH = parcelRequire("fx9tH");
var $gHaio = parcelRequire("gHaio");
var $4jHJP = parcelRequire("4jHJP");
var $4d43O = parcelRequire("4d43O");
var $k19N9 = parcelRequire("k19N9");
var $2evZZ = parcelRequire("2evZZ");
var $29ccb = parcelRequire("29ccb");
var $2WIYs = parcelRequire("2WIYs");
var $80L9g = parcelRequire("80L9g");

var $gz8ZY = parcelRequire("gz8ZY");

var $9oxdN = parcelRequire("9oxdN");

var $jlIaF = parcelRequire("jlIaF");

var $bQm3c = parcelRequire("bQm3c");

var $kDja4 = parcelRequire("kDja4");

var $gXsSh = parcelRequire("gXsSh");

var $yuLaV = parcelRequire("yuLaV");

var $4pEo5 = parcelRequire("4pEo5");

var $5bPOK = parcelRequire("5bPOK");

var $2VPmd = parcelRequire("2VPmd");

var $bB6dC = parcelRequire("bB6dC");

var $1mK5P = parcelRequire("1mK5P");

var $2qgZ5 = parcelRequire("2qgZ5");

var $4XEM3 = parcelRequire("4XEM3");

var $5jHnK = parcelRequire("5jHnK");
const $8a27c616de5aba0e$var$TOWNSQUARE_SMARTS_PRODUCT_IDENTIFIER = 'watermelon';
const $8a27c616de5aba0e$var$COMPASS_PRODUCT_IDENTIFIER = 'compass';
const $8a27c616de5aba0e$var$AI_SEARCH_PREQUERY_BANNER_MESSAGE_ID = 'confluence.frontend.search.sain.prequery.banner.message';
const $8a27c616de5aba0e$export$c89d6fd97d04eec5 = (0, $gXsSh.withRoutesContext)((props)=>{
    const { cloudId: cloudId, aggregatorUrl: aggregatorUrl, formatDate: formatDate, isExpanded: isExpanded, forwardRef: forwardRef, linkComponent: linkComponent, onNavigate: onNavigate, onNavigateSecondary: onNavigateSecondary, setIsExpanded: setIsExpanded, theme: theme, user: user, features: { jiraFeatures: jiraFeatures, interactiveSkeleton: interactiveSkeleton }, clearStickySearchRef: clearStickySearchRef, shouldFillContainer: shouldFillContainer, getQueryParams: getQueryParams } = props;
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { edition: edition, userId: userId, orgId: orgId, locale: locale } = (0, $bQm3c.useSessionData)();
    const [showPrequeryBanner, setShowPrequeryBanner] = (0, $gwFzn.useState)(false);
    const [prequeryBannerEligible, prequeryBannerDismissed, prequeryBannerError] = (0, $9oxdN.useFeatureDiscovery)($8a27c616de5aba0e$var$AI_SEARCH_PREQUERY_BANNER_MESSAGE_ID);
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isQuickSearchForWhiteboardsEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const isQuickSearchForDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const autocorrectEnabled = locale.split('-')[0] === 'en';
    const [quickFindEnabled] = (0, $5bPOK.useQuickFindEnabled)();
    const objectTypes = [
        (0, $bB6dC.ActivitiesObjectType).PAGE,
        (0, $bB6dC.ActivitiesObjectType).BLOGPOST,
        (0, $bB6dC.ActivitiesObjectType).EMBED,
        ...isQuickSearchForWhiteboardsEnabled ? [
            (0, $bB6dC.ActivitiesObjectType).WHITEBOARD
        ] : [],
        ...isQuickSearchForDatabasesEnabled ? [
            (0, $bB6dC.ActivitiesObjectType).DATABASE
        ] : []
    ];
    const { experimentLayers: experimentLayers, productEdition: productEdition, ...confluenceSuppliers } = (0, $2qgZ5.useConfluenceItemSuppliers)({
        cloudId: cloudId,
        userId: userId,
        principalId: userId || undefined,
        formatDate: formatDate,
        autocorrectEnabled: autocorrectEnabled,
        isQuickSearchForWhiteboardsEnabled: isQuickSearchForWhiteboardsEnabled,
        isQuickSearchForDatabasesEnabled: isQuickSearchForDatabasesEnabled,
        objectTypes: objectTypes
    });
    const dismissPrequeryBanner = ()=>{
        setShowPrequeryBanner(false);
        prequeryBannerDismissed();
    };
    const { aiSearchConfig: aiSearchConfig } = (0, $1mK5P.useAISearchSupplier)({
        prequeryBannerEnabled: showPrequeryBanner,
        dismissPrequeryBanner: dismissPrequeryBanner
    });
    (0, $gwFzn.useEffect)(()=>{
        if (prequeryBannerEligible && !prequeryBannerError) setShowPrequeryBanner(true);
    }, [
        prequeryBannerEligible,
        prequeryBannerError
    ]);
    const onNavigateMultiProduct = (id, href)=>{
        const navigationCallback = id === 'confluence' ? onNavigate : onNavigateSecondary;
        navigationCallback(href);
    };
    const { contentScope: contentScope, extensibleScopes: extensibleScopes } = (0, $4XEM3.useConfluenceScopes)({
        isQuickSearchForWhiteboardsEnabled: isQuickSearchForWhiteboardsEnabled,
        isQuickSearchForDatabasesEnabled: isQuickSearchForDatabasesEnabled
    });
    const queryParams = getQueryParams();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $80L9g.UserInputContextProvider), {
        stickySearchEnabled: true,
        isExpanded: isExpanded,
        resetStickySearchRef: clearStickySearchRef
    }, quickFindEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4pEo5.ConfluenceQuickFind), {
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        theme: theme,
        user: user,
        forwardRef: forwardRef,
        onNavigateGeneric: onNavigateMultiProduct,
        cloudId: cloudId,
        orgId: orgId,
        aggregatorUrl: aggregatorUrl,
        formatDate: formatDate,
        linkComponent: linkComponent,
        shouldFillContainer: shouldFillContainer,
        isRovoEnabled: quickFindEnabled,
        isGriffinNavEnabled: isNav4Enabled,
        queryParams: queryParams
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4d43O.FilterContextProvider), {
        isEnabled: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fx9tH.FilterContextProvider), {
        isEnabled: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5jHnK.ExperimentLayersAnalyticsListener), {
        experimentLayers: experimentLayers,
        productEdition: productEdition
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $k19N9.MultiProductDialog), {
        aiSearchConfig: aiSearchConfig,
        aggregatorUrl: aggregatorUrl,
        abTestCloudId: cloudId,
        orgId: orgId,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        theme: theme,
        user: user,
        forwardRef: forwardRef,
        onNavigateGeneric: onNavigateMultiProduct,
        dialogFeatures: {
            interactiveSkeleton: interactiveSkeleton,
            isGriffinNavEnabled: isNav4Enabled
        },
        edition: edition?.toString(),
        shouldFillContainer: shouldFillContainer,
        queryParams: queryParams
    }, ({ onRetry: onRetry })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            role: "tabpanel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gHaio.ExtensibleConfluenceTab), {
            order: 0,
            linkComponent: linkComponent,
            formatDate: formatDate,
            onRetry: onRetry,
            permissionSupplier: ()=>Promise.resolve(extensibleScopes),
            ...confluenceSuppliers,
            isPrefetchingEnabled: true,
            recentClientConfig: {
                url: (0, $jlIaF.CONTEXT_PATH),
                cloudId: cloudId,
                isUserAnonymous: !userId,
                isCollaborationGraphEnabled: false,
                collaborationGraphUrl: '/gateway/api/collaboration'
            },
            autocorrectEnabled: autocorrectEnabled,
            additionalContentTypesEnabled: true,
            aiSearchConfig: aiSearchConfig,
            rendererOverride: {
                ConfluenceResultRenderer: $2VPmd.ConfluenceResultRenderer,
                contentScope: contentScope
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jHJP.ExtensibleJiraTab), {
            order: 1,
            formatDate: formatDate,
            onRetry: onRetry,
            features: jiraFeatures
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jtVoy.BitbucketTab), {
            order: 2,
            onRetry: onRetry,
            features: {
                enableSingleScopesCall: true
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2evZZ.OpsgenieTab), {
            order: 3,
            onRetry: onRetry,
            cloudId: cloudId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $29ccb.TownsquareTab), {
            order: 4,
            onRetry: onRetry,
            userTeamConfig: {
                context: {
                    contextType: 'filter',
                    organizationId: orgId,
                    principalId: 'Context',
                    productKey: $8a27c616de5aba0e$var$TOWNSQUARE_SMARTS_PRODUCT_IDENTIFIER,
                    siteId: cloudId
                }
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2WIYs.TrelloTab), {
            order: 5,
            onRetry: onRetry
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5wbh9.CompassTab), {
            sourceContext: "confluence",
            isUserAnonymous: !userId,
            order: 6,
            onRetry: onRetry,
            userTeamConfig: {
                context: {
                    contextType: 'CompassFilter',
                    organizationId: orgId,
                    principalId: 'Context',
                    productKey: $8a27c616de5aba0e$var$COMPASS_PRODUCT_IDENTIFIER,
                    siteId: cloudId
                }
            }
        })))))));
});

});
parcelRegister("jtVoy", function(module, exports) {

$parcel$export(module.exports, "BitbucketTab", () => $3cc71055164da496$export$a83467d99f696187);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $crAJ1 = parcelRequire("crAJ1");

var $5CiaV = parcelRequire("5CiaV");

var $bqoDl = parcelRequire("bqoDl");

var $bF0iL = parcelRequire("bF0iL");

var $4V3UW = parcelRequire("4V3UW");

var $a5cba = parcelRequire("a5cba");
var $fJRVo = parcelRequire("fJRVo");

var $85AiF = parcelRequire("85AiF");

var $it4Xp = parcelRequire("it4Xp");

var $cPiQS = parcelRequire("cPiQS");

var $eztGN = parcelRequire("eztGN");

var $3Z7LN = parcelRequire("3Z7LN");

var $iEwUU = parcelRequire("iEwUU");

var $kmpep = parcelRequire("kmpep");
const $3cc71055164da496$var$mapAggregatorResponseToSearchItem = (repo)=>{
    return {
        title: repo.name,
        id: repo.uuid,
        meta: repo.workspace.name,
        url: repo.links.html.href,
        iconUrl: repo.links.avatar.href,
        containerId: repo.workspace.uuid
    };
};
const $3cc71055164da496$export$9d75ef492044e493 = ({ intl: intl, viewAllLinkGenerator: overriddenViewAllLinkGenerator, codeSearchUrlGenerator: overriddenCodeSearchUrlGenerator, codeSearchContextualUrlGenerator: overriddenCodeSearchContextualUrlGenerator, urlGeneratorForNoResultsScreen: overriddenUrlGeneratorForNoResultsScreen, permissionSupplier: overriddenPermissionsSupplier, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, currentContext: currentContext, features: features, ...rest })=>{
    const { viewAllLinkGenerator: viewAllLinkGenerator, codeSearchUrlGenerator: codeSearchUrlGenerator, codeSearchContextualUrlGenerator: codeSearchContextualUrlGenerator, urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen } = (0, $gwFzn.useMemo)(()=>{
        return (0, $cPiQS.bitbucketURLGenerators)({
            viewAllLinkGenerator: overriddenViewAllLinkGenerator,
            codeSearchUrlGenerator: overriddenCodeSearchUrlGenerator,
            codeSearchContextualUrlGenerator: overriddenCodeSearchContextualUrlGenerator,
            urlGeneratorForNoResultsScreen: overriddenUrlGeneratorForNoResultsScreen
        });
    }, [
        overriddenCodeSearchUrlGenerator,
        overriddenCodeSearchContextualUrlGenerator,
        overriddenUrlGeneratorForNoResultsScreen,
        overriddenViewAllLinkGenerator
    ]);
    const sections = [
        {
            id: (0, $it4Xp.BitbucketScope).BitbucketRepostitory,
            title: intl.formatMessage((0, $bqoDl.messages).bitbucket_repository_heading),
            scope: (0, $it4Xp.BitbucketScope).BitbucketRepostitory,
            showResultCount: true,
            viewAllLinkGenerator: viewAllLinkGenerator,
            resultMapper: ({ results: results })=>results.map((value)=>$3cc71055164da496$var$mapAggregatorResponseToSearchItem(value))
        }
    ];
    const itemSuppliers = (0, $5CiaV.useDefaultSuppliers)((0, $it4Xp.BITBUCKET_PRODUCT_ID), sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    const permissionSupplier = (0, $85AiF.useBitbucketPermissionSupplier)(overriddenPermissionsSupplier);
    const formattedSearchForCodeLabel = (context)=>{
        const { repository: repository, workspace: workspace } = context || {};
        let source = 'Bitbucket';
        if (repository) source = repository.name;
        else if (workspace) source = workspace.name;
        return intl.formatMessage((0, $bqoDl.messages).bitbucket_advanced_search, {
            source: source
        });
    };
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $gwFzn.useCallback)((query, _, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $3Z7LN.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return viewAllLinkGenerator(query);
    }, [
        viewAllLinkGenerator,
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5cba.SearchDialogProduct), {
        expandedStateInputPlaceholder: intl.formatMessage((0, $bqoDl.messages).bitbucket_expanded_input_placeholder),
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        id: (0, $it4Xp.BITBUCKET_PRODUCT_ID),
        permissionSupplier: permissionSupplier,
        preQuerySectionTitleGenerator: (section)=>section.id === (0, $it4Xp.BitbucketScope).BitbucketRepostitory ? intl.formatMessage((0, $bqoDl.messages).bitbucket_recent_repositories) : '',
        sections: sections,
        title: intl.formatMessage((0, $bF0iL.messages).bitbucket_tab_label),
        urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
        ...rest,
        ...itemSuppliers,
        children: ({ linkComponent: linkComponent, query: query })=>{
            const codeSearchUrl = currentContext ? codeSearchContextualUrlGenerator(query, currentContext) : codeSearchUrlGenerator(query);
            const contextualSearchMessage = formattedSearchForCodeLabel(currentContext);
            return {
                Header: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4V3UW.AdvancedSearch), {
                        advancedSearchMessage: contextualSearchMessage,
                        advancedSearchUrl: codeSearchUrl,
                        linkComponent: linkComponent
                    }),
                Footer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                        children: showAtlassianHomeSearchLink && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Z7LN.AtlassianHomeSearchLink), {
                                orgId: orgId,
                                cloudId: cloudId,
                                showModifierIcon: true
                            })
                        })
                    })
            };
        }
    });
};
const $3cc71055164da496$export$a83467d99f696187 = (0, $js7oX.default)($3cc71055164da496$export$9d75ef492044e493);

});
parcelRegister("crAJ1", function(module, exports) {

$parcel$export(module.exports, "SearchFooter", () => $307b1644cf276a47$export$64ded8b71dfcba9e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $307b1644cf276a47$export$64ded8b71dfcba9e = (0, $gwrgp.default)("div", {
    target: "e1jzvw2y0"
})({
    width: '100%',
    height: `${"var(--ds-space-600, 48px)"}`,
    borderTop: `1px solid ${`var(--ds-border, ${(0, $6fnsQ.N40A)})`}`
});

});

parcelRegister("5CiaV", function(module, exports) {

$parcel$export(module.exports, "useDefaultSuppliers", () => $029554683ea761ec$export$967ff0f6c3886589);

var $gJKpQ = parcelRequire("gJKpQ");

var $4ldrV = parcelRequire("4ldrV");

var $kmpep = parcelRequire("kmpep");

var $88j1D = parcelRequire("88j1D");

var $fJRVo = parcelRequire("fJRVo");
const $029554683ea761ec$var$MAX_DEFAULT_SITES = 3;
const $029554683ea761ec$export$dc64f87f5460b276 = (aggregatorClient, sections, context, experience, sourceProduct)=>async ({ query: query, filters: allFilters, workspaces: workspaces, sectionIds: allPermissionedScopes })=>{
        const defaultSites = workspaces?.slice(0, $029554683ea761ec$var$MAX_DEFAULT_SITES).map((workspace)=>workspace.id);
        // Extract sites from filters
        const siteFilter = allFilters.find((filter)=>filter['@type'] === (0, $88j1D.SITE_FILTER_TYPE_NAME));
        // @ts-ignore - typescript is not smart enough to know `siteFilter` will only ever be the sites filter
        const sites = siteFilter?.values || defaultSites || [];
        // Remove sites from the filters array
        const filters = allFilters.filter((filter)=>filter['@type'] !== (0, $88j1D.SITE_FILTER_TYPE_NAME)).map((f)=>f);
        const permittedSections = sections.filter((section)=>allPermissionedScopes.indexOf(section.id) >= 0).filter((section)=>section.isEnabled ? section.isEnabled(query, filters) : true);
        const scopes = permittedSections.map((section)=>section.scope);
        if (!aggregatorClient) return {
            sections: []
        };
        const { response: response } = await aggregatorClient.search({
            query: query,
            scopes: scopes,
            modelParams: [],
            experience: experience,
            context: context,
            filters: filters,
            sites: sites,
            sourceProduct: sourceProduct
        });
        const sectionsWithResults = permittedSections.map(({ scope: scope, id: id, title: title, resultMapper: resultMapper, ...rest })=>{
            const results = response.retrieveScope(scope);
            if (results === null) throw new Error(`Scope ${scope} was not found in the response, despite being requested`);
            return {
                ...rest,
                id: id,
                title: title,
                size: results.size,
                searchResults: resultMapper(results) || [],
                resultMapper: resultMapper
            };
        });
        const scopesWithSize = response.rawData.scopes.filter(({ size: size })=>size);
        const reponseHasSize = scopesWithSize.length > 0;
        const totalSizeAsReportedByAPI = reponseHasSize ? response.rawData.scopes.reduce((count, scope)=>count + (scope.size || 0), 0) : undefined;
        return {
            size: totalSizeAsReportedByAPI,
            sections: sectionsWithResults
        };
    };
const $029554683ea761ec$export$967ff0f6c3886589 = (id, sections, overrides)=>{
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const sessionId = (0, $4ldrV.useSearchSessionId)();
    const productContext = (0, $fJRVo.useProductContext)();
    const { getPrimaryProduct: getPrimaryProduct } = productContext;
    const primaryProduct = getPrimaryProduct();
    const primaryProductId = primaryProduct?.id;
    const search = $029554683ea761ec$export$dc64f87f5460b276(aggregatorClient, sections, {
        sessionId: sessionId,
        referrerId: ''
    }, (0, $gJKpQ.PLACEHOLDER_EXPERIENCE), primaryProductId);
    return {
        preQueryItemSupplier: overrides?.preQueryItemSupplier ?? ((args)=>search({
                ...args,
                query: '',
                filters: []
            })),
        postQueryItemSupplier: overrides?.postQueryItemSupplier ?? search
    };
};

});
parcelRegister("gJKpQ", function(module, exports) {

$parcel$export(module.exports, "PLACEHOLDER_EXPERIENCE", () => $79cbd4001c087560$export$2bde439437c11152);

var $kmpep = parcelRequire("kmpep");
const $79cbd4001c087560$export$2bde439437c11152 = 'product-search-dialog';

});
parcelRegister("kmpep", function(module, exports) {

$parcel$export(module.exports, "AggregatorClientContextProvider", () => $1c8fa64373cfd191$export$db02e603a9db00);
$parcel$export(module.exports, "useAggregatorClient", () => $1c8fa64373cfd191$export$b8a9ed32354e757e);
$parcel$export(module.exports, "useTypedAggregatorClient", () => $1c8fa64373cfd191$export$51bbe78d05c20324);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $12cJV = parcelRequire("12cJV");

var $91yhh = parcelRequire("91yhh");
const $1c8fa64373cfd191$var$AggregatorClientContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext(undefined);
const $1c8fa64373cfd191$export$db02e603a9db00 = ({ abTestCloudId: abTestCloudId, aggregatorUrl: aggregatorUrl, children: children })=>{
    const { backendExperiment: backendExperiment } = (0, $91yhh.useExperiments)();
    const aggregatorClient = (0, $gwFzn.useMemo)(()=>new (0, $12cJV.AggregatorClient)({
            url: aggregatorUrl,
            cloudId: abTestCloudId,
            siteMasterList: [],
            backendExperiment: backendExperiment
        }), [
        abTestCloudId,
        aggregatorUrl,
        backendExperiment
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($1c8fa64373cfd191$var$AggregatorClientContext.Provider, {
        value: aggregatorClient,
        children: children
    });
};
const $1c8fa64373cfd191$export$b8a9ed32354e757e = ()=>{
    const aggregatorClient = (0, $gwFzn.useContext)($1c8fa64373cfd191$var$AggregatorClientContext);
    return aggregatorClient;
};
const $1c8fa64373cfd191$export$51bbe78d05c20324 = ()=>{
    // Casting done here to ensure that the result types match the scopes requested
    const untypedClient = (0, $gwFzn.useContext)($1c8fa64373cfd191$var$AggregatorClientContext);
    return untypedClient;
};

});


parcelRegister("4ldrV", function(module, exports) {

$parcel$export(module.exports, "SearchSessionProvider", () => $833e609371746364$export$facabd4fde35268);
$parcel$export(module.exports, "useSearchSessionId", () => $833e609371746364$export$e1e7a4797df1a656);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kyKWe = parcelRequire("kyKWe");

var $hpDfc = parcelRequire("hpDfc");
const $833e609371746364$var$SearchSessionContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    searchSessionId: undefined
});
class $833e609371746364$var$SearchSessionProviderError extends Error {
    constructor(){
        super('Could not find any SearchSessionProvider, make sure there is a SearchSessionProvider further up the tree');
    }
}
function $833e609371746364$export$432081be24450536(Component) {
    const WrapperComponent = (props)=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)($833e609371746364$var$SearchSessionContext.Consumer, {
            children: ({ searchSessionId: searchSessionId })=>{
                if (!searchSessionId) throw new $833e609371746364$var$SearchSessionProviderError();
                return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                    ...props,
                    searchSessionId: searchSessionId
                });
            }
        });
    };
    return WrapperComponent;
}
class $833e609371746364$export$facabd4fde35268 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    static getDerivedStateFromProps(props, state) {
        // Reset the searchSessionId only when the dialog is expanded
        return {
            sessionKey: props.sessionKey,
            searchSessionId: props.sessionKey !== state.sessionKey && props.sessionKey !== 'ssid_provider_false' ? (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))() : state.searchSessionId
        };
    }
    render() {
        const { children: children } = this.props;
        const { searchSessionId: searchSessionId } = this.state;
        return /*#__PURE__*/ (0, $7UHDa.jsx)($833e609371746364$var$SearchSessionContext.Provider, {
            value: {
                searchSessionId: searchSessionId
            },
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
                analyticContext: {
                    searchSessionId: searchSessionId
                },
                nonPrivacySafeAnalyticContext: {},
                children: children
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            sessionKey: this.props.sessionKey,
            searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
        };
    }
}
function $833e609371746364$export$e1e7a4797df1a656() {
    const { searchSessionId: searchSessionId } = (0, $gwFzn.useContext)($833e609371746364$var$SearchSessionContext);
    if (searchSessionId) return searchSessionId;
    throw new $833e609371746364$var$SearchSessionProviderError();
}

});
parcelRegister("hpDfc", function(module, exports) {

$parcel$export(module.exports, "SearchDialogAnalyticsContext", () => $16dbb5df832b7062$export$b6f131c43d0365a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5dFS9 = parcelRequire("5dFS9");

var $kDuN4 = parcelRequire("kDuN4");
const $16dbb5df832b7062$export$b6f131c43d0365a = ({ analyticContext: analyticContext, nonPrivacySafeAnalyticContext: nonPrivacySafeAnalyticContext = {}, filterAnalyticsContext: filterAnalyticsContext = {}, nonPrivacySafeAnalyticContextGenerator: nonPrivacySafeAnalyticContextGenerator, children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kDuN4.default), {
        channel: (0, $5dFS9.DEFAULT_GAS_CHANNEL),
        onEvent: (event)=>{
            const additionalAttributes = typeof analyticContext === 'function' ? analyticContext() : analyticContext;
            const nonPrivacySafeAttributes = nonPrivacySafeAnalyticContextGenerator !== undefined ? nonPrivacySafeAnalyticContextGenerator() : nonPrivacySafeAnalyticContext;
            event.update((payload)=>{
                const filters = {
                    ...payload.attributes?.filters,
                    ...filterAnalyticsContext
                };
                // Operational event not support nonPrivacySafeAttributes
                const nonPrivacySafeAttributesPayload = payload.eventType === 'operational' ? {} : {
                    nonPrivacySafeAttributes: {
                        ...payload?.nonPrivacySafeAttributes,
                        ...nonPrivacySafeAttributes
                    }
                };
                return {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        ...additionalAttributes,
                        filters: Object.keys(filters).length > 0 ? filters : undefined
                    },
                    ...nonPrivacySafeAttributesPayload
                };
            });
        },
        children: children
    });
};

});
parcelRegister("5dFS9", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_GAS_CHANNEL", () => $a652ba3ef37d13f7$export$ed78826c06dd24e3);
$parcel$export(module.exports, "Trigger", () => $a652ba3ef37d13f7$export$41fb9f06171c75f4);
$parcel$export(module.exports, "AdvancedSearchLinkSubjectId", () => $a652ba3ef37d13f7$export$f7a2a633defbe589);
$parcel$export(module.exports, "onAdvancedSearchSelected", () => $a652ba3ef37d13f7$export$b544183e0becb531);
$parcel$export(module.exports, "onXButtonClicked", () => $a652ba3ef37d13f7$export$19360e9b825e4dfb);
$parcel$export(module.exports, "onNonDebouncedSearchTriggered", () => $a652ba3ef37d13f7$export$72e9f7dfc882e584);
$parcel$export(module.exports, "onStickySearchCleared", () => $a652ba3ef37d13f7$export$9cb41cdfd7c5452f);
$parcel$export(module.exports, "onAutocorrectShown", () => $a652ba3ef37d13f7$export$b4f9d93cc4bd7b82);
$parcel$export(module.exports, "onAutocorrectClicked", () => $a652ba3ef37d13f7$export$33cdbdfa7f154d6c);
$parcel$export(module.exports, "onHoverPreviewShow", () => $a652ba3ef37d13f7$export$82cfcc46988a9165);
$parcel$export(module.exports, "onHoverPreviewShown", () => $a652ba3ef37d13f7$export$c666b7de327a3cc2);
$parcel$export(module.exports, "onHoverPreviewClicked", () => $a652ba3ef37d13f7$export$dfba1b0d5d9e4887);
$parcel$export(module.exports, "onCardRequestFailed", () => $a652ba3ef37d13f7$export$4b429c3d1a2c2d67);
$parcel$export(module.exports, "onSearchResultViewAllLinkClicked", () => $a652ba3ef37d13f7$export$b87f0592bfac0edc);
$parcel$export(module.exports, "onMultiSiteAdvancedSearchSelected", () => $a652ba3ef37d13f7$export$62946e9fdc11ae8d);
$parcel$export(module.exports, "onMoreFiltersSelected", () => $a652ba3ef37d13f7$export$6c5bd82ba411ffb0);
$parcel$export(module.exports, "onSearchResultSelected", () => $a652ba3ef37d13f7$export$7816fccc5a0a2fed);
$parcel$export(module.exports, "onSearchResultHighlighted", () => $a652ba3ef37d13f7$export$95ef6569b5b2de4a);
$parcel$export(module.exports, "onSearchResultContext", () => $a652ba3ef37d13f7$export$656ab76fbb25e04);
$parcel$export(module.exports, "ResultsShownActionSubjectId", () => $a652ba3ef37d13f7$export$676101ab18001bd5);
$parcel$export(module.exports, "onSearchResultsShown", () => $a652ba3ef37d13f7$export$2d1da932f40a427e);
$parcel$export(module.exports, "onTextEntered", () => $a652ba3ef37d13f7$export$db28d8e16fb16e80);
$parcel$export(module.exports, "onPreQueryScreenViewed", () => $a652ba3ef37d13f7$export$145f05df248491e5);
$parcel$export(module.exports, "onRequestMade", () => $a652ba3ef37d13f7$export$93a340bed59d6525);
$parcel$export(module.exports, "onDismissed", () => $a652ba3ef37d13f7$export$97e12e4b0f216b1d);
$parcel$export(module.exports, "onShown", () => $a652ba3ef37d13f7$export$e79368bde551c62e);
$parcel$export(module.exports, "onDropdownMenuFilterView", () => $a652ba3ef37d13f7$export$9e2ba0ae72f48da8);
$parcel$export(module.exports, "onFilterSelect", () => $a652ba3ef37d13f7$export$151951fdc112763c);
$parcel$export(module.exports, "onFilterUnselect", () => $a652ba3ef37d13f7$export$f448c439d93613dd);
$parcel$export(module.exports, "onFilterFieldCleared", () => $a652ba3ef37d13f7$export$2e387d28788cf23b);
$parcel$export(module.exports, "onPaneLoadComplete", () => $a652ba3ef37d13f7$export$8ba00734f8071933);
$parcel$export(module.exports, "onExperimentLoaded", () => $a652ba3ef37d13f7$export$d9576525adc921c1);
$parcel$export(module.exports, "onTabSelected", () => $a652ba3ef37d13f7$export$cb0c8d6d4bf862f8);
$parcel$export(module.exports, "selectEvent", () => $a652ba3ef37d13f7$export$48143d759475d90f);
$parcel$export(module.exports, "onPrequeryBannerShown", () => $a652ba3ef37d13f7$export$1338fc4f37de8396);
$parcel$export(module.exports, "onSuggestedPromptClick", () => $a652ba3ef37d13f7$export$e7721900a147b5b2);
$parcel$export(module.exports, "onPrequeryBannerDismiss", () => $a652ba3ef37d13f7$export$889f319cb696bfae);
$parcel$export(module.exports, "onConfluenceReactionNudgeShown", () => $a652ba3ef37d13f7$export$a7d90f29e3bc6f4f);
/**
 * Note all events fired include the searchSessionId, experiment-id, queryHash, queryVersion, wordCount, resultCount where applicable
 */ const $a652ba3ef37d13f7$export$ed78826c06dd24e3 = 'fabric-elements';
var $a652ba3ef37d13f7$export$41fb9f06171c75f4 = /*#__PURE__*/ function(Trigger) {
    Trigger["SHORTCUT"] = "shortcut";
    Trigger["SHORTCUT_MODIFIED"] = "shortcutModified";
    Trigger["RETURN"] = "return";
    Trigger["CLICK"] = "click";
    Trigger["TEXT_ENTERED"] = "textEntered";
    return Trigger;
}({});
var $a652ba3ef37d13f7$export$f7a2a633defbe589 = /*#__PURE__*/ function(AdvancedSearchLinkSubjectId) {
    AdvancedSearchLinkSubjectId["CONFLUENCE"] = "confluenceAdvancedSearchLink";
    AdvancedSearchLinkSubjectId["CONFLUENCE_PEOPLE"] = "confluencePeopleSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_ISSUES"] = "jiraIssuesSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_BOARDS"] = "jiraBoardsSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_FILTERS"] = "jiraFiltersSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_PROJECTS"] = "jiraProjectsSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_PLANS"] = "jiraPlansSearchLink";
    AdvancedSearchLinkSubjectId["JIRA_PEOPLE"] = "jiraPeopleSearchLink";
    AdvancedSearchLinkSubjectId["NO_RESULTS"] = "noResultsAdvancedSearchLink";
    return AdvancedSearchLinkSubjectId;
}({});
const $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE = 'searchDialog';
const $a652ba3ef37d13f7$export$b544183e0becb531 = ({ trigger: trigger, actionSubjectId: actionSubjectId, isLoading: isLoading, newTab: newTab, isRovoCrossProductSearchLink: isRovoCrossProductSearchLink = false })=>{
    return {
        action: 'selected',
        actionSubject: 'advancedSearchLink',
        actionSubjectId: actionSubjectId,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            trigger: trigger,
            isLoading: isLoading,
            newTab: newTab,
            isRovoCrossProductSearchLink: isRovoCrossProductSearchLink
        }
    };
};
const $a652ba3ef37d13f7$export$7d52695c66ad1422 = ({ trigger: trigger, actionSubjectId: actionSubjectId, isLoading: isLoading, newTab: newTab })=>{
    return {
        action: 'selected',
        actionSubject: 'askAtlassianIntelligenceLink',
        actionSubjectId: actionSubjectId,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            trigger: trigger,
            isLoading: isLoading,
            newTab: newTab
        }
    };
};
const $a652ba3ef37d13f7$export$19360e9b825e4dfb = ({ actionSubjectId: actionSubjectId, searchSessionId: searchSessionId })=>{
    return {
        action: 'dismissed',
        actionSubject: 'stickySearch',
        actionSubjectId: actionSubjectId,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            searchSessionId: searchSessionId
        }
    };
};
const $a652ba3ef37d13f7$export$72e9f7dfc882e584 = ()=>{
    return {
        action: 'triggered',
        actionSubject: 'nonDebouncedSearch',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui'
    };
};
const $a652ba3ef37d13f7$export$9cb41cdfd7c5452f = ({ timeout: timeout })=>{
    return {
        eventType: 'track',
        action: 'cleared',
        actionSubject: 'stickySearch',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        attributes: {
            timeout: timeout
        }
    };
};
const $a652ba3ef37d13f7$export$b4f9d93cc4bd7b82 = ({ source: source, attributes: attributes })=>{
    return {
        eventType: 'ui',
        action: 'shown',
        actionSubject: 'link',
        actionSubjectId: 'autocorrect',
        source: source,
        attributes: attributes
    };
};
const $a652ba3ef37d13f7$export$33cdbdfa7f154d6c = ({ source: source, attributes: attributes })=>{
    return {
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'link',
        actionSubjectId: 'autocorrect',
        source: source,
        attributes: attributes
    };
};
const $a652ba3ef37d13f7$export$82cfcc46988a9165 = ({ actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        action: 'show',
        actionSubject: 'hoverPreview',
        actionSubjectId: actionSubjectId
    });
const $a652ba3ef37d13f7$export$c666b7de327a3cc2 = ({ actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        action: 'shown',
        actionSubject: 'hoverPreview',
        actionSubjectId: actionSubjectId
    });
const $a652ba3ef37d13f7$export$dfba1b0d5d9e4887 = ({ actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        action: 'clicked',
        actionSubject: 'hoverPreview',
        actionSubjectId: actionSubjectId
    });
const $a652ba3ef37d13f7$export$4b429c3d1a2c2d67 = ({ attributes: attributes })=>({
        eventType: 'operational',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        action: 'failed',
        actionSubject: 'trelloCardRequest',
        attributes: {
            ...attributes
        }
    });
const $a652ba3ef37d13f7$export$b87f0592bfac0edc = (sectionId)=>({
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'link',
        actionSubjectId: 'searchResultViewAllLink',
        attributes: {
            sectionId: sectionId
        }
    });
const $a652ba3ef37d13f7$export$62946e9fdc11ae8d = ({ trigger: trigger, actionSubjectId: actionSubjectId, isLoading: isLoading, newTab: newTab, destinationId: destinationId, index: index })=>{
    return {
        action: 'selected',
        actionSubject: 'advancedSearchLink',
        actionSubjectId: actionSubjectId,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            trigger: trigger,
            isLoading: isLoading,
            newTab: newTab,
            destinationId: destinationId,
            index: index
        }
    };
};
const $a652ba3ef37d13f7$export$6c5bd82ba411ffb0 = ({ trigger: trigger, selectedFiltersCount: selectedFiltersCount })=>{
    return {
        action: 'selected',
        actionSubject: 'moreFilterLink',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            trigger: trigger,
            selectedFiltersCount: selectedFiltersCount
        }
    };
};
const $a652ba3ef37d13f7$export$7816fccc5a0a2fed = ({ screen: screen, actionSubject: actionSubject })=>{
    return {
        action: 'selected',
        actionSubject: actionSubject,
        actionSubjectId: screen,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {}
    };
};
const $a652ba3ef37d13f7$export$95ef6569b5b2de4a = ({ screen: screen, actionSubject: actionSubject })=>{
    return {
        action: 'highlighted',
        actionSubject: actionSubject,
        actionSubjectId: screen,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $a652ba3ef37d13f7$export$656ab76fbb25e04 = ({ screen: screen, actionSubject: actionSubject })=>{
    return {
        action: 'contextMenu opened',
        actionSubject: actionSubject,
        actionSubjectId: screen,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
var $a652ba3ef37d13f7$export$676101ab18001bd5 = /*#__PURE__*/ function(ResultsShownActionSubjectId) {
    ResultsShownActionSubjectId["PREQUERY"] = "preQuerySearchResults";
    ResultsShownActionSubjectId["POSTQUERY"] = "postQuerySearchResults";
    ResultsShownActionSubjectId["CACHED"] = "cachedResults";
    ResultsShownActionSubjectId["PREQUERY_ERROR"] = "preQueryError";
    ResultsShownActionSubjectId["POSTQUERY_ERROR"] = "postQueryError";
    return ResultsShownActionSubjectId;
}({});
const $a652ba3ef37d13f7$export$2d1da932f40a427e = ({ actionSubjectId: actionSubjectId, resultCount: resultCount, sectionCount: sectionCount, results: results, timeToQueryMs: timeToQueryMs, activeProduct: activeProduct, isMultiProduct: isMultiProduct, filters: filters })=>{
    return {
        action: 'shown',
        actionSubject: 'searchResults',
        actionSubjectId: actionSubjectId,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            resultCount: resultCount,
            sectionCount: sectionCount,
            timeToQueryMs: timeToQueryMs,
            results: results,
            noResultsFetched: !resultCount,
            activeProduct: activeProduct,
            isMultiProduct: isMultiProduct,
            filters: filters
        }
    };
};
const $a652ba3ef37d13f7$export$db28d8e16fb16e80 = ()=>{
    return {
        action: 'entered',
        actionSubject: 'text',
        actionSubjectId: 'searchDialogTextField',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {}
    };
};
const $a652ba3ef37d13f7$export$3484ea513055aa12 = ({ total: total, currentSize: currentSize, pageSize: pageSize })=>{
    return {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'showMoreButton',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            total: total,
            currentSize: currentSize,
            pageSize: pageSize
        }
    };
};
const $a652ba3ef37d13f7$export$3fb15ebf22b4884e = ({ total: total, currentSize: currentSize, pageSize: pageSize })=>{
    return {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'showAllLink',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            total: total,
            currentSize: currentSize,
            pageSize: pageSize
        }
    };
};
const $a652ba3ef37d13f7$export$145f05df248491e5 = ({ searchSessionId: searchSessionId, trigger: trigger })=>{
    return {
        name: 'searchDialogPreQueryScreen',
        eventType: 'screen',
        attributes: {
            searchSessionId: searchSessionId,
            trigger: trigger
        }
    };
};
const $a652ba3ef37d13f7$export$93a340bed59d6525 = ({ actionSubjectId: actionSubjectId, timings: timings, activeProduct: activeProduct, isExpanded: isExpanded, isMultiProduct: isMultiProduct, filters: filters }, additionalContext = {}, nonPrivacySafeAttributes = {
    query: ''
})=>{
    return {
        action: 'completed',
        actionSubject: 'searchRequest',
        actionSubjectId: actionSubjectId,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            activeProduct: activeProduct,
            isExpanded: isExpanded,
            isMultiProduct: isMultiProduct,
            filters: filters,
            ...timings,
            ...additionalContext
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};
const $a652ba3ef37d13f7$export$a8d299e4bdceb0be = ()=>({
        action: 'shown',
        eventType: 'ui',
        actionSubject: 'searchResults',
        actionSubjectId: 'preQuerySearchResults',
        attributes: {
            resultCount: 0,
            results: []
        },
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE
    });
const $a652ba3ef37d13f7$export$97e12e4b0f216b1d = ()=>{
    return {
        action: 'dismissed',
        actionSubject: 'searchDialog',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui'
    };
};
const $a652ba3ef37d13f7$export$e79368bde551c62e = ({ visibleProducts: visibleProducts, visibleTabsCount: visibleTabsCount, isRovoCrossProductSearchLinkShown: isRovoCrossProductSearchLinkShown })=>{
    return {
        action: 'shown',
        actionSubject: 'searchDialog',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            visibleProducts: visibleProducts,
            visibleTabsCount: visibleTabsCount,
            isRovoCrossProductSearchLinkShown: isRovoCrossProductSearchLinkShown
        }
    };
};
const $a652ba3ef37d13f7$export$9e2ba0ae72f48da8 = ({ filterType: filterType })=>{
    return {
        action: 'viewed',
        actionSubject: 'filterField',
        actionSubjectId: 'dropdownMenuFilterField',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            filterType: filterType
        }
    };
};
const $a652ba3ef37d13f7$export$151951fdc112763c = ({ filterId: filterId, filterType: filterType, filterSource: filterSource })=>{
    return {
        action: 'selected',
        actionSubject: 'filter',
        actionSubjectId: 'searchDialogFilter',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            filterId: filterId,
            filterType: filterType,
            filterSource: filterSource
        }
    };
};
const $a652ba3ef37d13f7$export$f448c439d93613dd = ({ filterId: filterId, filterType: filterType, filterSource: filterSource })=>{
    return {
        action: 'unselected',
        actionSubject: 'filter',
        actionSubjectId: 'searchDialogFilter',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            filterId: filterId,
            filterType: filterType,
            filterSource: filterSource
        }
    };
};
const $a652ba3ef37d13f7$export$2e387d28788cf23b = ({ filterType: filterType })=>{
    return {
        action: 'cleared',
        actionSubject: 'filterField',
        actionSubjectId: 'searchDialogFilterField',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            filterType: filterType
        }
    };
};
const $a652ba3ef37d13f7$export$e785b4d14ffa4348 = ()=>{
    return {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'searchDialogClearFilters',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $a652ba3ef37d13f7$export$8ba00734f8071933 = (product, duration)=>{
    return {
        action: 'loadComplete',
        actionSubject: 'searchDialogPane',
        actionSubjectId: product,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            durationMs: duration
        }
    };
};
const $a652ba3ef37d13f7$export$d9576525adc921c1 = (abTest, experimentRequestDuration, isMultiProduct)=>{
    return {
        action: 'loaded',
        actionSubject: 'experiment',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'operational',
        attributes: {
            abTest: abTest,
            experimentRequestDuration: experimentRequestDuration,
            isMultiProduct: isMultiProduct
        }
    };
};
const $a652ba3ef37d13f7$export$cb0c8d6d4bf862f8 = ({ tabName: tabName }, additionalContext = {}, nonPrivacySafeAttributes = {
    query: ''
})=>{
    // this event is fired at the same level as the anlytics context hence it needs mandatory additional objects.
    return {
        action: 'clicked',
        actionSubject: 'tab',
        actionSubjectId: 'crossProductSearchTab',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            tabName: tabName,
            ...additionalContext
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};
const $a652ba3ef37d13f7$export$e89c96d52a36944 = (authorised, product)=>{
    return {
        action: 'checked',
        actionSubject: 'thirdPartyAuth',
        actionSubjectId: product,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {
            authorised: authorised
        }
    };
};
const $a652ba3ef37d13f7$export$a93c057f87e755b3 = (product)=>{
    return {
        action: 'authorised',
        actionSubject: 'thirdPartyProduct',
        actionSubjectId: product,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'track',
        attributes: {}
    };
};
const $a652ba3ef37d13f7$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            ...attributes
        }
    });
const $a652ba3ef37d13f7$var$position = (options, value)=>{
    return value ? options.findIndex((option)=>option.id === value.data.id) : -1;
};
const $a652ba3ef37d13f7$var$result = (option)=>{
    return option ? $a652ba3ef37d13f7$var$optionData2Analytics(option.data) : null;
};
const $a652ba3ef37d13f7$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    return {
        id: id ? id : null,
        type: type || null
    };
};
const $a652ba3ef37d13f7$var$createDefaultPickerAttributes = (fieldId, collabGraphSessionId)=>({
        context: fieldId,
        isCheckbox: true,
        queryLength: 0,
        collabGraphSessionId: collabGraphSessionId
    });
const $a652ba3ef37d13f7$export$48143d759475d90f = (value, options, fieldId, collabGraphSessionId)=>{
    return $a652ba3ef37d13f7$var$createEvent('ui', 'clicked', 'userPicker', {
        ...$a652ba3ef37d13f7$var$createDefaultPickerAttributes(fieldId, collabGraphSessionId),
        position: $a652ba3ef37d13f7$var$position(options, value),
        result: $a652ba3ef37d13f7$var$result(value)
    });
};
const $a652ba3ef37d13f7$export$73da5bde227e14d8 = ()=>{
    return {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'recentSearch',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $a652ba3ef37d13f7$export$1338fc4f37de8396 = ()=>{
    return {
        action: 'shown',
        actionSubject: 'aiOnboardingPrompt',
        actionSubjectId: 'prequeryBanner',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $a652ba3ef37d13f7$export$e7721900a147b5b2 = (promptId)=>{
    return {
        action: 'clicked',
        actionSubject: 'aiOnboardingPrompt',
        actionSubjectId: promptId,
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $a652ba3ef37d13f7$export$889f319cb696bfae = ()=>{
    return {
        action: 'clicked',
        actionSubject: 'aiOnboardingPrompt',
        actionSubjectId: 'dismissButton',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {}
    };
};
const $a652ba3ef37d13f7$export$a7d90f29e3bc6f4f = (neverActive)=>{
    return {
        action: 'shown',
        actionSubject: 'nudge',
        actionSubjectId: 'confluenceReactivation',
        source: $a652ba3ef37d13f7$var$BASE_ANALYTICS_SOURCE,
        eventType: 'ui',
        attributes: {
            touchpointId: 'search',
            neverActive: neverActive
        }
    };
};

});



parcelRegister("88j1D", function(module, exports) {

$parcel$export(module.exports, "SITE_FILTER_TYPE_NAME", () => $aa1fd6477603f439$export$f76bd7c689371575);
$parcel$export(module.exports, "DEFAULT_OPTION", () => $aa1fd6477603f439$export$d3212964e526b51c);
$parcel$export(module.exports, "FilterUIVariant", () => $aa1fd6477603f439$export$ab762b8071023de0);
$parcel$export(module.exports, "LastModifiedValues", () => $aa1fd6477603f439$export$2a1fb5b806348bf0);
const $aa1fd6477603f439$export$f76bd7c689371575 = 'sites';
const $aa1fd6477603f439$export$d3212964e526b51c = 'default';
var $aa1fd6477603f439$export$ab762b8071023de0 = /*#__PURE__*/ function(FilterUIVariant) {
    FilterUIVariant["CHECKBOX"] = "CHECKBOX";
    FilterUIVariant["STATIC_SELECT"] = "STATIC_SELECT";
    FilterUIVariant["MULTI_SELECT"] = "MULTI_SELECT";
    return FilterUIVariant;
}({});
var $aa1fd6477603f439$export$2a1fb5b806348bf0 = /*#__PURE__*/ function(LastModifiedValues) {
    LastModifiedValues["DEFAULT"] = "default";
    LastModifiedValues["TODAY"] = "today";
    LastModifiedValues["YESTERDAY"] = "yesterday";
    LastModifiedValues["PAST_SEVEN_DAYS"] = "past7Days";
    LastModifiedValues["PAST_THIRTY_DAYS"] = "past30Days";
    LastModifiedValues["PAST_YEAR"] = "pastYear";
    return LastModifiedValues;
}({});

});

parcelRegister("fJRVo", function(module, exports) {

$parcel$export(module.exports, "ProductRouter", () => $a5724fee76135767$export$36d5c2ec3fe68eef);
$parcel$export(module.exports, "useProductContext", () => $a5724fee76135767$export$b5aab9e12d92574f);
$parcel$export(module.exports, "withProductContext", () => $a5724fee76135767$export$a1f708a69696ca95);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aAuSn = parcelRequire("aAuSn");

var $gF7Az = parcelRequire("gF7Az");

var $gclFq = parcelRequire("gclFq");
const $a5724fee76135767$var$ProductContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    getProduct: (id)=>undefined,
    getActiveProduct: ()=>undefined,
    getPrimaryProduct: ()=>undefined,
    addProduct: ()=>undefined,
    updateProduct: ()=>undefined,
    removeProduct: ()=>undefined,
    showProduct: ()=>undefined,
    getDefaultAIConfig: ()=>undefined,
    products: []
});
const $a5724fee76135767$export$36d5c2ec3fe68eef = ({ primaryProduct: primaryProduct, __initialProducts: __initialProducts = (0, $gclFq.INITIAL_STATE), children: children })=>{
    const [products, dispatch] = (0, $gwFzn.useReducer)((0, $gclFq.reducer), __initialProducts);
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    (0, $gwFzn.useEffect)(()=>{
        if (!isExpanded) dispatch({
            type: 'HIDE_ALL'
        });
    }, [
        isExpanded
    ]);
    const addProduct = (0, $gwFzn.useCallback)((payload)=>{
        return dispatch({
            type: 'ADD',
            payload: payload
        });
    }, [
        dispatch
    ]);
    const updateProduct = (0, $gwFzn.useCallback)((payload)=>{
        return dispatch({
            type: 'UPDATE',
            payload: payload
        });
    }, [
        dispatch
    ]);
    const removeProduct = (0, $gwFzn.useCallback)((id)=>{
        return dispatch({
            type: 'REMOVE',
            payload: {
                id: id
            }
        });
    }, [
        dispatch
    ]);
    /**
	 * @function showProduct will ensure that only one product is displayed at a time
	 * @param {string} id - The product id which has to be made visible.
	 */ const showProduct = (0, $gwFzn.useCallback)((id)=>dispatch({
            type: 'SHOW',
            payload: {
                id: id
            }
        }), [
        dispatch
    ]);
    const getActiveProduct = (0, $gwFzn.useCallback)(()=>{
        return products.find((product)=>product.isDisplayed);
    }, [
        products
    ]);
    const productsRef = (0, $gwFzn.useRef)({});
    const getProduct = (0, $gwFzn.useCallback)((id)=>{
        const product = products.find((product)=>product.id === id);
        const productRef = productsRef.current[id];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($aAuSn)))(product, productRef)) productsRef.current[id] = product;
        return productsRef.current[id];
    }, [
        products
    ]);
    const getPrimaryProduct = (0, $gwFzn.useCallback)(()=>{
        const nominatedPrimaryProduct = primaryProduct && getProduct(primaryProduct);
        const firstRegisteredProduct = products.length > 0 && products[0];
        return nominatedPrimaryProduct || firstRegisteredProduct || undefined;
    }, [
        getProduct,
        primaryProduct,
        products
    ]);
    const getDefaultAIConfig = (0, $gwFzn.useCallback)(()=>{
        const primaryProduct = getPrimaryProduct();
        if (primaryProduct?.aiSearchConfig) return primaryProduct.aiSearchConfig;
        else return products.filter((product)=>product.aiSearchConfig)[0]?.aiSearchConfig;
    }, [
        products,
        getPrimaryProduct
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($a5724fee76135767$var$ProductContext.Provider, {
        value: {
            getProduct: getProduct,
            getActiveProduct: getActiveProduct,
            getPrimaryProduct: getPrimaryProduct,
            addProduct: addProduct,
            updateProduct: updateProduct,
            removeProduct: removeProduct,
            showProduct: showProduct,
            products: products,
            getDefaultAIConfig: getDefaultAIConfig
        },
        children: children
    });
};
const $a5724fee76135767$export$b5aab9e12d92574f = ()=>(0, $gwFzn.useContext)($a5724fee76135767$var$ProductContext);
const $a5724fee76135767$export$a1f708a69696ca95 = (WrappedComponent)=>{
    return (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)(WrappedComponent, {
            ...props,
            ...$a5724fee76135767$export$b5aab9e12d92574f()
        });
};

});
parcelRegister("gF7Az", function(module, exports) {

$parcel$export(module.exports, "DialogExpansionContextProvider", () => $71bd8ea3705f0301$export$4a9c91610a2bc03);
$parcel$export(module.exports, "useDialogExpansionContext", () => $71bd8ea3705f0301$export$124a7aa8f9a7a608);
$parcel$export(module.exports, "withDialogExpansionContext", () => $71bd8ea3705f0301$export$be366799d3426bb9);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $71bd8ea3705f0301$export$5d07de159ce5026c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    isExpanded: false,
    setIsExpanded: (isExpanded)=>{},
    allowChangeExpand: (expand)=>{}
});
const $71bd8ea3705f0301$export$4a9c91610a2bc03 = ({ children: children, isExpanded: isExpanded, setIsExpanded: setIsExpanded })=>{
    const [changeExpand, setChangeExpand] = (0, $gwFzn.useState)(true);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($71bd8ea3705f0301$export$5d07de159ce5026c.Provider, {
        value: {
            isExpanded: isExpanded,
            setIsExpanded: changeExpand ? setIsExpanded : ()=>{},
            allowChangeExpand: setChangeExpand
        },
        children: children
    });
};
const $71bd8ea3705f0301$export$124a7aa8f9a7a608 = ()=>{
    return (0, $gwFzn.useContext)($71bd8ea3705f0301$export$5d07de159ce5026c);
};
const $71bd8ea3705f0301$export$be366799d3426bb9 = (WrappedComponent)=>{
    return (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)(WrappedComponent, {
            ...props,
            ...$71bd8ea3705f0301$export$124a7aa8f9a7a608()
        });
};

});

parcelRegister("gclFq", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $95e6c3d859ed2047$export$36d128238e6b60f5);
$parcel$export(module.exports, "reducer", () => $95e6c3d859ed2047$export$1650419e431d3ba3);
const $95e6c3d859ed2047$export$36d128238e6b60f5 = [];
const $95e6c3d859ed2047$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case 'ADD':
            {
                const { payload: newProduct } = action;
                return $95e6c3d859ed2047$export$7caf006d7b64ee15(state, newProduct);
            }
        case 'UPDATE':
            {
                const { payload: updatePayload } = action;
                return $95e6c3d859ed2047$export$8d590d0c8872145e(state, updatePayload);
            }
        case 'SHOW':
            {
                const productIdToShow = action.payload.id;
                return $95e6c3d859ed2047$export$821c121fea76e4f5(state, productIdToShow);
            }
        case 'REMOVE':
            {
                const productIdToRemove = action.payload.id;
                return $95e6c3d859ed2047$export$86a330d9a979afdd(state, productIdToRemove);
            }
        case 'HIDE_ALL':
            return $95e6c3d859ed2047$export$b6d3947c481ec009(state);
        default:
            return state;
    }
};
function $95e6c3d859ed2047$export$7caf006d7b64ee15(products, addPayload) {
    // Check that new product id does not exist already
    if (products.filter((product)=>product.id === addPayload.id).length) return products;
    // Show error in console when duplicate order is added
    const duplicateOrder = products.find(({ order: order })=>order === addPayload.order);
    if (duplicateOrder) // eslint-disable-next-line no-console
    console.error(`product-search-dialog: Duplicate order of ${addPayload.order} has been set for the products of ${duplicateOrder.id} and ${addPayload.id}`);
    // Add product to state and maintain sorted array using order
    const newProduct = {
        ...addPayload,
        isDisplayed: false
    };
    const unsorted = [
        ...products,
        newProduct
    ];
    const sorted = unsorted.sort((a, b)=>a.order - b.order);
    return sorted;
}
function $95e6c3d859ed2047$export$8d590d0c8872145e(products, updatePayload) {
    const productToUpdate = products.find((p)=>p.id === updatePayload.id);
    if (!productToUpdate) throw new Error(`Cannot update ${updatePayload.id} before being added`);
    const validUpdateKeys = [
        'generateAdvancedSearchUrl',
        'tabRenderer'
    ];
    const validUpdatePayload = Object.fromEntries(Object.entries(updatePayload).filter(([key])=>validUpdateKeys.includes(key)));
    Object.assign(productToUpdate, validUpdatePayload);
    return products;
}
function $95e6c3d859ed2047$export$821c121fea76e4f5(products, productIdToShow) {
    return products.map((product)=>({
            ...product,
            isDisplayed: product.id === productIdToShow
        }));
}
function $95e6c3d859ed2047$export$86a330d9a979afdd(products, productIdToRemove) {
    return products.filter((product)=>product.id !== productIdToRemove);
}
function $95e6c3d859ed2047$export$b6d3947c481ec009(products) {
    return products.map((product)=>({
            ...product,
            isDisplayed: false
        }));
}

});



parcelRegister("bqoDl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c3475590821d5a81$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $c3475590821d5a81$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /**
   * Bitbucket
   */ bitbucket_repository_heading: {
        id: "product_search_dialog.bitbucket.repository_heading",
        defaultMessage: "Repositories"
    },
    bitbucket_advanced_search: {
        id: "product_search_dialog.bitbucket.bitbucket_advanced_search",
        defaultMessage: "Search for code in {source}"
    },
    bitbucket_repositories_section_title: {
        id: "product_search_dialog.bitbucket.bitbucket_repositories_section_title",
        defaultMessage: "Repositories"
    },
    bitbucket_recent_repositories: {
        id: "product_search_dialog.bitbucket.bitbucket_recent_repositories",
        defaultMessage: "Recently updated repositories"
    },
    bitbucket_expanded_input_placeholder: {
        id: "product_search_dialog.bitbucket.expanded.input-placeholder",
        defaultMessage: "Search Bitbucket"
    }
});

});

parcelRegister("bF0iL", function(module, exports) {

$parcel$export(module.exports, "commentedEventTypeMessages", () => $384d74d764657ed7$export$29c048cc57fefaf8);
$parcel$export(module.exports, "createdEventTypeMessages", () => $384d74d764657ed7$export$99e7e287b0f1db7);
$parcel$export(module.exports, "editedEventTypeMessages", () => $384d74d764657ed7$export$4d0c20aef6601783);
$parcel$export(module.exports, "publishedEventTypeMessages", () => $384d74d764657ed7$export$2cd1ec4decb563bb);
$parcel$export(module.exports, "updatedEventTypeMessages", () => $384d74d764657ed7$export$3b389551d0b5bf03);
$parcel$export(module.exports, "viewedEventTypeMessages", () => $384d74d764657ed7$export$2d3fe6e7f84a868e);
$parcel$export(module.exports, "defaultEventTypeMessages", () => $384d74d764657ed7$export$9be55d016b768442);
$parcel$export(module.exports, "messages", () => $384d74d764657ed7$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $384d74d764657ed7$export$29c048cc57fefaf8 = (0, $2nPZH.defineMessages)({
    absolute: {
        defaultMessage: "You commented on {date}",
        id: "recentWork.eventTypeMessage.absolute.commented"
    },
    relative: {
        defaultMessage: "You commented {date}",
        id: "recentWork.eventTypeMessage.relative.commented"
    }
});
const $384d74d764657ed7$export$99e7e287b0f1db7 = (0, $2nPZH.defineMessages)({
    absolute: {
        defaultMessage: "You created on {date}",
        id: "recentWork.eventTypeMessage.absolute.created"
    },
    relative: {
        defaultMessage: "You created {date}",
        id: "recentWork.eventTypeMessage.relative.created"
    }
});
const $384d74d764657ed7$export$4d0c20aef6601783 = (0, $2nPZH.defineMessages)({
    absolute: {
        defaultMessage: "You edited on {date}",
        id: "recentWork.eventTypeMessage.absolute.edited"
    },
    relative: {
        defaultMessage: "You edited {date}",
        id: "recentWork.eventTypeMessage.relative.edited"
    }
});
const $384d74d764657ed7$export$2cd1ec4decb563bb = (0, $2nPZH.defineMessages)({
    absolute: {
        defaultMessage: "You published on {date}",
        id: "recentWork.eventTypeMessage.absolute.published"
    },
    relative: {
        defaultMessage: "You published {date}",
        id: "recentWork.eventTypeMessage.relative.published"
    }
});
const $384d74d764657ed7$export$3b389551d0b5bf03 = (0, $2nPZH.defineMessages)({
    absolute: {
        defaultMessage: "You updated on {date}",
        id: "recentWork.eventTypeMessage.absolute.updated"
    },
    relative: {
        defaultMessage: "You updated {date}",
        id: "recentWork.eventTypeMessage.relative.updated"
    }
});
const $384d74d764657ed7$export$2d3fe6e7f84a868e = (0, $2nPZH.defineMessages)({
    absolute: {
        defaultMessage: "You viewed on {date}",
        id: "recentWork.eventTypeMessage.absolute.viewed"
    },
    relative: {
        defaultMessage: "You viewed {date}",
        id: "recentWork.eventTypeMessage.relative.viewed"
    }
});
const $384d74d764657ed7$export$9be55d016b768442 = (0, $2nPZH.defineMessages)({
    absolute: {
        defaultMessage: "You worked on {date}",
        id: "recentWork.eventTypeMessage.absolute.workedOn"
    },
    relative: {
        defaultMessage: "You worked on {date}",
        id: "recentWork.eventTypeMessage.absolute.workedOn"
    }
});
const $384d74d764657ed7$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /**
   * Product-agnostic messages
   */ common_updated_date_formatter: {
        id: "product_search_dialog.updated_date_formatter",
        defaultMessage: "Updated {date}"
    },
    common_recently_viewed_section_heading: {
        id: "product_search_dialog.recently_viewed_section_heading",
        defaultMessage: "Recently viewed"
    },
    common_recently_spaces_section_heading: {
        id: "product_search_dialog.recent_spaces_section_heading",
        defaultMessage: "Recent spaces"
    },
    common_recently_worked_with_section_heading: {
        id: "product_search_dialog.recently_worked_with_section_heading",
        defaultMessage: "Recently worked with"
    },
    common_error_state_failed_search_heading: {
        id: "product_search_dialog.error.failed_loading_search_heading",
        defaultMessage: "We're having trouble loading your recently viewed content."
    },
    common_error_state_failed_search_body: {
        id: "product_search_dialog.error.failed_loading_search_body",
        defaultMessage: "It might just be a hiccup. Please try refreshing the page or <emptyLink>try again.</emptyLink>"
    },
    common_empty_state_heading: {
        id: "product_search_dialog.empty.no_results_heading",
        defaultMessage: "We couldn't find anything matching your search."
    },
    common_empty_state_prequery_heading: {
        id: "product_search_dialog.empty_prequery.no_results_heading",
        defaultMessage: "Search for what you need"
    },
    common_error_state_prequery_heading: {
        id: "product_search_dialog.empty_prequery.error_heading",
        defaultMessage: "Something went wrong with showing initial results"
    },
    common_show_more_results_link: {
        id: "product_search_dialog.show_more_results_link",
        defaultMessage: "Show more"
    },
    common_show_all_results_link: {
        id: "product_search_dialog.show_all_results_link",
        defaultMessage: "View all results"
    },
    common_search_people_link: {
        id: "product_search_dialog.search_people_link",
        defaultMessage: "Search people"
    },
    common_search_input_collapsed_placeholder: {
        id: "product_search_dialog.search_input_collapsed_placeholder",
        defaultMessage: "Search"
    },
    common_search_input_enlarged_aria_label: {
        id: "product_search_dialog.search_input_enlarged_aria_label",
        defaultMessage: "Press enter to navigate to advanced search"
    },
    common_empty_state_body: {
        id: "product_search_dialog.empty.no_results_body",
        defaultMessage: "Try again with a different term, or refine your results with <a>Advanced Search</a>"
    },
    common_empty_state_body_no_advanced_search: {
        id: "product_search_dialog.empty.no_results_body_with_no_advanced_search",
        defaultMessage: "Try again with a different term."
    },
    common_give_feedback: {
        id: "product_search_dialog.give_feedback",
        defaultMessage: "Give feedback"
    },
    common_inline_onboarding_title: {
        id: "product_search_dialog.inline_onboarding_title",
        defaultMessage: "Search across Jira and Confluence"
    },
    common_inline_onboarding_body: {
        id: "product_search_dialog.inline_onboarding_body",
        defaultMessage: "Use the Jira and Confluence tabs to search and see recent items in either location."
    },
    common_inline_onboarding_action: {
        id: "product_search_dialog.inline_onboarding_action",
        defaultMessage: "Ok"
    },
    common_search_input_exit_button_label: {
        id: "search_dialog.search_input_exit_label",
        defaultMessage: "Exit Search"
    },
    common_search_input_clear_button_label: {
        id: "search_dialog.search_input_clear_label",
        defaultMessage: "Clear search session"
    },
    multi_site_advanced_search_label: {
        id: "product_search_dialog.multi_site_advanced_search_label",
        defaultMessage: "Search on:"
    },
    multi_site_advanced_search_more_dropdown: {
        id: "product_search_dialog.multi_site_advanced_search_more_dropdown",
        defaultMessage: "{count} more"
    },
    common_autocorrection_label: {
        id: "product_search_dialog.autocorrection.label",
        defaultMessage: "Did you mean"
    },
    /**
   * Cross product
   */ jira_tab_label: {
        id: "cross_product_search_dialog.jira.tab_label",
        defaultMessage: "Jira"
    },
    confluence_tab_label: {
        id: "cross_product_search_dialog.confluence.tab_label",
        defaultMessage: "Confluence"
    },
    atlas_tab_label: {
        id: "cross_product_search_dialog.atlas.tab_label",
        defaultMessage: "Atlas"
    },
    bitbucket_tab_label: {
        id: "cross_product_search_dialog.bitbucket.tab_label",
        defaultMessage: "Bitbucket"
    },
    opsgenie_tab_label: {
        id: "cross_product_search_dialog.opsgenie.tab_label",
        defaultMessage: "Opsgenie"
    },
    trello_tab_label: {
        id: "cross_product_search_dialog.trello.tab_label",
        defaultMessage: "Trello"
    },
    view_all_results_link: {
        id: "cross_product_search_dialog.view_all_results_link",
        defaultMessage: "View all {sectionTitle}"
    },
    recently_viewed_title: {
        id: "cross_product_search_dialog.recently_viewed_title",
        defaultMessage: "Recently Viewed {sectionTitle}"
    },
    /**
   * Common Confluence Messages
   */ confluence_people_section_heading: {
        id: "product_search_dialog.confluence.people_section_heading",
        defaultMessage: "People"
    },
    confluence_content_section_heading: {
        id: "product_search_dialog.confluence.content_section_heading",
        defaultMessage: "Content"
    },
    confluence_spaces_section_heading: {
        id: "product_search_dialog.confluence.spaces_section_heading",
        defaultMessage: "Spaces"
    },
    confluence_search_input_expanded_placeholder: {
        id: "product_search_dialog.confluence.search_input_expanded_placeholder",
        defaultMessage: "Search Confluence"
    },
    confluence_search_input_expanded_placeholder_ai: {
        id: "product_search_dialog.confluence.search_input_expanded_placeholder_ai",
        defaultMessage: "Search or ask questions within your Confluence"
    },
    confluence_pages_blogs_attachments_section_heading: {
        id: "product_search_dialog.confluence.pages_blogs_attachments_section_heading",
        defaultMessage: "Pages, blogs and attachments"
    },
    /**
   * Common Filtering Messages
   */ filters_applied: {
        id: "product_search_dialog.confluence.filters_applied",
        defaultMessage: "Looks like you have some filters applied"
    },
    clear_filters: {
        id: "product_search_dialog.confluence.clear_filters",
        defaultMessage: "Clear filters"
    },
    show_more_filters: {
        id: "search_dialog.filters.group.show-more",
        defaultMessage: "Show more"
    },
    more_filters: {
        id: "product_search_dialog.more_filters",
        defaultMessage: "View all filters"
    },
    no_options_filters: {
        id: "product_search_dialog.no_options_filters",
        defaultMessage: "No options"
    },
    loading_filters: {
        id: "product_search_dialog.loading_filters",
        defaultMessage: "Loading"
    },
    site_filters_title: {
        id: "product_search_dialog.common.site_filters",
        defaultMessage: "Filter by site"
    },
    space_filters_title: {
        id: "product_search_dialog.confluence.space_filters",
        defaultMessage: "Filter by space"
    },
    contributor_filters_title: {
        id: "product_search_dialog.confluence.contributor_filters",
        defaultMessage: "Filter by contributor"
    },
    contributor_filters_find_more: {
        id: "product_search_dialog.confluence.contributor_filters_find_more",
        defaultMessage: "Find a contributor"
    },
    space_filters_find_more: {
        id: "product_search_dialog.confluence.space_filters_find_more",
        defaultMessage: "Find a space"
    },
    site_filters_find_more: {
        id: "product_search_dialog.jira.site_filters_find_more",
        defaultMessage: "Find a site"
    },
    project_filters_find_more: {
        id: "product_search_dialog.jira.project_filters_find_more",
        defaultMessage: "Find a project"
    },
    project_filters_title: {
        id: "product_search_dialog.jira.project_filters",
        defaultMessage: "Filter by project"
    },
    assignee_filters_find_more: {
        id: "product_s earch_dialog.confluence.assignee_filters_find_more",
        defaultMessage: "Find an assignee"
    },
    assignee_filters_title: {
        id: "product_search_dialog.jira.assignee_filters",
        defaultMessage: "Filter by assignee"
    },
    binary_status_category_filters_title: {
        id: "product_search_dialog.jira.issue_filters",
        defaultMessage: "Filter by status"
    },
    binary_status_category_filter_option_done: {
        id: "product_search_dialog.jira.issue_filter_done",
        defaultMessage: "Done"
    },
    binary_status_category_filter_option_open: {
        id: "product_search_dialog.jira.issue_filter_open",
        defaultMessage: "Open"
    },
    date_filter_any_time_label: {
        id: "product_search_dialog.jira.date_filter_any",
        defaultMessage: "Any time"
    },
    date_filter_filters_title: {
        id: "product_search_dialog.jira.date_filters",
        defaultMessage: "Last updated"
    },
    /**
   * Common Jira Messages
   */ jira_advanced_search_label: {
        id: "global_search.jira.advanced_search_label",
        defaultMessage: "Go to all:"
    },
    jira_advanced_search_issues: {
        id: "global_search.jira.advanced_search_issues",
        defaultMessage: "Issues"
    },
    jira_advanced_search_projects: {
        id: "global_search.jira.advanced_search_projects",
        defaultMessage: "Projects"
    },
    jira_advanced_search_boards: {
        id: "global_search.jira.advanced_search_boards",
        defaultMessage: "Boards"
    },
    jira_advanced_search_filters: {
        id: "global_search.jira.advanced_search_filters",
        defaultMessage: "Filters"
    },
    jira_advanced_search_plans: {
        id: "global_search.jira.advanced_search_plans",
        defaultMessage: "Plans"
    },
    jira_advanced_search_people: {
        id: "global_search.jira.advanced_search_people",
        defaultMessage: "People"
    },
    jira_empty_state_prequery_heading: {
        id: "product_search_dialog.jira.empty_prequery.no_results_heading",
        defaultMessage: "Start searching to find your work"
    },
    jira_issues_section_heading: {
        id: "product_search_dialog.jira.issues_section_heading",
        defaultMessage: "Issues"
    },
    jira_boards_projects_filters_section_heading: {
        id: "product_search_dialog.jira.boards_projects_filters_section_heading",
        defaultMessage: "Boards, Projects and Filters"
    },
    jira_projects_filters_section_heading: {
        id: "product_search_dialog.jira.projects_filters_section_heading",
        defaultMessage: "Projects and Filters"
    },
    jira_boards_projects_filters_plans_section_heading: {
        id: "product_search_dialog.jira.boards_projects_filters_plans_section_heading",
        defaultMessage: "Boards, Projects, Filters and Plans"
    },
    jira_view_all_issues_new: {
        id: "product_search_dialog.jira.jira_view_all_issues_new",
        defaultMessage: "View all issues"
    },
    jira_recent_boards_projects_filters_section_heading: {
        id: "product_search_dialog.jira.recent_boards_projects_filters_section_heading",
        defaultMessage: "Recent Boards, Projects and Filters"
    },
    jira_recent_projects_filters_section_heading: {
        id: "product_search_dialog.jira.recent_projects_filters_section_heading",
        defaultMessage: "Recent Projects and Filters"
    },
    jira_recent_boards_projects_filters_plans_section_heading: {
        id: "product_search_dialog.jira.recent_boards_projects_filters_plans_section_heading",
        defaultMessage: "Recent Boards, Projects, Filters and Plans"
    },
    jira_recently_viewed_issues_section_heading: {
        id: "product_search_dialog.jira.recently_viewed_issues_section_heading",
        defaultMessage: "Recently viewed issues"
    },
    jira_search_placeholder: {
        id: "global_search.jira.search_placeholder",
        defaultMessage: "Search Jira"
    },
    jira_search_placeholder_experiment_jsw_enabled: {
        id: "global_search.jira.search_placeholder_experiment_jsw_enabled",
        defaultMessage: "Search for issues, boards, projects, and filters"
    },
    jira_advanced_search_issuesIssueTermRefresh: {
        id: "global_search.jira.advanced_search_issues-issue-term-refresh",
        defaultMessage: "Work items"
    },
    jira_issues_section_headingIssueTermRefresh: {
        id: "product_search_dialog.jira.issues_section_heading-issue-term-refresh",
        defaultMessage: "Work items"
    },
    jira_view_all_issues_newIssueTermRefresh: {
        id: "product_search_dialog.jira.jira_view_all_issues_new-issue-term-refresh",
        defaultMessage: "View all work items"
    },
    jira_recently_viewed_issues_section_headingIssueTermRefresh: {
        id: "product_search_dialog.jira.recently_viewed_issues_section_heading-issue-term-refresh",
        defaultMessage: "Recently viewed work items"
    },
    jira_search_placeholder_experiment_jsw_enabledIssueTermRefresh: {
        id: "global_search.jira.search_placeholder_experiment_jsw_enabled-issue-term-refresh",
        defaultMessage: "Search for work items, boards, projects, and filters"
    }
});

});

parcelRegister("4V3UW", function(module, exports) {

$parcel$export(module.exports, "AdvancedSearch", () => $2ba4e0bc1633544b$export$2709da4acd7d0aec);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $epvHH = parcelRequire("epvHH");
var $icqFF = parcelRequire("icqFF");

var $jEno1 = parcelRequire("jEno1");

var $3S0fp = parcelRequire("3S0fp");
var $5dFS9 = parcelRequire("5dFS9");
var $6dP89 = parcelRequire("6dP89");

var $5dFS9 = parcelRequire("5dFS9");

var $eKv3Q = parcelRequire("eKv3Q");
var $l3UB9 = parcelRequire("l3UB9");

var $fJRVo = parcelRequire("fJRVo");

var $2ZIpG = parcelRequire("2ZIpG");

var $b9sDF = parcelRequire("b9sDF");
const $2ba4e0bc1633544b$var$onKeyDown = (e, target, actionSubjectId, fireAnalyticsEvent)=>{
    if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        fireAnalyticsEvent((0, $5dFS9.onAdvancedSearchSelected)({
            trigger: (0, $5dFS9.Trigger).RETURN,
            actionSubjectId: actionSubjectId,
            isLoading: false,
            newTab: false
        }));
        // The ref here is the wrapper span however we simulate a click on the `ResultLinkComponent` that it wraps.
        target.firstElementChild?.click?.();
    }
};
const $2ba4e0bc1633544b$export$2709da4acd7d0aec = ({ advancedSearchMessage: advancedSearchMessage, advancedSearchUrl: advancedSearchUrl, linkComponent: linkComponent })=>{
    const { isLoading: isLoading } = (0, $2ZIpG.useQuery)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const productName = getActiveProduct()?.title;
    const actionSubjectId = `${productName}AdvancedSearchLink`;
    const onAdvancedSearchClicked = (0, $gwFzn.useCallback)((e)=>{
        fireAnalyticsEvent((0, $5dFS9.onAdvancedSearchSelected)({
            trigger: (0, $3S0fp.getTrigger)(e),
            actionSubjectId: actionSubjectId,
            isLoading: isLoading,
            newTab: (0, $3S0fp.isNewTab)(e)
        }));
    }, [
        fireAnalyticsEvent,
        actionSubjectId,
        isLoading
    ]);
    const [isKeyboardHighlighted, ref] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: (0, $gwFzn.useCallback)((e, target)=>$2ba4e0bc1633544b$var$onKeyDown(e, target, actionSubjectId, fireAnalyticsEvent), [
            actionSubjectId,
            fireAnalyticsEvent
        ])
    });
    if (!advancedSearchUrl || !advancedSearchMessage) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $b9sDF.AdvancedSearchLinkWrapper), {
        ref: ref,
        onClick: onAdvancedSearchClicked,
        role: "none",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $l3UB9.AdvancedSearchLink), {
            href: advancedSearchUrl,
            isKeyboardHighlighted: isKeyboardHighlighted,
            linkComponent: linkComponent,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eKv3Q.CenteredAdvancedSearchGroup), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jEno1))), {
                            color: "currentColor",
                            LEGACY_size: "small",
                            label: advancedSearchMessage
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eKv3Q.AdvancedSearchContent), {
                            children: advancedSearchMessage
                        })
                    ]
                }),
                isKeyboardHighlighted && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $epvHH.ReturnIcon), {
                    inverted: isKeyboardHighlighted
                })
            ]
        })
    });
};

});
parcelRegister("epvHH", function(module, exports) {

$parcel$export(module.exports, "ReturnIcon", () => $abe9af1675ab5b46$export$d6c38c54dfb7c9d5);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");
const $abe9af1675ab5b46$export$d6c38c54dfb7c9d5 = ({ inverted: inverted = false })=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                    width: "24",
                    height: "16",
                    fill: inverted ? `var(--ds-background-neutral-bold, ${0, $6fnsQ.N80})` : `var(--ds-background-neutral, ${0, $6fnsQ.N30})`,
                    rx: "3"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fill: inverted ? `var(--ds-icon-inverse, ${0, $6fnsQ.N30})` : `var(--ds-icon-subtle, ${0, $6fnsQ.N80})`,
                    fillRule: "nonzero",
                    d: "M8.12809107,9.16933636 C8.10113378,9.12943488 8.07791542,9.08679981 8.05893872,9.04193385 C8,8.89679975 7.98627063,8.74857828 8.01372937,8.60675456 C8.04118811,8.46493084 8.10983496,8.32950487 8.21966991,8.21966991 L9.96966991,6.46966991 C10.2625631,6.1767767 10.7374369,6.1767767 11.0303301,6.46966991 C11.3232233,6.76256313 11.3232233,7.23743687 11.0303301,7.53033009 L10.5606602,8 L12.75,8 C13.4403559,8 14,7.44035594 14,6.75 L14,5.75 C14,5.33578644 14.3357864,5 14.75,5 C15.1642136,5 15.5,5.33578644 15.5,5.75 L15.5,6.75 C15.5,8.26878306 14.2687831,9.5 12.75,9.5 L10.5606602,9.5 L11.0303301,9.96966991 C11.3232233,10.2625631 11.3232233,10.7374369 11.0303301,11.0303301 C10.7374369,11.3232233 10.2625631,11.3232233 9.96966991,11.0303301 L8.21966991,9.28033009 C8.18436185,9.24502202 8.15331014,9.20706939 8.1265148,9.16710979 Z"
                })
            ]
        })
    });

});

parcelRegister("3S0fp", function(module, exports) {

$parcel$export(module.exports, "sha256Hash", () => $17f8c3a758c1402a$export$e9131c78c1110376);
$parcel$export(module.exports, "getTrigger", () => $17f8c3a758c1402a$export$670ec347a1a78e34);
$parcel$export(module.exports, "isNewTab", () => $17f8c3a758c1402a$export$dfd8482ecf3b52d8);
$parcel$export(module.exports, "getWordCount", () => $17f8c3a758c1402a$export$dba3e2bcdbd49da4);

var $5dFS9 = parcelRequire("5dFS9");

var $3rxD2 = parcelRequire("3rxD2");
const $17f8c3a758c1402a$export$e9131c78c1110376 = (str)=>(0, (/*@__PURE__*/$parcel$interopDefault($3rxD2))).createHash('sha256').update(str).digest('hex');
const $17f8c3a758c1402a$export$670ec347a1a78e34 = (e)=>{
    if (e instanceof KeyboardEvent) return (0, $5dFS9.Trigger).RETURN;
    return e.screenX === 0 ? (0, $5dFS9.Trigger).RETURN : (0, $5dFS9.Trigger).CLICK;
};
const $17f8c3a758c1402a$export$dfd8482ecf3b52d8 = (e)=>{
    return !!(e && (e.metaKey || e.ctrlKey || e.shiftKey));
};
const $17f8c3a758c1402a$export$dba3e2bcdbd49da4 = (str)=>{
    return str.length > 0 ? str.split(/\s+/).length : 0;
};

});

parcelRegister("6dP89", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", () => $e245f4bcfda02d2d$export$e955abb82869dc84);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $5dFS9 = parcelRequire("5dFS9");
const $e245f4bcfda02d2d$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return {
        fireAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useCallback((payload)=>createAnalyticsEvent(payload).fire((0, $5dFS9.DEFAULT_GAS_CHANNEL)), [
            createAnalyticsEvent
        ])
    };
};

});

parcelRegister("eKv3Q", function(module, exports) {

$parcel$export(module.exports, "CenteredAdvancedSearchGroup", () => $73c221919444c9a0$export$5d708f1c4bba7ac3);
$parcel$export(module.exports, "StyledAdvancedSearch", () => $73c221919444c9a0$export$ffb3e5c7f83e1d2f);
$parcel$export(module.exports, "AdvancedSearchContent", () => $73c221919444c9a0$export$aa7c31826bbddc7b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $2hEyf = parcelRequire("2hEyf");

var $kPBHE = parcelRequire("kPBHE");

var $gwrgp = parcelRequire("gwrgp");
const $73c221919444c9a0$export$5d708f1c4bba7ac3 = (0, $gwrgp.default)("div", {
    target: "e1fpfwrr0"
})({
    name: "70qvj9",
    styles: "display:flex;align-items:center;"
});
const $73c221919444c9a0$var$outlineWidth = 2;
const $73c221919444c9a0$export$ffb3e5c7f83e1d2f = /*#__PURE__*/ (0, $gwrgp.default)((0, $kPBHE.Link), {
    target: "e1fpfwrr1"
})((props)=>({
        alignItems: 'center',
        color: `var(--ds-text, ${0, $6fnsQ.N900})`,
        cursor: 'pointer',
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        padding: `${"var(--ds-space-075, 6px)"} ${16 - $73c221919444c9a0$var$outlineWidth}px`,
        border: `${$73c221919444c9a0$var$outlineWidth}px solid transparent`,
        '&:hover': {
            color: `var(--ds-text, ${0, $6fnsQ.N900})`,
            backgroundColor: `var(--ds-background-neutral, ${0, $6fnsQ.N20})`,
            textDecoration: 'none'
        },
        '&:visited': {
            color: `var(--ds-text, ${0, $6fnsQ.N900})`
        },
        '&:focus': {
            outline: 'none',
            border: `${$73c221919444c9a0$var$outlineWidth}px solid ${`var(--ds-border-focused, ${0, $6fnsQ.B100})`}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? `var(--ds-background-neutral, ${0, $6fnsQ.N20})` : `var(--ds-background-neutral-subtle, ${0, $6fnsQ.N0})`
    }));
const $73c221919444c9a0$export$aa7c31826bbddc7b = (0, $gwrgp.default)("span", {
    target: "e1fpfwrr2"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body, ${(0, $2hEyf.fontFallback).body.medium})`,
    paddingLeft: "var(--ds-space-200, 16px)",
    display: 'flex',
    alignItems: 'center'
});

});

parcelRegister("l3UB9", function(module, exports) {

$parcel$export(module.exports, "AdvancedSearchLink", () => $2b4af01aea146af3$export$3f63855034354a21);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $eKv3Q = parcelRequire("eKv3Q");
const $2b4af01aea146af3$export$3f63855034354a21 = ({ href: href, linkComponent: linkComponent, ...rest })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $eKv3Q.StyledAdvancedSearch), {
        linkComponent: linkComponent,
        "data-test-id": "search-dialog-advanced-search-link",
        href: href,
        ...rest
    });

});

parcelRegister("2ZIpG", function(module, exports) {

$parcel$export(module.exports, "QueryContextProvider", () => $2904842909f92043$export$96e4d538f00fbce1);
$parcel$export(module.exports, "useQuery", () => $2904842909f92043$export$dd0a697e1782aedd);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $80L9g = parcelRequire("80L9g");

var $hpDfc = parcelRequire("hpDfc");
var $PfqP9 = parcelRequire("PfqP9");

var $gF7Az = parcelRequire("gF7Az");
const $2904842909f92043$var$QueryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    query: '',
    queryVersion: 0,
    isLoading: false,
    setQuery: (ignore)=>{},
    setQueryOnly: (ignore)=>{},
    setAdditionalAnalyticsContext: (ignore)=>({})
});
const $2904842909f92043$export$96e4d538f00fbce1 = ({ children: children })=>{
    const [stateQuery, setStateQuery] = (0, $gwFzn.useState)('');
    const { stickySearchEnabled: stickySearchEnabled, query: sessionQuery, showSearchAIDialog: showSearchAIDialog, toggleShowSearchAIDialog: toggleShowSearchAIDialog, storeQuery: storeQuery } = (0, $80L9g.useSessionUserInput)();
    const query = stickySearchEnabled ? sessionQuery : stateQuery;
    const setQuery = (0, $gwFzn.useCallback)((value)=>{
        if (showSearchAIDialog) toggleShowSearchAIDialog(false);
        stickySearchEnabled ? storeQuery(value) : setStateQuery(value);
    }, [
        showSearchAIDialog,
        toggleShowSearchAIDialog,
        stickySearchEnabled,
        storeQuery
    ]);
    const setQueryOnly = (0, $gwFzn.useCallback)((value)=>{
        stickySearchEnabled ? storeQuery(value) : setStateQuery(value);
    }, [
        stickySearchEnabled,
        storeQuery
    ]);
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { isLoading: isLoading, setAdditionalAnalyticsContext: setAdditionalAnalyticsContext, addAnalyticContext: addAnalyticContext, nonPrivacySafeContext: nonPrivacySafeContext, queryVersion: queryVersion } = (0, $PfqP9.useAnalyticsContext)(query);
    (0, $gwFzn.useEffect)(()=>{
        if (!isExpanded) {
            if (!stickySearchEnabled) setQuery('');
            setAdditionalAnalyticsContext({
                type: 'reset'
            });
        }
    }, [
        isExpanded,
        setAdditionalAnalyticsContext,
        stickySearchEnabled,
        setQuery
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($2904842909f92043$var$QueryContext.Provider, {
        value: {
            query: query,
            queryVersion: queryVersion,
            setQuery: setQuery,
            setQueryOnly: setQueryOnly,
            setAdditionalAnalyticsContext: setAdditionalAnalyticsContext,
            isLoading: isLoading
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
            analyticContext: addAnalyticContext,
            nonPrivacySafeAnalyticContextGenerator: nonPrivacySafeContext,
            children: children
        })
    });
};
const $2904842909f92043$export$dd0a697e1782aedd = ()=>{
    return (0, $gwFzn.useContext)($2904842909f92043$var$QueryContext);
};

});
parcelRegister("80L9g", function(module, exports) {

$parcel$export(module.exports, "UserInputContextProvider", () => $14178128195429da$export$dab413a8570d1ac4);
$parcel$export(module.exports, "useSessionUserInput", () => $14178128195429da$export$296c1552a8cb35a5);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $epS7s = parcelRequire("epS7s");

var $5dFS9 = parcelRequire("5dFS9");
var $hpDfc = parcelRequire("hpDfc");
var $6dP89 = parcelRequire("6dP89");
const $14178128195429da$var$noop = ()=>{};
const $14178128195429da$var$SESSION_RESET_TIMEOUT_MS = 300000;
const $14178128195429da$var$anyConfluenceFiltersChecked = (filters)=>{
    const confluencefilters = filters.confluence;
    if (confluencefilters) {
        const hasSpaceFilterChecked = confluencefilters.space?.length ? confluencefilters.space?.some((filter)=>{
            return filter.isChecked;
        }) : false;
        const hasPeopleFilterChecked = confluencefilters.people?.length ? confluencefilters.people?.some((filter)=>{
            return filter.isChecked;
        }) : false;
        const hasSiteFilterChecked = confluencefilters.site?.length ? confluencefilters.site?.some((filter)=>{
            return filter.isChecked;
        }) : false;
        return hasSpaceFilterChecked || hasPeopleFilterChecked || hasSiteFilterChecked;
    }
    return false;
};
const $14178128195429da$export$c87c231bb0fb0228 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    stickySearchEnabled: false,
    query: '',
    showSearchAIDialog: false,
    storeQuery: $14178128195429da$var$noop,
    toggleShowSearchAIDialog: $14178128195429da$var$noop,
    readFilters: $14178128195429da$var$noop,
    storeFilters: $14178128195429da$var$noop,
    resetSearchSession: $14178128195429da$var$noop,
    resetConfluenceFiltersRef: undefined,
    resetExtensibleFiltersRef: undefined
});
const $14178128195429da$export$dab413a8570d1ac4 = ({ stickySearchEnabled: stickySearchEnabled = false, sessionResetIdleTime: sessionResetIdleTime = $14178128195429da$var$SESSION_RESET_TIMEOUT_MS, isExpanded: isExpanded = false, resetStickySearchRef: resetStickySearchRef, children: children })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const [query, setQuery] = (0, $gwFzn.useState)((0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_QUERY_KEY)) || '');
    const [isStickyUpdated, setIsStickyUpdated] = (0, $gwFzn.useState)(false);
    const [stickyQueryUpdated, setStickyQueryUpdated] = (0, $gwFzn.useState)(false);
    const queryFirstUpdatedRef = (0, $gwFzn.useRef)(undefined);
    const lastExpandRef = (0, $gwFzn.useRef)(false);
    const lastQueryRef = (0, $gwFzn.useRef)('');
    const timeoutRef = (0, $gwFzn.useRef)();
    const resetConfluenceFiltersRef = (0, $gwFzn.useRef)();
    const resetExtensibleFiltersRef = (0, $gwFzn.useRef)();
    const sessionShowSearchAIDialogStr = (0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_SHOW_AI_DIALOG_KEY));
    const sessionShowSearchAIDialog = sessionShowSearchAIDialogStr ? JSON.parse(sessionShowSearchAIDialogStr) : false;
    const [showSearchAIDialog, setShowSearchAIDialog] = (0, $gwFzn.useState)(sessionShowSearchAIDialog);
    const resetSearchSession = (0, $gwFzn.useCallback)(()=>{
        (0, $epS7s.deleteSessionItem)((0, $epS7s.SEARCH_QUERY_KEY));
        (0, $epS7s.deleteSessionItem)((0, $epS7s.SEARCH_FILTERS_KEY));
        (0, $epS7s.deleteSessionItem)((0, $epS7s.SEARCH_SHOW_AI_DIALOG_KEY));
        resetConfluenceFiltersRef.current?.();
        resetExtensibleFiltersRef.current?.();
        setQuery('');
        setShowSearchAIDialog(false);
        queryFirstUpdatedRef.current = undefined;
        lastQueryRef.current = '';
    }, [
        resetConfluenceFiltersRef,
        resetExtensibleFiltersRef
    ]);
    const readFilters = (0, $gwFzn.useCallback)((productId)=>{
        const searchFilterString = (0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_FILTERS_KEY));
        const filters = searchFilterString ? JSON.parse(searchFilterString) : {};
        if (productId in filters) return filters[productId];
        return {};
    }, []);
    const updateSessionResetTimeout = (0, $gwFzn.useCallback)(()=>{
        if (timeoutRef?.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>{
            if (timeoutRef?.current) clearTimeout(timeoutRef.current);
            const searchFilterString = (0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_FILTERS_KEY));
            const filters = searchFilterString ? JSON.parse(searchFilterString) : {};
            if (query === '' && !$14178128195429da$var$anyConfluenceFiltersChecked(filters)) return; // Skip the reset and analytics event if no filters or query entered
            resetSearchSession();
            fireAnalyticsEvent((0, $5dFS9.onStickySearchCleared)({
                timeout: sessionResetIdleTime
            }));
        }, sessionResetIdleTime);
    }, [
        query,
        sessionResetIdleTime,
        resetSearchSession,
        fireAnalyticsEvent
    ]);
    const storeQuery = (0, $gwFzn.useCallback)((query)=>{
        setQuery(query);
        (0, $epS7s.setSessionItem)((0, $epS7s.SEARCH_QUERY_KEY), query);
        updateSessionResetTimeout();
        if (queryFirstUpdatedRef.current === undefined) queryFirstUpdatedRef.current = Date.now();
        if (lastQueryRef.current) setStickyQueryUpdated(query !== lastQueryRef.current);
    }, [
        updateSessionResetTimeout
    ]);
    const toggleShowSearchAIDialog = (0, $gwFzn.useCallback)((showSearchAIDialog)=>{
        setShowSearchAIDialog(showSearchAIDialog);
        (0, $epS7s.setSessionItem)((0, $epS7s.SEARCH_SHOW_AI_DIALOG_KEY), showSearchAIDialog.toString());
    }, []);
    const storeFilters = (0, $gwFzn.useCallback)((productId, value)=>{
        const searchFilterString = (0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_FILTERS_KEY));
        const filters = searchFilterString ? JSON.parse(searchFilterString) : {};
        filters[productId] = value;
        (0, $epS7s.setSessionItem)((0, $epS7s.SEARCH_FILTERS_KEY), JSON.stringify(filters));
        if (lastExpandRef.current) updateSessionResetTimeout;
    }, [
        lastExpandRef,
        updateSessionResetTimeout
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (resetStickySearchRef) resetStickySearchRef.current = resetSearchSession;
    });
    (0, $gwFzn.useEffect)(()=>{
        if (!lastExpandRef.current && isExpanded) updateSessionResetTimeout();
        if (lastExpandRef.current && !isExpanded) updateSessionResetTimeout();
    }, [
        lastExpandRef,
        isExpanded,
        updateSessionResetTimeout
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!lastExpandRef.current && isExpanded) {
            setIsStickyUpdated(query !== '');
            lastQueryRef.current = query;
            setStickyQueryUpdated(false);
        }
        lastExpandRef.current = isExpanded;
    }, [
        isExpanded,
        lastExpandRef,
        lastQueryRef,
        query
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($14178128195429da$export$c87c231bb0fb0228.Provider, {
        value: {
            stickySearchEnabled: stickySearchEnabled,
            query: query,
            showSearchAIDialog: showSearchAIDialog,
            storeQuery: stickySearchEnabled ? storeQuery : $14178128195429da$var$noop,
            toggleShowSearchAIDialog: toggleShowSearchAIDialog,
            readFilters: stickySearchEnabled ? readFilters : $14178128195429da$var$noop,
            storeFilters: stickySearchEnabled ? storeFilters : $14178128195429da$var$noop,
            resetSearchSession: stickySearchEnabled ? resetSearchSession : $14178128195429da$var$noop,
            resetConfluenceFiltersRef: stickySearchEnabled ? resetConfluenceFiltersRef : undefined,
            resetExtensibleFiltersRef: stickySearchEnabled ? resetExtensibleFiltersRef : undefined
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
            analyticContext: stickySearchEnabled ? {
                isSticky: true,
                isStickyUpdated: isStickyUpdated,
                stickyQueryUpdated: stickyQueryUpdated,
                queryUpdatedAgo: queryFirstUpdatedRef.current ? Date.now() - queryFirstUpdatedRef.current : undefined
            } : {
                isSticky: false
            },
            children: children
        })
    });
};
const $14178128195429da$export$296c1552a8cb35a5 = ()=>{
    return (0, $gwFzn.useContext)($14178128195429da$export$c87c231bb0fb0228);
};

});

parcelRegister("PfqP9", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", () => $bdba8c9822bcf66e$export$d1f587f82ad51c4);

var $gwFzn = parcelRequire("gwFzn");

var $3S0fp = parcelRequire("3S0fp");
const $bdba8c9822bcf66e$var$defaultAnalyticsContextState = {
    queryVersion: 0,
    isLoading: false
};
const $bdba8c9822bcf66e$var$analyticsContextReducer = (state, action)=>{
    switch(action.type){
        case 'queryVersion':
            return {
                ...state,
                queryVersion: action.value
            };
        case 'isLoading':
            return {
                ...state,
                isLoading: action.value
            };
        case 'reset':
            return $bdba8c9822bcf66e$var$defaultAnalyticsContextState;
        default:
            throw new Error();
    }
};
const $bdba8c9822bcf66e$export$d1f587f82ad51c4 = (query)=>{
    const [{ queryVersion: queryVersion, isLoading: isLoading }, setAdditionalAnalyticsContext] = (0, $gwFzn.useReducer)($bdba8c9822bcf66e$var$analyticsContextReducer, $bdba8c9822bcf66e$var$defaultAnalyticsContextState);
    const addAnalyticContext = (0, $gwFzn.useCallback)(()=>{
        return {
            wordCount: (0, $3S0fp.getWordCount)(query),
            queryLength: query.length,
            queryHash: (0, $3S0fp.sha256Hash)(query),
            queryHashSHA256: (0, $3S0fp.sha256Hash)(query),
            queryVersion: queryVersion
        };
    }, [
        query,
        queryVersion
    ]);
    const nonPrivacySafeContext = (0, $gwFzn.useCallback)(()=>{
        return {
            query: query
        };
    }, [
        query
    ]);
    return {
        isLoading: isLoading,
        setAdditionalAnalyticsContext: setAdditionalAnalyticsContext,
        addAnalyticContext: addAnalyticContext,
        nonPrivacySafeContext: nonPrivacySafeContext,
        queryVersion: queryVersion
    };
};

});


parcelRegister("b9sDF", function(module, exports) {

$parcel$export(module.exports, "AdvancedSearchLinkWrapper", () => $7f9d1377acc537c5$export$8e79650dab255425);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// AdvancedSearchLinkWrapper component is used for keyboard highlighting
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwrgp = parcelRequire("gwrgp");
const $7f9d1377acc537c5$export$8e79650dab255425 = (0, $gwrgp.default)("span", {
    target: "ecy8ma0"
})({
    name: "hboir5",
    styles: "display:flex;width:100%;"
});

});


parcelRegister("a5cba", function(module, exports) {

$parcel$export(module.exports, "SearchDialogProduct", () => $37edf39650c77c6a$export$bea8d7c130bb15c8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5UXzK = parcelRequire("5UXzK");

var $dByQx = parcelRequire("dByQx");

var $gF7Az = parcelRequire("gF7Az");

var $7a9pa = parcelRequire("7a9pa");

var $1e3Dw = parcelRequire("1e3Dw");
const $37edf39650c77c6a$export$bea8d7c130bb15c8 = ({ generateAdvancedSearchUrl: genUrl, ...rest })=>{
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const generateAdvancedSearchUrl = (0, $1e3Dw.useGenerateAdvancedSearchUrl)(genUrl);
    const props = {
        ...rest,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dByQx.default), {
        ...props,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5UXzK.AsyncProduct), {
            ...props,
            fallback: !isExpanded ? ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}) : undefined,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7a9pa.AsyncProvider), {
                ...props
            })
        })
    });
};

});
parcelRegister("5UXzK", function(module, exports) {

$parcel$export(module.exports, "AsyncProduct", () => $b2233dbfbf7baa26$export$ea887de8bd536d84);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $7prbm = parcelRequire("7prbm");

var $2jYn8 = parcelRequire("2jYn8");

var $fJRVo = parcelRequire("fJRVo");

var $cpIJW = parcelRequire("cpIJW");

var $bBxPo = parcelRequire("bBxPo");
class $b2233dbfbf7baa26$export$6bc62c4e30aa3c0a extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentWillUnmount() {
        const { removeProduct: removeProduct, id: id } = this.props;
        removeProduct(id);
    }
    render() {
        const { fallback: FallbackComponent, id: id, children: children } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Suspense), {
            fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bBxPo.ActiveProduct), {
                id: id,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7prbm.TimeLazyLoad), {
                    product: id,
                    children: FallbackComponent ? /*#__PURE__*/ (0, $7UHDa.jsx)(FallbackComponent, {}) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2jYn8.LoadingSpinner), {})
                })
            }),
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cpIJW.InitialisationExperienceSuccess), {
                    ...this.props
                }),
                children
            ]
        });
    }
}
const $b2233dbfbf7baa26$export$ea887de8bd536d84 = (0, $fJRVo.withProductContext)($b2233dbfbf7baa26$export$6bc62c4e30aa3c0a);

});
parcelRegister("7prbm", function(module, exports) {

$parcel$export(module.exports, "TimeLazyLoad", () => $cd5e177fbad53fb4$export$5a31ea5680c95894);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6dP89 = parcelRequire("6dP89");

var $5dFS9 = parcelRequire("5dFS9");
const $cd5e177fbad53fb4$export$5a31ea5680c95894 = ({ children: children, product: product })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    (0, $gwFzn.useEffect)(()=>{
        const start = Date.now();
        return ()=>{
            fireAnalyticsEvent((0, $5dFS9.onPaneLoadComplete)(product, Date.now() - start));
        };
    }, [
        fireAnalyticsEvent,
        product
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};

});

parcelRegister("2jYn8", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", () => $2eff2ad85863b392$export$b08b517936747730);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $jYL82 = parcelRequire("jYL82");

var $9hlns = parcelRequire("9hlns");
const $2eff2ad85863b392$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $jYL82.SpinnerContainer), {
        "data-testid": "search-dialog-loading-spinner",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jYL82.HorizontalCenteredContainer), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {})
        })
    });

});
parcelRegister("jYL82", function(module, exports) {

$parcel$export(module.exports, "HorizontalCenteredContainer", () => $63fd68c4ea134445$export$574c01fef92380ae);
$parcel$export(module.exports, "SpinnerContainer", () => $63fd68c4ea134445$export$a5e06607a5ac6158);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dTk3A = parcelRequire("dTk3A");

var $gwrgp = parcelRequire("gwrgp");
const $63fd68c4ea134445$export$574c01fef92380ae = (0, $gwrgp.default)("div", {
    target: "eh93uzp0"
})({
    name: "13o6z6d",
    styles: "margin:0 auto;"
});
const $63fd68c4ea134445$export$a5e06607a5ac6158 = (0, $gwrgp.default)("div", {
    target: "eh93uzp1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $dTk3A.gridSize)() * 12}px`,
    width: '100%',
    display: 'flex',
    alignItems: 'center'
});

});


parcelRegister("cpIJW", function(module, exports) {

$parcel$export(module.exports, "InitialisationExperienceSuccess", () => $fe5a5ea44cc052c2$export$12ba87fc0c8ef4e3);

var $gwFzn = parcelRequire("gwFzn");

var $gRazf = parcelRequire("gRazf");

var $fJRVo = parcelRequire("fJRVo");

var $jAnRi = parcelRequire("jAnRi");
const $fe5a5ea44cc052c2$export$7f8c86254a9e879c = ({ id: id, abTest: abTest, getPrimaryProduct: getPrimaryProduct })=>{
    const [successCalled, setSuccessCalled] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (successCalled) return;
        const primaryProduct = getPrimaryProduct();
        if (abTest && primaryProduct && primaryProduct.id === id) {
            (0, $jAnRi.initialisationExperience).success();
            setSuccessCalled(true);
        }
    }, [
        abTest,
        getPrimaryProduct,
        id,
        successCalled
    ]);
    return null;
};
const $fe5a5ea44cc052c2$export$12ba87fc0c8ef4e3 = (0, $gRazf.withABTestContext)((0, $fJRVo.withProductContext)($fe5a5ea44cc052c2$export$7f8c86254a9e879c));

});
parcelRegister("gRazf", function(module, exports) {

$parcel$export(module.exports, "ABTestContextProvider", () => $64a4585da9ac3d3b$export$e7d53dc13567ec0e);
$parcel$export(module.exports, "useABTest", () => $64a4585da9ac3d3b$export$14279a3fbdb52451);
$parcel$export(module.exports, "withABTestContext", () => $64a4585da9ac3d3b$export$5124bc23083a567d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $hpDfc = parcelRequire("hpDfc");
var $6dP89 = parcelRequire("6dP89");

var $5dFS9 = parcelRequire("5dFS9");

var $gJKpQ = parcelRequire("gJKpQ");
var $kmpep = parcelRequire("kmpep");

var $fJRVo = parcelRequire("fJRVo");

var $91yhh = parcelRequire("91yhh");

var $dByQx = parcelRequire("dByQx");

var $dh538 = parcelRequire("dh538");
const $64a4585da9ac3d3b$export$22966a5ebf51ce99 = {
    abTestId: 'default',
    controlId: 'default',
    experimentId: 'default'
};
const $64a4585da9ac3d3b$var$ABTestContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    abTest: null
});
const $64a4585da9ac3d3b$var$ABTestContextProviderStateless = ({ isMultiProduct: isMultiProduct, searchClient: searchClient, scope: scope, children: children, primaryProductId: primaryProductId, experience: experience })=>{
    const { backendExperiment: backendExperiment, frontendExperiments: frontendExperiments = {} } = (0, $91yhh.useExperiments)();
    const [abTest, setAbTest] = (0, $gwFzn.useState)(()=>{
        const defaultAbTest = (0, $dh538.fg)('qs-7058-remove-experiment-call-search-dialog') ? $64a4585da9ac3d3b$export$22966a5ebf51ce99 : null;
        return backendExperiment || defaultAbTest;
    });
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    (0, $gwFzn.useEffect)(()=>{
        const now = Date.now();
        if ((0, $dh538.fg)('qs-7058-remove-experiment-call-search-dialog') || !searchClient || !scope || abTest) return;
        if (scope === (0, $dByQx.PERFORMANCE_IMPROVEMENT_DUMMY_SECTION)) {
            setAbTest($64a4585da9ac3d3b$export$22966a5ebf51ce99);
            return;
        }
        searchClient// TODO: Remove PLACEHOLDER_EXPERIENCE
        .getAbTestData(scope, experience ?? (0, $gJKpQ.PLACEHOLDER_EXPERIENCE), primaryProductId).then((abTestResponse)=>{
            const duration = Date.now() - now;
            const abTestWithDefault = abTestResponse || $64a4585da9ac3d3b$export$22966a5ebf51ce99;
            setAbTest(abTestWithDefault);
            fireAnalyticsEvent((0, $5dFS9.onExperimentLoaded)(abTestWithDefault, duration, !!isMultiProduct));
        }).catch((e)=>{
            setAbTest($64a4585da9ac3d3b$export$22966a5ebf51ce99);
        });
    }, [
        searchClient,
        fireAnalyticsEvent,
        isMultiProduct,
        scope,
        abTest,
        primaryProductId,
        experience,
        backendExperiment
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($64a4585da9ac3d3b$var$ABTestContext.Provider, {
        value: {
            abTest: abTest
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
            analyticContext: {
                abTest: abTest || undefined,
                frontendExperiments: {
                    activeExperiments: Object.keys(frontendExperiments).filter((experiment)=>frontendExperiments[experiment]?.serveExperiment),
                    ...frontendExperiments
                }
            },
            nonPrivacySafeAnalyticContext: {},
            children: children
        })
    });
};
const $64a4585da9ac3d3b$export$e7d53dc13567ec0e = (props)=>{
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const searchClient = (0, $kmpep.useAggregatorClient)();
    const primaryProduct = getPrimaryProduct();
    const { sectionIds: sectionIds } = primaryProduct || {};
    const scope = (0, $gwFzn.useMemo)(()=>sectionIds && sectionIds.length > 0 ? sectionIds[0] : undefined, [
        sectionIds
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($64a4585da9ac3d3b$var$ABTestContextProviderStateless, {
        ...props,
        scope: scope,
        searchClient: searchClient,
        primaryProductId: primaryProduct?.id
    });
};
const $64a4585da9ac3d3b$export$14279a3fbdb52451 = ()=>{
    const { abTest: abTest } = (0, $gwFzn.useContext)($64a4585da9ac3d3b$var$ABTestContext);
    return abTest;
};
const $64a4585da9ac3d3b$export$5124bc23083a567d = (WrappedComponent)=>{
    return (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)(WrappedComponent, {
            ...props,
            ...(0, $gwFzn.useContext)($64a4585da9ac3d3b$var$ABTestContext)
        });
};

});
parcelRegister("dByQx", function(module, exports) {

$parcel$export(module.exports, "PERFORMANCE_IMPROVEMENT_DUMMY_SECTION", () => $0ab33f74cad490ac$export$d56c05d9b1186628);
$parcel$export(module.exports, "default", () => $0ab33f74cad490ac$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gJKpQ = parcelRequire("gJKpQ");
var $kmpep = parcelRequire("kmpep");

var $fJRVo = parcelRequire("fJRVo");

var $e0qNw = parcelRequire("e0qNw");
const $0ab33f74cad490ac$export$8e8702b7c6f58328 = ({ children: children, permissionSupplier: permissionSupplier, id: id, title: title, sections: sections, order: order, generateAdvancedSearchUrl: generateAdvancedSearchUrl, expandedStateInputPlaceholder: expandedStateInputPlaceholder, workspaces: workspaces, autocorrectEnabled: autocorrectEnabled, showViewAllFiltersLink: showViewAllFiltersLink, tabRenderer: tabRenderer, aiSearchConfig: aiSearchConfig, showSearchOnEnter: showSearchOnEnter })=>{
    const invokePostQuerySearchRef = (0, $gwFzn.useRef)(()=>{});
    const [allowedSections, setAllowedSections] = (0, $gwFzn.useState)([]);
    const searchClient = (0, $kmpep.useAggregatorClient)();
    (0, $gwFzn.useEffect)(()=>{
        if (allowedSections.length === 0) {
            // For Jira we need to improve performance by not rendering all the search dialog tabs before the
            // dialog is expanded. However, in order to ensure that the search component is interactive there needs
            // to be at least one allowed section. This test is a workaround to ensure that when there is only this
            // single dummy section that it is included without a permission check. This hook will be called again
            // when the search dialog is expanded and the real sections are provided.
            if (sections.length === 1 && sections[0].id === $0ab33f74cad490ac$export$d56c05d9b1186628) {
                setAllowedSections([
                    $0ab33f74cad490ac$export$d56c05d9b1186628
                ]);
                return;
            } else {
                const promise = permissionSupplier ? permissionSupplier() : searchClient ? searchClient.batchedGetExtensibleProductPermission(id, {
                    productIds: [
                        id
                    ],
                    experience: (0, $gJKpQ.PLACEHOLDER_EXPERIENCE)
                }) : Promise.resolve([]);
                promise.then((response)=>{
                    setAllowedSections(response);
                });
            }
        }
    /**
		 * We want to replicate componentDidMount behaviour to avoid invoking the API multiple times and we don't care if any other deps changed.
		 */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return allowedSections.length > 0 ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $e0qNw.default), {
            allowedSections: allowedSections,
            sections: sections,
            id: id,
            title: title,
            order: order,
            generateAdvancedSearchUrl: generateAdvancedSearchUrl,
            expandedStateInputPlaceholder: expandedStateInputPlaceholder,
            workspaces: workspaces,
            autocorrectEnabled: autocorrectEnabled,
            showViewAllFiltersLink: showViewAllFiltersLink,
            tabRenderer: tabRenderer,
            aiSearchConfig: aiSearchConfig,
            showSearchOnEnter: showSearchOnEnter,
            invokePostQuerySearchRef: invokePostQuerySearchRef,
            children: children
        })
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
};
const $0ab33f74cad490ac$export$d56c05d9b1186628 = '__PERFORMANCE_IMPROVEMENT_DUMMY_SECTION__';
var $0ab33f74cad490ac$export$2e2bcd8739ae039 = (0, $fJRVo.withProductContext)($0ab33f74cad490ac$export$8e8702b7c6f58328);

});
parcelRegister("e0qNw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e48ac6f5e264642a$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fJRVo = parcelRequire("fJRVo");
const $e48ac6f5e264642a$export$90be722c085777fe = ({ addProduct: addProduct, showProduct: showProduct, updateProduct: updateProduct, id: id, title: title, children: children, allowedSections: allowedSections, sections: sections, order: order, generateAdvancedSearchUrl: generateAdvancedSearchUrl, expandedStateInputPlaceholder: expandedStateInputPlaceholder, workspaces: workspaces, autocorrectEnabled: autocorrectEnabled, showViewAllFiltersLink: showViewAllFiltersLink, tabRenderer: tabRenderer, aiSearchConfig: aiSearchConfig, showSearchOnEnter: showSearchOnEnter, invokePostQuerySearchRef: invokePostQuerySearchRef })=>{
    const [originalId] = (0, $gwFzn.useState)(id);
    const [registeredProduct, setRegisteredProduct] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (allowedSections.length > 0) {
            const allowedSectionString = allowedSections.join(' ');
            const allowedRegisteredSections = sections.map((sec)=>sec.id).filter((sectionId)=>{
                const sectionIds = sectionId.replace(id, '').replace('.', '').split(',');
                let allowed = true;
                sectionIds.forEach((section)=>{
                    if (allowedSectionString.indexOf(section) === -1) allowed = false;
                });
                return allowed;
            });
            if (allowedRegisteredSections.length > 0) {
                addProduct({
                    id: id,
                    title: title,
                    sectionIds: sections.map((sec)=>sec.id),
                    order: order,
                    generateAdvancedSearchUrl: generateAdvancedSearchUrl,
                    expandedStateInputPlaceholder: expandedStateInputPlaceholder,
                    workspaces: workspaces,
                    autocorrectEnabled: autocorrectEnabled,
                    showViewAllFiltersLink: showViewAllFiltersLink,
                    tabRenderer: tabRenderer,
                    aiSearchConfig: aiSearchConfig,
                    showSearchOnEnter: showSearchOnEnter,
                    invokePostQuerySearchRef: invokePostQuerySearchRef
                });
                setRegisteredProduct(true);
            }
        }
    /**
		 * Updating of state is a side effect. We want it to happen in component did mount stage. Hence replicating this behaviour.
		 */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if (!registeredProduct) return;
        if (id !== originalId) {
            // eslint-disable-next-line no-console
            console.error("product-search-dialog: Cannot update a different product's properties. Did you change accidentally change a product's id?");
            return;
        }
        updateProduct({
            id: id,
            generateAdvancedSearchUrl: generateAdvancedSearchUrl,
            tabRenderer: tabRenderer
        });
    }, [
        registeredProduct,
        id,
        originalId,
        updateProduct,
        generateAdvancedSearchUrl,
        tabRenderer
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};
var $e48ac6f5e264642a$export$2e2bcd8739ae039 = (0, $fJRVo.withProductContext)($e48ac6f5e264642a$export$90be722c085777fe);

});



parcelRegister("jAnRi", function(module, exports) {

$parcel$export(module.exports, "COMPONENT", () => $e4619431597b06fa$export$af1e30ebbae9df3b);
$parcel$export(module.exports, "initialisationExperience", () => $e4619431597b06fa$export$e5b98327036a989d);

var $9NDUe = parcelRequire("9NDUe");
var $5aVN7 = parcelRequire("5aVN7");
const $e4619431597b06fa$export$af1e30ebbae9df3b = 'search-dialog';
const $e4619431597b06fa$export$e5b98327036a989d = new (0, $5aVN7.UFOExperience)('intialisation', {
    type: (0, $9NDUe.ExperienceTypes).Load,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
    platform: {
        component: $e4619431597b06fa$export$af1e30ebbae9df3b
    }
});

});


parcelRegister("bBxPo", function(module, exports) {

$parcel$export(module.exports, "ActiveProduct", () => $d457cad9438f33e2$export$13224c53a1606253);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $fJRVo = parcelRequire("fJRVo");
const $d457cad9438f33e2$export$13224c53a1606253 = ({ children: children, id: id })=>{
    const { getProduct: getProduct } = (0, $fJRVo.useProductContext)();
    const product = getProduct(id);
    if (!product?.isDisplayed) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};

});


parcelRegister("7a9pa", function(module, exports) {

$parcel$export(module.exports, "AsyncProvider", () => $298df496b78eadc8$export$2f9c5c9733d48598);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

const $298df496b78eadc8$var$AsyncResultProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("gKUJ3")).then(({ ResultProvider: ResultProvider })=>({
            default: ResultProvider
        })));
const $298df496b78eadc8$export$2f9c5c9733d48598 = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)($298df496b78eadc8$var$AsyncResultProvider, {
        ...props,
        children: props.children
    });

});
parcelRegister("gKUJ3", function(module, exports) {

let $c32cf1c2d1f97278$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c32cf1c2d1f97278$var$load("8F6ik").then(()=>parcelRequire('f8JZq'));

});


parcelRegister("1e3Dw", function(module, exports) {

$parcel$export(module.exports, "useGenerateAdvancedSearchUrl", () => $d3fd384d52c00b18$export$25a2b20022e2a01a);

var $gwFzn = parcelRequire("gwFzn");

var $amrMu = parcelRequire("amrMu");

var $4wMwH = parcelRequire("4wMwH");
const $d3fd384d52c00b18$export$25a2b20022e2a01a = (genUrl)=>{
    const { isGriffinNavEnabled: isGriffinNavEnabled } = (0, $amrMu.useFeaturesContext)();
    const { queryParams: queryParams } = (0, $4wMwH.useQueryParams)();
    return (0, $gwFzn.useCallback)((query, baseUrl, usage)=>{
        const advancedSearchUrl = genUrl?.(query, baseUrl, usage) || '';
        if (isGriffinNavEnabled) {
            const urlParts = advancedSearchUrl.split('?');
            // Omit text and originalQuery from the query params
            // originalQuery is used to support AutoCorrection in FPS and we don't want it
            // to persist between search queries
            const { text: text, originalQuery: originalQuery, ...rest } = queryParams || {};
            return `${urlParts[0]}?${new URLSearchParams({
                ...rest,
                ...query !== '' && {
                    text: query
                }
            }).toString()}`;
        }
        return advancedSearchUrl;
    }, [
        genUrl,
        isGriffinNavEnabled,
        queryParams
    ]);
};

});
parcelRegister("amrMu", function(module, exports) {

$parcel$export(module.exports, "FeaturesProvider", () => $1fd3b472f26a38c1$export$502d46f2366b5b43);
$parcel$export(module.exports, "useFeaturesContext", () => $1fd3b472f26a38c1$export$38c566c0640fb69a);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4wMwH = parcelRequire("4wMwH");
const $1fd3b472f26a38c1$export$98552201007e6417 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({});
const $1fd3b472f26a38c1$export$502d46f2366b5b43 = ({ dialogFeatures: dialogFeatures = {}, children: children })=>{
    const { queryParams: queryParams } = (0, $4wMwH.useQueryParams)();
    // Do not proceed with griffin navigation if query param props are not available
    const isGriffinNavEnabled = (0, $gwFzn.useMemo)(()=>dialogFeatures.isGriffinNavEnabled === true && queryParams !== undefined, [
        dialogFeatures.isGriffinNavEnabled,
        queryParams
    ]);
    return(/**
		 * Defaults and platfrom feature flag values can be overriden if explicit props are injected. This serves two purposes:
		 *
		 * 1. Storybook knobs can be provisioned for features that are powered by platfrom feature flags
		 *
		 * 2. Consumer products like Confluence, Jira can run statsig based experiments, where the Statsig evaluation happens in the product's code
		 * but the effect happens inside the code shipped by search platform.
		 */ /*#__PURE__*/ (0, $7UHDa.jsx)($1fd3b472f26a38c1$export$98552201007e6417.Provider, {
        value: {
            ...dialogFeatures,
            isGriffinNavEnabled: isGriffinNavEnabled
        },
        children: children
    }));
};
const $1fd3b472f26a38c1$export$38c566c0640fb69a = ()=>{
    return (0, $gwFzn.useContext)($1fd3b472f26a38c1$export$98552201007e6417);
};

});
parcelRegister("4wMwH", function(module, exports) {

$parcel$export(module.exports, "QueryParamsProvider", () => $de5accedd145fe95$export$90a656ad86ba2e2);
$parcel$export(module.exports, "useQueryParams", () => $de5accedd145fe95$export$b37ee0d76c6d2fbc);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $de5accedd145fe95$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    queryParams: undefined
});
const $de5accedd145fe95$export$90a656ad86ba2e2 = ({ queryParams: queryParams, children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($de5accedd145fe95$var$Context.Provider, {
        value: {
            queryParams: queryParams
        },
        children: children
    });
};
const $de5accedd145fe95$export$b37ee0d76c6d2fbc = ()=>{
    return (0, $gwFzn.useContext)($de5accedd145fe95$var$Context);
};

});




parcelRegister("85AiF", function(module, exports) {

$parcel$export(module.exports, "useBitbucketPermissionSupplier", () => $5cca7b29b77d44d1$export$e0a27ecb613d1aab);

var $gwFzn = parcelRequire("gwFzn");

var $gJKpQ = parcelRequire("gJKpQ");
var $kmpep = parcelRequire("kmpep");

var $it4Xp = parcelRequire("it4Xp");
const $5cca7b29b77d44d1$export$e0a27ecb613d1aab = (overridenPermissionsSupplier)=>{
    const client = (0, $kmpep.useTypedAggregatorClient)();
    return (0, $gwFzn.useMemo)(()=>{
        if (overridenPermissionsSupplier) return overridenPermissionsSupplier;
        return ()=>client?.getProductScopes((0, $it4Xp.BITBUCKET_PRODUCT_ID), (0, $gJKpQ.PLACEHOLDER_EXPERIENCE)) || [];
    }, [
        client,
        overridenPermissionsSupplier
    ]);
};

});
parcelRegister("it4Xp", function(module, exports) {

$parcel$export(module.exports, "BitbucketScope", () => $7fdea999808324e3$export$30e31f52a81be3c8);
$parcel$export(module.exports, "BITBUCKET_PRODUCT_ID", () => $7fdea999808324e3$export$49fc3e2141fc5779);
var $7fdea999808324e3$export$30e31f52a81be3c8 = /*#__PURE__*/ function(BitbucketScope) {
    BitbucketScope["BitbucketRepostitory"] = "bitbucket.repository";
    return BitbucketScope;
}({});
const $7fdea999808324e3$export$49fc3e2141fc5779 = 'bitbucket';

});


parcelRegister("cPiQS", function(module, exports) {

$parcel$export(module.exports, "bitbucketURLGenerators", () => $5e4d9137215cb451$export$8f020ef2e5947a78);
const $5e4d9137215cb451$var$getBitbucketBaseURL = ()=>{
    const hostname = window.location.hostname;
    if (hostname.includes('jira-dev.com') || hostname.startsWith('localhost')) return 'https://staging.bb-inf.net';
    return 'https://bitbucket.org';
};
const $5e4d9137215cb451$export$8f020ef2e5947a78 = (overrides)=>{
    const viewAllLinkGenerator = (query)=>`${$5e4d9137215cb451$var$getBitbucketBaseURL()}/dashboard/repositories?search=${encodeURIComponent(query)}`;
    const urlGeneratorForNoResultsScreen = (query)=>query ? `${$5e4d9137215cb451$var$getBitbucketBaseURL()}/dashboard/repositories?search=${encodeURIComponent(query)}` : `${$5e4d9137215cb451$var$getBitbucketBaseURL()}/dashboard/repositories`;
    const codeSearchUrlGenerator = (query)=>query ? `${$5e4d9137215cb451$var$getBitbucketBaseURL()}/search?q=${encodeURIComponent(query)}` : `${$5e4d9137215cb451$var$getBitbucketBaseURL()}/search`;
    const codeSearchContextualUrlGenerator = (query, context)=>{
        const { repository: repository, workspace: workspace } = context;
        let fullModifier = query || repository ? '?q=' : '';
        // Populate query params
        if (repository) {
            const repoSlug = encodeURIComponent(`repo:${repository.slug} `);
            fullModifier = `${fullModifier}${repoSlug}`;
        }
        if (query) fullModifier = `${fullModifier}${encodeURIComponent(query)}`;
        const workspaceUUID = repository?.workspace?.uuid || workspace?.uuid;
        if (workspaceUUID) fullModifier = fullModifier ? `${fullModifier}&account=${encodeURIComponent(workspaceUUID)}` : `?account=${encodeURIComponent(workspaceUUID)}`;
        return `${$5e4d9137215cb451$var$getBitbucketBaseURL()}/search${fullModifier}`;
    };
    return {
        viewAllLinkGenerator: overrides?.viewAllLinkGenerator || viewAllLinkGenerator,
        urlGeneratorForNoResultsScreen: overrides?.urlGeneratorForNoResultsScreen || urlGeneratorForNoResultsScreen,
        codeSearchUrlGenerator: overrides?.codeSearchUrlGenerator || codeSearchUrlGenerator,
        codeSearchContextualUrlGenerator: overrides?.codeSearchContextualUrlGenerator || codeSearchContextualUrlGenerator
    };
};

});

parcelRegister("eztGN", function(module, exports) {

$parcel$export(module.exports, "useShowAtlassianHomeSearchLink", () => $70c648daba3c4f25$export$14841bea82c8a2c4);

var $dh538 = parcelRequire("dh538");

var $cGCOz = parcelRequire("cGCOz");

var $iEwUU = parcelRequire("iEwUU");
const $70c648daba3c4f25$export$14841bea82c8a2c4 = (primaryProduct)=>{
    const { isRovoEnabled: isRovoEnabled } = (0, $cGCOz.useRovoContext)();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    return $70c648daba3c4f25$export$52dc59b9f236d940(isRovoEnabled, orgId, primaryProduct);
};
const $70c648daba3c4f25$export$52dc59b9f236d940 = (isRovoEnabled, orgId, primaryProduct)=>!!(isRovoEnabled && orgId && primaryProduct === 'jira' && (0, $dh538.fg)('jira_rovo_in_quick_search'));

});
parcelRegister("cGCOz", function(module, exports) {

$parcel$export(module.exports, "RovoContextProvider", () => $a17b947b16252498$export$ee92d5ccc84fac27);
$parcel$export(module.exports, "useRovoContext", () => $a17b947b16252498$export$4deb785ed026cc56);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $a17b947b16252498$var$RovoContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    isRovoEnabled: false,
    setIsRovoEnabled: (isRovoEnabled)=>{}
});
const $a17b947b16252498$export$ee92d5ccc84fac27 = ({ isEnabled: isEnabled, children: children })=>{
    const [isRovoEnabled, setIsRovoEnabled] = (0, $gwFzn.useState)(isEnabled || false);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($a17b947b16252498$var$RovoContext.Provider, {
        value: {
            isRovoEnabled: isRovoEnabled,
            setIsRovoEnabled: setIsRovoEnabled
        },
        children: children
    });
};
function $a17b947b16252498$export$4deb785ed026cc56() {
    return (0, $gwFzn.useContext)($a17b947b16252498$var$RovoContext);
}

});

parcelRegister("iEwUU", function(module, exports) {

$parcel$export(module.exports, "UserProvider", () => $977849d86adacef2$export$88f24fd8fcfab6ca);
$parcel$export(module.exports, "useUserContext", () => $977849d86adacef2$export$87c54b525b914dab);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $977849d86adacef2$var$UserContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    user: {},
    setUser: (user)=>{}
});
const $977849d86adacef2$export$88f24fd8fcfab6ca = ({ user: initialUser, orgId: orgId, children: children })=>{
    const [user, setUser] = (0, $gwFzn.useState)(initialUser || {});
    return /*#__PURE__*/ (0, $7UHDa.jsx)($977849d86adacef2$var$UserContext.Provider, {
        value: {
            user: user,
            orgId: orgId,
            setUser: setUser
        },
        children: children
    });
};
function $977849d86adacef2$export$87c54b525b914dab() {
    return (0, $gwFzn.useContext)($977849d86adacef2$var$UserContext);
}

});


parcelRegister("3Z7LN", function(module, exports) {

$parcel$export(module.exports, "getAtlassianHomeSearchUrl", () => $254bef028b438f80$export$306c16563e2015b8);
$parcel$export(module.exports, "AtlassianHomeSearchLink", () => $254bef028b438f80$export$829d02f6cd9ab0ce);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $g1L9J = parcelRequire("g1L9J");

var $guzTv = parcelRequire("guzTv");

var $6f0Oj = parcelRequire("6f0Oj");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $2ZIpG = parcelRequire("2ZIpG");

var $4mZlP = parcelRequire("4mZlP");

var $e1ib8 = parcelRequire("e1ib8");

var $fjD79 = parcelRequire("fjD79");

var $9BAfc = parcelRequire("9BAfc");

var $4I873 = parcelRequire("4I873");

var $3S0fp = parcelRequire("3S0fp");
var $5dFS9 = parcelRequire("5dFS9");
var $6dP89 = parcelRequire("6dP89");

var $fJRVo = parcelRequire("fJRVo");

var $l3UB9 = parcelRequire("l3UB9");
const $254bef028b438f80$var$ModifierIcon = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.ReturnIconWithModifier), {
        showModifierKey: true
    });
const $254bef028b438f80$var$ReturnIcon = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.ReturnIconWithModifier), {});
const $254bef028b438f80$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex'
});
const $254bef028b438f80$var$productIconStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '78px'
});
const $254bef028b438f80$var$moreButtonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'border.radius.100',
    paddingInline: 'space.075',
    marginRight: 'space.050',
    height: '20px',
    display: 'flex',
    alignItems: 'center'
});
const $254bef028b438f80$var$absoluteStyles = (0, $ecnYn.xcss)({
    position: 'absolute'
});
const $254bef028b438f80$var$borderStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '22px',
    width: '22px',
    borderRadius: '6px'
});
const $254bef028b438f80$var$jiraIconOverlapStyles = (0, $ecnYn.xcss)({
    zIndex: 'dialog',
    transform: 'translate(15px, 0)'
});
const $254bef028b438f80$var$confluenceIconOverlapStyles = (0, $ecnYn.xcss)({
    zIndex: 'navigation',
    transform: 'translate(30px, 0)'
});
const $254bef028b438f80$var$googleDriveIconOverlapStyles = (0, $ecnYn.xcss)({
    zIndex: 'card',
    transform: 'translate(45px, 0)'
});
const $254bef028b438f80$var$slackIconOverlapStyles = (0, $ecnYn.xcss)({
    transform: 'translate(60px, 0)'
});
const $254bef028b438f80$var$IconComponent = ({ showModifierIcon: showModifierIcon })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $254bef028b438f80$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                xcss: $254bef028b438f80$var$productIconStyles,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $254bef028b438f80$var$absoluteStyles,
                            $254bef028b438f80$var$jiraIconOverlapStyles,
                            $254bef028b438f80$var$borderStyles
                        ],
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $g1L9J.JiraIcon), {
                            size: "20"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $254bef028b438f80$var$absoluteStyles,
                            $254bef028b438f80$var$confluenceIconOverlapStyles,
                            $254bef028b438f80$var$borderStyles
                        ],
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $guzTv.ConfluenceIcon), {
                            size: "20"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $254bef028b438f80$var$absoluteStyles,
                            $254bef028b438f80$var$googleDriveIconOverlapStyles
                        ],
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9BAfc.GoogleDriveIcon), {})
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $254bef028b438f80$var$absoluteStyles,
                            $254bef028b438f80$var$slackIconOverlapStyles
                        ],
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4I873.SlackIcon), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $254bef028b438f80$var$moreButtonStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                    size: "small",
                    align: "center",
                    color: "color.text.subtle",
                    children: formatMessage((0, $e1ib8.messages).more)
                })
            }),
            showModifierIcon ? /*#__PURE__*/ (0, $7UHDa.jsx)($254bef028b438f80$var$ModifierIcon, {}) : /*#__PURE__*/ (0, $7UHDa.jsx)($254bef028b438f80$var$ReturnIcon, {})
        ]
    });
};
const $254bef028b438f80$export$306c16563e2015b8 = (orgId, cloudId, query, primaryProduct)=>{
    const url = new URL(`${(0, $fjD79.getDefaultAtlasBaseURL)(true)}/o/${orgId}/search`);
    url.searchParams.set('cloudId', cloudId);
    if (primaryProduct) url.searchParams.set('referrer', primaryProduct);
    if (query) url.searchParams.set('text', query);
    return url.toString();
};
const $254bef028b438f80$export$829d02f6cd9ab0ce = ({ orgId: orgId, cloudId: cloudId, showModifierIcon: showModifierIcon, actionSubjectId: actionSubjectId })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { query: query, isLoading: isLoading } = (0, $2ZIpG.useQuery)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const { getActiveProduct: getActiveProduct, getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const activeProduct = getActiveProduct();
    const href = $254bef028b438f80$export$306c16563e2015b8(orgId, cloudId, query, primaryProduct?.id);
    const productName = activeProduct?.title;
    const defaultActionSubjectId = `${productName}AdvancedSearchLink`;
    const onAdvancedSearchClicked = (0, $gwFzn.useCallback)((e)=>{
        fireAnalyticsEvent((0, $5dFS9.onAdvancedSearchSelected)({
            trigger: (0, $3S0fp.getTrigger)(e),
            actionSubjectId: actionSubjectId || defaultActionSubjectId,
            isLoading: isLoading,
            newTab: true,
            isRovoCrossProductSearchLink: true
        }));
    }, [
        fireAnalyticsEvent,
        isLoading,
        actionSubjectId,
        defaultActionSubjectId
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.AdvancedSearchFooterLink), {
        href: href,
        onClick: onAdvancedSearchClicked,
        linkComponent: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $l3UB9.AdvancedSearchLink), {
                ...props,
                isKeyboardHighlighted: !!props.isKeyboardHighlighted,
                href: href,
                target: "_blank"
            }),
        contentLabel: formatMessage((0, $e1ib8.messages).extensible_advanced_search_cross_product_footer),
        returnKeyIconComponent: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($254bef028b438f80$var$IconComponent, {
                showModifierIcon: showModifierIcon
            })
    });
};

});
parcelRegister("4mZlP", function(module, exports) {

$parcel$export(module.exports, "ReturnIconWithModifier", () => $53e1ecb0ab1cac21$export$74f31472c4e66c81);
$parcel$export(module.exports, "AdvancedSearchFooterLink", () => $53e1ecb0ab1cac21$export$3bd10e9d8677419f);
$parcel$export(module.exports, "AdvancedSearchFooter", () => $53e1ecb0ab1cac21$export$ad56be906d54f7e2);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $epvHH = parcelRequire("epvHH");
var $icqFF = parcelRequire("icqFF");

var $jEno1 = parcelRequire("jEno1");

var $7LKLe = parcelRequire("7LKLe");

var $eKv3Q = parcelRequire("eKv3Q");
var $l3UB9 = parcelRequire("l3UB9");
var $ingNj = parcelRequire("ingNj");

var $2ZIpG = parcelRequire("2ZIpG");

var $2OcMi = parcelRequire("2OcMi");

var $3S0fp = parcelRequire("3S0fp");
var $5dFS9 = parcelRequire("5dFS9");
var $6dP89 = parcelRequire("6dP89");

var $dBxQj = parcelRequire("dBxQj");

var $e1ib8 = parcelRequire("e1ib8");

var $fJRVo = parcelRequire("fJRVo");

var $ju7KJ = parcelRequire("ju7KJ");

var $80L9g = parcelRequire("80L9g");

var $gF7Az = parcelRequire("gF7Az");

var $4ldrV = parcelRequire("4ldrV");

var $f0f3d = parcelRequire("f0f3d");

var $6kOEz = parcelRequire("6kOEz");

var $hFUff = parcelRequire("hFUff");

var $5uL5H = parcelRequire("5uL5H");
const $53e1ecb0ab1cac21$var$onKeyDown = (e, target)=>{
    if (e.key === 'Enter') {
        e.preventDefault();
        // The ref here is the wrapper span however we simulate a click on the `ResultLinkComponent` that it wraps.
        target.firstElementChild?.click?.();
    }
};
const $53e1ecb0ab1cac21$var$onKeyDownWithShift = (e, target)=>{
    if (e.key === 'Enter' && e.shiftKey) {
        e.preventDefault();
        // The ref here is the wrapper span however we simulate a click on the `ResultLinkComponent` that it wraps.
        target.firstElementChild?.click?.();
    }
};
const $53e1ecb0ab1cac21$export$74f31472c4e66c81 = ({ showModifierKey: showModifierKey })=>{
    const ModifierKeyIcon = window.navigator.userAgent.includes('Mac') ? (0, $6kOEz.CommandIcon) : (0, $hFUff.ControlIcon);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $ju7KJ.SearchFooterLabelWrapper), {
        children: [
            showModifierKey && /*#__PURE__*/ (0, $7UHDa.jsx)(ModifierKeyIcon, {}),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5uL5H.SquareReturnIcon), {})
        ]
    });
};
const $53e1ecb0ab1cac21$export$ec11565276b0198d = ({ isKeyboardHighlighted: isKeyboardHighlighted, showSearchOnEnter: showSearchOnEnter, filterByProductFooter: filterByProductFooter, squareReturnIcon: squareReturnIcon })=>{
    if (showSearchOnEnter) return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $ju7KJ.SearchFooterLabelWrapper), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ju7KJ.SearchFooterLabel), {
                children: "Shift"
            }),
            "+",
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $epvHH.ReturnIcon), {
                inverted: isKeyboardHighlighted
            })
        ]
    });
    if (squareReturnIcon) return /*#__PURE__*/ (0, $7UHDa.jsx)($53e1ecb0ab1cac21$export$74f31472c4e66c81, {
        showModifierKey: filterByProductFooter
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $epvHH.ReturnIcon), {
        inverted: isKeyboardHighlighted
    });
};
const $53e1ecb0ab1cac21$export$3bd10e9d8677419f = ({ href: href, searchIconLabel: searchIconLabel = '', contentLabel: contentLabel, onClick: onClick, filterByProductFooter: filterByProductFooter, showSearchOnEnter: showSearchOnEnter, squareReturnIcon: squareReturnIcon, linkComponent: linkComponent, returnKeyIconComponent: ReturnKeyIconComponent = $53e1ecb0ab1cac21$export$ec11565276b0198d })=>{
    const [isKeyboardHighlighted, ref] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: showSearchOnEnter ? $53e1ecb0ab1cac21$var$onKeyDownWithShift : $53e1ecb0ab1cac21$var$onKeyDown
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ref: ref,
        onClick: onClick,
        role: "none",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'flex',
            height: '100%',
            width: '100%'
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $l3UB9.AdvancedSearchLink), {
            href: href,
            isKeyboardHighlighted: isKeyboardHighlighted,
            linkComponent: linkComponent,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ju7KJ.ContentWrapper), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eKv3Q.CenteredAdvancedSearchGroup), {
                        children: [
                            filterByProductFooter ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7LKLe))), {
                                color: "currentColor",
                                LEGACY_size: "small",
                                label: searchIconLabel
                            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jEno1))), {
                                color: "currentColor",
                                LEGACY_size: "small",
                                label: searchIconLabel
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eKv3Q.AdvancedSearchContent), {
                                children: contentLabel
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)(ReturnKeyIconComponent, {
                    isKeyboardHighlighted: isKeyboardHighlighted,
                    showSearchOnEnter: showSearchOnEnter,
                    filterByProductFooter: filterByProductFooter,
                    squareReturnIcon: squareReturnIcon
                })
            ]
        })
    }));
};
const $53e1ecb0ab1cac21$export$de2cb7be8250c972 = ({ query: query, isLoading: isLoading, activeProduct: activeProduct, closeDialog: closeDialog, searchFooterLabel: searchFooterLabel, searchFooterLabelWithIcon: searchFooterLabelWithIcon, linkComponent: linkComponent, urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen = ()=>'', squareReturnIcon: squareReturnIcon = false, filterByProductFooter: filterByProductFooter = false, returnKeyIconComponent: returnKeyIconComponent })=>{
    const intl = (0, $dBxQj.default)();
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const productName = activeProduct?.title;
    const productId = activeProduct?.id;
    const urlGenerator = activeProduct?.generateAdvancedSearchUrl || urlGeneratorForNoResultsScreen;
    const baseSearchUrl = filterByProductFooter ? `${urlGenerator(query)}&product=confluence` : urlGenerator(query);
    const advancedSearchUrl = query && productId === (0, $f0f3d.ProductKeys).Confluence ? (0, $2OcMi.addQuery)(baseSearchUrl, 'search_id', searchSessionId) : baseSearchUrl;
    const workspaces = activeProduct?.workspaces;
    const showSearchOnEnter = !!activeProduct?.showSearchOnEnter;
    const actionSubjectId = `${productName}AdvancedSearchLink`;
    const { resetSearchSession: resetSearchSession } = (0, $80L9g.useSessionUserInput)();
    const searchLabel = searchFooterLabel || intl.formatMessage((0, $e1ib8.messages).extensible_advanced_search_footer);
    const advancedSearchContentLabel = searchFooterLabelWithIcon || searchLabel;
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const onAdvancedSearchClicked = (0, $gwFzn.useCallback)((e)=>{
        if (!(0, $3S0fp.isNewTab)(e)) resetSearchSession();
        if (filterByProductFooter) closeDialog();
        fireAnalyticsEvent((0, $5dFS9.onAdvancedSearchSelected)({
            trigger: (0, $3S0fp.getTrigger)(e),
            actionSubjectId: actionSubjectId,
            isLoading: isLoading,
            newTab: (0, $3S0fp.isNewTab)(e)
        }));
    }, [
        fireAnalyticsEvent,
        isLoading,
        actionSubjectId,
        resetSearchSession,
        closeDialog,
        filterByProductFooter
    ]);
    if (workspaces && workspaces?.length > 1) {
        const workspacesWithAdvancedSearchLinks = workspaces.map((workspace)=>({
                product: productName || '',
                content: workspace.name,
                key: workspace.name,
                advancedSearchUrl: activeProduct?.generateAdvancedSearchUrl?.(query, workspace.baseUrl) || ''
            }));
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ingNj.default), {
            workspaces: workspacesWithAdvancedSearchLinks,
            linkComponent: linkComponent,
            isLoading: isLoading,
            onClick: (_, e)=>{
                (0, $5dFS9.onAdvancedSearchSelected)({
                    actionSubjectId: actionSubjectId,
                    trigger: (0, $3S0fp.getTrigger)(e),
                    isLoading: isLoading,
                    newTab: (0, $3S0fp.isNewTab)(e)
                });
            }
        });
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)($53e1ecb0ab1cac21$export$3bd10e9d8677419f, {
        href: advancedSearchUrl,
        searchIconLabel: searchLabel,
        contentLabel: advancedSearchContentLabel,
        onClick: onAdvancedSearchClicked,
        filterByProductFooter: filterByProductFooter,
        showSearchOnEnter: showSearchOnEnter,
        squareReturnIcon: squareReturnIcon,
        linkComponent: linkComponent,
        returnKeyIconComponent: returnKeyIconComponent
    });
};
const $53e1ecb0ab1cac21$export$ad56be906d54f7e2 = ({ ...rest })=>{
    const { query: query, isLoading: isLoading } = (0, $2ZIpG.useQuery)();
    const { setIsExpanded: setIsExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const activeProduct = getActiveProduct();
    const closeDialog = (0, $gwFzn.useCallback)(()=>{
        setIsExpanded(false);
    }, [
        setIsExpanded
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($53e1ecb0ab1cac21$export$de2cb7be8250c972, {
        ...rest,
        query: query,
        isLoading: isLoading,
        activeProduct: activeProduct,
        closeDialog: closeDialog
    });
};

});
parcelRegister("7LKLe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::289d4f542a1ed26db6d28b87ad2efcf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a8131e3ff7fd976$var$_react = $5a8131e3ff7fd976$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5a8131e3ff7fd976$var$_filter = $5a8131e3ff7fd976$var$_interopRequireDefault((parcelRequire("4AkKf")));

var $5a8131e3ff7fd976$var$_filter2 = $5a8131e3ff7fd976$var$_interopRequireDefault((parcelRequire("jIcpb")));
function $5a8131e3ff7fd976$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FilterIcon.
 * This component is FilterIcon, with `UNSAFE_fallbackIcon` set to "FilterIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a8131e3ff7fd976$var$FilterIcon = (props)=>/*#__PURE__*/ $5a8131e3ff7fd976$var$_react.default.createElement($5a8131e3ff7fd976$var$_filter.default, Object.assign({
        LEGACY_fallbackIcon: $5a8131e3ff7fd976$var$_filter2.default
    }, props));
$5a8131e3ff7fd976$var$FilterIcon.Name = 'FilterIconMigration';
var $5a8131e3ff7fd976$var$_default = module.exports.default = $5a8131e3ff7fd976$var$FilterIcon;

});

parcelRegister("ingNj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1e55472238d050e$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $jiwai = parcelRequire("jiwai");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $3S0fp = parcelRequire("3S0fp");
var $5dFS9 = parcelRequire("5dFS9");
var $6dP89 = parcelRequire("6dP89");

var $bF0iL = parcelRequire("bF0iL");
const $a1e55472238d050e$var$MAX_PRIMARY_WORKSPACES = 5;
const $a1e55472238d050e$var$getActionSubjectIdForProduct = (product)=>{
    return `${product.toLowerCase()}AdvancedSearchLink`;
};
const $a1e55472238d050e$export$c1abbe883cc8875 = ({ workspaces: workspaces, linkComponent: linkComponent, onClick: onClick, isLoading: isLoading, intl: intl })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const links = workspaces.map((workspace)=>({
            content: workspace.content,
            key: workspace.key,
            href: workspace.advancedSearchUrl
        }));
    const label = intl.formatMessage((0, $bF0iL.messages).multi_site_advanced_search_label);
    const dropdownLabel = intl.formatMessage((0, $bF0iL.messages).multi_site_advanced_search_more_dropdown, {
        count: links.length - $a1e55472238d050e$var$MAX_PRIMARY_WORKSPACES
    });
    const onAdvancedSearchClicked = (0, $gwFzn.useCallback)(({ key: key }, e)=>{
        const workspace = workspaces.filter((w)=>w.key === key)[0];
        if (!workspace) return;
        fireAnalyticsEvent((0, $5dFS9.onMultiSiteAdvancedSearchSelected)({
            trigger: (0, $3S0fp.getTrigger)(e),
            actionSubjectId: $a1e55472238d050e$var$getActionSubjectIdForProduct(workspace.product),
            isLoading: isLoading,
            newTab: (0, $3S0fp.isNewTab)(e),
            destinationId: key,
            index: workspaces.map((w)=>w.key).indexOf(key)
        }));
    }, [
        fireAnalyticsEvent,
        isLoading,
        workspaces
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jiwai.SearchFooterLinks), {
        linkComponent: linkComponent,
        onClick: (link, e)=>{
            onAdvancedSearchClicked(link, e);
            onClick && onClick(link.href, e);
        },
        label: label,
        dropdownTriggerLabel: dropdownLabel,
        links: links,
        maxPrimaryLinks: $a1e55472238d050e$var$MAX_PRIMARY_WORKSPACES
    });
};
var $a1e55472238d050e$export$2e2bcd8739ae039 = (0, $js7oX.default)($a1e55472238d050e$export$c1abbe883cc8875);

});
parcelRegister("jiwai", function(module, exports) {

$parcel$export(module.exports, "SearchFooterLinks", () => $aa4a78fb49270be5$export$697ca8c8f8bb38fc);

var $7UHDa = parcelRequire("7UHDa");

var $eEA8O = parcelRequire("eEA8O");

var $3gadb = parcelRequire("3gadb");

var $gwFzn = parcelRequire("gwFzn");

var $7ujO6 = parcelRequire("7ujO6");

var $DXuE9 = parcelRequire("DXuE9");

const $aa4a78fb49270be5$var$DropDownLinks = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("8NNqI")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $aa4a78fb49270be5$var$DEFAULT_MAX_PRIMARY_LINKS = 5;
const $aa4a78fb49270be5$export$697ca8c8f8bb38fc = ({ label: label, links: links, dropdownTriggerLabel: dropdownTriggerLabel, onClick: onClick, linkComponent: linkComponent, maxPrimaryLinks: maxPrimaryLinks })=>{
    const primaryLinks = links.slice(0, maxPrimaryLinks || $aa4a78fb49270be5$var$DEFAULT_MAX_PRIMARY_LINKS);
    const dropdownLinks = links.slice(maxPrimaryLinks || $aa4a78fb49270be5$var$DEFAULT_MAX_PRIMARY_LINKS, links.length);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $DXuE9.SearchFooterLinksContainer), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $DXuE9.LabelContainer), {
                children: label
            }),
            primaryLinks.map((link)=>{
                const { key: key, href: href, content: content } = link;
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $DXuE9.PrimaryButtonWrapper), {
                    onClick: (e)=>onClick && onClick(link, e),
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $DXuE9.PrimaryButtonStyledLink), {
                        href: href,
                        linkComponent: linkComponent,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
                            content: content,
                            tag: (0, $7ujO6.ForwardedRefToolTipTag),
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                                spacing: "compact",
                                tabIndex: -1,
                                children: content
                            })
                        })
                    })
                }, key);
            }),
            dropdownLinks && dropdownLinks.length > 0 ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($aa4a78fb49270be5$var$DropDownLinks, {
                    dropdownLinks: dropdownLinks,
                    dropdownTriggerLabel: dropdownTriggerLabel,
                    onClick: onClick,
                    linkComponent: linkComponent
                })
            }) : null
        ]
    });
};

});
parcelRegister("7ujO6", function(module, exports) {

$parcel$export(module.exports, "ForwardedRefToolTipTag", () => $e1ffbeb6e0936f83$export$349601f91196bc9c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $DXuE9 = parcelRequire("DXuE9");
const $e1ffbeb6e0936f83$export$349601f91196bc9c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $DXuE9.TruncatedTextDiv), {
        ...props,
        ref: ref
    }));

});
parcelRegister("DXuE9", function(module, exports) {

$parcel$export(module.exports, "SearchFooterLinksContainer", () => $9319a5a14fadb0c4$export$636ae9b701e134a6);
$parcel$export(module.exports, "LabelContainer", () => $9319a5a14fadb0c4$export$f5ae33f1b01a6402);
$parcel$export(module.exports, "TruncatedTextDiv", () => $9319a5a14fadb0c4$export$f060a0d7354d6f0f);
$parcel$export(module.exports, "PrimaryButtonWrapper", () => $9319a5a14fadb0c4$export$70f18730b5e534f8);
$parcel$export(module.exports, "PrimaryButtonStyledLink", () => $9319a5a14fadb0c4$export$c0a945c47b321ccb);
$parcel$export(module.exports, "DropownMenuLink", () => $9319a5a14fadb0c4$export$62368ee747a81340);

var $6fnsQ = parcelRequire("6fnsQ");

var $dTk3A = parcelRequire("dTk3A");

var $kPBHE = parcelRequire("kPBHE");

var $2azjJ = parcelRequire("2azjJ");

var $gwrgp = parcelRequire("gwrgp");
const $9319a5a14fadb0c4$export$636ae9b701e134a6 = (0, $gwrgp.default)("div", {
    target: "e17810te0"
})({
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'start',
    flexDirection: 'row',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-200, 16px)"}`,
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $2azjJ.dialogWidth),
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`
});
const $9319a5a14fadb0c4$export$f5ae33f1b01a6402 = (0, $gwrgp.default)("div", {
    target: "e17810te1"
})({
    name: "1eq7d53",
    styles: "margin-right:var(--ds-space-050, 4px);flex-shrink:0;"
});
const $9319a5a14fadb0c4$export$f060a0d7354d6f0f = (0, $gwrgp.default)("div", {
    target: "e17810te2"
})({
    name: "1h2ruwl",
    styles: "white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
});
const $9319a5a14fadb0c4$export$70f18730b5e534f8 = (0, $gwrgp.default)("div", {
    target: "e17810te3"
})({
    name: "1qj33pc",
    styles: "flex:1 1 0;overflow:hidden;max-width:max-content;margin-right:var(--ds-space-025, 2px);"
});
const $9319a5a14fadb0c4$export$c0a945c47b321ccb = /*#__PURE__*/ (0, $gwrgp.default)((0, $kPBHE.Link), {
    target: "e17810te4"
})({
    display: 'flex',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $dTk3A.borderRadius)()}px`,
    transitionDuration: '0.2s',
    transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    '&:focus': {
        outline: 'none',
        boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $6fnsQ.B100)})`} inset`
    },
    '&:hover': {
        textDecoration: 'none'
    }
});
const $9319a5a14fadb0c4$export$62368ee747a81340 = /*#__PURE__*/ (0, $gwrgp.default)((0, $kPBHE.Link), {
    target: "e17810te5"
})({
    display: 'block',
    position: 'relative',
    '&:focus': {
        outline: `2px solid ${`var(--ds-border-focused, ${(0, $6fnsQ.B100)})`}`,
        outlineOffset: '-2px'
    },
    '&:hover': {
        textDecoration: 'none'
    }
});

});


parcelRegister("8NNqI", function(module, exports) {

let $66893e103bfe4ddc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $66893e103bfe4ddc$var$load("6sXO4").then(()=>parcelRequire('gg9qV'));

});



parcelRegister("2OcMi", function(module, exports) {

$parcel$export(module.exports, "addQuery", () => $1f2b7f00ecdc409c$export$46ffbef61eff3d00);
$parcel$export(module.exports, "addQueryParams", () => $1f2b7f00ecdc409c$export$cbc5b385481fb319);
const $1f2b7f00ecdc409c$export$46ffbef61eff3d00 = (url, key, unencodedValue)=>{
    return $1f2b7f00ecdc409c$export$cbc5b385481fb319(url, {
        [key]: unencodedValue
    });
};
const $1f2b7f00ecdc409c$export$cbc5b385481fb319 = (url, params)=>{
    if (!url) return url;
    const sanitisedUrl = url.endsWith('?') || url.endsWith('&') ? url.slice(0, url.length - 1) : url;
    const paramsString = Object.entries(params).reduce((rest, [key, unencodedValue])=>{
        if (!key) return rest;
        const nextPart = `${encodeURIComponent(key)}=${encodeURIComponent(unencodedValue)}`;
        if (rest) return `${rest}&${nextPart}`;
        return nextPart;
    }, '');
    if (!paramsString) return url;
    // If it has a query string already
    if (sanitisedUrl.includes('?')) return `${sanitisedUrl}&${paramsString}`;
    return `${sanitisedUrl}?${paramsString}`;
};

});

parcelRegister("e1ib8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f92b14cfe6710408$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $f92b14cfe6710408$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /**
   * Extensible
   */ extensible_advanced_search_footer: {
        id: "extensible_search_dialog.advanced_search",
        defaultMessage: "Advanced search"
    },
    extensible_advanced_search_cross_product_footer: {
        id: "extensible_search_dialog.advanced_search_all_apps",
        defaultMessage: "Search all apps"
    },
    extensible_connect_to: {
        id: "extensible_search_dialog.connect_to",
        defaultMessage: "Connect to"
    },
    extensible_connect: {
        id: "extensible_search_dialog.connect",
        defaultMessage: "Connect"
    },
    more: {
        id: "extensible_search_dialog.more",
        defaultMessage: "+ more"
    }
});

});

parcelRegister("ju7KJ", function(module, exports) {

$parcel$export(module.exports, "ContentWrapper", () => $27d3f42c4140793d$export$6ce170286acaa8d3);
$parcel$export(module.exports, "SearchFooterLabelWrapper", () => $27d3f42c4140793d$export$85cc5ece3620f7ef);
$parcel$export(module.exports, "SearchFooterLabel", () => $27d3f42c4140793d$export$db59656b68ced4b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $27d3f42c4140793d$export$6ce170286acaa8d3 = (0, $gwrgp.default)("div", {
    target: "er9v89y0"
})({
    name: "ab8yd1",
    styles: "display:flex;height:100%;"
});
const $27d3f42c4140793d$export$85cc5ece3620f7ef = (0, $gwrgp.default)("div", {
    target: "er9v89y1"
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    gap: "var(--ds-space-025, 2px)",
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N90)})`
});
const $27d3f42c4140793d$export$db59656b68ced4b = (0, $gwrgp.default)("div", {
    target: "er9v89y2"
})({
    backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`,
    padding: `0px ${"var(--ds-space-025, 2px)"}`,
    borderRadius: '4px'
});

});

parcelRegister("f0f3d", function(module, exports) {

$parcel$export(module.exports, "ProductKeys", () => $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c);
$parcel$export(module.exports, "QuickFindConfluence", () => $5393c5baf4aba6f7$export$1763eeb490def9b);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $iBckn = parcelRequire("iBckn");

var $k1wrx = parcelRequire("k1wrx");

var $dh538 = parcelRequire("dh538");

var $a5cba = parcelRequire("a5cba");

var $bF0iL = parcelRequire("bF0iL");

var $dDSTM = parcelRequire("dDSTM");

var $8ioQN = parcelRequire("8ioQN");

var $1WJaw = parcelRequire("1WJaw");

var $cnoUz = parcelRequire("cnoUz");

var $20N1w = parcelRequire("20N1w");

var $1OS8u = parcelRequire("1OS8u");

var $axxOe = parcelRequire("axxOe");

var $clOud = parcelRequire("clOud");

var $1x1dO = parcelRequire("1x1dO");

var $ktwn8 = parcelRequire("ktwn8");

var $iEwUU = parcelRequire("iEwUU");

var $5yZy1 = parcelRequire("5yZy1");

var $91yhh = parcelRequire("91yhh");

var $bK7ak = parcelRequire("bK7ak");

var $amrMu = parcelRequire("amrMu");
const $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c = {
    Confluence: 'confluence',
    Atlas: 'townsquare'
};
const $5393c5baf4aba6f7$export$a55448378aa900a7 = ({ searchResult: searchResult, isKeyboardHighlighted: isKeyboardHighlighted })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $20N1w.PersistRecentSearch), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k1wrx.EnlargedSearchResultContent), {
            ...searchResult,
            isKeyboardHighlighted: isKeyboardHighlighted,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(searchResult.icon) ? searchResult.icon : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {})
        })
    });
};
const $5393c5baf4aba6f7$export$1763eeb490def9b = ({ onRetry: onRetry, linkComponent: linkComponent, confCloudClient: confCloudClient, aggAbsoluteUrl: aggAbsoluteUrl, onPreQueryErrorCallback: onPreQueryErrorCallback, cloudId: cloudId, orgId: orgId, primaryProduct: primaryProduct })=>{
    const { user: user } = (0, $iEwUU.useUserContext)();
    const features = (0, $amrMu.useFeaturesContext)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const appendAnalyticsQueryParams = (0, $bK7ak.useQueryParams)();
    const isEnhancedSearchAnalyticsEnabled = (0, $dh538.fg)('cc_page_experiences_enhanced_search_analytics_conf');
    const appendQueryParams = isEnhancedSearchAnalyticsEnabled && primaryProduct === 'confluence' ? appendAnalyticsQueryParams : undefined;
    const preQueryItemSupplier = (0, $iBckn.useQuickFindItemSupplier)({
        confCloudClient: confCloudClient,
        aggAbsoluteUrl: aggAbsoluteUrl,
        markErrorAsHandled: onPreQueryErrorCallback,
        itemRenderer: $5393c5baf4aba6f7$export$a55448378aa900a7,
        recentContentResultMapper: (0, $1OS8u.quickFindRecentItemResultMapper),
        recentSpaceResultMapper: (0, $axxOe.quickFindRecentSpaceResultMapper),
        userId: user.id,
        cloudId: cloudId
    });
    // This currently isn't being used for results fetching or rendering. It is
    // only being used to create an array of sections which are then used for
    // product registration. After product registration, these scopes are then
    // used to call the experiment endpoint, for this reason they need to be
    // valid scopes for each product.
    const defaultSections = (0, $gwFzn.useMemo)(()=>{
        switch(primaryProduct){
            case $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Confluence:
                return [
                    {
                        id: 'confluence.page',
                        title: ''
                    }
                ];
            case $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Atlas:
                return [
                    {
                        id: 'townsquare.goal',
                        title: ''
                    }
                ];
            default:
                return [];
        }
    }, [
        primaryProduct
    ]);
    const { backendExperiment: backendExperiment } = (0, $91yhh.useExperiments)();
    const { experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers } = backendExperiment || {};
    const quickFindPeopleAndTeamsResultMapper = (0, $clOud.getQuickFindPeopleAndTeamsResultMapper)(primaryProduct, orgId || '', cloudId);
    const quickFindPostQueryItemSupplier = (0, $iBckn.useQuickFindPostQueryItemSupplier)({
        cloudId: cloudId,
        resultRenderer: $5393c5baf4aba6f7$export$a55448378aa900a7,
        confluenceResultMapper: (0, $ktwn8.quickFindConfluenceContentMapper),
        atlasResultMapper: (0, $5yZy1.quickFindAtlasContentMapper),
        spaceResultMapper: (0, $1x1dO.quickFindConfluenceSpaceMapper),
        peopleAndTeamsResultMapper: quickFindPeopleAndTeamsResultMapper,
        sectionTitle: formatMessage((0, $dDSTM.messages).quick_find_results_section),
        userId: user.id,
        orgId: orgId,
        aggAbsoluteUrl: aggAbsoluteUrl,
        primaryProduct: primaryProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId })=>({
                name: name,
                layerId: layerId,
                shadowId: shadowId
            }))
    });
    const noResultsPostQueryItemSupplier = (0, $gwFzn.useCallback)(()=>Promise.resolve((0, $8ioQN.EMPTY_SEARCH_ITEMS)), []);
    const postQueryItemSupplier = features?.quickFind?.postQueryDisabled ? noResultsPostQueryItemSupplier : quickFindPostQueryItemSupplier;
    // TODO: baseUrl is a holdover from QS and not needed in QF
    const generateAdvancedSearchUrl = (0, $gwFzn.useCallback)((query, baseUrl, usage)=>{
        let url = '';
        const params = new URLSearchParams();
        const trimmedQuery = query.trim();
        if (trimmedQuery) params.append('text', trimmedQuery);
        if (primaryProduct === $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Confluence) {
            url = '/wiki/search/';
            if (usage === 'onInputEnterModified') params.append('product', 'confluence');
        } else if (orgId && primaryProduct === $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Atlas) {
            url = `/o/${orgId}/search/`;
            params.append('cloudId', cloudId);
        }
        // URLSearchParams's toString will do encode special characters, however spaces
        // are encoded as +. We need to replace them with %20 to match existing behaviour.
        url += `?${params.toString()}`;
        url = url.replace(/\+/g, '%20');
        return url;
    }, [
        cloudId,
        orgId,
        primaryProduct
    ]);
    const title = (0, $gwFzn.useMemo)(()=>{
        switch(primaryProduct){
            case $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Confluence:
                return formatMessage((0, $bF0iL.messages).confluence_tab_label);
            case $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Atlas:
                return formatMessage((0, $bF0iL.messages).atlas_tab_label);
            default:
                return '';
        }
    }, [
        formatMessage,
        primaryProduct
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5cba.SearchDialogProduct), {
        permissionSupplier: ()=>Promise.resolve(defaultSections.map((s)=>s.id)),
        sections: defaultSections,
        id: primaryProduct,
        title: title,
        order: 0,
        expandedStateInputPlaceholder: formatMessage((0, $dDSTM.messages).quick_find_search_input_placeholder),
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier,
        onRetry: onRetry,
        ResultRenderer: (0, $1WJaw.QuickFindResultRenderer),
        SearchItemsTransformer: (0, $cnoUz.QuickFindConfluenceTransformer),
        isPrefetchingEnabled: true,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        searchFooterLabel: 'Search your organization',
        linkComponent: linkComponent,
        appendQueryParams: appendQueryParams
    });
};

});
parcelRegister("iBckn", function(module, exports) {

$parcel$export(module.exports, "RECENT_ITEMS_SECTION_ID", () => $39c726418f03e72e$export$9747eb11a16f4445);
$parcel$export(module.exports, "RECENT_SPACES_SECTION_ID", () => $39c726418f03e72e$export$3813b30107e5b323);
$parcel$export(module.exports, "useQuickFindItemSupplier", () => $39c726418f03e72e$export$ec546060f7cdc293);
$parcel$export(module.exports, "CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID", () => $39c726418f03e72e$export$7b0766a033869f00);
$parcel$export(module.exports, "useQuickFindPostQueryItemSupplier", () => $39c726418f03e72e$export$f872504428bf2e7e);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $dh538 = parcelRequire("dh538");

var $c3vDd = parcelRequire("c3vDd");

var $ja8yA = parcelRequire("ja8yA");

var $9Lfxk = parcelRequire("9Lfxk");

var $jjQiR = parcelRequire("jjQiR");

var $gruCU = parcelRequire("gruCU");
const $39c726418f03e72e$var$INCLUDED_PRODUCTS = [
    'confluence',
    'jira',
    'townsquare',
    'graph'
];
// To filter out Confluence comment results - although query does
// not include comment type it is still returning comment results
const $39c726418f03e72e$var$INCLUDED_OBJECT_TYPES = [
    'page',
    'blogpost',
    'whiteboard',
    'issue',
    'project',
    'goal',
    'content',
    'document',
    'remote-link'
];
const $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_CONTENTS_FETCHED = 200;
const $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_SPACES_FETCHED = 10;
const $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_CONTENTS_DISPLAYED = 7;
const $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_SPACES_DISPLAYED = 3;
const $39c726418f03e72e$var$POST_QUERY_MAX_CONTENTS = 7;
const $39c726418f03e72e$var$POST_QUERY_MAX_SPACES = 1;
const $39c726418f03e72e$export$9747eb11a16f4445 = 'recent-items';
const $39c726418f03e72e$export$3813b30107e5b323 = 'recent-spaces';
const $39c726418f03e72e$export$ec546060f7cdc293 = ({ confCloudClient: confCloudClient, aggAbsoluteUrl: aggAbsoluteUrl, markErrorAsHandled: markErrorAsHandled, itemRenderer: itemRenderer, recentContentResultMapper: recentContentResultMapper, recentSpaceResultMapper: recentSpaceResultMapper, userId: userId, cloudId: cloudId })=>{
    return (0, $gwFzn.useCallback)(async ()=>{
        const getSections = ({ recentContents: recentContents, recentSpaces: recentSpaces })=>({
                sections: [
                    {
                        id: $39c726418f03e72e$export$9747eb11a16f4445,
                        title: '',
                        searchResults: recentContents,
                        resultLimit: $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_CONTENTS_DISPLAYED,
                        resultRenderer: itemRenderer
                    },
                    {
                        id: $39c726418f03e72e$export$3813b30107e5b323,
                        title: '',
                        searchResults: recentSpaces,
                        resultLimit: $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_SPACES_DISPLAYED,
                        resultRenderer: itemRenderer
                    }
                ]
            });
        if (!userId) return getSections({
            recentContents: [],
            recentSpaces: []
        });
        const recentActivitiesPromise = (0, $ja8yA.recentActivitiesQuery)({
            variables: {
                filteredProducts: $39c726418f03e72e$var$INCLUDED_PRODUCTS,
                filteredObjectTypes: (0, $dh538.fg)('smartlinks-qf-recents') ? $39c726418f03e72e$var$INCLUDED_OBJECT_TYPES : $39c726418f03e72e$var$INCLUDED_OBJECT_TYPES.filter((type)=>type !== 'remote-link'),
                filteredRootContainerIds: [
                    `ari:cloud:platform::site/${cloudId}`,
                    // covers Confluence, Jira
                    `ari:cloud:townsquare::site/${cloudId}` // for some reason Atlas has a different root container id
                ],
                itemsLimit: $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_CONTENTS_FETCHED
            },
            aggAbsoluteUrl: aggAbsoluteUrl
        });
        const recentSpacesPromise = confCloudClient ? confCloudClient.query({
            query: (0, $c3vDd.QuickFindSpacesQuery),
            variables: {
                spaceLimit: $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_SPACES_FETCHED
            }
        }) : Promise.resolve(undefined);
        const { recentContents: recentContents, recentSpaces: recentSpaces } = await Promise.all([
            recentActivitiesPromise,
            recentSpacesPromise
        ]).then(([recentItemsResponse, recentSpacesResponse])=>{
            const recentContents = recentItemsResponse?.data?.activity?.myActivity?.all.edges.filter((edge)=>edge?.node?.object?.data).map(recentContentResultMapper) || [];
            const recentSpacesResults = (0, $gruCU.parsePartialApolloResults)(recentSpacesResponse?.data?.myVisitedSpaces, recentSpacesResponse?.errors);
            const recentSpaces = recentSpacesResults?.nodes?.spaces?.map(recentSpaceResultMapper) || [];
            return {
                recentContents: recentContents,
                recentSpaces: recentSpaces
            };
        }).catch((err)=>{
            markErrorAsHandled && markErrorAsHandled(err);
            throw err;
        });
        return getSections({
            recentContents: recentContents,
            recentSpaces: recentSpaces
        });
    }, [
        confCloudClient,
        userId,
        markErrorAsHandled,
        itemRenderer,
        recentContentResultMapper,
        recentSpaceResultMapper,
        aggAbsoluteUrl,
        cloudId
    ]);
};
const $39c726418f03e72e$var$CONFLUENCE_CONTENT_ENTITIES = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:whiteboard',
    'ati:cloud:confluence:database'
];
const $39c726418f03e72e$var$ATLAS_ENTITIES = [
    'ati:cloud:townsquare:project',
    'ati:cloud:townsquare:goal',
    'ati:cloud:townsquare:tag'
];
const $39c726418f03e72e$var$ATLAS_PROJECT_GOAL_TAG_SECTION_ID = 'townsquare.project,goal,tag';
const $39c726418f03e72e$export$7b0766a033869f00 = 'confluence.page,blogpost,attachment';
const $39c726418f03e72e$export$47653725e5b469bb = 'space';
const $39c726418f03e72e$export$f80b16ba1f3b0d5c = 'people-and-teams';
const $39c726418f03e72e$var$ProductKeys = {
    Confluence: 'confluence',
    Atlas: 'townsquare'
};
const $39c726418f03e72e$export$f872504428bf2e7e = ({ aggAbsoluteUrl: aggAbsoluteUrl, cloudId: cloudId, resultRenderer: resultRenderer, confluenceResultMapper: confluenceResultMapper, atlasResultMapper: atlasResultMapper, spaceResultMapper: spaceResultMapper, peopleAndTeamsResultMapper: peopleAndTeamsResultMapper, sectionTitle: sectionTitle, userId: userId, orgId: orgId, primaryProduct: primaryProduct, experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers })=>{
    const intl = (0, $dBxQj.default)();
    return (0, $gwFzn.useCallback)(async (args)=>{
        const { query: query, analyticsInfo: analyticsInfo } = args;
        const getPeopleAndTeamsResults = async (query, userId, cloudId)=>{
            if (!userId || !cloudId) return [];
            const peopleResults = await (0, $jjQiR.getUserAndTeamSearchResults)({
                query: query,
                cloudId: cloudId,
                principalId: userId || '',
                orgId: orgId || '',
                intl: intl
            }).catch((e)=>{
                console.error(e);
                return [];
            });
            return peopleResults.map(peopleAndTeamsResultMapper);
        };
        const getConfluenceResults = async (query, cloudId)=>{
            const contentQueryResults = await (0, $9Lfxk.quickFindSearchQuery)({
                variables: {
                    query: query,
                    cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
                    resultsLimit: $39c726418f03e72e$var$POST_QUERY_MAX_CONTENTS,
                    spaceLimit: $39c726418f03e72e$var$POST_QUERY_MAX_SPACES,
                    includeAncestors: true,
                    // to show breadcrumbs
                    contentEntities: $39c726418f03e72e$var$CONFLUENCE_CONTENT_ENTITIES,
                    confluenceFilters: {
                        titleMatchOnly: true
                    },
                    searchSessionId: analyticsInfo?.searchSessionId,
                    queryVersion: analyticsInfo?.queryVersion,
                    includeSpaces: true,
                    experimentId: experimentId,
                    shadowExperimentId: shadowExperimentId,
                    experimentLayers: experimentLayers
                },
                aggAbsoluteUrl: aggAbsoluteUrl
            });
            const contentResponse = contentQueryResults.data?.search.results?.edges || [];
            const contentResults = contentResponse.map(confluenceResultMapper);
            const spaceResponse = contentQueryResults.data?.search.spaces?.edges || [];
            const spaceResults = spaceResponse.map(spaceResultMapper);
            return {
                contentResults: contentResults,
                spaceResults: spaceResults
            };
        };
        const getAtlasResults = async (query, analyticsInfo)=>{
            const contentQueryResults = await (0, $9Lfxk.quickFindSearchQuery)({
                variables: {
                    query: query,
                    cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
                    contentEntities: $39c726418f03e72e$var$ATLAS_ENTITIES,
                    confluenceFilters: {
                        titleMatchOnly: true
                    },
                    // this filter is applied on Atlas results as well
                    resultsLimit: $39c726418f03e72e$var$POST_QUERY_MAX_CONTENTS,
                    spaceLimit: $39c726418f03e72e$var$POST_QUERY_MAX_SPACES,
                    includeAncestors: false,
                    searchSessionId: analyticsInfo?.searchSessionId,
                    queryVersion: analyticsInfo?.queryVersion,
                    includeSpaces: false,
                    experimentId: experimentId,
                    shadowExperimentId: shadowExperimentId,
                    experimentLayers: experimentLayers
                },
                aggAbsoluteUrl: aggAbsoluteUrl
            });
            const contentResponse = contentQueryResults.data?.search.results?.edges || [];
            const contentResults = contentResponse.map(atlasResultMapper);
            return {
                contentResults: contentResults,
                spaceResults: []
            };
        };
        const getResults = (product)=>{
            switch(product){
                case $39c726418f03e72e$var$ProductKeys.Confluence:
                    return getConfluenceResults(query, cloudId);
                case $39c726418f03e72e$var$ProductKeys.Atlas:
                    return getAtlasResults(query, analyticsInfo);
                default:
                    return getConfluenceResults(query, cloudId);
            }
        };
        const { contentResults: contentResults, spaceResults: spaceResults } = await getResults(primaryProduct);
        const peopleAndTeamsResults = await getPeopleAndTeamsResults(query, userId, cloudId);
        const getContentSectionId = (product)=>{
            switch(product){
                case $39c726418f03e72e$var$ProductKeys.Confluence:
                    return $39c726418f03e72e$export$7b0766a033869f00;
                case $39c726418f03e72e$var$ProductKeys.Atlas:
                    return $39c726418f03e72e$var$ATLAS_PROJECT_GOAL_TAG_SECTION_ID;
                default:
                    return $39c726418f03e72e$export$7b0766a033869f00;
            }
        };
        return {
            sections: [
                {
                    id: getContentSectionId(primaryProduct),
                    title: sectionTitle,
                    searchResults: contentResults,
                    resultRenderer: resultRenderer
                },
                {
                    id: $39c726418f03e72e$export$47653725e5b469bb,
                    searchResults: spaceResults,
                    title: !contentResults.length ? sectionTitle : '',
                    resultRenderer: resultRenderer
                },
                {
                    id: $39c726418f03e72e$export$f80b16ba1f3b0d5c,
                    searchResults: peopleAndTeamsResults,
                    title: !contentResults.length && !spaceResults.length ? sectionTitle : '',
                    resultRenderer: resultRenderer
                }
            ]
        };
    }, [
        cloudId,
        resultRenderer,
        confluenceResultMapper,
        atlasResultMapper,
        spaceResultMapper,
        peopleAndTeamsResultMapper,
        sectionTitle,
        intl,
        orgId,
        userId,
        aggAbsoluteUrl,
        primaryProduct,
        experimentId,
        shadowExperimentId,
        experimentLayers
    ]);
};

});
parcelRegister("c3vDd", function(module, exports) {

$parcel$export(module.exports, "QuickFindSpacesQuery", () => $7c8d7e5d36cb13e1$export$9af2898b36d6a2cf);

var $d2LG0 = parcelRequire("d2LG0");
const $7c8d7e5d36cb13e1$var$QuickFindSpacesFragment = (0, $d2LG0.default)`fragment QuickFindSpacesFragment on Space{id key name icon{path}links{webui}}`;
const $7c8d7e5d36cb13e1$export$9af2898b36d6a2cf = (0, $d2LG0.default)`query QuickFindSpacesQuery($spaceLimit:Int!){myVisitedSpaces(limit:$spaceLimit){nodes{spaces{...QuickFindSpacesFragment}}}}${$7c8d7e5d36cb13e1$var$QuickFindSpacesFragment}`;

});

parcelRegister("9Lfxk", function(module, exports) {

$parcel$export(module.exports, "quickFindSearchQuery", () => $8c45e3f8287acbdd$export$ac350a1cbaa2773a);

var $4qT1X = parcelRequire("4qT1X");

var $3xvML = parcelRequire("3xvML");
const $8c45e3f8287acbdd$export$ac350a1cbaa2773a = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $3xvML.quickFindSearchGraphQuery),
        operationName: $3xvML.operationName
    });
};

});
parcelRegister("3xvML", function(module, exports) {

$parcel$export(module.exports, "operationName", () => $c3125637c00709c9$export$5db520940cf00715);
$parcel$export(module.exports, "quickFindSearchGraphQuery", () => $c3125637c00709c9$export$5dd443f88002bca3);
const $c3125637c00709c9$var$SearchResultAtlasProject = `
... on SearchResultAtlasProject {
  project {
    __typename
    key
  }
}
`;
const $c3125637c00709c9$var$SearchResultAtlasGoal = `
... on SearchResultAtlasGoal {
  goal {
    __typename
    key
  }
}
`;
const $c3125637c00709c9$var$SearchConfluencePageBlogAttachment = `
... on SearchConfluencePageBlogAttachment {
  __typename
  lastModified
  iconCssClass
  space {
    __typename
    id
    name
  }
  confluenceEntity @include(if: $includeAncestors) {
    ... on ConfluencePage {
      __typename
      ancestors {
        __typename
        id
        title
      }
    }
  }
}`;
const $c3125637c00709c9$export$5db520940cf00715 = 'QuickFindSearchQuery';
const $c3125637c00709c9$export$5dd443f88002bca3 = `
  query ${$c3125637c00709c9$export$5db520940cf00715}(
    $query: String!
    $cloudIdARI: String!
    $resultsLimit: Int!
    $spaceLimit: Int!
    $contentEntities: [String!]!
    $confluenceFilters: SearchConfluenceFilter
    $queryVersion: Int
    $searchSessionId: String
    $includeSpaces: Boolean!
    $includeAncestors: Boolean!
    $experimentId: String
    $shadowExperimentId: String
    $experimentLayers: [SearchExperimentLayer]
  ) {
    search {
      results: search(
        experience: "quick-find"
        query: $query
        first: $resultsLimit
        filters: {
          entities: $contentEntities
          locations: [$cloudIdARI]
          confluenceFilters: $confluenceFilters
        }
        analytics: {
          queryVersion: $queryVersion
          searchSessionId: $searchSessionId
        }
        experimentContext: {
          experimentId: $experimentId
          shadowExperimentId: $shadowExperimentId
          experimentLayers: $experimentLayers
        }
      ) {
        __typename
        edges {
          __typename
          node {
            id
            title
            url
            type
            iconUrl
            __typename
            ${$c3125637c00709c9$var$SearchConfluencePageBlogAttachment}
            ${$c3125637c00709c9$var$SearchResultAtlasProject}
            ${$c3125637c00709c9$var$SearchResultAtlasGoal}
          }
        }
        abTest {
          __typename
          abTestId
          controlId
          experimentId
        }
        totalCount
      }
      spaces: search(
        experience: "searchDialog"
        query: $query
        first: $spaceLimit
        filters: {
          entities: ["ati:cloud:confluence:space"]
          locations: [$cloudIdARI]
        }
        analytics: {
          queryVersion: $queryVersion
          searchSessionId: $searchSessionId
        }
      ) @include(if: $includeSpaces) {
        __typename
        edges {
          __typename
          node {
            ... on SearchConfluenceSpace {
              __typename
              id
              key
              title
              type
              url
              iconPath
            }
          }
        }
      }
    }
  }
`;

});


parcelRegister("jjQiR", function(module, exports) {

$parcel$export(module.exports, "getUserAndTeamSearchResults", () => $dca90199d0dcae68$export$69624d2b3a5a261b);

var $5kTPO = parcelRequire("5kTPO");
const $dca90199d0dcae68$var$MAX_RESULTS_USERS = 2;
const $dca90199d0dcae68$export$6e670d76ab78fcb3 = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)';
const $dca90199d0dcae68$export$69624d2b3a5a261b = ({ query: query, cloudId: cloudId, orgId: orgId, principalId: principalId = 'Context', intl: intl })=>(0, $5kTPO.default)({
        searchQueryFilter: $dca90199d0dcae68$export$6e670d76ab78fcb3,
        includeUsers: true,
        includeGroups: false,
        includeTeams: true,
        context: {
            contextType: 'confluence_search-dialog',
            principalId: principalId,
            productKey: 'confluence',
            siteId: cloudId,
            organizationId: orgId
        },
        maxNumberOfResults: $dca90199d0dcae68$var$MAX_RESULTS_USERS,
        query: query
    }, intl);

});

parcelRegister("gruCU", function(module, exports) {

$parcel$export(module.exports, "parsePartialApolloResults", () => $5eb9952c6e8f9411$export$e877f985e0128c5e);

var $3pqlr = parcelRequire("3pqlr");
function $5eb9952c6e8f9411$export$e877f985e0128c5e(data, graphQLErrors) {
    // Return data if there are no errors
    if (!graphQLErrors?.length) return data;
    // Return data if there are errors, but there is also partial data
    if (graphQLErrors?.length && data) {
        console.warn('Returning partial data despite GraphQL errors: ', graphQLErrors);
        return data;
    }
    // Throw an exception only if there are errors and NO data
    throw new (0, $3pqlr.GraphQLNoResultsWithErrorResponseError)(graphQLErrors);
}

});
parcelRegister("3pqlr", function(module, exports) {

$parcel$export(module.exports, "GraphQLNoResultsWithErrorResponseError", () => $1c744931ef76935f$export$beb638af7aef4c03);
class $1c744931ef76935f$export$beb638af7aef4c03 extends Error {
    constructor(graphQLErrors){
        super();
        this.graphQLErrors = void 0;
        this.name = 'GraphQLNoResultsWithErrorResponseError';
        this.graphQLErrors = graphQLErrors;
        this.message = 'GraphQL returned errors and no results';
    }
}

});



parcelRegister("k1wrx", function(module, exports) {

$parcel$export(module.exports, "EnlargedSearchResultContent", () => $136b05df76cfe49d$export$171a2a7e5a778acc);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dfZ5P = parcelRequire("dfZ5P");
var $jqsW9 = parcelRequire("jqsW9");

var $68Mwd = parcelRequire("68Mwd");

var $4jR19 = parcelRequire("4jR19");

var $9lW6K = parcelRequire("9lW6K");

var $1qfLF = parcelRequire("1qfLF");

var $5tPRL = parcelRequire("5tPRL");
const $136b05df76cfe49d$export$171a2a7e5a778acc = ({ icon: icon, label: label, title: title, highlightedTitle: highlightedTitle, meta: meta, additionalMeta: additionalMeta, displayAdditionalMetaWhenHighlightedOnly: displayAdditionalMetaWhenHighlightedOnly, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted, returnIcon: returnIcon = 'onHighlight', isRecentSearch: isRecentSearch, onRemove: onRemove })=>{
    const contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(null);
    const [isHover, setIsHover] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(false);
    const isActive = isKeyboardHighlighted || isHover;
    const showReturnIcon = (0, $gwFzn.useMemo)(()=>(returnIcon === 'always' || returnIcon === 'onHighlight' && isKeyboardHighlighted) && !isRecentSearch, [
        isKeyboardHighlighted,
        returnIcon,
        isRecentSearch
    ]);
    const showRemoveIcon = (0, $gwFzn.useMemo)(()=>isRecentSearch && isActive, [
        isRecentSearch,
        isActive
    ]);
    const showAdditionalMeta = (0, $gwFzn.useMemo)(()=>additionalMeta && (!displayAdditionalMetaWhenHighlightedOnly || isActive), [
        displayAdditionalMetaWhenHighlightedOnly,
        isActive,
        additionalMeta
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isKeyboardHighlighted && contentRef.current?.scrollIntoView) contentRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
        });
    }, [
        isKeyboardHighlighted
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.EnlargedResultContentWrapper), {
        ref: contentRef,
        isCollapsed: isCollapsed,
        isKeyboardHighlighted: isKeyboardHighlighted,
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false),
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedIconContainer), {
                children: icon
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.CollapsedResultContentWrapper), {
                "data-testid": "collapsed-result-view",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.EnlargedResultTitleContainer), {
                        isCollapsed: true,
                        children: [
                            typeof title === 'string' ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                                    title: title,
                                    className: "SearchDialogResultTitle",
                                    children: highlightedTitle ? (0, $9lW6K.enrichResultTitle)(highlightedTitle) : title
                                })
                            }) : title,
                            typeof label === 'string' ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.ResultLabel), {
                                title: label,
                                children: label
                            }) : label
                        ]
                    }),
                    meta && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedCollapsedResultDetailWrapper), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedCollapsedResultDetail), {
                            children: meta
                        })
                    })
                ]
            }),
            showAdditionalMeta && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedResultDetail), {
                children: additionalMeta
            }),
            showReturnIcon && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedReturnIconContainer), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jqsW9.SquareReturnIcon), {})
            }),
            showRemoveIcon && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedReturnIconContainer), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                    icon: (0, $dfZ5P.RemoveIcon),
                    spacing: 'compact',
                    onClick: onRemove,
                    label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...(0, $68Mwd.messages).remove_button_label
                    }),
                    appearance: 'subtle'
                })
            })
        ]
    });
};

});
parcelRegister("jqsW9", function(module, exports) {

$parcel$export(module.exports, "SquareReturnIcon", () => $247b5da4c2bbf48f$export$4501fc029b186da8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");
const $247b5da4c2bbf48f$export$4501fc029b186da8 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "nonzero",
                d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
                fill: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
            })
        ]
    });

});

parcelRegister("68Mwd", function(module, exports) {

$parcel$export(module.exports, "messages", () => $23def8654352e503$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $23def8654352e503$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    remove_button_label: {
        id: "search_dialog.results.remove_button_label",
        defaultMessage: "Remove this."
    }
});

});


parcelRegister("dDSTM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $383eef3932fe8448$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $383eef3932fe8448$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /**
   * Quick Find
   */ quick_find_search_input_placeholder: {
        id: "product_search_dialog.quick_find_search_input_rovo_placeholder",
        defaultMessage: "Search or ask Rovo"
    },
    quick_find_recent_search_text_dialog: {
        id: "product_search_dialog.quick_find_recent_search_text_dialog",
        defaultMessage: "From your recent searches"
    },
    quick_find_show_organization_results: {
        id: "product_search_dialog.quick_find_show_organization_results",
        defaultMessage: "Search your organization"
    },
    quick_find_show_filtered_results: {
        id: "product_search_dialog.quick_find_show_filtered_confluence_results",
        defaultMessage: "Filter by Confluence spaces, contributors and more"
    },
    quick_find_show_filtered_results_with_icon: {
        id: "product_search_dialog.quick_find_show_filtered_confluence_results_with_icon",
        defaultMessage: "Filter by {confluenceIcon} Confluence spaces, contributors and more"
    },
    quick_find_ask_atlassian_intelligence: {
        id: "product_search_dialog.quick_find_ask_atlassian_intelligence",
        defaultMessage: "Ask Atlassian Intelligence"
    },
    quick_find_recently_viewed: {
        id: "product_search_dialog.quick_find_recently_viewed",
        defaultMessage: "Recently Viewed"
    },
    quick_find_recent_draft_label: {
        id: "product_search_dialog.quick_find_recent_draft_label",
        defaultMessage: "DRAFT"
    },
    quick_find_recent_spaces_additional_meta: {
        id: "product_search_dialog.quick_find_recent_spaces_additional_meta",
        defaultMessage: "You recently visited"
    },
    quick_find_footer_text: {
        id: "product_search_dialog.quick_find_footer_help_text",
        defaultMessage: "Help us improve search"
    },
    quick_find_footer_full_page_search_link: {
        id: "product_search_dialog.quick_find_footer_full_page_search_products_link",
        defaultMessage: "Search across products"
    },
    quick_find_no_content_header: {
        id: "product_search_dialog.quick_find_no_content_header",
        defaultMessage: "Seek and you shall find"
    },
    quick_find_no_content_body: {
        id: "product_search_dialog.quick_find_no_content_body_rovo",
        defaultMessage: "Search or ask Rovo what you're looking for in your Atlassian and integrated products"
    },
    quick_find_post_query_no_results_header: {
        id: "product_search_dialog.quick_find_post_query_no_results_header",
        defaultMessage: "We couldn't find any results with that title"
    },
    quick_find_post_query_no_results_body: {
        id: "product_search_dialog.quick_find_post_query_no_results_body",
        defaultMessage: "<SearchContentLink>Search all content across your organization</SearchContentLink> or try again with a different term."
    },
    quick_find_search_results: {
        id: "product_search_dialog.quick_find_search_results",
        defaultMessage: "Search Results"
    },
    quick_find_confluence_space: {
        id: "product_search_dialog.quick_find_confluence_space",
        defaultMessage: "Confluence Space"
    },
    quick_find_results_section: {
        id: "product_search_dialog.quick_find_results_section",
        defaultMessage: "Search Results"
    },
    quick_find_results_team: {
        id: "product_search_dialog.quick_find_result_item_team",
        defaultMessage: "Team"
    },
    quick_find_recent_search: {
        id: "product_search_dialog.quick_find_recent_search",
        defaultMessage: "Recent search"
    },
    remove_button_label: {
        id: "product_search_dialog.results.remove_button_label",
        defaultMessage: "Remove this."
    },
    quick_find_rovo_tip: {
        id: "product_search_dialog.quick_find_rovo_tip",
        defaultMessage: "Enter a question like \u201CWhat\u2019s the vacation policy?\u201D and Rovo will find the answer."
    }
});

});

parcelRegister("8ioQN", function(module, exports) {

$parcel$export(module.exports, "EMPTY_SEARCH_ITEMS", () => $e45c02ccc2a6876d$export$205c1cd8d8ed1926);
const $e45c02ccc2a6876d$export$205c1cd8d8ed1926 = {
    size: 0,
    sections: []
};

});

parcelRegister("1WJaw", function(module, exports) {

$parcel$export(module.exports, "QuickFindResultRenderer", () => $1eb9e7406142d7a1$export$6e27f80792772bd6);

var $7UHDa = parcelRequire("7UHDa");

var $exgPf = parcelRequire("exgPf");
var $bO2XA = parcelRequire("bO2XA");
var $2LczZ = parcelRequire("2LczZ");

var $gwFzn = parcelRequire("gwFzn");

var $jFPud = parcelRequire("jFPud");

var $kPY5t = parcelRequire("kPY5t");

var $kUZlH = parcelRequire("kUZlH");

var $kf2EW = parcelRequire("kf2EW");
var $iN7gh = parcelRequire("iN7gh");
var $2hOQY = parcelRequire("2hOQY");

var $kTE07 = parcelRequire("kTE07");

var $4jR19 = parcelRequire("4jR19");

var $dDSTM = parcelRequire("dDSTM");

var $4Lm6U = parcelRequire("4Lm6U");

var $2hOQY = parcelRequire("2hOQY");

var $fJRVo = parcelRequire("fJRVo");

var $hyKIh = parcelRequire("hyKIh");

var $cGCOz = parcelRequire("cGCOz");

var $f0f3d = parcelRequire("f0f3d");

var $7OZuO = parcelRequire("7OZuO");

var $4ldrV = parcelRequire("4ldrV");

var $2OcMi = parcelRequire("2OcMi");
const $1eb9e7406142d7a1$export$6e27f80792772bd6 = ({ productState: productState, preQueryItems: preQueryItems, postQueryItems: postQueryItems, linkComponent: linkComponent, appendQueryParams: appendQueryParams, onRetryPreQuery: onRetryPreQuery, onRetryPostQuery: onRetryPostQuery })=>{
    const isMobileView = (0, $kPY5t.useIsMobileView)();
    const { isRovoEnabled: isRovoEnabled } = (0, $cGCOz.useRovoContext)();
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const activeProduct = getActiveProduct();
    const productId = activeProduct?.id;
    const renderResults = (0, $gwFzn.useCallback)(()=>{
        switch(productState){
            case (0, $jFPud.ProductStates).PreQuerySuccess:
            case (0, $jFPud.ProductStates).PreQueryLoading:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kUZlH.GenericSearchResult), {
                    searchItems: preQueryItems,
                    linkComponent: linkComponent,
                    screen: "preQuerySearchResults",
                    productState: productState,
                    isCollapsed: isMobileView,
                    appendQueryParams: appendQueryParams
                });
            case (0, $jFPud.ProductStates).PreQueryNoResult:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kTE07.PreQueryEmptyScreen), {});
            case (0, $jFPud.ProductStates).PreQueryError:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4Lm6U.SearchErrorScreen), {
                    onRetry: onRetryPreQuery
                });
            case (0, $jFPud.ProductStates).PostQueryTyping:
            case (0, $jFPud.ProductStates).PostQueryLoading:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kUZlH.GenericSearchResult), {
                    searchItems: postQueryItems,
                    linkComponent: linkComponent,
                    screen: "cachedResults",
                    productState: productState,
                    isCollapsed: isMobileView,
                    appendQueryParams: appendQueryParams,
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bO2XA.EnlargedSearchResultSection), {
                        title: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $dDSTM.messages).quick_find_search_results
                        }),
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $exgPf.EnlargedSearchResultContentSkeleton), {}),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $exgPf.EnlargedSearchResultContentSkeleton), {}),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $exgPf.EnlargedSearchResultContentSkeleton), {}),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $exgPf.EnlargedSearchResultContentSkeleton), {}),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $exgPf.EnlargedSearchResultContentSkeleton), {})
                        ]
                    })
                });
            case (0, $jFPud.ProductStates).PostQueryError:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4Lm6U.SearchErrorScreen), {
                    onRetry: onRetryPostQuery
                });
            case (0, $jFPud.ProductStates).PostQueryNoResult:
                const urlGeneratorForNoResultsScreen = (query)=>{
                    const generateUrl = activeProduct?.generateAdvancedSearchUrl || (()=>'');
                    const advancedSearchUrl = generateUrl(query);
                    return (0, $2OcMi.addQuery)(advancedSearchUrl, 'search_id', searchSessionId);
                };
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7OZuO.default), {
                    urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
                    fromQuickFindPostQueryNoResults: true
                });
            case (0, $jFPud.ProductStates).PostQuerySuccess:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kUZlH.GenericSearchResult), {
                    searchItems: postQueryItems,
                    linkComponent: linkComponent,
                    screen: "postQuerySearchResults",
                    productState: productState,
                    isCollapsed: isMobileView,
                    appendQueryParams: appendQueryParams
                });
        }
    }, [
        productState,
        preQueryItems,
        linkComponent,
        isMobileView,
        appendQueryParams,
        postQueryItems,
        onRetryPreQuery,
        onRetryPostQuery,
        activeProduct?.generateAdvancedSearchUrl,
        searchSessionId
    ]);
    const showSearchFooter = productState === (0, $jFPud.ProductStates).PreQuerySuccess || productState === (0, $jFPud.ProductStates).PreQueryLoading || productState === (0, $jFPud.ProductStates).PreQueryNoResult || productId === (0, $f0f3d.ProductKeys).Confluence && (productState === (0, $jFPud.ProductStates).PostQuerySuccess || productState === (0, $jFPud.ProductStates).PostQueryLoading || productState === (0, $jFPud.ProductStates).PostQueryNoResult);
    const showFilterFooter = productId === (0, $f0f3d.ProductKeys).Confluence && (productState === (0, $jFPud.ProductStates).PostQuerySuccess || productState === (0, $jFPud.ProductStates).PostQueryLoading || productState === (0, $jFPud.ProductStates).PostQueryNoResult);
    const showFeedbackFooter = productState === (0, $jFPud.ProductStates).PreQuerySuccess || productState === (0, $jFPud.ProductStates).PostQuerySuccess || productState === (0, $jFPud.ProductStates).PostQueryLoading || productState === (0, $jFPud.ProductStates).PostQueryNoResult;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            isRovoEnabled && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hyKIh.QuickFindRovoTip), {}),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LczZ.SearchDialogContent), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LczZ.ResultContainerOuter), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LczZ.ResultContainer), {
                        "aria-live": "polite",
                        children: renderResults()
                    })
                })
            }),
            showSearchFooter && productId === (0, $f0f3d.ProductKeys).Confluence ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2hOQY.SearchFooterPersistRecentSearch), {
                linkComponent: linkComponent
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2hOQY.SearchFooter), {
                linkComponent: linkComponent
            }),
            showFilterFooter && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iN7gh.FilterFooter), {}),
            showFeedbackFooter && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kf2EW.FeedbackFooter), {})
        ]
    });
};

});
parcelRegister("exgPf", function(module, exports) {

$parcel$export(module.exports, "EnlargedSearchResultContentSkeleton", () => $f5c3065a125d2f4b$export$958cb3907bb9ede);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5tPRL = parcelRequire("5tPRL");
const $f5c3065a125d2f4b$export$958cb3907bb9ede = ({})=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.EnlargedResultContentWrapper), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedIconContainer), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedSkeletonIcon), {})
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.CollapsedResultContentWrapper), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedResultTitleContainerSkeleton), {}),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedResultDetailSkeleton), {})
                ]
            })
        ]
    });
};

});

parcelRegister("bO2XA", function(module, exports) {

$parcel$export(module.exports, "EnlargedSearchResultSection", () => $c6b6394c69100db5$export$3cb2a92d364e01db);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $c4sKh = parcelRequire("c4sKh");

var $hiGBZ = parcelRequire("hiGBZ");
const $c6b6394c69100db5$export$3cb2a92d364e01db = ({ title: title, totalResults: totalResults, children: children })=>{
    const hasTitle = Boolean(title);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $hiGBZ.EnlargedSearchResultSectionContainer), {
        "data-vc": "search-result-section-enlarged",
        children: [
            hasTitle && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hiGBZ.EnlargedSearchResultSectionHeading), {
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $hiGBZ.EnlargedSearchResultsSectionTitle), {
                    children: [
                        title,
                        totalResults ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hiGBZ.SearchResultSectionTitleBadgeContainer), {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c4sKh.default), {
                                testId: "search-result-count-badge",
                                children: totalResults
                            })
                        }) : null
                    ]
                })
            }),
            children
        ]
    });
};

});
parcelRegister("hiGBZ", function(module, exports) {

$parcel$export(module.exports, "SearchResultSectionContainer", () => $4c44caf80474dcb2$export$ee908270616a8c0);
$parcel$export(module.exports, "EnlargedSearchResultSectionContainer", () => $4c44caf80474dcb2$export$503dfba90bfcca30);
$parcel$export(module.exports, "SearchResultSectionHeading", () => $4c44caf80474dcb2$export$12a98bde80b93e83);
$parcel$export(module.exports, "EnlargedSearchResultSectionHeading", () => $4c44caf80474dcb2$export$7ff5e58611d4f213);
$parcel$export(module.exports, "SearchResultsSectionTitle", () => $4c44caf80474dcb2$export$ce295363b4299a23);
$parcel$export(module.exports, "EnlargedSearchResultsSectionTitle", () => $4c44caf80474dcb2$export$ba58138b255a651c);
$parcel$export(module.exports, "SearchResultSectionTitleBadgeContainer", () => $4c44caf80474dcb2$export$47dafe5a3fc802fe);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $2azjJ = parcelRequire("2azjJ");

var $gwrgp = parcelRequire("gwrgp");
const $4c44caf80474dcb2$export$ee908270616a8c0 = (0, $gwrgp.default)("div", {
    target: "e1vq42j40"
})({
    padding: `${"var(--ds-space-100, 8px)"} 0`
});
const $4c44caf80474dcb2$export$503dfba90bfcca30 = (0, $gwrgp.default)("div", {
    target: "e1vq42j41"
})({
    name: "13xfj3y",
    styles: "padding:0;display:flex;flex-direction:column;gap:var(--ds-space-025, 2px);"
});
const $4c44caf80474dcb2$export$12a98bde80b93e83 = (0, $gwrgp.default)("div", {
    target: "e1vq42j42"
})({
    marginBottom: "var(--ds-space-075, 6px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: (0, $2azjJ.grid).multiple(4).px
});
const $4c44caf80474dcb2$export$7ff5e58611d4f213 = (0, $gwrgp.default)("div", {
    target: "e1vq42j43"
})({
    name: "1pkue4f",
    styles: "height:28px;display:flex;"
});
const $4c44caf80474dcb2$export$ce295363b4299a23 = (0, $gwrgp.default)("h2", {
    target: "e1vq42j44"
})({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $2azjJ.grid).twice().px,
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${(0, $2azjJ.grid).twice().px}`
});
const $4c44caf80474dcb2$export$ba58138b255a651c = (0, $gwrgp.default)("span", {
    target: "e1vq42j45"
})({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
    boxSizing: 'border-box',
    padding: `0 ${"var(--ds-space-100, 8px)"}`
});
const $4c44caf80474dcb2$export$47dafe5a3fc802fe = (0, $gwrgp.default)("div", {
    target: "e1vq42j46"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginLeft: (0, $2azjJ.grid).px,
    fontWeight: "var(--ds-font-weight-regular, 400)"
});

});


parcelRegister("jFPud", function(module, exports) {

$parcel$export(module.exports, "APIStates", () => $dfe01d0022147fd7$export$c701d1d8ac310aa0);
$parcel$export(module.exports, "ProductStates", () => $dfe01d0022147fd7$export$212790b4ffec121f);
var $dfe01d0022147fd7$export$c701d1d8ac310aa0 = /*#__PURE__*/ function(APIStates) {
    APIStates["Typing"] = "typing";
    APIStates["Loading"] = "loading";
    APIStates["Error"] = "error";
    APIStates["NoResult"] = "noresult";
    APIStates["Success"] = "success";
    return APIStates;
}({});
var $dfe01d0022147fd7$export$212790b4ffec121f = /*#__PURE__*/ function(ProductStates) {
    ProductStates["PreQueryLoading"] = "PreQueryLoading";
    ProductStates["PostQueryLoading"] = "PostQueryLoading";
    ProductStates["PreQuerySuccess"] = "PreQuerySuccess";
    ProductStates["PostQuerySuccess"] = "PostQuerySuccess";
    ProductStates["PreQueryError"] = "PreQueryError";
    ProductStates["PostQueryError"] = "PostQueryError";
    ProductStates["PreQueryNoResult"] = "PreQueryNoResult";
    ProductStates["PostQueryNoResult"] = "PostQueryNoResult";
    ProductStates["PostQueryTyping"] = "PostQueryTyping";
    ProductStates["Invalid"] = "Invalid";
    return ProductStates;
}({});

});

parcelRegister("kPY5t", function(module, exports) {

$parcel$export(module.exports, "useIsMobileView", () => $67b453f3f4811515$export$853d1166284edec0);

var $2azjJ = parcelRequire("2azjJ");
const $67b453f3f4811515$export$853d1166284edec0 = ()=>window.innerWidth <= (0, $2azjJ.dialogPageTakeoverWidth);

});

parcelRegister("kUZlH", function(module, exports) {

$parcel$export(module.exports, "GenericSearchResult", () => $3e96c9432766ab22$export$855c9ab7e6e3e97f);

var $7UHDa = parcelRequire("7UHDa");

var $bO2XA = parcelRequire("bO2XA");
var $lpcw3 = parcelRequire("lpcw3");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $hpDfc = parcelRequire("hpDfc");

var $2jE99 = parcelRequire("2jE99");

var $i0h8F = parcelRequire("i0h8F");

var $ipASa = parcelRequire("ipASa");

var $20N1w = parcelRequire("20N1w");

var $amrMu = parcelRequire("amrMu");

var $38QdT = parcelRequire("38QdT");
const $3e96c9432766ab22$export$f6fdc80358dfd95 = 10;
const $3e96c9432766ab22$export$fd06a2c70d34842e = (searchResultSections, sectionIndex)=>searchResultSections.slice(0, sectionIndex).reduce((accumulator, currentElem)=>accumulator + Math.min(currentElem.searchResults.length, currentElem.resultLimit || $3e96c9432766ab22$export$f6fdc80358dfd95), 0);
const $3e96c9432766ab22$var$getTotalResultCount = (forceHideResultCount, section)=>{
    // resultCount is only shown when a size is specified. We changed this
    // from using searchResults.length as we want to indicate the number of
    // possible search results rather than just the ones shown.
    const resultCount = !forceHideResultCount && section.showResultCount && section.size && section.searchResults.length ? Math.max(section.size, section.searchResults.length) : undefined;
    // totalResults considers the count returned from a section's resultMapper
    // to ensure rendered results align with the displayed count, in case results shown
    // are limited by the resultMapper
    const totalResults = Boolean(resultCount && section.searchResults.length < (section.resultLimit || $3e96c9432766ab22$export$f6fdc80358dfd95) && resultCount >= section.searchResults.length) ? section.searchResults.length : resultCount;
    return totalResults;
};
const $3e96c9432766ab22$var$GenericSearchResultWithIntl = ({ children: children, forceHideResultCount: forceHideResultCount = false, generateSectionTitle: generateSectionTitle = ({ title: title })=>title, intl: intl, isCollapsed: isCollapsed, linkComponent: linkComponent, productState: productState, renderSectionViewAll: renderSectionViewAll, searchItems: searchItems, screen: screen, nonPrivacySafeAnalyticContext: nonPrivacySafeAnalyticContext, appendQueryParams: appendQueryParams })=>{
    const { quickFind: quickFind } = (0, $amrMu.useFeaturesContext)();
    if (!searchItems || !(0, $2jE99.hasSearchResults)(searchItems)) {
        // This is mainly used to handle the loading state (e.g. a spinner or a skeleton)
        if (children) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $38QdT.SearchResultWrapper), {
            children: children
        });
        return null;
    }
    const ResultSection = quickFind?.enabled ? (0, $bO2XA.EnlargedSearchResultSection) : (0, $lpcw3.SearchResultSection);
    const QuickFindPersistRecentSearch = quickFind?.enabled ? (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment : (0, $20N1w.PersistRecentSearch);
    const ItemSection = (props)=>{
        const { section: section, sectionIndex: sectionIndex } = props;
        const itemLimit = typeof section.resultLimit === 'number' ? section.resultLimit : $3e96c9432766ab22$export$f6fdc80358dfd95;
        const searchResults = section.searchResults?.slice(0, itemLimit) || [];
        const totalResults = $3e96c9432766ab22$var$getTotalResultCount(forceHideResultCount, section);
        const totalNumberOfItemsInPreviousSections = $3e96c9432766ab22$export$fd06a2c70d34842e(searchItems.sections, sectionIndex);
        if (searchResults.length === 0) return null;
        return /*#__PURE__*/ (0, $7UHDa.jsxs)(ResultSection, {
            totalResults: totalResults,
            title: section.titleRenderer ? section.titleRenderer({
                isCollapsed: isCollapsed,
                productState: productState
            }) : generateSectionTitle(section, intl),
            children: [
                searchResults.map((result, index)=>{
                    const analyticContext = {
                        sectionIndex: sectionIndex,
                        sectionId: section.id,
                        containerId: result.containerId || null,
                        indexWithinSection: index,
                        globalIndex: totalNumberOfItemsInPreviousSections + index,
                        isCached: result.isRecentResult || false,
                        metadata: {
                            contentId: result.id,
                            containerId: result.containerId || null,
                            contentType: result.type || null
                        }
                    };
                    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
                        analyticContext: analyticContext,
                        nonPrivacySafeAnalyticContext: nonPrivacySafeAnalyticContext || {},
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)(QuickFindPersistRecentSearch, {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $i0h8F.SearchResultItem), {
                                isCollapsed: isCollapsed,
                                linkComponent: linkComponent,
                                productState: productState,
                                resultRenderer: section.resultRenderer,
                                resultWrapper: section.resultWrapper,
                                screen: screen,
                                searchResult: result,
                                appendQueryParams: appendQueryParams,
                                useAnalyticsOverride: section.useAnalyticsOverride
                            })
                        })
                    }, result.id);
                }),
                renderSectionViewAll && section.viewAllLinkGenerator && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ipASa.ViewAllLink), {
                    linkComponent: linkComponent,
                    section: section,
                    totalResults: totalResults
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $38QdT.SearchResultWrapper), {
        children: [
            searchItems.sections.map((section, index)=>/*#__PURE__*/ (0, $7UHDa.jsx)(ItemSection, {
                    section: section,
                    sectionIndex: index
                }, section.id)),
            children
        ]
    });
};
const $3e96c9432766ab22$export$855c9ab7e6e3e97f = (0, $js7oX.default)($3e96c9432766ab22$var$GenericSearchResultWithIntl);

});
parcelRegister("lpcw3", function(module, exports) {

$parcel$export(module.exports, "SearchResultSection", () => $806221755b41bdf0$export$51a5a703da15f0f7);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $c4sKh = parcelRequire("c4sKh");

var $hiGBZ = parcelRequire("hiGBZ");
const $806221755b41bdf0$export$51a5a703da15f0f7 = ({ title: title, totalResults: totalResults, children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $hiGBZ.SearchResultSectionContainer), {
        "data-vc": "search-result-section",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hiGBZ.SearchResultSectionHeading), {
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $hiGBZ.SearchResultsSectionTitle), {
                    children: [
                        title,
                        totalResults ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hiGBZ.SearchResultSectionTitleBadgeContainer), {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c4sKh.default), {
                                testId: "search-result-count-badge",
                                children: totalResults
                            })
                        }) : null
                    ]
                })
            }),
            children
        ]
    });
};

});

parcelRegister("2jE99", function(module, exports) {

$parcel$export(module.exports, "hasSearchResults", () => $278487f7dee8bb82$export$bcf020eea629e7ed);
const $278487f7dee8bb82$export$bcf020eea629e7ed = (searchItems)=>{
    const sectionsWithSearchResults = searchItems.sections.filter(({ searchResults: searchResults })=>searchResults.length > 0);
    return sectionsWithSearchResults.length > 0;
};

});

parcelRegister("i0h8F", function(module, exports) {

$parcel$export(module.exports, "SearchResultItem", () => $37c05cfbff7bc1a9$export$56e008c8bd1ccf7c);

var $7UHDa = parcelRequire("7UHDa");

var $WEXnq = parcelRequire("WEXnq");
var $16tQa = parcelRequire("16tQa");

var $gwFzn = parcelRequire("gwFzn");

var $4ldrV = parcelRequire("4ldrV");

var $2OcMi = parcelRequire("2OcMi");

var $ejGzS = parcelRequire("ejGzS");

var $O4eEI = parcelRequire("O4eEI");
const $37c05cfbff7bc1a9$var$DefaultSearchResultItemWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};
/**
 * Intended to be used for search results that are not links
 */ const $37c05cfbff7bc1a9$var$SearchResultItemKeyboardHiglightWrapper = ({ searchResultId: searchResultId, children: children })=>{
    const { isKeyboardHighlighted: isKeyboardHighlighted, ref: ref } = (0, $16tQa.useKeyboardHighlighting)({
        searchResultId: searchResultId
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ref: ref,
        children: children(isKeyboardHighlighted)
    });
};
const $37c05cfbff7bc1a9$export$56e008c8bd1ccf7c = ({ isCollapsed: isCollapsed, linkComponent: linkComponent, productState: productState, resultRenderer: resultRenderer, resultWrapper: resultWrapper, screen: screen, searchResult: searchResult, appendQueryParams: appendQueryParams, useAnalyticsOverride: useAnalyticsOverride = ()=>({}) })=>{
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { onHighlightCallback: defaultOnHighlightCallback, onSelectCallback: defaultOnSelectCallback, onContextMenuCallback: defaultOnContextMenuCallback } = (0, $O4eEI.useSearchResultAnalyticsCallbacks)({
        screen: screen,
        actionSubject: 'searchResult'
    });
    const { onHighlightCallback: overriddenOnHighlightCallback, onSelectCallback: overriddenOnSelectCallback, onContextMenuCallback: overriddenOnContextMenuCallback } = useAnalyticsOverride({
        screen: screen
    });
    const url = appendQueryParams === undefined ? (0, $2OcMi.addQuery)(searchResult.url, 'search_id', searchSessionId) : appendQueryParams(searchResult.url, searchSessionId, searchResult.type, searchResult.id);
    const SearchResultItemWrapper = resultWrapper || $37c05cfbff7bc1a9$var$DefaultSearchResultItemWrapper;
    const searchResultContentRenderer = (0, $gwFzn.useCallback)((isKeyboardHighlighted)=>resultRenderer ? resultRenderer({
            isCollapsed: isCollapsed,
            isKeyboardHighlighted: isKeyboardHighlighted,
            productState: productState,
            screen: screen,
            searchResult: searchResult
        }) : (0, $ejGzS.defaultResultRenderer)({
            isCollapsed: isCollapsed,
            isKeyboardHighlighted: isKeyboardHighlighted,
            screen: screen,
            searchResult: searchResult
        }), [
        isCollapsed,
        productState,
        resultRenderer,
        screen,
        searchResult
    ]);
    const id = `link-${searchResult.id}`;
    return /*#__PURE__*/ (0, $7UHDa.jsx)(SearchResultItemWrapper, {
        url: url,
        titleId: id,
        children: url ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $WEXnq.SearchResultLink), {
            href: url,
            linkComponent: searchResult.linkComponent ?? linkComponent,
            searchResultId: searchResult.id,
            onContextMenu: overriddenOnContextMenuCallback || defaultOnContextMenuCallback,
            onHighlighted: overriddenOnHighlightCallback || defaultOnHighlightCallback,
            onSelect: overriddenOnSelectCallback || defaultOnSelectCallback,
            "data-testid": id,
            id: id,
            children: (isKeyboardHighlighted)=>searchResultContentRenderer(isKeyboardHighlighted)
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)($37c05cfbff7bc1a9$var$SearchResultItemKeyboardHiglightWrapper, {
            searchResultId: searchResult.id,
            children: (isKeyboardHighlighted)=>searchResultContentRenderer(isKeyboardHighlighted)
        })
    });
};

});
parcelRegister("WEXnq", function(module, exports) {

$parcel$export(module.exports, "SearchResultLink", () => $6dc18a1d5e5462b9$export$76cc11d043a1381);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5tPRL = parcelRequire("5tPRL");

var $16tQa = parcelRequire("16tQa");
const $6dc18a1d5e5462b9$export$76cc11d043a1381 = ({ children: children, href: href, linkComponent: linkComponent, searchResultId: searchResultId, onSelect: onSelect, onHighlighted: onHighlighted, onContextMenu: onContextMenu, ...rest })=>{
    const { isKeyboardHighlighted: isKeyboardHighlighted, ref: ref } = (0, $16tQa.useKeyboardHighlighting)({
        searchResultId: searchResultId,
        onHighlighted: onHighlighted
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ref: ref,
        onClick: onSelect,
        onContextMenu: onContextMenu,
        role: "none",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.ResultLink), {
            linkComponent: linkComponent,
            href: href,
            ...rest,
            children: children(isKeyboardHighlighted)
        })
    }));
};

});
parcelRegister("16tQa", function(module, exports) {

$parcel$export(module.exports, "useKeyboardHighlighting", () => $c5296a0f968b5575$export$9803d460130e453);

var $gwFzn = parcelRequire("gwFzn");

var $icqFF = parcelRequire("icqFF");
/**
 * Callback which simulates a click on the target element when the enter key
 * is pressed whilst the target element is active.
 *
 * @param e Event from key down
 * @param target Active element when key was pressed
 */ const $c5296a0f968b5575$var$onKeyDown = (e, target)=>{
    // Only navigate if Enter was pressed without any modifiers
    if (e.key === 'Enter' && !e.shiftKey && !e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        // Find the deepest child element in the DOM
        let clickTarget = target;
        while(clickTarget.firstElementChild instanceof HTMLElement && clickTarget.firstElementChild?.click)clickTarget = clickTarget.firstElementChild;
        clickTarget.click();
    }
};
const $c5296a0f968b5575$export$9803d460130e453 = ({ searchResultId: searchResultId, onHighlighted: onHighlighted })=>{
    const [isKeyboardHighlighted, ref] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: $c5296a0f968b5575$var$onKeyDown,
        navigationTrackingId: searchResultId ?? null
    });
    // Ref for whether or not this search result was last highlighted
    const previousHighlight = (0, $gwFzn.useRef)(false);
    // Call the onHighlighted callback when this search result is highlighted
    (0, $gwFzn.useEffect)(()=>{
        if (!previousHighlight.current && isKeyboardHighlighted) onHighlighted?.();
        previousHighlight.current = isKeyboardHighlighted;
    }, [
        isKeyboardHighlighted,
        previousHighlight,
        onHighlighted
    ]);
    return {
        isKeyboardHighlighted: isKeyboardHighlighted,
        ref: ref
    };
};

});


parcelRegister("ejGzS", function(module, exports) {

$parcel$export(module.exports, "defaultResultRenderer", () => $c2d03b527301e03f$export$fa734eedc505eef7);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dcJ7R = parcelRequire("dcJ7R");

var $cO3Oi = parcelRequire("cO3Oi");

var $gnG2x = parcelRequire("gnG2x");

var $9Qum6 = parcelRequire("9Qum6");
const $c2d03b527301e03f$export$fa734eedc505eef7 = ({ isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted, screen: screen, searchResult: searchResult })=>{
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(searchResult.icon) ? searchResult.icon : typeof searchResult.icon === 'string' ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9Qum6.ResultAvatar), {
        borderColor: "transparent",
        src: searchResult.icon,
        appearance: "square",
        size: "xsmall",
        testId: "result-avatar"
    }) : searchResult.iconRenderer ? searchResult.iconRenderer({
        screen: screen
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9Qum6.ResultAvatar), {
        borderColor: "transparent",
        src: searchResult.iconUrl,
        appearance: "square",
        size: "xsmall",
        testId: "result-avatar"
    });
    const title = searchResult.isVerified ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        space: "space.025",
        alignBlock: "center",
        children: [
            searchResult.title,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cO3Oi.VerifiedTeamIcon), {})
        ]
    }) : searchResult.title;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gnG2x.SearchResultContent), {
        isKeyboardHighlighted: isKeyboardHighlighted,
        title: title,
        meta: searchResult.meta,
        additionalMeta: searchResult.additionalMeta,
        isCollapsed: isCollapsed,
        icon: icon
    }, `item_${searchResult.id}`);
};

});
parcelRegister("gnG2x", function(module, exports) {

$parcel$export(module.exports, "SearchResultContent", () => $9f2dcb84dea7d967$export$b5fd7d6305bfbd3e);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $epvHH = parcelRequire("epvHH");

var $5tPRL = parcelRequire("5tPRL");
const $9f2dcb84dea7d967$export$595b9d59c3d65270 = '@@@hl@@@';
const $9f2dcb84dea7d967$export$eea8f6b95460c3c3 = '@@@endhl@@@';
const $9f2dcb84dea7d967$var$getResultLabel = (label)=>{
    if (typeof label === 'string') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.ResultLabel), {
        title: typeof label === 'string' ? label : undefined,
        children: label
    });
    return label;
};
const $9f2dcb84dea7d967$var$getResultTitle = (title)=>{
    if (typeof title === 'string') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            title: title,
            className: "SearchDialogResultTitle",
            children: title
        })
    });
    return title;
};
const $9f2dcb84dea7d967$export$b5fd7d6305bfbd3e = ({ icon: icon, label: label, title: title, meta: meta, additionalMeta: additionalMeta, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted })=>{
    const getResultContent = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
            children: isCollapsed ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.CollapsedResultContentWrapper), {
                "data-testid": "collapsed-result-view",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.ResultTitleContainer), {
                        isCollapsed: true,
                        children: [
                            $9f2dcb84dea7d967$var$getResultLabel(label),
                            $9f2dcb84dea7d967$var$getResultTitle(title)
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.CollapsedResultDetailWrapper), {
                        children: [
                            meta && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.CollapsedResultDetail), {
                                title: typeof meta === 'string' ? meta : undefined,
                                children: meta
                            }),
                            additionalMeta && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.DetailsSeparator), {
                                        children: "\u2022"
                                    }),
                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.CollapsedResultDetail), {
                                        children: additionalMeta
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.ResultTitleContainer), {
                        children: [
                            $9f2dcb84dea7d967$var$getResultLabel(label),
                            $9f2dcb84dea7d967$var$getResultTitle(title)
                        ]
                    }),
                    meta && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.ResultDetail), {
                        title: typeof meta === 'string' ? meta : undefined,
                        children: meta
                    }),
                    additionalMeta ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.ResultDetail), {
                        title: typeof additionalMeta === 'string' ? additionalMeta : undefined,
                        children: additionalMeta
                    }) : null
                ]
            })
        });
    const contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(null);
    (0, $gwFzn.useEffect)(()=>{
        if (isKeyboardHighlighted && contentRef.current?.scrollIntoView) contentRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
        });
    }, [
        isKeyboardHighlighted
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.ResultContentWrapper), {
        ref: contentRef,
        isCollapsed: isCollapsed,
        isKeyboardHighlighted: isKeyboardHighlighted,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.IconContainer), {
                children: icon
            }),
            getResultContent(),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.ReturnIconContainer), {
                isCollapsed: isCollapsed,
                isKeyboardHighlighted: isKeyboardHighlighted,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $epvHH.ReturnIcon), {
                    inverted: true
                })
            })
        ]
    });
};

});

parcelRegister("9Qum6", function(module, exports) {

$parcel$export(module.exports, "ResultAvatar", () => $97dd1a753677152a$export$d2397285980ae833);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $esRft = parcelRequire("esRft");

var $gwrgp = parcelRequire("gwrgp");
const $97dd1a753677152a$var$NegativeMargin = (0, $gwrgp.default)("div", {
    target: "ez36xyc0"
})({
    name: "43a5nv",
    styles: "margin:var(--ds-space-negative-025, -2px);display:flex;"
});
const $97dd1a753677152a$export$d2397285980ae833 = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)($97dd1a753677152a$var$NegativeMargin, {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
            ...props
        })
    });

});


parcelRegister("O4eEI", function(module, exports) {

$parcel$export(module.exports, "useSearchResultAnalyticsCallbacks", () => $2ea9acd69c9f229c$export$4381245974d3b25a);

var $gwFzn = parcelRequire("gwFzn");

var $5dFS9 = parcelRequire("5dFS9");
var $6dP89 = parcelRequire("6dP89");
const $2ea9acd69c9f229c$export$4381245974d3b25a = ({ onHighlighted: onHighlighted, onSelect: onSelect, screen: screen, actionSubject: actionSubject })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const onHighlightCallback = (0, $gwFzn.useCallback)(()=>{
        fireAnalyticsEvent((0, $5dFS9.onSearchResultHighlighted)({
            screen: screen,
            actionSubject: actionSubject
        }));
        onHighlighted?.();
    }, [
        actionSubject,
        fireAnalyticsEvent,
        onHighlighted,
        screen
    ]);
    const onSelectCallback = (0, $gwFzn.useCallback)((e)=>{
        fireAnalyticsEvent((0, $5dFS9.onSearchResultSelected)({
            screen: screen,
            actionSubject: actionSubject
        }));
        onSelect?.(e);
    }, [
        actionSubject,
        fireAnalyticsEvent,
        onSelect,
        screen
    ]);
    const onContextMenuCallback = (0, $gwFzn.useCallback)((e)=>{
        fireAnalyticsEvent((0, $5dFS9.onSearchResultContext)({
            screen: screen,
            actionSubject: actionSubject
        }));
    }, [
        actionSubject,
        fireAnalyticsEvent,
        screen
    ]);
    return {
        onHighlightCallback: onHighlightCallback,
        onSelectCallback: onSelectCallback,
        onContextMenuCallback: onContextMenuCallback
    };
};

});


parcelRegister("ipASa", function(module, exports) {

$parcel$export(module.exports, "ViewAllLink", () => $ae4aed250b0b0b86$export$f8fe8ba0816633ed);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $hgHjQ = parcelRequire("hgHjQ");

var $bF0iL = parcelRequire("bF0iL");

var $2ZIpG = parcelRequire("2ZIpG");

var $6dP89 = parcelRequire("6dP89");

var $5dFS9 = parcelRequire("5dFS9");
const $ae4aed250b0b0b86$export$f8fe8ba0816633ed = ({ linkComponent: linkComponent, section: section, totalResults: totalResults = 0 })=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const { viewAllLinkGenerator: viewAllLinkGenerator, viewAllLinkRenderer: viewAllLinkRenderer } = section;
    if (!viewAllLinkGenerator) return null;
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        onClick: ()=>{
            fireAnalyticsEvent((0, $5dFS9.onSearchResultViewAllLinkClicked)(section.id));
        },
        role: "none",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hgHjQ.SearchResultSectionLink), {
            linkComponent: linkComponent,
            href: viewAllLinkGenerator(query),
            testId: "search-result-section-link",
            children: viewAllLinkRenderer ? viewAllLinkRenderer({
                section: section,
                totalResults: totalResults
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $bF0iL.messages).common_show_all_results_link
            })
        })
    }));
};

});
parcelRegister("hgHjQ", function(module, exports) {

$parcel$export(module.exports, "SearchResultSectionLink", () => $a5b1325517543fd8$export$f39804bac419a7f4);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5A4WA = parcelRequire("5A4WA");
const $a5b1325517543fd8$export$f39804bac419a7f4 = ({ children: children, linkComponent: linkComponent, ...rest })=>/* component must either be `undefined` or an component. A null or false will throw an error */ /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5A4WA.SectionLink), {
        appearance: "link",
        ...rest,
        component: linkComponent || undefined,
        children: children
    });

});
parcelRegister("5A4WA", function(module, exports) {

$parcel$export(module.exports, "SectionLink", () => $9155aa83cf58fa2b$export$3545bd757920e2b3);

var $eEA8O = parcelRequire("eEA8O");

var $2azjJ = parcelRequire("2azjJ");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $9155aa83cf58fa2b$export$3545bd757920e2b3 = /*#__PURE__*/ (0, $gwrgp.default)((0, $eEA8O.default), {
    target: "e1052ovn0"
})("margin-left:", (0, $2azjJ.grid).half().px, ";color:", `var(--ds-link, ${(0, $6fnsQ.B400)})`, ";cursor:pointer !important;&:hover{text-decoration:underline !important;}");

});



parcelRegister("20N1w", function(module, exports) {

$parcel$export(module.exports, "usePersistRecentSearches", () => $6c6cdd0bab182993$export$3adda20dc7f5408f);
$parcel$export(module.exports, "PersistRecentSearch", () => $6c6cdd0bab182993$export$c8074e5d4e733c21);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $iEwUU = parcelRequire("iEwUU");

var $1SV4e = parcelRequire("1SV4e");

var $fJRVo = parcelRequire("fJRVo");

var $2ZIpG = parcelRequire("2ZIpG");
const $6c6cdd0bab182993$export$3adda20dc7f5408f = (overrideQuery)=>{
    const previousQuery = (0, $gwFzn.useRef)(null);
    const { user: user } = (0, $iEwUU.useUserContext)();
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const product = getActiveProduct();
    const persistRecentSearch = (0, $gwFzn.useCallback)(()=>{
        if (user?.id && product?.id) {
            if (overrideQuery && overrideQuery.trim() !== '') (0, $1SV4e.addRecentSearch)(overrideQuery, user.id, product.id, (0, $1SV4e.RECENT_SEARCH_KEY));
            else if (previousQuery.current !== query && query.trim() !== '') {
                (0, $1SV4e.addRecentSearch)(query, user.id, product.id, (0, $1SV4e.RECENT_SEARCH_KEY));
                previousQuery.current = query;
            }
        }
    }, [
        product?.id,
        query,
        user.id,
        overrideQuery
    ]);
    const onClick = (0, $gwFzn.useCallback)(()=>{
        persistRecentSearch();
    }, [
        persistRecentSearch
    ]);
    const onEnter = (0, $gwFzn.useCallback)((event)=>{
        if (event.key === 'Enter') persistRecentSearch();
    }, [
        persistRecentSearch
    ]);
    return [
        onClick,
        onEnter
    ];
};
const $6c6cdd0bab182993$export$c8074e5d4e733c21 = ({ children: children, overrideQuery: overrideQuery })=>{
    const [onClick, onEnter] = $6c6cdd0bab182993$export$3adda20dc7f5408f(overrideQuery);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        onClick: onClick,
        onKeyDown: onEnter,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: '100%'
        },
        "data-testid": "persist-recent-search",
        children: children
    }));
};

});

parcelRegister("38QdT", function(module, exports) {

$parcel$export(module.exports, "SearchResultWrapper", () => $da656065b0b219a8$export$7ef688c5abd67ccc);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6hiXa = parcelRequire("6hiXa");

var $amrMu = parcelRequire("amrMu");
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da656065b0b219a8$var$QuickFindSearchResultWrapper = (0, $6hiXa.default).div`
	display: flex;
	flex-direction: column;
	gap: ${"var(--ds-space-025, 2px)"};
	padding: ${"var(--ds-space-100, 8px)"};
`;
const $da656065b0b219a8$export$7ef688c5abd67ccc = ({ children: children })=>{
    const { quickFind: quickFind } = (0, $amrMu.useFeaturesContext)();
    return quickFind?.enabled ? /*#__PURE__*/ (0, $7UHDa.jsx)($da656065b0b219a8$var$QuickFindSearchResultWrapper, {
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};

});


parcelRegister("kf2EW", function(module, exports) {

$parcel$export(module.exports, "FeedbackFooter", () => $9f20ae4c2debb5df$export$e7b87342306a8337);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dDSTM = parcelRequire("dDSTM");

var $kiEGX = parcelRequire("kiEGX");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $8UOsA = parcelRequire("8UOsA");
const $9f20ae4c2debb5df$var$footerContainerStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    borderTop: '1px solid',
    borderColor: 'color.border',
    display: 'flex',
    alignItems: 'center',
    color: 'color.text',
    gap: 'space.150'
});
const $9f20ae4c2debb5df$export$e7b87342306a8337 = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $9f20ae4c2debb5df$var$footerContainerStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $dDSTM.messages).quick_find_footer_text
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kiEGX.default), {
                TriggerComponent: ({ onClick: onClick })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UOsA.FeedbackButton), {
                        onClick: onClick
                    })
            })
        ]
    });
};

});
parcelRegister("kiEGX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1b8b9c22c9ab1c26$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6uGcC = parcelRequire("6uGcC");

var $iLCTn = parcelRequire("iLCTn");

var $dBxQj = parcelRequire("dBxQj");

var $iEwUU = parcelRequire("iEwUU");

var $h2sba = parcelRequire("h2sba");

var $2GmtI = parcelRequire("2GmtI");

var $kmpep = parcelRequire("kmpep");

var $fJRVo = parcelRequire("fJRVo");

var $amrMu = parcelRequire("amrMu");

var $91yhh = parcelRequire("91yhh");

const $1b8b9c22c9ab1c26$var$AkFeedbackCollector = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("islOg")).then((module)=>{
        return {
            default: module.default
        };
    }));

const $1b8b9c22c9ab1c26$var$AkFeedbackFlag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("islOg")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $1b8b9c22c9ab1c26$var$HELLO_TENANT_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $1b8b9c22c9ab1c26$var$ENTRYPOINT_ID = '9b88e53b-d04d-4f1c-ae85-6d7f59d1ca7a';
const $1b8b9c22c9ab1c26$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
/**
 * Feedback collector for extensible tabs in Quick Search i.e. confluence tab in QS and QF
 */ const $1b8b9c22c9ab1c26$var$FeedbackCollector = ({ TriggerComponent: TriggerComponent = (0, $h2sba.FeedbackButton) })=>{
    const { user: user } = (0, $iEwUU.useUserContext)();
    const { name: name, id: id } = user;
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $gwFzn.useState)(false);
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const { backendExperiment: backendExperiment, frontendExperiments: frontendExperiments = {} } = (0, $91yhh.useExperiments)();
    const { getActiveProduct: getActiveProduct, getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const activeProduct = getActiveProduct()?.title;
    const primaryProduct = getPrimaryProduct()?.title;
    const isHello = $1b8b9c22c9ab1c26$var$HELLO_TENANT_ID === cloudId;
    const isQuickFind = (0, $amrMu.useFeaturesContext)().quickFind?.enabled;
    const experience = isQuickFind ? 'quick-find' : 'quick-search';
    const feedbackContext = JSON.stringify({
        experimentLayers: backendExperiment?.experimentLayers,
        frontendExperiments: frontendExperiments,
        frontendVersion: (0, $2GmtI.BUILD_VERSION),
        product: activeProduct,
        primaryProduct: primaryProduct,
        cloudId: cloudId,
        userId: id,
        source: 'product-search-dialog',
        isHello: isHello,
        experience: experience,
        release: (0, $iLCTn.getProductReleaseVersion)(primaryProduct)
    });
    const { locale: locale } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)(TriggerComponent, {
                onClick: (e)=>{
                    e.preventDefault();
                    setIsOpen(true);
                }
            }),
            isOpen ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($1b8b9c22c9ab1c26$var$AkFeedbackCollector, {
                    locale: locale,
                    onClose: ()=>setIsOpen(false),
                    onSubmit: ()=>setDisplayFlag(true),
                    atlassianAccountId: id,
                    name: name,
                    entrypointId: $1b8b9c22c9ab1c26$var$ENTRYPOINT_ID,
                    additionalFields: [
                        {
                            id: $1b8b9c22c9ab1c26$var$FEEDBACK_CONTEXT_CF,
                            value: feedbackContext
                        }
                    ]
                })
            }) : null,
            displayFlag && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6uGcC.default), {
                onDismissed: ()=>setDisplayFlag(false),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                    fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)($1b8b9c22c9ab1c26$var$AkFeedbackFlag, {
                        locale: locale
                    })
                })
            })
        ]
    });
};
var $1b8b9c22c9ab1c26$export$2e2bcd8739ae039 = $1b8b9c22c9ab1c26$var$FeedbackCollector;

});
parcelRegister("h2sba", function(module, exports) {

$parcel$export(module.exports, "FeedbackButton", () => $9740cc300cdd6cc9$export$116fedbe5e2e2bd8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $bF0iL = parcelRequire("bF0iL");

var $ccHMk = parcelRequire("ccHMk");
const $9740cc300cdd6cc9$var$buttonStyles = (0, $3jLHL.css)({
    margin: '0 auto',
    width: 'fit-content'
});
const $9740cc300cdd6cc9$export$116fedbe5e2e2bd8 = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $9740cc300cdd6cc9$var$buttonStyles
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $ccHMk.default), {
        onClick: onClick,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $bF0iL.messages).common_give_feedback)));
};

});

parcelRegister("2GmtI", function(module, exports) {

$parcel$export(module.exports, "BUILD_VERSION", () => $4178462f01553fa5$export$2db401a6b81eceee);
const $4178462f01553fa5$var$packageName = "platform-pkg";
const $4178462f01553fa5$var$packageVersion = "0.0.0-use.local";
const $4178462f01553fa5$export$2db401a6b81eceee = `${$4178462f01553fa5$var$packageName}@${$4178462f01553fa5$var$packageVersion}`;

});



parcelRegister("iN7gh", function(module, exports) {

$parcel$export(module.exports, "FilterFooter", () => $abeef2063379c8b4$export$b4bfb1c3ed0cdeca);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $lAFHW = parcelRequire("lAFHW");

var $4mZlP = parcelRequire("4mZlP");

var $dDSTM = parcelRequire("dDSTM");

var $8fCWV = parcelRequire("8fCWV");

var $20N1w = parcelRequire("20N1w");
const $abeef2063379c8b4$export$b4bfb1c3ed0cdeca = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const confluenceIcon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lAFHW.ConfluenceIcon), {
        appearance: "brand",
        size: "small"
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $20N1w.PersistRecentSearch), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8fCWV.QuickFindAdvancedSearchLink), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.AdvancedSearchFooter), {
                squareReturnIcon: true,
                searchFooterLabel: formatMessage((0, $dDSTM.messages).quick_find_show_filtered_results),
                searchFooterLabelWithIcon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $dDSTM.messages).quick_find_show_filtered_results_with_icon,
                    values: {
                        confluenceIcon: confluenceIcon
                    }
                }),
                filterByProductFooter: true
            })
        })
    });
};

});
parcelRegister("8fCWV", function(module, exports) {

$parcel$export(module.exports, "QuickFindAdvancedSearchLink", () => $d9eaece468643009$export$a10ba81e8e8d140);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $d9eaece468643009$export$a10ba81e8e8d140 = (0, $gwrgp.default)("div", {
    target: "e58cvu60"
})({
    borderTop: `1px solid ${`var(--ds-border, ${(0, $6fnsQ.N40A)})`}`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> span > a': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    }
});

});


parcelRegister("2hOQY", function(module, exports) {

$parcel$export(module.exports, "SearchFooter", () => $7b3b7f54929a6bc9$export$64ded8b71dfcba9e);
$parcel$export(module.exports, "SearchFooterPersistRecentSearch", () => $7b3b7f54929a6bc9$export$8784f9fd2cdbbd0a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $4mZlP = parcelRequire("4mZlP");

var $dDSTM = parcelRequire("dDSTM");

var $8fCWV = parcelRequire("8fCWV");

var $20N1w = parcelRequire("20N1w");
const $7b3b7f54929a6bc9$export$64ded8b71dfcba9e = ({ linkComponent: linkComponent })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8fCWV.QuickFindAdvancedSearchLink), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.AdvancedSearchFooter), {
            linkComponent: linkComponent,
            squareReturnIcon: true,
            searchFooterLabel: formatMessage((0, $dDSTM.messages).quick_find_footer_full_page_search_link)
        })
    });
};
const $7b3b7f54929a6bc9$export$8784f9fd2cdbbd0a = ({ linkComponent: linkComponent })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $20N1w.PersistRecentSearch), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($7b3b7f54929a6bc9$export$64ded8b71dfcba9e, {
            linkComponent: linkComponent
        })
    });
};

});

parcelRegister("kTE07", function(module, exports) {

$parcel$export(module.exports, "PreQueryEmptyScreen", () => $25501d5677c22b5e$export$f16a7ed214a332fa);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $a7YLG = parcelRequire("a7YLG");

var $dDSTM = parcelRequire("dDSTM");

var $4jR19 = parcelRequire("4jR19");

const $25501d5677c22b5e$export$f76aab36aa9d8077 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("61iEs")));
const $25501d5677c22b5e$export$f16a7ed214a332fa = ({})=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7YLG.EmptyState), {
        Image: $25501d5677c22b5e$export$f76aab36aa9d8077,
        title: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $dDSTM.messages).quick_find_no_content_header
        }),
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $dDSTM.messages).quick_find_no_content_body
        })
    });
};

});
parcelRegister("a7YLG", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $63d3900d9fbf3b90$export$fddf379e22a74b00);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1HjZs = parcelRequire("1HjZs");
const $63d3900d9fbf3b90$export$fddf379e22a74b00 = ({ title: title, content: content, Image: Image })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1HjZs.Wrapper), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)(Image, {}),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1HjZs.Title), {
                    children: title
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1HjZs.Content), {
                    children: content
                })
            ]
        })
    });

});
parcelRegister("1HjZs", function(module, exports) {

$parcel$export(module.exports, "Title", () => $3c24ade336ec6966$export$f99233281efd08a0);
$parcel$export(module.exports, "Content", () => $3c24ade336ec6966$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "Wrapper", () => $3c24ade336ec6966$export$e6dfd72ab29f8598);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $7UHDa = parcelRequire("7UHDa");

var $2azjJ = parcelRequire("2azjJ");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
parcelRequire("gwFzn");

var $gwrgp = parcelRequire("gwrgp");
const $3c24ade336ec6966$var$TitleContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    color: 'color.text',
    marginTop: 'space.100'
});
const $3c24ade336ec6966$export$f99233281efd08a0 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $3c24ade336ec6966$var$TitleContainerStyles,
        children: children
    });
};
const $3c24ade336ec6966$export$7c6e2c02157bb7d2 = (0, $gwrgp.default)("div", {
    target: "e1ttkipm0"
})({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginTop: (0, $2azjJ.grid).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.primaryTextColour)
});
const $3c24ade336ec6966$export$e6dfd72ab29f8598 = (0, $gwrgp.default)("div", {
    target: "e1ttkipm1"
})({
    textAlign: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: (0, $2azjJ.grid).twice().px
});

});


parcelRegister("61iEs", function(module, exports) {

let $46214de772d3b2f1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $46214de772d3b2f1$var$load("4Sse2").then(()=>parcelRequire('c473Z'));

});


parcelRegister("4Lm6U", function(module, exports) {

$parcel$export(module.exports, "SearchErrorScreen", () => $60673a10504c6d4a$export$66fb8d8f30619036);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $j9DEc = parcelRequire("j9DEc");
const $60673a10504c6d4a$export$66fb8d8f30619036 = ({ onRetry: onRetry = ()=>null })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $j9DEc.default), {
        onRetry: onRetry
    });
};

});
parcelRegister("j9DEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d95f96bde66e8ac9$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $a7YLG = parcelRequire("a7YLG");
var $kPBHE = parcelRequire("kPBHE");

var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $bF0iL = parcelRequire("bF0iL");

var $cic0f = parcelRequire("cic0f");

const $d95f96bde66e8ac9$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("aFh8s")));
class $d95f96bde66e8ac9$export$930da00ff8e1539f extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { intl: intl } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7YLG.EmptyState), {
            title: intl.formatMessage((0, $bF0iL.messages).common_error_state_failed_search_heading),
            Image: $d95f96bde66e8ac9$var$Image,
            content: this.getContent()
        });
    }
    constructor(...args){
        super(...args);
        this.getContent = ()=>{
            const { onRetry: onRetry } = this.props;
            const linkComponent = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $cic0f.Button), {
                    ...props,
                    role: "button",
                    tabIndex: 0,
                    onClick: ()=>onRetry(),
                    onKeyDown: (event)=>event.key === 'Enter' ? onRetry() : undefined
                });
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $bF0iL.messages).common_error_state_failed_search_body,
                values: {
                    emptyLink: (s)=>// eslint-disable-next-line jsx-a11y/anchor-is-valid
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kPBHE.Link), {
                            linkComponent: linkComponent,
                            href: '',
                            children: s
                        })
                }
            });
        };
    }
}
var $d95f96bde66e8ac9$export$2e2bcd8739ae039 = (0, $js7oX.default)($d95f96bde66e8ac9$export$930da00ff8e1539f);

});
parcelRegister("cic0f", function(module, exports) {

$parcel$export(module.exports, "Button", () => $369c822a7a7f1b34$export$353f5b6fc5456de1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $369c822a7a7f1b34$export$353f5b6fc5456de1 = (0, $gwrgp.default)("span", {
    target: "e1hs8rk0"
})({
    color: `var(--ds-link, ${(0, $6fnsQ.B400)})`,
    cursor: 'pointer'
});

});

parcelRegister("aFh8s", function(module, exports) {

let $7c3b0677d27d41ae$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7c3b0677d27d41ae$var$load("eQXoP").then(()=>parcelRequire('6Vk9P'));

});



parcelRegister("hyKIh", function(module, exports) {

$parcel$export(module.exports, "QuickFindRovoTip", () => $d0c603ac0340e923$export$719e67cc0251dc18);

var $7UHDa = parcelRequire("7UHDa");

var $3HOqx = parcelRequire("3HOqx");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $5tPRL = parcelRequire("5tPRL");
var $dfZ5P = parcelRequire("dfZ5P");

var $1qfLF = parcelRequire("1qfLF");

var $dDSTM = parcelRequire("dDSTM");

var $hAh3S = parcelRequire("hAh3S");

var $aDRXf = parcelRequire("aDRXf");
const $d0c603ac0340e923$var$RovoTipMessageStyle = (0, $ecnYn.xcss)({
    width: '95%',
    marginLeft: 'space.050',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.050'
});
const $d0c603ac0340e923$var$RovoTipContainerStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.075',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $d0c603ac0340e923$var$RovoTipStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    minHeight: `${"var(--ds-space-500, 40px)"}`,
    paddingLeft: 'space.150',
    paddingRight: 'space.100',
    borderRadius: `${"var(--ds-space-050, 4px)"}`,
    backgroundColor: 'color.background.accent.purple.subtlest',
    color: 'color.text.accent.purple'
});
const $d0c603ac0340e923$export$719e67cc0251dc18 = ()=>{
    const { showRovoTip: showRovoTip, dismissRovoTip: dismissRovoTip } = (0, $hAh3S.useQuickFindRovoTip)();
    const { focusInput: focusInput } = (0, $aDRXf.useInputContext)();
    if (!showRovoTip) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $d0c603ac0340e923$var$RovoTipContainerStyle,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
            xcss: $d0c603ac0340e923$var$RovoTipStyle,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
                    label: "blank",
                    color: "var(--ds-text-accent-purple, #5E4DB2)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                    xcss: $d0c603ac0340e923$var$RovoTipMessageStyle,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("b", {
                            children: "Rovo tip:"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $dDSTM.messages).quick_find_rovo_tip
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedReturnIconContainer), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                        icon: (0, $dfZ5P.RemoveIcon),
                        spacing: 'compact',
                        onClick: (event)=>{
                            event.preventDefault();
                            event.stopPropagation();
                            dismissRovoTip();
                            focusInput && focusInput();
                        },
                        label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $dDSTM.messages).remove_button_label
                        }),
                        appearance: 'subtle'
                    })
                })
            ]
        })
    });
};

});
parcelRegister("hAh3S", function(module, exports) {

$parcel$export(module.exports, "useQuickFindRovoTip", () => $de41115665781d7f$export$ccc3a6663aee8d48);

var $gwFzn = parcelRequire("gwFzn");

var $4SPhZ = parcelRequire("4SPhZ");

var $iEwUU = parcelRequire("iEwUU");

var $fJRVo = parcelRequire("fJRVo");
const $de41115665781d7f$export$ccc3a6663aee8d48 = ()=>{
    const { user: user } = (0, $iEwUU.useUserContext)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const product = getActiveProduct();
    const [showRovoTip, setShowRovoTip] = (0, $gwFzn.useState)(true);
    (0, $gwFzn.useEffect)(()=>{
        if (!product) return;
        const rovoTipFromLocalStorage = (0, $4SPhZ.getRovoTip)(product.id, user?.id);
        setShowRovoTip(rovoTipFromLocalStorage);
    }, [
        user.id,
        product
    ]);
    const dismissRovoTip = (0, $gwFzn.useCallback)(()=>{
        if (product?.id) {
            const rovoTipFromLocalStorage = (0, $4SPhZ.setRovoTip)(product.id, user?.id);
            setShowRovoTip(rovoTipFromLocalStorage);
        }
    }, [
        user.id,
        product
    ]);
    return {
        showRovoTip: showRovoTip,
        dismissRovoTip: dismissRovoTip
    };
};

});

parcelRegister("aDRXf", function(module, exports) {

$parcel$export(module.exports, "InputContext", () => $0bc222710141dc7b$export$37fb8590cf2c088c);
$parcel$export(module.exports, "useInputContext", () => $0bc222710141dc7b$export$25c2004aac4f3cc);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $0bc222710141dc7b$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    focusInput: undefined
});
const $0bc222710141dc7b$export$37fb8590cf2c088c = ({ children: children, forwardRef: forwardRef })=>{
    const focusInput = (0, $gwFzn.useCallback)(()=>{
        if (typeof forwardRef === 'object') forwardRef?.current?.focus();
    }, [
        forwardRef
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($0bc222710141dc7b$var$Context.Provider, {
        value: {
            focusInput: focusInput
        },
        children: children
    });
};
const $0bc222710141dc7b$export$25c2004aac4f3cc = ()=>{
    return (0, $gwFzn.useContext)($0bc222710141dc7b$var$Context);
};

});


parcelRegister("7OZuO", function(module, exports) {

$parcel$export(module.exports, "default", () => $8910aa043bf2e2af$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $lnXRc = parcelRequire("lnXRc");

var $5dFS9 = parcelRequire("5dFS9");

var $ecdEs = parcelRequire("ecdEs");
var $1BaDj = parcelRequire("1BaDj");

var $2ZIpG = parcelRequire("2ZIpG");

var $5TmpD = parcelRequire("5TmpD");

var $21MH9 = parcelRequire("21MH9");

var $eEbYb = parcelRequire("eEbYb");
const $8910aa043bf2e2af$var$NoResultsWithHooks = ({ urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen = ()=>'', advancedSearchSelected: advancedSearchSelected, fromQuickFindPostQueryNoResults: fromQuickFindPostQueryNoResults })=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { autocorrectionEnabled: autocorrectionEnabled } = (0, $5TmpD.useAutocorrectionEnabled)();
    const advancedSearchUrl = urlGeneratorForNoResultsScreen(query); // TODO: needs filters here
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            autocorrectionEnabled && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $21MH9.AutocorrectAsyncWrapper), {
                container: (0, $eEbYb.NoResultsAutocorrectWrapper)
            }),
            fromQuickFindPostQueryNoResults ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1BaDj.default), {
                advancedSearchUrl: advancedSearchUrl,
                advancedSearchSelected: advancedSearchSelected
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ecdEs.default), {
                advancedSearchUrl: advancedSearchUrl,
                advancedSearchSelected: advancedSearchSelected
            })
        ]
    });
};
var $8910aa043bf2e2af$export$2e2bcd8739ae039 = (0, $lnXRc.withAnalytics)({
    advancedSearchSelected: (0, $5dFS9.onAdvancedSearchSelected)
})($8910aa043bf2e2af$var$NoResultsWithHooks);

});
parcelRegister("lnXRc", function(module, exports) {

$parcel$export(module.exports, "withAnalytics", () => $64f03dc1bbdc8c07$export$af9baadf0e4f6e13);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1DWH0 = parcelRequire("1DWH0");

var $5dFS9 = parcelRequire("5dFS9");
function $64f03dc1bbdc8c07$export$af9baadf0e4f6e13(analytics) {
    return (Component)=>{
        class WrappedComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
            render() {
                const { createAnalyticsEvent: createAnalyticsEvent, ...rest } = this.props;
                // There is NOT typesafety for the next line as typescript cannot infer types correctly with spread operators.
                // This is just going to have to go without type safety for the next line.
                return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                    ...rest,
                    ...this.wrappedAnalyticsCallback
                });
            }
            constructor(..._args){
                super(..._args);
                this.wrappedAnalyticsCallback = Object.keys(analytics).reduce((acc, key)=>({
                        ...acc,
                        // We forward all args to the corresponding callback regardless of type
                        [key]: (...args)=>{
                            this.props.createAnalyticsEvent && this.props.createAnalyticsEvent(analytics[key](...args)).fire((0, $5dFS9.DEFAULT_GAS_CHANNEL));
                        }
                    }), {});
            }
        }
        return (0, $1DWH0.default)()(WrappedComponent);
    };
}

});

parcelRegister("ecdEs", function(module, exports) {

$parcel$export(module.exports, "Image", () => $5dc707e28a4ee781$export$3e431a229df88919);
$parcel$export(module.exports, "default", () => $5dc707e28a4ee781$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $a7YLG = parcelRequire("a7YLG");
var $kPBHE = parcelRequire("kPBHE");

var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $3S0fp = parcelRequire("3S0fp");

var $5dFS9 = parcelRequire("5dFS9");

var $bF0iL = parcelRequire("bF0iL");

var $eEA8O = parcelRequire("eEA8O");

var $194zG = parcelRequire("194zG");

const $5dc707e28a4ee781$export$3e431a229df88919 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("8Jyqa")));
class $5dc707e28a4ee781$export$ef6006467f04ee41 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { intl: intl } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7YLG.EmptyState), {
            title: intl.formatMessage((0, $bF0iL.messages).common_empty_state_heading),
            Image: $5dc707e28a4ee781$export$3e431a229df88919,
            content: this.getContent()
        });
    }
    constructor(...args){
        super(...args);
        this.onAdvancedSearchClicked = (e)=>{
            const { advancedSearchSelected: advancedSearchSelected, onClick: onClick, advancedSearchUrl: advancedSearchUrl } = this.props;
            advancedSearchSelected({
                trigger: (0, $3S0fp.getTrigger)(e),
                actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).NO_RESULTS,
                isLoading: false,
                newTab: (0, $3S0fp.isNewTab)(e)
            });
            onClick && onClick(advancedSearchUrl, e);
        };
        this.getContent = ()=>{
            const { linkComponent: linkComponent, advancedSearchUrl: advancedSearchUrl, hasFilters: hasFilters, clearFilters: clearFilters, isMultiSite: isMultiSite } = this.props;
            if (!hasFilters) return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                role: "none",
                onClick: this.onAdvancedSearchClicked,
                children: isMultiSite || !advancedSearchUrl ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $bF0iL.messages).common_empty_state_body_no_advanced_search
                }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $bF0iL.messages).common_empty_state_body,
                    values: {
                        a: (s)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $kPBHE.Link), {
                                linkComponent: linkComponent,
                                href: advancedSearchUrl,
                                children: s
                            })
                    }
                })
            }));
            else return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        tagName: "div",
                        ...(0, $bF0iL.messages).filters_applied
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $194zG.ClearFiltersButtonWrapper), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                            appearance: "primary",
                            onClick: clearFilters,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                ...(0, $bF0iL.messages).clear_filters
                            })
                        })
                    })
                ]
            });
        };
    }
}
var $5dc707e28a4ee781$export$2e2bcd8739ae039 = (0, $js7oX.default)($5dc707e28a4ee781$export$ef6006467f04ee41);

});
parcelRegister("194zG", function(module, exports) {

$parcel$export(module.exports, "ClearFiltersButtonWrapper", () => $118ff74bd36c6a4e$export$8c06dfd742f74a6f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwrgp = parcelRequire("gwrgp");
const $118ff74bd36c6a4e$export$8c06dfd742f74a6f = (0, $gwrgp.default)("div", {
    target: "eg9i8g80"
})({
    name: "1bqq45c",
    styles: "padding-top:var(--ds-space-400, 32px);"
});

});

parcelRegister("8Jyqa", function(module, exports) {

let $65bd3a06c384a101$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $65bd3a06c384a101$var$load("9RypW").then(()=>parcelRequire('hd6X6'));

});


parcelRegister("1BaDj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e1084fdfd1fe42d$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $a7YLG = parcelRequire("a7YLG");
var $kPBHE = parcelRequire("kPBHE");

var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $3S0fp = parcelRequire("3S0fp");

var $5dFS9 = parcelRequire("5dFS9");

var $bF0iL = parcelRequire("bF0iL");

var $dDSTM = parcelRequire("dDSTM");

var $eEA8O = parcelRequire("eEA8O");

var $194zG = parcelRequire("194zG");

var $ecdEs = parcelRequire("ecdEs");
class $1e1084fdfd1fe42d$export$be28e1c115e337c7 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { intl: intl } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7YLG.EmptyState), {
            title: intl.formatMessage((0, $dDSTM.messages).quick_find_post_query_no_results_header),
            Image: (0, $ecdEs.Image),
            content: this.getContent()
        });
    }
    constructor(...args){
        super(...args);
        this.onAdvancedSearchClicked = (e)=>{
            const { advancedSearchSelected: advancedSearchSelected, onClick: onClick, advancedSearchUrl: advancedSearchUrl } = this.props;
            advancedSearchSelected({
                trigger: (0, $3S0fp.getTrigger)(e),
                actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).NO_RESULTS,
                isLoading: false,
                newTab: (0, $3S0fp.isNewTab)(e)
            });
            onClick && onClick(advancedSearchUrl, e);
        };
        this.getContent = ()=>{
            const { linkComponent: linkComponent, advancedSearchUrl: advancedSearchUrl, hasFilters: hasFilters, clearFilters: clearFilters, isMultiSite: isMultiSite } = this.props;
            if (!hasFilters) return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                role: "none",
                onClick: this.onAdvancedSearchClicked,
                children: isMultiSite || !advancedSearchUrl ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $bF0iL.messages).common_empty_state_body_no_advanced_search
                }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $dDSTM.messages).quick_find_post_query_no_results_body,
                    values: {
                        SearchContentLink: (s)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $kPBHE.Link), {
                                linkComponent: linkComponent,
                                href: advancedSearchUrl,
                                children: s
                            })
                    }
                })
            }));
            else return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        tagName: "div",
                        ...(0, $bF0iL.messages).filters_applied
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $194zG.ClearFiltersButtonWrapper), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                            appearance: "primary",
                            onClick: clearFilters,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                ...(0, $bF0iL.messages).clear_filters
                            })
                        })
                    })
                ]
            });
        };
    }
}
var $1e1084fdfd1fe42d$export$2e2bcd8739ae039 = (0, $js7oX.default)($1e1084fdfd1fe42d$export$be28e1c115e337c7);

});

parcelRegister("5TmpD", function(module, exports) {

$parcel$export(module.exports, "AUTOCORRECT_API_PATH", () => $56bec3c0e37551ba$export$9e194549e403d7c0);
$parcel$export(module.exports, "DEFAULT_AUTOCORRECT_DEBOUNCE_TIME_MS", () => $56bec3c0e37551ba$export$8cc0d0855105f007);
$parcel$export(module.exports, "isSupportedLanguage", () => $56bec3c0e37551ba$export$47c66070d6d6cd6d);
$parcel$export(module.exports, "sanitizeLanguage", () => $56bec3c0e37551ba$export$2c7172743adddb3f);
$parcel$export(module.exports, "shouldFetchAutocorrection", () => $56bec3c0e37551ba$export$68b44e0f3b4076e);
$parcel$export(module.exports, "useAutocorrectionEnabled", () => $56bec3c0e37551ba$export$bf742519320d45e9);
$parcel$export(module.exports, "fetchAutocorrection", () => $56bec3c0e37551ba$export$ac1bfa03f151bc79);

var $dBxQj = parcelRequire("dBxQj");

var $1o86H = parcelRequire("1o86H");

var $dwp40 = parcelRequire("dwp40");

var $fJRVo = parcelRequire("fJRVo");
var $56bec3c0e37551ba$var$SUPPORTED_LANGUAGES = /*#__PURE__*/ function(SUPPORTED_LANGUAGES) {
    SUPPORTED_LANGUAGES["English"] = "en";
    return SUPPORTED_LANGUAGES;
}($56bec3c0e37551ba$var$SUPPORTED_LANGUAGES || {});
const $56bec3c0e37551ba$export$9e194549e403d7c0 = 'autocorrect';
const $56bec3c0e37551ba$export$8cc0d0855105f007 = 250;
const $56bec3c0e37551ba$export$47c66070d6d6cd6d = (language)=>{
    return Object.values($56bec3c0e37551ba$var$SUPPORTED_LANGUAGES).includes(language);
};
const $56bec3c0e37551ba$export$2c7172743adddb3f = (locale)=>{
    if (locale.includes('-')) return locale.split('-')[0];
    return locale;
};
const $56bec3c0e37551ba$export$68b44e0f3b4076e = (query)=>{
    return query.length >= 4;
};
const $56bec3c0e37551ba$export$bf742519320d45e9 = ()=>{
    const { locale: locale } = (0, $dBxQj.default)();
    const lang = $56bec3c0e37551ba$export$2c7172743adddb3f(locale);
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const product = getActiveProduct();
    return {
        autocorrectionEnabled: !!product?.autocorrectEnabled && $56bec3c0e37551ba$export$47c66070d6d6cd6d(lang),
        productId: product?.id || ''
    };
};
const $56bec3c0e37551ba$export$ac1bfa03f151bc79 = (0, (/*@__PURE__*/$parcel$interopDefault($1o86H)))(({ query: query, aggregatorUrl: aggregatorUrl, lang: lang, cloudId: cloudId })=>{
    return (0, $dwp40.utils).requestService({
        url: aggregatorUrl
    }, {
        path: `${$56bec3c0e37551ba$export$9e194549e403d7c0}`,
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: query,
                language: lang,
                cloudId: cloudId
            })
        }
    });
}, $56bec3c0e37551ba$export$8cc0d0855105f007);

});

parcelRegister("21MH9", function(module, exports) {

$parcel$export(module.exports, "AutocorrectAsyncWrapper", () => $8a39f80e5c1cc577$export$5e9f08d9cf554737);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

const $8a39f80e5c1cc577$var$LoadedAutocorrection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fVDj1")).then(({ LoadedAutocorrection: LoadedAutocorrection })=>({
            default: LoadedAutocorrection
        })));
const $8a39f80e5c1cc577$export$5e9f08d9cf554737 = ({ container: container, fallback: fallback })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($8a39f80e5c1cc577$var$LoadedAutocorrection, {
            container: container,
            fallback: fallback
        })
    });
};

});
parcelRegister("fVDj1", function(module, exports) {

let $b98aab3798d87c59$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b98aab3798d87c59$var$load("6kNSo").then(()=>parcelRequire('kOUyO'));

});


parcelRegister("eEbYb", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $bf8f88eeb93453aa$export$44c18d210d5de37b);
$parcel$export(module.exports, "TextLabelWrapper", () => $bf8f88eeb93453aa$export$379a552b6c4d77e1);
$parcel$export(module.exports, "TextCorrectionWrapper", () => $bf8f88eeb93453aa$export$98340ed1d0e44a86);
$parcel$export(module.exports, "AutocorrectWrapper", () => $bf8f88eeb93453aa$export$c349a6e4bcccfcee);
$parcel$export(module.exports, "NoResultsAutocorrectWrapper", () => $bf8f88eeb93453aa$export$4bdce96b0ba50afe);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $bf8f88eeb93453aa$export$44c18d210d5de37b = (0, $gwrgp.default)("div", {
    target: "e23w5vh0"
})({
    backgroundColor: `var(--ds-surface, ${`${(0, $6fnsQ.N20)}`})`,
    height: '16px',
    width: '128px',
    borderRadius: '3px'
});
const $bf8f88eeb93453aa$export$379a552b6c4d77e1 = (0, $gwrgp.default)("span", {
    target: "e23w5vh1"
})({
    color: `var(--ds-text-accent-red, ${`${(0, $6fnsQ.R400)}`})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $bf8f88eeb93453aa$export$98340ed1d0e44a86 = (0, $gwrgp.default)("a", {
    target: "e23w5vh2"
})({
    cursor: 'pointer',
    color: `var(--ds-text-accent-blue, ${`${(0, $6fnsQ.B400)}`})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $bf8f88eeb93453aa$export$c349a6e4bcccfcee = (0, $gwrgp.default)("div", {
    target: "e23w5vh3"
})({
    name: "zwa1hm",
    styles: "text-transform:initial;font-weight:initial;"
});
const $bf8f88eeb93453aa$export$4bdce96b0ba50afe = (0, $gwrgp.default)("div", {
    target: "e23w5vh4"
})({
    name: "1mbrp18",
    styles: "margin-top:var(--ds-space-100, 8px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin-left:var(--ds-space-200, 16px);"
});

});



parcelRegister("cnoUz", function(module, exports) {

$parcel$export(module.exports, "QuickFindConfluenceTransformer", () => $704a874b96428859$export$d1cc89207db04ec4);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $bySHO = parcelRequire("bySHO");

var $lqMdf = parcelRequire("lqMdf");

var $7mejp = parcelRequire("7mejp");

var $791Lz = parcelRequire("791Lz");

var $2IGSl = parcelRequire("2IGSl");

var $a57V3 = parcelRequire("a57V3");
const $704a874b96428859$export$d1cc89207db04ec4 = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bySHO.PreQueryFilterTransformer), {
        ...rest,
        children: (args)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $lqMdf.PreQueryRecentlyViewedTransformer), {
                ...args,
                children: (args)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7mejp.RecentSearchesTransformer), {
                        ...args,
                        children: (args)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $791Lz.QueryFilterTransformer), {
                                ...args,
                                children: (args)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $2IGSl.PostQueryRecentlyViewedTransformer), {
                                        ...args,
                                        children: (args)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $a57V3.DeduplicateRecentlyViewedAndResultsTransformer), {
                                                ...args,
                                                children: (args)=>children(args)
                                            })
                                    })
                            })
                    })
            })
    });
};

});
parcelRegister("bySHO", function(module, exports) {

$parcel$export(module.exports, "PreQueryFilterTransformer", () => $e72227bd0175ccc2$export$eb528a71db3ec636);

var $iBckn = parcelRequire("iBckn");

var $2ZIpG = parcelRequire("2ZIpG");
const $e72227bd0175ccc2$export$eb528a71db3ec636 = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const filteredPreQuerySections = query ? preQueryItems.sections : preQueryItems.sections.filter((section)=>section.id !== (0, $iBckn.RECENT_SPACES_SECTION_ID));
    const filteredPreQueryItems = {
        sections: filteredPreQuerySections,
        size: filteredPreQuerySections.map((section)=>section.searchResults.length).reduce((acc, b)=>acc + b, 0)
    };
    return children({
        preQueryItems: filteredPreQueryItems,
        postQueryItems: postQueryItems,
        productState: productState
    });
};

});

parcelRegister("lqMdf", function(module, exports) {

$parcel$export(module.exports, "PreQueryRecentlyViewedTransformer", () => $8c058a58127c6526$export$4cf1eef5109c47c9);

var $js7oX = parcelRequire("js7oX");

var $dDSTM = parcelRequire("dDSTM");

var $3q90y = parcelRequire("3q90y");
const $8c058a58127c6526$export$8d431b8c84c2735b = ({ intl: intl, preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const newPreQueryItemsSections = preQueryItems.sections.map((section, i)=>{
        if (section.id === (0, $3q90y.RECENT_SEARCHES_SECTION_ID) || section.searchResults.length === 0) return section;
        else {
            const newSection = {
                ...section,
                title: intl.formatMessage((0, $dDSTM.messages).quick_find_recently_viewed)
            };
            return newSection;
        }
    });
    preQueryItems.sections = newPreQueryItemsSections;
    return children({
        preQueryItems: preQueryItems,
        postQueryItems: postQueryItems,
        productState: productState
    });
};
const $8c058a58127c6526$export$4cf1eef5109c47c9 = (0, $js7oX.default)($8c058a58127c6526$export$8d431b8c84c2735b);

});
parcelRegister("3q90y", function(module, exports) {

$parcel$export(module.exports, "RECENT_SEARCHES_SECTION_ID", () => $b9ad121c89489744$export$6c90641783086ccb);
$parcel$export(module.exports, "useRecentSearchesSection", () => $b9ad121c89489744$export$e5468815b4eb37d);

var $7UHDa = parcelRequire("7UHDa");

var $k1wrx = parcelRequire("k1wrx");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dDSTM = parcelRequire("dDSTM");

var $fJRVo = parcelRequire("fJRVo");

var $2ZIpG = parcelRequire("2ZIpG");

var $9Janh = parcelRequire("9Janh");

var $eYinl = parcelRequire("eYinl");

var $O4eEI = parcelRequire("O4eEI");

var $20N1w = parcelRequire("20N1w");

var $aDRXf = parcelRequire("aDRXf");
const $b9ad121c89489744$export$6c90641783086ccb = 'recent-searches';
const $b9ad121c89489744$var$MAX_RECENT_SEARCHES_SHOWN_IN_PRE_QUERY = 3;
const $b9ad121c89489744$var$MAX_RECENT_SEARCHES_SHOWN_IN_POST_QUERY = 1;
const $b9ad121c89489744$export$e5468815b4eb37d = ()=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const { focusInput: focusInput } = (0, $aDRXf.useInputContext)();
    const { recentSearchItems: recentSearchItems, removeRecentSearch: removeRecentSearch } = (0, $9Janh.useRecentSearches)({
        Icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eYinl.QuickFindIcon), {})
    });
    const recentSearches = recentSearchItems.map((result)=>({
            id: result.id,
            title: result.title,
            icon: result.icon,
            url: getActiveProduct()?.generateAdvancedSearchUrl?.(result.title) || '',
            meta: '',
            additionalMeta: query !== '' ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $dDSTM.messages).quick_find_recent_search_text_dialog
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $dDSTM.messages).quick_find_recent_search
            })
        }));
    const recentSearchesSection = (0, $gwFzn.useMemo)(()=>{
        return {
            id: $b9ad121c89489744$export$6c90641783086ccb,
            title: '',
            searchResults: recentSearches,
            resultRenderer: ({ searchResult: searchResult, isKeyboardHighlighted: isKeyboardHighlighted, isCollapsed: isCollapsed })=>{
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $20N1w.PersistRecentSearch), {
                    overrideQuery: searchResult.title,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k1wrx.EnlargedSearchResultContent), {
                        ...searchResult,
                        icon: searchResult.icon,
                        isKeyboardHighlighted: isKeyboardHighlighted,
                        isCollapsed: isCollapsed,
                        isRecentSearch: true,
                        onRemove: (event)=>{
                            event.preventDefault();
                            event.stopPropagation();
                            removeRecentSearch(searchResult.title);
                            focusInput && focusInput();
                        },
                        displayAdditionalMetaWhenHighlightedOnly: query === ''
                    })
                });
            },
            resultLimit: query ? $b9ad121c89489744$var$MAX_RECENT_SEARCHES_SHOWN_IN_POST_QUERY : $b9ad121c89489744$var$MAX_RECENT_SEARCHES_SHOWN_IN_PRE_QUERY,
            useAnalyticsOverride: ({ screen: screen })=>(0, $O4eEI.useSearchResultAnalyticsCallbacks)({
                    screen: screen,
                    actionSubject: 'recentSearch'
                })
        };
    }, [
        query,
        recentSearches,
        removeRecentSearch,
        focusInput
    ]);
    return recentSearchesSection;
};

});
parcelRegister("9Janh", function(module, exports) {

$parcel$export(module.exports, "useRecentSearches", () => $82a68bc4ee5a3cdf$export$d349a1b1b7874c14);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $iEwUU = parcelRequire("iEwUU");

var $1SV4e = parcelRequire("1SV4e");

var $fJRVo = parcelRequire("fJRVo");

var $dJB5H = parcelRequire("dJB5H");

var $3S0fp = parcelRequire("3S0fp");
const $82a68bc4ee5a3cdf$export$e0495117e49f394c = 50; // It can be different from the number of records in local storage
const $82a68bc4ee5a3cdf$export$d349a1b1b7874c14 = ({ Icon: Icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dJB5H.DefaultIcon), {}), limit: limit = $82a68bc4ee5a3cdf$export$e0495117e49f394c })=>{
    const { user: user } = (0, $iEwUU.useUserContext)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const product = getActiveProduct();
    const [recentSearchItems, setRecentSearchItems] = (0, $gwFzn.useState)([]);
    const memoizedIcon = (0, $gwFzn.useMemo)(()=>Icon, [
        Icon
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!product || !user.id) return;
        const recentSearches = (0, $1SV4e.getRecentSearches)(user.id, product.id, (0, $1SV4e.RECENT_SEARCH_KEY));
        const searchResults = recentSearches.map((value)=>({
                id: (0, $3S0fp.sha256Hash)(value),
                title: value,
                icon: memoizedIcon
            }));
        if (recentSearchItems.length === 0 && searchResults.length > 0) setRecentSearchItems(searchResults);
    }, [
        product,
        user.id,
        memoizedIcon,
        recentSearchItems.length
    ]);
    const removeRecentSearch = (0, $gwFzn.useCallback)((query)=>{
        if (user?.id && product?.id) {
            const recentSearches = (0, $1SV4e.removeRecentSearch)(query, user.id, product.id, (0, $1SV4e.RECENT_SEARCH_KEY));
            if (recentSearches) {
                const searchResults = recentSearches.map((value)=>({
                        id: (0, $3S0fp.sha256Hash)(value),
                        title: value,
                        icon: memoizedIcon
                    }));
                setRecentSearchItems(searchResults);
            }
        }
    }, [
        product,
        user.id,
        memoizedIcon
    ]);
    return {
        recentSearchItems: recentSearchItems.slice(0, limit),
        removeRecentSearch: removeRecentSearch
    };
};

});
parcelRegister("dJB5H", function(module, exports) {

$parcel$export(module.exports, "DefaultIcon", () => $54104dff0de2abd7$export$d206ce4c12e8ddf6);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $aEOt2 = parcelRequire("aEOt2");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $54104dff0de2abd7$var$IconContainer = (0, $gwrgp.default)("span", {
    target: "eao5nkl0"
})({
    name: "1qkppl",
    styles: "margin-left:var(--ds-space-negative-025, -2px);margin-top:var(--ds-space-025, 2px);"
});
const $54104dff0de2abd7$export$d206ce4c12e8ddf6 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($54104dff0de2abd7$var$IconContainer, {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aEOt2))), {
            color: `var(--ds-icon-accent-gray, ${(0, $6fnsQ.N600)})`,
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "recent-search"
        })
    });

});


parcelRegister("eYinl", function(module, exports) {

$parcel$export(module.exports, "QuickFindIcon", () => $4e314a008b56330d$export$f5db5b3314f27023);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $aEOt2 = parcelRequire("aEOt2");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $4e314a008b56330d$var$IconContainer = (0, $gwrgp.default)("span", {
    target: "e10r90tl0"
})({
    background: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`,
    height: "var(--ds-space-300, 24px)",
    borderRadius: "var(--ds-border-radius-400, 4px)",
    border: "'1px solid transparent'"
});
const $4e314a008b56330d$export$f5db5b3314f27023 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($4e314a008b56330d$var$IconContainer, {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aEOt2))), {
            color: `var(--ds-icon-accent-gray, ${(0, $6fnsQ.N600)})`,
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "recent-search"
        })
    });

});



parcelRegister("7mejp", function(module, exports) {

$parcel$export(module.exports, "RecentSearchesTransformer", () => $217415c35164e8dc$export$2142bc2fa441a5b0);

var $3q90y = parcelRequire("3q90y");
const $217415c35164e8dc$export$2142bc2fa441a5b0 = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const recentSearchesSection = (0, $3q90y.useRecentSearchesSection)();
    const preQueryItemsWithRecentSearches = {
        sections: [
            recentSearchesSection,
            ...preQueryItems.sections
        ],
        size: preQueryItems.size
    };
    return children({
        preQueryItems: preQueryItemsWithRecentSearches,
        postQueryItems: postQueryItems,
        productState: productState
    });
};

});

parcelRegister("791Lz", function(module, exports) {

$parcel$export(module.exports, "QueryFilterTransformer", () => $a2f4de094cafd3d0$export$308bb2328bfeb2be);

var $2ZIpG = parcelRequire("2ZIpG");

var $74Udv = parcelRequire("74Udv");
const $a2f4de094cafd3d0$var$RECENTLY_VIEWED_ITEMS_SHOWN = 10;
const $a2f4de094cafd3d0$export$308bb2328bfeb2be = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const filteredPreQueryItems = (0, $74Udv.filterAllSectionItems)({
        sections: preQueryItems.sections,
        size: preQueryItems.size
    }, query, $a2f4de094cafd3d0$var$RECENTLY_VIEWED_ITEMS_SHOWN);
    const highlightedPostQueryItems = (0, $74Udv.highlightPostQueryResultTitles)(postQueryItems, query);
    return children({
        preQueryItems: filteredPreQueryItems,
        postQueryItems: highlightedPostQueryItems,
        productState: productState
    });
};

});
parcelRegister("74Udv", function(module, exports) {

$parcel$export(module.exports, "filterFirstSectionItems", () => $fa84d6e3ef79d059$export$c942155d15f72814);
$parcel$export(module.exports, "filterAllSectionItems", () => $fa84d6e3ef79d059$export$f48d35d3732436aa);
$parcel$export(module.exports, "highlightPostQueryResultTitles", () => $fa84d6e3ef79d059$export$630e09546900f38e);
$parcel$export(module.exports, "mergeFirstSectionSearchItems", () => $fa84d6e3ef79d059$export$c28e3f530240553c);

var $bloXB = parcelRequire("bloXB");

var $3q90y = parcelRequire("3q90y");

var $jV49M = parcelRequire("jV49M");
const $fa84d6e3ef79d059$export$c942155d15f72814 = (searchItems, query, numberOfResultItems = 3)=>{
    if (!searchItems.sections[0]) return searchItems;
    const filteredSearchResults = searchItems.sections[0].searchResults.filter((item)=>{
        return item.title.toLowerCase().includes(query.toLowerCase());
    }).slice(0, numberOfResultItems);
    return {
        size: filteredSearchResults.length,
        sections: [
            {
                ...searchItems.sections[0],
                searchResults: filteredSearchResults
            }
        ]
    };
};
const $fa84d6e3ef79d059$export$f48d35d3732436aa = (searchItems, query, numberOfResultItems = 3)=>{
    if (query === '') return searchItems;
    const wordsInQuery = query.split(' ');
    const itemScoreMap = {};
    const filteredSearchSections = searchItems.sections.map((section)=>{
        return {
            ...section,
            searchResults: section.searchResults.map((item)=>{
                // 1st pass
                const doAllWordsMatch = wordsInQuery.reduce((acc, word)=>{
                    if (!acc) return acc;
                    return item.title.toLowerCase().includes(word.toLowerCase());
                }, true);
                if (doAllWordsMatch) {
                    // 2nd and 3rd Pass
                    const { highlightedTitle: highlightedTitle, negatedHighlightedTitle: negatedHighlightedTitle, score: score = 0 } = (0, $bloXB.highlightMatchedText)(item.title, wordsInQuery);
                    itemScoreMap[item.id] = score;
                    return {
                        ...item,
                        highlightedTitle: section.id !== (0, $3q90y.RECENT_SEARCHES_SECTION_ID) ? highlightedTitle : negatedHighlightedTitle
                    };
                }
                return null;
            }).filter((item)=>item).sort((item, secondItem)=>item && secondItem ? itemScoreMap[secondItem.id] - itemScoreMap[item.id] : 0).slice(0, numberOfResultItems)
        };
    });
    const size = filteredSearchSections.map((section)=>section.searchResults.length).reduce((acc, b)=>acc + b, 0);
    return {
        size: size,
        sections: filteredSearchSections
    };
};
const $fa84d6e3ef79d059$export$630e09546900f38e = (postQueryItems, query)=>{
    const wordsInQuery = query.split(' ');
    const highlightedSearchSections = postQueryItems.sections.map((section)=>{
        return {
            ...section,
            searchResults: section.searchResults.map((item)=>{
                const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(item.title, wordsInQuery);
                return {
                    ...item,
                    highlightedTitle: highlightedTitle
                };
            })
        };
    });
    return {
        size: postQueryItems.size,
        sections: highlightedSearchSections
    };
};
const $fa84d6e3ef79d059$export$c28e3f530240553c = (intermediateSearchItems, postQuerySearchItems)=>{
    if (!intermediateSearchItems.sections[0] || intermediateSearchItems.sections[0]?.searchResults.length === 0) return postQuerySearchItems;
    if (!postQuerySearchItems.sections[0] || postQuerySearchItems.sections[0]?.searchResults.length === 0) return intermediateSearchItems;
    const fullMergedResultsList = [
        ...intermediateSearchItems.sections[0].searchResults.map((result)=>({
                ...result,
                isRecentResult: true
            })),
        ...postQuerySearchItems.sections[0].searchResults
    ];
    const deduplicatedList = (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))(fullMergedResultsList, (item)=>item.id);
    const sections = [
        {
            ...postQuerySearchItems.sections[0],
            searchResults: deduplicatedList
        }
    ];
    return {
        size: sections.reduce((accumulator, currentElem)=>accumulator + currentElem.searchResults.length, 0),
        sections: sections
    };
};

});


parcelRegister("2IGSl", function(module, exports) {

$parcel$export(module.exports, "PostQueryRecentlyViewedTransformer", () => $9788089c1dc93380$export$1607c6754b1f6fc5);

var $js7oX = parcelRequire("js7oX");

var $jFPud = parcelRequire("jFPud");

var $dDSTM = parcelRequire("dDSTM");

var $3q90y = parcelRequire("3q90y");
const $9788089c1dc93380$var$RECENTLY_VIEWED_ITEMS_SHOWN = 5;
/**
 * This transformer assumes that preQueryItems contains recently viewed search
 * results and adds them to the postQueryItems.
 */ const $9788089c1dc93380$var$PostQueryRecentlyViewedTransformerWithIntl = ({ intl: intl, preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    // Create an array of recently viewed sections. These sections exclude recent
    // searches and have a combined result limit of 10.
    let recentlyViewedCount = 0;
    const recentlyViewedSections = preQueryItems.sections.filter((section)=>section.id !== (0, $3q90y.RECENT_SEARCHES_SECTION_ID)).filter((section)=>section.searchResults.length > 0).map((section, i)=>{
        const newSection = {
            ...section,
            resultLimit: Math.min(section.searchResults.length, $9788089c1dc93380$var$RECENTLY_VIEWED_ITEMS_SHOWN - recentlyViewedCount),
            title: i === 0 ? intl.formatMessage((0, $dDSTM.messages).quick_find_recently_viewed) : ''
        };
        recentlyViewedCount = Math.min(recentlyViewedCount + section.searchResults.length, $9788089c1dc93380$var$RECENTLY_VIEWED_ITEMS_SHOWN);
        return newSection;
    });
    // Add recent searches to the end of postQueryItems after post query returns
    const recentSearchesSection = preQueryItems.sections.find((section)=>section.id === (0, $3q90y.RECENT_SEARCHES_SECTION_ID));
    const postQueryItemsSectionsWithRecentSearches = recentSearchesSection && productState === (0, $jFPud.ProductStates).PostQuerySuccess ? [
        ...postQueryItems.sections,
        recentSearchesSection
    ] : [
        ...postQueryItems.sections
    ];
    // Create the new postQueryItems object
    const postQueryItemsWithRecentlyViewed = {
        size: [
            ...recentlyViewedSections,
            ...postQueryItems.sections
        ].map((section)=>section.searchResults.length).reduce((a, b)=>a + b, 0),
        sections: [
            ...recentlyViewedSections,
            ...postQueryItemsSectionsWithRecentSearches
        ]
    };
    return children({
        preQueryItems: preQueryItems,
        postQueryItems: postQueryItemsWithRecentlyViewed,
        productState: productState
    });
};
const $9788089c1dc93380$export$1607c6754b1f6fc5 = (0, $js7oX.default)($9788089c1dc93380$var$PostQueryRecentlyViewedTransformerWithIntl);

});

parcelRegister("a57V3", function(module, exports) {

$parcel$export(module.exports, "DeduplicateRecentlyViewedAndResultsTransformer", () => $3a919f723ec8ca9b$export$91b234728c3a1640);

var $iBckn = parcelRequire("iBckn");
const $3a919f723ec8ca9b$var$MAX_RENDERED_SEARCH_RESULTS = 5;
const $3a919f723ec8ca9b$export$91b234728c3a1640 = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const searchResults = postQueryItems.sections.find((section)=>section.id === (0, $iBckn.CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID))?.searchResults || [];
    const recentlyViewedResults = postQueryItems.sections.find((section)=>section.id === (0, $iBckn.RECENT_ITEMS_SECTION_ID))?.searchResults || [];
    const dedupedSearchResults = searchResults.filter((searchResult)=>{
        // Check for duplicates using ARIs
        const isDuplicate = recentlyViewedResults.some((recentlyViewedResult)=>recentlyViewedResult.ari === searchResult.ari);
        return searchResult.ari && !isDuplicate;
    });
    const postDeduplication = {
        ...postQueryItems,
        sections: postQueryItems.sections.map((section)=>{
            if (section.id === (0, $iBckn.CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID)) return {
                ...section,
                searchResults: dedupedSearchResults.slice(0, $3a919f723ec8ca9b$var$MAX_RENDERED_SEARCH_RESULTS)
            };
            return section;
        })
    };
    return children({
        preQueryItems: preQueryItems,
        postQueryItems: postDeduplication,
        productState: productState
    });
};

});


parcelRegister("1OS8u", function(module, exports) {

$parcel$export(module.exports, "quickFindRecentItemResultMapper", () => $47e0642ad89da657$export$1aadfab314f9e7ce);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $hWR4v = parcelRequire("hWR4v");

var $5nBzc = parcelRequire("5nBzc");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $DuEDb = parcelRequire("DuEDb");

var $dDSTM = parcelRequire("dDSTM");

var $8PrAH = parcelRequire("8PrAH");

var $kOyOy = parcelRequire("kOyOy");

var $j7mwp = parcelRequire("j7mwp");
const $47e0642ad89da657$var$CONTEXT_PATH = '/wiki';
const $47e0642ad89da657$var$labelStyles = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.050'
});
const $47e0642ad89da657$export$1aadfab314f9e7ce = (edge)=>{
    const item = edge.node;
    const data = item.object.data;
    const productType = item.object.product;
    switch(productType){
        case (0, $hWR4v.ActivityProduct).JIRA:
            return {
                id: item.object.id,
                title: `${data?.key}: ${(data?.fieldsById?.edges || [
                    {}
                ])[0].node?.text}` || '',
                url: data?.webUrl || '',
                icon: (0, $8PrAH.ContentIconRenderer)({
                    type: 'jira',
                    title: data?.title
                }),
                meta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $j7mwp.QuickFindResultMeta), {
                    meta: [
                        'Jira',
                        (0, $j7mwp.capitalizeFirstLetter)(item.object.type)
                    ]
                }),
                additionalMeta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $DuEDb.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                isRecentResult: true,
                type: `${item.object.product} ${item.object.type}`
            };
        case (0, $hWR4v.ActivityProduct).CONFLUENCE:
            // Do NOT show drafts for live-edit pages since they're not drafts from a user perspective
            const isDraft = (data?.pageStatus === 'DRAFT' || data?.blogStatus === 'DRAFT') && data?.subtype !== 'LIVE';
            return {
                ari: item.object.id,
                id: item.object.id,
                title: data?.title || '',
                url: `${data?.links?.base || $47e0642ad89da657$var$CONTEXT_PATH}${data?.links?.webUi}`,
                icon: (0, $8PrAH.ContentIconRenderer)({
                    type: item.object.type,
                    title: data?.title,
                    isDraft: isDraft
                }),
                label: isDraft ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $47e0642ad89da657$var$labelStyles,
                    as: "span",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5nBzc.default), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $dDSTM.messages).quick_find_recent_draft_label
                        })
                    })
                }) : '',
                meta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kOyOy.ConfluenceResultMeta), {
                    resultContentType: item.object.type,
                    resultAncestors: data?.ancestors,
                    resultSpace: data?.space
                }),
                additionalMeta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $DuEDb.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                isRecentResult: true,
                type: `${item.object.product} ${item.object.type}`,
                containerId: data?.space?.id || undefined
            };
        case (0, $hWR4v.ActivityProduct).ATLAS:
            return {
                id: item.object.id,
                title: `${data?.name}` || '',
                url: data?.url || '',
                icon: (0, $8PrAH.ContentIconRenderer)({
                    type: 'atlas',
                    imageSrc: data?.iconData || '',
                    title: data?.title
                }),
                meta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $j7mwp.QuickFindResultMeta), {
                    meta: [
                        (0, $j7mwp.capitalizeFirstLetter)(item.object.type),
                        data?.key
                    ]
                }),
                additionalMeta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $DuEDb.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                isRecentResult: true,
                type: `${item.object.product} ${item.object.type}`
            };
        default:
            return {
                id: '',
                title: '',
                url: '',
                icon: '',
                meta: ''
            };
    }
};

});
parcelRegister("DuEDb", function(module, exports) {

$parcel$export(module.exports, "WORKED_EVENT", () => $4c50cd29395d06d1$export$eb4e9f525aef1cc3);
$parcel$export(module.exports, "EventTypeMessage", () => $4c50cd29395d06d1$export$9e4fb3fb50a3c754);
// Extracted from @atlassian/recent-work-ui activity-event-type-message to create this
// helper function to convert timestamp to readable metadata

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $hrzSy = parcelRequire("hrzSy");

var $lDMQ2 = parcelRequire("lDMQ2");

var $eaVC4 = parcelRequire("eaVC4");

var $4oRNp = parcelRequire("4oRNp");

var $5mJ0F = parcelRequire("5mJ0F");
var $Lyrmh = parcelRequire("Lyrmh");
var $4c50cd29395d06d1$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SL_VIEWED"] = "sl-viewed";
    return VIEWED_EVENT;
}({});
var $4c50cd29395d06d1$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
function $4c50cd29395d06d1$export$e873c799b137eec4(date) {
    return (0, $lDMQ2.default)(new Date(date), $4c50cd29395d06d1$var$startOfOneWeekAgo());
}
function $4c50cd29395d06d1$var$startOfOneWeekAgo() {
    return (0, $eaVC4.default)((0, $4oRNp.default)(new Date(), 1));
}
const $4c50cd29395d06d1$export$9e4fb3fb50a3c754 = ({ eventType: eventType, timestamp: timestamp, isMyActivityData: isMyActivityData = true })=>{
    const isAbsolute = $4c50cd29395d06d1$export$e873c799b137eec4(timestamp);
    const message = (0, $Lyrmh.useEventTypeMessage)(eventType, {
        isMyActivityData: isMyActivityData,
        isAbsolute: isAbsolute
    });
    const { value: value, unit: unit } = (0, $5mJ0F.selectUnit)(new Date(timestamp).getTime(), new Date(), {
        day: 7
    });
    const values = isAbsolute ? {
        // Show the absolute time if the activity was more than a week ago
        // e.g: You viewed on January 1, 2021
        absoluteTime: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2nPZH.FormattedDate), {
            value: timestamp,
            month: "short",
            day: "2-digit",
            year: "numeric"
        })
    } : {
        // Show the relative time if the activity was within a week ago
        // e.g: You viewed 2 hours ago
        relativeTime: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hrzSy.default), {
            value: value,
            unit: unit
        })
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...message,
        values: values
    });
};

});

parcelRegister("8PrAH", function(module, exports) {

$parcel$export(module.exports, "ContentIconRenderer", () => $3b53752b63a8cd2e$export$bf56fa242f0fc37d);
$parcel$export(module.exports, "GenericIconRenderer", () => $3b53752b63a8cd2e$export$e5d849fb708254a9);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $esRft = parcelRequire("esRft");

var $2qVkt = parcelRequire("2qVkt");

var $9RVmI = parcelRequire("9RVmI");

var $ZDq1z = parcelRequire("ZDq1z");

var $5tmwS = parcelRequire("5tmwS");

var $1yB28 = parcelRequire("1yB28");

var $6B0jU = parcelRequire("6B0jU");

var $8jHAi = parcelRequire("8jHAi");

var $jfyuR = parcelRequire("jfyuR");

var $dQMPp = parcelRequire("dQMPp");
const $3b53752b63a8cd2e$var$negativeMarginStyles = (0, $ecnYn.xcss)({
    margin: 'space.negative.025',
    display: 'flex'
});
const $3b53752b63a8cd2e$var$iconTypes = {
    ATLAS: 'atlas',
    ATTACHMENT: 'attachment',
    BLOGPOST: 'blogpost',
    COMMENT: 'comment',
    CONTENT: 'content',
    CONFLUENCEBLOGPOST: 'confluence-blogpost',
    CONFLUENCEPAGE: 'confluence-page',
    DATABASE: 'database',
    FOLDER: 'folder',
    JIRA: 'jira',
    PAGE: 'page',
    WHITEBOARD: 'whiteboard'
};
const $3b53752b63a8cd2e$var$iconStyles = {
    BLUE: 'blue',
    GRAY: 'gray',
    PURPLE: 'purple',
    SHAPE: 'square',
    SIZE: '24',
    TEAL: 'teal',
    YELLOW: 'yellow'
};
const $3b53752b63a8cd2e$export$bf56fa242f0fc37d = ({ type: type, imageSrc: imageSrc, title: title, isDraft: isDraft = false })=>{
    // CONFLUENCE
    if (type === $3b53752b63a8cd2e$var$iconTypes.PAGE || type === $3b53752b63a8cd2e$var$iconTypes.CONFLUENCEPAGE || type === $3b53752b63a8cd2e$var$iconTypes.CONTENT) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        label: type,
        appearance: isDraft ? $3b53752b63a8cd2e$var$iconStyles.GRAY : $3b53752b63a8cd2e$var$iconStyles.BLUE,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.BLOGPOST || type === $3b53752b63a8cd2e$var$iconTypes.CONFLUENCEBLOGPOST) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.BLUE,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.DATABASE) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.PURPLE,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.FOLDER) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.BLUE,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.WHITEBOARD) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.TEAL,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.COMMENT) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.YELLOW,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.ATTACHMENT) // TODO: Clarify if the attachment icon should be changed
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jfyuR.AttachmentIcon), {
        title: title || '',
        size: "medium",
        label: type
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.ATLAS) return /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
        width: "24px",
        height: "24px",
        src: imageSrc || '',
        "aria-label": type,
        alt: type
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.JIRA) // TODO: Clarify the decision made for jira icons
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.BLUE,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {});
};
const $3b53752b63a8cd2e$export$e5d849fb708254a9 = ({ iconUrl: iconUrl, size: size = 'small', appearance: appearance = 'square' })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $3b53752b63a8cd2e$var$negativeMarginStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
            size: size,
            borderColor: "transparent",
            src: iconUrl,
            appearance: appearance,
            testId: "result-avatar"
        })
    });

});
parcelRegister("jfyuR", function(module, exports) {

$parcel$export(module.exports, "AttachmentIcon", () => $6488faa431f4e155$export$edc04f92718bbea4);

var $gwFzn = parcelRequire("gwFzn");

var $dlbUV = parcelRequire("dlbUV");

var $fX9Sa = parcelRequire("fX9Sa");

var $d4cCP = parcelRequire("d4cCP");

var $gguok = parcelRequire("gguok");

var $d8Kpd = parcelRequire("d8Kpd");

var $gH8Rx = parcelRequire("gH8Rx");

var $8DZd1 = parcelRequire("8DZd1");

var $djgQ6 = parcelRequire("djgQ6");

var $d5BUD = parcelRequire("d5BUD");

var $b4DX7 = parcelRequire("b4DX7");

var $41GKb = parcelRequire("41GKb");

var $20uDq = parcelRequire("20uDq");

var $11LZV = parcelRequire("11LZV");

var $lzyQK = parcelRequire("lzyQK");

var $hY1Uy = parcelRequire("hY1Uy");

var $dfQbH = parcelRequire("dfQbH");

var $1iV2p = parcelRequire("1iV2p");

var $7t8Pn = parcelRequire("7t8Pn");

var $ayTrS = parcelRequire("ayTrS");

var $hXc8o = parcelRequire("hXc8o");

var $90Icb = parcelRequire("90Icb");

var $lkBga = parcelRequire("lkBga");
const $6488faa431f4e155$var$AttachmentFileExtensionMatchers = [
    {
        regexp: /\.(pdf)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($11LZV))),
            (0, (/*@__PURE__*/$parcel$interopDefault($lzyQK)))
        ]
    },
    {
        regexp: /\.(gif)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($d5BUD))),
            (0, (/*@__PURE__*/$parcel$interopDefault($b4DX7)))
        ]
    },
    {
        regexp: /\.(jpeg|jpg|png)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($41GKb))),
            (0, (/*@__PURE__*/$parcel$interopDefault($20uDq)))
        ]
    },
    {
        regexp: /\.(xml|html|js|css|java|jar|war|ear)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($1iV2p))),
            (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
        ]
    },
    {
        regexp: /\.(zip|tar|gz|bz2|rar)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
            (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa)))
        ]
    },
    {
        regexp: /\.(xlt|xls|xlsm|xlsx|xlst)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($d8Kpd))),
            (0, (/*@__PURE__*/$parcel$interopDefault($gH8Rx)))
        ]
    },
    {
        regexp: /\.(pptx|ppsx|potx|pot|ppt|pptm)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($hY1Uy))),
            (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
        ]
    },
    {
        regexp: /\.(docx|dotx|doc|dot)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($90Icb))),
            (0, (/*@__PURE__*/$parcel$interopDefault($lkBga)))
        ]
    },
    {
        regexp: /\.(wma|wmv|ram|mp3)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
            (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
        ]
    },
    {
        regexp: /\.(mov|mpeg|mpg|mp4|avi)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
            (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o)))
        ]
    }
];
const $6488faa431f4e155$var$getIconArray = (title)=>{
    const extension = $6488faa431f4e155$var$AttachmentFileExtensionMatchers.find((extensionMatcher)=>{
        const matches = extensionMatcher.regexp.exec(title);
        return matches && matches.length > 0;
    });
    if (extension) return extension.icon;
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1))),
        (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)))
    ];
};
const $6488faa431f4e155$export$ebe2a8421106a1ee = {
    small: 0,
    medium: 1
};
const $6488faa431f4e155$export$edc04f92718bbea4 = ({ title: title, label: label, size: size })=>{
    const iconArray = $6488faa431f4e155$var$getIconArray(title);
    const sizeIndex = $6488faa431f4e155$export$ebe2a8421106a1ee[size];
    const icon = iconArray[sizeIndex];
    return /*#__PURE__*/ (0, $gwFzn.createElement)(icon, {
        label: label,
        testId: icon.name
    });
};

});


parcelRegister("kOyOy", function(module, exports) {

$parcel$export(module.exports, "ConfluenceResultMeta", () => $a454b160acdd3a63$export$9138e703d4b4585b);
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ // Copied from confluence/next/packages/navigation-search-dialog/src/suppliers/utils/ConfluenceResultMeta.tsx

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");

var $dcJ7R = parcelRequire("dcJ7R");
var $5dK2X = parcelRequire("5dK2X");

var $j7mwp = parcelRequire("j7mwp");

var $gwrgp = parcelRequire("gwrgp");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a454b160acdd3a63$var$ConfluenceResultMetaWrapper = (0, $gwrgp.default)("span", {
    target: "e10xva5d0"
})({
    name: "u4p24i",
    styles: "display:flex;flex-direction:row;align-items:center;"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a454b160acdd3a63$var$ConfluenceTypeWrapper = (0, $gwrgp.default)("span", {
    target: "e10xva5d1"
})({
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N300)})`
});
const $a454b160acdd3a63$var$BreadCrumbs = ({ breadCrumbs: breadCrumbs = [] })=>{
    if (breadCrumbs.length === 0) return null;
    // only allow 2 breadcrumbs
    // take the first and the last (if different)
    let twoBreadcrumbs = [];
    if (breadCrumbs.length > 2) twoBreadcrumbs = [
        breadCrumbs[0],
        breadCrumbs[breadCrumbs.length - 1]
    ];
    else twoBreadcrumbs = breadCrumbs;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
        separator: "/",
        space: "space.100",
        children: twoBreadcrumbs.map(({ id: id, title: title }, i)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                color: "color.text.subtle",
                size: "small",
                children: title
            }, id))
    });
};
const $a454b160acdd3a63$export$9138e703d4b4585b = ({ resultContentType: resultContentType, resultAncestors: resultAncestors, resultSpace: resultSpace })=>{
    const breadcrumbs = $a454b160acdd3a63$export$ed9f69ac7e699c53(resultAncestors, resultSpace);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)($a454b160acdd3a63$var$ConfluenceResultMetaWrapper, {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)($a454b160acdd3a63$var$ConfluenceTypeWrapper, {
                children: "Confluence"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $j7mwp.SpacerWrapper), {
                children: "\u2022"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)($a454b160acdd3a63$var$ConfluenceTypeWrapper, {
                children: `${(0, $j7mwp.capitalizeFirstLetter)(resultContentType)}`
            }),
            breadcrumbs?.length && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $j7mwp.SpacerWrapper), {
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)($a454b160acdd3a63$var$BreadCrumbs, {
                        breadCrumbs: breadcrumbs
                    })
                ]
            })
        ]
    });
};
const $a454b160acdd3a63$export$ed9f69ac7e699c53 = (ancestors, space)=>{
    let breadcrumbs = [];
    if (space) {
        const spaceBreadcrumb = {
            id: space?.id,
            title: space?.name
        };
        if (!ancestors || ancestors.length === 0) breadcrumbs = [
            spaceBreadcrumb
        ];
        else if (ancestors.length >= 1) // The first ancestor is a root node that shouldn't be rendered
        breadcrumbs = [
            spaceBreadcrumb,
            ...ancestors.slice(1)
        ];
    }
    // Filter out invalid breadcrumbs
    return breadcrumbs.filter((breadCrumb)=>breadCrumb.id && breadCrumb.title);
};

});
parcelRegister("j7mwp", function(module, exports) {

$parcel$export(module.exports, "SpacerWrapper", () => $68686fedcc1e2524$export$b05a2e78ddf8915e);
$parcel$export(module.exports, "capitalizeFirstLetter", () => $68686fedcc1e2524$export$d07f57595c356899);
$parcel$export(module.exports, "QuickFindResultMeta", () => $68686fedcc1e2524$export$73e5ecb29f7bf6e9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $68686fedcc1e2524$var$ResultMetaWrapper = (0, $gwrgp.default)("span", {
    target: "eflzzry0"
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N300)})`
});
const $68686fedcc1e2524$export$b05a2e78ddf8915e = (0, $gwrgp.default)("span", {
    target: "eflzzry1"
})({
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N300)})`,
    margin: `0px ${"var(--ds-space-100, 8px)"}`
});
function $68686fedcc1e2524$export$d07f57595c356899(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
}
const $68686fedcc1e2524$export$73e5ecb29f7bf6e9 = ({ meta: meta })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($68686fedcc1e2524$var$ResultMetaWrapper, {
        children: meta.filter((metaItem)=>metaItem !== null && metaItem !== undefined).map((metaItem, index)=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    metaItem,
                    index !== meta.length - 1 && /*#__PURE__*/ (0, $7UHDa.jsx)($68686fedcc1e2524$export$b05a2e78ddf8915e, {
                        children: "\u2022"
                    })
                ]
            }))
    });
};

});



parcelRegister("axxOe", function(module, exports) {

$parcel$export(module.exports, "quickFindRecentSpaceResultMapper", () => $c38d98a6d1a1036a$export$d04e5b6d01e34c3);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $esRft = parcelRequire("esRft");

var $dDSTM = parcelRequire("dDSTM");
const $c38d98a6d1a1036a$var$negativeMarginStyles = (0, $ecnYn.xcss)({
    margin: 'space.negative.025'
});
const $c38d98a6d1a1036a$var$CONTEXT_PATH = '/wiki';
const $c38d98a6d1a1036a$export$e5d849fb708254a9 = ({ iconUrl: iconUrl, size: size = 'small', appearance: appearance = 'square' })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $bUlM5.default), {
        xcss: $c38d98a6d1a1036a$var$negativeMarginStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
            size: size,
            borderColor: "transparent",
            src: iconUrl,
            appearance: appearance,
            testId: "result-avatar"
        })
    });
const $c38d98a6d1a1036a$export$d04e5b6d01e34c3 = (item)=>({
        id: item?.id || '',
        title: item?.name || '',
        meta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $dDSTM.messages).quick_find_confluence_space
        }),
        additionalMeta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $dDSTM.messages).quick_find_recent_spaces_additional_meta
        }),
        url: `${$c38d98a6d1a1036a$var$CONTEXT_PATH}${item?.links?.webui || ''}`,
        containerId: item?.id || undefined,
        icon: $c38d98a6d1a1036a$export$e5d849fb708254a9({
            iconUrl: `${$c38d98a6d1a1036a$var$CONTEXT_PATH}${item?.icon?.path || ''}`,
            size: 'small'
        }),
        isRecentResult: true,
        type: 'confluence space'
    });

});

parcelRegister("clOud", function(module, exports) {

$parcel$export(module.exports, "getQuickFindPeopleAndTeamsResultMapper", () => $9ebe45aba70c0c63$export$dbdea3e42644cff8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $8PrAH = parcelRequire("8PrAH");

var $dDSTM = parcelRequire("dDSTM");

var $aU479 = parcelRequire("aU479");
const $9ebe45aba70c0c63$export$dbdea3e42644cff8 = (primaryProduct, orgId, cloudId)=>{
    return (result)=>{
        if (result.type === 'team') return {
            title: result.name,
            id: result.id,
            type: result.type,
            meta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $dDSTM.messages).quick_find_results_team
            }),
            url: `${window.location.origin}${(0, $aU479.getTeamPath)(result.id, primaryProduct, orgId, cloudId)}`,
            icon: (0, $8PrAH.GenericIconRenderer)({
                iconUrl: result.avatarUrl
            })
        };
        else return {
            title: result.name,
            id: result.id,
            type: result.type,
            meta: result.title || '',
            url: `${window.location.origin}${(0, $aU479.getUserPath)(result.id, primaryProduct, orgId, cloudId)}`,
            icon: (0, $8PrAH.GenericIconRenderer)({
                iconUrl: result.avatarUrl,
                appearance: 'circle'
            })
        };
    };
};

});

parcelRegister("1x1dO", function(module, exports) {

$parcel$export(module.exports, "quickFindConfluenceSpaceMapper", () => $8bf0db52976a1541$export$831f92f4f63a8807);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dDSTM = parcelRequire("dDSTM");

var $lNtmT = parcelRequire("lNtmT");

var $8PrAH = parcelRequire("8PrAH");
const $8bf0db52976a1541$export$831f92f4f63a8807 = ({ node: item })=>{
    return {
        id: (0, $lNtmT.transformAriToId)(item?.id || '', item?.type || ''),
        title: item?.title || '',
        meta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $dDSTM.messages).quick_find_confluence_space
        }),
        url: item?.url || '',
        type: 'confluence space',
        containerId: item?.id,
        icon: (0, $8PrAH.GenericIconRenderer)({
            iconUrl: `/wiki${item?.iconPath || ''}`,
            size: 'small'
        })
    };
};

});
parcelRegister("lNtmT", function(module, exports) {

$parcel$export(module.exports, "transformAriToId", () => $35f4e8be421d896f$export$6d8886e8d5cdbeec);
const $35f4e8be421d896f$export$6d8886e8d5cdbeec = (id, type)=>{
    switch(type){
        case 'page':
            return id.split(':page/')[1];
        case 'blogpost':
            return id.split(':blogpost/')[1];
        case 'attachment':
            return id.split(':attachment/')[1];
        case 'space':
            return id.split(':space/')[1];
        case 'whiteboard':
            return id.split(':whiteboard/')[1];
        case 'embed':
            // embed ari url contains activation id so we split it differently here
            const embedAri = id.split('/');
            return embedAri[embedAri.length - 1];
        case 'database':
            // Databases ari url contains activation id so we split it differently here
            const databaseAri = id.split('/');
            return databaseAri[databaseAri.length - 1];
        default:
            return id;
    }
};

});


parcelRegister("ktwn8", function(module, exports) {

$parcel$export(module.exports, "quickFindConfluenceContentMapper", () => $df95e20809de4e37$export$6a180a233e580286);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $8PrAH = parcelRequire("8PrAH");

var $lNtmT = parcelRequire("lNtmT");

var $kOyOy = parcelRequire("kOyOy");

var $DuEDb = parcelRequire("DuEDb");
const $df95e20809de4e37$export$6a180a233e580286 = ({ node: item })=>{
    return {
        ari: item?.id,
        id: (0, $lNtmT.transformAriToId)(item?.id || '', item?.type || ''),
        title: item?.title || '',
        url: item?.url || '',
        meta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kOyOy.ConfluenceResultMeta), {
            resultContentType: item?.type || '',
            resultAncestors: item?.confluenceEntity?.ancestors,
            resultSpace: item?.space
        }),
        additionalMeta: item?.lastModified ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $DuEDb.EventTypeMessage), {
            timestamp: item.lastModified,
            eventType: (0, $DuEDb.WORKED_EVENT).UPDATED,
            isMyActivityData: false
        }) : '',
        containerId: (0, $lNtmT.transformAriToId)(item?.space?.id || 'UNAVAILABLE', 'space'),
        type: `confluence ${item?.type}` || '',
        icon: (0, $8PrAH.ContentIconRenderer)({
            type: item?.type || '',
            title: item?.title
        })
    };
};

});

parcelRegister("5yZy1", function(module, exports) {

$parcel$export(module.exports, "quickFindAtlasContentMapper", () => $d6ae9f5288c13a0d$export$92506b66b43d2a63);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $7jIfa = parcelRequire("7jIfa");

var $lNtmT = parcelRequire("lNtmT");

var $gj7hi = parcelRequire("gj7hi");

var $j7mwp = parcelRequire("j7mwp");
const $d6ae9f5288c13a0d$var$getIcon = (result)=>{
    return result?.iconUrl ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gj7hi.default), {
        height: 24,
        width: 24,
        title: result.type,
        src: result.iconUrl
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
};
const $d6ae9f5288c13a0d$var$getKey = (item)=>{
    if ((0, $7jIfa.isSearchResultAtlasProjectPartial)(item)) return item.project?.key;
    else if ((0, $7jIfa.isSearchResultAtlasGoalPartial)(item)) return item.goal?.key;
    else return null;
};
const $d6ae9f5288c13a0d$var$getTitle = (item)=>{
    if (!item) return '';
    let entityKey = $d6ae9f5288c13a0d$var$getKey(item);
    if (entityKey) return `${entityKey}: ${item.title || ''}`;
    return item.title || '';
};
const $d6ae9f5288c13a0d$export$92506b66b43d2a63 = ({ node: item })=>{
    return {
        id: (0, $lNtmT.transformAriToId)(item?.id || '', item?.type || ''),
        title: $d6ae9f5288c13a0d$var$getTitle(item),
        url: item?.url || '',
        meta: (0, $j7mwp.capitalizeFirstLetter)(item?.type || ''),
        additionalMeta: '',
        containerId: '',
        type: `atlas ${item?.type}` || '',
        icon: $d6ae9f5288c13a0d$var$getIcon(item)
    };
};

});

parcelRegister("bK7ak", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $493c216466d2aa05$export$b37ee0d76c6d2fbc);

var $UNGcJ = parcelRequire("UNGcJ");

var $2OcMi = parcelRequire("2OcMi");

var $2ZIpG = parcelRequire("2ZIpG");
const $493c216466d2aa05$export$b37ee0d76c6d2fbc = ()=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    return (url, searchSessionId, type, resultId, additionalAnalytics)=>{
        // legacy QF/QS have different types/have confluence prefixed or not
        return (0, $UNGcJ.transformAnalyticsToQueryParam)({
            query: query,
            url: url,
            searchSessionId: searchSessionId,
            additionalAnalytics: additionalAnalytics,
            resultId: resultId,
            type: type,
            addQueryParams: $2OcMi.addQueryParams,
            addQuery: $2OcMi.addQuery
        });
    };
};

});
parcelRegister("UNGcJ", function(module, exports) {

$parcel$export(module.exports, "transformAnalyticsToQueryParam", () => $bced069a163eb3f4$export$f9c120c22694d7aa);

var $aU479 = parcelRequire("aU479");

var $7H6GR = parcelRequire("7H6GR");
const $bced069a163eb3f4$export$f9c120c22694d7aa = ({ url: url, query: query, searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics, resultId: resultId, addQueryParams: addQueryParams, addQuery: addQuery, type: type })=>{
    const isConfluenceContent = typeof resultId === 'string' && resultId.includes('confluence') || typeof type === 'string' && [
        'confluence page',
        'confluence blogpost',
        'confluence space',
        'confluence attachment',
        'confluence whiteboard'
    ].some((contentType)=>contentType.includes(type));
    const hasAdditionalAnalytics = typeof additionalAnalytics === 'object' && Object.keys(additionalAnalytics).length > 0;
    if (!isConfluenceContent || !(query || hasAdditionalAnalytics)) return addQuery(url, 'search_id', searchSessionId);
    let events = [];
    if (query) events.push(`queryHash${(0, $7H6GR.valueSeparator)}${(0, $aU479.hashData)(query)}`);
    if (hasAdditionalAnalytics) Object.entries(additionalAnalytics).forEach(([attribute, value])=>{
        events.push(`${attribute}${(0, $7H6GR.valueSeparator)}${value}`);
    });
    if (events.length === 0) return addQuery(url, 'search_id', searchSessionId);
    const analyticsFormattedForUrlParsing = encodeURIComponent(events.join((0, $7H6GR.attributeSeparator)));
    return addQueryParams(url, {
        search_id: searchSessionId,
        additional_analytics: analyticsFormattedForUrlParsing
    });
};

});
parcelRegister("7H6GR", function(module, exports) {

$parcel$export(module.exports, "valueSeparator", () => $5ebc4269bdb715fd$export$a707596ddc3340c);
$parcel$export(module.exports, "attributeSeparator", () => $5ebc4269bdb715fd$export$5204c4564f8b6d00);
const $5ebc4269bdb715fd$export$a707596ddc3340c = '---';
const $5ebc4269bdb715fd$export$5204c4564f8b6d00 = '___';
const $5ebc4269bdb715fd$export$6e18f540c8c76192 = (additionalAnalytics)=>{
    const formattedEvents = {};
    if (typeof additionalAnalytics !== 'string') return formattedEvents;
    const events = additionalAnalytics?.split('____');
    events.forEach((event)=>{
        const formattedEvent = event?.split('---');
        const hasProperlyFormattedEvent = formattedEvent.length === 2;
        if (hasProperlyFormattedEvent) formattedEvents[formattedEvent[0]] = formattedEvent[1];
    });
    return formattedEvents;
};

});




parcelRegister("6kOEz", function(module, exports) {

$parcel$export(module.exports, "CommandIcon", () => $7193e24f5ddd050a$export$76bfbab5e3f9a6a3);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");
const $7193e24f5ddd050a$export$76bfbab5e3f9a6a3 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.89453 8.89551H6.88965C5.80957 8.89551 4.93457 8.04785 4.93457 6.96094C4.93457 5.87402 5.80957 4.99902 6.88965 4.99902C7.96973 4.99902 8.84473 5.87402 8.84473 6.96094V7.95898H11.1553V6.96094C11.1553 5.87402 12.0303 4.99902 13.1104 4.99902C14.1904 4.99902 15.0654 5.87402 15.0654 6.96094C15.0654 8.04785 14.1904 8.89551 13.1104 8.89551H12.1123V11.2402H13.1104C14.1904 11.2402 15.0654 12.0879 15.0654 13.1748C15.0654 14.2617 14.1904 15.1367 13.1104 15.1367C12.0303 15.1367 11.1553 14.2617 11.1553 13.1748V12.1768H8.84473V13.1748C8.84473 14.2617 7.96973 15.1367 6.88965 15.1367C5.80957 15.1367 4.93457 14.2617 4.93457 13.1748C4.93457 12.0879 5.80957 11.2402 6.88965 11.2402H7.89453V8.89551ZM6.88965 7.97266H7.89453V6.96094C7.89453 6.40723 7.43652 5.95605 6.88965 5.95605C6.34277 5.95605 5.88477 6.40723 5.88477 6.96094C5.88477 7.51465 6.34277 7.97266 6.88965 7.97266ZM13.1104 7.97266C13.6572 7.97266 14.1152 7.51465 14.1152 6.96094C14.1152 6.40723 13.6572 5.95605 13.1104 5.95605C12.5635 5.95605 12.1123 6.40723 12.1123 6.96094V7.97266H13.1104ZM8.84473 11.2539H11.1553V8.88184H8.84473V11.2539ZM6.88965 12.1562C6.34277 12.1562 5.88477 12.6143 5.88477 13.168C5.88477 13.7217 6.34277 14.1729 6.88965 14.1729C7.43652 14.1729 7.89453 13.7217 7.89453 13.168V12.1562H6.88965ZM13.1104 12.1562H12.1123V13.168C12.1123 13.7217 12.5635 14.1729 13.1104 14.1729C13.6572 14.1729 14.1152 13.7217 14.1152 13.168C14.1152 12.6143 13.6572 12.1562 13.1104 12.1562Z",
                fill: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
            })
        ]
    });

});

parcelRegister("hFUff", function(module, exports) {

$parcel$export(module.exports, "ControlIcon", () => $d8b813963b40dde9$export$1de95e9d7dda5112);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $d8b813963b40dde9$var$iconStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    height: '20px',
    borderRadius: 'border.radius.050',
    border: '1px solid transparent',
    color: 'color.text.subtle',
    font: 'font.body.small',
    display: 'flex',
    alignItems: 'center',
    paddingInline: 'space.050',
    paddingBlock: '0'
});
const $d8b813963b40dde9$export$1de95e9d7dda5112 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $d8b813963b40dde9$var$iconStyles,
        children: "Ctrl"
    });

});

parcelRegister("5uL5H", function(module, exports) {

$parcel$export(module.exports, "SquareReturnIcon", () => $d6b1539a23a3e88d$export$4501fc029b186da8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");
const $d6b1539a23a3e88d$export$4501fc029b186da8 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "nonzero",
                d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
                fill: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
            })
        ]
    });

});


parcelRegister("fjD79", function(module, exports) {

$parcel$export(module.exports, "getDefaultAtlasBaseURL", () => $1f7067aa44298f63$export$b182d98f245a5298);
$parcel$export(module.exports, "createProfileLink", () => $1f7067aa44298f63$export$5b4f9e589794eb96);
$parcel$export(module.exports, "createTeamProfileLink", () => $1f7067aa44298f63$export$a1c75f05b6ef3ec6);
$parcel$export(module.exports, "default", () => $1f7067aa44298f63$export$2e2bcd8739ae039);
const $1f7067aa44298f63$export$b182d98f245a5298 = (isGlobalExperienceWorkspace)=>{
    const hostname = window.location.hostname;
    const subdomain = isGlobalExperienceWorkspace ? 'home' : 'team';
    if (hostname.includes('jira-dev.com') || hostname.includes('.stg.atlassian.') || hostname.startsWith('localhost')) return `https://${subdomain}.stg.atlassian.com`;
    return `https://${subdomain}.atlassian.com`;
};
const $1f7067aa44298f63$export$4c191d74745f6ab1 = (entityId, path, isGlobalExperienceWorkspace, orgId)=>{
    const baseUrl = $1f7067aa44298f63$export$b182d98f245a5298(isGlobalExperienceWorkspace);
    if (isGlobalExperienceWorkspace && orgId) return `${baseUrl}/o/${orgId}/${path}/${entityId}`;
    return `${baseUrl}/${path}/${entityId}`;
};
const $1f7067aa44298f63$export$5b4f9e589794eb96 = (accountId, isGlobalExperienceWorkspace, orgId)=>$1f7067aa44298f63$export$4c191d74745f6ab1(accountId, 'people', isGlobalExperienceWorkspace, orgId);
const $1f7067aa44298f63$export$a1c75f05b6ef3ec6 = (teamId, isGlobalExperienceWorkspace, orgId)=>$1f7067aa44298f63$export$4c191d74745f6ab1(teamId, 'people/team', isGlobalExperienceWorkspace, orgId);
const $1f7067aa44298f63$var$getAtlasViewAllRedirectUrl = (entity, searchText, workspaces, isGlobalExperienceWorkspace, orgId)=>{
    let url;
    if (workspaces && workspaces.length === 1 && /team\.(stg\.)?atlassian\.com/.test(workspaces[0].baseUrl)) url = new URL(workspaces[0].baseUrl);
    else url = new URL($1f7067aa44298f63$export$b182d98f245a5298(isGlobalExperienceWorkspace));
    const pathPrefix = isGlobalExperienceWorkspace && orgId ? `o/${orgId}/` : '';
    url.pathname = `${pathPrefix}action/search/${entity}`;
    url.searchParams.append('searchText', searchText);
    return url.href;
};
var $1f7067aa44298f63$export$2e2bcd8739ae039 = $1f7067aa44298f63$var$getAtlasViewAllRedirectUrl;

});

parcelRegister("9BAfc", function(module, exports) {

$parcel$export(module.exports, "GoogleDriveIcon", () => $5b5eba0a2aeb65d3$export$e16bd899bb4eebf9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $5b5eba0a2aeb65d3$var$iconStyles = (0, $ecnYn.xcss)({
    width: '22px',
    height: '22px'
});
const $5b5eba0a2aeb65d3$export$e16bd899bb4eebf9 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $5b5eba0a2aeb65d3$var$iconStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            width: "22",
            height: "22",
            viewBox: "0 0 22 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                    x: "1",
                    y: "1",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                    x: "0.618757",
                    y: "0.618757",
                    width: "20.7625",
                    height: "20.7625",
                    rx: "4.38124",
                    stroke: "#0B1228",
                    strokeOpacity: "0.14",
                    strokeWidth: "0.762486"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                    clipPath: "url(#clip0_931_182)",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M4.20962 16.0782L4.91523 17.2907C5.06186 17.546 5.27262 17.7466 5.52005 17.8925L8.04009 13.5529H3C3 13.8355 3.07331 14.1181 3.21993 14.3734L4.20962 16.0782Z",
                            fill: "#0066DA"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M11 8.44751L8.47995 4.10791C8.23253 4.25378 8.02176 4.45435 7.87514 4.70962L3.21993 12.7324C3.07601 12.9822 3.00019 13.265 3 13.5529H8.04009L11 8.44751Z",
                            fill: "#00AC47"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M16.4799 17.8925C16.7273 17.7466 16.9381 17.546 17.0847 17.2907L17.3779 16.7893L18.78 14.3734C18.9266 14.1181 18.9999 13.8355 18.9999 13.5529H13.9595L15.032 15.6497L16.4799 17.8925Z",
                            fill: "#EA4335"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M11 8.4475L13.5201 4.1079C13.2726 3.96203 12.9886 3.8891 12.6953 3.8891H9.30472C9.01148 3.8891 8.7274 3.97115 8.47998 4.1079L11 8.4475Z",
                            fill: "#00832D"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M13.9594 13.5529H8.03958L5.51953 17.8925C5.76695 18.0383 6.05103 18.1113 6.34427 18.1113H15.6547C15.9479 18.1113 16.232 18.0292 16.4794 17.8925L13.9594 13.5529Z",
                            fill: "#2684FC"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M16.4525 8.72101L14.1249 4.70962C13.9782 4.45435 13.7675 4.25378 13.52 4.10791L11 8.44751L13.9599 13.5529H18.9908C18.9908 13.2703 18.9175 12.9877 18.7709 12.7324L16.4525 8.72101Z",
                            fill: "#FFBA00"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_931_182",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "16",
                            height: "14.2222",
                            fill: "white",
                            transform: "translate(3 3.88904)"
                        })
                    })
                })
            ]
        })
    });

});

parcelRegister("4I873", function(module, exports) {

$parcel$export(module.exports, "SlackIcon", () => $a12b4f39323b4c5d$export$b33fb54b08bb6422);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $a12b4f39323b4c5d$var$iconStyles = (0, $ecnYn.xcss)({
    width: '22px',
    height: '22px'
});
const $a12b4f39323b4c5d$export$b33fb54b08bb6422 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $a12b4f39323b4c5d$var$iconStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            width: "22",
            height: "22",
            viewBox: "0 0 22 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                    x: "1",
                    y: "1",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                    x: "0.5",
                    y: "0.5",
                    width: "21",
                    height: "21",
                    rx: "4.5",
                    stroke: "#0B1228",
                    strokeOpacity: "0.14"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                    clipPath: "url(#clip0_931_190)",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M6.99813 12.8186C6.99813 13.6234 6.34773 14.2738 5.54301 14.2738C4.73828 14.2738 4.08789 13.6234 4.08789 12.8186C4.08789 12.0139 4.73828 11.3635 5.54301 11.3635H6.99813V12.8186ZM7.72569 12.8186C7.72569 12.0139 8.37608 11.3635 9.1808 11.3635C9.98553 11.3635 10.6359 12.0139 10.6359 12.8186V16.4564C10.6359 17.2612 9.98553 17.9116 9.1808 17.9116C8.37608 17.9116 7.72569 17.2612 7.72569 16.4564V12.8186Z",
                            fill: "#E01E5A"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M9.18109 6.97615C8.37636 6.97615 7.72597 6.32576 7.72597 5.52104C7.72597 4.71631 8.37636 4.06592 9.18109 4.06592C9.98581 4.06592 10.6362 4.71631 10.6362 5.52104V6.97615H9.18109ZM9.18109 7.71474C9.98581 7.71474 10.6362 8.36513 10.6362 9.16986C10.6362 9.97458 9.98581 10.625 9.18109 10.625H5.53227C4.72754 10.625 4.07715 9.97458 4.07715 9.16986C4.07715 8.36513 4.72754 7.71474 5.53227 7.71474H9.18109Z",
                            fill: "#36C5F0"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M15.0123 9.16986C15.0123 8.36513 15.6627 7.71474 16.4674 7.71474C17.2721 7.71474 17.9225 8.36513 17.9225 9.16986C17.9225 9.97458 17.2721 10.625 16.4674 10.625H15.0123V9.16986ZM14.2847 9.16986C14.2847 9.97458 13.6344 10.625 12.8296 10.625C12.0249 10.625 11.3745 9.97458 11.3745 9.16986V5.52104C11.3745 4.71631 12.0249 4.06592 12.8296 4.06592C13.6344 4.06592 14.2847 4.71631 14.2847 5.52104V9.16986Z",
                            fill: "#2EB67D"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M12.8296 15.0013C13.6344 15.0013 14.2847 15.6517 14.2847 16.4564C14.2847 17.2612 13.6344 17.9116 12.8296 17.9116C12.0249 17.9116 11.3745 17.2612 11.3745 16.4564V15.0013H12.8296ZM12.8296 14.2738C12.0249 14.2738 11.3745 13.6234 11.3745 12.8186C11.3745 12.0139 12.0249 11.3635 12.8296 11.3635H16.4784C17.2832 11.3635 17.9336 12.0139 17.9336 12.8186C17.9336 13.6234 17.2832 14.2738 16.4784 14.2738H12.8296Z",
                            fill: "#ECB22E"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_931_190",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "14",
                            height: "14",
                            fill: "white",
                            transform: "translate(4 3.99988)"
                        })
                    })
                })
            ]
        })
    });

});



parcelRegister("5wbh9", function(module, exports) {

$parcel$export(module.exports, "CompassTab", () => $c70e830949a8116b$export$47b1e713578cc03f);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $crAJ1 = parcelRequire("crAJ1");

var $T9xHm = parcelRequire("T9xHm");

var $dh538 = parcelRequire("dh538");

var $4V3UW = parcelRequire("4V3UW");

var $a5cba = parcelRequire("a5cba");
var $fJRVo = parcelRequire("fJRVo");

var $jFPud = parcelRequire("jFPud");

var $2Mbeb = parcelRequire("2Mbeb");

var $cTEvB = parcelRequire("cTEvB");

var $elGZM = parcelRequire("elGZM");

var $cLKdA = parcelRequire("cLKdA");

var $48qR7 = parcelRequire("48qR7");

var $iEwUU = parcelRequire("iEwUU");

var $eztGN = parcelRequire("eztGN");

var $3Z7LN = parcelRequire("3Z7LN");

var $kmpep = parcelRequire("kmpep");

const $c70e830949a8116b$var$UpsellModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("3iCzO")).then((mod)=>({
            default: mod.UpsellModal
        })));
/**
 * Callback function to be used by PSD's permission supplier.
 * @returns all Compass scope required for Compass tab to function properly.
 */ const $c70e830949a8116b$var$upsellPermissionSupplier = ()=>{
    const response = Object.values((0, $cLKdA.CompassScope));
    return Promise.resolve(response);
};
const $c70e830949a8116b$var$CompassTabWithIntl = ({ baseUrl: baseUrl, crossFlowEnabled: crossFlowEnabled, intl: intl, isCompassActivated: isCompassActivated = false, isUserAnonymous: isUserAnonymous = false, postQueryItemSupplier: postQueryItemSupplier, preQueryItemSupplier: preQueryItemSupplier, sourceContext: sourceContext, upsellCtaButtonProps: upsellCtaButtonProps, userTeamConfig: userTeamConfig, ...rest })=>{
    const { advancedSearchLinkGenerator: advancedSearchLinkGenerator } = (0, $gwFzn.useMemo)(()=>{
        return (0, $48qR7.compassURLGenerators)(baseUrl);
    }, [
        baseUrl
    ]);
    const sections = (0, $cTEvB.getSections)(intl);
    const { preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams, postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams, preQuerySectionTitleGenerator: preQuerySectionTitleGenerator } = (0, $elGZM.useCompassSuppliers)({
        userTeamConfig: userTeamConfig,
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    }, sections);
    const getAdvancedSearchButtonLabel = (0, $gwFzn.useCallback)((productState)=>{
        switch(productState){
            case (0, $jFPud.ProductStates).PreQueryLoading:
            case (0, $jFPud.ProductStates).PreQuerySuccess:
            case (0, $jFPud.ProductStates).PreQueryError:
            case (0, $jFPud.ProductStates).PreQueryNoResult:
                return intl.formatMessage((0, $2Mbeb.messages).compass_view_all_components);
            default:
                return intl.formatMessage((0, $2Mbeb.messages).compass_view_all_results);
        }
    }, [
        intl
    ]);
    const shouldUpsell = !isUserAnonymous && crossFlowEnabled && !isCompassActivated && ((0, $dh538.fg)('hide_fedramp_compass_search_tab') ? !(0, $T9xHm.isFedrampModerate)() : true);
    const permissionSupplier = shouldUpsell ? $c70e830949a8116b$var$upsellPermissionSupplier : rest.permissionSupplier;
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $gwFzn.useCallback)((query, _, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $3Z7LN.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return advancedSearchLinkGenerator(query);
    }, [
        advancedSearchLinkGenerator,
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5cba.SearchDialogProduct), {
        id: (0, $elGZM.COMPASS_PRODUCT_ID),
        sections: sections,
        title: intl.formatMessage((0, $2Mbeb.messages).compass_tab_label),
        expandedStateInputPlaceholder: intl.formatMessage((0, $2Mbeb.messages).compass_expanded_input_placeholder),
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
        preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
        postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
        permissionSupplier: permissionSupplier,
        ...rest,
        children: ({ linkComponent: linkComponent, productState: productState, query: query })=>{
            if (shouldUpsell) return {
                Body: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($c70e830949a8116b$var$UpsellModal, {
                        sourceContext: sourceContext ?? 'product search dialog',
                        ctaButtonProps: upsellCtaButtonProps
                    }),
                Footer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {})
            };
            const advancedSearchUrl = advancedSearchLinkGenerator(query);
            const message = getAdvancedSearchButtonLabel(productState);
            return {
                Header: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4V3UW.AdvancedSearch), {
                        advancedSearchMessage: message,
                        advancedSearchUrl: advancedSearchUrl,
                        linkComponent: linkComponent
                    }),
                Footer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                        children: showAtlassianHomeSearchLink && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Z7LN.AtlassianHomeSearchLink), {
                                orgId: orgId,
                                cloudId: cloudId,
                                showModifierIcon: true
                            })
                        })
                    })
            };
        }
    });
};
const $c70e830949a8116b$export$47b1e713578cc03f = (0, $js7oX.default)($c70e830949a8116b$var$CompassTabWithIntl);

});
parcelRegister("T9xHm", function(module, exports) {

$parcel$export(module.exports, "isFedrampModerate", () => $0d80b51a2573beb2$export$104cb891a6e90b3a);

var $aK8Ra = parcelRequire("aK8Ra");

var $8hGEM = parcelRequire("8hGEM");
function $0d80b51a2573beb2$export$9186ccba8effc5de() {
    const atlCtxCookieValues = (0, $8hGEM.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $aK8Ra.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $0d80b51a2573beb2$export$104cb891a6e90b3a() {
    const atlCtxCookieValues = (0, $8hGEM.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $aK8Ra.FEDRAMP_MODERATE);
}
function $0d80b51a2573beb2$export$80638ee198476daf() {
    const atlCtxCookieValues = (0, $8hGEM.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icDomain;
}

});
parcelRegister("aK8Ra", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $e51c98f01c91eb22$export$ce553301d55c2fd8);
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $e51c98f01c91eb22$export$d8347b4aae768c2d);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $e51c98f01c91eb22$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $e51c98f01c91eb22$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $e51c98f01c91eb22$export$a0ffa0598c95dfb7);
const $e51c98f01c91eb22$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $e51c98f01c91eb22$export$f005e2e9f707cb5f = 'commercial';
const $e51c98f01c91eb22$export$a739cd5aac835909 = 'staging';
const $e51c98f01c91eb22$export$42dd0cdd351a4a9 = 'prod';
const $e51c98f01c91eb22$export$404582bc18fe4d9e = 'dev';
const $e51c98f01c91eb22$export$d8347b4aae768c2d = [
    $e51c98f01c91eb22$export$f005e2e9f707cb5f
];
const $e51c98f01c91eb22$export$b1b1ccc8f3e7f954 = [
    $e51c98f01c91eb22$export$f005e2e9f707cb5f,
    $e51c98f01c91eb22$export$ce553301d55c2fd8
];
const $e51c98f01c91eb22$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $e51c98f01c91eb22$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $e51c98f01c91eb22$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';

});

parcelRegister("8hGEM", function(module, exports) {

$parcel$export(module.exports, "parseAtlCtxCookies", () => $de133686e3836166$export$3fa7b7af96286cc9);

var $aK8Ra = parcelRequire("aK8Ra");
/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $de133686e3836166$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}
function $de133686e3836166$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        const cookies = global.document.cookie;
        const perimeter = $de133686e3836166$var$getRawCookieValue((0, $aK8Ra.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = $de133686e3836166$var$getRawCookieValue((0, $aK8Ra.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = $de133686e3836166$var$getRawCookieValue((0, $aK8Ra.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});


parcelRegister("2Mbeb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c4131fa39bec30c7$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $c4131fa39bec30c7$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /**
   * Compass
   */ compass_tab_label: {
        id: "product_search_dialog.compass.tab_label",
        defaultMessage: "Compass"
    },
    compass_components_section_heading: {
        id: "product_search_dialog.compass.components_section_heading",
        defaultMessage: "Components"
    },
    compass_people_section_heading: {
        id: "product_search_dialog.compass.people_section_heading",
        defaultMessage: "People"
    },
    compass_teams_section_heading: {
        id: "product_search_dialog.compass.teams_section_heading",
        defaultMessage: "Teams"
    },
    compass_endpoints_section_heading: {
        id: "product_search_dialog.compass.endpoints_section_heading",
        defaultMessage: "Endpoints"
    },
    compass_expanded_input_placeholder: {
        id: "product_search_dialog.compass.expanded.input-placeholder",
        defaultMessage: "Search Compass"
    },
    compass_view_all_components: {
        id: "product_search_dialog.compass.view_all_components_label",
        defaultMessage: "View all components"
    },
    compass_view_all_results: {
        id: "product_search_dialog.compass.view_all_results_label",
        defaultMessage: "View all results"
    },
    compass_component_type_service: {
        id: "product_search_dialog.compass.component_type.service",
        defaultMessage: "Service"
    },
    compass_component_type_library: {
        id: "product_search_dialog.compass.component_type.library",
        defaultMessage: "Library"
    },
    compass_component_type_application: {
        id: "product_search_dialog.compass.component_type.application",
        defaultMessage: "Application"
    },
    compass_component_type_capability: {
        id: "product_search_dialog.compass.component_type.capability",
        defaultMessage: "Capability"
    },
    compass_component_type_cloud_resource: {
        id: "product_search_dialog.compass.component_type.cloud_resource",
        defaultMessage: "Cloud resource"
    },
    compass_component_type_data_pipeline: {
        id: "product_search_dialog.compass.component_type.data_pipeline",
        defaultMessage: "Data pipeline"
    },
    compass_component_type_machine_learning_model: {
        id: "product_search_dialog.compass.component_type.machine_learning_model",
        defaultMessage: "Machine learning model"
    },
    compass_component_type_ui_element: {
        id: "product_search_dialog.compass.component_type.ui_element",
        defaultMessage: "UI element"
    },
    compass_component_type_website: {
        id: "product_search_dialog.compass.component_type.website",
        defaultMessage: "Website"
    },
    compass_component_type_other: {
        id: "product_search_dialog.compass.component_type.other",
        defaultMessage: "Other"
    },
    compass_recently_viewed_components: {
        id: "product_search_dialog.compass.recently_viewed_components",
        defaultMessage: "Recently viewed components"
    },
    compass_recently_viewed_teams: {
        id: "product_search_dialog.compass.recently_viewed_teams",
        defaultMessage: "Recently viewed teams"
    },
    compass_recently_viewed_endpoints: {
        id: "product_search_dialog.compass.recently_viewed_endpoints",
        defaultMessage: "Recently viewed endpoints"
    }
});

});

parcelRegister("cTEvB", function(module, exports) {

$parcel$export(module.exports, "getSections", () => $cf8641474df1decd$export$ddbcae0b0bd6b092);

var $2Mbeb = parcelRequire("2Mbeb");

var $ar4gF = parcelRequire("ar4gF");

var $cLKdA = parcelRequire("cLKdA");
const $cf8641474df1decd$var$mapComponentAggregatorResponseToSearchItem = (response)=>({
        title: response.title,
        id: response.id,
        meta: response.ownerId,
        url: response.url,
        icon: response.type,
        containerId: '' // no container
    });
const $cf8641474df1decd$var$mapApiEndpointAggregatorResponseToSearchItem = (response)=>({
        title: response.title,
        id: response.id,
        url: response.url,
        icon: response.url.split('/').pop()?.split('.')[0] || '',
        meta: ''
    });
const $cf8641474df1decd$export$ddbcae0b0bd6b092 = (intl)=>{
    const sections = [
        {
            id: (0, $cLKdA.CompassScope).Component,
            title: intl.formatMessage((0, $2Mbeb.messages).compass_components_section_heading),
            scope: (0, $cLKdA.CompassScope).Component,
            showResultCount: true,
            resultRenderer: (0, $ar4gF.componentResultRenderer),
            resultMapper: ({ results: results })=>results.map((value)=>$cf8641474df1decd$var$mapComponentAggregatorResponseToSearchItem(value))
        },
        {
            id: (0, $cLKdA.CompassScope).ApiEndpoint,
            title: intl.formatMessage((0, $2Mbeb.messages).compass_endpoints_section_heading),
            scope: (0, $cLKdA.CompassScope).ApiEndpoint,
            showResultCount: true,
            resultRenderer: (0, $ar4gF.endpointResultRenderer),
            resultLimit: 5,
            resultMapper: ({ results: results })=>results.map((value)=>$cf8641474df1decd$var$mapApiEndpointAggregatorResponseToSearchItem(value))
        }
    ];
    return sections;
};

});
parcelRegister("ar4gF", function(module, exports) {

$parcel$export(module.exports, "componentResultRenderer", () => $fe2b6b1b287be335$export$f2eed8836fc2639e);
$parcel$export(module.exports, "peopleAndTeamsResultRenderer", () => $fe2b6b1b287be335$export$3269347603d2224e);
$parcel$export(module.exports, "endpointResultRenderer", () => $fe2b6b1b287be335$export$2db93eff9b2b2c36);
/* result-renderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $ho4zm = parcelRequire("ho4zm");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");

var $3gadb = parcelRequire("3gadb");

var $gnG2x = parcelRequire("gnG2x");

var $9Qum6 = parcelRequire("9Qum6");

var $ejGzS = parcelRequire("ejGzS");

var $jFPud = parcelRequire("jFPud");

var $787Pb = parcelRequire("787Pb");
const $fe2b6b1b287be335$export$f2eed8836fc2639e = (args)=>{
    const { productState: productState, searchResult: searchResult } = args;
    const iconSize = productState === (0, $jFPud.ProductStates).PreQuerySuccess ? 'small' : 'medium';
    const iconType = searchResult.icon?.toString() ?? '';
    return (0, $ejGzS.defaultResultRenderer)({
        ...args,
        searchResult: {
            ...searchResult,
            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $787Pb.ResultIcon), {
                type: iconType,
                size: iconSize
            })
        }
    });
};
const $fe2b6b1b287be335$export$3269347603d2224e = (args)=>{
    const { productState: productState, searchResult: searchResult } = args;
    const iconSize = productState === (0, $jFPud.ProductStates).PreQuerySuccess ? 'xsmall' : 'small';
    return (0, $ejGzS.defaultResultRenderer)({
        ...args,
        searchResult: {
            ...searchResult,
            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9Qum6.ResultAvatar), {
                borderColor: "transparent",
                src: searchResult.iconUrl,
                appearance: "square",
                size: iconSize,
                testId: "result-avatar"
            })
        }
    });
};
const $fe2b6b1b287be335$var$MethodDetails = {
    POST: {
        abbreviation: 'POST',
        color: 'purpleLight'
    },
    GET: {
        abbreviation: 'GET',
        color: 'greenLight'
    },
    PUT: {
        abbreviation: 'PUT',
        color: 'blueLight'
    },
    DELETE: {
        abbreviation: 'DEL',
        color: 'redLight'
    },
    PATCH: {
        abbreviation: 'PATCH',
        color: 'greyLight'
    },
    OPTIONS: {
        abbreviation: 'OPT',
        color: 'greyLight'
    },
    HEAD: {
        abbreviation: 'HEAD',
        color: 'greyLight'
    },
    TRACE: {
        abbreviation: 'TRACE',
        color: 'greyLight'
    },
    CONNECT: {
        abbreviation: 'CONN',
        color: 'greyLight'
    }
};
const $fe2b6b1b287be335$var$styles = {
    methodTag: "_18u0r5cr"
};
const $fe2b6b1b287be335$export$2db93eff9b2b2c36 = (args)=>{
    const { searchResult: searchResult } = args;
    const method = (typeof searchResult.icon === 'string' ? searchResult.icon : '').toUpperCase();
    const methodDetails = $fe2b6b1b287be335$var$MethodDetails[method];
    const methodTag = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $fe2b6b1b287be335$var$styles.methodTag,
        children: methodDetails ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
            content: methodDetails.abbreviation,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ho4zm.default), {
                text: methodDetails.abbreviation,
                color: methodDetails.color
            })
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
            content: 'OTHER',
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ho4zm.default), {
                text: 'OTHER',
                color: "greyLight"
            })
        })
    });
    const title = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        paddingInlineStart: "space.300",
        children: searchResult.title
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gnG2x.SearchResultContent), {
        isKeyboardHighlighted: args.isKeyboardHighlighted,
        title: title,
        icon: methodTag,
        isCollapsed: args.isCollapsed,
        meta: searchResult.meta
    }, `item_${searchResult.id}`);
};

});
parcelRegister("787Pb", function(module, exports) {

$parcel$export(module.exports, "ResultIcon", () => $191b99a422a86faf$export$e8ec4da10aa3e6a6);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $id7ja = parcelRequire("id7ja");

var $3gadb = parcelRequire("3gadb");

var $cLKdA = parcelRequire("cLKdA");

var $jm8C7 = parcelRequire("jm8C7");
const $191b99a422a86faf$export$e8ec4da10aa3e6a6 = ({ type: type, size: size = 'medium' })=>{
    const intl = (0, $dBxQj.default)();
    const componentType = (0, $cLKdA.COMPONENT_TYPES)[type] ?? (0, $cLKdA.COMPONENT_TYPES).OTHER;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        content: intl.formatMessage(componentType.message),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jm8C7.IconBackground), {
            color: componentType.color,
            size: size,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $id7ja.default), {
                label: type,
                glyph: componentType.icon,
                size: size
            })
        })
    });
};

});
parcelRegister("cLKdA", function(module, exports) {

$parcel$export(module.exports, "CompassScope", () => $ea55797a819afe35$export$7dfd429914c57d74);
$parcel$export(module.exports, "COMPONENT_TYPES", () => $ea55797a819afe35$export$6349b6efda58d149);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");

var $2Mbeb = parcelRequire("2Mbeb");
var $ea55797a819afe35$export$7dfd429914c57d74 = /*#__PURE__*/ function(CompassScope) {
    CompassScope["Component"] = "compass.component";
    CompassScope["People"] = "compass.people";
    CompassScope["Teams"] = "compass.teams";
    CompassScope["ApiEndpoint"] = "compass.api-endpoint";
    return CompassScope;
}({});
const $ea55797a819afe35$export$6349b6efda58d149 = {
    SERVICE: {
        color: `var(--ds-icon, ${$6fnsQ.P300})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.714 5a1.286 1.286 0 1 0 0 2.571 1.286 1.286 0 0 0 0-2.571Zm-3.143.327A3.287 3.287 0 0 1 21 6.286a3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.042h-1.72L9.738 12l2.828 4.714h1.72a1 1 0 0 1 .285.041 3.287 3.287 0 0 1 6.429.96 3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.041H12a1 1 0 0 1-.857-.485L8.005 13H4a1 1 0 0 1 0-2h4.005l3.137-5.229A1 1 0 0 1 12 5.286h2.286a1 1 0 0 1 .285.04Zm3.143 11.101a1.286 1.286 0 1 0 0 2.572 1.286 1.286 0 0 0 0-2.572Z"
                })
            }),
        message: (0, $2Mbeb.messages).compass_component_type_service
    },
    LIBRARY: {
        color: `var(--ds-icon, ${$6fnsQ.Y500})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.21667 5C5.80834 5 4.66667 6.14167 4.66667 7.55V11H4.05C3.4701 11 3 11.4701 3 12.05C3 12.6299 3.4701 13.1 4.05 13.1H4.66667V16.55C4.66667 17.9583 5.80834 19.1 7.21667 19.1H9.05C9.6299 19.1 10.1 18.6299 10.1 18.05C10.1 17.4701 9.6299 17 9.05 17H7.21667C6.96814 17 6.76667 16.7985 6.76667 16.55V12.05V7.55C6.76667 7.30147 6.96814 7.1 7.21667 7.1H9.05C9.6299 7.1 10.1 6.6299 10.1 6.05C10.1 5.4701 9.6299 5 9.05 5H7.21667ZM16.8833 19.1C18.2917 19.1 19.4333 17.9583 19.4333 16.55V13.1H20.05C20.6299 13.1 21.1 12.6299 21.1 12.05C21.1 11.4701 20.6299 11 20.05 11H19.4333V7.55C19.4333 6.14167 18.2917 5 16.8833 5L15.05 5C14.4701 5 14 5.4701 14 6.05C14 6.6299 14.4701 7.1 15.05 7.1L16.8833 7.1C17.1319 7.1 17.3333 7.30147 17.3333 7.55V12.05L17.3333 16.55C17.3333 16.7985 17.1319 17 16.8833 17H15.05C14.4701 17 14 17.4701 14 18.05C14 18.6299 14.4701 19.1 15.05 19.1H16.8833Z"
                })
            }),
        message: (0, $2Mbeb.messages).compass_component_type_library
    },
    APPLICATION: {
        color: `var(--ds-icon, ${$6fnsQ.G300})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.57 3.105a1 1 0 0 1 .894.001l3.985 2A1 1 0 0 1 17 6v4.375l3.449 1.731A1 1 0 0 1 21 13v5a1 1 0 0 1-.553.895l-4.004 2a1 1 0 0 1-.894 0l-3.55-1.777-3.556 1.777a1 1 0 0 1-.894 0l-3.997-2A1 1 0 0 1 3 18v-5a1 1 0 0 1 .554-.895L7 10.389V6a1 1 0 0 1 .554-.895l4.016-2Zm-3.563 9.017L5 13.619v3.763l2.997 1.5 3.003-1.5V13.62l-2.993-1.498ZM13 13.619v3.763l2.996 1.5 3.004-1.5v-3.765l-2.986-1.499L13 13.619Zm2-3.237V6.617l-2.986-1.499L9 6.619v3.756l3 1.506 3-1.5Z"
                })
            }),
        message: (0, $2Mbeb.messages).compass_component_type_application
    },
    CAPABILITY: {
        color: `var(--ds-icon, ${$6fnsQ.N600})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.5145 6.15717C10.5145 6.97758 11.1796 7.64266 12 7.64266C12.8204 7.64266 13.4855 6.97758 13.4855 6.15717C13.4855 5.33676 12.8204 4.67168 12 4.67168C11.1796 4.67168 10.5145 5.33676 10.5145 6.15717ZM11.15 9.22799C10.8953 9.15765 10.6534 9.05647 10.4286 8.92873L8.93348 10.426C9.19656 10.8894 9.34679 11.4253 9.34679 11.9963C9.34679 13.7556 7.9206 15.1818 6.1613 15.1818C4.40201 15.1818 2.97581 13.7556 2.97581 11.9963C2.97581 10.237 4.40201 8.81083 6.1613 8.81083C6.73217 8.81083 7.26796 8.96099 7.73134 9.22398L9.22707 7.72612C8.96447 7.263 8.81454 6.72759 8.81454 6.15717C8.81454 4.39787 10.2407 2.97168 12 2.97168C13.7593 2.97168 15.1855 4.39787 15.1855 6.15717C15.1855 6.72831 15.0352 7.26434 14.772 7.72787L16.2683 9.22419C16.7318 8.96107 17.2677 8.81083 17.8387 8.81083C19.598 8.81083 21.0242 10.237 21.0242 11.9963C21.0242 13.7556 19.598 15.1818 17.8387 15.1818C16.0794 15.1818 14.6532 13.7556 14.6532 11.9963C14.6532 11.4255 14.8034 10.8897 15.0663 10.4264L13.5697 8.92972C13.3453 9.057 13.104 9.15784 12.85 9.228V14.7646C14.1966 15.1366 15.1855 16.3705 15.1855 17.8355C15.1855 19.5948 13.7593 21.021 12 21.021C10.2407 21.021 8.81454 19.5948 8.81454 17.8355C8.81454 16.3705 9.80338 15.1366 11.15 14.7646V9.22799ZM4.67581 11.9963C4.67581 12.8167 5.34089 13.4818 6.1613 13.4818C6.98172 13.4818 7.64679 12.8167 7.64679 11.9963C7.64679 11.1759 6.98172 10.5108 6.1613 10.5108C5.34089 10.5108 4.67581 11.1759 4.67581 11.9963ZM12 19.321C11.1796 19.321 10.5145 18.6559 10.5145 17.8355C10.5145 17.0151 11.1796 16.35 12 16.35C12.8204 16.35 13.4855 17.0151 13.4855 17.8355C13.4855 18.6559 12.8204 19.321 12 19.321ZM16.3532 11.9963C16.3532 12.8167 17.0183 13.4818 17.8387 13.4818C18.6591 13.4818 19.3242 12.8167 19.3242 11.9963C19.3242 11.1759 18.6591 10.5108 17.8387 10.5108C17.0183 10.5108 16.3532 11.1759 16.3532 11.9963Z"
                })
            }),
        message: (0, $2Mbeb.messages).compass_component_type_capability
    },
    CLOUD_RESOURCE: {
        color: `var(--ds-icon, ${$6fnsQ.P300})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M6.07585 10.4798C4.70269 10.7573 3.66883 11.9708 3.66883 13.4258C3.66883 15.0857 4.83719 16.4314 6.49712 16.4314M16.6409 16.4314C18.9648 16.4314 20.5 14.5475 20.5 12.2236C20.5 9.89967 18.6161 8.01578 16.2922 8.01578C15.8909 8.01578 15.5027 8.07196 15.1351 8.17688M15.1399 8.18267C14.3348 6.65375 12.7302 5.61133 10.8822 5.61133C8.22631 5.61133 6.07329 7.76435 6.07329 10.4202V10.4803",
                        stroke: "#fff",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M14.1963 16.4036C14.1963 17.8203 13.0479 18.9688 11.6312 18.9688C10.2146 18.9688 9.06612 17.8203 9.06612 16.4036C9.06612 14.987 10.2146 13.8385 11.6312 13.8385C13.0479 13.8385 14.1963 14.987 14.1963 16.4036Z",
                        stroke: "#fff",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
        message: (0, $2Mbeb.messages).compass_component_type_cloud_resource
    },
    DATA_PIPELINE: {
        color: `var(--ds-icon, ${$6fnsQ.R300})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M5.42614 8.00584C6.57734 8.45806 7.87717 7.89141 8.32938 6.7402C8.78159 5.589 8.21495 4.28917 7.06374 3.83696C5.91254 3.38475 4.61271 3.95139 4.1605 5.1026C3.70828 6.2538 4.27493 7.55363 5.42614 8.00584Z",
                        stroke: "#fff",
                        strokeWidth: "1.7",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M16.9334 20.1997C18.0846 20.6519 19.3844 20.0853 19.8366 18.9341C20.2888 17.7828 19.7222 16.483 18.571 16.0308C17.4198 15.5786 16.12 16.1452 15.6677 17.2964C15.2155 18.4477 15.7822 19.7475 16.9334 20.1997Z",
                        stroke: "#fff",
                        strokeWidth: "1.7",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M6.24493 8.56055V11.0306C6.24493 11.5829 6.69264 12.0306 7.24493 12.0306H16.0659C16.6182 12.0306 17.0659 12.4784 17.0659 13.0306V15.2116",
                        stroke: "#fff",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
        message: (0, $2Mbeb.messages).compass_component_type_data_pipeline
    },
    MACHINE_LEARNING_MODEL: {
        color: `var(--ds-icon, ${$6fnsQ.R300})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M11.8555 3.01807L15.7255 5.31503L19.6497 7.51807L19.5955 12.0181L19.6497 16.5181L15.7255 18.7211L11.8555 21.0181L7.98547 18.7211L4.06124 16.5181L4.11547 12.0181L4.06124 7.51807L7.98547 5.31503L11.8555 3.01807Z",
                        stroke: "#fff",
                        strokeWidth: "1.5",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M4.61222 7.89078L18.8696 16.1906",
                        stroke: "#fff",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M4.85273 16.2901L19.0688 7.95921",
                        stroke: "#fff",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M11.7317 20.2989L11.7317 3.24756",
                        stroke: "#fff",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "#FF5630",
                        d: "M10.7933 14.6374C12.1126 15.1556 13.6021 14.5062 14.1203 13.187C14.6385 11.8678 13.9892 10.3782 12.67 9.86003C11.3507 9.34181 9.86119 9.99116 9.34297 11.3104C8.82476 12.6296 9.47411 14.1192 10.7933 14.6374Z",
                        stroke: "#fff",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
        message: (0, $2Mbeb.messages).compass_component_type_machine_learning_model
    },
    UI_ELEMENT: {
        color: `var(--ds-icon, ${$6fnsQ.Y500})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                        id: "path-1-inside-1_1403_23012",
                        fill: "white",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            x: "2.83353",
                            y: "13.6489",
                            width: "6.97358",
                            height: "7.36887",
                            rx: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        fill: "none",
                        x: "2.83353",
                        y: "13.6489",
                        width: "6.97358",
                        height: "7.36887",
                        rx: "1",
                        stroke: "#fff",
                        strokeWidth: "3.2",
                        mask: "url(#path-1-inside-1_1403_23012)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                        id: "path-2-inside-2_1403_23012",
                        fill: "white",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            x: "2.83353",
                            y: "3.01807",
                            width: "18.5455",
                            height: "8.59702",
                            rx: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        fill: "none",
                        x: "2.83353",
                        y: "3.01807",
                        width: "18.5455",
                        height: "8.59702",
                        rx: "1",
                        stroke: "#fff",
                        strokeWidth: "3.2",
                        mask: "url(#path-2-inside-2_1403_23012)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                        id: "path-3-inside-3_1403_23012",
                        fill: "white",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            x: "11.5089",
                            y: "13.6489",
                            width: "9.87006",
                            height: "7.36887",
                            rx: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        fill: "none",
                        x: "11.5089",
                        y: "13.6489",
                        width: "9.87006",
                        height: "7.36887",
                        rx: "1",
                        stroke: "#fff",
                        strokeWidth: "3.2",
                        mask: "url(#path-3-inside-3_1403_23012)"
                    })
                ]
            }),
        message: (0, $2Mbeb.messages).compass_component_type_ui_element
    },
    WEBSITE: {
        color: `var(--ds-icon, ${$6fnsQ.G300})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fill: "fff",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.3319 20.9136C13.5069 20.9136 14.6704 20.6821 15.756 20.2325C16.8416 19.7828 17.828 19.1237 18.6589 18.2928C19.4898 17.462 20.1489 16.4756 20.5985 15.39C21.0482 14.3044 21.2796 13.1409 21.2796 11.9658C21.2796 10.7908 21.0482 9.62725 20.5985 8.54166C20.1489 7.45607 19.4898 6.46968 18.6589 5.6388C17.828 4.80793 16.8416 4.14884 15.756 3.69917C14.6704 3.24951 13.5069 3.01807 12.3319 3.01807C9.95879 3.01807 7.68289 3.96077 6.00486 5.6388C4.32683 7.31683 3.38412 9.59273 3.38412 11.9658C3.38412 14.3389 4.32683 16.6148 6.00486 18.2928C7.68289 19.9709 9.95879 20.9136 12.3319 20.9136V20.9136ZM11.4371 19.0614C9.70752 18.8456 8.11636 18.0054 6.96289 16.6987C5.80941 15.3919 5.17312 13.7088 5.17368 11.9658C5.17368 11.4111 5.24526 10.8831 5.36158 10.3642L9.64755 14.6501V15.5449C9.64755 16.5292 10.4529 17.3345 11.4371 17.3345V19.0614V19.0614ZM17.6111 16.7887C17.4975 16.427 17.2713 16.1113 16.9654 15.8875C16.6595 15.6637 16.29 15.5436 15.911 15.5449H15.0162V12.8606C15.0162 12.3685 14.6136 11.9658 14.1214 11.9658H8.75278V10.1763H10.5423C11.0345 10.1763 11.4371 9.77362 11.4371 9.28149V7.49194H13.2267C14.2109 7.49194 15.0162 6.68665 15.0162 5.70239V5.33553C17.6379 6.40032 19.4901 8.96832 19.4901 11.9658C19.4901 13.827 18.7743 15.5181 17.6111 16.7887V16.7887Z"
                })
            }),
        message: (0, $2Mbeb.messages).compass_component_type_website
    },
    OTHER: {
        color: `var(--ds-icon, ${$6fnsQ.B300})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991ZM3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 17.991V10.01Z"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7 8.335c0-.002 2.002-.002 2.002-.002C9 8.333 9 6.665 9 6.665c0 .002-2.002.002-2.002.002C7 6.667 7 8.335 7 8.335Zm-2-1.67C5 5.745 5.898 5 6.998 5h2.004C10.106 5 11 5.749 11 6.665v1.67C11 9.255 10.102 10 9.002 10H6.998C5.894 10 5 9.251 5 8.335v-1.67Zm10 1.67c0-.002 2.002-.002 2.002-.002C17 8.333 17 6.665 17 6.665c0 .002-2.002.002-2.002.002.002 0 .002 1.668.002 1.668Zm-2-1.67C13 5.745 13.898 5 14.998 5h2.004C18.106 5 19 5.749 19 6.665v1.67c0 .92-.898 1.665-1.998 1.665h-2.004C13.894 10 13 9.251 13 8.335v-1.67Z"
                    })
                ]
            }),
        message: (0, $2Mbeb.messages).compass_component_type_other
    }
};

});

parcelRegister("jm8C7", function(module, exports) {

$parcel$export(module.exports, "IconBackground", () => $27cceccddbf9c80b$export$e320804e9cbf60f);

var $SZOxu = parcelRequire("SZOxu");

var $6hiXa = parcelRequire("6hiXa");
const $27cceccddbf9c80b$export$e320804e9cbf60f = (0, $6hiXa.default).div`
	display: flex;
	align-items: center;
	justify-content: center;

	width: ${(props)=>(0, $SZOxu.sizes)[props.size]};
	height: ${(props)=>(0, $SZOxu.sizes)[props.size]};

	background-color: ${(props)=>props.color};
	border-radius: 3px;

	& > svg,
	& > span[role='img'],
	& > span[role='presentation'] {
		width: 83.333333%;
	}
`;

});




parcelRegister("elGZM", function(module, exports) {

$parcel$export(module.exports, "COMPASS_PRODUCT_ID", () => $e334ffb1d4729b69$export$29789a1990c8eafe);
$parcel$export(module.exports, "useCompassSuppliers", () => $e334ffb1d4729b69$export$9b569c25a7f27268);

var $dBxQj = parcelRequire("dBxQj");

var $5CiaV = parcelRequire("5CiaV");

var $3coNb = parcelRequire("3coNb");

var $2Mbeb = parcelRequire("2Mbeb");

var $4RUaK = parcelRequire("4RUaK");

var $cLKdA = parcelRequire("cLKdA");

var $48qR7 = parcelRequire("48qR7");

var $ar4gF = parcelRequire("ar4gF");
const $e334ffb1d4729b69$export$29789a1990c8eafe = 'compass';
const $e334ffb1d4729b69$var$NO_OWNER_TEAM = 'ari:cloud:teams::team/unidentified';
const $e334ffb1d4729b69$export$9b569c25a7f27268 = ({ userTeamConfig: userTeamConfig, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier }, sections)=>{
    const intl = (0, $dBxQj.default)();
    const itemSuppliers = (0, $5CiaV.useDefaultSuppliers)($e334ffb1d4729b69$export$29789a1990c8eafe, sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    const peopleAndTeamSupplier = (0, $3coNb.usePeopleAndTeamsQuery)({
        people: {
            id: (0, $cLKdA.CompassScope).People,
            title: intl.formatMessage((0, $2Mbeb.messages).compass_people_section_heading)
        },
        teams: {
            id: (0, $cLKdA.CompassScope).Teams,
            title: intl.formatMessage((0, $2Mbeb.messages).compass_teams_section_heading)
        }
    }, 3);
    const requestTeamMeta = async (teamId)=>{
        if (!userTeamConfig?.context.siteId || !teamId || teamId === $e334ffb1d4729b69$var$NO_OWNER_TEAM) return '';
        try {
            const team = await (0, $4RUaK.getTeamData)({
                url: userTeamConfig?.baseUrl || '',
                teamAri: teamId,
                siteId: userTeamConfig?.context.siteId
            });
            return team.displayName;
        } catch (e) {
            // Ignore
            return '';
        }
    };
    const userTeamConfigOverride = {
        context: userTeamConfig.context,
        baseUrl: userTeamConfig.baseUrl,
        resolveTeamUrl: userTeamConfig.resolveTeamUrl ?? (0, $48qR7.compassURLGenerators)().teamUrlGenerator,
        resolveUserUrl: userTeamConfig.resolveUserUrl ?? (0, $48qR7.compassURLGenerators)().userUrlGenerator
    };
    const hydrateOwnerMeta = async (items)=>{
        const promises = [];
        const compSection = items.sections.find((s)=>s.id === (0, $cLKdA.CompassScope).Component);
        if (compSection) compSection.searchResults.map(async (res)=>{
            promises.push(requestTeamMeta(res.meta).then((teamName)=>res.meta = teamName));
        });
        return Promise.all(promises).then(()=>items);
    };
    const preQueryItemSupplierWithTeamName = async (args)=>{
        const existingSections = await hydrateOwnerMeta(await itemSuppliers.preQueryItemSupplier(args));
        const teamSection = (await peopleAndTeamSupplier('', userTeamConfigOverride)).sections.find((section)=>section.id === (0, $cLKdA.CompassScope).Teams);
        return window.location.pathname.startsWith('/compass') ? existingSections : {
            size: existingSections.size,
            sections: [
                ...existingSections.sections,
                ...teamSection ? [
                    {
                        ...teamSection,
                        resultRenderer: (0, $ar4gF.peopleAndTeamsResultRenderer)
                    }
                ] : []
            ]
        };
    };
    const postQueryItemSupplierWithPeopleAndTeams = async (args)=>{
        const existingSections = await hydrateOwnerMeta(await itemSuppliers.postQueryItemSupplier(args));
        const people = userTeamConfigOverride ? await peopleAndTeamSupplier(args.query, {
            ...userTeamConfigOverride,
            context: {
                ...userTeamConfigOverride.context,
                siteId: userTeamConfigOverride.context.siteId
            }
        }) : null;
        return {
            size: existingSections.size,
            sections: [
                ...existingSections.sections,
                ...people?.sections.map((section)=>({
                        ...section,
                        resultRenderer: (0, $ar4gF.peopleAndTeamsResultRenderer)
                    })) ?? []
            ]
        };
    };
    const preQuerySectionTitleGenerator = (section)=>{
        switch(section.id){
            case (0, $cLKdA.CompassScope).Component:
                return window.location.pathname.startsWith('/compass') ? intl.formatMessage((0, $2Mbeb.messages).compass_recently_viewed_components) : intl.formatMessage((0, $2Mbeb.messages).compass_components_section_heading);
            case (0, $cLKdA.CompassScope).Teams:
                return window.location.pathname.startsWith('/compass') ? intl.formatMessage((0, $2Mbeb.messages).compass_recently_viewed_teams) : intl.formatMessage((0, $2Mbeb.messages).compass_teams_section_heading);
            case (0, $cLKdA.CompassScope).ApiEndpoint:
                return window.location.pathname.startsWith('/compass') ? intl.formatMessage((0, $2Mbeb.messages).compass_recently_viewed_endpoints) : intl.formatMessage((0, $2Mbeb.messages).compass_endpoints_section_heading);
            default:
                return '';
        }
    };
    return {
        preQueryItemSupplier: preQueryItemSupplierWithTeamName,
        postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator
    };
};

});
parcelRegister("3coNb", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsQuery", () => $6972a0988821eda6$export$f16e39d5b6af63da);

var $dBxQj = parcelRequire("dBxQj");
const $6972a0988821eda6$var$ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)';
const $6972a0988821eda6$var$resolveRecommendationRequest = ({ baseUrl: baseUrl, context: context, includeUsers: includeUsers, includeTeams: includeTeams, query: query, maxNumberOfResults: maxNumberOfResults })=>({
        baseUrl: baseUrl,
        context: context,
        maxNumberOfResults: maxNumberOfResults,
        query: query ?? '',
        searchQueryFilter: $6972a0988821eda6$var$ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER,
        includeUsers: includeUsers ?? false,
        includeGroups: false,
        includeTeams: includeTeams ?? false
    });

const $6972a0988821eda6$var$asyncGetUserRecommendations = async (request, intl)=>{
    try {
        const { getUserRecommendations: getUserRecommendations } = await (parcelRequire("e1DgV"));
        return getUserRecommendations(request, intl);
    } catch (e) {
    // Ignore
    }
};
const $6972a0988821eda6$export$f16e39d5b6af63da = (peopleAndTeamSections, maxItemsPerSection)=>{
    const intl = (0, $dBxQj.default)();
    return async (query, { baseUrl: baseUrl, context: context, resolveTeamUrl: resolveTeamUrl, resolveUserUrl: resolveUserUrl })=>{
        const teamsRequest = $6972a0988821eda6$var$resolveRecommendationRequest({
            includeTeams: true,
            baseUrl: baseUrl,
            context: context,
            query: query,
            maxNumberOfResults: 20
        });
        // Separate requests enables better empty query results for each section
        const usersRequest = $6972a0988821eda6$var$resolveRecommendationRequest({
            includeUsers: true,
            baseUrl: baseUrl,
            context: context,
            query: query,
            maxNumberOfResults: 20
        });
        try {
            const [teams, users] = await Promise.all([
                $6972a0988821eda6$var$asyncGetUserRecommendations(teamsRequest, intl),
                $6972a0988821eda6$var$asyncGetUserRecommendations(usersRequest, intl)
            ]);
            const teamResults = teams?.map((team)=>{
                return {
                    title: team.name,
                    id: team.id,
                    meta: '',
                    url: resolveTeamUrl ? resolveTeamUrl(team.id) : `/people/team/${team.id}`,
                    iconUrl: team.avatarUrl,
                    isVerified: team.verified
                };
            }) ?? [];
            const userResults = users?.map((user)=>{
                return {
                    title: user.name,
                    id: user.id,
                    meta: user.title || '',
                    url: resolveUserUrl ? resolveUserUrl(user.id) : `/people/${user.id}`,
                    iconUrl: user.avatarUrl
                };
            }) ?? [];
            return {
                sections: [
                    {
                        ...peopleAndTeamSections.people,
                        searchResults: maxItemsPerSection ? userResults.slice(0, maxItemsPerSection) : userResults
                    },
                    {
                        ...peopleAndTeamSections.teams,
                        searchResults: maxItemsPerSection ? teamResults.slice(0, maxItemsPerSection) : teamResults
                    }
                ]
            };
        } catch (error) {
            return {
                sections: [
                    {
                        ...peopleAndTeamSections.people,
                        searchResults: []
                    },
                    {
                        ...peopleAndTeamSections.teams,
                        searchResults: []
                    }
                ]
            };
        }
    };
};

});
parcelRegister("e1DgV", function(module, exports) {

let $02a29315d330d4d1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $02a29315d330d4d1$var$load("N7HSS"),
    $02a29315d330d4d1$var$load("gFkzm"),
    $02a29315d330d4d1$var$load("joJy8"),
    $02a29315d330d4d1$var$load("aHE9G"),
    $02a29315d330d4d1$var$load("ffEVr"),
    $02a29315d330d4d1$var$load("jjAxo")
]).then(()=>parcelRequire('7HssB'));

});


parcelRegister("4RUaK", function(module, exports) {

$parcel$export(module.exports, "getTeamData", () => $39c8c0bb71b97b60$export$c11a6707e0ba3a30);

var $dwp40 = parcelRequire("dwp40");
const $39c8c0bb71b97b60$export$a637ff7dbe7c1532 = ({ teamId: teamId, siteId: siteId })=>{
    if (teamId === undefined || siteId === undefined) throw new Error('Missing some required parameters teamId and siteId');
    return `/gateway/api/v4/teams/${encodeURIComponent(teamId)}?siteId=${encodeURIComponent(siteId)}`;
};
const $39c8c0bb71b97b60$export$c11a6707e0ba3a30 = ({ url: url, teamAri: teamAri, siteId: siteId })=>{
    const parts = teamAri.split('/');
    const teamId = parts[parts.length - 1];
    const options = {
        path: $39c8c0bb71b97b60$export$a637ff7dbe7c1532({
            teamId: teamId,
            siteId: siteId
        }),
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    return (0, $dwp40.utils).requestService({
        url: url
    }, options);
};

});

parcelRegister("48qR7", function(module, exports) {

$parcel$export(module.exports, "compassURLGenerators", () => $e86c1942bf63794c$export$9dd4fd2059f2de3b);
const $e86c1942bf63794c$var$getBaseURL = ()=>window.location.origin;
const $e86c1942bf63794c$export$9dd4fd2059f2de3b = (searchUrlOverride)=>{
    const advancedSearchLinkGenerator = (query)=>`${searchUrlOverride || $e86c1942bf63794c$var$getBaseURL()}/compass/components?query=${encodeURIComponent(query)}`;
    const teamUrlGenerator = (teamId)=>`${$e86c1942bf63794c$var$getBaseURL()}/compass/people/team/${teamId}`;
    const userUrlGenerator = (userId)=>`${$e86c1942bf63794c$var$getBaseURL()}/people/${userId}`;
    return {
        advancedSearchLinkGenerator: advancedSearchLinkGenerator,
        teamUrlGenerator: teamUrlGenerator,
        userUrlGenerator: userUrlGenerator
    };
};

});


parcelRegister("3iCzO", function(module, exports) {

let $2670fa0f9f376cb7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2670fa0f9f376cb7$var$load("joJy8"),
    $2670fa0f9f376cb7$var$load("aHE9G"),
    $2670fa0f9f376cb7$var$load("5kEKD")
]).then(()=>parcelRequire('eFfFJ'));

});


parcelRegister("fx9tH", function(module, exports) {

$parcel$export(module.exports, "FilterContextProvider", () => $d37a1f8828c7be3a$export$eb71bf38f5ae0f9c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $hpDfc = parcelRequire("hpDfc");

var $jnLgC = parcelRequire("jnLgC");

var $80L9g = parcelRequire("80L9g");
const $d37a1f8828c7be3a$export$5767e6ba1d152dc0 = ()=>{
    const lastModifiedDate = new Date();
    lastModifiedDate.setDate(lastModifiedDate.getDate() - 90);
    return lastModifiedDate.toISOString().split('T')[0];
};
const $d37a1f8828c7be3a$var$useFilters = (defaultFilters = [], storeFilters = (value)=>{})=>{
    const { filters: filters, dispatch: dispatch } = (0, $jnLgC.useFilter)(defaultFilters);
    (0, $gwFzn.useLayoutEffect)(()=>{
        storeFilters(filters);
    });
    const addFilters = (0, $gwFzn.useCallback)((newFilters)=>{
        dispatch((0, $jnLgC.addFilters)(newFilters));
        storeFilters(filters.concat(newFilters));
    }, [
        dispatch,
        filters,
        storeFilters
    ]);
    const updateFilter = (0, $gwFzn.useCallback)((id, isChecked)=>{
        dispatch((0, $jnLgC.updateFilterState)(id, isChecked, true));
        const index = filters.findIndex((filter)=>filter.id === id);
        const newFilters = [
            ...filters
        ];
        newFilters[index] = {
            ...newFilters[index],
            isChecked: isChecked,
            isVisible: true
        };
        storeFilters(filters.concat(newFilters));
    }, [
        dispatch,
        filters,
        storeFilters
    ]);
    const clearFilter = (0, $gwFzn.useCallback)(()=>{
        filters.forEach((f)=>{
            dispatch((0, $jnLgC.updateFilterState)(f.id, false));
        });
        const newFilters = filters.map((f)=>{
            const newF = {
                ...f
            };
            newF.isChecked = false;
            return newF;
        });
        storeFilters(newFilters);
    }, [
        dispatch,
        filters,
        storeFilters
    ]);
    const resetFilter = (0, $gwFzn.useCallback)(()=>{
        dispatch((0, $jnLgC.replaceAllFilters)(defaultFilters));
    }, [
        defaultFilters,
        dispatch
    ]);
    return {
        availableFilters: filters,
        addFilters: addFilters,
        updateFilter: updateFilter,
        clearFilter: clearFilter,
        reset: resetFilter,
        dispatch: dispatch
    };
};
const $d37a1f8828c7be3a$var$DEFAULT_FILTER_STATE = {
    availableFilters: [],
    addFilters: ()=>{},
    updateFilter: ()=>{},
    clearFilter: ()=>{},
    reset: ()=>{},
    dispatch: ()=>{}
};
const $d37a1f8828c7be3a$var$FilterContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    spaceFilters: $d37a1f8828c7be3a$var$DEFAULT_FILTER_STATE,
    peopleFilters: $d37a1f8828c7be3a$var$DEFAULT_FILTER_STATE,
    siteFilters: $d37a1f8828c7be3a$var$DEFAULT_FILTER_STATE,
    resetFilters: ()=>{},
    prequeryFiltersRef: {
        current: ''
    }
});
function $d37a1f8828c7be3a$export$5e1edcb3c154ab79(availableFilters) {
    const appliedFilters = availableFilters.map((availableFilter, index)=>({
            ...availableFilter,
            index: index
        })).filter((filterWithIndex)=>filterWithIndex.isChecked);
    return {
        applied: appliedFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource,
                index: appliedFilter.index
            })),
        recommendedIds: availableFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource
            }))
    };
}
const $d37a1f8828c7be3a$export$eb71bf38f5ae0f9c = ({ isEnabled: isEnabled = true, defaultSpaceFilters: defaultSpaceFilters, defaultPeopleFilters: defaultPeopleFilters, defaultSiteFilters: defaultSiteFilters, children: children })=>{
    const previousEnabledState = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(isEnabled);
    const { stickySearchEnabled: stickySearchEnabled, readFilters: readFilters, storeFilters: storeFilters, resetConfluenceFiltersRef: resetConfluenceFiltersRef } = (0, $80L9g.useSessionUserInput)();
    const [filters, setFilters] = (0, $gwFzn.useState)(readFilters('confluence'));
    const initialSpaceFilters = stickySearchEnabled ? filters?.space || defaultSpaceFilters : defaultSpaceFilters;
    const initialPeopleFilters = stickySearchEnabled ? filters?.people || defaultPeopleFilters : defaultPeopleFilters;
    const initialSiteFilters = stickySearchEnabled ? filters?.site || defaultSiteFilters : defaultSiteFilters;
    const getUpdateFilters = (0, $gwFzn.useCallback)((type)=>(options)=>{
            const filters = readFilters('confluence');
            switch(type){
                case 'SPACE':
                    filters.space = options;
                    break;
                case 'PEOPLE':
                    filters.people = options;
                    break;
                case 'SITE':
                    filters.site = options;
                    break;
            }
            storeFilters('confluence', filters);
        }, [
        readFilters,
        storeFilters
    ]);
    const spaceFilterStore = $d37a1f8828c7be3a$var$useFilters(initialSpaceFilters, stickySearchEnabled ? getUpdateFilters('SPACE') : undefined);
    const peopleFilterStore = $d37a1f8828c7be3a$var$useFilters(initialPeopleFilters, stickySearchEnabled ? getUpdateFilters('PEOPLE') : undefined);
    const siteFilterStore = $d37a1f8828c7be3a$var$useFilters(initialSiteFilters, stickySearchEnabled ? getUpdateFilters('SITE') : undefined);
    const prequeryFiltersRef = (0, $gwFzn.useRef)('');
    const filtersAnalyticsContext = spaceFilterStore.availableFilters.length === 0 && peopleFilterStore.availableFilters.length === 0 ? {} : {
        container: $d37a1f8828c7be3a$export$5e1edcb3c154ab79(spaceFilterStore.availableFilters),
        contributor: $d37a1f8828c7be3a$export$5e1edcb3c154ab79(peopleFilterStore.availableFilters)
    };
    const resetFilters = (0, $gwFzn.useCallback)(()=>{
        spaceFilterStore.dispatch((0, $jnLgC.replaceAllFilters)(defaultSpaceFilters || []));
        peopleFilterStore.dispatch((0, $jnLgC.replaceAllFilters)(defaultPeopleFilters || []));
        siteFilterStore.dispatch((0, $jnLgC.replaceAllFilters)(defaultSiteFilters || []));
    }, [
        defaultPeopleFilters,
        defaultSiteFilters,
        defaultSpaceFilters,
        peopleFilterStore,
        siteFilterStore,
        spaceFilterStore
    ]);
    const clearFilters = (0, $gwFzn.useCallback)(()=>{
        spaceFilterStore.clearFilter();
        peopleFilterStore.clearFilter();
        siteFilterStore.clearFilter();
        if (stickySearchEnabled) setFilters(readFilters('confluence'));
    }, [
        spaceFilterStore,
        peopleFilterStore,
        siteFilterStore,
        stickySearchEnabled,
        readFilters
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (resetConfluenceFiltersRef) resetConfluenceFiltersRef.current = clearFilters;
    }, [
        clearFilters,
        resetConfluenceFiltersRef
    ]);
    // We reset the state when the component becomes disabled
    if (previousEnabledState.current && !isEnabled && !stickySearchEnabled) resetFilters();
    previousEnabledState.current = isEnabled;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($d37a1f8828c7be3a$var$FilterContext.Provider, {
        value: {
            spaceFilters: spaceFilterStore,
            peopleFilters: peopleFilterStore,
            siteFilters: siteFilterStore,
            resetFilters: resetFilters,
            prequeryFiltersRef: prequeryFiltersRef
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
            analyticContext: {},
            nonPrivacySafeAnalyticContext: {},
            filterAnalyticsContext: filtersAnalyticsContext,
            children: children
        })
    });
};
const $d37a1f8828c7be3a$export$396ef541d9951d45 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext($d37a1f8828c7be3a$var$FilterContext);
};

});
parcelRegister("jnLgC", function(module, exports) {

$parcel$export(module.exports, "addFilters", () => $5fb8761f8962dfc8$export$60c1905c6f855529);
$parcel$export(module.exports, "replaceAllFilters", () => $5fb8761f8962dfc8$export$4dce09b3092bd5e8);
$parcel$export(module.exports, "updateFilterState", () => $5fb8761f8962dfc8$export$e4269d58720a0c2c);
$parcel$export(module.exports, "useFilter", () => $5fb8761f8962dfc8$export$3274cf84b703fff);

var $gwFzn = parcelRequire("gwFzn");
const $5fb8761f8962dfc8$export$60c1905c6f855529 = (filters, sortFunction)=>({
        type: 'ADD_FILTERS',
        newFilters: filters,
        sortFunction: sortFunction
    });
const $5fb8761f8962dfc8$export$3be5fe9f09d6965 = (id)=>({
        type: 'REMOVE_FILTER',
        id: id
    });
const $5fb8761f8962dfc8$export$4dce09b3092bd5e8 = (newFilters)=>({
        type: 'REPLACE_ALL_FILTERS',
        newFilters: newFilters
    });
const $5fb8761f8962dfc8$export$e4269d58720a0c2c = (filterId, isChecked, isVisible)=>({
        type: 'UPDATE_FILTER_STATE',
        filterId: filterId,
        isChecked: isChecked,
        isVisible: isVisible
    });
const $5fb8761f8962dfc8$export$234bf2a76076d85a = (newFilters)=>({
        type: 'REPLACE_ALL_FILTERS_AND_MAINTAIN_CHECKED',
        newFilters: newFilters
    });
function $5fb8761f8962dfc8$var$reducer(state, action) {
    switch(action.type){
        case 'ADD_FILTERS':
            {
                if (action.newFilters.length === 0) return state;
                let newState = [
                    ...state
                ];
                action.newFilters.forEach((f)=>{
                    const index = state.findIndex((filter)=>filter.id === f.id);
                    if (index === -1) newState.push(f);
                    else {
                        newState[index] = f;
                        return newState;
                    }
                });
                action.sortFunction && newState.sort(action.sortFunction);
                return newState;
            }
        case 'UPDATE_FILTER_STATE':
            {
                const index = state.findIndex((filter)=>filter.id === action.filterId);
                if (index === -1) return state;
                const newState = [
                    ...state
                ];
                newState[index] = {
                    ...newState[index],
                    isChecked: action.isChecked,
                    isVisible: action.isVisible === undefined || action.isVisible === null ? newState[index].isVisible : action.isVisible
                };
                return newState;
            }
        case 'REMOVE_FILTER':
            return [
                ...state.filter((filter)=>filter.id !== action.id)
            ];
        case 'REPLACE_ALL_FILTERS':
            return [
                ...action.newFilters
            ];
        case 'REPLACE_ALL_FILTERS_AND_MAINTAIN_CHECKED':
            {
                const newState = action.newFilters.map((newFilter)=>{
                    const existingFilter = state.find((f)=>f.id === newFilter.id);
                    if (existingFilter && newFilter.isVisible) newFilter.isChecked = existingFilter.isChecked;
                    return newFilter;
                });
                return newState;
            }
        default:
            // exhaustive check
            const _ = action;
            throw new Error(_);
    }
}
const $5fb8761f8962dfc8$export$3274cf84b703fff = (initialValues)=>{
    const [state, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useReducer($5fb8761f8962dfc8$var$reducer, initialValues ? initialValues : []);
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>({
            filters: state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
    return value;
};

});


parcelRegister("gHaio", function(module, exports) {

$parcel$export(module.exports, "ExtensibleConfluenceTab", () => $1f7f0d09c2b7d826$export$9afff4557e36fda3);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $dh538 = parcelRequire("dh538");

var $bF0iL = parcelRequire("bF0iL");

var $a5cba = parcelRequire("a5cba");
var $fJRVo = parcelRequire("fJRVo");

var $5CiaV = parcelRequire("5CiaV");

var $jqR6C = parcelRequire("jqR6C");

var $isK0H = parcelRequire("isK0H");

var $g1L2n = parcelRequire("g1L2n");

var $kzbg7 = parcelRequire("kzbg7");
var $cgH2x = parcelRequire("cgH2x");

var $169DF = parcelRequire("169DF");

var $6dP89 = parcelRequire("6dP89");

var $5dFS9 = parcelRequire("5dFS9");

var $jFPud = parcelRequire("jFPud");

var $lF5IG = parcelRequire("lF5IG");

var $9tC50 = parcelRequire("9tC50");

var $3Oj4P = parcelRequire("3Oj4P");

var $hUj82 = parcelRequire("hUj82");

var $bq0QQ = parcelRequire("bq0QQ");

var $lLhXY = parcelRequire("lLhXY");

var $fXZrW = parcelRequire("fXZrW");

var $gF7Az = parcelRequire("gF7Az");

var $2ZIpG = parcelRequire("2ZIpG");

var $80L9g = parcelRequire("80L9g");

var $bK7ak = parcelRequire("bK7ak");

var $1YBC8 = parcelRequire("1YBC8");
var $3Z7LN = parcelRequire("3Z7LN");

var $iEwUU = parcelRequire("iEwUU");

var $kmpep = parcelRequire("kmpep");

var $eztGN = parcelRequire("eztGN");

const $1f7f0d09c2b7d826$var$InteractiveSearchAIOnboardingBanner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("ex79W")).then(({ InteractiveSearchAIOnboardingBanner: InteractiveSearchAIOnboardingBanner })=>({
            default: InteractiveSearchAIOnboardingBanner
        })));
const $1f7f0d09c2b7d826$export$9afff4557e36fda3 = ({ recentClientConfig: recentClientConfig, searchClientConfig: searchClientConfig, aiSearchConfig: aiSearchConfig, formatDate: formatDate, children: children, autocorrectEnabled: autocorrectEnabled, additionalContentTypesEnabled: additionalContentTypesEnabled = false, rendererOverride: rendererOverride, aiAdminNotificationHeader: aiAdminNotificationHeader, confluenceReactivationExperiment: confluenceReactivationExperiment, confluenceAvailabilityExperiment: confluenceAvailabilityExperiment, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const { setQuery: setQuery } = (0, $2ZIpG.useQuery)();
    const { toggleShowSearchAIDialog: toggleShowSearchAIDialog } = (0, $80L9g.useSessionUserInput)();
    const { confluenceSites: confluenceSites } = (0, $lF5IG.useSearchConfigContext)();
    const { defineFilters: defineFilters } = (0, $cgH2x.useGenericFilters)();
    const { isUserAnonymous: isUserAnonymous } = recentClientConfig;
    const { searchClient: searchClient } = (0, $g1L2n.useRecentsClient)(recentClientConfig);
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const appendAnalyticsQueryParams = (0, $bK7ak.useQueryParams)();
    const { getActiveProduct: getActiveProduct, getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const [hasFiredVisitedEvent, setHasFiredVisitedEvent] = (0, $gwFzn.useState)(false);
    const isEnhancedSearchAnalyticsEnabled = (0, $dh538.fg)('cc_page_experiences_enhanced_search_analytics_conf');
    const appendQueryParams = isEnhancedSearchAnalyticsEnabled ? appendAnalyticsQueryParams : undefined;
    const siteFilterDefinition = (0, $cgH2x.useSiteFilterDefinition)(rest.workspaces || [], (0, $jqR6C.CONFLUENCE_PRODUCT_ID));
    const { confluenceTabDateFilter: confluenceTabDateFilter, appliedDateFilter: appliedDateFilter } = (0, $fXZrW.useConfluenceDateFilter)();
    const spaceFilterStore = (0, $kzbg7.useFilterStore)([], (0, $jqR6C.CONFLUENCE_PRODUCT_ID), (0, $jqR6C.ConfluenceFilters).Space);
    const peopleFilterStore = (0, $kzbg7.useFilterStore)([], (0, $jqR6C.CONFLUENCE_PRODUCT_ID), (0, $jqR6C.ConfluenceFilters).People);
    const { preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier } = (0, $lLhXY.useConfluenceSuppliers)({
        recentClientConfig: recentClientConfig,
        searchClientConfig: searchClientConfig,
        autocorrectEnabled: autocorrectEnabled,
        spaceFilterStore: spaceFilterStore,
        peopleFilterStore: peopleFilterStore,
        isExpanded: isExpanded,
        isUserAnonymous: isUserAnonymous,
        formatDate: formatDate,
        rendererOverride: rendererOverride,
        additionalContentTypesEnabled: additionalContentTypesEnabled
    });
    const sections = (0, $bq0QQ.useConfluenceSections)({
        formatDate: formatDate,
        autocorrectEnabled: autocorrectEnabled,
        additionalContentTypesEnabled: additionalContentTypesEnabled,
        rendererOverride: rendererOverride
    });
    const itemSuppliers = (0, $5CiaV.useDefaultSuppliers)((0, $jqR6C.CONFLUENCE_PRODUCT_ID), sections, {
        preQueryItemSupplier: rest.preQueryItemSupplier || preQueryItemSupplier,
        postQueryItemSupplier: rest.postQueryItemSupplier || postQueryItemSupplier
    });
    const confluenceAdvancedSearchUrlFactory = (0, $isK0H.useConfluenceAdvancedSearchUrlFactory)(recentClientConfig.url, {
        spaceFilters: spaceFilterStore.availableFilters.filter((f)=>f.isChecked).map((f)=>f.spaceKey || ''),
        peopleFilters: peopleFilterStore.availableFilters.filter((f)=>f.isChecked).map((f)=>f.id),
        dateFilter: !!appliedDateFilter ? [
            appliedDateFilter
        ] : []
    });
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const primaryProduct = getPrimaryProduct();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $gwFzn.useCallback)((query, baseUrl, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $3Z7LN.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return confluenceAdvancedSearchUrlFactory(query, baseUrl);
    }, [
        confluenceAdvancedSearchUrlFactory,
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    const recentSectionTitleGenerator = (0, $gwFzn.useCallback)((section)=>{
        return section.title;
    }, []);
    const loadSpaceFilters = (0, $gwFzn.useCallback)((query)=>{
        return isUserAnonymous || !searchClient ? Promise.resolve([]) : searchClient.search({
            query: query,
            context: {
                sessionId: '',
                referrerId: null
            },
            scopes: [
                (0, $jqR6C.ConfluenceScope).Space
            ],
            modelParams: [],
            resultLimit: (0, $jqR6C.SPACE_FILTER_LIMIT),
            experience: (0, $jqR6C.NAVIGATION_V3_EXPERIENCE),
            sites: []
        }).then(({ response: response })=>{
            const results = response.retrieveScope((0, $jqR6C.ConfluenceScope).Space)?.results;
            return results?.map((result)=>({
                    value: {
                        id: result.id,
                        spaceKey: result.space?.key || '',
                        avatarUrl: `${result.baseUrl}${result.space.icon.path}`,
                        label: result.title,
                        filterSource: (0, $169DF.FilterOptionSource).SEARCH,
                        isChecked: false,
                        isVisible: true
                    },
                    label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hUj82.FilterOptionItem), {
                        label: result.title,
                        iconProps: {
                            src: `${result.baseUrl}${result.space.icon.path}`,
                            appearance: 'square'
                        }
                    })
                })) || [];
        });
    }, [
        searchClient,
        isUserAnonymous
    ]);
    const loadPeopleFilters = (0, $gwFzn.useCallback)((query)=>{
        return isUserAnonymous || !searchClient ? Promise.resolve([]) : searchClient.search({
            query: query,
            context: {
                sessionId: '',
                referrerId: null
            },
            scopes: [
                (0, $jqR6C.ConfluenceScope).People
            ],
            modelParams: [],
            resultLimit: (0, $jqR6C.PEOPLE_FILTER_LIMIT),
            experience: (0, $jqR6C.NAVIGATION_V3_EXPERIENCE),
            sites: []
        }).then(({ response: response })=>{
            const results = response.retrieveScope((0, $jqR6C.ConfluenceScope).People)?.results;
            return results?.map((result)=>({
                    value: {
                        id: result.id,
                        avatarUrl: result.avatarUrl,
                        label: result.name,
                        filterSource: (0, $169DF.FilterOptionSource).SEARCH,
                        isChecked: false,
                        isVisible: true
                    },
                    label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hUj82.FilterOptionItem), {
                        label: result.name,
                        iconProps: {
                            src: result.avatarUrl
                        }
                    })
                })) || [];
        });
    }, [
        searchClient,
        isUserAnonymous
    ]);
    const confluenceTabGenericFilters = (0, $gwFzn.useMemo)(()=>{
        return [
            {
                ['@type']: (0, $jqR6C.ConfluenceFilters).Space,
                fieldName: 'spaceKeys',
                store: spaceFilterStore,
                loadFilterOptions: loadSpaceFilters,
                sectionLabel: formatMessage((0, $bF0iL.messages).space_filters_title),
                findMoreLabel: formatMessage((0, $bF0iL.messages).space_filters_find_more)
            },
            {
                ['@type']: (0, $jqR6C.ConfluenceFilters).People,
                fieldName: 'accountIds',
                store: peopleFilterStore,
                loadFilterOptions: loadPeopleFilters,
                sectionLabel: formatMessage((0, $bF0iL.messages).contributor_filters_title),
                findMoreLabel: formatMessage((0, $bF0iL.messages).contributor_filters_find_more),
                filterConfig: {
                    filterOptionIconShape: 'circle'
                }
            }
        ];
    }, [
        formatMessage,
        loadPeopleFilters,
        loadSpaceFilters,
        peopleFilterStore,
        spaceFilterStore
    ]);
    const filtersToDefine = (0, $gwFzn.useMemo)(()=>{
        return [
            ...confluenceTabDateFilter,
            ...siteFilterDefinition,
            ...confluenceTabGenericFilters
        ];
    }, [
        confluenceTabGenericFilters,
        confluenceTabDateFilter,
        siteFilterDefinition
    ]);
    const onPrequeryBannerRender = (0, $gwFzn.useCallback)(()=>{
        fireAnalyticsEvent((0, $5dFS9.onPrequeryBannerShown)());
    }, [
        fireAnalyticsEvent
    ]);
    const onPromptSuggestionClick = (0, $gwFzn.useCallback)((prompt, promptId)=>{
        fireAnalyticsEvent((0, $5dFS9.onSuggestedPromptClick)(promptId));
        setQuery(prompt);
        toggleShowSearchAIDialog(true);
    }, [
        fireAnalyticsEvent,
        setQuery,
        toggleShowSearchAIDialog
    ]);
    const dismissOnboardingBanner = (0, $gwFzn.useCallback)(()=>{
        if (aiSearchConfig?.dismissPrequeryBanner) {
            fireAnalyticsEvent((0, $5dFS9.onPrequeryBannerDismiss)());
            aiSearchConfig.dismissPrequeryBanner();
        }
    }, [
        aiSearchConfig,
        fireAnalyticsEvent
    ]);
    const initializeFilters = (0, $gwFzn.useCallback)(()=>{
        defineFilters((0, $jqR6C.CONFLUENCE_PRODUCT_ID), filtersToDefine);
    }, [
        defineFilters,
        filtersToDefine
    ]);
    initializeFilters();
    const { isEligibleInactiveUser: isEligibleInactiveUser, isEligibleNewUser: isEligibleNewUser, nudgeShown: isNudgeShown, setAllowConfluenceAccessCache: setAllowConfluenceAccessCache } = confluenceReactivationExperiment ?? {
        isEligibleUser: false,
        isEligibleNewUser: false,
        nudgeShown: false
    };
    const confluenceReactivationExperimentTabRenderer = (0, $gwFzn.useCallback)(({ title: title })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Oj4P.ConfluenceReactivationExperimentTab), {
            title: title,
            isEligibleInactiveUser: isEligibleInactiveUser,
            isEligibleNewUser: isEligibleNewUser,
            isNudgeShown: isNudgeShown
        }), [
        isEligibleInactiveUser,
        isEligibleNewUser,
        isNudgeShown
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!isNudgeShown && getActiveProduct()?.id === (0, $jqR6C.CONFLUENCE_PRODUCT_ID) && !hasFiredVisitedEvent) {
            // https://data-portal.internal.atlassian.com/analytics/registry/76739
            fireAnalyticsEvent({
                action: 'opened',
                actionSubject: 'panel',
                actionSubjectId: 'crossProductSearchPanel',
                source: 'searchDialog',
                eventType: 'ui',
                attributes: {
                    activeProduct: (0, $jqR6C.CONFLUENCE_PRODUCT_ID),
                    reactivationNudgeShown: true
                }
            });
            setHasFiredVisitedEvent(true);
        }
    }, [
        fireAnalyticsEvent,
        getActiveProduct,
        hasFiredVisitedEvent,
        setHasFiredVisitedEvent,
        isNudgeShown
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5cba.SearchDialogProduct), {
        id: (0, $jqR6C.CONFLUENCE_PRODUCT_ID),
        expandedStateInputPlaceholder: !!aiSearchConfig ? formatMessage((0, $bF0iL.messages).confluence_search_input_expanded_placeholder_ai) : formatMessage((0, $bF0iL.messages).confluence_search_input_expanded_placeholder),
        title: formatMessage((0, $bF0iL.messages).confluence_tab_label),
        tabRenderer: confluenceReactivationExperimentTabRenderer,
        autocorrectEnabled: autocorrectEnabled,
        sections: sections,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        preQuerySectionTitleGenerator: recentSectionTitleGenerator,
        showViewAllFiltersLink: true,
        ...rest,
        ...itemSuppliers,
        aiSearchConfig: aiSearchConfig,
        permissionSupplier: confluenceSites.length > 0 ? (0, $9tC50.defaultPermissionsSupplier) : rest.permissionSupplier,
        appendQueryParams: appendQueryParams,
        children: ({ productState: productState, ...props })=>{
            const Footer = showAtlassianHomeSearchLink && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1YBC8.ExtensibleConfluenceTabFooter), {
                orgId: orgId,
                cloudId: cloudId,
                ...props
            });
            if (productState === (0, $jFPud.ProductStates).PreQuerySuccess) {
                setAllowConfluenceAccessCache?.();
                if (!!aiAdminNotificationHeader) return {
                    Header: aiAdminNotificationHeader,
                    Footer: Footer
                };
                if (!!aiSearchConfig && aiSearchConfig.prequeryBannerEnabled) return {
                    Header: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($1f7f0d09c2b7d826$var$InteractiveSearchAIOnboardingBanner, {
                            onPromptSuggestionClick: onPromptSuggestionClick,
                            onXButtonClick: dismissOnboardingBanner,
                            onBannerShown: onPrequeryBannerRender
                        }),
                    Footer: Footer
                };
            }
            return {
                Footer: Footer
            };
        }
    });
};

});
parcelRegister("jqR6C", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_PRODUCT_ID", () => $36c76e3adf761bae$export$661dd16d63ed8290);
$parcel$export(module.exports, "NAVIGATION_V3_EXPERIENCE", () => $36c76e3adf761bae$export$4a204ebf24901f2e);
$parcel$export(module.exports, "SPACE_FILTER_LIMIT", () => $36c76e3adf761bae$export$10d5a4cb19960c6c);
$parcel$export(module.exports, "PEOPLE_FILTER_LIMIT", () => $36c76e3adf761bae$export$b41e7ecd9ba9baff);
$parcel$export(module.exports, "ConfluenceFilters", () => $36c76e3adf761bae$export$cf834bb06694a4e);
$parcel$export(module.exports, "ConfluenceScope", () => $36c76e3adf761bae$export$bb0f876d33576f3f);
const $36c76e3adf761bae$export$661dd16d63ed8290 = 'confluence';
const $36c76e3adf761bae$export$4a204ebf24901f2e = 'confluence.nav-v3';
const $36c76e3adf761bae$export$d4cf0635e2303166 = 250;
const $36c76e3adf761bae$export$10d5a4cb19960c6c = 10;
const $36c76e3adf761bae$export$b41e7ecd9ba9baff = 10;
var $36c76e3adf761bae$export$cf834bb06694a4e = /*#__PURE__*/ function(ConfluenceFilters) {
    ConfluenceFilters["Space"] = "spaces";
    ConfluenceFilters["People"] = "contributors";
    ConfluenceFilters["Date"] = "lastModified";
    return ConfluenceFilters;
}({});
var $36c76e3adf761bae$export$bb0f876d33576f3f = /*#__PURE__*/ function(ConfluenceScope) {
    ConfluenceScope["Item"] = "confluence.page,blogpost,attachment";
    ConfluenceScope["Space"] = "confluence.space";
    ConfluenceScope["People"] = "urs.user-confluence";
    ConfluenceScope["Content"] = "confluence.page,blogpost,attachment,whiteboard";
    return ConfluenceScope;
}({});

});

parcelRegister("isK0H", function(module, exports) {

$parcel$export(module.exports, "useConfluenceAdvancedSearchUrlFactory", () => $533b56e765b3323a$export$e189237de9f436c5);
$parcel$export(module.exports, "defaultFormatDate", () => $533b56e765b3323a$export$579a505f09fc5afa);

var $gwFzn = parcelRequire("gwFzn");
const $533b56e765b3323a$var$CONFLUENCE_ADVANCED_SEARCH_URL = '/wiki/search';
const $533b56e765b3323a$var$removeDuplicateWikiInUrl = (siteUrl)=>{
    return siteUrl.replace(/\/wiki(\/)?$/, '');
};
function $533b56e765b3323a$export$e189237de9f436c5(siteUrl, filters) {
    const trimmedSiteUrl = $533b56e765b3323a$var$removeDuplicateWikiInUrl(siteUrl);
    const spaceFilterString = filters.spaceFilters.length > 0 ? `&spaces=${encodeURIComponent(filters.spaceFilters.join(','))}` : '';
    const peopleFilterString = filters.peopleFilters.length > 0 ? `&contributors=${encodeURIComponent(filters.peopleFilters.join(','))}` : '';
    const dateFilterString = filters.dateFilter.length > 0 ? `&lastModified=${filters.dateFilter[0]}` : '';
    return (0, $gwFzn.useCallback)((query, siteUrl)=>{
        const url = siteUrl ? $533b56e765b3323a$var$removeDuplicateWikiInUrl(siteUrl) : trimmedSiteUrl;
        const trimmedQuery = query.trim();
        if (!trimmedQuery) return `${url}${$533b56e765b3323a$var$CONFLUENCE_ADVANCED_SEARCH_URL}`;
        return `${url}${$533b56e765b3323a$var$CONFLUENCE_ADVANCED_SEARCH_URL}?text=${encodeURIComponent(trimmedQuery)}${spaceFilterString}${peopleFilterString}${dateFilterString}`;
    }, [
        trimmedSiteUrl,
        spaceFilterString,
        peopleFilterString,
        dateFilterString
    ]);
}
const $533b56e765b3323a$export$579a505f09fc5afa = (lastModified)=>{
    const date = new Date(lastModified);
    return date.toLocaleString();
};

});

parcelRegister("g1L2n", function(module, exports) {

$parcel$export(module.exports, "useRecentsClient", () => $19ff8c138fce7df4$export$2ac7f7e39d1eda48);

var $gwFzn = parcelRequire("gwFzn");

var $jV49M = parcelRequire("jV49M");

var $csnse = parcelRequire("csnse");

var $aAuSn = parcelRequire("aAuSn");

var $dwp40 = parcelRequire("dwp40");

var $jqR6C = parcelRequire("jqR6C");

var $jXnBe = parcelRequire("jXnBe");

var $cfEFl = parcelRequire("cfEFl");
var $c3kEC = parcelRequire("c3kEC");
var $9Nzn7 = parcelRequire("9Nzn7");

var $1TPG8 = parcelRequire("1TPG8");

var $kmpep = parcelRequire("kmpep");

var $kfImN = parcelRequire("kfImN");

var $3NyIw = parcelRequire("3NyIw");
const $19ff8c138fce7df4$var$NAVIGATION_V3_EXPERIENCE = 'confluence.nav-v3';
const $19ff8c138fce7df4$var$RECENT_PAGES_PATH = 'rest/recentlyviewed/1.0/recent';
const $19ff8c138fce7df4$var$RECENT_SPACE_PATH = 'rest/recentlyviewed/1.0/recent/spaces';
const $19ff8c138fce7df4$var$DEFAULT_COLLAB_GRAPH_URL = 'gateway/api/collaboration';
const $19ff8c138fce7df4$var$ACTIVITY_CLIENT_RETRY_MS = 250;
const $19ff8c138fce7df4$var$RECENT_PAGES_LIMIT = 200;
const $19ff8c138fce7df4$var$RECENT_SPACE_LIMIT = 10;
const $19ff8c138fce7df4$var$RECENT_PEOPLE_LIMIT = 10;
function $19ff8c138fce7df4$var$recentWorkItemToResult(recentItem) {
    const { object: object, containers: containers } = recentItem;
    return {
        resultId: object.id,
        containerName: containers[0].name,
        containerId: '',
        resultType: (0, $jXnBe.ConfluenceObjectResult),
        isRecentResult: true,
        name: object.name || '',
        // Failsafe. All items should have a name.
        href: object.url,
        contentType: `confluence-${object.type}`,
        lastModified: undefined,
        // not available
        analyticsType: (0, $jXnBe.RecentConfluence)
    };
}
function $19ff8c138fce7df4$var$recentPageToResult(recentPage, baseUrl) {
    return {
        resultId: String(recentPage.id),
        name: recentPage.title || '',
        // This is a failsafe, there should be a filter to drop pages with no titles
        href: `${baseUrl}${recentPage.url}`,
        containerName: recentPage.space,
        analyticsType: (0, $jXnBe.RecentConfluence),
        resultType: (0, $jXnBe.ConfluenceObjectResult),
        contentType: `confluence-${recentPage.contentType}`,
        iconClass: recentPage.iconClass,
        containerId: recentPage.spaceId.toString(),
        isRecentResult: true,
        lastModified: undefined,
        // not available for recent results
        spaceId: recentPage.spaceId?.toString()
    };
}
function $19ff8c138fce7df4$var$mapCollabGraphContainer(response) {
    const items = response.collaborationGraphEntities.map((item)=>({
            id: item.containerDetails?.id,
            key: item.containerDetails?.key,
            icon: item.containerDetails?.iconUrl,
            name: item.containerDetails?.name,
            url: item.containerDetails?.url
        })).filter((space)=>space.id !== undefined).map((space)=>$19ff8c138fce7df4$var$recentSpaceToResult(space, space.url));
    return {
        items: items,
        timings: response.timings
    };
}
function $19ff8c138fce7df4$var$recentSpaceToResult(recentSpace, href) {
    return {
        resultId: recentSpace.id,
        name: recentSpace.name,
        key: recentSpace.key,
        href: href,
        avatarUrl: recentSpace.icon,
        analyticsType: (0, $jXnBe.RecentConfluence),
        resultType: (0, $jXnBe.GenericContainerResult),
        contentType: (0, $jXnBe.ConfluenceSpace),
        id: recentSpace.id
    };
}
function $19ff8c138fce7df4$var$mapUrsPeople(response, timings, isMultiSite) {
    if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, $jXnBe.Scope).UserConfluence}`);
    if (response.error) throw (0, $c3kEC.responseErrorToError)(response.error);
    const items = response.results.map((item)=>({
            resultType: (0, $jXnBe.PersonResult),
            resultId: `people-${item.id}`,
            userId: item.id,
            name: item.name,
            href: (0, $kfImN.generatePeopleProfileUrl)(isMultiSite, item.absoluteUrl, item.id),
            avatarUrl: item.avatarUrl,
            contentType: (0, $jXnBe.Person),
            analyticsType: (0, $jXnBe.ResultPerson),
            mentionName: item.nickname || '',
            presenceMessage: ''
        }));
    return {
        items: (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))(items, (item)=>item.resultId),
        timings: timings
    };
}

class $19ff8c138fce7df4$var$RecentsCache {
    constructor(props){
        this.recentCacheProps = void 0;
        this.recentItemCache = void 0;
        this.recentSpaceCache = void 0;
        this.recentPeopleCache = void 0;
        this.recentItemSupplier = async ()=>{
            if (!!this.recentCacheProps.recentWorkAPIUrl) try {
                const { createActivityClient: createActivityClient } = await (parcelRequire("lVwKT"));
                const activityClient = createActivityClient('v3', 'confluence', undefined, this.recentCacheProps.recentWorkAPIUrl);
                const { viewed: viewed } = await activityClient.fetchActivities([
                    $19ff8c138fce7df4$var$ACTIVITY_CLIENT_RETRY_MS
                ], {
                    products: [
                        'confluence'
                    ]
                }, [
                    'viewed'
                ]);
                const items = viewed.filter((item)=>item.object.product === 'confluence').map((item)=>$19ff8c138fce7df4$var$recentWorkItemToResult(item));
                return {
                    items: items,
                    totalSize: items.length,
                    timings: 0
                };
            } catch (e) {
                return {
                    items: [],
                    totalSize: 0,
                    timings: -1
                };
            }
            else try {
                const { result: result, durationMs: durationMs } = await (0, $9Nzn7.timed)((0, $dwp40.utils).requestService({
                    url: this.recentCacheProps.url
                }, {
                    path: $19ff8c138fce7df4$var$RECENT_PAGES_PATH,
                    queryParams: {
                        limit: $19ff8c138fce7df4$var$RECENT_PAGES_LIMIT
                    }
                }));
                const items = result.filter((page)=>!!page.title).map((recentPage)=>$19ff8c138fce7df4$var$recentPageToResult(recentPage, this.recentCacheProps.url));
                return {
                    items: items,
                    totalSize: items.length,
                    timings: durationMs
                };
            } catch (e) {
                return {
                    items: [],
                    totalSize: 0,
                    timings: -1
                };
            }
        };
        this.recentSpaceSupplier = async ()=>{
            if (this.recentCacheProps.isUserAnonymous) return Promise.resolve({
                items: [],
                timings: 0
            });
            if (this.recentCacheProps.isCollaborationGraphEnabled) return this.recentCacheProps.getCollabGraphContainers();
            else try {
                const { result: result, durationMs: durationMs } = await (0, $9Nzn7.timed)((0, $dwp40.utils).requestService({
                    url: this.recentCacheProps.url
                }, {
                    path: $19ff8c138fce7df4$var$RECENT_SPACE_PATH,
                    queryParams: {
                        limit: $19ff8c138fce7df4$var$RECENT_SPACE_LIMIT
                    }
                }));
                return {
                    items: result.map((recentSpace)=>$19ff8c138fce7df4$var$recentSpaceToResult(recentSpace, `${this.recentCacheProps.url}/spaces/${recentSpace.key}`)),
                    timings: durationMs
                };
            } catch (e) {
                return {
                    items: [],
                    timings: -1
                };
            }
        };
        this.recentPeopleSupplier = async ()=>{
            if (this.recentCacheProps.isUserAnonymous || !this.recentCacheProps.aggregatorClient) return Promise.resolve({
                items: [],
                timings: 0
            });
            return this.recentCacheProps.aggregatorClient.search({
                query: '',
                context: {
                    sessionId: '',
                    referrerId: null
                },
                scopes: [
                    (0, $jqR6C.ConfluenceScope).People
                ],
                modelParams: [],
                resultLimit: $19ff8c138fce7df4$var$RECENT_PEOPLE_LIMIT,
                experience: $19ff8c138fce7df4$var$NAVIGATION_V3_EXPERIENCE,
                sites: this.recentCacheProps.sites?.map((s)=>s.cloudId)
            }).then(({ response: response, requestDurationMs: requestDurationMs })=>$19ff8c138fce7df4$var$mapUrsPeople(response.retrieveScope((0, $jqR6C.ConfluenceScope).People), requestDurationMs, (this.recentCacheProps.sites || []).length > 0)).catch((e)=>({
                    items: [],
                    timings: -1
                }));
        };
        this.recentCacheProps = props;
        this.recentItemCache = new (0, $3NyIw.SimpleCache)(this.recentItemSupplier);
        this.recentSpaceCache = new (0, $3NyIw.SimpleCache)(this.recentSpaceSupplier);
        this.recentPeopleCache = new (0, $3NyIw.SimpleCache)(this.recentPeopleSupplier);
    }
}
const $19ff8c138fce7df4$var$getRecentsCache = (0, $csnse.default)((recentsCacheProps)=>new $19ff8c138fce7df4$var$RecentsCache(recentsCacheProps), (0, (/*@__PURE__*/$parcel$interopDefault($aAuSn))));
const $19ff8c138fce7df4$var$getCollabGraphClientWithConfig = (0, $csnse.default)((config)=>new (0, $cfEFl.CollaborationGraphClient)(config), (0, (/*@__PURE__*/$parcel$interopDefault($aAuSn))));
const $19ff8c138fce7df4$export$2ac7f7e39d1eda48 = (props)=>{
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const collabGraphClient = $19ff8c138fce7df4$var$getCollabGraphClientWithConfig({
        collaborationGraphUrl: props.collaborationGraphUrl || $19ff8c138fce7df4$var$DEFAULT_COLLAB_GRAPH_URL,
        cloudId: props.cloudId,
        isMultiSite: (props.sites || []).length > 1,
        sites: props.sites || [],
        collabGraphSessionId: props.collabGraphSessionId
    });
    const { isUserAnonymous: isUserAnonymous } = props;
    const getCollabGraphContainers = (0, $gwFzn.useCallback)(async ()=>{
        return isUserAnonymous ? Promise.resolve({
            items: [],
            timings: 0
        }) : collabGraphClient.getContainers([
            (0, $1TPG8.SpaceContainerType)
        ]).then((response)=>$19ff8c138fce7df4$var$mapCollabGraphContainer(response)).catch((e)=>({
                items: [],
                timings: -1
            }));
    }, [
        collabGraphClient,
        isUserAnonymous
    ]);
    const recentsCache = $19ff8c138fce7df4$var$getRecentsCache({
        ...props,
        aggregatorClient: aggregatorClient,
        getCollabGraphContainers: getCollabGraphContainers
    });
    const getRecentItems = (0, $gwFzn.useCallback)(()=>{
        return recentsCache.recentItemCache.get().value;
    }, [
        recentsCache
    ]);
    const getRecentSpaces = (0, $gwFzn.useCallback)(()=>{
        return recentsCache.recentSpaceCache.get().value;
    }, [
        recentsCache
    ]);
    const getRecentPeople = (0, $gwFzn.useCallback)(()=>{
        return recentsCache.recentPeopleCache.get().value;
    }, [
        recentsCache
    ]);
    return {
        getRecentItems: getRecentItems,
        getRecentSpaces: getRecentSpaces,
        getRecentPeople: getRecentPeople,
        getCollabGraphContainers: getCollabGraphContainers,
        searchClient: aggregatorClient,
        collabGraphClient: collabGraphClient
    };
};

});

parcelRegister("kzbg7", function(module, exports) {

$parcel$export(module.exports, "useFilterStore", () => $8488ca61c8c92e6d$export$875b296eac126ec2);

var $gwFzn = parcelRequire("gwFzn");

var $169DF = parcelRequire("169DF");

var $jnLgC = parcelRequire("jnLgC");

var $80L9g = parcelRequire("80L9g");
const $8488ca61c8c92e6d$export$875b296eac126ec2 = (defaultFilters = [], productId, filterType)=>{
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(undefined);
    const { stickySearchEnabled: stickySearchEnabled, readFilters: readFilters, storeFilters: storeFilters } = (0, $80L9g.useSessionUserInput)();
    const storedFilters = readFilters(productId) ? readFilters(productId)[filterType] : [];
    const defaultFiltersRef = (0, $gwFzn.useRef)(stickySearchEnabled && storedFilters && storedFilters.length > 0 ? storedFilters : defaultFilters);
    const { filters: filters, dispatch: dispatch } = (0, $jnLgC.useFilter)(defaultFiltersRef.current);
    const addFilters = (0, $gwFzn.useCallback)((newFilters)=>dispatch((0, $jnLgC.addFilters)(newFilters, (a, b)=>{
            if (a.filterSource === (0, $169DF.FilterOptionSource).CURRENT_USER && b.filterSource !== (0, $169DF.FilterOptionSource).CURRENT_USER) return -1;
            if (a.filterSource !== (0, $169DF.FilterOptionSource).CURRENT_USER && b.filterSource === (0, $169DF.FilterOptionSource).CURRENT_USER) return 1;
            return 0;
        })), [
        dispatch
    ]);
    const loadDefaultFilters = (load)=>{
        setIsLoading(true);
        load.then((result)=>setDefaultFilters(result)).finally(()=>setIsLoading(false));
    };
    const updateFilter = (0, $gwFzn.useCallback)((id, isChecked, isVisible = true)=>dispatch((0, $jnLgC.updateFilterState)(id, isChecked, isVisible)), [
        dispatch
    ]);
    const updateSingleValueFilter = (0, $gwFzn.useCallback)((id)=>{
        filters.forEach((f)=>dispatch((0, $jnLgC.updateFilterState)(f.id, f.id === id)));
    }, [
        filters,
        dispatch
    ]);
    const clearFilter = (0, $gwFzn.useCallback)(()=>{
        filters.forEach((f)=>dispatch((0, $jnLgC.updateFilterState)(f.id, false)));
    }, [
        filters,
        dispatch
    ]);
    const resetFilter = (0, $gwFzn.useCallback)(()=>{
        dispatch((0, $jnLgC.replaceAllFilters)(defaultFilters.length ? defaultFilters : defaultFiltersRef.current));
    }, [
        defaultFilters,
        dispatch
    ]);
    const setDefaultFilters = (0, $gwFzn.useCallback)((filters)=>{
        defaultFiltersRef.current = filters;
        resetFilter();
    }, [
        defaultFiltersRef,
        resetFilter
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (stickySearchEnabled) {
            const stickyFilter = readFilters(productId);
            stickyFilter[filterType] = filters;
            storeFilters(productId, stickyFilter);
        }
    }, [
        stickySearchEnabled,
        readFilters,
        storeFilters,
        productId,
        filterType,
        filters
    ]);
    return {
        availableFilters: filters,
        isLoading: isLoading && defaultFilters.length === 0,
        loadDefaultFilters: loadDefaultFilters,
        addFilters: addFilters,
        updateFilter: updateFilter,
        updateSingleValueFilter: updateSingleValueFilter,
        clearFilter: clearFilter,
        reset: resetFilter,
        dispatch: dispatch,
        setDefaultFilters: setDefaultFilters
    };
};

});
parcelRegister("169DF", function(module, exports) {

$parcel$export(module.exports, "FilterOptionSource", () => $d4be48b9fe9cdb51$export$a386c4ddeb43c20a);
var $d4be48b9fe9cdb51$export$a386c4ddeb43c20a = /*#__PURE__*/ function(FilterOptionSource) {
    /**
	 * This means the result came from collab graph
	 */ FilterOptionSource["COLLABORATION_GRAPH"] = "COLLABORATION_GRAPH";
    /**
	 * This means the result came from smart user picker
	 */ FilterOptionSource["SMART_USER_PICKER"] = "SMART_USER_PICKER";
    /**
	 * This means the result came from a recents (bootstrap) query
	 */ FilterOptionSource["RECENT"] = "RECENT";
    /**
	 * This means the result came from an explicit search
	 */ FilterOptionSource["SEARCH"] = "SEARCH";
    /**
	 * This means the result is derived from the current user
	 */ FilterOptionSource["CURRENT_USER"] = "CURRENT_USER";
    /**
	 * This means the result came from an external source passed into the component
	 */ FilterOptionSource["EXTERNAL"] = "EXTERNAL";
    /**
	 * This means the result is static without any user-generation
	 */ FilterOptionSource["STATIC"] = "STATIC";
    return FilterOptionSource;
}({});

});


parcelRegister("cgH2x", function(module, exports) {

$parcel$export(module.exports, "FilterContextHOC", () => $e93e47a7b7b4ad5d$export$ceb34aeb37186333);
$parcel$export(module.exports, "useGenericFilters", () => $e93e47a7b7b4ad5d$export$bc4556a4dba20090);
$parcel$export(module.exports, "useSiteFilterDefinition", () => $e93e47a7b7b4ad5d$export$aa277293bef5fdbf);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $gF7Az = parcelRequire("gF7Az");

var $80L9g = parcelRequire("80L9g");

var $169DF = parcelRequire("169DF");

var $kzbg7 = parcelRequire("kzbg7");

var $88j1D = parcelRequire("88j1D");

var $bF0iL = parcelRequire("bF0iL");
const $e93e47a7b7b4ad5d$export$95f4aabc01d7575d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    filterDefinitions: {},
    defineFilters: ()=>{}
});
const $e93e47a7b7b4ad5d$export$ceb34aeb37186333 = ({ children: children })=>{
    const filterDefinitions = (0, $gwFzn.useRef)({}).current;
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { stickySearchEnabled: stickySearchEnabled, resetExtensibleFiltersRef: resetExtensibleFiltersRef } = (0, $80L9g.useSessionUserInput)();
    const previousExpandState = (0, $gwFzn.useRef)(isExpanded);
    const defineFilters = (productId, filters)=>{
        filterDefinitions[productId] = filters;
    };
    const resetFilters = ()=>{
        Object.keys(filterDefinitions).forEach((productId)=>{
            filterDefinitions[productId].forEach((filter)=>{
                filter.store.reset();
            });
        });
    };
    (0, $gwFzn.useEffect)(()=>{
        if (previousExpandState.current && !isExpanded && !stickySearchEnabled) Object.keys(filterDefinitions).forEach((productId)=>{
            filterDefinitions[productId].forEach((filter)=>{
                filter.store.reset();
            });
        });
        previousExpandState.current = isExpanded;
    }, [
        isExpanded,
        stickySearchEnabled
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $gwFzn.useEffect)(()=>{
        if (resetExtensibleFiltersRef) resetExtensibleFiltersRef.current = resetFilters;
    }); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, $7UHDa.jsx)($e93e47a7b7b4ad5d$export$95f4aabc01d7575d.Provider, {
        value: {
            filterDefinitions: filterDefinitions,
            defineFilters: defineFilters
        },
        children: children
    });
};
const $e93e47a7b7b4ad5d$export$bc4556a4dba20090 = ()=>(0, $gwFzn.useContext)($e93e47a7b7b4ad5d$export$95f4aabc01d7575d);
const $e93e47a7b7b4ad5d$export$aa277293bef5fdbf = (workspaces, productId)=>{
    const isMultiWorkspace = workspaces && workspaces.length > 1;
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const siteFilterStore = (0, $kzbg7.useFilterStore)(workspaces?.map((workspace, index)=>({
            label: workspace.name,
            id: workspace.id,
            isChecked: false,
            isVisible: index < 3,
            filterSource: (0, $169DF.FilterOptionSource).EXTERNAL,
            avatarUrl: ''
        })), productId, (0, $88j1D.SITE_FILTER_TYPE_NAME));
    if (isMultiWorkspace) return [
        {
            '@type': (0, $88j1D.SITE_FILTER_TYPE_NAME),
            fieldName: 'values',
            store: siteFilterStore,
            loadFilterOptions: async ()=>[],
            sectionLabel: formatMessage((0, $bF0iL.messages).site_filters_title),
            findMoreLabel: formatMessage((0, $bF0iL.messages).site_filters_find_more)
        }
    ];
    else return [];
};

});

parcelRegister("lF5IG", function(module, exports) {

$parcel$export(module.exports, "useSearchConfigContext", () => $6004f871869f2e35$export$dca16f1ca9af3934);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $USdFJ = parcelRequire("USdFJ");
/**
 * Every product configuration might not choose to have the search config provider.
 * Hence this is explicitly initialised to null.
 */ const $6004f871869f2e35$var$SearchConfigContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    jiraSites: [],
    confluenceSites: [],
    atlasWorkspaces: []
});
const $6004f871869f2e35$export$9ce36a8a6ea7b893 = (props)=>{
    const { children: children, skeleton: SkeletonComponent = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}) } = props;
    const accessibleProducts = (0, $USdFJ.useSearchConfigClient)(props);
    return accessibleProducts == null ? /*#__PURE__*/ (0, $7UHDa.jsx)(SkeletonComponent, {}) : /*#__PURE__*/ (0, $7UHDa.jsx)($6004f871869f2e35$var$SearchConfigContext.Provider, {
        value: accessibleProducts,
        children: children
    });
};
function $6004f871869f2e35$export$dca16f1ca9af3934() {
    return (0, $gwFzn.useContext)($6004f871869f2e35$var$SearchConfigContext);
}

});
parcelRegister("USdFJ", function(module, exports) {

$parcel$export(module.exports, "AGGREGATOR_URL", () => $2b525f3653cbc825$export$55ad0abefe643b5f);
$parcel$export(module.exports, "useSearchConfigClient", () => $2b525f3653cbc825$export$16414e90b8f90666);

var $gwFzn = parcelRequire("gwFzn");

var $dwp40 = parcelRequire("dwp40");

var $5WAaL = parcelRequire("5WAaL");

var $k2JFl = parcelRequire("k2JFl");
var $2b525f3653cbc825$var$ProductsFromARI = /*#__PURE__*/ function(ProductsFromARI) {
    ProductsFromARI["JIRA"] = "jira";
    ProductsFromARI["CONFLUENCE"] = "confluence";
    ProductsFromARI["TOWNSQUARE"] = "townsquare";
    return ProductsFromARI;
}($2b525f3653cbc825$var$ProductsFromARI || {});
const $2b525f3653cbc825$var$CONFIG_API_URL = '/configuration/v1';
const $2b525f3653cbc825$export$55ad0abefe643b5f = '/gateway/api/xpsearch-aggregator';
const $2b525f3653cbc825$var$options = {
    path: $2b525f3653cbc825$var$CONFIG_API_URL,
    requestInit: {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }
};
const $2b525f3653cbc825$var$noAccessState = {
    jiraSites: [],
    confluenceSites: [],
    atlasWorkspaces: []
};
const $2b525f3653cbc825$var$dedupeEntriesById = (arr)=>{
    return arr.filter((initial, index, currentArray)=>currentArray.findIndex((matched)=>matched.id === initial.id) === index);
};
const $2b525f3653cbc825$var$dedupeEntriesByCloudId = (arr)=>{
    return arr.filter((initial, index, currentArray)=>currentArray.findIndex((matched)=>matched.cloudId === initial.cloudId) === index);
};
const $2b525f3653cbc825$export$ba14d9a5a581e827 = (response)=>{
    const groupedProducts = response.resources.reduce((acc, resource)=>{
        const { baseUrl: baseUrl, id: ari, siteName: siteName } = resource;
        const { id: id, product: product } = (0, $5WAaL.parseSiteARI)(ari);
        if (product.includes("jira")) acc.jiraSites && acc.jiraSites.push({
            product: (0, $k2JFl.Products).jira,
            avatarUrl: '',
            cloudId: id,
            siteUrl: baseUrl,
            siteName: siteName
        });
        if (product === "confluence") acc.confluenceSites && acc.confluenceSites.push({
            product: (0, $k2JFl.Products).confluence,
            avatarUrl: '',
            cloudId: id,
            siteUrl: baseUrl,
            siteName: siteName
        });
        if (product === "townsquare") acc.atlasWorkspaces && acc.atlasWorkspaces.push({
            name: siteName,
            id: id,
            baseUrl: baseUrl
        });
        return acc;
    }, $2b525f3653cbc825$var$noAccessState);
    return {
        jiraSites: $2b525f3653cbc825$var$dedupeEntriesByCloudId(groupedProducts.jiraSites),
        confluenceSites: $2b525f3653cbc825$var$dedupeEntriesByCloudId(groupedProducts.confluenceSites),
        atlasWorkspaces: $2b525f3653cbc825$var$dedupeEntriesById(groupedProducts.atlasWorkspaces)
    };
};
const $2b525f3653cbc825$export$16414e90b8f90666 = (props)=>{
    const { aggregatorUrl: aggregatorUrl = `${$2b525f3653cbc825$export$55ad0abefe643b5f}`, skip: skip = false } = props;
    const [accessibleProducts, setAccessibleProducts] = (0, $gwFzn.useState)(null);
    (0, $gwFzn.useEffect)(()=>{
        if (!skip && accessibleProducts === null) (0, $dwp40.utils).requestService({
            url: aggregatorUrl
        }, $2b525f3653cbc825$var$options).then((resp)=>{
            setAccessibleProducts($2b525f3653cbc825$export$ba14d9a5a581e827(resp));
        }).catch((_e)=>{
            setAccessibleProducts($2b525f3653cbc825$var$noAccessState);
        });
    }, [
        accessibleProducts,
        setAccessibleProducts,
        aggregatorUrl,
        skip
    ]);
    return accessibleProducts;
};

});
parcelRegister("5WAaL", function(module, exports) {

$parcel$export(module.exports, "parseSiteARI", () => $900262d035411b0d$export$8837a793ca98a5b5);
const $900262d035411b0d$var$SITE_ARI_REGEX = new RegExp('ari:cloud:(.+)::site/(.+)');
const $900262d035411b0d$export$8837a793ca98a5b5 = (ari)=>{
    if (!ari) return {
        product: '',
        id: ''
    };
    const [_original, product, id] = Array.from(ari.match($900262d035411b0d$var$SITE_ARI_REGEX) || [
        '',
        '',
        ''
    ]);
    return {
        product: product,
        id: id
    };
};

});

parcelRegister("k2JFl", function(module, exports) {

$parcel$export(module.exports, "Products", () => $37ea59e9cc74e158$export$92e44ea1079b9ec6);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
var $37ea59e9cc74e158$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["other"] = "OTHER";
    return Products;
}({});
const $37ea59e9cc74e158$var$primaryProductIndex = 0;
const $37ea59e9cc74e158$var$ProductContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    products: [],
    activeIndex: $37ea59e9cc74e158$var$primaryProductIndex,
    primaryProduct: ''
});
const $37ea59e9cc74e158$export$7d76ff5e8c6ff5f2 = ({ children: children, products: products, activeIndex: activeIndex = 0, primaryProduct: primaryProduct = '' })=>/*#__PURE__*/ (0, $7UHDa.jsx)($37ea59e9cc74e158$var$ProductContext.Provider, {
        value: {
            products: products,
            activeIndex: Math.min(products.length - 1, Math.max(0, activeIndex)),
            primaryProduct: primaryProduct
        },
        children: children
    });
const $37ea59e9cc74e158$export$964e8498268f0fe3 = ()=>(0, $gwFzn.useContext)($37ea59e9cc74e158$var$ProductContext).products;
const $37ea59e9cc74e158$export$92c6f3c7c09f3247 = ()=>{
    const { products: products, primaryProduct: primaryProduct } = (0, $gwFzn.useContext)($37ea59e9cc74e158$var$ProductContext);
    return primaryProduct || products[$37ea59e9cc74e158$var$primaryProductIndex];
};
const $37ea59e9cc74e158$export$1fc003d00f9819a9 = ()=>{
    const context = (0, $gwFzn.useContext)($37ea59e9cc74e158$var$ProductContext);
    return context.products[context.activeIndex];
};

});



parcelRegister("9tC50", function(module, exports) {

$parcel$export(module.exports, "defaultPermissionsSupplier", () => $a2ad679ee4094498$export$79b79eb7219cb5fd);

var $jqR6C = parcelRequire("jqR6C");
const $a2ad679ee4094498$export$79b79eb7219cb5fd = ()=>{
    const response = Object.values((0, $jqR6C.ConfluenceScope));
    return Promise.resolve(response);
};

});

parcelRegister("3Oj4P", function(module, exports) {

$parcel$export(module.exports, "ConfluenceReactivationExperimentTab", () => $089108003db7c5d6$export$33a7dd41d4b97411);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $5nBzc = parcelRequire("5nBzc");

var $6dP89 = parcelRequire("6dP89");

var $5dFS9 = parcelRequire("5dFS9");

var $b9hjy = parcelRequire("b9hjy");

var $bUlM5 = parcelRequire("bUlM5");
const $089108003db7c5d6$var$Tab = ({ intl: intl, title: title, isEligibleInactiveUser: isEligibleInactiveUser, isEligibleNewUser: isEligibleNewUser, isNudgeShown: isNudgeShown })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const displayNudge = !isNudgeShown && (isEligibleInactiveUser || isEligibleNewUser);
    (0, $gwFzn.useEffect)(()=>{
        displayNudge && fireAnalyticsEvent((0, $5dFS9.onConfluenceReactionNudgeShown)(!!isEligibleNewUser));
    }, [
        displayNudge,
        fireAnalyticsEvent,
        isEligibleNewUser
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
        alignItems: "center",
        columnGap: "space.100",
        children: [
            title,
            displayNudge && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5nBzc.default), {
                appearance: "new",
                children: intl.formatMessage(isEligibleNewUser ? (0, $b9hjy.messages).never_active_user : (0, $b9hjy.messages).inactive_user)
            })
        ]
    });
};
const $089108003db7c5d6$export$33a7dd41d4b97411 = (0, $js7oX.default)($089108003db7c5d6$var$Tab);

});
parcelRegister("b9hjy", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ac4a34ed4901a4de$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $ac4a34ed4901a4de$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /**
   * Confluence reactivation experiment tab nudge
   */ never_active_user: {
        id: "product_search_dialog.confluence.confluence_reactivation_experiment.never_active_user",
        defaultMessage: "Free access"
    },
    inactive_user: {
        id: "product_search_dialog.confluence.confluence_reactivation_experiment.inactive_user",
        defaultMessage: "More results"
    }
});

});


parcelRegister("hUj82", function(module, exports) {

$parcel$export(module.exports, "FilterOptionItem", () => $bf37330ffae29f1b$export$150fbd78f757731d);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $eN2vi = parcelRequire("eN2vi");

var $esRft = parcelRequire("esRft");
const $bf37330ffae29f1b$export$150fbd78f757731d = ({ label: label, iconProps: iconProps })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eN2vi.FilterShowMoreItem), {
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
            name: label,
            size: 'small',
            ...iconProps
        }),
        label: label
    });
};

});
parcelRegister("eN2vi", function(module, exports) {

$parcel$export(module.exports, "FilterShowMoreItem", () => $2226f60f4cec6118$export$c09bfbbe14287de2);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $lggDm = parcelRequire("lggDm");
const $2226f60f4cec6118$export$c09bfbbe14287de2 = ({ label: label, icon: icon, ...rest })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $lggDm.LabelWrapper), {
        ...rest,
        children: [
            icon && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lggDm.IconWrapper), {
                children: icon
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lggDm.FilterColLabelText), {
                children: label
            })
        ]
    });
};

});
parcelRegister("lggDm", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $b7a96cd3a77f60a3$export$be58b4326e23250f);
$parcel$export(module.exports, "LabelWrapper", () => $b7a96cd3a77f60a3$export$147422f7450ccfac);
$parcel$export(module.exports, "FilterColLabelText", () => $b7a96cd3a77f60a3$export$39d33abf45c3996);
$parcel$export(module.exports, "FilterRowLabelText", () => $b7a96cd3a77f60a3$export$dd6e1c6307d95848);
$parcel$export(module.exports, "CheckboxWrapper", () => $b7a96cd3a77f60a3$export$eef12940a6696c78);
$parcel$export(module.exports, "PillButton", () => $b7a96cd3a77f60a3$export$c5e39530e713771e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2azjJ = parcelRequire("2azjJ");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $b7a96cd3a77f60a3$export$397f5285b920487e = (0, $2azjJ.grid).multiple(22);
const $b7a96cd3a77f60a3$export$f51daa55764f8a9 = $b7a96cd3a77f60a3$export$397f5285b920487e.half();
const $b7a96cd3a77f60a3$var$IRREMOVABLE_AVATAR_PADDING_SIZE = 2;
// The +4px is to ensure consistency with the Atlaskit avatar which has a 2px padding around the 24px icon
const $b7a96cd3a77f60a3$var$ICON_WIDTH = (0, $2azjJ.grid).multiple(3).unitless + $b7a96cd3a77f60a3$var$IRREMOVABLE_AVATAR_PADDING_SIZE * 2;
const $b7a96cd3a77f60a3$var$ICON_HEIGHT = (0, $2azjJ.grid).multiple(3).unitless + $b7a96cd3a77f60a3$var$IRREMOVABLE_AVATAR_PADDING_SIZE * 2;
const $b7a96cd3a77f60a3$export$be58b4326e23250f = (0, $gwrgp.default)("span", {
    target: "e6939t10"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${$b7a96cd3a77f60a3$var$ICON_HEIGHT}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$b7a96cd3a77f60a3$var$ICON_WIDTH}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${(0, $2azjJ.grid).unitless - $b7a96cd3a77f60a3$var$IRREMOVABLE_AVATAR_PADDING_SIZE}px 0 ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $2azjJ.grid).half().unitless - $b7a96cd3a77f60a3$var$IRREMOVABLE_AVATAR_PADDING_SIZE}px`
});
const $b7a96cd3a77f60a3$export$147422f7450ccfac = (0, $gwrgp.default)("span", {
    target: "e6939t11"
})({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    // Offset the label's 4px padding-left
    marginLeft: "var(--ds-space-negative-050, -4px)",
    // The -2px is to offset the 28px container (see IconWrapper)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${(0, $2azjJ.grid).unitless - 2} 0`
});
const $b7a96cd3a77f60a3$export$39d33abf45c3996 = (0, $gwrgp.default)("span", {
    target: "e6939t12"
})((0, $2azjJ.nowrapEllipsis), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: $b7a96cd3a77f60a3$export$397f5285b920487e.px,
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`
});
const $b7a96cd3a77f60a3$export$dd6e1c6307d95848 = (0, $gwrgp.default)("span", {
    target: "e6939t13"
})((0, $2azjJ.nowrapEllipsis), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingLeft: (0, $2azjJ.grid).half().px,
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: $b7a96cd3a77f60a3$export$f51daa55764f8a9.px
});
const $b7a96cd3a77f60a3$export$eef12940a6696c78 = (0, $gwrgp.default)("span", {
    target: "e6939t14"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${(0, $2azjJ.grid).unitless - 2}px 0`,
    display: 'flex',
    flexGrow: 1
});
const $b7a96cd3a77f60a3$export$c5e39530e713771e = (0, $gwrgp.default)("button", {
    target: "e6939t15"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $2azjJ.grid).multiple(3).unitless + 2}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.selected ? `var(--ds-text-brand, ${0, $6fnsQ.B400})` : `var(--ds-text-subtlest, ${0, $6fnsQ.N500})`,
        outline: 'none',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${(0, $2azjJ.grid).half().px} ${(0, $2azjJ.grid).px}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.selected ? `var(--ds-background-selected, ${0, $6fnsQ.B50})` : `var(--ds-background-accent-gray-subtlest, ${0, $6fnsQ.N20})`,
        border: 'none',
        borderRadius: '14px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: `${(0, $2azjJ.grid).multiple(2).unitless + 2}px`,
        cursor: 'pointer',
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus-visible': {
            outline: `2px solid ${`var(--ds-border-focused, ${0, $6fnsQ.B100})`}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        }
    }));

});



parcelRegister("bq0QQ", function(module, exports) {

$parcel$export(module.exports, "useConfluenceSections", () => $38dc479b8383985f$export$468e9a0e16eb3222);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $jqR6C = parcelRequire("jqR6C");

var $bF0iL = parcelRequire("bF0iL");

var $isK0H = parcelRequire("isK0H");

var $1LtdH = parcelRequire("1LtdH");

var $88j1D = parcelRequire("88j1D");

var $hucqD = parcelRequire("hucqD");
const $38dc479b8383985f$var$ITEM_LIMIT_SIZE = 10;
const $38dc479b8383985f$var$SPACE_LIMIT_SIZE = 3;
const $38dc479b8383985f$var$PEOPLE_LIMIT_SIZE = 3;
const $38dc479b8383985f$export$468e9a0e16eb3222 = ({ formatDate: formatDate, autocorrectEnabled: autocorrectEnabled, additionalContentTypesEnabled: additionalContentTypesEnabled, rendererOverride: rendererOverride })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const confluenceItemResultMapper = (0, $gwFzn.useCallback)(({ results: results })=>results.map((result)=>({
                id: result.content.id,
                title: result.title,
                type: result.content.type,
                meta: result.container.title,
                additionalMeta: result.lastModified ? formatDate ? formatDate(result.lastModified) : (0, $isK0H.defaultFormatDate)(result.lastModified) : '',
                url: `${result.baseUrl}${result.url}`,
                containerId: result.content?.space?.id || result.container?.id || 'UNAVAILABLE',
                iconRenderer: (0, $1LtdH.ConfluenceItemIconRenderer)(result, true)
            })).slice(0, $38dc479b8383985f$var$ITEM_LIMIT_SIZE), [
        formatDate
    ]);
    const confluenceSpaceResultMapper = (0, $gwFzn.useCallback)(({ results: results })=>results.map((result)=>({
                id: result.id,
                title: result.title,
                meta: '',
                url: `${result.baseUrl || ''}${result.container.displayUrl}`,
                containerId: result.id,
                icon: (0, $1LtdH.GenericConfluenceIconRenderer)(`${result.baseUrl}${result.space.icon.path}`, true)
            })).slice(0, $38dc479b8383985f$var$SPACE_LIMIT_SIZE), []);
    const confluencePeopleResultMapper = (0, $gwFzn.useCallback)(({ results: results })=>results.map((result)=>({
                id: result.id,
                title: result.name,
                meta: '',
                url: result.absoluteUrl?.replace('/people', '/wiki/people') || '',
                containerId: '',
                icon: (0, $1LtdH.GenericConfluenceIconRenderer)(result.avatarUrl, true)
            })).slice(0, $38dc479b8383985f$var$PEOPLE_LIMIT_SIZE), []);
    const enableSpaceAndPeopleScope = (query, filters)=>{
        return !filters.find((filter)=>filter['@type'] === 'spaces' && filter['spaceKeys'].length > 0 || filter['@type'] === 'contributors' && filter['accountIds'].length > 0 || filter['@type'] === 'lastModified' && filter.from && filter.from !== (0, $88j1D.DEFAULT_OPTION));
    };
    const scopeId = additionalContentTypesEnabled && rendererOverride?.contentScope ? rendererOverride.contentScope : (0, $jqR6C.ConfluenceScope).Item;
    return (0, $gwFzn.useMemo)(()=>[
            {
                id: scopeId,
                title: formatMessage((0, $bF0iL.messages).confluence_content_section_heading),
                titleRenderer: (0, $hucqD.sectionTitleRenderer)(!!autocorrectEnabled),
                resultRenderer: additionalContentTypesEnabled && !!rendererOverride?.ConfluenceResultRenderer ? rendererOverride.ConfluenceResultRenderer : (0, $hucqD.ConfluenceItemResultRenderer),
                scope: scopeId,
                resultMapper: confluenceItemResultMapper,
                showResultCount: true,
                resultLimit: $38dc479b8383985f$var$ITEM_LIMIT_SIZE
            },
            {
                id: (0, $jqR6C.ConfluenceScope).Space,
                title: formatMessage((0, $bF0iL.messages).confluence_spaces_section_heading),
                scope: (0, $jqR6C.ConfluenceScope).Space,
                resultMapper: confluenceSpaceResultMapper,
                isEnabled: enableSpaceAndPeopleScope
            },
            {
                id: (0, $jqR6C.ConfluenceScope).People,
                title: formatMessage((0, $bF0iL.messages).confluence_people_section_heading),
                scope: (0, $jqR6C.ConfluenceScope).People,
                resultMapper: confluencePeopleResultMapper,
                isEnabled: enableSpaceAndPeopleScope
            }
        ], [
        formatMessage,
        autocorrectEnabled,
        confluenceItemResultMapper,
        confluenceSpaceResultMapper,
        confluencePeopleResultMapper,
        scopeId,
        additionalContentTypesEnabled,
        rendererOverride
    ]);
};

});
parcelRegister("1LtdH", function(module, exports) {

$parcel$export(module.exports, "getAvatarForConfluenceObjectResult", () => $7ce590926ed55824$export$310004de4fa0ccba);
$parcel$export(module.exports, "ConfluenceItemIconRenderer", () => $7ce590926ed55824$export$9e3ce228520dfa00);
$parcel$export(module.exports, "GenericConfluenceIconRenderer", () => $7ce590926ed55824$export$8fde8d521a2cd996);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dlbUV = parcelRequire("dlbUV");

var $d4cCP = parcelRequire("d4cCP");

var $d8Kpd = parcelRequire("d8Kpd");

var $8DZd1 = parcelRequire("8DZd1");

var $41GKb = parcelRequire("41GKb");

var $11LZV = parcelRequire("11LZV");

var $hY1Uy = parcelRequire("hY1Uy");

var $1iV2p = parcelRequire("1iV2p");

var $ayTrS = parcelRequire("ayTrS");

var $90Icb = parcelRequire("90Icb");

var $hxQwS = parcelRequire("hxQwS");

var $13WX1 = parcelRequire("13WX1");

var $fX9Sa = parcelRequire("fX9Sa");

var $gguok = parcelRequire("gguok");

var $gH8Rx = parcelRequire("gH8Rx");

var $djgQ6 = parcelRequire("djgQ6");

var $20uDq = parcelRequire("20uDq");

var $lzyQK = parcelRequire("lzyQK");

var $dfQbH = parcelRequire("dfQbH");

var $7t8Pn = parcelRequire("7t8Pn");

var $hXc8o = parcelRequire("hXc8o");

var $lkBga = parcelRequire("lkBga");

var $bueVT = parcelRequire("bueVT");

var $5yCDo = parcelRequire("5yCDo");

var $9Qum6 = parcelRequire("9Qum6");
/**
 * The following code was derived from an implementation in confluence-frontend,
 * although it differs substantially.
 *
 * The original can be found at ./packages/confluence-rest-api/src/helpers/icons.js
 */ const $7ce590926ed55824$var$ATTACHMENT_ICON_CLASS_PREFIXES = [
    // Quick Nav prefix
    'content-type-attachment-',
    // CQL prefix
    'icon-file-'
];
const $7ce590926ed55824$var$DEFAULT_ATTACHMENT_AVATAR = (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1)));
const $7ce590926ed55824$var$DEFAULT_ATTACHMENT_AVATAR_LARGE = (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)));
const $7ce590926ed55824$var$ATTACHMENT_FILE_EXTENSION_MATCHERS = [
    {
        regexp: /\.(gif|jpeg|jpg|png)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($41GKb))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($20uDq)))
    },
    {
        regexp: /\.(pdf)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($11LZV))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($lzyQK)))
    },
    {
        regexp: /\.(docx|dotx|doc|dot)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($90Icb))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($lkBga)))
    },
    {
        regexp: /\.(xml|html|js|css|java|jar|war|ear)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($1iV2p))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
    },
    {
        regexp: /\.(xlt|xls|xlsm|xlsx|xlst)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($d8Kpd))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($gH8Rx)))
    },
    {
        regexp: /\.(wma|wmv|ram|mp3)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
    },
    {
        regexp: /\.(pptx|ppsx|potx|pot|ppt|pptm)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($hY1Uy))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
    },
    {
        regexp: /\.(mov|mpeg|mpg|mp4|avi)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o)))
    },
    {
        regexp: /\.(zip)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa)))
    }
];
const $7ce590926ed55824$var$getIconType = (iconClass, fileName, isLarge)=>{
    // Check the iconClass to make sure we're looking at an attachment
    const prefixMatches = $7ce590926ed55824$var$ATTACHMENT_ICON_CLASS_PREFIXES.find((prefix)=>{
        return iconClass.startsWith(prefix);
    });
    // if it's an attachment, look at the file extension to work out which type
    if (prefixMatches) {
        const matchingType = $7ce590926ed55824$var$ATTACHMENT_FILE_EXTENSION_MATCHERS.find((extensionMatcher)=>{
            const matches = extensionMatcher.regexp.exec(fileName);
            return !!matches && matches.length > 0;
        });
        if (matchingType) return isLarge ? matchingType.avatarLarge : matchingType.avatar;
    }
    return isLarge ? $7ce590926ed55824$var$DEFAULT_ATTACHMENT_AVATAR_LARGE : $7ce590926ed55824$var$DEFAULT_ATTACHMENT_AVATAR;
};
const $7ce590926ed55824$export$310004de4fa0ccba = ({ type: type, title: title, iconCssClass: iconCssClass, isCollapsed: isCollapsed })=>{
    if (type === 'page' || type === 'confluence-page') {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- no icon available (https://product-fabric.atlassian.net/browse/DSP-20735)
        const Icon = isCollapsed ? (0, $5yCDo.default) : (0, $13WX1.default);
        return /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
            label: type
        });
    } else if (type === 'blogpost' || type === 'confluence-blogpost') {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- no icon available (https://product-fabric.atlassian.net/browse/DSP-20735)
        const Icon = isCollapsed ? (0, $bueVT.default) : (0, $hxQwS.default);
        return /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
            label: type
        });
    } else if (type === 'attachment') {
        const IconComponent = $7ce590926ed55824$var$getIconType(iconCssClass || '', title, isCollapsed);
        return /*#__PURE__*/ (0, $7UHDa.jsx)(IconComponent, {
            label: type
        });
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
};
const $7ce590926ed55824$export$9e3ce228520dfa00 = (result, largerIcons)=>()=>{
        if (result.content) return $7ce590926ed55824$export$310004de4fa0ccba({
            type: result.content.type,
            title: result.content.type,
            iconCssClass: result.iconCssClass,
            isCollapsed: largerIcons
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
    };
const $7ce590926ed55824$export$8fde8d521a2cd996 = (iconUrl, largerIcons)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $9Qum6.ResultAvatar), {
        borderColor: "transparent",
        src: iconUrl,
        appearance: "square",
        size: largerIcons ? 'small' : 'xsmall',
        testId: "result-avatar"
    });

});

parcelRegister("hucqD", function(module, exports) {

$parcel$export(module.exports, "sectionTitleRenderer", () => $7bcfa13d0f838ade$export$aee00814c9e3bae7);
$parcel$export(module.exports, "ConfluenceItemResultRenderer", () => $7bcfa13d0f838ade$export$1bdb91707b6d5bed);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $bF0iL = parcelRequire("bF0iL");

var $jFPud = parcelRequire("jFPud");

var $eEbYb = parcelRequire("eEbYb");

var $21MH9 = parcelRequire("21MH9");

var $ejGzS = parcelRequire("ejGzS");

var $1LtdH = parcelRequire("1LtdH");
const $7bcfa13d0f838ade$export$aee00814c9e3bae7 = (autocorrectEnabled)=>(args)=>{
        const { productState: productState } = args;
        const recentTitle = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $bF0iL.messages).common_recently_viewed_section_heading
        });
        const contentTitle = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $bF0iL.messages).confluence_content_section_heading
        });
        switch(productState){
            case (0, $jFPud.ProductStates).PreQuerySuccess:
                return recentTitle;
            case (0, $jFPud.ProductStates).PostQueryLoading:
                if (autocorrectEnabled) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEbYb.LoadingSkeleton), {
                    "data-testid": 'autocorrection-loading-skeleton'
                });
                return contentTitle;
            case (0, $jFPud.ProductStates).PostQuerySuccess:
                if (autocorrectEnabled) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $21MH9.AutocorrectAsyncWrapper), {
                    fallback: contentTitle
                });
                return contentTitle;
            default:
                return contentTitle;
        }
    };
const $7bcfa13d0f838ade$export$1bdb91707b6d5bed = ({ searchResult: searchResult, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { productState: productState } = rest;
    if (productState === 'PreQuerySuccess') return (0, $ejGzS.defaultResultRenderer)({
        ...rest,
        searchResult: {
            ...searchResult,
            additionalMeta: ''
        }
    });
    if (productState === 'PostQueryLoading' || productState === 'PostQuerySuccess') return (0, $ejGzS.defaultResultRenderer)({
        ...rest,
        searchResult: {
            ...searchResult,
            additionalMeta: !!searchResult.isRecentResult ? formatMessage((0, $bF0iL.messages).common_recently_viewed_section_heading) : searchResult.additionalMeta,
            icon: !!searchResult.isRecentResult ? (0, $1LtdH.getAvatarForConfluenceObjectResult)({
                // the recent content type is stored in additionalMeta but not displayed
                type: searchResult.additionalMeta || '',
                title: searchResult.title,
                isCollapsed: rest.isCollapsed
            }) : searchResult.icon
        }
    });
    return (0, $ejGzS.defaultResultRenderer)({
        searchResult: searchResult,
        ...rest
    });
};

});


parcelRegister("lLhXY", function(module, exports) {

$parcel$export(module.exports, "useConfluenceSuppliers", () => $4d73e9aedf98202d$export$c9757f311cedcc1d);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $jqR6C = parcelRequire("jqR6C");

var $169DF = parcelRequire("169DF");

var $hucqD = parcelRequire("hucqD");

var $bF0iL = parcelRequire("bF0iL");

var $g1L2n = parcelRequire("g1L2n");

var $2ZIpG = parcelRequire("2ZIpG");

var $fJRVo = parcelRequire("fJRVo");

var $isK0H = parcelRequire("isK0H");

var $1LtdH = parcelRequire("1LtdH");

var $jU1PW = parcelRequire("jU1PW");
const $4d73e9aedf98202d$var$RECENT_ITEMS_SIZE_LIMIT = 10;
const $4d73e9aedf98202d$var$RECENT_SPACES_SIZE_LIMIT = 3;
const $4d73e9aedf98202d$var$ITEM_LIMIT_SIZE = 10;
const $4d73e9aedf98202d$var$SPACE_LIMIT_SIZE = 3;
const $4d73e9aedf98202d$var$PEOPLE_LIMIT_SIZE = 3;

const $4d73e9aedf98202d$export$c9757f311cedcc1d = ({ recentClientConfig: recentClientConfig, searchClientConfig: searchClientConfig, spaceFilterStore: spaceFilterStore, peopleFilterStore: peopleFilterStore, isExpanded: isExpanded, isUserAnonymous: isUserAnonymous, formatDate: formatDate, autocorrectEnabled: autocorrectEnabled, rendererOverride: rendererOverride, additionalContentTypesEnabled: additionalContentTypesEnabled })=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const warmUpCache = isExpanded && query !== '' && getActiveProduct()?.id === (0, $jqR6C.CONFLUENCE_PRODUCT_ID);
    const [hasFetchedSpaces, setHasFetchedSpaces] = (0, $gwFzn.useState)(spaceFilterStore?.availableFilters?.length > 0 || false);
    const intl = (0, $dBxQj.default)();
    const hasFetchedUsersRef = (0, $gwFzn.useRef)(peopleFilterStore?.availableFilters?.length > 0 || false);
    const { isCollaborationGraphEnabled: isCollaborationGraphEnabled } = recentClientConfig;
    const { getRecentItems: getRecentItems, getRecentSpaces: getRecentSpaces, getRecentPeople: getRecentPeople, getCollabGraphContainers: getCollabGraphContainers } = (0, $g1L2n.useRecentsClient)(recentClientConfig);
    // Set the default space filters to come from the collab graph if they are not enabled for recents
    (0, $gwFzn.useEffect)(()=>{
        if (warmUpCache && !isCollaborationGraphEnabled && !hasFetchedSpaces) getCollabGraphContainers().then((spaces)=>{
            if (spaces.items.length > 0) spaceFilterStore.setDefaultFilters(spaces.items.map((item, index)=>({
                    id: item.id,
                    spaceKey: item.key,
                    avatarUrl: item.avatarUrl,
                    label: item.name,
                    filterSource: (0, $169DF.FilterOptionSource).RECENT,
                    isChecked: false,
                    isVisible: index < 3
                })));
            setHasFetchedSpaces(true);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isCollaborationGraphEnabled,
        getCollabGraphContainers,
        isExpanded,
        warmUpCache
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (warmUpCache && !hasFetchedUsersRef.current) {
            getRecentPeople().then((recentPeople)=>{
                peopleFilterStore.setDefaultFilters(recentPeople.items.map((item, index)=>({
                        id: item.userId,
                        avatarUrl: item.avatarUrl,
                        label: item.name,
                        filterSource: (0, $169DF.FilterOptionSource).RECENT,
                        isChecked: false,
                        isVisible: index < 3
                    })));
            });
            hasFetchedUsersRef.current = true;
        }
    }, [
        warmUpCache,
        peopleFilterStore,
        getRecentPeople
    ]);
    const contentResultRenderer = additionalContentTypesEnabled && rendererOverride?.ConfluenceResultRenderer ? rendererOverride.ConfluenceResultRenderer : (0, $hucqD.ConfluenceItemResultRenderer);
    const scope = additionalContentTypesEnabled && rendererOverride?.contentScope ? rendererOverride.contentScope : (0, $jqR6C.ConfluenceScope).Item;
    const preQueryItemSupplier = (0, $gwFzn.useMemo)(()=>()=>Promise.all([
                getRecentItems(),
                getRecentSpaces()
            ]).then((results)=>{
                const recentItems = results[0].items;
                const recentSpaces = results[1].items;
                if (!hasFetchedSpaces && isCollaborationGraphEnabled) {
                    spaceFilterStore.setDefaultFilters(recentSpaces.map((item, index)=>({
                            id: item.id,
                            spaceKey: item.key,
                            avatarUrl: item.avatarUrl,
                            label: item.name,
                            filterSource: (0, $169DF.FilterOptionSource).RECENT,
                            isChecked: false,
                            isVisible: index < 3
                        })));
                    setHasFetchedSpaces(true);
                }
                return {
                    size: results.reduce((sum, { items: items })=>{
                        return sum + items.length;
                    }, 0),
                    sections: [
                        {
                            id: 'recent-confluence-items',
                            titleRenderer: (0, $hucqD.sectionTitleRenderer)(!!autocorrectEnabled),
                            title: intl.formatMessage((0, $bF0iL.messages).common_recently_viewed_section_heading),
                            resultRenderer: contentResultRenderer,
                            scope: scope,
                            searchResults: recentItems.map((result)=>({
                                    id: result.resultId,
                                    title: result.name,
                                    meta: result.containerName,
                                    additionalMeta: result.contentType,
                                    url: result.href,
                                    containerId: result.spaceId,
                                    icon: (0, $1LtdH.getAvatarForConfluenceObjectResult)({
                                        type: result.contentType,
                                        title: result.name,
                                        isCollapsed: false
                                    }),
                                    isRecentResult: true
                                })),
                            resultLimit: $4d73e9aedf98202d$var$RECENT_ITEMS_SIZE_LIMIT
                        },
                        {
                            id: 'recent-confluence-spaces',
                            title: intl.formatMessage((0, $bF0iL.messages).common_recently_spaces_section_heading),
                            searchResults: recentSpaces.map((result)=>({
                                    id: result.resultId,
                                    title: result.name,
                                    meta: '',
                                    url: result.href,
                                    containerId: '',
                                    iconUrl: result.avatarUrl,
                                    isRecentResult: true
                                })),
                            resultLimit: $4d73e9aedf98202d$var$RECENT_SPACES_SIZE_LIMIT
                        }
                    ]
                };
            }), [
        getRecentItems,
        getRecentSpaces,
        hasFetchedSpaces,
        isCollaborationGraphEnabled,
        autocorrectEnabled,
        intl,
        spaceFilterStore,
        contentResultRenderer,
        scope
    ]);
    const postQueryItemSupplier = (0, $gwFzn.useMemo)(()=>!searchClientConfig?.graphQLEnabled ? undefined : async (args)=>{
            const { hasCheckedFilters: hasCheckedFilters, getUserSearchResults: getUserSearchResults } = await (parcelRequire("jtFzj"));
            const pageBlogAttachmentGraphQLResultMapper = ({ node: item })=>{
                return {
                    id: (0, $jU1PW.transformAriToId)(item?.id || '', item?.type || ''),
                    title: item?.title || '',
                    url: item?.url || '',
                    meta: item?.space?.name || '',
                    additionalMeta: item?.lastModified ? formatDate ? formatDate(item?.lastModified) : (0, $isK0H.defaultFormatDate)(item?.lastModified) : '',
                    containerId: (0, $jU1PW.transformAriToId)(item?.space?.id || 'UNAVAILABLE', 'space'),
                    type: item?.type || '',
                    icon: (0, $1LtdH.getAvatarForConfluenceObjectResult)({
                        type: item?.type || '',
                        title: item?.title || '',
                        iconCssClass: item?.iconCssClass || '',
                        isCollapsed: true
                    })
                };
            };
            const spaceGraphQLResultMapper = ({ node: item })=>{
                return {
                    id: (0, $jU1PW.transformAriToId)(item?.id || '', item?.type || ''),
                    title: item?.title || '',
                    meta: '',
                    url: item?.url || '',
                    type: item?.type || '',
                    containerId: (0, $jU1PW.transformAriToId)(item?.id || '', item?.type || ''),
                    icon: (0, $1LtdH.GenericConfluenceIconRenderer)(`/wiki${item?.iconPath || ''}`, true)
                };
            };
            const peopleResultMapper = (user)=>({
                    title: user.name,
                    id: user.id,
                    meta: '',
                    url: `${window.location.origin}/wiki/people/${user.id}`,
                    icon: (0, $1LtdH.GenericConfluenceIconRenderer)(`${user.avatarUrl}`, true)
                });
            const fetchOnlyPageBlogAttachments = hasCheckedFilters(args.filters);
            const graphQLResultsPromise = searchClientConfig?.graphQLPromise?.(args);
            const peopleResultsPromise = fetchOnlyPageBlogAttachments || isUserAnonymous ? Promise.resolve([]) : getUserSearchResults({
                query: args.query,
                cloudId: searchClientConfig?.cloudId || '',
                principalId: searchClientConfig?.userId,
                intl: intl
            }).catch((e)=>[]);
            return Promise.all([
                graphQLResultsPromise,
                peopleResultsPromise
            ]).then((results)=>{
                const pageBlogAttachmentResults = results[0]?.search.pageBlogAttachments.edges.map(pageBlogAttachmentGraphQLResultMapper) || [];
                const pageBlogAttachmentsCount = results[0]?.search.pageBlogAttachments.totalCount;
                const spaceResults = results[0]?.search.spaces?.edges.map(spaceGraphQLResultMapper) || [];
                const peopleResults = results[1].map(peopleResultMapper) || [];
                return {
                    sections: [
                        {
                            id: scope,
                            title: intl.formatMessage((0, $bF0iL.messages).confluence_content_section_heading),
                            searchResults: pageBlogAttachmentResults,
                            titleRenderer: (0, $hucqD.sectionTitleRenderer)(!!autocorrectEnabled),
                            resultRenderer: contentResultRenderer,
                            showResultCount: true,
                            size: pageBlogAttachmentsCount || undefined,
                            resultLimit: $4d73e9aedf98202d$var$ITEM_LIMIT_SIZE
                        },
                        {
                            id: (0, $jqR6C.ConfluenceScope).Space,
                            title: intl.formatMessage((0, $bF0iL.messages).confluence_spaces_section_heading),
                            searchResults: spaceResults,
                            resultLimit: $4d73e9aedf98202d$var$SPACE_LIMIT_SIZE
                        },
                        {
                            id: (0, $jqR6C.ConfluenceScope).People,
                            title: intl.formatMessage((0, $bF0iL.messages).confluence_people_section_heading),
                            searchResults: peopleResults,
                            resultLimit: $4d73e9aedf98202d$var$PEOPLE_LIMIT_SIZE
                        }
                    ],
                    size: pageBlogAttachmentResults.length + spaceResults.length + peopleResults.length
                };
            });
        }, [
        autocorrectEnabled,
        formatDate,
        intl,
        searchClientConfig,
        contentResultRenderer,
        isUserAnonymous,
        scope
    ]);
    return {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    };
};

});
parcelRegister("jU1PW", function(module, exports) {

$parcel$export(module.exports, "transformAriToId", () => $522eb9748c713499$export$6d8886e8d5cdbeec);
const $522eb9748c713499$export$6d8886e8d5cdbeec = (id, type)=>{
    switch(type){
        case 'page':
            return id.split(':page/')[1];
        case 'blogpost':
            return id.split(':blogpost/')[1];
        case 'attachment':
            return id.split(':attachment/')[1];
        case 'space':
            return id.split(':space/')[1];
        case 'whiteboard':
            return id.split(':whiteboard/')[1];
        case 'embed':
            // embed ari url contains activation id so we split it differently here
            const embedAri = id.split('/');
            return embedAri[embedAri.length - 1];
        case 'database':
            // Databases ari url contains activation id so we split it differently here
            const databaseAri = id.split('/');
            return databaseAri[databaseAri.length - 1];
        default:
            return id;
    }
};

});

parcelRegister("jtFzj", function(module, exports) {

let $e2e0f86aafc69f62$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e2e0f86aafc69f62$var$load("5QGog").then(()=>parcelRequire('eBmVD'));

});


parcelRegister("fXZrW", function(module, exports) {

$parcel$export(module.exports, "useConfluenceDateFilter", () => $d82bcb6e5a831fde$export$a31429ad2d37d59f);

var $gwFzn = parcelRequire("gwFzn");

var $jqR6C = parcelRequire("jqR6C");

var $169DF = parcelRequire("169DF");

var $88j1D = parcelRequire("88j1D");
var $kzbg7 = parcelRequire("kzbg7");

var $82MWW = parcelRequire("82MWW");

var $dBxQj = parcelRequire("dBxQj");
const $d82bcb6e5a831fde$var$getUTCDateRange = (fromOffset, toOffset)=>{
    const currentDate = new Date();
    const startOfDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const endOfDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999);
    const from = new Date(startOfDay.getTime() - fromOffset * 86400000);
    const to = new Date(endOfDay.getTime() - toOffset * 86400000);
    return {
        from: from.toISOString().split('Z')[0],
        to: to.toISOString().split('Z')[0]
    };
};
const $d82bcb6e5a831fde$export$a31429ad2d37d59f = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const dateFilterOptionsAndValues = (0, $gwFzn.useMemo)(()=>{
        return {
            [(0, $88j1D.LastModifiedValues).DEFAULT]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).DEFAULT,
                    label: formatMessage((0, $82MWW.messages).confluence_date_filter_any_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: true,
                    isVisible: true
                },
                dateRange: {
                    from: '',
                    to: ''
                }
            },
            [(0, $88j1D.LastModifiedValues).TODAY]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).TODAY,
                    label: formatMessage((0, $82MWW.messages).confluence_date_filter_today_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $d82bcb6e5a831fde$var$getUTCDateRange(0, 0)
            },
            [(0, $88j1D.LastModifiedValues).YESTERDAY]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).YESTERDAY,
                    label: formatMessage((0, $82MWW.messages).confluence_date_filter_yesterday_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $d82bcb6e5a831fde$var$getUTCDateRange(1, 1)
            },
            [(0, $88j1D.LastModifiedValues).PAST_SEVEN_DAYS]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_SEVEN_DAYS,
                    label: formatMessage((0, $82MWW.messages).confluence_date_filter_week_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $d82bcb6e5a831fde$var$getUTCDateRange(7, 0)
            },
            [(0, $88j1D.LastModifiedValues).PAST_THIRTY_DAYS]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_THIRTY_DAYS,
                    label: formatMessage((0, $82MWW.messages).confluence_date_filter_month_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $d82bcb6e5a831fde$var$getUTCDateRange(30, 0)
            },
            [(0, $88j1D.LastModifiedValues).PAST_YEAR]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_YEAR,
                    label: formatMessage((0, $82MWW.messages).confluence_date_filter_year_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $d82bcb6e5a831fde$var$getUTCDateRange(365, 0)
            }
        };
    }, [
        formatMessage
    ]);
    const dateFilterOptions = (0, $gwFzn.useMemo)(()=>dateFilterOptionsAndValues ? Object.values(dateFilterOptionsAndValues).map((value)=>value.filter) : [], [
        dateFilterOptionsAndValues
    ]);
    const dateFilterStore = (0, $kzbg7.useFilterStore)(dateFilterOptions, (0, $jqR6C.CONFLUENCE_PRODUCT_ID), (0, $jqR6C.ConfluenceFilters).Date);
    const appliedDateFilter = dateFilterStore?.availableFilters?.find((f)=>f.isChecked && f.id !== (0, $88j1D.DEFAULT_OPTION))?.id;
    const getLastModifiedValue = (0, $gwFzn.useCallback)(()=>{
        return appliedDateFilter && dateFilterOptionsAndValues && dateFilterOptionsAndValues[appliedDateFilter] ? {
            '@type': (0, $jqR6C.ConfluenceFilters).Date,
            from: dateFilterOptionsAndValues[appliedDateFilter].dateRange.from,
            to: dateFilterOptionsAndValues[appliedDateFilter].dateRange.to
        } : null;
    }, [
        appliedDateFilter,
        dateFilterOptionsAndValues
    ]);
    const confluenceTabDateFilter = (0, $gwFzn.useMemo)(()=>{
        return [
            {
                ['@type']: (0, $jqR6C.ConfluenceFilters).Date,
                uiVariant: (0, $88j1D.FilterUIVariant).STATIC_SELECT,
                fieldName: 'from',
                store: dateFilterStore,
                loadFilterOptions: async ()=>[],
                sectionLabel: formatMessage((0, $82MWW.messages).confluence_date_filter_title),
                findMoreLabel: '',
                mapSelectionToAppliedValue: ()=>getLastModifiedValue()
            }
        ];
    }, [
        dateFilterStore,
        formatMessage,
        getLastModifiedValue
    ]);
    return {
        appliedDateFilter: appliedDateFilter,
        confluenceTabDateFilter: confluenceTabDateFilter
    };
};

});
parcelRegister("82MWW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f80ef50bfa9d23a2$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $f80ef50bfa9d23a2$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    confluence_typing_state_header_text: {
        id: "product_search_dialog.confluence.typing_state_header_text",
        defaultMessage: "Search for content in Confluence"
    },
    confluence_date_filter_title: {
        id: "product_search_dialog.confluence.date_filter_title",
        defaultMessage: "Last updated"
    },
    confluence_date_filter_today_label: {
        id: "product_search_dialog.confluence.date_filter_today",
        defaultMessage: "Today"
    },
    confluence_date_filter_yesterday_label: {
        id: "product_search_dialog.confluence.date_filter_yesterday",
        defaultMessage: "Yesterday"
    },
    confluence_date_filter_week_label: {
        id: "product_search_dialog.confluence.date_filters_week",
        defaultMessage: "Past 7 days"
    },
    confluence_date_filter_month_label: {
        id: "product_search_dialog.confluence.date_filters_month",
        defaultMessage: "Past 30 days"
    },
    confluence_date_filter_year_label: {
        id: "product_search_dialog.confluence.date_filters_year",
        defaultMessage: "Past year"
    },
    confluence_date_filter_any_label: {
        id: "product_search_dialog.confluence.date_filters_any",
        defaultMessage: "Any time"
    }
});

});


parcelRegister("1YBC8", function(module, exports) {

$parcel$export(module.exports, "ExtensibleConfluenceTabFooter", () => $50734d056dfcdf62$export$d7ad215466e34991);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $crAJ1 = parcelRequire("crAJ1");

var $4mZlP = parcelRequire("4mZlP");

var $3Z7LN = parcelRequire("3Z7LN");

var $4mZlP = parcelRequire("4mZlP");
const $50734d056dfcdf62$var$ReturnIcon = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.ReturnIconWithModifier), {});
const $50734d056dfcdf62$export$d7ad215466e34991 = ({ orgId: orgId, cloudId: cloudId, ...props })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.AdvancedSearchFooter), {
                    ...props,
                    returnKeyIconComponent: $50734d056dfcdf62$var$ReturnIcon
                })
            }),
            orgId && cloudId && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Z7LN.AtlassianHomeSearchLink), {
                    orgId: orgId,
                    cloudId: cloudId,
                    showModifierIcon: true
                })
            })
        ]
    });
};

});

parcelRegister("ex79W", function(module, exports) {

let $a949b370429bc306$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a949b370429bc306$var$load("8XFC9").then(()=>parcelRequire('gnNGp'));

});


parcelRegister("4jHJP", function(module, exports) {

$parcel$export(module.exports, "ExtensibleJiraTab", () => $704bede17293a569$export$8db2a2835d8b9d10);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $crAJ1 = parcelRequire("crAJ1");

var $bF0iL = parcelRequire("bF0iL");

var $a5cba = parcelRequire("a5cba");
var $fJRVo = parcelRequire("fJRVo");

var $5CiaV = parcelRequire("5CiaV");

var $4azzq = parcelRequire("4azzq");

var $cgH2x = parcelRequire("cgH2x");

var $3invz = parcelRequire("3invz");

var $hlU74 = parcelRequire("hlU74");

var $btY8w = parcelRequire("btY8w");

var $1Yciq = parcelRequire("1Yciq");

var $5dFS9 = parcelRequire("5dFS9");

var $lF5IG = parcelRequire("lF5IG");

var $eztGN = parcelRequire("eztGN");

var $iEwUU = parcelRequire("iEwUU");

var $dKB22 = parcelRequire("dKB22");

var $gF7Az = parcelRequire("gF7Az");

var $2ZIpG = parcelRequire("2ZIpG");

var $kbm4u = parcelRequire("kbm4u");

var $iE5Vg = parcelRequire("iE5Vg");

var $jFPud = parcelRequire("jFPud");

var $2jYn8 = parcelRequire("2jYn8");

var $gRazf = parcelRequire("gRazf");

var $3cM77 = parcelRequire("3cM77");

var $5906J = parcelRequire("5906J");

var $3Z7LN = parcelRequire("3Z7LN");

var $4mZlP = parcelRequire("4mZlP");

var $kmpep = parcelRequire("kmpep");
let $704bede17293a569$var$hasLoadedFilters = false;
let $704bede17293a569$var$currentProjectRef;
let $704bede17293a569$var$currentUserRef;
const $704bede17293a569$export$5eff96142961f4a2 = (value)=>$704bede17293a569$var$hasLoadedFilters = value;
const $704bede17293a569$var$JiraNoPreQueryResults = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $3cM77.default), {
        message: (0, $bF0iL.messages).jira_empty_state_prequery_heading
    });
const $704bede17293a569$export$8db2a2835d8b9d10 = ({ features: features, children: children, config: config, formatDate: formatDate, autocorrectEnabled: autocorrectEnabled, currentProject: currentProject, currentUser: currentUser, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { jiraSites: jiraSites } = (0, $lF5IG.useSearchConfigContext)();
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const { query: query } = (0, $2ZIpG.useQuery)();
    const hasAdvancedRoadmapsAccess = !!features?.hasAdvancedRoadmapsAccess;
    const hasSoftwareAccess = !!features?.hasSoftwareAccess;
    const isPreviewOnJiraSearchResultsEnabled = !!features?.isPreviewOnJiraSearchResultsEnabled;
    const isReportedByMeFilterEnabled = !!features?.isReportedByMeFilterEnabled;
    const isConsistentIssueDetailsEnabled = !!features?.isConsistentIssueDetailsEnabled;
    const isDateFromFilterEnabled = !!features?.enableDateFromFilter;
    const shouldShowIssueLabelsFilter = !!features?.enableIssueLabelsFilter;
    const isPreQueryFiltersEnabled = true;
    const isSearchWithTextFieldInAllIssuesLinkEnabled = !!features?.isSearchWithTextFieldInAllIssuesLinkEnabled;
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const { defineFilters: defineFilters } = (0, $cgH2x.useGenericFilters)();
    const { filtersDefinition: filtersDefinition, loadFilters: loadFilters, filterValueGetters: filterValueGetters } = (0, $3invz.useFilters)(rest, shouldShowIssueLabelsFilter, config, currentProject, currentUser, isReportedByMeFilterEnabled);
    const { jiraTabDateFilterDefinition: jiraTabDateFilterDefinition, appliedDateFilterValue: appliedDateFilterValue } = (0, $5906J.useJiraDateFilter)({
        isDateFromFilterEnabled: isDateFromFilterEnabled
    });
    const abTest = (0, $gRazf.useABTest)();
    const isFasterSearchDisabled = abTest !== null && abTest !== undefined && (abTest.experimentId === 'durian-without-faster-search' || abTest.experimentId === 'default-without-faster-search');
    if ((!$704bede17293a569$var$hasLoadedFilters || $704bede17293a569$var$currentProjectRef?.id !== currentProject?.id || $704bede17293a569$var$currentUserRef?.id !== currentUser?.id || $704bede17293a569$var$currentUserRef?.avatarUrl !== currentUser?.avatarUrl) && isExpanded && getActiveProduct()?.id === (0, $4azzq.JIRA_PRODUCT_ID) && (isPreQueryFiltersEnabled || query !== '')) {
        loadFilters();
        $704bede17293a569$var$currentProjectRef = currentProject;
        $704bede17293a569$var$currentUserRef = currentUser;
        $704bede17293a569$export$5eff96142961f4a2(true);
    }
    defineFilters((0, $4azzq.JIRA_PRODUCT_ID), [
        ...isDateFromFilterEnabled ? jiraTabDateFilterDefinition : [],
        ...filtersDefinition
    ]);
    const { getFiltersAdvancedSearchUrl: getFiltersAdvancedSearchUrl } = (0, $btY8w.useURLFactory)(filterValueGetters, appliedDateFilterValue, isPreQueryFiltersEnabled, isSearchWithTextFieldInAllIssuesLinkEnabled);
    const generateAdvancedSearchUrl = (0, $gwFzn.useCallback)((query, baseUrl, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $3Z7LN.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return getFiltersAdvancedSearchUrl(query, baseUrl);
    }, [
        getFiltersAdvancedSearchUrl,
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    const { recentSectionTitleGenerator: recentSectionTitleGenerator, sections: sections } = (0, $hlU74.useSections)(hasAdvancedRoadmapsAccess, hasSoftwareAccess, getFiltersAdvancedSearchUrl, isPreviewOnJiraSearchResultsEnabled, (0, $dBxQj.default)(), formatDate, isConsistentIssueDetailsEnabled, autocorrectEnabled);
    const itemSuppliers = (0, $5CiaV.useDefaultSuppliers)((0, $4azzq.JIRA_PRODUCT_ID), sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5cba.SearchDialogProduct), {
        id: (0, $4azzq.JIRA_PRODUCT_ID),
        expandedStateInputPlaceholder: formatMessage((0, $bF0iL.messages).jira_search_placeholder),
        title: formatMessage((0, $bF0iL.messages).jira_tab_label),
        autocorrectEnabled: autocorrectEnabled,
        sections: sections,
        preQuerySectionTitleGenerator: recentSectionTitleGenerator,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        ...rest,
        ...itemSuppliers,
        permissionSupplier: jiraSites.length > 0 ? (0, $dKB22.defaultPermissionsSupplier) : rest.permissionSupplier,
        appendQueryParams: (0, $kbm4u.appendQueryParams),
        isPreQueryFiltersEnabled: isPreQueryFiltersEnabled,
        debounceTime: 300,
        children: ({ linkComponent: linkComponent, productState: productState })=>{
            return {
                Body: ()=>{
                    if (productState === (0, $jFPud.ProductStates).PostQueryLoading && isFasterSearchDisabled) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2jYn8.LoadingSpinner), {});
                    else if (productState === (0, $jFPud.ProductStates).PreQueryNoResult) return /*#__PURE__*/ (0, $7UHDa.jsx)($704bede17293a569$var$JiraNoPreQueryResults, {});
                },
                SectionFooter: jiraSites.length > 1 ? undefined // don't show the footer for multi sites
                 : ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $iE5Vg.default), {
                        advancedSearchSelected: (0, $5dFS9.onAdvancedSearchSelected),
                        linkComponent: linkComponent,
                        productState: productState,
                        features: features
                    }),
                Footer: ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1Yciq.JiraAdvancedSearch), {
                                returnKeyIconComponent: showAtlassianHomeSearchLink ? ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.ReturnIconWithModifier), {}) : undefined,
                                linkComponent: linkComponent,
                                productState: productState,
                                features: features
                            }),
                            showAtlassianHomeSearchLink && orgId && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Z7LN.AtlassianHomeSearchLink), {
                                    orgId: orgId,
                                    cloudId: cloudId,
                                    showModifierIcon: true
                                })
                            })
                        ]
                    })
            };
        }
    });
};

});
parcelRegister("4azzq", function(module, exports) {

$parcel$export(module.exports, "JIRA_PRODUCT_ID", () => $c54738dc6b9484af$export$bf5ad8f7e6312fe2);
$parcel$export(module.exports, "NAVIGATION_V3_EXPERIENCE", () => $c54738dc6b9484af$export$4a204ebf24901f2e);
$parcel$export(module.exports, "FILTER_LIST_LIMIT", () => $c54738dc6b9484af$export$a0931d840e4e9fd9);
$parcel$export(module.exports, "ISSUE_LIST_LIMIT", () => $c54738dc6b9484af$export$f6357d218d3fefa3);
$parcel$export(module.exports, "OTHERS_LIST_LIMIT_NO_ADVANCED_ROADMAPS_ACCESS", () => $c54738dc6b9484af$export$862d39c85199c14c);
$parcel$export(module.exports, "OTHERS_LIST_LIMIT_ADVANCED_ROADMAPS_ACCESS", () => $c54738dc6b9484af$export$223565448ddb4a15);
$parcel$export(module.exports, "DEFAULT_COLLAB_GRAPH_URL", () => $c54738dc6b9484af$export$e5ea847149c37067);
$parcel$export(module.exports, "DEFAULT_ISSUE_LABELS_SERVICE_URL", () => $c54738dc6b9484af$export$43bbc37c110456ee);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_URL", () => $c54738dc6b9484af$export$da00a8e161805bdf);
$parcel$export(module.exports, "JiraScope", () => $c54738dc6b9484af$export$45df25c6bac04c78);
$parcel$export(module.exports, "JiraFilters", () => $c54738dc6b9484af$export$dfd4d34c680dbd6e);
const $c54738dc6b9484af$export$bf5ad8f7e6312fe2 = 'jira';
const $c54738dc6b9484af$export$4a204ebf24901f2e = 'jira.nav-v3';
const $c54738dc6b9484af$export$a0931d840e4e9fd9 = 10;
const $c54738dc6b9484af$export$f6357d218d3fefa3 = 10;
const $c54738dc6b9484af$export$862d39c85199c14c = 6;
const $c54738dc6b9484af$export$223565448ddb4a15 = 8;
const $c54738dc6b9484af$export$e5ea847149c37067 = 'gateway/api/collaboration';
const $c54738dc6b9484af$export$43bbc37c110456ee = '/rest/api/1.0/labels/suggest';
const $c54738dc6b9484af$export$da00a8e161805bdf = `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`;
var $c54738dc6b9484af$export$45df25c6bac04c78 = /*#__PURE__*/ function(JiraScope) {
    JiraScope["Issue"] = "jira.issue";
    JiraScope["ProjectFilter"] = "jira.project,filter";
    JiraScope["BoardProjectFilter"] = "jira.board,project,filter";
    JiraScope["BoardProjectFilterPlans"] = "jira.board,project,filter,plan";
    JiraScope["Project"] = "jira.project";
    JiraScope["Assignee"] = "urs.user-jira";
    return JiraScope;
}({});
var $c54738dc6b9484af$export$dfd4d34c680dbd6e = /*#__PURE__*/ function(JiraFilters) {
    JiraFilters["Projects"] = "projects";
    JiraFilters["Assignees"] = "assignees";
    JiraFilters["Status"] = "binary_status_categories";
    JiraFilters["Date"] = "lastModified";
    JiraFilters["ReportedBy"] = "reportedBy";
    JiraFilters["IssueLabels"] = "issueLabels";
    return JiraFilters;
}({});

});

parcelRegister("3invz", function(module, exports) {

$parcel$export(module.exports, "useFilters", () => $892be119e555b7f8$export$973ca22476b0e05f);

var $7UHDa = parcelRequire("7UHDa");

var $dBxQj = parcelRequire("dBxQj");

var $gwFzn = parcelRequire("gwFzn");

var $aZ2wG = parcelRequire("aZ2wG");

var $bF0iL = parcelRequire("bF0iL");

var $4azzq = parcelRequire("4azzq");

var $88j1D = parcelRequire("88j1D");
var $kzbg7 = parcelRequire("kzbg7");
var $cgH2x = parcelRequire("cgH2x");

var $71A0K = parcelRequire("71A0K");

var $hUj82 = parcelRequire("hUj82");

var $169DF = parcelRequire("169DF");

var $ly8Ih = parcelRequire("ly8Ih");
const $892be119e555b7f8$export$fe780e7155e72c07 = (projects, project)=>{
    if (!project) return projects;
    const newOption = {
        ...project,
        isChecked: false,
        isVisible: true,
        filterSource: (0, $169DF.FilterOptionSource).EXTERNAL
    };
    const existingItem = projects.find((s)=>s.id === project.id);
    if (!existingItem?.isVisible) {
        const lastVisibleItemIdx = projects.findIndex((s)=>!s.isVisible) - 1;
        if (lastVisibleItemIdx > 0) projects[lastVisibleItemIdx].isVisible = false;
    }
    return [
        newOption
    ].concat(projects.filter((s)=>s.id !== project.id));
};
const $892be119e555b7f8$export$e54fe71d6476ce8f = (assignees, currentUser)=>{
    if (!currentUser) return assignees;
    const newOption = {
        id: currentUser.id,
        label: currentUser.name,
        avatarUrl: currentUser.avatarUrl,
        isChecked: false,
        isVisible: true,
        filterSource: (0, $169DF.FilterOptionSource).CURRENT_USER
    };
    const existingItem = assignees.find((assignee)=>assignee.id === currentUser.id);
    if (!existingItem?.isVisible) {
        const lastVisibleItemIdx = assignees.findIndex((assignee)=>!assignee.isVisible) - 1;
        if (lastVisibleItemIdx > 0) assignees[lastVisibleItemIdx].isVisible = false;
    }
    return [
        newOption
    ].concat(assignees.filter((assignee)=>assignee.id !== currentUser.id));
};
const $892be119e555b7f8$export$973ca22476b0e05f = (rest, shouldShowIssueLabelsFilter, config, currentProject, currentUser, isReportedByMeFilterEnabled)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { getFilterItemsByJiraScope: getFilterItemsByJiraScope, getProjectOptions: getProjectOptions, fetchIssueLabelOptions: fetchIssueLabelOptions, statusFilterOptions: statusFilterOptions } = (0, $71A0K.useFiltersClient)(config);
    const siteFilterDefinition = (0, $cgH2x.useSiteFilterDefinition)(rest.workspaces || [], (0, $4azzq.JIRA_PRODUCT_ID));
    const projectsFilterStore = (0, $kzbg7.useFilterStore)([], (0, $4azzq.JIRA_PRODUCT_ID), (0, $4azzq.JiraFilters).Projects);
    const assigneesFilterStore = (0, $kzbg7.useFilterStore)([], (0, $4azzq.JIRA_PRODUCT_ID), (0, $4azzq.JiraFilters).Assignees);
    const reportedByFilterStore = (0, $kzbg7.useFilterStore)([], (0, $4azzq.JIRA_PRODUCT_ID), (0, $4azzq.JiraFilters).ReportedBy);
    const statusFilterStore = (0, $kzbg7.useFilterStore)(statusFilterOptions, (0, $4azzq.JIRA_PRODUCT_ID), (0, $4azzq.JiraFilters).Status);
    const issueLabelsFilterStore = (0, $kzbg7.useFilterStore)([], (0, $4azzq.JIRA_PRODUCT_ID), (0, $4azzq.JiraFilters).IssueLabels);
    const loadFilters = (0, $gwFzn.useCallback)(()=>{
        projectsFilterStore.loadDefaultFilters(getProjectOptions().then((results)=>$892be119e555b7f8$export$fe780e7155e72c07(results, currentProject)));
        assigneesFilterStore.loadDefaultFilters(getFilterItemsByJiraScope((0, $4azzq.JiraScope).Assignee, '').then((results)=>$892be119e555b7f8$export$e54fe71d6476ce8f(results, currentUser)));
        if (shouldShowIssueLabelsFilter) issueLabelsFilterStore.loadDefaultFilters(fetchIssueLabelOptions(''));
        const defaultReportByOption = currentUser && currentUser.id ? {
            id: currentUser.id,
            label: formatMessage((0, $aZ2wG.messages).reported_by_me_filter_option),
            avatarUrl: '',
            isChecked: false,
            isVisible: true,
            filterSource: (0, $169DF.FilterOptionSource).CURRENT_USER
        } : undefined;
        if (defaultReportByOption && isReportedByMeFilterEnabled) reportedByFilterStore.setDefaultFilters([
            defaultReportByOption
        ]);
    }, [
        projectsFilterStore,
        getProjectOptions,
        assigneesFilterStore,
        getFilterItemsByJiraScope,
        shouldShowIssueLabelsFilter,
        currentUser,
        formatMessage,
        isReportedByMeFilterEnabled,
        currentProject,
        issueLabelsFilterStore,
        fetchIssueLabelOptions,
        reportedByFilterStore
    ]);
    const searchProject = (0, $gwFzn.useCallback)(async (query)=>{
        const result = await getFilterItemsByJiraScope((0, $4azzq.JiraScope).Project, query);
        return result?.map((item)=>({
                value: item,
                label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hUj82.FilterOptionItem), {
                    label: item.label,
                    iconProps: {
                        src: item.avatarUrl,
                        appearance: 'square'
                    }
                })
            })) || [];
    }, [
        getFilterItemsByJiraScope
    ]);
    const searchAssignee = (0, $gwFzn.useCallback)(async (query)=>{
        const result = await getFilterItemsByJiraScope((0, $4azzq.JiraScope).Assignee, query);
        return result?.map((item)=>({
                value: item,
                label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hUj82.FilterOptionItem), {
                    label: item.label,
                    iconProps: {
                        src: item.avatarUrl
                    }
                })
            })) || [];
    }, [
        getFilterItemsByJiraScope
    ]);
    const searchIssueLabels = (0, $gwFzn.useCallback)(async (query)=>{
        if (shouldShowIssueLabelsFilter) {
            const result = await fetchIssueLabelOptions(query);
            return result?.map((item)=>({
                    value: item,
                    label: item.label
                })) || [];
        }
        return [];
    }, [
        fetchIssueLabelOptions,
        shouldShowIssueLabelsFilter
    ]);
    const defaultValueGetter = (0, $gwFzn.useCallback)((availableFilters, valueKey = 'id')=>availableFilters.filter((f)=>f.isChecked && f[valueKey]).map((f)=>f[valueKey]), []);
    const appliedReportedByFilter = reportedByFilterStore?.availableFilters?.find((f)=>f.isChecked)?.id;
    const getReportedByMe = (0, $gwFzn.useCallback)(()=>{
        return appliedReportedByFilter ? {
            '@type': (0, $4azzq.JiraFilters).ReportedBy,
            accountIds: [
                appliedReportedByFilter
            ]
        } : null;
    }, [
        appliedReportedByFilter
    ]);
    const reportedByDefinition = isReportedByMeFilterEnabled ? [
        {
            ['@type']: (0, $4azzq.JiraFilters).ReportedBy,
            fieldName: 'accountIds',
            store: reportedByFilterStore,
            loadFilterOptions: async ()=>[],
            sectionLabel: formatMessage((0, $aZ2wG.messages).report_by_filters_title),
            findMoreLabel: '',
            mapSelectionToAppliedValue: getReportedByMe,
            filterConfig: {
                hideIcon: true,
                usePreloadedOptions: true,
                labelComponent: (0, $ly8Ih.FilterColLabText)
            }
        }
    ] : [];
    const appliedIssueLabelsFilters = (0, $gwFzn.useMemo)(()=>defaultValueGetter(issueLabelsFilterStore.availableFilters, 'label'), [
        defaultValueGetter,
        issueLabelsFilterStore.availableFilters
    ]);
    const getAppliedIssueLabels = (0, $gwFzn.useCallback)(()=>{
        if (appliedIssueLabelsFilters.length > 0) return {
            '@type': (0, $4azzq.JiraFilters).IssueLabels,
            issueLabels: appliedIssueLabelsFilters
        };
        return null;
    }, [
        appliedIssueLabelsFilters
    ]);
    const issueLabelsFilterDefinition = shouldShowIssueLabelsFilter ? [
        {
            ['@type']: (0, $4azzq.JiraFilters).IssueLabels,
            uiVariant: (0, $88j1D.FilterUIVariant).MULTI_SELECT,
            fieldName: 'issueLabels',
            store: issueLabelsFilterStore,
            loadFilterOptions: searchIssueLabels,
            sectionLabel: formatMessage((0, $aZ2wG.messages).issue_labels_filters_title),
            findMoreLabel: '',
            placeholderText: formatMessage((0, $aZ2wG.messages).issue_labels_filters_placeholder),
            mapSelectionToAppliedValue: getAppliedIssueLabels,
            filterConfig: {
                mainGroupLabel: formatMessage((0, $aZ2wG.messages).issue_labels_filters_options_group_label)
            }
        }
    ] : [];
    const filtersDefinition = [
        ...siteFilterDefinition,
        {
            ['@type']: (0, $4azzq.JiraFilters).Projects,
            fieldName: 'projectIds',
            store: projectsFilterStore,
            loadFilterOptions: searchProject,
            sectionLabel: formatMessage((0, $bF0iL.messages).project_filters_title),
            findMoreLabel: formatMessage((0, $bF0iL.messages).project_filters_find_more),
            filterConfig: {
                filterOptionIconShape: 'square'
            }
        },
        {
            ['@type']: (0, $4azzq.JiraFilters).Assignees,
            fieldName: 'accountIds',
            store: assigneesFilterStore,
            loadFilterOptions: searchAssignee,
            sectionLabel: formatMessage((0, $bF0iL.messages).assignee_filters_title),
            findMoreLabel: formatMessage((0, $bF0iL.messages).assignee_filters_find_more),
            filterConfig: {
                filterOptionIconShape: 'circle'
            }
        },
        ...reportedByDefinition,
        {
            ['@type']: (0, $4azzq.JiraFilters).Status,
            fieldName: 'binaryStatusCategories',
            store: statusFilterStore,
            loadFilterOptions: async ()=>[],
            sectionLabel: formatMessage((0, $bF0iL.messages).binary_status_category_filters_title),
            findMoreLabel: '',
            filterConfig: {
                filterGroupedBy: 'row',
                hideIcon: true,
                usePreloadedOptions: true
            }
        },
        ...issueLabelsFilterDefinition
    ];
    const filterValueGetters = (0, $gwFzn.useMemo)(()=>({
            projects: ()=>defaultValueGetter(projectsFilterStore.availableFilters),
            assignees: ()=>defaultValueGetter(assigneesFilterStore.availableFilters),
            statuses: ()=>defaultValueGetter(statusFilterStore.availableFilters),
            reportedBy: ()=>defaultValueGetter(reportedByFilterStore.availableFilters),
            issueLabels: ()=>shouldShowIssueLabelsFilter ? appliedIssueLabelsFilters : []
        }), [
        defaultValueGetter,
        projectsFilterStore.availableFilters,
        assigneesFilterStore.availableFilters,
        statusFilterStore.availableFilters,
        reportedByFilterStore.availableFilters,
        appliedIssueLabelsFilters,
        shouldShowIssueLabelsFilter
    ]);
    return {
        filterValueGetters: filterValueGetters,
        filtersDefinition: filtersDefinition,
        loadFilters: loadFilters
    };
};

});
parcelRegister("aZ2wG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $eabab0b86d11e1a1$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $eabab0b86d11e1a1$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    // NOT USED
    jira_boards_icon_accessibility_text: {
        id: "product_search_dialog.jira.boards_icon_accessibility_text",
        defaultMessage: "Board icon"
    },
    date_filter_today_label: {
        id: "product_search_dialog.jira.date_filter_today",
        defaultMessage: "Today"
    },
    date_filter_yesterday_label: {
        id: "product_search_dialog.jira.date_filter_yesterday",
        defaultMessage: "Yesterday"
    },
    date_filter_past_7_days_label: {
        id: "product_search_dialog.jira.date_filter_past_7_days",
        defaultMessage: "Past 7 days"
    },
    date_filter_past_30_days_label: {
        id: "product_search_dialog.jira.date_filter_past_30_days",
        defaultMessage: "Past 30 days"
    },
    date_filter_past_year_label: {
        id: "product_search_dialog.jira.date_filter_past_year",
        defaultMessage: "Past year"
    },
    report_by_filters_title: {
        id: "product_search_dialog.jira.report_by_filters",
        defaultMessage: "Filter by reporter"
    },
    reported_by_me_filter_option: {
        id: "product_search_dialog.jira.reported_by_me_filter",
        defaultMessage: "Reported by me"
    },
    issue_labels_filters_title: {
        id: "product_search_dialog.jira.issue_labels_filters",
        defaultMessage: "Filter by label"
    },
    issue_labels_filters_placeholder: {
        id: "product_search_dialog.jira.issue_labels_filters_placeholder",
        defaultMessage: "Select label"
    },
    issue_labels_filters_options_group_label: {
        id: "product_search_dialog.jira.issue_labels_filters_options_group_label",
        defaultMessage: "All labels"
    }
});

});

parcelRegister("71A0K", function(module, exports) {

$parcel$export(module.exports, "useFiltersClient", () => $941b6ab9222e6d09$export$86c53720f7942492);

var $dBxQj = parcelRequire("dBxQj");

var $bF0iL = parcelRequire("bF0iL");

var $4azzq = parcelRequire("4azzq");

var $169DF = parcelRequire("169DF");

var $cfEFl = parcelRequire("cfEFl");
var $c3kEC = parcelRequire("c3kEC");

var $kmpep = parcelRequire("kmpep");

var $aAuSn = parcelRequire("aAuSn");

var $csnse = parcelRequire("csnse");

var $lF5IG = parcelRequire("lF5IG");

var $cfEFl = parcelRequire("cfEFl");

var $jV49M = parcelRequire("jV49M");

var $dwp40 = parcelRequire("dwp40");

var $3S0fp = parcelRequire("3S0fp");
var $6dP89 = parcelRequire("6dP89");

var $7TH2w = parcelRequire("7TH2w");
// Jira uses this for performance monitoring/debugging
const $941b6ab9222e6d09$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
const $941b6ab9222e6d09$var$getCollabGraphClientWithConfig = (0, $csnse.default)((config)=>new (0, $cfEFl.CollaborationGraphClient)({
        collaborationGraphUrl: config.collaborationGraphUrl,
        cloudId: config.cloudId,
        isMultiSite: config.isMultiSite,
        sites: config.sites
    }), (0, (/*@__PURE__*/$parcel$interopDefault($aAuSn))));
const $941b6ab9222e6d09$var$MAX_VISIBLE_ITEMS = 3;
const $941b6ab9222e6d09$export$86c53720f7942492 = (config)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { jiraSites: jiraSites } = (0, $lF5IG.useSearchConfigContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const statusFilterOptions = [
        {
            id: 'open',
            filterSource: (0, $169DF.FilterOptionSource).STATIC,
            isChecked: false,
            isVisible: true,
            label: formatMessage((0, $bF0iL.messages).binary_status_category_filter_option_open)
        },
        {
            id: 'done',
            filterSource: (0, $169DF.FilterOptionSource).STATIC,
            isChecked: false,
            isVisible: true,
            label: formatMessage((0, $bF0iL.messages).binary_status_category_filter_option_done)
        }
    ];
    const jiraScopeFilterItemMapper = (item, isVisible, isRecent)=>({
            id: item.id,
            avatarUrl: item.avatarUrl || item.attributes?.avatar?.url,
            label: item.name,
            filterSource: isRecent ? (0, $169DF.FilterOptionSource).RECENT : (0, $169DF.FilterOptionSource).SEARCH,
            isChecked: false,
            isVisible: isVisible
        });
    const filterSupplier = async (currentScope, query, defaultItem)=>{
        if (!aggregatorClient) return [];
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: '',
                referrerId: null
            },
            scopes: [
                currentScope
            ],
            modelParams: [],
            resultLimit: (0, $4azzq.FILTER_LIST_LIMIT),
            experience: (0, $4azzq.NAVIGATION_V3_EXPERIENCE)
        }).then(({ response: response })=>{
            if (!response) throw (0, $c3kEC.responseErrorToError)(`Expected a response but did not get any for scope: ${currentScope}`);
            const scopedResponse = response.retrieveScope(currentScope);
            if (!scopedResponse) throw new Error(`Expected a response but did not get any for scope: ${currentScope}`);
            if (scopedResponse.error) throw (0, $c3kEC.responseErrorToError)(scopedResponse.error);
            const maxVisible = defaultItem !== undefined ? $941b6ab9222e6d09$var$MAX_VISIBLE_ITEMS - 1 : $941b6ab9222e6d09$var$MAX_VISIBLE_ITEMS;
            const options = scopedResponse.results.map((result, i)=>jiraScopeFilterItemMapper(result, i < maxVisible, query === ''));
            return defaultItem !== undefined ? [
                defaultItem,
                ...options
            ] : options;
        });
    };
    const fetchCollabGraphProjectOptions = async ()=>{
        const collabGraphClient = $941b6ab9222e6d09$var$getCollabGraphClientWithConfig({
            collaborationGraphUrl: config?.collaborationGraphUrl || (0, $4azzq.DEFAULT_COLLAB_GRAPH_URL),
            cloudId: config?.cloudId || '',
            isMultiSite: jiraSites?.length > 1,
            sites: jiraSites
        });
        return await collabGraphClient.getContainers([
            'jiraProject'
        ], jiraSites).then(({ collaborationGraphEntities: collaborationGraphEntities })=>{
            return collaborationGraphEntities.map((entity, i)=>({
                    label: entity.containerDetails.name,
                    id: entity.containerDetails.id,
                    avatarUrl: entity.containerDetails.iconUrl,
                    filterSource: (0, $169DF.FilterOptionSource).COLLABORATION_GRAPH,
                    isChecked: false,
                    isVisible: i < $941b6ab9222e6d09$var$MAX_VISIBLE_ITEMS
                }));
        });
    };
    const interleaveCGAndRecentResults = async (uniqueFn, collabGraphOptions)=>{
        if (collabGraphOptions?.length === (0, $cfEFl.MAX_CG_RESULTS)) return collabGraphOptions;
        else try {
            const recentOptions = await filterSupplier((0, $4azzq.JiraScope).Project, '');
            return collabGraphOptions?.length ? (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))([
                ...collabGraphOptions,
                ...recentOptions
            ], uniqueFn).map((item, i)=>({
                    ...item,
                    isVisible: i < $941b6ab9222e6d09$var$MAX_VISIBLE_ITEMS
                })) : recentOptions;
        } catch (e) {
            return collabGraphOptions?.length ? collabGraphOptions : [];
        }
    };
    const getProjectOptions = async ()=>{
        let collaborationGraphOptions;
        if (!!config?.cloudId) collaborationGraphOptions = await fetchCollabGraphProjectOptions();
        const interleavedResults = await interleaveCGAndRecentResults((project)=>project.id, collaborationGraphOptions);
        return interleavedResults;
    };
    const issueLabelFilterItemMapper = (issueLabel, isExternal)=>{
        return {
            id: (0, $3S0fp.sha256Hash)(`${config?.cloudId || ''}_${issueLabel.label}`),
            filterSource: isExternal ? (0, $169DF.FilterOptionSource).EXTERNAL : (0, $169DF.FilterOptionSource).SEARCH,
            isChecked: false,
            isVisible: isExternal,
            label: issueLabel.label
        };
    };
    const fireOperationalEvent = (payload)=>{
        fireAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            source: 'searchDialog',
            ...payload
        });
    };
    const fetchIssueLabelOptions = async (query)=>{
        const params = new URLSearchParams([
            [
                'query',
                query
            ]
        ]);
        const path = `${(0, $4azzq.DEFAULT_ISSUE_LABELS_SERVICE_URL)}?${params.toString()}`;
        const options = {
            requestInit: {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    [$941b6ab9222e6d09$var$CAPABILITY_HEADER_NAME]: 'PRODUCT_SEARCH_DIALOG'
                }
            }
        };
        try {
            return await (0, $dwp40.utils).requestService({
                url: path
            }, options).then((response)=>response?.suggestions?.map((issueLabel)=>issueLabelFilterItemMapper(issueLabel, query === '')));
        } catch (error) {
            fireOperationalEvent({
                action: 'failed',
                actionSubject: 'fetchIssueLabels',
                attributes: {
                    error: (0, $c3kEC.responseErrorToError)(error).message
                }
            });
            return [];
        }
    };
    return {
        mapJiraScopeFilterItem: jiraScopeFilterItemMapper,
        mapIssueLabelFilterItem: issueLabelFilterItemMapper,
        statusFilterOptions: statusFilterOptions,
        fetchIssueLabelOptions: fetchIssueLabelOptions,
        fetchCollabGraphProjectOptions: fetchCollabGraphProjectOptions,
        getProjectOptions: getProjectOptions,
        getFilterItemsByJiraScope: filterSupplier
    };
};

});

parcelRegister("ly8Ih", function(module, exports) {

$parcel$export(module.exports, "FilterColLabText", () => $d5b9dbc2d7e6b5ed$export$53582861b2eaced6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dTk3A = parcelRequire("dTk3A");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $d5b9dbc2d7e6b5ed$export$53582861b2eaced6 = (0, $gwrgp.default)("span", {
    target: "ekcv2vh0"
})({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $dTk3A.gridSize)() * 22}px`,
    paddingLeft: "var(--ds-space-050, 4px)",
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`
});

});


parcelRegister("hlU74", function(module, exports) {

$parcel$export(module.exports, "useSections", () => $8845a8b56f4b6117$export$5e1b8123b0df487f);

var $7UHDa = parcelRequire("7UHDa");

var $dh538 = parcelRequire("dh538");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $bF0iL = parcelRequire("bF0iL");

var $4azzq = parcelRequire("4azzq");

var $kbm4u = parcelRequire("kbm4u");

var $8WxPE = parcelRequire("8WxPE");

var $ejGzS = parcelRequire("ejGzS");

var $9PsEY = parcelRequire("9PsEY");

var $ekojD = parcelRequire("ekojD");

var $4JMD6 = parcelRequire("4JMD6");

var $gCJWJ = parcelRequire("gCJWJ");

var $hcMBV = parcelRequire("hcMBV");

const $8845a8b56f4b6117$var$HoverCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("5Vaiv")).then((mod)=>({
            default: mod.HoverCard
        })));
const $8845a8b56f4b6117$var$HoverCardResultWrapper = ({ children: children, url: url = '', titleId: titleId = '' })=>{
    const hidePreviewAction = (0, $gwFzn.useMemo)(()=>{
        return {
            hide: false,
            exclude: [
                (0, $hcMBV.CardAction).PreviewAction
            ]
        };
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9PsEY.HoverCardWrapper), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gCJWJ.default), {
            fallback: children,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Suspense, {
                fallback: children,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($8845a8b56f4b6117$var$HoverCard, {
                    url: url,
                    actionOptions: hidePreviewAction,
                    role: "dialog",
                    titleId: titleId,
                    children: children
                })
            })
        })
    });
};
const $8845a8b56f4b6117$var$viewAllLinkRendererIssues = ({ section: section, totalResults: totalResults })=>{
    const isTotalItemsGreaterThanTheLimit = (totalResults || section.searchResults?.length) > (section.resultLimit || 0);
    return isTotalItemsGreaterThanTheLimit ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...(0, $bF0iL.messages).common_show_all_results_link
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
};
const $8845a8b56f4b6117$export$5e1b8123b0df487f = (hasAdvancedRoadmapsAccess, hasSoftwareAccess, viewAllLinkGenerator, isPreviewOnJiraSearchResultsEnabled, intl, formatDate, isConsistentIssueDetailsEnabled, autocorrectEnabled)=>{
    const appendQueryParams = (0, $kbm4u.useQueryParams)();
    const mapJiraItems = (response)=>response.results.map((item)=>{
            const base = {
                id: item.id,
                title: item.name,
                url: appendQueryParams(item.url || '', item),
                meta: '',
                iconUrl: item.attributes?.avatar?.url || '',
                type: item.attributes['@type']
            };
            if (item.attributes && item.attributes['@type'] === (0, $8WxPE.AttributeType).issue) return {
                ...base,
                title: `${item.attributes?.key}  ${item.name}`,
                meta: item.attributes?.container?.title || '',
                containerId: item.attributes?.containerId,
                additionalMeta: (0, $ekojD.getTimeDetailForJiraIssueResult)(intl, formatDate, item.attributes?.updated)
            };
            if (item.attributes && item.attributes['@type'] === (0, $8WxPE.AttributeType).board) return {
                ...base,
                meta: item.attributes?.container?.title || '',
                containerId: item.attributes?.containerId
            };
            return base;
        });
    const getSectionDetailsByAccess = ()=>{
        if (hasAdvancedRoadmapsAccess) return {
            scope: (0, $4azzq.JiraScope).BoardProjectFilterPlans,
            recentHeading: (0, $bF0iL.messages).jira_recent_boards_projects_filters_plans_section_heading,
            searchHeading: (0, $bF0iL.messages).jira_boards_projects_filters_plans_section_heading
        };
        if (hasSoftwareAccess) return {
            scope: (0, $4azzq.JiraScope).BoardProjectFilter,
            recentHeading: (0, $bF0iL.messages).jira_recent_boards_projects_filters_section_heading,
            searchHeading: (0, $bF0iL.messages).jira_boards_projects_filters_section_heading
        };
        return {
            scope: (0, $4azzq.JiraScope).ProjectFilter,
            recentHeading: (0, $bF0iL.messages).jira_recent_projects_filters_section_heading,
            searchHeading: (0, $bF0iL.messages).jira_projects_filters_section_heading
        };
    };
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const secondSectionDetails = getSectionDetailsByAccess();
    const enableNoIssueSection = (query, filters)=>!filters.find((filter)=>filter['accountIds']?.length > 0 || filter['projectIds']?.length > 0 || filter['binaryStatusCategories']?.length > 0 || filter['issueLabels']?.length > 0);
    const resultRenderer = ()=>{
        return (args)=>(0, $ejGzS.defaultResultRenderer)(isConsistentIssueDetailsEnabled ? {
                ...args,
                isCollapsed: true
            } : args);
    };
    const sections = [
        {
            id: (0, $4azzq.JiraScope).Issue,
            title: formatMessage((0, $dh538.fg)('jira-issue-terminology-refresh-m3') ? (0, $bF0iL.messages).jira_issues_section_headingIssueTermRefresh : (0, $bF0iL.messages).jira_issues_section_heading),
            titleRenderer: (0, $4JMD6.sectionTitleRenderer)(!!autocorrectEnabled),
            scope: (0, $4azzq.JiraScope).Issue,
            resultMapper: mapJiraItems,
            showResultCount: true,
            resultLimit: (0, $4azzq.ISSUE_LIST_LIMIT),
            viewAllLinkRenderer: $8845a8b56f4b6117$var$viewAllLinkRendererIssues,
            resultRenderer: resultRenderer(),
            viewAllLinkGenerator: viewAllLinkGenerator,
            resultWrapper: isPreviewOnJiraSearchResultsEnabled ? $8845a8b56f4b6117$var$HoverCardResultWrapper : undefined
        },
        {
            id: secondSectionDetails.scope,
            title: formatMessage(secondSectionDetails.searchHeading),
            scope: secondSectionDetails.scope,
            resultMapper: mapJiraItems,
            isEnabled: enableNoIssueSection,
            resultLimit: hasAdvancedRoadmapsAccess ? (0, $4azzq.OTHERS_LIST_LIMIT_ADVANCED_ROADMAPS_ACCESS) : (0, $4azzq.OTHERS_LIST_LIMIT_NO_ADVANCED_ROADMAPS_ACCESS)
        }
    ];
    const recentSectionTitleGenerator = (section)=>section.id === (0, $4azzq.JiraScope).Issue ? formatMessage((0, $dh538.fg)('jira-issue-terminology-refresh-m3') ? (0, $bF0iL.messages).jira_recently_viewed_issues_section_headingIssueTermRefresh : (0, $bF0iL.messages).jira_recently_viewed_issues_section_heading) : formatMessage(secondSectionDetails.recentHeading);
    return {
        recentSectionTitleGenerator: recentSectionTitleGenerator,
        sections: sections,
        mapJiraItems: mapJiraItems,
        getSectionDetailsByAccess: getSectionDetailsByAccess
    };
};

});
parcelRegister("kbm4u", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $01f8562883944ff4$export$b37ee0d76c6d2fbc);
$parcel$export(module.exports, "appendQueryParams", () => $01f8562883944ff4$export$a0b32aef6b0d7373);

var $idlpk = parcelRequire("idlpk");

var $8WxPE = parcelRequire("8WxPE");

var $2OcMi = parcelRequire("2OcMi");
const $01f8562883944ff4$export$fd0142e43ea55591 = (href, searchResult)=>{
    const hrefWithReferrals = (0, $idlpk.attachJiraReferralIds)(href, {
        searchObjectId: searchResult.id,
        searchContainerId: searchResult.attributes.containerId,
        searchContentType: (0, $8WxPE.AttributeType).issue
    });
    return hrefWithReferrals;
};
const $01f8562883944ff4$export$8aceb1d6e8b68a94 = (href, searchResult)=>{
    const containerAttribute = searchResult.attributes['@type'] === (0, $8WxPE.AttributeType).board ? {
        searchContainerId: searchResult.attributes.containerId
    } : {};
    const contentTypeAttribute = {
        searchContentType: searchResult.attributes['@type']
    };
    const hrefWithReferrals = (0, $idlpk.attachJiraReferralIds)(href, {
        ...contentTypeAttribute,
        ...containerAttribute,
        searchObjectId: searchResult.id
    });
    return hrefWithReferrals;
};
const $01f8562883944ff4$export$b37ee0d76c6d2fbc = ()=>{
    return (href, searchResult)=>{
        if (searchResult.attributes['@type'] === (0, $8WxPE.AttributeType).issue) return $01f8562883944ff4$export$fd0142e43ea55591(href, searchResult);
        return $01f8562883944ff4$export$8aceb1d6e8b68a94(href, searchResult);
    };
};
const $01f8562883944ff4$export$a0b32aef6b0d7373 = (url, searchSessionId)=>{
    return (0, $2OcMi.addQueryParams)(url, {
        searchSessionId: searchSessionId
    });
};

});
parcelRegister("idlpk", function(module, exports) {

$parcel$export(module.exports, "attachJiraReferralIds", () => $71fe4fb99370a73e$export$6ad518df41ca9b2f);

var $2OcMi = parcelRequire("2OcMi");
const $71fe4fb99370a73e$export$6ad518df41ca9b2f = (href, ids)=>{
    return (0, $2OcMi.addQueryParams)(href, ids);
};

});


parcelRegister("9PsEY", function(module, exports) {

$parcel$export(module.exports, "HoverCardWrapper", () => $a3507ff98cccb432$export$54477ee883ec6167);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwrgp = parcelRequire("gwrgp");
const $a3507ff98cccb432$export$54477ee883ec6167 = (0, $gwrgp.default)("div", {
    target: "esh65ev0"
})({
    name: "7wh13m",
    styles: "display:block;width:100%;"
});

});

parcelRegister("ekojD", function(module, exports) {

$parcel$export(module.exports, "getTimeDetailForJiraIssueResult", () => $2dadc7da0d3cdd55$export$1d30bb3376c56ddb);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $bF0iL = parcelRequire("bF0iL");

var $RTf6z = parcelRequire("RTf6z");
const $2dadc7da0d3cdd55$export$1d30bb3376c56ddb = (intl, formatDate, updated)=>{
    if (!updated) {
        const message = intl.formatMessage((0, $bF0iL.messages).common_recently_viewed_section_heading);
        return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            title: message,
            children: message
        });
    }
    if (formatDate) return formatDate(updated);
    else return (0, $RTf6z.dateFormatter)(updated);
};

});
parcelRegister("RTf6z", function(module, exports) {

$parcel$export(module.exports, "dateFormatter", () => $e5e658f2850ebd6c$export$406508d2ca449bd);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $hrzSy = parcelRequire("hrzSy");

var $bF0iL = parcelRequire("bF0iL");
const $e5e658f2850ebd6c$var$SECONDS_IN_MIN = 60;
const $e5e658f2850ebd6c$var$SECONDS_IN_HR = $e5e658f2850ebd6c$var$SECONDS_IN_MIN * 60;
const $e5e658f2850ebd6c$var$SECONDS_IN_DAY = $e5e658f2850ebd6c$var$SECONDS_IN_HR * 24;
const $e5e658f2850ebd6c$export$be5e766167e613a9 = {
    commented: (0, $bF0iL.commentedEventTypeMessages),
    created: (0, $bF0iL.createdEventTypeMessages),
    edited: (0, $bF0iL.editedEventTypeMessages),
    published: (0, $bF0iL.publishedEventTypeMessages),
    updated: (0, $bF0iL.updatedEventTypeMessages),
    viewed: (0, $bF0iL.viewedEventTypeMessages)
};
const $e5e658f2850ebd6c$var$WithUpdatedLabel = (formattedDate)=>{
    const i18nMessage = (0, $bF0iL.messages).common_updated_date_formatter;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...i18nMessage,
        values: {
            date: formattedDate
        }
    });
};
const $e5e658f2850ebd6c$var$recentEventLabel = (eventType)=>{
    const i18nMessage = eventType ? $e5e658f2850ebd6c$export$be5e766167e613a9[eventType] || (0, $bF0iL.defaultEventTypeMessages) : (0, $bF0iL.defaultEventTypeMessages);
    return (formattedDate)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...i18nMessage.relative,
            values: {
                date: formattedDate
            }
        });
};
const $e5e658f2850ebd6c$var$absoluteRecentEventLabel = (eventType)=>{
    const i18nMessage = eventType ? $e5e658f2850ebd6c$export$be5e766167e613a9[eventType] || (0, $bF0iL.defaultEventTypeMessages) : (0, $bF0iL.defaultEventTypeMessages);
    return (formattedDate)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...i18nMessage.absolute,
            values: {
                date: formattedDate
            }
        });
};
function $e5e658f2850ebd6c$export$406508d2ca449bd(lastModified, isRecentActivity, eventType) {
    const secondsSinceUpdate = Math.floor((Date.now() - new Date(lastModified).getTime()) / 1000);
    const totalDays = Math.floor(secondsSinceUpdate / $e5e658f2850ebd6c$var$SECONDS_IN_DAY);
    const totalHours = Math.floor(secondsSinceUpdate / $e5e658f2850ebd6c$var$SECONDS_IN_HR);
    const totalMinutes = Math.floor(secondsSinceUpdate / $e5e658f2850ebd6c$var$SECONDS_IN_MIN);
    if (secondsSinceUpdate > 1 && secondsSinceUpdate < 60) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hrzSy.default), {
        value: -secondsSinceUpdate,
        style: "narrow",
        unit: "second",
        children: isRecentActivity ? $e5e658f2850ebd6c$var$recentEventLabel(eventType) : $e5e658f2850ebd6c$var$WithUpdatedLabel
    });
    if (totalMinutes >= 1 && totalMinutes < 60) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hrzSy.default), {
        value: -totalMinutes,
        style: "narrow",
        unit: "minute",
        children: isRecentActivity ? $e5e658f2850ebd6c$var$recentEventLabel(eventType) : $e5e658f2850ebd6c$var$WithUpdatedLabel
    });
    if (totalHours >= 1 && totalHours < 24) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hrzSy.default), {
        value: -totalHours,
        style: "narrow",
        unit: "hour",
        children: isRecentActivity ? $e5e658f2850ebd6c$var$recentEventLabel(eventType) : $e5e658f2850ebd6c$var$WithUpdatedLabel
    });
    if (totalDays >= 1 && totalDays < 8) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hrzSy.default), {
        value: -totalDays,
        style: "narrow",
        unit: "day",
        children: isRecentActivity ? $e5e658f2850ebd6c$var$recentEventLabel(eventType) : $e5e658f2850ebd6c$var$WithUpdatedLabel
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2nPZH.FormattedDate), {
        year: "numeric",
        month: "short",
        day: "2-digit",
        value: lastModified,
        children: isRecentActivity ? $e5e658f2850ebd6c$var$absoluteRecentEventLabel(eventType) : $e5e658f2850ebd6c$var$WithUpdatedLabel
    });
}

});


parcelRegister("4JMD6", function(module, exports) {

$parcel$export(module.exports, "sectionTitleRenderer", () => $6d4c433494a08e6d$export$aee00814c9e3bae7);

var $7UHDa = parcelRequire("7UHDa");

var $dh538 = parcelRequire("dh538");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $bF0iL = parcelRequire("bF0iL");

var $jFPud = parcelRequire("jFPud");

var $eEbYb = parcelRequire("eEbYb");

var $21MH9 = parcelRequire("21MH9");
const $6d4c433494a08e6d$export$aee00814c9e3bae7 = (autocorrectEnabled)=>(args)=>{
        const { productState: productState } = args;
        const recentTitle = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $bF0iL.messages).common_recently_viewed_section_heading
        });
        const issuesTitleMessage = (0, $dh538.fg)('jira-issue-terminology-refresh-m3') ? (0, $bF0iL.messages).jira_issues_section_headingIssueTermRefresh : (0, $bF0iL.messages).jira_issues_section_heading;
        const issuesTitle = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...issuesTitleMessage
        });
        switch(productState){
            case (0, $jFPud.ProductStates).PreQuerySuccess:
                return recentTitle;
            case (0, $jFPud.ProductStates).PostQueryLoading:
                if (autocorrectEnabled) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEbYb.LoadingSkeleton), {
                    "data-testid": 'autocorrection-loading-skeleton'
                });
                return issuesTitle;
            case (0, $jFPud.ProductStates).PostQuerySuccess:
                if (autocorrectEnabled) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $21MH9.AutocorrectAsyncWrapper), {
                    fallback: issuesTitle
                });
                return issuesTitle;
            default:
                return issuesTitle;
        }
    };

});

parcelRegister("gCJWJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b77b2477746b3ccd$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
class $b77b2477746b3ccd$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    static getDerivedStateFromError(_) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        this.props.onError && this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
var $b77b2477746b3ccd$export$2e2bcd8739ae039 = $b77b2477746b3ccd$var$ErrorBoundary;

});

parcelRegister("5Vaiv", function(module, exports) {

let $44fa437a804eaa2f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $44fa437a804eaa2f$var$load("i73Fi"),
    $44fa437a804eaa2f$var$load("4Bp5z"),
    $44fa437a804eaa2f$var$load("eyMrr"),
    $44fa437a804eaa2f$var$load("ffEVr"),
    $44fa437a804eaa2f$var$load("dTsOE"),
    $44fa437a804eaa2f$var$load("aZinD"),
    $44fa437a804eaa2f$var$load("joJy8"),
    $44fa437a804eaa2f$var$load("aHE9G"),
    $44fa437a804eaa2f$var$load("5i7Tn"),
    $44fa437a804eaa2f$var$load("EfTik")
]).then(()=>parcelRequire('1JhVb'));

});


parcelRegister("btY8w", function(module, exports) {

$parcel$export(module.exports, "useURLFactory", () => $418b29c7f9ac3680$export$f63780fc2b3633e);

var $gwFzn = parcelRequire("gwFzn");

var $4azzq = parcelRequire("4azzq");
/**
 * Builds a JQL query for text search input using summary and description
 */ const $418b29c7f9ac3680$var$buildTextSearchInputJql = (query)=>{
    if (!query) return '';
    const encodedQuery = encodeURIComponent(query);
    return `textfields ~ "${encodedQuery}*"`;
};
const $418b29c7f9ac3680$var$buildJQLAdvancedIssueUrl = (jql)=>`/issues/?jql=${jql}`;
const $418b29c7f9ac3680$var$buildJiraSearchUrl = (query)=>`/jira/search?searchString=${encodeURIComponent(query)}`;
const $418b29c7f9ac3680$var$buildSmartQueryAdvancedSearchUrl = (query)=>`/secure/QuickSearch.jspa?searchString=${encodeURIComponent(query)}`;
const $418b29c7f9ac3680$var$escapeAndQuoteLabels = (label)=>{
    // Escape backslashes and double quotes
    const escapedLabel = label.replace(/([\\"])/g, '\\$1');
    // Wrap the escaped label in double quotes
    return `"${escapedLabel}"`;
};
const $418b29c7f9ac3680$var$buildJqlQuery = (query, projectIds, accountIds, reporterIds, binaryStatusCategoryValues, issueLabels, appliedDateFilterValue, isSearchWithTextFieldInAllIssuesLinkEnabled)=>{
    let textJQL;
    if (isSearchWithTextFieldInAllIssuesLinkEnabled) textJQL = query ? `text ~ "${encodeURIComponent(query)}*"` : '';
    else textJQL = query ? $418b29c7f9ac3680$var$buildTextSearchInputJql(query) : '';
    const projectJQL = projectIds.length > 0 ? `project IN (${encodeURIComponent(projectIds.join(','))})` : '';
    const assigneeJQL = accountIds.length > 0 ? `assignee IN (${encodeURIComponent(accountIds.join(','))})` : '';
    const issueLabelsJQL = issueLabels.length > 0 ? `labels IN (${encodeURIComponent(issueLabels.map((label)=>$418b29c7f9ac3680$var$escapeAndQuoteLabels(label)).join(','))})` : '';
    const reporterJQL = reporterIds.length > 0 ? `reporter IN (${encodeURIComponent(reporterIds.join(','))})` : '';
    const updateDateJQL = appliedDateFilterValue !== null ? `updated >= "${appliedDateFilterValue.from}" AND updated <= "${appliedDateFilterValue.to}"` : '';
    const binaryStatusCategoryJQL = binaryStatusCategoryValues?.length === 1 ? `statusCategory IN (${encodeURIComponent($418b29c7f9ac3680$var$getStatusesByStatusCategory(binaryStatusCategoryValues))})` : '';
    return [
        textJQL,
        projectJQL,
        assigneeJQL,
        reporterJQL,
        binaryStatusCategoryJQL,
        issueLabelsJQL,
        updateDateJQL
    ].filter(Boolean).join(' AND ');
};
const $418b29c7f9ac3680$var$getStatusesByStatusCategory = (values)=>{
    if (!!values.find((v)=>v === 'open')) return '"undefined", "In Progress", "To Do"';
    if (!!values.find((v)=>v === 'done')) return '"Done"';
    return '';
};
const $418b29c7f9ac3680$export$f63780fc2b3633e = (filterValueGetters, appliedDateFilterValue, isPreQueryFiltersEnabled, isSearchWithTextFieldInAllIssuesLinkEnabled = false)=>{
    const buildJiraAdvancedSearchPath = (0, $gwFzn.useCallback)((query)=>{
        const trimmedQuery = query.trim();
        const projectIds = filterValueGetters.projects();
        const accountIds = filterValueGetters.assignees();
        const reporterIds = filterValueGetters.reportedBy();
        const binaryStatusCategories = filterValueGetters.statuses();
        const issueLabels = filterValueGetters.issueLabels();
        // If there is a filter applied, and either a query is provided or isPreQueryFiltersEnabled is true, then we build the JQL
        if ((projectIds.length !== 0 || accountIds.length !== 0 || reporterIds.length !== 0 || binaryStatusCategories.length === 1 || issueLabels.length !== 0 || appliedDateFilterValue !== null) && (trimmedQuery || isPreQueryFiltersEnabled)) return $418b29c7f9ac3680$var$buildJQLAdvancedIssueUrl($418b29c7f9ac3680$var$buildJqlQuery(trimmedQuery, projectIds, accountIds, reporterIds, binaryStatusCategories, issueLabels, appliedDateFilterValue, isSearchWithTextFieldInAllIssuesLinkEnabled));
        // Otherwise we determine next action based on whether a query is provided or not
        if (!trimmedQuery) // If query is empty, we utilise a spa transition with ISSUE_NAVIGATOR_URL
        return query === '' ? (0, $4azzq.ISSUE_NAVIGATOR_URL) : $418b29c7f9ac3680$var$buildSmartQueryAdvancedSearchUrl(query);
        return $418b29c7f9ac3680$var$buildJiraSearchUrl(trimmedQuery);
    }, [
        filterValueGetters,
        appliedDateFilterValue,
        isPreQueryFiltersEnabled,
        isSearchWithTextFieldInAllIssuesLinkEnabled
    ]);
    const useFiltersAdvancedSearchUrlFactory = (0, $gwFzn.useCallback)((query, siteUrl)=>`${siteUrl ?? ''}${buildJiraAdvancedSearchPath(query)}`, [
        buildJiraAdvancedSearchPath
    ]);
    return {
        getFiltersAdvancedSearchUrl: useFiltersAdvancedSearchUrlFactory
    };
};

});

parcelRegister("1Yciq", function(module, exports) {

$parcel$export(module.exports, "JiraAdvancedSearch", () => $2ede78aae473f56f$export$f8ed21c35936f5aa);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $lnXRc = parcelRequire("lnXRc");

var $5dFS9 = parcelRequire("5dFS9");

var $bF0iL = parcelRequire("bF0iL");

var $dBxQj = parcelRequire("dBxQj");

var $bKrl4 = parcelRequire("bKrl4");
const $2ede78aae473f56f$export$f5d288a16f3b101c = (props)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bKrl4.GetDefaultFooter), {
            returnKeyIconComponent: props.returnKeyIconComponent,
            linkComponent: props.linkComponent,
            productState: props.productState,
            searchFooterLabel: formatMessage((0, $dh538.fg)('jira-issue-terminology-refresh-m3') ? (0, $bF0iL.messages).jira_view_all_issues_newIssueTermRefresh : (0, $bF0iL.messages).jira_view_all_issues_new)
        })
    });
};
const $2ede78aae473f56f$export$f8ed21c35936f5aa = (0, $lnXRc.withAnalytics)({
    advancedSearchSelected: (0, $5dFS9.onAdvancedSearchSelected)
})($2ede78aae473f56f$export$f5d288a16f3b101c);
var $2ede78aae473f56f$export$2e2bcd8739ae039 = $2ede78aae473f56f$export$f8ed21c35936f5aa;

});
parcelRegister("bKrl4", function(module, exports) {

$parcel$export(module.exports, "GetDefaultFooter", () => $a98761a6028dbe88$export$e3c8b9bd86c3cfd6);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4mZlP = parcelRequire("4mZlP");

var $crAJ1 = parcelRequire("crAJ1");
const $a98761a6028dbe88$export$e3c8b9bd86c3cfd6 = ({ productState: productState, ...rest })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.AdvancedSearchFooter), {
            ...rest
        })
    });
};

});


parcelRegister("dKB22", function(module, exports) {

$parcel$export(module.exports, "defaultPermissionsSupplier", () => $4b29f03d0096a2d7$export$79b79eb7219cb5fd);

var $8WxPE = parcelRequire("8WxPE");
const $4b29f03d0096a2d7$export$79b79eb7219cb5fd = ()=>{
    const response = Object.values((0, $8WxPE.Scope));
    return Promise.resolve(response);
};

});

parcelRegister("iE5Vg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca3b19d515fa565d$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $3S0fp = parcelRequire("3S0fp");

var $5dFS9 = parcelRequire("5dFS9");

var $bF0iL = parcelRequire("bF0iL");

var $2ZIpG = parcelRequire("2ZIpG");

var $ebWzW = parcelRequire("ebWzW");
const $ca3b19d515fa565d$export$4c85ccfa2dce935c = (query, features)=>{
    let allLinks = {
        board: {
            href: `/secure/ManageRapidViews.jspa?contains=${query}`,
            message: (0, $bF0iL.messages).jira_advanced_search_boards,
            actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).JIRA_BOARDS
        },
        project: {
            href: `/projects?contains=${query}`,
            message: (0, $bF0iL.messages).jira_advanced_search_projects,
            actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).JIRA_PROJECTS
        },
        filters: {
            href: `/secure/ManageFilters.jspa?Search=Search&filterView=search&name=${query}`,
            message: (0, $bF0iL.messages).jira_advanced_search_filters,
            actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).JIRA_FILTERS
        },
        plans: {
            href: `/jira/plans`,
            message: (0, $bF0iL.messages).jira_advanced_search_plans,
            actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).JIRA_PLANS
        },
        people: {
            href: `/jira/people/search?q=${query}`,
            message: (0, $bF0iL.messages).jira_advanced_search_people,
            actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).JIRA_PEOPLE
        }
    };
    // Remove access to plans if the user does not have Advanced Roadmaps access
    if (!features?.hasAdvancedRoadmapsAccess) delete allLinks.plans;
    // Remove access to boards if the user does not have software access
    if (!features?.hasAdvancedRoadmapsAccess && !features?.hasSoftwareAccess) delete allLinks.board;
    return allLinks;
};
const $ca3b19d515fa565d$export$b16edfe49ade2612 = ({ advancedSearchSelected: advancedSearchSelected, features: features, linkComponent: linkComponent })=>{
    const { query: query, isLoading: isLoading } = (0, $2ZIpG.useQuery)();
    const onClickAndFireEvent = (e, actionSubjectId)=>{
        e.preventDefault();
        advancedSearchSelected({
            actionSubjectId: actionSubjectId,
            trigger: (0, $3S0fp.getTrigger)(e),
            isLoading: isLoading,
            newTab: (0, $3S0fp.isNewTab)(e)
        });
    };
    const searchConfiguration = $ca3b19d515fa565d$export$4c85ccfa2dce935c(query, features);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ebWzW.AdvancedSearchContainer), {
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
            as: "ul",
            xcss: $ca3b19d515fa565d$var$advancedSearchListStyles,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ebWzW.LabelContainer), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...(0, $bF0iL.messages).jira_advanced_search_label
                    })
                }),
                Object.keys(searchConfiguration).map((key)=>{
                    const { href: href, message: message, actionSubjectId: actionSubjectId } = searchConfiguration[key];
                    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        as: "li",
                        xcss: $ca3b19d515fa565d$var$advancedSearchListItemStyles,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                            onClick: (e)=>onClickAndFireEvent(e, actionSubjectId),
                            role: "none",
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ebWzW.StyledLink), {
                                linkComponent: linkComponent,
                                href: href,
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                    ...message
                                })
                            }, `search_link_${key}`)
                        })
                    });
                })
            ]
        })
    });
};
const $ca3b19d515fa565d$var$advancedSearchListStyles = (0, $ecnYn.xcss)({
    padding: '0',
    margin: '0',
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'row'
});
const $ca3b19d515fa565d$var$advancedSearchListItemStyles = (0, $ecnYn.xcss)({
    margin: '0',
    padding: '0'
});
var $ca3b19d515fa565d$export$2e2bcd8739ae039 = (0, $js7oX.default)($ca3b19d515fa565d$export$b16edfe49ade2612);

});
parcelRegister("ebWzW", function(module, exports) {

$parcel$export(module.exports, "AdvancedSearchContainer", () => $34cfde37e0470e3c$export$cb4aeb4aba07ad10);
$parcel$export(module.exports, "LabelContainer", () => $34cfde37e0470e3c$export$f5ae33f1b01a6402);
$parcel$export(module.exports, "StyledLink", () => $34cfde37e0470e3c$export$9048d548939551ee);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $kPBHE = parcelRequire("kPBHE");

var $gwrgp = parcelRequire("gwrgp");
const $34cfde37e0470e3c$export$cb4aeb4aba07ad10 = (0, $gwrgp.default)("div", {
    target: "eq9f4ne0"
})({
    name: "1jz6vo9",
    styles: "padding:var(--ds-space-200, 16px);"
});
const $34cfde37e0470e3c$export$f5ae33f1b01a6402 = (0, $gwrgp.default)("span", {
    target: "eq9f4ne1"
})({
    marginRight: "var(--ds-space-100, 8px)",
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`,
    '&:hover, &:focus': {
        color: `var(--ds-text, ${(0, $6fnsQ.N900)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':visited': {
        color: `var(--ds-text, ${(0, $6fnsQ.N900)})`
    }
});
const $34cfde37e0470e3c$export$9048d548939551ee = /*#__PURE__*/ (0, $gwrgp.default)((0, $kPBHE.Link), {
    target: "eq9f4ne2"
})({
    WebkitBoxAlign: 'baseline',
    alignItems: 'baseline',
    boxSizing: 'border-box',
    display: 'inline-flex',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    textAlign: 'center',
    whiteSpace: 'nowrap',
    borderRadius: '3px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-150, 8px)"}`,
    marginRight: "var(--ds-space-050, 4px)",
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`,
    backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N20)})`,
    transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`,
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $6fnsQ.N30)})`,
        textDecoration: 'none',
        transition: 'background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
    },
    '&:visited, &:focus-visible, &:focus': {
        color: `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`
    }
});

});


parcelRegister("3cM77", function(module, exports) {

$parcel$export(module.exports, "default", () => $542edd51ae7cea6d$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $a7YLG = parcelRequire("a7YLG");

var $js7oX = parcelRequire("js7oX");

var $bF0iL = parcelRequire("bF0iL");

const $542edd51ae7cea6d$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("gOGN4")));
const $542edd51ae7cea6d$var$NoPreQueryResults = ({ intl: intl, message: message })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7YLG.EmptyState), {
        title: intl.formatMessage(message || (0, $bF0iL.messages).common_empty_state_prequery_heading),
        Image: $542edd51ae7cea6d$var$Image
    });
var $542edd51ae7cea6d$export$2e2bcd8739ae039 = (0, $js7oX.default)($542edd51ae7cea6d$var$NoPreQueryResults);

});
parcelRegister("gOGN4", function(module, exports) {

let $c3e28228a18a4253$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c3e28228a18a4253$var$load("3BloW").then(()=>parcelRequire('4SDWJ'));

});


parcelRegister("5906J", function(module, exports) {

$parcel$export(module.exports, "useJiraDateFilter", () => $ad28263e005306c5$export$ab45d91883e25704);

var $gwFzn = parcelRequire("gwFzn");

var $4azzq = parcelRequire("4azzq");

var $169DF = parcelRequire("169DF");

var $88j1D = parcelRequire("88j1D");
var $kzbg7 = parcelRequire("kzbg7");

var $aZ2wG = parcelRequire("aZ2wG");

var $bF0iL = parcelRequire("bF0iL");

var $dBxQj = parcelRequire("dBxQj");
// The toOffset default is -1 because the 'to' date is not inclusive,
//  so we set it to the tomorrow's date to include results from today
const $ad28263e005306c5$var$getDateRange = (fromOffset, toOffset = -1)=>{
    const from = new Date();
    const to = new Date();
    from.setDate(from.getDate() - fromOffset);
    to.setDate(to.getDate() - toOffset);
    return {
        from: from.toISOString().split('T')[0],
        to: to.toISOString().split('T')[0]
    };
};
const $ad28263e005306c5$export$ab45d91883e25704 = ({ isDateFromFilterEnabled: isDateFromFilterEnabled })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const dateFilterOptionsAndValues = (0, $gwFzn.useMemo)(()=>{
        return !isDateFromFilterEnabled ? null : {
            [(0, $88j1D.LastModifiedValues).DEFAULT]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).DEFAULT,
                    label: formatMessage((0, $bF0iL.messages).date_filter_any_time_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: true,
                    isVisible: true
                },
                dateRange: {
                    from: '',
                    to: ''
                }
            },
            [(0, $88j1D.LastModifiedValues).TODAY]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).TODAY,
                    label: formatMessage((0, $aZ2wG.messages).date_filter_today_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $ad28263e005306c5$var$getDateRange(0)
            },
            [(0, $88j1D.LastModifiedValues).YESTERDAY]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).YESTERDAY,
                    label: formatMessage((0, $aZ2wG.messages).date_filter_yesterday_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $ad28263e005306c5$var$getDateRange(1, 0)
            },
            [(0, $88j1D.LastModifiedValues).PAST_SEVEN_DAYS]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_SEVEN_DAYS,
                    label: formatMessage((0, $aZ2wG.messages).date_filter_past_7_days_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $ad28263e005306c5$var$getDateRange(7)
            },
            [(0, $88j1D.LastModifiedValues).PAST_THIRTY_DAYS]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_THIRTY_DAYS,
                    label: formatMessage((0, $aZ2wG.messages).date_filter_past_30_days_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $ad28263e005306c5$var$getDateRange(30)
            },
            [(0, $88j1D.LastModifiedValues).PAST_YEAR]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_YEAR,
                    label: formatMessage((0, $aZ2wG.messages).date_filter_past_year_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $ad28263e005306c5$var$getDateRange(365)
            }
        };
    }, [
        isDateFromFilterEnabled,
        formatMessage
    ]);
    const dateFilterOptions = (0, $gwFzn.useMemo)(()=>dateFilterOptionsAndValues ? Object.values(dateFilterOptionsAndValues).map((value)=>value.filter) : [], [
        dateFilterOptionsAndValues
    ]);
    const dateFilterStore = (0, $kzbg7.useFilterStore)(dateFilterOptions, (0, $4azzq.JIRA_PRODUCT_ID), (0, $4azzq.JiraFilters).Date);
    const appliedDateFilter = dateFilterStore?.availableFilters?.find((f)=>f.isChecked && f.id !== (0, $88j1D.DEFAULT_OPTION))?.id;
    const appliedDateFilterValue = appliedDateFilter && dateFilterOptionsAndValues && dateFilterOptionsAndValues[appliedDateFilter] ? dateFilterOptionsAndValues[appliedDateFilter].dateRange : null;
    const getLastModifiedValue = (0, $gwFzn.useCallback)(()=>{
        return appliedDateFilterValue ? {
            '@type': (0, $4azzq.JiraFilters).Date,
            from: appliedDateFilterValue.from,
            to: appliedDateFilterValue.to
        } : null;
    }, [
        appliedDateFilterValue
    ]);
    const jiraTabDateFilterDefinition = (0, $gwFzn.useMemo)(()=>{
        return isDateFromFilterEnabled ? [
            {
                ['@type']: (0, $4azzq.JiraFilters).Date,
                uiVariant: (0, $88j1D.FilterUIVariant).STATIC_SELECT,
                fieldName: 'from',
                store: dateFilterStore,
                loadFilterOptions: async ()=>[],
                sectionLabel: formatMessage((0, $bF0iL.messages).date_filter_filters_title),
                findMoreLabel: '',
                mapSelectionToAppliedValue: ()=>getLastModifiedValue()
            }
        ] : [];
    }, [
        isDateFromFilterEnabled,
        dateFilterStore,
        formatMessage,
        getLastModifiedValue
    ]);
    return {
        appliedDateFilterValue: appliedDateFilterValue,
        jiraTabDateFilterDefinition: jiraTabDateFilterDefinition,
        dateFilterOptionsAndValues: dateFilterOptionsAndValues
    };
};

});


parcelRegister("4d43O", function(module, exports) {

$parcel$export(module.exports, "FilterContextProvider", () => $67a90fc752dffcfd$export$eb71bf38f5ae0f9c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $hpDfc = parcelRequire("hpDfc");

var $jnLgC = parcelRequire("jnLgC");

var $169DF = parcelRequire("169DF");

var $bF0iL = parcelRequire("bF0iL");

var $hYymy = parcelRequire("hYymy");
var $67a90fc752dffcfd$var$_BinaryStatusCategory;
const $67a90fc752dffcfd$var$BROCCOLI_30_EXPERIMENT = {
    experimentId: 'broccoli-30-frontend',
    days: 30
};
const $67a90fc752dffcfd$var$BROCCOLI_60_EXPERIMENT = {
    experimentId: 'broccoli-60-frontend',
    days: 60
};
const $67a90fc752dffcfd$var$BROCCOLI_90_EXPERIMENT = {
    experimentId: 'broccoli-90-frontend',
    days: 90
};
const $67a90fc752dffcfd$export$40e7ffc2d13a061c = [
    $67a90fc752dffcfd$var$BROCCOLI_30_EXPERIMENT,
    $67a90fc752dffcfd$var$BROCCOLI_60_EXPERIMENT,
    $67a90fc752dffcfd$var$BROCCOLI_90_EXPERIMENT
];
class $67a90fc752dffcfd$export$bea22cefe0b3447c {
    constructor(id, jqlValue){
        this.id = void 0;
        this.jqlValue = void 0;
        this.id = id;
        this.jqlValue = jqlValue;
    }
}
$67a90fc752dffcfd$var$_BinaryStatusCategory = $67a90fc752dffcfd$export$bea22cefe0b3447c;
$67a90fc752dffcfd$export$bea22cefe0b3447c.OPEN = new $67a90fc752dffcfd$var$_BinaryStatusCategory('open', '"undefined", "In Progress", "To Do"');
$67a90fc752dffcfd$export$bea22cefe0b3447c.DONE = new $67a90fc752dffcfd$var$_BinaryStatusCategory('done', '"Done"');
const $67a90fc752dffcfd$export$b5d1c2ef6aead4e6 = [
    {
        title: (0, $bF0iL.messages).binary_status_category_filter_option_open,
        id: $67a90fc752dffcfd$export$bea22cefe0b3447c.OPEN.id,
        isChecked: false,
        isVisible: true,
        filterSource: (0, $169DF.FilterOptionSource).STATIC
    },
    {
        title: (0, $bF0iL.messages).binary_status_category_filter_option_done,
        id: $67a90fc752dffcfd$export$bea22cefe0b3447c.DONE.id,
        isChecked: false,
        isVisible: true,
        filterSource: (0, $169DF.FilterOptionSource).STATIC
    }
];
const $67a90fc752dffcfd$export$973ca22476b0e05f = (defaultFilters = [])=>{
    const { filters: filters, dispatch: dispatch } = (0, $jnLgC.useFilter)(defaultFilters);
    const addFilters = (0, $gwFzn.useCallback)((newFilters)=>dispatch((0, $jnLgC.addFilters)(newFilters, (a, b)=>{
            if (a.filterSource === (0, $169DF.FilterOptionSource).CURRENT_USER && b.filterSource !== (0, $169DF.FilterOptionSource).CURRENT_USER) return -1;
            if (a.filterSource !== (0, $169DF.FilterOptionSource).CURRENT_USER && b.filterSource === (0, $169DF.FilterOptionSource).CURRENT_USER) return 1;
            return 0;
        })), [
        dispatch
    ]);
    const updateFilter = (0, $gwFzn.useCallback)((id, isChecked)=>dispatch((0, $jnLgC.updateFilterState)(id, isChecked, true)), [
        dispatch
    ]);
    const clearFilter = (0, $gwFzn.useCallback)(()=>{
        filters.forEach((f)=>dispatch((0, $jnLgC.updateFilterState)(f.id, false)));
    }, [
        filters,
        dispatch
    ]);
    const resetFilter = (0, $gwFzn.useCallback)(()=>{
        dispatch((0, $jnLgC.replaceAllFilters)(defaultFilters));
    }, [
        defaultFilters,
        dispatch
    ]);
    return {
        availableFilters: filters,
        addFilters: addFilters,
        updateFilter: updateFilter,
        clearFilter: clearFilter,
        reset: resetFilter,
        dispatch: dispatch
    };
};
const $67a90fc752dffcfd$var$DEFAULT_FILTER_STATE = {
    availableFilters: [],
    addFilters: ()=>{},
    updateFilter: ()=>{},
    clearFilter: ()=>{},
    reset: ()=>{},
    dispatch: ()=>{}
};
const $67a90fc752dffcfd$var$FilterContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    projectFilters: $67a90fc752dffcfd$var$DEFAULT_FILTER_STATE,
    assigneeFilters: $67a90fc752dffcfd$var$DEFAULT_FILTER_STATE,
    siteFilters: $67a90fc752dffcfd$var$DEFAULT_FILTER_STATE,
    binaryStatusCategoryFilters: $67a90fc752dffcfd$var$DEFAULT_FILTER_STATE,
    dateFilterFrom: {
        value: '',
        setValue: (_value)=>null
    },
    dateFilterTo: {
        value: '',
        setValue: (_value)=>null
    }
});
function $67a90fc752dffcfd$export$5e1edcb3c154ab79(availableFilters) {
    const appliedFilters = availableFilters.map((availableFilter, index)=>({
            ...availableFilter,
            index: index
        })).filter((filterWithIndex)=>filterWithIndex.isChecked);
    return {
        applied: appliedFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource,
                index: appliedFilter.index
            })),
        recommendedIds: availableFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource
            }))
    };
}
const $67a90fc752dffcfd$var$transformDateFiltersForAnalytics = (dateFilterFrom)=>{
    const availiableFilters = $67a90fc752dffcfd$export$40e7ffc2d13a061c.map((experiment)=>experiment.days).map((days)=>[
            days,
            (0, $hYymy.getDateXDaysBack)(days)
        ]);
    const appliedFilter = availiableFilters.filter(([_, date])=>date === dateFilterFrom).map(([days, _])=>({
            id: days
        }));
    return {
        applied: appliedFilter.map(({ id: id })=>({
                id: id,
                source: (0, $169DF.FilterOptionSource).STATIC
            })),
        recommendedIds: availiableFilters.map(([days, _])=>({
                id: days,
                source: (0, $169DF.FilterOptionSource).STATIC
            }))
    };
};
const $67a90fc752dffcfd$export$eb71bf38f5ae0f9c = ({ isEnabled: isEnabled = true, defaultProjectFilters: defaultProjectFilters, defaultAssigneeFilters: defaultAssigneeFilters, defaultSiteFilters: defaultSiteFilters, children: children })=>{
    const previousEnabledState = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(isEnabled);
    const [dateFilterFrom, setDateFilterFrom] = (0, $gwFzn.useState)('');
    const [dateFilterTo, setDateFilterTo] = (0, $gwFzn.useState)('');
    const projectFilterStore = $67a90fc752dffcfd$export$973ca22476b0e05f(defaultProjectFilters);
    const assigneeFilterStore = $67a90fc752dffcfd$export$973ca22476b0e05f(defaultAssigneeFilters);
    const siteFilterStore = $67a90fc752dffcfd$export$973ca22476b0e05f(defaultSiteFilters);
    const binaryStatusCategoryFilterStore = $67a90fc752dffcfd$export$973ca22476b0e05f($67a90fc752dffcfd$export$b5d1c2ef6aead4e6);
    const filtersAnalyticsContext = projectFilterStore.availableFilters.length === 0 && assigneeFilterStore.availableFilters.length === 0 ? {} : {
        projects: $67a90fc752dffcfd$export$5e1edcb3c154ab79(projectFilterStore.availableFilters),
        assignees: $67a90fc752dffcfd$export$5e1edcb3c154ab79(assigneeFilterStore.availableFilters),
        binaryStatusCategories: $67a90fc752dffcfd$export$5e1edcb3c154ab79(binaryStatusCategoryFilterStore.availableFilters),
        dateFrom: $67a90fc752dffcfd$var$transformDateFiltersForAnalytics(dateFilterFrom)
    };
    // We reset the state when the component becomes disabled
    if (previousEnabledState.current && !isEnabled) {
        projectFilterStore.reset();
        assigneeFilterStore.reset();
        siteFilterStore.reset();
        binaryStatusCategoryFilterStore.clearFilter();
        setDateFilterFrom('');
        setDateFilterTo('');
    }
    previousEnabledState.current = isEnabled;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($67a90fc752dffcfd$var$FilterContext.Provider, {
        value: {
            projectFilters: projectFilterStore,
            assigneeFilters: assigneeFilterStore,
            siteFilters: siteFilterStore,
            binaryStatusCategoryFilters: binaryStatusCategoryFilterStore,
            dateFilterFrom: {
                value: dateFilterFrom,
                setValue: setDateFilterFrom
            },
            dateFilterTo: {
                value: dateFilterTo,
                setValue: setDateFilterTo
            }
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
            analyticContext: {},
            nonPrivacySafeAnalyticContext: {},
            filterAnalyticsContext: filtersAnalyticsContext,
            children: children
        })
    });
};
const $67a90fc752dffcfd$export$396ef541d9951d45 = ()=>{
    const filterContext = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext($67a90fc752dffcfd$var$FilterContext);
    return filterContext;
};

});
parcelRegister("hYymy", function(module, exports) {

$parcel$export(module.exports, "getDateXDaysBack", () => $dae70913057c5350$export$e4a4d5c1140c233a);
const $dae70913057c5350$export$edfa1467d84b6872 = (item, query)=>{
    const lowerQuery = query.toLowerCase().trim();
    return item.name.toLowerCase().includes(lowerQuery) || item.attributes.key.toLowerCase().includes(lowerQuery);
};
const $dae70913057c5350$export$e4a4d5c1140c233a = (daysBefore)=>{
    const date = new Date();
    date.setDate(date.getDate() - daysBefore);
    return date.toISOString().split('T')[0];
};

});


parcelRegister("k19N9", function(module, exports) {

$parcel$export(module.exports, "MultiProductDialog", () => $5e2053bb9142cd57$export$c952be4395be8d29);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $7bbzF = parcelRequire("7bbzF");
var $5ZpeZ = parcelRequire("5ZpeZ");
var $7qNFx = parcelRequire("7qNFx");
var $80L9g = parcelRequire("80L9g");

var $kmpep = parcelRequire("kmpep");

var $2ErY6 = parcelRequire("2ErY6");

var $jAnRi = parcelRequire("jAnRi");

var $2ZIpG = parcelRequire("2ZIpG");

var $iEwUU = parcelRequire("iEwUU");

var $48BnN = parcelRequire("48BnN");

var $4ldrV = parcelRequire("4ldrV");

var $gF7Az = parcelRequire("gF7Az");

var $24xEE = parcelRequire("24xEE");

var $gMIQ9 = parcelRequire("gMIQ9");

var $aQmDW = parcelRequire("aQmDW");

var $64EAe = parcelRequire("64EAe");
const $5e2053bb9142cd57$var$ConditionalWrapper = ({ wrapper: wrapper, children: children })=>wrapper?.({
        children: children
    }) ?? children;

const $5e2053bb9142cd57$var$SearchAIDialogComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("k6Y8T")).then(({ SearchAIDialog: SearchAIDialog })=>({
            default: SearchAIDialog
        })));
const $5e2053bb9142cd57$var$SearchAIAnswerDialog = ({ aiSearchConfig: aiSearchConfig, onClose: onClose, edition: edition, closeParentDialog: closeParentDialog })=>{
    const { query: query, setQueryOnly: setQueryOnly } = (0, $2ZIpG.useQuery)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId || '';
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { user: user } = (0, $iEwUU.useUserContext)();
    const { resetSearchSession: resetSearchSession } = (0, $80L9g.useSessionUserInput)();
    const { allowChangeExpand: allowChangeExpand } = (0, $gF7Az.useDialogExpansionContext)();
    const filters = (0, $48BnN.useAppliedFilters)('confluence');
    const onNavigate = (0, $gwFzn.useCallback)(()=>{
        resetSearchSession();
        allowChangeExpand(true);
    }, [
        resetSearchSession,
        allowChangeExpand
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($5e2053bb9142cd57$var$SearchAIDialogComponent, {
            query: query,
            setQuery: setQueryOnly,
            cloudId: cloudId,
            getAIAnswer: aiSearchConfig.aiSearchQueryFunction,
            edition: edition,
            followUpsEnabled: aiSearchConfig.followUpsEnabled,
            onNavigate: onNavigate,
            onClose: onClose,
            searchSessionId: searchSessionId,
            userDetails: user,
            source: "searchDialog",
            parsedFilters: filters,
            closeParentDialog: closeParentDialog,
            sourceProduct: "confluence",
            userGeneratedAI: true
        })
    });
};
const $5e2053bb9142cd57$export$c952be4395be8d29 = ({ children: children, theme: theme, isExpanded: isExpanded, setIsExpanded: setIsExpanded, abTestCloudId: abTestCloudId, aggregatorUrl: aggregatorUrl, dialogFeatures: dialogFeatures, user: user, orgId: orgId, forwardRef: forwardRef, onNavigateGeneric: onNavigateGeneric, keepExpandedInTab: keepExpandedInTab, pageLoadMetrics: pageLoadMetrics, DialogWrapper: DialogWrapper, OnboardingRenderer: OnboardingRenderer, experience: experience, aiSearchConfig: aiSearchConfig, edition: edition, primaryProduct: primaryProduct, shouldFillContainer: shouldFillContainer, isRovoEnabled: isRovoEnabled, queryParams: queryParams })=>{
    (0, $24xEE.useUFOComponentExperience)((0, $jAnRi.initialisationExperience));
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5ZpeZ.MetaContextProvider), {
        theme: theme,
        experience: experience,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        abTestCloudId: abTestCloudId,
        aggregatorUrl: aggregatorUrl,
        clientProviderFeatures: dialogFeatures,
        user: user,
        orgId: orgId,
        dialogFeatures: dialogFeatures,
        primaryProduct: primaryProduct,
        forwardRef: forwardRef,
        isRovoEnabled: isRovoEnabled,
        queryParams: queryParams,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7bbzF.KeyboardWrapper), {
            shouldFillContainer: shouldFillContainer,
            forwardRef: forwardRef,
            keepExpandedInTab: keepExpandedInTab,
            children: ({ ref: ref, onRetry: onRetry })=>{
                return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2ErY6.ActiveProductSearchInput), {
                            shouldFillContainer: shouldFillContainer,
                            forwardRef: ref,
                            onNavigateGeneric: onNavigateGeneric,
                            features: dialogFeatures,
                            pageLoadMetrics: pageLoadMetrics
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)($5e2053bb9142cd57$var$ConditionalWrapper, {
                            wrapper: DialogWrapper,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gMIQ9.ActiveProductProvider), {
                                    children: ({ activeProduct: activeProduct, showSearchAIDialog: showSearchAIDialog, onCloseAIDialog: onCloseAIDialog, defaultAIConfig: defaultAIConfig })=>{
                                        const finalAIConfig = dialogFeatures?.isGriffinNavEnabled ? aiSearchConfig || defaultAIConfig : aiSearchConfig;
                                        return showSearchAIDialog && finalAIConfig && isExpanded ? /*#__PURE__*/ (0, $7UHDa.jsx)($5e2053bb9142cd57$var$SearchAIAnswerDialog, {
                                            aiSearchConfig: finalAIConfig,
                                            onClose: onCloseAIDialog,
                                            edition: edition,
                                            closeParentDialog: ()=>setIsExpanded(false)
                                        }) : /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $64EAe.ProductSearchDialogWrapper), {
                                            shouldFillContainer: shouldFillContainer,
                                            children: [
                                                OnboardingRenderer && isExpanded && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aQmDW.DisableXPSAB), {
                                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)(OnboardingRenderer, {
                                                        activeProductId: activeProduct?.id
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7qNFx.ProductTabs), {}),
                                                children({
                                                    ref: ref,
                                                    onRetry: onRetry
                                                })
                                            ]
                                        });
                                    }
                                })
                            })
                        })
                    ]
                });
            }
        })
    });
};

});
parcelRegister("7bbzF", function(module, exports) {

$parcel$export(module.exports, "KeyboardWrapper", () => $59d6c08dd81e927a$export$8ee2389f89cfdd2f);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $uJITI = parcelRequire("uJITI");
var $icqFF = parcelRequire("icqFF");
var $59aAc = parcelRequire("59aAc");

var $gF7Az = parcelRequire("gF7Az");

var $3MlpZ = parcelRequire("3MlpZ");

var $amrMu = parcelRequire("amrMu");
class $59d6c08dd81e927a$export$bb50437fb01e8bb5 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { isExpanded: isExpanded, isQuickFind: isQuickFind, shouldFillContainer: shouldFillContainer, children: children } = this.props;
        const SearchAnchorComponent = isQuickFind ? (0, $uJITI.EnlargedSearchAnchor) : (0, $59aAc.SearchAnchor);
        return /*#__PURE__*/ (0, $7UHDa.jsx)(SearchAnchorComponent, {
            onBlur: this.onBlurHandler,
            onFocus: this.onFocusHandler,
            onKeyDown: this.handleKeyDown,
            isExpanded: isExpanded,
            shouldFillContainer: shouldFillContainer,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $icqFF.KeyboardHighlightProvider), {
                listenerNode: this.state.ref,
                children: children ? children(this.setRef) : null
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            ref: null
        };
        /**
     * Hold a timeout id for the onBlur and onFocus handlers
     */ this.timeout = undefined;
        this.handleKeyDown = (event)=>{
            if (event.key === 'Escape' && !event.defaultPrevented && this.props.isExpanded) {
                event.preventDefault();
                this.close();
            }
        };
        this.onBlurHandler = ()=>{
            this.timeout = window.setTimeout(()=>{
                this.close();
            });
        };
        this.onFocusHandler = ()=>{
            window.clearTimeout(this.timeout);
        };
        this.setRef = (ref)=>{
            if (this.state.ref !== ref) this.setState({
                ref: ref
            });
        };
        this.close = ()=>{
            const { ref: ref } = this.state;
            ref && ref.blur();
            this.props.onClose();
        };
    }
}
const $59d6c08dd81e927a$export$8ee2389f89cfdd2f = ({ children: children, keepExpandedInTab: keepExpandedInTab = false, forwardRef: forwardRef, shouldFillContainer: shouldFillContainer, ...rest })=>{
    const { isExpanded: isExpanded, setIsExpanded: setIsExpanded, allowChangeExpand: allowChangeExpand } = (0, $gF7Az.useDialogExpansionContext)();
    const inputRef = (0, $gwFzn.useRef)(null);
    const mergedForwardref = (0, $3MlpZ.mergeRefCallback)(inputRef, forwardRef);
    const isQuickFind = (0, $amrMu.useFeaturesContext)().quickFind?.enabled;
    const onClose = (0, $gwFzn.useCallback)(()=>{
        setIsExpanded(false);
    }, [
        setIsExpanded
    ]);
    const onTabChange = (0, $gwFzn.useCallback)(()=>{
        if (document.hidden) allowChangeExpand(false);
        else {
            if (isExpanded) inputRef?.current?.focus?.();
            allowChangeExpand(true);
        }
    }, [
        allowChangeExpand,
        isExpanded
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (keepExpandedInTab) {
            document.addEventListener('visibilitychange', onTabChange);
            return ()=>{
                document.removeEventListener('visibilitychange', onTabChange);
            };
        }
    }, [
        onTabChange,
        keepExpandedInTab
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($59d6c08dd81e927a$export$bb50437fb01e8bb5, {
        ...rest,
        shouldFillContainer: shouldFillContainer,
        onClose: onClose,
        isExpanded: isExpanded,
        isQuickFind: isQuickFind,
        children: (setRef)=>{
            const ref = (0, $3MlpZ.mergeRefCallback)(setRef, mergedForwardref);
            const onRetry = ()=>{
                inputRef?.current?.focus?.();
            };
            return children({
                ref: ref,
                onRetry: onRetry
            });
        }
    });
};

});
parcelRegister("uJITI", function(module, exports) {

$parcel$export(module.exports, "EnlargedSearchAnchor", () => $811464270192717d$export$774d556eae0f6945);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $kHWmv = parcelRequire("kHWmv");
const $811464270192717d$export$774d556eae0f6945 = ({ children: children, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, isExpanded: isExpanded, shouldFillContainer: shouldFillContainer })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $kHWmv.EnlargedSearchAnchorWrapper), {
        isExpanded: isExpanded,
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kHWmv.AbsoluteContainer), {
            isExpanded: isExpanded,
            shouldFillContainer: shouldFillContainer,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kHWmv.SearchDialogAnchor), {
                onBlur: onBlur,
                onFocus: onFocus,
                onKeyDown: onKeyDown,
                isExpanded: isExpanded,
                shouldFillContainer: shouldFillContainer,
                children: children
            })
        })
    });

});

parcelRegister("3MlpZ", function(module, exports) {

$parcel$export(module.exports, "mergeRefCallback", () => $0ffb284ad494cbe0$export$bf39ce724f6cc9e5);
/**
 * Helper util class to merge a forward and callback ref.
 * The implementation to do this is not clean and so it's isolated here until React has a better solution.
 */ const $0ffb284ad494cbe0$var$callRef = (callbackOrForwardRef, ref)=>{
    if (!callbackOrForwardRef) return;
    if (typeof callbackOrForwardRef === 'function') callbackOrForwardRef(ref);
    else if (typeof callbackOrForwardRef === 'object' && Object.prototype.hasOwnProperty.call(callbackOrForwardRef, 'current')) // `#current` is technically read only, but we will force an assignment here.
    /* eslint-disable-next-line no-param-reassign */ callbackOrForwardRef.current = ref;
    else // This should never happen
    throw new Error('unsupported ref format, currently only callback and forward refs are supported');
};
const $0ffb284ad494cbe0$export$bf39ce724f6cc9e5 = (...refs)=>{
    return (ref)=>{
        refs.forEach((r)=>$0ffb284ad494cbe0$var$callRef(r, ref));
    };
};

});


parcelRegister("5ZpeZ", function(module, exports) {

$parcel$export(module.exports, "MetaContextProvider", () => $a995c577a9050532$export$3d88e5d350ac07d9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $eSS4z = parcelRequire("eSS4z");

var $gF7Az = parcelRequire("gF7Az");

var $2ZIpG = parcelRequire("2ZIpG");

var $fJRVo = parcelRequire("fJRVo");

var $7HRSM = parcelRequire("7HRSM");

var $aeF8q = parcelRequire("aeF8q");

var $4ldrV = parcelRequire("4ldrV");

var $kmpep = parcelRequire("kmpep");

var $gRazf = parcelRequire("gRazf");

var $6dbhj = parcelRequire("6dbhj");

var $2GvH8 = parcelRequire("2GvH8");

var $iEwUU = parcelRequire("iEwUU");

var $fj1bk = parcelRequire("fj1bk");

var $cgH2x = parcelRequire("cgH2x");

var $hKdD9 = parcelRequire("hKdD9");

var $5YmSS = parcelRequire("5YmSS");

var $amrMu = parcelRequire("amrMu");

var $lesEq = parcelRequire("lesEq");

var $aDRXf = parcelRequire("aDRXf");

var $cGCOz = parcelRequire("cGCOz");

var $4wMwH = parcelRequire("4wMwH");
const $a995c577a9050532$export$3d88e5d350ac07d9 = ({ children: children, theme: theme, setIsExpanded: setIsExpanded, isExpanded: isExpanded, abTestCloudId: abTestCloudId, aggregatorUrl: aggregatorUrl, experience: experience, clientProviderFeatures: clientProviderFeatures, user: user, orgId: orgId, dialogFeatures: dialogFeatures, primaryProduct: primaryProduct, forwardRef: forwardRef, isRovoEnabled: isRovoEnabled, queryParams: queryParams })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4wMwH.QueryParamsProvider), {
        queryParams: queryParams,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $amrMu.FeaturesProvider), {
            dialogFeatures: dialogFeatures,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iEwUU.UserProvider), {
                user: user,
                orgId: orgId,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGCOz.RovoContextProvider), {
                    isEnabled: isRovoEnabled,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7HRSM.default), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lesEq.QuickFindAnalyticContext), {
                            isQuickFind: dialogFeatures?.quickFind?.enabled,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aeF8q.BuildVersionAnalyticContext), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eSS4z.ThemeProvider), {
                                    partialSearchCSS: theme,
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gF7Az.DialogExpansionContextProvider), {
                                        isExpanded: isExpanded,
                                        setIsExpanded: setIsExpanded,
                                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fJRVo.ProductRouter), {
                                            primaryProduct: primaryProduct,
                                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kmpep.AggregatorClientContextProvider), {
                                                abTestCloudId: abTestCloudId,
                                                aggregatorUrl: aggregatorUrl,
                                                features: clientProviderFeatures,
                                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gRazf.ABTestContextProvider), {
                                                    experience: experience,
                                                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $4ldrV.SearchSessionProvider), {
                                                        sessionKey: `ssid_provider_${isExpanded}`,
                                                        children: [
                                                            isExpanded ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6dbhj.default), {}) : null,
                                                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2ZIpG.QueryContextProvider), {
                                                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cgH2x.FilterContextHOC), {
                                                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hKdD9.AutocorrectionProvider), {
                                                                        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $aDRXf.InputContext), {
                                                                            forwardRef: forwardRef,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fj1bk.AsyncLoadOnQuery), {}),
                                                                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5YmSS.DialogShownHandler), {
                                                                                    isExpanded: isExpanded
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2GvH8.DialogDismissedHandler), {
                                                                                    isExpanded: isExpanded
                                                                                }),
                                                                                children
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("7HRSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c5b4abe555f149c$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");
var $hlhtG = parcelRequire("hlhtG");

var $l3N71 = parcelRequire("l3N71");

var $1E3Hv = parcelRequire("1E3Hv");
class $9c5b4abe555f149c$var$MessagesIntlProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlhtG.default), {
            messages: this.state.messages,
            locale: this.props.intl.locale,
            children: children
        });
    }
    constructor(props){
        super(props);
        this.fetchLocale = ()=>{
            (0, $l3N71.getMessagesForLocale)(this.props.intl.locale).then((messages)=>this.setState({
                    messages: messages
                }));
        };
        this.state = {
            messages: (0, $l3N71.ENGLISH_LOCALES).indexOf(props.intl.locale) !== -1 ? (0, $1E3Hv.default) : undefined
        };
        this.fetchLocale();
    }
}
const $9c5b4abe555f149c$var$MessagesIntlProviderWithIntl = (0, $js7oX.default)($9c5b4abe555f149c$var$MessagesIntlProvider);
var $9c5b4abe555f149c$export$2e2bcd8739ae039 = $9c5b4abe555f149c$var$MessagesIntlProviderWithIntl;

});
parcelRegister("l3N71", function(module, exports) {

$parcel$export(module.exports, "ENGLISH_LOCALES", () => $670fab1500b9ac87$export$507533edf8f43d4e);
$parcel$export(module.exports, "getMessagesForLocale", () => $670fab1500b9ac87$export$d0a3169680473b6c);

var $1E3Hv = parcelRequire("1E3Hv");
const $670fab1500b9ac87$export$507533edf8f43d4e = [
    'en',
    'en-US',
    'en-GB'
];






























async function $670fab1500b9ac87$var$getMessages(locale) {
    let messages;
    switch(locale){
        case 'cs':
            messages = (parcelRequire("9cl5R"));
            break;
        case 'da':
            messages = (parcelRequire("ezuZG"));
            break;
        case 'de':
            messages = (parcelRequire("53dkg"));
            break;
        case 'en':
            messages = Promise.resolve((parcelRequire("1E3Hv")));
            break;
        case 'en_GB':
            messages = (parcelRequire("j0DHs"));
            break;
        case 'en_ZZ':
            messages = (parcelRequire("am1ps"));
            break;
        case 'es':
            messages = (parcelRequire("fSLXp"));
            break;
        case 'et':
            messages = (parcelRequire("2Im8o"));
            break;
        case 'fi':
            messages = (parcelRequire("dNOQq"));
            break;
        case 'fr':
            messages = (parcelRequire("jHFlV"));
            break;
        case 'hu':
            messages = (parcelRequire("7DNZO"));
            break;
        case 'is':
            messages = (parcelRequire("4amYN"));
            break;
        case 'it':
            messages = (parcelRequire("hk27j"));
            break;
        case 'ja':
            messages = (parcelRequire("2DX3T"));
            break;
        case 'ko':
            messages = (parcelRequire("1yEm5"));
            break;
        case 'nb':
            messages = (parcelRequire("k3kA8"));
            break;
        case 'nl':
            messages = (parcelRequire("aAlhN"));
            break;
        case 'pl':
            messages = (parcelRequire("eP1WB"));
            break;
        case 'pt_BR':
            messages = (parcelRequire("fnCm2"));
            break;
        case 'pt_PT':
            messages = (parcelRequire("6Z2SI"));
            break;
        case 'ro':
            messages = (parcelRequire("3835v"));
            break;
        case 'ru':
            messages = (parcelRequire("jNGUi"));
            break;
        case 'sk':
            messages = (parcelRequire("47tQi"));
            break;
        case 'sv':
            messages = (parcelRequire("yjDNj"));
            break;
        case 'th':
            messages = (parcelRequire("gATwK"));
            break;
        case 'tr':
            messages = (parcelRequire("5hsBE"));
            break;
        case 'uk':
            messages = (parcelRequire("4YlTZ"));
            break;
        case 'vi':
            messages = (parcelRequire("1FSLe"));
            break;
        case 'zh':
            messages = (parcelRequire("1eX7w"));
            break;
        case 'zh_TW':
            messages = (parcelRequire("anvPL"));
            break;
        default:
            throw new Error('Unknown locale: ' + locale);
    }
    return (await messages).default;
}
const $670fab1500b9ac87$export$d0a3169680473b6c = async (locale)=>{
    locale = locale.replace('-', '_');
    try {
        return await $670fab1500b9ac87$var$getMessages(locale);
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        return await $670fab1500b9ac87$var$getMessages(parentLocale);
    } catch (e) {
    // ignore
    }
    return 0, $1E3Hv.default;
};

});
parcelRegister("1E3Hv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6c104c09525816b7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $6c104c09525816b7$export$2e2bcd8739ae039 = {
    'cross_product_search_dialog.atlas.tab_label': 'Atlas',
    'cross_product_search_dialog.bitbucket.tab_label': 'Bitbucket',
    'cross_product_search_dialog.confluence.tab_label': 'Confluence',
    'cross_product_search_dialog.google_drive.tab_label': 'Drive',
    'cross_product_search_dialog.google_drive.unauthenticated_prompt': 'You can work on all of your Google sheets, docs, slides and more, without ever leaving Atlassian. Only you have this access.',
    'cross_product_search_dialog.jira.tab_label': 'Jira',
    'cross_product_search_dialog.opsgenie.tab_label': 'Opsgenie',
    'cross_product_search_dialog.recently_viewed_title': 'Recently Viewed {sectionTitle}',
    'cross_product_search_dialog.townsquare_globex_tab_label': 'Home',
    'cross_product_search_dialog.townsquare_recent_goals': 'Recent Goals',
    'cross_product_search_dialog.townsquare_recent_help_links': 'Recent Help Links',
    'cross_product_search_dialog.townsquare_recent_learnings_risks_decisions': 'Recent Learnings, Risks and Decisions',
    'cross_product_search_dialog.townsquare_recent_projects': 'Recent Projects',
    'cross_product_search_dialog.townsquare_tab_label': 'Atlas',
    'cross_product_search_dialog.trello.tab_label': 'Trello',
    'cross_product_search_dialog.view_all_results_link': 'View all {sectionTitle}',
    'document-search-result.google-docs-label': 'Docs',
    'document-search-result.google-sheets-label': 'Sheets',
    'document-search-result.google-slides-label': 'Slides',
    'document-search-result.ms-excel-label': 'Excel',
    'document-search-result.ms-powerpoint-label': 'PowerPoint',
    'document-search-result.ms-word-label': 'Word',
    'extensible_search_dialog.advanced_search': 'Advanced search',
    'extensible_search_dialog.advanced_search_all_apps': 'Search all apps',
    'extensible_search_dialog.connect': 'Connect',
    'extensible_search_dialog.connect_to': 'Connect to',
    'extensible_search_dialog.more': '+ more',
    'global_search.jira.advanced_search_boards': 'Boards',
    'global_search.jira.advanced_search_filters': 'Filters',
    'global_search.jira.advanced_search_issues': 'Issues',
    'global_search.jira.advanced_search_issues-issue-term-refresh': 'Work items',
    'global_search.jira.advanced_search_label': 'Go to all:',
    'global_search.jira.advanced_search_people': 'People',
    'global_search.jira.advanced_search_plans': 'Plans',
    'global_search.jira.advanced_search_projects': 'Projects',
    'global_search.jira.search_placeholder': 'Search Jira',
    'global_search.jira.search_placeholder_experiment_jsw_enabled': 'Search for issues, boards, projects, and filters',
    'global_search.jira.search_placeholder_experiment_jsw_enabled-issue-term-refresh': 'Search for work items, boards, projects, and filters',
    'product_s earch_dialog.confluence.assignee_filters_find_more': 'Find an assignee',
    'product_search_dialog.atlas.search_input_expanded_placeholder': 'Search Atlas',
    'product_search_dialog.autocorrection.label': 'Did you mean',
    'product_search_dialog.bitbucket.bitbucket_advanced_search': 'Search for code in {source}',
    'product_search_dialog.bitbucket.bitbucket_recent_repositories': 'Recently updated repositories',
    'product_search_dialog.bitbucket.bitbucket_repositories_section_title': 'Repositories',
    'product_search_dialog.bitbucket.expanded.input-placeholder': 'Search Bitbucket',
    'product_search_dialog.bitbucket.repository_heading': 'Repositories',
    'product_search_dialog.common.site_filters': 'Filter by site',
    'product_search_dialog.compass.component_type.application': 'Application',
    'product_search_dialog.compass.component_type.capability': 'Capability',
    'product_search_dialog.compass.component_type.cloud_resource': 'Cloud resource',
    'product_search_dialog.compass.component_type.data_pipeline': 'Data pipeline',
    'product_search_dialog.compass.component_type.library': 'Library',
    'product_search_dialog.compass.component_type.machine_learning_model': 'Machine learning model',
    'product_search_dialog.compass.component_type.other': 'Other',
    'product_search_dialog.compass.component_type.service': 'Service',
    'product_search_dialog.compass.component_type.ui_element': 'UI element',
    'product_search_dialog.compass.component_type.website': 'Website',
    'product_search_dialog.compass.components_section_heading': 'Components',
    'product_search_dialog.compass.endpoints_section_heading': 'Endpoints',
    'product_search_dialog.compass.expanded.input-placeholder': 'Search Compass',
    'product_search_dialog.compass.people_section_heading': 'People',
    'product_search_dialog.compass.recently_viewed_components': 'Recently viewed components',
    'product_search_dialog.compass.recently_viewed_endpoints': 'Recently viewed endpoints',
    'product_search_dialog.compass.recently_viewed_teams': 'Recently viewed teams',
    'product_search_dialog.compass.tab_label': 'Compass',
    'product_search_dialog.compass.teams_section_heading': 'Teams',
    'product_search_dialog.compass.upsell_modal_cta_text': 'Get Compass free',
    'product_search_dialog.compass.upsell_modal_description': "Catalog your software architecture in one place \u2013 so the teams working on it can reduce context switching, find what they need faster, and be more productive. How\u2019s that for a developer experience?",
    'product_search_dialog.compass.upsell_modal_description.bitbucket': 'See owners, dependencies, and help resources for your repositories by linking them to a central software catalog.',
    'product_search_dialog.compass.upsell_modal_heading': 'Control your software sprawl, so developers can control their time',
    'product_search_dialog.compass.upsell_modal_heading.bitbucket': 'Bring more context to your code',
    'product_search_dialog.compass.upsell_modal_learn_more_aria_label': 'Learn more about Compass',
    'product_search_dialog.compass.upsell_modal_learn_more_link': 'Learn more',
    'product_search_dialog.compass.upsell_tab_title_lozenge': 'New',
    'product_search_dialog.compass.view_all_components_label': 'View all components',
    'product_search_dialog.compass.view_all_results_label': 'View all results',
    'product_search_dialog.confluence.advanced_search_with_product_prefix': 'Confluence advanced search',
    'product_search_dialog.confluence.clear_filters': 'Clear filters',
    'product_search_dialog.confluence.confluence_availability_in_jira_search.description': 'Your team is collaborating in Confluence. Organize team knowledge, capture ideas, and share requirements for your Jira projects with pages, whiteboards, and databases.',
    'product_search_dialog.confluence.confluence_availability_in_jira_search.header': 'Your team is now using Confluence',
    'product_search_dialog.confluence.confluence_availability_in_jira_search.join_button': 'Join your team',
    'product_search_dialog.confluence.confluence_availability_in_jira_search.learn_more_button': 'Learn more',
    'product_search_dialog.confluence.confluence_availability_in_jira_search.tab.more_results': 'More results',
    'product_search_dialog.confluence.confluence_reactivation_experiment.inactive_user': 'More results',
    'product_search_dialog.confluence.confluence_reactivation_experiment.never_active_user': 'Free access',
    'product_search_dialog.confluence.content_section_heading': 'Content',
    'product_search_dialog.confluence.contributor_filters': 'Filter by contributor',
    'product_search_dialog.confluence.contributor_filters_find_more': 'Find a contributor',
    'product_search_dialog.confluence.date_filter_title': 'Last updated',
    'product_search_dialog.confluence.date_filter_today': 'Today',
    'product_search_dialog.confluence.date_filter_yesterday': 'Yesterday',
    'product_search_dialog.confluence.date_filters_any': 'Any time',
    'product_search_dialog.confluence.date_filters_month': 'Past 30 days',
    'product_search_dialog.confluence.date_filters_week': 'Past 7 days',
    'product_search_dialog.confluence.date_filters_year': 'Past year',
    'product_search_dialog.confluence.empty_state_body_no_advanced_search': 'Try different keywords, fewer of them, or ones that are more general.',
    'product_search_dialog.confluence.empty_state_body_prequery_filters': "We can\u2019t find anything created or updated in the last 90 days with your selected filters.",
    'product_search_dialog.confluence.empty_state_body_title': "We couldn't find any matches for your search.",
    'product_search_dialog.confluence.filters_applied': 'Looks like you have some filters applied',
    'product_search_dialog.confluence.pages_blogs_attachments_section_heading': 'Pages, blogs and attachments',
    'product_search_dialog.confluence.people_section_heading': 'People',
    'product_search_dialog.confluence.search_input_expanded_placeholder': 'Search Confluence',
    'product_search_dialog.confluence.search_input_expanded_placeholder_ai': 'Search or ask questions within your Confluence',
    'product_search_dialog.confluence.space_filters': 'Filter by space',
    'product_search_dialog.confluence.space_filters_find_more': 'Find a space',
    'product_search_dialog.confluence.spaces_section_heading': 'Spaces',
    'product_search_dialog.confluence.typing_state_header_text': 'Search for content in Confluence',
    'product_search_dialog.cross_product.empty.no_results_body': '<a>Search all content across your organization</a> or try a different term.',
    'product_search_dialog.cross_product.expanded.input-placeholder': 'Search All',
    'product_search_dialog.cross_product.recents.section_heading': 'Recently viewed',
    'product_search_dialog.cross_product.results.section_heading': 'Search results',
    'product_search_dialog.cross_product.tab_label': 'All',
    'product_search_dialog.empty.no_results_body': 'Try again with a different term, or refine your results with <a>Advanced Search</a>',
    'product_search_dialog.empty.no_results_body_with_no_advanced_search': 'Try again with a different term.',
    'product_search_dialog.empty.no_results_heading': "We couldn't find anything matching your search.",
    'product_search_dialog.empty_prequery.error_heading': 'Something went wrong with showing initial results',
    'product_search_dialog.empty_prequery.no_results_heading': 'Search for what you need',
    'product_search_dialog.error.failed_loading_search_body': 'It might just be a hiccup. Please try refreshing the page or <emptyLink>try again.</emptyLink>',
    'product_search_dialog.error.failed_loading_search_heading': "We're having trouble loading your recently viewed content.",
    'product_search_dialog.give_feedback': 'Give feedback',
    'product_search_dialog.google_drive.files_heading': 'Files',
    'product_search_dialog.inline_onboarding_action': 'Ok',
    'product_search_dialog.inline_onboarding_body': 'Use the Jira and Confluence tabs to search and see recent items in either location.',
    'product_search_dialog.inline_onboarding_title': 'Search across Jira and Confluence',
    'product_search_dialog.jira.assignee_filters': 'Filter by assignee',
    'product_search_dialog.jira.boards_icon_accessibility_text': 'Board icon',
    'product_search_dialog.jira.boards_projects_filters_plans_section_heading': 'Boards, Projects, Filters and Plans',
    'product_search_dialog.jira.boards_projects_filters_section_heading': 'Boards, Projects and Filters',
    'product_search_dialog.jira.date_filter_30': '30d',
    'product_search_dialog.jira.date_filter_60': '60d',
    'product_search_dialog.jira.date_filter_90': '90d',
    'product_search_dialog.jira.date_filter_any': 'Any time',
    'product_search_dialog.jira.date_filter_past_30_days': 'Past 30 days',
    'product_search_dialog.jira.date_filter_past_7_days': 'Past 7 days',
    'product_search_dialog.jira.date_filter_past_year': 'Past year',
    'product_search_dialog.jira.date_filter_today': 'Today',
    'product_search_dialog.jira.date_filter_yesterday': 'Yesterday',
    'product_search_dialog.jira.date_filters': 'Last updated',
    'product_search_dialog.jira.empty_prequery.no_results_heading': 'Start searching to find your work',
    'product_search_dialog.jira.issue_filter_done': 'Done',
    'product_search_dialog.jira.issue_filter_open': 'Open',
    'product_search_dialog.jira.issue_filters': 'Filter by status',
    'product_search_dialog.jira.issue_labels_filters': 'Filter by label',
    'product_search_dialog.jira.issue_labels_filters_options_group_label': 'All labels',
    'product_search_dialog.jira.issue_labels_filters_placeholder': 'Select label',
    'product_search_dialog.jira.issues_section_heading': 'Issues',
    'product_search_dialog.jira.issues_section_heading-issue-term-refresh': 'Work items',
    'product_search_dialog.jira.jira_view_all_issues_new': 'View all issues',
    'product_search_dialog.jira.jira_view_all_issues_new-issue-term-refresh': 'View all work items',
    'product_search_dialog.jira.project_filters': 'Filter by project',
    'product_search_dialog.jira.project_filters_find_more': 'Find a project',
    'product_search_dialog.jira.projects_filters_section_heading': 'Projects and Filters',
    'product_search_dialog.jira.recent_boards_projects_filters_plans_section_heading': 'Recent Boards, Projects, Filters and Plans',
    'product_search_dialog.jira.recent_boards_projects_filters_section_heading': 'Recent Boards, Projects and Filters',
    'product_search_dialog.jira.recent_projects_filters_section_heading': 'Recent Projects and Filters',
    'product_search_dialog.jira.recently_viewed_issues_section_heading': 'Recently viewed issues',
    'product_search_dialog.jira.recently_viewed_issues_section_heading-issue-term-refresh': 'Recently viewed work items',
    'product_search_dialog.jira.report_by_filters': 'Filter by reporter',
    'product_search_dialog.jira.reported_by_me_filter': 'Reported by me',
    'product_search_dialog.jira.site_filters_find_more': 'Find a site',
    'product_search_dialog.loading_filters': 'Loading',
    'product_search_dialog.more_filters': 'View all filters',
    'product_search_dialog.multi_site_advanced_search_label': 'Search on:',
    'product_search_dialog.multi_site_advanced_search_more_dropdown': '{count} more',
    'product_search_dialog.no_options_filters': 'No options',
    'product_search_dialog.opsgenie.advanced_search': 'Advanced alert search',
    'product_search_dialog.opsgenie.alert_heading': 'Alerts',
    'product_search_dialog.opsgenie.expanded.input-placeholder': 'Search Opsgenie',
    'product_search_dialog.opsgenie.opsgenie_recent_alerts': 'Recent Alerts',
    'product_search_dialog.quick_find_ask_atlassian_intelligence': 'Ask Atlassian Intelligence',
    'product_search_dialog.quick_find_confluence_space': 'Confluence Space',
    'product_search_dialog.quick_find_footer_full_page_search_products_link': 'Search across products',
    'product_search_dialog.quick_find_footer_help_text': 'Help us improve search',
    'product_search_dialog.quick_find_no_content_body_rovo': "Search or ask Rovo what you're looking for in your Atlassian and integrated products",
    'product_search_dialog.quick_find_no_content_header': 'Seek and you shall find',
    'product_search_dialog.quick_find_post_query_no_results_body': '<SearchContentLink>Search all content across your organization</SearchContentLink> or try again with a different term.',
    'product_search_dialog.quick_find_post_query_no_results_header': "We couldn't find any results with that title",
    'product_search_dialog.quick_find_recent_draft_label': 'DRAFT',
    'product_search_dialog.quick_find_recent_search': 'Recent search',
    'product_search_dialog.quick_find_recent_search_text_dialog': 'From your recent searches',
    'product_search_dialog.quick_find_recent_spaces_additional_meta': 'You recently visited',
    'product_search_dialog.quick_find_recently_viewed': 'Recently Viewed',
    'product_search_dialog.quick_find_result_item_team': 'Team',
    'product_search_dialog.quick_find_results_section': 'Search Results',
    'product_search_dialog.quick_find_rovo_tip': "Enter a question like \u201CWhat\u2019s the vacation policy?\u201D and Rovo will find the answer.",
    'product_search_dialog.quick_find_search_input_rovo_placeholder': 'Search or ask Rovo',
    'product_search_dialog.quick_find_search_results': 'Search Results',
    'product_search_dialog.quick_find_show_filtered_confluence_results': 'Filter by Confluence spaces, contributors and more',
    'product_search_dialog.quick_find_show_filtered_confluence_results_with_icon': 'Filter by {confluenceIcon} Confluence spaces, contributors and more',
    'product_search_dialog.quick_find_show_organization_results': 'Search your organization',
    'product_search_dialog.recent_spaces_section_heading': 'Recent spaces',
    'product_search_dialog.recently_viewed_heading': 'Advanced search',
    'product_search_dialog.recently_viewed_section_heading': 'Recently viewed',
    'product_search_dialog.recently_worked_with_section_heading': 'Recently worked with',
    'product_search_dialog.results.remove_button_label': 'Remove this.',
    'product_search_dialog.search_input_collapsed_placeholder': 'Search',
    'product_search_dialog.search_input_enlarged_aria_label': 'Press enter to navigate to advanced search',
    'product_search_dialog.search_people_link': 'Search people',
    'product_search_dialog.show_all_results_link': 'View all results',
    'product_search_dialog.show_more_results_link': 'Show more',
    'product_search_dialog.townsquare.search_input_expanded_placeholder': 'Search Home',
    'product_search_dialog.townsquare_goals_heading': 'Goals',
    'product_search_dialog.townsquare_goals_view_all': 'Search all goals',
    'product_search_dialog.townsquare_help_links_heading': 'Help Links',
    'product_search_dialog.townsquare_learnings_risks_decisions_heading': 'Learnings, Risks and Decisions',
    'product_search_dialog.townsquare_people_heading': 'People',
    'product_search_dialog.townsquare_people_view_all': 'Search all people',
    'product_search_dialog.townsquare_projects_heading': 'Projects',
    'product_search_dialog.townsquare_projects_view_all': 'Search all projects',
    'product_search_dialog.townsquare_recent_people': 'Recent People',
    'product_search_dialog.townsquare_recent_topics': 'Recent Topics',
    'product_search_dialog.townsquare_teams_heading': 'Teams',
    'product_search_dialog.townsquare_teams_view_all': 'Search all teams',
    'product_search_dialog.townsquare_topics_heading': 'Topics',
    'product_search_dialog.townsquare_topics_view_all': 'Search all topics',
    'product_search_dialog.trello.archived': 'Archived',
    'product_search_dialog.trello.archived.card-hover': 'This card is archived',
    'product_search_dialog.trello.board': 'Board',
    'product_search_dialog.trello.boards_heading': 'Boards',
    'product_search_dialog.trello.cards_heading': 'Cards',
    'product_search_dialog.trello.closed': 'Closed',
    'product_search_dialog.trello.closed.board-hover': 'This board is closed',
    'product_search_dialog.trello.expanded.input-placeholder': 'Search Trello',
    'product_search_dialog.trello.feedback_link': 'Help us improve your search results!',
    'product_search_dialog.trello.list': 'List',
    'product_search_dialog.trello.private_workspace': 'Private Workspace',
    'product_search_dialog.trello.recent_boards_heading': 'Recent boards',
    'product_search_dialog.trello.workspace': 'Workspace',
    'product_search_dialog.updated_date_formatter': 'Updated {date}',
    'recentWork.eventTypeMessage.absolute.commented': 'You commented on {date}',
    'recentWork.eventTypeMessage.absolute.created': 'You created on {date}',
    'recentWork.eventTypeMessage.absolute.edited': 'You edited on {date}',
    'recentWork.eventTypeMessage.absolute.published': 'You published on {date}',
    'recentWork.eventTypeMessage.absolute.updated': 'You updated on {date}',
    'recentWork.eventTypeMessage.absolute.viewed': 'You viewed on {date}',
    'recentWork.eventTypeMessage.absolute.workedOn': 'You worked on {date}',
    'recentWork.eventTypeMessage.relative.commented': 'You commented {date}',
    'recentWork.eventTypeMessage.relative.created': 'You created {date}',
    'recentWork.eventTypeMessage.relative.edited': 'You edited {date}',
    'recentWork.eventTypeMessage.relative.published': 'You published {date}',
    'recentWork.eventTypeMessage.relative.updated': 'You updated {date}',
    'recentWork.eventTypeMessage.relative.viewed': 'You viewed {date}',
    'search_dialog.filters.group.show-more': 'Show more',
    'search_dialog.search_input_clear_label': 'Clear search session',
    'search_dialog.search_input_exit_label': 'Exit Search'
};

});

parcelRegister("9cl5R", function(module, exports) {

let $6b2598c4b46cc26a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6b2598c4b46cc26a$var$load("dXz7U").then(()=>parcelRequire('efF3A'));

});

parcelRegister("ezuZG", function(module, exports) {

let $a9bc604a5d4e8583$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a9bc604a5d4e8583$var$load("gGEZv").then(()=>parcelRequire('1Mvyi'));

});

parcelRegister("53dkg", function(module, exports) {

let $3ad791cb7a90fef8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3ad791cb7a90fef8$var$load("d3blt").then(()=>parcelRequire('5Abiq'));

});

parcelRegister("j0DHs", function(module, exports) {

let $dd6ccffc839738d8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dd6ccffc839738d8$var$load("59Z93").then(()=>parcelRequire('fY7GX'));

});

parcelRegister("am1ps", function(module, exports) {

let $789d0d615f8512f9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $789d0d615f8512f9$var$load("kotjW").then(()=>parcelRequire('1JK4e'));

});

parcelRegister("fSLXp", function(module, exports) {

let $b9011977c747f9ca$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b9011977c747f9ca$var$load("kK6se").then(()=>parcelRequire('dr5EV'));

});

parcelRegister("2Im8o", function(module, exports) {

let $1fa0dc3d0db26d11$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1fa0dc3d0db26d11$var$load("5xf60").then(()=>parcelRequire('928dD'));

});

parcelRegister("dNOQq", function(module, exports) {

let $a0c74aa943be20d4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a0c74aa943be20d4$var$load("9VEIz").then(()=>parcelRequire('8u8jr'));

});

parcelRegister("jHFlV", function(module, exports) {

let $e5821c4013c1b4ec$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e5821c4013c1b4ec$var$load("cjdHS").then(()=>parcelRequire('iV9jc'));

});

parcelRegister("7DNZO", function(module, exports) {

let $5902f51a4cf9d451$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5902f51a4cf9d451$var$load("Whd6n").then(()=>parcelRequire('6zDwd'));

});

parcelRegister("4amYN", function(module, exports) {

let $3089ebd9dd90541e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3089ebd9dd90541e$var$load("jkUKZ").then(()=>parcelRequire('4V7KZ'));

});

parcelRegister("hk27j", function(module, exports) {

let $c9c5f24e6c5abc00$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c9c5f24e6c5abc00$var$load("9LPlo").then(()=>parcelRequire('eIyMR'));

});

parcelRegister("2DX3T", function(module, exports) {

let $1ecd09b830e26009$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1ecd09b830e26009$var$load("bCZbu").then(()=>parcelRequire('2cNOn'));

});

parcelRegister("1yEm5", function(module, exports) {

let $12284524ab36661d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $12284524ab36661d$var$load("jUfGx").then(()=>parcelRequire('i1XCh'));

});

parcelRegister("k3kA8", function(module, exports) {

let $e9940d98429cf9cc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e9940d98429cf9cc$var$load("8yxgV").then(()=>parcelRequire('k4Hxm'));

});

parcelRegister("aAlhN", function(module, exports) {

let $7b4dc71d89fc231a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7b4dc71d89fc231a$var$load("dBE2i").then(()=>parcelRequire('6e98G'));

});

parcelRegister("eP1WB", function(module, exports) {

let $aca75631ab96b9d5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $aca75631ab96b9d5$var$load("6FNZU").then(()=>parcelRequire('cRwJj'));

});

parcelRegister("fnCm2", function(module, exports) {

let $b326c162b83c2334$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b326c162b83c2334$var$load("ilWcC").then(()=>parcelRequire('3bomr'));

});

parcelRegister("6Z2SI", function(module, exports) {

let $515aacc555a96f8e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $515aacc555a96f8e$var$load("edU6Z").then(()=>parcelRequire('lD7ty'));

});

parcelRegister("3835v", function(module, exports) {

let $247483a27c8d799f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $247483a27c8d799f$var$load("atNxX").then(()=>parcelRequire('jE6uv'));

});

parcelRegister("jNGUi", function(module, exports) {

let $e6a3e061e7171fda$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e6a3e061e7171fda$var$load("gpgvY").then(()=>parcelRequire('aOGjz'));

});

parcelRegister("47tQi", function(module, exports) {

let $2ffef6f65ffb50b7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2ffef6f65ffb50b7$var$load("3IA7L").then(()=>parcelRequire('3vd6f'));

});

parcelRegister("yjDNj", function(module, exports) {

let $0672695a73243a14$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0672695a73243a14$var$load("hpq4P").then(()=>parcelRequire('hy5e4'));

});

parcelRegister("gATwK", function(module, exports) {

let $c14b14af85e511ce$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c14b14af85e511ce$var$load("8WMbP").then(()=>parcelRequire('47py6'));

});

parcelRegister("5hsBE", function(module, exports) {

let $3d84bae1dbf799e6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3d84bae1dbf799e6$var$load("kffHA").then(()=>parcelRequire('fZXUj'));

});

parcelRegister("4YlTZ", function(module, exports) {

let $39edc14fafc359e5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $39edc14fafc359e5$var$load("2zh8u").then(()=>parcelRequire('4BVSW'));

});

parcelRegister("1FSLe", function(module, exports) {

let $13841922cb7e7278$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $13841922cb7e7278$var$load("9YoTA").then(()=>parcelRequire('eI8pB'));

});

parcelRegister("1eX7w", function(module, exports) {

let $0e74f55502569d12$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0e74f55502569d12$var$load("a9qyt").then(()=>parcelRequire('6xDrT'));

});

parcelRegister("anvPL", function(module, exports) {

let $78e4bee6dd082d13$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $78e4bee6dd082d13$var$load("04egH").then(()=>parcelRequire('fBdRZ'));

});



parcelRegister("aeF8q", function(module, exports) {

$parcel$export(module.exports, "BuildVersionAnalyticContext", () => $79b726b1281ccb40$export$7095b8205ce661b6);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $hpDfc = parcelRequire("hpDfc");

var $2GmtI = parcelRequire("2GmtI");
const $79b726b1281ccb40$export$7095b8205ce661b6 = ({ children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
        analyticContext: {
            frontend: (0, $2GmtI.BUILD_VERSION)
        },
        nonPrivacySafeAnalyticContext: {},
        children: children
    });

});

parcelRegister("6dbhj", function(module, exports) {

$parcel$export(module.exports, "default", () => $95fbe0eb5eb00d19$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $6dP89 = parcelRequire("6dP89");

var $4ldrV = parcelRequire("4ldrV");
var $95fbe0eb5eb00d19$export$2e2bcd8739ae039 = ()=>{
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    (0, $gwFzn.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'operational',
            action: 'exposed',
            actionSubject: 'quickSearchExperiment',
            source: 'searchDialog'
        });
    // We keep the searchSessionId here because we want a new experiment exposure event every new session
    }, [
        fireAnalyticsEvent,
        searchSessionId
    ]);
    return null;
};

});

parcelRegister("2GvH8", function(module, exports) {

$parcel$export(module.exports, "DialogDismissedHandler", () => $2910c33607471958$export$50483e15753411d8);

var $gwFzn = parcelRequire("gwFzn");

var $lnXRc = parcelRequire("lnXRc");

var $5dFS9 = parcelRequire("5dFS9");
class $2910c33607471958$export$b768cbf5d904a94a extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidUpdate(prevProps) {
        const { onDialogClosed: onDialogClosed, isExpanded: isExpanded } = this.props;
        if (prevProps.isExpanded && !isExpanded) onDialogClosed();
    }
    render() {
        return null;
    }
}
const $2910c33607471958$export$50483e15753411d8 = (0, $lnXRc.withAnalytics)({
    onDialogClosed: (0, $5dFS9.onDismissed)
})($2910c33607471958$export$b768cbf5d904a94a);

});

parcelRegister("fj1bk", function(module, exports) {

$parcel$export(module.exports, "AsyncLoadOnQuery", () => $c422feafa0c6ebb6$export$c658105a3bdf0409);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gF7Az = parcelRequire("gF7Az");

var $2ZIpG = parcelRequire("2ZIpG");


const $c422feafa0c6ebb6$export$c658105a3bdf0409 = ()=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const [isFetched, setIsFetched] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (query && isFetched === false && isExpanded) {
            (parcelRequire("e1DgV"));
            (parcelRequire("fqWdp"));
            setIsFetched(true);
        }
    }, [
        query,
        isFetched,
        setIsFetched,
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
};

});
parcelRegister("fqWdp", function(module, exports) {

let $b3c671107460e8ca$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b3c671107460e8ca$var$load("lUh9w").then(()=>parcelRequire('5F6io'));

});


parcelRegister("hKdD9", function(module, exports) {

$parcel$export(module.exports, "AutocorrectionProvider", () => $e996a7cbe3e17aef$export$8ba6d08e2bcc861f);
$parcel$export(module.exports, "useAutocorrection", () => $e996a7cbe3e17aef$export$2f6912f63e498900);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $2ZIpG = parcelRequire("2ZIpG");

var $5TmpD = parcelRequire("5TmpD");

var $kmpep = parcelRequire("kmpep");
const $e996a7cbe3e17aef$var$NO_CORRECTION = [];
const $e996a7cbe3e17aef$var$AutocorrectionContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    correction: undefined,
    setCorrection: ()=>{}
});
const $e996a7cbe3e17aef$export$8ba6d08e2bcc861f = ({ children: children })=>{
    const { autocorrectionEnabled: autocorrectionEnabled } = (0, $5TmpD.useAutocorrectionEnabled)();
    const [correction, setCorrection] = (0, $gwFzn.useState)($e996a7cbe3e17aef$var$NO_CORRECTION);
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { locale: locale } = (0, $dBxQj.default)();
    const lang = (0, $5TmpD.sanitizeLanguage)(locale);
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const { url: aggregatorUrl, cloudId: cloudId } = aggregatorClient?.getAggregatorConfig() || {};
    (0, $gwFzn.useEffect)(()=>{
        setCorrection($e996a7cbe3e17aef$var$NO_CORRECTION);
        if (autocorrectionEnabled && (0, $5TmpD.shouldFetchAutocorrection)(query) && aggregatorUrl && cloudId) (0, $5TmpD.fetchAutocorrection)({
            query: query,
            aggregatorUrl: aggregatorUrl,
            lang: lang,
            cloudId: cloudId
        }).then((result)=>{
            if (!!result.termCorrections) setCorrection(result.termCorrections);
        }).catch((_error_)=>{});
    }, [
        autocorrectionEnabled,
        query,
        aggregatorUrl,
        cloudId,
        lang
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($e996a7cbe3e17aef$var$AutocorrectionContext.Provider, {
        value: {
            correction: correction,
            setCorrection: setCorrection
        },
        children: children
    });
};
const $e996a7cbe3e17aef$export$2f6912f63e498900 = ()=>{
    return (0, $gwFzn.useContext)($e996a7cbe3e17aef$var$AutocorrectionContext);
};

});

parcelRegister("5YmSS", function(module, exports) {

$parcel$export(module.exports, "DialogShownHandler", () => $5fa054eff2cb0a5a$export$914029055eb3fe8e);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fJRVo = parcelRequire("fJRVo");

var $5dFS9 = parcelRequire("5dFS9");

var $lnXRc = parcelRequire("lnXRc");

var $eztGN = parcelRequire("eztGN");
const $5fa054eff2cb0a5a$export$18e8dcaf0a5a46b2 = ({ isExpanded: isExpanded, onDialogShown: onDialogShown })=>{
    const { products: products, getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const isRovoCrossProductSearchLinkShown = (0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id);
    (0, $gwFzn.useEffect)(()=>{
        const emitAnalyticsEvent = ()=>{
            const visibleProducts = products.map((product)=>product.title);
            const visibleTabsCount = visibleProducts.length > 1 ? products.length : 0;
            onDialogShown({
                visibleProducts: visibleProducts,
                visibleTabsCount: visibleTabsCount,
                isRovoCrossProductSearchLinkShown: isRovoCrossProductSearchLinkShown
            });
        };
        isExpanded && emitAnalyticsEvent();
    }, [
        isExpanded
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
};
const $5fa054eff2cb0a5a$export$914029055eb3fe8e = (0, $lnXRc.withAnalytics)({
    onDialogShown: (0, $5dFS9.onShown)
})($5fa054eff2cb0a5a$export$18e8dcaf0a5a46b2);

});

parcelRegister("lesEq", function(module, exports) {

$parcel$export(module.exports, "QuickFindAnalyticContext", () => $f9a704b413e9ca44$export$bf21b659e40e8eb4);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $hpDfc = parcelRequire("hpDfc");
const $f9a704b413e9ca44$export$bf21b659e40e8eb4 = ({ children: children, isQuickFind: isQuickFind = false })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
        analyticContext: {
            isQuickFind: isQuickFind
        },
        nonPrivacySafeAnalyticContext: {},
        children: children
    });

});


parcelRegister("7qNFx", function(module, exports) {

$parcel$export(module.exports, "ProductTabs", () => $f90153b55c207314$export$f698db24bc555eee);

var $7UHDa = parcelRequire("7UHDa");

var $4A7Gn = parcelRequire("4A7Gn");
var $gCbPZ = parcelRequire("gCbPZ");
var $0DTaW = parcelRequire("0DTaW");
parcelRequire("gwFzn");

var $5dFS9 = parcelRequire("5dFS9");
var $6dP89 = parcelRequire("6dP89");

var $gRazf = parcelRequire("gRazf");

var $aQmDW = parcelRequire("aQmDW");

var $gF7Az = parcelRequire("gF7Az");

var $fJRVo = parcelRequire("fJRVo");

var $5EVbL = parcelRequire("5EVbL");
const $f90153b55c207314$var$CustomTab = ({ index: index, title: title, tabRenderer: tabRenderer })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gCbPZ.default), {
        testId: `search-dialog-product-tab-${index}`,
        children: tabRenderer ? tabRenderer({
            title: title
        }) : title
    }, index);
};
const $f90153b55c207314$export$bd4c4b880e23a953 = (props)=>{
    const { products: products, showProduct: showProduct, getActiveProduct: getActiveProduct, isExpanded: isExpanded, abTest: abTest } = props;
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const onTabClicked = (index)=>{
        const id = products[index].id;
        showProduct(products[index].id);
        fireAnalyticsEvent((0, $5dFS9.onTabSelected)({
            tabName: id
        }));
    };
    const activeProductId = getActiveProduct()?.id;
    const activeProductIndex = products.findIndex((product)=>product.id === activeProductId);
    const primaryProduct = products.find((product)=>product.order === 0);
    if (activeProductIndex === -1 && isExpanded && primaryProduct && abTest) {
        showProduct(primaryProduct.id);
        return null;
    }
    if (!isExpanded || products.length === 1 || !abTest || !primaryProduct) return null;
    // Tabs has unwanted flex-basis: 100% set, div wrapper gets around this
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aQmDW.DisableXPSAB), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5EVbL.TabControlsWrapper), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4A7Gn.default), {
                selected: activeProductIndex,
                onChange: onTabClicked,
                id: "tab-controls",
                shouldUnmountTabPanelOnChange: true,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $0DTaW.default), {
                    children: products.map((product, index)=>/*#__PURE__*/ (0, $7UHDa.jsx)($f90153b55c207314$var$CustomTab, {
                            index: index,
                            title: product.title,
                            tabRenderer: product.tabRenderer
                        }, product.id))
                })
            })
        })
    });
};
const $f90153b55c207314$export$f698db24bc555eee = (0, $gRazf.withABTestContext)((0, $fJRVo.withProductContext)((0, $gF7Az.withDialogExpansionContext)($f90153b55c207314$export$bd4c4b880e23a953)));

});
parcelRegister("aQmDW", function(module, exports) {

$parcel$export(module.exports, "DisableXPSAB", () => $fdf090eb866a7114$export$67fbd6b459867ac2);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $gRazf = parcelRequire("gRazf");
const $fdf090eb866a7114$export$67fbd6b459867ac2 = ({ children: children })=>{
    const abTest = (0, $gRazf.useABTest)();
    if (abTest?.experimentId === 'xps-hidden') // This experiment is a permanent FE experiment inside aggregator.
    return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};

});

parcelRegister("5EVbL", function(module, exports) {

$parcel$export(module.exports, "TabControlsWrapper", () => $d8c356d6f37fe7d8$export$f26b9facc67e59ba);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwrgp = parcelRequire("gwrgp");
const $d8c356d6f37fe7d8$export$f26b9facc67e59ba = (0, $gwrgp.default)("div", {
    target: "et5m3c0"
})({
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-200, 16px)"}`
});

});


parcelRegister("2ErY6", function(module, exports) {

$parcel$export(module.exports, "ActiveProductSearchInput", () => $088dcb4257ca9f76$export$88d712058aeecea7);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $eSS4z = parcelRequire("eSS4z");

var $1pSma = parcelRequire("1pSma");

var $fJRVo = parcelRequire("fJRVo");

var $3MlpZ = parcelRequire("3MlpZ");

var $2ZIpG = parcelRequire("2ZIpG");

var $gF7Az = parcelRequire("gF7Az");

var $gRazf = parcelRequire("gRazf");

var $9lA6g = parcelRequire("9lA6g");
var $boBbB = parcelRequire("boBbB");

var $a6FpF = parcelRequire("a6FpF");

var $80L9g = parcelRequire("80L9g");

var $dBxQj = parcelRequire("dBxQj");

var $bF0iL = parcelRequire("bF0iL");
const $088dcb4257ca9f76$export$83ddef5d719c74b1 = ({ forwardRef: forwardRef, isExpanded: isExpanded, setIsExpanded: setIsExpanded, activeProductId: activeProductId, query: query, setQuery: setQuery, onNavigateGeneric: onNavigateGeneric, isLoading: isLoading, pageLoadMetrics: pageLoadMetrics, shouldFillContainer: shouldFillContainer })=>{
    const inputRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        if (pageLoadMetrics) {
            const { metric: metric, customDataGetter: customDataGetter } = pageLoadMetrics;
            metric.stop({
                customData: customDataGetter()
            });
        }
    }, [
        pageLoadMetrics
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isExpanded) inputRef?.current?.focus();
    }, [
        isExpanded,
        inputRef,
        activeProductId
    ]);
    const ref = (0, $3MlpZ.mergeRefCallback)(forwardRef, inputRef);
    const openPressTracing = (0, $1pSma.default)('product-search-input-open');
    const onOpen = (0, $gwFzn.useCallback)(()=>{
        setIsExpanded(true);
        openPressTracing();
    }, [
        setIsExpanded,
        openPressTracing
    ]);
    const onBack = (0, $gwFzn.useCallback)(()=>{
        setIsExpanded(false);
    }, [
        setIsExpanded
    ]);
    const inputComponentProps = {
        activeProductId: activeProductId,
        query: query,
        setQuery: setQuery,
        forwardRef: ref,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        onOpen: onOpen,
        onNavigateGeneric: onNavigateGeneric,
        onBack: onBack,
        isLoading: isLoading,
        shouldFillContainer: shouldFillContainer
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a6FpF.GenericProductSearchInput), {
        ...inputComponentProps
    });
};
const $088dcb4257ca9f76$export$88d712058aeecea7 = ({ features: features, shouldFillContainer: shouldFillContainer, ...rest })=>{
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const { query: query, setQuery: setQuery, isLoading: isLoading } = (0, $2ZIpG.useQuery)();
    const { isExpanded: isExpanded, setIsExpanded: setIsExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { stickySearchEnabled: stickySearchEnabled } = (0, $80L9g.useSessionUserInput)();
    const abTest = (0, $gRazf.useABTest)();
    const theme = (0, $eSS4z.useTheme)();
    const activeProduct = getActiveProduct();
    const intl = (0, $dBxQj.default)();
    if (!abTest) return features?.interactiveSkeleton ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $boBbB.ProductSearchInputSkeletonInteractive), {
        theme: theme,
        shouldFillContainer: shouldFillContainer,
        stickySearchEnabled: stickySearchEnabled,
        ...features.interactiveSkeleton
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9lA6g.ProductSearchInputSkeleton), {
        shouldFillContainer: shouldFillContainer,
        theme: theme,
        placeholder: intl.formatMessage((0, $bF0iL.messages).common_search_input_collapsed_placeholder)
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)($088dcb4257ca9f76$export$83ddef5d719c74b1, {
        ...rest,
        shouldFillContainer: shouldFillContainer,
        activeProductId: activeProduct?.id,
        query: query,
        setQuery: setQuery,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        isLoading: isLoading
    });
};

});
parcelRegister("9lA6g", function(module, exports) {

$parcel$export(module.exports, "ProductSearchInputSkeleton", () => $40910eaaf86d577d$export$91fb362ea940bd8b);
/*
 * Minimalistic version of the search dialog, that provides a ready-only view
 * to be used as a loading component in async components and SSR.
 */ 
var $7UHDa = parcelRequire("7UHDa");

var $4smHY = parcelRequire("4smHY");
var $eSS4z = parcelRequire("eSS4z");
parcelRequire("gwFzn");
const $40910eaaf86d577d$export$91fb362ea940bd8b = ({ theme: theme, ...rest })=>{
    if (theme) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eSS4z.ThemeProvider), {
        partialSearchCSS: theme,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4smHY.default), {
            ...rest
        })
    });
    else return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4smHY.default), {
        ...rest
    });
};

});
parcelRegister("4smHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ea4f392138dd417$export$2e2bcd8739ae039);
/*
 * Skeleton consumed by product-search-dialog only,
 * check the comments in packages/product-search-dialog/src/common/product-search-input/product-search-input-skeleton.tsx.
 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $eSS4z = parcelRequire("eSS4z");

var $fwSxy = parcelRequire("fwSxy");

var $kHWmv = parcelRequire("kHWmv");

var $iSHbD = parcelRequire("iSHbD");

var $1qfLF = parcelRequire("1qfLF");

var $fG2rA = parcelRequire("fG2rA");

var $1jolb = parcelRequire("1jolb");
const $6ea4f392138dd417$var$MAX_INPUT_LENGTH = 500;
const $6ea4f392138dd417$export$9b2f977cfc67f251 = (props)=>{
    const theme = (0, $eSS4z.useTheme)();
    const { forwardRef: forwardRef, features: features, shouldFillContainer: shouldFillContainer, placeholder: nonFeaturesPlaceholder, ariaLabel: ariaLabel, dataSsrPlaceholder: dataSsrPlaceholder } = props;
    const { enabled: enabled, advancedSearchUrl: advancedSearchUrl, placeholder: placeholder, customScriptDataAttributes: customScriptDataAttributes } = features?.interactiveSkeleton || {};
    if (enabled || (0, $fG2rA.getInputSkeletonFocus)()) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1jolb.SSRsearchInput), {
        shouldFillContainer: shouldFillContainer,
        advancedSearchUrl: advancedSearchUrl,
        placeholder: placeholder || nonFeaturesPlaceholder,
        customScriptDataAttributes: customScriptDataAttributes,
        theme: theme
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kHWmv.SearchAnchorWrapper), {
        shouldFillContainer: shouldFillContainer,
        "data-ssr-placeholder": dataSsrPlaceholder,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fwSxy.SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: false,
            role: "search",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.MobileSearchIconWrapper), {
                    isExpanded: false,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                        label: "Search",
                        icon: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $iSHbD.SearchIcon), {
                                theme: theme,
                                isExpanded: false,
                                size: "medium"
                            })
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.DesktopSearchIconWrapper), {
                    ...theme,
                    isExpanded: false,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iSHbD.SearchIcon), {
                        theme: theme,
                        isExpanded: false
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SearchInputField), {
                    "data-test-id": "search-dialog-search-skeleton",
                    isExpanded: false,
                    placeholder: nonFeaturesPlaceholder || placeholder,
                    ref: forwardRef || undefined,
                    disabled: true,
                    value: "",
                    maxLength: $6ea4f392138dd417$var$MAX_INPUT_LENGTH,
                    onChange: ()=>{},
                    "aria-label": ariaLabel || nonFeaturesPlaceholder || placeholder,
                    ...theme
                })
            ]
        })
    });
};
var $6ea4f392138dd417$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)($6ea4f392138dd417$export$9b2f977cfc67f251, {
        ...props,
        forwardRef: ref
    }));

});
parcelRegister("1jolb", function(module, exports) {

$parcel$export(module.exports, "SSRsearchInput", () => SSRsearchInput);
/* eslint-disable import/extensions */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fwSxy = parcelRequire("fwSxy");

var $2wQTl = parcelRequire("2wQTl");

var $iSHbD = parcelRequire("iSHbD");
const SSRsearchInput = ({ advancedSearchUrl, placeholder, customScriptDataAttributes, theme, shouldFillContainer })=>{
    const scriptRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useLayoutEffect)(()=>{
        const current = scriptRef?.current;
        if (current) // eslint-disable-next-line
        eval(current.innerHTML);
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRsearchInputWrapper), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            id: "ssr-search-input-popout-container",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRformContainer), {
                id: "ssr-form-container",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("form", {
                    method: "get",
                    action: advancedSearchUrl,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fwSxy.SSRsearchInputContainer), {
                            shouldFillContainer: shouldFillContainer,
                            id: "ssr-input-container",
                            role: "search",
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRmobileSearchIconWrapper), {
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iSHbD.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false,
                                        size: "medium"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRdesktopSearchIconWrapper), {
                                    id: "ssr-search-icon-wrapper",
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iSHbD.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRsearchInputField), {
                                    id: "ssr-search-input",
                                    name: "text",
                                    placeholder: placeholder,
                                    autoComplete: "off",
                                    "aria-label": placeholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("script", {
                            "data-test-id": "ssr-scripts-init",
                            ref: scriptRef,
                            dangerouslySetInnerHTML: {
                                __html: (0, $2wQTl.script)
                            },
                            ...customScriptDataAttributes
                        })
                    ]
                })
            })
        })
    });
};

});



parcelRegister("a6FpF", function(module, exports) {

$parcel$export(module.exports, "GenericProductSearchInput", () => $e66e5da1711e0ddd$export$372be6d3f9d3f49);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $eaXrL = parcelRequire("eaXrL");

var $bF0iL = parcelRequire("bF0iL");

var $fJRVo = parcelRequire("fJRVo");

var $amrMu = parcelRequire("amrMu");

var $4wMwH = parcelRequire("4wMwH");
const $e66e5da1711e0ddd$var$debounceTime = 250;
const $e66e5da1711e0ddd$var$GenericInputWithIntl = ({ activeProductId: activeProductId, intl: intl, onNavigateGeneric: onNavigateGeneric, query: query, isExpanded: isExpanded, isLoading: isLoading, onOpen: onOpen, forwardRef: forwardRef, onBack: onBack, setQuery: setQuery, shouldFillContainer: shouldFillContainer })=>{
    const { getProduct: getProduct } = (0, $fJRVo.useProductContext)();
    const { isGriffinNavEnabled: isGriffinNavEnabled } = (0, $amrMu.useFeaturesContext)();
    const { queryParams: queryParams } = (0, $4wMwH.useQueryParams)();
    const hasQueryParamText = queryParams?.hasOwnProperty('text');
    const queryParamText = queryParams?.text?.toString() || '';
    const onNavigateGenericInput = (0, $gwFzn.useCallback)((productId)=>(href, event)=>{
            if (href) onNavigateGeneric(productId, href, event);
        }, [
        onNavigateGeneric
    ]);
    // We're using a ref for setQuery so that we can guarantee the function
    // definition is the same reference between renders.
    const setQueryRef = (0, $gwFzn.useRef)(setQuery);
    (0, $gwFzn.useEffect)(()=>{
        setQueryRef.current = setQuery;
    }, [
        setQuery
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isGriffinNavEnabled && hasQueryParamText) setQueryRef.current(queryParamText);
    }, [
        isGriffinNavEnabled,
        hasQueryParamText,
        queryParamText,
        setQueryRef
    ]);
    const { advancedSearchUrl: advancedSearchUrl, secondaryAdvancedSearchURL: secondaryAdvancedSearchURL, onNavigate: onNavigate, actionSubjectId: actionSubjectId, expandedStateInputPlaceholder: // @ts-expect-error
    expandedStateInputPlaceholder } = (()=>{
        if (!activeProductId || !getProduct(activeProductId)) return {
            advancedSearchUrl: '',
            secondaryAdvancedSearchURL: '',
            onNavigate: isGriffinNavEnabled ? onNavigateGenericInput('') : ()=>{},
            actionSubjectId: 'noActiveProduct'
        };
        return {
            advancedSearchUrl: getProduct(activeProductId)?.generateAdvancedSearchUrl?.(query) || '',
            secondaryAdvancedSearchURL: getProduct(activeProductId)?.generateAdvancedSearchUrl?.(query, undefined, 'onInputEnterModified') || '',
            expandedStateInputPlaceholder: getProduct(activeProductId)?.expandedStateInputPlaceholder || '',
            onNavigate: onNavigateGenericInput(activeProductId),
            actionSubjectId: activeProductId
        };
    })();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eaXrL.ProductSearchInput), {
        shouldFillContainer: shouldFillContainer,
        forwardRef: forwardRef,
        value: query,
        isExpanded: isExpanded,
        isLoading: isLoading,
        onOpen: onOpen,
        debounceTime: $e66e5da1711e0ddd$var$debounceTime,
        advancedSearchURL: advancedSearchUrl,
        secondaryAdvancedSearchURL: secondaryAdvancedSearchURL,
        actionSubjectId: actionSubjectId,
        onBack: onBack,
        onInput: setQuery,
        expandedPlaceholder: expandedStateInputPlaceholder ? expandedStateInputPlaceholder : intl.formatMessage((0, $bF0iL.messages).common_search_input_collapsed_placeholder),
        collapsedPlaceholder: intl.formatMessage((0, $bF0iL.messages).common_search_input_collapsed_placeholder),
        onNavigate: onNavigate
    });
};
const $e66e5da1711e0ddd$export$372be6d3f9d3f49 = (0, $js7oX.default)($e66e5da1711e0ddd$var$GenericInputWithIntl);

});
parcelRegister("eaXrL", function(module, exports) {

$parcel$export(module.exports, "ProductSearchInput", () => $b16b15c35dd761da$export$1ea4f29215db3ad6);

var $7UHDa = parcelRequire("7UHDa");

var $9jN1i = parcelRequire("9jN1i");
var $fG2rA = parcelRequire("fG2rA");
var $epS7s = parcelRequire("epS7s");
var $1IGQP = parcelRequire("1IGQP");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $dh538 = parcelRequire("dh538");

var $7rlMm = parcelRequire("7rlMm");

var $3S0fp = parcelRequire("3S0fp");
var $2bO3z = parcelRequire("2bO3z");
var $6dP89 = parcelRequire("6dP89");

var $5dFS9 = parcelRequire("5dFS9");

var $4ldrV = parcelRequire("4ldrV");

var $bF0iL = parcelRequire("bF0iL");

var $3MlpZ = parcelRequire("3MlpZ");

var $80L9g = parcelRequire("80L9g");

var $gF7Az = parcelRequire("gF7Az");

var $fJRVo = parcelRequire("fJRVo");

var $2ZIpG = parcelRequire("2ZIpG");

var $20N1w = parcelRequire("20N1w");

var $amrMu = parcelRequire("amrMu");

var $4wMwH = parcelRequire("4wMwH");

var $eztGN = parcelRequire("eztGN");

var $hWEfb = parcelRequire("hWEfb");

const $b16b15c35dd761da$var$SearchAIPromptComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("dv73R")).then(({ SearchAIPrompt: SearchAIPrompt })=>({
            default: SearchAIPrompt
        })));
const $b16b15c35dd761da$var$AskAIButton = ()=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const queryHash = (0, $3S0fp.sha256Hash)(query);
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const activeProduct = getActiveProduct();
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { showSearchAIDialog: showSearchAIDialog, toggleShowSearchAIDialog: toggleShowSearchAIDialog } = (0, $80L9g.useSessionUserInput)();
    const { isExpanded: isExpanded, setIsExpanded: setIsExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { isGriffinNavEnabled: isGriffinNavEnabled } = (0, $amrMu.useFeaturesContext)();
    const handleToggleShowSearchAIDialog = (0, $gwFzn.useCallback)((show)=>{
        if (isGriffinNavEnabled) setIsExpanded(show);
        toggleShowSearchAIDialog(show);
    }, [
        isGriffinNavEnabled,
        setIsExpanded,
        toggleShowSearchAIDialog
    ]);
    return !!activeProduct?.aiSearchConfig || !!showSearchAIDialog && isExpanded || isGriffinNavEnabled ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {}),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($b16b15c35dd761da$var$SearchAIPromptComponent, {
            query: query,
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            onToggleShowSearchAIDialog: handleToggleShowSearchAIDialog,
            source: "searchDialog"
        })
    }) : null;
};
const $b16b15c35dd761da$var$getTooltipContent = (message)=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7rlMm.KeyboardShortcutContainer), {
        children: [
            message,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7rlMm.KeyboardShortcut), {
                children: '/'
            })
        ]
    });
class $b16b15c35dd761da$export$f964308946b6123b extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidMount() {
        const { onInput: onInput, stickySearchEnabled: stickySearchEnabled } = this.props;
        const skeletonFocused = (0, $fG2rA.getInputSkeletonFocus)();
        const skeletonQuery = (0, $fG2rA.getInputSkeletonQuery)();
        const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $fG2rA.getInputSkeletonSelection)();
        const stickySearchQuery = (0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_QUERY_KEY)) || '';
        if (skeletonFocused) {
            this.expand((0, $5dFS9.Trigger).CLICK);
            onInput?.(skeletonQuery);
            if (this.ref) {
                this.ref.value = skeletonQuery;
                this.ref.focus();
                this.ref?.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
            }
        }
        (0, $fG2rA.removeInputSkeletonState)();
        if (stickySearchEnabled && stickySearchQuery) onInput?.(stickySearchQuery);
    }
    render() {
        const { value: value, isExpanded: isExpanded, expandedPlaceholder: expandedPlaceholder, collapsedPlaceholder: collapsedPlaceholder, debounceTime: debounceTime, intl: intl, showAIToggleButton: showAIToggleButton, isQuickFind: isQuickFind, ...rest } = this.props;
        const placeholder = isExpanded ? expandedPlaceholder : collapsedPlaceholder;
        const tooltipContent = $b16b15c35dd761da$var$getTooltipContent(intl.formatMessage((0, $bF0iL.messages).common_search_input_collapsed_placeholder));
        const SearchInputComponent = isQuickFind ? (0, $9jN1i.default) : (0, $1IGQP.default);
        return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
            children: [
                isExpanded ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2bO3z.default), {
                    query: value,
                    debounceTime: debounceTime
                }) : null,
                /*#__PURE__*/ (0, $7UHDa.jsx)(SearchInputComponent, {
                    ...rest,
                    onClick: this.onInputClick,
                    onInput: this.onInput,
                    ref: this.onRef,
                    isExpanded: isExpanded,
                    placeholder: placeholder,
                    value: value,
                    onEnter: this.onEnter,
                    onClear: this.onClear,
                    toggleAISearchButton: showAIToggleButton ? /*#__PURE__*/ (0, $7UHDa.jsx)($b16b15c35dd761da$var$AskAIButton, {}) : undefined,
                    tooltipContent: tooltipContent,
                    exitSearchLabel: intl.formatMessage((0, $bF0iL.messages).common_search_input_exit_button_label),
                    clearSearchLabel: intl.formatMessage((0, $bF0iL.messages).common_search_input_clear_button_label),
                    ...isQuickFind && {
                        ariaLabelContent: intl.formatMessage((0, $bF0iL.messages).common_search_input_enlarged_aria_label)
                    }
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.ref = null;
        this.onInput = (value)=>{
            if (value !== this.props.value) {
                this.expand((0, $5dFS9.Trigger).TEXT_ENTERED);
                this.props.onInput?.(value);
            }
        };
        this.expand = (trigger)=>{
            const { isExpanded: isExpanded, onOpen: onOpen, preQueryScreenViewed: preQueryScreenViewed, searchSessionId: searchSessionId } = this.props;
            if (!isExpanded) {
                onOpen();
                preQueryScreenViewed({
                    searchSessionId: searchSessionId,
                    trigger: trigger
                });
            }
        };
        this.close = (e)=>{
            const { isExpanded: isExpanded, onBack: onBack } = this.props;
            if (isExpanded) onBack?.(e);
        };
        this.onInputClick = ()=>{
            setTimeout(()=>this.ref?.focus());
            this.expand((0, $5dFS9.Trigger).CLICK);
        };
        this.onEnter = (event)=>{
            const { isExpanded: isExpanded, onEnter: onEnter } = this.props;
            if (isExpanded) onEnter?.(event);
        };
        this.onClear = ()=>{
            setTimeout(()=>this.ref?.focus());
            this.props.onClear?.();
        };
        this.onRef = (0, $3MlpZ.mergeRefCallback)(this.props.forwardRef, (ref)=>{
            this.ref = ref;
        });
    }
}
const $b16b15c35dd761da$export$b12c0eea3d812057 = (0, $js7oX.default)($b16b15c35dd761da$export$f964308946b6123b);
const $b16b15c35dd761da$export$1ea4f29215db3ad6 = (props)=>{
    const [_ignore, persistRecentSearchOnEnter] = (0, $20N1w.usePersistRecentSearches)();
    const { actionSubjectId: actionSubjectId, advancedSearchURL: advancedSearchURL, secondaryAdvancedSearchURL: secondaryAdvancedSearchURL, isLoading: isLoading, onNavigate: onNavigate, ...rest } = props;
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { stickySearchEnabled: stickySearchEnabled, query: query, resetSearchSession: resetSearchSession, showSearchAIDialog: showSearchAIDialog } = (0, $80L9g.useSessionUserInput)();
    const { allowChangeExpand: allowChangeExpand } = (0, $gF7Az.useDialogExpansionContext)();
    const { getActiveProduct: getActiveProduct, getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const isRovoCrossProductSearchLinkShown = (0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id);
    const { quickFind: quickFind, isGriffinNavEnabled: isGriffinNavEnabled } = (0, $amrMu.useFeaturesContext)();
    const showSearchOnEnter = !!getActiveProduct()?.showSearchOnEnter;
    const invokePostQuerySearchRef = getActiveProduct()?.invokePostQuerySearchRef;
    const activeProduct = getActiveProduct();
    const showAskAIButton = (0, $gwFzn.useMemo)(()=>{
        if (activeProduct) return !!activeProduct.aiSearchConfig;
        return query.length > 0;
    }, [
        query,
        activeProduct
    ]);
    const aiSearchEnabled = isGriffinNavEnabled ? showAskAIButton : !!getActiveProduct()?.aiSearchConfig || !!showSearchAIDialog;
    const isQuickFind = quickFind?.enabled;
    const { queryParams: queryParams } = (0, $4wMwH.useQueryParams)();
    const onEnter = (0, $gwFzn.useCallback)((event)=>{
        if ((0, $dh538.fg)('psd_stop_propagation_on_enter')) event.stopPropagation();
        persistRecentSearchOnEnter(event);
        if (showSearchAIDialog) return;
        if (showSearchOnEnter && !event?.shiftKey) {
            if (invokePostQuerySearchRef) {
                fireAnalyticsEvent((0, $5dFS9.onNonDebouncedSearchTriggered)());
                invokePostQuerySearchRef.current();
            }
            return;
        }
        const modifierKeyPressed = navigator.userAgent.includes('Mac') ? event.metaKey : event.ctrlKey;
        fireAnalyticsEvent((0, $5dFS9.onAdvancedSearchSelected)({
            actionSubjectId: actionSubjectId,
            isLoading: isLoading,
            newTab: false,
            trigger: modifierKeyPressed ? (0, $5dFS9.Trigger).SHORTCUT_MODIFIED : (0, $5dFS9.Trigger).SHORTCUT,
            // We know the user navigated to Rovo Search in Atlassian Home if the Rovo Search link was shown to them AND they either:
            // 1. navigated when the "All" product tab was selected
            // 2. navigated by using (cmd or ctrl) + enter when any product tab was selected
            isRovoCrossProductSearchLink: isRovoCrossProductSearchLinkShown && (activeProduct?.id === (0, $hWEfb.CROSS_PRODUCT_PRODUCT_ID) || modifierKeyPressed)
        }));
        if (stickySearchEnabled && advancedSearchURL && !isGriffinNavEnabled && !(event.metaKey || event.ctrlKey)) resetSearchSession();
        if (isGriffinNavEnabled) event.currentTarget.blur();
        onNavigate(modifierKeyPressed && secondaryAdvancedSearchURL ? secondaryAdvancedSearchURL : advancedSearchURL, event);
    }, [
        persistRecentSearchOnEnter,
        showSearchAIDialog,
        showSearchOnEnter,
        fireAnalyticsEvent,
        actionSubjectId,
        isLoading,
        stickySearchEnabled,
        advancedSearchURL,
        onNavigate,
        secondaryAdvancedSearchURL,
        invokePostQuerySearchRef,
        resetSearchSession,
        isGriffinNavEnabled,
        isRovoCrossProductSearchLinkShown,
        activeProduct?.id
    ]);
    const onClear = (0, $gwFzn.useCallback)(()=>{
        fireAnalyticsEvent((0, $5dFS9.onXButtonClicked)({
            actionSubjectId: actionSubjectId,
            searchSessionId: searchSessionId
        }));
        resetSearchSession();
        allowChangeExpand(true);
    }, [
        fireAnalyticsEvent,
        actionSubjectId,
        searchSessionId,
        resetSearchSession,
        allowChangeExpand
    ]);
    const onPreQueryScreenViewedCB = (0, $gwFzn.useCallback)((preQueryProps)=>fireAnalyticsEvent({
            ...(0, $5dFS9.onPreQueryScreenViewed)(preQueryProps),
            actionSubject: actionSubjectId
        }), [
        fireAnalyticsEvent,
        actionSubjectId
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($b16b15c35dd761da$export$b12c0eea3d812057, {
        ...rest,
        onEnter: onEnter,
        searchSessionId: searchSessionId,
        preQueryScreenViewed: onPreQueryScreenViewedCB,
        onClear: onClear,
        showClearButton: stickySearchEnabled && query !== '',
        allowChangeExpand: allowChangeExpand,
        stickySearchEnabled: stickySearchEnabled,
        showSearchOnEnter: showSearchOnEnter,
        showAIToggleButton: aiSearchEnabled,
        isLoading: isLoading,
        onNavigate: onNavigate,
        isQuickFind: isQuickFind,
        isGriffinNavEnabled: isGriffinNavEnabled,
        queryParams: queryParams
    });
};

});
parcelRegister("9jN1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $701d0a94d5d1fefc$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $3gadb = parcelRequire("3gadb");

var $3bV1Q = parcelRequire("3bV1Q");

var $1qfLF = parcelRequire("1qfLF");

var $eSS4z = parcelRequire("eSS4z");

var $iSHbD = parcelRequire("iSHbD");

var $fwSxy = parcelRequire("fwSxy");

var $kLFxv = parcelRequire("kLFxv");

var $c4tFX = parcelRequire("c4tFX");

var $6fnsQ = parcelRequire("6fnsQ");
const $701d0a94d5d1fefc$var$MAX_INPUT_LENGTH = 500;
const $701d0a94d5d1fefc$export$33e4ffe00576d3b4 = ({ onInput: onInput, onClick: onClick, onEnter: onEnter, isExpanded: isExpanded, placeholder: placeholder, forwardRef: forwardRef, value: value, theme: theme, tooltipContent: tooltipContent, onBack: onBack, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, exitSearchLabel: exitSearchLabel, clearSearchLabel: clearSearchLabel, shouldFillContainer: shouldFillContainer, onSelect: onSelect, ariaLabelContent: ariaLabelContent })=>{
    const handleInput = (e)=>{
        if (onInput) onInput(e.currentTarget.value);
    };
    const handleClick = (e)=>{
        if (onClick) onClick(e);
    };
    const handleKeyDown = (e)=>{
        if (e.nativeEvent?.isComposing || e.keyCode === 229) return;
        if (!e.defaultPrevented && e.key === 'Enter') {
            e.preventDefault();
            onEnter && onEnter(e);
        }
    };
    const handleSelect = (e)=>{
        if (onSelect) onSelect(e);
    };
    const TooltipComponent = tooltipContent && !isExpanded ? undefined : (0, $fwSxy.HiddenTooltip);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        content: tooltipContent,
        // NOTE: Types in React 18 have changed, `styled(TooltipPrimitive)` is no longer valid
        component: TooltipComponent,
        position: "bottom",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fwSxy.SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            role: "search",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.MobileSearchIconWrapper), {
                    isExpanded: isExpanded,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                        onClick: handleClick,
                        label: "Search",
                        icon: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $iSHbD.SearchIcon), {
                                theme: theme,
                                isExpanded: isExpanded,
                                size: "small"
                            })
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kLFxv.EnlargedDesktopSearchIconWrapper), {
                    ...theme,
                    isExpanded: isExpanded,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iSHbD.SearchIcon), {
                        theme: theme,
                        isExpanded: isExpanded,
                        size: isExpanded ? 'medium' : 'small',
                        primaryColor: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
                    })
                }),
                isExpanded && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.ArrowIconWrapper), {
                    ...theme,
                    onClick: onBack,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3bV1Q))), {
                        label: exitSearchLabel || 'Exit Search',
                        LEGACY_size: "large",
                        color: "currentColor"
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kLFxv.EnlargedSearchInputField), {
                    "data-test-id": "search-dialog-input",
                    onInput: handleInput,
                    onChange: handleInput,
                    onKeyDown: handleKeyDown,
                    onClick: handleClick,
                    onSelect: handleSelect,
                    isExpanded: isExpanded,
                    placeholder: placeholder,
                    ref: forwardRef || undefined,
                    value: value,
                    maxLength: $701d0a94d5d1fefc$var$MAX_INPUT_LENGTH,
                    "aria-label": ariaLabelContent || placeholder,
                    ...theme
                }),
                showClearButton && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c4tFX.EnlargedSearchInputOverlay), {
                    theme: theme,
                    showClearButton: showClearButton,
                    onClear: onClear,
                    allowChangeExpand: allowChangeExpand,
                    clearSearchLabel: clearSearchLabel,
                    isExpanded: isExpanded
                })
            ]
        })
    });
};
var $701d0a94d5d1fefc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef((props, ref)=>{
    const theme = (0, $eSS4z.useTheme)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)($701d0a94d5d1fefc$export$33e4ffe00576d3b4, {
        ...props,
        theme: theme,
        forwardRef: ref
    });
});

});
parcelRegister("kLFxv", function(module, exports) {

$parcel$export(module.exports, "EnlargedDesktopSearchIconWrapper", () => $b971e56a6791576d$export$3324ef4e3e3970dc);
$parcel$export(module.exports, "EnlargedClearIconWrapper", () => $b971e56a6791576d$export$68bd88880d49fc5);
$parcel$export(module.exports, "EnlargedSearchInputField", () => $b971e56a6791576d$export$aa34c63c6bd8fcb0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2azjJ = parcelRequire("2azjJ");

var $6fnsQ = parcelRequire("6fnsQ");

var $fwSxy = parcelRequire("fwSxy");

var $gwrgp = parcelRequire("gwrgp");
const $b971e56a6791576d$export$3324ef4e3e3970dc = /*#__PURE__*/ (0, $gwrgp.default)((0, $fwSxy.DesktopSearchIconWrapper), {
    target: "e4mn9mz0"
})("width:", (props)=>props.isExpanded ? (0, $2azjJ.enlargedInputFieldHeight).half().px : (0, $2azjJ.grid).multiple(2).px, ";height:", (props)=>props.isExpanded ? (0, $2azjJ.enlargedInputFieldHeight).half().px : (0, $2azjJ.grid).multiple(2).px, ";top:", (props)=>props.isExpanded ? (0, $2azjJ.grid).multiple(1.5).px : (0, $2azjJ.grid).px, ";left:", (props)=>props.isExpanded ? (0, $2azjJ.grid).multiple(2).px : (0, $2azjJ.grid).px, ";display:flex;align-items:center;");
const $b971e56a6791576d$export$68bd88880d49fc5 = /*#__PURE__*/ (0, $gwrgp.default)((0, $fwSxy.ClearIconWrapper), {
    target: "e4mn9mz1"
})("width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);padding-top:0;padding-bottom:0;padding-left:", ({ isExpanded: isExpanded })=>isExpanded ? `${"var(--ds-space-150, 12px)"}` : '0', ";padding-right:", ({ isExpanded: isExpanded })=>isExpanded ? `${"var(--ds-space-200, 16px)"}` : '2px', ";color:", `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`, ";");
const $b971e56a6791576d$export$aa34c63c6bd8fcb0 = /*#__PURE__*/ (0, $gwrgp.default)((0, $fwSxy.SearchInputField), {
    target: "e4mn9mz2"
})("display:flex;align-items:center;height:", (props)=>props.isExpanded ? (0, $2azjJ.enlargedInputFieldHeight).px : (0, $2azjJ.inputFieldHeight).px, ";border-radius:", (props)=>props.isExpanded ? '8px' : '5px', ";padding:", (props)=>props.isExpanded ? `${"var(--ds-space-150, 12px)"} 52px ${"var(--ds-space-150, 12px)"} 52px` : `0px ${"var(--ds-space-300, 24px)"} 0px 30px`, ";:focus{border:none;box-shadow:", `var(--ds-shadow-overlay, ${'0 ' + (0, $2azjJ.grid).multiple(0.5).px + ' ' + (0, $2azjJ.grid).px + ' ' + (0, $6fnsQ.N50A) + ', 0 0 1px ' + (0, $6fnsQ.N60A)})`, ";}");

});

parcelRegister("c4tFX", function(module, exports) {

$parcel$export(module.exports, "EnlargedSearchInputOverlay", () => $9d7751af5f629de9$export$cfdb69c9b0b1fec);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $fwSxy = parcelRequire("fwSxy");

var $2hj6R = parcelRequire("2hj6R");

var $kLFxv = parcelRequire("kLFxv");
const $9d7751af5f629de9$export$cfdb69c9b0b1fec = ({ theme: theme, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, clearSearchLabel: clearSearchLabel, isExpanded: isExpanded })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.InputBoxOverlayRight), {
        children: showClearButton && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kLFxv.EnlargedClearIconWrapper), {
            ...theme,
            role: "button",
            onClick: onClear,
            onMouseEnter: ()=>{
                allowChangeExpand?.(false);
            },
            onMouseLeave: ()=>{
                allowChangeExpand?.(true);
            },
            tabIndex: 0,
            isExpanded: isExpanded,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2hj6R))), {
                color: "currentColor",
                label: clearSearchLabel || 'Clear search session',
                LEGACY_size: "medium",
                spacing: "spacious"
            })
        })
    });
};

});


parcelRegister("7rlMm", function(module, exports) {

$parcel$export(module.exports, "KeyboardShortcutContainer", () => $be76b25cc1b2639d$export$e2deb14b255cffa0);
$parcel$export(module.exports, "KeyboardShortcut", () => $be76b25cc1b2639d$export$47a1bf8d9994c680);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $be76b25cc1b2639d$export$e2deb14b255cffa0 = (0, $gwrgp.default)("div", {
    target: "e19ugnpx0"
})({
    name: "xwvfuj",
    styles: "display:flex;line-height:16px;align-items:center;padding-bottom:var(--ds-space-025, 2px);padding-top:var(--ds-space-025, 2px);"
});
const $be76b25cc1b2639d$export$47a1bf8d9994c680 = (0, $gwrgp.default)("div", {
    target: "e19ugnpx1"
})({
    backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N400)})`,
    border: `1px solid ${`var(--ds-text-inverse, ${(0, $6fnsQ.N400)})`}`,
    borderRadius: '2px',
    marginLeft: "var(--ds-space-050, 4px)",
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"}`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});

});

parcelRegister("2bO3z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3576e5ec930ddc0$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $5dFS9 = parcelRequire("5dFS9");

var $lnXRc = parcelRequire("lnXRc");

var $2jjxD = parcelRequire("2jjxD");
class $b3576e5ec930ddc0$export$6cdeb9eeefdb65f3 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidUpdate(prevProps) {
        const { query: query } = this.props;
        if (prevProps.query !== query) /**
       * Earlier this component was child of [confluence|jira]-search-dialog which ensured that this got fired after the debounced search.
       * Now it will get moved to the wrapper component which will bring this at the same level as [confluence|jira]-search-dialog.
       * This leads to the event handler getting fired in the same tick before the debounced search.
       * Hence, forceful execution in the next tick.
       */ setTimeout(()=>this.textEntered());
    }
    componentWillUnmount() {
        this.textEntered.cancel();
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.textEntered = (0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(()=>{
            const { textEntered: textEntered } = this.props;
            textEntered();
        }, this.props.debounceTime || 0);
    }
}
var $b3576e5ec930ddc0$export$2e2bcd8739ae039 = (0, $lnXRc.withAnalytics)({
    textEntered: (0, $5dFS9.onTextEntered)
})($b3576e5ec930ddc0$export$6cdeb9eeefdb65f3);

});

parcelRegister("hWEfb", function(module, exports) {

$parcel$export(module.exports, "CROSS_PRODUCT_PRODUCT_ID", () => $6bef6d6b7bd7e701$export$6f9668437bcabf4e);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $kmpep = parcelRequire("kmpep");

var $aXg1M = parcelRequire("aXg1M");

var $k5vpy = parcelRequire("k5vpy");

var $ejGzS = parcelRequire("ejGzS");

var $avAUi = parcelRequire("avAUi");

var $4ldrV = parcelRequire("4ldrV");

var $lfOhG = parcelRequire("lfOhG");

var $74Udv = parcelRequire("74Udv");
const $6bef6d6b7bd7e701$export$6f9668437bcabf4e = 'rovo-cross-product';
const $6bef6d6b7bd7e701$var$resultRenderer = (args)=>(0, $ejGzS.defaultResultRenderer)({
        ...args,
        isCollapsed: true
    });
const $6bef6d6b7bd7e701$export$6ca9415334f42abe = ()=>{
    const intl = (0, $dBxQj.default)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const [results, setResults] = (0, $gwFzn.useState)([]);
    const [isQueryResolved, setIsQueryResolved] = (0, $gwFzn.useState)(false);
    const hasFilters = (0, $lfOhG.useCurrentProductHasAppliedFilters)();
    const preQuerySupplier = (0, $gwFzn.useCallback)(async ()=>{
        let currentResults = results;
        if (!isQueryResolved) {
            const response = await (0, $avAUi.fetchRecentActivities)(cloudId || '', searchSessionId || '');
            currentResults = response.filter((result)=>result !== undefined);
            setResults(currentResults);
            setIsQueryResolved(true);
        }
        return {
            size: currentResults.length,
            sections: [
                {
                    id: (0, $aXg1M.CrossProductScope).RECENTS,
                    title: intl.formatMessage((0, $k5vpy.messages).cross_product_recents_section_heading),
                    searchResults: currentResults,
                    resultRenderer: $6bef6d6b7bd7e701$var$resultRenderer
                }
            ]
        };
    }, [
        cloudId,
        intl,
        isQueryResolved,
        results,
        searchSessionId
    ]);
    const postQuerySupplier = (0, $gwFzn.useCallback)(async (args)=>{
        let currentResults = results;
        if (!isQueryResolved) {
            const response = await (0, $avAUi.fetchRecentActivities)(cloudId || '', searchSessionId || '');
            currentResults = response.filter((result)=>result !== undefined);
            setResults(currentResults);
            setIsQueryResolved(true);
        }
        const searchResults = {
            size: currentResults.length,
            sections: [
                {
                    id: (0, $aXg1M.CrossProductScope).RESULTS,
                    title: intl.formatMessage((0, $k5vpy.messages).cross_product_results_section_heading),
                    searchResults: currentResults,
                    resultRenderer: $6bef6d6b7bd7e701$var$resultRenderer
                }
            ]
        };
        return (0, $74Udv.filterFirstSectionItems)(searchResults, args.query, hasFilters ? 0 : 3);
    }, [
        cloudId,
        intl,
        isQueryResolved,
        results,
        searchSessionId,
        hasFilters
    ]);
    return {
        preQuerySupplier: preQuerySupplier,
        postQuerySupplier: postQuerySupplier
    };
};

});
parcelRegister("aXg1M", function(module, exports) {

$parcel$export(module.exports, "CrossProductScope", () => $7a3bb0801b8c1429$export$8b40788ab131f69a);
var $7a3bb0801b8c1429$export$8b40788ab131f69a = /*#__PURE__*/ function(CrossProductScope) {
    CrossProductScope["RECENTS"] = "rovo-cross-product.recents";
    CrossProductScope["RESULTS"] = "rovo-cross-product.results";
    return CrossProductScope;
}({});

});

parcelRegister("k5vpy", function(module, exports) {

$parcel$export(module.exports, "messages", () => $644bc14e6914d1ea$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $644bc14e6914d1ea$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    cross_product_tab_label: {
        id: "product_search_dialog.cross_product.tab_label",
        defaultMessage: "All"
    },
    cross_product_expanded_input_placeholder: {
        id: "product_search_dialog.cross_product.expanded.input-placeholder",
        defaultMessage: "Search All"
    },
    cross_product_recents_section_heading: {
        id: "product_search_dialog.cross_product.recents.section_heading",
        defaultMessage: "Recently viewed"
    },
    cross_product_results_section_heading: {
        id: "product_search_dialog.cross_product.results.section_heading",
        defaultMessage: "Search results"
    },
    googleDocsLabel: {
        id: "document-search-result.google-docs-label",
        defaultMessage: "Docs"
    },
    googleSlidesLabel: {
        id: "document-search-result.google-slides-label",
        defaultMessage: "Slides"
    },
    googleSheetsLabel: {
        id: "document-search-result.google-sheets-label",
        defaultMessage: "Sheets"
    },
    msWordLabel: {
        id: "document-search-result.ms-word-label",
        defaultMessage: "Word"
    },
    msPowerpointLabel: {
        id: "document-search-result.ms-powerpoint-label",
        defaultMessage: "PowerPoint"
    },
    msExcelLabel: {
        id: "document-search-result.ms-excel-label",
        defaultMessage: "Excel"
    },
    cross_product_empty_state_body: {
        id: "product_search_dialog.cross_product.empty.no_results_body",
        defaultMessage: "<a>Search all content across your organization</a> or try a different term."
    },
    documentLabel: {
        id: "document.label",
        defaultMessage: "Document"
    },
    spreadsheetLabel: {
        id: "spreadsheet.label",
        defaultMessage: "Spreadsheet"
    },
    presentationLabel: {
        id: "presentation.label",
        defaultMessage: "Presentation"
    },
    fileLabel: {
        id: "file.label",
        defaultMessage: "File"
    },
    databaseLabel: {
        id: "database.label",
        defaultMessage: "Database"
    },
    webPageLabel: {
        id: "web-page.label",
        defaultMessage: "Web Page"
    },
    pageLabel: {
        id: "page.label",
        defaultMessage: "Page"
    },
    blogpostLabel: {
        id: "blogpost.label",
        defaultMessage: "Blogpost"
    },
    dashboardLabel: {
        id: "dashboard.label",
        defaultMessage: "Dashboard"
    },
    invoiceLabel: {
        id: "invoice.label",
        defaultMessage: "Invoice"
    },
    designLabel: {
        id: "design.label",
        defaultMessage: "Design"
    },
    dealLabel: {
        id: "deal.label",
        defaultMessage: "Deal"
    },
    videoLabel: {
        id: "video.label",
        defaultMessage: "Video"
    },
    taskLabel: {
        id: "task.label",
        defaultMessage: "Task"
    },
    issueLabel: {
        id: "issue.label",
        defaultMessage: "Issue"
    },
    spaceLabel: {
        id: "space.label",
        defaultMessage: "Space"
    },
    projectLabel: {
        id: "project.label",
        defaultMessage: "Project"
    },
    repositoryLabel: {
        id: "repository.label",
        defaultMessage: "Repository"
    },
    customerOrgLabel: {
        id: "customer-org.label",
        defaultMessage: "Customer Org"
    },
    imageLabel: {
        id: "image.label",
        defaultMessage: "Image"
    },
    archiveLabel: {
        id: "archive.label",
        defaultMessage: "Archive"
    },
    audioLabel: {
        id: "audio.label",
        defaultMessage: "Audio"
    },
    pdfLabel: {
        id: "pdf.label",
        defaultMessage: "PDF"
    },
    codeLabel: {
        id: "code.label",
        defaultMessage: "Code"
    },
    otherLabel: {
        id: "other.label",
        defaultMessage: "Other"
    }
});

});

parcelRegister("avAUi", function(module, exports) {

$parcel$export(module.exports, "fetchRecentActivities", () => $474e7b9761beed17$export$ae65634d024c5427);

var $ja8yA = parcelRequire("ja8yA");

var $hAdPE = parcelRequire("hAdPE");

var $dh538 = parcelRequire("dh538");
const $474e7b9761beed17$export$48de245659972a87 = [
    'confluence',
    'jira',
    'townsquare',
    'graph'
];
const $474e7b9761beed17$export$742b5ce6018da1f4 = [
    'page',
    'blogpost',
    'whiteboard',
    'issue',
    'project',
    'goal',
    'content',
    'document',
    'remote-link'
];
const $474e7b9761beed17$export$ae65634d024c5427 = async (cloudId, searchSessionId)=>{
    return await (0, $ja8yA.recentActivitiesQuery)({
        variables: {
            filteredProducts: $474e7b9761beed17$export$48de245659972a87,
            filteredObjectTypes: (0, $dh538.fg)('smartlinks-qf-recents') ? $474e7b9761beed17$export$742b5ce6018da1f4 : $474e7b9761beed17$export$742b5ce6018da1f4.filter((type)=>type !== 'remote-link'),
            filteredRootContainerIds: [
                `ari:cloud:platform::site/${cloudId}`,
                `ari:cloud:townsquare::site/${cloudId}`
            ],
            itemsLimit: 200
        }
    }).then((response)=>{
        const edges = response.data?.activity?.myActivity?.all?.edges || [];
        try {
            return edges.map((edge)=>(0, $hAdPE.mapRecentActivitiesToSearchResult)(edge, searchSessionId || ''));
        } catch (error) {
            return [];
        }
    }).catch((error)=>{
        throw error;
    });
};

});
parcelRegister("hAdPE", function(module, exports) {

$parcel$export(module.exports, "mapRecentActivitiesToSearchResult", () => $8c4486081ff94342$export$b4f3fd6ea4c72985);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $hWR4v = parcelRequire("hWR4v");
var $6h3V2 = parcelRequire("6h3V2");

var $icWhS = parcelRequire("icWhS");
var $lNtmT = parcelRequire("lNtmT");

var $RTf6z = parcelRequire("RTf6z");

var $hjY9y = parcelRequire("hjY9y");

var $4jR19 = parcelRequire("4jR19");

var $dh538 = parcelRequire("dh538");

var $k5vpy = parcelRequire("k5vpy");
const $8c4486081ff94342$var$typeLabelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $8c4486081ff94342$export$a47c0c6de01249fd = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const SUBTYPE_DOCUMENT = 'DOCUMENT';
    const SUBTYPE_PRESENTATION = 'PRESENTATION';
    const SUBTYPE_SPREADSHEET = 'SPREADSHEET';
    const GOOGLE_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $k5vpy.messages).googleDocsLabel,
        [SUBTYPE_PRESENTATION]: (0, $k5vpy.messages).googleSlidesLabel,
        [SUBTYPE_SPREADSHEET]: (0, $k5vpy.messages).googleSheetsLabel
    };
    const MICROSOFT_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $k5vpy.messages).msWordLabel,
        [SUBTYPE_PRESENTATION]: (0, $k5vpy.messages).msPowerpointLabel,
        [SUBTYPE_SPREADSHEET]: (0, $k5vpy.messages).msExcelLabel
    };
    const normalizedSubtype = subtype?.toUpperCase();
    let label;
    if (product === (0, $hjY9y.Products).Sharepoint || product === (0, $hjY9y.Products).OneDrive) label = MICROSOFT_LABELS[normalizedSubtype];
    else if (product.includes((0, $hjY9y.Products).GoogleDrive)) label = GOOGLE_LABELS[normalizedSubtype];
    return label;
};
const $8c4486081ff94342$export$19dc2415a5fa9123 = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const labelKey = `${subtype}Label`;
    if (labelKey in (0, $k5vpy.messages)) return (0, $k5vpy.messages)[labelKey];
    else return (0, $k5vpy.messages).otherLabel;
};
const $8c4486081ff94342$var$mapConfluenceActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { title: title, space: space, links: links } = activity.object.data;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hjY9y.ProductIcon), {
        productKey: (0, $hjY9y.Products).Confluence
    });
    const spaceName = space?.name || '';
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const urlBase = links?.base;
    const urlWebUi = links?.webUi;
    const url = urlBase && urlWebUi && `${urlBase}${urlWebUi}`;
    if (!title || !url) return undefined;
    return {
        id: id,
        url: url,
        icon: icon,
        type: activity.object.type,
        title: title,
        meta: spaceName,
        containerId: (0, $lNtmT.transformAriToId)(space?.id || 'UNAVAILABLE', 'space'),
        additionalMeta: timestamp ? (0, $RTf6z.dateFormatter)(timestamp, true, eventType) : ''
    };
};
const $8c4486081ff94342$var$mapJiraActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { key: key, fieldsById: fieldsById, webUrl: webUrl } = activity.object.data;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hjY9y.ProductIcon), {
        productKey: (0, $hjY9y.Products).Jira
    });
    const summary = fieldsById?.edges?.[0]?.node?.text;
    const title = key && summary && `${key}: ${summary}`;
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const meta = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $8c4486081ff94342$var$typeLabelContainer,
        children: activity.object.type
    });
    if (!title || !webUrl) return undefined;
    return {
        id: id,
        url: webUrl,
        icon: icon,
        type: activity.object.type,
        title: title,
        meta: meta,
        containerId: '',
        additionalMeta: timestamp ? (0, $RTf6z.dateFormatter)(timestamp, true, eventType) : ''
    };
};
const $8c4486081ff94342$var$mapTownsquareActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { name: name, key: key, url: url } = activity.object.data;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hjY9y.ProductIcon), {
        productKey: (0, $hjY9y.Products).Atlas
    });
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    if (!name || !url) return undefined;
    return {
        id: id,
        url: url,
        icon: icon,
        type: activity.object.type,
        title: name,
        meta: key,
        containerId: '',
        additionalMeta: timestamp ? (0, $RTf6z.dateFormatter)(timestamp, true, eventType) : ''
    };
};
const $8c4486081ff94342$var$mapGraphDocumentActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const { type: type, displayName: displayName, parent: parent, url: url } = activity.object.data;
    const id = activity.object.id;
    const { resourceOwner: resourceOwner } = (0, $6h3V2.parseThirdPartyARI)(id);
    const resourceType = resourceOwner.split('.').at(1);
    const product = resourceType === 'google-drive' ? 'drive' : resourceType || '';
    if (!Object.values((0, $hjY9y.Products)).includes(product)) return;
    const title = displayName;
    if (!title || !url) return undefined;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hjY9y.ProductIcon), {
        productKey: product
    });
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const subtype = type?.category?.toLowerCase();
    const label = $8c4486081ff94342$export$a47c0c6de01249fd({
        product: product,
        subtype: subtype
    });
    const typeLabel = label ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $8c4486081ff94342$var$typeLabelContainer,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...label
        })
    }) : subtype ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $8c4486081ff94342$var$typeLabelContainer,
        children: subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase()
    }) : null;
    return {
        id: id,
        url: url,
        icon: icon,
        type: type,
        title: title,
        meta: typeLabel,
        containerId: parent?.id || 'UNAVAILABLE',
        additionalMeta: timestamp ? (0, $RTf6z.dateFormatter)(timestamp, true, eventType) : ''
    };
};
const $8c4486081ff94342$var$mapGraphRemoteLinkActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const { displayName: displayName, category: category, url: url } = activity.object.data;
    const id = activity.object.id;
    const { resourceOwner: resourceOwner } = (0, $6h3V2.parseThirdPartyARI)(id);
    const resourceType = resourceOwner.split('.').at(1);
    const product = resourceType === 'google-drive' ? 'drive' : resourceType || '';
    if (!Object.values((0, $hjY9y.Products)).includes(product)) return;
    const title = displayName;
    if (!title || !url) return undefined;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hjY9y.ProductIcon), {
        productKey: product
    });
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const subtype = category?.toLowerCase();
    const label = $8c4486081ff94342$export$19dc2415a5fa9123({
        product: product,
        subtype: subtype
    });
    const typeLabel = label ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $8c4486081ff94342$var$typeLabelContainer,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...label
        })
    }) : subtype ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $8c4486081ff94342$var$typeLabelContainer,
        children: subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase()
    }) : null;
    return {
        id: id,
        url: url,
        icon: icon,
        type: category,
        title: title,
        meta: typeLabel,
        containerId: 'UNAVAILABLE',
        additionalMeta: timestamp ? (0, $RTf6z.dateFormatter)(timestamp, true, eventType) : ''
    };
};
const $8c4486081ff94342$var$mapGraphActivityToSearchResult = (activity)=>{
    if ((0, $hWR4v.isDocumentActivity)(activity.object)) return $8c4486081ff94342$var$mapGraphDocumentActivityToSearchResult(activity);
    if ((0, $hWR4v.isRemoteLinkActivity)(activity.object) && (0, $dh538.fg)('smartlinks-qf-recents')) return $8c4486081ff94342$var$mapGraphRemoteLinkActivityToSearchResult(activity);
    return undefined;
};
const $8c4486081ff94342$export$b4f3fd6ea4c72985 = (edge, searchSessionId)=>{
    const activity = edge.node;
    const product = activity.object.product;
    const result = (0, $hWR4v.isGraphActivity)(activity.object) ? $8c4486081ff94342$var$mapGraphActivityToSearchResult(activity) : product === 'confluence' ? $8c4486081ff94342$var$mapConfluenceActivityToSearchResult(activity) : product === 'jira' ? $8c4486081ff94342$var$mapJiraActivityToSearchResult(activity) : product === 'townsquare' ? $8c4486081ff94342$var$mapTownsquareActivityToSearchResult(activity) : undefined;
    if (!result) return undefined;
    const urlWithAnalyticsQueryParams = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    return {
        ...result,
        url: urlWithAnalyticsQueryParams
    };
};

});
parcelRegister("hjY9y", function(module, exports) {

$parcel$export(module.exports, "Products", () => $f69e6a05e0e63212$export$92e44ea1079b9ec6);
$parcel$export(module.exports, "ProductIcon", () => $f69e6a05e0e63212$export$1a199e029d5e93d6);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4Nwes = parcelRequire("4Nwes");
var $lAFHW = parcelRequire("lAFHW");

var $6LeZx = parcelRequire("6LeZx");

var $dJDhX = parcelRequire("dJDhX");

var $guzTv = parcelRequire("guzTv");

var $eQW47 = parcelRequire("eQW47");

var $g1L9J = parcelRequire("g1L9J");

var $lQxxH = parcelRequire("lQxxH");

var $7MUoO = parcelRequire("7MUoO");

var $foJyA = parcelRequire("foJyA");

var $buthI = parcelRequire("buthI");

var $jFQYg = parcelRequire("jFQYg");

var $ZlCvd = parcelRequire("ZlCvd");

var $aT1C2 = parcelRequire("aT1C2");

var $bKoXw = parcelRequire("bKoXw");

var $cRogp = parcelRequire("cRogp");

var $dpIpE = parcelRequire("dpIpE");

var $2RIXb = parcelRequire("2RIXb");

var $8b6pH = parcelRequire("8b6pH");

var $gNpxn = parcelRequire("gNpxn");

var $fKCBg = parcelRequire("fKCBg");

var $9c5DY = parcelRequire("9c5DY");

var $9dDdC = parcelRequire("9dDdC");

var $9HR5H = parcelRequire("9HR5H");

var $hUGmM = parcelRequire("hUGmM");

var $9eHWZ = parcelRequire("9eHWZ");

var $6mOGj = parcelRequire("6mOGj");

var $xNfJ3 = parcelRequire("xNfJ3");

var $3yTTJ = parcelRequire("3yTTJ");

var $5wHPF = parcelRequire("5wHPF");

var $kVu7G = parcelRequire("kVu7G");

var $9DzSn = parcelRequire("9DzSn");

var $4sX9w = parcelRequire("4sX9w");

var $71zpm = parcelRequire("71zpm");

var $5FlG2 = parcelRequire("5FlG2");

var $2omOh = parcelRequire("2omOh");

var $k6xhg = parcelRequire("k6xhg");

var $i3woo = parcelRequire("i3woo");

var $1lwoS = parcelRequire("1lwoS");

var $gLGvg = parcelRequire("gLGvg");

var $1m0Bz = parcelRequire("1m0Bz");

var $3zUD2 = parcelRequire("3zUD2");

var $gHwiN = parcelRequire("gHwiN");

var $b15lm = parcelRequire("b15lm");

var $iFEkd = parcelRequire("iFEkd");

var $9o6kx = parcelRequire("9o6kx");

var $cegaR = parcelRequire("cegaR");

var $3aDJv = parcelRequire("3aDJv");

var $dgMee = parcelRequire("dgMee");

var $eOwHL = parcelRequire("eOwHL");

var $39NR5 = parcelRequire("39NR5");

var $bIkGo = parcelRequire("bIkGo");

var $8GMEU = parcelRequire("8GMEU");

var $74dAr = parcelRequire("74dAr");

var $dGVh7 = parcelRequire("dGVh7");

var $bndMH = parcelRequire("bndMH");

var $g6dt5 = parcelRequire("g6dt5");

var $fPxww = parcelRequire("fPxww");
const $f69e6a05e0e63212$var$ProductKeys3P = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3'
};
const $f69e6a05e0e63212$var$ProductKeys1P = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Trello: 'trello',
    Focus: 'mercury'
};
const $f69e6a05e0e63212$var$products1PIcons = {
    [$f69e6a05e0e63212$var$ProductKeys1P.Confluence]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $guzTv.ConfluenceIcon), (0, $lAFHW.ConfluenceIcon)), 'Confluence'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Atlas]: (0, $fPxww.RovoLogoFromLogo)((0, $4Nwes.AtlassianIcon), 'Home'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Jira]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $g1L9J.JiraIcon), (0, $lAFHW.JiraIcon)), 'Jira'),
    [$f69e6a05e0e63212$var$ProductKeys1P.JiraProductDiscovery]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $lQxxH.JiraProductDiscoveryIcon), (0, $lAFHW.JiraProductDiscoveryIcon)), 'Jira Product Discovery'),
    [$f69e6a05e0e63212$var$ProductKeys1P.JiraServiceManagement]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $7MUoO.JiraServiceManagementIcon), (0, $lAFHW.JiraServiceManagementIcon)), 'Jira Service Management'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Bitbucket]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $6LeZx.BitbucketIcon), (0, $lAFHW.BitbucketIcon)), 'Bitbucket'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Trello]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $foJyA.TrelloIcon), (0, $lAFHW.TrelloIcon)), 'Trello'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Compass]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $dJDhX.CompassIcon), (0, $lAFHW.CompassIcon)), 'Compass'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Focus]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $eQW47.FocusIcon), (0, $lAFHW.FocusIcon)), 'Focus')
};
const $f69e6a05e0e63212$var$products3PIcons = {
    [$f69e6a05e0e63212$var$ProductKeys3P.AdobeXD]: (0, $fPxww.get3PLogo)((0, $jFQYg.default), 'Adobe XD'),
    [$f69e6a05e0e63212$var$ProductKeys3P.AdobeSign]: (0, $fPxww.get3PLogo)((0, $ZlCvd.default), 'Adobe Sign'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Aha]: (0, $fPxww.get3PLogo)((0, $aT1C2.default), 'Aha'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Airtable]: (0, $fPxww.get3PLogo)((0, $bKoXw.default), 'Airtable'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Amplitude]: (0, $fPxww.get3PLogo)((0, $cRogp.default), 'Amplitude'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Asana]: (0, $fPxww.get3PLogo)((0, $dpIpE.default), 'Asana'),
    [$f69e6a05e0e63212$var$ProductKeys3P.AzureDevops]: (0, $fPxww.get3PLogo)((0, $2RIXb.default), 'Azure Devops'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Box]: (0, $fPxww.get3PLogo)((0, $8b6pH.default), 'Box'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Canva]: (0, $fPxww.get3PLogo)((0, $gNpxn.default), 'Canva'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Docusign]: (0, $fPxww.get3PLogo)((0, $fKCBg.default), 'Docusign'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Dovetail]: (0, $fPxww.get3PLogo)((0, $9c5DY.default), 'Dovetail'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Dropbox]: (0, $fPxww.get3PLogo)((0, $9dDdC.default), 'Dropbox'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Figma]: (0, $fPxww.get3PLogo)((0, $9HR5H.default), 'Figma'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Freshservice]: (0, $fPxww.get3PLogo)((0, $hUGmM.default), 'Freshservice'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Gmail]: (0, $fPxww.get3PLogo)((0, $9eHWZ.default), 'Gmail'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Github]: (0, $fPxww.get3PLogo)((0, $6mOGj.default), 'Github'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Gitlab]: (0, $fPxww.get3PLogo)((0, $xNfJ3.default), 'Gitlab'),
    [$f69e6a05e0e63212$var$ProductKeys3P.GoogleCalendar]: (0, $fPxww.get3PLogo)((0, $3yTTJ.default), 'Google Calendar'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Hubspot]: (0, $fPxww.get3PLogo)((0, $5wHPF.default), 'Hubspot'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Lucid]: (0, $fPxww.get3PLogo)((0, $kVu7G.default), 'Lucid'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Loom]: (0, $fPxww.get3PLogo)((0, $9DzSn.default), 'Loom'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Miro]: (0, $fPxww.get3PLogo)((0, $4sX9w.default), 'Miro'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Monday]: (0, $fPxww.get3PLogo)((0, $71zpm.default), 'Monday'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Mural]: (0, $fPxww.get3PLogo)((0, $5FlG2.default), 'Mural'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Notion]: (0, $fPxww.get3PLogo)((0, $2omOh.default), 'Notion'),
    [$f69e6a05e0e63212$var$ProductKeys3P.OutlookCalendar]: (0, $fPxww.get3PLogo)((0, $k6xhg.default), 'Outlook Calendar'),
    [$f69e6a05e0e63212$var$ProductKeys3P.OutlookMail]: (0, $fPxww.get3PLogo)((0, $i3woo.default), 'Outlook Mail'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Pipedrive]: (0, $fPxww.get3PLogo)((0, $1lwoS.default), 'Pipedrive'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Salesforce]: (0, $fPxww.get3PLogo)((0, $gLGvg.default), 'Salesforce'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Sentry]: (0, $fPxww.get3PLogo)((0, $1m0Bz.default), 'Sentry'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Sharepoint]: (0, $fPxww.get3PLogo)((0, $3zUD2.default), 'Sharepoint'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Slack]: (0, $fPxww.get3PLogo)((0, $gHwiN.default), 'Slack'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Smartsheet]: (0, $fPxww.get3PLogo)((0, $b15lm.default), 'Smartsheet'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Stripe]: (0, $fPxww.get3PLogo)((0, $iFEkd.default), 'Stripe'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Teams]: (0, $fPxww.get3PLogo)((0, $9o6kx.default), 'Teams'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Todoist]: (0, $fPxww.get3PLogo)((0, $cegaR.default), 'Todoist'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Webex]: (0, $fPxww.get3PLogo)((0, $3aDJv.default), 'Webex'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Zeplin]: (0, $fPxww.get3PLogo)((0, $dgMee.default), 'Zeplin'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Zendesk]: (0, $fPxww.get3PLogo)((0, $eOwHL.default), 'Zendesk'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Gitbook]: (0, $fPxww.get3PLogo)((0, $39NR5.default), 'Gitbook'),
    [$f69e6a05e0e63212$var$ProductKeys3P.AtlassianWebCrawler]: (0, $fPxww.RovoLogoFromLogo)((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), 'Atlassian Web Crawler'),
    [$f69e6a05e0e63212$var$ProductKeys3P.ConfluenceDC]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $guzTv.ConfluenceIcon), (0, $lAFHW.ConfluenceIcon)), 'Confluence'),
    [$f69e6a05e0e63212$var$ProductKeys3P.JiraDC]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $g1L9J.JiraIcon), (0, $lAFHW.JiraIcon)), 'Jira'),
    [$f69e6a05e0e63212$var$ProductKeys3P.LaunchDarkly]: (0, $fPxww.get3PLogo)((0, $bIkGo.default), 'LaunchDarkly'),
    [$f69e6a05e0e63212$var$ProductKeys3P.PagerDuty]: (0, $fPxww.get3PLogo)((0, $8GMEU.default), 'PagerDuty'),
    [$f69e6a05e0e63212$var$ProductKeys3P.PowerBI]: (0, $fPxww.get3PLogo)((0, $74dAr.default), 'PowerBI'),
    [$f69e6a05e0e63212$var$ProductKeys3P.ServiceNow]: (0, $fPxww.get3PLogo)((0, $dGVh7.default), 'ServiceNow'),
    [$f69e6a05e0e63212$var$ProductKeys3P.AWSS3]: (0, $fPxww.get3PLogo)((0, $bndMH.default), 'AWSS3'),
    [$f69e6a05e0e63212$var$ProductKeys3P.GoogleDrive]: (0, $fPxww.get3PLogo)((0, $g6dt5.default), 'GoogleDrive')
};
const $f69e6a05e0e63212$var$productIcons = {
    ...$f69e6a05e0e63212$var$products1PIcons,
    ...$f69e6a05e0e63212$var$products3PIcons
};
const $f69e6a05e0e63212$export$92e44ea1079b9ec6 = {
    ...$f69e6a05e0e63212$var$ProductKeys1P,
    ...$f69e6a05e0e63212$var$ProductKeys3P
};
const $f69e6a05e0e63212$export$1a199e029d5e93d6 = ({ productKey: productKey })=>{
    const Icon = $f69e6a05e0e63212$var$productIcons[productKey];
    return Icon ? /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
        label: productKey
    }) : null;
};

});
parcelRegister("jFQYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfe74c44e346a556$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $cfe74c44e346a556$var$AdobeXDIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-635.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#470137"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.5802 7.40457L9.75898 12.1789L12.7683 17.2427C12.7871 17.2812 12.7965 17.3198 12.7871 17.3584C12.7777 17.397 12.7401 17.368 12.6836 17.3777H10.5301C10.3796 17.3777 10.2762 17.368 10.2104 17.2716C10.0129 16.8665 9.806 16.471 9.60851 16.0659C9.41103 15.6705 9.19473 15.2654 8.96903 14.8507C8.74334 14.4359 8.51764 14.0212 8.29194 13.5968H8.27313C8.07565 14.0115 7.85935 14.4263 7.64306 14.841C7.42677 15.2558 7.21047 15.6705 7.00359 16.0756C6.78729 16.4807 6.571 16.8954 6.3547 17.2909C6.31709 17.3873 6.24186 17.397 6.13841 17.397H4.06952C4.0319 17.397 4.00369 17.4163 4.00369 17.368C3.99429 17.3295 4.00369 17.2909 4.0225 17.262L6.94716 12.3429L4.09773 7.39492C4.06952 7.35634 4.06011 7.31776 4.07892 7.29847C4.09773 7.26953 4.13535 7.25989 4.17296 7.25989H6.30768C6.3547 7.25989 6.40173 7.26953 6.43934 7.27918C6.47696 7.29847 6.50517 7.3274 6.53338 7.36598C6.71206 7.78073 6.91895 8.19547 7.13524 8.61021C7.36094 9.02496 7.57723 9.43006 7.81233 9.83515C8.03803 10.2403 8.24492 10.6453 8.44241 11.0601H8.46122C8.6587 10.6357 8.86559 10.221 9.07248 9.81586C9.27937 9.41077 9.49566 9.00567 9.71196 8.60057C9.92825 8.19547 10.1351 7.78073 10.342 7.38528C10.3514 7.34669 10.3702 7.30811 10.3985 7.28882C10.4361 7.26953 10.4737 7.25989 10.5207 7.26953H12.505C12.552 7.25989 12.599 7.28882 12.6084 7.33705C12.6178 7.34669 12.599 7.38528 12.5802 7.40457Z",
                fill: "#FF61F6"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.9248 17.5803C16.2289 17.5899 15.533 17.4453 14.9029 17.1463C14.3105 16.8666 13.8215 16.4036 13.4829 15.8345C13.135 15.2462 12.9657 14.5131 12.9657 13.6354C12.9563 12.9217 13.135 12.2176 13.4829 11.6003C13.8403 10.9733 14.3575 10.4525 14.9782 10.1053C15.6364 9.72911 16.4264 9.54585 17.3574 9.54585C17.4044 9.54585 17.4702 9.54585 17.5549 9.5555C17.711 9.5733 17.8464 9.43978 17.8464 9.28259V6.52691C17.8464 6.45939 17.8746 6.42081 17.9404 6.42081H19.791C19.8299 6.42081 19.873 6.41051 19.9052 6.43245C19.9189 6.44186 19.9299 6.45544 19.937 6.4702C19.9425 6.48177 19.9435 6.50762 19.9435 6.50762C19.9435 6.50762 19.9435 6.50762 19.9435 6.50762V15.6898C19.9435 15.8635 19.9529 16.0564 19.9623 16.2686C19.9811 16.4711 19.9905 16.664 19.9999 16.828C19.9999 16.8955 19.9717 16.9534 19.9059 16.9823C19.4169 17.1945 18.8996 17.3488 18.373 17.4453C17.8934 17.5321 17.4138 17.5803 16.9248 17.5803ZM17.5438 15.7015C17.7293 15.7077 17.8464 15.5265 17.8464 15.3409V11.666C17.8464 11.5147 17.7428 11.3763 17.5925 11.3591C17.489 11.3495 17.3856 11.3399 17.2821 11.3399C16.9154 11.3399 16.5486 11.417 16.2195 11.5906C15.8998 11.7546 15.627 11.9957 15.4201 12.3044C15.2133 12.613 15.1098 13.0278 15.1098 13.5293C15.1004 13.8669 15.1568 14.2045 15.2697 14.5228C15.3637 14.7832 15.5048 15.0147 15.6929 15.2076C15.8715 15.3812 16.0878 15.5162 16.3323 15.5934C16.5862 15.6802 16.8496 15.7188 17.1129 15.7188C17.2409 15.7188 17.3612 15.7108 17.4737 15.7022C17.4964 15.7004 17.521 15.7007 17.5438 15.7015Z",
                fill: "#FF61F6"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.90598 4H17.5043C19.1111 4 20.4103 5.29915 20.4103 6.90598V17.094C20.4103 18.7009 19.1111 20 17.5043 20H6.90598C5.29915 20 4 18.7009 4 17.094V6.90598C4 5.29915 5.29915 4 6.90598 4Z",
                fill: "#470137"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.629 8.2051L10.5777 11.5897L12.7658 15.1795C12.7794 15.2068 12.7863 15.2342 12.7794 15.2615C12.7726 15.2889 12.7453 15.2684 12.7042 15.2752H11.1384C11.029 15.2752 10.9538 15.2684 10.9059 15.2C10.7624 14.9128 10.6119 14.6325 10.4683 14.3453C10.3247 14.0649 10.1675 13.7778 10.0034 13.4837C9.83928 13.1897 9.67518 12.8957 9.51107 12.5948H9.4974C9.35381 12.8889 9.19654 13.1829 9.03928 13.4769C8.88201 13.7709 8.72475 14.0649 8.57432 14.3521C8.41706 14.6393 8.25979 14.9333 8.10253 15.2136C8.07518 15.282 8.02047 15.2889 7.94526 15.2889H6.44099C6.41364 15.2889 6.39312 15.3025 6.39312 15.2684C6.38629 15.241 6.39312 15.2136 6.4068 15.1931L8.5333 11.706L6.4615 8.19827C6.44099 8.17092 6.43415 8.14356 6.44783 8.12989C6.4615 8.10938 6.48885 8.10254 6.5162 8.10254H8.06834C8.10253 8.10254 8.13671 8.10938 8.16406 8.11621C8.19142 8.12989 8.21193 8.1504 8.23244 8.17775C8.36236 8.47177 8.51278 8.76579 8.67005 9.0598C8.83415 9.35382 8.99142 9.641 9.16236 9.92818C9.32646 10.2154 9.47688 10.5025 9.62047 10.7966H9.63415C9.77774 10.4957 9.92817 10.2017 10.0786 9.9145C10.229 9.62733 10.3863 9.34015 10.5436 9.05297C10.7008 8.76579 10.8512 8.47177 11.0017 8.19143C11.0085 8.16408 11.0222 8.13673 11.0427 8.12305C11.07 8.10938 11.0974 8.10254 11.1316 8.10938H12.5743C12.6085 8.10254 12.6427 8.12305 12.6495 8.15724C12.6564 8.16408 12.6427 8.19143 12.629 8.2051Z",
                fill: "#FF61F6"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.788 15.4188C15.282 15.4256 14.776 15.323 14.3179 15.1111C13.8872 14.9128 13.5316 14.5846 13.2854 14.1812C13.0325 13.7641 12.9094 13.2444 12.9094 12.6222C12.9025 12.1162 13.0325 11.6171 13.2854 11.1794C13.5453 10.735 13.9213 10.3658 14.3726 10.1196C14.8513 9.85295 15.4256 9.72304 16.1025 9.72304C16.1367 9.72304 16.1846 9.72304 16.2461 9.72988C16.3077 9.73671 16.376 9.73671 16.4581 9.74355V7.58287C16.4581 7.53501 16.4786 7.50765 16.5265 7.50765H17.9145C17.9487 7.50082 17.976 7.52817 17.9829 7.55552C17.9829 7.56236 17.9829 7.56919 17.9829 7.56919V14.0786C17.9829 14.2017 17.9897 14.3384 17.9966 14.4889C18.0102 14.6324 18.0171 14.7692 18.0239 14.8854C18.0239 14.9333 18.0034 14.9743 17.9555 14.9948C17.6 15.1453 17.2239 15.2547 16.841 15.323C16.4923 15.3846 16.1436 15.4188 15.788 15.4188ZM16.4581 14.0512V11.0427C16.3966 11.029 16.335 11.0153 16.2735 11.0085C16.1983 11.0017 16.1231 10.9948 16.0478 10.9948C15.7812 10.9948 15.5145 11.0495 15.2752 11.1726C15.0427 11.2889 14.8444 11.4598 14.694 11.6786C14.5436 11.8974 14.4683 12.1914 14.4683 12.547C14.4615 12.7863 14.5025 13.0256 14.5846 13.2512C14.653 13.4359 14.7555 13.6 14.8923 13.7367C15.0222 13.8598 15.1795 13.9555 15.3572 14.0102C15.5419 14.0718 15.7333 14.0991 15.9248 14.0991C16.0273 14.0991 16.1231 14.0923 16.2119 14.0854C16.3008 14.0923 16.376 14.0786 16.4581 14.0512Z",
                fill: "#FF61F6"
            })
        ]
    });
};
var $cfe74c44e346a556$export$2e2bcd8739ae039 = $cfe74c44e346a556$var$AdobeXDIcon;

});

parcelRegister("ZlCvd", function(module, exports) {

$parcel$export(module.exports, "default", () => $5694a8281bd37d8b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $5694a8281bd37d8b$var$AdobeSignIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-19.5",
                y: "-166.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#584CCC"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M25.7066 18.7523C25.0666 18.0399 23.8399 17.7112 22.0799 17.7112C21.1199 17.7112 20.1066 17.8208 19.1466 17.9852C18.5066 17.3824 17.9732 16.6701 17.4399 15.9578C17.0666 15.4099 16.6932 14.8619 16.3732 14.2592C16.9066 12.725 17.2266 11.0812 17.3332 9.43743C17.3332 7.95802 16.7466 6.36902 15.1466 6.36902C14.6132 6.36902 14.0799 6.69778 13.8132 7.19091C13.1199 8.39636 13.3866 10.8621 14.5066 13.4373C14.1332 14.588 13.7066 15.7386 13.2266 16.9989C12.7999 18.0947 12.3199 19.1358 11.7332 20.1221C10.0799 20.7796 6.61323 22.4234 6.29323 24.2316C6.18656 24.7795 6.34656 25.3274 6.77323 25.6562C7.14656 25.9849 7.6799 26.2041 8.21323 26.1493C10.2932 26.1493 12.3732 23.1905 13.8132 20.6152C14.6132 20.3413 15.4132 20.0673 16.2666 19.8481C17.1732 19.6289 18.0266 19.4098 18.8266 19.2454C21.0666 21.2179 23.0399 21.5467 23.9999 21.5467C25.3332 21.5467 25.8666 20.944 26.0266 20.4508C26.2399 19.8481 26.1332 19.1906 25.7066 18.7523ZM24.2666 19.7933C24.2132 20.1769 23.7866 20.4508 23.2532 20.4508C23.0932 20.4508 22.9332 20.4508 22.7732 20.396C21.7066 20.1221 20.6932 19.5742 19.8399 18.8618C20.5332 18.7523 21.2799 18.6975 21.9732 18.6975C22.4532 18.6975 22.9332 18.7523 23.4132 18.807C23.8932 18.9166 24.4266 19.1358 24.2666 19.7933ZM14.7199 7.68405C14.8266 7.51967 14.9866 7.41009 15.1999 7.35529C15.7332 7.35529 15.8399 7.95802 15.8399 8.50595C15.7866 9.76619 15.5732 10.9716 15.1999 12.1771C14.2932 9.82098 14.3999 8.23198 14.7199 7.68405ZM17.7066 18.2043C17.1199 18.3139 16.5332 18.4783 15.9466 18.6427C15.5199 18.7523 15.0932 18.9166 14.6132 19.0262C14.8266 18.5331 15.0399 18.0399 15.2532 17.6016C15.5199 16.9989 15.7332 16.3962 15.9466 15.7934C16.1599 16.1222 16.3199 16.3962 16.5332 16.6701C16.9066 17.218 17.3332 17.7112 17.7066 18.2043ZM11.2532 21.3823C9.9199 23.574 8.58656 24.9987 7.8399 24.9987C7.73323 24.9987 7.57323 24.9439 7.5199 24.8891C7.3599 24.7795 7.30656 24.5603 7.3599 24.3959C7.46656 23.574 9.01323 22.4234 11.2532 21.3823Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.82667 4H17.1733C18.72 4 20 5.28 20 6.82667V16.7467C20 18.32 18.72 19.5733 17.1733 19.5733H6.82667C5.28 19.6 4 18.32 4 16.7733V6.82667C4 5.28 5.28 4 6.82667 4Z",
                fill: "#584CCC"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.8533 13.0401C16.5333 12.6934 15.92 12.5334 15.04 12.5334C14.56 12.5334 14.0533 12.5868 13.5733 12.6668C13.2533 12.3734 12.9867 12.0268 12.72 11.6801C12.5333 11.4134 12.3467 11.1468 12.1867 10.8534C12.4533 10.1068 12.6133 9.30676 12.6667 8.50676C12.6667 7.78676 12.3733 7.01343 11.5733 7.01343C11.3067 7.01343 11.04 7.17343 10.9067 7.41343C10.56 8.00009 10.6933 9.20009 11.2533 10.4534C11.0667 11.0134 10.8533 11.5734 10.6133 12.1868C10.4 12.7201 10.16 13.2268 9.86668 13.7068C9.04001 14.0268 7.30668 14.8268 7.14668 15.7068C7.09334 15.9734 7.17334 16.2401 7.38668 16.4001C7.57334 16.5601 7.84001 16.6668 8.10668 16.6401C9.14668 16.6401 10.1867 15.2001 10.9067 13.9468C11.3067 13.8134 11.7067 13.6801 12.1333 13.5734C12.5867 13.4668 13.0133 13.3601 13.4133 13.2801C14.5333 14.2401 15.52 14.4001 16 14.4001C16.6667 14.4001 16.9333 14.1068 17.0133 13.8668C17.12 13.5734 17.0667 13.2534 16.8533 13.0401ZM16.1333 13.5468C16.1067 13.7334 15.8933 13.8668 15.6267 13.8668C15.5467 13.8668 15.4667 13.8668 15.3867 13.8401C14.8533 13.7068 14.3467 13.4401 13.92 13.0934C14.2667 13.0401 14.64 13.0134 14.9867 13.0134C15.2267 13.0134 15.4667 13.0401 15.7067 13.0668C15.9467 13.1201 16.2133 13.2268 16.1333 13.5468ZM11.36 7.65343C11.4133 7.57343 11.4933 7.52009 11.6 7.49343C11.8667 7.49343 11.92 7.78676 11.92 8.05343C11.8933 8.66676 11.7867 9.25343 11.6 9.84009C11.1467 8.69343 11.2 7.92009 11.36 7.65343ZM12.8533 12.7734C12.56 12.8268 12.2667 12.9068 11.9733 12.9868C11.76 13.0401 11.5467 13.1201 11.3067 13.1734C11.4133 12.9334 11.52 12.6934 11.6267 12.4801C11.76 12.1868 11.8667 11.8934 11.9733 11.6001C12.08 11.7601 12.16 11.8934 12.2667 12.0268C12.4533 12.2934 12.6667 12.5334 12.8533 12.7734ZM9.62668 14.3201C8.96001 15.3868 8.29334 16.0801 7.92001 16.0801C7.86668 16.0801 7.78668 16.0534 7.76001 16.0268C7.68001 15.9734 7.65334 15.8668 7.68001 15.7868C7.73334 15.3868 8.50668 14.8268 9.62668 14.3201Z",
                fill: "white"
            })
        ]
    });
};
var $5694a8281bd37d8b$export$2e2bcd8739ae039 = $5694a8281bd37d8b$var$AdobeSignIcon;

});

parcelRegister("aT1C2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2925c70e149e0de5$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $2925c70e149e0de5$var$AhaIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-635.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.5114 14.3589C13.4961 13.9874 13.4858 13.6157 13.4829 13.2439C13.4806 12.9476 13.4822 12.6512 13.4798 12.3549C13.4779 12.1238 13.4776 11.8926 13.4483 11.6628C13.4314 11.5303 13.4041 11.4003 13.3459 11.2789C13.2429 11.0639 13.0729 10.9187 12.8595 10.8216C12.562 10.6863 12.2524 10.6769 11.9374 10.742C11.6833 10.7945 11.4482 10.8957 11.2248 11.0259C11.1582 11.0647 11.0935 11.1066 11.0248 11.1522C11.0248 11.139 11.0248 11.1317 11.0248 11.1242C11.024 10.9117 11.0232 10.6993 11.0223 10.4868C11.0205 10.0525 11.0181 9.61825 11.0083 9.18407C11.0075 9.14589 11.0068 9.1076 11.003 9.06965C10.9985 9.02436 10.9605 8.99346 10.9209 9.00118C10.7482 9.03488 10.5756 9.06898 10.403 9.10296C10.182 9.14651 9.96017 9.18597 9.73703 9.21771C9.63006 9.23294 9.52302 9.24761 9.41605 9.26266C9.40776 9.26384 9.39813 9.26496 9.39433 9.27313C9.38968 9.28299 9.39892 9.28864 9.4053 9.29306C9.41476 9.29956 9.4137 9.30885 9.41498 9.31786C9.43737 9.47365 9.45467 9.63006 9.46883 9.7868C9.49083 10.0299 9.5041 10.2737 9.51339 10.5176C9.52722 10.8799 9.53366 11.2423 9.53607 11.6048C9.54323 12.6756 9.53573 13.7464 9.52577 14.8172C9.52515 14.8822 9.54228 14.8991 9.60722 14.8982C9.9839 14.8933 10.3605 14.8882 10.7372 14.8834C10.8454 14.882 10.9536 14.8819 11.0617 14.88C11.1067 14.8793 11.1419 14.8617 11.1375 14.803C11.1263 14.6534 11.1212 14.5034 11.1135 14.3536C11.0966 14.0279 11.0824 13.7021 11.0754 13.376C11.0725 13.24 11.0686 13.104 11.0675 12.968C11.065 12.6502 11.064 12.3324 11.0619 12.0146C11.0618 12.0001 11.0668 11.9933 11.0802 11.9881C11.1314 11.9683 11.1821 11.9472 11.233 11.9266C11.3449 11.8813 11.4598 11.8553 11.582 11.8677C11.6869 11.8784 11.7678 11.9237 11.8182 12.0183C11.8354 12.0504 11.8491 12.0839 11.8596 12.1188C11.9079 12.2798 11.9208 12.4461 11.9309 12.6124C11.9449 12.8432 11.9481 13.0743 11.9491 13.3054C11.9514 13.8152 11.9454 14.3249 11.943 14.8346C11.9427 14.8967 11.9627 14.9166 12.025 14.9164C12.2432 14.9154 12.4613 14.9063 12.6794 14.9013C12.7968 14.8986 12.9143 14.8968 13.0318 14.9015C13.1743 14.9071 13.3167 14.9164 13.4594 14.9164C13.5133 14.9164 13.5378 14.89 13.5351 14.8365C13.527 14.6775 13.5179 14.5184 13.5113 14.3592L13.5114 14.3589Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9366 9.01969C19.8949 9.01381 19.8552 9.02663 19.8151 9.03307C19.5797 9.07063 19.3445 9.10948 19.1092 9.14766C18.8849 9.18405 18.6607 9.22071 18.4363 9.25626C18.3593 9.26846 18.3278 9.30709 18.335 9.3844C18.3477 9.52166 18.3605 9.65887 18.372 9.79624C18.3901 10.0134 18.4071 10.2308 18.4246 10.448C18.4441 10.6912 18.4592 10.9349 18.473 11.1785C18.4862 11.4092 18.4974 11.64 18.5087 11.8708C18.5253 12.2067 18.5413 12.5427 18.5572 12.8786C18.5601 12.9403 18.5901 12.9699 18.6524 12.9689C18.8259 12.966 18.9992 12.9627 19.1727 12.9596C19.1727 12.959 19.1727 12.9585 19.1727 12.9579C19.2109 12.9579 19.2491 12.9584 19.2874 12.9578C19.4272 12.9557 19.567 12.9535 19.7069 12.9509C19.7598 12.9499 19.7931 12.9184 19.7943 12.8695C19.7981 12.7158 19.8008 12.5621 19.8057 12.4084C19.8128 12.1849 19.8201 11.9614 19.8299 11.7379C19.8428 11.4466 19.8577 11.1554 19.8727 10.8642C19.8815 10.6958 19.8914 10.5274 19.9024 10.3592C19.9159 10.1537 19.9299 9.94834 19.9456 9.74312C19.9583 9.57691 19.9737 9.41088 19.9879 9.24479C19.9923 9.19379 19.9984 9.14279 20 9.09168C20.0016 9.04511 19.9823 9.02619 19.9366 9.01969H19.9366Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.8688 14.1793C19.8688 13.9604 19.8688 13.7414 19.8688 13.5225C19.8688 13.4553 19.8458 13.4339 19.7778 13.4396C19.7231 13.4441 19.6685 13.4514 19.6137 13.455C19.3336 13.4735 19.0533 13.4827 18.7725 13.4746C18.6672 13.4715 18.562 13.4672 18.4571 13.4573C18.4019 13.4521 18.3713 13.4753 18.3714 13.5236C18.3715 13.5886 18.3713 13.6537 18.3731 13.7185C18.3774 13.8731 18.3778 14.0277 18.3757 14.1823C18.3727 14.4096 18.372 14.6369 18.3711 14.8643C18.3709 14.9132 18.3988 14.9386 18.4468 14.9356C18.5296 14.9305 18.6123 14.9244 18.695 14.9194C18.9465 14.9041 19.198 14.9013 19.4498 14.9076C19.5653 14.9104 19.6808 14.9132 19.7964 14.9166C19.8276 14.9174 19.8511 14.9065 19.864 14.8775C19.8706 14.8627 19.8688 14.8464 19.8688 14.8306C19.8689 14.6135 19.8688 14.3964 19.8688 14.1793Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.07031 14.2687C8.61418 12.7687 8.15801 11.2688 7.70189 9.76881C7.63667 9.55441 7.57151 9.34 7.50612 9.1256C7.48597 9.05949 7.43526 9.0268 7.36791 9.03771C7.25763 9.05557 7.14763 9.07522 7.03735 9.09313C6.67802 9.15152 6.31852 9.20884 5.96031 9.274C5.86772 9.29085 5.80132 9.34224 5.77154 9.43248C5.18325 11.2134 4.59553 12.9943 4.00768 14.7753C3.98317 14.8496 4.01849 14.8982 4.09703 14.8982C4.53249 14.8982 4.96801 14.8982 5.40348 14.8983C5.42128 14.8983 5.43902 14.8983 5.45593 14.8922C5.47636 14.8849 5.49142 14.8721 5.49635 14.8498C5.51896 14.7472 5.54136 14.6445 5.56425 14.5419C5.6335 14.2314 5.70297 13.921 5.77233 13.6105C5.77546 13.5964 5.77815 13.5867 5.79847 13.587C6.27581 13.5939 6.7532 13.6 7.23054 13.6053C7.25254 13.6055 7.26054 13.6121 7.26508 13.633C7.3552 14.0446 7.446 14.456 7.53669 14.8675C7.54811 14.9193 7.56759 14.935 7.62116 14.9357C7.63141 14.9358 7.64165 14.9352 7.6519 14.9349C7.90072 14.9282 8.14961 14.9214 8.34341 14.9162C8.65494 14.9162 8.91138 14.9165 9.16782 14.9161C9.22923 14.916 9.25593 14.8791 9.2383 14.8211C9.18226 14.6369 9.12623 14.4528 9.07025 14.2686L9.07031 14.2687ZM7.00544 12.4829C6.70517 12.4823 6.4049 12.4822 6.10457 12.483C6.07881 12.4831 6.07909 12.4754 6.08486 12.4548C6.22089 11.9665 6.3497 11.4762 6.47397 10.9849C6.50952 10.8442 6.54289 10.703 6.57737 10.562C6.57866 10.5569 6.58056 10.5518 6.58465 10.5392C6.6816 10.937 6.76787 11.3295 6.85732 11.7211C6.91319 11.966 6.96978 12.2107 7.02739 12.4552C7.03299 12.479 7.02834 12.4829 7.0055 12.4828L7.00544 12.4829Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.6715 14.483C17.6508 14.1846 17.6368 13.8858 17.6337 13.5866C17.6292 13.1505 17.6392 12.7144 17.6459 12.2783C17.6489 12.0854 17.6451 11.8927 17.6116 11.7017C17.5626 11.4229 17.427 11.1973 17.2 11.0277C17.0326 10.9026 16.8409 10.8332 16.6391 10.7888C16.3129 10.7171 15.9826 10.7133 15.6513 10.735C15.4224 10.75 15.1954 10.7808 14.9697 10.822C14.7443 10.8632 14.5215 10.9154 14.3015 10.9796C14.2482 10.9951 14.2304 11.018 14.2279 11.0738C14.225 11.1361 14.2232 11.1986 14.2205 11.2609C14.2138 11.4201 14.2068 11.5793 14.2002 11.7385C14.1971 11.812 14.193 11.8856 14.1925 11.9591C14.192 12.0256 14.2482 12.0552 14.2961 12.0363C14.4737 11.9667 14.6519 11.899 14.8344 11.8434C15.1069 11.7603 15.3843 11.7096 15.6705 11.7156C15.765 11.7175 15.8584 11.726 15.9472 11.7617C16.0354 11.797 16.0909 11.8595 16.1043 11.9553C16.11 11.996 16.1065 12.0371 16.106 12.0781C16.1057 12.1005 16.0979 12.1097 16.0745 12.1129C15.9739 12.127 15.8735 12.1417 15.7735 12.1592C15.4704 12.2122 15.1722 12.2838 14.8841 12.3937C14.6487 12.4835 14.426 12.5963 14.2307 12.7575C14.0093 12.9403 13.8519 13.1654 13.7916 13.4492C13.733 13.7249 13.7543 13.9976 13.8446 14.2642C13.9131 14.4664 14.0269 14.6385 14.1966 14.7708C14.3761 14.9107 14.5826 14.976 14.8076 14.9892C14.8076 14.9907 14.8078 14.9922 14.808 14.9937H14.9647C14.9647 14.9921 14.9647 14.9906 14.9649 14.989C15.0468 14.9825 15.1278 14.9702 15.2076 14.9506C15.5361 14.87 15.8352 14.7248 16.1143 14.5361C16.1279 14.527 16.1412 14.5175 16.1583 14.5057V14.5414C16.1583 14.6448 16.1582 14.7483 16.1584 14.8517C16.1585 14.9143 16.1809 14.9365 16.2426 14.9356C16.3964 14.9334 16.5502 14.9309 16.7041 14.9288C17.0099 14.9245 17.3157 14.9204 17.6215 14.9161C17.6734 14.9154 17.696 14.8915 17.6952 14.8397C17.6951 14.8341 17.6948 14.8285 17.6945 14.823C17.6868 14.7095 17.6793 14.5962 17.6714 14.4828L17.6715 14.483ZM16.1219 13.3558C16.1219 13.4806 16.1214 13.6055 16.1224 13.7302C16.1226 13.7497 16.1161 13.76 16.0995 13.7695C15.9485 13.857 15.7891 13.9147 15.6115 13.9032C15.4004 13.8894 15.2482 13.7607 15.226 13.5542C15.2022 13.3329 15.2951 13.1667 15.5135 13.0711C15.6245 13.0225 15.7419 12.9981 15.861 12.9813C15.9384 12.9704 16.0164 12.9631 16.0939 12.9531C16.1155 12.9503 16.1227 12.9553 16.1224 12.9785C16.1213 13.1043 16.1219 13.2301 16.1219 13.3558Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.5116 14.3589C13.4963 13.9874 13.4861 13.6157 13.4831 13.2439C13.4808 12.9476 13.4825 12.6512 13.48 12.3549C13.4781 12.1238 13.4778 11.8926 13.4486 11.6628C13.4316 11.5303 13.4044 11.4003 13.3462 11.2789C13.2432 11.0639 13.0732 10.9187 12.8598 10.8216C12.5623 10.6863 12.2527 10.6769 11.9377 10.742C11.6836 10.7945 11.4485 10.8957 11.225 11.0259C11.1584 11.0647 11.0938 11.1066 11.0251 11.1522C11.0251 11.139 11.0251 11.1317 11.0251 11.1242C11.0242 10.9117 11.0234 10.6993 11.0225 10.4868C11.0208 10.0525 11.0184 9.61825 11.0086 9.18407C11.0077 9.14589 11.007 9.1076 11.0033 9.06965C10.9988 9.02436 10.9607 8.99346 10.9211 9.00118C10.7485 9.03488 10.5759 9.06898 10.4033 9.10296C10.1822 9.14651 9.96041 9.18597 9.73728 9.21771C9.6303 9.23294 9.52327 9.24761 9.41629 9.26266C9.40801 9.26384 9.39838 9.26496 9.39457 9.27313C9.38992 9.28299 9.39916 9.28864 9.40554 9.29306C9.415 9.29956 9.41394 9.30885 9.41523 9.31786C9.43762 9.47365 9.45492 9.63006 9.46908 9.7868C9.49108 10.0299 9.50435 10.2737 9.51364 10.5176C9.52747 10.8799 9.5339 11.2423 9.53631 11.6048C9.54348 12.6756 9.53597 13.7464 9.52601 14.8172C9.52539 14.8822 9.54252 14.8991 9.60746 14.8982C9.98415 14.8933 10.3608 14.8882 10.7375 14.8834C10.8456 14.882 10.9538 14.8819 11.0619 14.88C11.107 14.8793 11.1421 14.8617 11.1377 14.803C11.1265 14.6534 11.1215 14.5034 11.1137 14.3536C11.0969 14.0279 11.0826 13.7021 11.0756 13.376C11.0727 13.24 11.0688 13.104 11.0677 12.968C11.0652 12.6502 11.0642 12.3324 11.0621 12.0146C11.062 12.0001 11.0671 11.9933 11.0804 11.9881C11.1316 11.9683 11.1823 11.9472 11.2332 11.9266C11.3452 11.8813 11.46 11.8553 11.5822 11.8677C11.6871 11.8784 11.768 11.9237 11.8185 12.0183C11.8356 12.0504 11.8494 12.0839 11.8599 12.1188C11.9082 12.2798 11.921 12.4461 11.9311 12.6124C11.9451 12.8432 11.9483 13.0743 11.9493 13.3054C11.9516 13.8152 11.9457 14.3249 11.9432 14.8346C11.9429 14.8967 11.963 14.9166 12.0253 14.9164C12.2435 14.9154 12.4615 14.9063 12.6796 14.9013C12.7971 14.8986 12.9146 14.8968 13.032 14.9015C13.1745 14.9071 13.3169 14.9164 13.4597 14.9164C13.5135 14.9164 13.5381 14.89 13.5353 14.8365C13.5272 14.6775 13.5181 14.5184 13.5116 14.3592L13.5116 14.3589Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9364 9.01981C19.8947 9.01394 19.855 9.02676 19.8149 9.03319C19.5795 9.07075 19.3443 9.1096 19.109 9.14778C18.8847 9.18417 18.6605 9.22084 18.4361 9.25638C18.3591 9.26859 18.3276 9.30721 18.3348 9.38452C18.3475 9.52178 18.3603 9.65899 18.3718 9.79636C18.3899 10.0136 18.4069 10.2309 18.4244 10.4481C18.444 10.6914 18.459 10.935 18.4729 11.1787C18.486 11.4094 18.4972 11.6402 18.5086 11.8709C18.5251 12.2068 18.5411 12.5428 18.557 12.8788C18.5599 12.9404 18.5899 12.97 18.6523 12.969C18.8257 12.9661 18.9991 12.9628 19.1725 12.9597C19.1725 12.9592 19.1725 12.9586 19.1725 12.958C19.2107 12.958 19.249 12.9585 19.2872 12.9579C19.427 12.9558 19.5669 12.9537 19.7067 12.951C19.7597 12.95 19.793 12.9186 19.7941 12.8696C19.7979 12.7159 19.8006 12.5622 19.8055 12.4085C19.8127 12.185 19.8199 11.9615 19.8297 11.7381C19.8426 11.4468 19.8575 11.1555 19.8726 10.8643C19.8813 10.6959 19.8913 10.5276 19.9022 10.3593C19.9157 10.1538 19.9297 9.94846 19.9454 9.74324C19.9581 9.57703 19.9736 9.411 19.9877 9.24491C19.9921 9.19391 19.9982 9.14291 19.9999 9.0918C20.0014 9.04523 19.9821 9.02631 19.9364 9.01981H19.9364Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.8689 14.1793C19.8689 13.9604 19.8689 13.7414 19.8689 13.5225C19.8689 13.4553 19.8459 13.4339 19.7779 13.4396C19.7231 13.4441 19.6685 13.4514 19.6137 13.455C19.3337 13.4735 19.0533 13.4827 18.7726 13.4746C18.6673 13.4715 18.5621 13.4672 18.4572 13.4573C18.4019 13.4521 18.3713 13.4753 18.3714 13.5236C18.3716 13.5886 18.3714 13.6537 18.3732 13.7185C18.3774 13.8731 18.3779 14.0277 18.3758 14.1823C18.3728 14.4096 18.3721 14.6369 18.3712 14.8643C18.3709 14.9132 18.3989 14.9386 18.4468 14.9356C18.5296 14.9305 18.6123 14.9244 18.6951 14.9194C18.9465 14.9041 19.1981 14.9013 19.4498 14.9076C19.5654 14.9104 19.6809 14.9132 19.7965 14.9166C19.8276 14.9174 19.8512 14.9065 19.8641 14.8775C19.8706 14.8627 19.8689 14.8464 19.8689 14.8306C19.8689 14.6135 19.8689 14.3964 19.8689 14.1793Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.07031 14.2689C8.61418 12.7689 8.15801 11.269 7.70189 9.76905C7.63667 9.55465 7.57151 9.34025 7.50612 9.12585C7.48597 9.05973 7.43526 9.02704 7.36791 9.03796C7.25763 9.05582 7.14763 9.07546 7.03735 9.09338C6.67802 9.15176 6.31852 9.20909 5.96031 9.27425C5.86772 9.2911 5.80132 9.34249 5.77154 9.43273C5.18325 11.2136 4.59553 12.9946 4.00768 14.7756C3.98317 14.8498 4.01849 14.8984 4.09703 14.8984C4.53249 14.8984 4.96801 14.8984 5.40348 14.8985C5.42128 14.8985 5.43902 14.8985 5.45593 14.8925C5.47636 14.8851 5.49142 14.8724 5.49635 14.85C5.51896 14.7474 5.54136 14.6448 5.56425 14.5421C5.6335 14.2317 5.70297 13.9212 5.77233 13.6108C5.77546 13.5966 5.77815 13.587 5.79847 13.5872C6.27581 13.5942 6.7532 13.6003 7.23054 13.6056C7.25254 13.6058 7.26054 13.6124 7.26508 13.6332C7.3552 14.0448 7.446 14.4563 7.53669 14.8678C7.54811 14.9195 7.56759 14.9352 7.62116 14.9359C7.63141 14.936 7.64165 14.9354 7.6519 14.9351C7.90072 14.9284 8.14961 14.9217 8.34341 14.9165C8.65494 14.9165 8.91138 14.9167 9.16782 14.9163C9.22923 14.9162 9.25593 14.8793 9.2383 14.8213C9.18226 14.6371 9.12623 14.453 9.07025 14.2689L9.07031 14.2689ZM7.00544 12.4832C6.70517 12.4825 6.4049 12.4824 6.10457 12.4833C6.07881 12.4833 6.07909 12.4757 6.08486 12.455C6.22089 11.9667 6.3497 11.4765 6.47397 10.9851C6.50952 10.8444 6.54289 10.7032 6.57737 10.5623C6.57866 10.5571 6.58056 10.5521 6.58465 10.5394C6.6816 10.9372 6.76787 11.3297 6.85732 11.7214C6.91319 11.9662 6.96978 12.2109 7.02739 12.4554C7.03299 12.4792 7.02834 12.4831 7.0055 12.4831L7.00544 12.4832Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.6717 14.483C17.6511 14.1846 17.637 13.8858 17.634 13.5866C17.6294 13.1505 17.6394 12.7144 17.6462 12.2783C17.6491 12.0854 17.6453 11.8927 17.6118 11.7017C17.5628 11.4229 17.4273 11.1973 17.2002 11.0277C17.0328 10.9026 16.8412 10.8332 16.6394 10.7888C16.3131 10.7171 15.9828 10.7133 15.6516 10.735C15.4227 10.75 15.1956 10.7808 14.97 10.822C14.7445 10.8632 14.5217 10.9154 14.3018 10.9796C14.2485 10.9951 14.2307 11.018 14.2281 11.0738C14.2253 11.1361 14.2234 11.1986 14.2208 11.2609C14.2141 11.4201 14.2071 11.5793 14.2004 11.7385C14.1973 11.812 14.1932 11.8856 14.1927 11.9591C14.1923 12.0256 14.2484 12.0552 14.2963 12.0363C14.4739 11.9667 14.6521 11.899 14.8346 11.8434C15.1071 11.7603 15.3845 11.7096 15.6707 11.7156C15.7653 11.7175 15.8586 11.726 15.9475 11.7617C16.0357 11.797 16.0911 11.8595 16.1045 11.9553C16.1103 11.996 16.1068 12.0371 16.1062 12.0781C16.1059 12.1005 16.0981 12.1097 16.0747 12.1129C15.9742 12.127 15.8737 12.1417 15.7738 12.1592C15.4707 12.2122 15.1724 12.2838 14.8843 12.3937C14.6489 12.4835 14.4263 12.5963 14.2309 12.7575C14.0095 12.9403 13.8522 13.1654 13.7918 13.4492C13.7332 13.7249 13.7546 13.9976 13.8449 14.2642C13.9133 14.4664 14.0271 14.6385 14.1969 14.7708C14.3763 14.9107 14.5829 14.976 14.8078 14.9892C14.8079 14.9907 14.8081 14.9922 14.8083 14.9937H14.965C14.965 14.9921 14.965 14.9906 14.9652 14.989C15.0471 14.9825 15.128 14.9702 15.2078 14.9506C15.5364 14.87 15.8355 14.7248 16.1146 14.5361C16.1281 14.527 16.1414 14.5175 16.1586 14.5057V14.5414C16.1586 14.6448 16.1584 14.7483 16.1586 14.8517C16.1587 14.9143 16.1811 14.9365 16.2428 14.9356C16.3966 14.9334 16.5505 14.9309 16.7043 14.9288C17.0101 14.9245 17.3159 14.9204 17.6218 14.9161C17.6737 14.9154 17.6963 14.8915 17.6954 14.8397C17.6953 14.8341 17.695 14.8285 17.6947 14.823C17.687 14.7095 17.6795 14.5962 17.6717 14.4828L17.6717 14.483ZM16.1221 13.3558C16.1221 13.4806 16.1217 13.6055 16.1226 13.7302C16.1228 13.7497 16.1163 13.76 16.0998 13.7695C15.9488 13.857 15.7893 13.9147 15.6117 13.9032C15.4006 13.8894 15.2485 13.7607 15.2262 13.5542C15.2024 13.3329 15.2953 13.1667 15.5138 13.0711C15.6247 13.0225 15.7421 12.9981 15.8613 12.9813C15.9387 12.9704 16.0166 12.9631 16.0942 12.9531C16.1157 12.9503 16.1229 12.9553 16.1227 12.9785C16.1215 13.1043 16.1221 13.2301 16.1221 13.3558Z",
                fill: "#0172CE"
            })
        ]
    });
};
var $2925c70e149e0de5$export$2e2bcd8739ae039 = $2925c70e149e0de5$var$AhaIcon;

});

parcelRegister("bKoXw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5642884c1dd34cff$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $5642884c1dd34cff$var$AirtableIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-635.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.1447 5.16889L5.17945 7.63723C4.84772 7.77451 4.85115 8.24569 5.18496 8.37801L11.1751 10.7535C11.7015 10.9622 12.2876 10.9622 12.8139 10.7535L18.8042 8.37801C19.1379 8.24569 19.1414 7.77451 18.8096 7.63723L12.8445 5.16889C12.3002 4.9437 11.6888 4.9437 11.1447 5.16889Z",
                fill: "#FFBF00"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.5259 12.0506V17.9848C12.5259 18.2671 12.8105 18.4603 13.0728 18.3563L19.7477 15.7655C19.9001 15.705 20.0001 15.5578 20.0001 15.3939V9.45974C20.0001 9.17748 19.7155 8.98421 19.4531 9.08821L12.7782 11.6791C12.6259 11.7395 12.5259 11.8867 12.5259 12.0506Z",
                fill: "#26B5F8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.9672 12.3568L8.98623 13.3133L8.78509 13.4105L4.6034 15.4141C4.33833 15.542 4 15.3488 4 15.0544V9.48465C4 9.37811 4.05462 9.28613 4.12788 9.21686C4.15845 9.1862 4.19309 9.16097 4.22908 9.14098C4.32901 9.08102 4.47155 9.06501 4.59273 9.11295L10.9339 11.6254C11.2562 11.7533 11.2815 12.2049 10.9672 12.3568Z",
                fill: "#ED3049"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.9672 12.3568L8.98628 13.3133L4.12793 9.21686C4.1585 9.1862 4.19314 9.16097 4.22913 9.14098C4.32906 9.08102 4.4716 9.06501 4.59278 9.11295L10.934 11.6254C11.2563 11.7533 11.2816 12.2049 10.9672 12.3568Z",
                fill: "black",
                fillOpacity: "0.25"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.2515 6.14778L6.03189 8.30757C5.74163 8.4277 5.74464 8.83998 6.03672 8.95576L11.2781 11.0343C11.7387 11.2169 12.2515 11.2169 12.712 11.0343L17.9535 8.95576C18.2455 8.83998 18.2486 8.4277 17.9583 8.30757L12.7388 6.14778C12.2625 5.95074 11.7276 5.95074 11.2515 6.14778Z",
                fill: "#FFBF00"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.4601 12.1693V17.3617C12.4601 17.6087 12.7091 17.7778 12.9387 17.6868L18.7792 15.4198C18.9126 15.3669 19 15.2381 19 15.0947V9.90228C19 9.65531 18.751 9.4862 18.5214 9.5772L12.6809 11.8442C12.5476 11.8971 12.4601 12.0259 12.4601 12.1693Z",
                fill: "#26B5F8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.0963 12.4372L9.36295 13.2741L9.18695 13.3592L5.52798 15.1124C5.29604 15.2243 5 15.0552 5 14.7976V9.92405C5 9.83083 5.0478 9.75035 5.11189 9.68974C5.13864 9.66291 5.16895 9.64083 5.20045 9.62334C5.28789 9.57088 5.4126 9.55687 5.51864 9.59881L11.0672 11.7972C11.3492 11.9091 11.3714 12.3043 11.0963 12.4372Z",
                fill: "#ED3049"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.0963 12.4372L9.36293 13.2741L5.11188 9.68974C5.13862 9.66291 5.16893 9.64083 5.20043 9.62334C5.28787 9.57088 5.41258 9.55687 5.51862 9.59881L11.0671 11.7972C11.3492 11.9091 11.3713 12.3043 11.0963 12.4372Z",
                fill: "black",
                fillOpacity: "0.25"
            })
        ]
    });
};
var $5642884c1dd34cff$export$2e2bcd8739ae039 = $5642884c1dd34cff$var$AirtableIcon;

});

parcelRegister("cRogp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e49fc528719c2d47$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $e49fc528719c2d47$var$AmplitudeIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-683.5",
                y: "-507.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#007FD2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.0516 7.60124C11.0073 7.54277 10.9568 7.51208 10.9007 7.51208C10.8545 7.51208 10.8122 7.53281 10.7851 7.55016C10.3591 7.88478 9.77609 9.30229 9.29834 11.1701L9.72131 11.1749C10.5565 11.1844 11.419 11.1942 12.2715 11.2073C12.0468 10.3518 11.8344 9.61843 11.6397 9.02646C11.3552 8.16124 11.1629 7.77393 11.0516 7.60124Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 12.0001C20 16.4183 16.4183 20.0001 12 20.0001C7.58169 20.0001 4 16.4183 4 12.0001C4 7.58181 7.58169 4.00012 12 4.00012C16.4183 4.00012 20 7.58181 20 12.0001ZM17.9088 11.8171C17.9088 11.6117 17.764 11.4404 17.569 11.4014C17.5679 11.4012 17.5667 11.4009 17.5655 11.4006C17.5632 11.4003 17.561 11.3995 17.5587 11.3992L17.5508 11.3984C17.5301 11.395 17.5091 11.3929 17.4876 11.3926L17.4315 11.3873C16.0916 11.2914 14.7131 11.2536 13.4199 11.2278L13.4173 11.2183C12.788 8.85747 12.0018 6.44382 10.9417 6.44382C9.9539 6.44831 9.06345 8.03418 8.29446 11.1584C7.75116 11.1514 7.2559 11.1439 6.78892 11.1359C6.76241 11.1354 6.73863 11.1352 6.71743 11.1352C6.61783 11.1352 6.56916 11.1394 6.54506 11.1426C6.28209 11.1892 6.09124 11.4186 6.09124 11.6883C6.09124 11.9633 6.29655 12.1992 6.56402 12.2377L6.56948 12.2433H8.04257C7.90586 12.8684 7.78602 13.4865 7.68594 14.0821L7.64209 14.3442L7.64161 14.3567C7.64257 14.559 7.80787 14.7235 8.00996 14.7235C8.13815 14.7235 8.2543 14.6567 8.32064 14.5526L8.33108 14.5609L9.05526 12.2433H12.5435C12.81 13.2502 13.0864 14.2899 13.4517 15.2657C13.6471 15.7874 14.1044 17.0094 14.8688 17.0155H14.8774C16.0604 17.0155 16.5214 15.1047 16.8268 13.8398C16.8924 13.5677 16.9491 13.3327 17.0026 13.16L17.0239 13.0886H17.0238C17.0289 13.0719 17.0316 13.0543 17.0316 13.0358C17.0316 12.9346 16.9496 12.8525 16.8484 12.8525C16.7698 12.8525 16.703 12.9018 16.6768 12.9712L16.6765 12.971L16.6508 13.0421C16.5504 13.32 16.4575 13.5828 16.3753 13.8157L16.369 13.8332C15.857 15.2833 15.6233 15.9452 15.1655 15.9453L15.1542 15.9452L15.1478 15.9461L15.1364 15.9458C14.5504 15.9458 13.9986 13.5635 13.7908 12.6668C13.7549 12.5114 13.7219 12.3688 13.6916 12.2433H17.481C17.5521 12.2433 17.6191 12.2255 17.6779 12.1947C17.6784 12.1945 17.6787 12.1943 17.679 12.1942C17.685 12.1911 17.6906 12.1876 17.6964 12.1842C17.7028 12.1805 17.7091 12.1768 17.7152 12.1728C17.7182 12.1709 17.7211 12.1688 17.724 12.1667C17.7332 12.1604 17.742 12.1539 17.7507 12.1468C17.7513 12.1463 17.7518 12.1458 17.7524 12.1453C17.8479 12.0671 17.9088 11.9486 17.9088 11.8171Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.9329 7.05123C10.883 6.98545 10.8263 6.95093 10.7632 6.95093C10.7112 6.95093 10.6636 6.97424 10.6331 6.99376C10.1538 7.37021 9.49798 8.9649 8.96051 11.0662L9.43635 11.0716C10.3759 11.0823 11.3462 11.0933 12.3053 11.1081C12.0525 10.1456 11.8136 9.32057 11.5945 8.6546C11.2745 7.68123 11.0582 7.24551 10.9329 7.05123Z",
                fill: "#007FD2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21 12C21 16.9704 16.9706 21 12 21C7.0294 21 3 16.9704 3 12C3 7.0294 7.0294 3 12 3C16.9706 3 21 7.0294 21 12ZM18.6473 11.7942C18.6473 11.563 18.4845 11.3704 18.2651 11.3264C18.2639 11.3263 18.2626 11.3259 18.2611 11.3255C18.2586 11.3252 18.2561 11.3243 18.2536 11.3239L18.2447 11.323C18.2214 11.3192 18.1977 11.3169 18.1735 11.3165L18.1104 11.3105C16.603 11.2027 15.0522 11.1602 13.5974 11.1311L13.5945 11.1204C12.8864 8.46452 12.002 5.74916 10.8094 5.74916C9.69813 5.75422 8.69639 7.53831 7.83126 11.053C7.22006 11.0452 6.66289 11.0367 6.13753 11.0277C6.10771 11.0272 6.08096 11.027 6.05711 11.027C5.94506 11.027 5.8903 11.0317 5.86319 11.0353C5.56735 11.0877 5.35265 11.3458 5.35265 11.6492C5.35265 11.9586 5.58361 12.2239 5.88452 12.2673L5.89066 12.2736H7.54789C7.3941 12.9768 7.25928 13.6722 7.14669 14.3422L7.09735 14.6371L7.09681 14.6512C7.09789 14.8787 7.28385 15.0638 7.5112 15.0638C7.65542 15.0638 7.78608 14.9886 7.86072 14.8715L7.87247 14.8809L8.68717 12.2736H12.6114C12.9112 13.4064 13.2222 14.576 13.6332 15.6737C13.853 16.2607 14.3675 17.6355 15.2273 17.6423H15.2371C16.568 17.6423 17.0866 15.4927 17.4302 14.0696C17.5039 13.7635 17.5677 13.4991 17.6279 13.3048L17.6519 13.2246H17.6517C17.6575 13.2058 17.6606 13.1859 17.6606 13.1651C17.6606 13.0513 17.5683 12.9589 17.4544 12.9589C17.366 12.9589 17.2908 13.0144 17.2614 13.0925L17.261 13.0923L17.2321 13.1722C17.1192 13.4848 17.0147 13.7805 16.9222 14.0425L16.9151 14.0622C16.3392 15.6936 16.0762 16.4382 15.5611 16.4384L15.5485 16.4382L15.5413 16.4393L15.5284 16.4389C14.8692 16.4389 14.2484 13.7588 14.0147 12.75C13.9742 12.5752 13.9372 12.4148 13.903 12.2736H18.1661C18.2461 12.2736 18.3215 12.2536 18.3877 12.2189C18.3882 12.2187 18.3886 12.2185 18.3889 12.2183C18.3956 12.2149 18.4019 12.2109 18.4084 12.2071C18.4157 12.203 18.4227 12.1988 18.4296 12.1943C18.433 12.1921 18.4363 12.1898 18.4395 12.1874C18.4498 12.1804 18.4598 12.173 18.4695 12.165C18.4702 12.1645 18.4708 12.1639 18.4715 12.1634C18.5789 12.0754 18.6473 11.942 18.6473 11.7942Z",
                fill: "#007FD2"
            })
        ]
    });
};
var $e49fc528719c2d47$export$2e2bcd8739ae039 = $e49fc528719c2d47$var$AmplitudeIcon;

});

parcelRegister("dpIpE", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd4523c3c0079a21$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $dd4523c3c0079a21$var$AsanaIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#F06A6A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.9553 12.3807C14.2737 12.3807 12.9105 13.7439 12.9105 15.4256C12.9105 17.1072 14.2737 18.4704 15.9553 18.4704C17.6369 18.4704 19 17.1072 19 15.4256C19 13.7439 17.6369 12.3807 15.9553 12.3807ZM8.04475 12.381C6.3632 12.381 5 13.7439 5 15.4256C5 17.1072 6.3632 18.4704 8.04475 18.4704C9.72637 18.4704 11.0896 17.1072 11.0896 15.4256C11.0896 13.7439 9.72637 12.381 8.04475 12.381ZM15.0447 8.57471C15.0447 10.2564 13.6816 11.6197 12 11.6197C10.3184 11.6197 8.95526 10.2564 8.95526 8.57471C8.95526 6.89336 10.3184 5.53003 12 5.53003C13.6816 5.53003 15.0447 6.89336 15.0447 8.57471Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.0853 12.8081C14.9233 12.8081 13.1707 14.5607 13.1707 16.7229C13.1707 18.8849 14.9233 20.6376 17.0853 20.6376C19.2474 20.6376 21 18.8849 21 16.7229C21 14.5607 19.2474 12.8081 17.0853 12.8081ZM6.91468 12.8084C4.75268 12.8084 3 14.5607 3 16.7229C3 18.8849 4.75268 20.6376 6.91468 20.6376C9.07677 20.6376 10.8295 18.8849 10.8295 16.7229C10.8295 14.5607 9.07677 12.8084 6.91468 12.8084ZM15.9146 7.91459C15.9146 10.0768 14.162 11.8296 12 11.8296C9.83793 11.8296 8.08533 10.0768 8.08533 7.91459C8.08533 5.75285 9.83793 4 12 4C14.162 4 15.9146 5.75285 15.9146 7.91459Z",
            fill: "#F06A6A"
        })
    });
};
var $dd4523c3c0079a21$export$2e2bcd8739ae039 = $dd4523c3c0079a21$var$AsanaIcon;

});

parcelRegister("2RIXb", function(module, exports) {

$parcel$export(module.exports, "default", () => $53660837dec24876$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $53660837dec24876$var$AzureDevopsIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.5 7.30929V16.4293L15.75 19.5L9.9375 17.3839V19.4818L6.64714 15.1821L16.2375 15.9321V7.71964L19.5 7.30929ZM16.3029 7.76786L10.9221 4.5V6.64393L5.98071 8.09571L4.5 9.99643V14.3132L6.61929 15.2486V9.71679L16.3029 7.76786Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19 7.622V16.134L15.5 19L10.075 17.025V18.983L7.004 14.97L15.955 15.67V8.005L19 7.622ZM16.016 8.05L10.994 5V7.001L6.382 8.356L5 10.13V14.159L6.978 15.032V9.869L16.016 8.05Z",
                fill: "url(#paint0_linear_24_1001)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                    id: "paint0_linear_24_1001",
                    x1: "12",
                    y1: "18.956",
                    x2: "12",
                    y2: "5.026",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            stopColor: "#0078D4"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "0.16",
                            stopColor: "#1380DA"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "0.53",
                            stopColor: "#3C91E5"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "0.82",
                            stopColor: "#559CEC"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "1",
                            stopColor: "#5EA0EF"
                        })
                    ]
                })
            })
        ]
    });
};
var $53660837dec24876$export$2e2bcd8739ae039 = $53660837dec24876$var$AzureDevopsIcon;

});

parcelRegister("8b6pH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b4c7485efb04e66$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $7b4c7485efb04e66$var$BoxIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-683.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#0071F7"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.8589 15.3516C20.0587 15.6312 20.0187 15.9907 19.779 16.1905C19.4994 16.3902 19.0999 16.3502 18.9002 16.1106L17.5021 14.313L16.1439 16.0706C15.9441 16.3502 15.5447 16.3502 15.265 16.1505C14.9854 15.9508 14.9455 15.5913 15.1452 15.3116L16.7431 13.2344L15.1452 11.1571C14.9455 10.8775 15.0254 10.478 15.265 10.2783C15.5447 10.0786 15.9441 10.1585 16.1439 10.3982L17.5021 12.1958L18.9002 10.478C19.0999 10.1984 19.4595 10.1585 19.779 10.3582C20.0587 10.5579 20.0587 10.9574 19.8589 11.237L18.301 13.2743L19.8589 15.3516ZM12.5886 15.1119C11.55 15.1119 10.7111 14.313 10.7111 13.2743C10.7111 12.2757 11.55 11.4368 12.5886 11.4368C13.6272 11.4368 14.4661 12.2757 14.4661 13.2743C14.4261 14.313 13.5873 15.1119 12.5886 15.1119ZM7.07591 15.1119C6.03729 15.1119 5.19841 14.313 5.19841 13.2743C5.19841 12.2757 6.03729 11.4368 7.07591 11.4368C8.11453 11.4368 8.95342 12.2757 8.95342 13.2743C8.95342 14.313 8.11453 15.1119 7.07591 15.1119ZM12.5886 10.2384C11.4301 10.2384 10.3915 10.8775 9.8722 11.8362C9.35289 10.8775 8.31427 10.2384 7.11586 10.2384C6.39682 10.2384 5.75766 10.478 5.23835 10.8376V8.28097C5.23835 7.96139 4.95873 7.68176 4.63915 7.68176C4.27963 7.68176 4 7.96139 4 8.28097V13.3143C4.03995 14.9921 5.39814 16.3103 7.07591 16.3103C8.27432 16.3103 9.31294 15.6312 9.83225 14.6725C10.3516 15.6312 11.3902 16.3103 12.5486 16.3103C14.2664 16.3103 15.6645 14.9521 15.6645 13.2344C15.7045 11.5966 14.3063 10.2384 12.5886 10.2384Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M20.8413 15.6285C21.066 15.9431 21.0211 16.3476 20.7514 16.5723C20.4368 16.797 19.9874 16.752 19.7627 16.4824L18.1898 14.4601L16.6619 16.4375C16.4371 16.752 15.9877 16.752 15.6732 16.5273C15.3586 16.3026 15.3136 15.8982 15.5383 15.5836L17.336 13.2467L15.5383 10.9098C15.3136 10.5952 15.4035 10.1458 15.6732 9.92112C15.9877 9.69642 16.4371 9.7863 16.6619 10.0559L18.1898 12.0783L19.7627 10.1458C19.9874 9.83124 20.3919 9.7863 20.7514 10.011C21.066 10.2357 21.066 10.6851 20.8413 10.9997L19.0886 13.2916L20.8413 15.6285ZM12.6622 15.3589C11.4937 15.3589 10.55 14.4601 10.55 13.2916C10.55 12.1681 11.4937 11.2244 12.6622 11.2244C13.8306 11.2244 14.7744 12.1681 14.7744 13.2916C14.7294 14.4601 13.7857 15.3589 12.6622 15.3589ZM6.4604 15.3589C5.29196 15.3589 4.34821 14.4601 4.34821 13.2916C4.34821 12.1681 5.29196 11.2244 6.4604 11.2244C7.62885 11.2244 8.5726 12.1681 8.5726 13.2916C8.5726 14.4601 7.62885 15.3589 6.4604 15.3589ZM12.6622 9.87618C11.3589 9.87618 10.1904 10.5952 9.60622 11.6738C9.022 10.5952 7.85355 9.87618 6.50534 9.87618C5.69642 9.87618 4.97737 10.1458 4.39315 10.5503V7.6741C4.39315 7.31458 4.07857 7 3.71904 7C3.31458 7 3 7.31458 3 7.6741V13.3366C3.04494 15.2241 4.57291 16.7071 6.4604 16.7071C7.80861 16.7071 8.97706 15.9431 9.56128 14.8646C10.1455 15.9431 11.314 16.7071 12.6172 16.7071C14.5497 16.7071 16.1226 15.1791 16.1226 13.2467C16.1675 11.4041 14.5946 9.87618 12.6622 9.87618Z",
            fill: "#0071F7"
        })
    });
};
var $7b4c7485efb04e66$export$2e2bcd8739ae039 = $7b4c7485efb04e66$var$BoxIcon;

});

parcelRegister("gNpxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8045fbc5fd77557$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $a8045fbc5fd77557$var$CanvaIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_1737_5849)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M17.0221 14.2091C16.9332 14.2091 16.855 14.2841 16.7737 14.4479C15.8548 16.3111 14.2679 17.6294 12.4314 17.6294C10.308 17.6294 8.993 15.7125 8.993 13.0644C8.993 8.57869 11.4923 5.98516 13.6875 5.98516C14.7133 5.98516 15.3398 6.62979 15.3398 7.65565C15.3398 8.87317 14.6481 9.51781 14.6481 9.94721C14.6481 10.14 14.768 10.2567 15.0057 10.2567C15.9609 10.2567 17.082 9.15909 17.082 7.60853C17.082 6.10509 15.7735 5 13.5783 5C9.95033 5 6.72607 8.36346 6.72607 13.0172C6.72607 16.6195 8.78313 19 11.9571 19C15.3258 19 17.2737 15.6483 17.2737 14.5604C17.2737 14.3194 17.1506 14.2091 17.0221 14.2091Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_1737_5849",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                        fill: "white"
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "#7D2AE7"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "url(#paint0_radial_24_1067)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "url(#paint1_radial_24_1067)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "url(#paint2_radial_24_1067)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "url(#paint3_radial_24_1067)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.4538 13.656C15.3878 13.656 15.3297 13.7118 15.2692 13.8338C14.5864 15.2204 13.4071 16.2016 12.0425 16.2016C10.4645 16.2016 9.48736 14.775 9.48736 12.804C9.48736 9.4655 11.3446 7.53522 12.9759 7.53522C13.7382 7.53522 14.2037 8.015 14.2037 8.77851C14.2037 9.68467 13.6897 10.1645 13.6897 10.484C13.6897 10.6275 13.7788 10.7144 13.9554 10.7144C14.6652 10.7144 15.4983 9.89747 15.4983 8.74344C15.4983 7.62448 14.526 6.802 12.8947 6.802C10.1988 6.802 7.8028 9.30531 7.8028 12.769C7.8028 15.45 9.3314 17.2217 11.69 17.2217C14.1933 17.2217 15.6408 14.7271 15.6408 13.9174C15.6408 13.7381 15.5493 13.656 15.4538 13.656Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint0_radial_24_1067",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.0906 18.2033) rotate(-49.4602) scale(12.3858 12.3828)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#6420FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6420FF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint1_radial_24_1067",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(8.23576 5.82176) rotate(54.7452) scale(13.9692 13.962)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00C4CC"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00C4CC",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint2_radial_24_1067",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.09053 18.2032) rotate(-45.2401) scale(12.2345 5.62672)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#6420FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6420FF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint3_radial_24_1067",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(10.5432 6.15916) rotate(66.5525) scale(12.6133 21.1075)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00C4CC",
                                stopOpacity: "0.725916"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.0001",
                                stopColor: "#00C4CC"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00C4CC",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $a8045fbc5fd77557$export$2e2bcd8739ae039 = $a8045fbc5fd77557$var$CanvaIcon;

});

parcelRegister("fKCBg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cc910e047331ab3$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $5cc910e047331ab3$var$DocusignIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-115.5",
                y: "-166.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "31",
                height: "31",
                rx: "7.5",
                stroke: "#0B1228",
                strokeOpacity: "0.14"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.2568 20.2378V25.1619C20.2568 25.4206 20.0472 25.6295 19.7877 25.6295H6.80236C6.54285 25.6295 6.33325 25.4206 6.33325 25.1619V12.2299C6.33325 11.9712 6.54285 11.7623 6.80236 11.7623H11.733V19.7703C11.733 20.0289 11.9426 20.2378 12.2021 20.2378H20.2568Z",
                fill: "#4C00FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M25.6668 13.2943C25.6668 17.4325 23.2414 20.2278 20.257 20.2378V15.0252C20.257 14.876 20.1971 14.7267 20.0873 14.6273L17.3725 11.9215C17.2627 11.8121 17.123 11.7524 16.9732 11.7524H11.7432V6.83818C11.7432 6.57953 11.9528 6.37063 12.2123 6.37063H19.5284C23.0018 6.36068 25.6668 9.14605 25.6668 13.2943Z",
                fill: "#FF5252"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.0873 14.6171C20.1971 14.7266 20.257 14.8658 20.257 15.0151V20.2277H12.2123C11.9528 20.2277 11.7432 20.0188 11.7432 19.7601V11.7522H16.9732C17.123 11.7522 17.2727 11.8119 17.3725 11.9213L20.0873 14.6171Z",
                fill: "black"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.0826 15.0417V18.6075C15.0826 18.7948 14.9308 18.946 14.7429 18.946H5.3397C5.15178 18.946 5 18.7948 5 18.6075V9.24286C5 9.05557 5.15178 8.9043 5.3397 8.9043H8.91017V14.7031C8.91017 14.8904 9.06195 15.0417 9.24987 15.0417H15.0826Z",
                fill: "#4C00FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19 10.0137C19 13.0104 17.2437 15.0346 15.0826 15.0418V11.2671C15.0826 11.159 15.0393 11.051 14.9598 10.979L12.9938 9.0196C12.9143 8.94036 12.8131 8.89714 12.7047 8.89714H8.91742V5.33859C8.91742 5.15129 9.0692 5.00002 9.25712 5.00002H14.555C17.0702 4.99282 19 7.00981 19 10.0137Z",
                fill: "#FF5252"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.9598 10.9717C15.0393 11.051 15.0826 11.1518 15.0826 11.2599V15.0345H9.25712C9.0692 15.0345 8.91742 14.8832 8.91742 14.6959V8.89709H12.7047C12.8131 8.89709 12.9215 8.94032 12.9938 9.01955L14.9598 10.9717Z",
                fill: "black"
            })
        ]
    });
};
var $5cc910e047331ab3$export$2e2bcd8739ae039 = $5cc910e047331ab3$var$DocusignIcon;

});

parcelRegister("9c5DY", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd8c52e47d888b99$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $dd8c52e47d888b99$var$DovetailIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-747.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77446 13.8484C5.74119 13.8676 5.74119 13.9156 5.77446 13.9349L8.90847 15.7448C8.93934 15.7626 8.95836 15.7956 8.95836 15.8312V19.4501C8.95836 19.4885 8.99997 19.5125 9.03327 19.4933L12.1673 17.6834C12.1981 17.6656 12.2172 17.6326 12.2172 17.597V13.9492C12.2172 13.9136 12.1981 13.8806 12.1672 13.8628L8.95836 12.0106L5.77446 13.8484Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77446 6.32257C5.74119 6.3418 5.74119 6.38983 5.77446 6.40903L8.90847 8.21896C8.93934 8.23681 8.95836 8.26975 8.95836 8.30542V12.0108L12.2172 10.1288V6.42346C12.2172 6.38779 12.1981 6.35482 12.1672 6.33697L9.00828 4.51363C8.97741 4.49578 8.93934 4.49578 8.90847 4.51363L5.77446 6.32257Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.2173 10.1281L15.4261 11.9813C15.457 11.9991 15.4761 12.0321 15.4761 12.0678V15.6866C15.4761 15.7251 15.5177 15.7491 15.5509 15.7299L18.6849 13.9199C18.7158 13.9021 18.7348 13.8691 18.7348 13.8335V10.1858C18.7348 10.1501 18.7158 10.1171 18.6849 10.0993L15.526 8.27594C15.4951 8.25812 15.457 8.25812 15.4261 8.27594L12.2173 10.1281Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.72 4H5.28C4.57308 4 4 4.57308 4 5.28V18.72C4 19.4269 4.57308 20 5.28 20H18.72C19.4269 20 20 19.4269 20 18.72V5.28C20 4.57308 19.4269 4 18.72 4Z",
                fill: "#0C0020"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.8497 13.2323C7.82752 13.2451 7.82752 13.2771 7.8497 13.2899L9.93904 14.4965C9.95962 14.5084 9.9723 14.5304 9.9723 14.5542V16.9667C9.9723 16.9924 10 17.0084 10.0222 16.9955L12.1116 15.7889C12.1321 15.777 12.1448 15.7551 12.1448 15.7313V13.2995C12.1448 13.2757 12.1321 13.2537 12.1115 13.2419L9.9723 12.0071L7.8497 13.2323Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.8497 8.21489C7.82752 8.22771 7.82752 8.25973 7.8497 8.27253L9.93904 9.47915C9.95962 9.49104 9.9723 9.513 9.9723 9.53678V12.007L12.1448 10.7524V8.28214C12.1448 8.25836 12.1321 8.23638 12.1115 8.22449L10.0056 7.00893C9.985 6.99702 9.95962 6.99702 9.93904 7.00893L7.8497 8.21489Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1448 10.7523L14.2841 11.9877C14.3047 11.9996 14.3174 12.0216 14.3174 12.0453V14.4579C14.3174 14.4835 14.3451 14.4995 14.3673 14.4867L16.4566 13.2801C16.4772 13.2682 16.4899 13.2463 16.4899 13.2225V10.7907C16.4899 10.7669 16.4772 10.7449 16.4566 10.733L14.3506 9.51745C14.33 9.50557 14.3047 9.50557 14.2841 9.51745L12.1448 10.7523Z",
                fill: "white"
            })
        ]
    });
};
var $dd8c52e47d888b99$export$2e2bcd8739ae039 = $dd8c52e47d888b99$var$DovetailIcon;

});

parcelRegister("9dDdC", function(module, exports) {

$parcel$export(module.exports, "default", () => $317758376a6d0f17$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $317758376a6d0f17$var$DropboxIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#0061FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.0098 8.48964L8.24219 10.8931L12.0098 13.2965L8.24219 15.7L4.47461 13.2836L8.24219 10.8801L4.47461 8.48964L8.24219 6.08618L12.0098 8.48964ZM8.2227 16.473L11.9903 14.0695L15.7579 16.473L11.9903 18.8765L8.2227 16.473ZM12.0098 13.2836L15.7773 10.8801L12.0098 8.48964L15.7579 6.08618L19.5254 8.48964L15.7579 10.8931L19.5254 13.2965L15.7579 15.7L12.0098 13.2836Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24px",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 43 40",
        version: "1.1",
        height: "24px",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z",
            fill: "#007EE5"
        })
    });
};
var $317758376a6d0f17$export$2e2bcd8739ae039 = $317758376a6d0f17$var$DropboxIcon;

});

parcelRegister("9HR5H", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8ffc72fdfda17ef$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $b8ffc72fdfda17ef$var$FigmaIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12 12C12 11.337 12.254 10.7011 12.7061 10.2322C13.1582 9.76339 13.7714 9.5 14.4107 9.5C15.0501 9.5 15.6633 9.76339 16.1153 10.2322C16.5674 10.7011 16.8214 11.337 16.8214 12C16.8214 12.663 16.5674 13.2989 16.1153 13.7678C15.6633 14.2366 15.0501 14.5 14.4107 14.5C13.7714 14.5 13.1582 14.2366 12.7061 13.7678C12.254 13.2989 12 12.663 12 12Z",
                        fill: "#1ABCFE"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.17871 17C7.17871 16.337 7.4327 15.7011 7.88479 15.2322C8.33689 14.7634 8.95006 14.5 9.58943 14.5H12.0001V17C12.0001 17.663 11.7462 18.2989 11.2941 18.7678C10.842 19.2366 10.2288 19.5 9.58943 19.5C8.95006 19.5 8.33689 19.2366 7.88479 18.7678C7.4327 18.2989 7.17871 17.663 7.17871 17V17Z",
                        fill: "#0ACF83"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12 4.5V9.5H14.4107C15.0501 9.5 15.6633 9.23661 16.1153 8.76777C16.5674 8.29893 16.8214 7.66304 16.8214 7C16.8214 6.33696 16.5674 5.70107 16.1153 5.23223C15.6633 4.76339 15.0501 4.5 14.4107 4.5H12Z",
                        fill: "#FF7262"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.17871 7C7.17871 7.66304 7.4327 8.29893 7.88479 8.76777C8.33689 9.23661 8.95006 9.5 9.58943 9.5H12.0001V4.5H9.58943C8.95006 4.5 8.33689 4.76339 7.88479 5.23223C7.4327 5.70107 7.17871 6.33696 7.17871 7V7Z",
                        fill: "#F24E1E"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.17871 12C7.17871 12.663 7.4327 13.2989 7.88479 13.7678C8.33689 14.2366 8.95006 14.5 9.58943 14.5H12.0001V9.5H9.58943C8.95006 9.5 8.33689 9.76339 7.88479 10.2322C7.4327 10.7011 7.17871 11.337 7.17871 12V12Z",
                        fill: "#A259FF"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_7_728)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M9.22776 20C10.6998 20 11.8944 18.8053 11.8944 17.3333V14.6666H9.22776C7.75576 14.6666 6.5611 15.8613 6.5611 17.3333C6.5611 18.8053 7.75576 20 9.22776 20Z",
                        fill: "#0ACF83"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M6.5611 12C6.5611 10.528 7.75576 9.33337 9.22776 9.33337H11.8944V14.6667H9.22776C7.75576 14.6667 6.5611 13.472 6.5611 12Z",
                        fill: "#A259FF"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M6.5611 6.66667C6.5611 5.19467 7.75576 4 9.22776 4H11.8944V9.33333H9.22776C7.75576 9.33333 6.5611 8.13867 6.5611 6.66667Z",
                        fill: "#F24E1E"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M11.8943 4H14.561C16.033 4 17.2277 5.19467 17.2277 6.66667C17.2277 8.13867 16.033 9.33333 14.561 9.33333H11.8943V4Z",
                        fill: "#FF7262"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M17.2277 12C17.2277 13.472 16.033 14.6667 14.561 14.6667C13.089 14.6667 11.8943 13.472 11.8943 12C11.8943 10.528 13.089 9.33337 14.561 9.33337C16.033 9.33337 17.2277 10.528 17.2277 12Z",
                        fill: "#1ABCFE"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_7_728",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });
};
var $b8ffc72fdfda17ef$export$2e2bcd8739ae039 = $b8ffc72fdfda17ef$var$FigmaIcon;

});

parcelRegister("hUGmM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a895e192628ab9a7$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $a895e192628ab9a7$var$FreshserviceIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-683.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#09C6FA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.6954 4.25008C15.7025 4.25008 16.7099 4.25338 17.7183 4.25008C18.2271 4.24619 18.6802 4.38244 19.0651 4.72054C19.4877 5.09067 19.7328 5.55604 19.7349 6.11783C19.7436 8.16046 19.767 10.2037 19.7289 12.2454C19.6945 14.0838 19.0364 15.7066 17.8236 17.091C16.5561 18.5389 14.9606 19.4014 13.0546 19.6709C11.5776 19.8805 10.1533 19.6736 8.79837 19.0498C6.90652 18.179 5.57016 16.7631 4.79229 14.8358C4.32449 13.676 4.16198 12.4628 4.29456 11.2138C4.46875 9.57492 5.09668 8.1346 6.17833 6.89283C7.22587 5.69708 8.52271 4.90171 10.0581 4.49714C10.7129 4.32786 11.3871 4.2451 12.0634 4.25098C12.9401 4.25158 13.8175 4.25128 14.6954 4.25008ZM13.1971 11.1482C12.6063 11.1482 12.0155 11.1464 11.4247 11.15C11.322 11.15 11.2897 11.1323 11.3274 11.0221C11.4729 10.5945 11.6099 10.1642 11.7503 9.73443C11.895 9.29243 12.0394 8.85042 12.1837 8.40841C12.2211 8.29372 12.1837 8.20089 12.084 8.14459C11.9844 8.08829 11.8838 8.10895 11.8087 8.20268C11.7668 8.25509 11.7291 8.31079 11.689 8.36529C11.0002 9.32517 10.3118 10.2847 9.62382 11.244C9.34987 11.6257 9.07501 12.0067 8.79926 12.3868C8.76505 12.4287 8.74371 12.4796 8.73781 12.5334C8.73192 12.5872 8.74172 12.6415 8.76604 12.6898C8.81722 12.8 8.9115 12.842 9.02673 12.8464C9.07581 12.8482 9.1252 12.8479 9.17428 12.8479H12.5042C12.7054 12.8479 12.709 12.8479 12.6449 13.0456C12.3744 13.8747 12.1026 14.7032 11.8296 15.5311C11.7802 15.6809 11.8036 15.7737 11.9113 15.8336C12.0191 15.8935 12.1128 15.8677 12.2106 15.7437C12.2247 15.7264 12.2376 15.7081 12.2507 15.6898C13.2284 14.3369 14.2055 12.9839 15.182 11.6309C15.2554 11.5294 15.2919 11.4237 15.2299 11.3063C15.168 11.1889 15.0626 11.1461 14.9288 11.1467C14.3518 11.1503 13.7745 11.1482 13.1971 11.1482Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M14.7823 4.00008C15.822 4.00008 16.8619 4.00348 17.9027 4.00008C18.428 3.99606 18.8957 4.13672 19.293 4.48571C19.7293 4.86779 19.9823 5.34817 19.9844 5.92808C19.9934 8.0366 20.0175 10.1457 19.9783 12.2533C19.9427 14.151 19.2634 15.8262 18.0115 17.2552C16.7031 18.7499 15.0561 19.6401 13.0887 19.9183C11.564 20.1347 10.0937 19.9211 8.69509 19.2772C6.74221 18.3783 5.36275 16.9168 4.55979 14.9272C4.0769 13.73 3.90914 12.4778 4.046 11.1884C4.22581 9.49669 4.87399 8.00991 5.99053 6.72809C7.07186 5.49376 8.41054 4.67273 9.99546 4.25511C10.6714 4.08037 11.3673 3.99494 12.0654 4.00101C12.9704 4.00163 13.8761 4.00132 14.7823 4.00008ZM13.2357 11.1207C12.6259 11.1207 12.016 11.1189 11.4061 11.1226C11.3002 11.1226 11.2668 11.1043 11.3057 10.9906C11.4559 10.5491 11.5974 10.1049 11.7423 9.66135C11.8916 9.20508 12.0407 8.74882 12.1896 8.29256C12.2282 8.17416 12.1896 8.07833 12.0867 8.02022C11.9839 7.9621 11.8801 7.98343 11.8025 8.08019C11.7593 8.13428 11.7203 8.19178 11.6789 8.24804C10.9679 9.23888 10.2573 10.2294 9.54717 11.2196C9.26438 11.6137 8.98066 12.0069 8.69601 12.3992C8.6607 12.4425 8.63867 12.4951 8.63258 12.5506C8.6265 12.6061 8.63662 12.6622 8.66172 12.7121C8.71455 12.8258 8.81187 12.8691 8.93082 12.8737C8.98148 12.8756 9.03246 12.8753 9.08313 12.8753H12.5205C12.7281 12.8753 12.7318 12.8753 12.6657 13.0793C12.3864 13.9352 12.1059 14.7904 11.8241 15.645C11.7732 15.7996 11.7973 15.8954 11.9085 15.9572C12.0197 16.0191 12.1164 15.9925 12.2174 15.8645C12.232 15.8466 12.2452 15.8277 12.2588 15.8089C13.2681 14.4122 14.2767 13.0156 15.2847 11.619C15.3604 11.5142 15.3981 11.4051 15.3341 11.2839C15.2702 11.1628 15.1614 11.1186 15.0233 11.1192C14.4277 11.1229 13.8317 11.1207 13.2357 11.1207Z",
            fill: "#09C6FA"
        })
    });
};
var $a895e192628ab9a7$export$2e2bcd8739ae039 = $a895e192628ab9a7$var$FreshserviceIcon;

});

parcelRegister("9eHWZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebee6edabad8a9c4$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $ebee6edabad8a9c4$var$GmailIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M5.52273 17.625H7.90909V11.8295L4.5 9.27271V16.6023C4.5 17.1682 4.95852 17.625 5.52273 17.625Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M16.0908 17.625H18.4772C19.0431 17.625 19.4999 17.1665 19.4999 16.6023V9.27271L16.0908 11.8295",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M16.0908 7.3977V11.8295L19.4999 9.2727V7.90906C19.4999 6.64429 18.0562 5.92327 17.0454 6.68179",
                        fill: "#FBBC04"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.90918 11.8295V7.39771L12.0001 10.4659L16.091 7.39771V11.8295L12.0001 14.8977",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M4.5 7.90931V9.27294L7.90909 11.8298V7.39794L6.95455 6.68203C5.94205 5.92351 4.5 6.64453 4.5 7.90931Z",
                        fill: "#C5221F"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "37 37 115 80",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#4285f4",
                d: "M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#34a853",
                d: "M120 108h14c3.32 0 6-2.69 6-6V59l-20 15"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#fbbc04",
                d: "M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#ea4335",
                d: "M72 74V48l24 18 24-18v26L96 92"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#c5221f",
                d: "M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2"
            })
        ]
    });
};
var $ebee6edabad8a9c4$export$2e2bcd8739ae039 = $ebee6edabad8a9c4$var$GmailIcon;

});

parcelRegister("6mOGj", function(module, exports) {

$parcel$export(module.exports, "default", () => $37eb7b587ecd273b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6fnsQ = parcelRequire("6fnsQ");
const $37eb7b587ecd273b$var$GithubIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0001 4C7.58233 4 4 7.67232 4 12.2025C4 15.8266 6.29226 18.9013 9.47093 19.9859C9.87075 20.0618 10.0175 19.808 10.0175 19.5913C10.0175 19.3957 10.0101 18.7496 10.0067 18.0642C7.78105 18.5604 7.31141 17.0964 7.31141 17.0964C6.9475 16.1483 6.42315 15.8962 6.42315 15.8962C5.6973 15.3871 6.47786 15.3975 6.47786 15.3975C7.28121 15.4554 7.70421 16.2428 7.70421 16.2428C8.41774 17.4968 9.57572 17.1343 10.0322 16.9247C10.104 16.3945 10.3114 16.0327 10.5402 15.8279C8.76324 15.6204 6.8953 14.9171 6.8953 11.7741C6.8953 10.8786 7.20782 10.1469 7.71958 9.57245C7.63651 9.36585 7.36268 8.53158 7.79708 7.40174C7.79708 7.40174 8.46887 7.18129 9.99766 8.24253C10.6358 8.06079 11.3202 7.96965 12.0001 7.96653C12.6799 7.96965 13.3649 8.06079 14.0042 8.24253C15.5311 7.18129 16.202 7.40174 16.202 7.40174C16.6375 8.53158 16.3635 9.36585 16.2804 9.57245C16.7934 10.1469 17.1038 10.8786 17.1038 11.7741C17.1038 14.9246 15.2323 15.6183 13.4508 15.8213C13.7378 16.0759 13.9935 16.5751 13.9935 17.3403C13.9935 18.4378 13.9842 19.3211 13.9842 19.5913C13.9842 19.8096 14.1282 20.0654 14.5337 19.9848C17.7107 18.899 20 15.8254 20 12.2025C20 7.67232 16.4182 4 12.0001 4Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_6309_146339)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M10.0001 0C4.47791 0 0 4.59039 0 10.2532C0 14.7833 2.86533 18.6266 6.83867 19.9824C7.33844 20.0773 7.52192 19.76 7.52192 19.4891C7.52192 19.2446 7.51265 18.437 7.50834 17.5802C4.72631 18.2005 4.13927 16.3705 4.13927 16.3705C3.68437 15.1854 3.02894 14.8702 3.02894 14.8702C2.12163 14.2339 3.09733 14.2469 3.09733 14.2469C4.10151 14.3193 4.63026 15.3035 4.63026 15.3035C5.52217 16.871 6.96965 16.4178 7.5403 16.1559C7.63006 15.4932 7.88921 15.0409 8.1752 14.7848C5.95404 14.5256 3.61912 13.6464 3.61912 9.71766C3.61912 8.59825 4.00977 7.6836 4.64947 6.96556C4.54564 6.70731 4.20335 5.66448 4.74635 4.25218C4.74635 4.25218 5.58609 3.97661 7.49708 5.30317C8.29476 5.07599 9.15024 4.96206 10.0001 4.95816C10.8499 4.96206 11.7061 5.07599 12.5052 5.30317C14.4139 3.97661 15.2525 4.25218 15.2525 4.25218C15.7968 5.66448 15.4544 6.70731 15.3505 6.96556C15.9917 7.6836 16.3797 8.59825 16.3797 9.71766C16.3797 13.6557 14.0403 14.5228 11.8135 14.7767C12.1722 15.0949 12.4918 15.7188 12.4918 16.6754C12.4918 18.0473 12.4802 19.1514 12.4802 19.4891C12.4802 19.762 12.6602 20.0817 13.1671 19.981C17.1383 18.6237 20 14.7818 20 10.2532C20 4.59039 15.5227 0 10.0001 0Z",
                        fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_6309_146339",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`
                    })
                })
            })
        ]
    });
};
var $37eb7b587ecd273b$export$2e2bcd8739ae039 = $37eb7b587ecd273b$var$GithubIcon;

});

parcelRegister("xNfJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa50a4b50f89009d$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $aa50a4b50f89009d$var$GitlabIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-587.5",
                y: "-363.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.7331 10.3948L19.7115 10.3373L17.5339 4.65705C17.4898 4.54552 17.4114 4.4509 17.31 4.3869C17.2343 4.33846 17.1483 4.30842 17.059 4.29919C16.9696 4.28996 16.8793 4.30179 16.7953 4.33375C16.7113 4.3657 16.636 4.41688 16.5754 4.4832C16.5147 4.54951 16.4705 4.6291 16.4461 4.7156L14.9763 9.21564H9.02381L7.55392 4.7156C7.5294 4.62923 7.48504 4.54979 7.42438 4.4836C7.36371 4.41742 7.28842 4.36632 7.20451 4.3344C7.1206 4.30247 7.03039 4.29059 6.94107 4.2997C6.85175 4.30882 6.7658 4.33868 6.69007 4.3869C6.58865 4.4509 6.51022 4.54552 6.46615 4.65705L4.28957 10.3383L4.26697 10.3948C3.95361 11.2138 3.91501 12.1125 4.15698 12.9553C4.39895 13.7981 4.90838 14.5394 5.60846 15.0674L5.61668 15.0736L5.63517 15.088L8.94779 17.5706L10.5913 18.8125L11.5897 19.5675C11.7068 19.656 11.8496 19.7038 11.9964 19.7038C12.1432 19.7038 12.2861 19.656 12.4032 19.5675L13.4016 18.8125L15.0451 17.5706L18.3813 15.0736L18.3906 15.0664C19.0906 14.5386 19.6001 13.7975 19.8423 12.9549C20.0844 12.1123 20.0461 11.2138 19.7331 10.3948Z",
                fill: "#E24329"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.7329 10.3948L19.7114 10.3373C18.6504 10.555 17.6507 11.0047 16.7839 11.6541L12.0024 15.2698L15.047 17.5706L18.3832 15.0736L18.3925 15.0664C19.0922 14.5383 19.6012 13.7971 19.843 12.9545C20.0848 12.1119 20.0462 11.2135 19.7329 10.3948Z",
                fill: "#FC6D26"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.94775 17.5708L10.5912 18.8126L11.5896 19.5676C11.7068 19.6561 11.8496 19.7039 11.9964 19.7039C12.1432 19.7039 12.286 19.6561 12.4032 19.5676L13.4016 18.8126L15.045 17.5708L12.0005 15.2699L8.94775 17.5708Z",
                fill: "#FCA326"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.21598 11.6541C6.34952 11.005 5.35016 10.5556 4.28957 10.3383L4.26697 10.3948C3.95361 11.2137 3.91501 12.1124 4.15698 12.9552C4.39895 13.798 4.90838 14.5393 5.60846 15.0674L5.61668 15.0735L5.63517 15.0879L8.94779 17.5706L11.9944 15.2697L7.21598 11.6541Z",
                fill: "#FC6D26"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.7331 11.0987L19.7115 11.0412L17.5339 5.36091C17.4898 5.24937 17.4114 5.15476 17.31 5.09076C17.2343 5.04232 17.1483 5.01228 17.059 5.00304C16.9696 4.99381 16.8793 5.00565 16.7953 5.0376C16.7113 5.06956 16.636 5.12074 16.5754 5.18705C16.5147 5.25337 16.4705 5.33296 16.4461 5.41946L14.9763 9.91949H9.02381L7.55392 5.41946C7.5294 5.33309 7.48504 5.25364 7.42438 5.18746C7.36371 5.12127 7.28842 5.07018 7.20451 5.03825C7.1206 5.00632 7.03039 4.99444 6.94107 5.00356C6.85175 5.01268 6.7658 5.04254 6.69007 5.09076C6.58865 5.15476 6.51023 5.24937 6.46615 5.36091L4.28957 11.0422L4.26697 11.0987C3.95361 11.9177 3.91501 12.8163 4.15698 13.6591C4.39895 14.502 4.90838 15.2433 5.60846 15.7713L5.61668 15.7775L5.63517 15.7918L8.9478 18.2745L10.5913 19.5164L11.5897 20.2713C11.7068 20.3598 11.8496 20.4077 11.9964 20.4077C12.1432 20.4077 12.2861 20.3598 12.4032 20.2713L13.4016 19.5164L15.0451 18.2745L18.3813 15.7775L18.3906 15.7703C19.0906 15.2424 19.6001 14.5014 19.8423 13.6588C20.0844 12.8161 20.0461 11.9176 19.7331 11.0987Z",
                fill: "#E24329"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.7331 11.0987L19.7115 11.0411C18.6505 11.2589 17.6508 11.7085 16.784 12.358L12.0026 15.9736L15.0471 18.2745L18.3833 15.7774L18.3926 15.7702C19.0923 15.2421 19.6014 14.501 19.8431 13.6583C20.0849 12.8157 20.0463 11.9174 19.7331 11.0987Z",
                fill: "#FC6D26"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.94781 18.2745L10.5913 19.5163L11.5897 20.2713C11.7068 20.3598 11.8496 20.4077 11.9965 20.4077C12.1433 20.4077 12.2861 20.3598 12.4032 20.2713L13.4016 19.5163L15.0451 18.2745L12.0006 15.9736L8.94781 18.2745Z",
                fill: "#FCA326"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.21598 12.358C6.34952 11.7089 5.35016 11.2596 4.28957 11.0422L4.26697 11.0987C3.95361 11.9177 3.91501 12.8164 4.15698 13.6592C4.39895 14.502 4.90838 15.2433 5.60846 15.7713L5.61668 15.7775L5.63517 15.7919L8.9478 18.2745L11.9944 15.9737L7.21598 12.358Z",
                fill: "#FC6D26"
            })
        ]
    });
};
var $aa50a4b50f89009d$export$2e2bcd8739ae039 = $aa50a4b50f89009d$var$GitlabIcon;

});

parcelRegister("3yTTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a2c5202162d89c8$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $1a2c5202162d89c8$var$GoogleCalendarIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-124.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.8208 8.17936L12.3822 7.7973L8.17949 8.17936L7.79736 12.0001L8.17942 15.8207L12.0001 16.2983L15.8208 15.8207L16.2029 11.9046L15.8208 8.17936Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M9.74654 14.1071C9.46096 13.9142 9.26322 13.6324 9.15527 13.2599L9.81819 12.9867C9.87837 13.216 9.98341 13.3936 10.1334 13.5197C10.2824 13.6458 10.4639 13.7079 10.6759 13.7079C10.8928 13.7079 11.079 13.642 11.2347 13.5101C11.3903 13.3783 11.4687 13.2102 11.4687 13.0068C11.4687 12.7986 11.3866 12.6285 11.2223 12.4967C11.058 12.365 10.8517 12.299 10.6052 12.299H10.2222V11.6428H10.566C10.7781 11.6428 10.9567 11.5856 11.1019 11.4709C11.2471 11.3563 11.3197 11.1997 11.3197 11C11.3197 10.8224 11.2547 10.681 11.1249 10.575C10.995 10.469 10.8306 10.4155 10.631 10.4155C10.4362 10.4155 10.2814 10.4671 10.1668 10.5712C10.0522 10.6753 9.96904 10.8033 9.91655 10.9542L9.26039 10.681C9.34728 10.4346 9.50684 10.2168 9.74081 10.0287C9.97484 9.8405 10.2738 9.74591 10.6367 9.74591C10.9051 9.74591 11.1468 9.79752 11.3608 9.90162C11.5747 10.0057 11.7428 10.15 11.8641 10.3333C11.9854 10.5176 12.0456 10.724 12.0456 10.9532C12.0456 11.1872 11.9893 11.3849 11.8766 11.5473C11.7638 11.7097 11.6253 11.8338 11.461 11.9208V11.9599C11.6779 12.0507 11.8546 12.1892 11.994 12.3754C12.1325 12.5617 12.2022 12.7843 12.2022 13.0441C12.2022 13.3039 12.1363 13.536 12.0045 13.7394C11.8726 13.9429 11.6902 14.1034 11.4591 14.2199C11.227 14.3364 10.9662 14.3956 10.6768 14.3956C10.3416 14.3966 10.0321 14.3001 9.74654 14.1071Z",
                        fill: "#1A73E8"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M13.8145 10.8175L13.0905 11.3438L12.7266 10.7917L14.0323 9.84991H14.5328V14.2924H13.8145V10.8175Z",
                        fill: "#1A73E8"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.8208 19.2592L19.2593 15.8206L17.54 15.0565L15.8208 15.8206L15.0566 17.5399L15.8208 19.2592Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.41504 17.54L8.17915 19.2593H15.8205V15.8207H8.17915L7.41504 17.54Z",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M5.88689 4.74078C5.25366 4.74078 4.74072 5.25372 4.74072 5.88695V15.8207L6.46001 16.5848L8.17929 15.8207V8.17935H15.8206L16.5847 6.46007L15.8207 4.74078H5.88689Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M4.74072 15.8207V18.1131C4.74072 18.7464 5.25366 19.2593 5.88689 19.2593H8.17929V15.8207H4.74072Z",
                        fill: "#188038"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.8203 8.17945V15.8208H19.2589V8.17945L17.5396 7.41534L15.8203 8.17945Z",
                        fill: "#FBBC04"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M19.2589 8.17929V5.88689C19.2589 5.25359 18.7459 4.74072 18.1127 4.74072H15.8203V8.17929H19.2589Z",
                        fill: "#1967D2"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        "aria-label": "Google Calendar",
        viewBox: "50 50 410 410 ",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#4285f4",
                d: "M100 340h74V174h166v-74H137q-37 0-37 35"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#1967d2",
                d: "M338 100v76h74v-41q0-35-35-35"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#fbbc04",
                d: "M338 174h74v164h-74"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#188038",
                d: "M100 338v39q0 35 35 35h41v-74"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#34a853",
                d: "M174 338h164v74H174"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#ea4335",
                d: "M338 412v-74h74"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "none",
                stroke: "#4285f4",
                strokeLinejoin: "bevel",
                strokeWidth: 15,
                d: "M204 229a25 22 1 1 1 25 27h-9 9a25 22 1 1 1-25 27m66-52 27-19h4v-7 103"
            })
        ]
    });
};
var $1a2c5202162d89c8$export$2e2bcd8739ae039 = $1a2c5202162d89c8$var$GoogleCalendarIcon;

});

parcelRegister("5wHPF", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8fe8259ed5344f$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $cf8fe8259ed5344f$var$HubSpotFilterIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-587.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#FF5C35"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.2949 7.36118V9.2655C18.0986 9.53156 19.5395 10.8388 19.9091 12.5445C20.2788 14.2502 19.4994 15.9955 17.9542 16.9226C16.409 17.8496 14.4229 17.7632 12.9725 16.7059L11.3506 18.2537C11.3927 18.3793 11.4149 18.5101 11.4169 18.6419C11.4169 19.1911 11.0701 19.6864 10.5383 19.8966C10.0065 20.1068 9.39443 19.9906 8.98742 19.6022C8.5804 19.2138 8.45864 18.6296 8.67892 18.1221C8.8992 17.6147 9.41812 17.2837 9.99372 17.2837C10.1318 17.2857 10.2689 17.307 10.4005 17.3469L12.0399 15.7824C11.0063 14.3791 10.9796 12.5146 11.9727 11.0849L6.58545 7.08265C6.32553 7.22716 6.03031 7.30382 5.72949 7.30488C4.77318 7.30379 3.99886 6.56308 4 5.65047C4.00115 4.73785 4.77732 3.99891 5.73363 4C6.68995 4.00109 7.46428 4.7418 7.46314 5.65442C7.4609 5.79367 7.44004 5.93209 7.40104 6.06629L12.8803 10.1347C13.4781 9.67598 14.1922 9.37614 14.9504 9.2655V7.36118C14.4121 7.12126 14.0671 6.60659 14.0644 6.03963V5.99518C14.0667 5.18711 14.7525 4.53257 15.5993 4.5304H15.6459C16.4927 4.53257 17.1785 5.18711 17.1808 5.99518V6.03963C17.1782 6.60659 16.8331 7.12126 16.2949 7.36118ZM13.3789 13.3881C13.3789 14.5707 14.3835 15.5295 15.6228 15.5295C16.8621 15.5295 17.8667 14.5707 17.8667 13.3881C17.8667 12.2055 16.8621 11.2467 15.6228 11.2467C14.3835 11.2467 13.3789 12.2055 13.3789 13.3881Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.2949 7.36118V9.2655C18.0986 9.53156 19.5395 10.8388 19.9091 12.5445C20.2788 14.2502 19.4994 15.9955 17.9542 16.9226C16.409 17.8496 14.4229 17.7632 12.9725 16.7059L11.3506 18.2537C11.3927 18.3793 11.4149 18.5101 11.4169 18.6419C11.4169 19.1911 11.0701 19.6864 10.5383 19.8966C10.0065 20.1068 9.39443 19.9906 8.98742 19.6022C8.5804 19.2138 8.45864 18.6296 8.67892 18.1221C8.8992 17.6147 9.41812 17.2837 9.99372 17.2837C10.1318 17.2857 10.2689 17.307 10.4005 17.3469L12.0399 15.7824C11.0063 14.3791 10.9796 12.5146 11.9727 11.0849L6.58545 7.08265C6.32553 7.22716 6.03031 7.30382 5.72949 7.30488C4.77318 7.30379 3.99886 6.56308 4 5.65047C4.00115 4.73785 4.77732 3.99891 5.73363 4C6.68995 4.00109 7.46428 4.7418 7.46314 5.65442C7.4609 5.79367 7.44004 5.93209 7.40104 6.06629L12.8803 10.1347C13.4781 9.67598 14.1922 9.37614 14.9504 9.2655V7.36118C14.4121 7.12126 14.0671 6.60659 14.0644 6.03963V5.99518C14.0667 5.18711 14.7525 4.53257 15.5993 4.5304H15.6459C16.4927 4.53257 17.1785 5.18711 17.1808 5.99518V6.03963C17.1782 6.60659 16.8331 7.12126 16.2949 7.36118ZM13.3789 13.3881C13.3789 14.5707 14.3835 15.5295 15.6228 15.5295C16.8621 15.5295 17.8667 14.5707 17.8667 13.3881C17.8667 12.2055 16.8621 11.2467 15.6228 11.2467C14.3835 11.2467 13.3789 12.2055 13.3789 13.3881Z",
            fill: "#FF5C35"
        })
    });
};
var $cf8fe8259ed5344f$export$2e2bcd8739ae039 = $cf8fe8259ed5344f$var$HubSpotFilterIcon;

});

parcelRegister("kVu7G", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5f11824900bc125$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6fnsQ = parcelRequire("6fnsQ");
const $a5f11824900bc125$var$LucidIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-587.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.01072 13.6063C6.01072 11.5924 6.01608 9.57906 6.00429 7.5652C6.00268 7.28018 6.08739 7.12189 6.34258 6.97751C8.00454 6.03689 9.65525 5.07648 11.3097 4.12249C11.6394 3.93212 11.656 3.94067 11.656 4.31286C11.656 8.28657 11.656 12.2603 11.656 16.2345C11.656 16.3148 11.6614 16.3955 11.6555 16.4752C11.641 16.6773 11.7123 16.711 11.8844 16.6099C12.4002 16.3078 12.9197 16.0116 13.4376 15.7132C14.5972 15.0447 15.7568 14.3758 16.917 13.7079C17.192 13.5496 17.2231 13.5672 17.2231 13.8913C17.2241 15.7533 17.2241 17.6158 17.2231 19.4778C17.2231 19.8232 17.2027 19.843 16.8601 19.8436C15.2164 19.8462 13.5727 19.8425 11.9295 19.8543C11.663 19.8564 11.5697 19.7805 11.5751 19.5067C11.5912 18.7227 11.5815 17.9388 11.5804 17.1543C11.5804 16.8746 11.5751 16.8693 11.329 17.011C9.66543 17.9671 8.00347 18.9265 6.33936 19.8821C6.25144 19.9323 6.16191 20.0478 6.05469 19.9783C5.96676 19.9216 6.01126 19.796 6.01126 19.7013C6.00965 17.6698 6.00965 15.6383 6.00965 13.6068L6.01072 13.6063Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M6.01072 13.6063C6.01072 11.5924 6.01608 9.57906 6.00429 7.5652C6.00268 7.28018 6.08739 7.12189 6.34258 6.97751C8.00454 6.03689 9.65525 5.07648 11.3097 4.12249C11.6394 3.93212 11.656 3.94067 11.656 4.31286C11.656 8.28657 11.656 12.2603 11.656 16.2345C11.656 16.3148 11.6614 16.3955 11.6555 16.4752C11.641 16.6773 11.7123 16.711 11.8844 16.6099C12.4002 16.3078 12.9197 16.0116 13.4376 15.7132C14.5972 15.0447 15.7568 14.3758 16.917 13.7079C17.192 13.5496 17.2231 13.5672 17.2231 13.8913C17.2241 15.7533 17.2241 17.6158 17.2231 19.4778C17.2231 19.8232 17.2027 19.843 16.8601 19.8436C15.2164 19.8462 13.5727 19.8425 11.9295 19.8543C11.663 19.8564 11.5697 19.7805 11.5751 19.5067C11.5912 18.7227 11.5815 17.9388 11.5804 17.1543C11.5804 16.8746 11.5751 16.8693 11.329 17.011C9.66543 17.9671 8.00347 18.9265 6.33936 19.8821C6.25144 19.9323 6.16191 20.0478 6.05469 19.9783C5.96676 19.9216 6.01126 19.796 6.01126 19.7013C6.00965 17.6698 6.00965 15.6383 6.00965 13.6068L6.01072 13.6063Z",
            fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`
        })
    });
};
var $a5f11824900bc125$export$2e2bcd8739ae039 = $a5f11824900bc125$var$LucidIcon;

});

parcelRegister("9DzSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $65126ba42d15d21a$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $65126ba42d15d21a$var$LoomIcon = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "2 2 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_271_181644)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M24.0115 12.9534H17.9154L23.1946 9.90666L22.1477 8.09334L16.8678 11.14L19.9151 5.86334L18.1014 4.81666L15.0534 10.092V4H12.9581V10.0927L9.91009 4.81666L8.09565 5.86334L11.1431 11.1387L5.86445 8.09334L4.81687 9.90666L10.0961 12.9534H4V15.0473H10.0955L4.81687 18.094L5.86378 19.9073L11.1437 16.8607L8.09565 22.1373L9.90943 23.184L12.9581 17.908V24H15.0534V17.7773L18.1574 23.1507L19.8585 22.1693L16.7537 16.7947L22.1463 19.9066L23.194 18.0934L17.9154 15.0466H24.0108V12.9534H24.0115ZM14.0057 16.8466C13.6317 16.8467 13.2613 16.7731 12.9158 16.6301C12.5703 16.487 12.2563 16.2773 11.9918 16.0129C11.7273 15.7486 11.5175 15.4347 11.3743 15.0893C11.2311 14.7438 11.1575 14.3736 11.1574 13.9997C11.1573 13.6257 11.2309 13.2554 11.374 12.91C11.5172 12.5646 11.7269 12.2506 11.9913 11.9862C12.2557 11.7218 12.5696 11.512 12.9152 11.3689C13.2607 11.2257 13.631 11.1521 14.0051 11.152C14.7604 11.1519 15.4848 11.4518 16.019 11.9857C16.5532 12.5197 16.8534 13.2439 16.8534 13.999C16.8535 14.7541 16.5536 15.4784 16.0195 16.0125C15.4854 16.5466 14.761 16.8466 14.0057 16.8466Z",
                    fill: "#5753F3"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_271_181644",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });
var $65126ba42d15d21a$export$2e2bcd8739ae039 = $65126ba42d15d21a$var$LoomIcon;

});

parcelRegister("4sX9w", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb3865c96b8d866c$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $cb3865c96b8d866c$var$MiroIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#FFDD33"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.0122 5.5H13.1097L14.6951 8.28547L11.2073 5.5H9.30491L11.0488 8.90456L7.40244 5.5H5.5L7.40244 9.83362L5.5 18.5H7.40244L11.0488 9.21453L9.30491 18.5H11.2073L14.6951 8.59544L13.1097 18.5H15.0122L18.5 7.6664L15.0122 5.5Z",
                fill: "black"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M4 8C4 5.79086 5.79086 4 8 4H16C18.2092 4 20 5.79086 20 8V16C20 18.2091 18.2092 20 16 20H8C5.79086 20 4 18.2091 4 16V8Z",
                fill: "#FFDD33"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.6372 7.05002H13.1848L14.3951 9.17662L11.7323 7.05002H10.2799L11.6113 9.64927L8.82744 7.05002H7.375L8.82744 10.3586L7.375 16.975H8.82744L11.6113 9.88592L10.2799 16.975H11.7323L14.3951 9.41327L13.1848 16.975H14.6372L17.3 8.70398L14.6372 7.05002Z",
                fill: "black"
            })
        ]
    });
};
var $cb3865c96b8d866c$export$2e2bcd8739ae039 = $cb3865c96b8d866c$var$MiroIcon;

});

parcelRegister("71zpm", function(module, exports) {

$parcel$export(module.exports, "default", () => $0516226a48c56413$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $0516226a48c56413$var$MondayIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.36594 16.7731C6.03435 16.7738 5.70851 16.6807 5.42172 16.5032C5.13492 16.3257 4.89744 16.0701 4.73354 15.7627C4.57214 15.4574 4.49165 15.111 4.50068 14.7606C4.50972 14.4103 4.60793 14.0691 4.78482 13.7738L8.14648 8.14287C8.31854 7.84024 8.56281 7.59175 8.85436 7.42277C9.14592 7.2538 9.47429 7.1704 9.80595 7.18109C10.1373 7.18956 10.4607 7.2918 10.7429 7.47734C11.0251 7.66289 11.256 7.92507 11.412 8.23707C11.7254 8.86914 11.6862 9.6296 11.3109 10.2229L7.95133 15.8538C7.78097 16.137 7.54634 16.3697 7.2692 16.5304C6.99206 16.6911 6.68137 16.7746 6.36594 16.7731Z",
                fill: "#F62B54"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.1321 16.7728C11.454 16.7728 10.8301 16.3861 10.5025 15.7647C10.3415 15.4602 10.2612 15.1148 10.2702 14.7653C10.2793 14.4159 10.3773 14.0756 10.5538 13.7811L13.9091 8.16313C14.0786 7.85625 14.322 7.60333 14.614 7.43061C14.9061 7.25789 15.2361 7.17165 15.5699 7.18084C16.2537 7.19679 16.8733 7.60475 17.1867 8.2429C17.4979 8.88105 17.4523 9.64607 17.0656 10.2379L13.7111 15.8559C13.5412 16.1378 13.3075 16.3696 13.0316 16.5299C12.7556 16.6901 12.4463 16.7737 12.1321 16.7728Z",
                fill: "#FFCC00"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.7693 16.82C18.7251 16.82 19.4999 16.0108 19.4999 15.0126C19.4999 14.0145 18.7251 13.2053 17.7693 13.2053C16.8134 13.2053 16.0386 14.0145 16.0386 15.0126C16.0386 16.0108 16.8134 16.82 17.7693 16.82Z",
                fill: "#00CA72"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M5.99034 16.9904C5.63664 16.9912 5.28909 16.8981 4.98317 16.7205C4.67725 16.543 4.42393 16.2875 4.24911 15.98C4.07695 15.6747 3.99109 15.3283 4.00073 14.978C4.01037 14.6276 4.11513 14.2865 4.3038 13.9911L7.88959 8.36021C8.07311 8.05759 8.33368 7.80909 8.64467 7.64012C8.95566 7.47115 9.30592 7.38774 9.65969 7.39843C10.0132 7.40691 10.3581 7.50914 10.6591 7.69469C10.9601 7.88023 11.2064 8.14242 11.3728 8.45442C11.7071 9.08649 11.6653 9.84695 11.2649 10.4403L7.68143 16.0712C7.49971 16.3543 7.24944 16.5871 6.95382 16.7478C6.6582 16.9084 6.3268 16.9919 5.99034 16.9904Z",
                fill: "#F62B54"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.1409 16.9902C11.4177 16.9902 10.7522 16.6035 10.4027 15.9821C10.2309 15.6776 10.1453 15.3322 10.1549 14.9827C10.1645 14.6333 10.2691 14.2931 10.4574 13.9985L14.0363 8.38054C14.2172 8.07366 14.4768 7.82074 14.7883 7.64802C15.0998 7.47529 15.4519 7.38906 15.808 7.39825C16.5373 7.4142 17.1982 7.82216 17.5325 8.46031C17.8645 9.09846 17.8159 9.86347 17.4033 10.4553L13.8251 16.0733C13.644 16.3552 13.3947 16.587 13.1004 16.7473C12.806 16.9075 12.476 16.9911 12.1409 16.9902Z",
                fill: "#FFCC00"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.154 17.0374C19.1736 17.0374 20.0001 16.2282 20.0001 15.2301C20.0001 14.2319 19.1736 13.4227 18.154 13.4227C17.1344 13.4227 16.3079 14.2319 16.3079 15.2301C16.3079 16.2282 17.1344 17.0374 18.154 17.0374Z",
                fill: "#00CA72"
            })
        ]
    });
};
var $0516226a48c56413$export$2e2bcd8739ae039 = $0516226a48c56413$var$MondayIcon;

});

parcelRegister("5FlG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $39ba9afef184103e$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $39ba9afef184103e$var$MuralIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.385264",
                y: "0.385264",
                width: "23.2295",
                height: "23.2295",
                rx: "5.61474",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.6754 16.1763C12.6757 14.0134 12.6843 11.8504 12.6739 9.68758C12.6654 7.94483 13.8929 6.44038 15.5576 6.08234C15.8132 6.02736 16.0709 5.99181 16.3335 6.00416C16.3754 6.06652 16.3699 6.13777 16.3701 6.20736C16.3708 6.83713 16.371 7.46704 16.3698 8.09681C16.3696 8.17062 16.3803 8.24819 16.3276 8.31236C15.8848 8.32742 15.5243 8.50576 15.2565 8.86034C15.089 9.08221 14.9992 9.3339 14.9928 9.61332C14.9914 9.67342 14.9908 9.73352 14.9908 9.79377C14.9908 11.8638 14.9908 13.9339 14.9905 16.0039C14.9905 16.0639 14.9863 16.1238 14.9842 16.1839C14.9391 16.2353 14.8769 16.2339 14.8176 16.2342C14.1625 16.2368 13.5073 16.2368 12.8522 16.2342C12.7888 16.2339 12.7197 16.2401 12.6755 16.1763H12.6754Z",
                fill: "#00843F"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9958 9.66997C19.997 9.7251 19.9991 9.78023 19.9991 9.83536C19.9992 12.6608 19.9994 15.4861 19.9988 18.3115C19.9988 18.5251 20.0262 18.4962 19.8174 18.4965C19.1651 18.4977 18.5127 18.497 17.8602 18.497C17.8251 18.497 17.7899 18.4955 17.7548 18.497C17.7016 18.4992 17.684 18.4709 17.6862 18.4226C17.6871 18.4025 17.6862 18.3825 17.6862 18.3623C17.6865 15.4716 17.6867 12.5811 17.687 9.69046C17.687 9.68548 17.6874 9.68036 17.6876 9.67539C17.7236 9.6043 17.7918 9.60324 17.8563 9.60294C18.5111 9.59948 19.1658 9.59963 19.8206 9.60249C19.8869 9.60279 19.9509 9.61213 19.9956 9.66982L19.9958 9.66997Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.31589 9.65845C6.31815 9.71343 6.32222 9.76841 6.32222 9.82339C6.32252 12.6568 6.32267 15.4902 6.32222 18.3237C6.32222 18.5291 6.34511 18.5007 6.1493 18.501C5.48729 18.502 4.82529 18.502 4.16344 18.5002C4.11208 18.5002 4.05183 18.5251 4.01025 18.4692C4.02758 18.4151 4.01538 18.3598 4.01538 18.3053C4.01628 15.4761 4.01613 12.6469 4.01613 9.81781C4.01613 9.61688 4.02682 9.60212 4.22535 9.60121C4.85738 9.5985 5.4894 9.59941 6.12143 9.60106C6.19072 9.60121 6.26407 9.59579 6.31604 9.65845H6.31589Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3296 18.485C11.282 18.508 11.2309 18.499 11.1813 18.4991C10.5242 18.5006 9.86683 18.5014 9.20965 18.5021C9.1845 18.5021 9.15949 18.5029 9.13434 18.502C9.06545 18.4995 9.02985 18.4615 9.02754 18.3881C9.02709 18.373 9.02754 18.358 9.02754 18.3429C9.02754 15.4932 9.02754 12.6434 9.02769 9.79368C9.02769 9.74864 9.03101 9.70361 9.03282 9.65842C9.08463 9.59651 9.15738 9.60103 9.22667 9.60073C9.86141 9.59907 10.4961 9.59907 11.1309 9.60073C11.2003 9.60088 11.2728 9.59711 11.3247 9.65857C11.3267 9.72364 11.3305 9.78871 11.3305 9.85378C11.3308 11.899 11.3306 13.9442 11.3311 15.9892C11.3311 16.0542 11.3234 16.1197 11.3409 16.1837C11.3704 16.2444 11.3702 16.3096 11.3702 16.3748C11.3704 17.0109 11.371 17.647 11.3696 18.283C11.3696 18.3521 11.3782 18.4246 11.3296 18.4847V18.485Z",
                fill: "#5887FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3247 9.65883C10.5607 9.65883 9.79675 9.65883 9.03263 9.65868C9.00822 9.44901 8.97343 9.24296 8.87477 9.05166C8.60861 8.53577 8.0406 8.24174 7.47124 8.32896C6.89584 8.41707 6.43884 8.87166 6.34515 9.45007C6.33401 9.5192 6.32557 9.58879 6.31593 9.65823C5.60302 9.65823 4.89011 9.65793 4.17719 9.65778C4.15716 9.65778 4.13682 9.65944 4.11694 9.65763C4.04795 9.65145 4.01226 9.67751 4.01753 9.75132C4.02039 9.79123 4.01783 9.8316 4.01783 9.87182C4.01783 12.6882 4.01783 15.5048 4.01753 18.3212C4.01753 18.3709 4.01286 18.4206 4.01015 18.4697C3.99267 18.4307 4.00307 18.3902 4.00307 18.351C4.00231 15.501 4.00201 12.6509 4.00277 9.80087C4.00277 9.28513 4.06874 8.77888 4.27389 8.30139C4.8172 7.03749 5.76675 6.26101 7.12404 6.04561C9.03022 5.74301 10.8088 6.97166 11.247 8.85389C11.3084 9.11794 11.3462 9.38605 11.3246 9.65883H11.3247Z",
                fill: "#FF4B4B"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9958 9.67086C19.816 9.6689 19.6361 9.66543 19.4563 9.66513C18.9213 9.66438 18.3864 9.66468 17.8514 9.66513C17.7967 9.66513 17.7413 9.65941 17.6878 9.67658C17.6785 9.52701 17.6637 9.37954 17.6171 9.23479C17.4522 8.72221 16.9529 8.33104 16.4019 8.3214C16.377 8.32094 16.3523 8.31612 16.3276 8.31326C16.3303 8.28344 16.3353 8.25361 16.3353 8.22379C16.335 7.48406 16.3343 6.74449 16.3337 6.00492C18.3515 5.97976 20.0257 7.66918 19.9958 9.67101V9.67086Z",
                fill: "#FC83FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3295 18.4854C11.3295 17.7731 11.3295 17.0608 11.3299 16.3486C11.3299 16.2938 11.3216 16.2382 11.3408 16.1844C11.7857 16.1819 12.2307 16.1793 12.6756 16.1768C12.7253 16.1795 12.7752 16.1844 12.8249 16.1844C13.5447 16.1849 14.2644 16.1846 14.9843 16.1844C14.9865 16.2343 14.9909 16.2843 14.9909 16.3342C14.9913 16.9954 14.9912 17.6568 14.9912 18.3181C14.9912 18.3532 14.99 18.3883 14.9909 18.4232C14.9921 18.4723 14.9705 18.4981 14.9201 18.4975C14.885 18.4972 14.8499 18.4982 14.8149 18.4982C13.7077 18.4982 12.6006 18.4982 11.4933 18.4981C11.4385 18.4981 11.3829 18.5051 11.3296 18.4853L11.3295 18.4854Z",
                fill: "#FFAA00"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.6756 16.1765C12.6759 14.0137 12.6845 11.8507 12.6741 9.68782C12.6657 7.94507 13.8931 6.44062 15.5579 6.08258C15.8135 6.0276 16.0712 5.99206 16.3337 6.00441C16.3756 6.06677 16.3702 6.13801 16.3703 6.2076C16.3711 6.83737 16.3712 7.46729 16.37 8.09706C16.3699 8.17086 16.3806 8.24844 16.3279 8.3126C15.885 8.32766 15.5246 8.50601 15.2568 8.86058C15.0893 9.08245 14.9995 9.33415 14.993 9.61356C14.9916 9.67366 14.991 9.73376 14.991 9.79401C14.991 11.8641 14.991 13.9341 14.9907 16.0042C14.9907 16.0641 14.9865 16.1241 14.9844 16.1842C14.9394 16.2355 14.8772 16.2342 14.8178 16.2345C14.1628 16.237 13.5075 16.237 12.8525 16.2345C12.789 16.2342 12.7199 16.2404 12.6758 16.1765H12.6756Z",
                fill: "#00843F"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9958 9.67021C19.997 9.72534 19.9991 9.78047 19.9991 9.8356C19.9992 12.661 19.9994 15.4863 19.9988 18.3118C19.9988 18.5254 20.0262 18.4965 19.8174 18.4968C19.1651 18.498 18.5127 18.4972 17.8602 18.4972C17.8251 18.4972 17.7899 18.4957 17.7548 18.4972C17.7016 18.4995 17.684 18.4712 17.6862 18.4228C17.6871 18.4028 17.6862 18.3827 17.6862 18.3625C17.6865 15.4719 17.6867 12.5814 17.687 9.6907C17.687 9.68573 17.6874 9.68061 17.6876 9.67564C17.7236 9.60454 17.7918 9.60349 17.8563 9.60319C18.5111 9.59972 19.1658 9.59987 19.8206 9.60273C19.8869 9.60303 19.9509 9.61237 19.9956 9.67006L19.9958 9.67021Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.31589 9.65857C6.31815 9.71355 6.32222 9.76853 6.32222 9.82351C6.32252 12.6569 6.32267 15.4904 6.32222 18.3238C6.32222 18.5292 6.34511 18.5008 6.1493 18.5011C5.48729 18.5021 4.82529 18.5021 4.16344 18.5003C4.11208 18.5003 4.05183 18.5252 4.01025 18.4693C4.02758 18.4152 4.01538 18.3599 4.01538 18.3054C4.01628 15.4762 4.01613 12.647 4.01613 9.81794C4.01613 9.617 4.02682 9.60224 4.22535 9.60133C4.85738 9.59862 5.4894 9.59953 6.12143 9.60118C6.19072 9.60133 6.26407 9.59591 6.31604 9.65857H6.31589Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3293 18.4851C11.2817 18.5081 11.2307 18.4991 11.1811 18.4992C10.5239 18.5008 9.86659 18.5015 9.20941 18.5023C9.18425 18.5023 9.15925 18.503 9.13409 18.5021C9.06521 18.4996 9.02961 18.4616 9.0273 18.3882C9.02685 18.3732 9.0273 18.3581 9.0273 18.343C9.0273 15.4933 9.0273 12.6435 9.02745 9.7938C9.02745 9.74877 9.03076 9.70373 9.03257 9.65854C9.08439 9.59663 9.15714 9.60115 9.22643 9.60085C9.86117 9.5992 10.4959 9.5992 11.1306 9.60085C11.2001 9.601 11.2725 9.59724 11.3245 9.65869C11.3265 9.72376 11.3302 9.78883 11.3302 9.8539C11.3305 11.8991 11.3304 13.9443 11.3308 15.9894C11.3308 16.0543 11.3231 16.1198 11.3406 16.1838C11.3701 16.2445 11.37 16.3097 11.37 16.375C11.3701 17.0111 11.3707 17.6472 11.3694 18.2831C11.3694 18.3522 11.378 18.4247 11.3293 18.4848V18.4851Z",
                fill: "#5887FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3247 9.65896C10.5607 9.65896 9.79675 9.65896 9.03263 9.65881C9.00822 9.44913 8.97343 9.24308 8.87477 9.05178C8.60861 8.53589 8.0406 8.24187 7.47124 8.32908C6.89584 8.41719 6.43884 8.87178 6.34515 9.45019C6.33401 9.51933 6.32557 9.58891 6.31593 9.65835C5.60302 9.65835 4.89011 9.65805 4.17719 9.6579C4.15716 9.6579 4.13682 9.65956 4.11694 9.65775C4.04795 9.65158 4.01226 9.67763 4.01753 9.75144C4.02039 9.79136 4.01783 9.83172 4.01783 9.87194C4.01783 12.6883 4.01783 15.5049 4.01753 18.3213C4.01753 18.371 4.01286 18.4207 4.01015 18.4698C3.99267 18.4308 4.00307 18.3903 4.00307 18.3511C4.00231 15.5011 4.00201 12.651 4.00277 9.801C4.00277 9.28525 4.06874 8.779 4.27389 8.30151C4.8172 7.03761 5.76675 6.26113 7.12404 6.04574C9.03022 5.74313 10.8088 6.97179 11.247 8.85401C11.3084 9.11806 11.3462 9.38617 11.3246 9.65896H11.3247Z",
                fill: "#FF4B4B"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9958 9.67086C19.816 9.6689 19.6361 9.66543 19.4563 9.66513C18.9213 9.66438 18.3864 9.66468 17.8514 9.66513C17.7967 9.66513 17.7413 9.65941 17.6878 9.67658C17.6785 9.52701 17.6637 9.37954 17.6171 9.23479C17.4522 8.72221 16.9529 8.33104 16.4019 8.3214C16.377 8.32094 16.3523 8.31612 16.3276 8.31326C16.3303 8.28344 16.3353 8.25361 16.3353 8.22379C16.335 7.48406 16.3343 6.74449 16.3337 6.00492C18.3515 5.97976 20.0257 7.66918 19.9958 9.67101V9.67086Z",
                fill: "#FC83FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3293 18.4856C11.3293 17.7733 11.3293 17.061 11.3298 16.3489C11.3298 16.294 11.3215 16.2385 11.3406 16.1847C11.7856 16.1821 12.2305 16.1796 12.6755 16.177C12.7252 16.1797 12.775 16.1847 12.8248 16.1847C13.5446 16.1851 14.2643 16.1848 14.9841 16.1847C14.9864 16.2345 14.9908 16.2845 14.9908 16.3344C14.9912 16.9957 14.9911 17.6571 14.9911 18.3183C14.9911 18.3534 14.9899 18.3885 14.9908 18.4234C14.992 18.4725 14.9704 18.4983 14.92 18.4977C14.8849 18.4974 14.8498 18.4985 14.8148 18.4985C13.7076 18.4985 12.6005 18.4985 11.4932 18.4983C11.4384 18.4983 11.3828 18.5054 11.3295 18.4855L11.3293 18.4856Z",
                fill: "#FFAA00"
            })
        ]
    });
};
var $39ba9afef184103e$export$2e2bcd8739ae039 = $39ba9afef184103e$var$MuralIcon;

});

parcelRegister("2omOh", function(module, exports) {

$parcel$export(module.exports, "default", () => $146e6df0b25543ec$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $146e6df0b25543ec$var$NotionIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-683.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M5.72382 5.14736L14.0236 4.53432C15.0431 4.44687 15.305 4.50582 15.9461 4.97186L18.5955 6.83828C19.0325 7.15927 19.178 7.24672 19.178 7.59621V17.8325C19.178 18.474 18.945 18.8535 18.1295 18.9114L8.49127 19.4952C7.87928 19.5241 7.58784 19.4367 7.26729 19.0282L5.31628 16.4912C4.96634 16.0243 4.82129 15.6748 4.82129 15.2662V6.16734C4.82129 5.6428 5.05423 5.20541 5.72382 5.14736Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.0236 4.53447L5.72382 5.14751C5.05423 5.20541 4.82129 5.64295 4.82129 6.16734V15.2662C4.82129 15.6746 4.96634 16.0241 5.31628 16.4912L7.26729 19.0281C7.58784 19.4365 7.87928 19.5241 8.49127 19.495L18.1296 18.9115C18.9446 18.8535 19.1781 18.474 19.1781 17.8326V7.59636C19.1781 7.26487 19.0472 7.16932 18.6617 6.88643L15.9461 4.97186C15.3052 4.50582 15.0431 4.44687 14.0236 4.53432V4.53447ZM8.70921 7.42882C7.92218 7.48177 7.74368 7.49377 7.29669 7.13032L6.16031 6.22644C6.04482 6.10944 6.10286 5.96349 6.39386 5.9344L14.3727 5.35136C15.0427 5.29286 15.3916 5.5264 15.6536 5.7304L17.0221 6.72188C17.0806 6.75143 17.2261 6.92588 17.051 6.92588L8.81121 7.42192L8.70921 7.42882ZM7.79168 17.7452V9.05539C7.79168 8.67589 7.90823 8.50085 8.25712 8.47145L17.721 7.91736C18.042 7.88841 18.1871 8.0924 18.1871 8.4713V17.1032C18.1871 17.4827 18.1286 17.8037 17.6046 17.8326L8.54827 18.3576C8.02433 18.3866 7.79183 18.2121 7.79183 17.7452H7.79168ZM16.7315 9.52128C16.7896 9.78377 16.7315 10.0463 16.469 10.0763L16.0325 10.1628V16.5786C15.6535 16.7826 15.3046 16.8992 15.013 16.8992C14.547 16.8992 14.4306 16.7532 14.0815 16.3161L11.2271 11.8252V16.1702L12.13 16.3746C12.13 16.3746 12.13 16.8996 11.4015 16.8996L9.39305 17.0162C9.33455 16.8992 9.39305 16.6077 9.5966 16.5497L10.1211 16.4042V10.6593L9.3932 10.6004C9.3347 10.3379 9.4802 9.95882 9.88819 9.92942L12.0432 9.78437L15.0131 14.3333V10.3089L14.2561 10.2219C14.1976 9.90047 14.4306 9.66692 14.7215 9.63842L16.7315 9.52128Z",
                fill: "#292A2E"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M5.8801 5.63103L13.9736 5.03323C14.9678 4.94796 15.2232 5.00544 15.8483 5.4599L18.4319 7.27992C18.858 7.59294 18.9999 7.67822 18.9999 8.01902V18.0009C18.9999 18.6265 18.7727 18.9965 17.9774 19.053L8.57877 19.6223C7.98199 19.6505 7.69779 19.5652 7.38521 19.1669L5.48269 16.6929C5.14144 16.2376 5 15.8968 5 15.4983V6.62566C5 6.11416 5.22716 5.68764 5.8801 5.63103Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.9736 5.03338L5.8801 5.63118C5.22716 5.68764 5 6.11431 5 6.62566V15.4983C5 15.8966 5.14144 16.2374 5.48269 16.6929L7.38521 19.1668C7.69779 19.5651 7.98199 19.6505 8.57877 19.6221L17.9776 19.0531C18.7723 18.9965 19 18.6265 19 18.001V8.01917C19 7.69591 18.8723 7.60274 18.4964 7.32688L15.8483 5.4599C15.2233 5.00544 14.9678 4.94796 13.9736 5.03323V5.03338ZM8.7913 7.85579C8.02382 7.90742 7.84976 7.91912 7.41388 7.56471L6.30574 6.68329C6.19312 6.5692 6.24972 6.42688 6.53349 6.39851L14.314 5.82996C14.9674 5.77291 15.3076 6.00066 15.5631 6.19958L16.8975 7.16642C16.9546 7.19524 17.0965 7.36535 16.9258 7.36535L8.89076 7.84906L8.7913 7.85579ZM7.89657 17.9157V9.44193C7.89657 9.07187 8.01022 8.90117 8.35044 8.8725L17.5791 8.33218C17.8922 8.30395 18.0336 8.50288 18.0336 8.87236V17.2897C18.0336 17.6598 17.9766 17.9728 17.4656 18.001L8.63435 18.513C8.12343 18.5412 7.89671 18.3711 7.89671 17.9157H7.89657ZM16.6142 9.89624C16.6708 10.1522 16.6142 10.4082 16.3582 10.4374L15.9326 10.5218V16.7782C15.563 16.9771 15.2227 17.0908 14.9384 17.0908C14.4839 17.0908 14.3704 16.9485 14.0301 16.5222L11.2466 12.1429V16.3799L12.1271 16.5793C12.1271 16.5793 12.1271 17.0912 11.4167 17.0912L9.45814 17.2049C9.40109 17.0908 9.45814 16.8066 9.65662 16.75L10.1681 16.6081V11.006L9.45828 10.9485C9.40124 10.6925 9.54312 10.3229 9.94097 10.2942L12.0424 10.1528L14.9385 14.5887V10.6643L14.2003 10.5795C14.1433 10.266 14.3704 10.0383 14.6542 10.0105L16.6142 9.89624Z",
                fill: "black"
            })
        ]
    });
};
var $146e6df0b25543ec$export$2e2bcd8739ae039 = $146e6df0b25543ec$var$NotionIcon;

});

parcelRegister("k6xhg", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d08bb2217642b2$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $00d08bb2217642b2$var$OutlookCalendarIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.1963 5.81042H9.67074C9.33358 5.81042 9.05615 6.08496 9.05615 6.4186V7.10989L13.2978 8.40948L17.8109 7.10989V6.4186C17.8109 6.08496 17.5335 5.81042 17.1963 5.81042Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.5332 12.4833C18.5973 12.2839 18.6485 12.0806 18.6864 11.8747C18.6864 11.7717 18.6308 11.6762 18.5406 11.6247L18.535 11.6217L18.5332 11.6209L13.7889 8.94645C13.7685 8.93335 13.7473 8.92131 13.7255 8.91047C13.5418 8.82037 13.3257 8.82037 13.142 8.91047C13.1202 8.92131 13.099 8.93328 13.0785 8.94645L8.33435 11.6209L8.33257 11.6217L8.32684 11.6247C8.23674 11.6762 8.18109 11.7717 8.18115 11.8747C8.21904 12.0806 8.27023 12.2839 8.33435 12.4833L13.3648 16.124L18.5332 12.4833Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.1842 7.10992H12.1201L11.2354 8.40952L12.1201 9.70898L15.1842 12.308H17.8106V9.70898L15.1842 7.10992Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 7.10999H12.1203V9.70898H9.05615V7.10999Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 7.10999H17.811V9.70898H15.1846V7.10999Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.1845 12.308L12.1203 9.70898H9.05615V12.308L12.1203 14.907L16.8619 15.6729L15.1845 12.308Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1201 9.70898H15.1843V12.308H12.1201V9.70898Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 12.3081H12.1203V14.9071H9.05615V12.3081Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 12.3081H17.811V14.9071H15.1846V12.3081Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.5172 15.8678L8.35449 12.1426L8.57073 11.7662C8.57073 11.7662 13.2742 14.4171 13.346 14.457C13.4054 14.4806 13.4723 14.4788 13.5303 14.4518C13.5972 14.4145 18.3156 11.7532 18.3156 11.7532L18.5327 12.1296L13.5172 15.8678Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.5407 12.1248L18.535 12.1282L18.5337 12.1291L13.7895 14.8035C13.5981 14.9257 13.3556 14.9406 13.1504 14.8429L14.8028 17.0352L18.4159 17.8136V17.8154C18.5863 17.6935 18.6874 17.4976 18.6873 17.2895V11.8749C18.6874 11.9778 18.6317 12.0734 18.5416 12.1248H18.5407Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.6864 17.2894V16.9698L14.3164 14.5059L13.7889 14.803C13.5976 14.9251 13.3551 14.9401 13.1499 14.8424L14.8023 17.0347L18.4154 17.8131V17.8149C18.5858 17.6929 18.6868 17.497 18.6868 17.289L18.6864 17.2894Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.6645 17.4555L13.8743 14.7551L13.7889 14.8032C13.5976 14.9253 13.3551 14.9403 13.1499 14.8426L14.8023 17.0349L18.4154 17.8133V17.815C18.538 17.7271 18.6262 17.5999 18.6649 17.4551L18.6645 17.4555Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.33388 12.1304V12.1261H8.32955L8.31637 12.1175C8.23142 12.0657 8.17985 11.9736 8.18067 11.8749V17.2904C8.18067 17.6463 8.4767 17.9393 8.83646 17.9393H18.0299C18.0845 17.9387 18.1389 17.9314 18.1918 17.9176C18.2192 17.9129 18.2458 17.9041 18.2706 17.8916C18.2799 17.8907 18.2888 17.8877 18.2968 17.8829C18.3326 17.8684 18.3665 17.8495 18.3975 17.8266L18.415 17.8136L8.33388 12.1304Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.5581 15.6292V8.55423C12.5571 8.2378 12.2943 7.97775 11.9745 7.97681H9.06976V11.2065L8.33387 11.6215L8.33215 11.6223L8.32648 11.6254C8.23632 11.6769 8.18066 11.7724 8.18066 11.8753V16.2083V16.2065H11.9745C12.2943 16.2057 12.5571 15.9456 12.5581 15.6292Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.1204 16.0622V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V16.6414V16.6397H11.5368C11.8566 16.6387 12.1194 16.3787 12.1204 16.0622ZM12.1204 15.1959V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.5368C11.8566 15.7724 12.1194 15.5123 12.1204 15.1959ZM11.6826 15.1959V8.98728C11.6816 8.6709 11.4189 8.41086 11.0991 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.0991C11.4189 15.7724 11.6816 15.5123 11.6826 15.1959Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M5.26223 8.40955H11.0985C11.4186 8.40955 11.6821 8.67016 11.6821 8.98691V14.7624C11.6821 15.0791 11.4186 15.3398 11.0985 15.3398H5.26223C4.94213 15.3398 4.67871 15.0791 4.67871 14.7624V8.98691C4.67871 8.67016 4.94213 8.40955 5.26223 8.40955Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.37132 10.7781C6.52637 10.4511 6.77674 10.1774 7.09008 9.99232C7.4373 9.7956 7.83266 9.69762 8.2326 9.70902C8.603 9.70096 8.96862 9.7939 9.28929 9.97757C9.59104 10.1554 9.83409 10.4163 9.98876 10.7283C10.1572 11.0721 10.2413 11.4504 10.2339 11.8324C10.2421 12.2317 10.1556 12.6274 9.98137 12.9877C9.82327 13.3108 9.5729 13.581 9.26127 13.7648C8.92812 13.9543 8.54887 14.0498 8.16472 14.0407C7.7863 14.0496 7.41259 13.9557 7.08441 13.7691C6.7803 13.591 6.53433 13.3299 6.37616 13.0171C6.20659 12.6783 6.12158 12.304 6.1284 11.926C6.12088 11.5301 6.20411 11.1377 6.37176 10.7781H6.37132ZM7.13733 12.6225C7.22004 12.8292 7.36032 13.0086 7.54185 13.1397C7.72658 13.2677 7.94804 13.3338 8.17345 13.3282C8.41363 13.3375 8.65044 13.2694 8.84802 13.1341C9.02733 13.003 9.16391 12.8227 9.2407 12.6156C9.32705 12.3847 9.36958 12.14 9.36633 11.8939C9.36901 11.6457 9.32902 11.3986 9.24815 11.1636C9.17684 10.952 9.04516 10.7653 8.86903 10.6261C8.67667 10.4839 8.4405 10.4117 8.20064 10.4216C7.97032 10.4157 7.7439 10.4821 7.55408 10.6113C7.36917 10.7428 7.22577 10.9237 7.14083 11.1329C6.95299 11.6117 6.95191 12.143 7.13777 12.6225H7.13733Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M25.4456 5.5H12.5525C11.9748 5.5 11.4995 5.97531 11.4995 6.55295V7.74978L18.7665 9.99978L26.4985 7.74978V6.55295C26.4985 5.97531 26.0232 5.5 25.4456 5.5Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.7358 17.053C27.8457 16.7078 27.9334 16.3558 27.9983 15.9993C27.9984 15.821 27.903 15.6557 27.7486 15.5666L27.7389 15.5613L27.7358 15.5599L19.6078 10.9297C19.5728 10.907 19.5364 10.8861 19.4991 10.8674C19.1844 10.7114 18.8141 10.7114 18.4994 10.8674C18.4621 10.8861 18.4258 10.9069 18.3906 10.9297L10.2627 15.5599L10.2597 15.5613L10.2498 15.5666C10.0955 15.6557 10.0001 15.821 10.0002 15.9993C10.0652 16.3558 10.1529 16.7078 10.2627 17.053L18.8811 23.3563L27.7358 17.053Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M21.9988 7.74982H16.7491L15.2334 9.99982L16.7491 12.2496L21.9988 16.7493H26.4985V12.2496L21.9988 7.74982Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4996 7.74982H16.7493V12.2495H11.4996V7.74982Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.9989 7.74982H26.4986V12.2495H21.9989V7.74982Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M21.999 16.7492L16.7493 12.2496H11.4996V16.7492L16.7493 21.249L24.8728 22.5749L21.999 16.7492Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.7493 12.2496H21.9989V16.7492H16.7493V12.2496Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4996 16.7493H16.7493V21.2489H11.4996V16.7493Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.9989 16.7493H26.4986V21.2489H21.9989V16.7493Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.1423 22.9124L10.2974 16.4628L10.6678 15.8111C10.6678 15.8111 18.7261 20.4008 18.849 20.4698C18.9509 20.5107 19.0654 20.5075 19.1648 20.4608C19.2795 20.3963 27.3632 15.7886 27.3632 15.7886L27.7352 16.4403L19.1423 22.9124Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.7488 16.4321L27.7391 16.4381L27.7368 16.4396L19.6089 21.0699C19.2809 21.2813 18.8655 21.3072 18.5139 21.1381L21.3449 24.9336L27.5351 26.2813V26.2843C27.8269 26.0732 28.0001 25.7341 28 25.3739V15.9995C28.0001 16.1777 27.9047 16.3431 27.7503 16.4321H27.7488Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.9985 25.3738V24.8204L20.5117 20.5546L19.608 21.0691C19.2802 21.2805 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2835C27.8262 26.0723 27.9993 25.7333 27.9993 25.3731L27.9985 25.3738Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.9611 25.661L19.7543 20.9858L19.608 21.0691C19.2802 21.2805 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2835C27.7443 26.1312 27.8954 25.911 27.9618 25.6603L27.9611 25.661Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.2621 16.4419V16.4344H10.2547L10.2321 16.4195C10.0866 16.3299 9.99823 16.1703 9.99965 15.9995V25.3754C9.99965 25.9916 10.5068 26.4988 11.1232 26.4988H26.8737C26.9673 26.4978 27.0606 26.4853 27.1511 26.4613C27.1982 26.4531 27.2437 26.4379 27.2862 26.4163C27.3021 26.4147 27.3174 26.4096 27.3311 26.4013C27.3925 26.3762 27.4505 26.3435 27.5036 26.3037L27.5336 26.2813L10.2621 16.4419Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.4992 22.4993V10.2503C17.4976 9.70247 17.0473 9.25225 16.4995 9.25061H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V23.5019V23.4989H16.4995C17.0473 23.4973 17.4976 23.047 17.4992 22.4993Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.7493 23.2491V11.0002C16.7477 10.4525 16.2973 10.0022 15.7496 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V24.2519V24.2489H15.7496C16.2973 24.2472 16.7477 23.797 16.7493 23.2491ZM16.7493 21.7493V11.0002C16.7477 10.4525 16.2973 10.0022 15.7496 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V22.7519V22.749H15.7496C16.2973 22.7473 16.7477 22.2971 16.7493 21.7493ZM15.9993 21.7493V11.0002C15.9977 10.4525 15.5475 10.0022 14.9997 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V22.7519V22.749H14.9997C15.5475 22.7473 15.9977 22.2971 15.9993 21.7493Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M4.99971 9.99988H14.9988C15.5472 9.99988 15.9985 10.4511 15.9985 10.9995V20.9986C15.9985 21.547 15.5472 21.9984 14.9988 21.9984H4.99971C4.45131 21.9984 4 21.547 4 20.9986V10.9995C4 10.4511 4.45131 9.99988 4.99971 9.99988Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.90014 14.1005C7.16577 13.5344 7.59472 13.0606 8.13155 12.7401C8.72643 12.3995 9.40377 12.2299 10.089 12.2497C10.7236 12.2357 11.35 12.3966 11.8993 12.7146C12.4163 13.0225 12.8327 13.4741 13.0977 14.0143C13.3864 14.6095 13.5304 15.2645 13.5177 15.9259C13.5318 16.6172 13.3835 17.3023 13.085 17.9261C12.8142 18.4854 12.3852 18.9533 11.8513 19.2715C11.2806 19.5995 10.6308 19.7648 9.97268 19.7492C9.32435 19.7646 8.6841 19.6019 8.12185 19.2789C7.60083 18.9705 7.17941 18.5185 6.90843 17.977C6.61792 17.3903 6.47228 16.7425 6.48395 16.0879C6.47108 15.4025 6.61366 14.7231 6.9009 14.1005H6.90014ZM8.2125 17.2938C8.35421 17.6517 8.59454 17.9623 8.90555 18.1892C9.22203 18.4109 9.60145 18.5252 9.98763 18.5155C10.3991 18.5318 10.8048 18.4138 11.1433 18.1795C11.4505 17.9526 11.6845 17.6404 11.8161 17.2818C11.964 16.8821 12.0369 16.4585 12.0313 16.0324C12.0359 15.6026 11.9674 15.1749 11.8289 14.768C11.7067 14.4017 11.4811 14.0783 11.1793 13.8374C10.8498 13.5913 10.4452 13.4662 10.0342 13.4834C9.63963 13.4731 9.2517 13.5881 8.9265 13.8118C8.6097 14.0395 8.36403 14.3527 8.2185 14.7148C7.89668 15.5438 7.89483 16.4636 8.21326 17.2938H8.2125Z",
                fill: "white"
            })
        ]
    });
};
var $00d08bb2217642b2$export$2e2bcd8739ae039 = $00d08bb2217642b2$var$OutlookCalendarIcon;

});

parcelRegister("i3woo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b09cd2aa9525d4b4$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $b09cd2aa9525d4b4$var$OutlookMailIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.1963 5.81042H9.67074C9.33358 5.81042 9.05615 6.08496 9.05615 6.4186V7.10989L13.2978 8.40948L17.8109 7.10989V6.4186C17.8109 6.08496 17.5335 5.81042 17.1963 5.81042Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.5332 12.4833C18.5973 12.2839 18.6485 12.0806 18.6864 11.8747C18.6864 11.7717 18.6308 11.6762 18.5406 11.6247L18.535 11.6217L18.5332 11.6209L13.7889 8.94645C13.7685 8.93335 13.7473 8.92131 13.7255 8.91047C13.5418 8.82037 13.3257 8.82037 13.142 8.91047C13.1202 8.92131 13.099 8.93328 13.0785 8.94645L8.33435 11.6209L8.33257 11.6217L8.32684 11.6247C8.23674 11.6762 8.18109 11.7717 8.18115 11.8747C8.21904 12.0806 8.27023 12.2839 8.33435 12.4833L13.3648 16.124L18.5332 12.4833Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.1842 7.10992H12.1201L11.2354 8.40952L12.1201 9.70898L15.1842 12.308H17.8106V9.70898L15.1842 7.10992Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 7.10999H12.1203V9.70898H9.05615V7.10999Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 7.10999H17.811V9.70898H15.1846V7.10999Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.1845 12.308L12.1203 9.70898H9.05615V12.308L12.1203 14.907L16.8619 15.6729L15.1845 12.308Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1201 9.70898H15.1843V12.308H12.1201V9.70898Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 12.3081H12.1203V14.9071H9.05615V12.3081Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 12.3081H17.811V14.9071H15.1846V12.3081Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.5172 15.8678L8.35449 12.1426L8.57073 11.7662C8.57073 11.7662 13.2742 14.4171 13.346 14.457C13.4054 14.4806 13.4723 14.4788 13.5303 14.4518C13.5972 14.4145 18.3156 11.7532 18.3156 11.7532L18.5327 12.1296L13.5172 15.8678Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.5407 12.1248L18.535 12.1282L18.5337 12.1291L13.7895 14.8035C13.5981 14.9257 13.3556 14.9406 13.1504 14.8429L14.8028 17.0352L18.4159 17.8136V17.8154C18.5863 17.6935 18.6874 17.4976 18.6873 17.2895V11.8749C18.6874 11.9778 18.6317 12.0734 18.5416 12.1248H18.5407Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.6864 17.2894V16.9698L14.3164 14.5059L13.7889 14.803C13.5976 14.9251 13.3551 14.9401 13.1499 14.8424L14.8023 17.0347L18.4154 17.8131V17.8149C18.5858 17.6929 18.6868 17.497 18.6868 17.289L18.6864 17.2894Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.6645 17.4555L13.8743 14.7551L13.7889 14.8032C13.5976 14.9253 13.3551 14.9403 13.1499 14.8426L14.8023 17.0349L18.4154 17.8133V17.815C18.538 17.7271 18.6262 17.5999 18.6649 17.4551L18.6645 17.4555Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.33388 12.1304V12.1261H8.32955L8.31637 12.1175C8.23142 12.0657 8.17985 11.9736 8.18067 11.8749V17.2904C8.18067 17.6463 8.4767 17.9393 8.83646 17.9393H18.0299C18.0845 17.9387 18.1389 17.9314 18.1918 17.9176C18.2192 17.9129 18.2458 17.9041 18.2706 17.8916C18.2799 17.8907 18.2888 17.8877 18.2968 17.8829C18.3326 17.8684 18.3665 17.8495 18.3975 17.8266L18.415 17.8136L8.33388 12.1304Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.5581 15.6292V8.55423C12.5571 8.2378 12.2943 7.97775 11.9745 7.97681H9.06976V11.2065L8.33387 11.6215L8.33215 11.6223L8.32648 11.6254C8.23632 11.6769 8.18066 11.7724 8.18066 11.8753V16.2083V16.2065H11.9745C12.2943 16.2057 12.5571 15.9456 12.5581 15.6292Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.1204 16.0622V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V16.6414V16.6397H11.5368C11.8566 16.6387 12.1194 16.3787 12.1204 16.0622ZM12.1204 15.1959V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.5368C11.8566 15.7724 12.1194 15.5123 12.1204 15.1959ZM11.6826 15.1959V8.98728C11.6816 8.6709 11.4189 8.41086 11.0991 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.0991C11.4189 15.7724 11.6816 15.5123 11.6826 15.1959Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M5.26223 8.40955H11.0985C11.4186 8.40955 11.6821 8.67016 11.6821 8.98691V14.7624C11.6821 15.0791 11.4186 15.3398 11.0985 15.3398H5.26223C4.94213 15.3398 4.67871 15.0791 4.67871 14.7624V8.98691C4.67871 8.67016 4.94213 8.40955 5.26223 8.40955Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.37132 10.7781C6.52637 10.4511 6.77674 10.1774 7.09008 9.99232C7.4373 9.7956 7.83266 9.69762 8.2326 9.70902C8.603 9.70096 8.96862 9.7939 9.28929 9.97757C9.59104 10.1554 9.83409 10.4163 9.98876 10.7283C10.1572 11.0721 10.2413 11.4504 10.2339 11.8324C10.2421 12.2317 10.1556 12.6274 9.98137 12.9877C9.82327 13.3108 9.5729 13.581 9.26127 13.7648C8.92812 13.9543 8.54887 14.0498 8.16472 14.0407C7.7863 14.0496 7.41259 13.9557 7.08441 13.7691C6.7803 13.591 6.53433 13.3299 6.37616 13.0171C6.20659 12.6783 6.12158 12.304 6.1284 11.926C6.12088 11.5301 6.20411 11.1377 6.37176 10.7781H6.37132ZM7.13733 12.6225C7.22004 12.8292 7.36032 13.0086 7.54185 13.1397C7.72658 13.2677 7.94804 13.3338 8.17345 13.3282C8.41363 13.3375 8.65044 13.2694 8.84802 13.1341C9.02733 13.003 9.16391 12.8227 9.2407 12.6156C9.32705 12.3847 9.36958 12.14 9.36633 11.8939C9.36901 11.6457 9.32902 11.3986 9.24815 11.1636C9.17684 10.952 9.04516 10.7653 8.86903 10.6261C8.67667 10.4839 8.4405 10.4117 8.20064 10.4216C7.97032 10.4157 7.7439 10.4821 7.55408 10.6113C7.36917 10.7428 7.22577 10.9237 7.14083 11.1329C6.95299 11.6117 6.95191 12.143 7.13777 12.6225H7.13733Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M25.4456 5.5H12.5525C11.9748 5.5 11.4995 5.97531 11.4995 6.55295V7.74978L18.7665 9.99978L26.4985 7.74978V6.55295C26.4985 5.97531 26.0232 5.5 25.4456 5.5Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.7361 17.053C27.8459 16.7078 27.9336 16.3558 27.9985 15.9993C27.9986 15.821 27.9033 15.6557 27.7488 15.5666L27.7391 15.5613L27.7361 15.5599L19.608 10.9297C19.573 10.907 19.5367 10.8861 19.4994 10.8674C19.1846 10.7114 18.8144 10.7114 18.4997 10.8674C18.4623 10.8861 18.426 10.9069 18.3909 10.9297L10.263 15.5599L10.2599 15.5613L10.2501 15.5666C10.0957 15.6557 10.0004 15.821 10.0005 15.9993C10.0654 16.3558 10.1531 16.7078 10.263 17.053L18.8814 23.3563L27.7361 17.053Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M21.999 7.74976H16.7494L15.2336 9.99976L16.7494 12.2495L21.999 16.7492H26.4987V12.2495L21.999 7.74976Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4995 7.74976H16.7492V12.2494H11.4995V7.74976Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.999 7.74976H26.4987V12.2494H21.999V7.74976Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M21.9989 16.7493L16.7492 12.2496H11.4995V16.7493L16.7492 21.2491L24.8726 22.575L21.9989 16.7493Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.7493 12.2496H21.9989V16.7493H16.7493V12.2496Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4995 16.7493H16.7492V21.2489H11.4995V16.7493Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.999 16.7493H26.4987V21.2489H21.999V16.7493Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.1423 22.9124L10.2974 16.4629L10.6678 15.8112C10.6678 15.8112 18.7261 20.4008 18.849 20.4699C18.9509 20.5108 19.0654 20.5075 19.1648 20.4608C19.2795 20.3964 27.3632 15.7887 27.3632 15.7887L27.7352 16.4404L19.1423 22.9124Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.7488 16.4322L27.7391 16.4382L27.7368 16.4397L19.6089 21.0699C19.2809 21.2814 18.8655 21.3072 18.5139 21.1381L21.3449 24.9336L27.5351 26.2813V26.2844C27.8269 26.0733 28.0001 25.7341 28 25.3739V15.9995C28.0001 16.1778 27.9047 16.3431 27.7503 16.4322H27.7488Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.9985 25.3739V24.8205L20.5117 20.5547L19.608 21.0692C19.2802 21.2806 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2836C27.8262 26.0724 27.9993 25.7333 27.9993 25.3731L27.9985 25.3739Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.9611 25.6612L19.7543 20.986L19.608 21.0692C19.2802 21.2806 18.8648 21.3066 18.5132 21.1374L21.3442 24.933L27.5343 26.2806V26.2836C27.7443 26.1313 27.8954 25.9111 27.9618 25.6604L27.9611 25.6612Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.262 16.442V16.4345H10.2546L10.232 16.4195C10.0865 16.3299 9.99811 16.1703 9.99953 15.9995V25.3754C9.99953 25.9917 10.5067 26.4989 11.1231 26.4989H26.8736C26.9672 26.4979 27.0605 26.4853 27.151 26.4613C27.198 26.4531 27.2435 26.438 27.2861 26.4164C27.302 26.4147 27.3173 26.4096 27.331 26.4013C27.3923 26.3762 27.4504 26.3435 27.5035 26.3038L27.5335 26.2813L10.262 16.442Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.4991 22.4994V10.2504C17.4974 9.70259 17.0472 9.25237 16.4994 9.25073H11.5227V14.8423L10.262 15.5608L10.259 15.5623L10.2493 15.5675C10.0949 15.6568 9.99951 15.822 9.99951 16.0002V23.502V23.499H16.4994C17.0472 23.4975 17.4974 23.0471 17.4991 22.4994Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.7492 23.2493V11.0003C16.7475 10.4526 16.2972 10.0024 15.7495 10.0006H11.5227V14.8423L10.262 15.5608L10.259 15.5623L10.2493 15.5675C10.0949 15.6568 9.99951 15.822 9.99951 16.0002V24.252V24.249H15.7495C16.2972 24.2473 16.7475 23.7971 16.7492 23.2493ZM16.7492 21.7494V11.0003C16.7475 10.4526 16.2972 10.0024 15.7495 10.0006H11.5227V14.8423L10.262 15.5608L10.259 15.5623L10.2493 15.5675C10.0949 15.6568 9.99951 15.822 9.99951 16.0002V22.752V22.7491H15.7495C16.2972 22.7474 16.7475 22.2972 16.7492 21.7494ZM15.9992 21.7494V11.0003C15.9975 10.4526 15.5473 10.0024 14.9996 10.0006H11.5227V14.8423L10.262 15.5608L10.259 15.5623L10.2493 15.5675C10.0949 15.6568 9.99951 15.822 9.99951 16.0002V22.752V22.7491H14.9996C15.5473 22.7474 15.9975 22.2972 15.9992 21.7494Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M4.99971 9.99988H14.9988C15.5472 9.99988 15.9985 10.4511 15.9985 10.9995V20.9986C15.9985 21.547 15.5472 21.9984 14.9988 21.9984H4.99971C4.45131 21.9984 4 21.547 4 20.9986V10.9995C4 10.4511 4.45131 9.99988 4.99971 9.99988Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.90014 14.1006C7.16577 13.5345 7.59472 13.0607 8.13155 12.7402C8.72643 12.3996 9.40377 12.23 10.089 12.2497C10.7236 12.2358 11.35 12.3967 11.8993 12.7147C12.4163 13.0225 12.8327 13.4742 13.0977 14.0144C13.3864 14.6096 13.5304 15.2646 13.5177 15.926C13.5318 16.6173 13.3835 17.3024 13.085 17.9262C12.8142 18.4855 12.3852 18.9534 11.8513 19.2716C11.2806 19.5996 10.6308 19.7649 9.97268 19.7493C9.32435 19.7647 8.6841 19.602 8.12185 19.279C7.60083 18.9706 7.17941 18.5185 6.90843 17.9771C6.61792 17.3904 6.47228 16.7425 6.48395 16.088C6.47108 15.4026 6.61366 14.7231 6.9009 14.1006H6.90014ZM8.2125 17.2939C8.35421 17.6518 8.59454 17.9624 8.90555 18.1893C9.22203 18.411 9.60145 18.5253 9.98763 18.5156C10.3991 18.5318 10.8048 18.4139 11.1433 18.1796C11.4505 17.9527 11.6845 17.6404 11.8161 17.2819C11.964 16.8822 12.0369 16.4586 12.0313 16.0324C12.0359 15.6026 11.9674 15.175 11.8289 14.7681C11.7067 14.4018 11.4811 14.0784 11.1793 13.8374C10.8498 13.5913 10.4452 13.4663 10.0342 13.4834C9.63963 13.4732 9.2517 13.5882 8.9265 13.8119C8.6097 14.0396 8.36403 14.3528 8.2185 14.7148C7.89668 15.5438 7.89483 16.4637 8.21326 17.2939H8.2125Z",
                fill: "white"
            })
        ]
    });
};
var $b09cd2aa9525d4b4$export$2e2bcd8739ae039 = $b09cd2aa9525d4b4$var$OutlookMailIcon;

});

parcelRegister("1lwoS", function(module, exports) {

$parcel$export(module.exports, "default", () => $854c18960b2d6ffb$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $854c18960b2d6ffb$var$PipedriveIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-635.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#017737"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.2336 10.1635C10.2336 11.5838 10.9541 13.1159 12.5396 13.1159C13.7154 13.1159 14.9043 12.198 14.9043 10.1427C14.9043 8.34075 13.9697 7.13106 12.5787 7.13106C11.4453 7.13106 10.2336 7.92728 10.2336 10.1635ZM13.1373 4.5C15.9802 4.5 17.8917 6.75159 17.8917 10.1032C17.8917 13.4022 15.878 15.7053 12.9993 15.7053C11.6268 15.7053 10.7476 15.1175 10.2879 14.6919C10.2912 14.7928 10.2933 14.9058 10.2933 15.0264V19.5H7.34834V7.58072C7.34834 7.40743 7.29292 7.3526 7.12122 7.3526H6.1084V4.74238H8.5796C9.71739 4.74238 10.0086 5.32145 10.0641 5.76782C10.5259 5.25017 11.4833 4.5 13.1373 4.5Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M10.4002 10.0411C10.4002 11.556 11.1687 13.1903 12.8599 13.1903C14.1142 13.1903 15.3823 12.2112 15.3823 10.0189C15.3823 8.0968 14.3854 6.80647 12.9017 6.80647C11.6927 6.80647 10.4002 7.65577 10.4002 10.0411ZM13.4975 4C16.5299 4 18.5688 6.4017 18.5688 9.97675C18.5688 13.4957 16.4209 15.9523 13.3503 15.9523C11.8862 15.9523 10.9485 15.3253 10.4582 14.8714C10.4616 14.979 10.4639 15.0995 10.4639 15.2282V20H7.32261V7.2861C7.32261 7.10126 7.26349 7.04278 7.08034 7.04278H6V4.25854H8.63594C9.84959 4.25854 10.1602 4.87621 10.2194 5.35234C10.712 4.80018 11.7332 4 13.4975 4Z",
            fill: "#017737"
        })
    });
};
var $854c18960b2d6ffb$export$2e2bcd8739ae039 = $854c18960b2d6ffb$var$PipedriveIcon;

});

parcelRegister("gLGvg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c002cdcd98eda8d3$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $c002cdcd98eda8d3$var$SalesforceIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.385264",
                y: "0.385264",
                width: "23.2295",
                height: "23.2295",
                rx: "5.61474",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                id: "mask0_719_13847",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "5",
                width: "18",
                height: "14",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M3 5.71326H21V18.2868H3V5.71326Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                mask: "url(#mask0_719_13847)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.4738 7.08983C11.0548 6.48497 11.8635 6.11041 12.7569 6.11041C13.9481 6.11041 14.9804 6.77218 15.5363 7.75821C16.0297 7.53763 16.5642 7.42374 17.1047 7.42402C19.2488 7.42402 20.9892 9.17769 20.9892 11.3417C20.9892 13.5056 19.2488 15.2593 17.1047 15.2593C16.8426 15.2593 16.5872 15.233 16.337 15.1832C15.8506 16.0501 14.9209 16.6391 13.862 16.6391C13.431 16.6399 13.0054 16.5422 12.6179 16.3532C12.1249 17.5113 10.9767 18.3253 9.63998 18.3253C8.24366 18.3253 7.0591 17.4451 6.60248 16.2076C6.39925 16.2505 6.1921 16.2721 5.98439 16.2719C4.32336 16.2719 2.97998 14.9087 2.97998 13.2344C2.97998 12.1094 3.58483 11.13 4.48219 10.6006C4.29181 10.1621 4.19382 9.689 4.19432 9.21091C4.19432 7.27856 5.7627 5.7168 7.69505 5.7168C8.82667 5.7168 9.83917 6.25614 10.4745 7.09327",
                    fill: "#00A1E0"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.6037 12.2516C5.59239 12.2812 5.60774 12.2873 5.61138 12.2925C5.64519 12.317 5.67954 12.3348 5.71395 12.3547C5.89792 12.452 6.07131 12.4804 6.25263 12.4804C6.62189 12.4804 6.85153 12.2839 6.85153 11.9675V11.9613C6.85153 11.6688 6.59211 11.5623 6.34991 11.4862L6.31821 11.4759C6.1349 11.4165 5.97674 11.3647 5.97674 11.2443V11.2381C5.97674 11.1349 6.06939 11.0588 6.21233 11.0588C6.37115 11.0588 6.56042 11.1117 6.68152 11.1786C6.68152 11.1786 6.71739 11.2018 6.73042 11.1671C6.7375 11.1484 6.79925 10.9832 6.80586 10.9646C6.81288 10.9453 6.80057 10.9306 6.78793 10.9231C6.64896 10.8384 6.45705 10.7808 6.25852 10.7808L6.22166 10.7809C5.8835 10.7809 5.64725 10.9854 5.64725 11.2779V11.2842C5.64725 11.5926 5.90798 11.6932 6.15151 11.7627L6.19069 11.7748C6.36804 11.8294 6.52157 11.8768 6.52157 12.0012V12.0074C6.52157 12.1219 6.42164 12.2072 6.2615 12.2072C6.19922 12.2072 6.00076 12.2062 5.78569 12.0703C5.75968 12.0551 5.74486 12.0442 5.72481 12.0319C5.71422 12.0255 5.68775 12.0139 5.67623 12.0486L5.60344 12.2511M11.0101 12.2511C10.9987 12.2806 11.0141 12.2868 11.0179 12.292C11.0515 12.3165 11.086 12.3342 11.1204 12.3541C11.3044 12.4514 11.4778 12.4799 11.6591 12.4799C12.0284 12.4799 12.258 12.2833 12.258 11.967V11.9608C12.258 11.6683 11.9993 11.5618 11.7564 11.4856L11.7247 11.4754C11.5414 11.416 11.3832 11.3642 11.3832 11.2438V11.2376C11.3832 11.1344 11.4759 11.0583 11.6188 11.0583C11.7776 11.0583 11.9662 11.1112 12.088 11.1781C12.088 11.1781 12.1239 11.2012 12.137 11.1666C12.144 11.1479 12.2058 10.9826 12.2118 10.9641C12.2188 10.9447 12.2065 10.9301 12.1939 10.9226C12.0549 10.8378 11.863 10.7803 11.6645 10.7803L11.6275 10.7804C11.2894 10.7804 11.0531 10.9849 11.0531 11.2774V11.2837C11.0531 11.5921 11.3139 11.6926 11.5574 11.7621L11.5965 11.7743C11.7745 11.8288 11.9274 11.8762 11.9274 12.0006V12.0069C11.9274 12.1213 11.8275 12.2067 11.6673 12.2067C11.6049 12.2067 11.4059 12.2056 11.1915 12.0697C11.1655 12.0546 11.1503 12.0441 11.1306 12.0314C11.1239 12.0272 11.0927 12.015 11.0821 12.0481L11.0093 12.2506M14.7019 11.6312C14.7019 11.8098 14.6686 11.9508 14.6033 12.0507C14.5382 12.1493 14.4398 12.1976 14.3029 12.1976C14.1659 12.1976 14.0679 12.1497 14.0037 12.0514C13.9391 11.9521 13.9065 11.8105 13.9065 11.6318C13.9065 11.4532 13.9393 11.3129 14.0037 11.2143C14.0678 11.1163 14.1652 11.0693 14.3029 11.0693C14.4405 11.0693 14.5385 11.1168 14.6033 11.2143C14.669 11.3129 14.7019 11.4532 14.7019 11.6318M15.0103 11.3003C14.9799 11.1977 14.9329 11.1077 14.87 11.0323C14.8071 10.9568 14.7277 10.8959 14.6331 10.8523C14.5391 10.8083 14.4279 10.7861 14.3022 10.7861C14.1765 10.7861 14.066 10.8084 13.9713 10.8523C13.8773 10.8962 13.7973 10.9568 13.7344 11.0323C13.6717 11.1077 13.6246 11.1977 13.5941 11.3003C13.564 11.4022 13.5487 11.5134 13.5487 11.6318C13.5487 11.7503 13.564 11.8615 13.5941 11.9634C13.6244 12.0659 13.6715 12.1559 13.7344 12.2314C13.7973 12.3068 13.8773 12.3671 13.9713 12.4101C14.066 12.4529 14.1771 12.4748 14.3022 12.4748C14.4273 12.4748 14.5385 12.4529 14.6324 12.4101C14.7264 12.3672 14.8065 12.3068 14.8693 12.2314C14.9321 12.1559 14.9792 12.0659 15.0096 11.9634C15.0397 11.8615 15.055 11.7503 15.055 11.6318C15.055 11.514 15.0397 11.4022 15.0096 11.3003M17.5442 12.1473C17.5341 12.1174 17.5048 12.1287 17.5048 12.1287C17.46 12.1458 17.4122 12.1617 17.3612 12.1696C17.3099 12.1777 17.2527 12.1818 17.1925 12.1818C17.0436 12.1818 16.9244 12.1374 16.8397 12.0494C16.7544 11.9614 16.7067 11.8198 16.7074 11.6279C16.7078 11.4532 16.7501 11.3221 16.8258 11.2215C16.9006 11.1223 17.0158 11.0707 17.168 11.0707C17.295 11.0707 17.3923 11.0854 17.4942 11.1173C17.4942 11.1173 17.5184 11.1278 17.53 11.096C17.557 11.0212 17.577 10.9676 17.6061 10.8856C17.6143 10.8621 17.5942 10.8521 17.5868 10.8493C17.5468 10.8337 17.4525 10.8081 17.381 10.7973C17.3142 10.7871 17.2367 10.7818 17.1494 10.7818C17.0197 10.7818 16.9045 10.804 16.8059 10.8479C16.7073 10.8918 16.6239 10.9525 16.5578 11.0279C16.4916 11.1033 16.4413 11.1933 16.4075 11.2959C16.3741 11.3978 16.3572 11.5097 16.3572 11.6281C16.3572 11.8836 16.4261 12.0907 16.5624 12.2422C16.6987 12.3944 16.9039 12.4712 17.1712 12.4712C17.3294 12.4712 17.4915 12.4393 17.608 12.3931C17.608 12.3931 17.6302 12.3824 17.6206 12.3565L17.5445 12.1473M18.0838 11.4591C18.0985 11.3598 18.1257 11.2771 18.1685 11.2129C18.2325 11.115 18.33 11.0614 18.467 11.0614C18.6039 11.0614 18.6946 11.1153 18.7595 11.2129C18.8025 11.2775 18.8213 11.3632 18.8283 11.4591L18.0805 11.459L18.0838 11.4591ZM19.1228 11.2407C19.0965 11.1421 19.0314 11.0422 18.9891 10.9965C18.9216 10.9244 18.8561 10.8734 18.7906 10.8457C18.696 10.8054 18.5942 10.7848 18.4914 10.785C18.3611 10.785 18.2426 10.807 18.1467 10.8518C18.0507 10.8969 17.97 10.9584 17.9064 11.0351C17.843 11.1119 17.7953 11.2025 17.7648 11.3064C17.7344 11.409 17.719 11.5215 17.719 11.6393C17.719 11.7598 17.735 11.8716 17.7663 11.9728C17.798 12.0748 17.8491 12.1641 17.9179 12.2382C17.9867 12.313 18.0747 12.3712 18.1806 12.4123C18.2858 12.4529 18.4135 12.4741 18.5598 12.4736C18.8616 12.4726 19.0204 12.4054 19.0852 12.369C19.0968 12.3626 19.1077 12.3514 19.0941 12.3191L19.0259 12.1279C19.0155 12.0994 18.9866 12.1097 18.9866 12.1097C18.9119 12.1376 18.806 12.1878 18.5578 12.1871C18.3957 12.1869 18.2759 12.139 18.2005 12.064C18.1237 11.9873 18.0853 11.8754 18.0794 11.7166L19.1249 11.7174C19.1249 11.7174 19.1525 11.7171 19.1553 11.6903C19.1564 11.6791 19.1911 11.4759 19.1242 11.2409L19.1228 11.2407ZM9.7257 11.4591C9.74046 11.3598 9.76772 11.2771 9.81041 11.2129C9.87447 11.115 9.97188 11.0614 10.1089 11.0614C10.2458 11.0614 10.3365 11.1153 10.4014 11.2129C10.4443 11.2775 10.4631 11.3632 10.4702 11.4591L9.72239 11.459L9.7257 11.4591ZM10.7647 11.2407C10.7385 11.1421 10.6733 11.0422 10.631 10.9965C10.5635 10.9244 10.498 10.8734 10.4325 10.8457C10.3379 10.8054 10.2361 10.7848 10.1333 10.785C10.003 10.785 9.88453 10.807 9.78857 10.8518C9.69261 10.8969 9.61188 10.9584 9.54835 11.0351C9.48502 11.1119 9.43717 11.2025 9.40673 11.3064C9.37636 11.409 9.36107 11.5215 9.36107 11.6393C9.36107 11.7598 9.37689 11.8716 9.40845 11.9728C9.44008 12.0748 9.49117 12.1641 9.55933 12.2382C9.62816 12.313 9.71617 12.3712 9.82206 12.4123C9.92728 12.4529 10.0543 12.4741 10.2012 12.4736C10.503 12.4726 10.6618 12.4054 10.7267 12.369C10.7382 12.3626 10.7492 12.3514 10.7355 12.3191L10.6673 12.1279C10.6568 12.0994 10.628 12.1097 10.628 12.1097C10.5532 12.1376 10.4473 12.1878 10.1991 12.1871C10.0377 12.1869 9.91722 12.139 9.84178 12.064C9.76501 11.9873 9.72663 11.8754 9.72067 11.7166L10.7663 11.7174C10.7663 11.7174 10.7938 11.7171 10.7966 11.6903C10.7978 11.6791 10.8324 11.4759 10.7654 11.2409L10.7647 11.2407ZM7.46908 12.1407C7.42812 12.108 7.42243 12.1 7.40886 12.0788C7.38815 12.0468 7.37756 12.0014 7.37756 11.9431C7.37756 11.8518 7.408 11.7856 7.47087 11.7413C7.47021 11.7414 7.56087 11.6632 7.77396 11.6658C7.86881 11.6675 7.96343 11.6756 8.05719 11.69V12.1645H8.05733C8.05733 12.1645 7.92497 12.193 7.77542 12.202C7.56299 12.2148 7.46902 12.1409 7.46968 12.1411L7.46908 12.1407ZM7.88467 11.4062C7.84232 11.4031 7.78739 11.4015 7.72188 11.4015C7.63254 11.4015 7.54585 11.4127 7.46511 11.4345C7.38372 11.4565 7.31026 11.4905 7.24739 11.5357C7.18435 11.5807 7.1325 11.6396 7.09585 11.7078C7.05886 11.7766 7.04 11.8574 7.04 11.9487C7.04 12.0413 7.05608 12.1214 7.08784 12.1869C7.11897 12.2519 7.16583 12.3081 7.22417 12.3504C7.2822 12.3926 7.35387 12.4238 7.43659 12.4424C7.51865 12.4611 7.6113 12.4706 7.71321 12.4706C7.82042 12.4706 7.92696 12.4616 8.03019 12.4441C8.11812 12.429 8.20571 12.4119 8.29292 12.3931C8.32772 12.3851 8.36637 12.3745 8.36637 12.3745C8.39218 12.368 8.3902 12.3404 8.3902 12.3404L8.3896 11.3874C8.3896 11.1783 8.33375 11.0228 8.2235 10.9269C8.11364 10.8309 7.95283 10.7826 7.74438 10.7826C7.66629 10.7826 7.53989 10.7932 7.46445 10.8083C7.46445 10.8083 7.23681 10.8525 7.14283 10.9261C7.14283 10.9261 7.12219 10.9388 7.13344 10.9676L7.20756 11.1661C7.21675 11.1919 7.24183 11.1831 7.24183 11.1831C7.24183 11.1831 7.24971 11.18 7.25897 11.1745C7.45949 11.0653 7.71361 11.0686 7.71361 11.0686C7.82611 11.0686 7.91346 11.0914 7.97169 11.1361C8.02867 11.1798 8.05772 11.246 8.05772 11.3849V11.4291C7.96839 11.4161 7.88567 11.4086 7.88567 11.4086L7.88467 11.4062ZM16.2891 10.8682C16.2906 10.8647 16.2914 10.8609 16.2914 10.8571C16.2914 10.8533 16.2907 10.8495 16.2892 10.846C16.2878 10.8425 16.2856 10.8394 16.2829 10.8367C16.2802 10.834 16.2769 10.832 16.2734 10.8306C16.2556 10.8238 16.1669 10.8051 16.0987 10.8009C15.9677 10.7926 15.8949 10.8148 15.8294 10.8441C15.7646 10.8733 15.693 10.9202 15.6533 10.9745L15.6532 10.8474C15.6532 10.83 15.6408 10.8159 15.6232 10.8159H15.3559C15.3385 10.8159 15.326 10.83 15.326 10.8474V12.4026C15.326 12.411 15.3293 12.419 15.3353 12.425C15.3412 12.4309 15.3492 12.4343 15.3577 12.4343H15.6316C15.64 12.4343 15.6481 12.4309 15.654 12.425C15.6599 12.419 15.6633 12.411 15.6633 12.4026V11.6217C15.6633 11.5171 15.6748 11.4133 15.6977 11.3477C15.7204 11.2829 15.7511 11.2313 15.7891 11.1942C15.8252 11.1584 15.8695 11.1319 15.9181 11.1168C15.9637 11.1037 16.0109 11.0971 16.0584 11.0971C16.113 11.0971 16.1729 11.1111 16.1729 11.1111C16.193 11.1133 16.2042 11.101 16.211 11.0829C16.2289 11.0352 16.2798 10.8923 16.2897 10.8639",
                fill: "#FFFFFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.7299 10.1503C13.6961 10.14 13.6616 10.1319 13.6267 10.1258C13.5799 10.118 13.5324 10.1143 13.4849 10.1148C13.2961 10.1148 13.1472 10.1681 13.0427 10.2735C12.939 10.378 12.8684 10.5373 12.833 10.7469L12.8202 10.8177H12.5832C12.5832 10.8177 12.5543 10.8165 12.5482 10.848L12.5093 11.0651C12.5066 11.0859 12.5155 11.0988 12.5433 11.0987H12.774L12.5399 12.4052C12.5216 12.5104 12.5006 12.597 12.4774 12.6626C12.4545 12.7273 12.4321 12.7758 12.4046 12.811C12.3779 12.8451 12.3527 12.8702 12.309 12.8848C12.273 12.8969 12.2316 12.9025 12.1862 12.9025C12.1609 12.9025 12.1273 12.8982 12.1025 12.8933C12.0777 12.8884 12.0648 12.8828 12.0462 12.875C12.0462 12.875 12.0191 12.8647 12.0085 12.8918C11.9998 12.914 11.9383 13.0831 11.931 13.104C11.9236 13.1246 11.934 13.1409 11.9471 13.1456C11.9778 13.1566 12.0007 13.1636 12.0425 13.1735C12.1006 13.1872 12.1496 13.188 12.1954 13.188C12.2915 13.188 12.3791 13.1745 12.4517 13.1483C12.5247 13.1219 12.5883 13.0759 12.6446 13.0137C12.7054 12.9465 12.7436 12.8761 12.7802 12.7802C12.8164 12.6851 12.8473 12.567 12.8719 12.4294L13.1071 11.0987H13.451C13.451 11.0987 13.48 11.0998 13.486 11.0683L13.5249 10.8513C13.5276 10.8305 13.5187 10.8175 13.4908 10.8177H13.1571C13.1587 10.8101 13.1739 10.6927 13.2122 10.5822C13.2286 10.535 13.2593 10.497 13.2854 10.4708C13.3098 10.4459 13.3397 10.4273 13.3728 10.4164C13.4091 10.4052 13.4469 10.3998 13.4849 10.4003C13.5163 10.4003 13.5471 10.4041 13.5706 10.4089C13.603 10.4158 13.6156 10.4195 13.624 10.422C13.6581 10.4324 13.6626 10.4223 13.6693 10.4058L13.7491 10.1867C13.7573 10.1631 13.7373 10.1532 13.7299 10.1503ZM9.0662 12.408C9.0662 12.4255 9.05376 12.4397 9.03629 12.4397H8.75947C8.74193 12.4397 8.72949 12.4255 8.72949 12.408V10.18C8.72949 10.1626 8.74193 10.1485 8.75947 10.1485H9.03629C9.05376 10.1485 9.0662 10.1626 9.0662 10.18V12.408Z",
                fill: "#FFFFFE"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                id: "mask0_7_630",
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "6",
                width: "18",
                height: "13",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M3 6H21V18.5735H3V6Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                mask: "url(#mask0_7_630)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.474 7.37645C11.055 6.77159 11.8637 6.39704 12.7571 6.39704C13.9483 6.39704 14.9806 7.0588 15.5365 8.04483C16.0299 7.82425 16.5644 7.71036 17.1049 7.71064C19.249 7.71064 20.9894 9.46431 20.9894 11.6283C20.9894 13.7923 19.249 15.5459 17.1049 15.5459C16.8428 15.5459 16.5874 15.5196 16.3372 15.4698C15.8508 16.3367 14.921 16.9257 13.8622 16.9257C13.4311 16.9266 13.0056 16.8288 12.6181 16.6398C12.1251 17.7979 10.9769 18.6119 9.64016 18.6119C8.24384 18.6119 7.05928 17.7317 6.60266 16.4942C6.39943 16.5371 6.19228 16.5587 5.98458 16.5586C4.32355 16.5586 2.98016 15.1953 2.98016 13.5211C2.98016 12.3961 3.58502 11.4167 4.48237 10.8872C4.292 10.4487 4.194 9.97562 4.1945 9.49754C4.1945 7.56518 5.76288 6.00342 7.69524 6.00342C8.82686 6.00342 9.83935 6.54276 10.4746 7.37989",
                    fill: "#00A1E0"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.6034 12.5383C5.59208 12.5678 5.60743 12.5739 5.61107 12.5792C5.64489 12.6036 5.67924 12.6214 5.71365 12.6413C5.89762 12.7386 6.071 12.767 6.25232 12.767C6.62159 12.767 6.85122 12.5705 6.85122 12.2542V12.2479C6.85122 11.9554 6.59181 11.8489 6.3496 11.7728L6.3179 11.7625C6.1346 11.7031 5.97643 11.6514 5.97643 11.5309V11.5248C5.97643 11.4215 6.06908 11.3454 6.21202 11.3454C6.37085 11.3454 6.56011 11.3983 6.68121 11.4652C6.68121 11.4652 6.71708 11.4884 6.73012 11.4538C6.7372 11.435 6.79894 11.2698 6.80556 11.2513C6.81257 11.2319 6.80026 11.2172 6.78762 11.2097C6.64865 11.125 6.45674 11.0674 6.25821 11.0674L6.22135 11.0676C5.88319 11.0676 5.64694 11.272 5.64694 11.5645V11.5708C5.64694 11.8792 5.90768 11.9798 6.15121 12.0493L6.19038 12.0615C6.36774 12.116 6.52126 12.1634 6.52126 12.2878V12.294C6.52126 12.4085 6.42134 12.4939 6.26119 12.4939C6.19892 12.4939 6.00046 12.4928 5.78538 12.3569C5.75937 12.3417 5.74455 12.3308 5.7245 12.3186C5.71391 12.3121 5.68744 12.3006 5.67593 12.3352L5.60313 12.5377M11.0097 12.5377C10.9984 12.5672 11.0138 12.5734 11.0176 12.5786C11.0512 12.6031 11.0857 12.6209 11.1201 12.6408C11.3041 12.738 11.4775 12.7665 11.6588 12.7665C12.0281 12.7665 12.2577 12.57 12.2577 12.2536V12.2474C12.2577 11.9549 11.999 11.8484 11.7561 11.7723L11.7244 11.762C11.5411 11.7026 11.3829 11.6508 11.3829 11.5304V11.5242C11.3829 11.421 11.4756 11.3449 11.6185 11.3449C11.7773 11.3449 11.9659 11.3978 12.0877 11.4647C12.0877 11.4647 12.1236 11.4878 12.1367 11.4532C12.1437 11.4345 12.2055 11.2693 12.2114 11.2507C12.2185 11.2313 12.2062 11.2167 12.1936 11.2092C12.0546 11.1245 11.8627 11.0669 11.6642 11.0669L11.6272 11.067C11.2891 11.067 11.0528 11.2715 11.0528 11.564V11.5703C11.0528 11.8787 11.3136 11.9793 11.5571 12.0488L11.5962 12.0609C11.7742 12.1155 11.9271 12.1628 11.9271 12.2873V12.2935C11.9271 12.408 11.8272 12.4933 11.667 12.4933C11.6046 12.4933 11.4056 12.4923 11.1912 12.3563C11.1652 12.3412 11.15 12.3307 11.1303 12.318C11.1236 12.3138 11.0924 12.3016 11.0817 12.3347L11.009 12.5372M14.7016 11.9178C14.7016 12.0965 14.6683 12.2374 14.603 12.3374C14.5379 12.436 14.4395 12.4843 14.3026 12.4843C14.1656 12.4843 14.0676 12.4364 14.0034 12.338C13.9388 12.2387 13.9062 12.0971 13.9062 11.9185C13.9062 11.7398 13.939 11.5995 14.0034 11.5009C14.0675 11.4029 14.1649 11.356 14.3026 11.356C14.4402 11.356 14.5381 11.4034 14.603 11.5009C14.6686 11.5995 14.7016 11.7398 14.7016 11.9185M15.01 11.5869C14.9796 11.4843 14.9326 11.3943 14.8697 11.3189C14.8068 11.2435 14.7274 11.1826 14.6328 11.1389C14.5388 11.0949 14.4276 11.0727 14.3019 11.0727C14.1762 11.0727 14.0656 11.095 13.971 11.1389C13.877 11.1828 13.797 11.2435 13.7341 11.3189C13.6714 11.3943 13.6242 11.4843 13.5938 11.5869C13.5637 11.6888 13.5484 11.8 13.5484 11.9185C13.5484 12.0369 13.5637 12.1481 13.5938 12.25C13.6241 12.3526 13.6712 12.4426 13.7341 12.518C13.797 12.5935 13.877 12.6537 13.971 12.6967C14.0656 12.7396 14.1768 12.7614 14.3019 12.7614C14.427 12.7614 14.5381 12.7396 14.6321 12.6967C14.7261 12.6538 14.8062 12.5935 14.869 12.518C14.9318 12.4426 14.9789 12.3526 15.0093 12.25C15.0394 12.1481 15.0547 12.0369 15.0547 11.9185C15.0547 11.8007 15.0394 11.6888 15.0093 11.5869M17.5439 12.434C17.5338 12.404 17.5045 12.4153 17.5045 12.4153C17.4597 12.4324 17.4119 12.4483 17.3609 12.4563C17.3096 12.4643 17.2524 12.4684 17.1922 12.4684C17.0433 12.4684 16.9241 12.424 16.8394 12.336C16.7541 12.248 16.7064 12.1064 16.7071 11.9145C16.7075 11.7398 16.7498 11.6087 16.8255 11.5082C16.9003 11.4089 17.0155 11.3573 17.1677 11.3573C17.2947 11.3573 17.392 11.372 17.4939 11.4039C17.4939 11.4039 17.5181 11.4145 17.5297 11.3826C17.5567 11.3078 17.5767 11.2542 17.6058 11.1722C17.614 11.1487 17.5938 11.1388 17.5865 11.1359C17.5465 11.1203 17.4522 11.0947 17.3807 11.0839C17.3139 11.0737 17.2364 11.0684 17.1491 11.0684C17.0194 11.0684 16.9042 11.0906 16.8056 11.1345C16.707 11.1784 16.6236 11.2391 16.5575 11.3145C16.4913 11.39 16.441 11.48 16.4072 11.5825C16.3738 11.6845 16.3569 11.7963 16.3569 11.9147C16.3569 12.1702 16.4258 12.3773 16.5621 12.5289C16.6984 12.6811 16.9036 12.7578 17.1709 12.7578C17.3291 12.7578 17.4912 12.7259 17.6077 12.6797C17.6077 12.6797 17.6299 12.669 17.6203 12.6431L17.5441 12.434M18.0835 11.7457C18.0982 11.6465 18.1254 11.5637 18.1682 11.4996C18.2322 11.4016 18.3297 11.348 18.4666 11.348C18.6036 11.348 18.6943 11.4019 18.7591 11.4996C18.8022 11.5641 18.821 11.6498 18.828 11.7457L18.0802 11.7456L18.0835 11.7457ZM19.1225 11.5274C19.0962 11.4287 19.0311 11.3288 18.9888 11.2832C18.9213 11.211 18.8558 11.1601 18.7903 11.1323C18.6957 11.0921 18.5939 11.0714 18.4911 11.0716C18.3608 11.0716 18.2423 11.0936 18.1464 11.1384C18.0504 11.1836 17.9697 11.245 17.9061 11.3217C17.8427 11.3985 17.795 11.4892 17.7645 11.5931C17.7341 11.6956 17.7187 11.8081 17.7187 11.9259C17.7187 12.0464 17.7347 12.1582 17.766 12.2595C17.7977 12.3614 17.8488 12.4507 17.9176 12.5248C17.9864 12.5996 18.0744 12.6578 18.1803 12.6989C18.2855 12.7396 18.4132 12.7607 18.5595 12.7602C18.8613 12.7592 19.0201 12.6921 19.0849 12.6557C19.0965 12.6492 19.1074 12.638 19.0938 12.6058L19.0256 12.4145C19.0152 12.386 18.9863 12.3963 18.9863 12.3963C18.9116 12.4242 18.8057 12.4744 18.5575 12.4737C18.3954 12.4735 18.2756 12.4256 18.2002 12.3507C18.1234 12.2739 18.085 12.162 18.0791 12.0032L19.1246 12.004C19.1246 12.004 19.1522 12.0038 19.155 11.9769C19.1561 11.9658 19.1908 11.7625 19.1238 11.5275L19.1225 11.5274ZM9.7254 11.7457C9.74015 11.6465 9.76742 11.5637 9.8101 11.4996C9.87416 11.4016 9.97157 11.348 10.1086 11.348C10.2455 11.348 10.3362 11.4019 10.4011 11.4996C10.444 11.5641 10.4628 11.6498 10.4699 11.7457L9.72209 11.7456L9.7254 11.7457ZM10.7644 11.5274C10.7382 11.4287 10.673 11.3288 10.6307 11.2832C10.5632 11.211 10.4977 11.1601 10.4322 11.1323C10.3376 11.0921 10.2358 11.0714 10.133 11.0716C10.0027 11.0716 9.88422 11.0936 9.78826 11.1384C9.69231 11.1836 9.61157 11.245 9.54804 11.3217C9.48471 11.3985 9.43687 11.4892 9.40643 11.5931C9.37605 11.6956 9.36076 11.8081 9.36076 11.9259C9.36076 12.0464 9.37658 12.1582 9.40815 12.2595C9.43978 12.3614 9.49087 12.4507 9.55903 12.5248C9.62785 12.5996 9.71587 12.6578 9.82175 12.6989C9.92697 12.7396 10.054 12.7607 10.2009 12.7602C10.5027 12.7592 10.6615 12.6921 10.7264 12.6557C10.7379 12.6492 10.7489 12.638 10.7352 12.6058L10.667 12.4145C10.6565 12.386 10.6276 12.3963 10.6276 12.3963C10.5529 12.4242 10.447 12.4744 10.1988 12.4737C10.0374 12.4735 9.91691 12.4256 9.84147 12.3507C9.76471 12.2739 9.72632 12.162 9.72037 12.0032L10.766 12.004C10.766 12.004 10.7935 12.0038 10.7963 11.9769C10.7975 11.9658 10.8321 11.7625 10.7651 11.5275L10.7644 11.5274ZM7.46878 12.4274C7.42782 12.3947 7.42213 12.3867 7.40856 12.3654C7.38785 12.3334 7.37726 12.288 7.37726 12.2297C7.37726 12.1384 7.4077 12.0722 7.47057 12.0279C7.4699 12.028 7.56057 11.9498 7.77365 11.9525C7.8685 11.9542 7.96313 11.9622 8.05689 11.9766V12.4511H8.05702C8.05702 12.4511 7.92467 12.4796 7.77511 12.4886C7.56268 12.5014 7.46871 12.4275 7.46938 12.4277L7.46878 12.4274ZM7.88437 11.6928C7.84201 11.6897 7.78709 11.6882 7.72157 11.6882C7.63224 11.6882 7.54554 11.6993 7.46481 11.7211C7.38341 11.7431 7.30996 11.7771 7.24709 11.8224C7.18405 11.8673 7.1322 11.9262 7.09554 11.9944C7.05855 12.0632 7.03969 12.144 7.03969 12.2353C7.03969 12.328 7.05577 12.408 7.08754 12.4735C7.11866 12.5385 7.16552 12.5947 7.22386 12.637C7.2819 12.6792 7.35357 12.7105 7.43629 12.729C7.51835 12.7477 7.61099 12.7572 7.7129 12.7572C7.82011 12.7572 7.92665 12.7482 8.02989 12.7308C8.11782 12.7156 8.20541 12.6986 8.29261 12.6797C8.32742 12.6717 8.36607 12.6612 8.36607 12.6612C8.39188 12.6546 8.38989 12.627 8.38989 12.627L8.38929 11.6741C8.38929 11.4649 8.33344 11.3094 8.22319 11.2135C8.11334 11.1175 7.95253 11.0692 7.74407 11.0692C7.66599 11.0692 7.53959 11.0798 7.46415 11.095C7.46415 11.095 7.2365 11.1392 7.14253 11.2127C7.14253 11.2127 7.12188 11.2255 7.13313 11.2542L7.20725 11.4528C7.21645 11.4785 7.24153 11.4697 7.24153 11.4697C7.24153 11.4697 7.2494 11.4666 7.25867 11.4611C7.45918 11.3519 7.7133 11.3552 7.7133 11.3552C7.8258 11.3552 7.91315 11.3781 7.97139 11.4227C8.02837 11.4665 8.05742 11.5326 8.05742 11.6715V11.7157C7.96808 11.7027 7.88536 11.6952 7.88536 11.6952L7.88437 11.6928ZM16.2888 11.1548C16.2903 11.1513 16.2911 11.1475 16.2911 11.1437C16.2911 11.1399 16.2904 11.1362 16.2889 11.1327C16.2874 11.1291 16.2853 11.126 16.2826 11.1233C16.2799 11.1207 16.2766 11.1186 16.2731 11.1172C16.2553 11.1104 16.1666 11.0917 16.0984 11.0875C15.9674 11.0793 15.8946 11.1014 15.8291 11.1308C15.7643 11.1599 15.6927 11.2069 15.653 11.2611L15.6529 11.1341C15.6529 11.1166 15.6405 11.1025 15.6229 11.1025H15.3556C15.3382 11.1025 15.3256 11.1166 15.3256 11.1341V12.6892C15.3257 12.6976 15.329 12.7057 15.335 12.7116C15.3409 12.7175 15.3489 12.7209 15.3573 12.7209H15.6313C15.6397 12.7209 15.6478 12.7175 15.6537 12.7116C15.6596 12.7057 15.6629 12.6976 15.6629 12.6892V11.9083C15.6629 11.8038 15.6745 11.6999 15.6974 11.6344C15.7201 11.5696 15.7508 11.5179 15.7888 11.4808C15.8249 11.445 15.8692 11.4185 15.9178 11.4034C15.9634 11.3903 16.0106 11.3837 16.0581 11.3837C16.1127 11.3837 16.1726 11.3977 16.1726 11.3977C16.1927 11.4 16.2039 11.3877 16.2107 11.3695C16.2286 11.3218 16.2795 11.1789 16.2894 11.1505",
                fill: "#FFFFFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.7299 10.437C13.6961 10.4268 13.6616 10.4186 13.6267 10.4125C13.5799 10.4047 13.5324 10.401 13.4849 10.4015C13.2961 10.4015 13.1472 10.4549 13.0427 10.5602C12.939 10.6648 12.8684 10.8241 12.833 11.0337L12.8202 11.1044H12.5832C12.5832 11.1044 12.5543 11.1032 12.5482 11.1348L12.5093 11.3518C12.5066 11.3726 12.5155 11.3856 12.5433 11.3854H12.774L12.5399 12.692C12.5216 12.7972 12.5006 12.8837 12.4774 12.9493C12.4545 13.0141 12.4321 13.0626 12.4046 13.0978C12.3779 13.1318 12.3527 13.1569 12.309 13.1716C12.273 13.1837 12.2316 13.1892 12.1862 13.1892C12.1609 13.1892 12.1273 13.185 12.1025 13.18C12.0777 13.1751 12.0648 13.1696 12.0462 13.1618C12.0462 13.1618 12.0191 13.1514 12.0085 13.1786C11.9998 13.2007 11.9383 13.3698 11.931 13.3907C11.9236 13.4114 11.934 13.4277 11.9471 13.4324C11.9778 13.4433 12.0007 13.4504 12.0425 13.4602C12.1006 13.4739 12.1496 13.4748 12.1954 13.4748C12.2915 13.4748 12.3791 13.4613 12.4517 13.4351C12.5247 13.4087 12.5883 13.3627 12.6446 13.3004C12.7054 13.2332 12.7436 13.1629 12.7802 13.0669C12.8164 12.9718 12.8473 12.8538 12.8719 12.7162L13.1071 11.3854H13.451C13.451 11.3854 13.48 11.3865 13.486 11.3551L13.5249 11.138C13.5276 11.1172 13.5187 11.1043 13.4908 11.1044H13.1571C13.1587 11.0969 13.1739 10.9795 13.2122 10.8689C13.2286 10.8218 13.2593 10.7837 13.2854 10.7576C13.3098 10.7327 13.3397 10.714 13.3728 10.7032C13.4091 10.692 13.4469 10.6865 13.4849 10.687C13.5163 10.687 13.5471 10.6908 13.5706 10.6957C13.603 10.7026 13.6156 10.7062 13.624 10.7087C13.6581 10.7191 13.6626 10.7091 13.6693 10.6926L13.7491 10.4734C13.7573 10.4498 13.7373 10.4399 13.7299 10.437ZM9.0662 12.6948C9.0662 12.7122 9.05376 12.7264 9.03629 12.7264H8.75947C8.74193 12.7264 8.72949 12.7122 8.72949 12.6948V10.4667C8.72949 10.4493 8.74193 10.4352 8.75947 10.4352H9.03629C9.05376 10.4352 9.0662 10.4493 9.0662 10.4667V12.6948Z",
                fill: "#FFFFFE"
            })
        ]
    });
};
var $c002cdcd98eda8d3$export$2e2bcd8739ae039 = $c002cdcd98eda8d3$var$SalesforceIcon;

});

parcelRegister("1m0Bz", function(module, exports) {

$parcel$export(module.exports, "default", () => $9335974b50c62609$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $9335974b50c62609$var$SentryIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-779.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.2634 5.12647C13.1313 4.90729 12.9448 4.72597 12.722 4.6001C12.4992 4.47423 12.2477 4.40808 11.9918 4.40808C11.7359 4.40808 11.4844 4.47423 11.2616 4.6001C11.0388 4.72597 10.8523 4.90729 10.7202 5.12647L8.62849 8.70913C10.2265 9.50694 11.588 10.7089 12.5779 12.1956C13.5677 13.6823 14.1514 15.4021 14.2711 17.1842H12.8024C12.683 15.6566 12.1667 14.1867 11.3047 12.9199C10.4427 11.6531 9.26492 10.6334 7.8878 9.96162L5.95183 13.309C6.726 13.6562 7.40046 14.1925 7.91318 14.8686C8.4259 15.5446 8.76042 16.3387 8.88598 17.1778H5.51314C5.47313 17.175 5.43447 17.1622 5.40062 17.1407C5.36677 17.1192 5.33881 17.0896 5.31926 17.0546C5.2997 17.0196 5.28917 16.9803 5.28861 16.9402C5.28805 16.9001 5.29747 16.8605 5.31604 16.8249L6.25065 15.2355C5.93401 14.9713 5.57212 14.7667 5.18253 14.6315L4.25746 16.2209C4.16115 16.3861 4.09863 16.5688 4.07353 16.7584C4.04842 16.9479 4.06124 17.1406 4.11122 17.3251C4.16121 17.5097 4.24737 17.6825 4.3647 17.8335C4.48203 17.9844 4.62819 18.1106 4.7947 18.2046C5.01407 18.3282 5.26134 18.3938 5.51314 18.3953H10.1321C10.2179 17.3368 10.0289 16.274 9.58332 15.3099C9.13777 14.3459 8.45081 13.5132 7.58898 12.8926L8.32331 11.621C9.41096 12.3681 10.285 13.3858 10.8592 14.5738C11.4334 15.7618 11.6879 17.0789 11.5976 18.3953H15.5109C15.602 16.4012 15.1682 14.418 14.2528 12.6441C13.3373 10.8701 11.9724 9.36748 10.2943 8.28633L11.7788 5.74318C11.8119 5.68775 11.8655 5.64764 11.928 5.63156C11.9906 5.61549 12.0569 5.62476 12.1126 5.65735C12.2811 5.74954 18.5627 16.7105 18.6803 16.8377C18.701 16.8748 18.7115 16.9168 18.7108 16.9593C18.7101 17.0019 18.6982 17.0435 18.6763 17.0799C18.6543 17.1164 18.6232 17.1464 18.5859 17.1669C18.5487 17.1874 18.5066 17.1978 18.4641 17.1969H16.9509C16.97 17.6017 16.97 18.0054 16.9509 18.4081H18.4705C18.6634 18.4093 18.8547 18.3723 19.0333 18.2991C19.2118 18.226 19.3741 18.1181 19.5107 17.9818C19.6473 17.8455 19.7554 17.6835 19.829 17.5051C19.9025 17.3267 19.94 17.1355 19.9391 16.9426C19.9393 16.6877 19.8713 16.4374 19.742 16.2178L13.2634 5.12647Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M13.273 5.71839C13.1399 5.49921 12.952 5.31788 12.7275 5.19201C12.503 5.06614 12.2495 5 11.9916 5C11.7338 5 11.4803 5.06614 11.2558 5.19201C11.0313 5.31788 10.8434 5.49921 10.7103 5.71839L8.60252 9.30104C10.2128 10.0989 11.5848 11.3008 12.5822 12.7875C13.5796 14.2742 14.1679 15.994 14.2884 17.7761H12.8085C12.6881 16.2485 12.1679 14.7786 11.2993 13.5118C10.4307 12.2451 9.24383 11.2253 7.85614 10.5535L5.90531 13.901C6.68543 14.2482 7.36506 14.7844 7.88171 15.4605C8.39837 16.1365 8.73546 16.9306 8.86199 17.7697H5.46325C5.42294 17.7669 5.38397 17.7542 5.34987 17.7326C5.31576 17.7111 5.28758 17.6815 5.26788 17.6465C5.24817 17.6115 5.23756 17.5722 5.23699 17.5321C5.23643 17.492 5.24593 17.4524 5.26464 17.4169L6.20642 15.8274C5.88735 15.5632 5.52269 15.3586 5.1301 15.2234L4.19793 16.8129C4.10089 16.978 4.03789 17.1607 4.01259 17.3503C3.98729 17.5398 4.0002 17.7325 4.05057 17.917C4.10094 18.1016 4.18776 18.2744 4.30599 18.4254C4.42423 18.5764 4.57151 18.7025 4.73929 18.7965C4.96035 18.9201 5.20952 18.9858 5.46325 18.9873H10.1177C10.2041 17.9287 10.0136 16.8659 9.56468 15.9018C9.11571 14.9378 8.42348 14.1051 7.55503 13.4845L8.295 12.2129C9.391 12.96 10.2718 13.9777 10.8504 15.1657C11.429 16.3537 11.6854 17.6709 11.5944 18.9873H15.5377C15.6296 16.9931 15.1924 15.01 14.27 13.236C13.3475 11.462 11.9721 9.9594 10.2811 8.87825L11.777 6.3351C11.8104 6.27967 11.8644 6.23956 11.9274 6.22348C11.9904 6.20741 12.0572 6.21667 12.1134 6.24927C12.2831 6.34146 18.6129 17.3024 18.7315 17.4296C18.7523 17.4667 18.763 17.5087 18.7623 17.5512C18.7616 17.5938 18.7495 17.6354 18.7274 17.6718C18.7053 17.7083 18.6739 17.7383 18.6364 17.7588C18.5988 17.7794 18.5565 17.7897 18.5136 17.7888H16.9889C17.0081 18.1936 17.0081 18.5973 16.9889 19H18.52C18.7145 19.0012 18.9072 18.9642 19.0872 18.8911C19.2671 18.8179 19.4306 18.71 19.5682 18.5737C19.7059 18.4375 19.8149 18.2754 19.889 18.097C19.9631 17.9186 20.0008 17.7274 20 17.5345C20.0002 17.2796 19.9316 17.0294 19.8014 16.8097L13.273 5.71839Z",
            fill: "#362D59"
        })
    });
};
var $9335974b50c62609$export$2e2bcd8739ae039 = $9335974b50c62609$var$SentryIcon;

});

parcelRegister("3zUD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c57db68586008b59$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $c57db68586008b59$var$SharePointIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-650.5",
                y: "-28.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#0B1228",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12.1863 13.1429C14.6523 13.1429 16.6514 11.0962 16.6514 8.57143C16.6514 6.0467 14.6523 4 12.1863 4C9.72029 4 7.72119 6.0467 7.72119 8.57143C7.72119 11.0962 9.72029 13.1429 12.1863 13.1429Z",
                        fill: "#036C70"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.907 16.9525C18.1675 16.9525 20 15.0763 20 12.762C20 10.4477 18.1675 8.57153 15.907 8.57153C13.6465 8.57153 11.814 10.4477 11.814 12.762C11.814 15.0763 13.6465 16.9525 15.907 16.9525Z",
                        fill: "#1A9BA1"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12.7443 20.0001C14.4911 20.0001 15.9071 18.5504 15.9071 16.762C15.9071 14.9737 14.4911 13.5239 12.7443 13.5239C10.9976 13.5239 9.58154 14.9737 9.58154 16.762C9.58154 18.5504 10.9976 20.0001 12.7443 20.0001Z",
                        fill: "#37C6D0"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.1",
                        d: "M12.9302 8.12585V16.2554C12.9283 16.5379 12.7611 16.7916 12.506 16.8992C12.4248 16.9344 12.3374 16.9525 12.2492 16.9525H9.58506C9.58134 16.8878 9.58134 16.8268 9.58134 16.762C9.5801 16.6984 9.58258 16.6348 9.58878 16.5716C9.65688 15.3538 10.3896 14.2794 11.4827 13.7944V13.0858C9.04996 12.6911 7.39032 10.3521 7.77583 7.86137C7.77851 7.84412 7.78127 7.82688 7.78414 7.80966C7.80266 7.68118 7.82876 7.55396 7.86228 7.42871H12.2493C12.6247 7.43017 12.9287 7.74144 12.9302 8.12585Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8772 7.80957H7.78421C7.37074 10.2958 9.00415 12.6544 11.4325 13.0777C11.5061 13.0906 11.5799 13.1015 11.654 13.1105C10.5005 13.6705 9.65993 15.261 9.58849 16.5715C9.5823 16.6348 9.57981 16.6984 9.58104 16.7619C9.58104 16.8267 9.58104 16.8877 9.58476 16.9524C9.59147 17.0805 9.60765 17.2078 9.63313 17.3334H11.8769C12.1528 17.3315 12.4006 17.1603 12.5057 16.8991C12.54 16.8159 12.5578 16.7265 12.5578 16.6362V8.50671C12.5564 8.12245 12.2526 7.81125 11.8772 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8772 7.80957H7.78418C7.37079 10.296 9.00445 12.6548 11.4331 13.078C11.4828 13.0867 11.5326 13.0945 11.5825 13.1014C10.4662 13.7018 9.65879 15.2884 9.58883 16.5715H11.8772C12.2521 16.5686 12.5553 16.2581 12.5581 15.8743V8.50671C12.5567 8.1223 12.2527 7.81103 11.8772 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.505 7.80957H7.78405C7.39371 10.1568 8.8303 12.4172 11.0845 13.0027C10.231 14.0012 9.70744 15.2502 9.58871 16.5715H11.505C11.8805 16.57 12.1845 16.2587 12.1859 15.8743V8.50671C12.1857 8.12178 11.881 7.80978 11.505 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M4.68205 7.80957H11.504C11.8807 7.80957 12.186 8.1222 12.186 8.50786V15.4922C12.186 15.8779 11.8807 16.1905 11.504 16.1905H4.68205C4.30536 16.1905 4 15.8779 4 15.4922V8.50786C4 8.1222 4.30536 7.80957 4.68205 7.80957Z",
                        fill: "#026D71"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.04621 11.9147C6.88638 11.8062 6.75286 11.6617 6.65588 11.4922C6.56192 11.3151 6.51508 11.1158 6.52007 10.9143C6.5117 10.6415 6.60162 10.3751 6.77272 10.1658C6.95251 9.95618 7.1849 9.80099 7.44472 9.717C7.74082 9.61722 8.05096 9.56805 8.36267 9.57148C8.77258 9.55614 9.18193 9.61482 9.57197 9.74481V10.621C9.40249 10.5159 9.21791 10.4388 9.02499 10.3924C8.81567 10.3399 8.60088 10.3135 8.38536 10.314C8.15809 10.3054 7.93227 10.3544 7.72787 10.4564C7.57007 10.5261 7.46774 10.6851 7.46741 10.861C7.46677 10.9677 7.50682 11.0705 7.57904 11.1475C7.66434 11.2382 7.76525 11.3121 7.87672 11.3654C8.00074 11.4286 8.18679 11.5127 8.43485 11.6176C8.46217 11.6264 8.48879 11.6374 8.51448 11.6504C8.75862 11.748 8.99415 11.867 9.21848 12.0058C9.38837 12.113 9.53095 12.26 9.63449 12.4347C9.74064 12.6328 9.79209 12.8566 9.78332 13.0824C9.79544 13.3624 9.71174 13.6381 9.54667 13.8618C9.38213 14.0674 9.16216 14.219 8.91411 14.2976C8.62236 14.3912 8.31786 14.4365 8.01215 14.4317C7.73787 14.433 7.46399 14.41 7.19355 14.3631C6.96521 14.3249 6.74237 14.2578 6.53011 14.1635V13.2397C6.733 13.388 6.95967 13.4989 7.19988 13.5673C7.43928 13.6437 7.68814 13.6845 7.93886 13.6884C8.17091 13.7035 8.40255 13.6532 8.60863 13.5429C8.75299 13.4595 8.84079 13.3015 8.83709 13.1319C8.83806 13.0138 8.79244 12.9004 8.71058 12.8172C8.60879 12.7149 8.49093 12.6308 8.36194 12.5684C8.2131 12.4922 7.99393 12.3918 7.70445 12.2671C7.47415 12.1723 7.25365 12.0543 7.04621 11.9147Z",
                        fill: "white"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_271_181641)",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                    clipPath: "url(#clip1_271_181641)",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M12.2328 13.4286C15.3153 13.4286 17.8142 10.8702 17.8142 7.71429C17.8142 4.55837 15.3153 2 12.2328 2C9.15024 2 6.65137 4.55837 6.65137 7.71429C6.65137 10.8702 9.15024 13.4286 12.2328 13.4286Z",
                            fill: "#036C70"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M16.8836 18.1906C19.7093 18.1906 21.9999 15.8454 21.9999 12.9525C21.9999 10.0595 19.7093 7.71436 16.8836 7.71436C14.058 7.71436 11.7673 10.0595 11.7673 12.9525C11.7673 15.8454 14.058 18.1906 16.8836 18.1906Z",
                            fill: "#1A9BA1"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M12.9303 22C15.1137 22 16.8838 20.1878 16.8838 17.9524C16.8838 15.717 15.1137 13.9048 12.9303 13.9048C10.7468 13.9048 8.97681 15.717 8.97681 17.9524C8.97681 20.1878 10.7468 22 12.9303 22Z",
                            fill: "#37C6D0"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            opacity: "0.1",
                            d: "M13.1628 7.15707V17.319C13.1605 17.6721 12.9515 17.9893 12.6326 18.1237C12.5311 18.1677 12.4219 18.1904 12.3117 18.1904H8.98144C8.9768 18.1094 8.9768 18.0333 8.9768 17.9523C8.97525 17.8728 8.97835 17.7933 8.9861 17.7142C9.07123 16.192 9.98715 14.849 11.3535 14.2428V13.3571C8.31257 12.8637 6.23802 9.93985 6.71991 6.82647C6.72326 6.8049 6.72671 6.78335 6.73029 6.76183C6.75344 6.60124 6.78607 6.44221 6.82797 6.28564H12.3117C12.781 6.28747 13.1611 6.67656 13.1628 7.15707Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.8464 6.76196H6.73014C6.2133 9.86973 8.25507 12.818 11.2906 13.3472C11.3825 13.3632 11.4748 13.3769 11.5673 13.3882C10.1255 14.0882 9.07479 16.0762 8.98549 17.7143C8.97775 17.7934 8.97463 17.8729 8.97618 17.9524C8.97618 18.0334 8.97618 18.1096 8.98083 18.1905C8.98922 18.3506 9.00944 18.5098 9.04129 18.6667H11.8459C12.1908 18.6644 12.5007 18.4504 12.632 18.1239C12.6749 18.0199 12.6971 17.9082 12.6971 17.7953V7.63339C12.6953 7.15306 12.3156 6.76406 11.8464 6.76196Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.8466 6.76196H6.73034C6.21361 9.87002 8.25569 12.8185 11.2915 13.3475C11.3536 13.3583 11.4158 13.3681 11.4783 13.3767C10.0829 14.1272 9.07361 16.1105 8.98616 17.7143H11.8466C12.3152 17.7107 12.6942 17.3227 12.6978 16.8429V7.63339C12.696 7.15288 12.316 6.76379 11.8466 6.76196Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.3814 6.76196H6.73019C6.24226 9.696 8.03799 12.5215 10.8558 13.2534C9.78883 14.5014 9.13442 16.0628 8.98601 17.7143H11.3814C11.8507 17.7125 12.2307 17.3234 12.2325 16.8429V7.63339C12.2323 7.15223 11.8513 6.76223 11.3814 6.76196Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M2.85256 6.76196H11.38C11.8509 6.76196 12.2326 7.15275 12.2326 7.63482V16.3653C12.2326 16.8474 11.8509 17.2382 11.38 17.2382H2.85256C2.3817 17.2382 2 16.8474 2 16.3653V7.63482C2 7.15275 2.3817 6.76196 2.85256 6.76196Z",
                            fill: "#04868B"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M5.80776 11.8932C5.60797 11.7575 5.44108 11.5769 5.31985 11.3651C5.20239 11.1437 5.14385 10.8946 5.15008 10.6427C5.13962 10.3017 5.25202 9.96868 5.46589 9.70702C5.69064 9.44505 5.98113 9.25105 6.30589 9.14606C6.67602 9.02134 7.0637 8.95988 7.45333 8.96416C7.96573 8.945 8.47741 9.01835 8.96496 9.18083V10.2761C8.75312 10.1447 8.52238 10.0483 8.28124 9.99036C8.01958 9.92467 7.7511 9.89173 7.4817 9.89226C7.19761 9.88158 6.91534 9.94276 6.65984 10.0704C6.46259 10.1575 6.33467 10.3561 6.33426 10.5761C6.33346 10.7095 6.38352 10.838 6.4738 10.9342C6.58043 11.0476 6.70656 11.1399 6.84589 11.2066C7.00093 11.2856 7.23349 11.3907 7.54357 11.5218C7.57771 11.5328 7.61099 11.5465 7.6431 11.5628C7.94828 11.6849 8.24269 11.8335 8.5231 12.007C8.73546 12.1411 8.91368 12.3249 9.04311 12.5432C9.1758 12.7908 9.24011 13.0706 9.22915 13.3528C9.2443 13.7029 9.13968 14.0474 8.93334 14.327C8.72767 14.5841 8.45269 14.7736 8.14264 14.8718C7.77795 14.9888 7.39733 15.0454 7.01519 15.0394C6.67234 15.041 6.32999 15.0123 5.99194 14.9537C5.70651 14.9059 5.42796 14.8221 5.16264 14.7042V13.5494C5.41625 13.7349 5.69959 13.8735 5.99985 13.9589C6.2991 14.0544 6.61017 14.1054 6.92357 14.1104C7.21363 14.1292 7.50318 14.0663 7.76078 13.9285C7.94123 13.8242 8.05098 13.6267 8.04637 13.4147C8.04757 13.2671 7.99055 13.1253 7.88823 13.0213C7.76098 12.8934 7.61366 12.7883 7.45242 12.7104C7.26638 12.6151 6.99242 12.4896 6.63056 12.3337C6.34269 12.2152 6.06706 12.0677 5.80776 11.8932Z",
                            fill: "white"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_271_181641",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "20",
                            height: "20",
                            fill: "white",
                            transform: "translate(2 2)"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip1_271_181641",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "20",
                            height: "20",
                            fill: "white",
                            transform: "translate(2 2)"
                        })
                    })
                ]
            })
        ]
    });
};
var $c57db68586008b59$export$2e2bcd8739ae039 = $c57db68586008b59$var$SharePointIcon;

});

parcelRegister("gHwiN", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59be1161c1b0258$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $f59be1161c1b0258$var$SlackIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-603.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.71235 13.9487C7.71235 14.8109 7.0155 15.5078 6.15329 15.5078C5.29109 15.5078 4.59424 14.8109 4.59424 13.9487C4.59424 13.0865 5.29109 12.3896 6.15329 12.3896H7.71235V13.9487ZM8.49188 13.9487C8.49188 13.0865 9.18873 12.3896 10.0509 12.3896C10.9131 12.3896 11.61 13.0865 11.61 13.9487V17.8463C11.61 18.7085 10.9131 19.4054 10.0509 19.4054C9.18873 19.4054 8.49188 18.7085 8.49188 17.8463V13.9487Z",
                        fill: "#E01E5A"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M10.051 7.68879C9.18882 7.68879 8.49197 6.99194 8.49197 6.12973C8.49197 5.26753 9.18882 4.57068 10.051 4.57068C10.9132 4.57068 11.6101 5.26753 11.6101 6.12973V7.68879H10.051ZM10.051 8.48013C10.9132 8.48013 11.6101 9.17698 11.6101 10.0392C11.6101 10.9014 10.9132 11.5982 10.051 11.5982H6.14157C5.27937 11.5982 4.58252 10.9014 4.58252 10.0392C4.58252 9.17698 5.27937 8.48013 6.14157 8.48013H10.051Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M16.299 10.0392C16.299 9.17698 16.9959 8.48013 17.8581 8.48013C18.7203 8.48013 19.4171 9.17698 19.4171 10.0392C19.4171 10.9014 18.7203 11.5982 17.8581 11.5982H16.299V10.0392ZM15.5195 10.0392C15.5195 10.9014 14.8226 11.5982 13.9604 11.5982C13.0982 11.5982 12.4014 10.9014 12.4014 10.0392V6.12973C12.4014 5.26753 13.0982 4.57068 13.9604 4.57068C14.8226 4.57068 15.5195 5.26753 15.5195 6.12973V10.0392Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M13.9604 16.2873C14.8226 16.2873 15.5195 16.9841 15.5195 17.8463C15.5195 18.7085 14.8226 19.4054 13.9604 19.4054C13.0982 19.4054 12.4014 18.7085 12.4014 17.8463V16.2873H13.9604ZM13.9604 15.5078C13.0982 15.5078 12.4014 14.8109 12.4014 13.9487C12.4014 13.0865 13.0982 12.3896 13.9604 12.3896H17.8699C18.7321 12.3896 19.4289 13.0865 19.4289 13.9487C19.4289 14.8109 18.7321 15.5078 17.8699 15.5078H13.9604Z",
                        fill: "#ECB22E"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_271_181639)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
                        fill: "#ECB22E"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
                        fill: "#E01E5A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_271_181639",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
};
var $f59be1161c1b0258$export$2e2bcd8739ae039 = $f59be1161c1b0258$var$SlackIcon;

});

parcelRegister("b15lm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d739a59c58974af2$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $d739a59c58974af2$var$SmartsheetIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-171.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.2708 12.9524C12.0781 12.5707 11.8938 12.2011 11.6762 11.8499C11.4003 11.4042 11.1009 10.9773 10.6919 10.6414C10.3847 10.3891 10.0444 10.2293 9.63382 10.2899C9.27961 10.3422 8.99393 10.5287 8.73676 10.7652C8.60099 10.8901 8.47697 11.0271 8.36318 11.1923C8.42475 11.2006 8.47588 11.2054 8.52636 11.2146C8.8921 11.2813 9.17343 11.4943 9.4269 11.7487C9.85292 12.1767 10.1699 12.6838 10.4539 13.2121C11.0905 14.3964 11.5574 15.6505 11.9569 16.9316C11.9608 16.944 11.9643 16.9564 11.9732 16.9859C13.5754 13.1534 15.383 9.45358 17.8734 6.12915L17.9021 6.13874C17.9021 6.22486 17.9021 6.31098 17.9021 6.39688C17.9021 9.19064 17.9052 11.9844 17.9002 14.7784C17.8986 15.6202 17.8858 16.4624 17.8233 17.3027C17.8027 17.5811 17.7742 17.8593 17.6754 18.1242C17.5601 18.4333 17.3395 18.5127 17.0594 18.338C16.8218 18.1898 16.6373 17.9825 16.4822 17.754C16.1504 17.2654 15.831 16.7687 15.6093 16.2167C15.5952 16.1814 15.5917 16.1009 15.5142 16.1761C15.009 16.6673 14.4222 17.0471 13.8187 17.4003C12.0839 18.4152 10.2293 19.1317 8.28355 19.6187C7.58535 19.7934 6.88193 19.9416 6.1735 20.0672C6.10497 20.0794 6.08734 20.0753 6.10192 19.997C6.19656 19.4857 6.23986 18.9697 6.23986 18.449C6.23856 14.0349 6.23964 9.6208 6.23638 5.20669C6.23638 5.09615 6.26314 5.07239 6.37128 5.07239C10.1708 5.07544 13.9701 5.075 17.7696 5.075H17.9017C15.5708 7.38279 13.6026 9.93061 12.2715 12.9526L12.2708 12.9524Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M12.2752 13.0096C12.0792 12.6216 11.8919 12.246 11.6708 11.8889C11.3903 11.436 11.086 11.0021 10.6703 10.6606C10.358 10.4042 10.0121 10.2417 9.59481 10.3033C9.23477 10.3565 8.9444 10.546 8.68299 10.7864C8.54499 10.9134 8.41894 11.0526 8.30327 11.2206C8.36586 11.229 8.41783 11.2339 8.46914 11.2432C8.8409 11.311 9.12685 11.5275 9.38449 11.7861C9.81751 12.2211 10.1397 12.7366 10.4283 13.2736C11.0754 14.4773 11.55 15.752 11.9561 17.0542C11.96 17.0668 11.9636 17.0795 11.9726 17.1094C13.6012 13.2139 15.4386 9.45323 17.9699 6.07414L17.9991 6.08389C17.9991 6.17142 17.9991 6.25896 17.9991 6.34627C17.9991 9.18597 18.0022 12.0257 17.9971 14.8656C17.9955 15.7212 17.9825 16.5773 17.919 17.4314C17.898 17.7144 17.869 17.9971 17.7686 18.2664C17.6514 18.5806 17.4272 18.6613 17.1425 18.4838C16.901 18.3331 16.7135 18.1224 16.5558 17.8901C16.2186 17.3935 15.8939 16.8887 15.6686 16.3275C15.6542 16.2916 15.6506 16.2099 15.5719 16.2863C15.0584 16.7856 14.4619 17.1717 13.8485 17.5307C12.0852 18.5623 10.2001 19.2905 8.22233 19.7855C7.51265 19.963 6.79766 20.1137 6.07759 20.2414C6.00793 20.2538 5.99001 20.2496 6.00483 20.17C6.10103 19.6504 6.14504 19.1258 6.14504 18.5966C6.14371 14.1099 6.14482 9.62321 6.1415 5.13651C6.1415 5.02415 6.1687 5 6.27862 5C10.1406 5.0031 14.0024 5.00266 17.8644 5.00266H17.9986C15.6294 7.34839 13.6289 9.93811 12.2758 13.0098L12.2752 13.0096Z",
            fill: "#143158"
        })
    });
};
var $d739a59c58974af2$export$2e2bcd8739ae039 = $d739a59c58974af2$var$SmartsheetIcon;

});

parcelRegister("iFEkd", function(module, exports) {

$parcel$export(module.exports, "default", () => $9affea886ceab4a6$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $9affea886ceab4a6$var$StripeIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#635BFF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.0639 9.32966C11.0639 8.76566 11.5259 8.54366 12.2939 8.54366C13.3979 8.54366 14.7899 8.87966 15.8939 9.47366V6.06566C14.6879 5.58566 13.4999 5.39966 12.2999 5.39966C9.35395 5.39966 7.39795 6.93566 7.39795 9.50366C7.39795 13.5057 12.9119 12.8697 12.9119 14.5977C12.9119 15.2637 12.3299 15.4797 11.5199 15.4797C10.3139 15.4797 8.77795 14.9877 7.55995 14.3217V17.7717C8.90995 18.3537 10.2719 18.5997 11.5199 18.5997C14.5379 18.5997 16.6139 17.1057 16.6139 14.5077C16.5899 10.1877 11.0639 10.9557 11.0639 9.32966Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5 5H19V19H5V5Z",
                fill: "#635BFF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4541 10.4422C11.4541 10.1132 11.7236 9.98366 12.1716 9.98366C12.8156 9.98366 13.6276 10.1797 14.2716 10.5262V8.53816C13.5681 8.25816 12.8751 8.14966 12.1751 8.14966C10.4566 8.14966 9.31555 9.04566 9.31555 10.5437C9.31555 12.8782 12.5321 12.5072 12.5321 13.5152C12.5321 13.9037 12.1926 14.0297 11.7201 14.0297C11.0166 14.0297 10.1206 13.7427 9.41005 13.3542V15.3667C10.1976 15.7062 10.9921 15.8497 11.7201 15.8497C13.4806 15.8497 14.6916 14.9782 14.6916 13.4627C14.6776 10.9427 11.4541 11.3907 11.4541 10.4422Z",
                fill: "white"
            })
        ]
    });
};
var $9affea886ceab4a6$export$2e2bcd8739ae039 = $9affea886ceab4a6$var$StripeIcon;

});

parcelRegister("9o6kx", function(module, exports) {

$parcel$export(module.exports, "default", () => $21498f2ed987f6e9$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $21498f2ed987f6e9$var$TeamsIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-506.5",
                y: "-603.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.4626 10.3286H18.3371C18.7032 10.3286 18.9999 10.6308 18.9999 11.0036V14.5978C18.9999 15.9679 17.9093 17.0786 16.564 17.0786H16.5525C15.2072 17.0788 14.1164 15.9682 14.1162 14.5981C14.1162 14.598 14.1162 14.5979 14.1162 14.5978V10.6814C14.1162 10.4866 14.2713 10.3286 14.4626 10.3286Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.0815 9.61849C17.9484 9.61849 18.6512 8.90274 18.6512 8.01982C18.6512 7.13689 17.9484 6.42114 17.0815 6.42114C16.2145 6.42114 15.5117 7.13689 15.5117 8.01982C15.5117 8.90274 16.2145 9.61849 17.0815 9.61849Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.1976 9.61839C13.4499 9.61839 14.465 8.58453 14.465 7.3092C14.465 6.03386 13.4499 5 12.1976 5C10.9453 5 9.93018 6.03386 9.93018 7.3092C9.93018 8.58453 10.9453 9.61839 12.1976 9.61839Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.2211 10.3286H8.82556C8.46387 10.3377 8.17775 10.6434 8.18614 11.0118V15.1111C8.13564 17.3217 9.85286 19.156 12.0233 19.2101C14.1938 19.156 15.911 17.3217 15.8605 15.1111V11.0118C15.8689 10.6434 15.5828 10.3377 15.2211 10.3286Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.1",
                d: "M12.3718 10.3286V16.0732C12.37 16.3366 12.2133 16.5733 11.9741 16.6736C11.8979 16.7064 11.8161 16.7233 11.7334 16.7233H8.49271C8.44736 16.6061 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.3718Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M12.0229 10.3286V16.4284C12.0229 16.5127 12.0063 16.596 11.9741 16.6736C11.8756 16.9172 11.6432 17.0768 11.3846 17.0786H8.65666C8.59736 16.9613 8.54154 16.8441 8.49271 16.7233C8.44387 16.6025 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M12.0229 10.3286V15.7179C12.0203 16.0759 11.736 16.3653 11.3845 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M11.6741 10.3286V15.7179C11.6714 16.0759 11.3872 16.3653 11.0357 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H11.6741Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.1",
                d: "M12.3722 8.49216V9.61123C12.3129 9.61478 12.2571 9.61834 12.1978 9.61834C12.1385 9.61834 12.0827 9.61479 12.0234 9.61123C11.9056 9.60328 11.7889 9.58425 11.6746 9.55439C10.9682 9.38403 10.3846 8.8795 10.1048 8.1973C10.0567 8.08274 10.0193 7.96378 9.99316 7.84204H11.7338C12.0859 7.8434 12.3709 8.13367 12.3722 8.49216Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M11.6742 8.84739V9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.0359C11.3879 8.19863 11.6729 8.48891 11.6742 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M4.63941 8.19727H11.0349C11.3881 8.19727 11.6744 8.48882 11.6744 8.84846V15.3618C11.6744 15.7214 11.3881 16.013 11.0349 16.013H4.63941C4.28627 16.013 4 15.7214 4 15.3618V8.84846C4 8.48882 4.28628 8.19727 4.63941 8.19727Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.51986 10.6761H8.24137V14.2216H7.42685V10.6761H6.1543V9.98828H9.51986V10.6761Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "1 1 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_3561_46629)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.0321 10H19.4879C19.9088 10 20.2501 10.3403 20.2501 10.76V14.8068C20.2501 16.3494 18.9959 17.6 17.4488 17.6H17.4355C15.8884 17.6002 14.634 16.3498 14.6338 14.8072C14.6338 14.8071 14.6338 14.8069 14.6338 14.8068V10.3972C14.6338 10.1778 14.8121 10 15.0321 10Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.0435 9.19961C19.0405 9.19961 19.8487 8.39372 19.8487 7.39961C19.8487 6.4055 19.0405 5.59961 18.0435 5.59961C17.0465 5.59961 16.2383 6.4055 16.2383 7.39961C16.2383 8.39372 17.0465 9.19961 18.0435 9.19961Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12.4274 9.20001C13.8675 9.20001 15.0349 8.03594 15.0349 6.6C15.0349 5.16406 13.8675 4 12.4274 4C10.9873 4 9.81982 5.16406 9.81982 6.6C9.81982 8.03594 10.9873 9.20001 12.4274 9.20001Z",
                        fill: "#7B83EB"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.904 10H8.54908C8.13313 10.0103 7.8041 10.3545 7.81375 10.7692V15.3848C7.75566 17.8737 9.73048 19.9391 12.2265 20C14.7226 19.9391 16.6974 17.8737 16.6393 15.3848V10.7692C16.649 10.3545 16.3199 10.0103 15.904 10Z",
                        fill: "#7B83EB"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.1",
                        d: "M12.6276 10V16.468C12.6256 16.7646 12.4454 17.0311 12.1703 17.144C12.0827 17.1809 11.9886 17.2 11.8935 17.2H8.16671C8.11456 17.068 8.06642 16.936 8.0263 16.8C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.6276Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2265 10V16.868C12.2265 16.9628 12.2074 17.0567 12.1703 17.144C12.0571 17.4183 11.7898 17.598 11.4924 17.6H8.35526C8.28706 17.468 8.22288 17.336 8.16671 17.2C8.11055 17.064 8.06642 16.936 8.0263 16.8C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.2265Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2265 10V16.068C12.2234 16.471 11.8965 16.797 11.4923 16.8H8.0263C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.2265Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8253 10V16.068C11.8223 16.471 11.4954 16.797 11.0912 16.8H8.0263C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H11.8253Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.1",
                        d: "M12.628 7.93121V9.19121C12.5598 9.19521 12.4956 9.19921 12.4274 9.19921C12.3592 9.19921 12.2951 9.19522 12.2269 9.19121C12.0914 9.18225 11.9572 9.16083 11.8257 9.12721C11.0133 8.93539 10.3422 8.36732 10.0205 7.59922C9.9651 7.47023 9.92213 7.33629 9.89209 7.19922H11.8939C12.2987 7.20075 12.6265 7.52757 12.628 7.93121Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2269 8.3316V9.1916C12.0915 9.18264 11.9572 9.16122 11.8257 9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.4928C11.8976 7.60114 12.2254 7.92797 12.2269 8.3316Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2269 8.3316V9.1916C12.0915 9.18264 11.9572 9.16122 11.8257 9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.4928C11.8976 7.60114 12.2254 7.92797 12.2269 8.3316Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8257 8.33161V9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.0916C11.4964 7.60115 11.8242 7.92798 11.8257 8.33161Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M3.73533 7.59961H11.0902C11.4964 7.59961 11.8256 7.92788 11.8256 8.33281V15.6664C11.8256 16.0713 11.4963 16.3996 11.0902 16.3996H3.73533C3.32921 16.3996 3 16.0713 3 15.6664V8.33281C3 7.92788 3.32922 7.59961 3.73533 7.59961Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M9.34796 10.3916H7.87769V14.3836H6.94098V10.3916H5.47754V9.61719H9.34796V10.3916Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_3561_46629",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "17.25",
                        height: "16",
                        fill: "white",
                        transform: "translate(3 4)"
                    })
                })
            })
        ]
    });
};
var $21498f2ed987f6e9$export$2e2bcd8739ae039 = $21498f2ed987f6e9$var$TeamsIcon;

});

parcelRegister("cegaR", function(module, exports) {

$parcel$export(module.exports, "default", () => $31f411dca8ce7b46$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $31f411dca8ce7b46$var$TodoistIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-731.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.7653 5.01575H7.2667C6.03236 5.01575 5.03174 6.01638 5.03174 7.25072V16.7493C5.03174 17.9837 6.03236 18.9843 7.2667 18.9843H16.7653C17.9996 18.9843 19.0002 17.9837 19.0002 16.7493V7.25072C19.0002 6.01638 17.9996 5.01575 16.7653 5.01575Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.98402 11.5604L10.7664 9.9593L10.7699 9.95712L13.6369 8.30708C13.7578 8.23724 13.7635 8.02335 13.6282 7.94565L13.5334 7.89152C13.3951 7.81295 13.2161 7.7108 13.1397 7.66628C13.0728 7.62983 12.9976 7.61118 12.9214 7.61209C12.8452 7.61301 12.7705 7.63347 12.7045 7.67151C12.6368 7.7108 8.12065 10.3072 7.96961 10.3932C7.88062 10.4441 7.77988 10.4708 7.67737 10.4708C7.57485 10.4708 7.47412 10.4441 7.38512 10.3932L5 9.00726V10.1854L5.02444 10.1994C5.61985 10.5464 7.02892 11.3671 7.37377 11.5613C7.58286 11.6792 7.78278 11.6766 7.98402 11.5604Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.98402 13.9142L10.7629 12.3148L10.7734 12.3087L13.6369 10.6608C13.7578 10.591 13.7635 10.3767 13.6282 10.2994L13.5334 10.2453C13.3955 10.1667 13.2161 10.0646 13.1397 10.02C13.0728 9.98359 12.9976 9.96494 12.9214 9.96585C12.8452 9.96677 12.7705 9.98723 12.7045 10.0253C12.6368 10.0641 8.12065 12.661 7.96961 12.7465C7.88062 12.7974 7.77988 12.8242 7.67737 12.8242C7.57485 12.8242 7.47412 12.7974 7.38512 12.7465C7.24282 12.6645 5 11.361 5 11.361V12.5387L5.02444 12.5531C5.62029 12.9002 7.02892 13.7204 7.37377 13.9151C7.58286 14.0329 7.78278 14.0303 7.98402 13.9142Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.7668 14.6663L7.98402 16.2679C7.78279 16.384 7.58242 16.3866 7.37377 16.2688C7.02892 16.0741 5.62029 15.2539 5.02444 14.9069L5 14.8924V13.7147L7.38512 15.1002C7.5654 15.2046 7.7889 15.2032 7.96961 15.1002C8.12065 15.0147 12.6368 12.4178 12.7045 12.3785C12.7705 12.3405 12.8452 12.32 12.9214 12.3191C12.9976 12.3182 13.0728 12.3369 13.1397 12.3733C13.3022 12.4673 13.4652 12.5604 13.6286 12.6527C13.7639 12.7304 13.7578 12.9447 13.6369 13.0146L10.7668 14.6663Z",
                fill: "#DE483A"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.4458 4H6.59025C5.17958 4 4.03601 5.14358 4.03601 6.55425V17.4098C4.03601 18.8205 5.17958 19.9641 6.59025 19.9641H17.4458C18.8564 19.9641 20 18.8205 20 17.4098V6.55425C20 5.14358 18.8564 4 17.4458 4Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.41031 11.4797L10.5901 9.64985L10.5941 9.64735L13.8707 7.7616C14.0089 7.68178 14.0154 7.43733 13.8608 7.34853L13.7525 7.28667C13.5944 7.19687 13.3898 7.08013 13.3025 7.02924C13.226 6.9876 13.1401 6.96627 13.053 6.96732C12.966 6.96837 12.8806 6.99175 12.8051 7.03523C12.7278 7.08013 7.56645 10.0475 7.39384 10.1457C7.29213 10.2039 7.17701 10.2345 7.05985 10.2345C6.94269 10.2345 6.82756 10.2039 6.72585 10.1457L4 8.5618V9.90827L4.02794 9.92423C4.7084 10.3208 6.31877 11.2587 6.71288 11.4807C6.95184 11.6154 7.18033 11.6124 7.41031 11.4797Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.41031 14.1697L10.5861 12.3418L10.5981 12.3348L13.8707 10.4515C14.0089 10.3717 14.0154 10.1268 13.8608 10.0385L13.7525 9.97661C13.5949 9.88681 13.3898 9.77007 13.3025 9.71919C13.226 9.67754 13.1401 9.65622 13.053 9.65726C12.966 9.65831 12.8806 9.68169 12.8051 9.72517C12.7278 9.76957 7.56645 12.7374 7.39384 12.8352C7.29213 12.8933 7.17701 12.9239 7.05985 12.9239C6.94269 12.9239 6.82756 12.8933 6.72585 12.8352C6.56322 12.7414 4 11.2517 4 11.2517V12.5977L4.02794 12.6142C4.7089 13.0108 6.31877 13.9482 6.71288 14.1707C6.95184 14.3054 7.18033 14.3024 7.41031 14.1697Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.5906 15.0292L7.41031 16.8596C7.18033 16.9923 6.95134 16.9953 6.71288 16.8606C6.31877 16.6381 4.7089 15.7007 4.02794 15.3041L4 15.2877V13.9417L6.72585 15.5251C6.93189 15.6444 7.18731 15.6429 7.39384 15.5251C7.56645 15.4273 12.7278 12.4595 12.8051 12.4146C12.8806 12.3711 12.966 12.3478 13.053 12.3467C13.1401 12.3457 13.226 12.367 13.3025 12.4086C13.4882 12.516 13.6745 12.6225 13.8613 12.7279C14.0159 12.8167 14.0089 13.0617 13.8707 13.1415L10.5906 15.0292Z",
                fill: "white"
            })
        ]
    });
};
var $31f411dca8ce7b46$export$2e2bcd8739ae039 = $31f411dca8ce7b46$var$TodoistIcon;

});

parcelRegister("3aDJv", function(module, exports) {

$parcel$export(module.exports, "default", () => $80a9ca5eb54c4f1b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $80a9ca5eb54c4f1b$var$WebexIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-554.5",
                y: "-363.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                id: "mask0_719_13847",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "6",
                width: "18",
                height: "13",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M20.5 6.177H3.5V18.551H20.5V6.177Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                mask: "url(#mask0_719_13847)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.77473 18.5019C5.62694 18.5019 4.55554 14.5209 4.31548 13.7465C3.71261 11.8018 3.52935 10.05 3.50994 9.86618C3.39799 8.80539 4.24877 8.06718 5.18252 8.06718C5.8895 8.06718 6.71005 8.49041 6.81877 9.51726C6.83761 9.68995 6.98136 11.1795 7.48984 12.8026C8.02049 14.4964 8.58341 15.1479 8.98879 15.1479C9.64347 15.1479 10.0429 13.4664 10.396 11.8653C10.6562 10.6857 10.9374 9.49712 11.4926 8.44128C12.4585 6.60445 13.9181 6.177 15.1791 6.177C17.944 6.177 19.3278 9.38049 19.3278 10.2105C19.3278 11.5975 18.1965 11.9513 17.7062 11.9513C16.6338 11.9513 16.2703 11.2327 15.9643 10.6029C15.689 10.0363 15.4016 9.56515 15.0299 9.56515C14.9078 9.56515 14.7946 9.62698 14.69 9.73341C13.7662 10.6723 13.4565 15.584 11.6095 17.4612C10.5856 18.5019 9.47152 18.5019 8.77473 18.5019Z",
                        fill: "#00BBFF"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.8181 8.06718C18.6934 8.06718 18.5681 8.07894 18.4451 8.1032C19.0296 8.94596 19.3221 9.82891 19.3221 10.2104C19.3221 11.5975 18.1907 11.9512 17.7004 11.9512C17.3178 11.9512 17.0254 11.8597 16.7937 11.7134C16.7916 11.7221 16.7895 11.7307 16.7873 11.7394C16.7184 12.0147 16.664 12.3159 16.5698 12.6092C16.3888 13.1729 16.1446 13.8168 15.8839 14.3151C15.6028 14.8523 15.3246 15.1666 14.9929 15.1501C14.6157 15.1314 14.3099 14.6452 13.9298 13.2711C13.8072 12.8281 13.6937 12.3423 13.5885 11.8653C13.3276 10.6822 13.0074 9.49254 12.4598 8.44128C11.5653 6.72426 10.0396 6.177 8.82156 6.177C7.69192 6.177 6.84795 6.71182 6.18495 7.3857C6.00175 7.57192 5.80158 7.82283 5.60059 8.11766C6.17886 8.25694 6.72565 8.69224 6.81293 9.51716C6.83015 9.67444 6.95085 10.9237 7.35628 12.3714C7.4726 12.0084 7.64222 11.4709 8.03625 10.6029C8.22939 10.2054 8.40369 9.94325 8.56092 9.78348C8.70514 9.63686 8.83499 9.57634 8.95193 9.57634C9.07804 9.57634 9.50861 9.69177 9.92778 11.1628C10.4477 12.9869 10.8346 15.8898 12.3086 17.4312C12.9587 18.1111 13.8685 18.551 15.1294 18.551C16.2358 18.551 17.1582 18.0637 17.8159 17.3859C18.8973 16.2712 19.4898 14.4284 19.7011 13.7465C20.3026 11.8064 20.4711 10.0518 20.4907 9.86618C20.6026 8.80539 19.709 8.06718 18.8181 8.06718Z",
                        fill: "#316AFF"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                id: "mask0_647_117",
                maskUnits: "userSpaceOnUse",
                x: "4",
                y: "6",
                width: "16",
                height: "12",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M20 6H4V17.6461H20V6Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                mask: "url(#mask0_647_117)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint0_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint1_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint2_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint3_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint4_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint5_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint6_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint7_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint8_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.9922 6C13.8054 6 12.4317 6.4023 11.5225 8.13109C11 9.12482 10.7353 10.2435 10.4905 11.3537C10.4099 11.719 10.3267 12.0888 10.2382 12.4394V17.4624C10.6873 17.3353 11.1697 17.0908 11.6326 16.6205C13.3709 14.8536 13.6625 10.2308 14.5319 9.34721C14.6303 9.24703 14.7369 9.18884 14.8518 9.18884C15.2016 9.18884 15.4722 9.63224 15.7312 10.1655C16.0192 10.7583 16.3613 11.4346 17.3707 11.4346C17.8322 11.4346 18.8969 11.1017 18.8969 9.79624C18.8969 9.01505 17.5945 6 14.9922 6Z",
                        fill: "url(#paint9_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint10_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint11_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint12_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint13_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint14_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "#316AFF"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint15_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint16_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint17_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint18_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint19_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint20_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint21_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint22_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint23_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint24_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint25_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint26_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint27_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint28_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint29_radial_647_117)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint0_linear_647_117",
                        x1: "17.2757",
                        y1: "9.40344",
                        x2: "6.80986",
                        y2: "12.8357",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#5CEE64"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00BBFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint1_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(10.09 12.186) rotate(-120.86) scale(6.85625 5.75574)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#007383"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.407867",
                                stopColor: "#00717E",
                                stopOpacity: "0.75"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.874482",
                                stopColor: "#007281",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint2_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(14.5948 10.9103) rotate(-126.734) scale(5.59154 3.67393)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#218970"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.459527",
                                stopColor: "#267E6A"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#026C51",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint3_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(9.6952 12.5099) rotate(-107.468) scale(4.554 2.37251)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#178697"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.407867",
                                stopColor: "#17838F",
                                stopOpacity: "0.79"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.874482",
                                stopColor: "#007281",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint4_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(11.7199 12.4856) rotate(-120.86) scale(11.5648 3.56733)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#25342F",
                                stopOpacity: "0.3"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#25342F",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint5_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(13.7828 11.0371) rotate(85.0979) scale(4.35562 2.47045)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#056D4F"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.232593",
                                stopColor: "#056C4E",
                                stopOpacity: "0.75"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.598902",
                                stopColor: "#056C4E",
                                stopOpacity: "0.300824"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.874482",
                                stopColor: "#056C4F",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint6_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(13.9754 3.99288) rotate(57.0774) scale(5.12012 2.6855)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#22B67B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.407867",
                                stopColor: "#24BE82"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#24BE82",
                                stopOpacity: "0.07"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint7_linear_647_117",
                        x1: "0.0633092",
                        y1: "11.6988",
                        x2: "7.4802",
                        y2: "11.7598",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#09F8FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint8_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(1.65669 5.0183) rotate(49.6506) scale(6.68716 6.67046)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#09F8FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint9_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.01337 1.6515) rotate(48.0118) scale(13.5629 13.5415)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00B8FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.745423",
                                stopColor: "#00B9FC",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint10_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.73139 11.8243) rotate(-107.468) scale(6.53747 4.52974)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00BCFF",
                                stopOpacity: "0.76"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.57273",
                                stopColor: "#00BAFC",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint11_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.6701 9.34133) rotate(-129.551) scale(4.62291 3.23649)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#5FEC50"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#3CC08E",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint12_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.0084 12.3189) rotate(-79.0944) scale(1.39957 0.968007)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#28855B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#14795C",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint13_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.941 12.2159) rotate(-77.8798) scale(1.15379 1.61246)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#28855B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#14795C",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint14_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(18.3155 10.1373) rotate(-132.79) scale(3.82739 2.68878)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#5FF05B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.813285",
                                stopColor: "#5DE955",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint15_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.1186 11.2367) rotate(37.4559) scale(3.40381 4.73123)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.966119",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint16_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.2718 11.6203) rotate(8.48611) scale(4.01618 5.99473)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.592487",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint17_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.5977 12.1185) rotate(24.6631) scale(3.43068 6.11312)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.756788",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint18_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.1948 12.3217) rotate(95.8028) scale(6.16725 3.37972)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.592487",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint19_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.1186 9.59893) rotate(93.6671) scale(7.42211 2.64877)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.884611",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint20_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(8.70726 11.1422) rotate(84.8296) scale(3.93849 2.08658)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.884611",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint21_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(8.70442 11.2481) rotate(87.2504) scale(4.11044 3.39354)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.884611",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint22_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(9.63961 15.1104) rotate(-23.1725) scale(4.58388 8.95991)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.708977",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint23_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(8.00865 10.2431) rotate(-159.526) scale(3.03689 5.19997)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#1A3DA0"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.708977",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint24_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(5.33541 11.2767) rotate(16.749) scale(5.79218 5.84719)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#1E3882"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.761404",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint25_linear_647_117",
                        x1: "3.51831",
                        y1: "8.07299",
                        x2: "9.22598",
                        y2: "11.7159",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.229329",
                                stopColor: "#1DC4FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1CC1FF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint26_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(1.65635 5.01803) rotate(49.6506) scale(6.68716 6.67046)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#09F8FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint27_linear_647_117",
                        x1: "3.8338",
                        y1: "8.25908",
                        x2: "5.43479",
                        y2: "9.71047",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#26FBFF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.637346",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint28_linear_647_117",
                        x1: "3.40845",
                        y1: "9.36998",
                        x2: "5.62288",
                        y2: "9.52796",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#26FBFF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.637346",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint29_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.73119 11.8243) rotate(-107.468) scale(6.53747 4.52974)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00BCFF",
                                stopOpacity: "0.76"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.57273",
                                stopColor: "#00BAFC",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $80a9ca5eb54c4f1b$export$2e2bcd8739ae039 = $80a9ca5eb54c4f1b$var$WebexIcon;

});

parcelRegister("dgMee", function(module, exports) {

$parcel$export(module.exports, "default", () => $17bdaf6b639eb088$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $17bdaf6b639eb088$var$ZeplinIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77432 14.5822L4.83263 14.9145L4.78223 17.6201L8.0417 16.4703C6.92361 16.1075 6.10732 15.4691 5.77432 14.5822Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.26698 11.7203L3 12.873L4.83299 14.9145L5.77438 14.5821C5.44228 13.6977 5.64688 12.6983 6.26698 11.7203Z",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.7655 7.81617C7.60483 9.28414 4.92255 12.3134 5.77454 14.5823L20.8407 9.26618C19.9887 6.99727 15.9259 6.34819 11.7655 7.81617Z",
                fill: "#FECF33"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.8498 16.0323C19.0101 14.564 21.6972 11.5483 20.8407 9.26611L5.77393 14.5822C6.63072 16.8645 10.6891 17.5002 14.8498 16.0323Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.8407 9.26611L5.77393 14.5822C6.06882 15.3681 7.19412 15.7552 8.7724 15.7552C10.3114 15.7552 12.2815 15.3875 14.3353 14.6628C18.4956 13.1948 21.4227 10.8178 20.8401 9.26611",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.8418 8.09302C16.3028 8.09302 14.3327 8.46074 12.2789 9.18545C8.11857 10.6534 5.19149 13.0301 5.77408 14.5821L20.8403 9.26601C20.5454 8.48015 19.4204 8.09302 17.8418 8.09302Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.0099 17.7638C16.5665 17.7638 15.9128 17.377 15.0659 16.6143C14.0648 15.712 12.9176 14.3903 11.8359 12.8925C10.7544 11.3953 9.86547 9.89801 9.33327 8.67692C8.75368 7.34629 8.67088 6.52827 9.08757 6.24516C9.17907 6.18315 9.28917 6.15186 9.41517 6.15186C9.75417 6.15186 10.4148 6.39555 11.6361 7.55724L11.6631 7.58245L11.6592 7.61867C11.6508 7.70213 11.6433 7.78645 11.6364 7.86904L11.6229 8.03305L11.5029 7.91656C10.1868 6.63577 9.60747 6.49755 9.41937 6.49755C9.36567 6.49755 9.32307 6.50798 9.29247 6.52885C9.11157 6.65142 9.09987 7.2524 9.66207 8.54217C10.185 9.74153 11.0607 11.2159 12.1281 12.694C13.196 14.1724 14.3255 15.4746 15.3092 16.3608C16.3697 17.3164 16.8476 17.4196 17.0042 17.4196C17.0582 17.4196 17.1017 17.4086 17.1344 17.3863C17.3249 17.257 17.3252 16.6132 16.6982 15.2246L16.6694 15.1611L16.7324 15.1278C16.7954 15.0945 16.8566 15.0617 16.9136 15.0304L16.9892 14.989L17.024 15.0658C17.4683 16.0496 17.8838 17.2999 17.339 17.6699C17.2472 17.7323 17.1365 17.7638 17.0099 17.7638Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.9505 15.9908L14.9445 16.0662C14.8392 17.3235 14.562 18.8346 13.8399 18.8961C13.8255 18.8972 13.8105 18.8978 13.7955 18.8978C13.3048 18.8978 12.8407 18.2189 12.4162 16.8801C12.0142 15.6133 11.7022 13.9129 11.5381 12.0911C11.3737 10.2702 11.3761 8.54257 11.545 7.2273C11.7289 5.7938 12.0793 5.04533 12.5863 5.00215C12.6013 5.00099 12.6169 5.00012 12.6322 5.00012C12.988 5.00012 13.5244 5.38957 14.0733 7.20238L13.7148 7.26903C13.5316 6.66341 13.3318 6.1708 13.1335 5.83176C12.9499 5.51881 12.7717 5.3464 12.6313 5.3464C12.6265 5.3464 12.622 5.3464 12.6172 5.34698C12.3976 5.36552 12.0775 5.88045 11.8993 7.2699C11.7334 8.56169 11.7313 10.2632 11.8933 12.061C12.0559 13.859 12.3625 15.5344 12.7573 16.7784C12.934 17.3354 13.1278 17.7947 13.318 18.1062C13.4932 18.3936 13.6627 18.5518 13.7952 18.5518C13.7997 18.5518 13.8042 18.5518 13.809 18.5512C14.019 18.5336 14.4153 17.9978 14.5821 16.1128L14.9505 15.9908Z",
                fill: "#EE6723"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77432 14.5822L4.83263 14.9145L4.78223 17.6201L8.0417 16.4703C6.92361 16.1075 6.10732 15.4691 5.77432 14.5822Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.26698 11.7203L3 12.873L4.83299 14.9145L5.77438 14.5821C5.44228 13.6977 5.64688 12.6983 6.26698 11.7203Z",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.7655 7.81617C7.60483 9.28414 4.92255 12.3134 5.77454 14.5823L20.8407 9.26618C19.9887 6.99727 15.9259 6.34819 11.7655 7.81617Z",
                fill: "#FECF33"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.8498 16.0323C19.0101 14.564 21.6972 11.5483 20.8407 9.26611L5.77393 14.5822C6.63072 16.8645 10.6891 17.5002 14.8498 16.0323Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.8407 9.26611L5.77393 14.5822C6.06882 15.3681 7.19412 15.7552 8.7724 15.7552C10.3114 15.7552 12.2815 15.3875 14.3353 14.6628C18.4956 13.1948 21.4227 10.8178 20.8401 9.26611",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.8418 8.09302C16.3028 8.09302 14.3327 8.46074 12.2789 9.18545C8.11857 10.6534 5.19149 13.0301 5.77408 14.5821L20.8403 9.26601C20.5454 8.48015 19.4204 8.09302 17.8418 8.09302Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.0099 17.7638C16.5665 17.7638 15.9128 17.377 15.0659 16.6143C14.0648 15.712 12.9176 14.3903 11.8359 12.8925C10.7544 11.3953 9.86547 9.89801 9.33327 8.67692C8.75368 7.34629 8.67088 6.52827 9.08757 6.24516C9.17907 6.18315 9.28917 6.15186 9.41517 6.15186C9.75417 6.15186 10.4148 6.39555 11.6361 7.55724L11.6631 7.58245L11.6592 7.61867C11.6508 7.70213 11.6433 7.78645 11.6364 7.86904L11.6229 8.03305L11.5029 7.91656C10.1868 6.63577 9.60747 6.49755 9.41937 6.49755C9.36567 6.49755 9.32307 6.50798 9.29247 6.52885C9.11157 6.65142 9.09987 7.2524 9.66207 8.54217C10.185 9.74153 11.0607 11.2159 12.1281 12.694C13.196 14.1724 14.3255 15.4746 15.3092 16.3608C16.3697 17.3164 16.8476 17.4196 17.0042 17.4196C17.0582 17.4196 17.1017 17.4086 17.1344 17.3863C17.3249 17.257 17.3252 16.6132 16.6982 15.2246L16.6694 15.1611L16.7324 15.1278C16.7954 15.0945 16.8566 15.0617 16.9136 15.0304L16.9892 14.989L17.024 15.0658C17.4683 16.0496 17.8838 17.2999 17.339 17.6699C17.2472 17.7323 17.1365 17.7638 17.0099 17.7638Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.9505 15.9908L14.9445 16.0662C14.8392 17.3235 14.562 18.8346 13.8399 18.8961C13.8255 18.8972 13.8105 18.8978 13.7955 18.8978C13.3048 18.8978 12.8407 18.2189 12.4162 16.8801C12.0142 15.6133 11.7022 13.9129 11.5381 12.0911C11.3737 10.2702 11.3761 8.54257 11.545 7.2273C11.7289 5.7938 12.0793 5.04533 12.5863 5.00215C12.6013 5.00099 12.6169 5.00012 12.6322 5.00012C12.988 5.00012 13.5244 5.38957 14.0733 7.20238L13.7148 7.26903C13.5316 6.66341 13.3318 6.1708 13.1335 5.83176C12.9499 5.51881 12.7717 5.3464 12.6313 5.3464C12.6265 5.3464 12.622 5.3464 12.6172 5.34698C12.3976 5.36552 12.0775 5.88045 11.8993 7.2699C11.7334 8.56169 11.7313 10.2632 11.8933 12.061C12.0559 13.859 12.3625 15.5344 12.7573 16.7784C12.934 17.3354 13.1278 17.7947 13.318 18.1062C13.4932 18.3936 13.6627 18.5518 13.7952 18.5518C13.7997 18.5518 13.8042 18.5518 13.809 18.5512C14.019 18.5336 14.4153 17.9978 14.5821 16.1128L14.9505 15.9908Z",
                fill: "#EE6723"
            })
        ]
    });
};
var $17bdaf6b639eb088$export$2e2bcd8739ae039 = $17bdaf6b639eb088$var$ZeplinIcon;

});

parcelRegister("eOwHL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bcd7036eebc7598$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $9bcd7036eebc7598$var$ZendeskIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-219.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#03363D"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.6092 9.34881V17.3365H4.99316L11.6092 9.34881ZM11.6092 6.48242C11.6092 7.35976 11.2607 8.20117 10.6403 8.82155C10.0199 9.44192 9.17853 9.79044 8.30119 9.79044C7.42384 9.79044 6.58244 9.44192 5.96206 8.82155C5.34169 8.20117 4.99316 7.35976 4.99316 6.48242H11.6092ZM12.6991 17.3372C12.6991 16.4598 13.0477 15.6184 13.668 14.9981C14.2884 14.3777 15.1298 14.0292 16.0072 14.0292C16.8845 14.0292 17.7259 14.3777 18.3463 14.9981C18.9667 15.6184 19.3152 16.4598 19.3152 17.3372H12.6991ZM12.6991 14.4708V6.48242H19.3166L12.6991 14.4701V14.4708Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M11.4666 9.80166V17.609H5L11.4666 9.80166ZM11.4666 7C11.4666 7.85753 11.126 8.67994 10.5196 9.2863C9.91326 9.89267 9.09085 10.2333 8.23332 10.2333C7.37579 10.2333 6.55338 9.89267 5.94702 9.2863C5.34065 8.67994 5 7.85753 5 7H11.4666ZM12.532 17.6096C12.532 16.7521 12.8726 15.9297 13.479 15.3233C14.0854 14.717 14.9078 14.3763 15.7653 14.3763C16.6228 14.3763 17.4452 14.717 18.0516 15.3233C18.658 15.9297 18.9986 16.7521 18.9986 17.6096H12.532ZM12.532 14.808V7H19L12.532 14.8073V14.808Z",
            fill: "#03363D"
        })
    });
};
var $9bcd7036eebc7598$export$2e2bcd8739ae039 = $9bcd7036eebc7598$var$ZendeskIcon;

});

parcelRegister("39NR5", function(module, exports) {

$parcel$export(module.exports, "default", () => $73cf90867809d07b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");
const $73cf90867809d07b$var$GitbookIcon = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M10.802 17.77a.703.703 0 1 1-.002 1.406.703.703 0 0 1 .002-1.406m11.024-4.347a.703.703 0 1 1 .001-1.406.703.703 0 0 1-.001 1.406m0-2.876a2.176 2.176 0 0 0-2.174 2.174c0 .233.039.465.115.691l-7.181 3.823a2.165 2.165 0 0 0-1.784-.937c-.829 0-1.584.475-1.95 1.216l-6.451-3.402c-.682-.358-1.192-1.48-1.138-2.502.028-.533.212-.947.493-1.107.178-.1.392-.092.62.027l.042.023c1.71.9 7.304 3.847 7.54 3.956.363.169.565.237 1.185-.057l11.564-6.014c.17-.064.368-.227.368-.474 0-.342-.354-.477-.355-.477-.658-.315-1.669-.788-2.655-1.25-2.108-.987-4.497-2.105-5.546-2.655-.906-.474-1.635-.074-1.765.006l-.252.125C7.78 6.048 1.46 9.178 1.1 9.397.457 9.789.058 10.57.006 11.539c-.08 1.537.703 3.14 1.824 3.727l6.822 3.518a2.175 2.175 0 0 0 2.15 1.862 2.177 2.177 0 0 0 2.173-2.14l7.514-4.073c.38.298.853.461 1.337.461A2.176 2.176 0 0 0 24 12.72a2.176 2.176 0 0 0-2.174-2.174"
        })
    });
var $73cf90867809d07b$export$2e2bcd8739ae039 = $73cf90867809d07b$var$GitbookIcon;

});

parcelRegister("bIkGo", function(module, exports) {

$parcel$export(module.exports, "default", () => $3698078ac83fd1c3$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $3698078ac83fd1c3$var$LaunchDarklyIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-683.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.0232 12.0808C20.0002 12.2346 19.9148 12.3512 19.8075 12.4584C17.3508 14.9147 14.895 17.3719 12.4389 19.8288C12.4116 19.8561 12.3853 19.8845 12.3562 19.9098C12.2424 20.0088 12.113 20.0247 11.9781 19.9655C11.845 19.9072 11.7732 19.798 11.7632 19.6539C11.7574 19.5702 11.7891 19.4944 11.8388 19.4264C11.9362 19.2931 12.0329 19.1593 12.13 19.0257C12.7486 18.1738 13.3672 17.3218 13.9859 16.47C14.3904 15.913 14.795 15.3562 15.1995 14.7994C15.3066 14.6519 15.4141 14.5047 15.5208 14.357C15.5315 14.3423 15.5483 14.3295 15.5454 14.3065C15.5243 14.3004 15.5082 14.3131 15.4912 14.32C14.8996 14.5611 14.308 14.8024 13.7166 15.0438C13.2263 15.2439 12.7362 15.4442 12.246 15.6446C11.1843 16.0784 10.1224 16.5119 9.06106 16.9467C8.97552 16.9817 8.88978 17.0024 8.79819 16.9813C8.65305 16.9479 8.54691 16.8331 8.52155 16.684C8.49883 16.5505 8.56326 16.4093 8.68877 16.3339C8.9313 16.1881 9.17582 16.0455 9.41951 15.9016C10.289 15.3879 11.1584 14.8742 12.028 14.3607C12.7979 13.9061 13.568 13.4519 14.338 12.9974C14.3655 12.9812 14.3924 12.9642 14.4339 12.9389C14.3588 12.9323 14.2988 12.9253 14.2387 12.922C13.9713 12.9073 13.7038 12.894 13.4363 12.8793C13.2181 12.8673 13 12.8547 12.7819 12.8415C12.5296 12.8261 12.2774 12.8095 12.0251 12.7943C11.9225 12.788 11.8197 12.7846 11.717 12.7786C11.5224 12.7673 11.3279 12.7548 11.1333 12.7432C11.0542 12.7385 10.975 12.7358 10.8959 12.7303C10.7057 12.7172 10.515 12.711 10.3246 12.6999C10.0723 12.6852 9.82012 12.6679 9.56774 12.6531C9.48432 12.6482 9.40084 12.6449 9.31742 12.6397C9.0523 12.6232 8.78686 12.6112 8.52161 12.5966C8.29917 12.5844 8.07679 12.5711 7.85434 12.5583C7.62765 12.5453 7.40082 12.5335 7.17426 12.519C6.95188 12.5048 6.72956 12.4913 6.50699 12.4805C6.28229 12.4696 6.05785 12.4551 5.83328 12.4422C5.61083 12.4294 5.38845 12.4166 5.166 12.4038C4.94356 12.391 4.72111 12.3791 4.49873 12.3648C4.43675 12.3608 4.37431 12.3592 4.31284 12.3523C4.16358 12.3353 4.05918 12.256 4.00602 12.1135C3.99707 12.0894 3.99243 12.0637 3.97705 12.0422V11.9393C3.99733 11.9207 3.99932 11.8936 4.0091 11.8701C4.06504 11.736 4.16332 11.6549 4.30917 11.6409C4.4307 11.6293 4.5528 11.6239 4.67464 11.6167C4.89921 11.6034 5.12378 11.5908 5.34835 11.5778C5.5708 11.565 5.79318 11.5517 6.01569 11.5395C6.28312 11.5249 6.55069 11.513 6.818 11.4964C6.89929 11.4914 6.98058 11.4877 7.06188 11.483C7.24364 11.4725 7.42528 11.4591 7.60705 11.4487C7.79532 11.438 7.98384 11.432 8.17185 11.4184C8.25315 11.4125 8.33451 11.4106 8.4158 11.4056C8.60606 11.3938 8.79639 11.3816 8.98672 11.3705C9.08938 11.3644 9.19223 11.3612 9.2949 11.355C9.54721 11.3397 9.79945 11.3229 10.0518 11.3077C10.2741 11.2942 10.4967 11.282 10.7191 11.2693C10.9458 11.2563 11.1726 11.2433 11.3993 11.2303C11.6196 11.2176 11.8398 11.2048 12.0602 11.1922C12.2847 11.1792 12.5093 11.1658 12.7339 11.1535C13.0014 11.1389 13.2689 11.127 13.5362 11.1105C13.6175 11.1055 13.6988 11.1016 13.7801 11.0971C13.9812 11.0858 14.1821 11.0732 14.3832 11.0609C14.3985 11.0599 14.4156 11.0646 14.4308 11.0529C14.4137 11.033 14.3934 11.0251 14.3751 11.0143C13.5146 10.5062 12.654 9.99844 11.7936 9.49047C10.898 8.96178 10.0024 8.43308 9.10689 7.90432C8.96837 7.82258 8.82909 7.74206 8.69192 7.65813C8.56776 7.58211 8.50449 7.44392 8.52374 7.31442C8.55817 7.0829 8.80701 6.93975 9.02933 7.03359C9.54483 7.25121 10.0641 7.45969 10.5821 7.67152C11.5167 8.05372 12.4516 8.43553 13.3863 8.81767C14.0887 9.10486 14.7912 9.39225 15.4938 9.679C15.5099 9.68556 15.5262 9.70217 15.5467 9.68743C15.5473 9.66503 15.5315 9.65177 15.5205 9.63665C15.1123 9.07442 14.7037 8.51251 14.2954 7.95041C13.7824 7.24426 13.2698 6.53792 12.7569 5.8317C12.4532 5.41352 12.1522 4.99341 11.8443 4.57832C11.679 4.35536 11.8105 4.07621 12.0167 4.01719C12.031 4.01313 12.0443 4.00579 12.0581 4C12.101 4 12.1439 4 12.1868 4C12.282 4.02349 12.354 4.08136 12.4221 4.14939C14.8857 6.61367 17.3497 9.07744 19.8147 11.5404C19.9208 11.6464 20.0037 11.7613 20.0233 11.9138V12.081L20.0232 12.0808Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M19.9999 12.0808C19.977 12.2346 19.8919 12.3512 19.7849 12.4584C17.3353 14.9147 14.8865 17.3719 12.4375 19.8288C12.4103 19.8561 12.384 19.8845 12.355 19.9098C12.2415 20.0088 12.1125 20.0247 11.978 19.9655C11.8453 19.9072 11.7737 19.798 11.7638 19.6539C11.758 19.5702 11.7896 19.4944 11.8391 19.4264C11.9362 19.2931 12.0327 19.1593 12.1295 19.0257C12.7463 18.1738 13.3631 17.3218 13.98 16.47C14.3833 15.913 14.7867 15.3562 15.1901 14.7994C15.2969 14.6519 15.4041 14.5047 15.5105 14.357C15.5212 14.3423 15.5379 14.3295 15.535 14.3065C15.514 14.3004 15.4979 14.3131 15.481 14.32C14.891 14.5611 14.3012 14.8024 13.7115 15.0438C13.2226 15.2439 12.7339 15.4442 12.2451 15.6446C11.1865 16.0784 10.1277 16.5119 9.06936 16.9467C8.98407 16.9817 8.89858 17.0024 8.80725 16.9813C8.66253 16.9479 8.55669 16.8331 8.53141 16.684C8.50875 16.5505 8.573 16.4093 8.69815 16.3339C8.93998 16.1881 9.18379 16.0455 9.42678 15.9016C10.2938 15.3879 11.1607 14.8742 12.0278 14.3607C12.7954 13.9061 13.5634 13.4519 14.3311 12.9974C14.3585 12.9812 14.3854 12.9642 14.4267 12.9389C14.3518 12.9323 14.292 12.9253 14.232 12.922C13.9654 12.9073 13.6987 12.894 13.432 12.8793C13.2145 12.8673 12.997 12.8547 12.7795 12.8415C12.5279 12.8261 12.2765 12.8095 12.0249 12.7943C11.9225 12.788 11.82 12.7846 11.7177 12.7786C11.5237 12.7673 11.3296 12.7548 11.1356 12.7432C11.0568 12.7385 10.9777 12.7358 10.8989 12.7303C10.7092 12.7172 10.5191 12.711 10.3293 12.6999C10.0777 12.6852 9.82623 12.6679 9.57458 12.6531C9.49141 12.6482 9.40817 12.6449 9.32499 12.6397C9.06063 12.6232 8.79596 12.6112 8.53147 12.5966C8.30967 12.5844 8.08793 12.5711 7.86612 12.5583C7.64008 12.5453 7.41391 12.5335 7.188 12.519C6.96626 12.5048 6.74458 12.4913 6.52265 12.4805C6.2986 12.4696 6.0748 12.4551 5.85088 12.4422C5.62907 12.4294 5.40733 12.4166 5.18553 12.4038C4.96372 12.391 4.74192 12.3791 4.52018 12.3648C4.45837 12.3608 4.39612 12.3592 4.33483 12.3523C4.18599 12.3353 4.08189 12.256 4.02888 12.1135C4.01996 12.0894 4.01534 12.0637 4 12.0422V11.9393C4.02022 11.9207 4.02221 11.8936 4.03196 11.8701C4.08773 11.736 4.18574 11.6549 4.33117 11.6409C4.45234 11.6293 4.57409 11.6239 4.69558 11.6167C4.9195 11.6034 5.14343 11.5908 5.36735 11.5778C5.58915 11.565 5.81089 11.5517 6.03276 11.5395C6.29943 11.5249 6.56623 11.513 6.83276 11.4964C6.91382 11.4914 6.99488 11.4877 7.07594 11.483C7.25718 11.4725 7.4383 11.4591 7.61954 11.4487C7.80727 11.438 7.99525 11.432 8.18272 11.4184C8.26378 11.4125 8.3449 11.4106 8.42596 11.4056C8.61568 11.3938 8.80546 11.3816 8.99523 11.3705C9.0976 11.3644 9.20016 11.3612 9.30253 11.355C9.55411 11.3397 9.80563 11.3229 10.0572 11.3077C10.279 11.2942 10.5008 11.282 10.7226 11.2693C10.9487 11.2563 11.1748 11.2433 11.4008 11.2303C11.6205 11.2176 11.8401 11.2048 12.0598 11.1922C12.2837 11.1792 12.5077 11.1658 12.7316 11.1535C12.9983 11.1389 13.2651 11.127 13.5316 11.1105C13.6127 11.1055 13.6938 11.1016 13.7748 11.0971C13.9753 11.0858 14.1757 11.0732 14.3761 11.0609C14.3914 11.0599 14.4085 11.0646 14.4236 11.0529C14.4066 11.033 14.3863 11.0251 14.3681 11.0143C13.5101 10.5062 12.652 9.99844 11.794 9.49047C10.901 8.96178 10.008 8.43308 9.11506 7.90432C8.97694 7.82258 8.83806 7.74206 8.70129 7.65813C8.57749 7.58211 8.5144 7.44392 8.53359 7.31442C8.56793 7.0829 8.81604 6.93975 9.03772 7.03359C9.55174 7.25121 10.0695 7.45969 10.586 7.67152C11.5179 8.05372 12.4501 8.43553 13.3821 8.81767C14.0826 9.10486 14.783 9.39225 15.4836 9.679C15.4996 9.68556 15.5159 9.70217 15.5363 9.68743C15.5369 9.66503 15.5212 9.65177 15.5102 9.63665C15.1032 9.07442 14.6957 8.51251 14.2886 7.95041C13.7771 7.24426 13.2659 6.53792 12.7546 5.8317C12.4518 5.41352 12.1516 4.99341 11.8446 4.57832C11.6797 4.35536 11.8109 4.07621 12.0165 4.01719C12.0307 4.01313 12.044 4.00579 12.0578 4C12.1005 4 12.1433 4 12.1861 4C12.281 4.02349 12.3529 4.08136 12.4207 4.14939C14.8772 6.61367 17.3341 9.07744 19.792 11.5404C19.8978 11.6464 19.9805 11.7613 20 11.9138V12.081L19.9999 12.0808Z",
            fill: "black"
        })
    });
};
var $3698078ac83fd1c3$export$2e2bcd8739ae039 = $3698078ac83fd1c3$var$LaunchDarklyIcon;

});

parcelRegister("8GMEU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db123cd7b504f9e$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $9db123cd7b504f9e$var$PagerDutyIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-731.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#04AB38"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.33974 9.0588C7.33988 9.05866 7.33996 9.05847 7.33996 9.05827C7.33996 7.60876 7.34084 6.15925 7.3382 4.70974C7.3382 4.5796 7.33644 4.4987 7.51495 4.50002C9.30876 4.51057 11.1026 4.49738 12.8964 4.51892C13.9116 4.53123 14.8801 4.77262 15.7546 5.30858C16.8256 5.96414 17.4222 6.94066 17.6117 8.16868C17.8148 9.48551 17.6012 10.7206 16.7918 11.8057C16.1033 12.7294 15.1439 13.2175 14.0285 13.4329C13.3347 13.567 12.6326 13.5846 11.9309 13.5899C10.4668 13.6013 9.00231 13.5912 7.53781 13.5991C7.36414 13.6 7.33557 13.5411 7.33645 13.3859C7.34172 11.9438 7.33952 10.5014 7.33952 9.05933C7.33952 9.05913 7.3396 9.05894 7.33974 9.0588Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.35232 17.4818C7.35232 16.8821 7.35539 16.2819 7.34968 15.6822C7.34836 15.5516 7.36463 15.4905 7.52246 15.4931C8.14414 15.5037 8.76626 15.5024 9.38794 15.4931C9.53215 15.4909 9.55281 15.5415 9.55237 15.6681C9.54798 16.89 9.5471 18.1118 9.55325 19.3333C9.55413 19.4753 9.50841 19.5003 9.37959 19.499C8.75791 19.4929 8.13579 19.4911 7.51411 19.4999C7.3699 19.5021 7.34836 19.452 7.34968 19.3249C7.35583 18.7102 7.35232 18.096 7.35232 17.4813V17.4818Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.54312 8.99636C9.54312 8.1834 9.54488 7.37088 9.54093 6.55791C9.54049 6.43788 9.55148 6.37589 9.70184 6.37677C10.7051 6.38424 11.7084 6.36446 12.7113 6.38776C13.2833 6.40095 13.8408 6.53021 14.3464 6.81996C15.0103 7.20028 15.3295 7.79604 15.3967 8.54042C15.4464 9.09221 15.4223 9.63697 15.1853 10.1514C14.8072 10.9723 14.1037 11.3416 13.2675 11.521C12.8942 11.601 12.5143 11.6195 12.1332 11.6195C11.3422 11.619 10.5513 11.612 9.76075 11.6247C9.56818 11.6278 9.53697 11.565 9.53917 11.3913C9.5484 10.5933 9.54312 9.79481 9.54312 8.9968V8.99636Z",
                fill: "#04AB38"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9969 11.9995C19.9969 14.6225 19.9963 17.2458 19.9997 19.8688C19.9997 19.9713 19.985 19.9991 19.8741 19.9987C14.6273 19.995 9.38021 19.995 4.13343 19.9987C4.01562 19.9991 4 19.9684 4 19.8609C4.00312 14.62 4.00312 9.37906 4 4.13812C4 4.03094 4.015 4 4.13343 4C9.37521 4.00406 14.6167 4.00406 19.8584 4C19.98 4 20 4.03187 20 4.14562C19.9966 6.76359 19.9972 9.38125 19.9972 11.9992L19.9969 11.9995Z",
                fill: "#04AB38"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.67927 9.89217C8.67927 8.86191 8.6799 7.83166 8.67802 6.80141C8.67802 6.70891 8.67677 6.65142 8.80364 6.65236C10.0786 6.65985 11.3536 6.65048 12.6286 6.66579C13.3501 6.67454 14.0385 6.84609 14.6601 7.22701C15.4213 7.69292 15.8454 8.38694 15.9801 9.2597C16.1244 10.1956 15.9726 11.0733 15.3973 11.8446C14.9079 12.5011 14.226 12.8479 13.4332 13.001C12.9401 13.0964 12.4411 13.1089 11.9423 13.1126C10.9017 13.1207 9.86081 13.1135 8.81989 13.1192C8.69646 13.1198 8.67615 13.0779 8.67677 12.9676C8.68052 11.9427 8.67896 10.9174 8.67896 9.89248L8.67927 9.89217Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.68845 15.8778C8.68845 15.4515 8.69063 15.025 8.68657 14.5988C8.68563 14.506 8.6972 14.4625 8.80938 14.4644C9.25125 14.4719 9.69343 14.471 10.1353 14.4644C10.2378 14.4629 10.2525 14.4988 10.2522 14.5888C10.249 15.4572 10.2484 16.3256 10.2528 17.1936C10.2534 17.2946 10.2209 17.3124 10.1294 17.3114C9.68749 17.3071 9.24531 17.3058 8.80345 17.3121C8.70095 17.3136 8.68563 17.278 8.68657 17.1877C8.69095 16.7508 8.68845 16.3143 8.68845 15.8775V15.8778Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.2451 9.89333C10.2451 9.31556 10.2463 8.73809 10.2435 8.16031C10.2432 8.075 10.251 8.03094 10.3579 8.03157C11.071 8.03688 11.7841 8.02282 12.4969 8.03938C12.9035 8.04876 13.2997 8.14062 13.6591 8.34655C14.1309 8.61685 14.3578 9.04026 14.4056 9.56929C14.4409 9.96146 14.4237 10.3486 14.2553 10.7142C13.9866 11.2976 13.4866 11.5601 12.8922 11.6876C12.6269 11.7445 12.3569 11.7576 12.086 11.7576C11.5238 11.7573 10.9616 11.7523 10.3998 11.7613C10.2629 11.7635 10.2407 11.7189 10.2423 11.5954C10.2488 11.0283 10.2451 10.4608 10.2451 9.89365V9.89333Z",
                fill: "#04AB38"
            })
        ]
    });
};
var $9db123cd7b504f9e$export$2e2bcd8739ae039 = $9db123cd7b504f9e$var$PagerDutyIcon;

});

parcelRegister("74dAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2db9f138882b352$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $a2db9f138882b352$var$PowerBIIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-602.5",
                y: "-507.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.4031 4H13.1618C12.7971 4 12.5015 4.29563 12.5015 4.66032V19.3397C12.5015 19.7044 12.7971 20 13.1618 20H17.4031C17.7677 20 18.0634 19.7044 18.0634 19.3397V4.66032C18.0634 4.29563 17.7677 4 17.4031 4Z",
                fill: "#B25400"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.787 19.3394V19.9998H9.88542C9.52072 19.9998 9.2251 19.7041 9.2251 19.3394V8.64738C9.2251 8.28268 9.52072 7.98706 9.88542 7.98706H14.1267C14.4914 7.98706 14.787 8.28268 14.787 8.64738V19.3394Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.787 19.3394V19.9998H9.88542C9.52072 19.9998 9.2251 19.7041 9.2251 19.3394V8.64738C9.2251 8.28268 9.52072 7.98706 9.88542 7.98706H14.1267C14.4914 7.98706 14.787 8.28268 14.787 8.64738V19.3394Z",
                fill: "#DE9800"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.5619 19.3394V19.9998H6.66032C6.29562 19.9998 6 19.7041 6 19.3394V12.6601C6 12.2954 6.29562 11.9998 6.66032 11.9998H10.9016C11.2663 11.9998 11.5619 12.2954 11.5619 12.6601V19.3394Z",
                fill: "#F3CD32"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.4032 4H13.1619C12.7972 4 12.5016 4.29563 12.5016 4.66032V19.3397C12.5016 19.7044 12.7972 20 13.1619 20H17.4032C17.7679 20 18.0635 19.7044 18.0635 19.3397V4.66032C18.0635 4.29563 17.7679 4 17.4032 4Z",
                fill: "url(#paint0_linear_384_141)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.7873 19.3397V20H9.88572C9.52102 20 9.2254 19.7044 9.2254 19.3397V8.64762C9.2254 8.28292 9.52102 7.9873 9.88572 7.9873H14.127C14.4917 7.9873 14.7873 8.28292 14.7873 8.64762V19.3397Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.7873 19.3397V20H9.88572C9.52102 20 9.2254 19.7044 9.2254 19.3397V8.64762C9.2254 8.28292 9.52102 7.9873 9.88572 7.9873H14.127C14.4917 7.9873 14.7873 8.28292 14.7873 8.64762V19.3397Z",
                fill: "url(#paint1_linear_384_141)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.5619 19.3397V20H6.66032C6.29562 20 6 19.7044 6 19.3397V12.6603C6 12.2956 6.29562 12 6.66032 12H10.9016C11.2663 12 11.5619 12.2956 11.5619 12.6603V19.3397Z",
                fill: "url(#paint2_linear_384_141)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint0_linear_384_141",
                        x1: "15.2561",
                        y1: "3.97968",
                        x2: "15.2561",
                        y2: "19.9797",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#EBBB14"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B25400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint1_linear_384_141",
                        x1: "11.9799",
                        y1: "7.93778",
                        x2: "11.9799",
                        y2: "19.9505",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#F9E583"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DE9800"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint2_linear_384_141",
                        x1: "8.75454",
                        y1: "11.9797",
                        x2: "8.75454",
                        y2: "19.9797",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#F9E68B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F3CD32"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $a2db9f138882b352$export$2e2bcd8739ae039 = $a2db9f138882b352$var$PowerBIIcon;

});

parcelRegister("dGVh7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad198126728ea2d1$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $ad198126728ea2d1$var$ServiceNowIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0473 4.00178C10.4382 3.99842 8.86528 4.4785 7.53234 5.37978C6.19941 6.28105 5.16796 7.56197 4.57171 9.05646C3.97546 10.5509 3.84191 12.1901 4.18837 13.7614C4.53483 15.3327 5.34532 16.7637 6.51478 17.8688C6.78908 18.13 7.14782 18.2844 7.52608 18.3041C7.90434 18.3237 8.27713 18.2073 8.57701 17.9759C9.56641 17.2396 10.7668 16.842 12.0001 16.842C13.2334 16.842 14.4339 17.2396 15.4233 17.9759C15.726 18.2078 16.1021 18.3232 16.4828 18.301C16.8635 18.2788 17.2236 18.1205 17.4973 17.8549C18.6576 16.7539 19.4626 15.3314 19.8092 13.7698C20.1558 12.2082 20.0282 10.5787 19.4426 9.09017C18.8571 7.60161 17.8404 6.32184 16.5228 5.41488C15.2052 4.50793 13.6467 4.01512 12.0473 3.99963M12.0001 16.0379C11.4713 16.0522 10.9451 15.9586 10.4536 15.7628C9.96216 15.567 9.51573 15.2731 9.1416 14.8991C8.76746 14.525 8.47347 14.0787 8.27754 13.5873C8.08161 13.0959 7.98787 12.5697 8.00202 12.0408C8.00202 10.9805 8.42326 9.96353 9.17305 9.21374C9.92284 8.46395 10.9398 8.04272 12.0001 8.04272C13.0605 8.04272 14.0774 8.46395 14.8272 9.21374C15.577 9.96353 15.9983 10.9805 15.9983 12.0408C16.0124 12.5697 15.9187 13.0959 15.7227 13.5873C15.5268 14.0787 15.2328 14.525 14.8587 14.8991C14.4846 15.2731 14.0381 15.567 13.5467 15.7628C13.0552 15.9586 12.529 16.0522 12.0001 16.0379Z",
                fill: "#62D84E"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.0473 5.00214C10.4382 4.99878 8.86528 5.47886 7.53234 6.38014C6.19941 7.28142 5.16796 8.56233 4.57171 10.0568C3.97546 11.5513 3.84191 13.1905 4.18837 14.7618C4.53483 16.333 5.34532 17.764 6.51478 18.8692C6.78908 19.1304 7.14782 19.2848 7.52608 19.3044C7.90434 19.3241 8.27713 19.2077 8.57701 18.9763C9.56641 18.24 10.7668 17.8423 12.0001 17.8423C13.2334 17.8423 14.4339 18.24 15.4233 18.9763C15.726 19.2082 16.1021 19.3236 16.4828 19.3013C16.8635 19.2791 17.2236 19.1208 17.4973 18.8553C18.6576 17.7542 19.4626 16.3317 19.8092 14.7702C20.1558 13.2086 20.0282 11.5791 19.4426 10.0905C18.8571 8.60198 17.8404 7.3222 16.5228 6.41525C15.2052 5.50829 13.6467 5.01549 12.0473 5M12.0001 17.0382C11.4713 17.0525 10.9451 16.9589 10.4536 16.7631C9.96216 16.5674 9.51573 16.2735 9.1416 15.8994C8.76746 15.5254 8.47347 15.0791 8.27754 14.5876C8.08161 14.0962 7.98787 13.57 8.00202 13.0412C8.00202 11.9808 8.42326 10.9639 9.17305 10.2141C9.92284 9.46432 10.9398 9.04309 12.0001 9.04309C13.0605 9.04309 14.0774 9.46432 14.8272 10.2141C15.577 10.9639 15.9983 11.9808 15.9983 13.0412C16.0124 13.57 15.9187 14.0962 15.7227 14.5876C15.5268 15.0791 15.2328 15.5254 14.8587 15.8994C14.4846 16.2735 14.0381 16.5674 13.5467 16.7631C13.0552 16.9589 12.529 17.0525 12.0001 17.0382Z",
            fill: "#62D84E"
        })
    });
};
var $ad198126728ea2d1$export$2e2bcd8739ae039 = $ad198126728ea2d1$var$ServiceNowIcon;

});

parcelRegister("bndMH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab446c4f11477054$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $ab446c4f11477054$var$AWSS3Icon = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("title", {
                children: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                id: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                width: "24",
                height: "24",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                        id: "Icon-Architecture-BG/64/Storage",
                        fill: "#7AA116",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            id: "Rectangle",
                            x: "0",
                            y: "0",
                            width: "24",
                            height: "24"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                        id: "Icon-Service/64/Amazon-Simple-Storage-Service_64",
                        transform: "scale(0.3) translate(12.999900, 11.999600)",
                        fill: "#FFFFFF",
                        width: "24",
                        height: "24",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M47.836,30.893 L48.22,28.189 C51.761,30.31 51.807,31.186 51.8060132,31.21 C51.8,31.215 51.196,31.719 47.836,30.893 L47.836,30.893 Z M45.893,30.353 C39.773,28.501 31.25,24.591 27.801,22.961 C27.801,22.947 27.805,22.934 27.805,22.92 C27.805,21.595 26.727,20.517 25.401,20.517 C24.077,20.517 22.999,21.595 22.999,22.92 C22.999,24.245 24.077,25.323 25.401,25.323 C25.983,25.323 26.511,25.106 26.928,24.761 C30.986,26.682 39.443,30.535 45.608,32.355 L43.17,49.561 C43.163,49.608 43.16,49.655 43.16,49.702 C43.16,51.217 36.453,54 25.494,54 C14.419,54 7.641,51.217 7.641,49.702 C7.641,49.656 7.638,49.611 7.632,49.566 L2.538,12.359 C6.947,15.394 16.43,17 25.5,17 C34.556,17 44.023,15.4 48.441,12.374 L45.893,30.353 Z M2,8.478 C2.072,7.162 9.634,2 25.5,2 C41.364,2 48.927,7.161 49,8.478 L49,8.927 C48.13,11.878 38.33,15 25.5,15 C12.648,15 2.843,11.868 2,8.913 L2,8.478 Z M51,8.5 C51,5.035 41.066,0 25.5,0 C9.934,0 0,5.035 0,8.5 L0.094,9.254 L5.642,49.778 C5.775,54.31 17.861,56 25.494,56 C34.966,56 45.029,53.822 45.159,49.781 L47.555,32.884 C48.888,33.203 49.985,33.366 50.866,33.366 C52.049,33.366 52.849,33.077 53.334,32.499 C53.732,32.025 53.884,31.451 53.77,30.84 C53.511,29.456 51.868,27.964 48.522,26.055 L50.898,9.293 L51,8.5 Z",
                            id: "Amazon-Simple-Storage-Service-Icon_64_Squid"
                        })
                    })
                ]
            })
        ]
    });
var $ab446c4f11477054$export$2e2bcd8739ae039 = $ab446c4f11477054$var$AWSS3Icon;

});

parcelRegister("g6dt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e09550576c833cf$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $6e09550576c833cf$export$e16bd899bb4eebf9 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-587.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M5.20962 17.0782L5.91523 18.2907C6.06186 18.546 6.27262 18.7466 6.52005 18.8925L9.04009 14.5529H4C4 14.8355 4.07331 15.1181 4.21993 15.3734L5.20962 17.0782Z",
                        fill: "#0066DA"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12 9.44751L9.47995 5.10791C9.23253 5.25378 9.02176 5.45435 8.87514 5.70962L4.21993 13.7324C4.07601 13.9822 4.00019 14.265 4 14.5529H9.04009L12 9.44751Z",
                        fill: "#00AC47"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M17.4799 18.8925C17.7273 18.7466 17.9381 18.546 18.0847 18.2907L18.3779 17.7893L19.78 15.3734C19.9266 15.1181 19.9999 14.8355 19.9999 14.5529H14.9595L16.032 16.6497L17.4799 18.8925Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12 9.4475L14.5201 5.1079C14.2726 4.96203 13.9886 4.8891 13.6953 4.8891H10.3047C10.0115 4.8891 9.7274 4.97115 9.47998 5.1079L12 9.4475Z",
                        fill: "#00832D"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.9594 14.5529H9.03958L6.51953 18.8925C6.76695 19.0383 7.05103 19.1113 7.34427 19.1113H16.6547C16.9479 19.1113 17.232 19.0292 17.4794 18.8925L14.9594 14.5529Z",
                        fill: "#2684FC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M17.4525 9.72101L15.1249 5.70962C14.9782 5.45435 14.7675 5.25378 14.52 5.10791L12 9.44751L14.9599 14.5529H19.9908C19.9908 14.2703 19.9175 13.9877 19.7709 13.7324L17.4525 9.72101Z",
                        fill: "#FFBA00"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_271_181643)",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                    clipPath: "url(#clip1_271_181643)",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            x: "2",
                            y: "2",
                            width: "20",
                            height: "20",
                            rx: "0.75",
                            fill: "white",
                            fillOpacity: "0.01"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                            clipPath: "url(#clip2_271_181643)",
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M3.51203 18.5459L4.39404 20.1089C4.57732 20.438 4.84078 20.6965 5.15006 20.8845L8.30011 15.2905H2C2 15.6548 2.09164 16.0192 2.27491 16.3482L3.51203 18.5459Z",
                                    fill: "#0066DA"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M12 8.70925L8.84994 3.11523C8.54066 3.30327 8.27721 3.56182 8.09393 3.89088L2.27491 14.2328C2.09501 14.5547 2.00024 14.9193 2 15.2904H8.30011L12 8.70925Z",
                                    fill: "#00AC47"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M18.85 20.8845C19.1593 20.6965 19.4227 20.438 19.606 20.1089L19.9725 19.4625L21.7251 16.3482C21.9084 16.0192 22 15.6548 22 15.2905H15.6995L17.0401 17.9935L18.85 20.8845Z",
                                    fill: "#EA4335"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M12.0002 8.70932L15.1502 3.1153C14.8409 2.92727 14.4858 2.83325 14.1193 2.83325H9.88103C9.51447 2.83325 9.15938 2.93902 8.8501 3.1153L12.0002 8.70932Z",
                                    fill: "#00832D"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M15.6997 15.2905H8.29996L5.1499 20.8845C5.45918 21.0726 5.81428 21.1666 6.18083 21.1666H17.8189C18.1854 21.1666 18.5405 21.0608 18.8498 20.8845L15.6997 15.2905Z",
                                    fill: "#2684FC"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M18.8156 9.06182L15.9061 3.89088C15.7228 3.56182 15.4593 3.30327 15.1501 3.11523L12 8.70925L15.6999 15.2904H21.9885C21.9885 14.9261 21.8969 14.5618 21.7136 14.2328L18.8156 9.06182Z",
                                    fill: "#FFBA00"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_271_181643",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "24",
                            height: "24",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip1_271_181643",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            x: "2",
                            y: "2",
                            width: "20",
                            height: "20",
                            rx: "0.75",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip2_271_181643",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "20",
                            height: "18.3333",
                            fill: "white",
                            transform: "translate(2 2.83325)"
                        })
                    })
                ]
            })
        ]
    });
};
var $6e09550576c833cf$export$2e2bcd8739ae039 = $6e09550576c833cf$export$e16bd899bb4eebf9;

});

parcelRegister("fPxww", function(module, exports) {

$parcel$export(module.exports, "getLogoVersion", () => $9dca3af2d039b729$export$f2e275790a265e16);
$parcel$export(module.exports, "get3PLogo", () => $9dca3af2d039b729$export$fab9faef3411dc6c);
$parcel$export(module.exports, "RovoLogoFromLogo", () => $9dca3af2d039b729$export$32db889b380fa03c);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $id7ja = parcelRequire("id7ja");
const $9dca3af2d039b729$var$iconContainerStyles = {
    small: (0, $ecnYn.xcss)({
        width: '16px',
        height: '16px'
    }),
    medium: (0, $ecnYn.xcss)({
        width: '24px',
        height: '24px'
    }),
    large: (0, $ecnYn.xcss)({
        width: '40px',
        height: '40px'
    }),
    xlarge: (0, $ecnYn.xcss)({
        width: '48px',
        height: '48px'
    })
};
const $9dca3af2d039b729$var$t25IconContainerStyles = {
    small: (0, $ecnYn.xcss)({
        width: '16px',
        height: '16px'
    }),
    medium: (0, $ecnYn.xcss)({
        width: '24px',
        height: '24px'
    }),
    large: (0, $ecnYn.xcss)({
        width: '32px',
        height: '32px'
    }),
    //t25 tile icons do not get bumped up to 40/48px to avoid additional padding
    xlarge: (0, $ecnYn.xcss)({
        width: '32x',
        height: '32px'
    })
};
const $9dca3af2d039b729$var$iconStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
function $9dca3af2d039b729$export$f2e275790a265e16(t25LogoComponent, LogoComponent) {
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? t25LogoComponent : LogoComponent;
}
function $9dca3af2d039b729$export$fab9faef3411dc6c(iconGlyph, iconLabel) {
    return (0, $dh538.fg)('rovo_search_custom_icon_component') ? $9dca3af2d039b729$export$dae027fade2c6d1d(iconGlyph, iconLabel) : $9dca3af2d039b729$export$7b66a86355afbb91(iconGlyph, iconLabel);
}
const $9dca3af2d039b729$export$1776e6671850176d = ({ glyph: SVG, label: label, size: size })=>{
    const useT25Styles = (0, $dh538.fg)('platform-team25-app-icon-tiles');
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: [
            useT25Styles ? $9dca3af2d039b729$var$t25IconContainerStyles[size] : $9dca3af2d039b729$var$iconContainerStyles[size],
            $9dca3af2d039b729$var$iconStyles
        ],
        "aria-label": label,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)(SVG, {})
    });
};
const $9dca3af2d039b729$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: "small",
            appearance: "brand"
        });
    };
};
const $9dca3af2d039b729$export$dae027fade2c6d1d = (glyph, defaultLabel = '')=>{
    return ({ label: label = defaultLabel })=>/*#__PURE__*/ (0, $7UHDa.jsx)($9dca3af2d039b729$export$1776e6671850176d, {
            label: label,
            glyph: glyph,
            size: "medium"
        });
};
const $9dca3af2d039b729$export$7b66a86355afbb91 = (glyph, defaultLabel = '')=>{
    return ({ label: label = defaultLabel, testId: testId })=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $id7ja.default), {
            label: label,
            testId: testId,
            glyph: glyph,
            size: "medium"
        });
    };
};

});




parcelRegister("lfOhG", function(module, exports) {

$parcel$export(module.exports, "useCurrentProductHasFilters", () => $22c6390f7332d66f$export$7fe06de49ac4bced);
$parcel$export(module.exports, "useGetCurrentProductFilters", () => $22c6390f7332d66f$export$1f8e3e68f7016027);
$parcel$export(module.exports, "useCurrentProductHasAppliedFilters", () => $22c6390f7332d66f$export$75dfe0d9a43fb0ea);
$parcel$export(module.exports, "useCurrentProductGenericSelectedFilterCount", () => $22c6390f7332d66f$export$b5ddd6b67ba52fed);

var $fJRVo = parcelRequire("fJRVo");

var $cgH2x = parcelRequire("cgH2x");

var $88j1D = parcelRequire("88j1D");
const $22c6390f7332d66f$export$7fe06de49ac4bced = ()=>{
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const product = getActiveProduct();
    const { filterDefinitions: filterDefinitions } = (0, $cgH2x.useGenericFilters)();
    return !!(product && filterDefinitions[product.id]?.length > 0);
};
const $22c6390f7332d66f$export$1f8e3e68f7016027 = ()=>{
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const product = getActiveProduct();
    const { filterDefinitions: filterDefinitions } = (0, $cgH2x.useGenericFilters)();
    return product && filterDefinitions[product.id] || [];
};
const $22c6390f7332d66f$export$75dfe0d9a43fb0ea = ()=>{
    const filters = $22c6390f7332d66f$export$1f8e3e68f7016027();
    let hasFilters = false;
    filters.forEach((filter)=>{
        filter.store.availableFilters.forEach((option)=>{
            if (option.isChecked && option.id !== (0, $88j1D.DEFAULT_OPTION)) hasFilters = true;
        });
    });
    return hasFilters;
};
const $22c6390f7332d66f$export$b5ddd6b67ba52fed = ()=>{
    const filters = $22c6390f7332d66f$export$1f8e3e68f7016027();
    const genericFilters = filters.filter((filter)=>filter['@type'] !== (0, $88j1D.SITE_FILTER_TYPE_NAME));
    return genericFilters.reduce((filterCount, nextFilter)=>nextFilter.store.availableFilters.filter((f)=>f.isChecked).length + filterCount, 0);
};

});


parcelRegister("dv73R", function(module, exports) {

let $9d43a5cf9b25a2e1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9d43a5cf9b25a2e1$var$load("9zZJj"),
    $9d43a5cf9b25a2e1$var$load("1Ojgx")
]).then(()=>parcelRequire('4E1b5'));

});




parcelRegister("48BnN", function(module, exports) {

$parcel$export(module.exports, "useAppliedFilters", () => $20c4d524183fb4e9$export$51b04ed1f44b6aaf);

var $88j1D = parcelRequire("88j1D");

var $cgH2x = parcelRequire("cgH2x");
const $20c4d524183fb4e9$export$51b04ed1f44b6aaf = (activeProductId)=>{
    const { filterDefinitions: filterDefinitions } = (0, $cgH2x.useGenericFilters)();
    let appliedFilters = [];
    // Find all of the filters that apply to the current product
    const filters = filterDefinitions[activeProductId];
    if (filters !== undefined) filters.forEach((filter)=>{
        // filters with specified value mapping logic should implement it, else use generic logic
        if (filter.mapSelectionToAppliedValue) {
            const valueToApply = filter.mapSelectionToAppliedValue();
            !!valueToApply && appliedFilters.push(valueToApply);
        } else {
            let applied = filter.store.availableFilters.filter((option)=>option.isChecked).map((filter)=>filter.id);
            // if no site filters are applied, the search should use the top 3 available sites
            if (filter['@type'] === (0, $88j1D.SITE_FILTER_TYPE_NAME) && applied.length === 0) applied = filter.store.availableFilters.slice(0, 3).map((filter)=>filter.id);
            if (filter['@type'] === 'spaces') applied = filter.store.availableFilters.filter((option)=>option.isChecked).map((filter)=>filter.spaceKey || '');
            if (applied.length > 0) appliedFilters.push({
                '@type': filter['@type'],
                [filter.fieldName]: applied
            });
        }
    });
    return appliedFilters;
};

});

parcelRegister("gMIQ9", function(module, exports) {

$parcel$export(module.exports, "ActiveProductProvider", () => $08c163fce83bd841$export$8cce9f9e667fae48);

var $gwFzn = parcelRequire("gwFzn");

var $fJRVo = parcelRequire("fJRVo");

var $80L9g = parcelRequire("80L9g");
const $08c163fce83bd841$export$8cce9f9e667fae48 = ({ children: children })=>{
    const { getActiveProduct: getActiveProduct, getDefaultAIConfig: getDefaultAIConfig } = (0, $fJRVo.useProductContext)();
    const { showSearchAIDialog: showSearchAIDialog, toggleShowSearchAIDialog: toggleShowSearchAIDialog } = (0, $80L9g.useSessionUserInput)();
    const onCloseAIDialog = (0, $gwFzn.useCallback)(()=>{
        toggleShowSearchAIDialog(false);
    }, [
        toggleShowSearchAIDialog
    ]);
    const defaultAIConfig = getDefaultAIConfig();
    return children({
        activeProduct: getActiveProduct(),
        showSearchAIDialog: showSearchAIDialog,
        onCloseAIDialog: onCloseAIDialog,
        defaultAIConfig: defaultAIConfig
    });
};

});

parcelRegister("64EAe", function(module, exports) {

$parcel$export(module.exports, "ProductSearchDialogWrapper", () => $51e1c9118342ae7a$export$99f979ec765e5f8f);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $7DA0P = parcelRequire("7DA0P");

var $gF7Az = parcelRequire("gF7Az");

var $amrMu = parcelRequire("amrMu");
const $51e1c9118342ae7a$export$99f979ec765e5f8f = ({ children: children, shouldFillContainer: shouldFillContainer })=>{
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { quickFind: quickFind } = (0, $amrMu.useFeaturesContext)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7DA0P.SearchDialog), {
        shouldFillContainer: shouldFillContainer,
        isExpanded: isExpanded,
        style: {
            boxShadow: isExpanded ? undefined : 'none',
            borderRadius: quickFind?.enabled ? "var(--ds-space-100, 8px)" : undefined
        },
        children: children
    });
};

});

parcelRegister("k6Y8T", function(module, exports) {

let $ea430535c6ce17ee$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ea430535c6ce17ee$var$load("4tWDP"),
    $ea430535c6ce17ee$var$load("7vwsA"),
    $ea430535c6ce17ee$var$load("N7HSS"),
    $ea430535c6ce17ee$var$load("gFkzm"),
    $ea430535c6ce17ee$var$load("3ZN1r"),
    $ea430535c6ce17ee$var$load("i73Fi"),
    $ea430535c6ce17ee$var$load("4Bp5z"),
    $ea430535c6ce17ee$var$load("eyMrr"),
    $ea430535c6ce17ee$var$load("900yZ"),
    $ea430535c6ce17ee$var$load("c7DhJ"),
    $ea430535c6ce17ee$var$load("ej4rO"),
    $ea430535c6ce17ee$var$load("6Nh0d"),
    $ea430535c6ce17ee$var$load("g7pmM"),
    $ea430535c6ce17ee$var$load("emd3r"),
    $ea430535c6ce17ee$var$load("9zZJj"),
    $ea430535c6ce17ee$var$load("jCu7l"),
    $ea430535c6ce17ee$var$load("hYWtF"),
    $ea430535c6ce17ee$var$load("dUEf9"),
    $ea430535c6ce17ee$var$load("1FHbS"),
    $ea430535c6ce17ee$var$load("dPqoW"),
    $ea430535c6ce17ee$var$load("dTsOE"),
    $ea430535c6ce17ee$var$load("kjZZD"),
    $ea430535c6ce17ee$var$load("7jSfd"),
    $ea430535c6ce17ee$var$load("4HZlX"),
    $ea430535c6ce17ee$var$load("kDqHr"),
    $ea430535c6ce17ee$var$load("5i7Tn"),
    $ea430535c6ce17ee$var$load("g9CVe"),
    $ea430535c6ce17ee$var$load("ZJtkJ"),
    $ea430535c6ce17ee$var$load("a9PRK"),
    $ea430535c6ce17ee$var$load("6qah4"),
    $ea430535c6ce17ee$var$load("ffEVr"),
    $ea430535c6ce17ee$var$load("c6MKV"),
    $ea430535c6ce17ee$var$load("aZinD"),
    $ea430535c6ce17ee$var$load("joJy8"),
    $ea430535c6ce17ee$var$load("aHE9G"),
    $ea430535c6ce17ee$var$load("6Z8WE"),
    $ea430535c6ce17ee$var$load("fiCwF")
]).then(()=>parcelRequire('bDy3t'));

});


parcelRegister("2evZZ", function(module, exports) {

$parcel$export(module.exports, "OpsgenieTab", () => $6cbf2f1ae9737b11$export$7571e7fdcc46c96b);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $5CiaV = parcelRequire("5CiaV");

var $bF0iL = parcelRequire("bF0iL");

var $6GxJO = parcelRequire("6GxJO");

var $a5cba = parcelRequire("a5cba");
var $fJRVo = parcelRequire("fJRVo");

var $iWkic = parcelRequire("iWkic");

var $cYpQr = parcelRequire("cYpQr");

var $crAJ1 = parcelRequire("crAJ1");

var $eztGN = parcelRequire("eztGN");

var $iEwUU = parcelRequire("iEwUU");

var $3Z7LN = parcelRequire("3Z7LN");

var $4mZlP = parcelRequire("4mZlP");

var $4mZlP = parcelRequire("4mZlP");
const $6cbf2f1ae9737b11$var$OPSGENIE_PRODUCT_ID = 'opsgenie';
const $6cbf2f1ae9737b11$export$864cff1b26c75e89 = (alert)=>{
    return {
        title: alert.message,
        id: alert.id,
        meta: alert.status.charAt(0).toUpperCase() + alert.status.slice(1),
        url: alert.link,
        iconUrl: alert.iconURI,
        containerId: '' // no conatiner
    };
};
const $6cbf2f1ae9737b11$export$527d10d7fdeeea4e = ({ intl: intl, cloudId: cloudId, generateAdvancedSearchUrl: overriddenGenerateAdvancedSearchUrl, hostUrl: hostUrl, postQueryItemSupplier: postQueryItemSupplier, preQueryItemSupplier: preQueryItemSupplier, ...rest })=>{
    const urlGeneratorArguments = (0, $gwFzn.useMemo)(()=>({
            cloudId: cloudId,
            hostUrl: hostUrl
        }), [
        cloudId,
        hostUrl
    ]);
    const { viewAllLinkGenerator: viewAllLinkGenerator, urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen } = (0, $cYpQr.useOpsgenieURLGenerators)(urlGeneratorArguments);
    const sections = [
        {
            id: (0, $iWkic.OpsgenieScope).OpsgenieAlert,
            title: intl.formatMessage((0, $6GxJO.messages).opsgenie_alerts_heading),
            scope: (0, $iWkic.OpsgenieScope).OpsgenieAlert,
            showResultCount: true,
            viewAllLinkGenerator: viewAllLinkGenerator,
            resultMapper: ({ results: results })=>results.map((value)=>$6cbf2f1ae9737b11$export$864cff1b26c75e89(value))
        }
    ];
    const itemSuppliers = (0, $5CiaV.useDefaultSuppliers)($6cbf2f1ae9737b11$var$OPSGENIE_PRODUCT_ID, sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    const preQuerySectionTitleGenerator = (0, $gwFzn.useCallback)((section)=>section.id === (0, $iWkic.OpsgenieScope).OpsgenieAlert ? intl.formatMessage((0, $6GxJO.messages).opsgenie_recent_alerts) : '', [
        intl
    ]);
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $gwFzn.useCallback)((query, baseUrl, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink && orgId) return (0, $3Z7LN.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return overriddenGenerateAdvancedSearchUrl?.(query, baseUrl, usage) || viewAllLinkGenerator(query);
    }, [
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id,
        overriddenGenerateAdvancedSearchUrl,
        viewAllLinkGenerator
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5cba.SearchDialogProduct), {
        expandedStateInputPlaceholder: intl.formatMessage((0, $6GxJO.messages).opsgenie_expanded_input_placeholder),
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        id: $6cbf2f1ae9737b11$var$OPSGENIE_PRODUCT_ID,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
        sections: sections,
        title: intl.formatMessage((0, $bF0iL.messages).opsgenie_tab_label),
        urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
        ...rest,
        ...itemSuppliers,
        children: ()=>{
            return {
                Footer: ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.AdvancedSearchFooter), {
                                    ...rest,
                                    searchFooterLabel: intl.formatMessage((0, $6GxJO.messages).opsgenie_advanced_search),
                                    returnKeyIconComponent: showAtlassianHomeSearchLink ? ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.ReturnIconWithModifier), {}) : undefined
                                })
                            }),
                            showAtlassianHomeSearchLink && orgId && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Z7LN.AtlassianHomeSearchLink), {
                                    orgId: orgId,
                                    cloudId: cloudId,
                                    showModifierIcon: true
                                })
                            })
                        ]
                    })
            };
        }
    });
};
const $6cbf2f1ae9737b11$export$7571e7fdcc46c96b = (0, $js7oX.default)($6cbf2f1ae9737b11$export$527d10d7fdeeea4e);

});
parcelRegister("6GxJO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8b3e3400ae6f3971$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $8b3e3400ae6f3971$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /*
   * Opsgenie
   */ opsgenie_expanded_input_placeholder: {
        id: "product_search_dialog.opsgenie.expanded.input-placeholder",
        defaultMessage: "Search Opsgenie"
    },
    opsgenie_recent_alerts: {
        id: "product_search_dialog.opsgenie.opsgenie_recent_alerts",
        defaultMessage: "Recent Alerts"
    },
    opsgenie_alerts_heading: {
        id: "product_search_dialog.opsgenie.alert_heading",
        defaultMessage: "Alerts"
    },
    opsgenie_advanced_search: {
        id: "product_search_dialog.opsgenie.advanced_search",
        defaultMessage: "Advanced alert search"
    }
});

});

parcelRegister("iWkic", function(module, exports) {

$parcel$export(module.exports, "OpsgenieScope", () => $57b4f9c3ea98ed8b$export$dc14148e3ded2998);
var $57b4f9c3ea98ed8b$export$dc14148e3ded2998 = /*#__PURE__*/ function(OpsgenieScope) {
    OpsgenieScope["OpsgenieAlert"] = "opsgenie.alert";
    return OpsgenieScope;
}({});

});

parcelRegister("cYpQr", function(module, exports) {

$parcel$export(module.exports, "useOpsgenieURLGenerators", () => $ddbd2b3a958b61d9$export$c78c65c0f344862e);

var $gwFzn = parcelRequire("gwFzn");
const $ddbd2b3a958b61d9$var$getOpsgenieAggregatorRedirectUrl = ({ cloudId: cloudId, hostUrl: hostUrl = '' })=>{
    return `${hostUrl}/gateway/api/xpsearch-aggregator/redirect/advanced/opsgenie/${cloudId}`;
};
const $ddbd2b3a958b61d9$export$c78c65c0f344862e = (arg)=>{
    const opsgenieAggregatorRedirector = (0, $gwFzn.useCallback)((query)=>`${$ddbd2b3a958b61d9$var$getOpsgenieAggregatorRedirectUrl(arg)}?query=${query}`, [
        arg
    ]);
    return {
        viewAllLinkGenerator: opsgenieAggregatorRedirector,
        urlGeneratorForNoResultsScreen: opsgenieAggregatorRedirector
    };
};

});


parcelRegister("29ccb", function(module, exports) {

$parcel$export(module.exports, "TownsquareTab", () => $3dc7d02d49b2e18c$export$b2c9c8ae315d8935);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $acrNX = parcelRequire("acrNX");

var $lF5IG = parcelRequire("lF5IG");

var $3hux3 = parcelRequire("3hux3");

var $a5cba = parcelRequire("a5cba");
var $fJRVo = parcelRequire("fJRVo");

var $cgH2x = parcelRequire("cgH2x");

var $9zyYG = parcelRequire("9zyYG");

var $1rta3 = parcelRequire("1rta3");

var $cqziK = parcelRequire("cqziK");

var $lzcvT = parcelRequire("lzcvT");

var $c6GJD = parcelRequire("c6GJD");

var $crAJ1 = parcelRequire("crAJ1");

var $eztGN = parcelRequire("eztGN");

var $iEwUU = parcelRequire("iEwUU");

var $3Z7LN = parcelRequire("3Z7LN");

var $kmpep = parcelRequire("kmpep");
const $3dc7d02d49b2e18c$var$defaultPermissionsSupplier = ()=>{
    const response = Object.values((0, $cqziK.TownsquareScope));
    return Promise.resolve(response);
};
const $3dc7d02d49b2e18c$export$e502dfe73eec1c84 = ({ intl: intl, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, userTeamConfig: userTeamConfig, workspaces: workspaces, atlasClientBaseUrlOverride: atlasClientBaseUrlOverride, organizationId: organizationId, ...rest })=>{
    const [isGlobalExperienceWorkspace, setGlobalExperienceWorkspace] = (0, $gwFzn.useState)();
    const { atlasWorkspaces: atlasWorkspaces } = (0, $lF5IG.useSearchConfigContext)();
    if (!workspaces) workspaces = atlasWorkspaces;
    const siteFilterDefinition = (0, $cgH2x.useSiteFilterDefinition)(workspaces, (0, $1rta3.TOWNSQUARE_PRODUCT_ID));
    const { preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams, postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams, preQuerySectionTitleGenerator: preQuerySectionTitleGenerator } = (0, $1rta3.useTownsquareSuppliers)({
        userTeamConfig: userTeamConfig,
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier,
        workspaces: workspaces,
        isGlobalExperienceWorkspace: isGlobalExperienceWorkspace
    });
    const { defineFilters: defineFilters } = (0, $cgH2x.useGenericFilters)();
    defineFilters((0, $1rta3.TOWNSQUARE_PRODUCT_ID), siteFilterDefinition);
    (0, $gwFzn.useEffect)(()=>{
        (0, $acrNX.isGlobalExperienceWorkspaceForCloudId)(userTeamConfig?.context.siteId, atlasClientBaseUrlOverride).then((result)=>{
            setGlobalExperienceWorkspace(result);
        }).catch(()=>{
            setGlobalExperienceWorkspace(false);
        });
    }, [
        atlasClientBaseUrlOverride,
        userTeamConfig?.context.siteId
    ]);
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $gwFzn.useCallback)((query, _, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $3Z7LN.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return '';
    }, [
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    let permissionSupplier = workspaces && workspaces.length > 0 || isGlobalExperienceWorkspace ? $3dc7d02d49b2e18c$var$defaultPermissionsSupplier : rest.permissionSupplier;
    if (isGlobalExperienceWorkspace === undefined) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5cba.SearchDialogProduct), {
        ...rest,
        id: (0, $1rta3.TOWNSQUARE_PRODUCT_ID),
        expandedStateInputPlaceholder: intl.formatMessage(isGlobalExperienceWorkspace ? (0, $3hux3.messages).townsquare_search_input_expanded_placeholder : (0, $3hux3.messages).atlas_search_input_expanded_placeholder),
        sections: (0, $9zyYG.getSections)(intl, workspaces, isGlobalExperienceWorkspace, userTeamConfig?.context.organizationId),
        title: intl.formatMessage(isGlobalExperienceWorkspace ? (0, $3hux3.messages).townsquare_globex_tab_label : (0, $3hux3.messages).townsquare_tab_label),
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
        preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
        postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
        workspaces: workspaces,
        permissionSupplier: permissionSupplier,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        children: ()=>{
            return {
                Footer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                        children: showAtlassianHomeSearchLink && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Z7LN.AtlassianHomeSearchLink), {
                                orgId: orgId,
                                cloudId: cloudId,
                                showModifierIcon: true
                            })
                        })
                    })
            };
        }
    });
};
const $3dc7d02d49b2e18c$export$485492c388dcd81e = (props)=>{
    if ((0, $c6GJD.default).initializeCompleted() && (0, $c6GJD.default).checkGate('ignore_atlas_product_search_dialog_on_fedramp') && (0, $lzcvT.isFedRamp)()) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($3dc7d02d49b2e18c$export$e502dfe73eec1c84, {
        ...props
    });
};
const $3dc7d02d49b2e18c$export$b2c9c8ae315d8935 = (0, $js7oX.default)($3dc7d02d49b2e18c$export$485492c388dcd81e);

});
parcelRegister("acrNX", function(module, exports) {

$parcel$export(module.exports, "isGlobalExperienceWorkspaceForCloudId", () => $b276001131c7a99f$export$d39036e5b47a0af);
function $b276001131c7a99f$var$getServiceUrl(cloudId, baseUrlOverride) {
    const path = `/gateway/api/townsquare/s/${cloudId}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`;
    if (baseUrlOverride) return `${baseUrlOverride}${path}`;
    return path;
}
async function $b276001131c7a99f$export$d39036e5b47a0af(cloudId, baseUrlOverride) {
    if (cloudId === undefined) return false;
    try {
        const response = await fetch($b276001131c7a99f$var$getServiceUrl(cloudId, baseUrlOverride), {
            credentials: 'include'
        });
        if (response.ok) {
            const workspaceType = await response.text();
            return workspaceType === 'GLOBAL_EXPERIENCE';
        }
        return false;
    } catch (err) {
        return false;
    }
}

});

parcelRegister("3hux3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ea6f0aa982c7afdb$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $ea6f0aa982c7afdb$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /*
   * Atlas, formerly known as Team Central or Townsquare
   */ atlas_search_input_expanded_placeholder: {
        id: "product_search_dialog.atlas.search_input_expanded_placeholder",
        defaultMessage: "Search Atlas"
    },
    townsquare_search_input_expanded_placeholder: {
        id: "product_search_dialog.townsquare.search_input_expanded_placeholder",
        defaultMessage: "Search Home"
    },
    townsquare_tab_label: {
        id: "cross_product_search_dialog.townsquare_tab_label",
        defaultMessage: "Atlas"
    },
    townsquare_globex_tab_label: {
        id: "cross_product_search_dialog.townsquare_globex_tab_label",
        defaultMessage: "Home"
    },
    townsquare_recent_projects: {
        id: "cross_product_search_dialog.townsquare_recent_projects",
        defaultMessage: "Recent Projects"
    },
    townsquare_recent_goals: {
        id: "cross_product_search_dialog.townsquare_recent_goals",
        defaultMessage: "Recent Goals"
    },
    townsquare_recent_help_links: {
        id: "cross_product_search_dialog.townsquare_recent_help_links",
        defaultMessage: "Recent Help Links"
    },
    townsquare_recent_learnings_risks_decisions: {
        id: "cross_product_search_dialog.townsquare_recent_learnings_risks_decisions",
        defaultMessage: "Recent Learnings, Risks and Decisions"
    },
    townsquare_recent_topics: {
        id: "product_search_dialog.townsquare_recent_topics",
        defaultMessage: "Recent Topics"
    },
    townsquare_recent_people: {
        id: "product_search_dialog.townsquare_recent_people",
        defaultMessage: "Recent People"
    },
    townsquare_projects_heading: {
        id: "product_search_dialog.townsquare_projects_heading",
        defaultMessage: "Projects"
    },
    townsquare_projects_view_all: {
        id: "product_search_dialog.townsquare_projects_view_all",
        defaultMessage: "Search all projects"
    },
    townsquare_goals_heading: {
        id: "product_search_dialog.townsquare_goals_heading",
        defaultMessage: "Goals"
    },
    townsquare_goals_view_all: {
        id: "product_search_dialog.townsquare_goals_view_all",
        defaultMessage: "Search all goals"
    },
    townsquare_help_links_heading: {
        id: "product_search_dialog.townsquare_help_links_heading",
        defaultMessage: "Help Links"
    },
    townsquare_topics_heading: {
        id: "product_search_dialog.townsquare_topics_heading",
        defaultMessage: "Topics"
    },
    townsquare_topics_view_all: {
        id: "product_search_dialog.townsquare_topics_view_all",
        defaultMessage: "Search all topics"
    },
    townsquare_learnings_risks_decisions_heading: {
        id: "product_search_dialog.townsquare_learnings_risks_decisions_heading",
        defaultMessage: "Learnings, Risks and Decisions"
    },
    townsquare_people_heading: {
        id: "product_search_dialog.townsquare_people_heading",
        defaultMessage: "People"
    },
    townsquare_people_view_all: {
        id: "product_search_dialog.townsquare_people_view_all",
        defaultMessage: "Search all people"
    },
    townsquare_teams_heading: {
        id: "product_search_dialog.townsquare_teams_heading",
        defaultMessage: "Teams"
    },
    townsquare_teams_view_all: {
        id: "product_search_dialog.townsquare_teams_view_all",
        defaultMessage: "Search all teams"
    }
});

});

parcelRegister("9zyYG", function(module, exports) {

$parcel$export(module.exports, "MAX_ITEMS_PER_SECTION", () => $ad01931f226af666$export$ece7c64a85a33d85);
$parcel$export(module.exports, "getSections", () => $ad01931f226af666$export$ddbcae0b0bd6b092);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $3hux3 = parcelRequire("3hux3");

var $cqziK = parcelRequire("cqziK");

var $fjD79 = parcelRequire("fjD79");
let $ad01931f226af666$var$defaultTownsquareResultMapper = ({ results: results })=>results.map((value)=>$ad01931f226af666$var$mapAggregatorResponseToSearchItem(value)).slice(0, $ad01931f226af666$export$ece7c64a85a33d85);
const $ad01931f226af666$export$ece7c64a85a33d85 = 3;
const $ad01931f226af666$var$mapAggregatorResponseToSearchItem = (response)=>{
    if ('account_id' in response) return {
        title: response.name,
        id: response.account_id,
        meta: '',
        url: response.absoluteUrl || '',
        iconUrl: response.picture,
        containerId: '' // no container
    };
    else return {
        title: response.title,
        id: response.id,
        meta: '',
        url: response.url,
        iconUrl: response.iconUrl,
        containerId: '' // no container
    };
};
const $ad01931f226af666$export$ddbcae0b0bd6b092 = (intl, workspaces, isGlobalExperienceWorkspace, orgId)=>[
        {
            id: (0, $cqziK.TownsquareScope).TownsquareProject,
            title: intl.formatMessage((0, $3hux3.messages).townsquare_projects_heading),
            showResultCount: false,
            scope: (0, $cqziK.TownsquareScope).TownsquareProject,
            resultMapper: $ad01931f226af666$var$defaultTownsquareResultMapper,
            viewAllLinkGenerator: (query)=>{
                return (0, $fjD79.default)('projects', query, workspaces, isGlobalExperienceWorkspace, orgId);
            },
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $3hux3.messages).townsquare_projects_view_all
                })
        },
        {
            id: (0, $cqziK.TownsquareScope).TownsquareGoal,
            title: intl.formatMessage((0, $3hux3.messages).townsquare_goals_heading),
            scope: (0, $cqziK.TownsquareScope).TownsquareGoal,
            resultMapper: $ad01931f226af666$var$defaultTownsquareResultMapper,
            viewAllLinkGenerator: (query)=>(0, $fjD79.default)('goals', query, workspaces, isGlobalExperienceWorkspace, orgId),
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $3hux3.messages).townsquare_goals_view_all
                })
        },
        {
            id: (0, $cqziK.TownsquareScope).TownsquareHelpLink,
            title: intl.formatMessage((0, $3hux3.messages).townsquare_help_links_heading),
            scope: (0, $cqziK.TownsquareScope).TownsquareHelpLink,
            resultMapper: $ad01931f226af666$var$defaultTownsquareResultMapper
        },
        {
            id: (0, $cqziK.TownsquareScope).TownsquareTag,
            title: intl.formatMessage((0, $3hux3.messages).townsquare_topics_heading),
            scope: (0, $cqziK.TownsquareScope).TownsquareTag,
            resultMapper: $ad01931f226af666$var$defaultTownsquareResultMapper,
            viewAllLinkGenerator: (query)=>(0, $fjD79.default)('topics', query, workspaces, isGlobalExperienceWorkspace, orgId),
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $3hux3.messages).townsquare_topics_view_all
                })
        },
        {
            id: (0, $cqziK.TownsquareScope).TownsquareLearning,
            title: intl.formatMessage((0, $3hux3.messages).townsquare_learnings_risks_decisions_heading),
            scope: (0, $cqziK.TownsquareScope).TownsquareLearning,
            resultMapper: $ad01931f226af666$var$defaultTownsquareResultMapper
        }
    ];

});
parcelRegister("cqziK", function(module, exports) {

$parcel$export(module.exports, "TownsquareScope", () => $7175e1aafd675626$export$fca43c5c12a4e3fa);
var $7175e1aafd675626$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});

});


parcelRegister("1rta3", function(module, exports) {

$parcel$export(module.exports, "TOWNSQUARE_PRODUCT_ID", () => $f4a2ff59ef026569$export$dac5be8ec1b3ddb1);
$parcel$export(module.exports, "useTownsquareSuppliers", () => $f4a2ff59ef026569$export$a0d26d0ba1e6d87a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $3coNb = parcelRequire("3coNb");

var $3hux3 = parcelRequire("3hux3");

var $5CiaV = parcelRequire("5CiaV");

var $9zyYG = parcelRequire("9zyYG");

var $cqziK = parcelRequire("cqziK");

var $fjD79 = parcelRequire("fjD79");
const $f4a2ff59ef026569$export$dac5be8ec1b3ddb1 = 'townsquare';
const $f4a2ff59ef026569$var$sectionSortOrder = [
    (0, $cqziK.TownsquareScope).TownsquareProject,
    (0, $cqziK.TownsquareScope).TownsquareGoal,
    (0, $cqziK.TownsquareScope).People,
    (0, $cqziK.TownsquareScope).Teams,
    (0, $cqziK.TownsquareScope).TownsquareTag,
    (0, $cqziK.TownsquareScope).TownsquareHelpLink,
    (0, $cqziK.TownsquareScope).TownsquareLearning
];
/**
 * Sorting sections to match the order defined in the array {sectionSortOrder}
 * While this should not happen, if the section is not part of the array, it is considered to be at the end.
 */ const $f4a2ff59ef026569$var$sortSections = (sectionA, sectionB)=>{
    const indexA = $f4a2ff59ef026569$var$sectionSortOrder.indexOf(sectionA.id);
    const indexB = $f4a2ff59ef026569$var$sectionSortOrder.indexOf(sectionB.id);
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
};
const $f4a2ff59ef026569$export$a0d26d0ba1e6d87a = ({ userTeamConfig: userTeamConfig, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, workspaces: workspaces, organizationId: organizationId, isGlobalExperienceWorkspace: isGlobalExperienceWorkspace })=>{
    const intl = (0, $dBxQj.default)();
    const orgId = organizationId ?? userTeamConfig?.context.organizationId;
    const itemSuppliers = (0, $5CiaV.useDefaultSuppliers)($f4a2ff59ef026569$export$dac5be8ec1b3ddb1, (0, $9zyYG.getSections)(intl, workspaces, isGlobalExperienceWorkspace, orgId), {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    // If we are in a global experience workspace, we need to set the product key to 'people'
    if (userTeamConfig) userTeamConfig.context.productKey = isGlobalExperienceWorkspace ? 'people' : userTeamConfig?.context.productKey;
    const peopleAndTeamSupplier = (0, $3coNb.usePeopleAndTeamsQuery)({
        people: {
            id: (0, $cqziK.TownsquareScope).People,
            title: intl.formatMessage((0, $3hux3.messages).townsquare_people_heading),
            viewAllLinkGenerator: (query)=>(0, $fjD79.default)('people', query, workspaces, isGlobalExperienceWorkspace, orgId),
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $3hux3.messages).townsquare_people_view_all
                })
        },
        teams: {
            id: (0, $cqziK.TownsquareScope).Teams,
            title: intl.formatMessage((0, $3hux3.messages).townsquare_teams_heading),
            viewAllLinkGenerator: (query)=>(0, $fjD79.default)('teams', query, workspaces, isGlobalExperienceWorkspace, orgId),
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $3hux3.messages).townsquare_teams_view_all
                })
        }
    }, (0, $9zyYG.MAX_ITEMS_PER_SECTION));
    const preQueryItemSupplierWithPeopleAndTeams = async (args)=>{
        const existingSections = await itemSuppliers.preQueryItemSupplier(args);
        const people = userTeamConfig ? await peopleAndTeamSupplier('', {
            resolveUserUrl: (userId)=>(0, $fjD79.createProfileLink)(userId, isGlobalExperienceWorkspace, orgId),
            resolveTeamUrl: (teamId)=>(0, $fjD79.createTeamProfileLink)(teamId, isGlobalExperienceWorkspace, orgId),
            ...userTeamConfig
        }) : null;
        const unsortedSections = [
            ...existingSections.sections,
            ...people?.sections ?? []
        ];
        return {
            size: unsortedSections.length,
            sections: unsortedSections.sort($f4a2ff59ef026569$var$sortSections)
        };
    };
    const postQueryItemSupplierWithPeopleAndTeams = async (args)=>{
        const existingSections = await itemSuppliers.postQueryItemSupplier(args);
        const { filters: filters } = args;
        const selectedWorkspace = filters.filter((filter)=>filter['@type'] === 'sites').map((filter)=>filter.values[0]).filter((val)=>val).shift();
        const people = userTeamConfig ? await peopleAndTeamSupplier(args.query, {
            resolveUserUrl: (userId)=>(0, $fjD79.createProfileLink)(userId, isGlobalExperienceWorkspace, orgId),
            resolveTeamUrl: (teamId)=>(0, $fjD79.createTeamProfileLink)(teamId, isGlobalExperienceWorkspace, orgId),
            ...userTeamConfig,
            context: {
                ...userTeamConfig.context,
                siteId: selectedWorkspace || userTeamConfig.context.siteId
            }
        }) : null;
        const unsortedSections = [
            ...existingSections.sections,
            ...people?.sections ?? []
        ];
        return {
            size: unsortedSections.length,
            sections: unsortedSections.sort($f4a2ff59ef026569$var$sortSections)
        };
    };
    const preQuerySectionTitleGenerator = (section)=>{
        switch(section.id){
            case (0, $cqziK.TownsquareScope).TownsquareProject:
                return intl.formatMessage((0, $3hux3.messages).townsquare_recent_projects);
            case (0, $cqziK.TownsquareScope).TownsquareGoal:
                return intl.formatMessage((0, $3hux3.messages).townsquare_recent_goals);
            case (0, $cqziK.TownsquareScope).TownsquareHelpLink:
                return intl.formatMessage((0, $3hux3.messages).townsquare_recent_help_links);
            case (0, $cqziK.TownsquareScope).TownsquareTag:
                return intl.formatMessage((0, $3hux3.messages).townsquare_recent_topics);
            case (0, $cqziK.TownsquareScope).TownsquareLearning:
                return intl.formatMessage((0, $3hux3.messages).townsquare_recent_learnings_risks_decisions);
            case (0, $cqziK.TownsquareScope).People:
                return intl.formatMessage((0, $3hux3.messages).townsquare_recent_people);
            default:
                return '';
        }
    };
    return {
        preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
        postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator
    };
};

});


parcelRegister("2WIYs", function(module, exports) {

$parcel$export(module.exports, "TrelloTab", () => $ab7ced8b5c4b8113$export$78fe0655c043c20);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $bF0iL = parcelRequire("bF0iL");

var $6la50 = parcelRequire("6la50");

var $a5cba = parcelRequire("a5cba");
var $fJRVo = parcelRequire("fJRVo");

var $5CiaV = parcelRequire("5CiaV");

var $tFil7 = parcelRequire("tFil7");

var $buUFy = parcelRequire("buUFy");

var $3Oi7g = parcelRequire("3Oi7g");

var $aJ5e0 = parcelRequire("aJ5e0");

var $46uIy = parcelRequire("46uIy");

var $4ldrV = parcelRequire("4ldrV");

var $2OcMi = parcelRequire("2OcMi");

var $eztGN = parcelRequire("eztGN");

var $3Z7LN = parcelRequire("3Z7LN");

var $iEwUU = parcelRequire("iEwUU");

var $kmpep = parcelRequire("kmpep");

const $ab7ced8b5c4b8113$var$TrelloBodyAsync = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("b5eQ2")).then(({ TrelloBody: TrelloBody })=>({
            default: TrelloBody
        })));
const $ab7ced8b5c4b8113$export$78fe0655c043c20 = ({ feedbackUrl: feedbackUrl, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, generateAdvancedSearchUrl: generateAdvancedSearchUrl, features: features, resultOnClick: resultOnClick, ...rest })=>{
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const trelloGenerateAdvancedSearchUrl = (0, $gwFzn.useCallback)((query, baseUrl, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $3Z7LN.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return (0, $2OcMi.addQueryParams)((0, $46uIy.viewAllLinkGenerator)(query), {
            search_id: searchSessionId
        });
    }, [
        searchSessionId,
        showAtlassianHomeSearchLink,
        orgId,
        cloudId,
        primaryProduct?.id
    ]);
    const boardSection = (0, $gwFzn.useMemo)(()=>{
        return {
            id: (0, $3Oi7g.TrelloScope).Board,
            title: formatMessage((0, $6la50.messages).trello_boards_heading),
            scope: (0, $3Oi7g.TrelloScope).Board,
            showResultCount: false,
            resultMapper: ({ results: results })=>results.map((board)=>({
                        id: board.id,
                        title: board.name,
                        meta: board.organization?.displayName ?? '',
                        closed: board.closed,
                        url: board.url,
                        prefs: board.prefs,
                        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aJ5e0.BoardIcon), {
                            ...board
                        }),
                        containerId: board.idOrganization ?? undefined
                    })),
            resultRenderer: (args)=>{
                const { id: id, title: title, meta: meta, closed: closed, url: url, prefs: prefs } = args?.searchResult;
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $tFil7.TrelloSearchResultComponent), {
                    id: id,
                    title: title,
                    meta: {
                        title: formatMessage((0, $6la50.messages).trello_workspace),
                        value: meta
                    },
                    closed: closed,
                    url: url,
                    prefs: prefs,
                    isPreviewOnTrelloSearchResultsEnabled: features?.isPreviewOnTrelloSearchResultsEnabled,
                    isColorBlindModeEnabled: features?.isColorBlindModeEnabled,
                    screen: args?.screen,
                    onResultClick: resultOnClick
                });
            }
        };
    }, [
        features?.isColorBlindModeEnabled,
        features?.isPreviewOnTrelloSearchResultsEnabled,
        formatMessage,
        resultOnClick
    ]);
    const cardSection = (0, $gwFzn.useMemo)(()=>{
        return {
            id: (0, $3Oi7g.TrelloScope).Card,
            title: formatMessage((0, $6la50.messages).trello_cards_heading),
            scope: (0, $3Oi7g.TrelloScope).Card,
            showResultCount: false,
            resultMapper: ({ results: results })=>results.map((card)=>({
                        id: card.id,
                        title: card.name,
                        meta: card.board.name,
                        additionalMeta: card.list.name,
                        closed: card.closed,
                        url: card.url,
                        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aJ5e0.CardIcon), {}),
                        containerId: card.idBoard
                    })),
            resultRenderer: (args)=>{
                const { id: id, title: title, meta: meta, additionalMeta: additionalMeta, url: url, closed: closed } = args?.searchResult;
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $tFil7.TrelloSearchResultComponent), {
                    id: id,
                    title: title,
                    meta: {
                        title: formatMessage((0, $6la50.messages).trello_board),
                        value: meta
                    },
                    additionalMeta: {
                        title: formatMessage((0, $6la50.messages).trello_list),
                        value: additionalMeta
                    },
                    closed: closed,
                    url: url,
                    isPreviewOnTrelloSearchResultsEnabled: features?.isPreviewOnTrelloSearchResultsEnabled,
                    isColorBlindModeEnabled: features?.isColorBlindModeEnabled,
                    screen: args?.screen,
                    onResultClick: resultOnClick
                });
            }
        };
    }, [
        features?.isColorBlindModeEnabled,
        features?.isPreviewOnTrelloSearchResultsEnabled,
        formatMessage,
        resultOnClick
    ]);
    const sections = (0, $gwFzn.useMemo)(()=>{
        return features?.isCardResultsSectionFirst ? [
            cardSection,
            {
                ...boardSection,
                viewAllLinkGenerator: trelloGenerateAdvancedSearchUrl
            }
        ] : [
            boardSection,
            {
                ...cardSection,
                viewAllLinkGenerator: trelloGenerateAdvancedSearchUrl
            }
        ];
    }, [
        boardSection,
        cardSection,
        features?.isCardResultsSectionFirst,
        trelloGenerateAdvancedSearchUrl
    ]);
    const itemSuppliers = (0, $5CiaV.useDefaultSuppliers)((0, $3Oi7g.TRELLO_PRODUCT_ID), sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    const preQuerySectionTitleGenerator = (0, $gwFzn.useCallback)((section)=>section.id === (0, $3Oi7g.TrelloScope).Board ? formatMessage((0, $6la50.messages).trello_recent_boards_heading) : '', [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5cba.SearchDialogProduct), {
        id: (0, $3Oi7g.TRELLO_PRODUCT_ID),
        expandedStateInputPlaceholder: formatMessage((0, $6la50.messages).trello_expanded_input_placeholder),
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
        generateAdvancedSearchUrl: trelloGenerateAdvancedSearchUrl,
        sections: sections,
        title: formatMessage((0, $bF0iL.messages).trello_tab_label),
        ...rest,
        ...itemSuppliers,
        children: (props)=>{
            return features?.isCardResultsSectionFirst ? {
                Footer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $buUFy.TrelloFooter), {
                        feedbackUrl: feedbackUrl,
                        urlGeneratorForNoResultsScreen: trelloGenerateAdvancedSearchUrl,
                        linkComponent: props.linkComponent,
                        showAtlassianHomeSearchLink: !!showAtlassianHomeSearchLink
                    }),
                Body: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($ab7ced8b5c4b8113$var$TrelloBodyAsync, {
                        ...props
                    })
            } : {
                Footer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $buUFy.TrelloFooter), {
                        feedbackUrl: feedbackUrl,
                        urlGeneratorForNoResultsScreen: trelloGenerateAdvancedSearchUrl,
                        linkComponent: props.linkComponent,
                        showAtlassianHomeSearchLink: !!showAtlassianHomeSearchLink
                    })
            };
        }
    });
};

});
parcelRegister("6la50", function(module, exports) {

$parcel$export(module.exports, "messages", () => $97d7736b9ea01187$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $97d7736b9ea01187$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /**
   * Trello
   */ trello_archived: {
        id: "product_search_dialog.trello.archived",
        defaultMessage: "Archived"
    },
    trello_archived_card_hover: {
        id: "product_search_dialog.trello.archived.card-hover",
        defaultMessage: "This card is archived"
    },
    trello_board: {
        id: "product_search_dialog.trello.board",
        defaultMessage: "Board"
    },
    trello_closed: {
        id: "product_search_dialog.trello.closed",
        defaultMessage: "Closed"
    },
    trello_closed_board_hover: {
        id: "product_search_dialog.trello.closed.board-hover",
        defaultMessage: "This board is closed"
    },
    trello_list: {
        id: "product_search_dialog.trello.list",
        defaultMessage: "List"
    },
    trello_workspace: {
        id: "product_search_dialog.trello.workspace",
        defaultMessage: "Workspace"
    },
    trello_private_workspace: {
        id: "product_search_dialog.trello.private_workspace",
        defaultMessage: "Private Workspace"
    },
    trello_expanded_input_placeholder: {
        id: "product_search_dialog.trello.expanded.input-placeholder",
        defaultMessage: "Search Trello"
    },
    trello_recent_boards_heading: {
        id: "product_search_dialog.trello.recent_boards_heading",
        defaultMessage: "Recent boards"
    },
    trello_boards_heading: {
        id: "product_search_dialog.trello.boards_heading",
        defaultMessage: "Boards"
    },
    trello_cards_heading: {
        id: "product_search_dialog.trello.cards_heading",
        defaultMessage: "Cards"
    },
    trello_feedback_link: {
        id: "product_search_dialog.trello.feedback_link",
        defaultMessage: "Help us improve your search results!"
    }
});

});

parcelRegister("tFil7", function(module, exports) {

$parcel$export(module.exports, "TrelloSearchResultComponent", () => $bdbfd4cb99d517f5$export$995a33bac606d212);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $5tPRL = parcelRequire("5tPRL");

var $6la50 = parcelRequire("6la50");

var $7dypi = parcelRequire("7dypi");

var $aJ5e0 = parcelRequire("aJ5e0");

var $2Loy2 = parcelRequire("2Loy2");
const $bdbfd4cb99d517f5$export$995a33bac606d212 = ({ id: id, title: title, url: url, prefs: prefs, meta: meta, additionalMeta: additionalMeta, closed: closed, isPreviewOnTrelloSearchResultsEnabled: isPreviewOnTrelloSearchResultsEnabled, isColorBlindModeEnabled: isColorBlindModeEnabled, screen: screen, onResultClick: onResultClick })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const isBoard = Boolean(prefs);
    const type = (0, $gwFzn.useMemo)(()=>isBoard ? 'board' : 'card', [
        isBoard
    ]);
    const metaValue = (0, $gwFzn.useMemo)(()=>isBoard && !meta.value ? formatMessage((0, $6la50.messages).trello_private_workspace) : meta.value, [
        formatMessage,
        isBoard,
        meta.value
    ]);
    const resultContentWrapperOnClick = (0, $gwFzn.useCallback)(()=>{
        if (onResultClick !== undefined) onResultClick();
    }, [
        onResultClick
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Loy2.HoverPreviewsResultWrapper), {
        id: id,
        title: title,
        url: url,
        prefs: prefs,
        meta: meta,
        additionalMeta: additionalMeta,
        closed: closed,
        type: type,
        isPreviewOnTrelloSearchResultsEnabled: isPreviewOnTrelloSearchResultsEnabled,
        isColorBlindModeEnabled: isColorBlindModeEnabled,
        screen: screen,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.ResultContentWrapper), {
            isCollapsed: true,
            onClick: resultContentWrapperOnClick,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.IconContainer), {
                    children: isBoard && prefs ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aJ5e0.BoardIcon), {
                        id: id,
                        name: title,
                        url: url,
                        prefs: prefs
                    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aJ5e0.CardIcon), {})
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.CollapsedResultContentWrapper), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.ResultTitleContainer), {
                            isCollapsed: true,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                                title: !isPreviewOnTrelloSearchResultsEnabled ? title : undefined,
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7dypi.CollapsedResultDetailWrapper), {
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7dypi.BoardAndListCol), {
                                    children: [
                                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7dypi.BoardAndListDetail), {
                                            title: !isPreviewOnTrelloSearchResultsEnabled ? `${meta.title}: ${metaValue}` : undefined,
                                            children: metaValue
                                        }),
                                        additionalMeta ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7dypi.BoardAndListDetail), {
                                            title: !isPreviewOnTrelloSearchResultsEnabled ? `${additionalMeta.title}: ${additionalMeta.value}` : undefined,
                                            children: [
                                                ": ",
                                                additionalMeta.value
                                            ]
                                        }) : null
                                    ]
                                }),
                                closed ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7dypi.ArchivedCol), {
                                    title: !isPreviewOnTrelloSearchResultsEnabled ? isBoard ? formatMessage((0, $6la50.messages).trello_closed_board_hover) : formatMessage((0, $6la50.messages).trello_archived_card_hover) : undefined,
                                    children: [
                                        "\u2022 ",
                                        isBoard ? formatMessage((0, $6la50.messages).trello_closed) : formatMessage((0, $6la50.messages).trello_archived)
                                    ]
                                }) : null
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("7dypi", function(module, exports) {

$parcel$export(module.exports, "BoardAndListCol", () => $c143c0027bdf6a89$export$14ccea95a01eec04);
$parcel$export(module.exports, "BoardAndListDetail", () => $c143c0027bdf6a89$export$67495cfd95013c39);
$parcel$export(module.exports, "ArchivedCol", () => $c143c0027bdf6a89$export$cd22da1a99fcf7b1);
$parcel$export(module.exports, "CollapsedResultDetailWrapper", () => $c143c0027bdf6a89$export$43a2b5c94cb85d9c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $c143c0027bdf6a89$export$14ccea95a01eec04 = (0, $gwrgp.default)("div", {
    target: "e1rjmdl20"
})({
    name: "s88hxx",
    styles: "display:flex;overflow:hidden;"
});
const $c143c0027bdf6a89$export$67495cfd95013c39 = (0, $gwrgp.default)("div", {
    target: "e1rjmdl21"
})({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: '5%',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`
});
const $c143c0027bdf6a89$export$cd22da1a99fcf7b1 = (0, $gwrgp.default)("div", {
    target: "e1rjmdl22"
})({
    marginLeft: "var(--ds-space-050, 4px)",
    flexShrink: 0,
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`
});
const $c143c0027bdf6a89$export$43a2b5c94cb85d9c = (0, $gwrgp.default)("div", {
    target: "e1rjmdl23"
})({
    name: "k008qs",
    styles: "display:flex;"
});

});

parcelRegister("aJ5e0", function(module, exports) {

$parcel$export(module.exports, "getCardIconUrl", () => $d7612f6af24b36cb$export$d00fcd959e6e6c2b);
$parcel$export(module.exports, "getBoardIconUrl", () => $d7612f6af24b36cb$export$419622b78ee4bd67);
$parcel$export(module.exports, "BoardIcon", () => $d7612f6af24b36cb$export$2f9da8868573b55d);
$parcel$export(module.exports, "CardIcon", () => $d7612f6af24b36cb$export$f4619d70a16e5ea0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dTk3A = parcelRequire("dTk3A");

var $6fnsQ = parcelRequire("6fnsQ");

var $1To4a = parcelRequire("1To4a");

var $gwrgp = parcelRequire("gwrgp");
const $d7612f6af24b36cb$var$baseStyle = {
    display: 'flex',
    // hack around IconContainer styles
    flexShrink: 0,
    // hack around IconContainer styles
    borderRadius: '2px',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
};
const $d7612f6af24b36cb$export$d00fcd959e6e6c2b = ()=>{
    const iconColor = (0, $1To4a.default)('color.icon', (0, $6fnsQ.N800));
    return `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.66667 0C1.19391 0 0 1.19391 0 2.66667V16C0 17.4728 1.19391 18.6667 2.66667 18.6667H21.3333C22.8061 18.6667 24 17.4728 24 16V2.66667C24 1.19391 22.8061 0 21.3333 0H2.66667ZM21.3333 2.66667H2.66667V10.6667H21.3333V2.66667ZM18.6667 14.6667C18.6667 15.403 19.2636 16 20 16C20.7364 16 21.3333 15.403 21.3333 14.6667C21.3333 13.9303 20.7364 13.3333 20 13.3333C19.2636 13.3333 18.6667 13.9303 18.6667 14.6667ZM4 16C3.26362 16 2.66667 15.403 2.66667 14.6667C2.66667 13.9303 3.26362 13.3333 4 13.3333H9.33333C10.0697 13.3333 10.6667 13.9303 10.6667 14.6667C10.6667 15.403 10.0697 16 9.33333 16H4Z" fill="${iconColor}"/></svg>`)}`;
};
const $d7612f6af24b36cb$export$419622b78ee4bd67 = ()=>{
    const iconColor = (0, $1To4a.default)('color.icon', (0, $6fnsQ.N800));
    return `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.77778C0 0.795938 0.795938 0 1.77778 0H14.2222C15.2041 0 16 0.795938 16 1.77778V14.2222C16 15.2041 15.2041 16 14.2222 16H1.77778C0.795938 16 0 15.2041 0 14.2222V1.77778ZM1.77778 2.66667C1.77778 2.17575 2.17575 1.77778 2.66667 1.77778H6.22222C6.71314 1.77778 7.11111 2.17575 7.11111 2.66667V11.5556C7.11111 12.0465 6.71314 12.4444 6.22222 12.4444H2.66667C2.17575 12.4444 1.77778 12.0465 1.77778 11.5556V2.66667ZM9.77778 1.77778C9.28686 1.77778 8.88889 2.17575 8.88889 2.66667V8C8.88889 8.49092 9.28686 8.88889 9.77778 8.88889H13.3333C13.8243 8.88889 14.2222 8.49092 14.2222 8V2.66667C14.2222 2.17575 13.8243 1.77778 13.3333 1.77778H9.77778Z" fill="${iconColor}"/></svg>`)}`;
};
const $d7612f6af24b36cb$export$2f9da8868573b55d = (0, $gwrgp.default)("span", {
    target: "est758s0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ prefs: { backgroundImageScaled: backgroundImageScaled, backgroundImage: backgroundImage, backgroundColor: backgroundColor } })=>{
    const boardUrl = backgroundImageScaled?.[0]?.url || backgroundImage;
    if (boardUrl) return {
        ...$d7612f6af24b36cb$var$baseStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        height: `${(0, $dTk3A.gridSize)() * 3}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        width: `${(0, $dTk3A.gridSize)() * 3}px`,
        backgroundImage: `url(${boardUrl})`
    };
    return {
        ...$d7612f6af24b36cb$var$baseStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        height: `${(0, $dTk3A.gridSize)() * 3}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        width: `${(0, $dTk3A.gridSize)() * 3}px`,
        backgroundColor: backgroundColor || `var(--ds-background-neutral, ${0, $6fnsQ.N40})`
    };
});
const $d7612f6af24b36cb$export$f4619d70a16e5ea0 = (0, $gwrgp.default)("span", {
    target: "est758s1"
})(()=>{
    return {
        ...$d7612f6af24b36cb$var$baseStyle,
        height: `19px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        width: `${(0, $dTk3A.gridSize)() * 3}px`,
        marginBottom: "var(--ds-space-100, 8px)",
        backgroundImage: `url(${$d7612f6af24b36cb$export$d00fcd959e6e6c2b()})`
    };
});

});

parcelRegister("2Loy2", function(module, exports) {

$parcel$export(module.exports, "HoverPreviewsResultWrapper", () => $d89a9a3c06a88b05$export$5662bd1eb353c490);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $k51fz = parcelRequire("k51fz");

const $d89a9a3c06a88b05$var$TrelloPopperAsync = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("lLdkS")).then(({ TrelloPopper: TrelloPopper })=>({
            default: TrelloPopper
        })));
const $d89a9a3c06a88b05$export$5662bd1eb353c490 = ({ id: id, title: title, prefs: prefs, meta: meta, additionalMeta: additionalMeta, closed: closed, type: type, children: children, isColorBlindModeEnabled: isColorBlindModeEnabled, isPreviewOnTrelloSearchResultsEnabled: isPreviewOnTrelloSearchResultsEnabled, screen: screen })=>{
    const { getCard: getCard } = (0, $k51fz.useTrelloCard)();
    const [result, setResult] = (0, $gwFzn.useState)();
    const onFetchCard = (0, $gwFzn.useCallback)(async ()=>{
        const card = await getCard(id);
        if (card) setResult({
            ...card,
            type: 'card',
            id: id,
            title: title,
            closed: closed,
            meta: meta,
            additionalMeta: additionalMeta,
            screen: screen
        });
    }, [
        getCard,
        id,
        title,
        closed,
        meta,
        screen,
        additionalMeta
    ]);
    const onFetchBoard = (0, $gwFzn.useCallback)(()=>{
        if (prefs) setResult({
            type: 'board',
            id: id,
            title: title,
            prefs: prefs,
            meta: meta,
            closed: closed,
            screen: screen
        });
    }, [
        id,
        title,
        prefs,
        meta,
        closed,
        screen
    ]);
    if (!isPreviewOnTrelloSearchResultsEnabled) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($d89a9a3c06a88b05$var$TrelloPopperAsync, {
            type: type,
            result: result,
            onFetchCard: onFetchCard,
            onFetchBoard: onFetchBoard,
            isColorBlindModeEnabled: isColorBlindModeEnabled,
            screen: screen,
            children: children
        })
    });
};

});
parcelRegister("k51fz", function(module, exports) {

$parcel$export(module.exports, "useTrelloCard", () => $2ab6392a5ef0ce9c$export$167729b86606a89e);

var $gwFzn = parcelRequire("gwFzn");

var $6dP89 = parcelRequire("6dP89");

var $5dFS9 = parcelRequire("5dFS9");
const $2ab6392a5ef0ce9c$var$cards = new Map();
const $2ab6392a5ef0ce9c$export$167729b86606a89e = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const loadCard = (0, $gwFzn.useCallback)(async (cardId)=>{
        try {
            const response = await fetch(`/1/card/${cardId}?fields=name,closed,url,cover,labels,idAttachmentCover&attachments=cover`);
            if (response.ok) {
                const cardResponse = await response.json();
                $2ab6392a5ef0ce9c$var$cards.set(cardId, cardResponse);
                return cardResponse;
            } else throw new Error(`Invalid response: ${response?.status}`);
        } catch (e) {
            if (e instanceof Error) fireAnalyticsEvent({
                ...(0, $5dFS9.onCardRequestFailed)({
                    attributes: {
                        errorMsg: e?.message,
                        errorName: e?.name
                    }
                })
            });
        }
    }, [
        fireAnalyticsEvent
    ]);
    const getCard = (0, $gwFzn.useCallback)(async (cardId)=>{
        return $2ab6392a5ef0ce9c$var$cards.get(cardId) ? Promise.resolve($2ab6392a5ef0ce9c$var$cards.get(cardId)) : loadCard(cardId);
    }, [
        loadCard
    ]);
    return {
        getCard: getCard
    };
};

});

parcelRegister("lLdkS", function(module, exports) {

let $fd7854fa35af28a9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fd7854fa35af28a9$var$load("2exA8").then(()=>parcelRequire('iiIdc'));

});



parcelRegister("buUFy", function(module, exports) {

$parcel$export(module.exports, "TrelloFooter", () => $24ad7b08697a57d9$export$c139d851a817966);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $crAJ1 = parcelRequire("crAJ1");

var $6la50 = parcelRequire("6la50");

var $4mZlP = parcelRequire("4mZlP");

var $aGmCb = parcelRequire("aGmCb");

var $iEwUU = parcelRequire("iEwUU");

var $3Z7LN = parcelRequire("3Z7LN");

var $4mZlP = parcelRequire("4mZlP");

var $kmpep = parcelRequire("kmpep");
const $24ad7b08697a57d9$export$c139d851a817966 = ({ feedbackUrl: feedbackUrl, showAtlassianHomeSearchLink: showAtlassianHomeSearchLink, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $aGmCb.SearchFooterWrapper), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.AdvancedSearchFooter), {
                ...rest,
                returnKeyIconComponent: showAtlassianHomeSearchLink ? ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.ReturnIconWithModifier), {}) : undefined
            }),
            showAtlassianHomeSearchLink && orgId && cloudId && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Z7LN.AtlassianHomeSearchLink), {
                    orgId: orgId,
                    cloudId: cloudId,
                    showModifierIcon: true
                })
            }),
            feedbackUrl && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aGmCb.FeedbackLinkWrapper), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aGmCb.FeedbackLink), {
                    appearance: "subtle-link",
                    href: feedbackUrl,
                    target: "_blank",
                    children: formatMessage((0, $6la50.messages).trello_feedback_link)
                })
            })
        ]
    });
};

});
parcelRegister("aGmCb", function(module, exports) {

$parcel$export(module.exports, "FeedbackLinkWrapper", () => $7ef4a4349ad50bfd$export$b68f382ed631ffe5);
$parcel$export(module.exports, "FeedbackLink", () => $7ef4a4349ad50bfd$export$4d44d7534024e0b6);
$parcel$export(module.exports, "SearchFooterWrapper", () => $7ef4a4349ad50bfd$export$a6be8d069f8a5fb4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $crAJ1 = parcelRequire("crAJ1");

var $eEA8O = parcelRequire("eEA8O");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $7ef4a4349ad50bfd$export$b68f382ed631ffe5 = (0, $gwrgp.default)("div", {
    target: "evrkq7c0"
})({
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N20)})`,
    padding: `${"var(--ds-space-050, 4px)"} 0`
});
const $7ef4a4349ad50bfd$export$4d44d7534024e0b6 = /*#__PURE__*/ (0, $gwrgp.default)((0, $eEA8O.default), {
    target: "evrkq7c1"
})("&&{text-decoration:underline;&:hover{color:", `var(--ds-link-pressed, ${(0, $6fnsQ.N900)})`, " !important;}}");
const $7ef4a4349ad50bfd$export$a6be8d069f8a5fb4 = /*#__PURE__*/ (0, $gwrgp.default)((0, $crAJ1.SearchFooter), {
    target: "evrkq7c2"
})({
    name: "1g4yje1",
    styles: "display:flex;flex-direction:column;height:100%;"
});

});


parcelRegister("3Oi7g", function(module, exports) {

$parcel$export(module.exports, "TRELLO_PRODUCT_ID", () => $f671aeb58cfbd736$export$4788c0ef19dba72f);
$parcel$export(module.exports, "TrelloScope", () => $f671aeb58cfbd736$export$1f420d5694f8d5b3);
const $f671aeb58cfbd736$export$4788c0ef19dba72f = 'trello';
var $f671aeb58cfbd736$export$1f420d5694f8d5b3 = /*#__PURE__*/ function(TrelloScope) {
    TrelloScope["Board"] = "trello.board";
    TrelloScope["Card"] = "trello.card";
    return TrelloScope;
}({});

});

parcelRegister("46uIy", function(module, exports) {

$parcel$export(module.exports, "viewAllLinkGenerator", () => $8cadf475bb862c29$export$28a2ffcf7191490b);
const $8cadf475bb862c29$var$getBaseUrl = ()=>{
    const hostname = window?.location?.hostname;
    if (hostname?.includes('jira-dev.com') || hostname?.startsWith('trellis.coffee') || hostname?.startsWith('localhost') || hostname?.startsWith('team.stg')) return 'https://trellis.coffee';
    return 'https://trello.com';
};
const $8cadf475bb862c29$export$28a2ffcf7191490b = (query)=>query ? `${$8cadf475bb862c29$var$getBaseUrl()}/search?q=${encodeURIComponent(query)}` : `${$8cadf475bb862c29$var$getBaseUrl()}/search`;

});

parcelRegister("b5eQ2", function(module, exports) {

let $811babe61bfc5824$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $811babe61bfc5824$var$load("eVnxm").then(()=>parcelRequire('5MSS3'));

});


parcelRegister("4pEo5", function(module, exports) {

$parcel$export(module.exports, "ConfluenceQuickFind", () => $86415052597ff71d$export$2c1361e70d618a59);

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $OjoBn = parcelRequire("OjoBn");

var $7Sm4c = parcelRequire("7Sm4c");

var $jlIaF = parcelRequire("jlIaF");
const $86415052597ff71d$export$2c1361e70d618a59 = ({ cloudId: cloudId, orgId: orgId, theme: theme, isExpanded: isExpanded, setIsExpanded: setIsExpanded, aggregatorUrl: aggregatorUrl, user: user, forwardRef: forwardRef, onNavigateGeneric: onNavigateGeneric, linkComponent: linkComponent, shouldFillContainer: shouldFillContainer, isRovoEnabled: isRovoEnabled, isGriffinNavEnabled: isGriffinNavEnabled, queryParams: queryParams })=>{
    const confCloudClient = (0, $diswb.useApolloClient)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $OjoBn.QuickFind), {
        theme: theme,
        linkComponent: linkComponent,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        abTestCloudId: cloudId,
        aggregatorUrl: aggregatorUrl,
        user: user,
        forwardRef: forwardRef,
        onNavigateGeneric: onNavigateGeneric,
        recentClientConfig: {
            url: (0, $jlIaF.CONTEXT_PATH),
            cloudId: cloudId,
            isCollaborationGraphEnabled: false,
            collaborationGraphUrl: '/gateway/api/collaboration',
            isUserAnonymous: !user?.id
        },
        confCloudClient: confCloudClient,
        onPreQueryErrorCallback: (0, $7Sm4c.markErrorAsHandled),
        cloudId: cloudId,
        orgId: orgId,
        primaryProduct: "confluence",
        shouldFillContainer: shouldFillContainer,
        isRovoEnabled: isRovoEnabled,
        dialogFeatures: {
            isGriffinNavEnabled: isGriffinNavEnabled
        },
        queryParams: queryParams
    });
};

});
parcelRegister("OjoBn", function(module, exports) {

$parcel$export(module.exports, "QuickFind", () => $5b7db3266f705bf2$export$7d842d92e2721710);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $k19N9 = parcelRequire("k19N9");

var $f0f3d = parcelRequire("f0f3d");
const $5b7db3266f705bf2$export$7d842d92e2721710 = ({ dialogFeatures: dialogFeatures, postQueryDisabled: postQueryDisabled, ...rest })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k19N9.MultiProductDialog), {
        dialogFeatures: {
            ...dialogFeatures,
            quickFind: {
                enabled: true,
                postQueryDisabled: postQueryDisabled
            }
        },
        ...rest,
        children: ({ onRetry: onRetry })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $f0f3d.QuickFindConfluence), {
                ...rest,
                onRetry: onRetry
            })
    });
};

});


parcelRegister("2VPmd", function(module, exports) {

$parcel$export(module.exports, "ConfluenceResultRenderer", () => $7b25068d4e2f79dd$export$bba16a2668c13d43);

var $dBxQj = parcelRequire("dBxQj");

var $ejGzS = parcelRequire("ejGzS");

var $fib1y = parcelRequire("fib1y");

var $g0lm5 = parcelRequire("g0lm5");
const $7b25068d4e2f79dd$export$bba16a2668c13d43 = ({ searchResult: searchResult, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { productState: productState } = rest;
    // REST API stores recent content type as meta data
    const contentType = searchResult.additionalMeta && typeof searchResult.additionalMeta === 'string' ? searchResult.additionalMeta || '' : searchResult.icon || '';
    // AFE does not return newer content type icons (i.e whiteboard/database) so we render it here
    const renderContentIcon = ()=>{
        if (searchResult?.type === 'whiteboard' || searchResult.icon === 'whiteboard') return (0, $g0lm5.ContentIconRenderer)({
            type: 'whiteboard',
            title: searchResult.title
        }) || '';
        if (searchResult?.type === 'database' || searchResult.icon === 'database') return (0, $g0lm5.ContentIconRenderer)({
            type: 'database',
            title: searchResult.title
        }) || '';
        if (searchResult?.type === 'embed' || searchResult.icon === 'embed') return (0, $g0lm5.ContentIconRenderer)({
            type: 'embed',
            title: searchResult.title
        }) || '';
        if (searchResult?.type === 'folder' || searchResult.icon === 'folder') return (0, $g0lm5.ContentIconRenderer)({
            type: 'folder',
            title: searchResult.title
        }) || '';
        return searchResult.icon;
    };
    if (productState === 'PreQuerySuccess') return (0, $ejGzS.defaultResultRenderer)({
        ...rest,
        searchResult: {
            ...searchResult,
            additionalMeta: undefined,
            icon: (0, $g0lm5.ContentIconRenderer)({
                type: contentType,
                title: searchResult.title || '',
                size: 'small'
            })
        }
    });
    if (productState === 'PostQueryTyping' || productState === 'PostQueryLoading' || productState === 'PostQuerySuccess') return (0, $ejGzS.defaultResultRenderer)({
        ...rest,
        searchResult: {
            ...searchResult,
            additionalMeta: !!searchResult.isRecentResult ? formatMessage((0, $fib1y.i18n).recentlyViewed) : searchResult.additionalMeta,
            icon: !!searchResult.isRecentResult ? (0, $g0lm5.ContentIconRenderer)({
                type: contentType,
                title: searchResult.title || ''
            }) : renderContentIcon()
        }
    });
    return (0, $ejGzS.defaultResultRenderer)({
        searchResult: searchResult,
        ...rest
    });
};

});
parcelRegister("fib1y", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $a33223da5daebf45$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $a33223da5daebf45$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    recentlyWorkedOn: {
        id: "navigation-search-dialog.suppliers.recentlyWorkedOn",
        defaultMessage: "Recently worked on"
    },
    recentlyViewed: {
        id: "navigation-search-dialog.suppliers.recentlyViewed",
        defaultMessage: "Recently viewed"
    },
    contents: {
        id: "navigation-search-dialog.suppliers.contents",
        defaultMessage: "Content"
    },
    spaces: {
        id: "navigation-search-dialog.suppliers.spaces",
        defaultMessage: "Spaces"
    },
    people: {
        id: "navigation-search-dialog.suppliers.people",
        defaultMessage: "People"
    },
    confluenceSpace: {
        id: "navigation-search-dialog.quickfind.confluenceSpace",
        defaultMessage: "Confluence Space"
    },
    team: {
        id: "navigation-search-dialog.team",
        defaultMessage: "Team"
    }
});

});

parcelRegister("g0lm5", function(module, exports) {

$parcel$export(module.exports, "ContentIconRenderer", () => $6460b69e49ab179f$export$bf56fa242f0fc37d);
$parcel$export(module.exports, "GenericIconRenderer", () => $6460b69e49ab179f$export$e5d849fb708254a9);
/* IconRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $gj7hi = parcelRequire("gj7hi");

var $esRft = parcelRequire("esRft");

var $13WX1 = parcelRequire("13WX1");

var $5yCDo = parcelRequire("5yCDo");

var $hxQwS = parcelRequire("hxQwS");

var $bueVT = parcelRequire("bueVT");

var $8DZd1 = parcelRequire("8DZd1");

var $djgQ6 = parcelRequire("djgQ6");

var $2v58P = parcelRequire("2v58P");

var $8WOej = parcelRequire("8WOej");

var $33kwL = parcelRequire("33kwL");
const $6460b69e49ab179f$var$NegativeMargin = null;
const $6460b69e49ab179f$export$bf56fa242f0fc37d = ({ type: type, title: title, iconCssClass: iconCssClass, size: size = 'medium', imageSrc: imageSrc })=>{
    if (type === 'page' || type === 'confluence-page' || type === 'content') {
        const Icon = size === 'medium' ? (0, $5yCDo.default) : (0, $13WX1.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Icon, {
            label: type
        });
    } else if (type === 'blogpost' || type === 'confluence-blogpost') {
        const Icon = size === 'medium' ? (0, $bueVT.default) : (0, $hxQwS.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Icon, {
            label: type
        });
    } else if (type === 'whiteboard') // CTIA-142 - This will be swapped out when AK supports the whiteboard icon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $33kwL.LegacyContentIcon), {
        size: size,
        type: "whiteboard",
        label: type
    });
    else if (type === 'database') // CTIA-142 - This will be swapped out when AK supports the database icon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $33kwL.LegacyContentIcon), {
        size: size,
        type: "database",
        label: type
    });
    else if (type === 'embed') // CTIA-142 - This will be swapped out when AK supports the embed icon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $33kwL.LegacyContentIcon), {
        size: size,
        type: "embed",
        label: type
    });
    else if (type === 'folder') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $33kwL.LegacyContentIcon), {
        size: size,
        type: "folder",
        label: type
    });
    else if (type === 'jira') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2v58P.default), {
        label: type
    });
    else if (type === 'atlas') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gj7hi.default), {
        src: imageSrc || '',
        "aria-label": type,
        alt: type,
        width: "24px",
        height: "24px"
    });
    else if (type === 'attachment') {
        if (!iconCssClass) {
            const Icon = size === 'medium' ? (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6))) : (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Icon, {
                label: type
            });
        } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8WOej.AttachmentIcon), {
            mediaType: iconCssClass,
            title: title,
            size: size,
            label: type
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null);
};
const $6460b69e49ab179f$export$e5d849fb708254a9 = ({ iconUrl: iconUrl, size: size = 'small', appearance: appearance = 'square' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_18s81i6y _1e0c1txw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $esRft.default), {
        size: size,
        borderColor: "transparent",
        src: iconUrl,
        appearance: appearance,
        testId: "result-avatar"
    }));

});
parcelRegister("8WOej", function(module, exports) {

$parcel$export(module.exports, "getMediaType", () => $403c9cfb5b020557$export$2063a590c0694ba8);
$parcel$export(module.exports, "AttachmentIcon", () => $403c9cfb5b020557$export$edc04f92718bbea4);

var $gwFzn = parcelRequire("gwFzn");

var $dlbUV = parcelRequire("dlbUV");

var $fX9Sa = parcelRequire("fX9Sa");

var $d4cCP = parcelRequire("d4cCP");

var $gguok = parcelRequire("gguok");

var $d8Kpd = parcelRequire("d8Kpd");

var $gH8Rx = parcelRequire("gH8Rx");

var $8DZd1 = parcelRequire("8DZd1");

var $djgQ6 = parcelRequire("djgQ6");

var $d5BUD = parcelRequire("d5BUD");

var $b4DX7 = parcelRequire("b4DX7");

var $41GKb = parcelRequire("41GKb");

var $20uDq = parcelRequire("20uDq");

var $11LZV = parcelRequire("11LZV");

var $lzyQK = parcelRequire("lzyQK");

var $hY1Uy = parcelRequire("hY1Uy");

var $dfQbH = parcelRequire("dfQbH");

var $1iV2p = parcelRequire("1iV2p");

var $7t8Pn = parcelRequire("7t8Pn");

var $ayTrS = parcelRequire("ayTrS");

var $hXc8o = parcelRequire("hXc8o");

var $90Icb = parcelRequire("90Icb");

var $lkBga = parcelRequire("lkBga");
const $403c9cfb5b020557$export$c647cb0ee6e282fe = [
    'small',
    'medium'
];
const $403c9cfb5b020557$var$AttachmentFileExtensionMatchers = [
    {
        regexp: /\.(pdf)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($11LZV))),
            (0, (/*@__PURE__*/$parcel$interopDefault($lzyQK)))
        ]
    },
    {
        regexp: /\.(gif)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($d5BUD))),
            (0, (/*@__PURE__*/$parcel$interopDefault($b4DX7)))
        ]
    },
    {
        regexp: /\.(jpeg|jpg|png)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($41GKb))),
            (0, (/*@__PURE__*/$parcel$interopDefault($20uDq)))
        ]
    },
    {
        regexp: /\.(xml|html|js|css|java|jar|war|ear)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($1iV2p))),
            (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
        ]
    },
    {
        regexp: /\.(zip|tar|gz|bz2|rar)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
            (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa)))
        ]
    },
    {
        regexp: /\.(xlt|xls|xlsm|xlsx|xlst)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($d8Kpd))),
            (0, (/*@__PURE__*/$parcel$interopDefault($gH8Rx)))
        ]
    },
    {
        regexp: /\.(pptx|ppsx|potx|pot|ppt|pptm)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($hY1Uy))),
            (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
        ]
    },
    {
        regexp: /\.(docx|dotx|doc|dot)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($90Icb))),
            (0, (/*@__PURE__*/$parcel$interopDefault($lkBga)))
        ]
    },
    {
        regexp: /\.(wma|wmv|ram|mp3)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
            (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
        ]
    },
    {
        regexp: /\.(mov|mpeg|mpg|mp4|avi)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
            (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o)))
        ]
    }
];
const $403c9cfb5b020557$export$724dbd38c6f8ef0 = {
    'application/pdf': [
        (0, (/*@__PURE__*/$parcel$interopDefault($11LZV))),
        (0, (/*@__PURE__*/$parcel$interopDefault($lzyQK)))
    ],
    'image/gif': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d5BUD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($b4DX7)))
    ],
    'image/jpeg': [
        (0, (/*@__PURE__*/$parcel$interopDefault($41GKb))),
        (0, (/*@__PURE__*/$parcel$interopDefault($20uDq)))
    ],
    'image/png': [
        (0, (/*@__PURE__*/$parcel$interopDefault($41GKb))),
        (0, (/*@__PURE__*/$parcel$interopDefault($20uDq)))
    ],
    'text/xml': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1iV2p))),
        (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
    ],
    'text/html': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1iV2p))),
        (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
    ],
    'text/css': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1iV2p))),
        (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
    ],
    'text/javascript': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1iV2p))),
        (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
    ],
    'text/plain': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1))),
        (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)))
    ],
    //NEED TO GIVE THIS AN ICON,
    'application/zip': [
        (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa)))
    ],
    'application/x-zip': [
        (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa)))
    ],
    'application/x-zip-compressed': [
        (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa)))
    ],
    'application/java-archive': [
        (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa)))
    ],
    'application/vnd.ms-excel': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d8Kpd))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gH8Rx)))
    ],
    'application/vnd.ms-powerpoint': [
        (0, (/*@__PURE__*/$parcel$interopDefault($hY1Uy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
    ],
    'application/msword': [
        (0, (/*@__PURE__*/$parcel$interopDefault($90Icb))),
        (0, (/*@__PURE__*/$parcel$interopDefault($lkBga)))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d8Kpd))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gH8Rx)))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d8Kpd))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gH8Rx)))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
        (0, (/*@__PURE__*/$parcel$interopDefault($hY1Uy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow': [
        (0, (/*@__PURE__*/$parcel$interopDefault($hY1Uy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.template': [
        (0, (/*@__PURE__*/$parcel$interopDefault($hY1Uy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        (0, (/*@__PURE__*/$parcel$interopDefault($90Icb))),
        (0, (/*@__PURE__*/$parcel$interopDefault($lkBga)))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template': [
        (0, (/*@__PURE__*/$parcel$interopDefault($90Icb))),
        (0, (/*@__PURE__*/$parcel$interopDefault($lkBga)))
    ],
    'application/x-shockwave-flash': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1))),
        (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)))
    ],
    //NEED TO GIVE THIS AN ICON
    'video/quicktime': [
        (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
        (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o)))
    ],
    'audio/x-ms-wma': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
    ],
    'audio/x-ms-wmv': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
    ],
    'video/mpeg': [
        (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
        (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o)))
    ],
    'audio/x-pn-realaudio': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
    ],
    'application/vnd.rn-realmedia': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1))),
        (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)))
    ],
    //NEED TO GIVE THIS AN ICON
    'audio/mpeg': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
    ],
    'video/x-msvideo': [
        (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
        (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o)))
    ],
    'video/mp4': [
        (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
        (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o)))
    ],
    'audio/mp4': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
    ],
    'audio/mp3': [
        (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
    ],
    default: [
        (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1))),
        (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)))
    ]
};
const $403c9cfb5b020557$export$2063a590c0694ba8 = (extensions)=>{
    if (!extensions || !Array.isArray(extensions)) return null;
    const mediaType = extensions.find(({ key: key })=>key === 'mediaType');
    return mediaType ? mediaType.value : null;
};
class $403c9cfb5b020557$export$edc04f92718bbea4 extends (0, $gwFzn.PureComponent) {
    render() {
        const { mediaType: mediaType, label: label, size: size } = this.props;
        const iconArray = this.getIconArray();
        const sizeIndex = $403c9cfb5b020557$export$c647cb0ee6e282fe.indexOf(size ?? 'medium') || 0;
        const icon = iconArray[sizeIndex];
        const testId = `attachment-icon-${mediaType?.replace('/', '-') ?? 'unknown'}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(icon, {
            size: // @ts-expect-error FIXME: `size` is not an acceptable prop here
            size,
            label: label,
            testId: testId
        });
    }
    constructor(...args){
        super(...args);
        this.getIconArray = ()=>{
            const { mediaType: mediaType, title: title } = this.props;
            if (mediaType && $403c9cfb5b020557$export$724dbd38c6f8ef0[mediaType]) return $403c9cfb5b020557$export$724dbd38c6f8ef0[mediaType];
            if (title) {
                const extension = $403c9cfb5b020557$var$AttachmentFileExtensionMatchers.find((extensionMatcher)=>{
                    const matches = extensionMatcher.regexp.exec(title);
                    return !!matches && matches.length > 0;
                });
                if (extension) return extension.icon;
            }
            return $403c9cfb5b020557$export$724dbd38c6f8ef0['default'];
        };
    }
}

});



parcelRegister("bB6dC", function(module, exports) {

$parcel$export(module.exports, "ActivitiesObjectType", () => $df938f5c6250aebc$export$4edf00fad4b97379);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $df938f5c6250aebc$export$4edf00fad4b97379 = /*#__PURE__*/ function(ActivitiesObjectType) {
    ActivitiesObjectType["BLOGPOST"] = "BLOGPOST";
    ActivitiesObjectType["DATABASE"] = "DATABASE";
    ActivitiesObjectType["EMBED"] = "EMBED";
    ActivitiesObjectType["ISSUE"] = "ISSUE";
    ActivitiesObjectType["PAGE"] = "PAGE";
    ActivitiesObjectType["WHITEBOARD"] = "WHITEBOARD";
    return ActivitiesObjectType;
}({});

});

parcelRegister("1mK5P", function(module, exports) {

$parcel$export(module.exports, "useAISearchSupplier", () => $db4dd28f79880540$export$39f60520d0d25b0e);

var $gwFzn = parcelRequire("gwFzn");

var $bHPHO = parcelRequire("bHPHO");

var $7Zbm6 = parcelRequire("7Zbm6");

var $5Ymlp = parcelRequire("5Ymlp");

var $9wGTI = parcelRequire("9wGTI");

var $bQm3c = parcelRequire("bQm3c");
const $db4dd28f79880540$export$39f60520d0d25b0e = ({ prequeryBannerEnabled: prequeryBannerEnabled, dismissPrequeryBanner: dismissPrequeryBanner })=>{
    const { cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const cloudIdARI = (0, $bHPHO.ConfluenceSiteAri).create({
        siteId: cloudId
    }).toString();
    const aiSearchStreamingFunction = (0, $gwFzn.useCallback)(({ variables: variables })=>({
            type: (0, $7Zbm6.AIAnswerAPIType).STREAM,
            stream: (0, $9wGTI.fg)('kd_sain_migrate_api') ? (0, $5Ymlp.sainStreamFetchConvoAIService)({
                variables: {
                    ...variables,
                    cloudIdARI: cloudIdARI
                },
                isReadingAids: false
            }) : (0, $5Ymlp.sainStreamFetchHandlerAssistanceService)({
                variables: {
                    ...variables,
                    cloudIdARI: cloudIdARI
                },
                isReadingAids: false
            })
        }), [
        cloudIdARI
    ]);
    return {
        aiSearchConfig: isAdminHubAIEnabled ? {
            aiSearchQueryFunction: aiSearchStreamingFunction,
            prequeryBannerEnabled: prequeryBannerEnabled,
            dismissPrequeryBanner: dismissPrequeryBanner,
            followUpsEnabled: true
        } : undefined
    };
};

});

parcelRegister("2qgZ5", function(module, exports) {

$parcel$export(module.exports, "useConfluenceItemSuppliers", () => $38ca96c4d9c67f5e$export$4c9ff87550df51de);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $diswb = parcelRequire("diswb");

var $g9GR5 = parcelRequire("g9GR5");
var $cvntw = parcelRequire("cvntw");

var $91yhh = parcelRequire("91yhh");

var $9wGTI = parcelRequire("9wGTI");

var $gKr8t = parcelRequire("gKr8t");
var $7Sm4c = parcelRequire("7Sm4c");

var $jlIaF = parcelRequire("jlIaF");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $1HFOS = parcelRequire("1HFOS");

var $g0lm5 = parcelRequire("g0lm5");

var $2VPmd = parcelRequire("2VPmd");

var $e7whT = parcelRequire("e7whT");

var $fib1y = parcelRequire("fib1y");

var $9CKbz = parcelRequire("9CKbz");
const $38ca96c4d9c67f5e$var$RECENT_CONTENTS_FETCH_LIMIT = 100;
const $38ca96c4d9c67f5e$var$RECENT_SPACE_FETCH_LIMIT = 10;
const $38ca96c4d9c67f5e$var$MAX_RESULTS_CONTENTS = 10;
const $38ca96c4d9c67f5e$var$MAX_RESULTS_SPACES = 3;
const $38ca96c4d9c67f5e$var$recentContentsCCResultMapper = (edge)=>{
    const item = edge?.node?.object?.content;
    return {
        id: item?.id || '',
        title: item?.title || '',
        type: item?.type || '',
        url: `${0, $jlIaF.CONTEXT_PATH}${item?.links?.webui || ''}`,
        meta: item?.space?.name || '',
        additionalMeta: item?.type || '',
        containerId: item?.space?.id || '',
        icon: item?.type || '',
        isRecentResult: true
    };
};
const $38ca96c4d9c67f5e$var$recentSpaceCCResultMapper = (item)=>({
        id: item?.id || '',
        title: item?.name || '',
        type: 'space',
        meta: '',
        url: `${0, $jlIaF.CONTEXT_PATH}${item?.links?.webui || ''}`,
        containerId: item?.id || undefined,
        icon: (0, $g0lm5.GenericIconRenderer)({
            iconUrl: `${(0, $jlIaF.CONTEXT_PATH)}${item?.icon?.path || ''}`,
            size: 'xsmall'
        }),
        isRecentResult: true
    });
const $38ca96c4d9c67f5e$export$4c9ff87550df51de = ({ cloudId: cloudId, userId: userId, principalId: principalId = 'context', autocorrectEnabled: autocorrectEnabled = false, isQuickSearchForWhiteboardsEnabled: isQuickSearchForWhiteboardsEnabled, isQuickSearchForDatabasesEnabled: isQuickSearchForDatabasesEnabled, objectTypes: objectTypes })=>{
    const intl = (0, $dBxQj.default)();
    const confCloudClient = (0, $diswb.useApolloClient)();
    const aggClient = (0, $gKr8t.getAGGClient)();
    const workedOnAPIEnabled = false;
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const contentEntities = (0, $gwFzn.useMemo)(()=>[
            'ati:cloud:confluence:page',
            'ati:cloud:confluence:blogpost',
            'ati:cloud:confluence:attachment',
            'ati:cloud:confluence:embed',
            'ati:cloud:confluence:folder',
            ...isQuickSearchForWhiteboardsEnabled ? [
                'ati:cloud:confluence:whiteboard'
            ] : [],
            ...isQuickSearchForDatabasesEnabled ? [
                'ati:cloud:confluence:database'
            ] : []
        ], [
        isQuickSearchForWhiteboardsEnabled,
        isQuickSearchForDatabasesEnabled
    ]);
    const preQueryItemSupplier = (0, $gwFzn.useCallback)(async ()=>{
        experienceTracker.start({
            name: (0, $irVI7.QUICK_SEARCH_PRE_QUERY)
        });
        const { recentContents: recentContents, recentSpaces: recentSpaces } = !userId ? {
            recentContents: [],
            recentSpaces: []
        } : await confCloudClient.query({
            query: (0, $e7whT.RecentQuickSearchQuery),
            variables: {
                cloudId: cloudId,
                contentItemsLimit: $38ca96c4d9c67f5e$var$RECENT_CONTENTS_FETCH_LIMIT,
                spaceLimit: $38ca96c4d9c67f5e$var$RECENT_SPACE_FETCH_LIMIT,
                objectTypes: objectTypes,
                workedOnAPIEnabled: workedOnAPIEnabled
            }
        }).then((response)=>{
            const rawSpaces = response.data?.myVisitedSpaces?.nodes?.spaces;
            const rawContent = workedOnAPIEnabled ? response.data.activities?.myActivities?.workedOn?.edges : response.data.activities?.myActivities?.viewed?.edges;
            const filteredRawContent = rawContent && rawContent.filter(// #help-work-platform suggested handling null content in FE while they investigate why some results are being returned null
            (edge)=>!(edge?.node?.object?.content?.status === 'trashed') && !(edge?.node?.object?.content === null));
            return {
                recentContents: filteredRawContent?.map($38ca96c4d9c67f5e$var$recentContentsCCResultMapper) || [],
                recentSpaces: rawSpaces?.map($38ca96c4d9c67f5e$var$recentSpaceCCResultMapper) || []
            };
        }).catch((error)=>{
            experienceTracker.fail({
                name: (0, $irVI7.QUICK_SEARCH_PRE_QUERY),
                error: error
            });
            // error is handled by the platform PSD component
            (0, $7Sm4c.markErrorAsHandled)(error);
            // The error will bubble up and the parent component will catch the error and handle it
            throw error;
        });
        experienceTracker.succeed({
            name: (0, $irVI7.QUICK_SEARCH_PRE_QUERY)
        });
        return {
            sections: [
                {
                    id: 'recent-confluence-items',
                    title: workedOnAPIEnabled ? intl.formatMessage((0, $fib1y.i18n).recentlyWorkedOn) : intl.formatMessage((0, $fib1y.i18n).recentlyViewed),
                    searchResults: recentContents,
                    resultLimit: $38ca96c4d9c67f5e$var$MAX_RESULTS_CONTENTS,
                    titleRenderer: (0, $9CKbz.ConfluenceTitleRenderer)(autocorrectEnabled, workedOnAPIEnabled, intl.formatMessage),
                    resultRenderer: (0, $2VPmd.ConfluenceResultRenderer)
                },
                {
                    id: 'recent-confluence-spaces',
                    title: intl.formatMessage((0, $fib1y.i18n).spaces),
                    searchResults: recentSpaces,
                    resultLimit: $38ca96c4d9c67f5e$var$MAX_RESULTS_SPACES
                }
            ]
        };
    }, [
        confCloudClient,
        cloudId,
        userId,
        intl,
        autocorrectEnabled,
        experienceTracker,
        workedOnAPIEnabled,
        objectTypes
    ]);
    const { backendExperiment: staticBackendExperiment } = (0, $91yhh.useExperiments)();
    const { backendExperiment: dynamicBackendExperiment, productEdition: productEdition } = (0, $1HFOS.useDynamicBackendExperiment)({
        cloudId: cloudId,
        entities: contentEntities,
        userId: userId || undefined,
        experience: 'quick-search'
    }) || {};
    const backendExperiment = (0, $9wGTI.fg)('confluence_search-scalable-statsig-layers') ? dynamicBackendExperiment : staticBackendExperiment;
    const { experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers } = backendExperiment || {};
    const searchClientConfig = {
        graphQLEnabled: true,
        graphQLPromise: (args)=>aggClient.query({
                query: (0, $cvntw.ConfluenceQuickSearchQuery),
                variables: (0, $g9GR5.confluenceGraphQLSearchVariablesMapper)({
                    ...args,
                    cloudId: cloudId,
                    contentEntities: contentEntities,
                    experimentId: experimentId,
                    shadowExperimentId: shadowExperimentId,
                    experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                            name: name,
                            layerId: layerId,
                            shadowId: shadowId,
                            definitions: definitions
                        })),
                    isLivePagesEnabled: (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in')
                })
            }).then((response)=>response.data),
        cloudId: cloudId,
        userId: principalId
    };
    return {
        experimentLayers: !(0, $9wGTI.fg)('confluence_search-scalable-statsig-layers') ? undefined : backendExperiment?.experimentLayers?.map((layer)=>{
            const { analyticsDefinitions: analyticsDefinitions, definitions: definitions, ...rest } = layer;
            return {
                ...rest,
                definitions: analyticsDefinitions
            };
        }),
        productEdition: productEdition,
        preQueryItemSupplier: preQueryItemSupplier,
        searchClientConfig: searchClientConfig
    };
};

});
parcelRegister("g9GR5", function(module, exports) {

$parcel$export(module.exports, "hasCheckedFilters", () => $448834a0f6f65d76$export$74c39e342047d9d1);
$parcel$export(module.exports, "confluenceGraphQLSearchVariablesMapper", () => $448834a0f6f65d76$export$76ca4f6f223de78a);

var $1U1CQ = parcelRequire("1U1CQ");
const $448834a0f6f65d76$var$CONFLUENCE_ARI_PREFIX = 'ari:cloud:confluence::site/';
const $448834a0f6f65d76$var$MAX_RESULTS_PAGE_BLOG_ATTACHMENTS = 10;
const $448834a0f6f65d76$var$MAX_RESULTS_SPACES = 3;
const $448834a0f6f65d76$export$71fb3a6d48f3d84f = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment'
];
const $448834a0f6f65d76$var$graphQLFilterMapper = (filters)=>{
    const confluenceFilters = {};
    filters.forEach((filter)=>{
        switch(filter['@type']){
            case 'spaces':
                confluenceFilters['spacesFilter'] = filter.spaceKeys;
                break;
            case 'verified':
                confluenceFilters['isVerified'] = filter.verified;
                break;
            case 'contributors':
                confluenceFilters['contributorsFilter'] = filter.accountIds;
                break;
            case 'lastModified':
                confluenceFilters['range'] = {
                    field: (0, $1U1CQ.ConfluenceGraphQLDateFilterFieldType).LASTMODIFIED,
                    gt: filter.from,
                    lt: filter.to
                };
                break;
            case 'titleMatchOnly':
                confluenceFilters['titleMatchOnly'] = filter.enabled;
                break;
            case 'pageStatus':
                confluenceFilters['pageStatus'] = filter.pageStatus;
                break;
            default:
                break;
        }
    });
    return confluenceFilters;
};
const $448834a0f6f65d76$export$74c39e342047d9d1 = (filters)=>filters.some((filter)=>{
        if (filter['@type'] === 'spaces' && filter.spaceKeys && filter.spaceKeys.length > 0) return true;
        else if (filter['@type'] === 'contributors' && filter.accountIds && filter.accountIds.length > 0) return true;
        else if (filter['@type'] === 'lastModified' && filter.from && filter.to) return true;
        return false;
    });
const $448834a0f6f65d76$export$76ca4f6f223de78a = ({ query: query, filters: filters, contentEntities: contentEntities = $448834a0f6f65d76$export$71fb3a6d48f3d84f, analyticsInfo: analyticsInfo, cloudId: cloudId, pageBlogAttachmentLimit: pageBlogAttachmentLimit = $448834a0f6f65d76$var$MAX_RESULTS_PAGE_BLOG_ATTACHMENTS, spaceLimit: spaceLimit = $448834a0f6f65d76$var$MAX_RESULTS_SPACES, includeAncestors: includeAncestors = false, experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers, isLivePagesEnabled: isLivePagesEnabled = false })=>{
    return {
        query: query,
        cloudIdARI: `${$448834a0f6f65d76$var$CONFLUENCE_ARI_PREFIX}${cloudId}`,
        pageBlogAttachmentLimit: pageBlogAttachmentLimit,
        spaceLimit: spaceLimit,
        includeAncestors: includeAncestors,
        contentEntities: contentEntities,
        confluenceFilters: $448834a0f6f65d76$var$graphQLFilterMapper(filters),
        searchSessionId: analyticsInfo?.searchSessionId,
        queryVersion: analyticsInfo?.queryVersion,
        includeSpaces: !$448834a0f6f65d76$export$74c39e342047d9d1(filters),
        isLivePagesEnabled: isLivePagesEnabled,
        experimentContext: {
            experimentId: experimentId,
            shadowExperimentId: shadowExperimentId,
            experimentLayers: experimentLayers
        }
    };
};

});
parcelRegister("1U1CQ", function(module, exports) {

$parcel$export(module.exports, "ConfluenceGraphQLDateFilterFieldType", () => $d70deb832e9cbf50$export$c23e925a9f49ee3c);
var $d70deb832e9cbf50$export$c23e925a9f49ee3c = /*#__PURE__*/ function(ConfluenceGraphQLDateFilterFieldType) {
    ConfluenceGraphQLDateFilterFieldType["LASTMODIFIED"] = "LASTMODIFIED";
    ConfluenceGraphQLDateFilterFieldType["CREATED"] = "CREATED,";
    return ConfluenceGraphQLDateFilterFieldType;
}({});

});


parcelRegister("cvntw", function(module, exports) {

$parcel$export(module.exports, "ConfluenceQuickSearchQuery", () => $701861e6cdd6ef14$export$913ed806993df47d);

var $d2LG0 = parcelRequire("d2LG0");
const $701861e6cdd6ef14$export$913ed806993df47d = (0, $d2LG0.default)`query ConfluenceQuickSearchQuery($query:String!$cloudIdARI:String!$pageBlogAttachmentLimit:Int!$spaceLimit:Int!$contentEntities:[String!]!$confluenceFilters:SearchConfluenceFilter$queryVersion:Int$searchSessionId:String$includeSpaces:Boolean!$includeAncestors:Boolean!$experimentContext:SearchExperimentContextInput$isLivePagesEnabled:Boolean!){search{pageBlogAttachments:search(experience:"product-search-dialog" query:$query first:$pageBlogAttachmentLimit filters:{entities:$contentEntities locations:[$cloudIdARI]confluenceFilters:$confluenceFilters}analytics:{queryVersion:$queryVersion searchSessionId:$searchSessionId}experimentContext:$experimentContext){edges{node{...on SearchConfluencePageBlogAttachment{id title type url lastModified iconCssClass space{id name}confluenceEntity{...on ConfluencePage{id subtype@include(if:$isLivePagesEnabled)ancestors@include(if:$includeAncestors){id title}}}}}}abTest{abTestId controlId experimentId}totalCount}spaces:search(experience:"searchDialog" query:$query first:$spaceLimit filters:{entities:["ati:cloud:confluence:space"]locations:[$cloudIdARI]}analytics:{queryVersion:$queryVersion searchSessionId:$searchSessionId})@include(if:$includeSpaces){edges{node{...on SearchConfluenceSpace{id key title type url iconPath}}}}}}`;

});

parcelRegister("1HFOS", function(module, exports) {

$parcel$export(module.exports, "useDynamicBackendExperiment", () => $35ce488ded4e8412$export$796c8e9967745d9a);

var $gwFzn = parcelRequire("gwFzn");

var $kNUwp = parcelRequire("kNUwp");

var $dbl1i = parcelRequire("dbl1i");
var $2hfy2 = parcelRequire("2hfy2");

var $3w0K2 = parcelRequire("3w0K2");

var $4VJDS = parcelRequire("4VJDS");

var $9wGTI = parcelRequire("9wGTI");
const $35ce488ded4e8412$var$HELLO_CLOUD_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $35ce488ded4e8412$var$EXPIRATION_TIME = 86400000;
const $35ce488ded4e8412$export$796c8e9967745d9a = ({ cloudId: cloudId, entities: entities, userId: userId, experience: experience })=>{
    const [searchConfig, setSearchConfig] = (0, $gwFzn.useState)();
    (0, $gwFzn.useEffect)(()=>{
        // Do nothing if feature gate is off
        if (!(0, $9wGTI.fg)('confluence_search-scalable-statsig-layers')) return;
        if (!cloudId) return;
        (0, $kNUwp.getSearchConfigV2)({
            cloudId: cloudId,
            userId: userId,
            onlyRefreshIfExpired: true,
            expiration: $35ce488ded4e8412$var$EXPIRATION_TIME
        }).then((result)=>{
            setSearchConfig(result);
        }).catch(()=>{
            // TODO: Error handling with Confluence's sentry client
            setSearchConfig({
                siteMetadata: [],
                resources: [],
                intercomHmac: ''
            });
        });
    }, [
        cloudId,
        userId
    ]);
    return (0, $gwFzn.useMemo)(()=>{
        // Return undefined if feature gate is off
        if (!(0, $9wGTI.fg)('confluence_search-scalable-statsig-layers')) return undefined;
        // Do not return dynamic experiments if search config is not loaded
        if (!searchConfig) return {
            backendExperiment: undefined,
            loading: true
        };
        const dynamicExperiments = (0, $dbl1i.dynamicExperimentsSchema).safeParse((0, $4VJDS.default).getStringList('search_platform_layer_functions', [])).data;
        if (!dynamicExperiments) return {
            backendExperiment: undefined,
            loading: false
        };
        const siteMetadata = searchConfig?.siteMetadata.find((metadata)=>metadata.siteId === cloudId);
        const isHello = siteMetadata?.siteId === $35ce488ded4e8412$var$HELLO_CLOUD_ID;
        const productEdition = siteMetadata?.productEdition;
        const productDataRegions = siteMetadata?.productDataRegions;
        const requestedEntities = entities.flatMap((entity)=>{
            try {
                const { resourceOwner: resourceOwner, resourceType: resourceType } = (0, $3w0K2.Ati).parse(entity);
                return [
                    {
                        entity: resourceOwner,
                        subEntity: resourceType.toUpperCase()
                    }
                ];
            } catch  {
                // TODO: Error handling with Confluence's sentry client
                return [];
            }
        });
        const backendExperiment = (0, $2hfy2.mapDynamicExperiments)({
            dynamicExperiments: dynamicExperiments,
            requestedEntities: requestedEntities,
            productEdition: productEdition,
            isHello: isHello,
            productDataRegions: productDataRegions,
            experience: experience,
            tenantId: cloudId
        });
        return {
            backendExperiment: backendExperiment,
            productEdition: productEdition,
            loading: false
        };
    }, [
        cloudId,
        entities,
        experience,
        searchConfig
    ]);
};

});

parcelRegister("e7whT", function(module, exports) {

$parcel$export(module.exports, "RecentQuickSearchQuery", () => $6a84866f2cdf6d7e$export$b4cc117e80f3c39f);

var $d2LG0 = parcelRequire("d2LG0");
const $6a84866f2cdf6d7e$export$b4cc117e80f3c39f = (0, $d2LG0.default)`query RecentQuickSearchQuery($cloudId:ID!$contentItemsLimit:Int!$spaceLimit:Int!$objectTypes:[ActivitiesObjectType!]$workedOnAPIEnabled:Boolean!){activities{myActivities{viewed(filters:[{type:AND arguments:{products:[CONFLUENCE]objectTypes:$objectTypes cloudIds:[$cloudId]}}]first:$contentItemsLimit)@skip(if:$workedOnAPIEnabled){edges{node{id object{id content{id title links{webui}type space{id name}status}}}}}workedOn(filters:[{type:AND arguments:{products:[CONFLUENCE]objectTypes:$objectTypes cloudIds:[$cloudId]}}]first:$contentItemsLimit)@include(if:$workedOnAPIEnabled){edges{node{id object{id content{id title links{webui}type space{id name}status}}}}}}}myVisitedSpaces(limit:$spaceLimit){nodes{spaces{id key name icon{path}links{webui}}}}}`;

});

parcelRegister("9CKbz", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTitleRenderer", () => $f5220b530c5db4b0$export$b25447981a133bbe);

var $gwFzn = parcelRequire("gwFzn");

var $21MH9 = parcelRequire("21MH9");
var $eEbYb = parcelRequire("eEbYb");

var $fib1y = parcelRequire("fib1y");
const $f5220b530c5db4b0$export$b25447981a133bbe = (autocorrectEnabled, workedOnAPIEnabled, formatMessage)=>({ productState: productState })=>{
        const recentlyViewedTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, workedOnAPIEnabled ? formatMessage((0, $fib1y.i18n).recentlyWorkedOn) : formatMessage((0, $fib1y.i18n).recentlyViewed));
        const pageBlogAttachmentTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, formatMessage((0, $fib1y.i18n).contents));
        if (productState === 'PreQuerySuccess') return recentlyViewedTitle;
        if (autocorrectEnabled) {
            if (productState === 'PostQueryLoading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEbYb.LoadingSkeleton), {
                "data-testid": "autocorrection-loading-skeleton"
            });
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $21MH9.AutocorrectAsyncWrapper), {
                fallback: pageBlogAttachmentTitle
            });
        }
        return pageBlogAttachmentTitle;
    };

});


parcelRegister("4XEM3", function(module, exports) {

$parcel$export(module.exports, "useConfluenceScopes", () => $0508fd4bbb3caedf$export$303ed8cbfd5b717a);
const $0508fd4bbb3caedf$export$303ed8cbfd5b717a = ({ isQuickSearchForWhiteboardsEnabled: isQuickSearchForWhiteboardsEnabled, isQuickSearchForDatabasesEnabled: isQuickSearchForDatabasesEnabled })=>{
    let contentScope = 'confluence.page,blogpost,attachment,embed,folder';
    const spaceAndUserScope = [
        'confluence.space',
        'urs.user-confluence'
    ];
    if (isQuickSearchForWhiteboardsEnabled) contentScope = `${contentScope},whiteboard`;
    if (isQuickSearchForDatabasesEnabled) contentScope = `${contentScope},database`;
    return {
        contentScope: contentScope,
        extensibleScopes: [
            contentScope,
            ...spaceAndUserScope
        ]
    };
};

});

parcelRegister("5jHnK", function(module, exports) {

$parcel$export(module.exports, "ExperimentLayersAnalyticsListener", () => $4875423f526257e1$export$4f8d571a44f08abe);

var $gwFzn = parcelRequire("gwFzn");

var $3pfAb = parcelRequire("3pfAb");

var $kDuN4 = parcelRequire("kDuN4");

var $9wGTI = parcelRequire("9wGTI");
const $4875423f526257e1$export$4f8d571a44f08abe = ({ experimentLayers: experimentLayers, productEdition: productEdition, children: children })=>{
    const handleEvent = (0, $gwFzn.useCallback)((event)=>{
        // Do not update the event if dynamic config is not being used
        if (!(0, $9wGTI.fg)('confluence_search-scalable-statsig-layers')) return;
        const action = event.payload.action;
        const actionSubject = event.payload.actionSubject;
        const actionSubjectId = event.payload.actionSubjectId;
        const isQuickFind = event.payload.attributes?.isQuickFind;
        // Do not update the event if its not a searchResults shown event on Quick Search
        if (actionSubject !== 'searchResults' || action !== 'shown' || actionSubjectId !== 'postQuerySearchResults' || isQuickFind) return;
        event.update((payload)=>{
            return {
                ...payload,
                attributes: {
                    ...payload.attributes,
                    backendExperiments: {
                        experimentLayers: experimentLayers
                    },
                    productEdition: productEdition,
                    abTest: undefined
                }
            };
        });
    }, [
        experimentLayers,
        productEdition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kDuN4.default), {
        onEvent: handleEvent,
        channel: (0, $3pfAb.FabricChannel).elements
    }, children);
};

});




//# sourceMappingURL=HelpPanel.849deba5.js.map
